
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire26ec"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire26ec"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("59RB5", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $3c175e510dbcbc19$export$ffb0004e005737fa, (v) => $3c175e510dbcbc19$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $3c175e510dbcbc19$export$34b9dba7ce09269b, (v) => $3c175e510dbcbc19$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $3c175e510dbcbc19$export$25062201e9e25d76, (v) => $3c175e510dbcbc19$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3c175e510dbcbc19$export$ffb0004e005737fa;
var $3c175e510dbcbc19$export$34b9dba7ce09269b;
var $3c175e510dbcbc19$export$25062201e9e25d76;
'use strict';

var $Fo7oF = parcelRequire("Fo7oF");
var $3c175e510dbcbc19$var$k = Symbol.for("react.element"), $3c175e510dbcbc19$var$l = Symbol.for("react.fragment"), $3c175e510dbcbc19$var$m = Object.prototype.hasOwnProperty, $3c175e510dbcbc19$var$n = $Fo7oF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $3c175e510dbcbc19$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $3c175e510dbcbc19$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$3c175e510dbcbc19$var$m.call(a, b) && !$3c175e510dbcbc19$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $3c175e510dbcbc19$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $3c175e510dbcbc19$var$n.current
    };
}
$3c175e510dbcbc19$export$ffb0004e005737fa = $3c175e510dbcbc19$var$l;
$3c175e510dbcbc19$export$34b9dba7ce09269b = $3c175e510dbcbc19$var$q;
$3c175e510dbcbc19$export$25062201e9e25d76 = $3c175e510dbcbc19$var$q;

});
parcelRegister("Fo7oF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bTqSv"));

});
parcelRegister("bTqSv", function(module, exports) {

$parcel$export(module.exports, "Children", () => $8a89ae3631ed7788$export$dca3b0875bd9a954, (v) => $8a89ae3631ed7788$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $8a89ae3631ed7788$export$16fa2f45be04daa8, (v) => $8a89ae3631ed7788$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $8a89ae3631ed7788$export$ffb0004e005737fa, (v) => $8a89ae3631ed7788$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $8a89ae3631ed7788$export$e2c29f18771995cb, (v) => $8a89ae3631ed7788$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $8a89ae3631ed7788$export$221d75b3f55bb0bd, (v) => $8a89ae3631ed7788$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $8a89ae3631ed7788$export$5f8d39834fd61797, (v) => $8a89ae3631ed7788$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $8a89ae3631ed7788$export$74bf444e3cd11ea5, (v) => $8a89ae3631ed7788$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $8a89ae3631ed7788$export$ae55be85d98224ed, (v) => $8a89ae3631ed7788$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $8a89ae3631ed7788$export$3ba232387fd5d6dd, (v) => $8a89ae3631ed7788$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $8a89ae3631ed7788$export$e530037191fcd5d7, (v) => $8a89ae3631ed7788$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $8a89ae3631ed7788$export$fd42f52fd3ae1109, (v) => $8a89ae3631ed7788$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $8a89ae3631ed7788$export$c8a8987d4410bf2d, (v) => $8a89ae3631ed7788$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $8a89ae3631ed7788$export$d38cd72104c1f0e9, (v) => $8a89ae3631ed7788$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $8a89ae3631ed7788$export$7d1e3a5e95ceca43, (v) => $8a89ae3631ed7788$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $8a89ae3631ed7788$export$257a8862b851cb5b, (v) => $8a89ae3631ed7788$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $8a89ae3631ed7788$export$a8257692ac88316c, (v) => $8a89ae3631ed7788$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $8a89ae3631ed7788$export$488013bae63b21da, (v) => $8a89ae3631ed7788$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $8a89ae3631ed7788$export$7c73462e0d25e514, (v) => $8a89ae3631ed7788$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $8a89ae3631ed7788$export$7568632d0d33d16d, (v) => $8a89ae3631ed7788$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $8a89ae3631ed7788$export$88948ce120ea2619, (v) => $8a89ae3631ed7788$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $8a89ae3631ed7788$export$35808ee640e87ca7, (v) => $8a89ae3631ed7788$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $8a89ae3631ed7788$export$fae74005e78b1a27, (v) => $8a89ae3631ed7788$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $8a89ae3631ed7788$export$dc8fbce3eb94dc1e, (v) => $8a89ae3631ed7788$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $8a89ae3631ed7788$export$6a7bc4e911dc01cf, (v) => $8a89ae3631ed7788$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $8a89ae3631ed7788$export$6d9c69b0de29b591, (v) => $8a89ae3631ed7788$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $8a89ae3631ed7788$export$f680877a34711e37, (v) => $8a89ae3631ed7788$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $8a89ae3631ed7788$export$d5a552a76deda3c2, (v) => $8a89ae3631ed7788$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $8a89ae3631ed7788$export$aaabe4eda9ed9969, (v) => $8a89ae3631ed7788$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $8a89ae3631ed7788$export$e5c5a5f917a5871c, (v) => $8a89ae3631ed7788$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $8a89ae3631ed7788$export$1538c33de8887b59, (v) => $8a89ae3631ed7788$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $8a89ae3631ed7788$export$13e3392192263954, (v) => $8a89ae3631ed7788$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $8a89ae3631ed7788$export$b8f5890fc79d6aca, (v) => $8a89ae3631ed7788$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $8a89ae3631ed7788$export$60241385465d0a34, (v) => $8a89ae3631ed7788$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $8a89ae3631ed7788$export$306c0aa65ff9ec16, (v) => $8a89ae3631ed7788$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $8a89ae3631ed7788$export$7b286972b8d8ccbf, (v) => $8a89ae3631ed7788$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $8a89ae3631ed7788$export$83d89fbfd8236492, (v) => $8a89ae3631ed7788$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8a89ae3631ed7788$export$dca3b0875bd9a954;
var $8a89ae3631ed7788$export$16fa2f45be04daa8;
var $8a89ae3631ed7788$export$ffb0004e005737fa;
var $8a89ae3631ed7788$export$e2c29f18771995cb;
var $8a89ae3631ed7788$export$221d75b3f55bb0bd;
var $8a89ae3631ed7788$export$5f8d39834fd61797;
var $8a89ae3631ed7788$export$74bf444e3cd11ea5;
var $8a89ae3631ed7788$export$ae55be85d98224ed;
var $8a89ae3631ed7788$export$3ba232387fd5d6dd;
var $8a89ae3631ed7788$export$e530037191fcd5d7;
var $8a89ae3631ed7788$export$fd42f52fd3ae1109;
var $8a89ae3631ed7788$export$c8a8987d4410bf2d;
var $8a89ae3631ed7788$export$d38cd72104c1f0e9;
var $8a89ae3631ed7788$export$7d1e3a5e95ceca43;
var $8a89ae3631ed7788$export$257a8862b851cb5b;
var $8a89ae3631ed7788$export$a8257692ac88316c;
var $8a89ae3631ed7788$export$488013bae63b21da;
var $8a89ae3631ed7788$export$7c73462e0d25e514;
var $8a89ae3631ed7788$export$7568632d0d33d16d;
var $8a89ae3631ed7788$export$88948ce120ea2619;
var $8a89ae3631ed7788$export$35808ee640e87ca7;
var $8a89ae3631ed7788$export$fae74005e78b1a27;
var $8a89ae3631ed7788$export$dc8fbce3eb94dc1e;
var $8a89ae3631ed7788$export$6a7bc4e911dc01cf;
var $8a89ae3631ed7788$export$6d9c69b0de29b591;
var $8a89ae3631ed7788$export$f680877a34711e37;
var $8a89ae3631ed7788$export$d5a552a76deda3c2;
var $8a89ae3631ed7788$export$aaabe4eda9ed9969;
var $8a89ae3631ed7788$export$e5c5a5f917a5871c;
var $8a89ae3631ed7788$export$1538c33de8887b59;
var $8a89ae3631ed7788$export$13e3392192263954;
var $8a89ae3631ed7788$export$b8f5890fc79d6aca;
var $8a89ae3631ed7788$export$60241385465d0a34;
var $8a89ae3631ed7788$export$306c0aa65ff9ec16;
var $8a89ae3631ed7788$export$7b286972b8d8ccbf;
var $8a89ae3631ed7788$export$83d89fbfd8236492;
'use strict';
var $8a89ae3631ed7788$var$l = Symbol.for("react.element"), $8a89ae3631ed7788$var$n = Symbol.for("react.portal"), $8a89ae3631ed7788$var$p = Symbol.for("react.fragment"), $8a89ae3631ed7788$var$q = Symbol.for("react.strict_mode"), $8a89ae3631ed7788$var$r = Symbol.for("react.profiler"), $8a89ae3631ed7788$var$t = Symbol.for("react.provider"), $8a89ae3631ed7788$var$u = Symbol.for("react.context"), $8a89ae3631ed7788$var$v = Symbol.for("react.forward_ref"), $8a89ae3631ed7788$var$w = Symbol.for("react.suspense"), $8a89ae3631ed7788$var$x = Symbol.for("react.memo"), $8a89ae3631ed7788$var$y = Symbol.for("react.lazy"), $8a89ae3631ed7788$var$z = Symbol.iterator;
function $8a89ae3631ed7788$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $8a89ae3631ed7788$var$z && a[$8a89ae3631ed7788$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $8a89ae3631ed7788$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $8a89ae3631ed7788$var$C = Object.assign, $8a89ae3631ed7788$var$D = {};
function $8a89ae3631ed7788$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $8a89ae3631ed7788$var$D;
    this.updater = e || $8a89ae3631ed7788$var$B;
}
$8a89ae3631ed7788$var$E.prototype.isReactComponent = {};
$8a89ae3631ed7788$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$8a89ae3631ed7788$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $8a89ae3631ed7788$var$F() {}
$8a89ae3631ed7788$var$F.prototype = $8a89ae3631ed7788$var$E.prototype;
function $8a89ae3631ed7788$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $8a89ae3631ed7788$var$D;
    this.updater = e || $8a89ae3631ed7788$var$B;
}
var $8a89ae3631ed7788$var$H = $8a89ae3631ed7788$var$G.prototype = new $8a89ae3631ed7788$var$F;
$8a89ae3631ed7788$var$H.constructor = $8a89ae3631ed7788$var$G;
$8a89ae3631ed7788$var$C($8a89ae3631ed7788$var$H, $8a89ae3631ed7788$var$E.prototype);
$8a89ae3631ed7788$var$H.isPureReactComponent = !0;
var $8a89ae3631ed7788$var$I = Array.isArray, $8a89ae3631ed7788$var$J = Object.prototype.hasOwnProperty, $8a89ae3631ed7788$var$K = {
    current: null
}, $8a89ae3631ed7788$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $8a89ae3631ed7788$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$8a89ae3631ed7788$var$J.call(b, d) && !$8a89ae3631ed7788$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $8a89ae3631ed7788$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $8a89ae3631ed7788$var$K.current
    };
}
function $8a89ae3631ed7788$var$N(a, b) {
    return {
        $$typeof: $8a89ae3631ed7788$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $8a89ae3631ed7788$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8a89ae3631ed7788$var$l;
}
function $8a89ae3631ed7788$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $8a89ae3631ed7788$var$P = /\/+/g;
function $8a89ae3631ed7788$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $8a89ae3631ed7788$var$escape("" + a.key) : b.toString(36);
}
function $8a89ae3631ed7788$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $8a89ae3631ed7788$var$l:
                case $8a89ae3631ed7788$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $8a89ae3631ed7788$var$Q(h, 0) : d, $8a89ae3631ed7788$var$I(c) ? (e = "", null != a && (e = a.replace($8a89ae3631ed7788$var$P, "$&/") + "/"), $8a89ae3631ed7788$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($8a89ae3631ed7788$var$O(c) && (c = $8a89ae3631ed7788$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($8a89ae3631ed7788$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($8a89ae3631ed7788$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $8a89ae3631ed7788$var$Q(k, g);
        h += $8a89ae3631ed7788$var$R(k, b, e, f, c);
    }
    else if (f = $8a89ae3631ed7788$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $8a89ae3631ed7788$var$Q(k, g++), h += $8a89ae3631ed7788$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $8a89ae3631ed7788$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $8a89ae3631ed7788$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $8a89ae3631ed7788$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $8a89ae3631ed7788$var$U = {
    current: null
}, $8a89ae3631ed7788$var$V = {
    transition: null
}, $8a89ae3631ed7788$var$W = {
    ReactCurrentDispatcher: $8a89ae3631ed7788$var$U,
    ReactCurrentBatchConfig: $8a89ae3631ed7788$var$V,
    ReactCurrentOwner: $8a89ae3631ed7788$var$K
};
function $8a89ae3631ed7788$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$8a89ae3631ed7788$export$dca3b0875bd9a954 = {
    map: $8a89ae3631ed7788$var$S,
    forEach: function(a, b, e) {
        $8a89ae3631ed7788$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $8a89ae3631ed7788$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $8a89ae3631ed7788$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$8a89ae3631ed7788$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$8a89ae3631ed7788$export$16fa2f45be04daa8 = $8a89ae3631ed7788$var$E;
$8a89ae3631ed7788$export$ffb0004e005737fa = $8a89ae3631ed7788$var$p;
$8a89ae3631ed7788$export$e2c29f18771995cb = $8a89ae3631ed7788$var$r;
$8a89ae3631ed7788$export$221d75b3f55bb0bd = $8a89ae3631ed7788$var$G;
$8a89ae3631ed7788$export$5f8d39834fd61797 = $8a89ae3631ed7788$var$q;
$8a89ae3631ed7788$export$74bf444e3cd11ea5 = $8a89ae3631ed7788$var$w;
$8a89ae3631ed7788$export$ae55be85d98224ed = $8a89ae3631ed7788$var$W;
$8a89ae3631ed7788$export$3ba232387fd5d6dd = $8a89ae3631ed7788$var$X;
$8a89ae3631ed7788$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $8a89ae3631ed7788$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $8a89ae3631ed7788$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$8a89ae3631ed7788$var$J.call(b, f) && !$8a89ae3631ed7788$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $8a89ae3631ed7788$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$8a89ae3631ed7788$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $8a89ae3631ed7788$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $8a89ae3631ed7788$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$8a89ae3631ed7788$export$c8a8987d4410bf2d = $8a89ae3631ed7788$var$M;
$8a89ae3631ed7788$export$d38cd72104c1f0e9 = function(a) {
    var b = $8a89ae3631ed7788$var$M.bind(null, a);
    b.type = a;
    return b;
};
$8a89ae3631ed7788$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$8a89ae3631ed7788$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $8a89ae3631ed7788$var$v,
        render: a
    };
};
$8a89ae3631ed7788$export$a8257692ac88316c = $8a89ae3631ed7788$var$O;
$8a89ae3631ed7788$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $8a89ae3631ed7788$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $8a89ae3631ed7788$var$T
    };
};
$8a89ae3631ed7788$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $8a89ae3631ed7788$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$8a89ae3631ed7788$export$7568632d0d33d16d = function(a) {
    var b = $8a89ae3631ed7788$var$V.transition;
    $8a89ae3631ed7788$var$V.transition = {};
    try {
        a();
    } finally{
        $8a89ae3631ed7788$var$V.transition = b;
    }
};
$8a89ae3631ed7788$export$88948ce120ea2619 = $8a89ae3631ed7788$var$X;
$8a89ae3631ed7788$export$35808ee640e87ca7 = function(a, b) {
    return $8a89ae3631ed7788$var$U.current.useCallback(a, b);
};
$8a89ae3631ed7788$export$fae74005e78b1a27 = function(a) {
    return $8a89ae3631ed7788$var$U.current.useContext(a);
};
$8a89ae3631ed7788$export$dc8fbce3eb94dc1e = function() {};
$8a89ae3631ed7788$export$6a7bc4e911dc01cf = function(a) {
    return $8a89ae3631ed7788$var$U.current.useDeferredValue(a);
};
$8a89ae3631ed7788$export$6d9c69b0de29b591 = function(a, b) {
    return $8a89ae3631ed7788$var$U.current.useEffect(a, b);
};
$8a89ae3631ed7788$export$f680877a34711e37 = function() {
    return $8a89ae3631ed7788$var$U.current.useId();
};
$8a89ae3631ed7788$export$d5a552a76deda3c2 = function(a, b, e) {
    return $8a89ae3631ed7788$var$U.current.useImperativeHandle(a, b, e);
};
$8a89ae3631ed7788$export$aaabe4eda9ed9969 = function(a, b) {
    return $8a89ae3631ed7788$var$U.current.useInsertionEffect(a, b);
};
$8a89ae3631ed7788$export$e5c5a5f917a5871c = function(a, b) {
    return $8a89ae3631ed7788$var$U.current.useLayoutEffect(a, b);
};
$8a89ae3631ed7788$export$1538c33de8887b59 = function(a, b) {
    return $8a89ae3631ed7788$var$U.current.useMemo(a, b);
};
$8a89ae3631ed7788$export$13e3392192263954 = function(a, b, e) {
    return $8a89ae3631ed7788$var$U.current.useReducer(a, b, e);
};
$8a89ae3631ed7788$export$b8f5890fc79d6aca = function(a) {
    return $8a89ae3631ed7788$var$U.current.useRef(a);
};
$8a89ae3631ed7788$export$60241385465d0a34 = function(a) {
    return $8a89ae3631ed7788$var$U.current.useState(a);
};
$8a89ae3631ed7788$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $8a89ae3631ed7788$var$U.current.useSyncExternalStore(a, b, e);
};
$8a89ae3631ed7788$export$7b286972b8d8ccbf = function() {
    return $8a89ae3631ed7788$var$U.current.useTransition();
};
$8a89ae3631ed7788$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("gtY0w", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $bffde70387e32ec2$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $bffde70387e32ec2$var$global; // eslint-disable-line no-undef

});

parcelRegister("lXZiV", function(module, exports) {
var $ffdea96b04b6f518$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $ffdea96b04b6f518$var$hasOwnProperty.call(it, key);
};

});

parcelRegister("8iMRJ", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("QlNUq"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("QlNUq", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("2SWGI", function(module, exports) {

var $gtY0w = parcelRequire("gtY0w");

var $8a19U = parcelRequire("8a19U");

var $disfj = parcelRequire("disfj");

var $bIIwe = parcelRequire("bIIwe");

var $3eawb = parcelRequire("3eawb");
var $219e261af042da9a$var$PROTOTYPE = 'prototype';
var $219e261af042da9a$var$$export = function(type, name, source) {
    var IS_FORCED = type & $219e261af042da9a$var$$export.F;
    var IS_GLOBAL = type & $219e261af042da9a$var$$export.G;
    var IS_STATIC = type & $219e261af042da9a$var$$export.S;
    var IS_PROTO = type & $219e261af042da9a$var$$export.P;
    var IS_BIND = type & $219e261af042da9a$var$$export.B;
    var target = IS_GLOBAL ? $gtY0w : IS_STATIC ? $gtY0w[name] || ($gtY0w[name] = {}) : ($gtY0w[name] || {})[$219e261af042da9a$var$PROTOTYPE];
    var exports = IS_GLOBAL ? $8a19U : $8a19U[name] || ($8a19U[name] = {});
    var expProto = exports[$219e261af042da9a$var$PROTOTYPE] || (exports[$219e261af042da9a$var$PROTOTYPE] = {});
    var key, own, out, exp;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        // export native or passed
        out = (own ? target : source)[key];
        // bind timers to global for call from export context
        exp = IS_BIND && own ? $3eawb(out, $gtY0w) : IS_PROTO && typeof out == 'function' ? $3eawb(Function.call, out) : out;
        // extend global
        if (target) $bIIwe(target, key, out, type & $219e261af042da9a$var$$export.U);
        // export
        if (exports[key] != out) $disfj(exports, key, exp);
        if (IS_PROTO && expProto[key] != out) expProto[key] = out;
    }
};
$gtY0w.core = $8a19U;
// type bitmap
$219e261af042da9a$var$$export.F = 1; // forced
$219e261af042da9a$var$$export.G = 2; // global
$219e261af042da9a$var$$export.S = 4; // static
$219e261af042da9a$var$$export.P = 8; // proto
$219e261af042da9a$var$$export.B = 16; // bind
$219e261af042da9a$var$$export.W = 32; // wrap
$219e261af042da9a$var$$export.U = 64; // safe
$219e261af042da9a$var$$export.R = 128; // real proto method for `library`
module.exports = $219e261af042da9a$var$$export;

});
parcelRegister("8a19U", function(module, exports) {
var $5f10280525a185eb$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $5f10280525a185eb$var$core; // eslint-disable-line no-undef

});

parcelRegister("disfj", function(module, exports) {

var $8QaBR = parcelRequire("8QaBR");

var $cttRt = parcelRequire("cttRt");

module.exports = (parcelRequire("8iMRJ")) ? function(object, key, value) {
    return $8QaBR.f(object, key, $cttRt(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("8QaBR", function(module, exports) {

$parcel$export(module.exports, "f", () => $66fb68f08afdc046$export$2d1720544b23b823, (v) => $66fb68f08afdc046$export$2d1720544b23b823 = v);
var $66fb68f08afdc046$export$2d1720544b23b823;

var $bmSbf = parcelRequire("bmSbf");

var $i28Fs = parcelRequire("i28Fs");

var $01Csn = parcelRequire("01Csn");
var $66fb68f08afdc046$var$dP = Object.defineProperty;

$66fb68f08afdc046$export$2d1720544b23b823 = (parcelRequire("8iMRJ")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $bmSbf(O);
    P = $01Csn(P, true);
    $bmSbf(Attributes);
    if ($i28Fs) try {
        return $66fb68f08afdc046$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("bmSbf", function(module, exports) {

var $lD7l7 = parcelRequire("lD7l7");
module.exports = function(it) {
    if (!$lD7l7(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("lD7l7", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("i28Fs", function(module, exports) {



module.exports = !(parcelRequire("8iMRJ")) && !(parcelRequire("QlNUq"))(function() {
    return Object.defineProperty((parcelRequire("e9tM3"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("e9tM3", function(module, exports) {

var $lD7l7 = parcelRequire("lD7l7");

var $gtY0w = parcelRequire("gtY0w");
var $a4d90077bd9f4731$require$document = $gtY0w.document;
// typeof document.createElement is 'object' in old IE
var $a4d90077bd9f4731$var$is = $lD7l7($a4d90077bd9f4731$require$document) && $lD7l7($a4d90077bd9f4731$require$document.createElement);
module.exports = function(it) {
    return $a4d90077bd9f4731$var$is ? $a4d90077bd9f4731$require$document.createElement(it) : {};
};

});


parcelRegister("01Csn", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $lD7l7 = parcelRequire("lD7l7");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$lD7l7(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$lD7l7(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$lD7l7(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$lD7l7(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("cttRt", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("bIIwe", function(module, exports) {

var $gtY0w = parcelRequire("gtY0w");

var $disfj = parcelRequire("disfj");

var $lXZiV = parcelRequire("lXZiV");

var $8886564d61613b87$var$SRC = (parcelRequire("jwR22"))('src');

var $3Ih5o = parcelRequire("3Ih5o");
var $8886564d61613b87$var$TO_STRING = 'toString';
var $8886564d61613b87$var$TPL = ('' + $3Ih5o).split($8886564d61613b87$var$TO_STRING);

(parcelRequire("8a19U")).inspectSource = function(it) {
    return $3Ih5o.call(it);
};
(module.exports = function(O, key, val, safe) {
    var isFunction = typeof val == 'function';
    if (isFunction) $lXZiV(val, 'name') || $disfj(val, 'name', key);
    if (O[key] === val) return;
    if (isFunction) $lXZiV(val, $8886564d61613b87$var$SRC) || $disfj(val, $8886564d61613b87$var$SRC, O[key] ? '' + O[key] : $8886564d61613b87$var$TPL.join(String(key)));
    if (O === $gtY0w) O[key] = val;
    else if (!safe) {
        delete O[key];
        $disfj(O, key, val);
    } else if (O[key]) O[key] = val;
    else $disfj(O, key, val);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, $8886564d61613b87$var$TO_STRING, function toString() {
    return typeof this == 'function' && this[$8886564d61613b87$var$SRC] || $3Ih5o.call(this);
});

});
parcelRegister("jwR22", function(module, exports) {
var $e37a247e2041511c$var$id = 0;
var $e37a247e2041511c$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$e37a247e2041511c$var$id + $e37a247e2041511c$var$px).toString(36));
};

});

parcelRegister("3Ih5o", function(module, exports) {

module.exports = (parcelRequire("4CirF"))('native-function-to-string', Function.toString);

});
parcelRegister("4CirF", function(module, exports) {

var $8a19U = parcelRequire("8a19U");

var $gtY0w = parcelRequire("gtY0w");
var $35c904df598e6584$var$SHARED = '__core-js_shared__';
var $35c904df598e6584$var$store = $gtY0w[$35c904df598e6584$var$SHARED] || ($gtY0w[$35c904df598e6584$var$SHARED] = {});

(module.exports = function(key, value) {
    return $35c904df598e6584$var$store[key] || ($35c904df598e6584$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $8a19U.version,
    mode: (parcelRequire("8qcv4")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("8qcv4", function(module, exports) {
module.exports = false;

});




parcelRegister("3eawb", function(module, exports) {
// optional / simple context binding

var $aXqxV = parcelRequire("aXqxV");
module.exports = function(fn, that, length) {
    $aXqxV(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("aXqxV", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});



parcelRegister("aXF7u", function(module, exports) {

var $8QaBR = parcelRequire("8QaBR");
var $7faf4f9f0855cabb$require$def = $8QaBR.f;

var $lXZiV = parcelRequire("lXZiV");

var $7faf4f9f0855cabb$var$TAG = (parcelRequire("fqMqf"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$lXZiV(it = stat ? it : it.prototype, $7faf4f9f0855cabb$var$TAG)) $7faf4f9f0855cabb$require$def(it, $7faf4f9f0855cabb$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("fqMqf", function(module, exports) {

var $b3bed85fea67fc99$var$store = (parcelRequire("4CirF"))('wks');

var $jwR22 = parcelRequire("jwR22");

var $gtY0w = parcelRequire("gtY0w");
var $b3bed85fea67fc99$require$Symbol = $gtY0w.Symbol;
var $b3bed85fea67fc99$var$USE_SYMBOL = typeof $b3bed85fea67fc99$require$Symbol == 'function';
var $b3bed85fea67fc99$var$$exports = module.exports = function(name) {
    return $b3bed85fea67fc99$var$store[name] || ($b3bed85fea67fc99$var$store[name] = $b3bed85fea67fc99$var$USE_SYMBOL && $b3bed85fea67fc99$require$Symbol[name] || ($b3bed85fea67fc99$var$USE_SYMBOL ? $b3bed85fea67fc99$require$Symbol : $jwR22)('Symbol.' + name));
};
$b3bed85fea67fc99$var$$exports.store = $b3bed85fea67fc99$var$store;

});


parcelRegister("8IDtE", function(module, exports) {

$parcel$export(module.exports, "f", () => $65910e230515a336$export$2d1720544b23b823, (v) => $65910e230515a336$export$2d1720544b23b823 = v);
var $65910e230515a336$export$2d1720544b23b823;

$65910e230515a336$export$2d1720544b23b823 = (parcelRequire("fqMqf"));

});

parcelRegister("lWstx", function(module, exports) {

var $gtY0w = parcelRequire("gtY0w");

var $8a19U = parcelRequire("8a19U");

var $8qcv4 = parcelRequire("8qcv4");

var $8IDtE = parcelRequire("8IDtE");

var $8QaBR = parcelRequire("8QaBR");
var $ff951a5a95b0a312$require$defineProperty = $8QaBR.f;
module.exports = function(name) {
    var $Symbol = $8a19U.Symbol || ($8a19U.Symbol = $8qcv4 ? {} : $gtY0w.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $ff951a5a95b0a312$require$defineProperty($Symbol, name, {
        value: $8IDtE.f(name)
    });
};

});

parcelRegister("aAgUs", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $1Wc55 = parcelRequire("1Wc55");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $1Wc55(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("1Wc55", function(module, exports) {
var $169494400d3bbb3c$var$toString = {}.toString;
module.exports = function(it) {
    return $169494400d3bbb3c$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("2zzLE", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $5T7Du = parcelRequire("5T7Du");

var $2Stpr = parcelRequire("2Stpr");

var $anH1q = parcelRequire("anH1q");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $5T7Du($this);
        var length = $2Stpr(O.length);
        var index = $anH1q(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("5T7Du", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $aAgUs = parcelRequire("aAgUs");

var $duF9G = parcelRequire("duF9G");
module.exports = function(it) {
    return $aAgUs($duF9G(it));
};

});
parcelRegister("duF9G", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("2Stpr", function(module, exports) {
// 7.1.15 ToLength

var $l8CUX = parcelRequire("l8CUX");
var $218770063924c6ad$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $218770063924c6ad$var$min($l8CUX(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("l8CUX", function(module, exports) {
// 7.1.4 ToInteger
var $f638888e1318f0fb$var$ceil = Math.ceil;
var $f638888e1318f0fb$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $f638888e1318f0fb$var$floor : $f638888e1318f0fb$var$ceil)(it);
};

});


parcelRegister("anH1q", function(module, exports) {

var $l8CUX = parcelRequire("l8CUX");
var $78ed6ca810b6e84a$var$max = Math.max;
var $78ed6ca810b6e84a$var$min = Math.min;
module.exports = function(index, length) {
    index = $l8CUX(index);
    return index < 0 ? $78ed6ca810b6e84a$var$max(index + length, 0) : $78ed6ca810b6e84a$var$min(index, length);
};

});


parcelRegister("hH45S", function(module, exports) {

var $ce19a0c2b2d032f9$var$shared = (parcelRequire("4CirF"))('keys');

var $jwR22 = parcelRequire("jwR22");
module.exports = function(key) {
    return $ce19a0c2b2d032f9$var$shared[key] || ($ce19a0c2b2d032f9$var$shared[key] = $jwR22(key));
};

});

parcelRegister("eK1p0", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});

parcelRegister("iC2yD", function(module, exports) {

$parcel$export(module.exports, "f", () => $d8cdc280d949431c$export$2d1720544b23b823, (v) => $d8cdc280d949431c$export$2d1720544b23b823 = v);
var $d8cdc280d949431c$export$2d1720544b23b823;
$d8cdc280d949431c$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});

parcelRegister("1y0po", function(module, exports) {
// 7.2.2 IsArray(argument)

var $1Wc55 = parcelRequire("1Wc55");
module.exports = Array.isArray || function isArray(arg) {
    return $1Wc55(arg) == 'Array';
};

});

parcelRegister("7bwTf", function(module, exports) {
// 7.1.13 ToObject(argument)

var $duF9G = parcelRequire("duF9G");
module.exports = function(it) {
    return Object($duF9G(it));
};

});

parcelRegister("3upGD", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $bmSbf = parcelRequire("bmSbf");

var $829ny = parcelRequire("829ny");

var $eK1p0 = parcelRequire("eK1p0");

var $28a81946537aeecf$var$IE_PROTO = (parcelRequire("hH45S"))('IE_PROTO');
var $28a81946537aeecf$var$Empty = function() {};
var $28a81946537aeecf$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $28a81946537aeecf$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("e9tM3"))('iframe');
    var i = $eK1p0.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("kDGgr")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $28a81946537aeecf$var$createDict = iframeDocument.F;
    while(i--)delete $28a81946537aeecf$var$createDict[$28a81946537aeecf$var$PROTOTYPE][$eK1p0[i]];
    return $28a81946537aeecf$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $28a81946537aeecf$var$Empty[$28a81946537aeecf$var$PROTOTYPE] = $bmSbf(O);
        result = new $28a81946537aeecf$var$Empty();
        $28a81946537aeecf$var$Empty[$28a81946537aeecf$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$28a81946537aeecf$var$IE_PROTO] = O;
    } else result = $28a81946537aeecf$var$createDict();
    return Properties === undefined ? result : $829ny(result, Properties);
};

});
parcelRegister("829ny", function(module, exports) {

var $8QaBR = parcelRequire("8QaBR");

var $bmSbf = parcelRequire("bmSbf");

var $1ttxT = parcelRequire("1ttxT");

module.exports = (parcelRequire("8iMRJ")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $bmSbf(O);
    var keys = $1ttxT(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$8QaBR.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("1ttxT", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $hvnAW = parcelRequire("hvnAW");

var $eK1p0 = parcelRequire("eK1p0");
module.exports = Object.keys || function keys(O) {
    return $hvnAW(O, $eK1p0);
};

});
parcelRegister("hvnAW", function(module, exports) {

var $lXZiV = parcelRequire("lXZiV");

var $5T7Du = parcelRequire("5T7Du");

var $cbe7a25c6ed4c8e9$var$arrayIndexOf = (parcelRequire("2zzLE"))(false);

var $cbe7a25c6ed4c8e9$var$IE_PROTO = (parcelRequire("hH45S"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $5T7Du(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $cbe7a25c6ed4c8e9$var$IE_PROTO) $lXZiV(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($lXZiV(O, key = names[i++])) ~$cbe7a25c6ed4c8e9$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});



parcelRegister("kDGgr", function(module, exports) {

var $gtY0w = parcelRequire("gtY0w");
var $f0683bfa61e14bf7$require$document = $gtY0w.document;
module.exports = $f0683bfa61e14bf7$require$document && $f0683bfa61e14bf7$require$document.documentElement;

});


parcelRegister("4nIN6", function(module, exports) {

$parcel$export(module.exports, "f", () => $330c0dfaf8f7793b$export$2d1720544b23b823, (v) => $330c0dfaf8f7793b$export$2d1720544b23b823 = v);
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $330c0dfaf8f7793b$export$2d1720544b23b823;

var $5T7Du = parcelRequire("5T7Du");

var $60lWN = parcelRequire("60lWN");
var $330c0dfaf8f7793b$require$gOPN = $60lWN.f;
var $330c0dfaf8f7793b$var$toString = {}.toString;
var $330c0dfaf8f7793b$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $330c0dfaf8f7793b$var$getWindowNames = function(it) {
    try {
        return $330c0dfaf8f7793b$require$gOPN(it);
    } catch (e) {
        return $330c0dfaf8f7793b$var$windowNames.slice();
    }
};
$330c0dfaf8f7793b$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $330c0dfaf8f7793b$var$windowNames && $330c0dfaf8f7793b$var$toString.call(it) == '[object Window]' ? $330c0dfaf8f7793b$var$getWindowNames(it) : $330c0dfaf8f7793b$require$gOPN($5T7Du(it));
};

});
parcelRegister("60lWN", function(module, exports) {

$parcel$export(module.exports, "f", () => $45f3c46c574c4a1c$export$2d1720544b23b823, (v) => $45f3c46c574c4a1c$export$2d1720544b23b823 = v);
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $45f3c46c574c4a1c$export$2d1720544b23b823;

var $hvnAW = parcelRequire("hvnAW");

var $45f3c46c574c4a1c$var$hiddenKeys = (parcelRequire("eK1p0")).concat('length', 'prototype');
$45f3c46c574c4a1c$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $hvnAW(O, $45f3c46c574c4a1c$var$hiddenKeys);
};

});


parcelRegister("11pTE", function(module, exports) {

$parcel$export(module.exports, "f", () => $0be9f8f480804b36$export$2d1720544b23b823, (v) => $0be9f8f480804b36$export$2d1720544b23b823 = v);
var $0be9f8f480804b36$export$2d1720544b23b823;

var $iC2yD = parcelRequire("iC2yD");

var $cttRt = parcelRequire("cttRt");

var $5T7Du = parcelRequire("5T7Du");

var $01Csn = parcelRequire("01Csn");

var $lXZiV = parcelRequire("lXZiV");

var $i28Fs = parcelRequire("i28Fs");
var $0be9f8f480804b36$var$gOPD = Object.getOwnPropertyDescriptor;

$0be9f8f480804b36$export$2d1720544b23b823 = (parcelRequire("8iMRJ")) ? $0be9f8f480804b36$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $5T7Du(O);
    P = $01Csn(P, true);
    if ($i28Fs) try {
        return $0be9f8f480804b36$var$gOPD(O, P);
    } catch (e) {}
    if ($lXZiV(O, P)) return $cttRt(!$iC2yD.f.call(O, P), O[P]);
};

});

parcelRegister("gb8Uy", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $2SWGI = parcelRequire("2SWGI");

var $8a19U = parcelRequire("8a19U");

var $QlNUq = parcelRequire("QlNUq");
module.exports = function(KEY, exec) {
    var fn = ($8a19U.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $2SWGI($2SWGI.S + $2SWGI.F * $QlNUq(function() {
        fn(1);
    }), 'Object', exp);
};

});

parcelRegister("5nB59", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $lXZiV = parcelRequire("lXZiV");

var $7bwTf = parcelRequire("7bwTf");

var $3eabdd797cc303f0$var$IE_PROTO = (parcelRequire("hH45S"))('IE_PROTO');
var $3eabdd797cc303f0$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $7bwTf(O);
    if ($lXZiV(O, $3eabdd797cc303f0$var$IE_PROTO)) return O[$3eabdd797cc303f0$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $3eabdd797cc303f0$var$ObjectProto : null;
};

});

parcelRegister("eHB8s", function(module, exports) {
'use strict';

var $8iMRJ = parcelRequire("8iMRJ");

var $1ttxT = parcelRequire("1ttxT");

var $iZji0 = parcelRequire("iZji0");

var $iC2yD = parcelRequire("iC2yD");

var $7bwTf = parcelRequire("7bwTf");

var $aAgUs = parcelRequire("aAgUs");
var $ab41e3252a1f7c32$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$ab41e3252a1f7c32$var$$assign || (parcelRequire("QlNUq"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $ab41e3252a1f7c32$var$$assign({}, A)[S] != 7 || Object.keys($ab41e3252a1f7c32$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $7bwTf(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $iZji0.f;
    var isEnum = $iC2yD.f;
    while(aLen > index){
        var S = $aAgUs(arguments[index++]);
        var keys = getSymbols ? $1ttxT(S).concat(getSymbols(S)) : $1ttxT(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$8iMRJ || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $ab41e3252a1f7c32$var$$assign;

});
parcelRegister("iZji0", function(module, exports) {

$parcel$export(module.exports, "f", () => $dd2ce2f610f77359$export$2d1720544b23b823, (v) => $dd2ce2f610f77359$export$2d1720544b23b823 = v);
var $dd2ce2f610f77359$export$2d1720544b23b823;
$dd2ce2f610f77359$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});


parcelRegister("382Uw", function(module, exports) {
// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
    // eslint-disable-next-line no-self-compare
    return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

});

parcelRegister("FiBqq", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $lD7l7 = parcelRequire("lD7l7");

var $bmSbf = parcelRequire("bmSbf");
var $07c2428b9a559315$var$check = function(O, proto) {
    $bmSbf(O);
    if (!$lD7l7(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("3eawb"))(Function.call, (parcelRequire("11pTE")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $07c2428b9a559315$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $07c2428b9a559315$var$check
};

});

parcelRegister("03JDo", function(module, exports) {
// getting tag from 19.1.3.6 Object.prototype.toString()

var $1Wc55 = parcelRequire("1Wc55");

var $00b3adf69f346fd0$var$TAG = (parcelRequire("fqMqf"))('toStringTag');
// ES3 wrong here
var $00b3adf69f346fd0$var$ARG = $1Wc55(function() {
    return arguments;
}()) == 'Arguments';
// fallback for IE11 Script Access Denied error
var $00b3adf69f346fd0$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (e) {}
};
module.exports = function(it) {
    var O, T, B;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = $00b3adf69f346fd0$var$tryGet(O = Object(it), $00b3adf69f346fd0$var$TAG)) == 'string' ? T : $00b3adf69f346fd0$var$ARG ? $1Wc55(O) : (B = $1Wc55(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

});

parcelRegister("i9XH1", function(module, exports) {
'use strict';

var $aXqxV = parcelRequire("aXqxV");

var $lD7l7 = parcelRequire("lD7l7");

var $2TNdz = parcelRequire("2TNdz");
var $d3875f0c977fcae7$var$arraySlice = [].slice;
var $d3875f0c977fcae7$var$factories = {};
var $d3875f0c977fcae7$var$construct = function(F, len, args) {
    if (!(len in $d3875f0c977fcae7$var$factories)) {
        for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
        // eslint-disable-next-line no-new-func
        $d3875f0c977fcae7$var$factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
    }
    return $d3875f0c977fcae7$var$factories[len](F, args);
};
module.exports = Function.bind || function bind(that /* , ...args */ ) {
    var fn = $aXqxV(this);
    var partArgs = $d3875f0c977fcae7$var$arraySlice.call(arguments, 1);
    var bound = function() {
        var args = partArgs.concat($d3875f0c977fcae7$var$arraySlice.call(arguments));
        return this instanceof bound ? $d3875f0c977fcae7$var$construct(fn, args.length, args) : $2TNdz(fn, args, that);
    };
    if ($lD7l7(fn.prototype)) bound.prototype = fn.prototype;
    return bound;
};

});
parcelRegister("2TNdz", function(module, exports) {
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that) {
    var un = that === undefined;
    switch(args.length){
        case 0:
            return un ? fn() : fn.call(that);
        case 1:
            return un ? fn(args[0]) : fn.call(that, args[0]);
        case 2:
            return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
        case 3:
            return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
        case 4:
            return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
    }
    return fn.apply(that, args);
};

});


parcelRegister("7fWUt", function(module, exports) {

var $2SWGI = parcelRequire("2SWGI");

var $duF9G = parcelRequire("duF9G");

var $QlNUq = parcelRequire("QlNUq");

var $d7QKc = parcelRequire("d7QKc");
var $5487a166374178fb$var$space = '[' + $d7QKc + ']';
var $5487a166374178fb$var$non = '\u200b\u0085';
var $5487a166374178fb$var$ltrim = RegExp('^' + $5487a166374178fb$var$space + $5487a166374178fb$var$space + '*');
var $5487a166374178fb$var$rtrim = RegExp($5487a166374178fb$var$space + $5487a166374178fb$var$space + '*$');
var $5487a166374178fb$var$exporter = function(KEY, exec, ALIAS) {
    var exp = {};
    var FORCE = $QlNUq(function() {
        return !!$d7QKc[KEY]() || $5487a166374178fb$var$non[KEY]() != $5487a166374178fb$var$non;
    });
    var fn = exp[KEY] = FORCE ? exec($5487a166374178fb$var$trim) : $d7QKc[KEY];
    if (ALIAS) exp[ALIAS] = fn;
    $2SWGI($2SWGI.P + $2SWGI.F * FORCE, 'String', exp);
};
// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var $5487a166374178fb$var$trim = $5487a166374178fb$var$exporter.trim = function(string, TYPE) {
    string = String($duF9G(string));
    if (TYPE & 1) string = string.replace($5487a166374178fb$var$ltrim, '');
    if (TYPE & 2) string = string.replace($5487a166374178fb$var$rtrim, '');
    return string;
};
module.exports = $5487a166374178fb$var$exporter;

});
parcelRegister("d7QKc", function(module, exports) {
module.exports = "	\n\v\f\r \xa0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";

});


parcelRegister("iBPed", function(module, exports) {
'use strict';

var $l8CUX = parcelRequire("l8CUX");

var $duF9G = parcelRequire("duF9G");
module.exports = function repeat(count) {
    var str = String($duF9G(this));
    var res = '';
    var n = $l8CUX(count);
    if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
    for(; n > 0; (n >>>= 1) && (str += str))if (n & 1) res += str;
    return res;
};

});

parcelRegister("JyvOH", function(module, exports) {
// 20.1.2.3 Number.isInteger(number)

var $lD7l7 = parcelRequire("lD7l7");
var $088ef97b9ca9c072$var$floor = Math.floor;
module.exports = function isInteger(it) {
    return !$lD7l7(it) && isFinite(it) && $088ef97b9ca9c072$var$floor(it) === it;
};

});

parcelRegister("aWXLh", function(module, exports) {
// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
    return (x = +x) > -0.00000001 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

});

parcelRegister("4LpWx", function(module, exports) {
// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
    // eslint-disable-next-line no-self-compare
    return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

});

parcelRegister("8KeG3", function(module, exports) {
// 20.2.2.16 Math.fround(x)

var $4LpWx = parcelRequire("4LpWx");
var $65de0130bb8aa409$var$pow = Math.pow;
var $65de0130bb8aa409$var$EPSILON = $65de0130bb8aa409$var$pow(2, -52);
var $65de0130bb8aa409$var$EPSILON32 = $65de0130bb8aa409$var$pow(2, -23);
var $65de0130bb8aa409$var$MAX32 = $65de0130bb8aa409$var$pow(2, 127) * (2 - $65de0130bb8aa409$var$EPSILON32);
var $65de0130bb8aa409$var$MIN32 = $65de0130bb8aa409$var$pow(2, -126);
var $65de0130bb8aa409$var$roundTiesToEven = function(n) {
    return n + 1 / $65de0130bb8aa409$var$EPSILON - 1 / $65de0130bb8aa409$var$EPSILON;
};
module.exports = Math.fround || function fround(x) {
    var $abs = Math.abs(x);
    var $sign = $4LpWx(x);
    var a, result;
    if ($abs < $65de0130bb8aa409$var$MIN32) return $sign * $65de0130bb8aa409$var$roundTiesToEven($abs / $65de0130bb8aa409$var$MIN32 / $65de0130bb8aa409$var$EPSILON32) * $65de0130bb8aa409$var$MIN32 * $65de0130bb8aa409$var$EPSILON32;
    a = (1 + $65de0130bb8aa409$var$EPSILON32 / $65de0130bb8aa409$var$EPSILON) * $abs;
    result = a - (a - $abs);
    // eslint-disable-next-line no-self-compare
    if (result > $65de0130bb8aa409$var$MAX32 || result != result) return $sign * Infinity;
    return $sign * result;
};

});

parcelRegister("9o1Sc", function(module, exports) {

var $l8CUX = parcelRequire("l8CUX");

var $duF9G = parcelRequire("duF9G");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($duF9G(that));
        var i = $l8CUX(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});

parcelRegister("aRtjl", function(module, exports) {
'use strict';

var $8qcv4 = parcelRequire("8qcv4");

var $2SWGI = parcelRequire("2SWGI");

var $bIIwe = parcelRequire("bIIwe");

var $disfj = parcelRequire("disfj");

var $1VgEQ = parcelRequire("1VgEQ");

var $kCznt = parcelRequire("kCznt");

var $aXF7u = parcelRequire("aXF7u");

var $5nB59 = parcelRequire("5nB59");

var $7e85972ccbc61a51$var$ITERATOR = (parcelRequire("fqMqf"))('iterator');
var $7e85972ccbc61a51$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $7e85972ccbc61a51$var$FF_ITERATOR = '@@iterator';
var $7e85972ccbc61a51$var$KEYS = 'keys';
var $7e85972ccbc61a51$var$VALUES = 'values';
var $7e85972ccbc61a51$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $kCznt(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$7e85972ccbc61a51$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $7e85972ccbc61a51$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $7e85972ccbc61a51$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $7e85972ccbc61a51$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$7e85972ccbc61a51$var$ITERATOR] || proto[$7e85972ccbc61a51$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $5nB59($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $aXF7u(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$8qcv4 && typeof IteratorPrototype[$7e85972ccbc61a51$var$ITERATOR] != 'function') $disfj(IteratorPrototype, $7e85972ccbc61a51$var$ITERATOR, $7e85972ccbc61a51$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $7e85972ccbc61a51$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$8qcv4 || FORCED) && ($7e85972ccbc61a51$var$BUGGY || VALUES_BUG || !proto[$7e85972ccbc61a51$var$ITERATOR])) $disfj(proto, $7e85972ccbc61a51$var$ITERATOR, $default);
    // Plug for library
    $1VgEQ[NAME] = $default;
    $1VgEQ[TAG] = $7e85972ccbc61a51$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($7e85972ccbc61a51$var$VALUES),
            keys: IS_SET ? $default : getMethod($7e85972ccbc61a51$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $bIIwe(proto, key, methods[key]);
        } else $2SWGI($2SWGI.P + $2SWGI.F * ($7e85972ccbc61a51$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("1VgEQ", function(module, exports) {
module.exports = {};

});

parcelRegister("kCznt", function(module, exports) {
'use strict';

var $3upGD = parcelRequire("3upGD");

var $cttRt = parcelRequire("cttRt");

var $aXF7u = parcelRequire("aXF7u");
var $f032cc8482f1edcd$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("disfj"))($f032cc8482f1edcd$var$IteratorPrototype, (parcelRequire("fqMqf"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $3upGD($f032cc8482f1edcd$var$IteratorPrototype, {
        next: $cttRt(1, next)
    });
    $aXF7u(Constructor, NAME + ' Iterator');
};

});


parcelRegister("5iXJY", function(module, exports) {

var $3dccf96c6b83d439$var$MATCH = (parcelRequire("fqMqf"))('match');
module.exports = function(KEY) {
    var re = /./;
    try {
        '/./'[KEY](re);
    } catch (e) {
        try {
            re[$3dccf96c6b83d439$var$MATCH] = false;
            return !'/./'[KEY](re);
        } catch (f) {}
    }
    return true;
};

});

parcelRegister("eu17v", function(module, exports) {

var $2SWGI = parcelRequire("2SWGI");

var $QlNUq = parcelRequire("QlNUq");

var $duF9G = parcelRequire("duF9G");
var $a8b4bc78f29f79e0$var$quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var $a8b4bc78f29f79e0$var$createHTML = function(string, tag, attribute, value) {
    var S = String($duF9G(string));
    var p1 = '<' + tag;
    if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace($a8b4bc78f29f79e0$var$quot, '&quot;') + '"';
    return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function(NAME, exec) {
    var O = {};
    O[NAME] = exec($a8b4bc78f29f79e0$var$createHTML);
    $2SWGI($2SWGI.P + $2SWGI.F * $QlNUq(function() {
        var test = ''[NAME]('"');
        return test !== test.toLowerCase() || test.split('"').length > 3;
    }), 'String', O);
};

});

parcelRegister("kSJfZ", function(module, exports) {
'use strict';

var $bmSbf = parcelRequire("bmSbf");

var $01Csn = parcelRequire("01Csn");
var $f33bf4d9f4a44157$var$NUMBER = 'number';
module.exports = function(hint) {
    if (hint !== 'string' && hint !== $f33bf4d9f4a44157$var$NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
    return $01Csn($bmSbf(this), hint != $f33bf4d9f4a44157$var$NUMBER);
};

});

parcelRegister("g4dgh", function(module, exports) {
// check on default Array iterator

var $1VgEQ = parcelRequire("1VgEQ");

var $bb274e88304628f5$var$ITERATOR = (parcelRequire("fqMqf"))('iterator');
var $bb274e88304628f5$var$ArrayProto = Array.prototype;
module.exports = function(it) {
    return it !== undefined && ($1VgEQ.Array === it || $bb274e88304628f5$var$ArrayProto[$bb274e88304628f5$var$ITERATOR] === it);
};

});

parcelRegister("ljgC0", function(module, exports) {

var $03JDo = parcelRequire("03JDo");

var $f838421cc7705d88$var$ITERATOR = (parcelRequire("fqMqf"))('iterator');

var $1VgEQ = parcelRequire("1VgEQ");

module.exports = (parcelRequire("8a19U")).getIteratorMethod = function(it) {
    if (it != undefined) return it[$f838421cc7705d88$var$ITERATOR] || it['@@iterator'] || $1VgEQ[$03JDo(it)];
};

});

parcelRegister("gkPUi", function(module, exports) {

var $be46c742323f1921$var$ITERATOR = (parcelRequire("fqMqf"))('iterator');
var $be46c742323f1921$var$SAFE_CLOSING = false;
try {
    var $be46c742323f1921$var$riter = [
        7
    ][$be46c742323f1921$var$ITERATOR]();
    $be46c742323f1921$var$riter['return'] = function() {
        $be46c742323f1921$var$SAFE_CLOSING = true;
    };
    // eslint-disable-next-line no-throw-literal
    Array.from($be46c742323f1921$var$riter, function() {
        throw 2;
    });
} catch (e) {}
module.exports = function(exec, skipClosing) {
    if (!skipClosing && !$be46c742323f1921$var$SAFE_CLOSING) return false;
    var safe = false;
    try {
        var arr = [
            7
        ];
        var iter = arr[$be46c742323f1921$var$ITERATOR]();
        iter.next = function() {
            return {
                done: safe = true
            };
        };
        arr[$be46c742323f1921$var$ITERATOR] = function() {
            return iter;
        };
        exec(arr);
    } catch (e) {}
    return safe;
};

});

parcelRegister("613qq", function(module, exports) {
'use strict';

var $QlNUq = parcelRequire("QlNUq");
module.exports = function(method, arg) {
    return !!method && $QlNUq(function() {
        // eslint-disable-next-line no-useless-call
        arg ? method.call(null, function() {}, 1) : method.call(null);
    });
};

});

parcelRegister("3gy3i", function(module, exports) {
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex

var $3eawb = parcelRequire("3eawb");

var $aAgUs = parcelRequire("aAgUs");

var $7bwTf = parcelRequire("7bwTf");

var $2Stpr = parcelRequire("2Stpr");

var $5Yuv1 = parcelRequire("5Yuv1");
module.exports = function(TYPE, $create) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    var create = $create || $5Yuv1;
    return function($this, callbackfn, that) {
        var O = $7bwTf($this);
        var self = $aAgUs(O);
        var f = $3eawb(callbackfn, that, 3);
        var length = $2Stpr(self.length);
        var index = 0;
        var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
        var val, res;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            val = self[index];
            res = f(val, index, O);
            if (TYPE) {
                if (IS_MAP) result[index] = res; // map
                else if (res) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return val; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        result.push(val); // filter
                }
                else if (IS_EVERY) return false; // every
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
    };
};

});
parcelRegister("5Yuv1", function(module, exports) {
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)

var $hXXp5 = parcelRequire("hXXp5");
module.exports = function(original, length) {
    return new ($hXXp5(original))(length);
};

});
parcelRegister("hXXp5", function(module, exports) {

var $lD7l7 = parcelRequire("lD7l7");

var $1y0po = parcelRequire("1y0po");

var $d14606a9c3e5c706$var$SPECIES = (parcelRequire("fqMqf"))('species');
module.exports = function(original) {
    var C;
    if ($1y0po(original)) {
        C = original.constructor;
        // cross-realm fallback
        if (typeof C == 'function' && (C === Array || $1y0po(C.prototype))) C = undefined;
        if ($lD7l7(C)) {
            C = C[$d14606a9c3e5c706$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? Array : C;
};

});



parcelRegister("kavIj", function(module, exports) {
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
'use strict';

var $7bwTf = parcelRequire("7bwTf");

var $anH1q = parcelRequire("anH1q");

var $2Stpr = parcelRequire("2Stpr");
module.exports = [].copyWithin || function copyWithin(target /* = 0 */ , start /* = 0, end = @length */ ) {
    var O = $7bwTf(this);
    var len = $2Stpr(O.length);
    var to = $anH1q(target, len);
    var from = $anH1q(start, len);
    var end = arguments.length > 2 ? arguments[2] : undefined;
    var count = Math.min((end === undefined ? len : $anH1q(end, len)) - from, len - to);
    var inc = 1;
    if (from < to && to < from + count) {
        inc = -1;
        from += count - 1;
        to += count - 1;
    }
    while(count-- > 0){
        if (from in O) O[to] = O[from];
        else delete O[to];
        to += inc;
        from += inc;
    }
    return O;
};

});

parcelRegister("fUASv", function(module, exports) {
// 22.1.3.31 Array.prototype[@@unscopables]

var $b958b13b365af7ae$var$UNSCOPABLES = (parcelRequire("fqMqf"))('unscopables');
var $b958b13b365af7ae$var$ArrayProto = Array.prototype;

if ($b958b13b365af7ae$var$ArrayProto[$b958b13b365af7ae$var$UNSCOPABLES] == undefined) (parcelRequire("disfj"))($b958b13b365af7ae$var$ArrayProto, $b958b13b365af7ae$var$UNSCOPABLES, {});
module.exports = function(key) {
    $b958b13b365af7ae$var$ArrayProto[$b958b13b365af7ae$var$UNSCOPABLES][key] = true;
};

});

parcelRegister("hI6TD", function(module, exports) {
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
'use strict';

var $7bwTf = parcelRequire("7bwTf");

var $anH1q = parcelRequire("anH1q");

var $2Stpr = parcelRequire("2Stpr");
module.exports = function fill(value /* , start = 0, end = @length */ ) {
    var O = $7bwTf(this);
    var length = $2Stpr(O.length);
    var aLen = arguments.length;
    var index = $anH1q(aLen > 1 ? arguments[1] : undefined, length);
    var end = aLen > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : $anH1q(end, length);
    while(endPos > index)O[index++] = value;
    return O;
};

});

parcelRegister("bDRPQ", function(module, exports) {
'use strict';

var $gtY0w = parcelRequire("gtY0w");

var $8QaBR = parcelRequire("8QaBR");

var $8iMRJ = parcelRequire("8iMRJ");

var $879d18c28e9b1310$var$SPECIES = (parcelRequire("fqMqf"))('species');
module.exports = function(KEY) {
    var C = $gtY0w[KEY];
    if ($8iMRJ && C && !C[$879d18c28e9b1310$var$SPECIES]) $8QaBR.f(C, $879d18c28e9b1310$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});

parcelRegister("i0uZ5", function(module, exports) {
'use strict';

var $fUASv = parcelRequire("fUASv");

var $3DTXB = parcelRequire("3DTXB");

var $1VgEQ = parcelRequire("1VgEQ");

var $5T7Du = parcelRequire("5T7Du");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("aRtjl"))(Array, 'Array', function(iterated, kind) {
    this._t = $5T7Du(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $3DTXB(1);
    }
    if (kind == 'keys') return $3DTXB(0, index);
    if (kind == 'values') return $3DTXB(0, O[index]);
    return $3DTXB(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$1VgEQ.Arguments = $1VgEQ.Array;
$fUASv('keys');
$fUASv('values');
$fUASv('entries');

});
parcelRegister("3DTXB", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});


parcelRegister("jVwmq", function(module, exports) {
'use strict';

var $bmSbf = parcelRequire("bmSbf");
module.exports = function() {
    var that = $bmSbf(this);
    var result = '';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.unicode) result += 'u';
    if (that.sticky) result += 'y';
    return result;
};

});

parcelRegister("h6eDo", function(module, exports) {
'use strict';
parcelRequire("cwKrQ");

var $bIIwe = parcelRequire("bIIwe");

var $disfj = parcelRequire("disfj");

var $QlNUq = parcelRequire("QlNUq");

var $duF9G = parcelRequire("duF9G");

var $fqMqf = parcelRequire("fqMqf");

var $isEge = parcelRequire("isEge");
var $c72e59496caf8d61$var$SPECIES = $fqMqf('species');
var $c72e59496caf8d61$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$QlNUq(function() {
    // #replace needs built-in support for named groups.
    // #match works fine because it just return the exec results, even if it has
    // a "grops" property.
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: '7'
        };
        return result;
    };
    return ''.replace(re, '$<a>') !== '7';
});
var $c72e59496caf8d61$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = function() {
    // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
    var re = /(?:)/;
    var originalExec = re.exec;
    re.exec = function() {
        return originalExec.apply(this, arguments);
    };
    var result = 'ab'.split(re);
    return result.length === 2 && result[0] === 'a' && result[1] === 'b';
}();
module.exports = function(KEY, length, exec) {
    var SYMBOL = $fqMqf(KEY);
    var DELEGATES_TO_SYMBOL = !$QlNUq(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ''[KEY](O) != 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !$QlNUq(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        re.exec = function() {
            execCalled = true;
            return null;
        };
        if (KEY === 'split') {
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$c72e59496caf8d61$var$SPECIES] = function() {
                return re;
            };
        }
        re[SYMBOL]('');
        return !execCalled;
    }) : undefined;
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !$c72e59496caf8d61$var$REPLACE_SUPPORTS_NAMED_GROUPS || KEY === 'split' && !$c72e59496caf8d61$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
        var nativeRegExpMethod = /./[SYMBOL];
        var fns = exec($duF9G, SYMBOL, ''[KEY], function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
            if (regexp.exec === $isEge) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: nativeRegExpMethod.call(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: nativeMethod.call(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        var strfn = fns[0];
        var rxfn = fns[1];
        $bIIwe(String.prototype, KEY, strfn);
        $disfj(RegExp.prototype, SYMBOL, length == 2 ? function(string, arg) {
            return rxfn.call(string, this, arg);
        } : function(string) {
            return rxfn.call(string, this);
        });
    }
};

});
parcelRegister("cwKrQ", function(module, exports) {
'use strict';

var $isEge = parcelRequire("isEge");

(parcelRequire("2SWGI"))({
    target: 'RegExp',
    proto: true,
    forced: $isEge !== /./.exec
}, {
    exec: $isEge
});

});
parcelRegister("isEge", function(module, exports) {
'use strict';

var $jVwmq = parcelRequire("jVwmq");
var $d70a127bfab96e59$var$nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var $d70a127bfab96e59$var$nativeReplace = String.prototype.replace;
var $d70a127bfab96e59$var$patchedExec = $d70a127bfab96e59$var$nativeExec;
var $d70a127bfab96e59$var$LAST_INDEX = 'lastIndex';
var $d70a127bfab96e59$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/, re2 = /b*/g;
    $d70a127bfab96e59$var$nativeExec.call(re1, 'a');
    $d70a127bfab96e59$var$nativeExec.call(re2, 'a');
    return re1[$d70a127bfab96e59$var$LAST_INDEX] !== 0 || re2[$d70a127bfab96e59$var$LAST_INDEX] !== 0;
}();
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $d70a127bfab96e59$var$NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
var $d70a127bfab96e59$var$PATCH = $d70a127bfab96e59$var$UPDATES_LAST_INDEX_WRONG || $d70a127bfab96e59$var$NPCG_INCLUDED;
if ($d70a127bfab96e59$var$PATCH) $d70a127bfab96e59$var$patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    if ($d70a127bfab96e59$var$NPCG_INCLUDED) reCopy = new RegExp('^' + re.source + '$(?!\\s)', $jVwmq.call(re));
    if ($d70a127bfab96e59$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re[$d70a127bfab96e59$var$LAST_INDEX];
    match = $d70a127bfab96e59$var$nativeExec.call(re, str);
    if ($d70a127bfab96e59$var$UPDATES_LAST_INDEX_WRONG && match) re[$d70a127bfab96e59$var$LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    if ($d70a127bfab96e59$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
    // eslint-disable-next-line no-loop-func
    $d70a127bfab96e59$var$nativeReplace.call(match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    return match;
};
module.exports = $d70a127bfab96e59$var$patchedExec;

});



parcelRegister("jrtAb", function(module, exports) {
// 7.3.20 SpeciesConstructor(O, defaultConstructor)

var $bmSbf = parcelRequire("bmSbf");

var $aXqxV = parcelRequire("aXqxV");

var $e2777c6f92a7e650$var$SPECIES = (parcelRequire("fqMqf"))('species');
module.exports = function(O, D) {
    var C = $bmSbf(O).constructor;
    var S;
    return C === undefined || (S = $bmSbf(C)[$e2777c6f92a7e650$var$SPECIES]) == undefined ? D : $aXqxV(S);
};

});

parcelRegister("1PWRj", function(module, exports) {
module.exports = function(it, Constructor, name, forbiddenField) {
    if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) throw TypeError(name + ': incorrect invocation!');
    return it;
};

});

parcelRegister("6mCZJ", function(module, exports) {

var $gtY0w = parcelRequire("gtY0w");

var $jlcCz = parcelRequire("jlcCz");
var $4a230ba8565234cc$require$macrotask = $jlcCz.set;
var $4a230ba8565234cc$var$Observer = $gtY0w.MutationObserver || $gtY0w.WebKitMutationObserver;
var $4a230ba8565234cc$var$process = $gtY0w.process;
var $4a230ba8565234cc$var$Promise = $gtY0w.Promise;

var $4a230ba8565234cc$var$isNode = (parcelRequire("1Wc55"))($4a230ba8565234cc$var$process) == 'process';
module.exports = function() {
    var head, last, notify;
    var flush = function() {
        var parent, fn;
        if ($4a230ba8565234cc$var$isNode && (parent = $4a230ba8565234cc$var$process.domain)) parent.exit();
        while(head){
            fn = head.fn;
            head = head.next;
            try {
                fn();
            } catch (e) {
                if (head) notify();
                else last = undefined;
                throw e;
            }
        }
        last = undefined;
        if (parent) parent.enter();
    };
    // Node.js
    if ($4a230ba8565234cc$var$isNode) notify = function() {
        $4a230ba8565234cc$var$process.nextTick(flush);
    };
    else if ($4a230ba8565234cc$var$Observer && !($gtY0w.navigator && $gtY0w.navigator.standalone)) {
        var toggle = true;
        var node = document.createTextNode('');
        new $4a230ba8565234cc$var$Observer(flush).observe(node, {
            characterData: true
        }); // eslint-disable-line no-new
        notify = function() {
            node.data = toggle = !toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if ($4a230ba8565234cc$var$Promise && $4a230ba8565234cc$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        var promise = $4a230ba8565234cc$var$Promise.resolve(undefined);
        notify = function() {
            promise.then(flush);
        };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
    } else notify = function() {
        // strange IE + webpack dev server bug - use .call(global)
        $4a230ba8565234cc$require$macrotask.call($gtY0w, flush);
    };
    return function(fn) {
        var task = {
            fn: fn,
            next: undefined
        };
        if (last) last.next = task;
        if (!head) {
            head = task;
            notify();
        }
        last = task;
    };
};

});
parcelRegister("jlcCz", function(module, exports) {

var $3eawb = parcelRequire("3eawb");

var $2TNdz = parcelRequire("2TNdz");

var $kDGgr = parcelRequire("kDGgr");

var $e9tM3 = parcelRequire("e9tM3");

var $gtY0w = parcelRequire("gtY0w");
var $e149c4cb02d002b2$var$process = $gtY0w.process;
var $e149c4cb02d002b2$var$setTask = $gtY0w.setImmediate;
var $e149c4cb02d002b2$var$clearTask = $gtY0w.clearImmediate;
var $e149c4cb02d002b2$var$MessageChannel = $gtY0w.MessageChannel;
var $e149c4cb02d002b2$var$Dispatch = $gtY0w.Dispatch;
var $e149c4cb02d002b2$var$counter = 0;
var $e149c4cb02d002b2$var$queue = {};
var $e149c4cb02d002b2$var$ONREADYSTATECHANGE = 'onreadystatechange';
var $e149c4cb02d002b2$var$defer, $e149c4cb02d002b2$var$channel, $e149c4cb02d002b2$var$port;
var $e149c4cb02d002b2$var$run = function() {
    var id = +this;
    // eslint-disable-next-line no-prototype-builtins
    if ($e149c4cb02d002b2$var$queue.hasOwnProperty(id)) {
        var fn = $e149c4cb02d002b2$var$queue[id];
        delete $e149c4cb02d002b2$var$queue[id];
        fn();
    }
};
var $e149c4cb02d002b2$var$listener = function(event) {
    $e149c4cb02d002b2$var$run.call(event.data);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$e149c4cb02d002b2$var$setTask || !$e149c4cb02d002b2$var$clearTask) {
    $e149c4cb02d002b2$var$setTask = function setImmediate(fn) {
        var args = [];
        var i = 1;
        while(arguments.length > i)args.push(arguments[i++]);
        $e149c4cb02d002b2$var$queue[++$e149c4cb02d002b2$var$counter] = function() {
            // eslint-disable-next-line no-new-func
            $2TNdz(typeof fn == 'function' ? fn : Function(fn), args);
        };
        $e149c4cb02d002b2$var$defer($e149c4cb02d002b2$var$counter);
        return $e149c4cb02d002b2$var$counter;
    };
    $e149c4cb02d002b2$var$clearTask = function clearImmediate(id) {
        delete $e149c4cb02d002b2$var$queue[id];
    };
    // Node.js 0.8-
    if ((parcelRequire("1Wc55"))($e149c4cb02d002b2$var$process) == 'process') $e149c4cb02d002b2$var$defer = function(id) {
        $e149c4cb02d002b2$var$process.nextTick($3eawb($e149c4cb02d002b2$var$run, id, 1));
    };
    else if ($e149c4cb02d002b2$var$Dispatch && $e149c4cb02d002b2$var$Dispatch.now) $e149c4cb02d002b2$var$defer = function(id) {
        $e149c4cb02d002b2$var$Dispatch.now($3eawb($e149c4cb02d002b2$var$run, id, 1));
    };
    else if ($e149c4cb02d002b2$var$MessageChannel) {
        $e149c4cb02d002b2$var$channel = new $e149c4cb02d002b2$var$MessageChannel();
        $e149c4cb02d002b2$var$port = $e149c4cb02d002b2$var$channel.port2;
        $e149c4cb02d002b2$var$channel.port1.onmessage = $e149c4cb02d002b2$var$listener;
        $e149c4cb02d002b2$var$defer = $3eawb($e149c4cb02d002b2$var$port.postMessage, $e149c4cb02d002b2$var$port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($gtY0w.addEventListener && typeof postMessage == 'function' && !$gtY0w.importScripts) {
        $e149c4cb02d002b2$var$defer = function(id) {
            $gtY0w.postMessage(id + '', '*');
        };
        $gtY0w.addEventListener('message', $e149c4cb02d002b2$var$listener, false);
    // IE8-
    } else if ($e149c4cb02d002b2$var$ONREADYSTATECHANGE in $e9tM3('script')) $e149c4cb02d002b2$var$defer = function(id) {
        $kDGgr.appendChild($e9tM3('script'))[$e149c4cb02d002b2$var$ONREADYSTATECHANGE] = function() {
            $kDGgr.removeChild(this);
            $e149c4cb02d002b2$var$run.call(id);
        };
    };
    else $e149c4cb02d002b2$var$defer = function(id) {
        setTimeout($3eawb($e149c4cb02d002b2$var$run, id, 1), 0);
    };
}
module.exports = {
    set: $e149c4cb02d002b2$var$setTask,
    clear: $e149c4cb02d002b2$var$clearTask
};

});


parcelRegister("8wIxQ", function(module, exports) {

var $bIIwe = parcelRequire("bIIwe");
module.exports = function(target, src, safe) {
    for(var key in src)$bIIwe(target, key, src[key], safe);
    return target;
};

});

parcelRegister("ixLuk", function(module, exports) {
'use strict';

var $gtY0w = parcelRequire("gtY0w");

var $2SWGI = parcelRequire("2SWGI");

var $bIIwe = parcelRequire("bIIwe");

var $8wIxQ = parcelRequire("8wIxQ");

var $gfLLt = parcelRequire("gfLLt");

var $5uNQA = parcelRequire("5uNQA");

var $1PWRj = parcelRequire("1PWRj");

var $lD7l7 = parcelRequire("lD7l7");

var $QlNUq = parcelRequire("QlNUq");

var $gkPUi = parcelRequire("gkPUi");

var $aXF7u = parcelRequire("aXF7u");

var $gFUup = parcelRequire("gFUup");
module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
    var Base = $gtY0w[NAME];
    var C = Base;
    var ADDER = IS_MAP ? 'set' : 'add';
    var proto = C && C.prototype;
    var O = {};
    var fixMethod = function(KEY) {
        var fn = proto[KEY];
        $bIIwe(proto, KEY, KEY == 'delete' ? function(a) {
            return IS_WEAK && !$lD7l7(a) ? false : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'has' ? function has(a) {
            return IS_WEAK && !$lD7l7(a) ? false : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'get' ? function get(a) {
            return IS_WEAK && !$lD7l7(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'add' ? function add(a) {
            fn.call(this, a === 0 ? 0 : a);
            return this;
        } : function set(a, b) {
            fn.call(this, a === 0 ? 0 : a, b);
            return this;
        });
    };
    if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !$QlNUq(function() {
        new C().entries().next();
    }))) {
        // create collection constructor
        C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
        $8wIxQ(C.prototype, methods);
        $gfLLt.NEED = true;
    } else {
        var instance = new C();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
        // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $QlNUq(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        var ACCEPT_ITERABLES = $gkPUi(function(iter) {
            new C(iter);
        }); // eslint-disable-line no-new
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $QlNUq(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new C();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            C = wrapper(function(target, iterable) {
                $1PWRj(target, C, NAME);
                var that = $gFUup(new Base(), target, C);
                if (iterable != undefined) $5uNQA(iterable, IS_MAP, that[ADDER], that);
                return that;
            });
            C.prototype = proto;
            proto.constructor = C;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod('delete');
            fixMethod('has');
            IS_MAP && fixMethod('get');
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && proto.clear) delete proto.clear;
    }
    $aXF7u(C, NAME);
    O[NAME] = C;
    $2SWGI($2SWGI.G + $2SWGI.W + $2SWGI.F * (C != Base), O);
    if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
    return C;
};

});
parcelRegister("gfLLt", function(module, exports) {

var $bd53191bf70de1e1$var$META = (parcelRequire("jwR22"))('meta');

var $lD7l7 = parcelRequire("lD7l7");

var $lXZiV = parcelRequire("lXZiV");

var $8QaBR = parcelRequire("8QaBR");
var $bd53191bf70de1e1$require$setDesc = $8QaBR.f;
var $bd53191bf70de1e1$var$id = 0;
var $bd53191bf70de1e1$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $bd53191bf70de1e1$var$FREEZE = !(parcelRequire("QlNUq"))(function() {
    return $bd53191bf70de1e1$var$isExtensible(Object.preventExtensions({}));
});
var $bd53191bf70de1e1$var$setMeta = function(it) {
    $bd53191bf70de1e1$require$setDesc(it, $bd53191bf70de1e1$var$META, {
        value: {
            i: 'O' + ++$bd53191bf70de1e1$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $bd53191bf70de1e1$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$lD7l7(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$lXZiV(it, $bd53191bf70de1e1$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$bd53191bf70de1e1$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $bd53191bf70de1e1$var$setMeta(it);
    // return object ID
    }
    return it[$bd53191bf70de1e1$var$META].i;
};
var $bd53191bf70de1e1$var$getWeak = function(it, create) {
    if (!$lXZiV(it, $bd53191bf70de1e1$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$bd53191bf70de1e1$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $bd53191bf70de1e1$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$bd53191bf70de1e1$var$META].w;
};
// add metadata on freeze-family methods calling
var $bd53191bf70de1e1$var$onFreeze = function(it) {
    if ($bd53191bf70de1e1$var$FREEZE && $bd53191bf70de1e1$var$meta.NEED && $bd53191bf70de1e1$var$isExtensible(it) && !$lXZiV(it, $bd53191bf70de1e1$var$META)) $bd53191bf70de1e1$var$setMeta(it);
    return it;
};
var $bd53191bf70de1e1$var$meta = module.exports = {
    KEY: $bd53191bf70de1e1$var$META,
    NEED: false,
    fastKey: $bd53191bf70de1e1$var$fastKey,
    getWeak: $bd53191bf70de1e1$var$getWeak,
    onFreeze: $bd53191bf70de1e1$var$onFreeze
};

});

parcelRegister("5uNQA", function(module, exports) {

var $3eawb = parcelRequire("3eawb");

var $2Kbie = parcelRequire("2Kbie");

var $g4dgh = parcelRequire("g4dgh");

var $bmSbf = parcelRequire("bmSbf");

var $2Stpr = parcelRequire("2Stpr");

var $ljgC0 = parcelRequire("ljgC0");
var $40066baf38a66e8a$var$BREAK = {};
var $40066baf38a66e8a$var$RETURN = {};
var $40066baf38a66e8a$var$exports = module.exports = function(iterable, entries, fn, that, ITERATOR) {
    var iterFn = ITERATOR ? function() {
        return iterable;
    } : $ljgC0(iterable);
    var f = $3eawb(fn, that, entries ? 2 : 1);
    var index = 0;
    var length, step, iterator, result;
    if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
    // fast case for arrays with default iterator
    if ($g4dgh(iterFn)) for(length = $2Stpr(iterable.length); length > index; index++){
        result = entries ? f($bmSbf(step = iterable[index])[0], step[1]) : f(iterable[index]);
        if (result === $40066baf38a66e8a$var$BREAK || result === $40066baf38a66e8a$var$RETURN) return result;
    }
    else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done;){
        result = $2Kbie(iterator, f, step.value, entries);
        if (result === $40066baf38a66e8a$var$BREAK || result === $40066baf38a66e8a$var$RETURN) return result;
    }
};
$40066baf38a66e8a$var$exports.BREAK = $40066baf38a66e8a$var$BREAK;
$40066baf38a66e8a$var$exports.RETURN = $40066baf38a66e8a$var$RETURN;

});
parcelRegister("2Kbie", function(module, exports) {
// call something on iterator step with safe closing on error

var $bmSbf = parcelRequire("bmSbf");
module.exports = function(iterator, fn, value, entries) {
    try {
        return entries ? fn($bmSbf(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
        var ret = iterator['return'];
        if (ret !== undefined) $bmSbf(ret.call(iterator));
        throw e;
    }
};

});


parcelRegister("gFUup", function(module, exports) {

var $lD7l7 = parcelRequire("lD7l7");

var $FiBqq = parcelRequire("FiBqq");
var $c23c4b4a3e208058$require$setPrototypeOf = $FiBqq.set;
module.exports = function(that, target, C) {
    var S = target.constructor;
    var P;
    if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && $lD7l7(P) && $c23c4b4a3e208058$require$setPrototypeOf) $c23c4b4a3e208058$require$setPrototypeOf(that, P);
    return that;
};

});


parcelRegister("fCxik", function(module, exports) {

var $gtY0w = parcelRequire("gtY0w");

var $disfj = parcelRequire("disfj");

var $jwR22 = parcelRequire("jwR22");
var $b5f43b427a20afc0$var$TYPED = $jwR22('typed_array');
var $b5f43b427a20afc0$var$VIEW = $jwR22('view');
var $b5f43b427a20afc0$var$ABV = !!($gtY0w.ArrayBuffer && $gtY0w.DataView);
var $b5f43b427a20afc0$var$CONSTR = $b5f43b427a20afc0$var$ABV;
var $b5f43b427a20afc0$var$i = 0;
var $b5f43b427a20afc0$var$l = 9;
var $b5f43b427a20afc0$var$Typed;
var $b5f43b427a20afc0$var$TypedArrayConstructors = 'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'.split(',');
while($b5f43b427a20afc0$var$i < $b5f43b427a20afc0$var$l)if ($b5f43b427a20afc0$var$Typed = $gtY0w[$b5f43b427a20afc0$var$TypedArrayConstructors[$b5f43b427a20afc0$var$i++]]) {
    $disfj($b5f43b427a20afc0$var$Typed.prototype, $b5f43b427a20afc0$var$TYPED, true);
    $disfj($b5f43b427a20afc0$var$Typed.prototype, $b5f43b427a20afc0$var$VIEW, true);
} else $b5f43b427a20afc0$var$CONSTR = false;
module.exports = {
    ABV: $b5f43b427a20afc0$var$ABV,
    CONSTR: $b5f43b427a20afc0$var$CONSTR,
    TYPED: $b5f43b427a20afc0$var$TYPED,
    VIEW: $b5f43b427a20afc0$var$VIEW
};

});

parcelRegister("3ftQA", function(module, exports) {
'use strict';

var $gtY0w = parcelRequire("gtY0w");

var $8iMRJ = parcelRequire("8iMRJ");

var $8qcv4 = parcelRequire("8qcv4");

var $fCxik = parcelRequire("fCxik");

var $disfj = parcelRequire("disfj");

var $8wIxQ = parcelRequire("8wIxQ");

var $QlNUq = parcelRequire("QlNUq");

var $1PWRj = parcelRequire("1PWRj");

var $l8CUX = parcelRequire("l8CUX");

var $2Stpr = parcelRequire("2Stpr");

var $8H6jQ = parcelRequire("8H6jQ");

var $60lWN = parcelRequire("60lWN");
var $25d9ecd4729e6598$require$gOPN = $60lWN.f;

var $8QaBR = parcelRequire("8QaBR");
var $25d9ecd4729e6598$require$dP = $8QaBR.f;

var $hI6TD = parcelRequire("hI6TD");

var $aXF7u = parcelRequire("aXF7u");
var $25d9ecd4729e6598$var$ARRAY_BUFFER = 'ArrayBuffer';
var $25d9ecd4729e6598$var$DATA_VIEW = 'DataView';
var $25d9ecd4729e6598$var$PROTOTYPE = 'prototype';
var $25d9ecd4729e6598$var$WRONG_LENGTH = 'Wrong length!';
var $25d9ecd4729e6598$var$WRONG_INDEX = 'Wrong index!';
var $25d9ecd4729e6598$var$$ArrayBuffer = $gtY0w[$25d9ecd4729e6598$var$ARRAY_BUFFER];
var $25d9ecd4729e6598$var$$DataView = $gtY0w[$25d9ecd4729e6598$var$DATA_VIEW];
var $25d9ecd4729e6598$var$Math = $gtY0w.Math;
var $25d9ecd4729e6598$var$RangeError = $gtY0w.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var $25d9ecd4729e6598$var$Infinity1 = $gtY0w.Infinity;
var $25d9ecd4729e6598$var$BaseBuffer = $25d9ecd4729e6598$var$$ArrayBuffer;
var $25d9ecd4729e6598$var$abs = $25d9ecd4729e6598$var$Math.abs;
var $25d9ecd4729e6598$var$pow = $25d9ecd4729e6598$var$Math.pow;
var $25d9ecd4729e6598$var$floor = $25d9ecd4729e6598$var$Math.floor;
var $25d9ecd4729e6598$var$log = $25d9ecd4729e6598$var$Math.log;
var $25d9ecd4729e6598$var$LN2 = $25d9ecd4729e6598$var$Math.LN2;
var $25d9ecd4729e6598$var$BUFFER = 'buffer';
var $25d9ecd4729e6598$var$BYTE_LENGTH = 'byteLength';
var $25d9ecd4729e6598$var$BYTE_OFFSET = 'byteOffset';
var $25d9ecd4729e6598$var$$BUFFER = $8iMRJ ? '_b' : $25d9ecd4729e6598$var$BUFFER;
var $25d9ecd4729e6598$var$$LENGTH = $8iMRJ ? '_l' : $25d9ecd4729e6598$var$BYTE_LENGTH;
var $25d9ecd4729e6598$var$$OFFSET = $8iMRJ ? '_o' : $25d9ecd4729e6598$var$BYTE_OFFSET;
// IEEE754 conversions based on https://github.com/feross/ieee754
function $25d9ecd4729e6598$var$packIEEE754(value, mLen, nBytes) {
    var buffer = new Array(nBytes);
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? $25d9ecd4729e6598$var$pow(2, -24) - $25d9ecd4729e6598$var$pow(2, -77) : 0;
    var i = 0;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    var e, m, c;
    value = $25d9ecd4729e6598$var$abs(value);
    // eslint-disable-next-line no-self-compare
    if (value != value || value === Infinity) {
        // eslint-disable-next-line no-self-compare
        m = value != value ? 1 : 0;
        e = eMax;
    } else {
        e = $25d9ecd4729e6598$var$floor($25d9ecd4729e6598$var$log(value) / $25d9ecd4729e6598$var$LN2);
        if (value * (c = $25d9ecd4729e6598$var$pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * $25d9ecd4729e6598$var$pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * $25d9ecd4729e6598$var$pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * $25d9ecd4729e6598$var$pow(2, eBias - 1) * $25d9ecd4729e6598$var$pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
    buffer[--i] |= s * 128;
    return buffer;
}
function $25d9ecd4729e6598$var$unpackIEEE754(buffer, mLen, nBytes) {
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = eLen - 7;
    var i = nBytes - 1;
    var s = buffer[i--];
    var e = s & 127;
    var m;
    s >>= 7;
    for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : s ? -Infinity : Infinity;
    else {
        m = m + $25d9ecd4729e6598$var$pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * $25d9ecd4729e6598$var$pow(2, e - mLen);
}
function $25d9ecd4729e6598$var$unpackI32(bytes) {
    return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function $25d9ecd4729e6598$var$packI8(it) {
    return [
        it & 0xff
    ];
}
function $25d9ecd4729e6598$var$packI16(it) {
    return [
        it & 0xff,
        it >> 8 & 0xff
    ];
}
function $25d9ecd4729e6598$var$packI32(it) {
    return [
        it & 0xff,
        it >> 8 & 0xff,
        it >> 16 & 0xff,
        it >> 24 & 0xff
    ];
}
function $25d9ecd4729e6598$var$packF64(it) {
    return $25d9ecd4729e6598$var$packIEEE754(it, 52, 8);
}
function $25d9ecd4729e6598$var$packF32(it) {
    return $25d9ecd4729e6598$var$packIEEE754(it, 23, 4);
}
function $25d9ecd4729e6598$var$addGetter(C, key, internal) {
    $25d9ecd4729e6598$require$dP(C[$25d9ecd4729e6598$var$PROTOTYPE], key, {
        get: function() {
            return this[internal];
        }
    });
}
function $25d9ecd4729e6598$var$get(view, bytes, index, isLittleEndian) {
    var numIndex = +index;
    var intIndex = $8H6jQ(numIndex);
    if (intIndex + bytes > view[$25d9ecd4729e6598$var$$LENGTH]) throw $25d9ecd4729e6598$var$RangeError($25d9ecd4729e6598$var$WRONG_INDEX);
    var store = view[$25d9ecd4729e6598$var$$BUFFER]._b;
    var start = intIndex + view[$25d9ecd4729e6598$var$$OFFSET];
    var pack = store.slice(start, start + bytes);
    return isLittleEndian ? pack : pack.reverse();
}
function $25d9ecd4729e6598$var$set(view, bytes, index, conversion, value, isLittleEndian) {
    var numIndex = +index;
    var intIndex = $8H6jQ(numIndex);
    if (intIndex + bytes > view[$25d9ecd4729e6598$var$$LENGTH]) throw $25d9ecd4729e6598$var$RangeError($25d9ecd4729e6598$var$WRONG_INDEX);
    var store = view[$25d9ecd4729e6598$var$$BUFFER]._b;
    var start = intIndex + view[$25d9ecd4729e6598$var$$OFFSET];
    var pack = conversion(+value);
    for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}
if (!$fCxik.ABV) {
    $25d9ecd4729e6598$var$$ArrayBuffer = function ArrayBuffer(length) {
        $1PWRj(this, $25d9ecd4729e6598$var$$ArrayBuffer, $25d9ecd4729e6598$var$ARRAY_BUFFER);
        var byteLength = $8H6jQ(length);
        this._b = $hI6TD.call(new Array(byteLength), 0);
        this[$25d9ecd4729e6598$var$$LENGTH] = byteLength;
    };
    $25d9ecd4729e6598$var$$DataView = function DataView(buffer, byteOffset, byteLength) {
        $1PWRj(this, $25d9ecd4729e6598$var$$DataView, $25d9ecd4729e6598$var$DATA_VIEW);
        $1PWRj(buffer, $25d9ecd4729e6598$var$$ArrayBuffer, $25d9ecd4729e6598$var$DATA_VIEW);
        var bufferLength = buffer[$25d9ecd4729e6598$var$$LENGTH];
        var offset = $l8CUX(byteOffset);
        if (offset < 0 || offset > bufferLength) throw $25d9ecd4729e6598$var$RangeError('Wrong offset!');
        byteLength = byteLength === undefined ? bufferLength - offset : $2Stpr(byteLength);
        if (offset + byteLength > bufferLength) throw $25d9ecd4729e6598$var$RangeError($25d9ecd4729e6598$var$WRONG_LENGTH);
        this[$25d9ecd4729e6598$var$$BUFFER] = buffer;
        this[$25d9ecd4729e6598$var$$OFFSET] = offset;
        this[$25d9ecd4729e6598$var$$LENGTH] = byteLength;
    };
    if ($8iMRJ) {
        $25d9ecd4729e6598$var$addGetter($25d9ecd4729e6598$var$$ArrayBuffer, $25d9ecd4729e6598$var$BYTE_LENGTH, '_l');
        $25d9ecd4729e6598$var$addGetter($25d9ecd4729e6598$var$$DataView, $25d9ecd4729e6598$var$BUFFER, '_b');
        $25d9ecd4729e6598$var$addGetter($25d9ecd4729e6598$var$$DataView, $25d9ecd4729e6598$var$BYTE_LENGTH, '_l');
        $25d9ecd4729e6598$var$addGetter($25d9ecd4729e6598$var$$DataView, $25d9ecd4729e6598$var$BYTE_OFFSET, '_o');
    }
    $8wIxQ($25d9ecd4729e6598$var$$DataView[$25d9ecd4729e6598$var$PROTOTYPE], {
        getInt8: function getInt8(byteOffset) {
            return $25d9ecd4729e6598$var$get(this, 1, byteOffset)[0] << 24 >> 24;
        },
        getUint8: function getUint8(byteOffset) {
            return $25d9ecd4729e6598$var$get(this, 1, byteOffset)[0];
        },
        getInt16: function getInt16(byteOffset /* , littleEndian */ ) {
            var bytes = $25d9ecd4729e6598$var$get(this, 2, byteOffset, arguments[1]);
            return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
        },
        getUint16: function getUint16(byteOffset /* , littleEndian */ ) {
            var bytes = $25d9ecd4729e6598$var$get(this, 2, byteOffset, arguments[1]);
            return bytes[1] << 8 | bytes[0];
        },
        getInt32: function getInt32(byteOffset /* , littleEndian */ ) {
            return $25d9ecd4729e6598$var$unpackI32($25d9ecd4729e6598$var$get(this, 4, byteOffset, arguments[1]));
        },
        getUint32: function getUint32(byteOffset /* , littleEndian */ ) {
            return $25d9ecd4729e6598$var$unpackI32($25d9ecd4729e6598$var$get(this, 4, byteOffset, arguments[1])) >>> 0;
        },
        getFloat32: function getFloat32(byteOffset /* , littleEndian */ ) {
            return $25d9ecd4729e6598$var$unpackIEEE754($25d9ecd4729e6598$var$get(this, 4, byteOffset, arguments[1]), 23, 4);
        },
        getFloat64: function getFloat64(byteOffset /* , littleEndian */ ) {
            return $25d9ecd4729e6598$var$unpackIEEE754($25d9ecd4729e6598$var$get(this, 8, byteOffset, arguments[1]), 52, 8);
        },
        setInt8: function setInt8(byteOffset, value) {
            $25d9ecd4729e6598$var$set(this, 1, byteOffset, $25d9ecd4729e6598$var$packI8, value);
        },
        setUint8: function setUint8(byteOffset, value) {
            $25d9ecd4729e6598$var$set(this, 1, byteOffset, $25d9ecd4729e6598$var$packI8, value);
        },
        setInt16: function setInt16(byteOffset, value /* , littleEndian */ ) {
            $25d9ecd4729e6598$var$set(this, 2, byteOffset, $25d9ecd4729e6598$var$packI16, value, arguments[2]);
        },
        setUint16: function setUint16(byteOffset, value /* , littleEndian */ ) {
            $25d9ecd4729e6598$var$set(this, 2, byteOffset, $25d9ecd4729e6598$var$packI16, value, arguments[2]);
        },
        setInt32: function setInt32(byteOffset, value /* , littleEndian */ ) {
            $25d9ecd4729e6598$var$set(this, 4, byteOffset, $25d9ecd4729e6598$var$packI32, value, arguments[2]);
        },
        setUint32: function setUint32(byteOffset, value /* , littleEndian */ ) {
            $25d9ecd4729e6598$var$set(this, 4, byteOffset, $25d9ecd4729e6598$var$packI32, value, arguments[2]);
        },
        setFloat32: function setFloat32(byteOffset, value /* , littleEndian */ ) {
            $25d9ecd4729e6598$var$set(this, 4, byteOffset, $25d9ecd4729e6598$var$packF32, value, arguments[2]);
        },
        setFloat64: function setFloat64(byteOffset, value /* , littleEndian */ ) {
            $25d9ecd4729e6598$var$set(this, 8, byteOffset, $25d9ecd4729e6598$var$packF64, value, arguments[2]);
        }
    });
} else {
    if (!$QlNUq(function() {
        $25d9ecd4729e6598$var$$ArrayBuffer(1);
    }) || !$QlNUq(function() {
        new $25d9ecd4729e6598$var$$ArrayBuffer(-1); // eslint-disable-line no-new
    }) || $QlNUq(function() {
        new $25d9ecd4729e6598$var$$ArrayBuffer(); // eslint-disable-line no-new
        new $25d9ecd4729e6598$var$$ArrayBuffer(1.5); // eslint-disable-line no-new
        new $25d9ecd4729e6598$var$$ArrayBuffer(NaN); // eslint-disable-line no-new
        return $25d9ecd4729e6598$var$$ArrayBuffer.name != $25d9ecd4729e6598$var$ARRAY_BUFFER;
    })) {
        $25d9ecd4729e6598$var$$ArrayBuffer = function ArrayBuffer(length) {
            $1PWRj(this, $25d9ecd4729e6598$var$$ArrayBuffer);
            return new $25d9ecd4729e6598$var$BaseBuffer($8H6jQ(length));
        };
        var $25d9ecd4729e6598$var$ArrayBufferProto = $25d9ecd4729e6598$var$$ArrayBuffer[$25d9ecd4729e6598$var$PROTOTYPE] = $25d9ecd4729e6598$var$BaseBuffer[$25d9ecd4729e6598$var$PROTOTYPE];
        for(var $25d9ecd4729e6598$var$keys = $25d9ecd4729e6598$require$gOPN($25d9ecd4729e6598$var$BaseBuffer), $25d9ecd4729e6598$var$j = 0, $25d9ecd4729e6598$var$key; $25d9ecd4729e6598$var$keys.length > $25d9ecd4729e6598$var$j;)if (!(($25d9ecd4729e6598$var$key = $25d9ecd4729e6598$var$keys[$25d9ecd4729e6598$var$j++]) in $25d9ecd4729e6598$var$$ArrayBuffer)) $disfj($25d9ecd4729e6598$var$$ArrayBuffer, $25d9ecd4729e6598$var$key, $25d9ecd4729e6598$var$BaseBuffer[$25d9ecd4729e6598$var$key]);
        if (!$8qcv4) $25d9ecd4729e6598$var$ArrayBufferProto.constructor = $25d9ecd4729e6598$var$$ArrayBuffer;
    }
    // iOS Safari 7.x bug
    var $25d9ecd4729e6598$var$view = new $25d9ecd4729e6598$var$$DataView(new $25d9ecd4729e6598$var$$ArrayBuffer(2));
    var $25d9ecd4729e6598$var$$setInt8 = $25d9ecd4729e6598$var$$DataView[$25d9ecd4729e6598$var$PROTOTYPE].setInt8;
    $25d9ecd4729e6598$var$view.setInt8(0, 2147483648);
    $25d9ecd4729e6598$var$view.setInt8(1, 2147483649);
    if ($25d9ecd4729e6598$var$view.getInt8(0) || !$25d9ecd4729e6598$var$view.getInt8(1)) $8wIxQ($25d9ecd4729e6598$var$$DataView[$25d9ecd4729e6598$var$PROTOTYPE], {
        setInt8: function setInt8(byteOffset, value) {
            $25d9ecd4729e6598$var$$setInt8.call(this, byteOffset, value << 24 >> 24);
        },
        setUint8: function setUint8(byteOffset, value) {
            $25d9ecd4729e6598$var$$setInt8.call(this, byteOffset, value << 24 >> 24);
        }
    }, true);
}
$aXF7u($25d9ecd4729e6598$var$$ArrayBuffer, $25d9ecd4729e6598$var$ARRAY_BUFFER);
$aXF7u($25d9ecd4729e6598$var$$DataView, $25d9ecd4729e6598$var$DATA_VIEW);
$disfj($25d9ecd4729e6598$var$$DataView[$25d9ecd4729e6598$var$PROTOTYPE], $fCxik.VIEW, true);
module.exports[$25d9ecd4729e6598$var$ARRAY_BUFFER] = $25d9ecd4729e6598$var$$ArrayBuffer;
module.exports[$25d9ecd4729e6598$var$DATA_VIEW] = $25d9ecd4729e6598$var$$DataView;

});
parcelRegister("8H6jQ", function(module, exports) {
// https://tc39.github.io/ecma262/#sec-toindex

var $l8CUX = parcelRequire("l8CUX");

var $2Stpr = parcelRequire("2Stpr");
module.exports = function(it) {
    if (it === undefined) return 0;
    var number = $l8CUX(it);
    var length = $2Stpr(number);
    if (number !== length) throw RangeError('Wrong length!');
    return length;
};

});


parcelRegister("lrRPW", function(module, exports) {
'use strict';







































if ((parcelRequire("8iMRJ"))) {
    var $f9d5e174f519189f$var$LIBRARY = (parcelRequire("8qcv4"));
    var $f9d5e174f519189f$var$global = (parcelRequire("gtY0w"));
    var $f9d5e174f519189f$var$fails = (parcelRequire("QlNUq"));
    var $f9d5e174f519189f$var$$export = (parcelRequire("2SWGI"));
    var $f9d5e174f519189f$var$$typed = (parcelRequire("fCxik"));
    var $f9d5e174f519189f$var$$buffer = (parcelRequire("3ftQA"));
    var $f9d5e174f519189f$var$ctx = (parcelRequire("3eawb"));
    var $f9d5e174f519189f$var$anInstance = (parcelRequire("1PWRj"));
    var $f9d5e174f519189f$var$propertyDesc = (parcelRequire("cttRt"));
    var $f9d5e174f519189f$var$hide = (parcelRequire("disfj"));
    var $f9d5e174f519189f$var$redefineAll = (parcelRequire("8wIxQ"));
    var $f9d5e174f519189f$var$toInteger = (parcelRequire("l8CUX"));
    var $f9d5e174f519189f$var$toLength = (parcelRequire("2Stpr"));
    var $f9d5e174f519189f$var$toIndex = (parcelRequire("8H6jQ"));
    var $f9d5e174f519189f$var$toAbsoluteIndex = (parcelRequire("anH1q"));
    var $f9d5e174f519189f$var$toPrimitive = (parcelRequire("01Csn"));
    var $f9d5e174f519189f$var$has = (parcelRequire("lXZiV"));
    var $f9d5e174f519189f$var$classof = (parcelRequire("03JDo"));
    var $f9d5e174f519189f$var$isObject = (parcelRequire("lD7l7"));
    var $f9d5e174f519189f$var$toObject = (parcelRequire("7bwTf"));
    var $f9d5e174f519189f$var$isArrayIter = (parcelRequire("g4dgh"));
    var $f9d5e174f519189f$var$create = (parcelRequire("3upGD"));
    var $f9d5e174f519189f$var$getPrototypeOf = (parcelRequire("5nB59"));
    var $f9d5e174f519189f$var$gOPN = (parcelRequire("60lWN")).f;
    var $f9d5e174f519189f$var$getIterFn = (parcelRequire("ljgC0"));
    var $f9d5e174f519189f$var$uid = (parcelRequire("jwR22"));
    var $f9d5e174f519189f$var$wks = (parcelRequire("fqMqf"));
    var $f9d5e174f519189f$var$createArrayMethod = (parcelRequire("3gy3i"));
    var $f9d5e174f519189f$var$createArrayIncludes = (parcelRequire("2zzLE"));
    var $f9d5e174f519189f$var$speciesConstructor = (parcelRequire("jrtAb"));
    var $f9d5e174f519189f$var$ArrayIterators = (parcelRequire("i0uZ5"));
    var $f9d5e174f519189f$var$Iterators = (parcelRequire("1VgEQ"));
    var $f9d5e174f519189f$var$$iterDetect = (parcelRequire("gkPUi"));
    var $f9d5e174f519189f$var$setSpecies = (parcelRequire("bDRPQ"));
    var $f9d5e174f519189f$var$arrayFill = (parcelRequire("hI6TD"));
    var $f9d5e174f519189f$var$arrayCopyWithin = (parcelRequire("kavIj"));
    var $f9d5e174f519189f$var$$DP = (parcelRequire("8QaBR"));
    var $f9d5e174f519189f$var$$GOPD = (parcelRequire("11pTE"));
    var $f9d5e174f519189f$var$dP = $f9d5e174f519189f$var$$DP.f;
    var $f9d5e174f519189f$var$gOPD = $f9d5e174f519189f$var$$GOPD.f;
    var $f9d5e174f519189f$var$RangeError = $f9d5e174f519189f$var$global.RangeError;
    var $f9d5e174f519189f$var$TypeError = $f9d5e174f519189f$var$global.TypeError;
    var $f9d5e174f519189f$var$Uint8Array = $f9d5e174f519189f$var$global.Uint8Array;
    var $f9d5e174f519189f$var$ARRAY_BUFFER = 'ArrayBuffer';
    var $f9d5e174f519189f$var$SHARED_BUFFER = 'Shared' + $f9d5e174f519189f$var$ARRAY_BUFFER;
    var $f9d5e174f519189f$var$BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
    var $f9d5e174f519189f$var$PROTOTYPE = 'prototype';
    var $f9d5e174f519189f$var$ArrayProto = Array[$f9d5e174f519189f$var$PROTOTYPE];
    var $f9d5e174f519189f$var$$ArrayBuffer = $f9d5e174f519189f$var$$buffer.ArrayBuffer;
    var $f9d5e174f519189f$var$$DataView = $f9d5e174f519189f$var$$buffer.DataView;
    var $f9d5e174f519189f$var$arrayForEach = $f9d5e174f519189f$var$createArrayMethod(0);
    var $f9d5e174f519189f$var$arrayFilter = $f9d5e174f519189f$var$createArrayMethod(2);
    var $f9d5e174f519189f$var$arraySome = $f9d5e174f519189f$var$createArrayMethod(3);
    var $f9d5e174f519189f$var$arrayEvery = $f9d5e174f519189f$var$createArrayMethod(4);
    var $f9d5e174f519189f$var$arrayFind = $f9d5e174f519189f$var$createArrayMethod(5);
    var $f9d5e174f519189f$var$arrayFindIndex = $f9d5e174f519189f$var$createArrayMethod(6);
    var $f9d5e174f519189f$var$arrayIncludes = $f9d5e174f519189f$var$createArrayIncludes(true);
    var $f9d5e174f519189f$var$arrayIndexOf = $f9d5e174f519189f$var$createArrayIncludes(false);
    var $f9d5e174f519189f$var$arrayValues = $f9d5e174f519189f$var$ArrayIterators.values;
    var $f9d5e174f519189f$var$arrayKeys = $f9d5e174f519189f$var$ArrayIterators.keys;
    var $f9d5e174f519189f$var$arrayEntries = $f9d5e174f519189f$var$ArrayIterators.entries;
    var $f9d5e174f519189f$var$arrayLastIndexOf = $f9d5e174f519189f$var$ArrayProto.lastIndexOf;
    var $f9d5e174f519189f$var$arrayReduce = $f9d5e174f519189f$var$ArrayProto.reduce;
    var $f9d5e174f519189f$var$arrayReduceRight = $f9d5e174f519189f$var$ArrayProto.reduceRight;
    var $f9d5e174f519189f$var$arrayJoin = $f9d5e174f519189f$var$ArrayProto.join;
    var $f9d5e174f519189f$var$arraySort = $f9d5e174f519189f$var$ArrayProto.sort;
    var $f9d5e174f519189f$var$arraySlice = $f9d5e174f519189f$var$ArrayProto.slice;
    var $f9d5e174f519189f$var$arrayToString = $f9d5e174f519189f$var$ArrayProto.toString;
    var $f9d5e174f519189f$var$arrayToLocaleString = $f9d5e174f519189f$var$ArrayProto.toLocaleString;
    var $f9d5e174f519189f$var$ITERATOR = $f9d5e174f519189f$var$wks('iterator');
    var $f9d5e174f519189f$var$TAG = $f9d5e174f519189f$var$wks('toStringTag');
    var $f9d5e174f519189f$var$TYPED_CONSTRUCTOR = $f9d5e174f519189f$var$uid('typed_constructor');
    var $f9d5e174f519189f$var$DEF_CONSTRUCTOR = $f9d5e174f519189f$var$uid('def_constructor');
    var $f9d5e174f519189f$var$ALL_CONSTRUCTORS = $f9d5e174f519189f$var$$typed.CONSTR;
    var $f9d5e174f519189f$var$TYPED_ARRAY = $f9d5e174f519189f$var$$typed.TYPED;
    var $f9d5e174f519189f$var$VIEW = $f9d5e174f519189f$var$$typed.VIEW;
    var $f9d5e174f519189f$var$WRONG_LENGTH = 'Wrong length!';
    var $f9d5e174f519189f$var$$map = $f9d5e174f519189f$var$createArrayMethod(1, function(O, length) {
        return $f9d5e174f519189f$var$allocate($f9d5e174f519189f$var$speciesConstructor(O, O[$f9d5e174f519189f$var$DEF_CONSTRUCTOR]), length);
    });
    var $f9d5e174f519189f$var$LITTLE_ENDIAN = $f9d5e174f519189f$var$fails(function() {
        // eslint-disable-next-line no-undef
        return new $f9d5e174f519189f$var$Uint8Array(new Uint16Array([
            1
        ]).buffer)[0] === 1;
    });
    var $f9d5e174f519189f$var$FORCED_SET = !!$f9d5e174f519189f$var$Uint8Array && !!$f9d5e174f519189f$var$Uint8Array[$f9d5e174f519189f$var$PROTOTYPE].set && $f9d5e174f519189f$var$fails(function() {
        new $f9d5e174f519189f$var$Uint8Array(1).set({});
    });
    var $f9d5e174f519189f$var$toOffset = function(it, BYTES) {
        var offset = $f9d5e174f519189f$var$toInteger(it);
        if (offset < 0 || offset % BYTES) throw $f9d5e174f519189f$var$RangeError('Wrong offset!');
        return offset;
    };
    var $f9d5e174f519189f$var$validate = function(it) {
        if ($f9d5e174f519189f$var$isObject(it) && $f9d5e174f519189f$var$TYPED_ARRAY in it) return it;
        throw $f9d5e174f519189f$var$TypeError(it + ' is not a typed array!');
    };
    var $f9d5e174f519189f$var$allocate = function(C, length) {
        if (!($f9d5e174f519189f$var$isObject(C) && $f9d5e174f519189f$var$TYPED_CONSTRUCTOR in C)) throw $f9d5e174f519189f$var$TypeError('It is not a typed array constructor!');
        return new C(length);
    };
    var $f9d5e174f519189f$var$speciesFromList = function(O, list) {
        return $f9d5e174f519189f$var$fromList($f9d5e174f519189f$var$speciesConstructor(O, O[$f9d5e174f519189f$var$DEF_CONSTRUCTOR]), list);
    };
    var $f9d5e174f519189f$var$fromList = function(C, list) {
        var index = 0;
        var length = list.length;
        var result = $f9d5e174f519189f$var$allocate(C, length);
        while(length > index)result[index] = list[index++];
        return result;
    };
    var $f9d5e174f519189f$var$addGetter = function(it, key, internal) {
        $f9d5e174f519189f$var$dP(it, key, {
            get: function() {
                return this._d[internal];
            }
        });
    };
    var $f9d5e174f519189f$var$$from = function from(source /* , mapfn, thisArg */ ) {
        var O = $f9d5e174f519189f$var$toObject(source);
        var aLen = arguments.length;
        var mapfn = aLen > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var iterFn = $f9d5e174f519189f$var$getIterFn(O);
        var i, length, values, result, step, iterator;
        if (iterFn != undefined && !$f9d5e174f519189f$var$isArrayIter(iterFn)) {
            for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++)values.push(step.value);
            O = values;
        }
        if (mapping && aLen > 2) mapfn = $f9d5e174f519189f$var$ctx(mapfn, arguments[2], 2);
        for(i = 0, length = $f9d5e174f519189f$var$toLength(O.length), result = $f9d5e174f519189f$var$allocate(this, length); length > i; i++)result[i] = mapping ? mapfn(O[i], i) : O[i];
        return result;
    };
    var $f9d5e174f519189f$var$$of = function of() {
        var index = 0;
        var length = arguments.length;
        var result = $f9d5e174f519189f$var$allocate(this, length);
        while(length > index)result[index] = arguments[index++];
        return result;
    };
    // iOS Safari 6.x fails here
    var $f9d5e174f519189f$var$TO_LOCALE_BUG = !!$f9d5e174f519189f$var$Uint8Array && $f9d5e174f519189f$var$fails(function() {
        $f9d5e174f519189f$var$arrayToLocaleString.call(new $f9d5e174f519189f$var$Uint8Array(1));
    });
    var $f9d5e174f519189f$var$$toLocaleString = function toLocaleString() {
        return $f9d5e174f519189f$var$arrayToLocaleString.apply($f9d5e174f519189f$var$TO_LOCALE_BUG ? $f9d5e174f519189f$var$arraySlice.call($f9d5e174f519189f$var$validate(this)) : $f9d5e174f519189f$var$validate(this), arguments);
    };
    var $f9d5e174f519189f$var$proto = {
        copyWithin: function copyWithin(target, start /* , end */ ) {
            return $f9d5e174f519189f$var$arrayCopyWithin.call($f9d5e174f519189f$var$validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
        },
        every: function every(callbackfn /* , thisArg */ ) {
            return $f9d5e174f519189f$var$arrayEvery($f9d5e174f519189f$var$validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        fill: function fill(value /* , start, end */ ) {
            return $f9d5e174f519189f$var$arrayFill.apply($f9d5e174f519189f$var$validate(this), arguments);
        },
        filter: function filter(callbackfn /* , thisArg */ ) {
            return $f9d5e174f519189f$var$speciesFromList(this, $f9d5e174f519189f$var$arrayFilter($f9d5e174f519189f$var$validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
        },
        find: function find(predicate /* , thisArg */ ) {
            return $f9d5e174f519189f$var$arrayFind($f9d5e174f519189f$var$validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
        },
        findIndex: function findIndex(predicate /* , thisArg */ ) {
            return $f9d5e174f519189f$var$arrayFindIndex($f9d5e174f519189f$var$validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
        },
        forEach: function forEach(callbackfn /* , thisArg */ ) {
            $f9d5e174f519189f$var$arrayForEach($f9d5e174f519189f$var$validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        indexOf: function indexOf(searchElement /* , fromIndex */ ) {
            return $f9d5e174f519189f$var$arrayIndexOf($f9d5e174f519189f$var$validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
        },
        includes: function includes(searchElement /* , fromIndex */ ) {
            return $f9d5e174f519189f$var$arrayIncludes($f9d5e174f519189f$var$validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
        },
        join: function join(separator) {
            return $f9d5e174f519189f$var$arrayJoin.apply($f9d5e174f519189f$var$validate(this), arguments);
        },
        lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */ ) {
            return $f9d5e174f519189f$var$arrayLastIndexOf.apply($f9d5e174f519189f$var$validate(this), arguments);
        },
        map: function map(mapfn /* , thisArg */ ) {
            return $f9d5e174f519189f$var$$map($f9d5e174f519189f$var$validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        reduce: function reduce(callbackfn /* , initialValue */ ) {
            return $f9d5e174f519189f$var$arrayReduce.apply($f9d5e174f519189f$var$validate(this), arguments);
        },
        reduceRight: function reduceRight(callbackfn /* , initialValue */ ) {
            return $f9d5e174f519189f$var$arrayReduceRight.apply($f9d5e174f519189f$var$validate(this), arguments);
        },
        reverse: function reverse() {
            var that = this;
            var length = $f9d5e174f519189f$var$validate(that).length;
            var middle = Math.floor(length / 2);
            var index = 0;
            var value;
            while(index < middle){
                value = that[index];
                that[index++] = that[--length];
                that[length] = value;
            }
            return that;
        },
        some: function some(callbackfn /* , thisArg */ ) {
            return $f9d5e174f519189f$var$arraySome($f9d5e174f519189f$var$validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        sort: function sort(comparefn) {
            return $f9d5e174f519189f$var$arraySort.call($f9d5e174f519189f$var$validate(this), comparefn);
        },
        subarray: function subarray(begin, end) {
            var O = $f9d5e174f519189f$var$validate(this);
            var length = O.length;
            var $begin = $f9d5e174f519189f$var$toAbsoluteIndex(begin, length);
            return new ($f9d5e174f519189f$var$speciesConstructor(O, O[$f9d5e174f519189f$var$DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, $f9d5e174f519189f$var$toLength((end === undefined ? length : $f9d5e174f519189f$var$toAbsoluteIndex(end, length)) - $begin));
        }
    };
    var $f9d5e174f519189f$var$$slice = function slice(start, end) {
        return $f9d5e174f519189f$var$speciesFromList(this, $f9d5e174f519189f$var$arraySlice.call($f9d5e174f519189f$var$validate(this), start, end));
    };
    var $f9d5e174f519189f$var$$set = function set(arrayLike /* , offset */ ) {
        $f9d5e174f519189f$var$validate(this);
        var offset = $f9d5e174f519189f$var$toOffset(arguments[1], 1);
        var length = this.length;
        var src = $f9d5e174f519189f$var$toObject(arrayLike);
        var len = $f9d5e174f519189f$var$toLength(src.length);
        var index = 0;
        if (len + offset > length) throw $f9d5e174f519189f$var$RangeError($f9d5e174f519189f$var$WRONG_LENGTH);
        while(index < len)this[offset + index] = src[index++];
    };
    var $f9d5e174f519189f$var$$iterators = {
        entries: function entries() {
            return $f9d5e174f519189f$var$arrayEntries.call($f9d5e174f519189f$var$validate(this));
        },
        keys: function keys() {
            return $f9d5e174f519189f$var$arrayKeys.call($f9d5e174f519189f$var$validate(this));
        },
        values: function values() {
            return $f9d5e174f519189f$var$arrayValues.call($f9d5e174f519189f$var$validate(this));
        }
    };
    var $f9d5e174f519189f$var$isTAIndex = function(target, key) {
        return $f9d5e174f519189f$var$isObject(target) && target[$f9d5e174f519189f$var$TYPED_ARRAY] && typeof key != 'symbol' && key in target && String(+key) == String(key);
    };
    var $f9d5e174f519189f$var$$getDesc = function getOwnPropertyDescriptor(target, key) {
        return $f9d5e174f519189f$var$isTAIndex(target, key = $f9d5e174f519189f$var$toPrimitive(key, true)) ? $f9d5e174f519189f$var$propertyDesc(2, target[key]) : $f9d5e174f519189f$var$gOPD(target, key);
    };
    var $f9d5e174f519189f$var$$setDesc = function defineProperty(target, key, desc) {
        if ($f9d5e174f519189f$var$isTAIndex(target, key = $f9d5e174f519189f$var$toPrimitive(key, true)) && $f9d5e174f519189f$var$isObject(desc) && $f9d5e174f519189f$var$has(desc, 'value') && !$f9d5e174f519189f$var$has(desc, 'get') && !$f9d5e174f519189f$var$has(desc, 'set') && !desc.configurable && (!$f9d5e174f519189f$var$has(desc, 'writable') || desc.writable) && (!$f9d5e174f519189f$var$has(desc, 'enumerable') || desc.enumerable)) {
            target[key] = desc.value;
            return target;
        }
        return $f9d5e174f519189f$var$dP(target, key, desc);
    };
    if (!$f9d5e174f519189f$var$ALL_CONSTRUCTORS) {
        $f9d5e174f519189f$var$$GOPD.f = $f9d5e174f519189f$var$$getDesc;
        $f9d5e174f519189f$var$$DP.f = $f9d5e174f519189f$var$$setDesc;
    }
    $f9d5e174f519189f$var$$export($f9d5e174f519189f$var$$export.S + $f9d5e174f519189f$var$$export.F * !$f9d5e174f519189f$var$ALL_CONSTRUCTORS, 'Object', {
        getOwnPropertyDescriptor: $f9d5e174f519189f$var$$getDesc,
        defineProperty: $f9d5e174f519189f$var$$setDesc
    });
    if ($f9d5e174f519189f$var$fails(function() {
        $f9d5e174f519189f$var$arrayToString.call({});
    })) $f9d5e174f519189f$var$arrayToString = $f9d5e174f519189f$var$arrayToLocaleString = function toString() {
        return $f9d5e174f519189f$var$arrayJoin.call(this);
    };
    var $f9d5e174f519189f$var$$TypedArrayPrototype$ = $f9d5e174f519189f$var$redefineAll({}, $f9d5e174f519189f$var$proto);
    $f9d5e174f519189f$var$redefineAll($f9d5e174f519189f$var$$TypedArrayPrototype$, $f9d5e174f519189f$var$$iterators);
    $f9d5e174f519189f$var$hide($f9d5e174f519189f$var$$TypedArrayPrototype$, $f9d5e174f519189f$var$ITERATOR, $f9d5e174f519189f$var$$iterators.values);
    $f9d5e174f519189f$var$redefineAll($f9d5e174f519189f$var$$TypedArrayPrototype$, {
        slice: $f9d5e174f519189f$var$$slice,
        set: $f9d5e174f519189f$var$$set,
        constructor: function() {},
        toString: $f9d5e174f519189f$var$arrayToString,
        toLocaleString: $f9d5e174f519189f$var$$toLocaleString
    });
    $f9d5e174f519189f$var$addGetter($f9d5e174f519189f$var$$TypedArrayPrototype$, 'buffer', 'b');
    $f9d5e174f519189f$var$addGetter($f9d5e174f519189f$var$$TypedArrayPrototype$, 'byteOffset', 'o');
    $f9d5e174f519189f$var$addGetter($f9d5e174f519189f$var$$TypedArrayPrototype$, 'byteLength', 'l');
    $f9d5e174f519189f$var$addGetter($f9d5e174f519189f$var$$TypedArrayPrototype$, 'length', 'e');
    $f9d5e174f519189f$var$dP($f9d5e174f519189f$var$$TypedArrayPrototype$, $f9d5e174f519189f$var$TAG, {
        get: function() {
            return this[$f9d5e174f519189f$var$TYPED_ARRAY];
        }
    });
    // eslint-disable-next-line max-statements
    module.exports = function(KEY, BYTES, wrapper, CLAMPED) {
        CLAMPED = !!CLAMPED;
        var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
        var GETTER = 'get' + KEY;
        var SETTER = 'set' + KEY;
        var TypedArray = $f9d5e174f519189f$var$global[NAME];
        var Base = TypedArray || {};
        var TAC = TypedArray && $f9d5e174f519189f$var$getPrototypeOf(TypedArray);
        var FORCED = !TypedArray || !$f9d5e174f519189f$var$$typed.ABV;
        var O = {};
        var TypedArrayPrototype = TypedArray && TypedArray[$f9d5e174f519189f$var$PROTOTYPE];
        var getter = function(that, index) {
            var data = that._d;
            return data.v[GETTER](index * BYTES + data.o, $f9d5e174f519189f$var$LITTLE_ENDIAN);
        };
        var setter = function(that, index, value) {
            var data = that._d;
            if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
            data.v[SETTER](index * BYTES + data.o, value, $f9d5e174f519189f$var$LITTLE_ENDIAN);
        };
        var addElement = function(that, index) {
            $f9d5e174f519189f$var$dP(that, index, {
                get: function() {
                    return getter(this, index);
                },
                set: function(value) {
                    return setter(this, index, value);
                },
                enumerable: true
            });
        };
        if (FORCED) {
            TypedArray = wrapper(function(that, data, $offset, $length) {
                $f9d5e174f519189f$var$anInstance(that, TypedArray, NAME, '_d');
                var index = 0;
                var offset = 0;
                var buffer, byteLength, length, klass;
                if (!$f9d5e174f519189f$var$isObject(data)) {
                    length = $f9d5e174f519189f$var$toIndex(data);
                    byteLength = length * BYTES;
                    buffer = new $f9d5e174f519189f$var$$ArrayBuffer(byteLength);
                } else if (data instanceof $f9d5e174f519189f$var$$ArrayBuffer || (klass = $f9d5e174f519189f$var$classof(data)) == $f9d5e174f519189f$var$ARRAY_BUFFER || klass == $f9d5e174f519189f$var$SHARED_BUFFER) {
                    buffer = data;
                    offset = $f9d5e174f519189f$var$toOffset($offset, BYTES);
                    var $len = data.byteLength;
                    if ($length === undefined) {
                        if ($len % BYTES) throw $f9d5e174f519189f$var$RangeError($f9d5e174f519189f$var$WRONG_LENGTH);
                        byteLength = $len - offset;
                        if (byteLength < 0) throw $f9d5e174f519189f$var$RangeError($f9d5e174f519189f$var$WRONG_LENGTH);
                    } else {
                        byteLength = $f9d5e174f519189f$var$toLength($length) * BYTES;
                        if (byteLength + offset > $len) throw $f9d5e174f519189f$var$RangeError($f9d5e174f519189f$var$WRONG_LENGTH);
                    }
                    length = byteLength / BYTES;
                } else if ($f9d5e174f519189f$var$TYPED_ARRAY in data) return $f9d5e174f519189f$var$fromList(TypedArray, data);
                else return $f9d5e174f519189f$var$$from.call(TypedArray, data);
                $f9d5e174f519189f$var$hide(that, '_d', {
                    b: buffer,
                    o: offset,
                    l: byteLength,
                    e: length,
                    v: new $f9d5e174f519189f$var$$DataView(buffer)
                });
                while(index < length)addElement(that, index++);
            });
            TypedArrayPrototype = TypedArray[$f9d5e174f519189f$var$PROTOTYPE] = $f9d5e174f519189f$var$create($f9d5e174f519189f$var$$TypedArrayPrototype$);
            $f9d5e174f519189f$var$hide(TypedArrayPrototype, 'constructor', TypedArray);
        } else if (!$f9d5e174f519189f$var$fails(function() {
            TypedArray(1);
        }) || !$f9d5e174f519189f$var$fails(function() {
            new TypedArray(-1); // eslint-disable-line no-new
        }) || !$f9d5e174f519189f$var$$iterDetect(function(iter) {
            new TypedArray(); // eslint-disable-line no-new
            new TypedArray(null); // eslint-disable-line no-new
            new TypedArray(1.5); // eslint-disable-line no-new
            new TypedArray(iter); // eslint-disable-line no-new
        }, true)) {
            TypedArray = wrapper(function(that, data, $offset, $length) {
                $f9d5e174f519189f$var$anInstance(that, TypedArray, NAME);
                var klass;
                // `ws` module bug, temporarily remove validation length for Uint8Array
                // https://github.com/websockets/ws/pull/645
                if (!$f9d5e174f519189f$var$isObject(data)) return new Base($f9d5e174f519189f$var$toIndex(data));
                if (data instanceof $f9d5e174f519189f$var$$ArrayBuffer || (klass = $f9d5e174f519189f$var$classof(data)) == $f9d5e174f519189f$var$ARRAY_BUFFER || klass == $f9d5e174f519189f$var$SHARED_BUFFER) return $length !== undefined ? new Base(data, $f9d5e174f519189f$var$toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, $f9d5e174f519189f$var$toOffset($offset, BYTES)) : new Base(data);
                if ($f9d5e174f519189f$var$TYPED_ARRAY in data) return $f9d5e174f519189f$var$fromList(TypedArray, data);
                return $f9d5e174f519189f$var$$from.call(TypedArray, data);
            });
            $f9d5e174f519189f$var$arrayForEach(TAC !== Function.prototype ? $f9d5e174f519189f$var$gOPN(Base).concat($f9d5e174f519189f$var$gOPN(TAC)) : $f9d5e174f519189f$var$gOPN(Base), function(key) {
                if (!(key in TypedArray)) $f9d5e174f519189f$var$hide(TypedArray, key, Base[key]);
            });
            TypedArray[$f9d5e174f519189f$var$PROTOTYPE] = TypedArrayPrototype;
            if (!$f9d5e174f519189f$var$LIBRARY) TypedArrayPrototype.constructor = TypedArray;
        }
        var $nativeIterator = TypedArrayPrototype[$f9d5e174f519189f$var$ITERATOR];
        var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
        var $iterator = $f9d5e174f519189f$var$$iterators.values;
        $f9d5e174f519189f$var$hide(TypedArray, $f9d5e174f519189f$var$TYPED_CONSTRUCTOR, true);
        $f9d5e174f519189f$var$hide(TypedArrayPrototype, $f9d5e174f519189f$var$TYPED_ARRAY, NAME);
        $f9d5e174f519189f$var$hide(TypedArrayPrototype, $f9d5e174f519189f$var$VIEW, true);
        $f9d5e174f519189f$var$hide(TypedArrayPrototype, $f9d5e174f519189f$var$DEF_CONSTRUCTOR, TypedArray);
        if (CLAMPED ? new TypedArray(1)[$f9d5e174f519189f$var$TAG] != NAME : !($f9d5e174f519189f$var$TAG in TypedArrayPrototype)) $f9d5e174f519189f$var$dP(TypedArrayPrototype, $f9d5e174f519189f$var$TAG, {
            get: function() {
                return NAME;
            }
        });
        O[NAME] = TypedArray;
        $f9d5e174f519189f$var$$export($f9d5e174f519189f$var$$export.G + $f9d5e174f519189f$var$$export.W + $f9d5e174f519189f$var$$export.F * (TypedArray != Base), O);
        $f9d5e174f519189f$var$$export($f9d5e174f519189f$var$$export.S, NAME, {
            BYTES_PER_ELEMENT: BYTES
        });
        $f9d5e174f519189f$var$$export($f9d5e174f519189f$var$$export.S + $f9d5e174f519189f$var$$export.F * $f9d5e174f519189f$var$fails(function() {
            Base.of.call(TypedArray, 1);
        }), NAME, {
            from: $f9d5e174f519189f$var$$from,
            of: $f9d5e174f519189f$var$$of
        });
        if (!($f9d5e174f519189f$var$BYTES_PER_ELEMENT in TypedArrayPrototype)) $f9d5e174f519189f$var$hide(TypedArrayPrototype, $f9d5e174f519189f$var$BYTES_PER_ELEMENT, BYTES);
        $f9d5e174f519189f$var$$export($f9d5e174f519189f$var$$export.P, NAME, $f9d5e174f519189f$var$proto);
        $f9d5e174f519189f$var$setSpecies(NAME);
        $f9d5e174f519189f$var$$export($f9d5e174f519189f$var$$export.P + $f9d5e174f519189f$var$$export.F * $f9d5e174f519189f$var$FORCED_SET, NAME, {
            set: $f9d5e174f519189f$var$$set
        });
        $f9d5e174f519189f$var$$export($f9d5e174f519189f$var$$export.P + $f9d5e174f519189f$var$$export.F * !CORRECT_ITER_NAME, NAME, $f9d5e174f519189f$var$$iterators);
        if (!$f9d5e174f519189f$var$LIBRARY && TypedArrayPrototype.toString != $f9d5e174f519189f$var$arrayToString) TypedArrayPrototype.toString = $f9d5e174f519189f$var$arrayToString;
        $f9d5e174f519189f$var$$export($f9d5e174f519189f$var$$export.P + $f9d5e174f519189f$var$$export.F * $f9d5e174f519189f$var$fails(function() {
            new TypedArray(1).slice();
        }), NAME, {
            slice: $f9d5e174f519189f$var$$slice
        });
        $f9d5e174f519189f$var$$export($f9d5e174f519189f$var$$export.P + $f9d5e174f519189f$var$$export.F * ($f9d5e174f519189f$var$fails(function() {
            return [
                1,
                2
            ].toLocaleString() != new TypedArray([
                1,
                2
            ]).toLocaleString();
        }) || !$f9d5e174f519189f$var$fails(function() {
            TypedArrayPrototype.toLocaleString.call([
                1,
                2
            ]);
        })), NAME, {
            toLocaleString: $f9d5e174f519189f$var$$toLocaleString
        });
        $f9d5e174f519189f$var$Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
        if (!$f9d5e174f519189f$var$LIBRARY && !CORRECT_ITER_NAME) $f9d5e174f519189f$var$hide(TypedArrayPrototype, $f9d5e174f519189f$var$ITERATOR, $iterator);
    };
} else module.exports = function() {};

});

parcelRegister("bzgfn", function(module, exports) {
// all object keys, includes non-enumerable and symbols

var $60lWN = parcelRequire("60lWN");

var $iZji0 = parcelRequire("iZji0");

var $bmSbf = parcelRequire("bmSbf");

var $gtY0w = parcelRequire("gtY0w");
var $86bf90e69cb49921$require$Reflect = $gtY0w.Reflect;
module.exports = $86bf90e69cb49921$require$Reflect && $86bf90e69cb49921$require$Reflect.ownKeys || function ownKeys(it) {
    var keys = $60lWN.f($bmSbf(it));
    var getSymbols = $iZji0.f;
    return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

});

parcelRegister("4SA5N", function(module, exports) {

var $8iMRJ = parcelRequire("8iMRJ");

var $1ttxT = parcelRequire("1ttxT");

var $5T7Du = parcelRequire("5T7Du");

var $iC2yD = parcelRequire("iC2yD");
var $38d833c52ec0f778$require$isEnum = $iC2yD.f;
module.exports = function(isEntries) {
    return function(it) {
        var O = $5T7Du(it);
        var keys = $1ttxT(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;
        while(length > i){
            key = keys[i++];
            if (!$8iMRJ || $38d833c52ec0f778$require$isEnum.call(O, key)) result.push(isEntries ? [
                key,
                O[key]
            ] : O[key]);
        }
        return result;
    };
};

});

parcelRegister("XHXMy", function(module, exports) {
parcelRequire("ciJMK");

module.exports = (parcelRequire("bP2GN")).global;

});
parcelRegister("ciJMK", function(module, exports) {
// https://github.com/tc39/proposal-global

var $e3TpI = parcelRequire("e3TpI");

$e3TpI($e3TpI.G, {
    global: (parcelRequire("dr17b"))
});

});
parcelRegister("e3TpI", function(module, exports) {

var $dr17b = parcelRequire("dr17b");

var $bP2GN = parcelRequire("bP2GN");

var $ThcZO = parcelRequire("ThcZO");

var $agJUc = parcelRequire("agJUc");

var $k8034 = parcelRequire("k8034");
var $a3cc54843f839e1d$var$PROTOTYPE = 'prototype';
var $a3cc54843f839e1d$var$$export = function(type, name, source) {
    var IS_FORCED = type & $a3cc54843f839e1d$var$$export.F;
    var IS_GLOBAL = type & $a3cc54843f839e1d$var$$export.G;
    var IS_STATIC = type & $a3cc54843f839e1d$var$$export.S;
    var IS_PROTO = type & $a3cc54843f839e1d$var$$export.P;
    var IS_BIND = type & $a3cc54843f839e1d$var$$export.B;
    var IS_WRAP = type & $a3cc54843f839e1d$var$$export.W;
    var exports = IS_GLOBAL ? $bP2GN : $bP2GN[name] || ($bP2GN[name] = {});
    var expProto = exports[$a3cc54843f839e1d$var$PROTOTYPE];
    var target = IS_GLOBAL ? $dr17b : IS_STATIC ? $dr17b[name] : ($dr17b[name] || {})[$a3cc54843f839e1d$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $k8034(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $ThcZO(out, $dr17b) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$a3cc54843f839e1d$var$PROTOTYPE] = C[$a3cc54843f839e1d$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $ThcZO(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $a3cc54843f839e1d$var$$export.R && expProto && !expProto[key]) $agJUc(expProto, key, out);
        }
    }
};
// type bitmap
$a3cc54843f839e1d$var$$export.F = 1; // forced
$a3cc54843f839e1d$var$$export.G = 2; // global
$a3cc54843f839e1d$var$$export.S = 4; // static
$a3cc54843f839e1d$var$$export.P = 8; // proto
$a3cc54843f839e1d$var$$export.B = 16; // bind
$a3cc54843f839e1d$var$$export.W = 32; // wrap
$a3cc54843f839e1d$var$$export.U = 64; // safe
$a3cc54843f839e1d$var$$export.R = 128; // real proto method for `library`
module.exports = $a3cc54843f839e1d$var$$export;

});
parcelRegister("dr17b", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $9c7ea95e739d8e08$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $9c7ea95e739d8e08$var$global; // eslint-disable-line no-undef

});

parcelRegister("bP2GN", function(module, exports) {
var $89b68b283b485e71$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $89b68b283b485e71$var$core; // eslint-disable-line no-undef

});

parcelRegister("ThcZO", function(module, exports) {
// optional / simple context binding

var $adoYR = parcelRequire("adoYR");
module.exports = function(fn, that, length) {
    $adoYR(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("adoYR", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("agJUc", function(module, exports) {

var $3TadF = parcelRequire("3TadF");

var $dIPQK = parcelRequire("dIPQK");

module.exports = (parcelRequire("2Sw8y")) ? function(object, key, value) {
    return $3TadF.f(object, key, $dIPQK(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("3TadF", function(module, exports) {

$parcel$export(module.exports, "f", () => $2d4e6f840d59d701$export$2d1720544b23b823, (v) => $2d4e6f840d59d701$export$2d1720544b23b823 = v);
var $2d4e6f840d59d701$export$2d1720544b23b823;

var $2yE3r = parcelRequire("2yE3r");

var $k5LbN = parcelRequire("k5LbN");

var $e3bws = parcelRequire("e3bws");
var $2d4e6f840d59d701$var$dP = Object.defineProperty;

$2d4e6f840d59d701$export$2d1720544b23b823 = (parcelRequire("2Sw8y")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $2yE3r(O);
    P = $e3bws(P, true);
    $2yE3r(Attributes);
    if ($k5LbN) try {
        return $2d4e6f840d59d701$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("2yE3r", function(module, exports) {

var $k2tS4 = parcelRequire("k2tS4");
module.exports = function(it) {
    if (!$k2tS4(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("k2tS4", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("k5LbN", function(module, exports) {



module.exports = !(parcelRequire("2Sw8y")) && !(parcelRequire("5uX2P"))(function() {
    return Object.defineProperty((parcelRequire("5TeH9"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("2Sw8y", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("5uX2P"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("5uX2P", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("5TeH9", function(module, exports) {

var $k2tS4 = parcelRequire("k2tS4");

var $dr17b = parcelRequire("dr17b");
var $449d7ceecdde59a3$require$document = $dr17b.document;
// typeof document.createElement is 'object' in old IE
var $449d7ceecdde59a3$var$is = $k2tS4($449d7ceecdde59a3$require$document) && $k2tS4($449d7ceecdde59a3$require$document.createElement);
module.exports = function(it) {
    return $449d7ceecdde59a3$var$is ? $449d7ceecdde59a3$require$document.createElement(it) : {};
};

});


parcelRegister("e3bws", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $k2tS4 = parcelRequire("k2tS4");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$k2tS4(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$k2tS4(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$k2tS4(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$k2tS4(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("dIPQK", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("k8034", function(module, exports) {
var $ea74979d27df6cd9$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $ea74979d27df6cd9$var$hasOwnProperty.call(it, key);
};

});




parcelRegister("ehGlY", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $a66381b3d0f4cdca$export$ae55be85d98224ed, (v) => $a66381b3d0f4cdca$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $a66381b3d0f4cdca$export$d39a5bbd09211389, (v) => $a66381b3d0f4cdca$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $a66381b3d0f4cdca$export$882461b6382ed46c, (v) => $a66381b3d0f4cdca$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $a66381b3d0f4cdca$export$466bfc07425424d5, (v) => $a66381b3d0f4cdca$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $a66381b3d0f4cdca$export$cd75ccfd720a3cd4, (v) => $a66381b3d0f4cdca$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $a66381b3d0f4cdca$export$fa8d919ba61d84db, (v) => $a66381b3d0f4cdca$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $a66381b3d0f4cdca$export$757ceba2d55c277e, (v) => $a66381b3d0f4cdca$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $a66381b3d0f4cdca$export$b3890eb0ae9dca99, (v) => $a66381b3d0f4cdca$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $a66381b3d0f4cdca$export$502457920280e6be, (v) => $a66381b3d0f4cdca$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $a66381b3d0f4cdca$export$c78a37762a8d58e1, (v) => $a66381b3d0f4cdca$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $a66381b3d0f4cdca$export$dc54d992c10e8a18, (v) => $a66381b3d0f4cdca$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $a66381b3d0f4cdca$export$83d89fbfd8236492, (v) => $a66381b3d0f4cdca$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $a66381b3d0f4cdca$export$ae55be85d98224ed;
var $a66381b3d0f4cdca$export$d39a5bbd09211389;
var $a66381b3d0f4cdca$export$882461b6382ed46c;
var $a66381b3d0f4cdca$export$466bfc07425424d5;
var $a66381b3d0f4cdca$export$cd75ccfd720a3cd4;
var $a66381b3d0f4cdca$export$fa8d919ba61d84db;
var $a66381b3d0f4cdca$export$757ceba2d55c277e;
var $a66381b3d0f4cdca$export$b3890eb0ae9dca99;
var $a66381b3d0f4cdca$export$502457920280e6be;
var $a66381b3d0f4cdca$export$c78a37762a8d58e1;
var $a66381b3d0f4cdca$export$dc54d992c10e8a18;
var $a66381b3d0f4cdca$export$83d89fbfd8236492;
'use strict';

var $Fo7oF = parcelRequire("Fo7oF");

var $aTlqC = parcelRequire("aTlqC");
function $a66381b3d0f4cdca$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $a66381b3d0f4cdca$var$da = new Set, $a66381b3d0f4cdca$var$ea = {};
function $a66381b3d0f4cdca$var$fa(a, b) {
    $a66381b3d0f4cdca$var$ha(a, b);
    $a66381b3d0f4cdca$var$ha(a + "Capture", b);
}
function $a66381b3d0f4cdca$var$ha(a, b) {
    $a66381b3d0f4cdca$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$a66381b3d0f4cdca$var$da.add(b[a]);
}
var $a66381b3d0f4cdca$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $a66381b3d0f4cdca$var$ja = Object.prototype.hasOwnProperty, $a66381b3d0f4cdca$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $a66381b3d0f4cdca$var$la = {}, $a66381b3d0f4cdca$var$ma = {};
function $a66381b3d0f4cdca$var$oa(a) {
    if ($a66381b3d0f4cdca$var$ja.call($a66381b3d0f4cdca$var$ma, a)) return !0;
    if ($a66381b3d0f4cdca$var$ja.call($a66381b3d0f4cdca$var$la, a)) return !1;
    if ($a66381b3d0f4cdca$var$ka.test(a)) return $a66381b3d0f4cdca$var$ma[a] = !0;
    $a66381b3d0f4cdca$var$la[a] = !0;
    return !1;
}
function $a66381b3d0f4cdca$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $a66381b3d0f4cdca$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $a66381b3d0f4cdca$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $a66381b3d0f4cdca$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $a66381b3d0f4cdca$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $a66381b3d0f4cdca$var$z[a] = new $a66381b3d0f4cdca$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $a66381b3d0f4cdca$var$z[b] = new $a66381b3d0f4cdca$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $a66381b3d0f4cdca$var$z[a] = new $a66381b3d0f4cdca$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $a66381b3d0f4cdca$var$z[a] = new $a66381b3d0f4cdca$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $a66381b3d0f4cdca$var$z[a] = new $a66381b3d0f4cdca$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $a66381b3d0f4cdca$var$z[a] = new $a66381b3d0f4cdca$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $a66381b3d0f4cdca$var$z[a] = new $a66381b3d0f4cdca$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $a66381b3d0f4cdca$var$z[a] = new $a66381b3d0f4cdca$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $a66381b3d0f4cdca$var$z[a] = new $a66381b3d0f4cdca$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $a66381b3d0f4cdca$var$ra = /[\-:]([a-z])/g;
function $a66381b3d0f4cdca$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($a66381b3d0f4cdca$var$ra, $a66381b3d0f4cdca$var$sa);
    $a66381b3d0f4cdca$var$z[b] = new $a66381b3d0f4cdca$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($a66381b3d0f4cdca$var$ra, $a66381b3d0f4cdca$var$sa);
    $a66381b3d0f4cdca$var$z[b] = new $a66381b3d0f4cdca$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($a66381b3d0f4cdca$var$ra, $a66381b3d0f4cdca$var$sa);
    $a66381b3d0f4cdca$var$z[b] = new $a66381b3d0f4cdca$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $a66381b3d0f4cdca$var$z[a] = new $a66381b3d0f4cdca$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$a66381b3d0f4cdca$var$z.xlinkHref = new $a66381b3d0f4cdca$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $a66381b3d0f4cdca$var$z[a] = new $a66381b3d0f4cdca$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $a66381b3d0f4cdca$var$ta(a, b, c, d) {
    var e = $a66381b3d0f4cdca$var$z.hasOwnProperty(b) ? $a66381b3d0f4cdca$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $a66381b3d0f4cdca$var$qa(b, c, e, d) && (c = null), d || null === e ? $a66381b3d0f4cdca$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $a66381b3d0f4cdca$var$ua = $Fo7oF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $a66381b3d0f4cdca$var$va = Symbol.for("react.element"), $a66381b3d0f4cdca$var$wa = Symbol.for("react.portal"), $a66381b3d0f4cdca$var$ya = Symbol.for("react.fragment"), $a66381b3d0f4cdca$var$za = Symbol.for("react.strict_mode"), $a66381b3d0f4cdca$var$Aa = Symbol.for("react.profiler"), $a66381b3d0f4cdca$var$Ba = Symbol.for("react.provider"), $a66381b3d0f4cdca$var$Ca = Symbol.for("react.context"), $a66381b3d0f4cdca$var$Da = Symbol.for("react.forward_ref"), $a66381b3d0f4cdca$var$Ea = Symbol.for("react.suspense"), $a66381b3d0f4cdca$var$Fa = Symbol.for("react.suspense_list"), $a66381b3d0f4cdca$var$Ga = Symbol.for("react.memo"), $a66381b3d0f4cdca$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $a66381b3d0f4cdca$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $a66381b3d0f4cdca$var$Ja = Symbol.iterator;
function $a66381b3d0f4cdca$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $a66381b3d0f4cdca$var$Ja && a[$a66381b3d0f4cdca$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $a66381b3d0f4cdca$var$A = Object.assign, $a66381b3d0f4cdca$var$La;
function $a66381b3d0f4cdca$var$Ma(a) {
    if (void 0 === $a66381b3d0f4cdca$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $a66381b3d0f4cdca$var$La = b && b[1] || "";
    }
    return "\n" + $a66381b3d0f4cdca$var$La + a;
}
var $a66381b3d0f4cdca$var$Na = !1;
function $a66381b3d0f4cdca$var$Oa(a, b) {
    if (!a || $a66381b3d0f4cdca$var$Na) return "";
    $a66381b3d0f4cdca$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $a66381b3d0f4cdca$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $a66381b3d0f4cdca$var$Ma(a) : "";
}
function $a66381b3d0f4cdca$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $a66381b3d0f4cdca$var$Ma(a.type);
        case 16:
            return $a66381b3d0f4cdca$var$Ma("Lazy");
        case 13:
            return $a66381b3d0f4cdca$var$Ma("Suspense");
        case 19:
            return $a66381b3d0f4cdca$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $a66381b3d0f4cdca$var$Oa(a.type, !1), a;
        case 11:
            return a = $a66381b3d0f4cdca$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $a66381b3d0f4cdca$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $a66381b3d0f4cdca$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $a66381b3d0f4cdca$var$ya:
            return "Fragment";
        case $a66381b3d0f4cdca$var$wa:
            return "Portal";
        case $a66381b3d0f4cdca$var$Aa:
            return "Profiler";
        case $a66381b3d0f4cdca$var$za:
            return "StrictMode";
        case $a66381b3d0f4cdca$var$Ea:
            return "Suspense";
        case $a66381b3d0f4cdca$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $a66381b3d0f4cdca$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $a66381b3d0f4cdca$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $a66381b3d0f4cdca$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $a66381b3d0f4cdca$var$Ga:
            return b = a.displayName || null, null !== b ? b : $a66381b3d0f4cdca$var$Qa(a.type) || "Memo";
        case $a66381b3d0f4cdca$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $a66381b3d0f4cdca$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $a66381b3d0f4cdca$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $a66381b3d0f4cdca$var$Qa(b);
        case 8:
            return b === $a66381b3d0f4cdca$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $a66381b3d0f4cdca$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $a66381b3d0f4cdca$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $a66381b3d0f4cdca$var$Ua(a) {
    var b = $a66381b3d0f4cdca$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $a66381b3d0f4cdca$var$Va(a) {
    a._valueTracker || (a._valueTracker = $a66381b3d0f4cdca$var$Ua(a));
}
function $a66381b3d0f4cdca$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $a66381b3d0f4cdca$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $a66381b3d0f4cdca$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $a66381b3d0f4cdca$var$Ya(a, b) {
    var c = b.checked;
    return $a66381b3d0f4cdca$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $a66381b3d0f4cdca$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $a66381b3d0f4cdca$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a66381b3d0f4cdca$var$ab(a, b) {
    b = b.checked;
    null != b && $a66381b3d0f4cdca$var$ta(a, "checked", b, !1);
}
function $a66381b3d0f4cdca$var$bb(a, b) {
    $a66381b3d0f4cdca$var$ab(a, b);
    var c = $a66381b3d0f4cdca$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $a66381b3d0f4cdca$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $a66381b3d0f4cdca$var$cb(a, b.type, $a66381b3d0f4cdca$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $a66381b3d0f4cdca$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $a66381b3d0f4cdca$var$cb(a, b, c) {
    if ("number" !== b || $a66381b3d0f4cdca$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $a66381b3d0f4cdca$var$eb = Array.isArray;
function $a66381b3d0f4cdca$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $a66381b3d0f4cdca$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $a66381b3d0f4cdca$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($a66381b3d0f4cdca$var$p(91));
    return $a66381b3d0f4cdca$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $a66381b3d0f4cdca$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($a66381b3d0f4cdca$var$p(92));
            if ($a66381b3d0f4cdca$var$eb(c)) {
                if (1 < c.length) throw Error($a66381b3d0f4cdca$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $a66381b3d0f4cdca$var$Sa(c)
    };
}
function $a66381b3d0f4cdca$var$ib(a, b) {
    var c = $a66381b3d0f4cdca$var$Sa(b.value), d = $a66381b3d0f4cdca$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $a66381b3d0f4cdca$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $a66381b3d0f4cdca$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $a66381b3d0f4cdca$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $a66381b3d0f4cdca$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $a66381b3d0f4cdca$var$mb, $a66381b3d0f4cdca$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $a66381b3d0f4cdca$var$mb = $a66381b3d0f4cdca$var$mb || document.createElement("div");
        $a66381b3d0f4cdca$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $a66381b3d0f4cdca$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $a66381b3d0f4cdca$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $a66381b3d0f4cdca$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $a66381b3d0f4cdca$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($a66381b3d0f4cdca$var$pb).forEach(function(a) {
    $a66381b3d0f4cdca$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $a66381b3d0f4cdca$var$pb[b] = $a66381b3d0f4cdca$var$pb[a];
    });
});
function $a66381b3d0f4cdca$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $a66381b3d0f4cdca$var$pb.hasOwnProperty(a) && $a66381b3d0f4cdca$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $a66381b3d0f4cdca$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $a66381b3d0f4cdca$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $a66381b3d0f4cdca$var$tb = $a66381b3d0f4cdca$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $a66381b3d0f4cdca$var$ub(a, b) {
    if (b) {
        if ($a66381b3d0f4cdca$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($a66381b3d0f4cdca$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($a66381b3d0f4cdca$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($a66381b3d0f4cdca$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($a66381b3d0f4cdca$var$p(62));
    }
}
function $a66381b3d0f4cdca$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $a66381b3d0f4cdca$var$wb = null;
function $a66381b3d0f4cdca$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $a66381b3d0f4cdca$var$yb = null, $a66381b3d0f4cdca$var$zb = null, $a66381b3d0f4cdca$var$Ab = null;
function $a66381b3d0f4cdca$var$Bb(a) {
    if (a = $a66381b3d0f4cdca$var$Cb(a)) {
        if ("function" !== typeof $a66381b3d0f4cdca$var$yb) throw Error($a66381b3d0f4cdca$var$p(280));
        var b = a.stateNode;
        b && (b = $a66381b3d0f4cdca$var$Db(b), $a66381b3d0f4cdca$var$yb(a.stateNode, a.type, b));
    }
}
function $a66381b3d0f4cdca$var$Eb(a) {
    $a66381b3d0f4cdca$var$zb ? $a66381b3d0f4cdca$var$Ab ? $a66381b3d0f4cdca$var$Ab.push(a) : $a66381b3d0f4cdca$var$Ab = [
        a
    ] : $a66381b3d0f4cdca$var$zb = a;
}
function $a66381b3d0f4cdca$var$Fb() {
    if ($a66381b3d0f4cdca$var$zb) {
        var a = $a66381b3d0f4cdca$var$zb, b = $a66381b3d0f4cdca$var$Ab;
        $a66381b3d0f4cdca$var$Ab = $a66381b3d0f4cdca$var$zb = null;
        $a66381b3d0f4cdca$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$a66381b3d0f4cdca$var$Bb(b[a]);
    }
}
function $a66381b3d0f4cdca$var$Gb(a, b) {
    return a(b);
}
function $a66381b3d0f4cdca$var$Hb() {}
var $a66381b3d0f4cdca$var$Ib = !1;
function $a66381b3d0f4cdca$var$Jb(a, b, c) {
    if ($a66381b3d0f4cdca$var$Ib) return a(b, c);
    $a66381b3d0f4cdca$var$Ib = !0;
    try {
        return $a66381b3d0f4cdca$var$Gb(a, b, c);
    } finally{
        if ($a66381b3d0f4cdca$var$Ib = !1, null !== $a66381b3d0f4cdca$var$zb || null !== $a66381b3d0f4cdca$var$Ab) $a66381b3d0f4cdca$var$Hb(), $a66381b3d0f4cdca$var$Fb();
    }
}
function $a66381b3d0f4cdca$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $a66381b3d0f4cdca$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($a66381b3d0f4cdca$var$p(231, b, typeof c));
    return c;
}
var $a66381b3d0f4cdca$var$Lb = !1;
if ($a66381b3d0f4cdca$var$ia) try {
    var $a66381b3d0f4cdca$var$Mb = {};
    Object.defineProperty($a66381b3d0f4cdca$var$Mb, "passive", {
        get: function() {
            $a66381b3d0f4cdca$var$Lb = !0;
        }
    });
    window.addEventListener("test", $a66381b3d0f4cdca$var$Mb, $a66381b3d0f4cdca$var$Mb);
    window.removeEventListener("test", $a66381b3d0f4cdca$var$Mb, $a66381b3d0f4cdca$var$Mb);
} catch (a) {
    $a66381b3d0f4cdca$var$Lb = !1;
}
function $a66381b3d0f4cdca$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $a66381b3d0f4cdca$var$Ob = !1, $a66381b3d0f4cdca$var$Pb = null, $a66381b3d0f4cdca$var$Qb = !1, $a66381b3d0f4cdca$var$Rb = null, $a66381b3d0f4cdca$var$Sb = {
    onError: function(a) {
        $a66381b3d0f4cdca$var$Ob = !0;
        $a66381b3d0f4cdca$var$Pb = a;
    }
};
function $a66381b3d0f4cdca$var$Tb(a, b, c, d, e, f, g, h, k) {
    $a66381b3d0f4cdca$var$Ob = !1;
    $a66381b3d0f4cdca$var$Pb = null;
    $a66381b3d0f4cdca$var$Nb.apply($a66381b3d0f4cdca$var$Sb, arguments);
}
function $a66381b3d0f4cdca$var$Ub(a, b, c, d, e, f, g, h, k) {
    $a66381b3d0f4cdca$var$Tb.apply(this, arguments);
    if ($a66381b3d0f4cdca$var$Ob) {
        if ($a66381b3d0f4cdca$var$Ob) {
            var l = $a66381b3d0f4cdca$var$Pb;
            $a66381b3d0f4cdca$var$Ob = !1;
            $a66381b3d0f4cdca$var$Pb = null;
        } else throw Error($a66381b3d0f4cdca$var$p(198));
        $a66381b3d0f4cdca$var$Qb || ($a66381b3d0f4cdca$var$Qb = !0, $a66381b3d0f4cdca$var$Rb = l);
    }
}
function $a66381b3d0f4cdca$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $a66381b3d0f4cdca$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $a66381b3d0f4cdca$var$Xb(a) {
    if ($a66381b3d0f4cdca$var$Vb(a) !== a) throw Error($a66381b3d0f4cdca$var$p(188));
}
function $a66381b3d0f4cdca$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $a66381b3d0f4cdca$var$Vb(a);
        if (null === b) throw Error($a66381b3d0f4cdca$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $a66381b3d0f4cdca$var$Xb(e), a;
                if (f === d) return $a66381b3d0f4cdca$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($a66381b3d0f4cdca$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($a66381b3d0f4cdca$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($a66381b3d0f4cdca$var$p(190));
    }
    if (3 !== c.tag) throw Error($a66381b3d0f4cdca$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $a66381b3d0f4cdca$var$Zb(a) {
    a = $a66381b3d0f4cdca$var$Yb(a);
    return null !== a ? $a66381b3d0f4cdca$var$$b(a) : null;
}
function $a66381b3d0f4cdca$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $a66381b3d0f4cdca$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $a66381b3d0f4cdca$var$ac = $aTlqC.unstable_scheduleCallback, $a66381b3d0f4cdca$var$bc = $aTlqC.unstable_cancelCallback, $a66381b3d0f4cdca$var$cc = $aTlqC.unstable_shouldYield, $a66381b3d0f4cdca$var$dc = $aTlqC.unstable_requestPaint, $a66381b3d0f4cdca$var$B = $aTlqC.unstable_now, $a66381b3d0f4cdca$var$ec = $aTlqC.unstable_getCurrentPriorityLevel, $a66381b3d0f4cdca$var$fc = $aTlqC.unstable_ImmediatePriority, $a66381b3d0f4cdca$var$gc = $aTlqC.unstable_UserBlockingPriority, $a66381b3d0f4cdca$var$hc = $aTlqC.unstable_NormalPriority, $a66381b3d0f4cdca$var$ic = $aTlqC.unstable_LowPriority, $a66381b3d0f4cdca$var$jc = $aTlqC.unstable_IdlePriority, $a66381b3d0f4cdca$var$kc = null, $a66381b3d0f4cdca$var$lc = null;
function $a66381b3d0f4cdca$var$mc(a) {
    if ($a66381b3d0f4cdca$var$lc && "function" === typeof $a66381b3d0f4cdca$var$lc.onCommitFiberRoot) try {
        $a66381b3d0f4cdca$var$lc.onCommitFiberRoot($a66381b3d0f4cdca$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $a66381b3d0f4cdca$var$oc = Math.clz32 ? Math.clz32 : $a66381b3d0f4cdca$var$nc, $a66381b3d0f4cdca$var$pc = Math.log, $a66381b3d0f4cdca$var$qc = Math.LN2;
function $a66381b3d0f4cdca$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($a66381b3d0f4cdca$var$pc(a) / $a66381b3d0f4cdca$var$qc | 0) | 0;
}
var $a66381b3d0f4cdca$var$rc = 64, $a66381b3d0f4cdca$var$sc = 4194304;
function $a66381b3d0f4cdca$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $a66381b3d0f4cdca$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $a66381b3d0f4cdca$var$tc(h) : (f &= g, 0 !== f && (d = $a66381b3d0f4cdca$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $a66381b3d0f4cdca$var$tc(g) : 0 !== f && (d = $a66381b3d0f4cdca$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $a66381b3d0f4cdca$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $a66381b3d0f4cdca$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $a66381b3d0f4cdca$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $a66381b3d0f4cdca$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $a66381b3d0f4cdca$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $a66381b3d0f4cdca$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $a66381b3d0f4cdca$var$yc() {
    var a = $a66381b3d0f4cdca$var$rc;
    $a66381b3d0f4cdca$var$rc <<= 1;
    0 === ($a66381b3d0f4cdca$var$rc & 4194240) && ($a66381b3d0f4cdca$var$rc = 64);
    return a;
}
function $a66381b3d0f4cdca$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $a66381b3d0f4cdca$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $a66381b3d0f4cdca$var$oc(b);
    a[b] = c;
}
function $a66381b3d0f4cdca$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $a66381b3d0f4cdca$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $a66381b3d0f4cdca$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $a66381b3d0f4cdca$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $a66381b3d0f4cdca$var$C = 0;
function $a66381b3d0f4cdca$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $a66381b3d0f4cdca$var$Ec, $a66381b3d0f4cdca$var$Fc, $a66381b3d0f4cdca$var$Gc, $a66381b3d0f4cdca$var$Hc, $a66381b3d0f4cdca$var$Ic, $a66381b3d0f4cdca$var$Jc = !1, $a66381b3d0f4cdca$var$Kc = [], $a66381b3d0f4cdca$var$Lc = null, $a66381b3d0f4cdca$var$Mc = null, $a66381b3d0f4cdca$var$Nc = null, $a66381b3d0f4cdca$var$Oc = new Map, $a66381b3d0f4cdca$var$Pc = new Map, $a66381b3d0f4cdca$var$Qc = [], $a66381b3d0f4cdca$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $a66381b3d0f4cdca$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $a66381b3d0f4cdca$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $a66381b3d0f4cdca$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $a66381b3d0f4cdca$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $a66381b3d0f4cdca$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $a66381b3d0f4cdca$var$Pc.delete(b.pointerId);
    }
}
function $a66381b3d0f4cdca$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $a66381b3d0f4cdca$var$Cb(b), null !== b && $a66381b3d0f4cdca$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $a66381b3d0f4cdca$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $a66381b3d0f4cdca$var$Lc = $a66381b3d0f4cdca$var$Tc($a66381b3d0f4cdca$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $a66381b3d0f4cdca$var$Mc = $a66381b3d0f4cdca$var$Tc($a66381b3d0f4cdca$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $a66381b3d0f4cdca$var$Nc = $a66381b3d0f4cdca$var$Tc($a66381b3d0f4cdca$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $a66381b3d0f4cdca$var$Oc.set(f, $a66381b3d0f4cdca$var$Tc($a66381b3d0f4cdca$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $a66381b3d0f4cdca$var$Pc.set(f, $a66381b3d0f4cdca$var$Tc($a66381b3d0f4cdca$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $a66381b3d0f4cdca$var$Vc(a) {
    var b = $a66381b3d0f4cdca$var$Wc(a.target);
    if (null !== b) {
        var c = $a66381b3d0f4cdca$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $a66381b3d0f4cdca$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $a66381b3d0f4cdca$var$Ic(a.priority, function() {
                        $a66381b3d0f4cdca$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $a66381b3d0f4cdca$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $a66381b3d0f4cdca$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $a66381b3d0f4cdca$var$wb = d;
            c.target.dispatchEvent(d);
            $a66381b3d0f4cdca$var$wb = null;
        } else return b = $a66381b3d0f4cdca$var$Cb(c), null !== b && $a66381b3d0f4cdca$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $a66381b3d0f4cdca$var$Zc(a, b, c) {
    $a66381b3d0f4cdca$var$Xc(a) && c.delete(b);
}
function $a66381b3d0f4cdca$var$$c() {
    $a66381b3d0f4cdca$var$Jc = !1;
    null !== $a66381b3d0f4cdca$var$Lc && $a66381b3d0f4cdca$var$Xc($a66381b3d0f4cdca$var$Lc) && ($a66381b3d0f4cdca$var$Lc = null);
    null !== $a66381b3d0f4cdca$var$Mc && $a66381b3d0f4cdca$var$Xc($a66381b3d0f4cdca$var$Mc) && ($a66381b3d0f4cdca$var$Mc = null);
    null !== $a66381b3d0f4cdca$var$Nc && $a66381b3d0f4cdca$var$Xc($a66381b3d0f4cdca$var$Nc) && ($a66381b3d0f4cdca$var$Nc = null);
    $a66381b3d0f4cdca$var$Oc.forEach($a66381b3d0f4cdca$var$Zc);
    $a66381b3d0f4cdca$var$Pc.forEach($a66381b3d0f4cdca$var$Zc);
}
function $a66381b3d0f4cdca$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $a66381b3d0f4cdca$var$Jc || ($a66381b3d0f4cdca$var$Jc = !0, $aTlqC.unstable_scheduleCallback($aTlqC.unstable_NormalPriority, $a66381b3d0f4cdca$var$$c)));
}
function $a66381b3d0f4cdca$var$bd(a) {
    function b(b) {
        return $a66381b3d0f4cdca$var$ad(b, a);
    }
    if (0 < $a66381b3d0f4cdca$var$Kc.length) {
        $a66381b3d0f4cdca$var$ad($a66381b3d0f4cdca$var$Kc[0], a);
        for(var c = 1; c < $a66381b3d0f4cdca$var$Kc.length; c++){
            var d = $a66381b3d0f4cdca$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $a66381b3d0f4cdca$var$Lc && $a66381b3d0f4cdca$var$ad($a66381b3d0f4cdca$var$Lc, a);
    null !== $a66381b3d0f4cdca$var$Mc && $a66381b3d0f4cdca$var$ad($a66381b3d0f4cdca$var$Mc, a);
    null !== $a66381b3d0f4cdca$var$Nc && $a66381b3d0f4cdca$var$ad($a66381b3d0f4cdca$var$Nc, a);
    $a66381b3d0f4cdca$var$Oc.forEach(b);
    $a66381b3d0f4cdca$var$Pc.forEach(b);
    for(c = 0; c < $a66381b3d0f4cdca$var$Qc.length; c++)d = $a66381b3d0f4cdca$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $a66381b3d0f4cdca$var$Qc.length && (c = $a66381b3d0f4cdca$var$Qc[0], null === c.blockedOn);)$a66381b3d0f4cdca$var$Vc(c), null === c.blockedOn && $a66381b3d0f4cdca$var$Qc.shift();
}
var $a66381b3d0f4cdca$var$cd = $a66381b3d0f4cdca$var$ua.ReactCurrentBatchConfig, $a66381b3d0f4cdca$var$dd = !0;
function $a66381b3d0f4cdca$var$ed(a, b, c, d) {
    var e = $a66381b3d0f4cdca$var$C, f = $a66381b3d0f4cdca$var$cd.transition;
    $a66381b3d0f4cdca$var$cd.transition = null;
    try {
        $a66381b3d0f4cdca$var$C = 1, $a66381b3d0f4cdca$var$fd(a, b, c, d);
    } finally{
        $a66381b3d0f4cdca$var$C = e, $a66381b3d0f4cdca$var$cd.transition = f;
    }
}
function $a66381b3d0f4cdca$var$gd(a, b, c, d) {
    var e = $a66381b3d0f4cdca$var$C, f = $a66381b3d0f4cdca$var$cd.transition;
    $a66381b3d0f4cdca$var$cd.transition = null;
    try {
        $a66381b3d0f4cdca$var$C = 4, $a66381b3d0f4cdca$var$fd(a, b, c, d);
    } finally{
        $a66381b3d0f4cdca$var$C = e, $a66381b3d0f4cdca$var$cd.transition = f;
    }
}
function $a66381b3d0f4cdca$var$fd(a, b, c, d) {
    if ($a66381b3d0f4cdca$var$dd) {
        var e = $a66381b3d0f4cdca$var$Yc(a, b, c, d);
        if (null === e) $a66381b3d0f4cdca$var$hd(a, b, d, $a66381b3d0f4cdca$var$id, c), $a66381b3d0f4cdca$var$Sc(a, d);
        else if ($a66381b3d0f4cdca$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($a66381b3d0f4cdca$var$Sc(a, d), b & 4 && -1 < $a66381b3d0f4cdca$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $a66381b3d0f4cdca$var$Cb(e);
                null !== f && $a66381b3d0f4cdca$var$Ec(f);
                f = $a66381b3d0f4cdca$var$Yc(a, b, c, d);
                null === f && $a66381b3d0f4cdca$var$hd(a, b, d, $a66381b3d0f4cdca$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $a66381b3d0f4cdca$var$hd(a, b, d, null, c);
    }
}
var $a66381b3d0f4cdca$var$id = null;
function $a66381b3d0f4cdca$var$Yc(a, b, c, d) {
    $a66381b3d0f4cdca$var$id = null;
    a = $a66381b3d0f4cdca$var$xb(d);
    a = $a66381b3d0f4cdca$var$Wc(a);
    if (null !== a) {
        if (b = $a66381b3d0f4cdca$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $a66381b3d0f4cdca$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $a66381b3d0f4cdca$var$id = a;
    return null;
}
function $a66381b3d0f4cdca$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($a66381b3d0f4cdca$var$ec()){
                case $a66381b3d0f4cdca$var$fc:
                    return 1;
                case $a66381b3d0f4cdca$var$gc:
                    return 4;
                case $a66381b3d0f4cdca$var$hc:
                case $a66381b3d0f4cdca$var$ic:
                    return 16;
                case $a66381b3d0f4cdca$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $a66381b3d0f4cdca$var$kd = null, $a66381b3d0f4cdca$var$ld = null, $a66381b3d0f4cdca$var$md = null;
function $a66381b3d0f4cdca$var$nd() {
    if ($a66381b3d0f4cdca$var$md) return $a66381b3d0f4cdca$var$md;
    var a, b = $a66381b3d0f4cdca$var$ld, c = b.length, d, e = "value" in $a66381b3d0f4cdca$var$kd ? $a66381b3d0f4cdca$var$kd.value : $a66381b3d0f4cdca$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $a66381b3d0f4cdca$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $a66381b3d0f4cdca$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $a66381b3d0f4cdca$var$pd() {
    return !0;
}
function $a66381b3d0f4cdca$var$qd() {
    return !1;
}
function $a66381b3d0f4cdca$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $a66381b3d0f4cdca$var$pd : $a66381b3d0f4cdca$var$qd;
        this.isPropagationStopped = $a66381b3d0f4cdca$var$qd;
        return this;
    }
    $a66381b3d0f4cdca$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $a66381b3d0f4cdca$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $a66381b3d0f4cdca$var$pd);
        },
        persist: function() {},
        isPersistent: $a66381b3d0f4cdca$var$pd
    });
    return b;
}
var $a66381b3d0f4cdca$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $a66381b3d0f4cdca$var$td = $a66381b3d0f4cdca$var$rd($a66381b3d0f4cdca$var$sd), $a66381b3d0f4cdca$var$ud = $a66381b3d0f4cdca$var$A({}, $a66381b3d0f4cdca$var$sd, {
    view: 0,
    detail: 0
}), $a66381b3d0f4cdca$var$vd = $a66381b3d0f4cdca$var$rd($a66381b3d0f4cdca$var$ud), $a66381b3d0f4cdca$var$wd, $a66381b3d0f4cdca$var$xd, $a66381b3d0f4cdca$var$yd, $a66381b3d0f4cdca$var$Ad = $a66381b3d0f4cdca$var$A({}, $a66381b3d0f4cdca$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $a66381b3d0f4cdca$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $a66381b3d0f4cdca$var$yd && ($a66381b3d0f4cdca$var$yd && "mousemove" === a.type ? ($a66381b3d0f4cdca$var$wd = a.screenX - $a66381b3d0f4cdca$var$yd.screenX, $a66381b3d0f4cdca$var$xd = a.screenY - $a66381b3d0f4cdca$var$yd.screenY) : $a66381b3d0f4cdca$var$xd = $a66381b3d0f4cdca$var$wd = 0, $a66381b3d0f4cdca$var$yd = a);
        return $a66381b3d0f4cdca$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $a66381b3d0f4cdca$var$xd;
    }
}), $a66381b3d0f4cdca$var$Bd = $a66381b3d0f4cdca$var$rd($a66381b3d0f4cdca$var$Ad), $a66381b3d0f4cdca$var$Cd = $a66381b3d0f4cdca$var$A({}, $a66381b3d0f4cdca$var$Ad, {
    dataTransfer: 0
}), $a66381b3d0f4cdca$var$Dd = $a66381b3d0f4cdca$var$rd($a66381b3d0f4cdca$var$Cd), $a66381b3d0f4cdca$var$Ed = $a66381b3d0f4cdca$var$A({}, $a66381b3d0f4cdca$var$ud, {
    relatedTarget: 0
}), $a66381b3d0f4cdca$var$Fd = $a66381b3d0f4cdca$var$rd($a66381b3d0f4cdca$var$Ed), $a66381b3d0f4cdca$var$Gd = $a66381b3d0f4cdca$var$A({}, $a66381b3d0f4cdca$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a66381b3d0f4cdca$var$Hd = $a66381b3d0f4cdca$var$rd($a66381b3d0f4cdca$var$Gd), $a66381b3d0f4cdca$var$Id = $a66381b3d0f4cdca$var$A({}, $a66381b3d0f4cdca$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $a66381b3d0f4cdca$var$Jd = $a66381b3d0f4cdca$var$rd($a66381b3d0f4cdca$var$Id), $a66381b3d0f4cdca$var$Kd = $a66381b3d0f4cdca$var$A({}, $a66381b3d0f4cdca$var$sd, {
    data: 0
}), $a66381b3d0f4cdca$var$Ld = $a66381b3d0f4cdca$var$rd($a66381b3d0f4cdca$var$Kd), $a66381b3d0f4cdca$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $a66381b3d0f4cdca$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $a66381b3d0f4cdca$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $a66381b3d0f4cdca$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $a66381b3d0f4cdca$var$Od[a]) ? !!b[a] : !1;
}
function $a66381b3d0f4cdca$var$zd() {
    return $a66381b3d0f4cdca$var$Pd;
}
var $a66381b3d0f4cdca$var$Qd = $a66381b3d0f4cdca$var$A({}, $a66381b3d0f4cdca$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $a66381b3d0f4cdca$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $a66381b3d0f4cdca$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $a66381b3d0f4cdca$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $a66381b3d0f4cdca$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $a66381b3d0f4cdca$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $a66381b3d0f4cdca$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $a66381b3d0f4cdca$var$Rd = $a66381b3d0f4cdca$var$rd($a66381b3d0f4cdca$var$Qd), $a66381b3d0f4cdca$var$Sd = $a66381b3d0f4cdca$var$A({}, $a66381b3d0f4cdca$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $a66381b3d0f4cdca$var$Td = $a66381b3d0f4cdca$var$rd($a66381b3d0f4cdca$var$Sd), $a66381b3d0f4cdca$var$Ud = $a66381b3d0f4cdca$var$A({}, $a66381b3d0f4cdca$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $a66381b3d0f4cdca$var$zd
}), $a66381b3d0f4cdca$var$Vd = $a66381b3d0f4cdca$var$rd($a66381b3d0f4cdca$var$Ud), $a66381b3d0f4cdca$var$Wd = $a66381b3d0f4cdca$var$A({}, $a66381b3d0f4cdca$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a66381b3d0f4cdca$var$Xd = $a66381b3d0f4cdca$var$rd($a66381b3d0f4cdca$var$Wd), $a66381b3d0f4cdca$var$Yd = $a66381b3d0f4cdca$var$A({}, $a66381b3d0f4cdca$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $a66381b3d0f4cdca$var$Zd = $a66381b3d0f4cdca$var$rd($a66381b3d0f4cdca$var$Yd), $a66381b3d0f4cdca$var$$d = [
    9,
    13,
    27,
    32
], $a66381b3d0f4cdca$var$ae = $a66381b3d0f4cdca$var$ia && "CompositionEvent" in window, $a66381b3d0f4cdca$var$be = null;
$a66381b3d0f4cdca$var$ia && "documentMode" in document && ($a66381b3d0f4cdca$var$be = document.documentMode);
var $a66381b3d0f4cdca$var$ce = $a66381b3d0f4cdca$var$ia && "TextEvent" in window && !$a66381b3d0f4cdca$var$be, $a66381b3d0f4cdca$var$de = $a66381b3d0f4cdca$var$ia && (!$a66381b3d0f4cdca$var$ae || $a66381b3d0f4cdca$var$be && 8 < $a66381b3d0f4cdca$var$be && 11 >= $a66381b3d0f4cdca$var$be), $a66381b3d0f4cdca$var$ee = String.fromCharCode(32), $a66381b3d0f4cdca$var$fe = !1;
function $a66381b3d0f4cdca$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $a66381b3d0f4cdca$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $a66381b3d0f4cdca$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $a66381b3d0f4cdca$var$ie = !1;
function $a66381b3d0f4cdca$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $a66381b3d0f4cdca$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $a66381b3d0f4cdca$var$fe = !0;
            return $a66381b3d0f4cdca$var$ee;
        case "textInput":
            return a = b.data, a === $a66381b3d0f4cdca$var$ee && $a66381b3d0f4cdca$var$fe ? null : a;
        default:
            return null;
    }
}
function $a66381b3d0f4cdca$var$ke(a, b) {
    if ($a66381b3d0f4cdca$var$ie) return "compositionend" === a || !$a66381b3d0f4cdca$var$ae && $a66381b3d0f4cdca$var$ge(a, b) ? (a = $a66381b3d0f4cdca$var$nd(), $a66381b3d0f4cdca$var$md = $a66381b3d0f4cdca$var$ld = $a66381b3d0f4cdca$var$kd = null, $a66381b3d0f4cdca$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $a66381b3d0f4cdca$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $a66381b3d0f4cdca$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $a66381b3d0f4cdca$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$a66381b3d0f4cdca$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $a66381b3d0f4cdca$var$ne(a, b, c, d) {
    $a66381b3d0f4cdca$var$Eb(d);
    b = $a66381b3d0f4cdca$var$oe(b, "onChange");
    0 < b.length && (c = new $a66381b3d0f4cdca$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $a66381b3d0f4cdca$var$pe = null, $a66381b3d0f4cdca$var$qe = null;
function $a66381b3d0f4cdca$var$re(a) {
    $a66381b3d0f4cdca$var$se(a, 0);
}
function $a66381b3d0f4cdca$var$te(a) {
    var b = $a66381b3d0f4cdca$var$ue(a);
    if ($a66381b3d0f4cdca$var$Wa(b)) return a;
}
function $a66381b3d0f4cdca$var$ve(a, b) {
    if ("change" === a) return b;
}
var $a66381b3d0f4cdca$var$we = !1;
if ($a66381b3d0f4cdca$var$ia) {
    var $a66381b3d0f4cdca$var$xe;
    if ($a66381b3d0f4cdca$var$ia) {
        var $a66381b3d0f4cdca$var$ye = "oninput" in document;
        if (!$a66381b3d0f4cdca$var$ye) {
            var $a66381b3d0f4cdca$var$ze = document.createElement("div");
            $a66381b3d0f4cdca$var$ze.setAttribute("oninput", "return;");
            $a66381b3d0f4cdca$var$ye = "function" === typeof $a66381b3d0f4cdca$var$ze.oninput;
        }
        $a66381b3d0f4cdca$var$xe = $a66381b3d0f4cdca$var$ye;
    } else $a66381b3d0f4cdca$var$xe = !1;
    $a66381b3d0f4cdca$var$we = $a66381b3d0f4cdca$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $a66381b3d0f4cdca$var$Ae() {
    $a66381b3d0f4cdca$var$pe && ($a66381b3d0f4cdca$var$pe.detachEvent("onpropertychange", $a66381b3d0f4cdca$var$Be), $a66381b3d0f4cdca$var$qe = $a66381b3d0f4cdca$var$pe = null);
}
function $a66381b3d0f4cdca$var$Be(a) {
    if ("value" === a.propertyName && $a66381b3d0f4cdca$var$te($a66381b3d0f4cdca$var$qe)) {
        var b = [];
        $a66381b3d0f4cdca$var$ne(b, $a66381b3d0f4cdca$var$qe, a, $a66381b3d0f4cdca$var$xb(a));
        $a66381b3d0f4cdca$var$Jb($a66381b3d0f4cdca$var$re, b);
    }
}
function $a66381b3d0f4cdca$var$Ce(a, b, c) {
    "focusin" === a ? ($a66381b3d0f4cdca$var$Ae(), $a66381b3d0f4cdca$var$pe = b, $a66381b3d0f4cdca$var$qe = c, $a66381b3d0f4cdca$var$pe.attachEvent("onpropertychange", $a66381b3d0f4cdca$var$Be)) : "focusout" === a && $a66381b3d0f4cdca$var$Ae();
}
function $a66381b3d0f4cdca$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $a66381b3d0f4cdca$var$te($a66381b3d0f4cdca$var$qe);
}
function $a66381b3d0f4cdca$var$Ee(a, b) {
    if ("click" === a) return $a66381b3d0f4cdca$var$te(b);
}
function $a66381b3d0f4cdca$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $a66381b3d0f4cdca$var$te(b);
}
function $a66381b3d0f4cdca$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $a66381b3d0f4cdca$var$He = "function" === typeof Object.is ? Object.is : $a66381b3d0f4cdca$var$Ge;
function $a66381b3d0f4cdca$var$Ie(a, b) {
    if ($a66381b3d0f4cdca$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$a66381b3d0f4cdca$var$ja.call(b, e) || !$a66381b3d0f4cdca$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $a66381b3d0f4cdca$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $a66381b3d0f4cdca$var$Ke(a, b) {
    var c = $a66381b3d0f4cdca$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $a66381b3d0f4cdca$var$Je(c);
    }
}
function $a66381b3d0f4cdca$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $a66381b3d0f4cdca$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $a66381b3d0f4cdca$var$Me() {
    for(var a = window, b = $a66381b3d0f4cdca$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $a66381b3d0f4cdca$var$Xa(a.document);
    }
    return b;
}
function $a66381b3d0f4cdca$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $a66381b3d0f4cdca$var$Oe(a) {
    var b = $a66381b3d0f4cdca$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $a66381b3d0f4cdca$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $a66381b3d0f4cdca$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $a66381b3d0f4cdca$var$Ke(c, f);
                var g = $a66381b3d0f4cdca$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $a66381b3d0f4cdca$var$Pe = $a66381b3d0f4cdca$var$ia && "documentMode" in document && 11 >= document.documentMode, $a66381b3d0f4cdca$var$Qe = null, $a66381b3d0f4cdca$var$Re = null, $a66381b3d0f4cdca$var$Se = null, $a66381b3d0f4cdca$var$Te = !1;
function $a66381b3d0f4cdca$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $a66381b3d0f4cdca$var$Te || null == $a66381b3d0f4cdca$var$Qe || $a66381b3d0f4cdca$var$Qe !== $a66381b3d0f4cdca$var$Xa(d) || (d = $a66381b3d0f4cdca$var$Qe, "selectionStart" in d && $a66381b3d0f4cdca$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $a66381b3d0f4cdca$var$Se && $a66381b3d0f4cdca$var$Ie($a66381b3d0f4cdca$var$Se, d) || ($a66381b3d0f4cdca$var$Se = d, d = $a66381b3d0f4cdca$var$oe($a66381b3d0f4cdca$var$Re, "onSelect"), 0 < d.length && (b = new $a66381b3d0f4cdca$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $a66381b3d0f4cdca$var$Qe)));
}
function $a66381b3d0f4cdca$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $a66381b3d0f4cdca$var$We = {
    animationend: $a66381b3d0f4cdca$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $a66381b3d0f4cdca$var$Ve("Animation", "AnimationIteration"),
    animationstart: $a66381b3d0f4cdca$var$Ve("Animation", "AnimationStart"),
    transitionend: $a66381b3d0f4cdca$var$Ve("Transition", "TransitionEnd")
}, $a66381b3d0f4cdca$var$Xe = {}, $a66381b3d0f4cdca$var$Ye = {};
$a66381b3d0f4cdca$var$ia && ($a66381b3d0f4cdca$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $a66381b3d0f4cdca$var$We.animationend.animation, delete $a66381b3d0f4cdca$var$We.animationiteration.animation, delete $a66381b3d0f4cdca$var$We.animationstart.animation), "TransitionEvent" in window || delete $a66381b3d0f4cdca$var$We.transitionend.transition);
function $a66381b3d0f4cdca$var$Ze(a) {
    if ($a66381b3d0f4cdca$var$Xe[a]) return $a66381b3d0f4cdca$var$Xe[a];
    if (!$a66381b3d0f4cdca$var$We[a]) return a;
    var b = $a66381b3d0f4cdca$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $a66381b3d0f4cdca$var$Ye) return $a66381b3d0f4cdca$var$Xe[a] = b[c];
    return a;
}
var $a66381b3d0f4cdca$var$$e = $a66381b3d0f4cdca$var$Ze("animationend"), $a66381b3d0f4cdca$var$af = $a66381b3d0f4cdca$var$Ze("animationiteration"), $a66381b3d0f4cdca$var$bf = $a66381b3d0f4cdca$var$Ze("animationstart"), $a66381b3d0f4cdca$var$cf = $a66381b3d0f4cdca$var$Ze("transitionend"), $a66381b3d0f4cdca$var$df = new Map, $a66381b3d0f4cdca$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $a66381b3d0f4cdca$var$ff(a, b) {
    $a66381b3d0f4cdca$var$df.set(a, b);
    $a66381b3d0f4cdca$var$fa(b, [
        a
    ]);
}
for(var $a66381b3d0f4cdca$var$gf = 0; $a66381b3d0f4cdca$var$gf < $a66381b3d0f4cdca$var$ef.length; $a66381b3d0f4cdca$var$gf++){
    var $a66381b3d0f4cdca$var$hf = $a66381b3d0f4cdca$var$ef[$a66381b3d0f4cdca$var$gf], $a66381b3d0f4cdca$var$jf = $a66381b3d0f4cdca$var$hf.toLowerCase(), $a66381b3d0f4cdca$var$kf = $a66381b3d0f4cdca$var$hf[0].toUpperCase() + $a66381b3d0f4cdca$var$hf.slice(1);
    $a66381b3d0f4cdca$var$ff($a66381b3d0f4cdca$var$jf, "on" + $a66381b3d0f4cdca$var$kf);
}
$a66381b3d0f4cdca$var$ff($a66381b3d0f4cdca$var$$e, "onAnimationEnd");
$a66381b3d0f4cdca$var$ff($a66381b3d0f4cdca$var$af, "onAnimationIteration");
$a66381b3d0f4cdca$var$ff($a66381b3d0f4cdca$var$bf, "onAnimationStart");
$a66381b3d0f4cdca$var$ff("dblclick", "onDoubleClick");
$a66381b3d0f4cdca$var$ff("focusin", "onFocus");
$a66381b3d0f4cdca$var$ff("focusout", "onBlur");
$a66381b3d0f4cdca$var$ff($a66381b3d0f4cdca$var$cf, "onTransitionEnd");
$a66381b3d0f4cdca$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$a66381b3d0f4cdca$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$a66381b3d0f4cdca$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$a66381b3d0f4cdca$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$a66381b3d0f4cdca$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$a66381b3d0f4cdca$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$a66381b3d0f4cdca$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$a66381b3d0f4cdca$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$a66381b3d0f4cdca$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$a66381b3d0f4cdca$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $a66381b3d0f4cdca$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $a66381b3d0f4cdca$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($a66381b3d0f4cdca$var$lf));
function $a66381b3d0f4cdca$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $a66381b3d0f4cdca$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $a66381b3d0f4cdca$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $a66381b3d0f4cdca$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $a66381b3d0f4cdca$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($a66381b3d0f4cdca$var$Qb) throw a = $a66381b3d0f4cdca$var$Rb, $a66381b3d0f4cdca$var$Qb = !1, $a66381b3d0f4cdca$var$Rb = null, a;
}
function $a66381b3d0f4cdca$var$D(a, b) {
    var c = b[$a66381b3d0f4cdca$var$of];
    void 0 === c && (c = b[$a66381b3d0f4cdca$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($a66381b3d0f4cdca$var$pf(b, a, 2, !1), c.add(d));
}
function $a66381b3d0f4cdca$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $a66381b3d0f4cdca$var$pf(c, a, d, b);
}
var $a66381b3d0f4cdca$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $a66381b3d0f4cdca$var$sf(a) {
    if (!a[$a66381b3d0f4cdca$var$rf]) {
        a[$a66381b3d0f4cdca$var$rf] = !0;
        $a66381b3d0f4cdca$var$da.forEach(function(b) {
            "selectionchange" !== b && ($a66381b3d0f4cdca$var$mf.has(b) || $a66381b3d0f4cdca$var$qf(b, !1, a), $a66381b3d0f4cdca$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$a66381b3d0f4cdca$var$rf] || (b[$a66381b3d0f4cdca$var$rf] = !0, $a66381b3d0f4cdca$var$qf("selectionchange", !1, b));
    }
}
function $a66381b3d0f4cdca$var$pf(a, b, c, d) {
    switch($a66381b3d0f4cdca$var$jd(b)){
        case 1:
            var e = $a66381b3d0f4cdca$var$ed;
            break;
        case 4:
            e = $a66381b3d0f4cdca$var$gd;
            break;
        default:
            e = $a66381b3d0f4cdca$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$a66381b3d0f4cdca$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $a66381b3d0f4cdca$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $a66381b3d0f4cdca$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $a66381b3d0f4cdca$var$Jb(function() {
        var d = f, e = $a66381b3d0f4cdca$var$xb(c), g = [];
        a: {
            var h = $a66381b3d0f4cdca$var$df.get(a);
            if (void 0 !== h) {
                var k = $a66381b3d0f4cdca$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $a66381b3d0f4cdca$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $a66381b3d0f4cdca$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $a66381b3d0f4cdca$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $a66381b3d0f4cdca$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $a66381b3d0f4cdca$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $a66381b3d0f4cdca$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $a66381b3d0f4cdca$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $a66381b3d0f4cdca$var$Vd;
                        break;
                    case $a66381b3d0f4cdca$var$$e:
                    case $a66381b3d0f4cdca$var$af:
                    case $a66381b3d0f4cdca$var$bf:
                        k = $a66381b3d0f4cdca$var$Hd;
                        break;
                    case $a66381b3d0f4cdca$var$cf:
                        k = $a66381b3d0f4cdca$var$Xd;
                        break;
                    case "scroll":
                        k = $a66381b3d0f4cdca$var$vd;
                        break;
                    case "wheel":
                        k = $a66381b3d0f4cdca$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $a66381b3d0f4cdca$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $a66381b3d0f4cdca$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $a66381b3d0f4cdca$var$Kb(w, x), null != F && t.push($a66381b3d0f4cdca$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $a66381b3d0f4cdca$var$wb && (n = c.relatedTarget || c.fromElement) && ($a66381b3d0f4cdca$var$Wc(n) || n[$a66381b3d0f4cdca$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $a66381b3d0f4cdca$var$Wc(n) : null, null !== n && (J = $a66381b3d0f4cdca$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $a66381b3d0f4cdca$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $a66381b3d0f4cdca$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $a66381b3d0f4cdca$var$ue(k);
                        u = null == n ? h : $a66381b3d0f4cdca$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $a66381b3d0f4cdca$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $a66381b3d0f4cdca$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $a66381b3d0f4cdca$var$vf(F))u++;
                            for(; 0 < w - u;)t = $a66381b3d0f4cdca$var$vf(t), w--;
                            for(; 0 < u - w;)x = $a66381b3d0f4cdca$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $a66381b3d0f4cdca$var$vf(t);
                                x = $a66381b3d0f4cdca$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $a66381b3d0f4cdca$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $a66381b3d0f4cdca$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $a66381b3d0f4cdca$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $a66381b3d0f4cdca$var$ve;
                else if ($a66381b3d0f4cdca$var$me(h)) {
                    if ($a66381b3d0f4cdca$var$we) na = $a66381b3d0f4cdca$var$Fe;
                    else {
                        na = $a66381b3d0f4cdca$var$De;
                        var xa = $a66381b3d0f4cdca$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $a66381b3d0f4cdca$var$Ee);
                if (na && (na = na(a, d))) {
                    $a66381b3d0f4cdca$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $a66381b3d0f4cdca$var$cb(h, "number", h.value);
            }
            xa = d ? $a66381b3d0f4cdca$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($a66381b3d0f4cdca$var$me(xa) || "true" === xa.contentEditable) $a66381b3d0f4cdca$var$Qe = xa, $a66381b3d0f4cdca$var$Re = d, $a66381b3d0f4cdca$var$Se = null;
                    break;
                case "focusout":
                    $a66381b3d0f4cdca$var$Se = $a66381b3d0f4cdca$var$Re = $a66381b3d0f4cdca$var$Qe = null;
                    break;
                case "mousedown":
                    $a66381b3d0f4cdca$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $a66381b3d0f4cdca$var$Te = !1;
                    $a66381b3d0f4cdca$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($a66381b3d0f4cdca$var$Pe) break;
                case "keydown":
                case "keyup":
                    $a66381b3d0f4cdca$var$Ue(g, c, e);
            }
            var $a;
            if ($a66381b3d0f4cdca$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $a66381b3d0f4cdca$var$ie ? $a66381b3d0f4cdca$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($a66381b3d0f4cdca$var$de && "ko" !== c.locale && ($a66381b3d0f4cdca$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $a66381b3d0f4cdca$var$ie && ($a = $a66381b3d0f4cdca$var$nd()) : ($a66381b3d0f4cdca$var$kd = e, $a66381b3d0f4cdca$var$ld = "value" in $a66381b3d0f4cdca$var$kd ? $a66381b3d0f4cdca$var$kd.value : $a66381b3d0f4cdca$var$kd.textContent, $a66381b3d0f4cdca$var$ie = !0)), xa = $a66381b3d0f4cdca$var$oe(d, ba), 0 < xa.length && (ba = new $a66381b3d0f4cdca$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $a66381b3d0f4cdca$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $a66381b3d0f4cdca$var$ce ? $a66381b3d0f4cdca$var$je(a, c) : $a66381b3d0f4cdca$var$ke(a, c)) d = $a66381b3d0f4cdca$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $a66381b3d0f4cdca$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $a66381b3d0f4cdca$var$se(g, b);
    });
}
function $a66381b3d0f4cdca$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $a66381b3d0f4cdca$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $a66381b3d0f4cdca$var$Kb(a, c), null != f && d.unshift($a66381b3d0f4cdca$var$tf(a, f, e)), f = $a66381b3d0f4cdca$var$Kb(a, b), null != f && d.push($a66381b3d0f4cdca$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $a66381b3d0f4cdca$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $a66381b3d0f4cdca$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $a66381b3d0f4cdca$var$Kb(c, f), null != k && g.unshift($a66381b3d0f4cdca$var$tf(c, k, h))) : e || (k = $a66381b3d0f4cdca$var$Kb(c, f), null != k && g.push($a66381b3d0f4cdca$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $a66381b3d0f4cdca$var$xf = /\r\n?/g, $a66381b3d0f4cdca$var$yf = /\u0000|\uFFFD/g;
function $a66381b3d0f4cdca$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($a66381b3d0f4cdca$var$xf, "\n").replace($a66381b3d0f4cdca$var$yf, "");
}
function $a66381b3d0f4cdca$var$Af(a, b, c) {
    b = $a66381b3d0f4cdca$var$zf(b);
    if ($a66381b3d0f4cdca$var$zf(a) !== b && c) throw Error($a66381b3d0f4cdca$var$p(425));
}
function $a66381b3d0f4cdca$var$Bf() {}
var $a66381b3d0f4cdca$var$Cf = null, $a66381b3d0f4cdca$var$Df = null;
function $a66381b3d0f4cdca$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $a66381b3d0f4cdca$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $a66381b3d0f4cdca$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $a66381b3d0f4cdca$var$Hf = "function" === typeof Promise ? Promise : void 0, $a66381b3d0f4cdca$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $a66381b3d0f4cdca$var$Hf ? function(a) {
    return $a66381b3d0f4cdca$var$Hf.resolve(null).then(a).catch($a66381b3d0f4cdca$var$If);
} : $a66381b3d0f4cdca$var$Ff;
function $a66381b3d0f4cdca$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $a66381b3d0f4cdca$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $a66381b3d0f4cdca$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $a66381b3d0f4cdca$var$bd(b);
}
function $a66381b3d0f4cdca$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $a66381b3d0f4cdca$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $a66381b3d0f4cdca$var$Nf = Math.random().toString(36).slice(2), $a66381b3d0f4cdca$var$Of = "__reactFiber$" + $a66381b3d0f4cdca$var$Nf, $a66381b3d0f4cdca$var$Pf = "__reactProps$" + $a66381b3d0f4cdca$var$Nf, $a66381b3d0f4cdca$var$uf = "__reactContainer$" + $a66381b3d0f4cdca$var$Nf, $a66381b3d0f4cdca$var$of = "__reactEvents$" + $a66381b3d0f4cdca$var$Nf, $a66381b3d0f4cdca$var$Qf = "__reactListeners$" + $a66381b3d0f4cdca$var$Nf, $a66381b3d0f4cdca$var$Rf = "__reactHandles$" + $a66381b3d0f4cdca$var$Nf;
function $a66381b3d0f4cdca$var$Wc(a) {
    var b = a[$a66381b3d0f4cdca$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$a66381b3d0f4cdca$var$uf] || c[$a66381b3d0f4cdca$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $a66381b3d0f4cdca$var$Mf(a); null !== a;){
                if (c = a[$a66381b3d0f4cdca$var$Of]) return c;
                a = $a66381b3d0f4cdca$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $a66381b3d0f4cdca$var$Cb(a) {
    a = a[$a66381b3d0f4cdca$var$Of] || a[$a66381b3d0f4cdca$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $a66381b3d0f4cdca$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($a66381b3d0f4cdca$var$p(33));
}
function $a66381b3d0f4cdca$var$Db(a) {
    return a[$a66381b3d0f4cdca$var$Pf] || null;
}
var $a66381b3d0f4cdca$var$Sf = [], $a66381b3d0f4cdca$var$Tf = -1;
function $a66381b3d0f4cdca$var$Uf(a) {
    return {
        current: a
    };
}
function $a66381b3d0f4cdca$var$E(a) {
    0 > $a66381b3d0f4cdca$var$Tf || (a.current = $a66381b3d0f4cdca$var$Sf[$a66381b3d0f4cdca$var$Tf], $a66381b3d0f4cdca$var$Sf[$a66381b3d0f4cdca$var$Tf] = null, $a66381b3d0f4cdca$var$Tf--);
}
function $a66381b3d0f4cdca$var$G(a, b) {
    $a66381b3d0f4cdca$var$Tf++;
    $a66381b3d0f4cdca$var$Sf[$a66381b3d0f4cdca$var$Tf] = a.current;
    a.current = b;
}
var $a66381b3d0f4cdca$var$Vf = {}, $a66381b3d0f4cdca$var$H = $a66381b3d0f4cdca$var$Uf($a66381b3d0f4cdca$var$Vf), $a66381b3d0f4cdca$var$Wf = $a66381b3d0f4cdca$var$Uf(!1), $a66381b3d0f4cdca$var$Xf = $a66381b3d0f4cdca$var$Vf;
function $a66381b3d0f4cdca$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $a66381b3d0f4cdca$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $a66381b3d0f4cdca$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $a66381b3d0f4cdca$var$$f() {
    $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$Wf);
    $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$H);
}
function $a66381b3d0f4cdca$var$ag(a, b, c) {
    if ($a66381b3d0f4cdca$var$H.current !== $a66381b3d0f4cdca$var$Vf) throw Error($a66381b3d0f4cdca$var$p(168));
    $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$H, b);
    $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$Wf, c);
}
function $a66381b3d0f4cdca$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($a66381b3d0f4cdca$var$p(108, $a66381b3d0f4cdca$var$Ra(a) || "Unknown", e));
    return $a66381b3d0f4cdca$var$A({}, c, d);
}
function $a66381b3d0f4cdca$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $a66381b3d0f4cdca$var$Vf;
    $a66381b3d0f4cdca$var$Xf = $a66381b3d0f4cdca$var$H.current;
    $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$H, a);
    $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$Wf, $a66381b3d0f4cdca$var$Wf.current);
    return !0;
}
function $a66381b3d0f4cdca$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($a66381b3d0f4cdca$var$p(169));
    c ? (a = $a66381b3d0f4cdca$var$bg(a, b, $a66381b3d0f4cdca$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$Wf), $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$H), $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$H, a)) : $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$Wf);
    $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$Wf, c);
}
var $a66381b3d0f4cdca$var$eg = null, $a66381b3d0f4cdca$var$fg = !1, $a66381b3d0f4cdca$var$gg = !1;
function $a66381b3d0f4cdca$var$hg(a) {
    null === $a66381b3d0f4cdca$var$eg ? $a66381b3d0f4cdca$var$eg = [
        a
    ] : $a66381b3d0f4cdca$var$eg.push(a);
}
function $a66381b3d0f4cdca$var$ig(a) {
    $a66381b3d0f4cdca$var$fg = !0;
    $a66381b3d0f4cdca$var$hg(a);
}
function $a66381b3d0f4cdca$var$jg() {
    if (!$a66381b3d0f4cdca$var$gg && null !== $a66381b3d0f4cdca$var$eg) {
        $a66381b3d0f4cdca$var$gg = !0;
        var a = 0, b = $a66381b3d0f4cdca$var$C;
        try {
            var c = $a66381b3d0f4cdca$var$eg;
            for($a66381b3d0f4cdca$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $a66381b3d0f4cdca$var$eg = null;
            $a66381b3d0f4cdca$var$fg = !1;
        } catch (e) {
            throw null !== $a66381b3d0f4cdca$var$eg && ($a66381b3d0f4cdca$var$eg = $a66381b3d0f4cdca$var$eg.slice(a + 1)), $a66381b3d0f4cdca$var$ac($a66381b3d0f4cdca$var$fc, $a66381b3d0f4cdca$var$jg), e;
        } finally{
            $a66381b3d0f4cdca$var$C = b, $a66381b3d0f4cdca$var$gg = !1;
        }
    }
    return null;
}
var $a66381b3d0f4cdca$var$kg = [], $a66381b3d0f4cdca$var$lg = 0, $a66381b3d0f4cdca$var$mg = null, $a66381b3d0f4cdca$var$ng = 0, $a66381b3d0f4cdca$var$og = [], $a66381b3d0f4cdca$var$pg = 0, $a66381b3d0f4cdca$var$qg = null, $a66381b3d0f4cdca$var$rg = 1, $a66381b3d0f4cdca$var$sg = "";
function $a66381b3d0f4cdca$var$tg(a, b) {
    $a66381b3d0f4cdca$var$kg[$a66381b3d0f4cdca$var$lg++] = $a66381b3d0f4cdca$var$ng;
    $a66381b3d0f4cdca$var$kg[$a66381b3d0f4cdca$var$lg++] = $a66381b3d0f4cdca$var$mg;
    $a66381b3d0f4cdca$var$mg = a;
    $a66381b3d0f4cdca$var$ng = b;
}
function $a66381b3d0f4cdca$var$ug(a, b, c) {
    $a66381b3d0f4cdca$var$og[$a66381b3d0f4cdca$var$pg++] = $a66381b3d0f4cdca$var$rg;
    $a66381b3d0f4cdca$var$og[$a66381b3d0f4cdca$var$pg++] = $a66381b3d0f4cdca$var$sg;
    $a66381b3d0f4cdca$var$og[$a66381b3d0f4cdca$var$pg++] = $a66381b3d0f4cdca$var$qg;
    $a66381b3d0f4cdca$var$qg = a;
    var d = $a66381b3d0f4cdca$var$rg;
    a = $a66381b3d0f4cdca$var$sg;
    var e = 32 - $a66381b3d0f4cdca$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $a66381b3d0f4cdca$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $a66381b3d0f4cdca$var$rg = 1 << 32 - $a66381b3d0f4cdca$var$oc(b) + e | c << e | d;
        $a66381b3d0f4cdca$var$sg = f + a;
    } else $a66381b3d0f4cdca$var$rg = 1 << f | c << e | d, $a66381b3d0f4cdca$var$sg = a;
}
function $a66381b3d0f4cdca$var$vg(a) {
    null !== a.return && ($a66381b3d0f4cdca$var$tg(a, 1), $a66381b3d0f4cdca$var$ug(a, 1, 0));
}
function $a66381b3d0f4cdca$var$wg(a) {
    for(; a === $a66381b3d0f4cdca$var$mg;)$a66381b3d0f4cdca$var$mg = $a66381b3d0f4cdca$var$kg[--$a66381b3d0f4cdca$var$lg], $a66381b3d0f4cdca$var$kg[$a66381b3d0f4cdca$var$lg] = null, $a66381b3d0f4cdca$var$ng = $a66381b3d0f4cdca$var$kg[--$a66381b3d0f4cdca$var$lg], $a66381b3d0f4cdca$var$kg[$a66381b3d0f4cdca$var$lg] = null;
    for(; a === $a66381b3d0f4cdca$var$qg;)$a66381b3d0f4cdca$var$qg = $a66381b3d0f4cdca$var$og[--$a66381b3d0f4cdca$var$pg], $a66381b3d0f4cdca$var$og[$a66381b3d0f4cdca$var$pg] = null, $a66381b3d0f4cdca$var$sg = $a66381b3d0f4cdca$var$og[--$a66381b3d0f4cdca$var$pg], $a66381b3d0f4cdca$var$og[$a66381b3d0f4cdca$var$pg] = null, $a66381b3d0f4cdca$var$rg = $a66381b3d0f4cdca$var$og[--$a66381b3d0f4cdca$var$pg], $a66381b3d0f4cdca$var$og[$a66381b3d0f4cdca$var$pg] = null;
}
var $a66381b3d0f4cdca$var$xg = null, $a66381b3d0f4cdca$var$yg = null, $a66381b3d0f4cdca$var$I = !1, $a66381b3d0f4cdca$var$zg = null;
function $a66381b3d0f4cdca$var$Ag(a, b) {
    var c = $a66381b3d0f4cdca$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $a66381b3d0f4cdca$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $a66381b3d0f4cdca$var$xg = a, $a66381b3d0f4cdca$var$yg = $a66381b3d0f4cdca$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $a66381b3d0f4cdca$var$xg = a, $a66381b3d0f4cdca$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $a66381b3d0f4cdca$var$qg ? {
                id: $a66381b3d0f4cdca$var$rg,
                overflow: $a66381b3d0f4cdca$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $a66381b3d0f4cdca$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $a66381b3d0f4cdca$var$xg = a, $a66381b3d0f4cdca$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $a66381b3d0f4cdca$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $a66381b3d0f4cdca$var$Eg(a) {
    if ($a66381b3d0f4cdca$var$I) {
        var b = $a66381b3d0f4cdca$var$yg;
        if (b) {
            var c = b;
            if (!$a66381b3d0f4cdca$var$Cg(a, b)) {
                if ($a66381b3d0f4cdca$var$Dg(a)) throw Error($a66381b3d0f4cdca$var$p(418));
                b = $a66381b3d0f4cdca$var$Lf(c.nextSibling);
                var d = $a66381b3d0f4cdca$var$xg;
                b && $a66381b3d0f4cdca$var$Cg(a, b) ? $a66381b3d0f4cdca$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $a66381b3d0f4cdca$var$I = !1, $a66381b3d0f4cdca$var$xg = a);
            }
        } else {
            if ($a66381b3d0f4cdca$var$Dg(a)) throw Error($a66381b3d0f4cdca$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $a66381b3d0f4cdca$var$I = !1;
            $a66381b3d0f4cdca$var$xg = a;
        }
    }
}
function $a66381b3d0f4cdca$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $a66381b3d0f4cdca$var$xg = a;
}
function $a66381b3d0f4cdca$var$Gg(a) {
    if (a !== $a66381b3d0f4cdca$var$xg) return !1;
    if (!$a66381b3d0f4cdca$var$I) return $a66381b3d0f4cdca$var$Fg(a), $a66381b3d0f4cdca$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$a66381b3d0f4cdca$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $a66381b3d0f4cdca$var$yg)) {
        if ($a66381b3d0f4cdca$var$Dg(a)) throw $a66381b3d0f4cdca$var$Hg(), Error($a66381b3d0f4cdca$var$p(418));
        for(; b;)$a66381b3d0f4cdca$var$Ag(a, b), b = $a66381b3d0f4cdca$var$Lf(b.nextSibling);
    }
    $a66381b3d0f4cdca$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($a66381b3d0f4cdca$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $a66381b3d0f4cdca$var$yg = $a66381b3d0f4cdca$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $a66381b3d0f4cdca$var$yg = null;
        }
    } else $a66381b3d0f4cdca$var$yg = $a66381b3d0f4cdca$var$xg ? $a66381b3d0f4cdca$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $a66381b3d0f4cdca$var$Hg() {
    for(var a = $a66381b3d0f4cdca$var$yg; a;)a = $a66381b3d0f4cdca$var$Lf(a.nextSibling);
}
function $a66381b3d0f4cdca$var$Ig() {
    $a66381b3d0f4cdca$var$yg = $a66381b3d0f4cdca$var$xg = null;
    $a66381b3d0f4cdca$var$I = !1;
}
function $a66381b3d0f4cdca$var$Jg(a) {
    null === $a66381b3d0f4cdca$var$zg ? $a66381b3d0f4cdca$var$zg = [
        a
    ] : $a66381b3d0f4cdca$var$zg.push(a);
}
var $a66381b3d0f4cdca$var$Kg = $a66381b3d0f4cdca$var$ua.ReactCurrentBatchConfig;
function $a66381b3d0f4cdca$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($a66381b3d0f4cdca$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($a66381b3d0f4cdca$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($a66381b3d0f4cdca$var$p(284));
        if (!c._owner) throw Error($a66381b3d0f4cdca$var$p(290, a));
    }
    return a;
}
function $a66381b3d0f4cdca$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($a66381b3d0f4cdca$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $a66381b3d0f4cdca$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $a66381b3d0f4cdca$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $a66381b3d0f4cdca$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $a66381b3d0f4cdca$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $a66381b3d0f4cdca$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $a66381b3d0f4cdca$var$Ha && $a66381b3d0f4cdca$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $a66381b3d0f4cdca$var$Lg(a, b, c), d.return = a, d;
        d = $a66381b3d0f4cdca$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $a66381b3d0f4cdca$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $a66381b3d0f4cdca$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $a66381b3d0f4cdca$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $a66381b3d0f4cdca$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $a66381b3d0f4cdca$var$va:
                    return c = $a66381b3d0f4cdca$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $a66381b3d0f4cdca$var$Lg(a, null, b), c.return = a, c;
                case $a66381b3d0f4cdca$var$wa:
                    return b = $a66381b3d0f4cdca$var$Sg(b, a.mode, c), b.return = a, b;
                case $a66381b3d0f4cdca$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($a66381b3d0f4cdca$var$eb(b) || $a66381b3d0f4cdca$var$Ka(b)) return b = $a66381b3d0f4cdca$var$Tg(b, a.mode, c, null), b.return = a, b;
            $a66381b3d0f4cdca$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $a66381b3d0f4cdca$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $a66381b3d0f4cdca$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $a66381b3d0f4cdca$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($a66381b3d0f4cdca$var$eb(c) || $a66381b3d0f4cdca$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $a66381b3d0f4cdca$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $a66381b3d0f4cdca$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $a66381b3d0f4cdca$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $a66381b3d0f4cdca$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($a66381b3d0f4cdca$var$eb(d) || $a66381b3d0f4cdca$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $a66381b3d0f4cdca$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $a66381b3d0f4cdca$var$I && $a66381b3d0f4cdca$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $a66381b3d0f4cdca$var$I && $a66381b3d0f4cdca$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $a66381b3d0f4cdca$var$I && $a66381b3d0f4cdca$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $a66381b3d0f4cdca$var$Ka(h);
        if ("function" !== typeof l) throw Error($a66381b3d0f4cdca$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($a66381b3d0f4cdca$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $a66381b3d0f4cdca$var$I && $a66381b3d0f4cdca$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $a66381b3d0f4cdca$var$I && $a66381b3d0f4cdca$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $a66381b3d0f4cdca$var$I && $a66381b3d0f4cdca$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $a66381b3d0f4cdca$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $a66381b3d0f4cdca$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $a66381b3d0f4cdca$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $a66381b3d0f4cdca$var$Ha && $a66381b3d0f4cdca$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $a66381b3d0f4cdca$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $a66381b3d0f4cdca$var$ya ? (d = $a66381b3d0f4cdca$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $a66381b3d0f4cdca$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $a66381b3d0f4cdca$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $a66381b3d0f4cdca$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $a66381b3d0f4cdca$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $a66381b3d0f4cdca$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($a66381b3d0f4cdca$var$eb(f)) return n(a, d, f, h);
            if ($a66381b3d0f4cdca$var$Ka(f)) return t(a, d, f, h);
            $a66381b3d0f4cdca$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $a66381b3d0f4cdca$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $a66381b3d0f4cdca$var$Ug = $a66381b3d0f4cdca$var$Og(!0), $a66381b3d0f4cdca$var$Vg = $a66381b3d0f4cdca$var$Og(!1), $a66381b3d0f4cdca$var$Wg = $a66381b3d0f4cdca$var$Uf(null), $a66381b3d0f4cdca$var$Xg = null, $a66381b3d0f4cdca$var$Yg = null, $a66381b3d0f4cdca$var$Zg = null;
function $a66381b3d0f4cdca$var$$g() {
    $a66381b3d0f4cdca$var$Zg = $a66381b3d0f4cdca$var$Yg = $a66381b3d0f4cdca$var$Xg = null;
}
function $a66381b3d0f4cdca$var$ah(a) {
    var b = $a66381b3d0f4cdca$var$Wg.current;
    $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$Wg);
    a._currentValue = b;
}
function $a66381b3d0f4cdca$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $a66381b3d0f4cdca$var$ch(a, b) {
    $a66381b3d0f4cdca$var$Xg = a;
    $a66381b3d0f4cdca$var$Zg = $a66381b3d0f4cdca$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($a66381b3d0f4cdca$var$dh = !0), a.firstContext = null);
}
function $a66381b3d0f4cdca$var$eh(a) {
    var b = a._currentValue;
    if ($a66381b3d0f4cdca$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $a66381b3d0f4cdca$var$Yg) {
            if (null === $a66381b3d0f4cdca$var$Xg) throw Error($a66381b3d0f4cdca$var$p(308));
            $a66381b3d0f4cdca$var$Yg = a;
            $a66381b3d0f4cdca$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $a66381b3d0f4cdca$var$Yg = $a66381b3d0f4cdca$var$Yg.next = a;
    }
    return b;
}
var $a66381b3d0f4cdca$var$fh = null;
function $a66381b3d0f4cdca$var$gh(a) {
    null === $a66381b3d0f4cdca$var$fh ? $a66381b3d0f4cdca$var$fh = [
        a
    ] : $a66381b3d0f4cdca$var$fh.push(a);
}
function $a66381b3d0f4cdca$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $a66381b3d0f4cdca$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $a66381b3d0f4cdca$var$ih(a, d);
}
function $a66381b3d0f4cdca$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $a66381b3d0f4cdca$var$jh = !1;
function $a66381b3d0f4cdca$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $a66381b3d0f4cdca$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $a66381b3d0f4cdca$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $a66381b3d0f4cdca$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($a66381b3d0f4cdca$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $a66381b3d0f4cdca$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $a66381b3d0f4cdca$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $a66381b3d0f4cdca$var$ih(a, c);
}
function $a66381b3d0f4cdca$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $a66381b3d0f4cdca$var$Cc(a, c);
    }
}
function $a66381b3d0f4cdca$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $a66381b3d0f4cdca$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $a66381b3d0f4cdca$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $a66381b3d0f4cdca$var$A({}, q, r);
                            break a;
                        case 2:
                            $a66381b3d0f4cdca$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $a66381b3d0f4cdca$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $a66381b3d0f4cdca$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($a66381b3d0f4cdca$var$p(191, e));
            e.call(d);
        }
    }
}
var $a66381b3d0f4cdca$var$th = {}, $a66381b3d0f4cdca$var$uh = $a66381b3d0f4cdca$var$Uf($a66381b3d0f4cdca$var$th), $a66381b3d0f4cdca$var$vh = $a66381b3d0f4cdca$var$Uf($a66381b3d0f4cdca$var$th), $a66381b3d0f4cdca$var$wh = $a66381b3d0f4cdca$var$Uf($a66381b3d0f4cdca$var$th);
function $a66381b3d0f4cdca$var$xh(a) {
    if (a === $a66381b3d0f4cdca$var$th) throw Error($a66381b3d0f4cdca$var$p(174));
    return a;
}
function $a66381b3d0f4cdca$var$yh(a, b) {
    $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$wh, b);
    $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$vh, a);
    $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$uh, $a66381b3d0f4cdca$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $a66381b3d0f4cdca$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $a66381b3d0f4cdca$var$lb(b, a);
    }
    $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$uh);
    $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$uh, b);
}
function $a66381b3d0f4cdca$var$zh() {
    $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$uh);
    $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$vh);
    $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$wh);
}
function $a66381b3d0f4cdca$var$Ah(a) {
    $a66381b3d0f4cdca$var$xh($a66381b3d0f4cdca$var$wh.current);
    var b = $a66381b3d0f4cdca$var$xh($a66381b3d0f4cdca$var$uh.current);
    var c = $a66381b3d0f4cdca$var$lb(b, a.type);
    b !== c && ($a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$vh, a), $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$uh, c));
}
function $a66381b3d0f4cdca$var$Bh(a) {
    $a66381b3d0f4cdca$var$vh.current === a && ($a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$uh), $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$vh));
}
var $a66381b3d0f4cdca$var$L = $a66381b3d0f4cdca$var$Uf(0);
function $a66381b3d0f4cdca$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $a66381b3d0f4cdca$var$Dh = [];
function $a66381b3d0f4cdca$var$Eh() {
    for(var a = 0; a < $a66381b3d0f4cdca$var$Dh.length; a++)$a66381b3d0f4cdca$var$Dh[a]._workInProgressVersionPrimary = null;
    $a66381b3d0f4cdca$var$Dh.length = 0;
}
var $a66381b3d0f4cdca$var$Fh = $a66381b3d0f4cdca$var$ua.ReactCurrentDispatcher, $a66381b3d0f4cdca$var$Gh = $a66381b3d0f4cdca$var$ua.ReactCurrentBatchConfig, $a66381b3d0f4cdca$var$Hh = 0, $a66381b3d0f4cdca$var$M = null, $a66381b3d0f4cdca$var$N = null, $a66381b3d0f4cdca$var$O = null, $a66381b3d0f4cdca$var$Ih = !1, $a66381b3d0f4cdca$var$Jh = !1, $a66381b3d0f4cdca$var$Kh = 0, $a66381b3d0f4cdca$var$Lh = 0;
function $a66381b3d0f4cdca$var$P() {
    throw Error($a66381b3d0f4cdca$var$p(321));
}
function $a66381b3d0f4cdca$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$a66381b3d0f4cdca$var$He(a[c], b[c])) return !1;
    return !0;
}
function $a66381b3d0f4cdca$var$Nh(a, b, c, d, e, f) {
    $a66381b3d0f4cdca$var$Hh = f;
    $a66381b3d0f4cdca$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $a66381b3d0f4cdca$var$Fh.current = null === a || null === a.memoizedState ? $a66381b3d0f4cdca$var$Oh : $a66381b3d0f4cdca$var$Ph;
    a = c(d, e);
    if ($a66381b3d0f4cdca$var$Jh) {
        f = 0;
        do {
            $a66381b3d0f4cdca$var$Jh = !1;
            $a66381b3d0f4cdca$var$Kh = 0;
            if (25 <= f) throw Error($a66381b3d0f4cdca$var$p(301));
            f += 1;
            $a66381b3d0f4cdca$var$O = $a66381b3d0f4cdca$var$N = null;
            b.updateQueue = null;
            $a66381b3d0f4cdca$var$Fh.current = $a66381b3d0f4cdca$var$Qh;
            a = c(d, e);
        }while ($a66381b3d0f4cdca$var$Jh);
    }
    $a66381b3d0f4cdca$var$Fh.current = $a66381b3d0f4cdca$var$Rh;
    b = null !== $a66381b3d0f4cdca$var$N && null !== $a66381b3d0f4cdca$var$N.next;
    $a66381b3d0f4cdca$var$Hh = 0;
    $a66381b3d0f4cdca$var$O = $a66381b3d0f4cdca$var$N = $a66381b3d0f4cdca$var$M = null;
    $a66381b3d0f4cdca$var$Ih = !1;
    if (b) throw Error($a66381b3d0f4cdca$var$p(300));
    return a;
}
function $a66381b3d0f4cdca$var$Sh() {
    var a = 0 !== $a66381b3d0f4cdca$var$Kh;
    $a66381b3d0f4cdca$var$Kh = 0;
    return a;
}
function $a66381b3d0f4cdca$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $a66381b3d0f4cdca$var$O ? $a66381b3d0f4cdca$var$M.memoizedState = $a66381b3d0f4cdca$var$O = a : $a66381b3d0f4cdca$var$O = $a66381b3d0f4cdca$var$O.next = a;
    return $a66381b3d0f4cdca$var$O;
}
function $a66381b3d0f4cdca$var$Uh() {
    if (null === $a66381b3d0f4cdca$var$N) {
        var a = $a66381b3d0f4cdca$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $a66381b3d0f4cdca$var$N.next;
    var b = null === $a66381b3d0f4cdca$var$O ? $a66381b3d0f4cdca$var$M.memoizedState : $a66381b3d0f4cdca$var$O.next;
    if (null !== b) $a66381b3d0f4cdca$var$O = b, $a66381b3d0f4cdca$var$N = a;
    else {
        if (null === a) throw Error($a66381b3d0f4cdca$var$p(310));
        $a66381b3d0f4cdca$var$N = a;
        a = {
            memoizedState: $a66381b3d0f4cdca$var$N.memoizedState,
            baseState: $a66381b3d0f4cdca$var$N.baseState,
            baseQueue: $a66381b3d0f4cdca$var$N.baseQueue,
            queue: $a66381b3d0f4cdca$var$N.queue,
            next: null
        };
        null === $a66381b3d0f4cdca$var$O ? $a66381b3d0f4cdca$var$M.memoizedState = $a66381b3d0f4cdca$var$O = a : $a66381b3d0f4cdca$var$O = $a66381b3d0f4cdca$var$O.next = a;
    }
    return $a66381b3d0f4cdca$var$O;
}
function $a66381b3d0f4cdca$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $a66381b3d0f4cdca$var$Wh(a) {
    var b = $a66381b3d0f4cdca$var$Uh(), c = b.queue;
    if (null === c) throw Error($a66381b3d0f4cdca$var$p(311));
    c.lastRenderedReducer = a;
    var d = $a66381b3d0f4cdca$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($a66381b3d0f4cdca$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $a66381b3d0f4cdca$var$M.lanes |= m;
                $a66381b3d0f4cdca$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $a66381b3d0f4cdca$var$He(d, b.memoizedState) || ($a66381b3d0f4cdca$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $a66381b3d0f4cdca$var$M.lanes |= f, $a66381b3d0f4cdca$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $a66381b3d0f4cdca$var$Xh(a) {
    var b = $a66381b3d0f4cdca$var$Uh(), c = b.queue;
    if (null === c) throw Error($a66381b3d0f4cdca$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $a66381b3d0f4cdca$var$He(f, b.memoizedState) || ($a66381b3d0f4cdca$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $a66381b3d0f4cdca$var$Yh() {}
function $a66381b3d0f4cdca$var$Zh(a, b) {
    var c = $a66381b3d0f4cdca$var$M, d = $a66381b3d0f4cdca$var$Uh(), e = b(), f = !$a66381b3d0f4cdca$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $a66381b3d0f4cdca$var$dh = !0);
    d = d.queue;
    $a66381b3d0f4cdca$var$$h($a66381b3d0f4cdca$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $a66381b3d0f4cdca$var$O && $a66381b3d0f4cdca$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $a66381b3d0f4cdca$var$bi(9, $a66381b3d0f4cdca$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $a66381b3d0f4cdca$var$Q) throw Error($a66381b3d0f4cdca$var$p(349));
        0 !== ($a66381b3d0f4cdca$var$Hh & 30) || $a66381b3d0f4cdca$var$di(c, b, e);
    }
    return e;
}
function $a66381b3d0f4cdca$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $a66381b3d0f4cdca$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $a66381b3d0f4cdca$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $a66381b3d0f4cdca$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $a66381b3d0f4cdca$var$ei(b) && $a66381b3d0f4cdca$var$fi(a);
}
function $a66381b3d0f4cdca$var$ai(a, b, c) {
    return c(function() {
        $a66381b3d0f4cdca$var$ei(b) && $a66381b3d0f4cdca$var$fi(a);
    });
}
function $a66381b3d0f4cdca$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$a66381b3d0f4cdca$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $a66381b3d0f4cdca$var$fi(a) {
    var b = $a66381b3d0f4cdca$var$ih(a, 1);
    null !== b && $a66381b3d0f4cdca$var$gi(b, a, 1, -1);
}
function $a66381b3d0f4cdca$var$hi(a) {
    var b = $a66381b3d0f4cdca$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $a66381b3d0f4cdca$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $a66381b3d0f4cdca$var$ii.bind(null, $a66381b3d0f4cdca$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $a66381b3d0f4cdca$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $a66381b3d0f4cdca$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $a66381b3d0f4cdca$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $a66381b3d0f4cdca$var$ji() {
    return $a66381b3d0f4cdca$var$Uh().memoizedState;
}
function $a66381b3d0f4cdca$var$ki(a, b, c, d) {
    var e = $a66381b3d0f4cdca$var$Th();
    $a66381b3d0f4cdca$var$M.flags |= a;
    e.memoizedState = $a66381b3d0f4cdca$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $a66381b3d0f4cdca$var$li(a, b, c, d) {
    var e = $a66381b3d0f4cdca$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $a66381b3d0f4cdca$var$N) {
        var g = $a66381b3d0f4cdca$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $a66381b3d0f4cdca$var$Mh(d, g.deps)) {
            e.memoizedState = $a66381b3d0f4cdca$var$bi(b, c, f, d);
            return;
        }
    }
    $a66381b3d0f4cdca$var$M.flags |= a;
    e.memoizedState = $a66381b3d0f4cdca$var$bi(1 | b, c, f, d);
}
function $a66381b3d0f4cdca$var$mi(a, b) {
    return $a66381b3d0f4cdca$var$ki(8390656, 8, a, b);
}
function $a66381b3d0f4cdca$var$$h(a, b) {
    return $a66381b3d0f4cdca$var$li(2048, 8, a, b);
}
function $a66381b3d0f4cdca$var$ni(a, b) {
    return $a66381b3d0f4cdca$var$li(4, 2, a, b);
}
function $a66381b3d0f4cdca$var$oi(a, b) {
    return $a66381b3d0f4cdca$var$li(4, 4, a, b);
}
function $a66381b3d0f4cdca$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $a66381b3d0f4cdca$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $a66381b3d0f4cdca$var$li(4, 4, $a66381b3d0f4cdca$var$pi.bind(null, b, a), c);
}
function $a66381b3d0f4cdca$var$ri() {}
function $a66381b3d0f4cdca$var$si(a, b) {
    var c = $a66381b3d0f4cdca$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $a66381b3d0f4cdca$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a66381b3d0f4cdca$var$ti(a, b) {
    var c = $a66381b3d0f4cdca$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $a66381b3d0f4cdca$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a66381b3d0f4cdca$var$ui(a, b, c) {
    if (0 === ($a66381b3d0f4cdca$var$Hh & 21)) return a.baseState && (a.baseState = !1, $a66381b3d0f4cdca$var$dh = !0), a.memoizedState = c;
    $a66381b3d0f4cdca$var$He(c, b) || (c = $a66381b3d0f4cdca$var$yc(), $a66381b3d0f4cdca$var$M.lanes |= c, $a66381b3d0f4cdca$var$rh |= c, a.baseState = !0);
    return b;
}
function $a66381b3d0f4cdca$var$vi(a, b) {
    var c = $a66381b3d0f4cdca$var$C;
    $a66381b3d0f4cdca$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $a66381b3d0f4cdca$var$Gh.transition;
    $a66381b3d0f4cdca$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $a66381b3d0f4cdca$var$C = c, $a66381b3d0f4cdca$var$Gh.transition = d;
    }
}
function $a66381b3d0f4cdca$var$wi() {
    return $a66381b3d0f4cdca$var$Uh().memoizedState;
}
function $a66381b3d0f4cdca$var$xi(a, b, c) {
    var d = $a66381b3d0f4cdca$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a66381b3d0f4cdca$var$zi(a)) $a66381b3d0f4cdca$var$Ai(b, c);
    else if (c = $a66381b3d0f4cdca$var$hh(a, b, c, d), null !== c) {
        var e = $a66381b3d0f4cdca$var$R();
        $a66381b3d0f4cdca$var$gi(c, a, d, e);
        $a66381b3d0f4cdca$var$Bi(c, b, d);
    }
}
function $a66381b3d0f4cdca$var$ii(a, b, c) {
    var d = $a66381b3d0f4cdca$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a66381b3d0f4cdca$var$zi(a)) $a66381b3d0f4cdca$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($a66381b3d0f4cdca$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $a66381b3d0f4cdca$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $a66381b3d0f4cdca$var$hh(a, b, e, d);
        null !== c && (e = $a66381b3d0f4cdca$var$R(), $a66381b3d0f4cdca$var$gi(c, a, d, e), $a66381b3d0f4cdca$var$Bi(c, b, d));
    }
}
function $a66381b3d0f4cdca$var$zi(a) {
    var b = a.alternate;
    return a === $a66381b3d0f4cdca$var$M || null !== b && b === $a66381b3d0f4cdca$var$M;
}
function $a66381b3d0f4cdca$var$Ai(a, b) {
    $a66381b3d0f4cdca$var$Jh = $a66381b3d0f4cdca$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $a66381b3d0f4cdca$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $a66381b3d0f4cdca$var$Cc(a, c);
    }
}
var $a66381b3d0f4cdca$var$Rh = {
    readContext: $a66381b3d0f4cdca$var$eh,
    useCallback: $a66381b3d0f4cdca$var$P,
    useContext: $a66381b3d0f4cdca$var$P,
    useEffect: $a66381b3d0f4cdca$var$P,
    useImperativeHandle: $a66381b3d0f4cdca$var$P,
    useInsertionEffect: $a66381b3d0f4cdca$var$P,
    useLayoutEffect: $a66381b3d0f4cdca$var$P,
    useMemo: $a66381b3d0f4cdca$var$P,
    useReducer: $a66381b3d0f4cdca$var$P,
    useRef: $a66381b3d0f4cdca$var$P,
    useState: $a66381b3d0f4cdca$var$P,
    useDebugValue: $a66381b3d0f4cdca$var$P,
    useDeferredValue: $a66381b3d0f4cdca$var$P,
    useTransition: $a66381b3d0f4cdca$var$P,
    useMutableSource: $a66381b3d0f4cdca$var$P,
    useSyncExternalStore: $a66381b3d0f4cdca$var$P,
    useId: $a66381b3d0f4cdca$var$P,
    unstable_isNewReconciler: !1
}, $a66381b3d0f4cdca$var$Oh = {
    readContext: $a66381b3d0f4cdca$var$eh,
    useCallback: function(a, b) {
        $a66381b3d0f4cdca$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $a66381b3d0f4cdca$var$eh,
    useEffect: $a66381b3d0f4cdca$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $a66381b3d0f4cdca$var$ki(4194308, 4, $a66381b3d0f4cdca$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $a66381b3d0f4cdca$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $a66381b3d0f4cdca$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $a66381b3d0f4cdca$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $a66381b3d0f4cdca$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $a66381b3d0f4cdca$var$xi.bind(null, $a66381b3d0f4cdca$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $a66381b3d0f4cdca$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $a66381b3d0f4cdca$var$hi,
    useDebugValue: $a66381b3d0f4cdca$var$ri,
    useDeferredValue: function(a) {
        return $a66381b3d0f4cdca$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $a66381b3d0f4cdca$var$hi(!1), b = a[0];
        a = $a66381b3d0f4cdca$var$vi.bind(null, a[1]);
        $a66381b3d0f4cdca$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $a66381b3d0f4cdca$var$M, e = $a66381b3d0f4cdca$var$Th();
        if ($a66381b3d0f4cdca$var$I) {
            if (void 0 === c) throw Error($a66381b3d0f4cdca$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $a66381b3d0f4cdca$var$Q) throw Error($a66381b3d0f4cdca$var$p(349));
            0 !== ($a66381b3d0f4cdca$var$Hh & 30) || $a66381b3d0f4cdca$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $a66381b3d0f4cdca$var$mi($a66381b3d0f4cdca$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $a66381b3d0f4cdca$var$bi(9, $a66381b3d0f4cdca$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $a66381b3d0f4cdca$var$Th(), b = $a66381b3d0f4cdca$var$Q.identifierPrefix;
        if ($a66381b3d0f4cdca$var$I) {
            var c = $a66381b3d0f4cdca$var$sg;
            var d = $a66381b3d0f4cdca$var$rg;
            c = (d & ~(1 << 32 - $a66381b3d0f4cdca$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $a66381b3d0f4cdca$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $a66381b3d0f4cdca$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $a66381b3d0f4cdca$var$Ph = {
    readContext: $a66381b3d0f4cdca$var$eh,
    useCallback: $a66381b3d0f4cdca$var$si,
    useContext: $a66381b3d0f4cdca$var$eh,
    useEffect: $a66381b3d0f4cdca$var$$h,
    useImperativeHandle: $a66381b3d0f4cdca$var$qi,
    useInsertionEffect: $a66381b3d0f4cdca$var$ni,
    useLayoutEffect: $a66381b3d0f4cdca$var$oi,
    useMemo: $a66381b3d0f4cdca$var$ti,
    useReducer: $a66381b3d0f4cdca$var$Wh,
    useRef: $a66381b3d0f4cdca$var$ji,
    useState: function() {
        return $a66381b3d0f4cdca$var$Wh($a66381b3d0f4cdca$var$Vh);
    },
    useDebugValue: $a66381b3d0f4cdca$var$ri,
    useDeferredValue: function(a) {
        var b = $a66381b3d0f4cdca$var$Uh();
        return $a66381b3d0f4cdca$var$ui(b, $a66381b3d0f4cdca$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $a66381b3d0f4cdca$var$Wh($a66381b3d0f4cdca$var$Vh)[0], b = $a66381b3d0f4cdca$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $a66381b3d0f4cdca$var$Yh,
    useSyncExternalStore: $a66381b3d0f4cdca$var$Zh,
    useId: $a66381b3d0f4cdca$var$wi,
    unstable_isNewReconciler: !1
}, $a66381b3d0f4cdca$var$Qh = {
    readContext: $a66381b3d0f4cdca$var$eh,
    useCallback: $a66381b3d0f4cdca$var$si,
    useContext: $a66381b3d0f4cdca$var$eh,
    useEffect: $a66381b3d0f4cdca$var$$h,
    useImperativeHandle: $a66381b3d0f4cdca$var$qi,
    useInsertionEffect: $a66381b3d0f4cdca$var$ni,
    useLayoutEffect: $a66381b3d0f4cdca$var$oi,
    useMemo: $a66381b3d0f4cdca$var$ti,
    useReducer: $a66381b3d0f4cdca$var$Xh,
    useRef: $a66381b3d0f4cdca$var$ji,
    useState: function() {
        return $a66381b3d0f4cdca$var$Xh($a66381b3d0f4cdca$var$Vh);
    },
    useDebugValue: $a66381b3d0f4cdca$var$ri,
    useDeferredValue: function(a) {
        var b = $a66381b3d0f4cdca$var$Uh();
        return null === $a66381b3d0f4cdca$var$N ? b.memoizedState = a : $a66381b3d0f4cdca$var$ui(b, $a66381b3d0f4cdca$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $a66381b3d0f4cdca$var$Xh($a66381b3d0f4cdca$var$Vh)[0], b = $a66381b3d0f4cdca$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $a66381b3d0f4cdca$var$Yh,
    useSyncExternalStore: $a66381b3d0f4cdca$var$Zh,
    useId: $a66381b3d0f4cdca$var$wi,
    unstable_isNewReconciler: !1
};
function $a66381b3d0f4cdca$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $a66381b3d0f4cdca$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $a66381b3d0f4cdca$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $a66381b3d0f4cdca$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $a66381b3d0f4cdca$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $a66381b3d0f4cdca$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $a66381b3d0f4cdca$var$R(), e = $a66381b3d0f4cdca$var$yi(a), f = $a66381b3d0f4cdca$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $a66381b3d0f4cdca$var$nh(a, f, e);
        null !== b && ($a66381b3d0f4cdca$var$gi(b, a, e, d), $a66381b3d0f4cdca$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $a66381b3d0f4cdca$var$R(), e = $a66381b3d0f4cdca$var$yi(a), f = $a66381b3d0f4cdca$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $a66381b3d0f4cdca$var$nh(a, f, e);
        null !== b && ($a66381b3d0f4cdca$var$gi(b, a, e, d), $a66381b3d0f4cdca$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $a66381b3d0f4cdca$var$R(), d = $a66381b3d0f4cdca$var$yi(a), e = $a66381b3d0f4cdca$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $a66381b3d0f4cdca$var$nh(a, e, d);
        null !== b && ($a66381b3d0f4cdca$var$gi(b, a, d, c), $a66381b3d0f4cdca$var$oh(b, a, d));
    }
};
function $a66381b3d0f4cdca$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$a66381b3d0f4cdca$var$Ie(c, d) || !$a66381b3d0f4cdca$var$Ie(e, f) : !0;
}
function $a66381b3d0f4cdca$var$Gi(a, b, c) {
    var d = !1, e = $a66381b3d0f4cdca$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $a66381b3d0f4cdca$var$eh(f) : (e = $a66381b3d0f4cdca$var$Zf(b) ? $a66381b3d0f4cdca$var$Xf : $a66381b3d0f4cdca$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $a66381b3d0f4cdca$var$Yf(a, e) : $a66381b3d0f4cdca$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $a66381b3d0f4cdca$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $a66381b3d0f4cdca$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $a66381b3d0f4cdca$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $a66381b3d0f4cdca$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $a66381b3d0f4cdca$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $a66381b3d0f4cdca$var$eh(f) : (f = $a66381b3d0f4cdca$var$Zf(b) ? $a66381b3d0f4cdca$var$Xf : $a66381b3d0f4cdca$var$H.current, e.context = $a66381b3d0f4cdca$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($a66381b3d0f4cdca$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $a66381b3d0f4cdca$var$Ei.enqueueReplaceState(e, e.state, null), $a66381b3d0f4cdca$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $a66381b3d0f4cdca$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $a66381b3d0f4cdca$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $a66381b3d0f4cdca$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $a66381b3d0f4cdca$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $a66381b3d0f4cdca$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $a66381b3d0f4cdca$var$Ni(a, b, c) {
    c = $a66381b3d0f4cdca$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $a66381b3d0f4cdca$var$Oi || ($a66381b3d0f4cdca$var$Oi = !0, $a66381b3d0f4cdca$var$Pi = d);
        $a66381b3d0f4cdca$var$Li(a, b);
    };
    return c;
}
function $a66381b3d0f4cdca$var$Qi(a, b, c) {
    c = $a66381b3d0f4cdca$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $a66381b3d0f4cdca$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $a66381b3d0f4cdca$var$Li(a, b);
        "function" !== typeof d && (null === $a66381b3d0f4cdca$var$Ri ? $a66381b3d0f4cdca$var$Ri = new Set([
            this
        ]) : $a66381b3d0f4cdca$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $a66381b3d0f4cdca$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $a66381b3d0f4cdca$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $a66381b3d0f4cdca$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $a66381b3d0f4cdca$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $a66381b3d0f4cdca$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $a66381b3d0f4cdca$var$mh(-1, 1), b.tag = 2, $a66381b3d0f4cdca$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $a66381b3d0f4cdca$var$Wi = $a66381b3d0f4cdca$var$ua.ReactCurrentOwner, $a66381b3d0f4cdca$var$dh = !1;
function $a66381b3d0f4cdca$var$Xi(a, b, c, d) {
    b.child = null === a ? $a66381b3d0f4cdca$var$Vg(b, null, c, d) : $a66381b3d0f4cdca$var$Ug(b, a.child, c, d);
}
function $a66381b3d0f4cdca$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $a66381b3d0f4cdca$var$ch(b, e);
    d = $a66381b3d0f4cdca$var$Nh(a, b, c, d, f, e);
    c = $a66381b3d0f4cdca$var$Sh();
    if (null !== a && !$a66381b3d0f4cdca$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $a66381b3d0f4cdca$var$Zi(a, b, e);
    $a66381b3d0f4cdca$var$I && c && $a66381b3d0f4cdca$var$vg(b);
    b.flags |= 1;
    $a66381b3d0f4cdca$var$Xi(a, b, d, e);
    return b.child;
}
function $a66381b3d0f4cdca$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$a66381b3d0f4cdca$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $a66381b3d0f4cdca$var$bj(a, b, f, d, e);
        a = $a66381b3d0f4cdca$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $a66381b3d0f4cdca$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $a66381b3d0f4cdca$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $a66381b3d0f4cdca$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $a66381b3d0f4cdca$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($a66381b3d0f4cdca$var$Ie(f, d) && a.ref === b.ref) {
            if ($a66381b3d0f4cdca$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($a66381b3d0f4cdca$var$dh = !0);
            else return b.lanes = a.lanes, $a66381b3d0f4cdca$var$Zi(a, b, e);
        }
    }
    return $a66381b3d0f4cdca$var$cj(a, b, c, d, e);
}
function $a66381b3d0f4cdca$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$ej, $a66381b3d0f4cdca$var$fj), $a66381b3d0f4cdca$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$ej, $a66381b3d0f4cdca$var$fj), $a66381b3d0f4cdca$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$ej, $a66381b3d0f4cdca$var$fj);
            $a66381b3d0f4cdca$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$ej, $a66381b3d0f4cdca$var$fj), $a66381b3d0f4cdca$var$fj |= d;
    $a66381b3d0f4cdca$var$Xi(a, b, e, c);
    return b.child;
}
function $a66381b3d0f4cdca$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $a66381b3d0f4cdca$var$cj(a, b, c, d, e) {
    var f = $a66381b3d0f4cdca$var$Zf(c) ? $a66381b3d0f4cdca$var$Xf : $a66381b3d0f4cdca$var$H.current;
    f = $a66381b3d0f4cdca$var$Yf(b, f);
    $a66381b3d0f4cdca$var$ch(b, e);
    c = $a66381b3d0f4cdca$var$Nh(a, b, c, d, f, e);
    d = $a66381b3d0f4cdca$var$Sh();
    if (null !== a && !$a66381b3d0f4cdca$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $a66381b3d0f4cdca$var$Zi(a, b, e);
    $a66381b3d0f4cdca$var$I && d && $a66381b3d0f4cdca$var$vg(b);
    b.flags |= 1;
    $a66381b3d0f4cdca$var$Xi(a, b, c, e);
    return b.child;
}
function $a66381b3d0f4cdca$var$hj(a, b, c, d, e) {
    if ($a66381b3d0f4cdca$var$Zf(c)) {
        var f = !0;
        $a66381b3d0f4cdca$var$cg(b);
    } else f = !1;
    $a66381b3d0f4cdca$var$ch(b, e);
    if (null === b.stateNode) $a66381b3d0f4cdca$var$ij(a, b), $a66381b3d0f4cdca$var$Gi(b, c, d), $a66381b3d0f4cdca$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $a66381b3d0f4cdca$var$eh(l) : (l = $a66381b3d0f4cdca$var$Zf(c) ? $a66381b3d0f4cdca$var$Xf : $a66381b3d0f4cdca$var$H.current, l = $a66381b3d0f4cdca$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $a66381b3d0f4cdca$var$Hi(b, g, d, l);
        $a66381b3d0f4cdca$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $a66381b3d0f4cdca$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $a66381b3d0f4cdca$var$Wf.current || $a66381b3d0f4cdca$var$jh ? ("function" === typeof m && ($a66381b3d0f4cdca$var$Di(b, c, m, d), k = b.memoizedState), (h = $a66381b3d0f4cdca$var$jh || $a66381b3d0f4cdca$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $a66381b3d0f4cdca$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $a66381b3d0f4cdca$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $a66381b3d0f4cdca$var$eh(k) : (k = $a66381b3d0f4cdca$var$Zf(c) ? $a66381b3d0f4cdca$var$Xf : $a66381b3d0f4cdca$var$H.current, k = $a66381b3d0f4cdca$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $a66381b3d0f4cdca$var$Hi(b, g, d, k);
        $a66381b3d0f4cdca$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $a66381b3d0f4cdca$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $a66381b3d0f4cdca$var$Wf.current || $a66381b3d0f4cdca$var$jh ? ("function" === typeof y && ($a66381b3d0f4cdca$var$Di(b, c, y, d), n = b.memoizedState), (l = $a66381b3d0f4cdca$var$jh || $a66381b3d0f4cdca$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $a66381b3d0f4cdca$var$jj(a, b, c, d, f, e);
}
function $a66381b3d0f4cdca$var$jj(a, b, c, d, e, f) {
    $a66381b3d0f4cdca$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $a66381b3d0f4cdca$var$dg(b, c, !1), $a66381b3d0f4cdca$var$Zi(a, b, f);
    d = b.stateNode;
    $a66381b3d0f4cdca$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $a66381b3d0f4cdca$var$Ug(b, a.child, null, f), b.child = $a66381b3d0f4cdca$var$Ug(b, null, h, f)) : $a66381b3d0f4cdca$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $a66381b3d0f4cdca$var$dg(b, c, !0);
    return b.child;
}
function $a66381b3d0f4cdca$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $a66381b3d0f4cdca$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $a66381b3d0f4cdca$var$ag(a, b.context, !1);
    $a66381b3d0f4cdca$var$yh(a, b.containerInfo);
}
function $a66381b3d0f4cdca$var$lj(a, b, c, d, e) {
    $a66381b3d0f4cdca$var$Ig();
    $a66381b3d0f4cdca$var$Jg(e);
    b.flags |= 256;
    $a66381b3d0f4cdca$var$Xi(a, b, c, d);
    return b.child;
}
var $a66381b3d0f4cdca$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $a66381b3d0f4cdca$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $a66381b3d0f4cdca$var$oj(a, b, c) {
    var d = b.pendingProps, e = $a66381b3d0f4cdca$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$L, e & 1);
    if (null === a) {
        $a66381b3d0f4cdca$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $a66381b3d0f4cdca$var$pj(g, d, 0, null), a = $a66381b3d0f4cdca$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $a66381b3d0f4cdca$var$nj(c), b.memoizedState = $a66381b3d0f4cdca$var$mj, a) : $a66381b3d0f4cdca$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $a66381b3d0f4cdca$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $a66381b3d0f4cdca$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $a66381b3d0f4cdca$var$Pg(h, f) : (f = $a66381b3d0f4cdca$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $a66381b3d0f4cdca$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $a66381b3d0f4cdca$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $a66381b3d0f4cdca$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $a66381b3d0f4cdca$var$qj(a, b) {
    b = $a66381b3d0f4cdca$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $a66381b3d0f4cdca$var$sj(a, b, c, d) {
    null !== d && $a66381b3d0f4cdca$var$Jg(d);
    $a66381b3d0f4cdca$var$Ug(b, a.child, null, c);
    a = $a66381b3d0f4cdca$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $a66381b3d0f4cdca$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $a66381b3d0f4cdca$var$Ki(Error($a66381b3d0f4cdca$var$p(422))), $a66381b3d0f4cdca$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $a66381b3d0f4cdca$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $a66381b3d0f4cdca$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $a66381b3d0f4cdca$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $a66381b3d0f4cdca$var$nj(g);
        b.memoizedState = $a66381b3d0f4cdca$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $a66381b3d0f4cdca$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($a66381b3d0f4cdca$var$p(419));
        d = $a66381b3d0f4cdca$var$Ki(f, d, void 0);
        return $a66381b3d0f4cdca$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($a66381b3d0f4cdca$var$dh || h) {
        d = $a66381b3d0f4cdca$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $a66381b3d0f4cdca$var$ih(a, e), $a66381b3d0f4cdca$var$gi(d, a, e, -1));
        }
        $a66381b3d0f4cdca$var$tj();
        d = $a66381b3d0f4cdca$var$Ki(Error($a66381b3d0f4cdca$var$p(421)));
        return $a66381b3d0f4cdca$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $a66381b3d0f4cdca$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $a66381b3d0f4cdca$var$yg = $a66381b3d0f4cdca$var$Lf(e.nextSibling);
    $a66381b3d0f4cdca$var$xg = b;
    $a66381b3d0f4cdca$var$I = !0;
    $a66381b3d0f4cdca$var$zg = null;
    null !== a && ($a66381b3d0f4cdca$var$og[$a66381b3d0f4cdca$var$pg++] = $a66381b3d0f4cdca$var$rg, $a66381b3d0f4cdca$var$og[$a66381b3d0f4cdca$var$pg++] = $a66381b3d0f4cdca$var$sg, $a66381b3d0f4cdca$var$og[$a66381b3d0f4cdca$var$pg++] = $a66381b3d0f4cdca$var$qg, $a66381b3d0f4cdca$var$rg = a.id, $a66381b3d0f4cdca$var$sg = a.overflow, $a66381b3d0f4cdca$var$qg = b);
    b = $a66381b3d0f4cdca$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $a66381b3d0f4cdca$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $a66381b3d0f4cdca$var$bh(a.return, b, c);
}
function $a66381b3d0f4cdca$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $a66381b3d0f4cdca$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $a66381b3d0f4cdca$var$Xi(a, b, d.children, c);
    d = $a66381b3d0f4cdca$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $a66381b3d0f4cdca$var$vj(a, c, b);
            else if (19 === a.tag) $a66381b3d0f4cdca$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $a66381b3d0f4cdca$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $a66381b3d0f4cdca$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $a66381b3d0f4cdca$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $a66381b3d0f4cdca$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $a66381b3d0f4cdca$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $a66381b3d0f4cdca$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $a66381b3d0f4cdca$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $a66381b3d0f4cdca$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($a66381b3d0f4cdca$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $a66381b3d0f4cdca$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $a66381b3d0f4cdca$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $a66381b3d0f4cdca$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $a66381b3d0f4cdca$var$kj(b);
            $a66381b3d0f4cdca$var$Ig();
            break;
        case 5:
            $a66381b3d0f4cdca$var$Ah(b);
            break;
        case 1:
            $a66381b3d0f4cdca$var$Zf(b.type) && $a66381b3d0f4cdca$var$cg(b);
            break;
        case 4:
            $a66381b3d0f4cdca$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$L, $a66381b3d0f4cdca$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $a66381b3d0f4cdca$var$oj(a, b, c);
                $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$L, $a66381b3d0f4cdca$var$L.current & 1);
                a = $a66381b3d0f4cdca$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$L, $a66381b3d0f4cdca$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $a66381b3d0f4cdca$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$L, $a66381b3d0f4cdca$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $a66381b3d0f4cdca$var$dj(a, b, c);
    }
    return $a66381b3d0f4cdca$var$Zi(a, b, c);
}
var $a66381b3d0f4cdca$var$zj, $a66381b3d0f4cdca$var$Aj, $a66381b3d0f4cdca$var$Bj, $a66381b3d0f4cdca$var$Cj;
$a66381b3d0f4cdca$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$a66381b3d0f4cdca$var$Aj = function() {};
$a66381b3d0f4cdca$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $a66381b3d0f4cdca$var$xh($a66381b3d0f4cdca$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $a66381b3d0f4cdca$var$Ya(a, e);
                d = $a66381b3d0f4cdca$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $a66381b3d0f4cdca$var$A({}, e, {
                    value: void 0
                });
                d = $a66381b3d0f4cdca$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $a66381b3d0f4cdca$var$gb(a, e);
                d = $a66381b3d0f4cdca$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $a66381b3d0f4cdca$var$Bf);
        }
        $a66381b3d0f4cdca$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($a66381b3d0f4cdca$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($a66381b3d0f4cdca$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $a66381b3d0f4cdca$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$a66381b3d0f4cdca$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $a66381b3d0f4cdca$var$Dj(a, b) {
    if (!$a66381b3d0f4cdca$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $a66381b3d0f4cdca$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $a66381b3d0f4cdca$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $a66381b3d0f4cdca$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $a66381b3d0f4cdca$var$S(b), null;
        case 1:
            return $a66381b3d0f4cdca$var$Zf(b.type) && $a66381b3d0f4cdca$var$$f(), $a66381b3d0f4cdca$var$S(b), null;
        case 3:
            d = b.stateNode;
            $a66381b3d0f4cdca$var$zh();
            $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$Wf);
            $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$H);
            $a66381b3d0f4cdca$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $a66381b3d0f4cdca$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $a66381b3d0f4cdca$var$zg && ($a66381b3d0f4cdca$var$Fj($a66381b3d0f4cdca$var$zg), $a66381b3d0f4cdca$var$zg = null));
            $a66381b3d0f4cdca$var$Aj(a, b);
            $a66381b3d0f4cdca$var$S(b);
            return null;
        case 5:
            $a66381b3d0f4cdca$var$Bh(b);
            var e = $a66381b3d0f4cdca$var$xh($a66381b3d0f4cdca$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $a66381b3d0f4cdca$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($a66381b3d0f4cdca$var$p(166));
                    $a66381b3d0f4cdca$var$S(b);
                    return null;
                }
                a = $a66381b3d0f4cdca$var$xh($a66381b3d0f4cdca$var$uh.current);
                if ($a66381b3d0f4cdca$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$a66381b3d0f4cdca$var$Of] = b;
                    d[$a66381b3d0f4cdca$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $a66381b3d0f4cdca$var$D("cancel", d);
                            $a66381b3d0f4cdca$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $a66381b3d0f4cdca$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $a66381b3d0f4cdca$var$lf.length; e++)$a66381b3d0f4cdca$var$D($a66381b3d0f4cdca$var$lf[e], d);
                            break;
                        case "source":
                            $a66381b3d0f4cdca$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $a66381b3d0f4cdca$var$D("error", d);
                            $a66381b3d0f4cdca$var$D("load", d);
                            break;
                        case "details":
                            $a66381b3d0f4cdca$var$D("toggle", d);
                            break;
                        case "input":
                            $a66381b3d0f4cdca$var$Za(d, f);
                            $a66381b3d0f4cdca$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $a66381b3d0f4cdca$var$D("invalid", d);
                            break;
                        case "textarea":
                            $a66381b3d0f4cdca$var$hb(d, f), $a66381b3d0f4cdca$var$D("invalid", d);
                    }
                    $a66381b3d0f4cdca$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $a66381b3d0f4cdca$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $a66381b3d0f4cdca$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $a66381b3d0f4cdca$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $a66381b3d0f4cdca$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $a66381b3d0f4cdca$var$Va(d);
                            $a66381b3d0f4cdca$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $a66381b3d0f4cdca$var$Va(d);
                            $a66381b3d0f4cdca$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $a66381b3d0f4cdca$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $a66381b3d0f4cdca$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$a66381b3d0f4cdca$var$Of] = b;
                    a[$a66381b3d0f4cdca$var$Pf] = d;
                    $a66381b3d0f4cdca$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $a66381b3d0f4cdca$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $a66381b3d0f4cdca$var$D("cancel", a);
                                $a66381b3d0f4cdca$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $a66381b3d0f4cdca$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $a66381b3d0f4cdca$var$lf.length; e++)$a66381b3d0f4cdca$var$D($a66381b3d0f4cdca$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $a66381b3d0f4cdca$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $a66381b3d0f4cdca$var$D("error", a);
                                $a66381b3d0f4cdca$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $a66381b3d0f4cdca$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $a66381b3d0f4cdca$var$Za(a, d);
                                e = $a66381b3d0f4cdca$var$Ya(a, d);
                                $a66381b3d0f4cdca$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $a66381b3d0f4cdca$var$A({}, d, {
                                    value: void 0
                                });
                                $a66381b3d0f4cdca$var$D("invalid", a);
                                break;
                            case "textarea":
                                $a66381b3d0f4cdca$var$hb(a, d);
                                e = $a66381b3d0f4cdca$var$gb(a, d);
                                $a66381b3d0f4cdca$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $a66381b3d0f4cdca$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $a66381b3d0f4cdca$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $a66381b3d0f4cdca$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $a66381b3d0f4cdca$var$ob(a, k) : "number" === typeof k && $a66381b3d0f4cdca$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($a66381b3d0f4cdca$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $a66381b3d0f4cdca$var$D("scroll", a) : null != k && $a66381b3d0f4cdca$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $a66381b3d0f4cdca$var$Va(a);
                                $a66381b3d0f4cdca$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $a66381b3d0f4cdca$var$Va(a);
                                $a66381b3d0f4cdca$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $a66381b3d0f4cdca$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $a66381b3d0f4cdca$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $a66381b3d0f4cdca$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $a66381b3d0f4cdca$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $a66381b3d0f4cdca$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $a66381b3d0f4cdca$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($a66381b3d0f4cdca$var$p(166));
                c = $a66381b3d0f4cdca$var$xh($a66381b3d0f4cdca$var$wh.current);
                $a66381b3d0f4cdca$var$xh($a66381b3d0f4cdca$var$uh.current);
                if ($a66381b3d0f4cdca$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$a66381b3d0f4cdca$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $a66381b3d0f4cdca$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $a66381b3d0f4cdca$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $a66381b3d0f4cdca$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$a66381b3d0f4cdca$var$Of] = b, b.stateNode = d;
            }
            $a66381b3d0f4cdca$var$S(b);
            return null;
        case 13:
            $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($a66381b3d0f4cdca$var$I && null !== $a66381b3d0f4cdca$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $a66381b3d0f4cdca$var$Hg(), $a66381b3d0f4cdca$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $a66381b3d0f4cdca$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($a66381b3d0f4cdca$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($a66381b3d0f4cdca$var$p(317));
                        f[$a66381b3d0f4cdca$var$Of] = b;
                    } else $a66381b3d0f4cdca$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $a66381b3d0f4cdca$var$S(b);
                    f = !1;
                } else null !== $a66381b3d0f4cdca$var$zg && ($a66381b3d0f4cdca$var$Fj($a66381b3d0f4cdca$var$zg), $a66381b3d0f4cdca$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($a66381b3d0f4cdca$var$L.current & 1) ? 0 === $a66381b3d0f4cdca$var$T && ($a66381b3d0f4cdca$var$T = 3) : $a66381b3d0f4cdca$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $a66381b3d0f4cdca$var$S(b);
            return null;
        case 4:
            return $a66381b3d0f4cdca$var$zh(), $a66381b3d0f4cdca$var$Aj(a, b), null === a && $a66381b3d0f4cdca$var$sf(b.stateNode.containerInfo), $a66381b3d0f4cdca$var$S(b), null;
        case 10:
            return $a66381b3d0f4cdca$var$ah(b.type._context), $a66381b3d0f4cdca$var$S(b), null;
        case 17:
            return $a66381b3d0f4cdca$var$Zf(b.type) && $a66381b3d0f4cdca$var$$f(), $a66381b3d0f4cdca$var$S(b), null;
        case 19:
            $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$L);
            f = b.memoizedState;
            if (null === f) return $a66381b3d0f4cdca$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $a66381b3d0f4cdca$var$Dj(f, !1);
                else {
                    if (0 !== $a66381b3d0f4cdca$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $a66381b3d0f4cdca$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $a66381b3d0f4cdca$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$L, $a66381b3d0f4cdca$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $a66381b3d0f4cdca$var$B() > $a66381b3d0f4cdca$var$Gj && (b.flags |= 128, d = !0, $a66381b3d0f4cdca$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $a66381b3d0f4cdca$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $a66381b3d0f4cdca$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$a66381b3d0f4cdca$var$I) return $a66381b3d0f4cdca$var$S(b), null;
                    } else 2 * $a66381b3d0f4cdca$var$B() - f.renderingStartTime > $a66381b3d0f4cdca$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $a66381b3d0f4cdca$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $a66381b3d0f4cdca$var$B(), b.sibling = null, c = $a66381b3d0f4cdca$var$L.current, $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$L, d ? c & 1 | 2 : c & 1), b;
            $a66381b3d0f4cdca$var$S(b);
            return null;
        case 22:
        case 23:
            return $a66381b3d0f4cdca$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($a66381b3d0f4cdca$var$fj & 1073741824) && ($a66381b3d0f4cdca$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $a66381b3d0f4cdca$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($a66381b3d0f4cdca$var$p(156, b.tag));
}
function $a66381b3d0f4cdca$var$Ij(a, b) {
    $a66381b3d0f4cdca$var$wg(b);
    switch(b.tag){
        case 1:
            return $a66381b3d0f4cdca$var$Zf(b.type) && $a66381b3d0f4cdca$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $a66381b3d0f4cdca$var$zh(), $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$Wf), $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$H), $a66381b3d0f4cdca$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $a66381b3d0f4cdca$var$Bh(b), null;
        case 13:
            $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($a66381b3d0f4cdca$var$p(340));
                $a66381b3d0f4cdca$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$L), null;
        case 4:
            return $a66381b3d0f4cdca$var$zh(), null;
        case 10:
            return $a66381b3d0f4cdca$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $a66381b3d0f4cdca$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $a66381b3d0f4cdca$var$Jj = !1, $a66381b3d0f4cdca$var$U = !1, $a66381b3d0f4cdca$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $a66381b3d0f4cdca$var$V = null;
function $a66381b3d0f4cdca$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $a66381b3d0f4cdca$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $a66381b3d0f4cdca$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $a66381b3d0f4cdca$var$W(a, b, d);
    }
}
var $a66381b3d0f4cdca$var$Nj = !1;
function $a66381b3d0f4cdca$var$Oj(a, b) {
    $a66381b3d0f4cdca$var$Cf = $a66381b3d0f4cdca$var$dd;
    a = $a66381b3d0f4cdca$var$Me();
    if ($a66381b3d0f4cdca$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $a66381b3d0f4cdca$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $a66381b3d0f4cdca$var$dd = !1;
    for($a66381b3d0f4cdca$var$V = b; null !== $a66381b3d0f4cdca$var$V;)if (b = $a66381b3d0f4cdca$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $a66381b3d0f4cdca$var$V = a;
    else for(; null !== $a66381b3d0f4cdca$var$V;){
        b = $a66381b3d0f4cdca$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $a66381b3d0f4cdca$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($a66381b3d0f4cdca$var$p(163));
            }
        } catch (F) {
            $a66381b3d0f4cdca$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $a66381b3d0f4cdca$var$V = a;
            break;
        }
        $a66381b3d0f4cdca$var$V = b.return;
    }
    n = $a66381b3d0f4cdca$var$Nj;
    $a66381b3d0f4cdca$var$Nj = !1;
    return n;
}
function $a66381b3d0f4cdca$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $a66381b3d0f4cdca$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $a66381b3d0f4cdca$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $a66381b3d0f4cdca$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $a66381b3d0f4cdca$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $a66381b3d0f4cdca$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$a66381b3d0f4cdca$var$Of], delete b[$a66381b3d0f4cdca$var$Pf], delete b[$a66381b3d0f4cdca$var$of], delete b[$a66381b3d0f4cdca$var$Qf], delete b[$a66381b3d0f4cdca$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $a66381b3d0f4cdca$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $a66381b3d0f4cdca$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $a66381b3d0f4cdca$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $a66381b3d0f4cdca$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $a66381b3d0f4cdca$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($a66381b3d0f4cdca$var$Vj(a, b, c), a = a.sibling; null !== a;)$a66381b3d0f4cdca$var$Vj(a, b, c), a = a.sibling;
}
function $a66381b3d0f4cdca$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($a66381b3d0f4cdca$var$Wj(a, b, c), a = a.sibling; null !== a;)$a66381b3d0f4cdca$var$Wj(a, b, c), a = a.sibling;
}
var $a66381b3d0f4cdca$var$X = null, $a66381b3d0f4cdca$var$Xj = !1;
function $a66381b3d0f4cdca$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$a66381b3d0f4cdca$var$Zj(a, b, c), c = c.sibling;
}
function $a66381b3d0f4cdca$var$Zj(a, b, c) {
    if ($a66381b3d0f4cdca$var$lc && "function" === typeof $a66381b3d0f4cdca$var$lc.onCommitFiberUnmount) try {
        $a66381b3d0f4cdca$var$lc.onCommitFiberUnmount($a66381b3d0f4cdca$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $a66381b3d0f4cdca$var$U || $a66381b3d0f4cdca$var$Lj(c, b);
        case 6:
            var d = $a66381b3d0f4cdca$var$X, e = $a66381b3d0f4cdca$var$Xj;
            $a66381b3d0f4cdca$var$X = null;
            $a66381b3d0f4cdca$var$Yj(a, b, c);
            $a66381b3d0f4cdca$var$X = d;
            $a66381b3d0f4cdca$var$Xj = e;
            null !== $a66381b3d0f4cdca$var$X && ($a66381b3d0f4cdca$var$Xj ? (a = $a66381b3d0f4cdca$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $a66381b3d0f4cdca$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $a66381b3d0f4cdca$var$X && ($a66381b3d0f4cdca$var$Xj ? (a = $a66381b3d0f4cdca$var$X, c = c.stateNode, 8 === a.nodeType ? $a66381b3d0f4cdca$var$Kf(a.parentNode, c) : 1 === a.nodeType && $a66381b3d0f4cdca$var$Kf(a, c), $a66381b3d0f4cdca$var$bd(a)) : $a66381b3d0f4cdca$var$Kf($a66381b3d0f4cdca$var$X, c.stateNode));
            break;
        case 4:
            d = $a66381b3d0f4cdca$var$X;
            e = $a66381b3d0f4cdca$var$Xj;
            $a66381b3d0f4cdca$var$X = c.stateNode.containerInfo;
            $a66381b3d0f4cdca$var$Xj = !0;
            $a66381b3d0f4cdca$var$Yj(a, b, c);
            $a66381b3d0f4cdca$var$X = d;
            $a66381b3d0f4cdca$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$a66381b3d0f4cdca$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $a66381b3d0f4cdca$var$Mj(c, b, g) : 0 !== (f & 4) && $a66381b3d0f4cdca$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $a66381b3d0f4cdca$var$Yj(a, b, c);
            break;
        case 1:
            if (!$a66381b3d0f4cdca$var$U && ($a66381b3d0f4cdca$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $a66381b3d0f4cdca$var$W(c, b, h);
            }
            $a66381b3d0f4cdca$var$Yj(a, b, c);
            break;
        case 21:
            $a66381b3d0f4cdca$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($a66381b3d0f4cdca$var$U = (d = $a66381b3d0f4cdca$var$U) || null !== c.memoizedState, $a66381b3d0f4cdca$var$Yj(a, b, c), $a66381b3d0f4cdca$var$U = d) : $a66381b3d0f4cdca$var$Yj(a, b, c);
            break;
        default:
            $a66381b3d0f4cdca$var$Yj(a, b, c);
    }
}
function $a66381b3d0f4cdca$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $a66381b3d0f4cdca$var$Kj);
        b.forEach(function(b) {
            var d = $a66381b3d0f4cdca$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $a66381b3d0f4cdca$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $a66381b3d0f4cdca$var$X = h.stateNode;
                        $a66381b3d0f4cdca$var$Xj = !1;
                        break a;
                    case 3:
                        $a66381b3d0f4cdca$var$X = h.stateNode.containerInfo;
                        $a66381b3d0f4cdca$var$Xj = !0;
                        break a;
                    case 4:
                        $a66381b3d0f4cdca$var$X = h.stateNode.containerInfo;
                        $a66381b3d0f4cdca$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $a66381b3d0f4cdca$var$X) throw Error($a66381b3d0f4cdca$var$p(160));
            $a66381b3d0f4cdca$var$Zj(f, g, e);
            $a66381b3d0f4cdca$var$X = null;
            $a66381b3d0f4cdca$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $a66381b3d0f4cdca$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$a66381b3d0f4cdca$var$dk(b, a), b = b.sibling;
}
function $a66381b3d0f4cdca$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $a66381b3d0f4cdca$var$ck(b, a);
            $a66381b3d0f4cdca$var$ek(a);
            if (d & 4) {
                try {
                    $a66381b3d0f4cdca$var$Pj(3, a, a.return), $a66381b3d0f4cdca$var$Qj(3, a);
                } catch (t) {
                    $a66381b3d0f4cdca$var$W(a, a.return, t);
                }
                try {
                    $a66381b3d0f4cdca$var$Pj(5, a, a.return);
                } catch (t) {
                    $a66381b3d0f4cdca$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $a66381b3d0f4cdca$var$ck(b, a);
            $a66381b3d0f4cdca$var$ek(a);
            d & 512 && null !== c && $a66381b3d0f4cdca$var$Lj(c, c.return);
            break;
        case 5:
            $a66381b3d0f4cdca$var$ck(b, a);
            $a66381b3d0f4cdca$var$ek(a);
            d & 512 && null !== c && $a66381b3d0f4cdca$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $a66381b3d0f4cdca$var$ob(e, "");
                } catch (t) {
                    $a66381b3d0f4cdca$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $a66381b3d0f4cdca$var$ab(e, f);
                    $a66381b3d0f4cdca$var$vb(h, g);
                    var l = $a66381b3d0f4cdca$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $a66381b3d0f4cdca$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $a66381b3d0f4cdca$var$nb(e, q) : "children" === m ? $a66381b3d0f4cdca$var$ob(e, q) : $a66381b3d0f4cdca$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $a66381b3d0f4cdca$var$bb(e, f);
                            break;
                        case "textarea":
                            $a66381b3d0f4cdca$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $a66381b3d0f4cdca$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $a66381b3d0f4cdca$var$fb(e, !!f.multiple, f.defaultValue, !0) : $a66381b3d0f4cdca$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$a66381b3d0f4cdca$var$Pf] = f;
                } catch (t) {
                    $a66381b3d0f4cdca$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $a66381b3d0f4cdca$var$ck(b, a);
            $a66381b3d0f4cdca$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($a66381b3d0f4cdca$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $a66381b3d0f4cdca$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $a66381b3d0f4cdca$var$ck(b, a);
            $a66381b3d0f4cdca$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $a66381b3d0f4cdca$var$bd(b.containerInfo);
            } catch (t) {
                $a66381b3d0f4cdca$var$W(a, a.return, t);
            }
            break;
        case 4:
            $a66381b3d0f4cdca$var$ck(b, a);
            $a66381b3d0f4cdca$var$ek(a);
            break;
        case 13:
            $a66381b3d0f4cdca$var$ck(b, a);
            $a66381b3d0f4cdca$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($a66381b3d0f4cdca$var$fk = $a66381b3d0f4cdca$var$B()));
            d & 4 && $a66381b3d0f4cdca$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($a66381b3d0f4cdca$var$U = (l = $a66381b3d0f4cdca$var$U) || m, $a66381b3d0f4cdca$var$ck(b, a), $a66381b3d0f4cdca$var$U = l) : $a66381b3d0f4cdca$var$ck(b, a);
            $a66381b3d0f4cdca$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($a66381b3d0f4cdca$var$V = a, m = a.child; null !== m;){
                    for(q = $a66381b3d0f4cdca$var$V = m; null !== $a66381b3d0f4cdca$var$V;){
                        r = $a66381b3d0f4cdca$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $a66381b3d0f4cdca$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $a66381b3d0f4cdca$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $a66381b3d0f4cdca$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $a66381b3d0f4cdca$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $a66381b3d0f4cdca$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $a66381b3d0f4cdca$var$V = y) : $a66381b3d0f4cdca$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $a66381b3d0f4cdca$var$rb("display", g));
                            } catch (t) {
                                $a66381b3d0f4cdca$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $a66381b3d0f4cdca$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $a66381b3d0f4cdca$var$ck(b, a);
            $a66381b3d0f4cdca$var$ek(a);
            d & 4 && $a66381b3d0f4cdca$var$ak(a);
            break;
        case 21:
            break;
        default:
            $a66381b3d0f4cdca$var$ck(b, a), $a66381b3d0f4cdca$var$ek(a);
    }
}
function $a66381b3d0f4cdca$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($a66381b3d0f4cdca$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($a66381b3d0f4cdca$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($a66381b3d0f4cdca$var$ob(e, ""), d.flags &= -33);
                    var f = $a66381b3d0f4cdca$var$Uj(a);
                    $a66381b3d0f4cdca$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $a66381b3d0f4cdca$var$Uj(a);
                    $a66381b3d0f4cdca$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($a66381b3d0f4cdca$var$p(161));
            }
        } catch (k) {
            $a66381b3d0f4cdca$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $a66381b3d0f4cdca$var$hk(a, b, c) {
    $a66381b3d0f4cdca$var$V = a;
    $a66381b3d0f4cdca$var$ik(a, b, c);
}
function $a66381b3d0f4cdca$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $a66381b3d0f4cdca$var$V;){
        var e = $a66381b3d0f4cdca$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $a66381b3d0f4cdca$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $a66381b3d0f4cdca$var$U;
                h = $a66381b3d0f4cdca$var$Jj;
                var l = $a66381b3d0f4cdca$var$U;
                $a66381b3d0f4cdca$var$Jj = g;
                if (($a66381b3d0f4cdca$var$U = k) && !l) for($a66381b3d0f4cdca$var$V = e; null !== $a66381b3d0f4cdca$var$V;)g = $a66381b3d0f4cdca$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $a66381b3d0f4cdca$var$jk(e) : null !== k ? (k.return = g, $a66381b3d0f4cdca$var$V = k) : $a66381b3d0f4cdca$var$jk(e);
                for(; null !== f;)$a66381b3d0f4cdca$var$V = f, $a66381b3d0f4cdca$var$ik(f, b, c), f = f.sibling;
                $a66381b3d0f4cdca$var$V = e;
                $a66381b3d0f4cdca$var$Jj = h;
                $a66381b3d0f4cdca$var$U = l;
            }
            $a66381b3d0f4cdca$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $a66381b3d0f4cdca$var$V = f) : $a66381b3d0f4cdca$var$kk(a, b, c);
    }
}
function $a66381b3d0f4cdca$var$kk(a) {
    for(; null !== $a66381b3d0f4cdca$var$V;){
        var b = $a66381b3d0f4cdca$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $a66381b3d0f4cdca$var$U || $a66381b3d0f4cdca$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$a66381b3d0f4cdca$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $a66381b3d0f4cdca$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $a66381b3d0f4cdca$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $a66381b3d0f4cdca$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $a66381b3d0f4cdca$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($a66381b3d0f4cdca$var$p(163));
                }
                $a66381b3d0f4cdca$var$U || b.flags & 512 && $a66381b3d0f4cdca$var$Rj(b);
            } catch (r) {
                $a66381b3d0f4cdca$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $a66381b3d0f4cdca$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $a66381b3d0f4cdca$var$V = c;
            break;
        }
        $a66381b3d0f4cdca$var$V = b.return;
    }
}
function $a66381b3d0f4cdca$var$gk(a) {
    for(; null !== $a66381b3d0f4cdca$var$V;){
        var b = $a66381b3d0f4cdca$var$V;
        if (b === a) {
            $a66381b3d0f4cdca$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $a66381b3d0f4cdca$var$V = c;
            break;
        }
        $a66381b3d0f4cdca$var$V = b.return;
    }
}
function $a66381b3d0f4cdca$var$jk(a) {
    for(; null !== $a66381b3d0f4cdca$var$V;){
        var b = $a66381b3d0f4cdca$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $a66381b3d0f4cdca$var$Qj(4, b);
                    } catch (k) {
                        $a66381b3d0f4cdca$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $a66381b3d0f4cdca$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $a66381b3d0f4cdca$var$Rj(b);
                    } catch (k) {
                        $a66381b3d0f4cdca$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $a66381b3d0f4cdca$var$Rj(b);
                    } catch (k) {
                        $a66381b3d0f4cdca$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $a66381b3d0f4cdca$var$W(b, b.return, k);
        }
        if (b === a) {
            $a66381b3d0f4cdca$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $a66381b3d0f4cdca$var$V = h;
            break;
        }
        $a66381b3d0f4cdca$var$V = b.return;
    }
}
var $a66381b3d0f4cdca$var$lk = Math.ceil, $a66381b3d0f4cdca$var$mk = $a66381b3d0f4cdca$var$ua.ReactCurrentDispatcher, $a66381b3d0f4cdca$var$nk = $a66381b3d0f4cdca$var$ua.ReactCurrentOwner, $a66381b3d0f4cdca$var$ok = $a66381b3d0f4cdca$var$ua.ReactCurrentBatchConfig, $a66381b3d0f4cdca$var$K = 0, $a66381b3d0f4cdca$var$Q = null, $a66381b3d0f4cdca$var$Y = null, $a66381b3d0f4cdca$var$Z = 0, $a66381b3d0f4cdca$var$fj = 0, $a66381b3d0f4cdca$var$ej = $a66381b3d0f4cdca$var$Uf(0), $a66381b3d0f4cdca$var$T = 0, $a66381b3d0f4cdca$var$pk = null, $a66381b3d0f4cdca$var$rh = 0, $a66381b3d0f4cdca$var$qk = 0, $a66381b3d0f4cdca$var$rk = 0, $a66381b3d0f4cdca$var$sk = null, $a66381b3d0f4cdca$var$tk = null, $a66381b3d0f4cdca$var$fk = 0, $a66381b3d0f4cdca$var$Gj = Infinity, $a66381b3d0f4cdca$var$uk = null, $a66381b3d0f4cdca$var$Oi = !1, $a66381b3d0f4cdca$var$Pi = null, $a66381b3d0f4cdca$var$Ri = null, $a66381b3d0f4cdca$var$vk = !1, $a66381b3d0f4cdca$var$wk = null, $a66381b3d0f4cdca$var$xk = 0, $a66381b3d0f4cdca$var$yk = 0, $a66381b3d0f4cdca$var$zk = null, $a66381b3d0f4cdca$var$Ak = -1, $a66381b3d0f4cdca$var$Bk = 0;
function $a66381b3d0f4cdca$var$R() {
    return 0 !== ($a66381b3d0f4cdca$var$K & 6) ? $a66381b3d0f4cdca$var$B() : -1 !== $a66381b3d0f4cdca$var$Ak ? $a66381b3d0f4cdca$var$Ak : $a66381b3d0f4cdca$var$Ak = $a66381b3d0f4cdca$var$B();
}
function $a66381b3d0f4cdca$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($a66381b3d0f4cdca$var$K & 2) && 0 !== $a66381b3d0f4cdca$var$Z) return $a66381b3d0f4cdca$var$Z & -$a66381b3d0f4cdca$var$Z;
    if (null !== $a66381b3d0f4cdca$var$Kg.transition) return 0 === $a66381b3d0f4cdca$var$Bk && ($a66381b3d0f4cdca$var$Bk = $a66381b3d0f4cdca$var$yc()), $a66381b3d0f4cdca$var$Bk;
    a = $a66381b3d0f4cdca$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $a66381b3d0f4cdca$var$jd(a.type);
    return a;
}
function $a66381b3d0f4cdca$var$gi(a, b, c, d) {
    if (50 < $a66381b3d0f4cdca$var$yk) throw $a66381b3d0f4cdca$var$yk = 0, $a66381b3d0f4cdca$var$zk = null, Error($a66381b3d0f4cdca$var$p(185));
    $a66381b3d0f4cdca$var$Ac(a, c, d);
    if (0 === ($a66381b3d0f4cdca$var$K & 2) || a !== $a66381b3d0f4cdca$var$Q) a === $a66381b3d0f4cdca$var$Q && (0 === ($a66381b3d0f4cdca$var$K & 2) && ($a66381b3d0f4cdca$var$qk |= c), 4 === $a66381b3d0f4cdca$var$T && $a66381b3d0f4cdca$var$Ck(a, $a66381b3d0f4cdca$var$Z)), $a66381b3d0f4cdca$var$Dk(a, d), 1 === c && 0 === $a66381b3d0f4cdca$var$K && 0 === (b.mode & 1) && ($a66381b3d0f4cdca$var$Gj = $a66381b3d0f4cdca$var$B() + 500, $a66381b3d0f4cdca$var$fg && $a66381b3d0f4cdca$var$jg());
}
function $a66381b3d0f4cdca$var$Dk(a, b) {
    var c = a.callbackNode;
    $a66381b3d0f4cdca$var$wc(a, b);
    var d = $a66381b3d0f4cdca$var$uc(a, a === $a66381b3d0f4cdca$var$Q ? $a66381b3d0f4cdca$var$Z : 0);
    if (0 === d) null !== c && $a66381b3d0f4cdca$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $a66381b3d0f4cdca$var$bc(c);
        if (1 === b) 0 === a.tag ? $a66381b3d0f4cdca$var$ig($a66381b3d0f4cdca$var$Ek.bind(null, a)) : $a66381b3d0f4cdca$var$hg($a66381b3d0f4cdca$var$Ek.bind(null, a)), $a66381b3d0f4cdca$var$Jf(function() {
            0 === ($a66381b3d0f4cdca$var$K & 6) && $a66381b3d0f4cdca$var$jg();
        }), c = null;
        else {
            switch($a66381b3d0f4cdca$var$Dc(d)){
                case 1:
                    c = $a66381b3d0f4cdca$var$fc;
                    break;
                case 4:
                    c = $a66381b3d0f4cdca$var$gc;
                    break;
                case 16:
                    c = $a66381b3d0f4cdca$var$hc;
                    break;
                case 536870912:
                    c = $a66381b3d0f4cdca$var$jc;
                    break;
                default:
                    c = $a66381b3d0f4cdca$var$hc;
            }
            c = $a66381b3d0f4cdca$var$Fk(c, $a66381b3d0f4cdca$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $a66381b3d0f4cdca$var$Gk(a, b) {
    $a66381b3d0f4cdca$var$Ak = -1;
    $a66381b3d0f4cdca$var$Bk = 0;
    if (0 !== ($a66381b3d0f4cdca$var$K & 6)) throw Error($a66381b3d0f4cdca$var$p(327));
    var c = a.callbackNode;
    if ($a66381b3d0f4cdca$var$Hk() && a.callbackNode !== c) return null;
    var d = $a66381b3d0f4cdca$var$uc(a, a === $a66381b3d0f4cdca$var$Q ? $a66381b3d0f4cdca$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $a66381b3d0f4cdca$var$Ik(a, d);
    else {
        b = d;
        var e = $a66381b3d0f4cdca$var$K;
        $a66381b3d0f4cdca$var$K |= 2;
        var f = $a66381b3d0f4cdca$var$Jk();
        if ($a66381b3d0f4cdca$var$Q !== a || $a66381b3d0f4cdca$var$Z !== b) $a66381b3d0f4cdca$var$uk = null, $a66381b3d0f4cdca$var$Gj = $a66381b3d0f4cdca$var$B() + 500, $a66381b3d0f4cdca$var$Kk(a, b);
        for(;;)try {
            $a66381b3d0f4cdca$var$Lk();
            break;
        } catch (h) {
            $a66381b3d0f4cdca$var$Mk(a, h);
        }
        $a66381b3d0f4cdca$var$$g();
        $a66381b3d0f4cdca$var$mk.current = f;
        $a66381b3d0f4cdca$var$K = e;
        null !== $a66381b3d0f4cdca$var$Y ? b = 0 : ($a66381b3d0f4cdca$var$Q = null, $a66381b3d0f4cdca$var$Z = 0, b = $a66381b3d0f4cdca$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $a66381b3d0f4cdca$var$xc(a), 0 !== e && (d = e, b = $a66381b3d0f4cdca$var$Nk(a, e)));
        if (1 === b) throw c = $a66381b3d0f4cdca$var$pk, $a66381b3d0f4cdca$var$Kk(a, 0), $a66381b3d0f4cdca$var$Ck(a, d), $a66381b3d0f4cdca$var$Dk(a, $a66381b3d0f4cdca$var$B()), c;
        if (6 === b) $a66381b3d0f4cdca$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$a66381b3d0f4cdca$var$Ok(e) && (b = $a66381b3d0f4cdca$var$Ik(a, d), 2 === b && (f = $a66381b3d0f4cdca$var$xc(a), 0 !== f && (d = f, b = $a66381b3d0f4cdca$var$Nk(a, f))), 1 === b)) throw c = $a66381b3d0f4cdca$var$pk, $a66381b3d0f4cdca$var$Kk(a, 0), $a66381b3d0f4cdca$var$Ck(a, d), $a66381b3d0f4cdca$var$Dk(a, $a66381b3d0f4cdca$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($a66381b3d0f4cdca$var$p(345));
                case 2:
                    $a66381b3d0f4cdca$var$Pk(a, $a66381b3d0f4cdca$var$tk, $a66381b3d0f4cdca$var$uk);
                    break;
                case 3:
                    $a66381b3d0f4cdca$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $a66381b3d0f4cdca$var$fk + 500 - $a66381b3d0f4cdca$var$B(), 10 < b)) {
                        if (0 !== $a66381b3d0f4cdca$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $a66381b3d0f4cdca$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $a66381b3d0f4cdca$var$Ff($a66381b3d0f4cdca$var$Pk.bind(null, a, $a66381b3d0f4cdca$var$tk, $a66381b3d0f4cdca$var$uk), b);
                        break;
                    }
                    $a66381b3d0f4cdca$var$Pk(a, $a66381b3d0f4cdca$var$tk, $a66381b3d0f4cdca$var$uk);
                    break;
                case 4:
                    $a66381b3d0f4cdca$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $a66381b3d0f4cdca$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $a66381b3d0f4cdca$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $a66381b3d0f4cdca$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $a66381b3d0f4cdca$var$Ff($a66381b3d0f4cdca$var$Pk.bind(null, a, $a66381b3d0f4cdca$var$tk, $a66381b3d0f4cdca$var$uk), d);
                        break;
                    }
                    $a66381b3d0f4cdca$var$Pk(a, $a66381b3d0f4cdca$var$tk, $a66381b3d0f4cdca$var$uk);
                    break;
                case 5:
                    $a66381b3d0f4cdca$var$Pk(a, $a66381b3d0f4cdca$var$tk, $a66381b3d0f4cdca$var$uk);
                    break;
                default:
                    throw Error($a66381b3d0f4cdca$var$p(329));
            }
        }
    }
    $a66381b3d0f4cdca$var$Dk(a, $a66381b3d0f4cdca$var$B());
    return a.callbackNode === c ? $a66381b3d0f4cdca$var$Gk.bind(null, a) : null;
}
function $a66381b3d0f4cdca$var$Nk(a, b) {
    var c = $a66381b3d0f4cdca$var$sk;
    a.current.memoizedState.isDehydrated && ($a66381b3d0f4cdca$var$Kk(a, b).flags |= 256);
    a = $a66381b3d0f4cdca$var$Ik(a, b);
    2 !== a && (b = $a66381b3d0f4cdca$var$tk, $a66381b3d0f4cdca$var$tk = c, null !== b && $a66381b3d0f4cdca$var$Fj(b));
    return a;
}
function $a66381b3d0f4cdca$var$Fj(a) {
    null === $a66381b3d0f4cdca$var$tk ? $a66381b3d0f4cdca$var$tk = a : $a66381b3d0f4cdca$var$tk.push.apply($a66381b3d0f4cdca$var$tk, a);
}
function $a66381b3d0f4cdca$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$a66381b3d0f4cdca$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $a66381b3d0f4cdca$var$Ck(a, b) {
    b &= ~$a66381b3d0f4cdca$var$rk;
    b &= ~$a66381b3d0f4cdca$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $a66381b3d0f4cdca$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $a66381b3d0f4cdca$var$Ek(a) {
    if (0 !== ($a66381b3d0f4cdca$var$K & 6)) throw Error($a66381b3d0f4cdca$var$p(327));
    $a66381b3d0f4cdca$var$Hk();
    var b = $a66381b3d0f4cdca$var$uc(a, 0);
    if (0 === (b & 1)) return $a66381b3d0f4cdca$var$Dk(a, $a66381b3d0f4cdca$var$B()), null;
    var c = $a66381b3d0f4cdca$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $a66381b3d0f4cdca$var$xc(a);
        0 !== d && (b = d, c = $a66381b3d0f4cdca$var$Nk(a, d));
    }
    if (1 === c) throw c = $a66381b3d0f4cdca$var$pk, $a66381b3d0f4cdca$var$Kk(a, 0), $a66381b3d0f4cdca$var$Ck(a, b), $a66381b3d0f4cdca$var$Dk(a, $a66381b3d0f4cdca$var$B()), c;
    if (6 === c) throw Error($a66381b3d0f4cdca$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $a66381b3d0f4cdca$var$Pk(a, $a66381b3d0f4cdca$var$tk, $a66381b3d0f4cdca$var$uk);
    $a66381b3d0f4cdca$var$Dk(a, $a66381b3d0f4cdca$var$B());
    return null;
}
function $a66381b3d0f4cdca$var$Qk(a, b) {
    var c = $a66381b3d0f4cdca$var$K;
    $a66381b3d0f4cdca$var$K |= 1;
    try {
        return a(b);
    } finally{
        $a66381b3d0f4cdca$var$K = c, 0 === $a66381b3d0f4cdca$var$K && ($a66381b3d0f4cdca$var$Gj = $a66381b3d0f4cdca$var$B() + 500, $a66381b3d0f4cdca$var$fg && $a66381b3d0f4cdca$var$jg());
    }
}
function $a66381b3d0f4cdca$var$Rk(a) {
    null !== $a66381b3d0f4cdca$var$wk && 0 === $a66381b3d0f4cdca$var$wk.tag && 0 === ($a66381b3d0f4cdca$var$K & 6) && $a66381b3d0f4cdca$var$Hk();
    var b = $a66381b3d0f4cdca$var$K;
    $a66381b3d0f4cdca$var$K |= 1;
    var c = $a66381b3d0f4cdca$var$ok.transition, d = $a66381b3d0f4cdca$var$C;
    try {
        if ($a66381b3d0f4cdca$var$ok.transition = null, $a66381b3d0f4cdca$var$C = 1, a) return a();
    } finally{
        $a66381b3d0f4cdca$var$C = d, $a66381b3d0f4cdca$var$ok.transition = c, $a66381b3d0f4cdca$var$K = b, 0 === ($a66381b3d0f4cdca$var$K & 6) && $a66381b3d0f4cdca$var$jg();
    }
}
function $a66381b3d0f4cdca$var$Hj() {
    $a66381b3d0f4cdca$var$fj = $a66381b3d0f4cdca$var$ej.current;
    $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$ej);
}
function $a66381b3d0f4cdca$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $a66381b3d0f4cdca$var$Gf(c));
    if (null !== $a66381b3d0f4cdca$var$Y) for(c = $a66381b3d0f4cdca$var$Y.return; null !== c;){
        var d = c;
        $a66381b3d0f4cdca$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $a66381b3d0f4cdca$var$$f();
                break;
            case 3:
                $a66381b3d0f4cdca$var$zh();
                $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$Wf);
                $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$H);
                $a66381b3d0f4cdca$var$Eh();
                break;
            case 5:
                $a66381b3d0f4cdca$var$Bh(d);
                break;
            case 4:
                $a66381b3d0f4cdca$var$zh();
                break;
            case 13:
                $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$L);
                break;
            case 19:
                $a66381b3d0f4cdca$var$E($a66381b3d0f4cdca$var$L);
                break;
            case 10:
                $a66381b3d0f4cdca$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $a66381b3d0f4cdca$var$Hj();
        }
        c = c.return;
    }
    $a66381b3d0f4cdca$var$Q = a;
    $a66381b3d0f4cdca$var$Y = a = $a66381b3d0f4cdca$var$Pg(a.current, null);
    $a66381b3d0f4cdca$var$Z = $a66381b3d0f4cdca$var$fj = b;
    $a66381b3d0f4cdca$var$T = 0;
    $a66381b3d0f4cdca$var$pk = null;
    $a66381b3d0f4cdca$var$rk = $a66381b3d0f4cdca$var$qk = $a66381b3d0f4cdca$var$rh = 0;
    $a66381b3d0f4cdca$var$tk = $a66381b3d0f4cdca$var$sk = null;
    if (null !== $a66381b3d0f4cdca$var$fh) {
        for(b = 0; b < $a66381b3d0f4cdca$var$fh.length; b++)if (c = $a66381b3d0f4cdca$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $a66381b3d0f4cdca$var$fh = null;
    }
    return a;
}
function $a66381b3d0f4cdca$var$Mk(a, b) {
    do {
        var c = $a66381b3d0f4cdca$var$Y;
        try {
            $a66381b3d0f4cdca$var$$g();
            $a66381b3d0f4cdca$var$Fh.current = $a66381b3d0f4cdca$var$Rh;
            if ($a66381b3d0f4cdca$var$Ih) {
                for(var d = $a66381b3d0f4cdca$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $a66381b3d0f4cdca$var$Ih = !1;
            }
            $a66381b3d0f4cdca$var$Hh = 0;
            $a66381b3d0f4cdca$var$O = $a66381b3d0f4cdca$var$N = $a66381b3d0f4cdca$var$M = null;
            $a66381b3d0f4cdca$var$Jh = !1;
            $a66381b3d0f4cdca$var$Kh = 0;
            $a66381b3d0f4cdca$var$nk.current = null;
            if (null === c || null === c.return) {
                $a66381b3d0f4cdca$var$T = 1;
                $a66381b3d0f4cdca$var$pk = b;
                $a66381b3d0f4cdca$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $a66381b3d0f4cdca$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $a66381b3d0f4cdca$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $a66381b3d0f4cdca$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $a66381b3d0f4cdca$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $a66381b3d0f4cdca$var$Si(f, l, b);
                            $a66381b3d0f4cdca$var$tj();
                            break a;
                        }
                        k = Error($a66381b3d0f4cdca$var$p(426));
                    }
                } else if ($a66381b3d0f4cdca$var$I && h.mode & 1) {
                    var J = $a66381b3d0f4cdca$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $a66381b3d0f4cdca$var$Vi(J, g, h, f, b);
                        $a66381b3d0f4cdca$var$Jg($a66381b3d0f4cdca$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $a66381b3d0f4cdca$var$Ji(k, h);
                4 !== $a66381b3d0f4cdca$var$T && ($a66381b3d0f4cdca$var$T = 2);
                null === $a66381b3d0f4cdca$var$sk ? $a66381b3d0f4cdca$var$sk = [
                    f
                ] : $a66381b3d0f4cdca$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $a66381b3d0f4cdca$var$Ni(f, k, b);
                            $a66381b3d0f4cdca$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $a66381b3d0f4cdca$var$Ri || !$a66381b3d0f4cdca$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $a66381b3d0f4cdca$var$Qi(f, h, b);
                                $a66381b3d0f4cdca$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $a66381b3d0f4cdca$var$Sk(c);
        } catch (na) {
            b = na;
            $a66381b3d0f4cdca$var$Y === c && null !== c && ($a66381b3d0f4cdca$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $a66381b3d0f4cdca$var$Jk() {
    var a = $a66381b3d0f4cdca$var$mk.current;
    $a66381b3d0f4cdca$var$mk.current = $a66381b3d0f4cdca$var$Rh;
    return null === a ? $a66381b3d0f4cdca$var$Rh : a;
}
function $a66381b3d0f4cdca$var$tj() {
    if (0 === $a66381b3d0f4cdca$var$T || 3 === $a66381b3d0f4cdca$var$T || 2 === $a66381b3d0f4cdca$var$T) $a66381b3d0f4cdca$var$T = 4;
    null === $a66381b3d0f4cdca$var$Q || 0 === ($a66381b3d0f4cdca$var$rh & 268435455) && 0 === ($a66381b3d0f4cdca$var$qk & 268435455) || $a66381b3d0f4cdca$var$Ck($a66381b3d0f4cdca$var$Q, $a66381b3d0f4cdca$var$Z);
}
function $a66381b3d0f4cdca$var$Ik(a, b) {
    var c = $a66381b3d0f4cdca$var$K;
    $a66381b3d0f4cdca$var$K |= 2;
    var d = $a66381b3d0f4cdca$var$Jk();
    if ($a66381b3d0f4cdca$var$Q !== a || $a66381b3d0f4cdca$var$Z !== b) $a66381b3d0f4cdca$var$uk = null, $a66381b3d0f4cdca$var$Kk(a, b);
    for(;;)try {
        $a66381b3d0f4cdca$var$Tk();
        break;
    } catch (e) {
        $a66381b3d0f4cdca$var$Mk(a, e);
    }
    $a66381b3d0f4cdca$var$$g();
    $a66381b3d0f4cdca$var$K = c;
    $a66381b3d0f4cdca$var$mk.current = d;
    if (null !== $a66381b3d0f4cdca$var$Y) throw Error($a66381b3d0f4cdca$var$p(261));
    $a66381b3d0f4cdca$var$Q = null;
    $a66381b3d0f4cdca$var$Z = 0;
    return $a66381b3d0f4cdca$var$T;
}
function $a66381b3d0f4cdca$var$Tk() {
    for(; null !== $a66381b3d0f4cdca$var$Y;)$a66381b3d0f4cdca$var$Uk($a66381b3d0f4cdca$var$Y);
}
function $a66381b3d0f4cdca$var$Lk() {
    for(; null !== $a66381b3d0f4cdca$var$Y && !$a66381b3d0f4cdca$var$cc();)$a66381b3d0f4cdca$var$Uk($a66381b3d0f4cdca$var$Y);
}
function $a66381b3d0f4cdca$var$Uk(a) {
    var b = $a66381b3d0f4cdca$var$Vk(a.alternate, a, $a66381b3d0f4cdca$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $a66381b3d0f4cdca$var$Sk(a) : $a66381b3d0f4cdca$var$Y = b;
    $a66381b3d0f4cdca$var$nk.current = null;
}
function $a66381b3d0f4cdca$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $a66381b3d0f4cdca$var$Ej(c, b, $a66381b3d0f4cdca$var$fj), null !== c) {
                $a66381b3d0f4cdca$var$Y = c;
                return;
            }
        } else {
            c = $a66381b3d0f4cdca$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $a66381b3d0f4cdca$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $a66381b3d0f4cdca$var$T = 6;
                $a66381b3d0f4cdca$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $a66381b3d0f4cdca$var$Y = b;
            return;
        }
        $a66381b3d0f4cdca$var$Y = b = a;
    }while (null !== b);
    0 === $a66381b3d0f4cdca$var$T && ($a66381b3d0f4cdca$var$T = 5);
}
function $a66381b3d0f4cdca$var$Pk(a, b, c) {
    var d = $a66381b3d0f4cdca$var$C, e = $a66381b3d0f4cdca$var$ok.transition;
    try {
        $a66381b3d0f4cdca$var$ok.transition = null, $a66381b3d0f4cdca$var$C = 1, $a66381b3d0f4cdca$var$Wk(a, b, c, d);
    } finally{
        $a66381b3d0f4cdca$var$ok.transition = e, $a66381b3d0f4cdca$var$C = d;
    }
    return null;
}
function $a66381b3d0f4cdca$var$Wk(a, b, c, d) {
    do $a66381b3d0f4cdca$var$Hk();
    while (null !== $a66381b3d0f4cdca$var$wk);
    if (0 !== ($a66381b3d0f4cdca$var$K & 6)) throw Error($a66381b3d0f4cdca$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($a66381b3d0f4cdca$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $a66381b3d0f4cdca$var$Bc(a, f);
    a === $a66381b3d0f4cdca$var$Q && ($a66381b3d0f4cdca$var$Y = $a66381b3d0f4cdca$var$Q = null, $a66381b3d0f4cdca$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $a66381b3d0f4cdca$var$vk || ($a66381b3d0f4cdca$var$vk = !0, $a66381b3d0f4cdca$var$Fk($a66381b3d0f4cdca$var$hc, function() {
        $a66381b3d0f4cdca$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $a66381b3d0f4cdca$var$ok.transition;
        $a66381b3d0f4cdca$var$ok.transition = null;
        var g = $a66381b3d0f4cdca$var$C;
        $a66381b3d0f4cdca$var$C = 1;
        var h = $a66381b3d0f4cdca$var$K;
        $a66381b3d0f4cdca$var$K |= 4;
        $a66381b3d0f4cdca$var$nk.current = null;
        $a66381b3d0f4cdca$var$Oj(a, c);
        $a66381b3d0f4cdca$var$dk(c, a);
        $a66381b3d0f4cdca$var$Oe($a66381b3d0f4cdca$var$Df);
        $a66381b3d0f4cdca$var$dd = !!$a66381b3d0f4cdca$var$Cf;
        $a66381b3d0f4cdca$var$Df = $a66381b3d0f4cdca$var$Cf = null;
        a.current = c;
        $a66381b3d0f4cdca$var$hk(c, a, e);
        $a66381b3d0f4cdca$var$dc();
        $a66381b3d0f4cdca$var$K = h;
        $a66381b3d0f4cdca$var$C = g;
        $a66381b3d0f4cdca$var$ok.transition = f;
    } else a.current = c;
    $a66381b3d0f4cdca$var$vk && ($a66381b3d0f4cdca$var$vk = !1, $a66381b3d0f4cdca$var$wk = a, $a66381b3d0f4cdca$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($a66381b3d0f4cdca$var$Ri = null);
    $a66381b3d0f4cdca$var$mc(c.stateNode, d);
    $a66381b3d0f4cdca$var$Dk(a, $a66381b3d0f4cdca$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($a66381b3d0f4cdca$var$Oi) throw $a66381b3d0f4cdca$var$Oi = !1, a = $a66381b3d0f4cdca$var$Pi, $a66381b3d0f4cdca$var$Pi = null, a;
    0 !== ($a66381b3d0f4cdca$var$xk & 1) && 0 !== a.tag && $a66381b3d0f4cdca$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $a66381b3d0f4cdca$var$zk ? $a66381b3d0f4cdca$var$yk++ : ($a66381b3d0f4cdca$var$yk = 0, $a66381b3d0f4cdca$var$zk = a) : $a66381b3d0f4cdca$var$yk = 0;
    $a66381b3d0f4cdca$var$jg();
    return null;
}
function $a66381b3d0f4cdca$var$Hk() {
    if (null !== $a66381b3d0f4cdca$var$wk) {
        var a = $a66381b3d0f4cdca$var$Dc($a66381b3d0f4cdca$var$xk), b = $a66381b3d0f4cdca$var$ok.transition, c = $a66381b3d0f4cdca$var$C;
        try {
            $a66381b3d0f4cdca$var$ok.transition = null;
            $a66381b3d0f4cdca$var$C = 16 > a ? 16 : a;
            if (null === $a66381b3d0f4cdca$var$wk) var d = !1;
            else {
                a = $a66381b3d0f4cdca$var$wk;
                $a66381b3d0f4cdca$var$wk = null;
                $a66381b3d0f4cdca$var$xk = 0;
                if (0 !== ($a66381b3d0f4cdca$var$K & 6)) throw Error($a66381b3d0f4cdca$var$p(331));
                var e = $a66381b3d0f4cdca$var$K;
                $a66381b3d0f4cdca$var$K |= 4;
                for($a66381b3d0f4cdca$var$V = a.current; null !== $a66381b3d0f4cdca$var$V;){
                    var f = $a66381b3d0f4cdca$var$V, g = f.child;
                    if (0 !== ($a66381b3d0f4cdca$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($a66381b3d0f4cdca$var$V = l; null !== $a66381b3d0f4cdca$var$V;){
                                    var m = $a66381b3d0f4cdca$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $a66381b3d0f4cdca$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $a66381b3d0f4cdca$var$V = q;
                                    else for(; null !== $a66381b3d0f4cdca$var$V;){
                                        m = $a66381b3d0f4cdca$var$V;
                                        var r = m.sibling, y = m.return;
                                        $a66381b3d0f4cdca$var$Sj(m);
                                        if (m === l) {
                                            $a66381b3d0f4cdca$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $a66381b3d0f4cdca$var$V = r;
                                            break;
                                        }
                                        $a66381b3d0f4cdca$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $a66381b3d0f4cdca$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $a66381b3d0f4cdca$var$V = g;
                    else b: for(; null !== $a66381b3d0f4cdca$var$V;){
                        f = $a66381b3d0f4cdca$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $a66381b3d0f4cdca$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $a66381b3d0f4cdca$var$V = x;
                            break b;
                        }
                        $a66381b3d0f4cdca$var$V = f.return;
                    }
                }
                var w = a.current;
                for($a66381b3d0f4cdca$var$V = w; null !== $a66381b3d0f4cdca$var$V;){
                    g = $a66381b3d0f4cdca$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $a66381b3d0f4cdca$var$V = u;
                    else b: for(g = w; null !== $a66381b3d0f4cdca$var$V;){
                        h = $a66381b3d0f4cdca$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $a66381b3d0f4cdca$var$Qj(9, h);
                            }
                        } catch (na) {
                            $a66381b3d0f4cdca$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $a66381b3d0f4cdca$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $a66381b3d0f4cdca$var$V = F;
                            break b;
                        }
                        $a66381b3d0f4cdca$var$V = h.return;
                    }
                }
                $a66381b3d0f4cdca$var$K = e;
                $a66381b3d0f4cdca$var$jg();
                if ($a66381b3d0f4cdca$var$lc && "function" === typeof $a66381b3d0f4cdca$var$lc.onPostCommitFiberRoot) try {
                    $a66381b3d0f4cdca$var$lc.onPostCommitFiberRoot($a66381b3d0f4cdca$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $a66381b3d0f4cdca$var$C = c, $a66381b3d0f4cdca$var$ok.transition = b;
        }
    }
    return !1;
}
function $a66381b3d0f4cdca$var$Xk(a, b, c) {
    b = $a66381b3d0f4cdca$var$Ji(c, b);
    b = $a66381b3d0f4cdca$var$Ni(a, b, 1);
    a = $a66381b3d0f4cdca$var$nh(a, b, 1);
    b = $a66381b3d0f4cdca$var$R();
    null !== a && ($a66381b3d0f4cdca$var$Ac(a, 1, b), $a66381b3d0f4cdca$var$Dk(a, b));
}
function $a66381b3d0f4cdca$var$W(a, b, c) {
    if (3 === a.tag) $a66381b3d0f4cdca$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $a66381b3d0f4cdca$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $a66381b3d0f4cdca$var$Ri || !$a66381b3d0f4cdca$var$Ri.has(d))) {
                a = $a66381b3d0f4cdca$var$Ji(c, a);
                a = $a66381b3d0f4cdca$var$Qi(b, a, 1);
                b = $a66381b3d0f4cdca$var$nh(b, a, 1);
                a = $a66381b3d0f4cdca$var$R();
                null !== b && ($a66381b3d0f4cdca$var$Ac(b, 1, a), $a66381b3d0f4cdca$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $a66381b3d0f4cdca$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $a66381b3d0f4cdca$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $a66381b3d0f4cdca$var$Q === a && ($a66381b3d0f4cdca$var$Z & c) === c && (4 === $a66381b3d0f4cdca$var$T || 3 === $a66381b3d0f4cdca$var$T && ($a66381b3d0f4cdca$var$Z & 130023424) === $a66381b3d0f4cdca$var$Z && 500 > $a66381b3d0f4cdca$var$B() - $a66381b3d0f4cdca$var$fk ? $a66381b3d0f4cdca$var$Kk(a, 0) : $a66381b3d0f4cdca$var$rk |= c);
    $a66381b3d0f4cdca$var$Dk(a, b);
}
function $a66381b3d0f4cdca$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $a66381b3d0f4cdca$var$sc, $a66381b3d0f4cdca$var$sc <<= 1, 0 === ($a66381b3d0f4cdca$var$sc & 130023424) && ($a66381b3d0f4cdca$var$sc = 4194304)));
    var c = $a66381b3d0f4cdca$var$R();
    a = $a66381b3d0f4cdca$var$ih(a, b);
    null !== a && ($a66381b3d0f4cdca$var$Ac(a, b, c), $a66381b3d0f4cdca$var$Dk(a, c));
}
function $a66381b3d0f4cdca$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $a66381b3d0f4cdca$var$Yk(a, c);
}
function $a66381b3d0f4cdca$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($a66381b3d0f4cdca$var$p(314));
    }
    null !== d && d.delete(b);
    $a66381b3d0f4cdca$var$Yk(a, c);
}
var $a66381b3d0f4cdca$var$Vk;
$a66381b3d0f4cdca$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $a66381b3d0f4cdca$var$Wf.current) $a66381b3d0f4cdca$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $a66381b3d0f4cdca$var$dh = !1, $a66381b3d0f4cdca$var$yj(a, b, c);
            $a66381b3d0f4cdca$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $a66381b3d0f4cdca$var$dh = !1, $a66381b3d0f4cdca$var$I && 0 !== (b.flags & 1048576) && $a66381b3d0f4cdca$var$ug(b, $a66381b3d0f4cdca$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $a66381b3d0f4cdca$var$ij(a, b);
            a = b.pendingProps;
            var e = $a66381b3d0f4cdca$var$Yf(b, $a66381b3d0f4cdca$var$H.current);
            $a66381b3d0f4cdca$var$ch(b, c);
            e = $a66381b3d0f4cdca$var$Nh(null, b, d, a, e, c);
            var f = $a66381b3d0f4cdca$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $a66381b3d0f4cdca$var$Zf(d) ? (f = !0, $a66381b3d0f4cdca$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $a66381b3d0f4cdca$var$kh(b), e.updater = $a66381b3d0f4cdca$var$Ei, b.stateNode = e, e._reactInternals = b, $a66381b3d0f4cdca$var$Ii(b, d, a, c), b = $a66381b3d0f4cdca$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $a66381b3d0f4cdca$var$I && f && $a66381b3d0f4cdca$var$vg(b), $a66381b3d0f4cdca$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $a66381b3d0f4cdca$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $a66381b3d0f4cdca$var$Zk(d);
                a = $a66381b3d0f4cdca$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $a66381b3d0f4cdca$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $a66381b3d0f4cdca$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $a66381b3d0f4cdca$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $a66381b3d0f4cdca$var$$i(null, b, d, $a66381b3d0f4cdca$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($a66381b3d0f4cdca$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a66381b3d0f4cdca$var$Ci(d, e), $a66381b3d0f4cdca$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a66381b3d0f4cdca$var$Ci(d, e), $a66381b3d0f4cdca$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $a66381b3d0f4cdca$var$kj(b);
                if (null === a) throw Error($a66381b3d0f4cdca$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $a66381b3d0f4cdca$var$lh(a, b);
                $a66381b3d0f4cdca$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $a66381b3d0f4cdca$var$Ji(Error($a66381b3d0f4cdca$var$p(423)), b);
                        b = $a66381b3d0f4cdca$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $a66381b3d0f4cdca$var$Ji(Error($a66381b3d0f4cdca$var$p(424)), b);
                        b = $a66381b3d0f4cdca$var$lj(a, b, d, c, e);
                        break a;
                    } else for($a66381b3d0f4cdca$var$yg = $a66381b3d0f4cdca$var$Lf(b.stateNode.containerInfo.firstChild), $a66381b3d0f4cdca$var$xg = b, $a66381b3d0f4cdca$var$I = !0, $a66381b3d0f4cdca$var$zg = null, c = $a66381b3d0f4cdca$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $a66381b3d0f4cdca$var$Ig();
                    if (d === e) {
                        b = $a66381b3d0f4cdca$var$Zi(a, b, c);
                        break a;
                    }
                    $a66381b3d0f4cdca$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $a66381b3d0f4cdca$var$Ah(b), null === a && $a66381b3d0f4cdca$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $a66381b3d0f4cdca$var$Ef(d, e) ? g = null : null !== f && $a66381b3d0f4cdca$var$Ef(d, f) && (b.flags |= 32), $a66381b3d0f4cdca$var$gj(a, b), $a66381b3d0f4cdca$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $a66381b3d0f4cdca$var$Eg(b), null;
        case 13:
            return $a66381b3d0f4cdca$var$oj(a, b, c);
        case 4:
            return $a66381b3d0f4cdca$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $a66381b3d0f4cdca$var$Ug(b, null, d, c) : $a66381b3d0f4cdca$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a66381b3d0f4cdca$var$Ci(d, e), $a66381b3d0f4cdca$var$Yi(a, b, d, e, c);
        case 7:
            return $a66381b3d0f4cdca$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $a66381b3d0f4cdca$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $a66381b3d0f4cdca$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $a66381b3d0f4cdca$var$G($a66381b3d0f4cdca$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($a66381b3d0f4cdca$var$He(f.value, g)) {
                        if (f.children === e.children && !$a66381b3d0f4cdca$var$Wf.current) {
                            b = $a66381b3d0f4cdca$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $a66381b3d0f4cdca$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $a66381b3d0f4cdca$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($a66381b3d0f4cdca$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $a66381b3d0f4cdca$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $a66381b3d0f4cdca$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $a66381b3d0f4cdca$var$ch(b, c), e = $a66381b3d0f4cdca$var$eh(e), d = d(e), b.flags |= 1, $a66381b3d0f4cdca$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $a66381b3d0f4cdca$var$Ci(d, b.pendingProps), e = $a66381b3d0f4cdca$var$Ci(d.type, e), $a66381b3d0f4cdca$var$$i(a, b, d, e, c);
        case 15:
            return $a66381b3d0f4cdca$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a66381b3d0f4cdca$var$Ci(d, e), $a66381b3d0f4cdca$var$ij(a, b), b.tag = 1, $a66381b3d0f4cdca$var$Zf(d) ? (a = !0, $a66381b3d0f4cdca$var$cg(b)) : a = !1, $a66381b3d0f4cdca$var$ch(b, c), $a66381b3d0f4cdca$var$Gi(b, d, e), $a66381b3d0f4cdca$var$Ii(b, d, e, c), $a66381b3d0f4cdca$var$jj(null, b, d, !0, a, c);
        case 19:
            return $a66381b3d0f4cdca$var$xj(a, b, c);
        case 22:
            return $a66381b3d0f4cdca$var$dj(a, b, c);
    }
    throw Error($a66381b3d0f4cdca$var$p(156, b.tag));
};
function $a66381b3d0f4cdca$var$Fk(a, b) {
    return $a66381b3d0f4cdca$var$ac(a, b);
}
function $a66381b3d0f4cdca$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $a66381b3d0f4cdca$var$Bg(a, b, c, d) {
    return new $a66381b3d0f4cdca$var$$k(a, b, c, d);
}
function $a66381b3d0f4cdca$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $a66381b3d0f4cdca$var$Zk(a) {
    if ("function" === typeof a) return $a66381b3d0f4cdca$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $a66381b3d0f4cdca$var$Da) return 11;
        if (a === $a66381b3d0f4cdca$var$Ga) return 14;
    }
    return 2;
}
function $a66381b3d0f4cdca$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $a66381b3d0f4cdca$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $a66381b3d0f4cdca$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $a66381b3d0f4cdca$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $a66381b3d0f4cdca$var$ya:
            return $a66381b3d0f4cdca$var$Tg(c.children, e, f, b);
        case $a66381b3d0f4cdca$var$za:
            g = 8;
            e |= 8;
            break;
        case $a66381b3d0f4cdca$var$Aa:
            return a = $a66381b3d0f4cdca$var$Bg(12, c, b, e | 2), a.elementType = $a66381b3d0f4cdca$var$Aa, a.lanes = f, a;
        case $a66381b3d0f4cdca$var$Ea:
            return a = $a66381b3d0f4cdca$var$Bg(13, c, b, e), a.elementType = $a66381b3d0f4cdca$var$Ea, a.lanes = f, a;
        case $a66381b3d0f4cdca$var$Fa:
            return a = $a66381b3d0f4cdca$var$Bg(19, c, b, e), a.elementType = $a66381b3d0f4cdca$var$Fa, a.lanes = f, a;
        case $a66381b3d0f4cdca$var$Ia:
            return $a66381b3d0f4cdca$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $a66381b3d0f4cdca$var$Ba:
                    g = 10;
                    break a;
                case $a66381b3d0f4cdca$var$Ca:
                    g = 9;
                    break a;
                case $a66381b3d0f4cdca$var$Da:
                    g = 11;
                    break a;
                case $a66381b3d0f4cdca$var$Ga:
                    g = 14;
                    break a;
                case $a66381b3d0f4cdca$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($a66381b3d0f4cdca$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $a66381b3d0f4cdca$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $a66381b3d0f4cdca$var$Tg(a, b, c, d) {
    a = $a66381b3d0f4cdca$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $a66381b3d0f4cdca$var$pj(a, b, c, d) {
    a = $a66381b3d0f4cdca$var$Bg(22, a, d, b);
    a.elementType = $a66381b3d0f4cdca$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $a66381b3d0f4cdca$var$Qg(a, b, c) {
    a = $a66381b3d0f4cdca$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $a66381b3d0f4cdca$var$Sg(a, b, c) {
    b = $a66381b3d0f4cdca$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $a66381b3d0f4cdca$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $a66381b3d0f4cdca$var$zc(0);
    this.expirationTimes = $a66381b3d0f4cdca$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $a66381b3d0f4cdca$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $a66381b3d0f4cdca$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $a66381b3d0f4cdca$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $a66381b3d0f4cdca$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $a66381b3d0f4cdca$var$kh(f);
    return a;
}
function $a66381b3d0f4cdca$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a66381b3d0f4cdca$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $a66381b3d0f4cdca$var$dl(a) {
    if (!a) return $a66381b3d0f4cdca$var$Vf;
    a = a._reactInternals;
    a: {
        if ($a66381b3d0f4cdca$var$Vb(a) !== a || 1 !== a.tag) throw Error($a66381b3d0f4cdca$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($a66381b3d0f4cdca$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($a66381b3d0f4cdca$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($a66381b3d0f4cdca$var$Zf(c)) return $a66381b3d0f4cdca$var$bg(a, c, b);
    }
    return b;
}
function $a66381b3d0f4cdca$var$el(a, b, c, d, e, f, g, h, k) {
    a = $a66381b3d0f4cdca$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $a66381b3d0f4cdca$var$dl(null);
    c = a.current;
    d = $a66381b3d0f4cdca$var$R();
    e = $a66381b3d0f4cdca$var$yi(c);
    f = $a66381b3d0f4cdca$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $a66381b3d0f4cdca$var$nh(c, f, e);
    a.current.lanes = e;
    $a66381b3d0f4cdca$var$Ac(a, e, d);
    $a66381b3d0f4cdca$var$Dk(a, d);
    return a;
}
function $a66381b3d0f4cdca$var$fl(a, b, c, d) {
    var e = b.current, f = $a66381b3d0f4cdca$var$R(), g = $a66381b3d0f4cdca$var$yi(e);
    c = $a66381b3d0f4cdca$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $a66381b3d0f4cdca$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $a66381b3d0f4cdca$var$nh(e, b, g);
    null !== a && ($a66381b3d0f4cdca$var$gi(a, e, g, f), $a66381b3d0f4cdca$var$oh(a, e, g));
    return g;
}
function $a66381b3d0f4cdca$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $a66381b3d0f4cdca$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $a66381b3d0f4cdca$var$il(a, b) {
    $a66381b3d0f4cdca$var$hl(a, b);
    (a = a.alternate) && $a66381b3d0f4cdca$var$hl(a, b);
}
function $a66381b3d0f4cdca$var$jl() {
    return null;
}
var $a66381b3d0f4cdca$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $a66381b3d0f4cdca$var$ll(a) {
    this._internalRoot = a;
}
$a66381b3d0f4cdca$var$ml.prototype.render = $a66381b3d0f4cdca$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($a66381b3d0f4cdca$var$p(409));
    $a66381b3d0f4cdca$var$fl(a, b, null, null);
};
$a66381b3d0f4cdca$var$ml.prototype.unmount = $a66381b3d0f4cdca$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $a66381b3d0f4cdca$var$Rk(function() {
            $a66381b3d0f4cdca$var$fl(null, a, null, null);
        });
        b[$a66381b3d0f4cdca$var$uf] = null;
    }
};
function $a66381b3d0f4cdca$var$ml(a) {
    this._internalRoot = a;
}
$a66381b3d0f4cdca$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $a66381b3d0f4cdca$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $a66381b3d0f4cdca$var$Qc.length && 0 !== b && b < $a66381b3d0f4cdca$var$Qc[c].priority; c++);
        $a66381b3d0f4cdca$var$Qc.splice(c, 0, a);
        0 === c && $a66381b3d0f4cdca$var$Vc(a);
    }
};
function $a66381b3d0f4cdca$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $a66381b3d0f4cdca$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $a66381b3d0f4cdca$var$pl() {}
function $a66381b3d0f4cdca$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $a66381b3d0f4cdca$var$gl(g);
                f.call(a);
            };
        }
        var g = $a66381b3d0f4cdca$var$el(b, d, a, 0, null, !1, !1, "", $a66381b3d0f4cdca$var$pl);
        a._reactRootContainer = g;
        a[$a66381b3d0f4cdca$var$uf] = g.current;
        $a66381b3d0f4cdca$var$sf(8 === a.nodeType ? a.parentNode : a);
        $a66381b3d0f4cdca$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $a66381b3d0f4cdca$var$gl(k);
            h.call(a);
        };
    }
    var k = $a66381b3d0f4cdca$var$bl(a, 0, !1, null, null, !1, !1, "", $a66381b3d0f4cdca$var$pl);
    a._reactRootContainer = k;
    a[$a66381b3d0f4cdca$var$uf] = k.current;
    $a66381b3d0f4cdca$var$sf(8 === a.nodeType ? a.parentNode : a);
    $a66381b3d0f4cdca$var$Rk(function() {
        $a66381b3d0f4cdca$var$fl(b, k, c, d);
    });
    return k;
}
function $a66381b3d0f4cdca$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $a66381b3d0f4cdca$var$gl(g);
                h.call(a);
            };
        }
        $a66381b3d0f4cdca$var$fl(b, g, a, e);
    } else g = $a66381b3d0f4cdca$var$ql(c, b, a, e, d);
    return $a66381b3d0f4cdca$var$gl(g);
}
$a66381b3d0f4cdca$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $a66381b3d0f4cdca$var$tc(b.pendingLanes);
                0 !== c && ($a66381b3d0f4cdca$var$Cc(b, c | 1), $a66381b3d0f4cdca$var$Dk(b, $a66381b3d0f4cdca$var$B()), 0 === ($a66381b3d0f4cdca$var$K & 6) && ($a66381b3d0f4cdca$var$Gj = $a66381b3d0f4cdca$var$B() + 500, $a66381b3d0f4cdca$var$jg()));
            }
            break;
        case 13:
            $a66381b3d0f4cdca$var$Rk(function() {
                var b = $a66381b3d0f4cdca$var$ih(a, 1);
                if (null !== b) {
                    var c = $a66381b3d0f4cdca$var$R();
                    $a66381b3d0f4cdca$var$gi(b, a, 1, c);
                }
            }), $a66381b3d0f4cdca$var$il(a, 1);
    }
};
$a66381b3d0f4cdca$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $a66381b3d0f4cdca$var$ih(a, 134217728);
        if (null !== b) {
            var c = $a66381b3d0f4cdca$var$R();
            $a66381b3d0f4cdca$var$gi(b, a, 134217728, c);
        }
        $a66381b3d0f4cdca$var$il(a, 134217728);
    }
};
$a66381b3d0f4cdca$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $a66381b3d0f4cdca$var$yi(a), c = $a66381b3d0f4cdca$var$ih(a, b);
        if (null !== c) {
            var d = $a66381b3d0f4cdca$var$R();
            $a66381b3d0f4cdca$var$gi(c, a, b, d);
        }
        $a66381b3d0f4cdca$var$il(a, b);
    }
};
$a66381b3d0f4cdca$var$Hc = function() {
    return $a66381b3d0f4cdca$var$C;
};
$a66381b3d0f4cdca$var$Ic = function(a, b) {
    var c = $a66381b3d0f4cdca$var$C;
    try {
        return $a66381b3d0f4cdca$var$C = a, b();
    } finally{
        $a66381b3d0f4cdca$var$C = c;
    }
};
$a66381b3d0f4cdca$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $a66381b3d0f4cdca$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $a66381b3d0f4cdca$var$Db(d);
                        if (!e) throw Error($a66381b3d0f4cdca$var$p(90));
                        $a66381b3d0f4cdca$var$Wa(d);
                        $a66381b3d0f4cdca$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $a66381b3d0f4cdca$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $a66381b3d0f4cdca$var$fb(a, !!c.multiple, b, !1);
    }
};
$a66381b3d0f4cdca$var$Gb = $a66381b3d0f4cdca$var$Qk;
$a66381b3d0f4cdca$var$Hb = $a66381b3d0f4cdca$var$Rk;
var $a66381b3d0f4cdca$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $a66381b3d0f4cdca$var$Cb,
        $a66381b3d0f4cdca$var$ue,
        $a66381b3d0f4cdca$var$Db,
        $a66381b3d0f4cdca$var$Eb,
        $a66381b3d0f4cdca$var$Fb,
        $a66381b3d0f4cdca$var$Qk
    ]
}, $a66381b3d0f4cdca$var$tl = {
    findFiberByHostInstance: $a66381b3d0f4cdca$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $a66381b3d0f4cdca$var$ul = {
    bundleType: $a66381b3d0f4cdca$var$tl.bundleType,
    version: $a66381b3d0f4cdca$var$tl.version,
    rendererPackageName: $a66381b3d0f4cdca$var$tl.rendererPackageName,
    rendererConfig: $a66381b3d0f4cdca$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $a66381b3d0f4cdca$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $a66381b3d0f4cdca$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $a66381b3d0f4cdca$var$tl.findFiberByHostInstance || $a66381b3d0f4cdca$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $a66381b3d0f4cdca$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$a66381b3d0f4cdca$var$vl.isDisabled && $a66381b3d0f4cdca$var$vl.supportsFiber) try {
        $a66381b3d0f4cdca$var$kc = $a66381b3d0f4cdca$var$vl.inject($a66381b3d0f4cdca$var$ul), $a66381b3d0f4cdca$var$lc = $a66381b3d0f4cdca$var$vl;
    } catch (a) {}
}
$a66381b3d0f4cdca$export$ae55be85d98224ed = $a66381b3d0f4cdca$var$sl;
$a66381b3d0f4cdca$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$a66381b3d0f4cdca$var$nl(b)) throw Error($a66381b3d0f4cdca$var$p(200));
    return $a66381b3d0f4cdca$var$cl(a, b, null, c);
};
$a66381b3d0f4cdca$export$882461b6382ed46c = function(a, b) {
    if (!$a66381b3d0f4cdca$var$nl(a)) throw Error($a66381b3d0f4cdca$var$p(299));
    var c = !1, d = "", e = $a66381b3d0f4cdca$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $a66381b3d0f4cdca$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$a66381b3d0f4cdca$var$uf] = b.current;
    $a66381b3d0f4cdca$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $a66381b3d0f4cdca$var$ll(b);
};
$a66381b3d0f4cdca$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($a66381b3d0f4cdca$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($a66381b3d0f4cdca$var$p(268, a));
    }
    a = $a66381b3d0f4cdca$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$a66381b3d0f4cdca$export$cd75ccfd720a3cd4 = function(a) {
    return $a66381b3d0f4cdca$var$Rk(a);
};
$a66381b3d0f4cdca$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$a66381b3d0f4cdca$var$ol(b)) throw Error($a66381b3d0f4cdca$var$p(200));
    return $a66381b3d0f4cdca$var$rl(null, a, b, !0, c);
};
$a66381b3d0f4cdca$export$757ceba2d55c277e = function(a, b, c) {
    if (!$a66381b3d0f4cdca$var$nl(a)) throw Error($a66381b3d0f4cdca$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $a66381b3d0f4cdca$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $a66381b3d0f4cdca$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$a66381b3d0f4cdca$var$uf] = b.current;
    $a66381b3d0f4cdca$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $a66381b3d0f4cdca$var$ml(b);
};
$a66381b3d0f4cdca$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$a66381b3d0f4cdca$var$ol(b)) throw Error($a66381b3d0f4cdca$var$p(200));
    return $a66381b3d0f4cdca$var$rl(null, a, b, !1, c);
};
$a66381b3d0f4cdca$export$502457920280e6be = function(a) {
    if (!$a66381b3d0f4cdca$var$ol(a)) throw Error($a66381b3d0f4cdca$var$p(40));
    return a._reactRootContainer ? ($a66381b3d0f4cdca$var$Rk(function() {
        $a66381b3d0f4cdca$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$a66381b3d0f4cdca$var$uf] = null;
        });
    }), !0) : !1;
};
$a66381b3d0f4cdca$export$c78a37762a8d58e1 = $a66381b3d0f4cdca$var$Qk;
$a66381b3d0f4cdca$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$a66381b3d0f4cdca$var$ol(c)) throw Error($a66381b3d0f4cdca$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($a66381b3d0f4cdca$var$p(38));
    return $a66381b3d0f4cdca$var$rl(a, b, c, !1, d);
};
$a66381b3d0f4cdca$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("aTlqC", function(module, exports) {
'use strict';

module.exports = (parcelRequire("es9sH"));

});
parcelRegister("es9sH", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $a85b052802a74615$export$c4744153514ff05d, (v) => $a85b052802a74615$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $a85b052802a74615$export$3e506c1ccc9cc1a7, (v) => $a85b052802a74615$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $a85b052802a74615$export$e26fe2ed2fa76875, (v) => $a85b052802a74615$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $a85b052802a74615$export$502329bbf4b505b1, (v) => $a85b052802a74615$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $a85b052802a74615$export$6e3807111c4874c4, (v) => $a85b052802a74615$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $a85b052802a74615$export$c27134553091fb3a, (v) => $a85b052802a74615$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $a85b052802a74615$export$33ee1acdc04fd2a2, (v) => $a85b052802a74615$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $a85b052802a74615$export$b00a404bbd5edef2, (v) => $a85b052802a74615$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $a85b052802a74615$export$8352ce38b91d0c62, (v) => $a85b052802a74615$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $a85b052802a74615$export$d66a1c1c77bd778b, (v) => $a85b052802a74615$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $a85b052802a74615$export$d3dfb8e4810cb555, (v) => $a85b052802a74615$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $a85b052802a74615$export$839f9183b0465a69, (v) => $a85b052802a74615$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $a85b052802a74615$export$72fdf0e06517287b, (v) => $a85b052802a74615$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $a85b052802a74615$export$4b844e58a3e414b4, (v) => $a85b052802a74615$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $a85b052802a74615$export$816d2913ae6b83b1, (v) => $a85b052802a74615$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $a85b052802a74615$export$61bcfe829111a1d0, (v) => $a85b052802a74615$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $a85b052802a74615$export$7ee8c9beb337bc3f, (v) => $a85b052802a74615$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $a85b052802a74615$export$b5836b71941fa3ed, (v) => $a85b052802a74615$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $a85b052802a74615$export$cf845f2c119da08a, (v) => $a85b052802a74615$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a85b052802a74615$export$c4744153514ff05d;
var $a85b052802a74615$export$3e506c1ccc9cc1a7;
var $a85b052802a74615$export$e26fe2ed2fa76875;
var $a85b052802a74615$export$502329bbf4b505b1;
var $a85b052802a74615$export$6e3807111c4874c4;
var $a85b052802a74615$export$c27134553091fb3a;
var $a85b052802a74615$export$33ee1acdc04fd2a2;
var $a85b052802a74615$export$b00a404bbd5edef2;
var $a85b052802a74615$export$8352ce38b91d0c62;
var $a85b052802a74615$export$d66a1c1c77bd778b;
var $a85b052802a74615$export$d3dfb8e4810cb555;
var $a85b052802a74615$export$839f9183b0465a69;
var $a85b052802a74615$export$72fdf0e06517287b;
var $a85b052802a74615$export$4b844e58a3e414b4;
var $a85b052802a74615$export$816d2913ae6b83b1;
var $a85b052802a74615$export$61bcfe829111a1d0;
var $a85b052802a74615$export$7ee8c9beb337bc3f;
var $a85b052802a74615$export$b5836b71941fa3ed;
var $a85b052802a74615$export$cf845f2c119da08a;
'use strict';
function $a85b052802a74615$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $a85b052802a74615$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $a85b052802a74615$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $a85b052802a74615$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $a85b052802a74615$var$g(C, c)) n < e && 0 > $a85b052802a74615$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $a85b052802a74615$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $a85b052802a74615$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a85b052802a74615$var$l = performance;
    $a85b052802a74615$export$c4744153514ff05d = function() {
        return $a85b052802a74615$var$l.now();
    };
} else {
    var $a85b052802a74615$var$p = Date, $a85b052802a74615$var$q = $a85b052802a74615$var$p.now();
    $a85b052802a74615$export$c4744153514ff05d = function() {
        return $a85b052802a74615$var$p.now() - $a85b052802a74615$var$q;
    };
}
var $a85b052802a74615$var$r = [], $a85b052802a74615$var$t = [], $a85b052802a74615$var$u = 1, $a85b052802a74615$var$v = null, $a85b052802a74615$var$y = 3, $a85b052802a74615$var$z = !1, $a85b052802a74615$var$A = !1, $a85b052802a74615$var$B = !1, $a85b052802a74615$var$D = "function" === typeof setTimeout ? setTimeout : null, $a85b052802a74615$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $a85b052802a74615$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $a85b052802a74615$var$G(a) {
    for(var b = $a85b052802a74615$var$h($a85b052802a74615$var$t); null !== b;){
        if (null === b.callback) $a85b052802a74615$var$k($a85b052802a74615$var$t);
        else if (b.startTime <= a) $a85b052802a74615$var$k($a85b052802a74615$var$t), b.sortIndex = b.expirationTime, $a85b052802a74615$var$f($a85b052802a74615$var$r, b);
        else break;
        b = $a85b052802a74615$var$h($a85b052802a74615$var$t);
    }
}
function $a85b052802a74615$var$H(a) {
    $a85b052802a74615$var$B = !1;
    $a85b052802a74615$var$G(a);
    if (!$a85b052802a74615$var$A) {
        if (null !== $a85b052802a74615$var$h($a85b052802a74615$var$r)) $a85b052802a74615$var$A = !0, $a85b052802a74615$var$I($a85b052802a74615$var$J);
        else {
            var b = $a85b052802a74615$var$h($a85b052802a74615$var$t);
            null !== b && $a85b052802a74615$var$K($a85b052802a74615$var$H, b.startTime - a);
        }
    }
}
function $a85b052802a74615$var$J(a, b) {
    $a85b052802a74615$var$A = !1;
    $a85b052802a74615$var$B && ($a85b052802a74615$var$B = !1, $a85b052802a74615$var$E($a85b052802a74615$var$L), $a85b052802a74615$var$L = -1);
    $a85b052802a74615$var$z = !0;
    var c = $a85b052802a74615$var$y;
    try {
        $a85b052802a74615$var$G(b);
        for($a85b052802a74615$var$v = $a85b052802a74615$var$h($a85b052802a74615$var$r); null !== $a85b052802a74615$var$v && (!($a85b052802a74615$var$v.expirationTime > b) || a && !$a85b052802a74615$var$M());){
            var d = $a85b052802a74615$var$v.callback;
            if ("function" === typeof d) {
                $a85b052802a74615$var$v.callback = null;
                $a85b052802a74615$var$y = $a85b052802a74615$var$v.priorityLevel;
                var e = d($a85b052802a74615$var$v.expirationTime <= b);
                b = $a85b052802a74615$export$c4744153514ff05d();
                "function" === typeof e ? $a85b052802a74615$var$v.callback = e : $a85b052802a74615$var$v === $a85b052802a74615$var$h($a85b052802a74615$var$r) && $a85b052802a74615$var$k($a85b052802a74615$var$r);
                $a85b052802a74615$var$G(b);
            } else $a85b052802a74615$var$k($a85b052802a74615$var$r);
            $a85b052802a74615$var$v = $a85b052802a74615$var$h($a85b052802a74615$var$r);
        }
        if (null !== $a85b052802a74615$var$v) var w = !0;
        else {
            var m = $a85b052802a74615$var$h($a85b052802a74615$var$t);
            null !== m && $a85b052802a74615$var$K($a85b052802a74615$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $a85b052802a74615$var$v = null, $a85b052802a74615$var$y = c, $a85b052802a74615$var$z = !1;
    }
}
var $a85b052802a74615$var$N = !1, $a85b052802a74615$var$O = null, $a85b052802a74615$var$L = -1, $a85b052802a74615$var$P = 5, $a85b052802a74615$var$Q = -1;
function $a85b052802a74615$var$M() {
    return $a85b052802a74615$export$c4744153514ff05d() - $a85b052802a74615$var$Q < $a85b052802a74615$var$P ? !1 : !0;
}
function $a85b052802a74615$var$R() {
    if (null !== $a85b052802a74615$var$O) {
        var a = $a85b052802a74615$export$c4744153514ff05d();
        $a85b052802a74615$var$Q = a;
        var b = !0;
        try {
            b = $a85b052802a74615$var$O(!0, a);
        } finally{
            b ? $a85b052802a74615$var$S() : ($a85b052802a74615$var$N = !1, $a85b052802a74615$var$O = null);
        }
    } else $a85b052802a74615$var$N = !1;
}
var $a85b052802a74615$var$S;
if ("function" === typeof $a85b052802a74615$var$F) $a85b052802a74615$var$S = function() {
    $a85b052802a74615$var$F($a85b052802a74615$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $a85b052802a74615$var$T = new MessageChannel, $a85b052802a74615$var$U = $a85b052802a74615$var$T.port2;
    $a85b052802a74615$var$T.port1.onmessage = $a85b052802a74615$var$R;
    $a85b052802a74615$var$S = function() {
        $a85b052802a74615$var$U.postMessage(null);
    };
} else $a85b052802a74615$var$S = function() {
    $a85b052802a74615$var$D($a85b052802a74615$var$R, 0);
};
function $a85b052802a74615$var$I(a) {
    $a85b052802a74615$var$O = a;
    $a85b052802a74615$var$N || ($a85b052802a74615$var$N = !0, $a85b052802a74615$var$S());
}
function $a85b052802a74615$var$K(a, b) {
    $a85b052802a74615$var$L = $a85b052802a74615$var$D(function() {
        a($a85b052802a74615$export$c4744153514ff05d());
    }, b);
}
$a85b052802a74615$export$3e506c1ccc9cc1a7 = 5;
$a85b052802a74615$export$e26fe2ed2fa76875 = 1;
$a85b052802a74615$export$502329bbf4b505b1 = 4;
$a85b052802a74615$export$6e3807111c4874c4 = 3;
$a85b052802a74615$export$c27134553091fb3a = null;
$a85b052802a74615$export$33ee1acdc04fd2a2 = 2;
$a85b052802a74615$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$a85b052802a74615$export$8352ce38b91d0c62 = function() {
    $a85b052802a74615$var$A || $a85b052802a74615$var$z || ($a85b052802a74615$var$A = !0, $a85b052802a74615$var$I($a85b052802a74615$var$J));
};
$a85b052802a74615$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a85b052802a74615$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$a85b052802a74615$export$d3dfb8e4810cb555 = function() {
    return $a85b052802a74615$var$y;
};
$a85b052802a74615$export$839f9183b0465a69 = function() {
    return $a85b052802a74615$var$h($a85b052802a74615$var$r);
};
$a85b052802a74615$export$72fdf0e06517287b = function(a) {
    switch($a85b052802a74615$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $a85b052802a74615$var$y;
    }
    var c = $a85b052802a74615$var$y;
    $a85b052802a74615$var$y = b;
    try {
        return a();
    } finally{
        $a85b052802a74615$var$y = c;
    }
};
$a85b052802a74615$export$4b844e58a3e414b4 = function() {};
$a85b052802a74615$export$816d2913ae6b83b1 = function() {};
$a85b052802a74615$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $a85b052802a74615$var$y;
    $a85b052802a74615$var$y = a;
    try {
        return b();
    } finally{
        $a85b052802a74615$var$y = c;
    }
};
$a85b052802a74615$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $a85b052802a74615$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $a85b052802a74615$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $a85b052802a74615$var$f($a85b052802a74615$var$t, a), null === $a85b052802a74615$var$h($a85b052802a74615$var$r) && a === $a85b052802a74615$var$h($a85b052802a74615$var$t) && ($a85b052802a74615$var$B ? ($a85b052802a74615$var$E($a85b052802a74615$var$L), $a85b052802a74615$var$L = -1) : $a85b052802a74615$var$B = !0, $a85b052802a74615$var$K($a85b052802a74615$var$H, c - d))) : (a.sortIndex = e, $a85b052802a74615$var$f($a85b052802a74615$var$r, a), $a85b052802a74615$var$A || $a85b052802a74615$var$z || ($a85b052802a74615$var$A = !0, $a85b052802a74615$var$I($a85b052802a74615$var$J)));
    return a;
};
$a85b052802a74615$export$b5836b71941fa3ed = $a85b052802a74615$var$M;
$a85b052802a74615$export$cf845f2c119da08a = function(a) {
    var b = $a85b052802a74615$var$y;
    return function() {
        var c = $a85b052802a74615$var$y;
        $a85b052802a74615$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $a85b052802a74615$var$y = c;
        }
    };
};

});



parcelRegister("d2bgE", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $97d433c6cf76ee8c$var$ReactIs, $97d433c6cf76ee8c$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("cTtd9"))();

});
parcelRegister("cTtd9", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $8YDf5 = parcelRequire("8YDf5");
function $963147d31d67b1dd$var$emptyFunction() {}
function $963147d31d67b1dd$var$emptyFunctionWithReset() {}
$963147d31d67b1dd$var$emptyFunctionWithReset.resetWarningCache = $963147d31d67b1dd$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $8YDf5) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $963147d31d67b1dd$var$emptyFunctionWithReset,
        resetWarningCache: $963147d31d67b1dd$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("8YDf5", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $68925e0a3835b297$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $68925e0a3835b297$var$ReactPropTypesSecret;

});



parcelRegister("59aql", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $3bf5e0f7bdc10b60$export$2b8d127b894957b9, (v) => $3bf5e0f7bdc10b60$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $3bf5e0f7bdc10b60$export$cea3a54a6425200c, (v) => $3bf5e0f7bdc10b60$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $3bf5e0f7bdc10b60$export$a7c73072b1a182ae, (v) => $3bf5e0f7bdc10b60$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $3bf5e0f7bdc10b60$export$9f27bc3417b4524d, (v) => $3bf5e0f7bdc10b60$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $3bf5e0f7bdc10b60$export$db77ccec0bb4ccac, (v) => $3bf5e0f7bdc10b60$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $3bf5e0f7bdc10b60$export$8392c0c9d3dcbd35, (v) => $3bf5e0f7bdc10b60$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $3bf5e0f7bdc10b60$export$ffb0004e005737fa, (v) => $3bf5e0f7bdc10b60$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $3bf5e0f7bdc10b60$export$b624eff549462981, (v) => $3bf5e0f7bdc10b60$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $3bf5e0f7bdc10b60$export$7897aa7841a5380c, (v) => $3bf5e0f7bdc10b60$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $3bf5e0f7bdc10b60$export$602eac185826482c, (v) => $3bf5e0f7bdc10b60$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $3bf5e0f7bdc10b60$export$e2c29f18771995cb, (v) => $3bf5e0f7bdc10b60$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $3bf5e0f7bdc10b60$export$5f8d39834fd61797, (v) => $3bf5e0f7bdc10b60$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $3bf5e0f7bdc10b60$export$74bf444e3cd11ea5, (v) => $3bf5e0f7bdc10b60$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $3bf5e0f7bdc10b60$export$92387174baf9b227, (v) => $3bf5e0f7bdc10b60$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $3bf5e0f7bdc10b60$export$ec112efeb987d9c6, (v) => $3bf5e0f7bdc10b60$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $3bf5e0f7bdc10b60$export$b706b080d889d2c9, (v) => $3bf5e0f7bdc10b60$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $3bf5e0f7bdc10b60$export$5be5a87408f70ddc, (v) => $3bf5e0f7bdc10b60$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $3bf5e0f7bdc10b60$export$45a5e7f76e0caa8d, (v) => $3bf5e0f7bdc10b60$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $3bf5e0f7bdc10b60$export$455c2e768291efa6, (v) => $3bf5e0f7bdc10b60$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $3bf5e0f7bdc10b60$export$9522e17588c12572, (v) => $3bf5e0f7bdc10b60$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $3bf5e0f7bdc10b60$export$2110ac352bb060b9, (v) => $3bf5e0f7bdc10b60$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $3bf5e0f7bdc10b60$export$56885ab8b9c456ab, (v) => $3bf5e0f7bdc10b60$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $3bf5e0f7bdc10b60$export$d927fcb6adf8f9de, (v) => $3bf5e0f7bdc10b60$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $3bf5e0f7bdc10b60$export$b82d16f27459e05a, (v) => $3bf5e0f7bdc10b60$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $3bf5e0f7bdc10b60$export$522c17b4f5e123e8, (v) => $3bf5e0f7bdc10b60$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $3bf5e0f7bdc10b60$export$1aabd8a0274ecfd6, (v) => $3bf5e0f7bdc10b60$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $3bf5e0f7bdc10b60$export$9b621391a187a31a, (v) => $3bf5e0f7bdc10b60$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $3bf5e0f7bdc10b60$export$f5bbd400c2f4426f, (v) => $3bf5e0f7bdc10b60$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3bf5e0f7bdc10b60$export$2b8d127b894957b9;
var $3bf5e0f7bdc10b60$export$cea3a54a6425200c;
var $3bf5e0f7bdc10b60$export$a7c73072b1a182ae;
var $3bf5e0f7bdc10b60$export$9f27bc3417b4524d;
var $3bf5e0f7bdc10b60$export$db77ccec0bb4ccac;
var $3bf5e0f7bdc10b60$export$8392c0c9d3dcbd35;
var $3bf5e0f7bdc10b60$export$ffb0004e005737fa;
var $3bf5e0f7bdc10b60$export$b624eff549462981;
var $3bf5e0f7bdc10b60$export$7897aa7841a5380c;
var $3bf5e0f7bdc10b60$export$602eac185826482c;
var $3bf5e0f7bdc10b60$export$e2c29f18771995cb;
var $3bf5e0f7bdc10b60$export$5f8d39834fd61797;
var $3bf5e0f7bdc10b60$export$74bf444e3cd11ea5;
var $3bf5e0f7bdc10b60$export$92387174baf9b227;
var $3bf5e0f7bdc10b60$export$ec112efeb987d9c6;
var $3bf5e0f7bdc10b60$export$b706b080d889d2c9;
var $3bf5e0f7bdc10b60$export$5be5a87408f70ddc;
var $3bf5e0f7bdc10b60$export$45a5e7f76e0caa8d;
var $3bf5e0f7bdc10b60$export$455c2e768291efa6;
var $3bf5e0f7bdc10b60$export$9522e17588c12572;
var $3bf5e0f7bdc10b60$export$2110ac352bb060b9;
var $3bf5e0f7bdc10b60$export$56885ab8b9c456ab;
var $3bf5e0f7bdc10b60$export$d927fcb6adf8f9de;
var $3bf5e0f7bdc10b60$export$b82d16f27459e05a;
var $3bf5e0f7bdc10b60$export$522c17b4f5e123e8;
var $3bf5e0f7bdc10b60$export$1aabd8a0274ecfd6;
var $3bf5e0f7bdc10b60$export$9b621391a187a31a;
var $3bf5e0f7bdc10b60$export$f5bbd400c2f4426f;
'use strict';
var $3bf5e0f7bdc10b60$var$b = "function" === typeof Symbol && Symbol.for, $3bf5e0f7bdc10b60$var$c = $3bf5e0f7bdc10b60$var$b ? Symbol.for("react.element") : 60103, $3bf5e0f7bdc10b60$var$d = $3bf5e0f7bdc10b60$var$b ? Symbol.for("react.portal") : 60106, $3bf5e0f7bdc10b60$var$e = $3bf5e0f7bdc10b60$var$b ? Symbol.for("react.fragment") : 60107, $3bf5e0f7bdc10b60$var$f = $3bf5e0f7bdc10b60$var$b ? Symbol.for("react.strict_mode") : 60108, $3bf5e0f7bdc10b60$var$g = $3bf5e0f7bdc10b60$var$b ? Symbol.for("react.profiler") : 60114, $3bf5e0f7bdc10b60$var$h = $3bf5e0f7bdc10b60$var$b ? Symbol.for("react.provider") : 60109, $3bf5e0f7bdc10b60$var$k = $3bf5e0f7bdc10b60$var$b ? Symbol.for("react.context") : 60110, $3bf5e0f7bdc10b60$var$l = $3bf5e0f7bdc10b60$var$b ? Symbol.for("react.async_mode") : 60111, $3bf5e0f7bdc10b60$var$m = $3bf5e0f7bdc10b60$var$b ? Symbol.for("react.concurrent_mode") : 60111, $3bf5e0f7bdc10b60$var$n = $3bf5e0f7bdc10b60$var$b ? Symbol.for("react.forward_ref") : 60112, $3bf5e0f7bdc10b60$var$p = $3bf5e0f7bdc10b60$var$b ? Symbol.for("react.suspense") : 60113, $3bf5e0f7bdc10b60$var$q = $3bf5e0f7bdc10b60$var$b ? Symbol.for("react.suspense_list") : 60120, $3bf5e0f7bdc10b60$var$r = $3bf5e0f7bdc10b60$var$b ? Symbol.for("react.memo") : 60115, $3bf5e0f7bdc10b60$var$t = $3bf5e0f7bdc10b60$var$b ? Symbol.for("react.lazy") : 60116, $3bf5e0f7bdc10b60$var$v = $3bf5e0f7bdc10b60$var$b ? Symbol.for("react.block") : 60121, $3bf5e0f7bdc10b60$var$w = $3bf5e0f7bdc10b60$var$b ? Symbol.for("react.fundamental") : 60117, $3bf5e0f7bdc10b60$var$x = $3bf5e0f7bdc10b60$var$b ? Symbol.for("react.responder") : 60118, $3bf5e0f7bdc10b60$var$y = $3bf5e0f7bdc10b60$var$b ? Symbol.for("react.scope") : 60119;
function $3bf5e0f7bdc10b60$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $3bf5e0f7bdc10b60$var$c:
                switch(a = a.type, a){
                    case $3bf5e0f7bdc10b60$var$l:
                    case $3bf5e0f7bdc10b60$var$m:
                    case $3bf5e0f7bdc10b60$var$e:
                    case $3bf5e0f7bdc10b60$var$g:
                    case $3bf5e0f7bdc10b60$var$f:
                    case $3bf5e0f7bdc10b60$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $3bf5e0f7bdc10b60$var$k:
                            case $3bf5e0f7bdc10b60$var$n:
                            case $3bf5e0f7bdc10b60$var$t:
                            case $3bf5e0f7bdc10b60$var$r:
                            case $3bf5e0f7bdc10b60$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $3bf5e0f7bdc10b60$var$d:
                return u;
        }
    }
}
function $3bf5e0f7bdc10b60$var$A(a) {
    return $3bf5e0f7bdc10b60$var$z(a) === $3bf5e0f7bdc10b60$var$m;
}
$3bf5e0f7bdc10b60$export$2b8d127b894957b9 = $3bf5e0f7bdc10b60$var$l;
$3bf5e0f7bdc10b60$export$cea3a54a6425200c = $3bf5e0f7bdc10b60$var$m;
$3bf5e0f7bdc10b60$export$a7c73072b1a182ae = $3bf5e0f7bdc10b60$var$k;
$3bf5e0f7bdc10b60$export$9f27bc3417b4524d = $3bf5e0f7bdc10b60$var$h;
$3bf5e0f7bdc10b60$export$db77ccec0bb4ccac = $3bf5e0f7bdc10b60$var$c;
$3bf5e0f7bdc10b60$export$8392c0c9d3dcbd35 = $3bf5e0f7bdc10b60$var$n;
$3bf5e0f7bdc10b60$export$ffb0004e005737fa = $3bf5e0f7bdc10b60$var$e;
$3bf5e0f7bdc10b60$export$b624eff549462981 = $3bf5e0f7bdc10b60$var$t;
$3bf5e0f7bdc10b60$export$7897aa7841a5380c = $3bf5e0f7bdc10b60$var$r;
$3bf5e0f7bdc10b60$export$602eac185826482c = $3bf5e0f7bdc10b60$var$d;
$3bf5e0f7bdc10b60$export$e2c29f18771995cb = $3bf5e0f7bdc10b60$var$g;
$3bf5e0f7bdc10b60$export$5f8d39834fd61797 = $3bf5e0f7bdc10b60$var$f;
$3bf5e0f7bdc10b60$export$74bf444e3cd11ea5 = $3bf5e0f7bdc10b60$var$p;
$3bf5e0f7bdc10b60$export$92387174baf9b227 = function(a) {
    return $3bf5e0f7bdc10b60$var$A(a) || $3bf5e0f7bdc10b60$var$z(a) === $3bf5e0f7bdc10b60$var$l;
};
$3bf5e0f7bdc10b60$export$ec112efeb987d9c6 = $3bf5e0f7bdc10b60$var$A;
$3bf5e0f7bdc10b60$export$b706b080d889d2c9 = function(a) {
    return $3bf5e0f7bdc10b60$var$z(a) === $3bf5e0f7bdc10b60$var$k;
};
$3bf5e0f7bdc10b60$export$5be5a87408f70ddc = function(a) {
    return $3bf5e0f7bdc10b60$var$z(a) === $3bf5e0f7bdc10b60$var$h;
};
$3bf5e0f7bdc10b60$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $3bf5e0f7bdc10b60$var$c;
};
$3bf5e0f7bdc10b60$export$455c2e768291efa6 = function(a) {
    return $3bf5e0f7bdc10b60$var$z(a) === $3bf5e0f7bdc10b60$var$n;
};
$3bf5e0f7bdc10b60$export$9522e17588c12572 = function(a) {
    return $3bf5e0f7bdc10b60$var$z(a) === $3bf5e0f7bdc10b60$var$e;
};
$3bf5e0f7bdc10b60$export$2110ac352bb060b9 = function(a) {
    return $3bf5e0f7bdc10b60$var$z(a) === $3bf5e0f7bdc10b60$var$t;
};
$3bf5e0f7bdc10b60$export$56885ab8b9c456ab = function(a) {
    return $3bf5e0f7bdc10b60$var$z(a) === $3bf5e0f7bdc10b60$var$r;
};
$3bf5e0f7bdc10b60$export$d927fcb6adf8f9de = function(a) {
    return $3bf5e0f7bdc10b60$var$z(a) === $3bf5e0f7bdc10b60$var$d;
};
$3bf5e0f7bdc10b60$export$b82d16f27459e05a = function(a) {
    return $3bf5e0f7bdc10b60$var$z(a) === $3bf5e0f7bdc10b60$var$g;
};
$3bf5e0f7bdc10b60$export$522c17b4f5e123e8 = function(a) {
    return $3bf5e0f7bdc10b60$var$z(a) === $3bf5e0f7bdc10b60$var$f;
};
$3bf5e0f7bdc10b60$export$1aabd8a0274ecfd6 = function(a) {
    return $3bf5e0f7bdc10b60$var$z(a) === $3bf5e0f7bdc10b60$var$p;
};
$3bf5e0f7bdc10b60$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $3bf5e0f7bdc10b60$var$e || a === $3bf5e0f7bdc10b60$var$m || a === $3bf5e0f7bdc10b60$var$g || a === $3bf5e0f7bdc10b60$var$f || a === $3bf5e0f7bdc10b60$var$p || a === $3bf5e0f7bdc10b60$var$q || "object" === typeof a && null !== a && (a.$$typeof === $3bf5e0f7bdc10b60$var$t || a.$$typeof === $3bf5e0f7bdc10b60$var$r || a.$$typeof === $3bf5e0f7bdc10b60$var$h || a.$$typeof === $3bf5e0f7bdc10b60$var$k || a.$$typeof === $3bf5e0f7bdc10b60$var$n || a.$$typeof === $3bf5e0f7bdc10b60$var$w || a.$$typeof === $3bf5e0f7bdc10b60$var$x || a.$$typeof === $3bf5e0f7bdc10b60$var$y || a.$$typeof === $3bf5e0f7bdc10b60$var$v);
};
$3bf5e0f7bdc10b60$export$f5bbd400c2f4426f = $3bf5e0f7bdc10b60$var$z;

});

parcelRegister("f4XEI", function(module, exports) {

$parcel$export(module.exports, "createRule", () => createRule);
$parcel$export(module.exports, "toCssValue", () => toCssValue);
$parcel$export(module.exports, "RuleList", () => RuleList);
$parcel$export(module.exports, "create", () => createJss);
$parcel$export(module.exports, "hasCSSTOMSupport", () => hasCSSTOMSupport);
$parcel$export(module.exports, "getDynamicStyles", () => getDynamicStyles);

var $elnlQ = parcelRequire("elnlQ");

var $6gRhZ = parcelRequire("6gRhZ");

var $hA7HB = parcelRequire("hA7HB");

var $fxzEt = parcelRequire("fxzEt");

var $bLCcc = parcelRequire("bLCcc");

var $bnz4d = parcelRequire("bnz4d");

var $fjJNR = parcelRequire("fjJNR");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== 'object') return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = 'unnamed';
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var join = function join(value, by) {
    var result = '';
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === '!important') break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === '!important') break;
        if (cssValue) cssValue += ', ';
        cssValue += join(value[i], ' ');
    }
    else cssValue = join(value, ', '); // Add !important, because it was ignored.
    if (value[value.length - 1] === '!important') cssValue += ' !important';
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: '',
        space: ''
    };
    return {
        linebreak: '\n',
        space: ' '
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = '';
    for(var index = 0; index < indent; index++)result += '  ';
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = '';
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== 'fallbacks') {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = 'style';
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $bLCcc.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $bnz4d.default)((0, $bnz4d.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    };
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== 'object') json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    };
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $elnlQ.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $fxzEt.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = 'conditional';
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $elnlQ.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    };
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
    };
    return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = 'keyframes';
        this.at = '@keyframes';
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = 'noname';
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $elnlQ.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $elnlQ.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === 'string') return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style' || !sheet) return style;
        if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
        if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case 'animation':
                return findReferencedKeyframe(val, sheet.keyframes);
            case 'animation-name':
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $bLCcc.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $elnlQ.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === 'keyframes') return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = 'font-face';
        this.at = '@font-face';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = '';
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = 'viewport';
        this.at = '@viewport';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = 'simple';
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = '';
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += '\n';
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    '@charset': true,
    '@import': true,
    '@namespace': true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $elnlQ.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    };
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $elnlQ.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    };
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    };
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    };
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    };
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    };
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    };
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    };
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    };
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    };
    _proto.toString = function toString(options) {
        var str = '';
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $elnlQ.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    };
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    };
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    };
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    };
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    };
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    };
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    };
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === 'object' ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    };
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    };
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    };
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    };
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    };
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    };
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    };
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    };
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    };
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: 'external'
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    };
    _proto.reset = function reset() {
        this.registry = [];
    };
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    };
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $fjJNR.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = '';
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $fxzEt.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = '';
        var prefix = '';
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return '';
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = toCssValue(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === 'string') {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute('content') : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ('insertRule' in container) container.insertRule(rule, index);
        else if ('appendRule' in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = '\n';
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute('data-jss', '');
        if (media) this.element.setAttribute('media', media);
        if (meta) this.element.setAttribute('data-meta', meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute('nonce', nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    };
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = '\n';
        }
    };
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    };
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    };
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === 'conditional' || rule.type === 'keyframes') {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    };
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    };
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    };
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    };
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $6gRhZ.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: 'internal'
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $elnlQ.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ('Renderer' in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    };
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== 'number') index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $elnlQ.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    };
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    };
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === 'object') return this.createRule(undefined, name, style);
        var ruleOptions = (0, $elnlQ.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $hA7HB.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $hA7HB.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $fxzEt.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === 'function') {
            if (!to) to = {};
            to[key] = value;
        } else if (type === 'object' && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $afa581186bde3971$export$2e2bcd8739ae039 = index;

});
parcelRegister("elnlQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a71523f78be2c21e$export$2e2bcd8739ae039);
function $a71523f78be2c21e$export$2e2bcd8739ae039() {
    return $a71523f78be2c21e$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a71523f78be2c21e$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("6gRhZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $490d92cc597dafb6$export$2e2bcd8739ae039);
var $490d92cc597dafb6$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $490d92cc597dafb6$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $490d92cc597dafb6$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $490d92cc597dafb6$var$_typeof(document)) === 'object' && document.nodeType === 9;
var $490d92cc597dafb6$export$2e2bcd8739ae039 = $490d92cc597dafb6$export$4e09c449d6c407f7;

});

parcelRegister("hA7HB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cccbc5f801a0b1d9$export$2e2bcd8739ae039);
var $cccbc5f801a0b1d9$var$isProduction = true;
function $cccbc5f801a0b1d9$var$warning(condition, message) {
    if (!$cccbc5f801a0b1d9$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $cccbc5f801a0b1d9$export$2e2bcd8739ae039 = $cccbc5f801a0b1d9$var$warning;

});

parcelRegister("fxzEt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b50597ce643df998$export$2e2bcd8739ae039);

var $8ki5x = parcelRequire("8ki5x");
function $b50597ce643df998$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $8ki5x.default)(o.key), o);
    }
}
function $b50597ce643df998$export$2e2bcd8739ae039(e, r, t) {
    return r && $b50597ce643df998$var$_defineProperties(e.prototype, r), t && $b50597ce643df998$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("8ki5x", function(module, exports) {

$parcel$export(module.exports, "default", () => $60fe38f242dafe88$export$2e2bcd8739ae039);

var $69Iz3 = parcelRequire("69Iz3");

var $2WGPg = parcelRequire("2WGPg");
function $60fe38f242dafe88$export$2e2bcd8739ae039(t) {
    var i = (0, $2WGPg.default)(t, "string");
    return "symbol" == (0, $69Iz3.default)(i) ? i : i + "";
}

});
parcelRegister("69Iz3", function(module, exports) {

$parcel$export(module.exports, "default", () => $47b626e19026501a$export$2e2bcd8739ae039);
function $47b626e19026501a$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $47b626e19026501a$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $47b626e19026501a$export$2e2bcd8739ae039(o);
}

});

parcelRegister("2WGPg", function(module, exports) {

$parcel$export(module.exports, "default", () => $225237dac3b64ef7$export$2e2bcd8739ae039);

var $69Iz3 = parcelRequire("69Iz3");
function $225237dac3b64ef7$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $69Iz3.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $69Iz3.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("bLCcc", function(module, exports) {

$parcel$export(module.exports, "default", () => $8911b65b1f07015e$export$2e2bcd8739ae039);

var $bkGme = parcelRequire("bkGme");
function $8911b65b1f07015e$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $bkGme.default)(t, o);
}

});
parcelRegister("bkGme", function(module, exports) {

$parcel$export(module.exports, "default", () => $84026b50571f6772$export$2e2bcd8739ae039);
function $84026b50571f6772$export$2e2bcd8739ae039(t, e) {
    return $84026b50571f6772$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $84026b50571f6772$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("bnz4d", function(module, exports) {

$parcel$export(module.exports, "default", () => $848d0b48ca8a5306$export$2e2bcd8739ae039);
function $848d0b48ca8a5306$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("fjJNR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b26c28ee97e904a8$export$2e2bcd8739ae039);
function $b26c28ee97e904a8$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("fVt0T", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("8ziF9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $63d011a0878cb975$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");
parcelRequire("1ndZg");
var $5VUYT = parcelRequire("5VUYT");

var $508Sg = parcelRequire("508Sg");

var $iJOrq = parcelRequire("iJOrq");

var $6VnXl = parcelRequire("6VnXl");

var $gxOk8 = parcelRequire("gxOk8");

var $6A5XN = parcelRequire("6A5XN");
var $63d011a0878cb975$var$Accordion = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(props, ref) {
    var _useUncontrolled = (0, $5VUYT.default)(props, {
        activeKey: 'onSelect'
    }), _useUncontrolled$as = _useUncontrolled.as, Component = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as, activeKey = _useUncontrolled.activeKey, bsPrefix = _useUncontrolled.bsPrefix, children = _useUncontrolled.children, className = _useUncontrolled.className, onSelect = _useUncontrolled.onSelect, controlledProps = (0, $fjJNR.default)(_useUncontrolled, [
        "as",
        "activeKey",
        "bsPrefix",
        "children",
        "className",
        "onSelect"
    ]);
    var finalClassName = (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'accordion'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $6A5XN.default).Provider, {
        value: activeKey || null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $6VnXl.default).Provider, {
        value: onSelect || null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({
        ref: ref
    }, controlledProps, {
        className: finalClassName
    }), children)));
});
$63d011a0878cb975$var$Accordion.displayName = 'Accordion';
$63d011a0878cb975$var$Accordion.Toggle = (0, $iJOrq.default);
$63d011a0878cb975$var$Accordion.Collapse = (0, $gxOk8.default);
var $63d011a0878cb975$export$2e2bcd8739ae039 = $63d011a0878cb975$var$Accordion;

});
parcelRegister("1ndZg", function(module, exports) {

$parcel$export(module.exports, "useUncontrolled", () => (parcelRequire("5VUYT")).default);
$parcel$export(module.exports, "useUncontrolledProp", () => (parcelRequire("5VUYT")).useUncontrolledProp);

var $5VUYT = parcelRequire("5VUYT");

var $9BUqZ = parcelRequire("9BUqZ");

});
parcelRegister("5VUYT", function(module, exports) {

$parcel$export(module.exports, "useUncontrolledProp", () => $451e79e1a2b0d46e$export$2ee51287a16ca325);
$parcel$export(module.exports, "default", () => $451e79e1a2b0d46e$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $Fo7oF = parcelRequire("Fo7oF");

var $hKvBW = parcelRequire("hKvBW");
function $451e79e1a2b0d46e$var$_toPropertyKey(arg) {
    var key = $451e79e1a2b0d46e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $451e79e1a2b0d46e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $451e79e1a2b0d46e$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $Fo7oF.useRef)(propValue !== undefined);
    var _useState = (0, $Fo7oF.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $Fo7oF.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $451e79e1a2b0d46e$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$hKvBW.defaultKey(fieldName)], propsValue = _ref[fieldName], rest = (0, $fjJNR.default)(_ref, [
            $hKvBW.defaultKey(fieldName),
            fieldName
        ].map($451e79e1a2b0d46e$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $451e79e1a2b0d46e$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $elnlQ.default)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}

});
parcelRegister("hKvBW", function(module, exports) {

$parcel$export(module.exports, "defaultKey", () => $cebf40d3f6c8b0a5$export$26cbf8c37e721e67);
$parcel$export(module.exports, "uncontrolledPropTypes", () => $cebf40d3f6c8b0a5$export$8abd944bed26e726);
$parcel$export(module.exports, "isProp", () => $cebf40d3f6c8b0a5$export$12ae2baa35bd9b8b);
$parcel$export(module.exports, "canAcceptRef", () => $cebf40d3f6c8b0a5$export$95e5b18573b29087);
parcelRequire("8Mkf1");
var $cebf40d3f6c8b0a5$var$noop = function noop() {};
function $cebf40d3f6c8b0a5$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $cebf40d3f6c8b0a5$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $cebf40d3f6c8b0a5$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$cebf40d3f6c8b0a5$export$26cbf8c37e721e67(prop)] = $cebf40d3f6c8b0a5$var$noop;
        var handler;
    });
    return propTypes;
}
function $cebf40d3f6c8b0a5$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $cebf40d3f6c8b0a5$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $cebf40d3f6c8b0a5$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}

});
parcelRegister("8Mkf1", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $664281e9015f9457$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $664281e9015f9457$var$invariant;

});



parcelRegister("9BUqZ", function(module, exports) {

var $fjJNR = parcelRequire("fjJNR");

var $elnlQ = parcelRequire("elnlQ");

var $bLCcc = parcelRequire("bLCcc");

var $Fo7oF = parcelRequire("Fo7oF");

var $6YhMy = parcelRequire("6YhMy");

var $8Mkf1 = parcelRequire("8Mkf1");

var $hKvBW = parcelRequire("hKvBW");
var $6ff358731cd80341$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $6ff358731cd80341$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $hKvBW.canAcceptRef(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($hKvBW.defaultKey);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($8Mkf1)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $bLCcc.default)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $elnlQ.default)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$hKvBW.defaultKey(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $elnlQ.default)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$hKvBW.isProp(props, key) && $hKvBW.isProp(prevProps, key)) nextState.values[key] = props[$hKvBW.defaultKey(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $fjJNR.default)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component);
    (0, $6YhMy.polyfill)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $elnlQ.default)({
        innerRef: function innerRef() {}
    }, $hKvBW.uncontrolledPropTypes(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(UncontrolledComponent, (0, $elnlQ.default)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $6ff358731cd80341$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $6ff358731cd80341$export$2e2bcd8739ae039(newComponent, (0, $elnlQ.default)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}

});
parcelRegister("6YhMy", function(module, exports) {

$parcel$export(module.exports, "polyfill", () => $513623d1cf084e6d$export$cea1c58a6db52bca);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $513623d1cf084e6d$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $513623d1cf084e6d$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $513623d1cf084e6d$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$513623d1cf084e6d$var$componentWillMount.__suppressDeprecationWarning = true;
$513623d1cf084e6d$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$513623d1cf084e6d$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $513623d1cf084e6d$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $513623d1cf084e6d$var$componentWillMount;
        prototype.componentWillReceiveProps = $513623d1cf084e6d$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $513623d1cf084e6d$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});



parcelRegister("508Sg", function(module, exports) {

$parcel$export(module.exports, "useBootstrapPrefix", () => $3a43d60ea204af26$export$7f387860ebffb32c);

var $elnlQ = parcelRequire("elnlQ");

var $Fo7oF = parcelRequire("Fo7oF");
var $3a43d60ea204af26$var$ThemeContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createContext({});
var $3a43d60ea204af26$export$b631efc24e9d5e2f = $3a43d60ea204af26$var$ThemeContext.Consumer, $3a43d60ea204af26$var$Provider = $3a43d60ea204af26$var$ThemeContext.Provider;
function $3a43d60ea204af26$var$ThemeProvider(_ref) {
    var prefixes = _ref.prefixes, children = _ref.children;
    var copiedPrefixes = (0, $Fo7oF.useMemo)(function() {
        return (0, $elnlQ.default)({}, prefixes);
    }, [
        prefixes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement($3a43d60ea204af26$var$Provider, {
        value: copiedPrefixes
    }, children);
}
function $3a43d60ea204af26$export$7f387860ebffb32c(prefix, defaultPrefix) {
    var prefixes = (0, $Fo7oF.useContext)($3a43d60ea204af26$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $3a43d60ea204af26$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    var isClassy = Component.prototype && Component.prototype.isReactComponent; // If it's a functional component make sure we don't break it with a ref
    var _opts = opts, prefix = _opts.prefix, _opts$forwardRefAs = _opts.forwardRefAs, forwardRefAs = _opts$forwardRefAs === void 0 ? isClassy ? 'ref' : 'innerRef' : _opts$forwardRefAs;
    var Wrapped = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref2, ref) {
        var props = (0, $elnlQ.default)({}, _ref2);
        props[forwardRefAs] = ref;
        var bsPrefix = $3a43d60ea204af26$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, props, {
            bsPrefix: bsPrefix
        }));
    });
    Wrapped.displayName = "Bootstrap(" + (Component.displayName || Component.name) + ")";
    return Wrapped;
}
var $3a43d60ea204af26$export$2e2bcd8739ae039 = $3a43d60ea204af26$var$ThemeProvider;

});

parcelRegister("iJOrq", function(module, exports) {

$parcel$export(module.exports, "default", () => $da438e8ad3dabb51$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $Fo7oF = parcelRequire("Fo7oF");

var $6VnXl = parcelRequire("6VnXl");

var $6A5XN = parcelRequire("6A5XN");
function $da438e8ad3dabb51$export$3d10dad2c2f3a4ae(eventKey, onClick) {
    var contextEventKey = (0, $Fo7oF.useContext)((0, $6A5XN.default));
    var onSelect = (0, $Fo7oF.useContext)((0, $6VnXl.default));
    return function(e) {
        /*
      Compare the event key in context with the given event key.
      If they are the same, then collapse the component.
    */ var eventKeyPassed = eventKey === contextEventKey ? null : eventKey;
        if (onSelect) onSelect(eventKeyPassed, e);
        if (onClick) onClick(e);
    };
}
var $da438e8ad3dabb51$var$AccordionToggle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, eventKey = _ref.eventKey, onClick = _ref.onClick, props = (0, $fjJNR.default)(_ref, [
        "as",
        "children",
        "eventKey",
        "onClick"
    ]);
    var accordionOnClick = $da438e8ad3dabb51$export$3d10dad2c2f3a4ae(eventKey, onClick);
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({
        ref: ref,
        onClick: accordionOnClick
    }, props), children);
});
var $da438e8ad3dabb51$export$2e2bcd8739ae039 = $da438e8ad3dabb51$var$AccordionToggle;

});
parcelRegister("6VnXl", function(module, exports) {

$parcel$export(module.exports, "makeEventKey", () => $50aaa62166ca6df6$export$eef49b42fde998a3);
$parcel$export(module.exports, "default", () => $50aaa62166ca6df6$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
var $50aaa62166ca6df6$var$SelectableContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createContext(null);
var $50aaa62166ca6df6$export$eef49b42fde998a3 = function makeEventKey(eventKey, href) {
    if (href === void 0) href = null;
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $50aaa62166ca6df6$export$2e2bcd8739ae039 = $50aaa62166ca6df6$var$SelectableContext;

});

parcelRegister("6A5XN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4caabb13409f9210$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
var $4caabb13409f9210$var$context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createContext(null);
$4caabb13409f9210$var$context.displayName = 'AccordionContext';
var $4caabb13409f9210$export$2e2bcd8739ae039 = $4caabb13409f9210$var$context;

});


parcelRegister("gxOk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0b6c3a99a203dbe$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $Fo7oF = parcelRequire("Fo7oF");

var $ev6at = parcelRequire("ev6at");

var $6A5XN = parcelRequire("6A5XN");

var $6VnXl = parcelRequire("6VnXl");
var $c0b6c3a99a203dbe$var$AccordionCollapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var children = _ref.children, eventKey = _ref.eventKey, props = (0, $fjJNR.default)(_ref, [
        "children",
        "eventKey"
    ]);
    var contextEventKey = (0, $Fo7oF.useContext)((0, $6A5XN.default)); // Empty SelectableContext is to prevent elements in the collapse
    // from collapsing the accordion when clicked.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $6VnXl.default).Provider, {
        value: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $ev6at.default), (0, $elnlQ.default)({
        ref: ref,
        in: contextEventKey === eventKey
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Children.only(children))));
});
$c0b6c3a99a203dbe$var$AccordionCollapse.displayName = 'AccordionCollapse';
var $c0b6c3a99a203dbe$export$2e2bcd8739ae039 = $c0b6c3a99a203dbe$var$AccordionCollapse;

});
parcelRegister("ev6at", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a8e8bec4e03ac5e1$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $e0zyR = parcelRequire("e0zyR");

var $Fo7oF = parcelRequire("Fo7oF");

var $dOG8L = parcelRequire("dOG8L");

var $1kNYT = parcelRequire("1kNYT");

var $8HBT4 = parcelRequire("8HBT4");

var $azUrB = parcelRequire("azUrB");
var $a8e8bec4e03ac5e1$var$_collapseStyles;
var $a8e8bec4e03ac5e1$var$MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function $a8e8bec4e03ac5e1$var$getDefaultDimensionValue(dimension, elem) {
    var offset = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
    var value = elem[offset];
    var margins = $a8e8bec4e03ac5e1$var$MARGINS[dimension];
    return value + // @ts-ignore
    parseInt((0, $e0zyR.default)(elem, margins[0]), 10) + // @ts-ignore
    parseInt((0, $e0zyR.default)(elem, margins[1]), 10);
}
var $a8e8bec4e03ac5e1$var$collapseStyles = ($a8e8bec4e03ac5e1$var$_collapseStyles = {}, $a8e8bec4e03ac5e1$var$_collapseStyles[0, $dOG8L.EXITED] = 'collapse', $a8e8bec4e03ac5e1$var$_collapseStyles[0, $dOG8L.EXITING] = 'collapsing', $a8e8bec4e03ac5e1$var$_collapseStyles[0, $dOG8L.ENTERING] = 'collapsing', $a8e8bec4e03ac5e1$var$_collapseStyles[0, $dOG8L.ENTERED] = 'collapse show', $a8e8bec4e03ac5e1$var$_collapseStyles);
var $a8e8bec4e03ac5e1$var$defaultProps = {
    in: false,
    timeout: 300,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    getDimensionValue: $a8e8bec4e03ac5e1$var$getDefaultDimensionValue
};
var $a8e8bec4e03ac5e1$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var onEnter = _ref.onEnter, onEntering = _ref.onEntering, onEntered = _ref.onEntered, onExit = _ref.onExit, onExiting = _ref.onExiting, className = _ref.className, children = _ref.children, _ref$dimension = _ref.dimension, dimension = _ref$dimension === void 0 ? 'height' : _ref$dimension, _ref$getDimensionValu = _ref.getDimensionValue, getDimensionValue = _ref$getDimensionValu === void 0 ? $a8e8bec4e03ac5e1$var$getDefaultDimensionValue : _ref$getDimensionValu, props = (0, $fjJNR.default)(_ref, [
        "onEnter",
        "onEntering",
        "onEntered",
        "onExit",
        "onExiting",
        "className",
        "children",
        "dimension",
        "getDimensionValue"
    ]);
    /* Compute dimension */ var computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ var handleEnter = (0, $Fo7oF.useMemo)(function() {
        return (0, $8HBT4.default)(function(elem) {
            elem.style[computedDimension] = '0';
        }, onEnter);
    }, [
        computedDimension,
        onEnter
    ]);
    var handleEntering = (0, $Fo7oF.useMemo)(function() {
        return (0, $8HBT4.default)(function(elem) {
            var scroll = "scroll" + computedDimension[0].toUpperCase() + computedDimension.slice(1);
            elem.style[computedDimension] = elem[scroll] + "px";
        }, onEntering);
    }, [
        computedDimension,
        onEntering
    ]);
    var handleEntered = (0, $Fo7oF.useMemo)(function() {
        return (0, $8HBT4.default)(function(elem) {
            elem.style[computedDimension] = null;
        }, onEntered);
    }, [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ var handleExit = (0, $Fo7oF.useMemo)(function() {
        return (0, $8HBT4.default)(function(elem) {
            elem.style[computedDimension] = getDimensionValue(computedDimension, elem) + "px";
            (0, $azUrB.default)(elem);
        }, onExit);
    }, [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    var handleExiting = (0, $Fo7oF.useMemo)(function() {
        return (0, $8HBT4.default)(function(elem) {
            elem.style[computedDimension] = null;
        }, onExiting);
    }, [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $dOG8L.default // @ts-ignore
    ), (0, $elnlQ.default)({
        ref: ref,
        addEndListener: (0, $1kNYT.default)
    }, props, {
        "aria-expanded": props.role ? props.in : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting
    }), function(state, innerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).cloneElement(children, (0, $elnlQ.default)({}, innerProps, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, children.props.className, $a8e8bec4e03ac5e1$var$collapseStyles[state], computedDimension === 'width' && 'width')
        }));
    });
}); // @ts-ignore
// @ts-ignore
$a8e8bec4e03ac5e1$var$Collapse.defaultProps = $a8e8bec4e03ac5e1$var$defaultProps;
var $a8e8bec4e03ac5e1$export$2e2bcd8739ae039 = $a8e8bec4e03ac5e1$var$Collapse;

});
parcelRegister("e0zyR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a32ca67c6d95a4a0$export$2e2bcd8739ae039);

var $bJIp1 = parcelRequire("bJIp1");

var $duuO9 = parcelRequire("duuO9");

var $3Y1qN = parcelRequire("3Y1qN");
function $a32ca67c6d95a4a0$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $duuO9.default)(property)) || (0, $bJIp1.default)(node).getPropertyValue((0, $duuO9.default)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $duuO9.default)(key));
        else if ((0, $3Y1qN.default)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $duuO9.default)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $a32ca67c6d95a4a0$export$2e2bcd8739ae039 = $a32ca67c6d95a4a0$var$style;

});
parcelRegister("bJIp1", function(module, exports) {

$parcel$export(module.exports, "default", () => $88b6571f4f213459$export$2e2bcd8739ae039);

var $V56RG = parcelRequire("V56RG");
function $88b6571f4f213459$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $V56RG.default)(node).getComputedStyle(node, psuedoElement);
}

});
parcelRegister("V56RG", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ab949ab9cb7c7ce$export$2e2bcd8739ae039);

var $kyq9h = parcelRequire("kyq9h");
function $0ab949ab9cb7c7ce$export$2e2bcd8739ae039(node) {
    var doc = (0, $kyq9h.default)(node);
    return doc && doc.defaultView || window;
}

});
parcelRegister("kyq9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef6b44321e8081c0$export$2e2bcd8739ae039);
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $ef6b44321e8081c0$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});



parcelRegister("duuO9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d25f982cab12380$export$2e2bcd8739ae039);
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ 
var $cdiZR = parcelRequire("cdiZR");
var $9d25f982cab12380$var$msPattern = /^ms-/;
function $9d25f982cab12380$export$2e2bcd8739ae039(string) {
    return (0, $cdiZR.default)(string).replace($9d25f982cab12380$var$msPattern, '-ms-');
}

});
parcelRegister("cdiZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e456f4f34b53497$export$2e2bcd8739ae039);
var $8e456f4f34b53497$var$rUpper = /([A-Z])/g;
function $8e456f4f34b53497$export$2e2bcd8739ae039(string) {
    return string.replace($8e456f4f34b53497$var$rUpper, '-$1').toLowerCase();
}

});


parcelRegister("3Y1qN", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e3815eb6e7da4e5$export$2e2bcd8739ae039);
var $2e3815eb6e7da4e5$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $2e3815eb6e7da4e5$export$2e2bcd8739ae039(value) {
    return !!(value && $2e3815eb6e7da4e5$var$supportedTransforms.test(value));
}

});


parcelRegister("dOG8L", function(module, exports) {

$parcel$export(module.exports, "EXITED", () => $a0f0a20cafc90783$export$84cbff306f539230);
$parcel$export(module.exports, "ENTERING", () => $a0f0a20cafc90783$export$df38205c966be359);
$parcel$export(module.exports, "ENTERED", () => $a0f0a20cafc90783$export$78e9e6e3e014d60a);
$parcel$export(module.exports, "EXITING", () => $a0f0a20cafc90783$export$4aacc83d4d59139f);
$parcel$export(module.exports, "default", () => $a0f0a20cafc90783$export$2e2bcd8739ae039);

var $fjJNR = parcelRequire("fjJNR");

var $bLCcc = parcelRequire("bLCcc");


var $Fo7oF = parcelRequire("Fo7oF");

var $bvYwR = parcelRequire("bvYwR");

var $kUwrQ = parcelRequire("kUwrQ");


var $a8RX5 = parcelRequire("a8RX5");

var $9Og96 = parcelRequire("9Og96");
var $a0f0a20cafc90783$export$bb38bb9a1161268 = 'unmounted';
var $a0f0a20cafc90783$export$84cbff306f539230 = 'exited';
var $a0f0a20cafc90783$export$df38205c966be359 = 'entering';
var $a0f0a20cafc90783$export$78e9e6e3e014d60a = 'entered';
var $a0f0a20cafc90783$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $a0f0a20cafc90783$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $bLCcc.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $a0f0a20cafc90783$export$84cbff306f539230;
                _this.appearStatus = $a0f0a20cafc90783$export$df38205c966be359;
            } else initialStatus = $a0f0a20cafc90783$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $a0f0a20cafc90783$export$bb38bb9a1161268;
        else initialStatus = $a0f0a20cafc90783$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $a0f0a20cafc90783$export$bb38bb9a1161268) return {
            status: $a0f0a20cafc90783$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $a0f0a20cafc90783$export$df38205c966be359 && status !== $a0f0a20cafc90783$export$78e9e6e3e014d60a) nextStatus = $a0f0a20cafc90783$export$df38205c966be359;
            } else if (status === $a0f0a20cafc90783$export$df38205c966be359 || status === $a0f0a20cafc90783$export$78e9e6e3e014d60a) nextStatus = $a0f0a20cafc90783$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $a0f0a20cafc90783$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($bvYwR))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $9Og96.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $a0f0a20cafc90783$export$84cbff306f539230) this.setState({
            status: $a0f0a20cafc90783$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($bvYwR))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $kUwrQ.default).disabled) {
            this.safeSetState({
                status: $a0f0a20cafc90783$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $a0f0a20cafc90783$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $a0f0a20cafc90783$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($bvYwR))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $kUwrQ.default).disabled) {
            this.safeSetState({
                status: $a0f0a20cafc90783$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $a0f0a20cafc90783$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $a0f0a20cafc90783$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($bvYwR))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $a0f0a20cafc90783$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $fjJNR.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $a8RX5.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component);
$a0f0a20cafc90783$var$Transition.contextType = (0, $a8RX5.default);
$a0f0a20cafc90783$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $a0f0a20cafc90783$var$noop() {}
$a0f0a20cafc90783$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $a0f0a20cafc90783$var$noop,
    onEntering: $a0f0a20cafc90783$var$noop,
    onEntered: $a0f0a20cafc90783$var$noop,
    onExit: $a0f0a20cafc90783$var$noop,
    onExiting: $a0f0a20cafc90783$var$noop,
    onExited: $a0f0a20cafc90783$var$noop
};
$a0f0a20cafc90783$var$Transition.UNMOUNTED = $a0f0a20cafc90783$export$bb38bb9a1161268;
$a0f0a20cafc90783$var$Transition.EXITED = $a0f0a20cafc90783$export$84cbff306f539230;
$a0f0a20cafc90783$var$Transition.ENTERING = $a0f0a20cafc90783$export$df38205c966be359;
$a0f0a20cafc90783$var$Transition.ENTERED = $a0f0a20cafc90783$export$78e9e6e3e014d60a;
$a0f0a20cafc90783$var$Transition.EXITING = $a0f0a20cafc90783$export$4aacc83d4d59139f;
var $a0f0a20cafc90783$export$2e2bcd8739ae039 = $a0f0a20cafc90783$var$Transition;

});
parcelRegister("bvYwR", function(module, exports) {
'use strict';
function $86218abe117206c6$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($86218abe117206c6$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$86218abe117206c6$var$checkDCE();

module.exports = (parcelRequire("ehGlY"));

});

parcelRegister("kUwrQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f392351b27fbbdf8$export$2e2bcd8739ae039);
var $f392351b27fbbdf8$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("a8RX5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7624808200fac4e9$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
var $7624808200fac4e9$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createContext(null);

});

parcelRegister("9Og96", function(module, exports) {

$parcel$export(module.exports, "forceReflow", () => $72454ec5de54ed96$export$7d26bbb1236dafd6);
var $72454ec5de54ed96$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("1kNYT", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f8e6de6bc5e1738$export$2e2bcd8739ae039);

var $3dbbQ = parcelRequire("3dbbQ");
function $0f8e6de6bc5e1738$export$2e2bcd8739ae039(element, handler) {
    var remove = (0, $3dbbQ.default)(element, function(e) {
        if (e.target === element) {
            remove();
            handler(e);
        }
    });
}

});
parcelRegister("3dbbQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $256b441f18ed61a8$export$2e2bcd8739ae039);

var $e0zyR = parcelRequire("e0zyR");

var $1KSyE = parcelRequire("1KSyE");

var $fsZbr = parcelRequire("fsZbr");
function $256b441f18ed61a8$var$parseDuration(node) {
    var str = (0, $e0zyR.default)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $256b441f18ed61a8$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $fsZbr.default)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $1KSyE.default)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $256b441f18ed61a8$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $256b441f18ed61a8$var$parseDuration(element) || 0;
    var removeEmulate = $256b441f18ed61a8$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $1KSyE.default)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}

});
parcelRegister("1KSyE", function(module, exports) {

$parcel$export(module.exports, "default", () => $1474685fe95d539f$export$2e2bcd8739ae039);

var $6XdXy = parcelRequire("6XdXy");

var $gXRE3 = parcelRequire("gXRE3");
function $1474685fe95d539f$var$listen(node, eventName, handler, options) {
    (0, $6XdXy.default)(node, eventName, handler, options);
    return function() {
        (0, $gXRE3.default)(node, eventName, handler, options);
    };
}
var $1474685fe95d539f$export$2e2bcd8739ae039 = $1474685fe95d539f$var$listen;

});
parcelRegister("6XdXy", function(module, exports) {

$parcel$export(module.exports, "default", () => $510314d8f82e9877$export$2e2bcd8739ae039);
/* eslint-disable no-return-assign */ 
var $9m3pg = parcelRequire("9m3pg");
var $510314d8f82e9877$export$63fefd044b2bc624 = false;
var $510314d8f82e9877$export$a614c6b395900f69 = false;
try {
    var $510314d8f82e9877$var$options = {
        get passive () {
            return $510314d8f82e9877$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $510314d8f82e9877$export$a614c6b395900f69 = $510314d8f82e9877$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $9m3pg.default) {
        window.addEventListener('test', $510314d8f82e9877$var$options, $510314d8f82e9877$var$options);
        window.removeEventListener('test', $510314d8f82e9877$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $510314d8f82e9877$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$510314d8f82e9877$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$510314d8f82e9877$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $510314d8f82e9877$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $510314d8f82e9877$export$2e2bcd8739ae039 = $510314d8f82e9877$var$addEventListener;

});
parcelRegister("9m3pg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cf8cf9cbbbe62c6$export$2e2bcd8739ae039);
var $6cf8cf9cbbbe62c6$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

});


parcelRegister("gXRE3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c59bc4d5ffceedd7$export$2e2bcd8739ae039);
/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $c59bc4d5ffceedd7$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $c59bc4d5ffceedd7$export$2e2bcd8739ae039 = $c59bc4d5ffceedd7$var$removeEventListener;

});


parcelRegister("fsZbr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b428ee4d2362d9be$export$2e2bcd8739ae039);
/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $b428ee4d2362d9be$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}

});



parcelRegister("8HBT4", function(module, exports) {

$parcel$export(module.exports, "default", () => $655fba7f61207d2a$export$2e2bcd8739ae039);
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $655fba7f61207d2a$var$createChainedFunction() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    return funcs.filter(function(f) {
        return f != null;
    }).reduce(function(acc, f) {
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            // @ts-ignore
            acc.apply(this, args); // @ts-ignore
            f.apply(this, args);
        };
    }, null);
}
var $655fba7f61207d2a$export$2e2bcd8739ae039 = $655fba7f61207d2a$var$createChainedFunction;

});

parcelRegister("azUrB", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b38f4ed86f05526$export$2e2bcd8739ae039);
// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $7b38f4ed86f05526$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}

});




parcelRegister("6MAJg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4f03b76b055eee9a$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");

var $dwZwr = parcelRequire("dwZwr");
var $4f03b76b055eee9a$var$defaultProps = {
    variant: 'primary',
    active: false,
    disabled: false
};
var $4f03b76b055eee9a$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, variant = _ref.variant, size = _ref.size, active = _ref.active, className = _ref.className, block = _ref.block, type = _ref.type, as = _ref.as, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "variant",
        "size",
        "active",
        "className",
        "block",
        "type",
        "as"
    ]);
    var prefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'btn');
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, prefix, active && 'active', variant && prefix + "-" + variant, block && prefix + "-block", size && prefix + "-" + size);
    if (props.href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $dwZwr.default), (0, $elnlQ.default)({}, props, {
        as: as,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(classes, props.disabled && 'disabled')
    }));
    if (ref) props.ref = ref;
    if (type) props.type = type;
    else if (!as) props.type = 'button';
    var Component = as || 'button';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, props, {
        className: classes
    }));
});
$4f03b76b055eee9a$var$Button.displayName = 'Button';
$4f03b76b055eee9a$var$Button.defaultProps = $4f03b76b055eee9a$var$defaultProps;
var $4f03b76b055eee9a$export$2e2bcd8739ae039 = $4f03b76b055eee9a$var$Button;

});
parcelRegister("dwZwr", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d9dfc93860facb9$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $Fo7oF = parcelRequire("Fo7oF");

var $8HBT4 = parcelRequire("8HBT4");
function $9d9dfc93860facb9$var$isTrivialHref(href) {
    return !href || href.trim() === '#';
}
/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, DropdownItems, etc.
 */ var $9d9dfc93860facb9$var$SafeAnchor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'a' : _ref$as, disabled = _ref.disabled, onKeyDown = _ref.onKeyDown, props = (0, $fjJNR.default)(_ref, [
        "as",
        "disabled",
        "onKeyDown"
    ]);
    var handleClick = function handleClick(event) {
        var href = props.href, onClick = props.onClick;
        if (disabled || $9d9dfc93860facb9$var$isTrivialHref(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        if (onClick) onClick(event);
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if ($9d9dfc93860facb9$var$isTrivialHref(props.href)) {
        props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
        // otherwise, the cursor incorrectly styled (except with role='button')
        props.href = props.href || '#';
    }
    if (disabled) {
        props.tabIndex = -1;
        props['aria-disabled'] = true;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({
        ref: ref
    }, props, {
        onClick: handleClick,
        onKeyDown: (0, $8HBT4.default)(handleKeyDown, onKeyDown)
    }));
});
$9d9dfc93860facb9$var$SafeAnchor.displayName = 'SafeAnchor';
var $9d9dfc93860facb9$export$2e2bcd8739ae039 = $9d9dfc93860facb9$var$SafeAnchor;

});


parcelRegister("drDkQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9c9c4f23e4819bb6$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");

var $ghpJm = parcelRequire("ghpJm");

var $6Buwg = parcelRequire("6Buwg");

var $exUOK = parcelRequire("exUOK");

var $f7rri = parcelRequire("f7rri");
var $9c9c4f23e4819bb6$var$DivStyledAsH5 = (0, $6Buwg.default)('h5');
var $9c9c4f23e4819bb6$var$DivStyledAsH6 = (0, $6Buwg.default)('h6');
var $9c9c4f23e4819bb6$var$CardBody = (0, $ghpJm.default)('card-body');
var $9c9c4f23e4819bb6$var$CardTitle = (0, $ghpJm.default)('card-title', {
    Component: $9c9c4f23e4819bb6$var$DivStyledAsH5
});
var $9c9c4f23e4819bb6$var$CardSubtitle = (0, $ghpJm.default)('card-subtitle', {
    Component: $9c9c4f23e4819bb6$var$DivStyledAsH6
});
var $9c9c4f23e4819bb6$var$CardLink = (0, $ghpJm.default)('card-link', {
    Component: 'a'
});
var $9c9c4f23e4819bb6$var$CardText = (0, $ghpJm.default)('card-text', {
    Component: 'p'
});
var $9c9c4f23e4819bb6$var$CardHeader = (0, $ghpJm.default)('card-header');
var $9c9c4f23e4819bb6$var$CardFooter = (0, $ghpJm.default)('card-footer');
var $9c9c4f23e4819bb6$var$CardImgOverlay = (0, $ghpJm.default)('card-img-overlay');
var $9c9c4f23e4819bb6$var$defaultProps = {
    body: false
};
var $9c9c4f23e4819bb6$var$Card = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, bg = _ref.bg, text = _ref.text, border = _ref.border, body = _ref.body, children = _ref.children, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "className",
        "bg",
        "text",
        "border",
        "body",
        "children",
        "as"
    ]);
    var prefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'card');
    var cardContext = (0, $Fo7oF.useMemo)(function() {
        return {
            cardHeaderBsPrefix: prefix + "-header"
        };
    }, [
        prefix
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $exUOK.default).Provider, {
        value: cardContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, prefix, bg && "bg-" + bg, text && "text-" + text, border && "border-" + border)
    }), body ? /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement($9c9c4f23e4819bb6$var$CardBody, null, children) : children));
});
$9c9c4f23e4819bb6$var$Card.displayName = 'Card';
$9c9c4f23e4819bb6$var$Card.defaultProps = $9c9c4f23e4819bb6$var$defaultProps;
$9c9c4f23e4819bb6$var$Card.Img = (0, $f7rri.default);
$9c9c4f23e4819bb6$var$Card.Title = $9c9c4f23e4819bb6$var$CardTitle;
$9c9c4f23e4819bb6$var$Card.Subtitle = $9c9c4f23e4819bb6$var$CardSubtitle;
$9c9c4f23e4819bb6$var$Card.Body = $9c9c4f23e4819bb6$var$CardBody;
$9c9c4f23e4819bb6$var$Card.Link = $9c9c4f23e4819bb6$var$CardLink;
$9c9c4f23e4819bb6$var$Card.Text = $9c9c4f23e4819bb6$var$CardText;
$9c9c4f23e4819bb6$var$Card.Header = $9c9c4f23e4819bb6$var$CardHeader;
$9c9c4f23e4819bb6$var$Card.Footer = $9c9c4f23e4819bb6$var$CardFooter;
$9c9c4f23e4819bb6$var$Card.ImgOverlay = $9c9c4f23e4819bb6$var$CardImgOverlay;
var $9c9c4f23e4819bb6$export$2e2bcd8739ae039 = $9c9c4f23e4819bb6$var$Card;

});
parcelRegister("ghpJm", function(module, exports) {

$parcel$export(module.exports, "default", () => $bda2316f629e4df8$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $bA4Jj = parcelRequire("bA4Jj");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");
var $bda2316f629e4df8$var$pascalCase = function pascalCase(str) {
    return str[0].toUpperCase() + (0, $bA4Jj.default)(str).slice(1);
};
function $bda2316f629e4df8$export$2e2bcd8739ae039(prefix, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$displayName = _ref.displayName, displayName = _ref$displayName === void 0 ? $bda2316f629e4df8$var$pascalCase(prefix) : _ref$displayName, Component = _ref.Component, defaultProps = _ref.defaultProps;
    var BsComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref2, ref) {
        var className = _ref2.className, bsPrefix = _ref2.bsPrefix, _ref2$as = _ref2.as, Tag = _ref2$as === void 0 ? Component || 'div' : _ref2$as, props = (0, $fjJNR.default)(_ref2, [
            "className",
            "bsPrefix",
            "as"
        ]);
        var resolvedPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, prefix);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Tag, (0, $elnlQ.default)({
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, resolvedPrefix)
        }, props));
    });
    BsComponent.defaultProps = defaultProps;
    BsComponent.displayName = displayName;
    return BsComponent;
}

});
parcelRegister("bA4Jj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $86e6b9c1759cfbe6$export$2e2bcd8739ae039);
var $86e6b9c1759cfbe6$var$rHyphen = /-(.)/g;
function $86e6b9c1759cfbe6$export$2e2bcd8739ae039(string) {
    return string.replace($86e6b9c1759cfbe6$var$rHyphen, function(_, chr) {
        return chr.toUpperCase();
    });
}

});


parcelRegister("6Buwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ceddf4521dc24a4$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $Fo7oF = parcelRequire("Fo7oF");

var $fVt0T = parcelRequire("fVt0T");
var $4ceddf4521dc24a4$export$2e2bcd8739ae039 = function(className) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(p, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", (0, $elnlQ.default)({}, p, {
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(p.className, className)
        }));
    });
};

});

parcelRegister("exUOK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a970388d1b0c83d4$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
var $a970388d1b0c83d4$var$context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createContext(null);
$a970388d1b0c83d4$var$context.displayName = 'CardContext';
var $a970388d1b0c83d4$export$2e2bcd8739ae039 = $a970388d1b0c83d4$var$context;

});

parcelRegister("f7rri", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b01ccb5902ff89c2$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");
var $b01ccb5902ff89c2$var$defaultProps = {
    variant: null
};
var $b01ccb5902ff89c2$var$CardImg = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, variant = _ref.variant, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'img' : _ref$as, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "className",
        "variant",
        "as"
    ]);
    var prefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'card-img');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(variant ? prefix + "-" + variant : prefix, className)
    }, props));
});
$b01ccb5902ff89c2$var$CardImg.displayName = 'CardImg';
$b01ccb5902ff89c2$var$CardImg.defaultProps = $b01ccb5902ff89c2$var$defaultProps;
var $b01ccb5902ff89c2$export$2e2bcd8739ae039 = $b01ccb5902ff89c2$var$CardImg;

});


parcelRegister("clW5X", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8fe482ac893fbe07$var$all;

var $f6O08 = parcelRequire("f6O08");
var $8fe482ac893fbe07$var$_createChainableTypeChecker2 = $8fe482ac893fbe07$var$_interopRequireDefault($f6O08);
function $8fe482ac893fbe07$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8fe482ac893fbe07$var$all() {
    for(var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++)validators[_key] = arguments[_key];
    function allPropTypes() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var error = null;
        validators.forEach(function(validator) {
            if (error != null) return;
            var result = validator.apply(undefined, args);
            if (result != null) error = result;
        });
        return error;
    }
    return (0, $8fe482ac893fbe07$var$_createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = module.exports['default'];

});
parcelRegister("f6O08", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $affe33c4f76f76a5$var$createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ // Mostly taken from ReactPropTypes.
function $affe33c4f76f76a5$var$createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || '<<anonymous>>';
        var propFullNameSafe = propFullName || propName;
        if (props[propName] == null) {
            if (isRequired) return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
            return null;
        }
        for(var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)args[_key - 6] = arguments[_key];
        return validate.apply(undefined, [
            props,
            propName,
            componentNameSafe,
            location,
            propFullNameSafe
        ].concat(args));
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
module.exports = module.exports['default'];

});


parcelRegister("gJ3n2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c2d376a9b0a822b8$var$isRequiredForA11y;
function $c2d376a9b0a822b8$var$isRequiredForA11y(validator) {
    return function validate(props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || '<<anonymous>>';
        var propFullNameSafe = propFullName || propName;
        if (props[propName] == null) return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
        for(var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++)args[_key - 5] = arguments[_key];
        return validator.apply(undefined, [
            props,
            propName,
            componentName,
            location,
            propFullName
        ].concat(args));
    };
}
module.exports = module.exports['default'];

});

parcelRegister("gQ4vH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c4250051c3c963da$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");
parcelRequire("1ndZg");
var $5VUYT = parcelRequire("5VUYT");

var $7i6aT = parcelRequire("7i6aT");

var $508Sg = parcelRequire("508Sg");

var $b5rGi = parcelRequire("b5rGi");

var $9vybq = parcelRequire("9vybq");

var $6Buwg = parcelRequire("6Buwg");

var $ghpJm = parcelRequire("ghpJm");

var $dwZwr = parcelRequire("dwZwr");
var $c4250051c3c963da$var$DivStyledAsH4 = (0, $6Buwg.default)('h4');
$c4250051c3c963da$var$DivStyledAsH4.displayName = 'DivStyledAsH4';
var $c4250051c3c963da$var$AlertHeading = (0, $ghpJm.default)('alert-heading', {
    Component: $c4250051c3c963da$var$DivStyledAsH4
});
var $c4250051c3c963da$var$AlertLink = (0, $ghpJm.default)('alert-link', {
    Component: (0, $dwZwr.default)
});
var $c4250051c3c963da$var$defaultProps = {
    show: true,
    transition: (0, $b5rGi.default),
    closeLabel: 'Close alert'
};
var $c4250051c3c963da$var$Alert = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(uncontrolledProps, ref) {
    var _useUncontrolled = (0, $5VUYT.default)(uncontrolledProps, {
        show: 'onClose'
    }), bsPrefix = _useUncontrolled.bsPrefix, show = _useUncontrolled.show, closeLabel = _useUncontrolled.closeLabel, className = _useUncontrolled.className, children = _useUncontrolled.children, variant = _useUncontrolled.variant, onClose = _useUncontrolled.onClose, dismissible = _useUncontrolled.dismissible, transition = _useUncontrolled.transition, props = (0, $fjJNR.default)(_useUncontrolled, [
        "bsPrefix",
        "show",
        "closeLabel",
        "className",
        "children",
        "variant",
        "onClose",
        "dismissible",
        "transition"
    ]);
    var prefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'alert');
    var handleClose = (0, $7i6aT.default)(function(e) {
        if (onClose) onClose(false, e);
    });
    var Transition = transition === true ? (0, $b5rGi.default) : transition;
    var alert = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", (0, $elnlQ.default)({
        role: "alert"
    }, !Transition ? props : undefined, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, prefix, variant && prefix + "-" + variant, dismissible && prefix + "-dismissible")
    }), dismissible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $9vybq.default), {
        onClick: handleClose,
        label: closeLabel
    }), children);
    if (!Transition) return show ? alert : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Transition, (0, $elnlQ.default)({
        unmountOnExit: true
    }, props, {
        ref: undefined,
        in: show
    }), alert);
});
$c4250051c3c963da$var$Alert.displayName = 'Alert';
$c4250051c3c963da$var$Alert.defaultProps = $c4250051c3c963da$var$defaultProps;
$c4250051c3c963da$var$Alert.Link = $c4250051c3c963da$var$AlertLink;
$c4250051c3c963da$var$Alert.Heading = $c4250051c3c963da$var$AlertHeading;
var $c4250051c3c963da$export$2e2bcd8739ae039 = $c4250051c3c963da$var$Alert;

});
parcelRegister("7i6aT", function(module, exports) {

$parcel$export(module.exports, "default", () => $54ef00fe2dcd86d2$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");

var $54D5T = parcelRequire("54D5T");
function $54ef00fe2dcd86d2$export$2e2bcd8739ae039(fn) {
    var ref = (0, $54D5T.default)(fn);
    return (0, $Fo7oF.useCallback)(function() {
        return ref.current && ref.current.apply(ref, arguments);
    }, [
        ref
    ]);
}

});
parcelRegister("54D5T", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b1ba6ba84722ba7$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded befor being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $3b1ba6ba84722ba7$var$useCommittedRef(value) {
    var ref = (0, $Fo7oF.useRef)(value);
    (0, $Fo7oF.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $3b1ba6ba84722ba7$export$2e2bcd8739ae039 = $3b1ba6ba84722ba7$var$useCommittedRef;

});


parcelRegister("b5rGi", function(module, exports) {

$parcel$export(module.exports, "default", () => $8125a23d4b4d933b$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $dOG8L = parcelRequire("dOG8L");

var $1kNYT = parcelRequire("1kNYT");

var $azUrB = parcelRequire("azUrB");
var $8125a23d4b4d933b$var$_fadeStyles;
var $8125a23d4b4d933b$var$defaultProps = {
    in: false,
    timeout: 300,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false
};
var $8125a23d4b4d933b$var$fadeStyles = ($8125a23d4b4d933b$var$_fadeStyles = {}, $8125a23d4b4d933b$var$_fadeStyles[0, $dOG8L.ENTERING] = 'show', $8125a23d4b4d933b$var$_fadeStyles[0, $dOG8L.ENTERED] = 'show', $8125a23d4b4d933b$var$_fadeStyles);
var $8125a23d4b4d933b$var$Fade = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var className = _ref.className, children = _ref.children, props = (0, $fjJNR.default)(_ref, [
        "className",
        "children"
    ]);
    var handleEnter = (0, $Fo7oF.useCallback)(function(node) {
        (0, $azUrB.default)(node);
        if (props.onEnter) props.onEnter(node);
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $dOG8L.default), (0, $elnlQ.default)({
        ref: ref,
        addEndListener: (0, $1kNYT.default)
    }, props, {
        onEnter: handleEnter
    }), function(status, innerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).cloneElement(children, (0, $elnlQ.default)({}, innerProps, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))('fade', className, children.props.className, $8125a23d4b4d933b$var$fadeStyles[status])
        }));
    });
});
$8125a23d4b4d933b$var$Fade.defaultProps = $8125a23d4b4d933b$var$defaultProps;
$8125a23d4b4d933b$var$Fade.displayName = 'Fade';
var $8125a23d4b4d933b$export$2e2bcd8739ae039 = $8125a23d4b4d933b$var$Fade;

});

parcelRegister("9vybq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ec1866138be7772$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $d2bgE = parcelRequire("d2bgE");

var $Fo7oF = parcelRequire("Fo7oF");

var $fVt0T = parcelRequire("fVt0T");
var $6ec1866138be7772$var$propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func
};
var $6ec1866138be7772$var$defaultProps = {
    label: 'Close'
};
var $6ec1866138be7772$var$CloseButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var label = _ref.label, onClick = _ref.onClick, className = _ref.className, props = (0, $fjJNR.default)(_ref, [
        "label",
        "onClick",
        "className"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("button", (0, $elnlQ.default)({
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))('close', className),
        onClick: onClick
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("span", {
        "aria-hidden": "true"
    }, "\xD7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("span", {
        className: "sr-only"
    }, label));
});
$6ec1866138be7772$var$CloseButton.displayName = 'CloseButton';
$6ec1866138be7772$var$CloseButton.propTypes = $6ec1866138be7772$var$propTypes;
$6ec1866138be7772$var$CloseButton.defaultProps = $6ec1866138be7772$var$defaultProps;
var $6ec1866138be7772$export$2e2bcd8739ae039 = $6ec1866138be7772$var$CloseButton;

});


parcelRegister("jVxV5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e81da6ed2e5a442f$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");
var $e81da6ed2e5a442f$var$defaultProps = {
    pill: false
};
var $e81da6ed2e5a442f$var$Badge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, variant = _ref.variant, pill = _ref.pill, className = _ref.className, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "variant",
        "pill",
        "className",
        "as"
    ]);
    var prefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'badge');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, prefix, pill && prefix + "-pill", variant && prefix + "-" + variant)
    }));
});
$e81da6ed2e5a442f$var$Badge.displayName = 'Badge';
$e81da6ed2e5a442f$var$Badge.defaultProps = $e81da6ed2e5a442f$var$defaultProps;
var $e81da6ed2e5a442f$export$2e2bcd8739ae039 = $e81da6ed2e5a442f$var$Badge;

});

parcelRegister("9uT02", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6ea1942dd8679fb5$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");

var $bu4Ni = parcelRequire("bu4Ni");
var $6ea1942dd8679fb5$var$defaultProps = {
    label: 'breadcrumb',
    listProps: {}
};
var $6ea1942dd8679fb5$var$Breadcrumb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, listProps = _ref.listProps, children = _ref.children, label = _ref.label, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'nav' : _ref$as, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "className",
        "listProps",
        "children",
        "label",
        "as"
    ]);
    var prefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'breadcrumb');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({
        "aria-label": label,
        className: className,
        ref: ref
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("ol", (0, $elnlQ.default)({}, listProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(prefix, listProps == null ? void 0 : listProps.className)
    }), children));
});
$6ea1942dd8679fb5$var$Breadcrumb.displayName = 'Breadcrumb';
$6ea1942dd8679fb5$var$Breadcrumb.defaultProps = $6ea1942dd8679fb5$var$defaultProps;
$6ea1942dd8679fb5$var$Breadcrumb.Item = (0, $bu4Ni.default);
var $6ea1942dd8679fb5$export$2e2bcd8739ae039 = $6ea1942dd8679fb5$var$Breadcrumb;

});
parcelRegister("bu4Ni", function(module, exports) {

$parcel$export(module.exports, "default", () => $85c63712d9f02767$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $dwZwr = parcelRequire("dwZwr");

var $508Sg = parcelRequire("508Sg");
var $85c63712d9f02767$var$defaultProps = {
    active: false,
    linkProps: {}
};
var $85c63712d9f02767$var$BreadcrumbItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, active = _ref.active, children = _ref.children, className = _ref.className, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'li' : _ref$as, _ref$linkAs = _ref.linkAs, LinkComponent = _ref$linkAs === void 0 ? (0, $dwZwr.default) : _ref$linkAs, linkProps = _ref.linkProps, href = _ref.href, title = _ref.title, target = _ref.target, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "active",
        "children",
        "className",
        "as",
        "linkAs",
        "linkProps",
        "href",
        "title",
        "target"
    ]);
    var prefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'breadcrumb-item');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(prefix, className, {
            active: active
        }),
        "aria-current": active ? 'page' : undefined
    }), active ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(LinkComponent, (0, $elnlQ.default)({}, linkProps, {
        href: href,
        title: title,
        target: target
    }), children));
});
$85c63712d9f02767$var$BreadcrumbItem.displayName = 'BreadcrumbItem';
$85c63712d9f02767$var$BreadcrumbItem.defaultProps = $85c63712d9f02767$var$defaultProps;
var $85c63712d9f02767$export$2e2bcd8739ae039 = $85c63712d9f02767$var$BreadcrumbItem;

});


parcelRegister("eB6H1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $aa09b673ca90c80c$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $6MAJg = parcelRequire("6MAJg");
var $aa09b673ca90c80c$var$noop = function noop() {
    return undefined;
};
var $aa09b673ca90c80c$var$ToggleButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var children = _ref.children, name = _ref.name, className = _ref.className, checked = _ref.checked, type = _ref.type, onChange = _ref.onChange, value = _ref.value, disabled = _ref.disabled, inputRef = _ref.inputRef, props = (0, $fjJNR.default)(_ref, [
        "children",
        "name",
        "className",
        "checked",
        "type",
        "onChange",
        "value",
        "disabled",
        "inputRef"
    ]);
    var _useState = (0, $Fo7oF.useState)(false), focused = _useState[0], setFocused = _useState[1];
    var handleFocus = (0, $Fo7oF.useCallback)(function(e) {
        if (e.target.tagName === 'INPUT') setFocused(true);
    }, []);
    var handleBlur = (0, $Fo7oF.useCallback)(function(e) {
        if (e.target.tagName === 'INPUT') setFocused(false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $6MAJg.default), (0, $elnlQ.default)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, focused && 'focus', disabled && 'disabled'),
        type: undefined,
        active: !!checked,
        as: "label"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("input", {
        name: name,
        type: type,
        value: value,
        ref: inputRef,
        autoComplete: "off",
        checked: !!checked,
        disabled: !!disabled,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onChange: onChange || $aa09b673ca90c80c$var$noop
    }), children);
});
$aa09b673ca90c80c$var$ToggleButton.displayName = 'ToggleButton';
var $aa09b673ca90c80c$export$2e2bcd8739ae039 = $aa09b673ca90c80c$var$ToggleButton;

});

parcelRegister("6EcT1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4d70797c4f1aec0c$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");
var $4d70797c4f1aec0c$var$defaultProps = {
    role: 'toolbar'
};
var $4d70797c4f1aec0c$var$ButtonToolbar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "className"
    ]);
    var prefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'btn-toolbar');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", (0, $elnlQ.default)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, prefix)
    }));
});
$4d70797c4f1aec0c$var$ButtonToolbar.displayName = 'ButtonToolbar';
$4d70797c4f1aec0c$var$ButtonToolbar.defaultProps = $4d70797c4f1aec0c$var$defaultProps;
var $4d70797c4f1aec0c$export$2e2bcd8739ae039 = $4d70797c4f1aec0c$var$ButtonToolbar;

});

parcelRegister("4k5Ek", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $325d698dbffcd512$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");
var $325d698dbffcd512$var$defaultProps = {
    vertical: false,
    toggle: false,
    role: 'group'
};
var $325d698dbffcd512$var$ButtonGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, size = _ref.size, toggle = _ref.toggle, vertical = _ref.vertical, className = _ref.className, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, rest = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "size",
        "toggle",
        "vertical",
        "className",
        "as"
    ]);
    var prefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'btn-group');
    var baseClass = prefix;
    if (vertical) baseClass = prefix + "-vertical";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, rest, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, baseClass, size && prefix + "-" + size, toggle && prefix + "-toggle")
    }));
});
$325d698dbffcd512$var$ButtonGroup.displayName = 'ButtonGroup';
$325d698dbffcd512$var$ButtonGroup.defaultProps = $325d698dbffcd512$var$defaultProps;
var $325d698dbffcd512$export$2e2bcd8739ae039 = $325d698dbffcd512$var$ButtonGroup;

});

parcelRegister("563PU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3b607d1332c78329$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $Fo7oF = parcelRequire("Fo7oF");

var $8Mkf1 = parcelRequire("8Mkf1");
parcelRequire("1ndZg");
var $5VUYT = parcelRequire("5VUYT");

var $8HBT4 = parcelRequire("8HBT4");

var $fn04P = parcelRequire("fn04P");

var $4k5Ek = parcelRequire("4k5Ek");

var $eB6H1 = parcelRequire("eB6H1");
var $3b607d1332c78329$var$defaultProps = {
    type: 'radio',
    vertical: false
};
var $3b607d1332c78329$var$ToggleButtonGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(props, ref) {
    var _useUncontrolled = (0, $5VUYT.default)(props, {
        value: 'onChange'
    }), children = _useUncontrolled.children, type = _useUncontrolled.type, name = _useUncontrolled.name, value = _useUncontrolled.value, onChange = _useUncontrolled.onChange, controlledProps = (0, $fjJNR.default)(_useUncontrolled, [
        "children",
        "type",
        "name",
        "value",
        "onChange"
    ]);
    var getValues = function getValues() {
        return value == null ? [] : [].concat(value);
    };
    var handleToggle = function handleToggle(inputVal, event) {
        if (!onChange) return;
        var values = getValues();
        var isActive = values.indexOf(inputVal) !== -1;
        if (type === 'radio') {
            if (!isActive && onChange) onChange(inputVal, event);
            return;
        }
        if (isActive) onChange(values.filter(function(n) {
            return n !== inputVal;
        }), event);
        else onChange([].concat(values, [
            inputVal
        ]), event);
    };
    !(type !== 'radio' || !!name) && (0, (/*@__PURE__*/$parcel$interopDefault($8Mkf1)))(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $4k5Ek.default), (0, $elnlQ.default)({}, controlledProps, {
        ref: ref,
        toggle: true
    }), (0, $fn04P.map)(children, function(child) {
        var values = getValues();
        var _child$props = child.props, childVal = _child$props.value, childOnChange = _child$props.onChange;
        var handler = function handler(e) {
            return handleToggle(childVal, e);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).cloneElement(child, {
            type: type,
            name: child.name || name,
            checked: values.indexOf(childVal) !== -1,
            onChange: (0, $8HBT4.default)(childOnChange, handler)
        });
    }));
});
$3b607d1332c78329$var$ToggleButtonGroup.defaultProps = $3b607d1332c78329$var$defaultProps;
$3b607d1332c78329$var$ToggleButtonGroup.Button = (0, $eB6H1.default);
var $3b607d1332c78329$export$2e2bcd8739ae039 = $3b607d1332c78329$var$ToggleButtonGroup;

});
parcelRegister("fn04P", function(module, exports) {

$parcel$export(module.exports, "map", () => $b3091045ebd8fcb9$export$871de8747c9eaa88);

var $Fo7oF = parcelRequire("Fo7oF");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $b3091045ebd8fcb9$export$871de8747c9eaa88(children, func) {
    var index = 0;
    return (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Children.map(children, function(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).isValidElement(child) ? func(child, index++) : child;
    });
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $b3091045ebd8fcb9$export$4b80e395e36b5a56(children, func) {
    var index = 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Children.forEach(children, function(child) {
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).isValidElement(child)) func(child, index++);
    });
}

});


parcelRegister("dP1T5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $a101809bce24f7eb$var$createWithBsPrefix;

var $a101809bce24f7eb$var$_classnames = $a101809bce24f7eb$var$_interopRequireDefault((parcelRequire("fVt0T")));

var $a101809bce24f7eb$var$_camelize = $a101809bce24f7eb$var$_interopRequireDefault((parcelRequire("bA4Jj")));

var $a101809bce24f7eb$var$_react = $a101809bce24f7eb$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $508Sg = parcelRequire("508Sg");
function $a101809bce24f7eb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $a101809bce24f7eb$var$_extends() {
    $a101809bce24f7eb$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a101809bce24f7eb$var$_extends.apply(this, arguments);
}
function $a101809bce24f7eb$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a101809bce24f7eb$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a101809bce24f7eb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a101809bce24f7eb$var$pascalCase = function pascalCase(str) {
    return str[0].toUpperCase() + (0, $a101809bce24f7eb$var$_camelize["default"])(str).slice(1);
};
function $a101809bce24f7eb$var$createWithBsPrefix(prefix) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$displayName = _ref.displayName, displayName = _ref$displayName === void 0 ? $a101809bce24f7eb$var$pascalCase(prefix) : _ref$displayName, _ref$Component = _ref.Component, Component = _ref$Component === void 0 ? 'div' : _ref$Component, defaultProps = _ref.defaultProps;
    var BsComponent = /*#__PURE__*/ $a101809bce24f7eb$var$_react["default"].forwardRef(function(_ref2, ref) {
        var className = _ref2.className, bsPrefix = _ref2.bsPrefix, _ref2$as = _ref2.as, Tag = _ref2$as === void 0 ? Component : _ref2$as, props = $a101809bce24f7eb$var$_objectWithoutProperties(_ref2, [
            "className",
            "bsPrefix",
            "as"
        ]);
        var resolvedPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, prefix);
        return /*#__PURE__*/ $a101809bce24f7eb$var$_react["default"].createElement(Tag, $a101809bce24f7eb$var$_extends({
            ref: ref,
            className: (0, $a101809bce24f7eb$var$_classnames["default"])(className, resolvedPrefix)
        }, props));
    });
    BsComponent.defaultProps = defaultProps;
    BsComponent.displayName = displayName;
    return BsComponent;
}

});

parcelRegister("734S2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $521c976377756c09$var$_react = $521c976377756c09$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $521c976377756c09$var$_classnames = $521c976377756c09$var$_interopRequireDefault((parcelRequire("fVt0T")));
function $521c976377756c09$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $521c976377756c09$var$_extends() {
    $521c976377756c09$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $521c976377756c09$var$_extends.apply(this, arguments);
}
var $521c976377756c09$var$_default = function _default(className) {
    return /*#__PURE__*/ $521c976377756c09$var$_react["default"].forwardRef(function(p, ref) {
        return /*#__PURE__*/ $521c976377756c09$var$_react["default"].createElement("div", $521c976377756c09$var$_extends({}, p, {
            ref: ref,
            className: (0, $521c976377756c09$var$_classnames["default"])(p.className, className)
        }));
    });
};
module.exports["default"] = $521c976377756c09$var$_default;

});

parcelRegister("d8VTR", function(module, exports) {

/*!
 * Chart.js v2.9.4
 * https://www.chartjs.org
 * (c) 2020 Chart.js Contributors
 * Released under the MIT License
 */ (function(global, factory) {
    module.exports = factory(function() {
        try {
            return (parcelRequire("lwFFd"));
        } catch (e) {}
    }());
})(module.exports, function(moment) {
    'use strict';
    moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
    function createCommonjsModule(fn, module1) {
        return module1 = {
            exports: {}
        }, fn(module1, module1.exports), module1.exports;
    }
    function getCjsExportFromNamespace(n) {
        return n && n['default'] || n;
    }
    var colorName = {
        "aliceblue": [
            240,
            248,
            255
        ],
        "antiquewhite": [
            250,
            235,
            215
        ],
        "aqua": [
            0,
            255,
            255
        ],
        "aquamarine": [
            127,
            255,
            212
        ],
        "azure": [
            240,
            255,
            255
        ],
        "beige": [
            245,
            245,
            220
        ],
        "bisque": [
            255,
            228,
            196
        ],
        "black": [
            0,
            0,
            0
        ],
        "blanchedalmond": [
            255,
            235,
            205
        ],
        "blue": [
            0,
            0,
            255
        ],
        "blueviolet": [
            138,
            43,
            226
        ],
        "brown": [
            165,
            42,
            42
        ],
        "burlywood": [
            222,
            184,
            135
        ],
        "cadetblue": [
            95,
            158,
            160
        ],
        "chartreuse": [
            127,
            255,
            0
        ],
        "chocolate": [
            210,
            105,
            30
        ],
        "coral": [
            255,
            127,
            80
        ],
        "cornflowerblue": [
            100,
            149,
            237
        ],
        "cornsilk": [
            255,
            248,
            220
        ],
        "crimson": [
            220,
            20,
            60
        ],
        "cyan": [
            0,
            255,
            255
        ],
        "darkblue": [
            0,
            0,
            139
        ],
        "darkcyan": [
            0,
            139,
            139
        ],
        "darkgoldenrod": [
            184,
            134,
            11
        ],
        "darkgray": [
            169,
            169,
            169
        ],
        "darkgreen": [
            0,
            100,
            0
        ],
        "darkgrey": [
            169,
            169,
            169
        ],
        "darkkhaki": [
            189,
            183,
            107
        ],
        "darkmagenta": [
            139,
            0,
            139
        ],
        "darkolivegreen": [
            85,
            107,
            47
        ],
        "darkorange": [
            255,
            140,
            0
        ],
        "darkorchid": [
            153,
            50,
            204
        ],
        "darkred": [
            139,
            0,
            0
        ],
        "darksalmon": [
            233,
            150,
            122
        ],
        "darkseagreen": [
            143,
            188,
            143
        ],
        "darkslateblue": [
            72,
            61,
            139
        ],
        "darkslategray": [
            47,
            79,
            79
        ],
        "darkslategrey": [
            47,
            79,
            79
        ],
        "darkturquoise": [
            0,
            206,
            209
        ],
        "darkviolet": [
            148,
            0,
            211
        ],
        "deeppink": [
            255,
            20,
            147
        ],
        "deepskyblue": [
            0,
            191,
            255
        ],
        "dimgray": [
            105,
            105,
            105
        ],
        "dimgrey": [
            105,
            105,
            105
        ],
        "dodgerblue": [
            30,
            144,
            255
        ],
        "firebrick": [
            178,
            34,
            34
        ],
        "floralwhite": [
            255,
            250,
            240
        ],
        "forestgreen": [
            34,
            139,
            34
        ],
        "fuchsia": [
            255,
            0,
            255
        ],
        "gainsboro": [
            220,
            220,
            220
        ],
        "ghostwhite": [
            248,
            248,
            255
        ],
        "gold": [
            255,
            215,
            0
        ],
        "goldenrod": [
            218,
            165,
            32
        ],
        "gray": [
            128,
            128,
            128
        ],
        "green": [
            0,
            128,
            0
        ],
        "greenyellow": [
            173,
            255,
            47
        ],
        "grey": [
            128,
            128,
            128
        ],
        "honeydew": [
            240,
            255,
            240
        ],
        "hotpink": [
            255,
            105,
            180
        ],
        "indianred": [
            205,
            92,
            92
        ],
        "indigo": [
            75,
            0,
            130
        ],
        "ivory": [
            255,
            255,
            240
        ],
        "khaki": [
            240,
            230,
            140
        ],
        "lavender": [
            230,
            230,
            250
        ],
        "lavenderblush": [
            255,
            240,
            245
        ],
        "lawngreen": [
            124,
            252,
            0
        ],
        "lemonchiffon": [
            255,
            250,
            205
        ],
        "lightblue": [
            173,
            216,
            230
        ],
        "lightcoral": [
            240,
            128,
            128
        ],
        "lightcyan": [
            224,
            255,
            255
        ],
        "lightgoldenrodyellow": [
            250,
            250,
            210
        ],
        "lightgray": [
            211,
            211,
            211
        ],
        "lightgreen": [
            144,
            238,
            144
        ],
        "lightgrey": [
            211,
            211,
            211
        ],
        "lightpink": [
            255,
            182,
            193
        ],
        "lightsalmon": [
            255,
            160,
            122
        ],
        "lightseagreen": [
            32,
            178,
            170
        ],
        "lightskyblue": [
            135,
            206,
            250
        ],
        "lightslategray": [
            119,
            136,
            153
        ],
        "lightslategrey": [
            119,
            136,
            153
        ],
        "lightsteelblue": [
            176,
            196,
            222
        ],
        "lightyellow": [
            255,
            255,
            224
        ],
        "lime": [
            0,
            255,
            0
        ],
        "limegreen": [
            50,
            205,
            50
        ],
        "linen": [
            250,
            240,
            230
        ],
        "magenta": [
            255,
            0,
            255
        ],
        "maroon": [
            128,
            0,
            0
        ],
        "mediumaquamarine": [
            102,
            205,
            170
        ],
        "mediumblue": [
            0,
            0,
            205
        ],
        "mediumorchid": [
            186,
            85,
            211
        ],
        "mediumpurple": [
            147,
            112,
            219
        ],
        "mediumseagreen": [
            60,
            179,
            113
        ],
        "mediumslateblue": [
            123,
            104,
            238
        ],
        "mediumspringgreen": [
            0,
            250,
            154
        ],
        "mediumturquoise": [
            72,
            209,
            204
        ],
        "mediumvioletred": [
            199,
            21,
            133
        ],
        "midnightblue": [
            25,
            25,
            112
        ],
        "mintcream": [
            245,
            255,
            250
        ],
        "mistyrose": [
            255,
            228,
            225
        ],
        "moccasin": [
            255,
            228,
            181
        ],
        "navajowhite": [
            255,
            222,
            173
        ],
        "navy": [
            0,
            0,
            128
        ],
        "oldlace": [
            253,
            245,
            230
        ],
        "olive": [
            128,
            128,
            0
        ],
        "olivedrab": [
            107,
            142,
            35
        ],
        "orange": [
            255,
            165,
            0
        ],
        "orangered": [
            255,
            69,
            0
        ],
        "orchid": [
            218,
            112,
            214
        ],
        "palegoldenrod": [
            238,
            232,
            170
        ],
        "palegreen": [
            152,
            251,
            152
        ],
        "paleturquoise": [
            175,
            238,
            238
        ],
        "palevioletred": [
            219,
            112,
            147
        ],
        "papayawhip": [
            255,
            239,
            213
        ],
        "peachpuff": [
            255,
            218,
            185
        ],
        "peru": [
            205,
            133,
            63
        ],
        "pink": [
            255,
            192,
            203
        ],
        "plum": [
            221,
            160,
            221
        ],
        "powderblue": [
            176,
            224,
            230
        ],
        "purple": [
            128,
            0,
            128
        ],
        "rebeccapurple": [
            102,
            51,
            153
        ],
        "red": [
            255,
            0,
            0
        ],
        "rosybrown": [
            188,
            143,
            143
        ],
        "royalblue": [
            65,
            105,
            225
        ],
        "saddlebrown": [
            139,
            69,
            19
        ],
        "salmon": [
            250,
            128,
            114
        ],
        "sandybrown": [
            244,
            164,
            96
        ],
        "seagreen": [
            46,
            139,
            87
        ],
        "seashell": [
            255,
            245,
            238
        ],
        "sienna": [
            160,
            82,
            45
        ],
        "silver": [
            192,
            192,
            192
        ],
        "skyblue": [
            135,
            206,
            235
        ],
        "slateblue": [
            106,
            90,
            205
        ],
        "slategray": [
            112,
            128,
            144
        ],
        "slategrey": [
            112,
            128,
            144
        ],
        "snow": [
            255,
            250,
            250
        ],
        "springgreen": [
            0,
            255,
            127
        ],
        "steelblue": [
            70,
            130,
            180
        ],
        "tan": [
            210,
            180,
            140
        ],
        "teal": [
            0,
            128,
            128
        ],
        "thistle": [
            216,
            191,
            216
        ],
        "tomato": [
            255,
            99,
            71
        ],
        "turquoise": [
            64,
            224,
            208
        ],
        "violet": [
            238,
            130,
            238
        ],
        "wheat": [
            245,
            222,
            179
        ],
        "white": [
            255,
            255,
            255
        ],
        "whitesmoke": [
            245,
            245,
            245
        ],
        "yellow": [
            255,
            255,
            0
        ],
        "yellowgreen": [
            154,
            205,
            50
        ]
    };
    var conversions = createCommonjsModule(function(module1) {
        /* MIT license */ // NOTE: conversions should only return primitive values (i.e. arrays, or
        //       values that give correct `typeof` results).
        //       do not use box values types (i.e. Number(), String(), etc.)
        var reverseKeywords = {};
        for(var key in colorName)if (colorName.hasOwnProperty(key)) reverseKeywords[colorName[key]] = key;
        var convert = module1.exports = {
            rgb: {
                channels: 3,
                labels: 'rgb'
            },
            hsl: {
                channels: 3,
                labels: 'hsl'
            },
            hsv: {
                channels: 3,
                labels: 'hsv'
            },
            hwb: {
                channels: 3,
                labels: 'hwb'
            },
            cmyk: {
                channels: 4,
                labels: 'cmyk'
            },
            xyz: {
                channels: 3,
                labels: 'xyz'
            },
            lab: {
                channels: 3,
                labels: 'lab'
            },
            lch: {
                channels: 3,
                labels: 'lch'
            },
            hex: {
                channels: 1,
                labels: [
                    'hex'
                ]
            },
            keyword: {
                channels: 1,
                labels: [
                    'keyword'
                ]
            },
            ansi16: {
                channels: 1,
                labels: [
                    'ansi16'
                ]
            },
            ansi256: {
                channels: 1,
                labels: [
                    'ansi256'
                ]
            },
            hcg: {
                channels: 3,
                labels: [
                    'h',
                    'c',
                    'g'
                ]
            },
            apple: {
                channels: 3,
                labels: [
                    'r16',
                    'g16',
                    'b16'
                ]
            },
            gray: {
                channels: 1,
                labels: [
                    'gray'
                ]
            }
        };
        // hide .channels and .labels properties
        for(var model in convert)if (convert.hasOwnProperty(model)) {
            if (!('channels' in convert[model])) throw new Error('missing channels property: ' + model);
            if (!('labels' in convert[model])) throw new Error('missing channel labels property: ' + model);
            if (convert[model].labels.length !== convert[model].channels) throw new Error('channel and label counts mismatch: ' + model);
            var channels = convert[model].channels;
            var labels = convert[model].labels;
            delete convert[model].channels;
            delete convert[model].labels;
            Object.defineProperty(convert[model], 'channels', {
                value: channels
            });
            Object.defineProperty(convert[model], 'labels', {
                value: labels
            });
        }
        convert.rgb.hsl = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var min = Math.min(r, g, b);
            var max = Math.max(r, g, b);
            var delta = max - min;
            var h;
            var s;
            var l;
            if (max === min) h = 0;
            else if (r === max) h = (g - b) / delta;
            else if (g === max) h = 2 + (b - r) / delta;
            else if (b === max) h = 4 + (r - g) / delta;
            h = Math.min(h * 60, 360);
            if (h < 0) h += 360;
            l = (min + max) / 2;
            if (max === min) s = 0;
            else if (l <= 0.5) s = delta / (max + min);
            else s = delta / (2 - max - min);
            return [
                h,
                s * 100,
                l * 100
            ];
        };
        convert.rgb.hsv = function(rgb) {
            var rdif;
            var gdif;
            var bdif;
            var h;
            var s;
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var v = Math.max(r, g, b);
            var diff = v - Math.min(r, g, b);
            var diffc = function(c) {
                return (v - c) / 6 / diff + 0.5;
            };
            if (diff === 0) h = s = 0;
            else {
                s = diff / v;
                rdif = diffc(r);
                gdif = diffc(g);
                bdif = diffc(b);
                if (r === v) h = bdif - gdif;
                else if (g === v) h = 1 / 3 + rdif - bdif;
                else if (b === v) h = 2 / 3 + gdif - rdif;
                if (h < 0) h += 1;
                else if (h > 1) h -= 1;
            }
            return [
                h * 360,
                s * 100,
                v * 100
            ];
        };
        convert.rgb.hwb = function(rgb) {
            var r = rgb[0];
            var g = rgb[1];
            var b = rgb[2];
            var h = convert.rgb.hsl(rgb)[0];
            var w = 1 / 255 * Math.min(r, Math.min(g, b));
            b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
            return [
                h,
                w * 100,
                b * 100
            ];
        };
        convert.rgb.cmyk = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var c;
            var m;
            var y;
            var k;
            k = Math.min(1 - r, 1 - g, 1 - b);
            c = (1 - r - k) / (1 - k) || 0;
            m = (1 - g - k) / (1 - k) || 0;
            y = (1 - b - k) / (1 - k) || 0;
            return [
                c * 100,
                m * 100,
                y * 100,
                k * 100
            ];
        };
        /**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */ function comparativeDistance(x, y) {
            return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
        }
        convert.rgb.keyword = function(rgb) {
            var reversed = reverseKeywords[rgb];
            if (reversed) return reversed;
            var currentClosestDistance = Infinity;
            var currentClosestKeyword;
            for(var keyword in colorName)if (colorName.hasOwnProperty(keyword)) {
                var value = colorName[keyword];
                // Compute comparative distance
                var distance = comparativeDistance(rgb, value);
                // Check if its less, if so set as closest
                if (distance < currentClosestDistance) {
                    currentClosestDistance = distance;
                    currentClosestKeyword = keyword;
                }
            }
            return currentClosestKeyword;
        };
        convert.keyword.rgb = function(keyword) {
            return colorName[keyword];
        };
        convert.rgb.xyz = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            // assume sRGB
            r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
            g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
            b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
            var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
            var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
            var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
            return [
                x * 100,
                y * 100,
                z * 100
            ];
        };
        convert.rgb.lab = function(rgb) {
            var xyz = convert.rgb.xyz(rgb);
            var x = xyz[0];
            var y = xyz[1];
            var z = xyz[2];
            var l;
            var a;
            var b;
            x /= 95.047;
            y /= 100;
            z /= 108.883;
            x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
            y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
            z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
            l = 116 * y - 16;
            a = 500 * (x - y);
            b = 200 * (y - z);
            return [
                l,
                a,
                b
            ];
        };
        convert.hsl.rgb = function(hsl) {
            var h = hsl[0] / 360;
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var t1;
            var t2;
            var t3;
            var rgb;
            var val;
            if (s === 0) {
                val = l * 255;
                return [
                    val,
                    val,
                    val
                ];
            }
            if (l < 0.5) t2 = l * (1 + s);
            else t2 = l + s - l * s;
            t1 = 2 * l - t2;
            rgb = [
                0,
                0,
                0
            ];
            for(var i = 0; i < 3; i++){
                t3 = h + 1 / 3 * -(i - 1);
                if (t3 < 0) t3++;
                if (t3 > 1) t3--;
                if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
                else if (2 * t3 < 1) val = t2;
                else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                else val = t1;
                rgb[i] = val * 255;
            }
            return rgb;
        };
        convert.hsl.hsv = function(hsl) {
            var h = hsl[0];
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var smin = s;
            var lmin = Math.max(l, 0.01);
            var sv;
            var v;
            l *= 2;
            s *= l <= 1 ? l : 2 - l;
            smin *= lmin <= 1 ? lmin : 2 - lmin;
            v = (l + s) / 2;
            sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
            return [
                h,
                sv * 100,
                v * 100
            ];
        };
        convert.hsv.rgb = function(hsv) {
            var h = hsv[0] / 60;
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var hi = Math.floor(h) % 6;
            var f = h - Math.floor(h);
            var p = 255 * v * (1 - s);
            var q = 255 * v * (1 - s * f);
            var t = 255 * v * (1 - s * (1 - f));
            v *= 255;
            switch(hi){
                case 0:
                    return [
                        v,
                        t,
                        p
                    ];
                case 1:
                    return [
                        q,
                        v,
                        p
                    ];
                case 2:
                    return [
                        p,
                        v,
                        t
                    ];
                case 3:
                    return [
                        p,
                        q,
                        v
                    ];
                case 4:
                    return [
                        t,
                        p,
                        v
                    ];
                case 5:
                    return [
                        v,
                        p,
                        q
                    ];
            }
        };
        convert.hsv.hsl = function(hsv) {
            var h = hsv[0];
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var vmin = Math.max(v, 0.01);
            var lmin;
            var sl;
            var l;
            l = (2 - s) * v;
            lmin = (2 - s) * vmin;
            sl = s * vmin;
            sl /= lmin <= 1 ? lmin : 2 - lmin;
            sl = sl || 0;
            l /= 2;
            return [
                h,
                sl * 100,
                l * 100
            ];
        };
        // http://dev.w3.org/csswg/css-color/#hwb-to-rgb
        convert.hwb.rgb = function(hwb) {
            var h = hwb[0] / 360;
            var wh = hwb[1] / 100;
            var bl = hwb[2] / 100;
            var ratio = wh + bl;
            var i;
            var v;
            var f;
            var n;
            // wh + bl cant be > 1
            if (ratio > 1) {
                wh /= ratio;
                bl /= ratio;
            }
            i = Math.floor(6 * h);
            v = 1 - bl;
            f = 6 * h - i;
            if ((i & 0x01) !== 0) f = 1 - f;
            n = wh + f * (v - wh); // linear interpolation
            var r;
            var g;
            var b;
            switch(i){
                default:
                case 6:
                case 0:
                    r = v;
                    g = n;
                    b = wh;
                    break;
                case 1:
                    r = n;
                    g = v;
                    b = wh;
                    break;
                case 2:
                    r = wh;
                    g = v;
                    b = n;
                    break;
                case 3:
                    r = wh;
                    g = n;
                    b = v;
                    break;
                case 4:
                    r = n;
                    g = wh;
                    b = v;
                    break;
                case 5:
                    r = v;
                    g = wh;
                    b = n;
                    break;
            }
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.cmyk.rgb = function(cmyk) {
            var c = cmyk[0] / 100;
            var m = cmyk[1] / 100;
            var y = cmyk[2] / 100;
            var k = cmyk[3] / 100;
            var r;
            var g;
            var b;
            r = 1 - Math.min(1, c * (1 - k) + k);
            g = 1 - Math.min(1, m * (1 - k) + k);
            b = 1 - Math.min(1, y * (1 - k) + k);
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.xyz.rgb = function(xyz) {
            var x = xyz[0] / 100;
            var y = xyz[1] / 100;
            var z = xyz[2] / 100;
            var r;
            var g;
            var b;
            r = x * 3.2406 + y * -1.5372 + z * -0.4986;
            g = x * -0.9689 + y * 1.8758 + z * 0.0415;
            b = x * 0.0557 + y * -0.204 + z * 1.0570;
            // assume sRGB
            r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
            g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
            b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
            r = Math.min(Math.max(0, r), 1);
            g = Math.min(Math.max(0, g), 1);
            b = Math.min(Math.max(0, b), 1);
            return [
                r * 255,
                g * 255,
                b * 255
            ];
        };
        convert.xyz.lab = function(xyz) {
            var x = xyz[0];
            var y = xyz[1];
            var z = xyz[2];
            var l;
            var a;
            var b;
            x /= 95.047;
            y /= 100;
            z /= 108.883;
            x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
            y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
            z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
            l = 116 * y - 16;
            a = 500 * (x - y);
            b = 200 * (y - z);
            return [
                l,
                a,
                b
            ];
        };
        convert.lab.xyz = function(lab) {
            var l = lab[0];
            var a = lab[1];
            var b = lab[2];
            var x;
            var y;
            var z;
            y = (l + 16) / 116;
            x = a / 500 + y;
            z = y - b / 200;
            var y2 = Math.pow(y, 3);
            var x2 = Math.pow(x, 3);
            var z2 = Math.pow(z, 3);
            y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
            x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
            z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
            x *= 95.047;
            y *= 100;
            z *= 108.883;
            return [
                x,
                y,
                z
            ];
        };
        convert.lab.lch = function(lab) {
            var l = lab[0];
            var a = lab[1];
            var b = lab[2];
            var hr;
            var h;
            var c;
            hr = Math.atan2(b, a);
            h = hr * 360 / 2 / Math.PI;
            if (h < 0) h += 360;
            c = Math.sqrt(a * a + b * b);
            return [
                l,
                c,
                h
            ];
        };
        convert.lch.lab = function(lch) {
            var l = lch[0];
            var c = lch[1];
            var h = lch[2];
            var a;
            var b;
            var hr;
            hr = h / 360 * 2 * Math.PI;
            a = c * Math.cos(hr);
            b = c * Math.sin(hr);
            return [
                l,
                a,
                b
            ];
        };
        convert.rgb.ansi16 = function(args) {
            var r = args[0];
            var g = args[1];
            var b = args[2];
            var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
            value = Math.round(value / 50);
            if (value === 0) return 30;
            var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
            if (value === 2) ansi += 60;
            return ansi;
        };
        convert.hsv.ansi16 = function(args) {
            // optimization here; we already know the value and don't need to get
            // it converted for us.
            return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
        };
        convert.rgb.ansi256 = function(args) {
            var r = args[0];
            var g = args[1];
            var b = args[2];
            // we use the extended greyscale palette here, with the exception of
            // black and white. normal palette only has 4 greyscale shades.
            if (r === g && g === b) {
                if (r < 8) return 16;
                if (r > 248) return 231;
                return Math.round((r - 8) / 247 * 24) + 232;
            }
            var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
            return ansi;
        };
        convert.ansi16.rgb = function(args) {
            var color = args % 10;
            // handle greyscale
            if (color === 0 || color === 7) {
                if (args > 50) color += 3.5;
                color = color / 10.5 * 255;
                return [
                    color,
                    color,
                    color
                ];
            }
            var mult = (~~(args > 50) + 1) * 0.5;
            var r = (color & 1) * mult * 255;
            var g = (color >> 1 & 1) * mult * 255;
            var b = (color >> 2 & 1) * mult * 255;
            return [
                r,
                g,
                b
            ];
        };
        convert.ansi256.rgb = function(args) {
            // handle greyscale
            if (args >= 232) {
                var c = (args - 232) * 10 + 8;
                return [
                    c,
                    c,
                    c
                ];
            }
            args -= 16;
            var rem;
            var r = Math.floor(args / 36) / 5 * 255;
            var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
            var b = rem % 6 / 5 * 255;
            return [
                r,
                g,
                b
            ];
        };
        convert.rgb.hex = function(args) {
            var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
            var string = integer.toString(16).toUpperCase();
            return '000000'.substring(string.length) + string;
        };
        convert.hex.rgb = function(args) {
            var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
            if (!match) return [
                0,
                0,
                0
            ];
            var colorString = match[0];
            if (match[0].length === 3) colorString = colorString.split('').map(function(char) {
                return char + char;
            }).join('');
            var integer = parseInt(colorString, 16);
            var r = integer >> 16 & 0xFF;
            var g = integer >> 8 & 0xFF;
            var b = integer & 0xFF;
            return [
                r,
                g,
                b
            ];
        };
        convert.rgb.hcg = function(rgb) {
            var r = rgb[0] / 255;
            var g = rgb[1] / 255;
            var b = rgb[2] / 255;
            var max = Math.max(Math.max(r, g), b);
            var min = Math.min(Math.min(r, g), b);
            var chroma = max - min;
            var grayscale;
            var hue;
            if (chroma < 1) grayscale = min / (1 - chroma);
            else grayscale = 0;
            if (chroma <= 0) hue = 0;
            else if (max === r) hue = (g - b) / chroma % 6;
            else if (max === g) hue = 2 + (b - r) / chroma;
            else hue = 4 + (r - g) / chroma + 4;
            hue /= 6;
            hue %= 1;
            return [
                hue * 360,
                chroma * 100,
                grayscale * 100
            ];
        };
        convert.hsl.hcg = function(hsl) {
            var s = hsl[1] / 100;
            var l = hsl[2] / 100;
            var c = 1;
            var f = 0;
            if (l < 0.5) c = 2.0 * s * l;
            else c = 2.0 * s * (1.0 - l);
            if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
            return [
                hsl[0],
                c * 100,
                f * 100
            ];
        };
        convert.hsv.hcg = function(hsv) {
            var s = hsv[1] / 100;
            var v = hsv[2] / 100;
            var c = s * v;
            var f = 0;
            if (c < 1.0) f = (v - c) / (1 - c);
            return [
                hsv[0],
                c * 100,
                f * 100
            ];
        };
        convert.hcg.rgb = function(hcg) {
            var h = hcg[0] / 360;
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            if (c === 0.0) return [
                g * 255,
                g * 255,
                g * 255
            ];
            var pure = [
                0,
                0,
                0
            ];
            var hi = h % 1 * 6;
            var v = hi % 1;
            var w = 1 - v;
            var mg = 0;
            switch(Math.floor(hi)){
                case 0:
                    pure[0] = 1;
                    pure[1] = v;
                    pure[2] = 0;
                    break;
                case 1:
                    pure[0] = w;
                    pure[1] = 1;
                    pure[2] = 0;
                    break;
                case 2:
                    pure[0] = 0;
                    pure[1] = 1;
                    pure[2] = v;
                    break;
                case 3:
                    pure[0] = 0;
                    pure[1] = w;
                    pure[2] = 1;
                    break;
                case 4:
                    pure[0] = v;
                    pure[1] = 0;
                    pure[2] = 1;
                    break;
                default:
                    pure[0] = 1;
                    pure[1] = 0;
                    pure[2] = w;
            }
            mg = (1.0 - c) * g;
            return [
                (c * pure[0] + mg) * 255,
                (c * pure[1] + mg) * 255,
                (c * pure[2] + mg) * 255
            ];
        };
        convert.hcg.hsv = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var v = c + g * (1.0 - c);
            var f = 0;
            if (v > 0.0) f = c / v;
            return [
                hcg[0],
                f * 100,
                v * 100
            ];
        };
        convert.hcg.hsl = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var l = g * (1.0 - c) + 0.5 * c;
            var s = 0;
            if (l > 0.0 && l < 0.5) s = c / (2 * l);
            else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
            return [
                hcg[0],
                s * 100,
                l * 100
            ];
        };
        convert.hcg.hwb = function(hcg) {
            var c = hcg[1] / 100;
            var g = hcg[2] / 100;
            var v = c + g * (1.0 - c);
            return [
                hcg[0],
                (v - c) * 100,
                (1 - v) * 100
            ];
        };
        convert.hwb.hcg = function(hwb) {
            var w = hwb[1] / 100;
            var b = hwb[2] / 100;
            var v = 1 - b;
            var c = v - w;
            var g = 0;
            if (c < 1) g = (v - c) / (1 - c);
            return [
                hwb[0],
                c * 100,
                g * 100
            ];
        };
        convert.apple.rgb = function(apple) {
            return [
                apple[0] / 65535 * 255,
                apple[1] / 65535 * 255,
                apple[2] / 65535 * 255
            ];
        };
        convert.rgb.apple = function(rgb) {
            return [
                rgb[0] / 255 * 65535,
                rgb[1] / 255 * 65535,
                rgb[2] / 255 * 65535
            ];
        };
        convert.gray.rgb = function(args) {
            return [
                args[0] / 100 * 255,
                args[0] / 100 * 255,
                args[0] / 100 * 255
            ];
        };
        convert.gray.hsl = convert.gray.hsv = function(args) {
            return [
                0,
                0,
                args[0]
            ];
        };
        convert.gray.hwb = function(gray) {
            return [
                0,
                100,
                gray[0]
            ];
        };
        convert.gray.cmyk = function(gray) {
            return [
                0,
                0,
                0,
                gray[0]
            ];
        };
        convert.gray.lab = function(gray) {
            return [
                gray[0],
                0,
                0
            ];
        };
        convert.gray.hex = function(gray) {
            var val = Math.round(gray[0] / 100 * 255) & 0xFF;
            var integer = (val << 16) + (val << 8) + val;
            var string = integer.toString(16).toUpperCase();
            return '000000'.substring(string.length) + string;
        };
        convert.rgb.gray = function(rgb) {
            var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
            return [
                val / 255 * 100
            ];
        };
    });
    var conversions_1 = conversions.rgb;
    var conversions_2 = conversions.hsl;
    var conversions_3 = conversions.hsv;
    var conversions_4 = conversions.hwb;
    var conversions_5 = conversions.cmyk;
    var conversions_6 = conversions.xyz;
    var conversions_7 = conversions.lab;
    var conversions_8 = conversions.lch;
    var conversions_9 = conversions.hex;
    var conversions_10 = conversions.keyword;
    var conversions_11 = conversions.ansi16;
    var conversions_12 = conversions.ansi256;
    var conversions_13 = conversions.hcg;
    var conversions_14 = conversions.apple;
    var conversions_15 = conversions.gray;
    /*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function buildGraph() {
        var graph = {};
        // https://jsperf.com/object-keys-vs-for-in-with-closure/3
        var models = Object.keys(conversions);
        for(var len = models.length, i = 0; i < len; i++)graph[models[i]] = {
            // http://jsperf.com/1-vs-infinity
            // micro-opt, but this is simple.
            distance: -1,
            parent: null
        };
        return graph;
    }
    // https://en.wikipedia.org/wiki/Breadth-first_search
    function deriveBFS(fromModel) {
        var graph = buildGraph();
        var queue = [
            fromModel
        ]; // unshift -> queue -> pop
        graph[fromModel].distance = 0;
        while(queue.length){
            var current = queue.pop();
            var adjacents = Object.keys(conversions[current]);
            for(var len = adjacents.length, i = 0; i < len; i++){
                var adjacent = adjacents[i];
                var node = graph[adjacent];
                if (node.distance === -1) {
                    node.distance = graph[current].distance + 1;
                    node.parent = current;
                    queue.unshift(adjacent);
                }
            }
        }
        return graph;
    }
    function link(from, to) {
        return function(args) {
            return to(from(args));
        };
    }
    function wrapConversion(toModel, graph) {
        var path = [
            graph[toModel].parent,
            toModel
        ];
        var fn = conversions[graph[toModel].parent][toModel];
        var cur = graph[toModel].parent;
        while(graph[cur].parent){
            path.unshift(graph[cur].parent);
            fn = link(conversions[graph[cur].parent][cur], fn);
            cur = graph[cur].parent;
        }
        fn.conversion = path;
        return fn;
    }
    var route = function(fromModel) {
        var graph = deriveBFS(fromModel);
        var conversion = {};
        var models = Object.keys(graph);
        for(var len = models.length, i = 0; i < len; i++){
            var toModel = models[i];
            var node = graph[toModel];
            if (node.parent === null) continue;
            conversion[toModel] = wrapConversion(toModel, graph);
        }
        return conversion;
    };
    var convert = {};
    var models = Object.keys(conversions);
    function wrapRaw(fn) {
        var wrappedFn = function(args) {
            if (args === undefined || args === null) return args;
            if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
            return fn(args);
        };
        // preserve .conversion property if there is one
        if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
        return wrappedFn;
    }
    function wrapRounded(fn) {
        var wrappedFn = function(args) {
            if (args === undefined || args === null) return args;
            if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
            var result = fn(args);
            // we're assuming the result is an array here.
            // see notice in conversions.js; don't use box types
            // in conversion functions.
            if (typeof result === 'object') for(var len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
            return result;
        };
        // preserve .conversion property if there is one
        if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
        return wrappedFn;
    }
    models.forEach(function(fromModel) {
        convert[fromModel] = {};
        Object.defineProperty(convert[fromModel], 'channels', {
            value: conversions[fromModel].channels
        });
        Object.defineProperty(convert[fromModel], 'labels', {
            value: conversions[fromModel].labels
        });
        var routes = route(fromModel);
        var routeModels = Object.keys(routes);
        routeModels.forEach(function(toModel) {
            var fn = routes[toModel];
            convert[fromModel][toModel] = wrapRounded(fn);
            convert[fromModel][toModel].raw = wrapRaw(fn);
        });
    });
    var colorConvert = convert;
    var colorName$1 = {
        "aliceblue": [
            240,
            248,
            255
        ],
        "antiquewhite": [
            250,
            235,
            215
        ],
        "aqua": [
            0,
            255,
            255
        ],
        "aquamarine": [
            127,
            255,
            212
        ],
        "azure": [
            240,
            255,
            255
        ],
        "beige": [
            245,
            245,
            220
        ],
        "bisque": [
            255,
            228,
            196
        ],
        "black": [
            0,
            0,
            0
        ],
        "blanchedalmond": [
            255,
            235,
            205
        ],
        "blue": [
            0,
            0,
            255
        ],
        "blueviolet": [
            138,
            43,
            226
        ],
        "brown": [
            165,
            42,
            42
        ],
        "burlywood": [
            222,
            184,
            135
        ],
        "cadetblue": [
            95,
            158,
            160
        ],
        "chartreuse": [
            127,
            255,
            0
        ],
        "chocolate": [
            210,
            105,
            30
        ],
        "coral": [
            255,
            127,
            80
        ],
        "cornflowerblue": [
            100,
            149,
            237
        ],
        "cornsilk": [
            255,
            248,
            220
        ],
        "crimson": [
            220,
            20,
            60
        ],
        "cyan": [
            0,
            255,
            255
        ],
        "darkblue": [
            0,
            0,
            139
        ],
        "darkcyan": [
            0,
            139,
            139
        ],
        "darkgoldenrod": [
            184,
            134,
            11
        ],
        "darkgray": [
            169,
            169,
            169
        ],
        "darkgreen": [
            0,
            100,
            0
        ],
        "darkgrey": [
            169,
            169,
            169
        ],
        "darkkhaki": [
            189,
            183,
            107
        ],
        "darkmagenta": [
            139,
            0,
            139
        ],
        "darkolivegreen": [
            85,
            107,
            47
        ],
        "darkorange": [
            255,
            140,
            0
        ],
        "darkorchid": [
            153,
            50,
            204
        ],
        "darkred": [
            139,
            0,
            0
        ],
        "darksalmon": [
            233,
            150,
            122
        ],
        "darkseagreen": [
            143,
            188,
            143
        ],
        "darkslateblue": [
            72,
            61,
            139
        ],
        "darkslategray": [
            47,
            79,
            79
        ],
        "darkslategrey": [
            47,
            79,
            79
        ],
        "darkturquoise": [
            0,
            206,
            209
        ],
        "darkviolet": [
            148,
            0,
            211
        ],
        "deeppink": [
            255,
            20,
            147
        ],
        "deepskyblue": [
            0,
            191,
            255
        ],
        "dimgray": [
            105,
            105,
            105
        ],
        "dimgrey": [
            105,
            105,
            105
        ],
        "dodgerblue": [
            30,
            144,
            255
        ],
        "firebrick": [
            178,
            34,
            34
        ],
        "floralwhite": [
            255,
            250,
            240
        ],
        "forestgreen": [
            34,
            139,
            34
        ],
        "fuchsia": [
            255,
            0,
            255
        ],
        "gainsboro": [
            220,
            220,
            220
        ],
        "ghostwhite": [
            248,
            248,
            255
        ],
        "gold": [
            255,
            215,
            0
        ],
        "goldenrod": [
            218,
            165,
            32
        ],
        "gray": [
            128,
            128,
            128
        ],
        "green": [
            0,
            128,
            0
        ],
        "greenyellow": [
            173,
            255,
            47
        ],
        "grey": [
            128,
            128,
            128
        ],
        "honeydew": [
            240,
            255,
            240
        ],
        "hotpink": [
            255,
            105,
            180
        ],
        "indianred": [
            205,
            92,
            92
        ],
        "indigo": [
            75,
            0,
            130
        ],
        "ivory": [
            255,
            255,
            240
        ],
        "khaki": [
            240,
            230,
            140
        ],
        "lavender": [
            230,
            230,
            250
        ],
        "lavenderblush": [
            255,
            240,
            245
        ],
        "lawngreen": [
            124,
            252,
            0
        ],
        "lemonchiffon": [
            255,
            250,
            205
        ],
        "lightblue": [
            173,
            216,
            230
        ],
        "lightcoral": [
            240,
            128,
            128
        ],
        "lightcyan": [
            224,
            255,
            255
        ],
        "lightgoldenrodyellow": [
            250,
            250,
            210
        ],
        "lightgray": [
            211,
            211,
            211
        ],
        "lightgreen": [
            144,
            238,
            144
        ],
        "lightgrey": [
            211,
            211,
            211
        ],
        "lightpink": [
            255,
            182,
            193
        ],
        "lightsalmon": [
            255,
            160,
            122
        ],
        "lightseagreen": [
            32,
            178,
            170
        ],
        "lightskyblue": [
            135,
            206,
            250
        ],
        "lightslategray": [
            119,
            136,
            153
        ],
        "lightslategrey": [
            119,
            136,
            153
        ],
        "lightsteelblue": [
            176,
            196,
            222
        ],
        "lightyellow": [
            255,
            255,
            224
        ],
        "lime": [
            0,
            255,
            0
        ],
        "limegreen": [
            50,
            205,
            50
        ],
        "linen": [
            250,
            240,
            230
        ],
        "magenta": [
            255,
            0,
            255
        ],
        "maroon": [
            128,
            0,
            0
        ],
        "mediumaquamarine": [
            102,
            205,
            170
        ],
        "mediumblue": [
            0,
            0,
            205
        ],
        "mediumorchid": [
            186,
            85,
            211
        ],
        "mediumpurple": [
            147,
            112,
            219
        ],
        "mediumseagreen": [
            60,
            179,
            113
        ],
        "mediumslateblue": [
            123,
            104,
            238
        ],
        "mediumspringgreen": [
            0,
            250,
            154
        ],
        "mediumturquoise": [
            72,
            209,
            204
        ],
        "mediumvioletred": [
            199,
            21,
            133
        ],
        "midnightblue": [
            25,
            25,
            112
        ],
        "mintcream": [
            245,
            255,
            250
        ],
        "mistyrose": [
            255,
            228,
            225
        ],
        "moccasin": [
            255,
            228,
            181
        ],
        "navajowhite": [
            255,
            222,
            173
        ],
        "navy": [
            0,
            0,
            128
        ],
        "oldlace": [
            253,
            245,
            230
        ],
        "olive": [
            128,
            128,
            0
        ],
        "olivedrab": [
            107,
            142,
            35
        ],
        "orange": [
            255,
            165,
            0
        ],
        "orangered": [
            255,
            69,
            0
        ],
        "orchid": [
            218,
            112,
            214
        ],
        "palegoldenrod": [
            238,
            232,
            170
        ],
        "palegreen": [
            152,
            251,
            152
        ],
        "paleturquoise": [
            175,
            238,
            238
        ],
        "palevioletred": [
            219,
            112,
            147
        ],
        "papayawhip": [
            255,
            239,
            213
        ],
        "peachpuff": [
            255,
            218,
            185
        ],
        "peru": [
            205,
            133,
            63
        ],
        "pink": [
            255,
            192,
            203
        ],
        "plum": [
            221,
            160,
            221
        ],
        "powderblue": [
            176,
            224,
            230
        ],
        "purple": [
            128,
            0,
            128
        ],
        "rebeccapurple": [
            102,
            51,
            153
        ],
        "red": [
            255,
            0,
            0
        ],
        "rosybrown": [
            188,
            143,
            143
        ],
        "royalblue": [
            65,
            105,
            225
        ],
        "saddlebrown": [
            139,
            69,
            19
        ],
        "salmon": [
            250,
            128,
            114
        ],
        "sandybrown": [
            244,
            164,
            96
        ],
        "seagreen": [
            46,
            139,
            87
        ],
        "seashell": [
            255,
            245,
            238
        ],
        "sienna": [
            160,
            82,
            45
        ],
        "silver": [
            192,
            192,
            192
        ],
        "skyblue": [
            135,
            206,
            235
        ],
        "slateblue": [
            106,
            90,
            205
        ],
        "slategray": [
            112,
            128,
            144
        ],
        "slategrey": [
            112,
            128,
            144
        ],
        "snow": [
            255,
            250,
            250
        ],
        "springgreen": [
            0,
            255,
            127
        ],
        "steelblue": [
            70,
            130,
            180
        ],
        "tan": [
            210,
            180,
            140
        ],
        "teal": [
            0,
            128,
            128
        ],
        "thistle": [
            216,
            191,
            216
        ],
        "tomato": [
            255,
            99,
            71
        ],
        "turquoise": [
            64,
            224,
            208
        ],
        "violet": [
            238,
            130,
            238
        ],
        "wheat": [
            245,
            222,
            179
        ],
        "white": [
            255,
            255,
            255
        ],
        "whitesmoke": [
            245,
            245,
            245
        ],
        "yellow": [
            255,
            255,
            0
        ],
        "yellowgreen": [
            154,
            205,
            50
        ]
    };
    /* MIT license */ var colorString = {
        getRgba: getRgba,
        getHsla: getHsla,
        getRgb: getRgb,
        getHsl: getHsl,
        getHwb: getHwb,
        getAlpha: getAlpha,
        hexString: hexString,
        rgbString: rgbString,
        rgbaString: rgbaString,
        percentString: percentString,
        percentaString: percentaString,
        hslString: hslString,
        hslaString: hslaString,
        hwbString: hwbString,
        keyword: keyword
    };
    function getRgba(string) {
        if (!string) return;
        var abbr = /^#([a-fA-F0-9]{3,4})$/i, hex = /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i, rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i, per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i, keyword = /(\w+)/;
        var rgb = [
            0,
            0,
            0
        ], a = 1, match = string.match(abbr), hexAlpha = "";
        if (match) {
            match = match[1];
            hexAlpha = match[3];
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i] + match[i], 16);
            if (hexAlpha) a = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
        } else if (match = string.match(hex)) {
            hexAlpha = match[2];
            match = match[1];
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
            if (hexAlpha) a = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
        } else if (match = string.match(rgba)) {
            for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i + 1]);
            a = parseFloat(match[4]);
        } else if (match = string.match(per)) {
            for(var i = 0; i < rgb.length; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
            a = parseFloat(match[4]);
        } else if (match = string.match(keyword)) {
            if (match[1] == "transparent") return [
                0,
                0,
                0,
                0
            ];
            rgb = colorName$1[match[1]];
            if (!rgb) return;
        }
        for(var i = 0; i < rgb.length; i++)rgb[i] = scale(rgb[i], 0, 255);
        if (!a && a != 0) a = 1;
        else a = scale(a, 0, 1);
        rgb[3] = a;
        return rgb;
    }
    function getHsla(string) {
        if (!string) return;
        var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
        var match = string.match(hsl);
        if (match) {
            var alpha = parseFloat(match[4]);
            var h = scale(parseInt(match[1]), 0, 360), s = scale(parseFloat(match[2]), 0, 100), l = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [
                h,
                s,
                l,
                a
            ];
        }
    }
    function getHwb(string) {
        if (!string) return;
        var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
        var match = string.match(hwb);
        if (match) {
            var alpha = parseFloat(match[4]);
            var h = scale(parseInt(match[1]), 0, 360), w = scale(parseFloat(match[2]), 0, 100), b = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
            return [
                h,
                w,
                b,
                a
            ];
        }
    }
    function getRgb(string) {
        var rgba = getRgba(string);
        return rgba && rgba.slice(0, 3);
    }
    function getHsl(string) {
        var hsla = getHsla(string);
        return hsla && hsla.slice(0, 3);
    }
    function getAlpha(string) {
        var vals = getRgba(string);
        if (vals) return vals[3];
        else if (vals = getHsla(string)) return vals[3];
        else if (vals = getHwb(string)) return vals[3];
    }
    // generators
    function hexString(rgba, a) {
        var a = a !== undefined && rgba.length === 3 ? a : rgba[3];
        return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (a >= 0 && a < 1 ? hexDouble(Math.round(a * 255)) : "");
    }
    function rgbString(rgba, alpha) {
        if (alpha < 1 || rgba[3] && rgba[3] < 1) return rgbaString(rgba, alpha);
        return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
    }
    function rgbaString(rgba, alpha) {
        if (alpha === undefined) alpha = rgba[3] !== undefined ? rgba[3] : 1;
        return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ", " + alpha + ")";
    }
    function percentString(rgba, alpha) {
        if (alpha < 1 || rgba[3] && rgba[3] < 1) return percentaString(rgba, alpha);
        var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
        return "rgb(" + r + "%, " + g + "%, " + b + "%)";
    }
    function percentaString(rgba, alpha) {
        var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
        return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
    }
    function hslString(hsla, alpha) {
        if (alpha < 1 || hsla[3] && hsla[3] < 1) return hslaString(hsla, alpha);
        return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
    }
    function hslaString(hsla, alpha) {
        if (alpha === undefined) alpha = hsla[3] !== undefined ? hsla[3] : 1;
        return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + alpha + ")";
    }
    // hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
    // (hwb have alpha optional & 1 is default value)
    function hwbString(hwb, alpha) {
        if (alpha === undefined) alpha = hwb[3] !== undefined ? hwb[3] : 1;
        return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%" + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
    }
    function keyword(rgb) {
        return reverseNames[rgb.slice(0, 3)];
    }
    // helpers
    function scale(num, min, max) {
        return Math.min(Math.max(min, num), max);
    }
    function hexDouble(num) {
        var str = num.toString(16).toUpperCase();
        return str.length < 2 ? "0" + str : str;
    }
    //create a list of reverse color names
    var reverseNames = {};
    for(var name in colorName$1)reverseNames[colorName$1[name]] = name;
    /* MIT license */ var Color = function(obj) {
        if (obj instanceof Color) return obj;
        if (!(this instanceof Color)) return new Color(obj);
        this.valid = false;
        this.values = {
            rgb: [
                0,
                0,
                0
            ],
            hsl: [
                0,
                0,
                0
            ],
            hsv: [
                0,
                0,
                0
            ],
            hwb: [
                0,
                0,
                0
            ],
            cmyk: [
                0,
                0,
                0,
                0
            ],
            alpha: 1
        };
        // parse Color() argument
        var vals;
        if (typeof obj === 'string') {
            vals = colorString.getRgba(obj);
            if (vals) this.setValues('rgb', vals);
            else if (vals = colorString.getHsla(obj)) this.setValues('hsl', vals);
            else if (vals = colorString.getHwb(obj)) this.setValues('hwb', vals);
        } else if (typeof obj === 'object') {
            vals = obj;
            if (vals.r !== undefined || vals.red !== undefined) this.setValues('rgb', vals);
            else if (vals.l !== undefined || vals.lightness !== undefined) this.setValues('hsl', vals);
            else if (vals.v !== undefined || vals.value !== undefined) this.setValues('hsv', vals);
            else if (vals.w !== undefined || vals.whiteness !== undefined) this.setValues('hwb', vals);
            else if (vals.c !== undefined || vals.cyan !== undefined) this.setValues('cmyk', vals);
        }
    };
    Color.prototype = {
        isValid: function() {
            return this.valid;
        },
        rgb: function() {
            return this.setSpace('rgb', arguments);
        },
        hsl: function() {
            return this.setSpace('hsl', arguments);
        },
        hsv: function() {
            return this.setSpace('hsv', arguments);
        },
        hwb: function() {
            return this.setSpace('hwb', arguments);
        },
        cmyk: function() {
            return this.setSpace('cmyk', arguments);
        },
        rgbArray: function() {
            return this.values.rgb;
        },
        hslArray: function() {
            return this.values.hsl;
        },
        hsvArray: function() {
            return this.values.hsv;
        },
        hwbArray: function() {
            var values = this.values;
            if (values.alpha !== 1) return values.hwb.concat([
                values.alpha
            ]);
            return values.hwb;
        },
        cmykArray: function() {
            return this.values.cmyk;
        },
        rgbaArray: function() {
            var values = this.values;
            return values.rgb.concat([
                values.alpha
            ]);
        },
        hslaArray: function() {
            var values = this.values;
            return values.hsl.concat([
                values.alpha
            ]);
        },
        alpha: function(val) {
            if (val === undefined) return this.values.alpha;
            this.setValues('alpha', val);
            return this;
        },
        red: function(val) {
            return this.setChannel('rgb', 0, val);
        },
        green: function(val) {
            return this.setChannel('rgb', 1, val);
        },
        blue: function(val) {
            return this.setChannel('rgb', 2, val);
        },
        hue: function(val) {
            if (val) {
                val %= 360;
                val = val < 0 ? 360 + val : val;
            }
            return this.setChannel('hsl', 0, val);
        },
        saturation: function(val) {
            return this.setChannel('hsl', 1, val);
        },
        lightness: function(val) {
            return this.setChannel('hsl', 2, val);
        },
        saturationv: function(val) {
            return this.setChannel('hsv', 1, val);
        },
        whiteness: function(val) {
            return this.setChannel('hwb', 1, val);
        },
        blackness: function(val) {
            return this.setChannel('hwb', 2, val);
        },
        value: function(val) {
            return this.setChannel('hsv', 2, val);
        },
        cyan: function(val) {
            return this.setChannel('cmyk', 0, val);
        },
        magenta: function(val) {
            return this.setChannel('cmyk', 1, val);
        },
        yellow: function(val) {
            return this.setChannel('cmyk', 2, val);
        },
        black: function(val) {
            return this.setChannel('cmyk', 3, val);
        },
        hexString: function() {
            return colorString.hexString(this.values.rgb);
        },
        rgbString: function() {
            return colorString.rgbString(this.values.rgb, this.values.alpha);
        },
        rgbaString: function() {
            return colorString.rgbaString(this.values.rgb, this.values.alpha);
        },
        percentString: function() {
            return colorString.percentString(this.values.rgb, this.values.alpha);
        },
        hslString: function() {
            return colorString.hslString(this.values.hsl, this.values.alpha);
        },
        hslaString: function() {
            return colorString.hslaString(this.values.hsl, this.values.alpha);
        },
        hwbString: function() {
            return colorString.hwbString(this.values.hwb, this.values.alpha);
        },
        keyword: function() {
            return colorString.keyword(this.values.rgb, this.values.alpha);
        },
        rgbNumber: function() {
            var rgb = this.values.rgb;
            return rgb[0] << 16 | rgb[1] << 8 | rgb[2];
        },
        luminosity: function() {
            // http://www.w3.org/TR/WCAG20/#relativeluminancedef
            var rgb = this.values.rgb;
            var lum = [];
            for(var i = 0; i < rgb.length; i++){
                var chan = rgb[i] / 255;
                lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
            }
            return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
        },
        contrast: function(color2) {
            // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
            var lum1 = this.luminosity();
            var lum2 = color2.luminosity();
            if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
            return (lum2 + 0.05) / (lum1 + 0.05);
        },
        level: function(color2) {
            var contrastRatio = this.contrast(color2);
            if (contrastRatio >= 7.1) return 'AAA';
            return contrastRatio >= 4.5 ? 'AA' : '';
        },
        dark: function() {
            // YIQ equation from http://24ways.org/2010/calculating-color-contrast
            var rgb = this.values.rgb;
            var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
            return yiq < 128;
        },
        light: function() {
            return !this.dark();
        },
        negate: function() {
            var rgb = [];
            for(var i = 0; i < 3; i++)rgb[i] = 255 - this.values.rgb[i];
            this.setValues('rgb', rgb);
            return this;
        },
        lighten: function(ratio) {
            var hsl = this.values.hsl;
            hsl[2] += hsl[2] * ratio;
            this.setValues('hsl', hsl);
            return this;
        },
        darken: function(ratio) {
            var hsl = this.values.hsl;
            hsl[2] -= hsl[2] * ratio;
            this.setValues('hsl', hsl);
            return this;
        },
        saturate: function(ratio) {
            var hsl = this.values.hsl;
            hsl[1] += hsl[1] * ratio;
            this.setValues('hsl', hsl);
            return this;
        },
        desaturate: function(ratio) {
            var hsl = this.values.hsl;
            hsl[1] -= hsl[1] * ratio;
            this.setValues('hsl', hsl);
            return this;
        },
        whiten: function(ratio) {
            var hwb = this.values.hwb;
            hwb[1] += hwb[1] * ratio;
            this.setValues('hwb', hwb);
            return this;
        },
        blacken: function(ratio) {
            var hwb = this.values.hwb;
            hwb[2] += hwb[2] * ratio;
            this.setValues('hwb', hwb);
            return this;
        },
        greyscale: function() {
            var rgb = this.values.rgb;
            // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
            var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
            this.setValues('rgb', [
                val,
                val,
                val
            ]);
            return this;
        },
        clearer: function(ratio) {
            var alpha = this.values.alpha;
            this.setValues('alpha', alpha - alpha * ratio);
            return this;
        },
        opaquer: function(ratio) {
            var alpha = this.values.alpha;
            this.setValues('alpha', alpha + alpha * ratio);
            return this;
        },
        rotate: function(degrees) {
            var hsl = this.values.hsl;
            var hue = (hsl[0] + degrees) % 360;
            hsl[0] = hue < 0 ? 360 + hue : hue;
            this.setValues('hsl', hsl);
            return this;
        },
        /**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */ mix: function(mixinColor, weight) {
            var color1 = this;
            var color2 = mixinColor;
            var p = weight === undefined ? 0.5 : weight;
            var w = 2 * p - 1;
            var a = color1.alpha() - color2.alpha();
            var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            var w2 = 1 - w1;
            return this.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue()).alpha(color1.alpha() * p + color2.alpha() * (1 - p));
        },
        toJSON: function() {
            return this.rgb();
        },
        clone: function() {
            // NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
            // making the final build way to big to embed in Chart.js. So let's do it manually,
            // assuming that values to clone are 1 dimension arrays containing only numbers,
            // except 'alpha' which is a number.
            var result = new Color();
            var source = this.values;
            var target = result.values;
            var value, type;
            for(var prop in source)if (source.hasOwnProperty(prop)) {
                value = source[prop];
                type = ({}).toString.call(value);
                if (type === '[object Array]') target[prop] = value.slice(0);
                else if (type === '[object Number]') target[prop] = value;
                else console.error('unexpected color value:', value);
            }
            return result;
        }
    };
    Color.prototype.spaces = {
        rgb: [
            'red',
            'green',
            'blue'
        ],
        hsl: [
            'hue',
            'saturation',
            'lightness'
        ],
        hsv: [
            'hue',
            'saturation',
            'value'
        ],
        hwb: [
            'hue',
            'whiteness',
            'blackness'
        ],
        cmyk: [
            'cyan',
            'magenta',
            'yellow',
            'black'
        ]
    };
    Color.prototype.maxes = {
        rgb: [
            255,
            255,
            255
        ],
        hsl: [
            360,
            100,
            100
        ],
        hsv: [
            360,
            100,
            100
        ],
        hwb: [
            360,
            100,
            100
        ],
        cmyk: [
            100,
            100,
            100,
            100
        ]
    };
    Color.prototype.getValues = function(space) {
        var values = this.values;
        var vals = {};
        for(var i = 0; i < space.length; i++)vals[space.charAt(i)] = values[space][i];
        if (values.alpha !== 1) vals.a = values.alpha;
        // {r: 255, g: 255, b: 255, a: 0.4}
        return vals;
    };
    Color.prototype.setValues = function(space, vals) {
        var values = this.values;
        var spaces = this.spaces;
        var maxes = this.maxes;
        var alpha = 1;
        var i;
        this.valid = true;
        if (space === 'alpha') alpha = vals;
        else if (vals.length) {
            // [10, 10, 10]
            values[space] = vals.slice(0, space.length);
            alpha = vals[space.length];
        } else if (vals[space.charAt(0)] !== undefined) {
            // {r: 10, g: 10, b: 10}
            for(i = 0; i < space.length; i++)values[space][i] = vals[space.charAt(i)];
            alpha = vals.a;
        } else if (vals[spaces[space][0]] !== undefined) {
            // {red: 10, green: 10, blue: 10}
            var chans = spaces[space];
            for(i = 0; i < space.length; i++)values[space][i] = vals[chans[i]];
            alpha = vals.alpha;
        }
        values.alpha = Math.max(0, Math.min(1, alpha === undefined ? values.alpha : alpha));
        if (space === 'alpha') return false;
        var capped;
        // cap values of the space prior converting all values
        for(i = 0; i < space.length; i++){
            capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
            values[space][i] = Math.round(capped);
        }
        // convert to all the other color spaces
        for(var sname in spaces)if (sname !== space) values[sname] = colorConvert[space][sname](values[space]);
        return true;
    };
    Color.prototype.setSpace = function(space, args) {
        var vals = args[0];
        if (vals === undefined) // color.rgb()
        return this.getValues(space);
        // color.rgb(10, 10, 10)
        if (typeof vals === 'number') vals = Array.prototype.slice.call(args);
        this.setValues(space, vals);
        return this;
    };
    Color.prototype.setChannel = function(space, index, val) {
        var svalues = this.values[space];
        if (val === undefined) // color.red()
        return svalues[index];
        else if (val === svalues[index]) // color.red(color.red())
        return this;
        // color.red(100)
        svalues[index] = val;
        this.setValues(space, svalues);
        return this;
    };
    if (typeof window !== 'undefined') window.Color = Color;
    var chartjsColor = Color;
    function isValidKey(key) {
        return [
            '__proto__',
            'prototype',
            'constructor'
        ].indexOf(key) === -1;
    }
    /**
 * @namespace Chart.helpers
 */ var helpers = {
        /**
	 * An empty function that can be used, for example, for optional callback.
	 */ noop: function() {},
        /**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */ uid: function() {
            var id = 0;
            return function() {
                return id++;
            };
        }(),
        /**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */ isNullOrUndef: function(value) {
            return value === null || typeof value === 'undefined';
        },
        /**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */ isArray: function(value) {
            if (Array.isArray && Array.isArray(value)) return true;
            var type = Object.prototype.toString.call(value);
            if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') return true;
            return false;
        },
        /**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */ isObject: function(value) {
            return value !== null && Object.prototype.toString.call(value) === '[object Object]';
        },
        /**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */ isFinite: function(value) {
            return (typeof value === 'number' || value instanceof Number) && isFinite(value);
        },
        /**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */ valueOrDefault: function(value, defaultValue) {
            return typeof value === 'undefined' ? defaultValue : value;
        },
        /**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */ valueAtIndexOrDefault: function(value, index, defaultValue) {
            return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
        },
        /**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */ callback: function(fn, args, thisArg) {
            if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
        },
        /**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */ each: function(loopable, fn, thisArg, reverse) {
            var i, len, keys;
            if (helpers.isArray(loopable)) {
                len = loopable.length;
                if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
                else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
            } else if (helpers.isObject(loopable)) {
                keys = Object.keys(loopable);
                len = keys.length;
                for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
            }
        },
        /**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */ arrayEquals: function(a0, a1) {
            var i, ilen, v0, v1;
            if (!a0 || !a1 || a0.length !== a1.length) return false;
            for(i = 0, ilen = a0.length; i < ilen; ++i){
                v0 = a0[i];
                v1 = a1[i];
                if (v0 instanceof Array && v1 instanceof Array) {
                    if (!helpers.arrayEquals(v0, v1)) return false;
                } else if (v0 !== v1) // NOTE: two different object instances will never be equal: {x:20} != {x:20}
                return false;
            }
            return true;
        },
        /**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */ clone: function(source) {
            if (helpers.isArray(source)) return source.map(helpers.clone);
            if (helpers.isObject(source)) {
                var target = Object.create(source);
                var keys = Object.keys(source);
                var klen = keys.length;
                var k = 0;
                for(; k < klen; ++k)target[keys[k]] = helpers.clone(source[keys[k]]);
                return target;
            }
            return source;
        },
        /**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */ _merger: function(key, target, source, options) {
            if (!isValidKey(key)) // We want to ensure we do not copy prototypes over
            // as this can pollute global namespaces
            return;
            var tval = target[key];
            var sval = source[key];
            if (helpers.isObject(tval) && helpers.isObject(sval)) helpers.merge(tval, sval, options);
            else target[key] = helpers.clone(sval);
        },
        /**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */ _mergerIf: function(key, target, source) {
            if (!isValidKey(key)) // We want to ensure we do not copy prototypes over
            // as this can pollute global namespaces
            return;
            var tval = target[key];
            var sval = source[key];
            if (helpers.isObject(tval) && helpers.isObject(sval)) helpers.mergeIf(tval, sval);
            else if (!target.hasOwnProperty(key)) target[key] = helpers.clone(sval);
        },
        /**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */ merge: function(target, source, options) {
            var sources = helpers.isArray(source) ? source : [
                source
            ];
            var ilen = sources.length;
            var merge, i, keys, klen, k;
            if (!helpers.isObject(target)) return target;
            options = options || {};
            merge = options.merger || helpers._merger;
            for(i = 0; i < ilen; ++i){
                source = sources[i];
                if (!helpers.isObject(source)) continue;
                keys = Object.keys(source);
                for(k = 0, klen = keys.length; k < klen; ++k)merge(keys[k], target, source, options);
            }
            return target;
        },
        /**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */ mergeIf: function(target, source) {
            return helpers.merge(target, source, {
                merger: helpers._mergerIf
            });
        },
        /**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */ extend: Object.assign || function(target) {
            return helpers.merge(target, [].slice.call(arguments, 1), {
                merger: function(key, dst, src) {
                    dst[key] = src[key];
                }
            });
        },
        /**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */ inherits: function(extensions) {
            var me = this;
            var ChartElement = extensions && extensions.hasOwnProperty('constructor') ? extensions.constructor : function() {
                return me.apply(this, arguments);
            };
            var Surrogate = function() {
                this.constructor = ChartElement;
            };
            Surrogate.prototype = me.prototype;
            ChartElement.prototype = new Surrogate();
            ChartElement.extend = helpers.inherits;
            if (extensions) helpers.extend(ChartElement.prototype, extensions);
            ChartElement.__super__ = me.prototype;
            return ChartElement;
        },
        _deprecated: function(scope, value, previous, current) {
            if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
        }
    };
    var helpers_core = helpers;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */ helpers.callCallback = helpers.callback;
    /**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.indexOf = function(array, item, fromIndex) {
        return Array.prototype.indexOf.call(array, item, fromIndex);
    };
    /**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.getValueOrDefault = helpers.valueOrDefault;
    /**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
    /**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */ var effects = {
        linear: function(t) {
            return t;
        },
        easeInQuad: function(t) {
            return t * t;
        },
        easeOutQuad: function(t) {
            return -t * (t - 2);
        },
        easeInOutQuad: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t;
            return -0.5 * (--t * (t - 2) - 1);
        },
        easeInCubic: function(t) {
            return t * t * t;
        },
        easeOutCubic: function(t) {
            return (t = t - 1) * t * t + 1;
        },
        easeInOutCubic: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t;
            return 0.5 * ((t -= 2) * t * t + 2);
        },
        easeInQuart: function(t) {
            return t * t * t * t;
        },
        easeOutQuart: function(t) {
            return -((t = t - 1) * t * t * t - 1);
        },
        easeInOutQuart: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t * t;
            return -0.5 * ((t -= 2) * t * t * t - 2);
        },
        easeInQuint: function(t) {
            return t * t * t * t * t;
        },
        easeOutQuint: function(t) {
            return (t = t - 1) * t * t * t * t + 1;
        },
        easeInOutQuint: function(t) {
            if ((t /= 0.5) < 1) return 0.5 * t * t * t * t * t;
            return 0.5 * ((t -= 2) * t * t * t * t + 2);
        },
        easeInSine: function(t) {
            return -Math.cos(t * (Math.PI / 2)) + 1;
        },
        easeOutSine: function(t) {
            return Math.sin(t * (Math.PI / 2));
        },
        easeInOutSine: function(t) {
            return -0.5 * (Math.cos(Math.PI * t) - 1);
        },
        easeInExpo: function(t) {
            return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
        },
        easeOutExpo: function(t) {
            return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
        },
        easeInOutExpo: function(t) {
            if (t === 0) return 0;
            if (t === 1) return 1;
            if ((t /= 0.5) < 1) return 0.5 * Math.pow(2, 10 * (t - 1));
            return 0.5 * (-Math.pow(2, -10 * --t) + 2);
        },
        easeInCirc: function(t) {
            if (t >= 1) return t;
            return -(Math.sqrt(1 - t * t) - 1);
        },
        easeOutCirc: function(t) {
            return Math.sqrt(1 - (t = t - 1) * t);
        },
        easeInOutCirc: function(t) {
            if ((t /= 0.5) < 1) return -0.5 * (Math.sqrt(1 - t * t) - 1);
            return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
        },
        easeInElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if (t === 1) return 1;
            if (!p) p = 0.3;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
        },
        easeOutElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if (t === 1) return 1;
            if (!p) p = 0.3;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
        },
        easeInOutElastic: function(t) {
            var s = 1.70158;
            var p = 0;
            var a = 1;
            if (t === 0) return 0;
            if ((t /= 0.5) === 2) return 1;
            if (!p) p = 0.45;
            if (a < 1) {
                a = 1;
                s = p / 4;
            } else s = p / (2 * Math.PI) * Math.asin(1 / a);
            if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
            return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
        },
        easeInBack: function(t) {
            var s = 1.70158;
            return t * t * ((s + 1) * t - s);
        },
        easeOutBack: function(t) {
            var s = 1.70158;
            return (t = t - 1) * t * ((s + 1) * t + s) + 1;
        },
        easeInOutBack: function(t) {
            var s = 1.70158;
            if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
            return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
        },
        easeInBounce: function(t) {
            return 1 - effects.easeOutBounce(1 - t);
        },
        easeOutBounce: function(t) {
            if (t < 1 / 2.75) return 7.5625 * t * t;
            if (t < 2 / 2.75) return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
            if (t < 2.5 / 2.75) return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
            return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
        },
        easeInOutBounce: function(t) {
            if (t < 0.5) return effects.easeInBounce(t * 2) * 0.5;
            return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
        }
    };
    var helpers_easing = {
        effects: effects
    };
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.easingEffects = effects;
    var PI = Math.PI;
    var RAD_PER_DEG = PI / 180;
    var DOUBLE_PI = PI * 2;
    var HALF_PI = PI / 2;
    var QUARTER_PI = PI / 4;
    var TWO_THIRDS_PI = PI * 2 / 3;
    /**
 * @namespace Chart.helpers.canvas
 */ var exports$1 = {
        /**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */ clear: function(chart) {
            chart.ctx.clearRect(0, 0, chart.width, chart.height);
        },
        /**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */ roundedRect: function(ctx, x, y, width, height, radius) {
            if (radius) {
                var r = Math.min(radius, height / 2, width / 2);
                var left = x + r;
                var top = y + r;
                var right = x + width - r;
                var bottom = y + height - r;
                ctx.moveTo(x, top);
                if (left < right && top < bottom) {
                    ctx.arc(left, top, r, -PI, -HALF_PI);
                    ctx.arc(right, top, r, -HALF_PI, 0);
                    ctx.arc(right, bottom, r, 0, HALF_PI);
                    ctx.arc(left, bottom, r, HALF_PI, PI);
                } else if (left < right) {
                    ctx.moveTo(left, y);
                    ctx.arc(right, top, r, -HALF_PI, HALF_PI);
                    ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
                } else if (top < bottom) {
                    ctx.arc(left, top, r, -PI, 0);
                    ctx.arc(left, bottom, r, 0, PI);
                } else ctx.arc(left, top, r, -PI, PI);
                ctx.closePath();
                ctx.moveTo(x, y);
            } else ctx.rect(x, y, width, height);
        },
        drawPoint: function(ctx, style, radius, x, y, rotation) {
            var type, xOffset, yOffset, size, cornerRadius;
            var rad = (rotation || 0) * RAD_PER_DEG;
            if (style && typeof style === 'object') {
                type = style.toString();
                if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
                    ctx.save();
                    ctx.translate(x, y);
                    ctx.rotate(rad);
                    ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
                    ctx.restore();
                    return;
                }
            }
            if (isNaN(radius) || radius <= 0) return;
            ctx.beginPath();
            switch(style){
                // Default includes circle
                default:
                    ctx.arc(x, y, radius, 0, DOUBLE_PI);
                    ctx.closePath();
                    break;
                case 'triangle':
                    ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    rad += TWO_THIRDS_PI;
                    ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    rad += TWO_THIRDS_PI;
                    ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
                    ctx.closePath();
                    break;
                case 'rectRounded':
                    // NOTE: the rounded rect implementation changed to use `arc` instead of
                    // `quadraticCurveTo` since it generates better results when rect is
                    // almost a circle. 0.516 (instead of 0.5) produces results with visually
                    // closer proportion to the previous impl and it is inscribed in the
                    // circle with `radius`. For more details, see the following PRs:
                    // https://github.com/chartjs/Chart.js/issues/5597
                    // https://github.com/chartjs/Chart.js/issues/5858
                    cornerRadius = radius * 0.516;
                    size = radius - cornerRadius;
                    xOffset = Math.cos(rad + QUARTER_PI) * size;
                    yOffset = Math.sin(rad + QUARTER_PI) * size;
                    ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
                    ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
                    ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
                    ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
                    ctx.closePath();
                    break;
                case 'rect':
                    if (!rotation) {
                        size = Math.SQRT1_2 * radius;
                        ctx.rect(x - size, y - size, 2 * size, 2 * size);
                        break;
                    }
                    rad += QUARTER_PI;
                /* falls through */ case 'rectRot':
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    ctx.closePath();
                    break;
                case 'crossRot':
                    rad += QUARTER_PI;
                /* falls through */ case 'cross':
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    break;
                case 'star':
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    rad += QUARTER_PI;
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    ctx.moveTo(x + yOffset, y - xOffset);
                    ctx.lineTo(x - yOffset, y + xOffset);
                    break;
                case 'line':
                    xOffset = Math.cos(rad) * radius;
                    yOffset = Math.sin(rad) * radius;
                    ctx.moveTo(x - xOffset, y - yOffset);
                    ctx.lineTo(x + xOffset, y + yOffset);
                    break;
                case 'dash':
                    ctx.moveTo(x, y);
                    ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
                    break;
            }
            ctx.fill();
            ctx.stroke();
        },
        /**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */ _isPointInArea: function(point, area) {
            var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
            return point.x > area.left - epsilon && point.x < area.right + epsilon && point.y > area.top - epsilon && point.y < area.bottom + epsilon;
        },
        clipArea: function(ctx, area) {
            ctx.save();
            ctx.beginPath();
            ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
            ctx.clip();
        },
        unclipArea: function(ctx) {
            ctx.restore();
        },
        lineTo: function(ctx, previous, target, flip) {
            var stepped = target.steppedLine;
            if (stepped) {
                if (stepped === 'middle') {
                    var midpoint = (previous.x + target.x) / 2.0;
                    ctx.lineTo(midpoint, flip ? target.y : previous.y);
                    ctx.lineTo(midpoint, flip ? previous.y : target.y);
                } else if (stepped === 'after' && !flip || stepped !== 'after' && flip) ctx.lineTo(previous.x, target.y);
                else ctx.lineTo(target.x, previous.y);
                ctx.lineTo(target.x, target.y);
                return;
            }
            if (!target.tension) {
                ctx.lineTo(target.x, target.y);
                return;
            }
            ctx.bezierCurveTo(flip ? previous.controlPointPreviousX : previous.controlPointNextX, flip ? previous.controlPointPreviousY : previous.controlPointNextY, flip ? target.controlPointNextX : target.controlPointPreviousX, flip ? target.controlPointNextY : target.controlPointPreviousY, target.x, target.y);
        }
    };
    var helpers_canvas = exports$1;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.clear = exports$1.clear;
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers_core.drawRoundedRectangle = function(ctx) {
        ctx.beginPath();
        exports$1.roundedRect.apply(exports$1, arguments);
    };
    var defaults = {
        /**
	 * @private
	 */ _set: function(scope, values) {
            return helpers_core.merge(this[scope] || (this[scope] = {}), values);
        }
    };
    // TODO(v3): remove 'global' from namespace.  all default are global and
    // there's inconsistency around which options are under 'global'
    defaults._set('global', {
        defaultColor: 'rgba(0,0,0,0.1)',
        defaultFontColor: '#666',
        defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        defaultFontSize: 12,
        defaultFontStyle: 'normal',
        defaultLineHeight: 1.2,
        showLines: true
    });
    var core_defaults = defaults;
    var valueOrDefault = helpers_core.valueOrDefault;
    /**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function toFontString(font) {
        if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) return null;
        return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
    }
    /**
 * @alias Chart.helpers.options
 * @namespace
 */ var helpers_options = {
        /**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */ toLineHeight: function(value, size) {
            var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
            if (!matches || matches[1] === 'normal') return size * 1.2;
            value = +matches[2];
            switch(matches[3]){
                case 'px':
                    return value;
                case '%':
                    value /= 100;
                    break;
            }
            return size * value;
        },
        /**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */ toPadding: function(value) {
            var t, r, b, l;
            if (helpers_core.isObject(value)) {
                t = +value.top || 0;
                r = +value.right || 0;
                b = +value.bottom || 0;
                l = +value.left || 0;
            } else t = r = b = l = +value || 0;
            return {
                top: t,
                right: r,
                bottom: b,
                left: l,
                height: t + b,
                width: l + r
            };
        },
        /**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */ _parseFont: function(options) {
            var globalDefaults = core_defaults.global;
            var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
            var font = {
                family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
                lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
                size: size,
                style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
                weight: null,
                string: ''
            };
            font.string = toFontString(font);
            return font;
        },
        /**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @param {object} [info] - object to return information about resolution in
	 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
	 * @since 2.7.0
	 */ resolve: function(inputs, context, index, info) {
            var cacheable = true;
            var i, ilen, value;
            for(i = 0, ilen = inputs.length; i < ilen; ++i){
                value = inputs[i];
                if (value === undefined) continue;
                if (context !== undefined && typeof value === 'function') {
                    value = value(context);
                    cacheable = false;
                }
                if (index !== undefined && helpers_core.isArray(value)) {
                    value = value[index];
                    cacheable = false;
                }
                if (value !== undefined) {
                    if (info && !cacheable) info.cacheable = false;
                    return value;
                }
            }
        }
    };
    /**
 * @alias Chart.helpers.math
 * @namespace
 */ var exports$2 = {
        /**
	 * Returns an array of factors sorted from 1 to sqrt(value)
	 * @private
	 */ _factorize: function(value) {
            var result = [];
            var sqrt = Math.sqrt(value);
            var i;
            for(i = 1; i < sqrt; i++)if (value % i === 0) {
                result.push(i);
                result.push(value / i);
            }
            if (sqrt === (sqrt | 0)) result.push(sqrt);
            result.sort(function(a, b) {
                return a - b;
            }).pop();
            return result;
        },
        log10: Math.log10 || function(x) {
            var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
            // Check for whole powers of 10,
            // which due to floating point rounding error should be corrected.
            var powerOf10 = Math.round(exponent);
            var isPowerOf10 = x === Math.pow(10, powerOf10);
            return isPowerOf10 ? powerOf10 : exponent;
        }
    };
    var helpers_math = exports$2;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
 * @namespace Chart.helpers.log10
 * @deprecated since version 2.9.0
 * @todo remove at version 3
 * @private
 */ helpers_core.log10 = exports$2.log10;
    var getRtlAdapter = function(rectX, width) {
        return {
            x: function(x) {
                return rectX + rectX + width - x;
            },
            setWidth: function(w) {
                width = w;
            },
            textAlign: function(align) {
                if (align === 'center') return align;
                return align === 'right' ? 'left' : 'right';
            },
            xPlus: function(x, value) {
                return x - value;
            },
            leftForLtr: function(x, itemWidth) {
                return x - itemWidth;
            }
        };
    };
    var getLtrAdapter = function() {
        return {
            x: function(x) {
                return x;
            },
            setWidth: function(w) {},
            textAlign: function(align) {
                return align;
            },
            xPlus: function(x, value) {
                return x + value;
            },
            leftForLtr: function(x, _itemWidth) {
                return x;
            }
        };
    };
    var getAdapter = function(rtl, rectX, width) {
        return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
    };
    var overrideTextDirection = function(ctx, direction) {
        var style, original;
        if (direction === 'ltr' || direction === 'rtl') {
            style = ctx.canvas.style;
            original = [
                style.getPropertyValue('direction'),
                style.getPropertyPriority('direction')
            ];
            style.setProperty('direction', direction, 'important');
            ctx.prevTextDirection = original;
        }
    };
    var restoreTextDirection = function(ctx) {
        var original = ctx.prevTextDirection;
        if (original !== undefined) {
            delete ctx.prevTextDirection;
            ctx.canvas.style.setProperty('direction', original[0], original[1]);
        }
    };
    var helpers_rtl = {
        getRtlAdapter: getAdapter,
        overrideTextDirection: overrideTextDirection,
        restoreTextDirection: restoreTextDirection
    };
    var helpers$1 = helpers_core;
    var easing = helpers_easing;
    var canvas = helpers_canvas;
    var options = helpers_options;
    var math = helpers_math;
    var rtl = helpers_rtl;
    helpers$1.easing = easing;
    helpers$1.canvas = canvas;
    helpers$1.options = options;
    helpers$1.math = math;
    helpers$1.rtl = rtl;
    function interpolate(start, view, model, ease) {
        var keys = Object.keys(model);
        var i, ilen, key, actual, origin, target, type, c0, c1;
        for(i = 0, ilen = keys.length; i < ilen; ++i){
            key = keys[i];
            target = model[key];
            // if a value is added to the model after pivot() has been called, the view
            // doesn't contain it, so let's initialize the view to the target value.
            if (!view.hasOwnProperty(key)) view[key] = target;
            actual = view[key];
            if (actual === target || key[0] === '_') continue;
            if (!start.hasOwnProperty(key)) start[key] = actual;
            origin = start[key];
            type = typeof target;
            if (type === typeof origin) {
                if (type === 'string') {
                    c0 = chartjsColor(origin);
                    if (c0.valid) {
                        c1 = chartjsColor(target);
                        if (c1.valid) {
                            view[key] = c1.mix(c0, ease).rgbString();
                            continue;
                        }
                    }
                } else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
                    view[key] = origin + (target - origin) * ease;
                    continue;
                }
            }
            view[key] = target;
        }
    }
    var Element = function(configuration) {
        helpers$1.extend(this, configuration);
        this.initialize.apply(this, arguments);
    };
    helpers$1.extend(Element.prototype, {
        _type: undefined,
        initialize: function() {
            this.hidden = false;
        },
        pivot: function() {
            var me = this;
            if (!me._view) me._view = helpers$1.extend({}, me._model);
            me._start = {};
            return me;
        },
        transition: function(ease) {
            var me = this;
            var model = me._model;
            var start = me._start;
            var view = me._view;
            // No animation -> No Transition
            if (!model || ease === 1) {
                me._view = helpers$1.extend({}, model);
                me._start = null;
                return me;
            }
            if (!view) view = me._view = {};
            if (!start) start = me._start = {};
            interpolate(start, view, model, ease);
            return me;
        },
        tooltipPosition: function() {
            return {
                x: this._model.x,
                y: this._model.y
            };
        },
        hasValue: function() {
            return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
        }
    });
    Element.extend = helpers$1.inherits;
    var core_element = Element;
    var exports$3 = core_element.extend({
        chart: null,
        currentStep: 0,
        numSteps: 60,
        easing: '',
        render: null,
        onAnimationProgress: null,
        onAnimationComplete: null
    });
    var core_animation = exports$3;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */ Object.defineProperty(exports$3.prototype, 'animationObject', {
        get: function() {
            return this;
        }
    });
    /**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */ Object.defineProperty(exports$3.prototype, 'chartInstance', {
        get: function() {
            return this.chart;
        },
        set: function(value) {
            this.chart = value;
        }
    });
    core_defaults._set('global', {
        animation: {
            duration: 1000,
            easing: 'easeOutQuart',
            onProgress: helpers$1.noop,
            onComplete: helpers$1.noop
        }
    });
    var core_animations = {
        animations: [],
        request: null,
        /**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */ addAnimation: function(chart, animation, duration, lazy) {
            var animations = this.animations;
            var i, ilen;
            animation.chart = chart;
            animation.startTime = Date.now();
            animation.duration = duration;
            if (!lazy) chart.animating = true;
            for(i = 0, ilen = animations.length; i < ilen; ++i)if (animations[i].chart === chart) {
                animations[i] = animation;
                return;
            }
            animations.push(animation);
            // If there are no animations queued, manually kickstart a digest, for lack of a better word
            if (animations.length === 1) this.requestAnimationFrame();
        },
        cancelAnimation: function(chart) {
            var index = helpers$1.findIndex(this.animations, function(animation) {
                return animation.chart === chart;
            });
            if (index !== -1) {
                this.animations.splice(index, 1);
                chart.animating = false;
            }
        },
        requestAnimationFrame: function() {
            var me = this;
            if (me.request === null) // Skip animation frame requests until the active one is executed.
            // This can happen when processing mouse events, e.g. 'mousemove'
            // and 'mouseout' events will trigger multiple renders.
            me.request = helpers$1.requestAnimFrame.call(window, function() {
                me.request = null;
                me.startDigest();
            });
        },
        /**
	 * @private
	 */ startDigest: function() {
            var me = this;
            me.advance();
            // Do we have more stuff to animate?
            if (me.animations.length > 0) me.requestAnimationFrame();
        },
        /**
	 * @private
	 */ advance: function() {
            var animations = this.animations;
            var animation, chart, numSteps, nextStep;
            var i = 0;
            // 1 animation per chart, so we are looping charts here
            while(i < animations.length){
                animation = animations[i];
                chart = animation.chart;
                numSteps = animation.numSteps;
                // Make sure that currentStep starts at 1
                // https://github.com/chartjs/Chart.js/issues/6104
                nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
                animation.currentStep = Math.min(nextStep, numSteps);
                helpers$1.callback(animation.render, [
                    chart,
                    animation
                ], chart);
                helpers$1.callback(animation.onAnimationProgress, [
                    animation
                ], chart);
                if (animation.currentStep >= numSteps) {
                    helpers$1.callback(animation.onAnimationComplete, [
                        animation
                    ], chart);
                    chart.animating = false;
                    animations.splice(i, 1);
                } else ++i;
            }
        }
    };
    var resolve = helpers$1.options.resolve;
    var arrayEvents = [
        'push',
        'pop',
        'shift',
        'splice',
        'unshift'
    ];
    /**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */ function listenArrayEvents(array, listener) {
        if (array._chartjs) {
            array._chartjs.listeners.push(listener);
            return;
        }
        Object.defineProperty(array, '_chartjs', {
            configurable: true,
            enumerable: false,
            value: {
                listeners: [
                    listener
                ]
            }
        });
        arrayEvents.forEach(function(key) {
            var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
            var base = array[key];
            Object.defineProperty(array, key, {
                configurable: true,
                enumerable: false,
                value: function() {
                    var args = Array.prototype.slice.call(arguments);
                    var res = base.apply(this, args);
                    helpers$1.each(array._chartjs.listeners, function(object) {
                        if (typeof object[method] === 'function') object[method].apply(object, args);
                    });
                    return res;
                }
            });
        });
    }
    /**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */ function unlistenArrayEvents(array, listener) {
        var stub = array._chartjs;
        if (!stub) return;
        var listeners = stub.listeners;
        var index = listeners.indexOf(listener);
        if (index !== -1) listeners.splice(index, 1);
        if (listeners.length > 0) return;
        arrayEvents.forEach(function(key) {
            delete array[key];
        });
        delete array._chartjs;
    }
    // Base class for all dataset controllers (line, bar, etc)
    var DatasetController = function(chart, datasetIndex) {
        this.initialize(chart, datasetIndex);
    };
    helpers$1.extend(DatasetController.prototype, {
        /**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */ datasetElementType: null,
        /**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */ dataElementType: null,
        /**
	 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */ _datasetElementOptions: [
            'backgroundColor',
            'borderCapStyle',
            'borderColor',
            'borderDash',
            'borderDashOffset',
            'borderJoinStyle',
            'borderWidth'
        ],
        /**
	 * Data element option keys to be resolved in _resolveDataElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'pointStyle'
        ],
        initialize: function(chart, datasetIndex) {
            var me = this;
            me.chart = chart;
            me.index = datasetIndex;
            me.linkScales();
            me.addElements();
            me._type = me.getMeta().type;
        },
        updateIndex: function(datasetIndex) {
            this.index = datasetIndex;
        },
        linkScales: function() {
            var me = this;
            var meta = me.getMeta();
            var chart = me.chart;
            var scales = chart.scales;
            var dataset = me.getDataset();
            var scalesOpts = chart.options.scales;
            if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
            if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
        },
        getDataset: function() {
            return this.chart.data.datasets[this.index];
        },
        getMeta: function() {
            return this.chart.getDatasetMeta(this.index);
        },
        getScaleForId: function(scaleID) {
            return this.chart.scales[scaleID];
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.getMeta().yAxisID;
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.getMeta().xAxisID;
        },
        /**
	 * @private
	 */ _getValueScale: function() {
            return this.getScaleForId(this._getValueScaleId());
        },
        /**
	 * @private
	 */ _getIndexScale: function() {
            return this.getScaleForId(this._getIndexScaleId());
        },
        reset: function() {
            this._update(true);
        },
        /**
	 * @private
	 */ destroy: function() {
            if (this._data) unlistenArrayEvents(this._data, this);
        },
        createMetaDataset: function() {
            var me = this;
            var type = me.datasetElementType;
            return type && new type({
                _chart: me.chart,
                _datasetIndex: me.index
            });
        },
        createMetaData: function(index) {
            var me = this;
            var type = me.dataElementType;
            return type && new type({
                _chart: me.chart,
                _datasetIndex: me.index,
                _index: index
            });
        },
        addElements: function() {
            var me = this;
            var meta = me.getMeta();
            var data = me.getDataset().data || [];
            var metaData = meta.data;
            var i, ilen;
            for(i = 0, ilen = data.length; i < ilen; ++i)metaData[i] = metaData[i] || me.createMetaData(i);
            meta.dataset = meta.dataset || me.createMetaDataset();
        },
        addElementAndReset: function(index) {
            var element = this.createMetaData(index);
            this.getMeta().data.splice(index, 0, element);
            this.updateElement(element, index, true);
        },
        buildOrUpdateElements: function() {
            var me = this;
            var dataset = me.getDataset();
            var data = dataset.data || (dataset.data = []);
            // In order to correctly handle data addition/deletion animation (an thus simulate
            // real-time charts), we need to monitor these data modifications and synchronize
            // the internal meta data accordingly.
            if (me._data !== data) {
                if (me._data) // This case happens when the user replaced the data array instance.
                unlistenArrayEvents(me._data, me);
                if (data && Object.isExtensible(data)) listenArrayEvents(data, me);
                me._data = data;
            }
            // Re-sync meta data in case the user replaced the data array or if we missed
            // any updates and so make sure that we handle number of datapoints changing.
            me.resyncElements();
        },
        /**
	 * Returns the merged user-supplied and default dataset-level options
	 * @private
	 */ _configure: function() {
            var me = this;
            me._config = helpers$1.merge(Object.create(null), [
                me.chart.options.datasets[me._type],
                me.getDataset()
            ], {
                merger: function(key, target, source) {
                    if (key !== '_meta' && key !== 'data') helpers$1._merger(key, target, source);
                }
            });
        },
        _update: function(reset) {
            var me = this;
            me._configure();
            me._cachedDataOpts = null;
            me.update(reset);
        },
        update: helpers$1.noop,
        transition: function(easingValue) {
            var meta = this.getMeta();
            var elements = meta.data || [];
            var ilen = elements.length;
            var i = 0;
            for(; i < ilen; ++i)elements[i].transition(easingValue);
            if (meta.dataset) meta.dataset.transition(easingValue);
        },
        draw: function() {
            var meta = this.getMeta();
            var elements = meta.data || [];
            var ilen = elements.length;
            var i = 0;
            if (meta.dataset) meta.dataset.draw();
            for(; i < ilen; ++i)elements[i].draw();
        },
        /**
	 * Returns a set of predefined style properties that should be used to represent the dataset
	 * or the data if the index is specified
	 * @param {number} index - data index
	 * @return {IStyleInterface} style object
	 */ getStyle: function(index) {
            var me = this;
            var meta = me.getMeta();
            var dataset = meta.dataset;
            var style;
            me._configure();
            if (dataset && index === undefined) style = me._resolveDatasetElementOptions(dataset || {});
            else {
                index = index || 0;
                style = me._resolveDataElementOptions(meta.data[index] || {}, index);
            }
            if (style.fill === false || style.fill === null) style.backgroundColor = style.borderColor;
            return style;
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function(element, hover) {
            var me = this;
            var chart = me.chart;
            var datasetOpts = me._config;
            var custom = element.custom || {};
            var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
            var elementOptions = me._datasetElementOptions;
            var values = {};
            var i, ilen, key, readKey;
            // Scriptable options
            var context = {
                chart: chart,
                dataset: me.getDataset(),
                datasetIndex: me.index,
                hover: hover
            };
            for(i = 0, ilen = elementOptions.length; i < ilen; ++i){
                key = elementOptions[i];
                readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
                values[key] = resolve([
                    custom[readKey],
                    datasetOpts[readKey],
                    options[readKey]
                ], context);
            }
            return values;
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function(element, index) {
            var me = this;
            var custom = element && element.custom;
            var cached = me._cachedDataOpts;
            if (cached && !custom) return cached;
            var chart = me.chart;
            var datasetOpts = me._config;
            var options = chart.options.elements[me.dataElementType.prototype._type] || {};
            var elementOptions = me._dataElementOptions;
            var values = {};
            // Scriptable options
            var context = {
                chart: chart,
                dataIndex: index,
                dataset: me.getDataset(),
                datasetIndex: me.index
            };
            // `resolve` sets cacheable to `false` if any option is indexed or scripted
            var info = {
                cacheable: !custom
            };
            var keys, i, ilen, key;
            custom = custom || {};
            if (helpers$1.isArray(elementOptions)) for(i = 0, ilen = elementOptions.length; i < ilen; ++i){
                key = elementOptions[i];
                values[key] = resolve([
                    custom[key],
                    datasetOpts[key],
                    options[key]
                ], context, index, info);
            }
            else {
                keys = Object.keys(elementOptions);
                for(i = 0, ilen = keys.length; i < ilen; ++i){
                    key = keys[i];
                    values[key] = resolve([
                        custom[key],
                        datasetOpts[elementOptions[key]],
                        datasetOpts[key],
                        options[key]
                    ], context, index, info);
                }
            }
            if (info.cacheable) me._cachedDataOpts = Object.freeze(values);
            return values;
        },
        removeHoverStyle: function(element) {
            helpers$1.merge(element._model, element.$previousStyle || {});
            delete element.$previousStyle;
        },
        setHoverStyle: function(element) {
            var dataset = this.chart.data.datasets[element._datasetIndex];
            var index = element._index;
            var custom = element.custom || {};
            var model = element._model;
            var getHoverColor = helpers$1.getHoverColor;
            element.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = resolve([
                custom.hoverBackgroundColor,
                dataset.hoverBackgroundColor,
                getHoverColor(model.backgroundColor)
            ], undefined, index);
            model.borderColor = resolve([
                custom.hoverBorderColor,
                dataset.hoverBorderColor,
                getHoverColor(model.borderColor)
            ], undefined, index);
            model.borderWidth = resolve([
                custom.hoverBorderWidth,
                dataset.hoverBorderWidth,
                model.borderWidth
            ], undefined, index);
        },
        /**
	 * @private
	 */ _removeDatasetHoverStyle: function() {
            var element = this.getMeta().dataset;
            if (element) this.removeHoverStyle(element);
        },
        /**
	 * @private
	 */ _setDatasetHoverStyle: function() {
            var element = this.getMeta().dataset;
            var prev = {};
            var i, ilen, key, keys, hoverOptions, model;
            if (!element) return;
            model = element._model;
            hoverOptions = this._resolveDatasetElementOptions(element, true);
            keys = Object.keys(hoverOptions);
            for(i = 0, ilen = keys.length; i < ilen; ++i){
                key = keys[i];
                prev[key] = model[key];
                model[key] = hoverOptions[key];
            }
            element.$previousStyle = prev;
        },
        /**
	 * @private
	 */ resyncElements: function() {
            var me = this;
            var meta = me.getMeta();
            var data = me.getDataset().data;
            var numMeta = meta.data.length;
            var numData = data.length;
            if (numData < numMeta) meta.data.splice(numData, numMeta - numData);
            else if (numData > numMeta) me.insertElements(numMeta, numData - numMeta);
        },
        /**
	 * @private
	 */ insertElements: function(start, count) {
            for(var i = 0; i < count; ++i)this.addElementAndReset(start + i);
        },
        /**
	 * @private
	 */ onDataPush: function() {
            var count = arguments.length;
            this.insertElements(this.getDataset().data.length - count, count);
        },
        /**
	 * @private
	 */ onDataPop: function() {
            this.getMeta().data.pop();
        },
        /**
	 * @private
	 */ onDataShift: function() {
            this.getMeta().data.shift();
        },
        /**
	 * @private
	 */ onDataSplice: function(start, count) {
            this.getMeta().data.splice(start, count);
            this.insertElements(start, arguments.length - 2);
        },
        /**
	 * @private
	 */ onDataUnshift: function() {
            this.insertElements(0, arguments.length);
        }
    });
    DatasetController.extend = helpers$1.inherits;
    var core_datasetController = DatasetController;
    var TAU = Math.PI * 2;
    core_defaults._set('global', {
        elements: {
            arc: {
                backgroundColor: core_defaults.global.defaultColor,
                borderColor: '#fff',
                borderWidth: 2,
                borderAlign: 'center'
            }
        }
    });
    function clipArc(ctx, arc) {
        var startAngle = arc.startAngle;
        var endAngle = arc.endAngle;
        var pixelMargin = arc.pixelMargin;
        var angleMargin = pixelMargin / arc.outerRadius;
        var x = arc.x;
        var y = arc.y;
        // Draw an inner border by cliping the arc and drawing a double-width border
        // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
        ctx.beginPath();
        ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
        if (arc.innerRadius > pixelMargin) {
            angleMargin = pixelMargin / arc.innerRadius;
            ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
        } else ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
        ctx.closePath();
        ctx.clip();
    }
    function drawFullCircleBorders(ctx, vm, arc, inner) {
        var endAngle = arc.endAngle;
        var i;
        if (inner) {
            arc.endAngle = arc.startAngle + TAU;
            clipArc(ctx, arc);
            arc.endAngle = endAngle;
            if (arc.endAngle === arc.startAngle && arc.fullCircles) {
                arc.endAngle += TAU;
                arc.fullCircles--;
            }
        }
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
        for(i = 0; i < arc.fullCircles; ++i)ctx.stroke();
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
        for(i = 0; i < arc.fullCircles; ++i)ctx.stroke();
    }
    function drawBorder(ctx, vm, arc) {
        var inner = vm.borderAlign === 'inner';
        if (inner) {
            ctx.lineWidth = vm.borderWidth * 2;
            ctx.lineJoin = 'round';
        } else {
            ctx.lineWidth = vm.borderWidth;
            ctx.lineJoin = 'bevel';
        }
        if (arc.fullCircles) drawFullCircleBorders(ctx, vm, arc, inner);
        if (inner) clipArc(ctx, arc);
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
        ctx.closePath();
        ctx.stroke();
    }
    var element_arc = core_element.extend({
        _type: 'arc',
        inLabelRange: function(mouseX) {
            var vm = this._view;
            if (vm) return Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2);
            return false;
        },
        inRange: function(chartX, chartY) {
            var vm = this._view;
            if (vm) {
                var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {
                    x: chartX,
                    y: chartY
                });
                var angle = pointRelativePosition.angle;
                var distance = pointRelativePosition.distance;
                // Sanitise angle range
                var startAngle = vm.startAngle;
                var endAngle = vm.endAngle;
                while(endAngle < startAngle)endAngle += TAU;
                while(angle > endAngle)angle -= TAU;
                while(angle < startAngle)angle += TAU;
                // Check if within the range of the open/close angle
                var betweenAngles = angle >= startAngle && angle <= endAngle;
                var withinRadius = distance >= vm.innerRadius && distance <= vm.outerRadius;
                return betweenAngles && withinRadius;
            }
            return false;
        },
        getCenterPoint: function() {
            var vm = this._view;
            var halfAngle = (vm.startAngle + vm.endAngle) / 2;
            var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
            return {
                x: vm.x + Math.cos(halfAngle) * halfRadius,
                y: vm.y + Math.sin(halfAngle) * halfRadius
            };
        },
        getArea: function() {
            var vm = this._view;
            return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
        },
        tooltipPosition: function() {
            var vm = this._view;
            var centreAngle = vm.startAngle + (vm.endAngle - vm.startAngle) / 2;
            var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
            return {
                x: vm.x + Math.cos(centreAngle) * rangeFromCentre,
                y: vm.y + Math.sin(centreAngle) * rangeFromCentre
            };
        },
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var pixelMargin = vm.borderAlign === 'inner' ? 0.33 : 0;
            var arc = {
                x: vm.x,
                y: vm.y,
                innerRadius: vm.innerRadius,
                outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
                pixelMargin: pixelMargin,
                startAngle: vm.startAngle,
                endAngle: vm.endAngle,
                fullCircles: Math.floor(vm.circumference / TAU)
            };
            var i;
            ctx.save();
            ctx.fillStyle = vm.backgroundColor;
            ctx.strokeStyle = vm.borderColor;
            if (arc.fullCircles) {
                arc.endAngle = arc.startAngle + TAU;
                ctx.beginPath();
                ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
                ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
                ctx.closePath();
                for(i = 0; i < arc.fullCircles; ++i)ctx.fill();
                arc.endAngle = arc.startAngle + vm.circumference % TAU;
            }
            ctx.beginPath();
            ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
            ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
            ctx.closePath();
            ctx.fill();
            if (vm.borderWidth) drawBorder(ctx, vm, arc);
            ctx.restore();
        }
    });
    var valueOrDefault$1 = helpers$1.valueOrDefault;
    var defaultColor = core_defaults.global.defaultColor;
    core_defaults._set('global', {
        elements: {
            line: {
                tension: 0.4,
                backgroundColor: defaultColor,
                borderWidth: 3,
                borderColor: defaultColor,
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                capBezierPoints: true,
                fill: true
            }
        }
    });
    var element_line = core_element.extend({
        _type: 'line',
        draw: function() {
            var me = this;
            var vm = me._view;
            var ctx = me._chart.ctx;
            var spanGaps = vm.spanGaps;
            var points = me._children.slice(); // clone array
            var globalDefaults = core_defaults.global;
            var globalOptionLineElements = globalDefaults.elements.line;
            var lastDrawnIndex = -1;
            var closePath = me._loop;
            var index, previous, currentVM;
            if (!points.length) return;
            if (me._loop) {
                for(index = 0; index < points.length; ++index){
                    previous = helpers$1.previousItem(points, index);
                    // If the line has an open path, shift the point array
                    if (!points[index]._view.skip && previous._view.skip) {
                        points = points.slice(index).concat(points.slice(0, index));
                        closePath = spanGaps;
                        break;
                    }
                }
                // If the line has a close path, add the first point again
                if (closePath) points.push(points[0]);
            }
            ctx.save();
            // Stroke Line Options
            ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
            // IE 9 and 10 do not support line dash
            if (ctx.setLineDash) ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
            ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
            ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
            ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
            ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
            // Stroke Line
            ctx.beginPath();
            // First point moves to it's starting position no matter what
            currentVM = points[0]._view;
            if (!currentVM.skip) {
                ctx.moveTo(currentVM.x, currentVM.y);
                lastDrawnIndex = 0;
            }
            for(index = 1; index < points.length; ++index){
                currentVM = points[index]._view;
                previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
                if (!currentVM.skip) {
                    if (lastDrawnIndex !== index - 1 && !spanGaps || lastDrawnIndex === -1) // There was a gap and this is the first point after the gap
                    ctx.moveTo(currentVM.x, currentVM.y);
                    else // Line to next point
                    helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
                    lastDrawnIndex = index;
                }
            }
            if (closePath) ctx.closePath();
            ctx.stroke();
            ctx.restore();
        }
    });
    var valueOrDefault$2 = helpers$1.valueOrDefault;
    var defaultColor$1 = core_defaults.global.defaultColor;
    core_defaults._set('global', {
        elements: {
            point: {
                radius: 3,
                pointStyle: 'circle',
                backgroundColor: defaultColor$1,
                borderColor: defaultColor$1,
                borderWidth: 1,
                // Hover
                hitRadius: 1,
                hoverRadius: 4,
                hoverBorderWidth: 1
            }
        }
    });
    function xRange(mouseX) {
        var vm = this._view;
        return vm ? Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius : false;
    }
    function yRange(mouseY) {
        var vm = this._view;
        return vm ? Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius : false;
    }
    var element_point = core_element.extend({
        _type: 'point',
        inRange: function(mouseX, mouseY) {
            var vm = this._view;
            return vm ? Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2) < Math.pow(vm.hitRadius + vm.radius, 2) : false;
        },
        inLabelRange: xRange,
        inXRange: xRange,
        inYRange: yRange,
        getCenterPoint: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y
            };
        },
        getArea: function() {
            return Math.PI * Math.pow(this._view.radius, 2);
        },
        tooltipPosition: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y,
                padding: vm.radius + vm.borderWidth
            };
        },
        draw: function(chartArea) {
            var vm = this._view;
            var ctx = this._chart.ctx;
            var pointStyle = vm.pointStyle;
            var rotation = vm.rotation;
            var radius = vm.radius;
            var x = vm.x;
            var y = vm.y;
            var globalDefaults = core_defaults.global;
            var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow
            if (vm.skip) return;
            // Clipping for Points.
            if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
                ctx.strokeStyle = vm.borderColor || defaultColor;
                ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
                ctx.fillStyle = vm.backgroundColor || defaultColor;
                helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
            }
        }
    });
    var defaultColor$2 = core_defaults.global.defaultColor;
    core_defaults._set('global', {
        elements: {
            rectangle: {
                backgroundColor: defaultColor$2,
                borderColor: defaultColor$2,
                borderSkipped: 'bottom',
                borderWidth: 0
            }
        }
    });
    function isVertical(vm) {
        return vm && vm.width !== undefined;
    }
    /**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */ function getBarBounds(vm) {
        var x1, x2, y1, y2, half;
        if (isVertical(vm)) {
            half = vm.width / 2;
            x1 = vm.x - half;
            x2 = vm.x + half;
            y1 = Math.min(vm.y, vm.base);
            y2 = Math.max(vm.y, vm.base);
        } else {
            half = vm.height / 2;
            x1 = Math.min(vm.x, vm.base);
            x2 = Math.max(vm.x, vm.base);
            y1 = vm.y - half;
            y2 = vm.y + half;
        }
        return {
            left: x1,
            top: y1,
            right: x2,
            bottom: y2
        };
    }
    function swap(orig, v1, v2) {
        return orig === v1 ? v2 : orig === v2 ? v1 : orig;
    }
    function parseBorderSkipped(vm) {
        var edge = vm.borderSkipped;
        var res = {};
        if (!edge) return res;
        if (vm.horizontal) {
            if (vm.base > vm.x) edge = swap(edge, 'left', 'right');
        } else if (vm.base < vm.y) edge = swap(edge, 'bottom', 'top');
        res[edge] = true;
        return res;
    }
    function parseBorderWidth(vm, maxW, maxH) {
        var value = vm.borderWidth;
        var skip = parseBorderSkipped(vm);
        var t, r, b, l;
        if (helpers$1.isObject(value)) {
            t = +value.top || 0;
            r = +value.right || 0;
            b = +value.bottom || 0;
            l = +value.left || 0;
        } else t = r = b = l = +value || 0;
        return {
            t: skip.top || t < 0 ? 0 : t > maxH ? maxH : t,
            r: skip.right || r < 0 ? 0 : r > maxW ? maxW : r,
            b: skip.bottom || b < 0 ? 0 : b > maxH ? maxH : b,
            l: skip.left || l < 0 ? 0 : l > maxW ? maxW : l
        };
    }
    function boundingRects(vm) {
        var bounds = getBarBounds(vm);
        var width = bounds.right - bounds.left;
        var height = bounds.bottom - bounds.top;
        var border = parseBorderWidth(vm, width / 2, height / 2);
        return {
            outer: {
                x: bounds.left,
                y: bounds.top,
                w: width,
                h: height
            },
            inner: {
                x: bounds.left + border.l,
                y: bounds.top + border.t,
                w: width - border.l - border.r,
                h: height - border.t - border.b
            }
        };
    }
    function inRange(vm, x, y) {
        var skipX = x === null;
        var skipY = y === null;
        var bounds = !vm || skipX && skipY ? false : getBarBounds(vm);
        return bounds && (skipX || x >= bounds.left && x <= bounds.right) && (skipY || y >= bounds.top && y <= bounds.bottom);
    }
    var element_rectangle = core_element.extend({
        _type: 'rectangle',
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var rects = boundingRects(vm);
            var outer = rects.outer;
            var inner = rects.inner;
            ctx.fillStyle = vm.backgroundColor;
            ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
            if (outer.w === inner.w && outer.h === inner.h) return;
            ctx.save();
            ctx.beginPath();
            ctx.rect(outer.x, outer.y, outer.w, outer.h);
            ctx.clip();
            ctx.fillStyle = vm.borderColor;
            ctx.rect(inner.x, inner.y, inner.w, inner.h);
            ctx.fill('evenodd');
            ctx.restore();
        },
        height: function() {
            var vm = this._view;
            return vm.base - vm.y;
        },
        inRange: function(mouseX, mouseY) {
            return inRange(this._view, mouseX, mouseY);
        },
        inLabelRange: function(mouseX, mouseY) {
            var vm = this._view;
            return isVertical(vm) ? inRange(vm, mouseX, null) : inRange(vm, null, mouseY);
        },
        inXRange: function(mouseX) {
            return inRange(this._view, mouseX, null);
        },
        inYRange: function(mouseY) {
            return inRange(this._view, null, mouseY);
        },
        getCenterPoint: function() {
            var vm = this._view;
            var x, y;
            if (isVertical(vm)) {
                x = vm.x;
                y = (vm.y + vm.base) / 2;
            } else {
                x = (vm.x + vm.base) / 2;
                y = vm.y;
            }
            return {
                x: x,
                y: y
            };
        },
        getArea: function() {
            var vm = this._view;
            return isVertical(vm) ? vm.width * Math.abs(vm.y - vm.base) : vm.height * Math.abs(vm.x - vm.base);
        },
        tooltipPosition: function() {
            var vm = this._view;
            return {
                x: vm.x,
                y: vm.y
            };
        }
    });
    var elements = {};
    var Arc = element_arc;
    var Line = element_line;
    var Point = element_point;
    var Rectangle = element_rectangle;
    elements.Arc = Arc;
    elements.Line = Line;
    elements.Point = Point;
    elements.Rectangle = Rectangle;
    var deprecated = helpers$1._deprecated;
    var valueOrDefault$3 = helpers$1.valueOrDefault;
    core_defaults._set('bar', {
        hover: {
            mode: 'label'
        },
        scales: {
            xAxes: [
                {
                    type: 'category',
                    offset: true,
                    gridLines: {
                        offsetGridLines: true
                    }
                }
            ],
            yAxes: [
                {
                    type: 'linear'
                }
            ]
        }
    });
    core_defaults._set('global', {
        datasets: {
            bar: {
                categoryPercentage: 0.8,
                barPercentage: 0.9
            }
        }
    });
    /**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */ function computeMinSampleSize(scale, pixels) {
        var min = scale._length;
        var prev, curr, i, ilen;
        for(i = 1, ilen = pixels.length; i < ilen; ++i)min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
        for(i = 0, ilen = scale.getTicks().length; i < ilen; ++i){
            curr = scale.getPixelForTick(i);
            min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
            prev = curr;
        }
        return min;
    }
    /**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */ function computeFitCategoryTraits(index, ruler, options) {
        var thickness = options.barThickness;
        var count = ruler.stackCount;
        var curr = ruler.pixels[index];
        var min = helpers$1.isNullOrUndef(thickness) ? computeMinSampleSize(ruler.scale, ruler.pixels) : -1;
        var size, ratio;
        if (helpers$1.isNullOrUndef(thickness)) {
            size = min * options.categoryPercentage;
            ratio = options.barPercentage;
        } else {
            // When bar thickness is enforced, category and bar percentages are ignored.
            // Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
            // and deprecate barPercentage since this value is ignored when thickness is absolute.
            size = thickness * count;
            ratio = 1;
        }
        return {
            chunk: size / count,
            ratio: ratio,
            start: curr - size / 2
        };
    }
    /**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */ function computeFlexCategoryTraits(index, ruler, options) {
        var pixels = ruler.pixels;
        var curr = pixels[index];
        var prev = index > 0 ? pixels[index - 1] : null;
        var next = index < pixels.length - 1 ? pixels[index + 1] : null;
        var percent = options.categoryPercentage;
        var start, size;
        if (prev === null) // first data: its size is double based on the next point or,
        // if it's also the last data, we use the scale size.
        prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
        if (next === null) // last data: its size is also double based on the previous point.
        next = curr + curr - prev;
        start = curr - (curr - Math.min(prev, next)) / 2 * percent;
        size = Math.abs(next - prev) / 2 * percent;
        return {
            chunk: size / ruler.stackCount,
            ratio: options.barPercentage,
            start: start
        };
    }
    var controller_bar = core_datasetController.extend({
        dataElementType: elements.Rectangle,
        /**
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderSkipped',
            'borderWidth',
            'barPercentage',
            'barThickness',
            'categoryPercentage',
            'maxBarThickness',
            'minBarLength'
        ],
        initialize: function() {
            var me = this;
            var meta, scaleOpts;
            core_datasetController.prototype.initialize.apply(me, arguments);
            meta = me.getMeta();
            meta.stack = me.getDataset().stack;
            meta.bar = true;
            scaleOpts = me._getIndexScale().options;
            deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
            deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
            deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
            deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
            deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
        },
        update: function(reset) {
            var me = this;
            var rects = me.getMeta().data;
            var i, ilen;
            me._ruler = me.getRuler();
            for(i = 0, ilen = rects.length; i < ilen; ++i)me.updateElement(rects[i], i, reset);
        },
        updateElement: function(rectangle, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var dataset = me.getDataset();
            var options = me._resolveDataElementOptions(rectangle, index);
            rectangle._xScale = me.getScaleForId(meta.xAxisID);
            rectangle._yScale = me.getScaleForId(meta.yAxisID);
            rectangle._datasetIndex = me.index;
            rectangle._index = index;
            rectangle._model = {
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderSkipped: options.borderSkipped,
                borderWidth: options.borderWidth,
                datasetLabel: dataset.label,
                label: me.chart.data.labels[index]
            };
            if (helpers$1.isArray(dataset.data[index])) rectangle._model.borderSkipped = null;
            me._updateElementGeometry(rectangle, index, reset, options);
            rectangle.pivot();
        },
        /**
	 * @private
	 */ _updateElementGeometry: function(rectangle, index, reset, options) {
            var me = this;
            var model = rectangle._model;
            var vscale = me._getValueScale();
            var base = vscale.getBasePixel();
            var horizontal = vscale.isHorizontal();
            var ruler = me._ruler || me.getRuler();
            var vpixels = me.calculateBarValuePixels(me.index, index, options);
            var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
            model.horizontal = horizontal;
            model.base = reset ? base : vpixels.base;
            model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
            model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
            model.height = horizontal ? ipixels.size : undefined;
            model.width = horizontal ? undefined : ipixels.size;
        },
        /**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */ _getStacks: function(last) {
            var me = this;
            var scale = me._getIndexScale();
            var metasets = scale._getMatchingVisibleMetas(me._type);
            var stacked = scale.options.stacked;
            var ilen = metasets.length;
            var stacks = [];
            var i, meta;
            for(i = 0; i < ilen; ++i){
                meta = metasets[i];
                // stacked   | meta.stack
                //           | found | not found | undefined
                // false     |   x   |     x     |     x
                // true      |       |     x     |
                // undefined |       |     x     |     x
                if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
                if (meta.index === last) break;
            }
            return stacks;
        },
        /**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */ getStackCount: function() {
            return this._getStacks().length;
        },
        /**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */ getStackIndex: function(datasetIndex, name) {
            var stacks = this._getStacks(datasetIndex);
            var index = name !== undefined ? stacks.indexOf(name) : -1; // indexOf returns -1 if element is not present
            return index === -1 ? stacks.length - 1 : index;
        },
        /**
	 * @private
	 */ getRuler: function() {
            var me = this;
            var scale = me._getIndexScale();
            var pixels = [];
            var i, ilen;
            for(i = 0, ilen = me.getMeta().data.length; i < ilen; ++i)pixels.push(scale.getPixelForValue(null, i, me.index));
            return {
                pixels: pixels,
                start: scale._startPixel,
                end: scale._endPixel,
                stackCount: me.getStackCount(),
                scale: scale
            };
        },
        /**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */ calculateBarValuePixels: function(datasetIndex, index, options) {
            var me = this;
            var chart = me.chart;
            var scale = me._getValueScale();
            var isHorizontal = scale.isHorizontal();
            var datasets = chart.data.datasets;
            var metasets = scale._getMatchingVisibleMetas(me._type);
            var value = scale._parseValue(datasets[datasetIndex].data[index]);
            var minBarLength = options.minBarLength;
            var stacked = scale.options.stacked;
            var stack = me.getMeta().stack;
            var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
            var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
            var ilen = metasets.length;
            var i, imeta, ivalue, base, head, size, stackLength;
            if (stacked || stacked === undefined && stack !== undefined) for(i = 0; i < ilen; ++i){
                imeta = metasets[i];
                if (imeta.index === datasetIndex) break;
                if (imeta.stack === stack) {
                    stackLength = scale._parseValue(datasets[imeta.index].data[index]);
                    ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
                    if (value.min < 0 && ivalue < 0 || value.max >= 0 && ivalue > 0) start += ivalue;
                }
            }
            base = scale.getPixelForValue(start);
            head = scale.getPixelForValue(start + length);
            size = head - base;
            if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
                size = minBarLength;
                if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) head = base - minBarLength;
                else head = base + minBarLength;
            }
            return {
                size: size,
                base: base,
                head: head,
                center: head + size / 2
            };
        },
        /**
	 * @private
	 */ calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
            var me = this;
            var range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options) : computeFitCategoryTraits(index, ruler, options);
            var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
            var center = range.start + range.chunk * stackIndex + range.chunk / 2;
            var size = Math.min(valueOrDefault$3(options.maxBarThickness, Infinity), range.chunk * range.ratio);
            return {
                base: center - size / 2,
                head: center + size / 2,
                center: center,
                size: size
            };
        },
        draw: function() {
            var me = this;
            var chart = me.chart;
            var scale = me._getValueScale();
            var rects = me.getMeta().data;
            var dataset = me.getDataset();
            var ilen = rects.length;
            var i = 0;
            helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
            for(; i < ilen; ++i){
                var val = scale._parseValue(dataset.data[i]);
                if (!isNaN(val.min) && !isNaN(val.max)) rects[i].draw();
            }
            helpers$1.canvas.unclipArea(chart.ctx);
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function() {
            var me = this;
            var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
            var indexOpts = me._getIndexScale().options;
            var valueOpts = me._getValueScale().options;
            values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
            values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
            values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
            values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
            values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
            return values;
        }
    });
    var valueOrDefault$4 = helpers$1.valueOrDefault;
    var resolve$1 = helpers$1.options.resolve;
    core_defaults._set('bubble', {
        hover: {
            mode: 'single'
        },
        scales: {
            xAxes: [
                {
                    type: 'linear',
                    position: 'bottom',
                    id: 'x-axis-0' // need an ID so datasets can reference the scale
                }
            ],
            yAxes: [
                {
                    type: 'linear',
                    position: 'left',
                    id: 'y-axis-0'
                }
            ]
        },
        tooltips: {
            callbacks: {
                title: function() {
                    // Title doesn't make sense for scatter since we format the data as a point
                    return '';
                },
                label: function(item, data) {
                    var datasetLabel = data.datasets[item.datasetIndex].label || '';
                    var dataPoint = data.datasets[item.datasetIndex].data[item.index];
                    return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
                }
            }
        }
    });
    var controller_bubble = core_datasetController.extend({
        /**
	 * @protected
	 */ dataElementType: elements.Point,
        /**
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'hoverBackgroundColor',
            'hoverBorderColor',
            'hoverBorderWidth',
            'hoverRadius',
            'hitRadius',
            'pointStyle',
            'rotation'
        ],
        /**
	 * @protected
	 */ update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var points = meta.data;
            // Update Points
            helpers$1.each(points, function(point, index) {
                me.updateElement(point, index, reset);
            });
        },
        /**
	 * @protected
	 */ updateElement: function(point, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var custom = point.custom || {};
            var xScale = me.getScaleForId(meta.xAxisID);
            var yScale = me.getScaleForId(meta.yAxisID);
            var options = me._resolveDataElementOptions(point, index);
            var data = me.getDataset().data[index];
            var dsIndex = me.index;
            var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
            var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
            point._xScale = xScale;
            point._yScale = yScale;
            point._options = options;
            point._datasetIndex = dsIndex;
            point._index = index;
            point._model = {
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                hitRadius: options.hitRadius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                radius: reset ? 0 : options.radius,
                skip: custom.skip || isNaN(x) || isNaN(y),
                x: x,
                y: y
            };
            point.pivot();
        },
        /**
	 * @protected
	 */ setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
            model.radius = options.radius + options.hoverRadius;
        },
        /**
	 * @private
	 */ _resolveDataElementOptions: function(point, index) {
            var me = this;
            var chart = me.chart;
            var dataset = me.getDataset();
            var custom = point.custom || {};
            var data = dataset.data[index] || {};
            var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);
            // Scriptable options
            var context = {
                chart: chart,
                dataIndex: index,
                dataset: dataset,
                datasetIndex: me.index
            };
            // In case values were cached (and thus frozen), we need to clone the values
            if (me._cachedDataOpts === values) values = helpers$1.extend({}, values);
            // Custom radius resolution
            values.radius = resolve$1([
                custom.radius,
                data.r,
                me._config.radius,
                chart.options.elements.point.radius
            ], context, index);
            return values;
        }
    });
    var valueOrDefault$5 = helpers$1.valueOrDefault;
    var PI$1 = Math.PI;
    var DOUBLE_PI$1 = PI$1 * 2;
    var HALF_PI$1 = PI$1 / 2;
    core_defaults._set('doughnut', {
        animation: {
            // Boolean - Whether we animate the rotation of the Doughnut
            animateRotate: true,
            // Boolean - Whether we animate scaling the Doughnut from the centre
            animateScale: false
        },
        hover: {
            mode: 'single'
        },
        legendCallback: function(chart) {
            var list = document.createElement('ul');
            var data = chart.data;
            var datasets = data.datasets;
            var labels = data.labels;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute('class', chart.id + '-legend');
            if (datasets.length) for(i = 0, ilen = datasets[0].data.length; i < ilen; ++i){
                listItem = list.appendChild(document.createElement('li'));
                listItemSpan = listItem.appendChild(document.createElement('span'));
                listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
                if (labels[i]) listItem.appendChild(document.createTextNode(labels[i]));
            }
            return list.outerHTML;
        },
        legend: {
            labels: {
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            strokeStyle: style.borderColor,
                            lineWidth: style.borderWidth,
                            hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                            // Extra data used for toggling the correct item
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick: function(e, legendItem) {
                var index = legendItem.index;
                var chart = this.chart;
                var i, ilen, meta;
                for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i){
                    meta = chart.getDatasetMeta(i);
                    // toggle visibility of index if exists
                    if (meta.data[index]) meta.data[index].hidden = !meta.data[index].hidden;
                }
                chart.update();
            }
        },
        // The percentage of the chart that we cut out of the middle.
        cutoutPercentage: 50,
        // The rotation of the chart, where the first data arc begins.
        rotation: -HALF_PI$1,
        // The total circumference of the chart.
        circumference: DOUBLE_PI$1,
        // Need to override these to give a nice default
        tooltips: {
            callbacks: {
                title: function() {
                    return '';
                },
                label: function(tooltipItem, data) {
                    var dataLabel = data.labels[tooltipItem.index];
                    var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    if (helpers$1.isArray(dataLabel)) {
                        // show value on first line of multiline label
                        // need to clone because we are changing the value
                        dataLabel = dataLabel.slice();
                        dataLabel[0] += value;
                    } else dataLabel += value;
                    return dataLabel;
                }
            }
        }
    });
    var controller_doughnut = core_datasetController.extend({
        dataElementType: elements.Arc,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'borderAlign',
            'hoverBackgroundColor',
            'hoverBorderColor',
            'hoverBorderWidth'
        ],
        // Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
        getRingIndex: function(datasetIndex) {
            var ringIndex = 0;
            for(var j = 0; j < datasetIndex; ++j)if (this.chart.isDatasetVisible(j)) ++ringIndex;
            return ringIndex;
        },
        update: function(reset) {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var ratioX = 1;
            var ratioY = 1;
            var offsetX = 0;
            var offsetY = 0;
            var meta = me.getMeta();
            var arcs = meta.data;
            var cutout = opts.cutoutPercentage / 100 || 0;
            var circumference = opts.circumference;
            var chartWeight = me._getRingWeight(me.index);
            var maxWidth, maxHeight, i, ilen;
            // If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
            if (circumference < DOUBLE_PI$1) {
                var startAngle = opts.rotation % DOUBLE_PI$1;
                startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
                var endAngle = startAngle + circumference;
                var startX = Math.cos(startAngle);
                var startY = Math.sin(startAngle);
                var endX = Math.cos(endAngle);
                var endY = Math.sin(endAngle);
                var contains0 = startAngle <= 0 && endAngle >= 0 || endAngle >= DOUBLE_PI$1;
                var contains90 = startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1 || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
                var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
                var contains270 = startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1 || endAngle >= PI$1 + HALF_PI$1;
                var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
                var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
                var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
                var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
                ratioX = (maxX - minX) / 2;
                ratioY = (maxY - minY) / 2;
                offsetX = -(maxX + minX) / 2;
                offsetY = -(maxY + minY) / 2;
            }
            for(i = 0, ilen = arcs.length; i < ilen; ++i)arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
            chart.borderWidth = me.getMaxBorderWidth();
            maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
            maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
            chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
            chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
            chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
            chart.offsetX = offsetX * chart.outerRadius;
            chart.offsetY = offsetY * chart.outerRadius;
            meta.total = me.calculateTotal();
            me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
            me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
            for(i = 0, ilen = arcs.length; i < ilen; ++i)me.updateElement(arcs[i], i, reset);
        },
        updateElement: function(arc, index, reset) {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var animationOpts = opts.animation;
            var centerX = (chartArea.left + chartArea.right) / 2;
            var centerY = (chartArea.top + chartArea.bottom) / 2;
            var startAngle = opts.rotation; // non reset case handled later
            var endAngle = opts.rotation; // non reset case handled later
            var dataset = me.getDataset();
            var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
            var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
            var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
            var options = arc._options || {};
            helpers$1.extend(arc, {
                // Utility
                _datasetIndex: me.index,
                _index: index,
                // Desired view properties
                _model: {
                    backgroundColor: options.backgroundColor,
                    borderColor: options.borderColor,
                    borderWidth: options.borderWidth,
                    borderAlign: options.borderAlign,
                    x: centerX + chart.offsetX,
                    y: centerY + chart.offsetY,
                    startAngle: startAngle,
                    endAngle: endAngle,
                    circumference: circumference,
                    outerRadius: outerRadius,
                    innerRadius: innerRadius,
                    label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
                }
            });
            var model = arc._model;
            // Set correct angles if not resetting
            if (!reset || !animationOpts.animateRotate) {
                if (index === 0) model.startAngle = opts.rotation;
                else model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
                model.endAngle = model.startAngle + model.circumference;
            }
            arc.pivot();
        },
        calculateTotal: function() {
            var dataset = this.getDataset();
            var meta = this.getMeta();
            var total = 0;
            var value;
            helpers$1.each(meta.data, function(element, index) {
                value = dataset.data[index];
                if (!isNaN(value) && !element.hidden) total += Math.abs(value);
            });
            /* if (total === 0) {
			total = NaN;
		}*/ return total;
        },
        calculateCircumference: function(value) {
            var total = this.getMeta().total;
            if (total > 0 && !isNaN(value)) return DOUBLE_PI$1 * (Math.abs(value) / total);
            return 0;
        },
        // gets the max border or hover width to properly scale pie charts
        getMaxBorderWidth: function(arcs) {
            var me = this;
            var max = 0;
            var chart = me.chart;
            var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
            if (!arcs) {
                // Find the outmost visible dataset
                for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                    meta = chart.getDatasetMeta(i);
                    arcs = meta.data;
                    if (i !== me.index) controller = meta.controller;
                    break;
                }
            }
            if (!arcs) return 0;
            for(i = 0, ilen = arcs.length; i < ilen; ++i){
                arc = arcs[i];
                if (controller) {
                    controller._configure();
                    options = controller._resolveDataElementOptions(arc, i);
                } else options = arc._options;
                if (options.borderAlign !== 'inner') {
                    borderWidth = options.borderWidth;
                    hoverWidth = options.hoverBorderWidth;
                    max = borderWidth > max ? borderWidth : max;
                    max = hoverWidth > max ? hoverWidth : max;
                }
            }
            return max;
        },
        /**
	 * @protected
	 */ setHoverStyle: function(arc) {
            var model = arc._model;
            var options = arc._options;
            var getHoverColor = helpers$1.getHoverColor;
            arc.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
        },
        /**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */ _getRingWeightOffset: function(datasetIndex) {
            var ringWeightOffset = 0;
            for(var i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
            return ringWeightOffset;
        },
        /**
	 * @private
	 */ _getRingWeight: function(dataSetIndex) {
            return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
        },
        /**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */ _getVisibleDatasetWeightTotal: function() {
            return this._getRingWeightOffset(this.chart.data.datasets.length);
        }
    });
    core_defaults._set('horizontalBar', {
        hover: {
            mode: 'index',
            axis: 'y'
        },
        scales: {
            xAxes: [
                {
                    type: 'linear',
                    position: 'bottom'
                }
            ],
            yAxes: [
                {
                    type: 'category',
                    position: 'left',
                    offset: true,
                    gridLines: {
                        offsetGridLines: true
                    }
                }
            ]
        },
        elements: {
            rectangle: {
                borderSkipped: 'left'
            }
        },
        tooltips: {
            mode: 'index',
            axis: 'y'
        }
    });
    core_defaults._set('global', {
        datasets: {
            horizontalBar: {
                categoryPercentage: 0.8,
                barPercentage: 0.9
            }
        }
    });
    var controller_horizontalBar = controller_bar.extend({
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.getMeta().xAxisID;
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.getMeta().yAxisID;
        }
    });
    var valueOrDefault$6 = helpers$1.valueOrDefault;
    var resolve$2 = helpers$1.options.resolve;
    var isPointInArea = helpers$1.canvas._isPointInArea;
    core_defaults._set('line', {
        showLines: true,
        spanGaps: false,
        hover: {
            mode: 'label'
        },
        scales: {
            xAxes: [
                {
                    type: 'category',
                    id: 'x-axis-0'
                }
            ],
            yAxes: [
                {
                    type: 'linear',
                    id: 'y-axis-0'
                }
            ]
        }
    });
    function scaleClip(scale, halfBorderWidth) {
        var tickOpts = scale && scale.options.ticks || {};
        var reverse = tickOpts.reverse;
        var min = tickOpts.min === undefined ? halfBorderWidth : 0;
        var max = tickOpts.max === undefined ? halfBorderWidth : 0;
        return {
            start: reverse ? max : min,
            end: reverse ? min : max
        };
    }
    function defaultClip(xScale, yScale, borderWidth) {
        var halfBorderWidth = borderWidth / 2;
        var x = scaleClip(xScale, halfBorderWidth);
        var y = scaleClip(yScale, halfBorderWidth);
        return {
            top: y.end,
            right: x.end,
            bottom: y.start,
            left: x.start
        };
    }
    function toClip(value) {
        var t, r, b, l;
        if (helpers$1.isObject(value)) {
            t = value.top;
            r = value.right;
            b = value.bottom;
            l = value.left;
        } else t = r = b = l = value;
        return {
            top: t,
            right: r,
            bottom: b,
            left: l
        };
    }
    var controller_line = core_datasetController.extend({
        datasetElementType: elements.Line,
        dataElementType: elements.Point,
        /**
	 * @private
	 */ _datasetElementOptions: [
            'backgroundColor',
            'borderCapStyle',
            'borderColor',
            'borderDash',
            'borderDashOffset',
            'borderJoinStyle',
            'borderWidth',
            'cubicInterpolationMode',
            'fill'
        ],
        /**
	 * @private
	 */ _dataElementOptions: {
            backgroundColor: 'pointBackgroundColor',
            borderColor: 'pointBorderColor',
            borderWidth: 'pointBorderWidth',
            hitRadius: 'pointHitRadius',
            hoverBackgroundColor: 'pointHoverBackgroundColor',
            hoverBorderColor: 'pointHoverBorderColor',
            hoverBorderWidth: 'pointHoverBorderWidth',
            hoverRadius: 'pointHoverRadius',
            pointStyle: 'pointStyle',
            radius: 'pointRadius',
            rotation: 'pointRotation'
        },
        update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var line = meta.dataset;
            var points = meta.data || [];
            var options = me.chart.options;
            var config = me._config;
            var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
            var i, ilen;
            me._xScale = me.getScaleForId(meta.xAxisID);
            me._yScale = me.getScaleForId(meta.yAxisID);
            // Update Line
            if (showLine) {
                // Compatibility: If the properties are defined with only the old name, use those values
                if (config.tension !== undefined && config.lineTension === undefined) config.lineTension = config.tension;
                // Utility
                line._scale = me._yScale;
                line._datasetIndex = me.index;
                // Data
                line._children = points;
                // Model
                line._model = me._resolveDatasetElementOptions(line);
                line.pivot();
            }
            // Update Points
            for(i = 0, ilen = points.length; i < ilen; ++i)me.updateElement(points[i], i, reset);
            if (showLine && line._model.tension !== 0) me.updateBezierControlPoints();
            // Now pivot the point for animation
            for(i = 0, ilen = points.length; i < ilen; ++i)points[i].pivot();
        },
        updateElement: function(point, index, reset) {
            var me = this;
            var meta = me.getMeta();
            var custom = point.custom || {};
            var dataset = me.getDataset();
            var datasetIndex = me.index;
            var value = dataset.data[index];
            var xScale = me._xScale;
            var yScale = me._yScale;
            var lineModel = meta.dataset._model;
            var x, y;
            var options = me._resolveDataElementOptions(point, index);
            x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
            y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
            // Utility
            point._xScale = xScale;
            point._yScale = yScale;
            point._options = options;
            point._datasetIndex = datasetIndex;
            point._index = index;
            // Desired view properties
            point._model = {
                x: x,
                y: y,
                skip: custom.skip || isNaN(x) || isNaN(y),
                // Appearance
                radius: options.radius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
                steppedLine: lineModel ? lineModel.steppedLine : false,
                // Tooltip
                hitRadius: options.hitRadius
            };
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function(element) {
            var me = this;
            var config = me._config;
            var custom = element.custom || {};
            var options = me.chart.options;
            var lineOptions = options.elements.line;
            var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
            // The default behavior of lines is to break at null values, according
            // to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
            // This option gives lines the ability to span gaps
            values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
            values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
            values.steppedLine = resolve$2([
                custom.steppedLine,
                config.steppedLine,
                lineOptions.stepped
            ]);
            values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
            return values;
        },
        calculatePointY: function(value, index, datasetIndex) {
            var me = this;
            var chart = me.chart;
            var yScale = me._yScale;
            var sumPos = 0;
            var sumNeg = 0;
            var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
            if (yScale.options.stacked) {
                rightValue = +yScale.getRightValue(value);
                metasets = chart._getSortedVisibleDatasetMetas();
                ilen = metasets.length;
                for(i = 0; i < ilen; ++i){
                    dsMeta = metasets[i];
                    if (dsMeta.index === datasetIndex) break;
                    ds = chart.data.datasets[dsMeta.index];
                    if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
                        stackedRightValue = +yScale.getRightValue(ds.data[index]);
                        if (stackedRightValue < 0) sumNeg += stackedRightValue || 0;
                        else sumPos += stackedRightValue || 0;
                    }
                }
                if (rightValue < 0) return yScale.getPixelForValue(sumNeg + rightValue);
                return yScale.getPixelForValue(sumPos + rightValue);
            }
            return yScale.getPixelForValue(value);
        },
        updateBezierControlPoints: function() {
            var me = this;
            var chart = me.chart;
            var meta = me.getMeta();
            var lineModel = meta.dataset._model;
            var area = chart.chartArea;
            var points = meta.data || [];
            var i, ilen, model, controlPoints;
            // Only consider points that are drawn in case the spanGaps option is used
            if (lineModel.spanGaps) points = points.filter(function(pt) {
                return !pt._model.skip;
            });
            function capControlPoint(pt, min, max) {
                return Math.max(Math.min(pt, max), min);
            }
            if (lineModel.cubicInterpolationMode === 'monotone') helpers$1.splineCurveMonotone(points);
            else for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i)._model, model, helpers$1.nextItem(points, i)._model, lineModel.tension);
                model.controlPointPreviousX = controlPoints.previous.x;
                model.controlPointPreviousY = controlPoints.previous.y;
                model.controlPointNextX = controlPoints.next.x;
                model.controlPointNextY = controlPoints.next.y;
            }
            if (chart.options.elements.line.capBezierPoints) for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                if (isPointInArea(model, area)) {
                    if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
                        model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
                        model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
                    }
                    if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
                        model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
                        model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
                    }
                }
            }
        },
        draw: function() {
            var me = this;
            var chart = me.chart;
            var meta = me.getMeta();
            var points = meta.data || [];
            var area = chart.chartArea;
            var canvas = chart.canvas;
            var i = 0;
            var ilen = points.length;
            var clip;
            if (me._showLine) {
                clip = meta.dataset._model.clip;
                helpers$1.canvas.clipArea(chart.ctx, {
                    left: clip.left === false ? 0 : area.left - clip.left,
                    right: clip.right === false ? canvas.width : area.right + clip.right,
                    top: clip.top === false ? 0 : area.top - clip.top,
                    bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
                });
                meta.dataset.draw();
                helpers$1.canvas.unclipArea(chart.ctx);
            }
            // Draw the points
            for(; i < ilen; ++i)points[i].draw(area);
        },
        /**
	 * @protected
	 */ setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
            model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
        }
    });
    var resolve$3 = helpers$1.options.resolve;
    core_defaults._set('polarArea', {
        scale: {
            type: 'radialLinear',
            angleLines: {
                display: false
            },
            gridLines: {
                circular: true
            },
            pointLabels: {
                display: false
            },
            ticks: {
                beginAtZero: true
            }
        },
        // Boolean - Whether to animate the rotation of the chart
        animation: {
            animateRotate: true,
            animateScale: true
        },
        startAngle: -0.5 * Math.PI,
        legendCallback: function(chart) {
            var list = document.createElement('ul');
            var data = chart.data;
            var datasets = data.datasets;
            var labels = data.labels;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute('class', chart.id + '-legend');
            if (datasets.length) for(i = 0, ilen = datasets[0].data.length; i < ilen; ++i){
                listItem = list.appendChild(document.createElement('li'));
                listItemSpan = listItem.appendChild(document.createElement('span'));
                listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
                if (labels[i]) listItem.appendChild(document.createTextNode(labels[i]));
            }
            return list.outerHTML;
        },
        legend: {
            labels: {
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) return data.labels.map(function(label, i) {
                        var meta = chart.getDatasetMeta(0);
                        var style = meta.controller.getStyle(i);
                        return {
                            text: label,
                            fillStyle: style.backgroundColor,
                            strokeStyle: style.borderColor,
                            lineWidth: style.borderWidth,
                            hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                            // Extra data used for toggling the correct item
                            index: i
                        };
                    });
                    return [];
                }
            },
            onClick: function(e, legendItem) {
                var index = legendItem.index;
                var chart = this.chart;
                var i, ilen, meta;
                for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i){
                    meta = chart.getDatasetMeta(i);
                    meta.data[index].hidden = !meta.data[index].hidden;
                }
                chart.update();
            }
        },
        // Need to override these to give a nice default
        tooltips: {
            callbacks: {
                title: function() {
                    return '';
                },
                label: function(item, data) {
                    return data.labels[item.index] + ': ' + item.yLabel;
                }
            }
        }
    });
    var controller_polarArea = core_datasetController.extend({
        dataElementType: elements.Arc,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _dataElementOptions: [
            'backgroundColor',
            'borderColor',
            'borderWidth',
            'borderAlign',
            'hoverBackgroundColor',
            'hoverBorderColor',
            'hoverBorderWidth'
        ],
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.chart.scale.id;
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.chart.scale.id;
        },
        update: function(reset) {
            var me = this;
            var dataset = me.getDataset();
            var meta = me.getMeta();
            var start = me.chart.options.startAngle || 0;
            var starts = me._starts = [];
            var angles = me._angles = [];
            var arcs = meta.data;
            var i, ilen, angle;
            me._updateRadius();
            meta.count = me.countVisibleElements();
            for(i = 0, ilen = dataset.data.length; i < ilen; i++){
                starts[i] = start;
                angle = me._computeAngle(i);
                angles[i] = angle;
                start += angle;
            }
            for(i = 0, ilen = arcs.length; i < ilen; ++i){
                arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
                me.updateElement(arcs[i], i, reset);
            }
        },
        /**
	 * @private
	 */ _updateRadius: function() {
            var me = this;
            var chart = me.chart;
            var chartArea = chart.chartArea;
            var opts = chart.options;
            var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
            chart.outerRadius = Math.max(minSize / 2, 0);
            chart.innerRadius = Math.max(opts.cutoutPercentage ? chart.outerRadius / 100 * opts.cutoutPercentage : 1, 0);
            chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
            me.outerRadius = chart.outerRadius - chart.radiusLength * me.index;
            me.innerRadius = me.outerRadius - chart.radiusLength;
        },
        updateElement: function(arc, index, reset) {
            var me = this;
            var chart = me.chart;
            var dataset = me.getDataset();
            var opts = chart.options;
            var animationOpts = opts.animation;
            var scale = chart.scale;
            var labels = chart.data.labels;
            var centerX = scale.xCenter;
            var centerY = scale.yCenter;
            // var negHalfPI = -0.5 * Math.PI;
            var datasetStartAngle = opts.startAngle;
            var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
            var startAngle = me._starts[index];
            var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
            var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
            var options = arc._options || {};
            helpers$1.extend(arc, {
                // Utility
                _datasetIndex: me.index,
                _index: index,
                _scale: scale,
                // Desired view properties
                _model: {
                    backgroundColor: options.backgroundColor,
                    borderColor: options.borderColor,
                    borderWidth: options.borderWidth,
                    borderAlign: options.borderAlign,
                    x: centerX,
                    y: centerY,
                    innerRadius: 0,
                    outerRadius: reset ? resetRadius : distance,
                    startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
                    endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
                    label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
                }
            });
            arc.pivot();
        },
        countVisibleElements: function() {
            var dataset = this.getDataset();
            var meta = this.getMeta();
            var count = 0;
            helpers$1.each(meta.data, function(element, index) {
                if (!isNaN(dataset.data[index]) && !element.hidden) count++;
            });
            return count;
        },
        /**
	 * @protected
	 */ setHoverStyle: function(arc) {
            var model = arc._model;
            var options = arc._options;
            var getHoverColor = helpers$1.getHoverColor;
            var valueOrDefault = helpers$1.valueOrDefault;
            arc.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth
            };
            model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
        },
        /**
	 * @private
	 */ _computeAngle: function(index) {
            var me = this;
            var count = this.getMeta().count;
            var dataset = me.getDataset();
            var meta = me.getMeta();
            if (isNaN(dataset.data[index]) || meta.data[index].hidden) return 0;
            // Scriptable options
            var context = {
                chart: me.chart,
                dataIndex: index,
                dataset: dataset,
                datasetIndex: me.index
            };
            return resolve$3([
                me.chart.options.elements.arc.angle,
                2 * Math.PI / count
            ], context, index);
        }
    });
    core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
    core_defaults._set('pie', {
        cutoutPercentage: 0
    });
    // Pie charts are Doughnut chart with different defaults
    var controller_pie = controller_doughnut;
    var valueOrDefault$7 = helpers$1.valueOrDefault;
    core_defaults._set('radar', {
        spanGaps: false,
        scale: {
            type: 'radialLinear'
        },
        elements: {
            line: {
                fill: 'start',
                tension: 0 // no bezier in radar
            }
        }
    });
    var controller_radar = core_datasetController.extend({
        datasetElementType: elements.Line,
        dataElementType: elements.Point,
        linkScales: helpers$1.noop,
        /**
	 * @private
	 */ _datasetElementOptions: [
            'backgroundColor',
            'borderWidth',
            'borderColor',
            'borderCapStyle',
            'borderDash',
            'borderDashOffset',
            'borderJoinStyle',
            'fill'
        ],
        /**
	 * @private
	 */ _dataElementOptions: {
            backgroundColor: 'pointBackgroundColor',
            borderColor: 'pointBorderColor',
            borderWidth: 'pointBorderWidth',
            hitRadius: 'pointHitRadius',
            hoverBackgroundColor: 'pointHoverBackgroundColor',
            hoverBorderColor: 'pointHoverBorderColor',
            hoverBorderWidth: 'pointHoverBorderWidth',
            hoverRadius: 'pointHoverRadius',
            pointStyle: 'pointStyle',
            radius: 'pointRadius',
            rotation: 'pointRotation'
        },
        /**
	 * @private
	 */ _getIndexScaleId: function() {
            return this.chart.scale.id;
        },
        /**
	 * @private
	 */ _getValueScaleId: function() {
            return this.chart.scale.id;
        },
        update: function(reset) {
            var me = this;
            var meta = me.getMeta();
            var line = meta.dataset;
            var points = meta.data || [];
            var scale = me.chart.scale;
            var config = me._config;
            var i, ilen;
            // Compatibility: If the properties are defined with only the old name, use those values
            if (config.tension !== undefined && config.lineTension === undefined) config.lineTension = config.tension;
            // Utility
            line._scale = scale;
            line._datasetIndex = me.index;
            // Data
            line._children = points;
            line._loop = true;
            // Model
            line._model = me._resolveDatasetElementOptions(line);
            line.pivot();
            // Update Points
            for(i = 0, ilen = points.length; i < ilen; ++i)me.updateElement(points[i], i, reset);
            // Update bezier control points
            me.updateBezierControlPoints();
            // Now pivot the point for animation
            for(i = 0, ilen = points.length; i < ilen; ++i)points[i].pivot();
        },
        updateElement: function(point, index, reset) {
            var me = this;
            var custom = point.custom || {};
            var dataset = me.getDataset();
            var scale = me.chart.scale;
            var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
            var options = me._resolveDataElementOptions(point, index);
            var lineModel = me.getMeta().dataset._model;
            var x = reset ? scale.xCenter : pointPosition.x;
            var y = reset ? scale.yCenter : pointPosition.y;
            // Utility
            point._scale = scale;
            point._options = options;
            point._datasetIndex = me.index;
            point._index = index;
            // Desired view properties
            point._model = {
                x: x,
                y: y,
                skip: custom.skip || isNaN(x) || isNaN(y),
                // Appearance
                radius: options.radius,
                pointStyle: options.pointStyle,
                rotation: options.rotation,
                backgroundColor: options.backgroundColor,
                borderColor: options.borderColor,
                borderWidth: options.borderWidth,
                tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
                // Tooltip
                hitRadius: options.hitRadius
            };
        },
        /**
	 * @private
	 */ _resolveDatasetElementOptions: function() {
            var me = this;
            var config = me._config;
            var options = me.chart.options;
            var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
            values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
            values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
            return values;
        },
        updateBezierControlPoints: function() {
            var me = this;
            var meta = me.getMeta();
            var area = me.chart.chartArea;
            var points = meta.data || [];
            var i, ilen, model, controlPoints;
            // Only consider points that are drawn in case the spanGaps option is used
            if (meta.dataset._model.spanGaps) points = points.filter(function(pt) {
                return !pt._model.skip;
            });
            function capControlPoint(pt, min, max) {
                return Math.max(Math.min(pt, max), min);
            }
            for(i = 0, ilen = points.length; i < ilen; ++i){
                model = points[i]._model;
                controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i, true)._model, model, helpers$1.nextItem(points, i, true)._model, model.tension);
                // Prevent the bezier going outside of the bounds of the graph
                model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
                model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
                model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
                model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
            }
        },
        setHoverStyle: function(point) {
            var model = point._model;
            var options = point._options;
            var getHoverColor = helpers$1.getHoverColor;
            point.$previousStyle = {
                backgroundColor: model.backgroundColor,
                borderColor: model.borderColor,
                borderWidth: model.borderWidth,
                radius: model.radius
            };
            model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
            model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
            model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
            model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
        }
    });
    core_defaults._set('scatter', {
        hover: {
            mode: 'single'
        },
        scales: {
            xAxes: [
                {
                    id: 'x-axis-1',
                    type: 'linear',
                    position: 'bottom'
                }
            ],
            yAxes: [
                {
                    id: 'y-axis-1',
                    type: 'linear',
                    position: 'left'
                }
            ]
        },
        tooltips: {
            callbacks: {
                title: function() {
                    return ''; // doesn't make sense for scatter since data are formatted as a point
                },
                label: function(item) {
                    return '(' + item.xLabel + ', ' + item.yLabel + ')';
                }
            }
        }
    });
    core_defaults._set('global', {
        datasets: {
            scatter: {
                showLine: false
            }
        }
    });
    // Scatter charts use line controllers
    var controller_scatter = controller_line;
    // NOTE export a map in which the key represents the controller type, not
    // the class, and so must be CamelCase in order to be correctly retrieved
    // by the controller in core.controller.js (`controllers[meta.type]`).
    var controllers = {
        bar: controller_bar,
        bubble: controller_bubble,
        doughnut: controller_doughnut,
        horizontalBar: controller_horizontalBar,
        line: controller_line,
        polarArea: controller_polarArea,
        pie: controller_pie,
        radar: controller_radar,
        scatter: controller_scatter
    };
    /**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */ function getRelativePosition(e, chart) {
        if (e.native) return {
            x: e.x,
            y: e.y
        };
        return helpers$1.getRelativePosition(e, chart);
    }
    /**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */ function parseVisibleItems(chart, handler) {
        var metasets = chart._getSortedVisibleDatasetMetas();
        var metadata, i, j, ilen, jlen, element;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            metadata = metasets[i].data;
            for(j = 0, jlen = metadata.length; j < jlen; ++j){
                element = metadata[j];
                if (!element._view.skip) handler(element);
            }
        }
    }
    /**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */ function getIntersectItems(chart, position) {
        var elements = [];
        parseVisibleItems(chart, function(element) {
            if (element.inRange(position.x, position.y)) elements.push(element);
        });
        return elements;
    }
    /**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */ function getNearestItems(chart, position, intersect, distanceMetric) {
        var minDistance = Number.POSITIVE_INFINITY;
        var nearestItems = [];
        parseVisibleItems(chart, function(element) {
            if (intersect && !element.inRange(position.x, position.y)) return;
            var center = element.getCenterPoint();
            var distance = distanceMetric(position, center);
            if (distance < minDistance) {
                nearestItems = [
                    element
                ];
                minDistance = distance;
            } else if (distance === minDistance) // Can have multiple items at the same distance in which case we sort by size
            nearestItems.push(element);
        });
        return nearestItems;
    }
    /**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */ function getDistanceMetricForAxis(axis) {
        var useX = axis.indexOf('x') !== -1;
        var useY = axis.indexOf('y') !== -1;
        return function(pt1, pt2) {
            var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
            var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
            return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
        };
    }
    function indexMode(chart, e, options) {
        var position = getRelativePosition(e, chart);
        // Default axis for index mode is 'x' to match old behaviour
        options.axis = options.axis || 'x';
        var distanceMetric = getDistanceMetricForAxis(options.axis);
        var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
        var elements = [];
        if (!items.length) return [];
        chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
            var element = meta.data[items[0]._index];
            // don't count items that are skipped (null data)
            if (element && !element._view.skip) elements.push(element);
        });
        return elements;
    }
    /**
 * @interface IInteractionOptions
 */ /**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */ /**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */ var core_interaction = {
        // Helper function for different modes
        modes: {
            single: function(chart, e) {
                var position = getRelativePosition(e, chart);
                var elements = [];
                parseVisibleItems(chart, function(element) {
                    if (element.inRange(position.x, position.y)) {
                        elements.push(element);
                        return elements;
                    }
                });
                return elements.slice(0, 1);
            },
            /**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */ label: indexMode,
            /**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ index: indexMode,
            /**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ dataset: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                options.axis = options.axis || 'xy';
                var distanceMetric = getDistanceMetricForAxis(options.axis);
                var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
                if (items.length > 0) items = chart.getDatasetMeta(items[0]._datasetIndex).data;
                return items;
            },
            /**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */ 'x-axis': function(chart, e) {
                return indexMode(chart, e, {
                    intersect: false
                });
            },
            /**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ point: function(chart, e) {
                var position = getRelativePosition(e, chart);
                return getIntersectItems(chart, position);
            },
            /**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ nearest: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                options.axis = options.axis || 'xy';
                var distanceMetric = getDistanceMetricForAxis(options.axis);
                return getNearestItems(chart, position, options.intersect, distanceMetric);
            },
            /**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ x: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                var items = [];
                var intersectsItem = false;
                parseVisibleItems(chart, function(element) {
                    if (element.inXRange(position.x)) items.push(element);
                    if (element.inRange(position.x, position.y)) intersectsItem = true;
                });
                // If we want to trigger on an intersect and we don't have any items
                // that intersect the position, return nothing
                if (options.intersect && !intersectsItem) items = [];
                return items;
            },
            /**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */ y: function(chart, e, options) {
                var position = getRelativePosition(e, chart);
                var items = [];
                var intersectsItem = false;
                parseVisibleItems(chart, function(element) {
                    if (element.inYRange(position.y)) items.push(element);
                    if (element.inRange(position.x, position.y)) intersectsItem = true;
                });
                // If we want to trigger on an intersect and we don't have any items
                // that intersect the position, return nothing
                if (options.intersect && !intersectsItem) items = [];
                return items;
            }
        }
    };
    var extend = helpers$1.extend;
    function filterByPosition(array, position) {
        return helpers$1.where(array, function(v) {
            return v.pos === position;
        });
    }
    function sortByWeight(array, reverse) {
        return array.sort(function(a, b) {
            var v0 = reverse ? b : a;
            var v1 = reverse ? a : b;
            return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
        });
    }
    function wrapBoxes(boxes) {
        var layoutBoxes = [];
        var i, ilen, box;
        for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
            box = boxes[i];
            layoutBoxes.push({
                index: i,
                box: box,
                pos: box.position,
                horizontal: box.isHorizontal(),
                weight: box.weight
            });
        }
        return layoutBoxes;
    }
    function setLayoutDims(layouts, params) {
        var i, ilen, layout;
        for(i = 0, ilen = layouts.length; i < ilen; ++i){
            layout = layouts[i];
            // store width used instead of chartArea.w in fitBoxes
            layout.width = layout.horizontal ? layout.box.fullWidth && params.availableWidth : params.vBoxMaxWidth;
            // store height used instead of chartArea.h in fitBoxes
            layout.height = layout.horizontal && params.hBoxMaxHeight;
        }
    }
    function buildLayoutBoxes(boxes) {
        var layoutBoxes = wrapBoxes(boxes);
        var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
        var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
        var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
        var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
        return {
            leftAndTop: left.concat(top),
            rightAndBottom: right.concat(bottom),
            chartArea: filterByPosition(layoutBoxes, 'chartArea'),
            vertical: left.concat(right),
            horizontal: top.concat(bottom)
        };
    }
    function getCombinedMax(maxPadding, chartArea, a, b) {
        return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
    }
    function updateDims(chartArea, params, layout) {
        var box = layout.box;
        var maxPadding = chartArea.maxPadding;
        var newWidth, newHeight;
        if (layout.size) // this layout was already counted for, lets first reduce old size
        chartArea[layout.pos] -= layout.size;
        layout.size = layout.horizontal ? box.height : box.width;
        chartArea[layout.pos] += layout.size;
        if (box.getPadding) {
            var boxPadding = box.getPadding();
            maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
            maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
            maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
            maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
        }
        newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
        newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');
        if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
            chartArea.w = newWidth;
            chartArea.h = newHeight;
            // return true if chart area changed in layout's direction
            var sizes = layout.horizontal ? [
                newWidth,
                chartArea.w
            ] : [
                newHeight,
                chartArea.h
            ];
            return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
        }
    }
    function handleMaxPadding(chartArea) {
        var maxPadding = chartArea.maxPadding;
        function updatePos(pos) {
            var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
            chartArea[pos] += change;
            return change;
        }
        chartArea.y += updatePos('top');
        chartArea.x += updatePos('left');
        updatePos('right');
        updatePos('bottom');
    }
    function getMargins(horizontal, chartArea) {
        var maxPadding = chartArea.maxPadding;
        function marginForPositions(positions) {
            var margin = {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            };
            positions.forEach(function(pos) {
                margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
            });
            return margin;
        }
        return horizontal ? marginForPositions([
            'left',
            'right'
        ]) : marginForPositions([
            'top',
            'bottom'
        ]);
    }
    function fitBoxes(boxes, chartArea, params) {
        var refitBoxes = [];
        var i, ilen, layout, box, refit, changed;
        for(i = 0, ilen = boxes.length; i < ilen; ++i){
            layout = boxes[i];
            box = layout.box;
            box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
            if (updateDims(chartArea, params, layout)) {
                changed = true;
                if (refitBoxes.length) // Dimensions changed and there were non full width boxes before this
                // -> we have to refit those
                refit = true;
            }
            if (!box.fullWidth) refitBoxes.push(layout);
        }
        return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
    }
    function placeBoxes(boxes, chartArea, params) {
        var userPadding = params.padding;
        var x = chartArea.x;
        var y = chartArea.y;
        var i, ilen, layout, box;
        for(i = 0, ilen = boxes.length; i < ilen; ++i){
            layout = boxes[i];
            box = layout.box;
            if (layout.horizontal) {
                box.left = box.fullWidth ? userPadding.left : chartArea.left;
                box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
                box.top = y;
                box.bottom = y + box.height;
                box.width = box.right - box.left;
                y = box.bottom;
            } else {
                box.left = x;
                box.right = x + box.width;
                box.top = chartArea.top;
                box.bottom = chartArea.top + chartArea.h;
                box.height = box.bottom - box.top;
                x = box.right;
            }
        }
        chartArea.x = x;
        chartArea.y = y;
    }
    core_defaults._set('global', {
        layout: {
            padding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }
        }
    });
    /**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */ // The layout service is very self explanatory.  It's responsible for the layout within a chart.
    // Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
    // It is this service's responsibility of carrying out that layout.
    var core_layouts = {
        defaults: {},
        /**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */ addBox: function(chart, item) {
            if (!chart.boxes) chart.boxes = [];
            // initialize item with default values
            item.fullWidth = item.fullWidth || false;
            item.position = item.position || 'top';
            item.weight = item.weight || 0;
            item._layers = item._layers || function() {
                return [
                    {
                        z: 0,
                        draw: function() {
                            item.draw.apply(item, arguments);
                        }
                    }
                ];
            };
            chart.boxes.push(item);
        },
        /**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */ removeBox: function(chart, layoutItem) {
            var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
            if (index !== -1) chart.boxes.splice(index, 1);
        },
        /**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */ configure: function(chart, item, options) {
            var props = [
                'fullWidth',
                'position',
                'weight'
            ];
            var ilen = props.length;
            var i = 0;
            var prop;
            for(; i < ilen; ++i){
                prop = props[i];
                if (options.hasOwnProperty(prop)) item[prop] = options[prop];
            }
        },
        /**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */ update: function(chart, width, height) {
            if (!chart) return;
            var layoutOptions = chart.options.layout || {};
            var padding = helpers$1.options.toPadding(layoutOptions.padding);
            var availableWidth = width - padding.width;
            var availableHeight = height - padding.height;
            var boxes = buildLayoutBoxes(chart.boxes);
            var verticalBoxes = boxes.vertical;
            var horizontalBoxes = boxes.horizontal;
            // Essentially we now have any number of boxes on each of the 4 sides.
            // Our canvas looks like the following.
            // The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
            // B1 is the bottom axis
            // There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
            // These locations are single-box locations only, when trying to register a chartArea location that is already taken,
            // an error will be thrown.
            //
            // |----------------------------------------------------|
            // |                  T1 (Full Width)                   |
            // |----------------------------------------------------|
            // |    |    |                 T2                  |    |
            // |    |----|-------------------------------------|----|
            // |    |    | C1 |                           | C2 |    |
            // |    |    |----|                           |----|    |
            // |    |    |                                     |    |
            // | L1 | L2 |           ChartArea (C0)            | R1 |
            // |    |    |                                     |    |
            // |    |    |----|                           |----|    |
            // |    |    | C3 |                           | C4 |    |
            // |    |----|-------------------------------------|----|
            // |    |    |                 B1                  |    |
            // |----------------------------------------------------|
            // |                  B2 (Full Width)                   |
            // |----------------------------------------------------|
            //
            var params = Object.freeze({
                outerWidth: width,
                outerHeight: height,
                padding: padding,
                availableWidth: availableWidth,
                vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
                hBoxMaxHeight: availableHeight / 2
            });
            var chartArea = extend({
                maxPadding: extend({}, padding),
                w: availableWidth,
                h: availableHeight,
                x: padding.left,
                y: padding.top
            }, padding);
            setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
            // First fit vertical boxes
            fitBoxes(verticalBoxes, chartArea, params);
            // Then fit horizontal boxes
            if (fitBoxes(horizontalBoxes, chartArea, params)) // if the area changed, re-fit vertical boxes
            fitBoxes(verticalBoxes, chartArea, params);
            handleMaxPadding(chartArea);
            // Finally place the boxes to correct coordinates
            placeBoxes(boxes.leftAndTop, chartArea, params);
            // Move to opposite side of chart
            chartArea.x += chartArea.w;
            chartArea.y += chartArea.h;
            placeBoxes(boxes.rightAndBottom, chartArea, params);
            chart.chartArea = {
                left: chartArea.left,
                top: chartArea.top,
                right: chartArea.left + chartArea.w,
                bottom: chartArea.top + chartArea.h
            };
            // Finally update boxes in chartArea (radial scale for example)
            helpers$1.each(boxes.chartArea, function(layout) {
                var box = layout.box;
                extend(box, chart.chartArea);
                box.update(chartArea.w, chartArea.h);
            });
        }
    };
    /**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */ var platform_basic = {
        acquireContext: function(item) {
            if (item && item.canvas) // Support for any object associated to a canvas (including a context2d)
            item = item.canvas;
            return item && item.getContext('2d') || null;
        }
    };
    var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";
    var platform_dom$1 = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        'default': platform_dom
    });
    var stylesheet = getCjsExportFromNamespace(platform_dom$1);
    var EXPANDO_KEY = '$chartjs';
    var CSS_PREFIX = 'chartjs-';
    var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
    var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
    var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
    var ANIMATION_START_EVENTS = [
        'animationstart',
        'webkitAnimationStart'
    ];
    /**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */ var EVENT_TYPES = {
        touchstart: 'mousedown',
        touchmove: 'mousemove',
        touchend: 'mouseup',
        pointerenter: 'mouseenter',
        pointerdown: 'mousedown',
        pointermove: 'mousemove',
        pointerup: 'mouseup',
        pointerleave: 'mouseout',
        pointerout: 'mouseout'
    };
    /**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */ function readUsedSize(element, property) {
        var value = helpers$1.getStyle(element, property);
        var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
        return matches ? Number(matches[1]) : undefined;
    }
    /**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */ function initCanvas(canvas, config) {
        var style = canvas.style;
        // NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
        // returns null or '' if no explicit value has been set to the canvas attribute.
        var renderHeight = canvas.getAttribute('height');
        var renderWidth = canvas.getAttribute('width');
        // Chart.js modifies some canvas values that we want to restore on destroy
        canvas[EXPANDO_KEY] = {
            initial: {
                height: renderHeight,
                width: renderWidth,
                style: {
                    display: style.display,
                    height: style.height,
                    width: style.width
                }
            }
        };
        // Force canvas to display as block to avoid extra space caused by inline
        // elements, which would interfere with the responsive resize process.
        // https://github.com/chartjs/Chart.js/issues/2538
        style.display = style.display || 'block';
        if (renderWidth === null || renderWidth === '') {
            var displayWidth = readUsedSize(canvas, 'width');
            if (displayWidth !== undefined) canvas.width = displayWidth;
        }
        if (renderHeight === null || renderHeight === '') {
            if (canvas.style.height === '') // If no explicit render height and style height, let's apply the aspect ratio,
            // which one can be specified by the user but also by charts as default option
            // (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
            canvas.height = canvas.width / (config.options.aspectRatio || 2);
            else {
                var displayHeight = readUsedSize(canvas, 'height');
                if (displayWidth !== undefined) canvas.height = displayHeight;
            }
        }
        return canvas;
    }
    /**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ var supportsEventListenerOptions = function() {
        var supports = false;
        try {
            var options = Object.defineProperty({}, 'passive', {
                // eslint-disable-next-line getter-return
                get: function() {
                    supports = true;
                }
            });
            window.addEventListener('e', null, options);
        } catch (e) {
        // continue regardless of error
        }
        return supports;
    }();
    // Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
    // https://github.com/chartjs/Chart.js/issues/4287
    var eventListenerOptions = supportsEventListenerOptions ? {
        passive: true
    } : false;
    function addListener(node, type, listener) {
        node.addEventListener(type, listener, eventListenerOptions);
    }
    function removeListener(node, type, listener) {
        node.removeEventListener(type, listener, eventListenerOptions);
    }
    function createEvent(type, chart, x, y, nativeEvent) {
        return {
            type: type,
            chart: chart,
            native: nativeEvent || null,
            x: x !== undefined ? x : null,
            y: y !== undefined ? y : null
        };
    }
    function fromNativeEvent(event, chart) {
        var type = EVENT_TYPES[event.type] || event.type;
        var pos = helpers$1.getRelativePosition(event, chart);
        return createEvent(type, chart, pos.x, pos.y, event);
    }
    function throttled(fn, thisArg) {
        var ticking = false;
        var args = [];
        return function() {
            args = Array.prototype.slice.call(arguments);
            thisArg = thisArg || this;
            if (!ticking) {
                ticking = true;
                helpers$1.requestAnimFrame.call(window, function() {
                    ticking = false;
                    fn.apply(thisArg, args);
                });
            }
        };
    }
    function createDiv(cls) {
        var el = document.createElement('div');
        el.className = cls || '';
        return el;
    }
    // Implementation based on https://github.com/marcj/css-element-queries
    function createResizer(handler) {
        var maxSize = 1000000;
        // NOTE(SB) Don't use innerHTML because it could be considered unsafe.
        // https://github.com/chartjs/Chart.js/issues/5902
        var resizer = createDiv(CSS_SIZE_MONITOR);
        var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
        var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');
        expand.appendChild(createDiv());
        shrink.appendChild(createDiv());
        resizer.appendChild(expand);
        resizer.appendChild(shrink);
        resizer._reset = function() {
            expand.scrollLeft = maxSize;
            expand.scrollTop = maxSize;
            shrink.scrollLeft = maxSize;
            shrink.scrollTop = maxSize;
        };
        var onScroll = function() {
            resizer._reset();
            handler();
        };
        addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
        addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
        return resizer;
    }
    // https://davidwalsh.name/detect-node-insertion
    function watchForRender(node, handler) {
        var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
        var proxy = expando.renderProxy = function(e) {
            if (e.animationName === CSS_RENDER_ANIMATION) handler();
        };
        helpers$1.each(ANIMATION_START_EVENTS, function(type) {
            addListener(node, type, proxy);
        });
        // #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
        // is removed then added back immediately (same animation frame?). Accessing the
        // `offsetParent` property will force a reflow and re-evaluate the CSS animation.
        // https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
        // https://github.com/chartjs/Chart.js/issues/4737
        expando.reflow = !!node.offsetParent;
        node.classList.add(CSS_RENDER_MONITOR);
    }
    function unwatchForRender(node) {
        var expando = node[EXPANDO_KEY] || {};
        var proxy = expando.renderProxy;
        if (proxy) {
            helpers$1.each(ANIMATION_START_EVENTS, function(type) {
                removeListener(node, type, proxy);
            });
            delete expando.renderProxy;
        }
        node.classList.remove(CSS_RENDER_MONITOR);
    }
    function addResizeListener(node, listener, chart) {
        var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
        // Let's keep track of this added resizer and thus avoid DOM query when removing it.
        var resizer = expando.resizer = createResizer(throttled(function() {
            if (expando.resizer) {
                var container = chart.options.maintainAspectRatio && node.parentNode;
                var w = container ? container.clientWidth : 0;
                listener(createEvent('resize', chart));
                if (container && container.clientWidth < w && chart.canvas) // If the container size shrank during chart resize, let's assume
                // scrollbar appeared. So we resize again with the scrollbar visible -
                // effectively making chart smaller and the scrollbar hidden again.
                // Because we are inside `throttled`, and currently `ticking`, scroll
                // events are ignored during this whole 2 resize process.
                // If we assumed wrong and something else happened, we are resizing
                // twice in a frame (potential performance issue)
                listener(createEvent('resize', chart));
            }
        }));
        // The resizer needs to be attached to the node parent, so we first need to be
        // sure that `node` is attached to the DOM before injecting the resizer element.
        watchForRender(node, function() {
            if (expando.resizer) {
                var container = node.parentNode;
                if (container && container !== resizer.parentNode) container.insertBefore(resizer, container.firstChild);
                // The container size might have changed, let's reset the resizer state.
                resizer._reset();
            }
        });
    }
    function removeResizeListener(node) {
        var expando = node[EXPANDO_KEY] || {};
        var resizer = expando.resizer;
        delete expando.resizer;
        unwatchForRender(node);
        if (resizer && resizer.parentNode) resizer.parentNode.removeChild(resizer);
    }
    /**
 * Injects CSS styles inline if the styles are not already present.
 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
 * @param {string} css - the CSS to be injected.
 */ function injectCSS(rootNode, css) {
        // https://stackoverflow.com/q/3922139
        var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
        if (!expando.containsStyles) {
            expando.containsStyles = true;
            css = '/* Chart.js */\n' + css;
            var style = document.createElement('style');
            style.setAttribute('type', 'text/css');
            style.appendChild(document.createTextNode(css));
            rootNode.appendChild(style);
        }
    }
    var platform_dom$2 = {
        /**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */ disableCSSInjection: false,
        /**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */ _enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
        /**
	 * Initializes resources that depend on platform options.
	 * @param {HTMLCanvasElement} canvas - The Canvas element.
	 * @private
	 */ _ensureLoaded: function(canvas) {
            if (!this.disableCSSInjection) {
                // If the canvas is in a shadow DOM, then the styles must also be inserted
                // into the same shadow DOM.
                // https://github.com/chartjs/Chart.js/issues/5763
                var root = canvas.getRootNode ? canvas.getRootNode() : document;
                var targetNode = root.host ? root : document.head;
                injectCSS(targetNode, stylesheet);
            }
        },
        acquireContext: function(item, config) {
            if (typeof item === 'string') item = document.getElementById(item);
            else if (item.length) // Support for array based queries (such as jQuery)
            item = item[0];
            if (item && item.canvas) // Support for any object associated to a canvas (including a context2d)
            item = item.canvas;
            // To prevent canvas fingerprinting, some add-ons undefine the getContext
            // method, for example: https://github.com/kkapsner/CanvasBlocker
            // https://github.com/chartjs/Chart.js/issues/2807
            var context = item && item.getContext && item.getContext('2d');
            // `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
            // inside an iframe or when running in a protected environment. We could guess the
            // types from their toString() value but let's keep things flexible and assume it's
            // a sufficient condition if the item has a context2D which has item as `canvas`.
            // https://github.com/chartjs/Chart.js/issues/3887
            // https://github.com/chartjs/Chart.js/issues/4102
            // https://github.com/chartjs/Chart.js/issues/4152
            if (context && context.canvas === item) {
                // Load platform resources on first chart creation, to make it possible to
                // import the library before setting platform options.
                this._ensureLoaded(item);
                initCanvas(item, config);
                return context;
            }
            return null;
        },
        releaseContext: function(context) {
            var canvas = context.canvas;
            if (!canvas[EXPANDO_KEY]) return;
            var initial = canvas[EXPANDO_KEY].initial;
            [
                'height',
                'width'
            ].forEach(function(prop) {
                var value = initial[prop];
                if (helpers$1.isNullOrUndef(value)) canvas.removeAttribute(prop);
                else canvas.setAttribute(prop, value);
            });
            helpers$1.each(initial.style || {}, function(value, key) {
                canvas.style[key] = value;
            });
            // The canvas render size might have been changed (and thus the state stack discarded),
            // we can't use save() and restore() to restore the initial state. So make sure that at
            // least the canvas context is reset to the default state by setting the canvas width.
            // https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
            // eslint-disable-next-line no-self-assign
            canvas.width = canvas.width;
            delete canvas[EXPANDO_KEY];
        },
        addEventListener: function(chart, type, listener) {
            var canvas = chart.canvas;
            if (type === 'resize') {
                // Note: the resize event is not supported on all browsers.
                addResizeListener(canvas, listener, chart);
                return;
            }
            var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
            var proxies = expando.proxies || (expando.proxies = {});
            var proxy = proxies[chart.id + '_' + type] = function(event) {
                listener(fromNativeEvent(event, chart));
            };
            addListener(canvas, type, proxy);
        },
        removeEventListener: function(chart, type, listener) {
            var canvas = chart.canvas;
            if (type === 'resize') {
                // Note: the resize event is not supported on all browsers.
                removeResizeListener(canvas);
                return;
            }
            var expando = listener[EXPANDO_KEY] || {};
            var proxies = expando.proxies || {};
            var proxy = proxies[chart.id + '_' + type];
            if (!proxy) return;
            removeListener(canvas, type, proxy);
        }
    };
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers$1.addEvent = addListener;
    /**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */ helpers$1.removeEvent = removeListener;
    // @TODO Make possible to select another platform at build time.
    var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;
    /**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */ var platform = helpers$1.extend({
        /**
	 * @since 2.7.0
	 */ initialize: function() {},
        /**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */ acquireContext: function() {},
        /**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */ releaseContext: function() {},
        /**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */ addEventListener: function() {},
        /**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */ removeEventListener: function() {}
    }, implementation);
    core_defaults._set('global', {
        plugins: {}
    });
    /**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */ var core_plugins = {
        /**
	 * Globally registered plugins.
	 * @private
	 */ _plugins: [],
        /**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */ _cacheId: 0,
        /**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */ register: function(plugins) {
            var p = this._plugins;
            [].concat(plugins).forEach(function(plugin) {
                if (p.indexOf(plugin) === -1) p.push(plugin);
            });
            this._cacheId++;
        },
        /**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */ unregister: function(plugins) {
            var p = this._plugins;
            [].concat(plugins).forEach(function(plugin) {
                var idx = p.indexOf(plugin);
                if (idx !== -1) p.splice(idx, 1);
            });
            this._cacheId++;
        },
        /**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */ clear: function() {
            this._plugins = [];
            this._cacheId++;
        },
        /**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */ count: function() {
            return this._plugins.length;
        },
        /**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */ getAll: function() {
            return this._plugins;
        },
        /**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */ notify: function(chart, hook, args) {
            var descriptors = this.descriptors(chart);
            var ilen = descriptors.length;
            var i, descriptor, plugin, params, method;
            for(i = 0; i < ilen; ++i){
                descriptor = descriptors[i];
                plugin = descriptor.plugin;
                method = plugin[hook];
                if (typeof method === 'function') {
                    params = [
                        chart
                    ].concat(args || []);
                    params.push(descriptor.options);
                    if (method.apply(plugin, params) === false) return false;
                }
            }
            return true;
        },
        /**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */ descriptors: function(chart) {
            var cache = chart.$plugins || (chart.$plugins = {});
            if (cache.id === this._cacheId) return cache.descriptors;
            var plugins = [];
            var descriptors = [];
            var config = chart && chart.config || {};
            var options = config.options && config.options.plugins || {};
            this._plugins.concat(config.plugins || []).forEach(function(plugin) {
                var idx = plugins.indexOf(plugin);
                if (idx !== -1) return;
                var id = plugin.id;
                var opts = options[id];
                if (opts === false) return;
                if (opts === true) opts = helpers$1.clone(core_defaults.global.plugins[id]);
                plugins.push(plugin);
                descriptors.push({
                    plugin: plugin,
                    options: opts || {}
                });
            });
            cache.descriptors = descriptors;
            cache.id = this._cacheId;
            return descriptors;
        },
        /**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */ _invalidate: function(chart) {
            delete chart.$plugins;
        }
    };
    var core_scaleService = {
        // Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
        // use the new chart options to grab the correct scale
        constructors: {},
        // Use a registration function so that we can move to an ES6 map when we no longer need to support
        // old browsers
        // Scale config defaults
        defaults: {},
        registerScaleType: function(type, scaleConstructor, scaleDefaults) {
            this.constructors[type] = scaleConstructor;
            this.defaults[type] = helpers$1.clone(scaleDefaults);
        },
        getScaleConstructor: function(type) {
            return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
        },
        getScaleDefaults: function(type) {
            // Return the scale defaults merged with the global settings so that we always use the latest ones
            return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [
                core_defaults.scale,
                this.defaults[type]
            ]) : {};
        },
        updateScaleDefaults: function(type, additions) {
            var me = this;
            if (me.defaults.hasOwnProperty(type)) me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
        },
        addScalesToLayout: function(chart) {
            // Adds each scale to the chart.boxes array to be sized accordingly
            helpers$1.each(chart.scales, function(scale) {
                // Set ILayoutItem parameters for backwards compatibility
                scale.fullWidth = scale.options.fullWidth;
                scale.position = scale.options.position;
                scale.weight = scale.options.weight;
                core_layouts.addBox(chart, scale);
            });
        }
    };
    var valueOrDefault$8 = helpers$1.valueOrDefault;
    var getRtlHelper = helpers$1.rtl.getRtlAdapter;
    core_defaults._set('global', {
        tooltips: {
            enabled: true,
            custom: null,
            mode: 'nearest',
            position: 'average',
            intersect: true,
            backgroundColor: 'rgba(0,0,0,0.8)',
            titleFontStyle: 'bold',
            titleSpacing: 2,
            titleMarginBottom: 6,
            titleFontColor: '#fff',
            titleAlign: 'left',
            bodySpacing: 2,
            bodyFontColor: '#fff',
            bodyAlign: 'left',
            footerFontStyle: 'bold',
            footerSpacing: 2,
            footerMarginTop: 6,
            footerFontColor: '#fff',
            footerAlign: 'left',
            yPadding: 6,
            xPadding: 6,
            caretPadding: 2,
            caretSize: 5,
            cornerRadius: 6,
            multiKeyBackground: '#fff',
            displayColors: true,
            borderColor: 'rgba(0,0,0,0)',
            borderWidth: 0,
            callbacks: {
                // Args are: (tooltipItems, data)
                beforeTitle: helpers$1.noop,
                title: function(tooltipItems, data) {
                    var title = '';
                    var labels = data.labels;
                    var labelCount = labels ? labels.length : 0;
                    if (tooltipItems.length > 0) {
                        var item = tooltipItems[0];
                        if (item.label) title = item.label;
                        else if (item.xLabel) title = item.xLabel;
                        else if (labelCount > 0 && item.index < labelCount) title = labels[item.index];
                    }
                    return title;
                },
                afterTitle: helpers$1.noop,
                // Args are: (tooltipItems, data)
                beforeBody: helpers$1.noop,
                // Args are: (tooltipItem, data)
                beforeLabel: helpers$1.noop,
                label: function(tooltipItem, data) {
                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
                    if (label) label += ': ';
                    if (!helpers$1.isNullOrUndef(tooltipItem.value)) label += tooltipItem.value;
                    else label += tooltipItem.yLabel;
                    return label;
                },
                labelColor: function(tooltipItem, chart) {
                    var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
                    var activeElement = meta.data[tooltipItem.index];
                    var view = activeElement._view;
                    return {
                        borderColor: view.borderColor,
                        backgroundColor: view.backgroundColor
                    };
                },
                labelTextColor: function() {
                    return this._options.bodyFontColor;
                },
                afterLabel: helpers$1.noop,
                // Args are: (tooltipItems, data)
                afterBody: helpers$1.noop,
                // Args are: (tooltipItems, data)
                beforeFooter: helpers$1.noop,
                footer: helpers$1.noop,
                afterFooter: helpers$1.noop
            }
        }
    });
    var positioners = {
        /**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */ average: function(elements) {
            if (!elements.length) return false;
            var i, len;
            var x = 0;
            var y = 0;
            var count = 0;
            for(i = 0, len = elements.length; i < len; ++i){
                var el = elements[i];
                if (el && el.hasValue()) {
                    var pos = el.tooltipPosition();
                    x += pos.x;
                    y += pos.y;
                    ++count;
                }
            }
            return {
                x: x / count,
                y: y / count
            };
        },
        /**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */ nearest: function(elements, eventPosition) {
            var x = eventPosition.x;
            var y = eventPosition.y;
            var minDistance = Number.POSITIVE_INFINITY;
            var i, len, nearestElement;
            for(i = 0, len = elements.length; i < len; ++i){
                var el = elements[i];
                if (el && el.hasValue()) {
                    var center = el.getCenterPoint();
                    var d = helpers$1.distanceBetweenPoints(eventPosition, center);
                    if (d < minDistance) {
                        minDistance = d;
                        nearestElement = el;
                    }
                }
            }
            if (nearestElement) {
                var tp = nearestElement.tooltipPosition();
                x = tp.x;
                y = tp.y;
            }
            return {
                x: x,
                y: y
            };
        }
    };
    // Helper to push or concat based on if the 2nd parameter is an array or not
    function pushOrConcat(base, toPush) {
        if (toPush) {
            if (helpers$1.isArray(toPush)) // base = base.concat(toPush);
            Array.prototype.push.apply(base, toPush);
            else base.push(toPush);
        }
        return base;
    }
    /**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */ function splitNewlines(str) {
        if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
        return str;
    }
    /**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */ function createTooltipItem(element) {
        var xScale = element._xScale;
        var yScale = element._yScale || element._scale; // handle radar || polarArea charts
        var index = element._index;
        var datasetIndex = element._datasetIndex;
        var controller = element._chart.getDatasetMeta(datasetIndex).controller;
        var indexScale = controller._getIndexScale();
        var valueScale = controller._getValueScale();
        return {
            xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
            yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
            label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
            value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
            index: index,
            datasetIndex: datasetIndex,
            x: element._model.x,
            y: element._model.y
        };
    }
    /**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */ function getBaseModel(tooltipOpts) {
        var globalDefaults = core_defaults.global;
        return {
            // Positioning
            xPadding: tooltipOpts.xPadding,
            yPadding: tooltipOpts.yPadding,
            xAlign: tooltipOpts.xAlign,
            yAlign: tooltipOpts.yAlign,
            // Drawing direction and text direction
            rtl: tooltipOpts.rtl,
            textDirection: tooltipOpts.textDirection,
            // Body
            bodyFontColor: tooltipOpts.bodyFontColor,
            _bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
            _bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
            _bodyAlign: tooltipOpts.bodyAlign,
            bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
            bodySpacing: tooltipOpts.bodySpacing,
            // Title
            titleFontColor: tooltipOpts.titleFontColor,
            _titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
            _titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
            titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
            _titleAlign: tooltipOpts.titleAlign,
            titleSpacing: tooltipOpts.titleSpacing,
            titleMarginBottom: tooltipOpts.titleMarginBottom,
            // Footer
            footerFontColor: tooltipOpts.footerFontColor,
            _footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
            _footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
            footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
            _footerAlign: tooltipOpts.footerAlign,
            footerSpacing: tooltipOpts.footerSpacing,
            footerMarginTop: tooltipOpts.footerMarginTop,
            // Appearance
            caretSize: tooltipOpts.caretSize,
            cornerRadius: tooltipOpts.cornerRadius,
            backgroundColor: tooltipOpts.backgroundColor,
            opacity: 0,
            legendColorBackground: tooltipOpts.multiKeyBackground,
            displayColors: tooltipOpts.displayColors,
            borderColor: tooltipOpts.borderColor,
            borderWidth: tooltipOpts.borderWidth
        };
    }
    /**
 * Get the size of the tooltip
 */ function getTooltipSize(tooltip, model) {
        var ctx = tooltip._chart.ctx;
        var height = model.yPadding * 2; // Tooltip Padding
        var width = 0;
        // Count of all lines in the body
        var body = model.body;
        var combinedBodyLength = body.reduce(function(count, bodyItem) {
            return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
        }, 0);
        combinedBodyLength += model.beforeBody.length + model.afterBody.length;
        var titleLineCount = model.title.length;
        var footerLineCount = model.footer.length;
        var titleFontSize = model.titleFontSize;
        var bodyFontSize = model.bodyFontSize;
        var footerFontSize = model.footerFontSize;
        height += titleLineCount * titleFontSize; // Title Lines
        height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
        height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
        height += combinedBodyLength * bodyFontSize; // Body Lines
        height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
        height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
        height += footerLineCount * footerFontSize; // Footer Lines
        height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
        // Title width
        var widthPadding = 0;
        var maxLineWidth = function(line) {
            width = Math.max(width, ctx.measureText(line).width + widthPadding);
        };
        ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
        helpers$1.each(model.title, maxLineWidth);
        // Body width
        ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
        helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
        // Body lines may include some extra width due to the color box
        widthPadding = model.displayColors ? bodyFontSize + 2 : 0;
        helpers$1.each(body, function(bodyItem) {
            helpers$1.each(bodyItem.before, maxLineWidth);
            helpers$1.each(bodyItem.lines, maxLineWidth);
            helpers$1.each(bodyItem.after, maxLineWidth);
        });
        // Reset back to 0
        widthPadding = 0;
        // Footer width
        ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
        helpers$1.each(model.footer, maxLineWidth);
        // Add padding
        width += 2 * model.xPadding;
        return {
            width: width,
            height: height
        };
    }
    /**
 * Helper to get the alignment of a tooltip given the size
 */ function determineAlignment(tooltip, size) {
        var model = tooltip._model;
        var chart = tooltip._chart;
        var chartArea = tooltip._chart.chartArea;
        var xAlign = 'center';
        var yAlign = 'center';
        if (model.y < size.height) yAlign = 'top';
        else if (model.y > chart.height - size.height) yAlign = 'bottom';
        var lf, rf; // functions to determine left, right alignment
        var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
        var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
        var midX = (chartArea.left + chartArea.right) / 2;
        var midY = (chartArea.top + chartArea.bottom) / 2;
        if (yAlign === 'center') {
            lf = function(x) {
                return x <= midX;
            };
            rf = function(x) {
                return x > midX;
            };
        } else {
            lf = function(x) {
                return x <= size.width / 2;
            };
            rf = function(x) {
                return x >= chart.width - size.width / 2;
            };
        }
        olf = function(x) {
            return x + size.width + model.caretSize + model.caretPadding > chart.width;
        };
        orf = function(x) {
            return x - size.width - model.caretSize - model.caretPadding < 0;
        };
        yf = function(y) {
            return y <= midY ? 'top' : 'bottom';
        };
        if (lf(model.x)) {
            xAlign = 'left';
            // Is tooltip too wide and goes over the right side of the chart.?
            if (olf(model.x)) {
                xAlign = 'center';
                yAlign = yf(model.y);
            }
        } else if (rf(model.x)) {
            xAlign = 'right';
            // Is tooltip too wide and goes outside left edge of canvas?
            if (orf(model.x)) {
                xAlign = 'center';
                yAlign = yf(model.y);
            }
        }
        var opts = tooltip._options;
        return {
            xAlign: opts.xAlign ? opts.xAlign : xAlign,
            yAlign: opts.yAlign ? opts.yAlign : yAlign
        };
    }
    /**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */ function getBackgroundPoint(vm, size, alignment, chart) {
        // Background Position
        var x = vm.x;
        var y = vm.y;
        var caretSize = vm.caretSize;
        var caretPadding = vm.caretPadding;
        var cornerRadius = vm.cornerRadius;
        var xAlign = alignment.xAlign;
        var yAlign = alignment.yAlign;
        var paddingAndSize = caretSize + caretPadding;
        var radiusAndPadding = cornerRadius + caretPadding;
        if (xAlign === 'right') x -= size.width;
        else if (xAlign === 'center') {
            x -= size.width / 2;
            if (x + size.width > chart.width) x = chart.width - size.width;
            if (x < 0) x = 0;
        }
        if (yAlign === 'top') y += paddingAndSize;
        else if (yAlign === 'bottom') y -= size.height + paddingAndSize;
        else y -= size.height / 2;
        if (yAlign === 'center') {
            if (xAlign === 'left') x += paddingAndSize;
            else if (xAlign === 'right') x -= paddingAndSize;
        } else if (xAlign === 'left') x -= radiusAndPadding;
        else if (xAlign === 'right') x += radiusAndPadding;
        return {
            x: x,
            y: y
        };
    }
    function getAlignedX(vm, align) {
        return align === 'center' ? vm.x + vm.width / 2 : align === 'right' ? vm.x + vm.width - vm.xPadding : vm.x + vm.xPadding;
    }
    /**
 * Helper to build before and after body lines
 */ function getBeforeAfterBodyLines(callback) {
        return pushOrConcat([], splitNewlines(callback));
    }
    var exports$4 = core_element.extend({
        initialize: function() {
            this._model = getBaseModel(this._options);
            this._lastActive = [];
        },
        // Get the title
        // Args are: (tooltipItem, data)
        getTitle: function() {
            var me = this;
            var opts = me._options;
            var callbacks = opts.callbacks;
            var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
            var title = callbacks.title.apply(me, arguments);
            var afterTitle = callbacks.afterTitle.apply(me, arguments);
            var lines = [];
            lines = pushOrConcat(lines, splitNewlines(beforeTitle));
            lines = pushOrConcat(lines, splitNewlines(title));
            lines = pushOrConcat(lines, splitNewlines(afterTitle));
            return lines;
        },
        // Args are: (tooltipItem, data)
        getBeforeBody: function() {
            return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
        },
        // Args are: (tooltipItem, data)
        getBody: function(tooltipItems, data) {
            var me = this;
            var callbacks = me._options.callbacks;
            var bodyItems = [];
            helpers$1.each(tooltipItems, function(tooltipItem) {
                var bodyItem = {
                    before: [],
                    lines: [],
                    after: []
                };
                pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
                pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
                pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
                bodyItems.push(bodyItem);
            });
            return bodyItems;
        },
        // Args are: (tooltipItem, data)
        getAfterBody: function() {
            return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
        },
        // Get the footer and beforeFooter and afterFooter lines
        // Args are: (tooltipItem, data)
        getFooter: function() {
            var me = this;
            var callbacks = me._options.callbacks;
            var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
            var footer = callbacks.footer.apply(me, arguments);
            var afterFooter = callbacks.afterFooter.apply(me, arguments);
            var lines = [];
            lines = pushOrConcat(lines, splitNewlines(beforeFooter));
            lines = pushOrConcat(lines, splitNewlines(footer));
            lines = pushOrConcat(lines, splitNewlines(afterFooter));
            return lines;
        },
        update: function(changed) {
            var me = this;
            var opts = me._options;
            // Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
            // that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
            // which breaks any animations.
            var existingModel = me._model;
            var model = me._model = getBaseModel(opts);
            var active = me._active;
            var data = me._data;
            // In the case where active.length === 0 we need to keep these at existing values for good animations
            var alignment = {
                xAlign: existingModel.xAlign,
                yAlign: existingModel.yAlign
            };
            var backgroundPoint = {
                x: existingModel.x,
                y: existingModel.y
            };
            var tooltipSize = {
                width: existingModel.width,
                height: existingModel.height
            };
            var tooltipPosition = {
                x: existingModel.caretX,
                y: existingModel.caretY
            };
            var i, len;
            if (active.length) {
                model.opacity = 1;
                var labelColors = [];
                var labelTextColors = [];
                tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
                var tooltipItems = [];
                for(i = 0, len = active.length; i < len; ++i)tooltipItems.push(createTooltipItem(active[i]));
                // If the user provided a filter function, use it to modify the tooltip items
                if (opts.filter) tooltipItems = tooltipItems.filter(function(a) {
                    return opts.filter(a, data);
                });
                // If the user provided a sorting function, use it to modify the tooltip items
                if (opts.itemSort) tooltipItems = tooltipItems.sort(function(a, b) {
                    return opts.itemSort(a, b, data);
                });
                // Determine colors for boxes
                helpers$1.each(tooltipItems, function(tooltipItem) {
                    labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
                    labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
                });
                // Build the Text Lines
                model.title = me.getTitle(tooltipItems, data);
                model.beforeBody = me.getBeforeBody(tooltipItems, data);
                model.body = me.getBody(tooltipItems, data);
                model.afterBody = me.getAfterBody(tooltipItems, data);
                model.footer = me.getFooter(tooltipItems, data);
                // Initial positioning and colors
                model.x = tooltipPosition.x;
                model.y = tooltipPosition.y;
                model.caretPadding = opts.caretPadding;
                model.labelColors = labelColors;
                model.labelTextColors = labelTextColors;
                // data points
                model.dataPoints = tooltipItems;
                // We need to determine alignment of the tooltip
                tooltipSize = getTooltipSize(this, model);
                alignment = determineAlignment(this, tooltipSize);
                // Final Size and Position
                backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
            } else model.opacity = 0;
            model.xAlign = alignment.xAlign;
            model.yAlign = alignment.yAlign;
            model.x = backgroundPoint.x;
            model.y = backgroundPoint.y;
            model.width = tooltipSize.width;
            model.height = tooltipSize.height;
            // Point where the caret on the tooltip points to
            model.caretX = tooltipPosition.x;
            model.caretY = tooltipPosition.y;
            me._model = model;
            if (changed && opts.custom) opts.custom.call(me, model);
            return me;
        },
        drawCaret: function(tooltipPoint, size) {
            var ctx = this._chart.ctx;
            var vm = this._view;
            var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
            ctx.lineTo(caretPosition.x1, caretPosition.y1);
            ctx.lineTo(caretPosition.x2, caretPosition.y2);
            ctx.lineTo(caretPosition.x3, caretPosition.y3);
        },
        getCaretPosition: function(tooltipPoint, size, vm) {
            var x1, x2, x3, y1, y2, y3;
            var caretSize = vm.caretSize;
            var cornerRadius = vm.cornerRadius;
            var xAlign = vm.xAlign;
            var yAlign = vm.yAlign;
            var ptX = tooltipPoint.x;
            var ptY = tooltipPoint.y;
            var width = size.width;
            var height = size.height;
            if (yAlign === 'center') {
                y2 = ptY + height / 2;
                if (xAlign === 'left') {
                    x1 = ptX;
                    x2 = x1 - caretSize;
                    x3 = x1;
                    y1 = y2 + caretSize;
                    y3 = y2 - caretSize;
                } else {
                    x1 = ptX + width;
                    x2 = x1 + caretSize;
                    x3 = x1;
                    y1 = y2 - caretSize;
                    y3 = y2 + caretSize;
                }
            } else {
                if (xAlign === 'left') {
                    x2 = ptX + cornerRadius + caretSize;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                } else if (xAlign === 'right') {
                    x2 = ptX + width - cornerRadius - caretSize;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                } else {
                    x2 = vm.caretX;
                    x1 = x2 - caretSize;
                    x3 = x2 + caretSize;
                }
                if (yAlign === 'top') {
                    y1 = ptY;
                    y2 = y1 - caretSize;
                    y3 = y1;
                } else {
                    y1 = ptY + height;
                    y2 = y1 + caretSize;
                    y3 = y1;
                    // invert drawing order
                    var tmp = x3;
                    x3 = x1;
                    x1 = tmp;
                }
            }
            return {
                x1: x1,
                x2: x2,
                x3: x3,
                y1: y1,
                y2: y2,
                y3: y3
            };
        },
        drawTitle: function(pt, vm, ctx) {
            var title = vm.title;
            var length = title.length;
            var titleFontSize, titleSpacing, i;
            if (length) {
                var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
                pt.x = getAlignedX(vm, vm._titleAlign);
                ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
                ctx.textBaseline = 'middle';
                titleFontSize = vm.titleFontSize;
                titleSpacing = vm.titleSpacing;
                ctx.fillStyle = vm.titleFontColor;
                ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
                for(i = 0; i < length; ++i){
                    ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
                    pt.y += titleFontSize + titleSpacing; // Line Height and spacing
                    if (i + 1 === length) pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
                }
            }
        },
        drawBody: function(pt, vm, ctx) {
            var bodyFontSize = vm.bodyFontSize;
            var bodySpacing = vm.bodySpacing;
            var bodyAlign = vm._bodyAlign;
            var body = vm.body;
            var drawColorBoxes = vm.displayColors;
            var xLinePadding = 0;
            var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
            var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
            var fillLineOfText = function(line) {
                ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
                pt.y += bodyFontSize + bodySpacing;
            };
            var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
            var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
            ctx.textAlign = bodyAlign;
            ctx.textBaseline = 'middle';
            ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
            pt.x = getAlignedX(vm, bodyAlignForCalculation);
            // Before body lines
            ctx.fillStyle = vm.bodyFontColor;
            helpers$1.each(vm.beforeBody, fillLineOfText);
            xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? bodyFontSize / 2 + 1 : bodyFontSize + 2 : 0;
            // Draw body lines now
            for(i = 0, ilen = body.length; i < ilen; ++i){
                bodyItem = body[i];
                textColor = vm.labelTextColors[i];
                labelColors = vm.labelColors[i];
                ctx.fillStyle = textColor;
                helpers$1.each(bodyItem.before, fillLineOfText);
                lines = bodyItem.lines;
                for(j = 0, jlen = lines.length; j < jlen; ++j){
                    // Draw Legend-like boxes if needed
                    if (drawColorBoxes) {
                        var rtlColorX = rtlHelper.x(colorX);
                        // Fill a white rect so that colours merge nicely if the opacity is < 1
                        ctx.fillStyle = vm.legendColorBackground;
                        ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
                        // Border
                        ctx.lineWidth = 1;
                        ctx.strokeStyle = labelColors.borderColor;
                        ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);
                        // Inner square
                        ctx.fillStyle = labelColors.backgroundColor;
                        ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
                        ctx.fillStyle = textColor;
                    }
                    fillLineOfText(lines[j]);
                }
                helpers$1.each(bodyItem.after, fillLineOfText);
            }
            // Reset back to 0 for after body
            xLinePadding = 0;
            // After body lines
            helpers$1.each(vm.afterBody, fillLineOfText);
            pt.y -= bodySpacing; // Remove last body spacing
        },
        drawFooter: function(pt, vm, ctx) {
            var footer = vm.footer;
            var length = footer.length;
            var footerFontSize, i;
            if (length) {
                var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
                pt.x = getAlignedX(vm, vm._footerAlign);
                pt.y += vm.footerMarginTop;
                ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
                ctx.textBaseline = 'middle';
                footerFontSize = vm.footerFontSize;
                ctx.fillStyle = vm.footerFontColor;
                ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
                for(i = 0; i < length; ++i){
                    ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
                    pt.y += footerFontSize + vm.footerSpacing;
                }
            }
        },
        drawBackground: function(pt, vm, ctx, tooltipSize) {
            ctx.fillStyle = vm.backgroundColor;
            ctx.strokeStyle = vm.borderColor;
            ctx.lineWidth = vm.borderWidth;
            var xAlign = vm.xAlign;
            var yAlign = vm.yAlign;
            var x = pt.x;
            var y = pt.y;
            var width = tooltipSize.width;
            var height = tooltipSize.height;
            var radius = vm.cornerRadius;
            ctx.beginPath();
            ctx.moveTo(x + radius, y);
            if (yAlign === 'top') this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + width - radius, y);
            ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
            if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + width, y + height - radius);
            ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
            if (yAlign === 'bottom') this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x + radius, y + height);
            ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
            if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, tooltipSize);
            ctx.lineTo(x, y + radius);
            ctx.quadraticCurveTo(x, y, x + radius, y);
            ctx.closePath();
            ctx.fill();
            if (vm.borderWidth > 0) ctx.stroke();
        },
        draw: function() {
            var ctx = this._chart.ctx;
            var vm = this._view;
            if (vm.opacity === 0) return;
            var tooltipSize = {
                width: vm.width,
                height: vm.height
            };
            var pt = {
                x: vm.x,
                y: vm.y
            };
            // IE11/Edge does not like very small opacities, so snap to 0
            var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
            // Truthy/falsey value for empty tooltip
            var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
            if (this._options.enabled && hasTooltipContent) {
                ctx.save();
                ctx.globalAlpha = opacity;
                // Draw Background
                this.drawBackground(pt, vm, ctx, tooltipSize);
                // Draw Title, Body, and Footer
                pt.y += vm.yPadding;
                helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);
                // Titles
                this.drawTitle(pt, vm, ctx);
                // Body
                this.drawBody(pt, vm, ctx);
                // Footer
                this.drawFooter(pt, vm, ctx);
                helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
                ctx.restore();
            }
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */ handleEvent: function(e) {
            var me = this;
            var options = me._options;
            var changed = false;
            me._lastActive = me._lastActive || [];
            // Find Active Elements for tooltips
            if (e.type === 'mouseout') me._active = [];
            else {
                me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
                if (options.reverse) me._active.reverse();
            }
            // Remember Last Actives
            changed = !helpers$1.arrayEquals(me._active, me._lastActive);
            // Only handle target event on tooltip change
            if (changed) {
                me._lastActive = me._active;
                if (options.enabled || options.custom) {
                    me._eventPosition = {
                        x: e.x,
                        y: e.y
                    };
                    me.update(true);
                    me.pivot();
                }
            }
            return changed;
        }
    });
    /**
 * @namespace Chart.Tooltip.positioners
 */ var positioners_1 = positioners;
    var core_tooltip = exports$4;
    core_tooltip.positioners = positioners_1;
    var valueOrDefault$9 = helpers$1.valueOrDefault;
    core_defaults._set('global', {
        elements: {},
        events: [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ],
        hover: {
            onHover: null,
            mode: 'nearest',
            intersect: true,
            animationDuration: 400
        },
        onClick: null,
        maintainAspectRatio: true,
        responsive: true,
        responsiveAnimationDuration: 0
    });
    /**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */ function mergeScaleConfig() {
        return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
            merger: function(key, target, source, options) {
                if (key === 'xAxes' || key === 'yAxes') {
                    var slen = source[key].length;
                    var i, type, scale;
                    if (!target[key]) target[key] = [];
                    for(i = 0; i < slen; ++i){
                        scale = source[key][i];
                        type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');
                        if (i >= target[key].length) target[key].push({});
                        if (!target[key][i].type || scale.type && scale.type !== target[key][i].type) // new/untyped scale or type changed: let's apply the new defaults
                        // then merge source scale to correctly overwrite the defaults.
                        helpers$1.merge(target[key][i], [
                            core_scaleService.getScaleDefaults(type),
                            scale
                        ]);
                        else // scales type are the same
                        helpers$1.merge(target[key][i], scale);
                    }
                } else helpers$1._merger(key, target, source, options);
            }
        });
    }
    /**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */ function mergeConfig() {
        return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
            merger: function(key, target, source, options) {
                var tval = target[key] || Object.create(null);
                var sval = source[key];
                if (key === 'scales') // scale config merging is complex. Add our own function here for that
                target[key] = mergeScaleConfig(tval, sval);
                else if (key === 'scale') // used in polar area & radar charts since there is only one scale
                target[key] = helpers$1.merge(tval, [
                    core_scaleService.getScaleDefaults(sval.type),
                    sval
                ]);
                else helpers$1._merger(key, target, source, options);
            }
        });
    }
    function initConfig(config) {
        config = config || Object.create(null);
        // Do NOT use mergeConfig for the data object because this method merges arrays
        // and so would change references to labels and datasets, preventing data updates.
        var data = config.data = config.data || {};
        data.datasets = data.datasets || [];
        data.labels = data.labels || [];
        config.options = mergeConfig(core_defaults.global, core_defaults[config.type], config.options || {});
        return config;
    }
    function updateConfig(chart) {
        var newOptions = chart.options;
        helpers$1.each(chart.scales, function(scale) {
            core_layouts.removeBox(chart, scale);
        });
        newOptions = mergeConfig(core_defaults.global, core_defaults[chart.config.type], newOptions);
        chart.options = chart.config.options = newOptions;
        chart.ensureScalesHaveIDs();
        chart.buildOrUpdateScales();
        // Tooltip
        chart.tooltip._options = newOptions.tooltips;
        chart.tooltip.initialize();
    }
    function nextAvailableScaleId(axesOpts, prefix, index) {
        var id;
        var hasId = function(obj) {
            return obj.id === id;
        };
        do id = prefix + index++;
        while (helpers$1.findIndex(axesOpts, hasId) >= 0);
        return id;
    }
    function positionIsHorizontal(position) {
        return position === 'top' || position === 'bottom';
    }
    function compare2Level(l1, l2) {
        return function(a, b) {
            return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
        };
    }
    var Chart = function(item, config) {
        this.construct(item, config);
        return this;
    };
    helpers$1.extend(Chart.prototype, /** @lends Chart */ {
        /**
	 * @private
	 */ construct: function(item, config) {
            var me = this;
            config = initConfig(config);
            var context = platform.acquireContext(item, config);
            var canvas = context && context.canvas;
            var height = canvas && canvas.height;
            var width = canvas && canvas.width;
            me.id = helpers$1.uid();
            me.ctx = context;
            me.canvas = canvas;
            me.config = config;
            me.width = width;
            me.height = height;
            me.aspectRatio = height ? width / height : null;
            me.options = config.options;
            me._bufferedRender = false;
            me._layers = [];
            /**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */ me.chart = me;
            me.controller = me; // chart.chart.controller #inception
            // Add the chart instance to the global namespace
            Chart.instances[me.id] = me;
            // Define alias to the config data: `chart.data === chart.config.data`
            Object.defineProperty(me, 'data', {
                get: function() {
                    return me.config.data;
                },
                set: function(value) {
                    me.config.data = value;
                }
            });
            if (!context || !canvas) {
                // The given item is not a compatible context2d element, let's return before finalizing
                // the chart initialization but after setting basic chart / controller properties that
                // can help to figure out that the chart is not valid (e.g chart.canvas !== null);
                // https://github.com/chartjs/Chart.js/issues/2807
                console.error("Failed to create chart: can't acquire context from the given item");
                return;
            }
            me.initialize();
            me.update();
        },
        /**
	 * @private
	 */ initialize: function() {
            var me = this;
            // Before init plugin notification
            core_plugins.notify(me, 'beforeInit');
            helpers$1.retinaScale(me, me.options.devicePixelRatio);
            me.bindEvents();
            if (me.options.responsive) // Initial resize before chart draws (must be silent to preserve initial animations).
            me.resize(true);
            me.initToolTip();
            // After init plugin notification
            core_plugins.notify(me, 'afterInit');
            return me;
        },
        clear: function() {
            helpers$1.canvas.clear(this);
            return this;
        },
        stop: function() {
            // Stops any current animation loop occurring
            core_animations.cancelAnimation(this);
            return this;
        },
        resize: function(silent) {
            var me = this;
            var options = me.options;
            var canvas = me.canvas;
            var aspectRatio = options.maintainAspectRatio && me.aspectRatio || null;
            // the canvas render width and height will be casted to integers so make sure that
            // the canvas display style uses the same integer values to avoid blurring effect.
            // Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
            var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
            var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
            if (me.width === newWidth && me.height === newHeight) return;
            canvas.width = me.width = newWidth;
            canvas.height = me.height = newHeight;
            canvas.style.width = newWidth + 'px';
            canvas.style.height = newHeight + 'px';
            helpers$1.retinaScale(me, options.devicePixelRatio);
            if (!silent) {
                // Notify any plugins about the resize
                var newSize = {
                    width: newWidth,
                    height: newHeight
                };
                core_plugins.notify(me, 'resize', [
                    newSize
                ]);
                // Notify of resize
                if (options.onResize) options.onResize(me, newSize);
                me.stop();
                me.update({
                    duration: options.responsiveAnimationDuration
                });
            }
        },
        ensureScalesHaveIDs: function() {
            var options = this.options;
            var scalesOptions = options.scales || {};
            var scaleOptions = options.scale;
            helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
                if (!xAxisOptions.id) xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
            });
            helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
                if (!yAxisOptions.id) yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
            });
            if (scaleOptions) scaleOptions.id = scaleOptions.id || 'scale';
        },
        /**
	 * Builds a map of scale ID to scale object for future lookup.
	 */ buildOrUpdateScales: function() {
            var me = this;
            var options = me.options;
            var scales = me.scales || {};
            var items = [];
            var updated = Object.keys(scales).reduce(function(obj, id) {
                obj[id] = false;
                return obj;
            }, {});
            if (options.scales) items = items.concat((options.scales.xAxes || []).map(function(xAxisOptions) {
                return {
                    options: xAxisOptions,
                    dtype: 'category',
                    dposition: 'bottom'
                };
            }), (options.scales.yAxes || []).map(function(yAxisOptions) {
                return {
                    options: yAxisOptions,
                    dtype: 'linear',
                    dposition: 'left'
                };
            }));
            if (options.scale) items.push({
                options: options.scale,
                dtype: 'radialLinear',
                isDefault: true,
                dposition: 'chartArea'
            });
            helpers$1.each(items, function(item) {
                var scaleOptions = item.options;
                var id = scaleOptions.id;
                var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
                if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
                updated[id] = true;
                var scale = null;
                if (id in scales && scales[id].type === scaleType) {
                    scale = scales[id];
                    scale.options = scaleOptions;
                    scale.ctx = me.ctx;
                    scale.chart = me;
                } else {
                    var scaleClass = core_scaleService.getScaleConstructor(scaleType);
                    if (!scaleClass) return;
                    scale = new scaleClass({
                        id: id,
                        type: scaleType,
                        options: scaleOptions,
                        ctx: me.ctx,
                        chart: me
                    });
                    scales[scale.id] = scale;
                }
                scale.mergeTicksOptions();
                // TODO(SB): I think we should be able to remove this custom case (options.scale)
                // and consider it as a regular scale part of the "scales"" map only! This would
                // make the logic easier and remove some useless? custom code.
                if (item.isDefault) me.scale = scale;
            });
            // clear up discarded scales
            helpers$1.each(updated, function(hasUpdated, id) {
                if (!hasUpdated) delete scales[id];
            });
            me.scales = scales;
            core_scaleService.addScalesToLayout(this);
        },
        buildOrUpdateControllers: function() {
            var me = this;
            var newControllers = [];
            var datasets = me.data.datasets;
            var i, ilen;
            for(i = 0, ilen = datasets.length; i < ilen; i++){
                var dataset = datasets[i];
                var meta = me.getDatasetMeta(i);
                var type = dataset.type || me.config.type;
                if (meta.type && meta.type !== type) {
                    me.destroyDatasetMeta(i);
                    meta = me.getDatasetMeta(i);
                }
                meta.type = type;
                meta.order = dataset.order || 0;
                meta.index = i;
                if (meta.controller) {
                    meta.controller.updateIndex(i);
                    meta.controller.linkScales();
                } else {
                    var ControllerClass = controllers[meta.type];
                    if (ControllerClass === undefined) throw new Error('"' + meta.type + '" is not a chart type.');
                    meta.controller = new ControllerClass(me, i);
                    newControllers.push(meta.controller);
                }
            }
            return newControllers;
        },
        /**
	 * Reset the elements of all datasets
	 * @private
	 */ resetElements: function() {
            var me = this;
            helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
                me.getDatasetMeta(datasetIndex).controller.reset();
            }, me);
        },
        /**
	* Resets the chart back to it's state before the initial animation
	*/ reset: function() {
            this.resetElements();
            this.tooltip.initialize();
        },
        update: function(config) {
            var me = this;
            var i, ilen;
            if (!config || typeof config !== 'object') // backwards compatibility
            config = {
                duration: config,
                lazy: arguments[1]
            };
            updateConfig(me);
            // plugins options references might have change, let's invalidate the cache
            // https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
            core_plugins._invalidate(me);
            if (core_plugins.notify(me, 'beforeUpdate') === false) return;
            // In case the entire data object changed
            me.tooltip._data = me.data;
            // Make sure dataset controllers are updated and new controllers are reset
            var newControllers = me.buildOrUpdateControllers();
            // Make sure all dataset controllers have correct meta data counts
            for(i = 0, ilen = me.data.datasets.length; i < ilen; i++)me.getDatasetMeta(i).controller.buildOrUpdateElements();
            me.updateLayout();
            // Can only reset the new controllers after the scales have been updated
            if (me.options.animation && me.options.animation.duration) helpers$1.each(newControllers, function(controller) {
                controller.reset();
            });
            me.updateDatasets();
            // Need to reset tooltip in case it is displayed with elements that are removed
            // after update.
            me.tooltip.initialize();
            // Last active contains items that were previously in the tooltip.
            // When we reset the tooltip, we need to clear it
            me.lastActive = [];
            // Do this before render so that any plugins that need final scale updates can use it
            core_plugins.notify(me, 'afterUpdate');
            me._layers.sort(compare2Level('z', '_idx'));
            if (me._bufferedRender) me._bufferedRequest = {
                duration: config.duration,
                easing: config.easing,
                lazy: config.lazy
            };
            else me.render(config);
        },
        /**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */ updateLayout: function() {
            var me = this;
            if (core_plugins.notify(me, 'beforeLayout') === false) return;
            core_layouts.update(this, this.width, this.height);
            me._layers = [];
            helpers$1.each(me.boxes, function(box) {
                // _configure is called twice, once in core.scale.update and once here.
                // Here the boxes are fully updated and at their final positions.
                if (box._configure) box._configure();
                me._layers.push.apply(me._layers, box._layers());
            }, me);
            me._layers.forEach(function(item, index) {
                item._idx = index;
            });
            /**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */ core_plugins.notify(me, 'afterScaleUpdate');
            core_plugins.notify(me, 'afterLayout');
        },
        /**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */ updateDatasets: function() {
            var me = this;
            if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) return;
            for(var i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me.updateDataset(i);
            core_plugins.notify(me, 'afterDatasetsUpdate');
        },
        /**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */ updateDataset: function(index) {
            var me = this;
            var meta = me.getDatasetMeta(index);
            var args = {
                meta: meta,
                index: index
            };
            if (core_plugins.notify(me, 'beforeDatasetUpdate', [
                args
            ]) === false) return;
            meta.controller._update();
            core_plugins.notify(me, 'afterDatasetUpdate', [
                args
            ]);
        },
        render: function(config) {
            var me = this;
            if (!config || typeof config !== 'object') // backwards compatibility
            config = {
                duration: config,
                lazy: arguments[1]
            };
            var animationOptions = me.options.animation;
            var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
            var lazy = config.lazy;
            if (core_plugins.notify(me, 'beforeRender') === false) return;
            var onComplete = function(animation) {
                core_plugins.notify(me, 'afterRender');
                helpers$1.callback(animationOptions && animationOptions.onComplete, [
                    animation
                ], me);
            };
            if (animationOptions && duration) {
                var animation = new core_animation({
                    numSteps: duration / 16.66,
                    easing: config.easing || animationOptions.easing,
                    render: function(chart, animationObject) {
                        var easingFunction = helpers$1.easing.effects[animationObject.easing];
                        var currentStep = animationObject.currentStep;
                        var stepDecimal = currentStep / animationObject.numSteps;
                        chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
                    },
                    onAnimationProgress: animationOptions.onProgress,
                    onAnimationComplete: onComplete
                });
                core_animations.addAnimation(me, animation, duration, lazy);
            } else {
                me.draw();
                // See https://github.com/chartjs/Chart.js/issues/3781
                onComplete(new core_animation({
                    numSteps: 0,
                    chart: me
                }));
            }
            return me;
        },
        draw: function(easingValue) {
            var me = this;
            var i, layers;
            me.clear();
            if (helpers$1.isNullOrUndef(easingValue)) easingValue = 1;
            me.transition(easingValue);
            if (me.width <= 0 || me.height <= 0) return;
            if (core_plugins.notify(me, 'beforeDraw', [
                easingValue
            ]) === false) return;
            // Because of plugin hooks (before/afterDatasetsDraw), datasets can't
            // currently be part of layers. Instead, we draw
            // layers <= 0 before(default, backward compat), and the rest after
            layers = me._layers;
            for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(me.chartArea);
            me.drawDatasets(easingValue);
            // Rest of layers
            for(; i < layers.length; ++i)layers[i].draw(me.chartArea);
            me._drawTooltip(easingValue);
            core_plugins.notify(me, 'afterDraw', [
                easingValue
            ]);
        },
        /**
	 * @private
	 */ transition: function(easingValue) {
            var me = this;
            for(var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i)if (me.isDatasetVisible(i)) me.getDatasetMeta(i).controller.transition(easingValue);
            me.tooltip.transition(easingValue);
        },
        /**
	 * @private
	 */ _getSortedDatasetMetas: function(filterVisible) {
            var me = this;
            var datasets = me.data.datasets || [];
            var result = [];
            var i, ilen;
            for(i = 0, ilen = datasets.length; i < ilen; ++i)if (!filterVisible || me.isDatasetVisible(i)) result.push(me.getDatasetMeta(i));
            result.sort(compare2Level('order', 'index'));
            return result;
        },
        /**
	 * @private
	 */ _getSortedVisibleDatasetMetas: function() {
            return this._getSortedDatasetMetas(true);
        },
        /**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */ drawDatasets: function(easingValue) {
            var me = this;
            var metasets, i;
            if (core_plugins.notify(me, 'beforeDatasetsDraw', [
                easingValue
            ]) === false) return;
            metasets = me._getSortedVisibleDatasetMetas();
            for(i = metasets.length - 1; i >= 0; --i)me.drawDataset(metasets[i], easingValue);
            core_plugins.notify(me, 'afterDatasetsDraw', [
                easingValue
            ]);
        },
        /**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */ drawDataset: function(meta, easingValue) {
            var me = this;
            var args = {
                meta: meta,
                index: meta.index,
                easingValue: easingValue
            };
            if (core_plugins.notify(me, 'beforeDatasetDraw', [
                args
            ]) === false) return;
            meta.controller.draw(easingValue);
            core_plugins.notify(me, 'afterDatasetDraw', [
                args
            ]);
        },
        /**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */ _drawTooltip: function(easingValue) {
            var me = this;
            var tooltip = me.tooltip;
            var args = {
                tooltip: tooltip,
                easingValue: easingValue
            };
            if (core_plugins.notify(me, 'beforeTooltipDraw', [
                args
            ]) === false) return;
            tooltip.draw();
            core_plugins.notify(me, 'afterTooltipDraw', [
                args
            ]);
        },
        /**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */ getElementAtEvent: function(e) {
            return core_interaction.modes.single(this, e);
        },
        getElementsAtEvent: function(e) {
            return core_interaction.modes.label(this, e, {
                intersect: true
            });
        },
        getElementsAtXAxis: function(e) {
            return core_interaction.modes['x-axis'](this, e, {
                intersect: true
            });
        },
        getElementsAtEventForMode: function(e, mode, options) {
            var method = core_interaction.modes[mode];
            if (typeof method === 'function') return method(this, e, options);
            return [];
        },
        getDatasetAtEvent: function(e) {
            return core_interaction.modes.dataset(this, e, {
                intersect: true
            });
        },
        getDatasetMeta: function(datasetIndex) {
            var me = this;
            var dataset = me.data.datasets[datasetIndex];
            if (!dataset._meta) dataset._meta = {};
            var meta = dataset._meta[me.id];
            if (!meta) meta = dataset._meta[me.id] = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset.order || 0,
                index: datasetIndex
            };
            return meta;
        },
        getVisibleDatasetCount: function() {
            var count = 0;
            for(var i = 0, ilen = this.data.datasets.length; i < ilen; ++i)if (this.isDatasetVisible(i)) count++;
            return count;
        },
        isDatasetVisible: function(datasetIndex) {
            var meta = this.getDatasetMeta(datasetIndex);
            // meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
            // the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
            return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
        },
        generateLegend: function() {
            return this.options.legendCallback(this);
        },
        /**
	 * @private
	 */ destroyDatasetMeta: function(datasetIndex) {
            var id = this.id;
            var dataset = this.data.datasets[datasetIndex];
            var meta = dataset._meta && dataset._meta[id];
            if (meta) {
                meta.controller.destroy();
                delete dataset._meta[id];
            }
        },
        destroy: function() {
            var me = this;
            var canvas = me.canvas;
            var i, ilen;
            me.stop();
            // dataset controllers need to cleanup associated data
            for(i = 0, ilen = me.data.datasets.length; i < ilen; ++i)me.destroyDatasetMeta(i);
            if (canvas) {
                me.unbindEvents();
                helpers$1.canvas.clear(me);
                platform.releaseContext(me.ctx);
                me.canvas = null;
                me.ctx = null;
            }
            core_plugins.notify(me, 'destroy');
            delete Chart.instances[me.id];
        },
        toBase64Image: function() {
            return this.canvas.toDataURL.apply(this.canvas, arguments);
        },
        initToolTip: function() {
            var me = this;
            me.tooltip = new core_tooltip({
                _chart: me,
                _chartInstance: me,
                _data: me.data,
                _options: me.options.tooltips
            }, me);
        },
        /**
	 * @private
	 */ bindEvents: function() {
            var me = this;
            var listeners = me._listeners = {};
            var listener = function() {
                me.eventHandler.apply(me, arguments);
            };
            helpers$1.each(me.options.events, function(type) {
                platform.addEventListener(me, type, listener);
                listeners[type] = listener;
            });
            // Elements used to detect size change should not be injected for non responsive charts.
            // See https://github.com/chartjs/Chart.js/issues/2210
            if (me.options.responsive) {
                listener = function() {
                    me.resize();
                };
                platform.addEventListener(me, 'resize', listener);
                listeners.resize = listener;
            }
        },
        /**
	 * @private
	 */ unbindEvents: function() {
            var me = this;
            var listeners = me._listeners;
            if (!listeners) return;
            delete me._listeners;
            helpers$1.each(listeners, function(listener, type) {
                platform.removeEventListener(me, type, listener);
            });
        },
        updateHoverStyle: function(elements, mode, enabled) {
            var prefix = enabled ? 'set' : 'remove';
            var element, i, ilen;
            for(i = 0, ilen = elements.length; i < ilen; ++i){
                element = elements[i];
                if (element) this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
            }
            if (mode === 'dataset') this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
        },
        /**
	 * @private
	 */ eventHandler: function(e) {
            var me = this;
            var tooltip = me.tooltip;
            if (core_plugins.notify(me, 'beforeEvent', [
                e
            ]) === false) return;
            // Buffer any update calls so that renders do not occur
            me._bufferedRender = true;
            me._bufferedRequest = null;
            var changed = me.handleEvent(e);
            // for smooth tooltip animations issue #4989
            // the tooltip should be the source of change
            // Animation check workaround:
            // tooltip._start will be null when tooltip isn't animating
            if (tooltip) changed = tooltip._start ? tooltip.handleEvent(e) : changed | tooltip.handleEvent(e);
            core_plugins.notify(me, 'afterEvent', [
                e
            ]);
            var bufferedRequest = me._bufferedRequest;
            if (bufferedRequest) // If we have an update that was triggered, we need to do a normal render
            me.render(bufferedRequest);
            else if (changed && !me.animating) {
                // If entering, leaving, or changing elements, animate the change via pivot
                me.stop();
                // We only need to render at this point. Updating will cause scales to be
                // recomputed generating flicker & using more memory than necessary.
                me.render({
                    duration: me.options.hover.animationDuration,
                    lazy: true
                });
            }
            me._bufferedRender = false;
            me._bufferedRequest = null;
            return me;
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */ handleEvent: function(e) {
            var me = this;
            var options = me.options || {};
            var hoverOptions = options.hover;
            var changed = false;
            me.lastActive = me.lastActive || [];
            // Find Active Elements for hover and tooltips
            if (e.type === 'mouseout') me.active = [];
            else me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
            // Invoke onHover hook
            // Need to call with native event here to not break backwards compatibility
            helpers$1.callback(options.onHover || options.hover.onHover, [
                e.native,
                me.active
            ], me);
            if (e.type === 'mouseup' || e.type === 'click') {
                if (options.onClick) // Use e.native here for backwards compatibility
                options.onClick.call(me, e.native, me.active);
            }
            // Remove styling for last active (even if it may still be active)
            if (me.lastActive.length) me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
            // Built in hover styling
            if (me.active.length && hoverOptions.mode) me.updateHoverStyle(me.active, hoverOptions.mode, true);
            changed = !helpers$1.arrayEquals(me.active, me.lastActive);
            // Remember Last Actives
            me.lastActive = me.active;
            return changed;
        }
    });
    /**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */ Chart.instances = {};
    var core_controller = Chart;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */ Chart.Controller = Chart;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */ Chart.types = {};
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ helpers$1.configMerge = mergeConfig;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ helpers$1.scaleMerge = mergeScaleConfig;
    var core_helpers = function() {
        // -- Basic js utility methods
        helpers$1.where = function(collection, filterCallback) {
            if (helpers$1.isArray(collection) && Array.prototype.filter) return collection.filter(filterCallback);
            var filtered = [];
            helpers$1.each(collection, function(item) {
                if (filterCallback(item)) filtered.push(item);
            });
            return filtered;
        };
        helpers$1.findIndex = Array.prototype.findIndex ? function(array, callback, scope) {
            return array.findIndex(callback, scope);
        } : function(array, callback, scope) {
            scope = scope === undefined ? array : scope;
            for(var i = 0, ilen = array.length; i < ilen; ++i){
                if (callback.call(scope, array[i], i, array)) return i;
            }
            return -1;
        };
        helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
            // Default to start of the array
            if (helpers$1.isNullOrUndef(startIndex)) startIndex = -1;
            for(var i = startIndex + 1; i < arrayToSearch.length; i++){
                var currentItem = arrayToSearch[i];
                if (filterCallback(currentItem)) return currentItem;
            }
        };
        helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
            // Default to end of the array
            if (helpers$1.isNullOrUndef(startIndex)) startIndex = arrayToSearch.length;
            for(var i = startIndex - 1; i >= 0; i--){
                var currentItem = arrayToSearch[i];
                if (filterCallback(currentItem)) return currentItem;
            }
        };
        // -- Math methods
        helpers$1.isNumber = function(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        };
        helpers$1.almostEquals = function(x, y, epsilon) {
            return Math.abs(x - y) < epsilon;
        };
        helpers$1.almostWhole = function(x, epsilon) {
            var rounded = Math.round(x);
            return rounded - epsilon <= x && rounded + epsilon >= x;
        };
        helpers$1.max = function(array) {
            return array.reduce(function(max, value) {
                if (!isNaN(value)) return Math.max(max, value);
                return max;
            }, Number.NEGATIVE_INFINITY);
        };
        helpers$1.min = function(array) {
            return array.reduce(function(min, value) {
                if (!isNaN(value)) return Math.min(min, value);
                return min;
            }, Number.POSITIVE_INFINITY);
        };
        helpers$1.sign = Math.sign ? function(x) {
            return Math.sign(x);
        } : function(x) {
            x = +x; // convert to a number
            if (x === 0 || isNaN(x)) return x;
            return x > 0 ? 1 : -1;
        };
        helpers$1.toRadians = function(degrees) {
            return degrees * (Math.PI / 180);
        };
        helpers$1.toDegrees = function(radians) {
            return radians * (180 / Math.PI);
        };
        /**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */ helpers$1._decimalPlaces = function(x) {
            if (!helpers$1.isFinite(x)) return;
            var e = 1;
            var p = 0;
            while(Math.round(x * e) / e !== x){
                e *= 10;
                p++;
            }
            return p;
        };
        // Gets the angle from vertical upright to the point about a centre.
        helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
            var distanceFromXCenter = anglePoint.x - centrePoint.x;
            var distanceFromYCenter = anglePoint.y - centrePoint.y;
            var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
            var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
            if (angle < -0.5 * Math.PI) angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
            return {
                angle: angle,
                distance: radialDistanceFromCenter
            };
        };
        helpers$1.distanceBetweenPoints = function(pt1, pt2) {
            return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
        };
        /**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */ helpers$1.aliasPixel = function(pixelWidth) {
            return pixelWidth % 2 === 0 ? 0 : 0.5;
        };
        /**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */ helpers$1._alignPixel = function(chart, pixel, width) {
            var devicePixelRatio = chart.currentDevicePixelRatio;
            var halfWidth = width / 2;
            return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
        };
        helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
            // Props to Rob Spencer at scaled innovation for his post on splining between points
            // http://scaledinnovation.com/analytics/splines/aboutSplines.html
            // This function must also respect "skipped" points
            var previous = firstPoint.skip ? middlePoint : firstPoint;
            var current = middlePoint;
            var next = afterPoint.skip ? middlePoint : afterPoint;
            var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
            var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
            var s01 = d01 / (d01 + d12);
            var s12 = d12 / (d01 + d12);
            // If all points are the same, s01 & s02 will be inf
            s01 = isNaN(s01) ? 0 : s01;
            s12 = isNaN(s12) ? 0 : s12;
            var fa = t * s01; // scaling factor for triangle Ta
            var fb = t * s12;
            return {
                previous: {
                    x: current.x - fa * (next.x - previous.x),
                    y: current.y - fa * (next.y - previous.y)
                },
                next: {
                    x: current.x + fb * (next.x - previous.x),
                    y: current.y + fb * (next.y - previous.y)
                }
            };
        };
        helpers$1.EPSILON = Number.EPSILON || 1e-14;
        helpers$1.splineCurveMonotone = function(points) {
            // This function calculates Bézier control points in a similar way than |splineCurve|,
            // but preserves monotonicity of the provided data and ensures no local extremums are added
            // between the dataset discrete points due to the interpolation.
            // See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
            var pointsWithTangents = (points || []).map(function(point) {
                return {
                    model: point._model,
                    deltaK: 0,
                    mK: 0
                };
            });
            // Calculate slopes (deltaK) and initialize tangents (mK)
            var pointsLen = pointsWithTangents.length;
            var i, pointBefore, pointCurrent, pointAfter;
            for(i = 0; i < pointsLen; ++i){
                pointCurrent = pointsWithTangents[i];
                if (pointCurrent.model.skip) continue;
                pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
                pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
                if (pointAfter && !pointAfter.model.skip) {
                    var slopeDeltaX = pointAfter.model.x - pointCurrent.model.x;
                    // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
                    pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
                }
                if (!pointBefore || pointBefore.model.skip) pointCurrent.mK = pointCurrent.deltaK;
                else if (!pointAfter || pointAfter.model.skip) pointCurrent.mK = pointBefore.deltaK;
                else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) pointCurrent.mK = 0;
                else pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
            }
            // Adjust tangents to ensure monotonic properties
            var alphaK, betaK, tauK, squaredMagnitude;
            for(i = 0; i < pointsLen - 1; ++i){
                pointCurrent = pointsWithTangents[i];
                pointAfter = pointsWithTangents[i + 1];
                if (pointCurrent.model.skip || pointAfter.model.skip) continue;
                if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
                    pointCurrent.mK = pointAfter.mK = 0;
                    continue;
                }
                alphaK = pointCurrent.mK / pointCurrent.deltaK;
                betaK = pointAfter.mK / pointCurrent.deltaK;
                squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
                if (squaredMagnitude <= 9) continue;
                tauK = 3 / Math.sqrt(squaredMagnitude);
                pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
                pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
            }
            // Compute control points
            var deltaX;
            for(i = 0; i < pointsLen; ++i){
                pointCurrent = pointsWithTangents[i];
                if (pointCurrent.model.skip) continue;
                pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
                pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
                if (pointBefore && !pointBefore.model.skip) {
                    deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
                    pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
                    pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
                }
                if (pointAfter && !pointAfter.model.skip) {
                    deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
                    pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
                    pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
                }
            }
        };
        helpers$1.nextItem = function(collection, index, loop) {
            if (loop) return index >= collection.length - 1 ? collection[0] : collection[index + 1];
            return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
        };
        helpers$1.previousItem = function(collection, index, loop) {
            if (loop) return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
            return index <= 0 ? collection[0] : collection[index - 1];
        };
        // Implementation of the nice number algorithm used in determining where axis labels will go
        helpers$1.niceNum = function(range, round) {
            var exponent = Math.floor(helpers$1.log10(range));
            var fraction = range / Math.pow(10, exponent);
            var niceFraction;
            if (round) {
                if (fraction < 1.5) niceFraction = 1;
                else if (fraction < 3) niceFraction = 2;
                else if (fraction < 7) niceFraction = 5;
                else niceFraction = 10;
            } else if (fraction <= 1.0) niceFraction = 1;
            else if (fraction <= 2) niceFraction = 2;
            else if (fraction <= 5) niceFraction = 5;
            else niceFraction = 10;
            return niceFraction * Math.pow(10, exponent);
        };
        // Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
        helpers$1.requestAnimFrame = function() {
            if (typeof window === 'undefined') return function(callback) {
                callback();
            };
            return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(callback) {
                return window.setTimeout(callback, 1000 / 60);
            };
        }();
        // -- DOM methods
        helpers$1.getRelativePosition = function(evt, chart) {
            var mouseX, mouseY;
            var e = evt.originalEvent || evt;
            var canvas = evt.target || evt.srcElement;
            var boundingRect = canvas.getBoundingClientRect();
            var touches = e.touches;
            if (touches && touches.length > 0) {
                mouseX = touches[0].clientX;
                mouseY = touches[0].clientY;
            } else {
                mouseX = e.clientX;
                mouseY = e.clientY;
            }
            // Scale mouse coordinates into canvas coordinates
            // by following the pattern laid out by 'jerryj' in the comments of
            // https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
            var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
            var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
            var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
            var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
            var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
            var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
            // We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
            // the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
            mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / width * canvas.width / chart.currentDevicePixelRatio);
            mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / height * canvas.height / chart.currentDevicePixelRatio);
            return {
                x: mouseX,
                y: mouseY
            };
        };
        // Private helper function to convert max-width/max-height values that may be percentages into a number
        function parseMaxStyle(styleValue, node, parentProperty) {
            var valueInPixels;
            if (typeof styleValue === 'string') {
                valueInPixels = parseInt(styleValue, 10);
                if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
                valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
            } else valueInPixels = styleValue;
            return valueInPixels;
        }
        /**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */ function isConstrainedValue(value) {
            return value !== undefined && value !== null && value !== 'none';
        }
        /**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */ function getConstraintDimension(domNode, maxStyle, percentageProperty) {
            var view = document.defaultView;
            var parentNode = helpers$1._getParentNode(domNode);
            var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
            var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
            var hasCNode = isConstrainedValue(constrainedNode);
            var hasCContainer = isConstrainedValue(constrainedContainer);
            var infinity = Number.POSITIVE_INFINITY;
            if (hasCNode || hasCContainer) return Math.min(hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity, hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
            return 'none';
        }
        // returns Number or undefined if no constraint
        helpers$1.getConstraintWidth = function(domNode) {
            return getConstraintDimension(domNode, 'max-width', 'clientWidth');
        };
        // returns Number or undefined if no constraint
        helpers$1.getConstraintHeight = function(domNode) {
            return getConstraintDimension(domNode, 'max-height', 'clientHeight');
        };
        /**
	 * @private
 	 */ helpers$1._calculatePadding = function(container, padding, parentDimension) {
            padding = helpers$1.getStyle(container, padding);
            return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
        };
        /**
	 * @private
	 */ helpers$1._getParentNode = function(domNode) {
            var parent = domNode.parentNode;
            if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
            return parent;
        };
        helpers$1.getMaximumWidth = function(domNode) {
            var container = helpers$1._getParentNode(domNode);
            if (!container) return domNode.clientWidth;
            var clientWidth = container.clientWidth;
            var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
            var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);
            var w = clientWidth - paddingLeft - paddingRight;
            var cw = helpers$1.getConstraintWidth(domNode);
            return isNaN(cw) ? w : Math.min(w, cw);
        };
        helpers$1.getMaximumHeight = function(domNode) {
            var container = helpers$1._getParentNode(domNode);
            if (!container) return domNode.clientHeight;
            var clientHeight = container.clientHeight;
            var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
            var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);
            var h = clientHeight - paddingTop - paddingBottom;
            var ch = helpers$1.getConstraintHeight(domNode);
            return isNaN(ch) ? h : Math.min(h, ch);
        };
        helpers$1.getStyle = function(el, property) {
            return el.currentStyle ? el.currentStyle[property] : document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
        };
        helpers$1.retinaScale = function(chart, forceRatio) {
            var pixelRatio = chart.currentDevicePixelRatio = forceRatio || typeof window !== 'undefined' && window.devicePixelRatio || 1;
            if (pixelRatio === 1) return;
            var canvas = chart.canvas;
            var height = chart.height;
            var width = chart.width;
            canvas.height = height * pixelRatio;
            canvas.width = width * pixelRatio;
            chart.ctx.scale(pixelRatio, pixelRatio);
            // If no style has been set on the canvas, the render size is used as display size,
            // making the chart visually bigger, so let's enforce it to the "correct" values.
            // See https://github.com/chartjs/Chart.js/issues/3575
            if (!canvas.style.height && !canvas.style.width) {
                canvas.style.height = height + 'px';
                canvas.style.width = width + 'px';
            }
        };
        // -- Canvas methods
        helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
            return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
        };
        helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
            cache = cache || {};
            var data = cache.data = cache.data || {};
            var gc = cache.garbageCollect = cache.garbageCollect || [];
            if (cache.font !== font) {
                data = cache.data = {};
                gc = cache.garbageCollect = [];
                cache.font = font;
            }
            ctx.font = font;
            var longest = 0;
            var ilen = arrayOfThings.length;
            var i, j, jlen, thing, nestedThing;
            for(i = 0; i < ilen; i++){
                thing = arrayOfThings[i];
                // Undefined strings and arrays should not be measured
                if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) longest = helpers$1.measureText(ctx, data, gc, longest, thing);
                else if (helpers$1.isArray(thing)) // if it is an array lets measure each element
                // to do maybe simplify this function a bit so we can do this more recursively?
                for(j = 0, jlen = thing.length; j < jlen; j++){
                    nestedThing = thing[j];
                    // Undefined strings and arrays should not be measured
                    if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
                }
            }
            var gcLen = gc.length / 2;
            if (gcLen > arrayOfThings.length) {
                for(i = 0; i < gcLen; i++)delete data[gc[i]];
                gc.splice(0, gcLen);
            }
            return longest;
        };
        helpers$1.measureText = function(ctx, data, gc, longest, string) {
            var textWidth = data[string];
            if (!textWidth) {
                textWidth = data[string] = ctx.measureText(string).width;
                gc.push(string);
            }
            if (textWidth > longest) longest = textWidth;
            return longest;
        };
        /**
	 * @deprecated
	 */ helpers$1.numberOfLabelLines = function(arrayOfThings) {
            var numberOfLines = 1;
            helpers$1.each(arrayOfThings, function(thing) {
                if (helpers$1.isArray(thing)) {
                    if (thing.length > numberOfLines) numberOfLines = thing.length;
                }
            });
            return numberOfLines;
        };
        helpers$1.color = !chartjsColor ? function(value) {
            console.error('Color.js not found!');
            return value;
        } : function(value) {
            /* global CanvasGradient */ if (value instanceof CanvasGradient) value = core_defaults.global.defaultColor;
            return chartjsColor(value);
        };
        helpers$1.getHoverColor = function(colorValue) {
            /* global CanvasPattern */ return colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient ? colorValue : helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
        };
    };
    function abstract() {
        throw new Error("This method is not implemented: either no adapter can be found or an incomplete integration was provided.");
    }
    /**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ /**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */ /**
 * @class
 */ function DateAdapter(options) {
        this.options = options || {};
    }
    helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
        /**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */ formats: abstract,
        /**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */ parse: abstract,
        /**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */ format: abstract,
        /**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */ add: abstract,
        /**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */ diff: abstract,
        /**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */ startOf: abstract,
        /**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */ endOf: abstract,
        // DEPRECATIONS
        /**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */ _create: function(value) {
            return value;
        }
    });
    DateAdapter.override = function(members) {
        helpers$1.extend(DateAdapter.prototype, members);
    };
    var _date = DateAdapter;
    var core_adapters = {
        _date: _date
    };
    /**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */ var core_ticks = {
        /**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */ formatters: {
            /**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */ values: function(value) {
                return helpers$1.isArray(value) ? value : '' + value;
            },
            /**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */ linear: function(tickValue, index, ticks) {
                // If we have lots of ticks, don't use the ones
                var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
                // If we have a number like 2.5 as the delta, figure out how many decimal places we need
                if (Math.abs(delta) > 1) {
                    if (tickValue !== Math.floor(tickValue)) // not an integer
                    delta = tickValue - Math.floor(tickValue);
                }
                var logDelta = helpers$1.log10(Math.abs(delta));
                var tickString = '';
                if (tickValue !== 0) {
                    var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
                    if (maxTick < 1e-4) {
                        var logTick = helpers$1.log10(Math.abs(tickValue));
                        var numExponential = Math.floor(logTick) - Math.floor(logDelta);
                        numExponential = Math.max(Math.min(numExponential, 20), 0);
                        tickString = tickValue.toExponential(numExponential);
                    } else {
                        var numDecimal = -1 * Math.floor(logDelta);
                        numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
                        tickString = tickValue.toFixed(numDecimal);
                    }
                } else tickString = '0'; // never show decimal places for 0
                return tickString;
            },
            logarithmic: function(tickValue, index, ticks) {
                var remain = tickValue / Math.pow(10, Math.floor(helpers$1.log10(tickValue)));
                if (tickValue === 0) return '0';
                else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) return tickValue.toExponential();
                return '';
            }
        }
    };
    var isArray = helpers$1.isArray;
    var isNullOrUndef = helpers$1.isNullOrUndef;
    var valueOrDefault$a = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
    core_defaults._set('scale', {
        display: true,
        position: 'left',
        offset: false,
        // grid line settings
        gridLines: {
            display: true,
            color: 'rgba(0,0,0,0.1)',
            lineWidth: 1,
            drawBorder: true,
            drawOnChartArea: true,
            drawTicks: true,
            tickMarkLength: 10,
            zeroLineWidth: 1,
            zeroLineColor: 'rgba(0,0,0,0.25)',
            zeroLineBorderDash: [],
            zeroLineBorderDashOffset: 0.0,
            offsetGridLines: false,
            borderDash: [],
            borderDashOffset: 0.0
        },
        // scale label
        scaleLabel: {
            // display property
            display: false,
            // actual label
            labelString: '',
            // top/bottom padding
            padding: {
                top: 4,
                bottom: 4
            }
        },
        // label settings
        ticks: {
            beginAtZero: false,
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            padding: 0,
            reverse: false,
            display: true,
            autoSkip: true,
            autoSkipPadding: 0,
            labelOffset: 0,
            // We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
            callback: core_ticks.formatters.values,
            minor: {},
            major: {}
        }
    });
    /** Returns a new array containing numItems from arr */ function sample(arr, numItems) {
        var result = [];
        var increment = arr.length / numItems;
        var i = 0;
        var len = arr.length;
        for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
        return result;
    }
    function getPixelForGridLine(scale, index, offsetGridLines) {
        var length = scale.getTicks().length;
        var validIndex = Math.min(index, length - 1);
        var lineValue = scale.getPixelForTick(validIndex);
        var start = scale._startPixel;
        var end = scale._endPixel;
        var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
        var offset;
        if (offsetGridLines) {
            if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
            else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
            else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
            lineValue += validIndex < index ? offset : -offset;
            // Return undefined if the pixel is out of the range
            if (lineValue < start - epsilon || lineValue > end + epsilon) return;
        }
        return lineValue;
    }
    function garbageCollect(caches, length) {
        helpers$1.each(caches, function(cache) {
            var gc = cache.gc;
            var gcLen = gc.length / 2;
            var i;
            if (gcLen > length) {
                for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
                gc.splice(0, gcLen);
            }
        });
    }
    /**
 * Returns {width, height, offset} objects for the first, last, widest, highest tick
 * labels where offset indicates the anchor point offset from the top in pixels.
 */ function computeLabelSizes(ctx, tickFonts, ticks, caches) {
        var length = ticks.length;
        var widths = [];
        var heights = [];
        var offsets = [];
        var widestLabelSize = 0;
        var highestLabelSize = 0;
        var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
        for(i = 0; i < length; ++i){
            label = ticks[i].label;
            tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            // Undefined labels and arrays should not be measured
            if (!isNullOrUndef(label) && !isArray(label)) {
                width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if (isArray(label)) // if it is an array let's measure each element
            for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                // Undefined labels and arrays should not be measured
                if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
                    width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            offsets.push(lineHeight / 2);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        garbageCollect(caches, length);
        widest = widths.indexOf(widestLabelSize);
        highest = heights.indexOf(highestLabelSize);
        function valueAt(idx) {
            return {
                width: widths[idx] || 0,
                height: heights[idx] || 0,
                offset: offsets[idx] || 0
            };
        }
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest)
        };
    }
    function getTickMarkLength(options) {
        return options.drawTicks ? options.tickMarkLength : 0;
    }
    function getScaleLabelHeight(options) {
        var font, padding;
        if (!options.display) return 0;
        font = helpers$1.options._parseFont(options);
        padding = helpers$1.options.toPadding(options.padding);
        return font.lineHeight + padding.height;
    }
    function parseFontOptions(options, nestedOpts) {
        return helpers$1.extend(helpers$1.options._parseFont({
            fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
            fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
            fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
            lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
        }), {
            color: helpers$1.options.resolve([
                nestedOpts.fontColor,
                options.fontColor,
                core_defaults.global.defaultFontColor
            ])
        });
    }
    function parseTickFontOptions(options) {
        var minor = parseFontOptions(options, options.minor);
        var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
        return {
            minor: minor,
            major: major
        };
    }
    function nonSkipped(ticksToFilter) {
        var filtered = [];
        var item, index, len;
        for(index = 0, len = ticksToFilter.length; index < len; ++index){
            item = ticksToFilter[index];
            if (typeof item._index !== 'undefined') filtered.push(item);
        }
        return filtered;
    }
    function getEvenSpacing(arr) {
        var len = arr.length;
        var i, diff;
        if (len < 2) return false;
        for(diff = arr[0], i = 1; i < len; ++i){
            if (arr[i] - arr[i - 1] !== diff) return false;
        }
        return diff;
    }
    function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
        var evenMajorSpacing = getEvenSpacing(majorIndices);
        var spacing = (ticks.length - 1) / ticksLimit;
        var factors, factor, i, ilen;
        // If the major ticks are evenly spaced apart, place the minor ticks
        // so that they divide the major ticks into even chunks
        if (!evenMajorSpacing) return Math.max(spacing, 1);
        factors = helpers$1.math._factorize(evenMajorSpacing);
        for(i = 0, ilen = factors.length - 1; i < ilen; i++){
            factor = factors[i];
            if (factor > spacing) return factor;
        }
        return Math.max(spacing, 1);
    }
    function getMajorIndices(ticks) {
        var result = [];
        var i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
        return result;
    }
    function skipMajors(ticks, majorIndices, spacing) {
        var count = 0;
        var next = majorIndices[0];
        var i, tick;
        spacing = Math.ceil(spacing);
        for(i = 0; i < ticks.length; i++){
            tick = ticks[i];
            if (i === next) {
                tick._index = i;
                count++;
                next = majorIndices[count * spacing];
            } else delete tick.label;
        }
    }
    function skip(ticks, spacing, majorStart, majorEnd) {
        var start = valueOrDefault$a(majorStart, 0);
        var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
        var count = 0;
        var length, i, tick, next;
        spacing = Math.ceil(spacing);
        if (majorEnd) {
            length = majorEnd - majorStart;
            spacing = length / Math.floor(length / spacing);
        }
        next = start;
        while(next < 0){
            count++;
            next = Math.round(start + count * spacing);
        }
        for(i = Math.max(start, 0); i < end; i++){
            tick = ticks[i];
            if (i === next) {
                tick._index = i;
                count++;
                next = Math.round(start + count * spacing);
            } else delete tick.label;
        }
    }
    var Scale = core_element.extend({
        zeroLineIndex: 0,
        /**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */ getPadding: function() {
            var me = this;
            return {
                left: me.paddingLeft || 0,
                top: me.paddingTop || 0,
                right: me.paddingRight || 0,
                bottom: me.paddingBottom || 0
            };
        },
        /**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */ getTicks: function() {
            return this._ticks;
        },
        /**
	* @private
	*/ _getLabels: function() {
            var data = this.chart.data;
            return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
        },
        // These methods are ordered by lifecyle. Utilities then follow.
        // Any function defined here is inherited by all scale types.
        // Any function can be extended by the scale type
        /**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.Scale.mergeTicksOptions
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */ mergeTicksOptions: function() {
        // noop
        },
        beforeUpdate: function() {
            helpers$1.callback(this.options.beforeUpdate, [
                this
            ]);
        },
        /**
	 * @param {number} maxWidth - the max width in pixels
	 * @param {number} maxHeight - the max height in pixels
	 * @param {object} margins - the space between the edge of the other scales and edge of the chart
	 *   This space comes from two sources:
	 *     - padding - space that's required to show the labels at the edges of the scale
	 *     - thickness of scales or legends in another orientation
	 */ update: function(maxWidth, maxHeight, margins) {
            var me = this;
            var tickOpts = me.options.ticks;
            var sampleSize = tickOpts.sampleSize;
            var i, ilen, labels, ticks, samplingEnabled;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = helpers$1.extend({
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }, margins);
            me._ticks = null;
            me.ticks = null;
            me._labelSizes = null;
            me._maxLabelLines = 0;
            me.longestLabelWidth = 0;
            me.longestTextCache = me.longestTextCache || {};
            me._gridLineItems = null;
            me._labelItems = null;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Data min/max
            me.beforeDataLimits();
            me.determineDataLimits();
            me.afterDataLimits();
            // Ticks - `this.ticks` is now DEPRECATED!
            // Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
            // and must not be accessed directly from outside this class. `this.ticks` being
            // around for long time and not marked as private, we can't change its structure
            // without unexpected breaking changes. If you need to access the scale ticks,
            // use scale.getTicks() instead.
            me.beforeBuildTicks();
            // New implementations should return an array of objects but for BACKWARD COMPAT,
            // we still support no return (`this.ticks` internally set by calling this method).
            ticks = me.buildTicks() || [];
            // Allow modification of ticks in callback.
            ticks = me.afterBuildTicks(ticks) || ticks;
            // Ensure ticks contains ticks in new tick format
            if ((!ticks || !ticks.length) && me.ticks) {
                ticks = [];
                for(i = 0, ilen = me.ticks.length; i < ilen; ++i)ticks.push({
                    value: me.ticks[i],
                    major: false
                });
            }
            me._ticks = ticks;
            // Compute tick rotation and fit using a sampled subset of labels
            // We generally don't need to compute the size of every single label for determining scale size
            samplingEnabled = sampleSize < ticks.length;
            labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);
            // _configure is called twice, once here, once from core.controller.updateLayout.
            // Here we haven't been positioned yet, but dimensions are correct.
            // Variables set in _configure are needed for calculateTickRotation, and
            // it's ok that coordinates are not correct there, only dimensions matter.
            me._configure();
            // Tick Rotation
            me.beforeCalculateTickRotation();
            me.calculateTickRotation();
            me.afterCalculateTickRotation();
            me.beforeFit();
            me.fit();
            me.afterFit();
            // Auto-skip
            me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;
            if (samplingEnabled) // Generate labels using all non-skipped ticks
            labels = me._convertTicksToLabels(me._ticksToDraw);
            me.ticks = labels; // BACKWARD COMPATIBILITY
            // IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!
            me.afterUpdate();
            // TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
            // make maxWidth and maxHeight private
            return me.minSize;
        },
        /**
	 * @private
	 */ _configure: function() {
            var me = this;
            var reversePixels = me.options.ticks.reverse;
            var startPixel, endPixel;
            if (me.isHorizontal()) {
                startPixel = me.left;
                endPixel = me.right;
            } else {
                startPixel = me.top;
                endPixel = me.bottom;
                // by default vertical scales are from bottom to top, so pixels are reversed
                reversePixels = !reversePixels;
            }
            me._startPixel = startPixel;
            me._endPixel = endPixel;
            me._reversePixels = reversePixels;
            me._length = endPixel - startPixel;
        },
        afterUpdate: function() {
            helpers$1.callback(this.options.afterUpdate, [
                this
            ]);
        },
        //
        beforeSetDimensions: function() {
            helpers$1.callback(this.options.beforeSetDimensions, [
                this
            ]);
        },
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
        },
        afterSetDimensions: function() {
            helpers$1.callback(this.options.afterSetDimensions, [
                this
            ]);
        },
        // Data limits
        beforeDataLimits: function() {
            helpers$1.callback(this.options.beforeDataLimits, [
                this
            ]);
        },
        determineDataLimits: helpers$1.noop,
        afterDataLimits: function() {
            helpers$1.callback(this.options.afterDataLimits, [
                this
            ]);
        },
        //
        beforeBuildTicks: function() {
            helpers$1.callback(this.options.beforeBuildTicks, [
                this
            ]);
        },
        buildTicks: helpers$1.noop,
        afterBuildTicks: function(ticks) {
            var me = this;
            // ticks is empty for old axis implementations here
            if (isArray(ticks) && ticks.length) return helpers$1.callback(me.options.afterBuildTicks, [
                me,
                ticks
            ]);
            // Support old implementations (that modified `this.ticks` directly in buildTicks)
            me.ticks = helpers$1.callback(me.options.afterBuildTicks, [
                me,
                me.ticks
            ]) || me.ticks;
            return ticks;
        },
        beforeTickToLabelConversion: function() {
            helpers$1.callback(this.options.beforeTickToLabelConversion, [
                this
            ]);
        },
        convertTicksToLabels: function() {
            var me = this;
            // Convert ticks to strings
            var tickOpts = me.options.ticks;
            me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
        },
        afterTickToLabelConversion: function() {
            helpers$1.callback(this.options.afterTickToLabelConversion, [
                this
            ]);
        },
        //
        beforeCalculateTickRotation: function() {
            helpers$1.callback(this.options.beforeCalculateTickRotation, [
                this
            ]);
        },
        calculateTickRotation: function() {
            var me = this;
            var options = me.options;
            var tickOpts = options.ticks;
            var numTicks = me.getTicks().length;
            var minRotation = tickOpts.minRotation || 0;
            var maxRotation = tickOpts.maxRotation;
            var labelRotation = minRotation;
            var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
            if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
                me.labelRotation = minRotation;
                return;
            }
            labelSizes = me._getLabelSizes();
            maxLabelWidth = labelSizes.widest.width;
            maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;
            // Estimate the width of each grid based on the canvas width, the maximum
            // label width and the number of tick intervals
            maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
            tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);
            // Allow 3 pixels x2 padding either side for label readability
            if (maxLabelWidth + 6 > tickWidth) {
                tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
                maxHeight = me.maxHeight - getTickMarkLength(options.gridLines) - tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
                maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
                labelRotation = helpers$1.toDegrees(Math.min(Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)), Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)));
                labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
            }
            me.labelRotation = labelRotation;
        },
        afterCalculateTickRotation: function() {
            helpers$1.callback(this.options.afterCalculateTickRotation, [
                this
            ]);
        },
        //
        beforeFit: function() {
            helpers$1.callback(this.options.beforeFit, [
                this
            ]);
        },
        fit: function() {
            var me = this;
            // Reset
            var minSize = me.minSize = {
                width: 0,
                height: 0
            };
            var chart = me.chart;
            var opts = me.options;
            var tickOpts = opts.ticks;
            var scaleLabelOpts = opts.scaleLabel;
            var gridLineOpts = opts.gridLines;
            var display = me._isVisible();
            var isBottom = opts.position === 'bottom';
            var isHorizontal = me.isHorizontal();
            // Width
            if (isHorizontal) minSize.width = me.maxWidth;
            else if (display) minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
            // height
            if (!isHorizontal) minSize.height = me.maxHeight; // fill all the height
            else if (display) minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
            // Don't bother fitting the ticks if we are not showing the labels
            if (tickOpts.display && display) {
                var tickFonts = parseTickFontOptions(tickOpts);
                var labelSizes = me._getLabelSizes();
                var firstLabelSize = labelSizes.first;
                var lastLabelSize = labelSizes.last;
                var widestLabelSize = labelSizes.widest;
                var highestLabelSize = labelSizes.highest;
                var lineSpace = tickFonts.minor.lineHeight * 0.4;
                var tickPadding = tickOpts.padding;
                if (isHorizontal) {
                    // A horizontal axis is more constrained by the height.
                    var isRotated = me.labelRotation !== 0;
                    var angleRadians = helpers$1.toRadians(me.labelRotation);
                    var cosRotation = Math.cos(angleRadians);
                    var sinRotation = Math.sin(angleRadians);
                    var labelHeight = sinRotation * widestLabelSize.width + cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0)) + (isRotated ? 0 : lineSpace); // padding
                    minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
                    var offsetLeft = me.getPixelForTick(0) - me.left;
                    var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
                    var paddingLeft, paddingRight;
                    // Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
                    // which means that the right padding is dominated by the font height
                    if (isRotated) {
                        paddingLeft = isBottom ? cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset : sinRotation * (firstLabelSize.height - firstLabelSize.offset);
                        paddingRight = isBottom ? sinRotation * (lastLabelSize.height - lastLabelSize.offset) : cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
                    } else {
                        paddingLeft = firstLabelSize.width / 2;
                        paddingRight = lastLabelSize.width / 2;
                    }
                    // Adjust padding taking into account changes in offsets
                    // and add 3 px to move away from canvas edges
                    me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
                    me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
                } else {
                    // A vertical axis is more constrained by the width. Labels are the
                    // dominant factor here, so get that length first and account for padding
                    var labelWidth = tickOpts.mirror ? 0 : // use lineSpace for consistency with horizontal axis
                    // tickPadding is not implemented for horizontal
                    widestLabelSize.width + tickPadding + lineSpace;
                    minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
                    me.paddingTop = firstLabelSize.height / 2;
                    me.paddingBottom = lastLabelSize.height / 2;
                }
            }
            me.handleMargins();
            if (isHorizontal) {
                me.width = me._length = chart.width - me.margins.left - me.margins.right;
                me.height = minSize.height;
            } else {
                me.width = minSize.width;
                me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
            }
        },
        /**
	 * Handle margins and padding interactions
	 * @private
	 */ handleMargins: function() {
            var me = this;
            if (me.margins) {
                me.margins.left = Math.max(me.paddingLeft, me.margins.left);
                me.margins.top = Math.max(me.paddingTop, me.margins.top);
                me.margins.right = Math.max(me.paddingRight, me.margins.right);
                me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
            }
        },
        afterFit: function() {
            helpers$1.callback(this.options.afterFit, [
                this
            ]);
        },
        // Shared Methods
        isHorizontal: function() {
            var pos = this.options.position;
            return pos === 'top' || pos === 'bottom';
        },
        isFullWidth: function() {
            return this.options.fullWidth;
        },
        // Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
        getRightValue: function(rawValue) {
            // Null and undefined values first
            if (isNullOrUndef(rawValue)) return NaN;
            // isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
            if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) return NaN;
            // If it is in fact an object, dive in one more level
            if (rawValue) {
                if (this.isHorizontal()) {
                    if (rawValue.x !== undefined) return this.getRightValue(rawValue.x);
                } else if (rawValue.y !== undefined) return this.getRightValue(rawValue.y);
            }
            // Value is good, return it
            return rawValue;
        },
        _convertTicksToLabels: function(ticks) {
            var me = this;
            var labels, i, ilen;
            me.ticks = ticks.map(function(tick) {
                return tick.value;
            });
            me.beforeTickToLabelConversion();
            // New implementations should return the formatted tick labels but for BACKWARD
            // COMPAT, we still support no return (`this.ticks` internally changed by calling
            // this method and supposed to contain only string values).
            labels = me.convertTicksToLabels(ticks) || me.ticks;
            me.afterTickToLabelConversion();
            // BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
            for(i = 0, ilen = ticks.length; i < ilen; ++i)ticks[i].label = labels[i];
            return labels;
        },
        /**
	 * @private
	 */ _getLabelSizes: function() {
            var me = this;
            var labelSizes = me._labelSizes;
            if (!labelSizes) {
                me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
                me.longestLabelWidth = labelSizes.widest.width;
            }
            return labelSizes;
        },
        /**
	 * @private
	 */ _parseValue: function(value) {
            var start, end, min, max;
            if (isArray(value)) {
                start = +this.getRightValue(value[0]);
                end = +this.getRightValue(value[1]);
                min = Math.min(start, end);
                max = Math.max(start, end);
            } else {
                value = +this.getRightValue(value);
                start = undefined;
                end = value;
                min = value;
                max = value;
            }
            return {
                min: min,
                max: max,
                start: start,
                end: end
            };
        },
        /**
	* @private
	*/ _getScaleLabel: function(rawValue) {
            var v = this._parseValue(rawValue);
            if (v.start !== undefined) return '[' + v.start + ', ' + v.end + ']';
            return +this.getRightValue(rawValue);
        },
        /**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */ getLabelForIndex: helpers$1.noop,
        /**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */ getPixelForValue: helpers$1.noop,
        /**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */ getValueForPixel: helpers$1.noop,
        /**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getPixelForTick: function(index) {
            var me = this;
            var offset = me.options.offset;
            var numTicks = me._ticks.length;
            var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
            return index < 0 || index > numTicks - 1 ? null : me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
        },
        /**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getPixelForDecimal: function(decimal) {
            var me = this;
            if (me._reversePixels) decimal = 1 - decimal;
            return me._startPixel + decimal * me._length;
        },
        getDecimalForPixel: function(pixel) {
            var decimal = (pixel - this._startPixel) / this._length;
            return this._reversePixels ? 1 - decimal : decimal;
        },
        /**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */ getBasePixel: function() {
            return this.getPixelForValue(this.getBaseValue());
        },
        getBaseValue: function() {
            var me = this;
            var min = me.min;
            var max = me.max;
            return me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
        },
        /**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */ _autoSkip: function(ticks) {
            var me = this;
            var tickOpts = me.options.ticks;
            var axisLength = me._length;
            var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
            var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
            var numMajorIndices = majorIndices.length;
            var first = majorIndices[0];
            var last = majorIndices[numMajorIndices - 1];
            var i, ilen, spacing, avgMajorSpacing;
            // If there are too many major ticks to display them all
            if (numMajorIndices > ticksLimit) {
                skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
                return nonSkipped(ticks);
            }
            spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
            if (numMajorIndices > 0) {
                for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
                avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
                skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
                skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
                return nonSkipped(ticks);
            }
            skip(ticks, spacing);
            return nonSkipped(ticks);
        },
        /**
	 * @private
	 */ _tickSize: function() {
            var me = this;
            var optionTicks = me.options.ticks;
            // Calculate space needed by label in axis direction.
            var rot = helpers$1.toRadians(me.labelRotation);
            var cos = Math.abs(Math.cos(rot));
            var sin = Math.abs(Math.sin(rot));
            var labelSizes = me._getLabelSizes();
            var padding = optionTicks.autoSkipPadding || 0;
            var w = labelSizes ? labelSizes.widest.width + padding : 0;
            var h = labelSizes ? labelSizes.highest.height + padding : 0;
            // Calculate space needed for 1 tick in axis direction.
            return me.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
        },
        /**
	 * @private
	 */ _isVisible: function() {
            var me = this;
            var chart = me.chart;
            var display = me.options.display;
            var i, ilen, meta;
            if (display !== 'auto') return !!display;
            // When 'auto', the scale is visible if at least one associated dataset is visible.
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                if (meta.xAxisID === me.id || meta.yAxisID === me.id) return true;
            }
            return false;
        },
        /**
	 * @private
	 */ _computeGridLineItems: function(chartArea) {
            var me = this;
            var chart = me.chart;
            var options = me.options;
            var gridLines = options.gridLines;
            var position = options.position;
            var offsetGridLines = gridLines.offsetGridLines;
            var isHorizontal = me.isHorizontal();
            var ticks = me._ticksToDraw;
            var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
            var tl = getTickMarkLength(gridLines);
            var items = [];
            var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
            var axisHalfWidth = axisWidth / 2;
            var alignPixel = helpers$1._alignPixel;
            var alignBorderValue = function(pixel) {
                return alignPixel(chart, pixel, axisWidth);
            };
            var borderValue, i, tick, lineValue, alignedLineValue;
            var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
            if (position === 'top') {
                borderValue = alignBorderValue(me.bottom);
                ty1 = me.bottom - tl;
                ty2 = borderValue - axisHalfWidth;
                y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
                y2 = chartArea.bottom;
            } else if (position === 'bottom') {
                borderValue = alignBorderValue(me.top);
                y1 = chartArea.top;
                y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
                ty1 = borderValue + axisHalfWidth;
                ty2 = me.top + tl;
            } else if (position === 'left') {
                borderValue = alignBorderValue(me.right);
                tx1 = me.right - tl;
                tx2 = borderValue - axisHalfWidth;
                x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
                x2 = chartArea.right;
            } else {
                borderValue = alignBorderValue(me.left);
                x1 = chartArea.left;
                x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
                tx1 = borderValue + axisHalfWidth;
                tx2 = me.left + tl;
            }
            for(i = 0; i < ticksLength; ++i){
                tick = ticks[i] || {};
                // autoskipper skipped this tick (#4635)
                if (isNullOrUndef(tick.label) && i < ticks.length) continue;
                if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
                    // Draw the first index specially
                    lineWidth = gridLines.zeroLineWidth;
                    lineColor = gridLines.zeroLineColor;
                    borderDash = gridLines.zeroLineBorderDash || [];
                    borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
                } else {
                    lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
                    lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
                    borderDash = gridLines.borderDash || [];
                    borderDashOffset = gridLines.borderDashOffset || 0.0;
                }
                lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);
                // Skip if the pixel is out of the range
                if (lineValue === undefined) continue;
                alignedLineValue = alignPixel(chart, lineValue, lineWidth);
                if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
                else ty1 = ty2 = y1 = y2 = alignedLineValue;
                items.push({
                    tx1: tx1,
                    ty1: ty1,
                    tx2: tx2,
                    ty2: ty2,
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2,
                    width: lineWidth,
                    color: lineColor,
                    borderDash: borderDash,
                    borderDashOffset: borderDashOffset
                });
            }
            items.ticksLength = ticksLength;
            items.borderValue = borderValue;
            return items;
        },
        /**
	 * @private
	 */ _computeLabelItems: function() {
            var me = this;
            var options = me.options;
            var optionTicks = options.ticks;
            var position = options.position;
            var isMirrored = optionTicks.mirror;
            var isHorizontal = me.isHorizontal();
            var ticks = me._ticksToDraw;
            var fonts = parseTickFontOptions(optionTicks);
            var tickPadding = optionTicks.padding;
            var tl = getTickMarkLength(options.gridLines);
            var rotation = -helpers$1.toRadians(me.labelRotation);
            var items = [];
            var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
            if (position === 'top') {
                y = me.bottom - tl - tickPadding;
                textAlign = !rotation ? 'center' : 'left';
            } else if (position === 'bottom') {
                y = me.top + tl + tickPadding;
                textAlign = !rotation ? 'center' : 'right';
            } else if (position === 'left') {
                x = me.right - (isMirrored ? 0 : tl) - tickPadding;
                textAlign = isMirrored ? 'left' : 'right';
            } else {
                x = me.left + (isMirrored ? 0 : tl) + tickPadding;
                textAlign = isMirrored ? 'right' : 'left';
            }
            for(i = 0, ilen = ticks.length; i < ilen; ++i){
                tick = ticks[i];
                label = tick.label;
                // autoskipper skipped this tick (#4635)
                if (isNullOrUndef(label)) continue;
                pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
                font = tick.major ? fonts.major : fonts.minor;
                lineHeight = font.lineHeight;
                lineCount = isArray(label) ? label.length : 1;
                if (isHorizontal) {
                    x = pixel;
                    textOffset = position === 'top' ? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight : (!rotation ? 0.5 : 0) * lineHeight;
                } else {
                    y = pixel;
                    textOffset = (1 - lineCount) * lineHeight / 2;
                }
                items.push({
                    x: x,
                    y: y,
                    rotation: rotation,
                    label: label,
                    font: font,
                    textOffset: textOffset,
                    textAlign: textAlign
                });
            }
            return items;
        },
        /**
	 * @private
	 */ _drawGrid: function(chartArea) {
            var me = this;
            var gridLines = me.options.gridLines;
            if (!gridLines.display) return;
            var ctx = me.ctx;
            var chart = me.chart;
            var alignPixel = helpers$1._alignPixel;
            var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
            var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
            var width, color, i, ilen, item;
            for(i = 0, ilen = items.length; i < ilen; ++i){
                item = items[i];
                width = item.width;
                color = item.color;
                if (width && color) {
                    ctx.save();
                    ctx.lineWidth = width;
                    ctx.strokeStyle = color;
                    if (ctx.setLineDash) {
                        ctx.setLineDash(item.borderDash);
                        ctx.lineDashOffset = item.borderDashOffset;
                    }
                    ctx.beginPath();
                    if (gridLines.drawTicks) {
                        ctx.moveTo(item.tx1, item.ty1);
                        ctx.lineTo(item.tx2, item.ty2);
                    }
                    if (gridLines.drawOnChartArea) {
                        ctx.moveTo(item.x1, item.y1);
                        ctx.lineTo(item.x2, item.y2);
                    }
                    ctx.stroke();
                    ctx.restore();
                }
            }
            if (axisWidth) {
                // Draw the line at the edge of the axis
                var firstLineWidth = axisWidth;
                var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
                var borderValue = items.borderValue;
                var x1, x2, y1, y2;
                if (me.isHorizontal()) {
                    x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
                    x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
                    y1 = y2 = borderValue;
                } else {
                    y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
                    y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
                    x1 = x2 = borderValue;
                }
                ctx.lineWidth = axisWidth;
                ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
                ctx.beginPath();
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.stroke();
            }
        },
        /**
	 * @private
	 */ _drawLabels: function() {
            var me = this;
            var optionTicks = me.options.ticks;
            if (!optionTicks.display) return;
            var ctx = me.ctx;
            var items = me._labelItems || (me._labelItems = me._computeLabelItems());
            var i, j, ilen, jlen, item, tickFont, label, y;
            for(i = 0, ilen = items.length; i < ilen; ++i){
                item = items[i];
                tickFont = item.font;
                // Make sure we draw text in the correct color and font
                ctx.save();
                ctx.translate(item.x, item.y);
                ctx.rotate(item.rotation);
                ctx.font = tickFont.string;
                ctx.fillStyle = tickFont.color;
                ctx.textBaseline = 'middle';
                ctx.textAlign = item.textAlign;
                label = item.label;
                y = item.textOffset;
                if (isArray(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                    // We just make sure the multiline element is a string here..
                    ctx.fillText('' + label[j], 0, y);
                    y += tickFont.lineHeight;
                }
                else ctx.fillText(label, 0, y);
                ctx.restore();
            }
        },
        /**
	 * @private
	 */ _drawTitle: function() {
            var me = this;
            var ctx = me.ctx;
            var options = me.options;
            var scaleLabel = options.scaleLabel;
            if (!scaleLabel.display) return;
            var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
            var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
            var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
            var halfLineHeight = scaleLabelFont.lineHeight / 2;
            var position = options.position;
            var rotation = 0;
            var scaleLabelX, scaleLabelY;
            if (me.isHorizontal()) {
                scaleLabelX = me.left + me.width / 2; // midpoint of the width
                scaleLabelY = position === 'bottom' ? me.bottom - halfLineHeight - scaleLabelPadding.bottom : me.top + halfLineHeight + scaleLabelPadding.top;
            } else {
                var isLeft = position === 'left';
                scaleLabelX = isLeft ? me.left + halfLineHeight + scaleLabelPadding.top : me.right - halfLineHeight - scaleLabelPadding.top;
                scaleLabelY = me.top + me.height / 2;
                rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
            }
            ctx.save();
            ctx.translate(scaleLabelX, scaleLabelY);
            ctx.rotate(rotation);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillStyle = scaleLabelFontColor; // render in correct colour
            ctx.font = scaleLabelFont.string;
            ctx.fillText(scaleLabel.labelString, 0, 0);
            ctx.restore();
        },
        draw: function(chartArea) {
            var me = this;
            if (!me._isVisible()) return;
            me._drawGrid(chartArea);
            me._drawTitle();
            me._drawLabels();
        },
        /**
	 * @private
	 */ _layers: function() {
            var me = this;
            var opts = me.options;
            var tz = opts.ticks && opts.ticks.z || 0;
            var gz = opts.gridLines && opts.gridLines.z || 0;
            if (!me._isVisible() || tz === gz || me.draw !== me._draw) // backward compatibility: draw has been overridden by custom scale
            return [
                {
                    z: tz,
                    draw: function() {
                        me.draw.apply(me, arguments);
                    }
                }
            ];
            return [
                {
                    z: gz,
                    draw: function() {
                        me._drawGrid.apply(me, arguments);
                        me._drawTitle.apply(me, arguments);
                    }
                },
                {
                    z: tz,
                    draw: function() {
                        me._drawLabels.apply(me, arguments);
                    }
                }
            ];
        },
        /**
	 * @private
	 */ _getMatchingVisibleMetas: function(type) {
            var me = this;
            var isHorizontal = me.isHorizontal();
            return me.chart._getSortedVisibleDatasetMetas().filter(function(meta) {
                return (!type || meta.type === type) && (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
            });
        }
    });
    Scale.prototype._draw = Scale.prototype.draw;
    var core_scale = Scale;
    var isNullOrUndef$1 = helpers$1.isNullOrUndef;
    var defaultConfig = {
        position: 'bottom'
    };
    var scale_category = core_scale.extend({
        determineDataLimits: function() {
            var me = this;
            var labels = me._getLabels();
            var ticksOpts = me.options.ticks;
            var min = ticksOpts.min;
            var max = ticksOpts.max;
            var minIndex = 0;
            var maxIndex = labels.length - 1;
            var findIndex;
            if (min !== undefined) {
                // user specified min value
                findIndex = labels.indexOf(min);
                if (findIndex >= 0) minIndex = findIndex;
            }
            if (max !== undefined) {
                // user specified max value
                findIndex = labels.indexOf(max);
                if (findIndex >= 0) maxIndex = findIndex;
            }
            me.minIndex = minIndex;
            me.maxIndex = maxIndex;
            me.min = labels[minIndex];
            me.max = labels[maxIndex];
        },
        buildTicks: function() {
            var me = this;
            var labels = me._getLabels();
            var minIndex = me.minIndex;
            var maxIndex = me.maxIndex;
            // If we are viewing some subset of labels, slice the original array
            me.ticks = minIndex === 0 && maxIndex === labels.length - 1 ? labels : labels.slice(minIndex, maxIndex + 1);
        },
        getLabelForIndex: function(index, datasetIndex) {
            var me = this;
            var chart = me.chart;
            if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
            return me._getLabels()[index];
        },
        _configure: function() {
            var me = this;
            var offset = me.options.offset;
            var ticks = me.ticks;
            core_scale.prototype._configure.call(me);
            if (!me.isHorizontal()) // For backward compatibility, vertical category scale reverse is inverted.
            me._reversePixels = !me._reversePixels;
            if (!ticks) return;
            me._startValue = me.minIndex - (offset ? 0.5 : 0);
            me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
        },
        // Used to get data value locations.  Value can either be an index or a numerical value
        getPixelForValue: function(value, index, datasetIndex) {
            var me = this;
            var valueCategory, labels, idx;
            if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) value = me.chart.data.datasets[datasetIndex].data[index];
            // If value is a data object, then index is the index in the data array,
            // not the index of the scale. We need to change that.
            if (!isNullOrUndef$1(value)) valueCategory = me.isHorizontal() ? value.x : value.y;
            if (valueCategory !== undefined || value !== undefined && isNaN(index)) {
                labels = me._getLabels();
                value = helpers$1.valueOrDefault(valueCategory, value);
                idx = labels.indexOf(value);
                index = idx !== -1 ? idx : index;
                if (isNaN(index)) index = value;
            }
            return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
        },
        getPixelForTick: function(index) {
            var ticks = this.ticks;
            return index < 0 || index > ticks.length - 1 ? null : this.getPixelForValue(ticks[index], index + this.minIndex);
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
            return Math.min(Math.max(value, 0), me.ticks.length - 1);
        },
        getBasePixel: function() {
            return this.bottom;
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults = defaultConfig;
    scale_category._defaults = _defaults;
    var noop = helpers$1.noop;
    var isNullOrUndef$2 = helpers$1.isNullOrUndef;
    /**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */ function generateTicks(generationOptions, dataRange) {
        var ticks = [];
        // To get a "nice" value for the tick spacing, we will use the appropriately named
        // "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
        // for details.
        var MIN_SPACING = 1e-14;
        var stepSize = generationOptions.stepSize;
        var unit = stepSize || 1;
        var maxNumSpaces = generationOptions.maxTicks - 1;
        var min = generationOptions.min;
        var max = generationOptions.max;
        var precision = generationOptions.precision;
        var rmin = dataRange.min;
        var rmax = dataRange.max;
        var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
        var factor, niceMin, niceMax, numSpaces;
        // Beyond MIN_SPACING floating point numbers being to lose precision
        // such that we can't do the math necessary to generate ticks
        if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) return [
            rmin,
            rmax
        ];
        numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
        if (numSpaces > maxNumSpaces) // If the calculated num of spaces exceeds maxNumSpaces, recalculate it
        spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
        if (stepSize || isNullOrUndef$2(precision)) // If a precision is not specified, calculate factor based on spacing
        factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
        else {
            // If the user specified a precision, round to that number of decimal places
            factor = Math.pow(10, precision);
            spacing = Math.ceil(spacing * factor) / factor;
        }
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
        // If min, max and stepSize is set and they make an evenly spaced scale use it.
        if (stepSize) {
            // If very close to our whole number, use it.
            if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) niceMin = min;
            if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) niceMax = max;
        }
        numSpaces = (niceMax - niceMin) / spacing;
        // If very close to our rounded value, use it.
        if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
        niceMin = Math.round(niceMin * factor) / factor;
        niceMax = Math.round(niceMax * factor) / factor;
        ticks.push(isNullOrUndef$2(min) ? niceMin : min);
        for(var j = 1; j < numSpaces; ++j)ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
        ticks.push(isNullOrUndef$2(max) ? niceMax : max);
        return ticks;
    }
    var scale_linearbase = core_scale.extend({
        getRightValue: function(value) {
            if (typeof value === 'string') return +value;
            return core_scale.prototype.getRightValue.call(this, value);
        },
        handleTickRangeOptions: function() {
            var me = this;
            var opts = me.options;
            var tickOpts = opts.ticks;
            // If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
            // do nothing since that would make the chart weird. If the user really wants a weird chart
            // axis, they can manually override it
            if (tickOpts.beginAtZero) {
                var minSign = helpers$1.sign(me.min);
                var maxSign = helpers$1.sign(me.max);
                if (minSign < 0 && maxSign < 0) // move the top up to 0
                me.max = 0;
                else if (minSign > 0 && maxSign > 0) // move the bottom down to 0
                me.min = 0;
            }
            var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
            var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
            if (tickOpts.min !== undefined) me.min = tickOpts.min;
            else if (tickOpts.suggestedMin !== undefined) {
                if (me.min === null) me.min = tickOpts.suggestedMin;
                else me.min = Math.min(me.min, tickOpts.suggestedMin);
            }
            if (tickOpts.max !== undefined) me.max = tickOpts.max;
            else if (tickOpts.suggestedMax !== undefined) {
                if (me.max === null) me.max = tickOpts.suggestedMax;
                else me.max = Math.max(me.max, tickOpts.suggestedMax);
            }
            if (setMin !== setMax) // We set the min or the max but not both.
            // So ensure that our range is good
            // Inverted or 0 length range can happen when
            // ticks.min is set, and no datasets are visible
            {
                if (me.min >= me.max) {
                    if (setMin) me.max = me.min + 1;
                    else me.min = me.max - 1;
                }
            }
            if (me.min === me.max) {
                me.max++;
                if (!tickOpts.beginAtZero) me.min--;
            }
        },
        getTickLimit: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var stepSize = tickOpts.stepSize;
            var maxTicksLimit = tickOpts.maxTicksLimit;
            var maxTicks;
            if (stepSize) maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
            else {
                maxTicks = me._computeTickLimit();
                maxTicksLimit = maxTicksLimit || 11;
            }
            if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
            return maxTicks;
        },
        _computeTickLimit: function() {
            return Number.POSITIVE_INFINITY;
        },
        handleDirectionalChanges: noop,
        buildTicks: function() {
            var me = this;
            var opts = me.options;
            var tickOpts = opts.ticks;
            // Figure out what the max number of ticks we can support it is based on the size of
            // the axis area. For now, we say that the minimum tick spacing in pixels must be 40
            // We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
            // the graph. Make sure we always have at least 2 ticks
            var maxTicks = me.getTickLimit();
            maxTicks = Math.max(2, maxTicks);
            var numericGeneratorOptions = {
                maxTicks: maxTicks,
                min: tickOpts.min,
                max: tickOpts.max,
                precision: tickOpts.precision,
                stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
            };
            var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
            me.handleDirectionalChanges();
            // At this point, we need to update our max and min given the tick values since we have expanded the
            // range of the scale
            me.max = helpers$1.max(ticks);
            me.min = helpers$1.min(ticks);
            if (tickOpts.reverse) {
                ticks.reverse();
                me.start = me.max;
                me.end = me.min;
            } else {
                me.start = me.min;
                me.end = me.max;
            }
        },
        convertTicksToLabels: function() {
            var me = this;
            me.ticksAsNumbers = me.ticks.slice();
            me.zeroLineIndex = me.ticks.indexOf(0);
            core_scale.prototype.convertTicksToLabels.call(me);
        },
        _configure: function() {
            var me = this;
            var ticks = me.getTicks();
            var start = me.min;
            var end = me.max;
            var offset;
            core_scale.prototype._configure.call(me);
            if (me.options.offset && ticks.length) {
                offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
                start -= offset;
                end += offset;
            }
            me._startValue = start;
            me._endValue = end;
            me._valueRange = end - start;
        }
    });
    var defaultConfig$1 = {
        position: 'left',
        ticks: {
            callback: core_ticks.formatters.linear
        }
    };
    var DEFAULT_MIN = 0;
    var DEFAULT_MAX = 1;
    function getOrCreateStack(stacks, stacked, meta) {
        var key = [
            meta.type,
            // we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
            stacked === undefined && meta.stack === undefined ? meta.index : '',
            meta.stack
        ].join('.');
        if (stacks[key] === undefined) stacks[key] = {
            pos: [],
            neg: []
        };
        return stacks[key];
    }
    function stackData(scale, stacks, meta, data) {
        var opts = scale.options;
        var stacked = opts.stacked;
        var stack = getOrCreateStack(stacks, stacked, meta);
        var pos = stack.pos;
        var neg = stack.neg;
        var ilen = data.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = scale._parseValue(data[i]);
            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) continue;
            pos[i] = pos[i] || 0;
            neg[i] = neg[i] || 0;
            if (opts.relativePoints) pos[i] = 100;
            else if (value.min < 0 || value.max < 0) neg[i] += value.min;
            else pos[i] += value.max;
        }
    }
    function updateMinMax(scale, meta, data) {
        var ilen = data.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = scale._parseValue(data[i]);
            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) continue;
            scale.min = Math.min(scale.min, value.min);
            scale.max = Math.max(scale.max, value.max);
        }
    }
    var scale_linear = scale_linearbase.extend({
        determineDataLimits: function() {
            var me = this;
            var opts = me.options;
            var chart = me.chart;
            var datasets = chart.data.datasets;
            var metasets = me._getMatchingVisibleMetas();
            var hasStacks = opts.stacked;
            var stacks = {};
            var ilen = metasets.length;
            var i, meta, data, values;
            me.min = Number.POSITIVE_INFINITY;
            me.max = Number.NEGATIVE_INFINITY;
            if (hasStacks === undefined) for(i = 0; !hasStacks && i < ilen; ++i){
                meta = metasets[i];
                hasStacks = meta.stack !== undefined;
            }
            for(i = 0; i < ilen; ++i){
                meta = metasets[i];
                data = datasets[meta.index].data;
                if (hasStacks) stackData(me, stacks, meta, data);
                else updateMinMax(me, meta, data);
            }
            helpers$1.each(stacks, function(stackValues) {
                values = stackValues.pos.concat(stackValues.neg);
                me.min = Math.min(me.min, helpers$1.min(values));
                me.max = Math.max(me.max, helpers$1.max(values));
            });
            me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
            me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
            // Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
            me.handleTickRangeOptions();
        },
        // Returns the maximum number of ticks based on the scale dimension
        _computeTickLimit: function() {
            var me = this;
            var tickFont;
            if (me.isHorizontal()) return Math.ceil(me.width / 40);
            tickFont = helpers$1.options._parseFont(me.options.ticks);
            return Math.ceil(me.height / tickFont.lineHeight);
        },
        // Called after the ticks are built. We need
        handleDirectionalChanges: function() {
            if (!this.isHorizontal()) // We are in a vertical orientation. The top value is the highest. So reverse the array
            this.ticks.reverse();
        },
        getLabelForIndex: function(index, datasetIndex) {
            return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
        },
        // Utils
        getPixelForValue: function(value) {
            var me = this;
            return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
        },
        getValueForPixel: function(pixel) {
            return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
        },
        getPixelForTick: function(index) {
            var ticks = this.ticksAsNumbers;
            if (index < 0 || index > ticks.length - 1) return null;
            return this.getPixelForValue(ticks[index]);
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$1 = defaultConfig$1;
    scale_linear._defaults = _defaults$1;
    var valueOrDefault$b = helpers$1.valueOrDefault;
    var log10 = helpers$1.math.log10;
    /**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */ function generateTicks$1(generationOptions, dataRange) {
        var ticks = [];
        var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
        var endExp = Math.floor(log10(dataRange.max));
        var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
        var exp, significand;
        if (tickVal === 0) {
            exp = Math.floor(log10(dataRange.minNotZero));
            significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
            ticks.push(tickVal);
            tickVal = significand * Math.pow(10, exp);
        } else {
            exp = Math.floor(log10(tickVal));
            significand = Math.floor(tickVal / Math.pow(10, exp));
        }
        var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
        do {
            ticks.push(tickVal);
            ++significand;
            if (significand === 10) {
                significand = 1;
                ++exp;
                precision = exp >= 0 ? 1 : precision;
            }
            tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
        }while (exp < endExp || exp === endExp && significand < endSignificand);
        var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
        ticks.push(lastTick);
        return ticks;
    }
    var defaultConfig$2 = {
        position: 'left',
        // label settings
        ticks: {
            callback: core_ticks.formatters.logarithmic
        }
    };
    // TODO(v3): change this to positiveOrDefault
    function nonNegativeOrDefault(value, defaultValue) {
        return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
    }
    var scale_logarithmic = core_scale.extend({
        determineDataLimits: function() {
            var me = this;
            var opts = me.options;
            var chart = me.chart;
            var datasets = chart.data.datasets;
            var isHorizontal = me.isHorizontal();
            function IDMatches(meta) {
                return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
            }
            var datasetIndex, meta, value, data, i, ilen;
            // Calculate Range
            me.min = Number.POSITIVE_INFINITY;
            me.max = Number.NEGATIVE_INFINITY;
            me.minNotZero = Number.POSITIVE_INFINITY;
            var hasStacks = opts.stacked;
            if (hasStacks === undefined) for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                meta = chart.getDatasetMeta(datasetIndex);
                if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) && meta.stack !== undefined) {
                    hasStacks = true;
                    break;
                }
            }
            if (opts.stacked || hasStacks) {
                var valuesPerStack = {};
                for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                    meta = chart.getDatasetMeta(datasetIndex);
                    var key = [
                        meta.type,
                        // we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
                        opts.stacked === undefined && meta.stack === undefined ? datasetIndex : '',
                        meta.stack
                    ].join('.');
                    if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
                        if (valuesPerStack[key] === undefined) valuesPerStack[key] = [];
                        data = datasets[datasetIndex].data;
                        for(i = 0, ilen = data.length; i < ilen; i++){
                            var values = valuesPerStack[key];
                            value = me._parseValue(data[i]);
                            // invalid, hidden and negative values are ignored
                            if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) continue;
                            values[i] = values[i] || 0;
                            values[i] += value.max;
                        }
                    }
                }
                helpers$1.each(valuesPerStack, function(valuesForType) {
                    if (valuesForType.length > 0) {
                        var minVal = helpers$1.min(valuesForType);
                        var maxVal = helpers$1.max(valuesForType);
                        me.min = Math.min(me.min, minVal);
                        me.max = Math.max(me.max, maxVal);
                    }
                });
            } else for(datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++){
                meta = chart.getDatasetMeta(datasetIndex);
                if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
                    data = datasets[datasetIndex].data;
                    for(i = 0, ilen = data.length; i < ilen; i++){
                        value = me._parseValue(data[i]);
                        // invalid, hidden and negative values are ignored
                        if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) continue;
                        me.min = Math.min(value.min, me.min);
                        me.max = Math.max(value.max, me.max);
                        if (value.min !== 0) me.minNotZero = Math.min(value.min, me.minNotZero);
                    }
                }
            }
            me.min = helpers$1.isFinite(me.min) ? me.min : null;
            me.max = helpers$1.isFinite(me.max) ? me.max : null;
            me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;
            // Common base implementation to handle ticks.min, ticks.max
            this.handleTickRangeOptions();
        },
        handleTickRangeOptions: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var DEFAULT_MIN = 1;
            var DEFAULT_MAX = 10;
            me.min = nonNegativeOrDefault(tickOpts.min, me.min);
            me.max = nonNegativeOrDefault(tickOpts.max, me.max);
            if (me.min === me.max) {
                if (me.min !== 0 && me.min !== null) {
                    me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
                    me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
                } else {
                    me.min = DEFAULT_MIN;
                    me.max = DEFAULT_MAX;
                }
            }
            if (me.min === null) me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
            if (me.max === null) me.max = me.min !== 0 ? Math.pow(10, Math.floor(log10(me.min)) + 1) : DEFAULT_MAX;
            if (me.minNotZero === null) {
                if (me.min > 0) me.minNotZero = me.min;
                else if (me.max < 1) me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
                else me.minNotZero = DEFAULT_MIN;
            }
        },
        buildTicks: function() {
            var me = this;
            var tickOpts = me.options.ticks;
            var reverse = !me.isHorizontal();
            var generationOptions = {
                min: nonNegativeOrDefault(tickOpts.min),
                max: nonNegativeOrDefault(tickOpts.max)
            };
            var ticks = me.ticks = generateTicks$1(generationOptions, me);
            // At this point, we need to update our max and min given the tick values since we have expanded the
            // range of the scale
            me.max = helpers$1.max(ticks);
            me.min = helpers$1.min(ticks);
            if (tickOpts.reverse) {
                reverse = !reverse;
                me.start = me.max;
                me.end = me.min;
            } else {
                me.start = me.min;
                me.end = me.max;
            }
            if (reverse) ticks.reverse();
        },
        convertTicksToLabels: function() {
            this.tickValues = this.ticks.slice();
            core_scale.prototype.convertTicksToLabels.call(this);
        },
        // Get the correct tooltip label
        getLabelForIndex: function(index, datasetIndex) {
            return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
        },
        getPixelForTick: function(index) {
            var ticks = this.tickValues;
            if (index < 0 || index > ticks.length - 1) return null;
            return this.getPixelForValue(ticks[index]);
        },
        /**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */ _getFirstTickValue: function(value) {
            var exp = Math.floor(log10(value));
            var significand = Math.floor(value / Math.pow(10, exp));
            return significand * Math.pow(10, exp);
        },
        _configure: function() {
            var me = this;
            var start = me.min;
            var offset = 0;
            core_scale.prototype._configure.call(me);
            if (start === 0) {
                start = me._getFirstTickValue(me.minNotZero);
                offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
            }
            me._startValue = log10(start);
            me._valueOffset = offset;
            me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
        },
        getPixelForValue: function(value) {
            var me = this;
            var decimal = 0;
            value = +me.getRightValue(value);
            if (value > me.min && value > 0) decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
            return me.getPixelForDecimal(decimal);
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var decimal = me.getDecimalForPixel(pixel);
            return decimal === 0 && me.min === 0 ? 0 : Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$2 = defaultConfig$2;
    scale_logarithmic._defaults = _defaults$2;
    var valueOrDefault$c = helpers$1.valueOrDefault;
    var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
    var resolve$4 = helpers$1.options.resolve;
    var defaultConfig$3 = {
        display: true,
        // Boolean - Whether to animate scaling the chart from the centre
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            color: 'rgba(0,0,0,0.1)',
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        gridLines: {
            circular: false
        },
        // label settings
        ticks: {
            // Boolean - Show a backdrop to the scale label
            showLabelBackdrop: true,
            // String - The colour of the label backdrop
            backdropColor: 'rgba(255,255,255,0.75)',
            // Number - The backdrop padding above & below the label in pixels
            backdropPaddingY: 2,
            // Number - The backdrop padding to the side of the label in pixels
            backdropPaddingX: 2,
            callback: core_ticks.formatters.linear
        },
        pointLabels: {
            // Boolean - if true, show point labels
            display: true,
            // Number - Point label font size in pixels
            fontSize: 10,
            // Function - Used to convert point labels
            callback: function(label) {
                return label;
            }
        }
    };
    function getTickBackdropHeight(opts) {
        var tickOpts = opts.ticks;
        if (tickOpts.display && opts.display) return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
        return 0;
    }
    function measureLabelSize(ctx, lineHeight, label) {
        if (helpers$1.isArray(label)) return {
            w: helpers$1.longestText(ctx, ctx.font, label),
            h: label.length * lineHeight
        };
        return {
            w: ctx.measureText(label).width,
            h: lineHeight
        };
    }
    function determineLimits(angle, pos, size, min, max) {
        if (angle === min || angle === max) return {
            start: pos - size / 2,
            end: pos + size / 2
        };
        else if (angle < min || angle > max) return {
            start: pos - size,
            end: pos
        };
        return {
            start: pos,
            end: pos + size
        };
    }
    /**
 * Helper function to fit a radial linear scale with point labels
 */ function fitWithPointLabels(scale) {
        // Right, this is really confusing and there is a lot of maths going on here
        // The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
        //
        // Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
        //
        // Solution:
        //
        // We assume the radius of the polygon is half the size of the canvas at first
        // at each index we check if the text overlaps.
        //
        // Where it does, we store that angle and that index.
        //
        // After finding the largest index and angle we calculate how much we need to remove
        // from the shape radius to move the point inwards by that x.
        //
        // We average the left and right distances to get the maximum shape radius that can fit in the box
        // along with labels.
        //
        // Once we have that, we can find the centre point for the chart, by taking the x text protrusion
        // on each side, removing that from the size, halving it and adding the left x protrusion width.
        //
        // This will mean we have a shape fitted to the canvas, as large as it can be with the labels
        // and position it in the most space efficient manner
        //
        // https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
        var plFont = helpers$1.options._parseFont(scale.options.pointLabels);
        // Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
        // Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
        var furthestLimits = {
            l: 0,
            r: scale.width,
            t: 0,
            b: scale.height - scale.paddingTop
        };
        var furthestAngles = {};
        var i, textSize, pointPosition;
        scale.ctx.font = plFont.string;
        scale._pointLabelSizes = [];
        var valueCount = scale.chart.data.labels.length;
        for(i = 0; i < valueCount; i++){
            pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
            textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
            scale._pointLabelSizes[i] = textSize;
            // Add quarter circle to make degree 0 mean top of circle
            var angleRadians = scale.getIndexAngle(i);
            var angle = helpers$1.toDegrees(angleRadians) % 360;
            var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
            var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
            if (hLimits.start < furthestLimits.l) {
                furthestLimits.l = hLimits.start;
                furthestAngles.l = angleRadians;
            }
            if (hLimits.end > furthestLimits.r) {
                furthestLimits.r = hLimits.end;
                furthestAngles.r = angleRadians;
            }
            if (vLimits.start < furthestLimits.t) {
                furthestLimits.t = vLimits.start;
                furthestAngles.t = angleRadians;
            }
            if (vLimits.end > furthestLimits.b) {
                furthestLimits.b = vLimits.end;
                furthestAngles.b = angleRadians;
            }
        }
        scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
    }
    function getTextAlignForAngle(angle) {
        if (angle === 0 || angle === 180) return 'center';
        else if (angle < 180) return 'left';
        return 'right';
    }
    function fillText(ctx, text, position, lineHeight) {
        var y = position.y + lineHeight / 2;
        var i, ilen;
        if (helpers$1.isArray(text)) for(i = 0, ilen = text.length; i < ilen; ++i){
            ctx.fillText(text[i], position.x, y);
            y += lineHeight;
        }
        else ctx.fillText(text, position.x, y);
    }
    function adjustPointPositionForLabelHeight(angle, textSize, position) {
        if (angle === 90 || angle === 270) position.y -= textSize.h / 2;
        else if (angle > 270 || angle < 90) position.y -= textSize.h;
    }
    function drawPointLabels(scale) {
        var ctx = scale.ctx;
        var opts = scale.options;
        var pointLabelOpts = opts.pointLabels;
        var tickBackdropHeight = getTickBackdropHeight(opts);
        var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
        var plFont = helpers$1.options._parseFont(pointLabelOpts);
        ctx.save();
        ctx.font = plFont.string;
        ctx.textBaseline = 'middle';
        for(var i = scale.chart.data.labels.length - 1; i >= 0; i--){
            // Extra pixels out for some label spacing
            var extra = i === 0 ? tickBackdropHeight / 2 : 0;
            var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);
            // Keep this in loop since we may support array properties here
            var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
            ctx.fillStyle = pointLabelFontColor;
            var angleRadians = scale.getIndexAngle(i);
            var angle = helpers$1.toDegrees(angleRadians);
            ctx.textAlign = getTextAlignForAngle(angle);
            adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
            fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
        }
        ctx.restore();
    }
    function drawRadiusLine(scale, gridLineOpts, radius, index) {
        var ctx = scale.ctx;
        var circular = gridLineOpts.circular;
        var valueCount = scale.chart.data.labels.length;
        var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
        var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
        var pointPosition;
        if (!circular && !valueCount || !lineColor || !lineWidth) return;
        ctx.save();
        ctx.strokeStyle = lineColor;
        ctx.lineWidth = lineWidth;
        if (ctx.setLineDash) {
            ctx.setLineDash(gridLineOpts.borderDash || []);
            ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
        }
        ctx.beginPath();
        if (circular) // Draw circular arcs between the points
        ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
        else {
            // Draw straight lines connecting each index
            pointPosition = scale.getPointPosition(0, radius);
            ctx.moveTo(pointPosition.x, pointPosition.y);
            for(var i = 1; i < valueCount; i++){
                pointPosition = scale.getPointPosition(i, radius);
                ctx.lineTo(pointPosition.x, pointPosition.y);
            }
        }
        ctx.closePath();
        ctx.stroke();
        ctx.restore();
    }
    function numberOrZero(param) {
        return helpers$1.isNumber(param) ? param : 0;
    }
    var scale_radialLinear = scale_linearbase.extend({
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            me.width = me.maxWidth;
            me.height = me.maxHeight;
            me.paddingTop = getTickBackdropHeight(me.options) / 2;
            me.xCenter = Math.floor(me.width / 2);
            me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
            me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
        },
        determineDataLimits: function() {
            var me = this;
            var chart = me.chart;
            var min = Number.POSITIVE_INFINITY;
            var max = Number.NEGATIVE_INFINITY;
            helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
                if (chart.isDatasetVisible(datasetIndex)) {
                    var meta = chart.getDatasetMeta(datasetIndex);
                    helpers$1.each(dataset.data, function(rawValue, index) {
                        var value = +me.getRightValue(rawValue);
                        if (isNaN(value) || meta.data[index].hidden) return;
                        min = Math.min(value, min);
                        max = Math.max(value, max);
                    });
                }
            });
            me.min = min === Number.POSITIVE_INFINITY ? 0 : min;
            me.max = max === Number.NEGATIVE_INFINITY ? 0 : max;
            // Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
            me.handleTickRangeOptions();
        },
        // Returns the maximum number of ticks based on the scale dimension
        _computeTickLimit: function() {
            return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
        },
        convertTicksToLabels: function() {
            var me = this;
            scale_linearbase.prototype.convertTicksToLabels.call(me);
            // Point labels
            me.pointLabels = me.chart.data.labels.map(function() {
                var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
                return label || label === 0 ? label : '';
            });
        },
        getLabelForIndex: function(index, datasetIndex) {
            return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
        },
        fit: function() {
            var me = this;
            var opts = me.options;
            if (opts.display && opts.pointLabels.display) fitWithPointLabels(me);
            else me.setCenterPoint(0, 0, 0, 0);
        },
        /**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */ setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
            var me = this;
            var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
            var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
            var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
            var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
            radiusReductionLeft = numberOrZero(radiusReductionLeft);
            radiusReductionRight = numberOrZero(radiusReductionRight);
            radiusReductionTop = numberOrZero(radiusReductionTop);
            radiusReductionBottom = numberOrZero(radiusReductionBottom);
            me.drawingArea = Math.min(Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2), Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
            me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
        },
        setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
            var me = this;
            var maxRight = me.width - rightMovement - me.drawingArea;
            var maxLeft = leftMovement + me.drawingArea;
            var maxTop = topMovement + me.drawingArea;
            var maxBottom = me.height - me.paddingTop - bottomMovement - me.drawingArea;
            me.xCenter = Math.floor((maxLeft + maxRight) / 2 + me.left);
            me.yCenter = Math.floor((maxTop + maxBottom) / 2 + me.top + me.paddingTop);
        },
        getIndexAngle: function(index) {
            var chart = this.chart;
            var angleMultiplier = 360 / chart.data.labels.length;
            var options = chart.options || {};
            var startAngle = options.startAngle || 0;
            // Start from the top instead of right, so remove a quarter of the circle
            var angle = (index * angleMultiplier + startAngle) % 360;
            return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
        },
        getDistanceFromCenterForValue: function(value) {
            var me = this;
            if (helpers$1.isNullOrUndef(value)) return NaN;
            // Take into account half font size + the yPadding of the top value
            var scalingFactor = me.drawingArea / (me.max - me.min);
            if (me.options.ticks.reverse) return (me.max - value) * scalingFactor;
            return (value - me.min) * scalingFactor;
        },
        getPointPosition: function(index, distanceFromCenter) {
            var me = this;
            var thisAngle = me.getIndexAngle(index) - Math.PI / 2;
            return {
                x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
                y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
            };
        },
        getPointPositionForValue: function(index, value) {
            return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
        },
        getBasePosition: function(index) {
            var me = this;
            var min = me.min;
            var max = me.max;
            return me.getPointPositionForValue(index || 0, me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0);
        },
        /**
	 * @private
	 */ _drawGrid: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            var gridLineOpts = opts.gridLines;
            var angleLineOpts = opts.angleLines;
            var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
            var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
            var i, offset, position;
            if (opts.pointLabels.display) drawPointLabels(me);
            if (gridLineOpts.display) helpers$1.each(me.ticks, function(label, index) {
                if (index !== 0) {
                    offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
                    drawRadiusLine(me, gridLineOpts, offset, index);
                }
            });
            if (angleLineOpts.display && lineWidth && lineColor) {
                ctx.save();
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = lineColor;
                if (ctx.setLineDash) {
                    ctx.setLineDash(resolve$4([
                        angleLineOpts.borderDash,
                        gridLineOpts.borderDash,
                        []
                    ]));
                    ctx.lineDashOffset = resolve$4([
                        angleLineOpts.borderDashOffset,
                        gridLineOpts.borderDashOffset,
                        0.0
                    ]);
                }
                for(i = me.chart.data.labels.length - 1; i >= 0; i--){
                    offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
                    position = me.getPointPosition(i, offset);
                    ctx.beginPath();
                    ctx.moveTo(me.xCenter, me.yCenter);
                    ctx.lineTo(position.x, position.y);
                    ctx.stroke();
                }
                ctx.restore();
            }
        },
        /**
	 * @private
	 */ _drawLabels: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            var tickOpts = opts.ticks;
            if (!tickOpts.display) return;
            var startAngle = me.getIndexAngle(0);
            var tickFont = helpers$1.options._parseFont(tickOpts);
            var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
            var offset, width;
            ctx.save();
            ctx.font = tickFont.string;
            ctx.translate(me.xCenter, me.yCenter);
            ctx.rotate(startAngle);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            helpers$1.each(me.ticks, function(label, index) {
                if (index === 0 && !tickOpts.reverse) return;
                offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
                if (tickOpts.showLabelBackdrop) {
                    width = ctx.measureText(label).width;
                    ctx.fillStyle = tickOpts.backdropColor;
                    ctx.fillRect(-width / 2 - tickOpts.backdropPaddingX, -offset - tickFont.size / 2 - tickOpts.backdropPaddingY, width + tickOpts.backdropPaddingX * 2, tickFont.size + tickOpts.backdropPaddingY * 2);
                }
                ctx.fillStyle = tickFontColor;
                ctx.fillText(label, 0, -offset);
            });
            ctx.restore();
        },
        /**
	 * @private
	 */ _drawTitle: helpers$1.noop
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$3 = defaultConfig$3;
    scale_radialLinear._defaults = _defaults$3;
    var deprecated$1 = helpers$1._deprecated;
    var resolve$5 = helpers$1.options.resolve;
    var valueOrDefault$d = helpers$1.valueOrDefault;
    // Integer constants are from the ES6 spec.
    var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
    var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
    var INTERVALS = {
        millisecond: {
            common: true,
            size: 1,
            steps: 1000
        },
        second: {
            common: true,
            size: 1000,
            steps: 60
        },
        minute: {
            common: true,
            size: 60000,
            steps: 60
        },
        hour: {
            common: true,
            size: 3600000,
            steps: 24
        },
        day: {
            common: true,
            size: 86400000,
            steps: 30
        },
        week: {
            common: false,
            size: 604800000,
            steps: 4
        },
        month: {
            common: true,
            size: 2.628e9,
            steps: 12
        },
        quarter: {
            common: false,
            size: 7.884e9,
            steps: 4
        },
        year: {
            common: true,
            size: 3.154e10
        }
    };
    var UNITS = Object.keys(INTERVALS);
    function sorter(a, b) {
        return a - b;
    }
    function arrayUnique(items) {
        var hash = {};
        var out = [];
        var i, ilen, item;
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            if (!hash[item]) {
                hash[item] = true;
                out.push(item);
            }
        }
        return out;
    }
    function getMin(options) {
        return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
    }
    function getMax(options) {
        return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
    }
    /**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */ function buildLookupTable(timestamps, min, max, distribution) {
        if (distribution === 'linear' || !timestamps.length) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        var table = [];
        var items = [
            min
        ];
        var i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr > min && curr < max) items.push(curr);
        }
        items.push(max);
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            // only add points that breaks the scale linearity
            if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    // @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
    function lookup(table, key, value) {
        var lo = 0;
        var hi = table.length - 1;
        var mid, i0, i1;
        while(lo >= 0 && lo <= hi){
            mid = lo + hi >> 1;
            i0 = table[mid - 1] || null;
            i1 = table[mid];
            if (!i0) // given value is outside table (before first item)
            return {
                lo: null,
                hi: i1
            };
            else if (i1[key] < value) lo = mid + 1;
            else if (i0[key] > value) hi = mid - 1;
            else return {
                lo: i0,
                hi: i1
            };
        }
        // given value is outside table (after last item)
        return {
            lo: i1,
            hi: null
        };
    }
    /**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */ function interpolate$1(table, skey, sval, tkey) {
        var range = lookup(table, skey, sval);
        // Note: the lookup table ALWAYS contains at least 2 items (min and max)
        var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
        var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
        var span = next[skey] - prev[skey];
        var ratio = span ? (sval - prev[skey]) / span : 0;
        var offset = (next[tkey] - prev[tkey]) * ratio;
        return prev[tkey] + offset;
    }
    function toTimestamp(scale, input) {
        var adapter = scale._adapter;
        var options = scale.options.time;
        var parser = options.parser;
        var format = parser || options.format;
        var value = input;
        if (typeof parser === 'function') value = parser(value);
        // Only parse if its not a timestamp already
        if (!helpers$1.isFinite(value)) value = typeof format === 'string' ? adapter.parse(value, format) : adapter.parse(value);
        if (value !== null) return +value;
        // Labels are in an incompatible format and no `parser` has been provided.
        // The user might still use the deprecated `format` option for parsing.
        if (!parser && typeof format === 'function') {
            value = format(input);
            // `format` could return something else than a timestamp, if so, parse it
            if (!helpers$1.isFinite(value)) value = adapter.parse(value);
        }
        return value;
    }
    function parse(scale, input) {
        if (helpers$1.isNullOrUndef(input)) return null;
        var options = scale.options.time;
        var value = toTimestamp(scale, scale.getRightValue(input));
        if (value === null) return value;
        if (options.round) value = +scale._adapter.startOf(value, options.round);
        return value;
    }
    /**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */ function determineUnitForAutoTicks(minUnit, min, max, capacity) {
        var ilen = UNITS.length;
        var i, interval, factor;
        for(i = UNITS.indexOf(minUnit); i < ilen - 1; ++i){
            interval = INTERVALS[UNITS[i]];
            factor = interval.steps ? interval.steps : MAX_INTEGER;
            if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return UNITS[i];
        }
        return UNITS[ilen - 1];
    }
    /**
 * Figures out what unit to format a set of ticks with
 */ function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
        var i, unit;
        for(i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--){
            unit = UNITS[i];
            if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
        }
        return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
    }
    function determineMajorUnit(unit) {
        for(var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i){
            if (INTERVALS[UNITS[i]].common) return UNITS[i];
        }
    }
    /**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */ function generate(scale, min, max, capacity) {
        var adapter = scale._adapter;
        var options = scale.options;
        var timeOpts = options.time;
        var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
        var stepSize = resolve$5([
            timeOpts.stepSize,
            timeOpts.unitStepSize,
            1
        ]);
        var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        var first = min;
        var ticks = [];
        var time;
        // For 'week' unit, handle the first day of week option
        if (weekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        // Align first ticks on unit
        first = +adapter.startOf(first, weekday ? 'day' : minor);
        // Prevent browser from freezing in case user options request millions of milliseconds
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
        for(time = first; time < max; time = +adapter.add(time, stepSize, minor))ticks.push(time);
        if (time === max || options.bounds === 'ticks') ticks.push(time);
        return ticks;
    }
    /**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */ function computeOffsets(table, ticks, min, max, options) {
        var start = 0;
        var end = 0;
        var first, last;
        if (options.offset && ticks.length) {
            first = interpolate$1(table, 'time', ticks[0], 'pos');
            if (ticks.length === 1) start = 1 - first;
            else start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
            last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
            if (ticks.length === 1) end = last;
            else end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
        }
        return {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    function setMajorTicks(scale, ticks, map, majorUnit) {
        var adapter = scale._adapter;
        var first = +adapter.startOf(ticks[0].value, majorUnit);
        var last = ticks[ticks.length - 1].value;
        var major, index;
        for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
            index = map[major];
            if (index >= 0) ticks[index].major = true;
        }
        return ticks;
    }
    function ticksFromTimestamps(scale, values, majorUnit) {
        var ticks = [];
        var map = {};
        var ilen = values.length;
        var i, value;
        for(i = 0; i < ilen; ++i){
            value = values[i];
            map[value] = i;
            ticks.push({
                value: value,
                major: false
            });
        }
        // We set the major ticks separately from the above loop because calling startOf for every tick
        // is expensive when there is a large number of ticks
        return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
    }
    var defaultConfig$4 = {
        position: 'bottom',
        /**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */ distribution: 'linear',
        /**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */ bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            displayFormat: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            autoSkip: false,
            /**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */ source: 'auto',
            major: {
                enabled: false
            }
        }
    };
    var scale_time = core_scale.extend({
        initialize: function() {
            this.mergeTicksOptions();
            core_scale.prototype.initialize.call(this);
        },
        update: function() {
            var me = this;
            var options = me.options;
            var time = options.time || (options.time = {});
            var adapter = me._adapter = new core_adapters._date(options.adapters.date);
            // DEPRECATIONS: output a message only one time per update
            deprecated$1('time scale', time.format, 'time.format', 'time.parser');
            deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
            deprecated$1('time scale', time.max, 'time.max', 'ticks.max');
            // Backward compatibility: before introducing adapter, `displayFormats` was
            // supposed to contain *all* unit/string pairs but this can't be resolved
            // when loading the scale (adapters are loaded afterward), so let's populate
            // missing formats on update
            helpers$1.mergeIf(time.displayFormats, adapter.formats());
            return core_scale.prototype.update.apply(me, arguments);
        },
        /**
	 * Allows data to be referenced via 't' attribute
	 */ getRightValue: function(rawValue) {
            if (rawValue && rawValue.t !== undefined) rawValue = rawValue.t;
            return core_scale.prototype.getRightValue.call(this, rawValue);
        },
        determineDataLimits: function() {
            var me = this;
            var chart = me.chart;
            var adapter = me._adapter;
            var options = me.options;
            var unit = options.time.unit || 'day';
            var min = MAX_INTEGER;
            var max = MIN_INTEGER;
            var timestamps = [];
            var datasets = [];
            var labels = [];
            var i, j, ilen, jlen, data, timestamp, labelsAdded;
            var dataLabels = me._getLabels();
            for(i = 0, ilen = dataLabels.length; i < ilen; ++i)labels.push(parse(me, dataLabels[i]));
            for(i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                data = chart.data.datasets[i].data;
                // Let's consider that all data have the same format.
                if (helpers$1.isObject(data[0])) {
                    datasets[i] = [];
                    for(j = 0, jlen = data.length; j < jlen; ++j){
                        timestamp = parse(me, data[j]);
                        timestamps.push(timestamp);
                        datasets[i][j] = timestamp;
                    }
                } else {
                    datasets[i] = labels.slice(0);
                    if (!labelsAdded) {
                        timestamps = timestamps.concat(labels);
                        labelsAdded = true;
                    }
                }
            } else datasets[i] = [];
            if (labels.length) {
                min = Math.min(min, labels[0]);
                max = Math.max(max, labels[labels.length - 1]);
            }
            if (timestamps.length) {
                timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
                min = Math.min(min, timestamps[0]);
                max = Math.max(max, timestamps[timestamps.length - 1]);
            }
            min = parse(me, getMin(options)) || min;
            max = parse(me, getMax(options)) || max;
            // In case there is no valid min/max, set limits based on unit time option
            min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
            max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;
            // Make sure that max is strictly higher than min (required by the lookup table)
            me.min = Math.min(min, max);
            me.max = Math.max(min + 1, max);
            // PRIVATE
            me._table = [];
            me._timestamps = {
                data: timestamps,
                datasets: datasets,
                labels: labels
            };
        },
        buildTicks: function() {
            var me = this;
            var min = me.min;
            var max = me.max;
            var options = me.options;
            var tickOpts = options.ticks;
            var timeOpts = options.time;
            var timestamps = me._timestamps;
            var ticks = [];
            var capacity = me.getLabelCapacity(min);
            var source = tickOpts.source;
            var distribution = options.distribution;
            var i, ilen, timestamp;
            if (source === 'data' || source === 'auto' && distribution === 'series') timestamps = timestamps.data;
            else if (source === 'labels') timestamps = timestamps.labels;
            else timestamps = generate(me, min, max, capacity);
            if (options.bounds === 'ticks' && timestamps.length) {
                min = timestamps[0];
                max = timestamps[timestamps.length - 1];
            }
            // Enforce limits with user min/max options
            min = parse(me, getMin(options)) || min;
            max = parse(me, getMax(options)) || max;
            // Remove ticks outside the min/max range
            for(i = 0, ilen = timestamps.length; i < ilen; ++i){
                timestamp = timestamps[i];
                if (timestamp >= min && timestamp <= max) ticks.push(timestamp);
            }
            me.min = min;
            me.max = max;
            // PRIVATE
            // determineUnitForFormatting relies on the number of ticks so we don't use it when
            // autoSkip is enabled because we don't yet know what the final number of ticks will be
            me._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity) : determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
            me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined : determineMajorUnit(me._unit);
            me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
            me._offsets = computeOffsets(me._table, ticks, min, max, options);
            if (tickOpts.reverse) ticks.reverse();
            return ticksFromTimestamps(me, ticks, me._majorUnit);
        },
        getLabelForIndex: function(index, datasetIndex) {
            var me = this;
            var adapter = me._adapter;
            var data = me.chart.data;
            var timeOpts = me.options.time;
            var label = data.labels && index < data.labels.length ? data.labels[index] : '';
            var value = data.datasets[datasetIndex].data[index];
            if (helpers$1.isObject(value)) label = me.getRightValue(value);
            if (timeOpts.tooltipFormat) return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
            if (typeof label === 'string') return label;
            return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
        },
        /**
	 * Function to format an individual tick mark
	 * @private
	 */ tickFormatFunction: function(time, index, ticks, format) {
            var me = this;
            var adapter = me._adapter;
            var options = me.options;
            var formats = options.time.displayFormats;
            var minorFormat = formats[me._unit];
            var majorUnit = me._majorUnit;
            var majorFormat = formats[majorUnit];
            var tick = ticks[index];
            var tickOpts = options.ticks;
            var major = majorUnit && majorFormat && tick && tick.major;
            var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
            var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
            var formatter = resolve$5([
                nestedTickOpts.callback,
                nestedTickOpts.userCallback,
                tickOpts.callback,
                tickOpts.userCallback
            ]);
            return formatter ? formatter(label, index, ticks) : label;
        },
        convertTicksToLabels: function(ticks) {
            var labels = [];
            var i, ilen;
            for(i = 0, ilen = ticks.length; i < ilen; ++i)labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
            return labels;
        },
        /**
	 * @private
	 */ getPixelForOffset: function(time) {
            var me = this;
            var offsets = me._offsets;
            var pos = interpolate$1(me._table, 'time', time, 'pos');
            return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
        },
        getPixelForValue: function(value, index, datasetIndex) {
            var me = this;
            var time = null;
            if (index !== undefined && datasetIndex !== undefined) time = me._timestamps.datasets[datasetIndex][index];
            if (time === null) time = parse(me, value);
            if (time !== null) return me.getPixelForOffset(time);
        },
        getPixelForTick: function(index) {
            var ticks = this.getTicks();
            return index >= 0 && index < ticks.length ? this.getPixelForOffset(ticks[index].value) : null;
        },
        getValueForPixel: function(pixel) {
            var me = this;
            var offsets = me._offsets;
            var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
            var time = interpolate$1(me._table, 'pos', pos, 'time');
            // DEPRECATION, we should return time directly
            return me._adapter._create(time);
        },
        /**
	 * @private
	 */ _getLabelSize: function(label) {
            var me = this;
            var ticksOpts = me.options.ticks;
            var tickLabelWidth = me.ctx.measureText(label).width;
            var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
            var cosRotation = Math.cos(angle);
            var sinRotation = Math.sin(angle);
            var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
            return {
                w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
                h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
            };
        },
        /**
	 * Crude approximation of what the label width might be
	 * @private
	 */ getLabelWidth: function(label) {
            return this._getLabelSize(label).w;
        },
        /**
	 * @private
	 */ getLabelCapacity: function(exampleTime) {
            var me = this;
            var timeOpts = me.options.time;
            var displayFormats = timeOpts.displayFormats;
            // pick the longest format (milliseconds) for guestimation
            var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
            var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [
                exampleTime
            ], me._majorUnit), format);
            var size = me._getLabelSize(exampleLabel);
            var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
            if (me.options.offset) capacity--;
            return capacity > 0 ? capacity : 1;
        }
    });
    // INTERNAL: static default options, registered in src/index.js
    var _defaults$4 = defaultConfig$4;
    scale_time._defaults = _defaults$4;
    var scales = {
        category: scale_category,
        linear: scale_linear,
        logarithmic: scale_logarithmic,
        radialLinear: scale_radialLinear,
        time: scale_time
    };
    var FORMATS = {
        datetime: 'MMM D, YYYY, h:mm:ss a',
        millisecond: 'h:mm:ss.SSS a',
        second: 'h:mm:ss a',
        minute: 'h:mm a',
        hour: 'hA',
        day: 'MMM D',
        week: 'll',
        month: 'MMM YYYY',
        quarter: '[Q]Q - YYYY',
        year: 'YYYY'
    };
    core_adapters._date.override(typeof moment === 'function' ? {
        _id: 'moment',
        formats: function() {
            return FORMATS;
        },
        parse: function(value, format) {
            if (typeof value === 'string' && typeof format === 'string') value = moment(value, format);
            else if (!(value instanceof moment)) value = moment(value);
            return value.isValid() ? value.valueOf() : null;
        },
        format: function(time, format) {
            return moment(time).format(format);
        },
        add: function(time, amount, unit) {
            return moment(time).add(amount, unit).valueOf();
        },
        diff: function(max, min, unit) {
            return moment(max).diff(moment(min), unit);
        },
        startOf: function(time, unit, weekday) {
            time = moment(time);
            if (unit === 'isoWeek') return time.isoWeekday(weekday).valueOf();
            return time.startOf(unit).valueOf();
        },
        endOf: function(time, unit) {
            return moment(time).endOf(unit).valueOf();
        },
        // DEPRECATIONS
        /**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */ _create: function(time) {
            return moment(time);
        }
    } : {});
    core_defaults._set('global', {
        plugins: {
            filler: {
                propagate: true
            }
        }
    });
    var mappers = {
        dataset: function(source) {
            var index = source.fill;
            var chart = source.chart;
            var meta = chart.getDatasetMeta(index);
            var visible = meta && chart.isDatasetVisible(index);
            var points = visible && meta.dataset._children || [];
            var length = points.length || 0;
            return !length ? null : function(point, i) {
                return i < length && points[i]._view || null;
            };
        },
        boundary: function(source) {
            var boundary = source.boundary;
            var x = boundary ? boundary.x : null;
            var y = boundary ? boundary.y : null;
            if (helpers$1.isArray(boundary)) return function(point, i) {
                return boundary[i];
            };
            return function(point) {
                return {
                    x: x === null ? point.x : x,
                    y: y === null ? point.y : y
                };
            };
        }
    };
    // @todo if (fill[0] === '#')
    function decodeFill(el, index, count) {
        var model = el._model || {};
        var fill = model.fill;
        var target;
        if (fill === undefined) fill = !!model.backgroundColor;
        if (fill === false || fill === null) return false;
        if (fill === true) return 'origin';
        target = parseFloat(fill, 10);
        if (isFinite(target) && Math.floor(target) === target) {
            if (fill[0] === '-' || fill[0] === '+') target = index + target;
            if (target === index || target < 0 || target >= count) return false;
            return target;
        }
        switch(fill){
            // compatibility
            case 'bottom':
                return 'start';
            case 'top':
                return 'end';
            case 'zero':
                return 'origin';
            // supported boundaries
            case 'origin':
            case 'start':
            case 'end':
                return fill;
            // invalid fill values
            default:
                return false;
        }
    }
    function computeLinearBoundary(source) {
        var model = source.el._model || {};
        var scale = source.el._scale || {};
        var fill = source.fill;
        var target = null;
        var horizontal;
        if (isFinite(fill)) return null;
        // Backward compatibility: until v3, we still need to support boundary values set on
        // the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
        // controllers might still use it (e.g. the Smith chart).
        if (fill === 'start') target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
        else if (fill === 'end') target = model.scaleTop === undefined ? scale.top : model.scaleTop;
        else if (model.scaleZero !== undefined) target = model.scaleZero;
        else if (scale.getBasePixel) target = scale.getBasePixel();
        if (target !== undefined && target !== null) {
            if (target.x !== undefined && target.y !== undefined) return target;
            if (helpers$1.isFinite(target)) {
                horizontal = scale.isHorizontal();
                return {
                    x: horizontal ? target : null,
                    y: horizontal ? null : target
                };
            }
        }
        return null;
    }
    function computeCircularBoundary(source) {
        var scale = source.el._scale;
        var options = scale.options;
        var length = scale.chart.data.labels.length;
        var fill = source.fill;
        var target = [];
        var start, end, center, i, point;
        if (!length) return null;
        start = options.ticks.reverse ? scale.max : scale.min;
        end = options.ticks.reverse ? scale.min : scale.max;
        center = scale.getPointPositionForValue(0, start);
        for(i = 0; i < length; ++i){
            point = fill === 'start' || fill === 'end' ? scale.getPointPositionForValue(i, fill === 'start' ? start : end) : scale.getBasePosition(i);
            if (options.gridLines.circular) {
                point.cx = center.x;
                point.cy = center.y;
                point.angle = scale.getIndexAngle(i) - Math.PI / 2;
            }
            target.push(point);
        }
        return target;
    }
    function computeBoundary(source) {
        var scale = source.el._scale || {};
        if (scale.getPointPositionForValue) return computeCircularBoundary(source);
        return computeLinearBoundary(source);
    }
    function resolveTarget(sources, index, propagate) {
        var source = sources[index];
        var fill = source.fill;
        var visited = [
            index
        ];
        var target;
        if (!propagate) return fill;
        while(fill !== false && visited.indexOf(fill) === -1){
            if (!isFinite(fill)) return fill;
            target = sources[fill];
            if (!target) return false;
            if (target.visible) return fill;
            visited.push(fill);
            fill = target.fill;
        }
        return false;
    }
    function createMapper(source) {
        var fill = source.fill;
        var type = 'dataset';
        if (fill === false) return null;
        if (!isFinite(fill)) type = 'boundary';
        return mappers[type](source);
    }
    function isDrawable(point) {
        return point && !point.skip;
    }
    function drawArea(ctx, curve0, curve1, len0, len1) {
        var i, cx, cy, r;
        if (!len0 || !len1) return;
        // building first area curve (normal)
        ctx.moveTo(curve0[0].x, curve0[0].y);
        for(i = 1; i < len0; ++i)helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
        if (curve1[0].angle !== undefined) {
            cx = curve1[0].cx;
            cy = curve1[0].cy;
            r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
            for(i = len1 - 1; i > 0; --i)ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
            return;
        }
        // joining the two area curves
        ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
        // building opposite area curve (reverse)
        for(i = len1 - 1; i > 0; --i)helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
    }
    function doFill(ctx, points, mapper, view, color, loop) {
        var count = points.length;
        var span = view.spanGaps;
        var curve0 = [];
        var curve1 = [];
        var len0 = 0;
        var len1 = 0;
        var i, ilen, index, p0, p1, d0, d1, loopOffset;
        ctx.beginPath();
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i % count;
            p0 = points[index]._view;
            p1 = mapper(p0, index, view);
            d0 = isDrawable(p0);
            d1 = isDrawable(p1);
            if (loop && loopOffset === undefined && d0) {
                loopOffset = i + 1;
                ilen = count + loopOffset;
            }
            if (d0 && d1) {
                len0 = curve0.push(p0);
                len1 = curve1.push(p1);
            } else if (len0 && len1) {
                if (!span) {
                    drawArea(ctx, curve0, curve1, len0, len1);
                    len0 = len1 = 0;
                    curve0 = [];
                    curve1 = [];
                } else {
                    if (d0) curve0.push(p0);
                    if (d1) curve1.push(p1);
                }
            }
        }
        drawArea(ctx, curve0, curve1, len0, len1);
        ctx.closePath();
        ctx.fillStyle = color;
        ctx.fill();
    }
    var plugin_filler = {
        id: 'filler',
        afterDatasetsUpdate: function(chart, options) {
            var count = (chart.data.datasets || []).length;
            var propagate = options.propagate;
            var sources = [];
            var meta, i, el, source;
            for(i = 0; i < count; ++i){
                meta = chart.getDatasetMeta(i);
                el = meta.dataset;
                source = null;
                if (el && el._model && el instanceof elements.Line) source = {
                    visible: chart.isDatasetVisible(i),
                    fill: decodeFill(el, i, count),
                    chart: chart,
                    el: el
                };
                meta.$filler = source;
                sources.push(source);
            }
            for(i = 0; i < count; ++i){
                source = sources[i];
                if (!source) continue;
                source.fill = resolveTarget(sources, i, propagate);
                source.boundary = computeBoundary(source);
                source.mapper = createMapper(source);
            }
        },
        beforeDatasetsDraw: function(chart) {
            var metasets = chart._getSortedVisibleDatasetMetas();
            var ctx = chart.ctx;
            var meta, i, el, view, points, mapper, color;
            for(i = metasets.length - 1; i >= 0; --i){
                meta = metasets[i].$filler;
                if (!meta || !meta.visible) continue;
                el = meta.el;
                view = el._view;
                points = el._children || [];
                mapper = meta.mapper;
                color = view.backgroundColor || core_defaults.global.defaultColor;
                if (mapper && color && points.length) {
                    helpers$1.canvas.clipArea(ctx, chart.chartArea);
                    doFill(ctx, points, mapper, view, color, el._loop);
                    helpers$1.canvas.unclipArea(ctx);
                }
            }
        }
    };
    var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
    var noop$1 = helpers$1.noop;
    var valueOrDefault$e = helpers$1.valueOrDefault;
    core_defaults._set('global', {
        legend: {
            display: true,
            position: 'top',
            align: 'center',
            fullWidth: true,
            reverse: false,
            weight: 1000,
            // a callback that will handle
            onClick: function(e, legendItem) {
                var index = legendItem.datasetIndex;
                var ci = this.chart;
                var meta = ci.getDatasetMeta(index);
                // See controller.isDatasetVisible comment
                meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
                // We hid a dataset ... rerender the chart
                ci.update();
            },
            onHover: null,
            onLeave: null,
            labels: {
                boxWidth: 40,
                padding: 10,
                // Generates labels shown in the legend
                // Valid properties to return:
                // text : text to display
                // fillStyle : fill of coloured box
                // strokeStyle: stroke of coloured box
                // hidden : if this legend item refers to a hidden item
                // lineCap : cap style for line
                // lineDash
                // lineDashOffset :
                // lineJoin :
                // lineWidth :
                generateLabels: function(chart) {
                    var datasets = chart.data.datasets;
                    var options = chart.options.legend || {};
                    var usePointStyle = options.labels && options.labels.usePointStyle;
                    return chart._getSortedDatasetMetas().map(function(meta) {
                        var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                        return {
                            text: datasets[meta.index].label,
                            fillStyle: style.backgroundColor,
                            hidden: !chart.isDatasetVisible(meta.index),
                            lineCap: style.borderCapStyle,
                            lineDash: style.borderDash,
                            lineDashOffset: style.borderDashOffset,
                            lineJoin: style.borderJoinStyle,
                            lineWidth: style.borderWidth,
                            strokeStyle: style.borderColor,
                            pointStyle: style.pointStyle,
                            rotation: style.rotation,
                            // Below is extra data used for toggling the datasets
                            datasetIndex: meta.index
                        };
                    }, this);
                }
            }
        },
        legendCallback: function(chart) {
            var list = document.createElement('ul');
            var datasets = chart.data.datasets;
            var i, ilen, listItem, listItemSpan;
            list.setAttribute('class', chart.id + '-legend');
            for(i = 0, ilen = datasets.length; i < ilen; i++){
                listItem = list.appendChild(document.createElement('li'));
                listItemSpan = listItem.appendChild(document.createElement('span'));
                listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
                if (datasets[i].label) listItem.appendChild(document.createTextNode(datasets[i].label));
            }
            return list.outerHTML;
        }
    });
    /**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */ function getBoxWidth(labelOpts, fontSize) {
        return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ? fontSize : labelOpts.boxWidth;
    }
    /**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */ var Legend = core_element.extend({
        initialize: function(config) {
            var me = this;
            helpers$1.extend(me, config);
            // Contains hit boxes for each dataset (in dataset order)
            me.legendHitBoxes = [];
            /**
 		 * @private
 		 */ me._hoveredItem = null;
            // Are we in doughnut mode which has a different data type
            me.doughnutMode = false;
        },
        // These methods are ordered by lifecycle. Utilities then follow.
        // Any function defined here is inherited by all legend types.
        // Any function can be extended by the legend type
        beforeUpdate: noop$1,
        update: function(maxWidth, maxHeight, margins) {
            var me = this;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = margins;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Labels
            me.beforeBuildLabels();
            me.buildLabels();
            me.afterBuildLabels();
            // Fit
            me.beforeFit();
            me.fit();
            me.afterFit();
            //
            me.afterUpdate();
            return me.minSize;
        },
        afterUpdate: noop$1,
        //
        beforeSetDimensions: noop$1,
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
            // Reset minSize
            me.minSize = {
                width: 0,
                height: 0
            };
        },
        afterSetDimensions: noop$1,
        //
        beforeBuildLabels: noop$1,
        buildLabels: function() {
            var me = this;
            var labelOpts = me.options.labels || {};
            var legendItems = helpers$1.callback(labelOpts.generateLabels, [
                me.chart
            ], me) || [];
            if (labelOpts.filter) legendItems = legendItems.filter(function(item) {
                return labelOpts.filter(item, me.chart.data);
            });
            if (me.options.reverse) legendItems.reverse();
            me.legendItems = legendItems;
        },
        afterBuildLabels: noop$1,
        //
        beforeFit: noop$1,
        fit: function() {
            var me = this;
            var opts = me.options;
            var labelOpts = opts.labels;
            var display = opts.display;
            var ctx = me.ctx;
            var labelFont = helpers$1.options._parseFont(labelOpts);
            var fontSize = labelFont.size;
            // Reset hit boxes
            var hitboxes = me.legendHitBoxes = [];
            var minSize = me.minSize;
            var isHorizontal = me.isHorizontal();
            if (isHorizontal) {
                minSize.width = me.maxWidth; // fill all the width
                minSize.height = display ? 10 : 0;
            } else {
                minSize.width = display ? 10 : 0;
                minSize.height = me.maxHeight; // fill all the height
            }
            // Increase sizes here
            if (!display) {
                me.width = minSize.width = me.height = minSize.height = 0;
                return;
            }
            ctx.font = labelFont.string;
            if (isHorizontal) {
                // Labels
                // Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
                var lineWidths = me.lineWidths = [
                    0
                ];
                var totalHeight = 0;
                ctx.textAlign = 'left';
                ctx.textBaseline = 'middle';
                helpers$1.each(me.legendItems, function(legendItem, i) {
                    var boxWidth = getBoxWidth(labelOpts, fontSize);
                    var width = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
                    if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
                        totalHeight += fontSize + labelOpts.padding;
                        lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                    }
                    // Store the hitbox width and height here. Final position will be updated in `draw`
                    hitboxes[i] = {
                        left: 0,
                        top: 0,
                        width: width,
                        height: fontSize
                    };
                    lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
                });
                minSize.height += totalHeight;
            } else {
                var vPadding = labelOpts.padding;
                var columnWidths = me.columnWidths = [];
                var columnHeights = me.columnHeights = [];
                var totalWidth = labelOpts.padding;
                var currentColWidth = 0;
                var currentColHeight = 0;
                helpers$1.each(me.legendItems, function(legendItem, i) {
                    var boxWidth = getBoxWidth(labelOpts, fontSize);
                    var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
                    // If too tall, go to new column
                    if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
                        totalWidth += currentColWidth + labelOpts.padding;
                        columnWidths.push(currentColWidth); // previous column width
                        columnHeights.push(currentColHeight);
                        currentColWidth = 0;
                        currentColHeight = 0;
                    }
                    // Get max width
                    currentColWidth = Math.max(currentColWidth, itemWidth);
                    currentColHeight += fontSize + vPadding;
                    // Store the hitbox width and height here. Final position will be updated in `draw`
                    hitboxes[i] = {
                        left: 0,
                        top: 0,
                        width: itemWidth,
                        height: fontSize
                    };
                });
                totalWidth += currentColWidth;
                columnWidths.push(currentColWidth);
                columnHeights.push(currentColHeight);
                minSize.width += totalWidth;
            }
            me.width = minSize.width;
            me.height = minSize.height;
        },
        afterFit: noop$1,
        // Shared Methods
        isHorizontal: function() {
            return this.options.position === 'top' || this.options.position === 'bottom';
        },
        // Actually draw the legend on the canvas
        draw: function() {
            var me = this;
            var opts = me.options;
            var labelOpts = opts.labels;
            var globalDefaults = core_defaults.global;
            var defaultColor = globalDefaults.defaultColor;
            var lineDefault = globalDefaults.elements.line;
            var legendHeight = me.height;
            var columnHeights = me.columnHeights;
            var legendWidth = me.width;
            var lineWidths = me.lineWidths;
            if (!opts.display) return;
            var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
            var ctx = me.ctx;
            var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
            var labelFont = helpers$1.options._parseFont(labelOpts);
            var fontSize = labelFont.size;
            var cursor;
            // Canvas setup
            ctx.textAlign = rtlHelper.textAlign('left');
            ctx.textBaseline = 'middle';
            ctx.lineWidth = 0.5;
            ctx.strokeStyle = fontColor; // for strikethrough effect
            ctx.fillStyle = fontColor; // render in correct colour
            ctx.font = labelFont.string;
            var boxWidth = getBoxWidth(labelOpts, fontSize);
            var hitboxes = me.legendHitBoxes;
            // current position
            var drawLegendBox = function(x, y, legendItem) {
                if (isNaN(boxWidth) || boxWidth <= 0) return;
                // Set the ctx for the box
                ctx.save();
                var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
                ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
                ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
                ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
                ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
                if (ctx.setLineDash) // IE 9 and 10 do not support line dash
                ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
                if (labelOpts && labelOpts.usePointStyle) {
                    // Recalculate x and y for drawPoint() because its expecting
                    // x and y to be center of figure (instead of top left)
                    var radius = boxWidth * Math.SQRT2 / 2;
                    var centerX = rtlHelper.xPlus(x, boxWidth / 2);
                    var centerY = y + fontSize / 2;
                    // Draw pointStyle as legend symbol
                    helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
                } else {
                    // Draw box as legend symbol
                    ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
                    if (lineWidth !== 0) ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
                }
                ctx.restore();
            };
            var fillText = function(x, y, legendItem, textWidth) {
                var halfFontSize = fontSize / 2;
                var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
                var yMiddle = y + halfFontSize;
                ctx.fillText(legendItem.text, xLeft, yMiddle);
                if (legendItem.hidden) {
                    // Strikethrough the text if hidden
                    ctx.beginPath();
                    ctx.lineWidth = 2;
                    ctx.moveTo(xLeft, yMiddle);
                    ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
                    ctx.stroke();
                }
            };
            var alignmentOffset = function(dimension, blockSize) {
                switch(opts.align){
                    case 'start':
                        return labelOpts.padding;
                    case 'end':
                        return dimension - blockSize;
                    default:
                        return (dimension - blockSize + labelOpts.padding) / 2;
                }
            };
            // Horizontal
            var isHorizontal = me.isHorizontal();
            if (isHorizontal) cursor = {
                x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
                y: me.top + labelOpts.padding,
                line: 0
            };
            else cursor = {
                x: me.left + labelOpts.padding,
                y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
                line: 0
            };
            helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
            var itemHeight = fontSize + labelOpts.padding;
            helpers$1.each(me.legendItems, function(legendItem, i) {
                var textWidth = ctx.measureText(legendItem.text).width;
                var width = boxWidth + fontSize / 2 + textWidth;
                var x = cursor.x;
                var y = cursor.y;
                rtlHelper.setWidth(me.minSize.width);
                // Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
                // instead of me.right and me.bottom because me.width and me.height
                // may have been changed since me.minSize was calculated
                if (isHorizontal) {
                    if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
                        y = cursor.y += itemHeight;
                        cursor.line++;
                        x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
                    }
                } else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
                    x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
                    cursor.line++;
                    y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
                }
                var realX = rtlHelper.x(x);
                drawLegendBox(realX, y, legendItem);
                hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
                hitboxes[i].top = y;
                // Fill the actual label
                fillText(realX, y, legendItem, textWidth);
                if (isHorizontal) cursor.x += width + labelOpts.padding;
                else cursor.y += itemHeight;
            });
            helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
        },
        /**
	 * @private
	 */ _getLegendItemAt: function(x, y) {
            var me = this;
            var i, hitBox, lh;
            if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
                // See if we are touching one of the dataset boxes
                lh = me.legendHitBoxes;
                for(i = 0; i < lh.length; ++i){
                    hitBox = lh[i];
                    if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) // Touching an element
                    return me.legendItems[i];
                }
            }
            return null;
        },
        /**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */ handleEvent: function(e) {
            var me = this;
            var opts = me.options;
            var type = e.type === 'mouseup' ? 'click' : e.type;
            var hoveredItem;
            if (type === 'mousemove') {
                if (!opts.onHover && !opts.onLeave) return;
            } else if (type === 'click') {
                if (!opts.onClick) return;
            } else return;
            // Chart event already has relative position in it
            hoveredItem = me._getLegendItemAt(e.x, e.y);
            if (type === 'click') {
                if (hoveredItem && opts.onClick) // use e.native for backwards compatibility
                opts.onClick.call(me, e.native, hoveredItem);
            } else {
                if (opts.onLeave && hoveredItem !== me._hoveredItem) {
                    if (me._hoveredItem) opts.onLeave.call(me, e.native, me._hoveredItem);
                    me._hoveredItem = hoveredItem;
                }
                if (opts.onHover && hoveredItem) // use e.native for backwards compatibility
                opts.onHover.call(me, e.native, hoveredItem);
            }
        }
    });
    function createNewLegendAndAttach(chart, legendOpts) {
        var legend = new Legend({
            ctx: chart.ctx,
            options: legendOpts,
            chart: chart
        });
        core_layouts.configure(chart, legend, legendOpts);
        core_layouts.addBox(chart, legend);
        chart.legend = legend;
    }
    var plugin_legend = {
        id: 'legend',
        /**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */ _element: Legend,
        beforeInit: function(chart) {
            var legendOpts = chart.options.legend;
            if (legendOpts) createNewLegendAndAttach(chart, legendOpts);
        },
        beforeUpdate: function(chart) {
            var legendOpts = chart.options.legend;
            var legend = chart.legend;
            if (legendOpts) {
                helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
                if (legend) {
                    core_layouts.configure(chart, legend, legendOpts);
                    legend.options = legendOpts;
                } else createNewLegendAndAttach(chart, legendOpts);
            } else if (legend) {
                core_layouts.removeBox(chart, legend);
                delete chart.legend;
            }
        },
        afterEvent: function(chart, e) {
            var legend = chart.legend;
            if (legend) legend.handleEvent(e);
        }
    };
    var noop$2 = helpers$1.noop;
    core_defaults._set('global', {
        title: {
            display: false,
            fontStyle: 'bold',
            fullWidth: true,
            padding: 10,
            position: 'top',
            text: '',
            weight: 2000 // by default greater than legend (1000) to be above
        }
    });
    /**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */ var Title = core_element.extend({
        initialize: function(config) {
            var me = this;
            helpers$1.extend(me, config);
            // Contains hit boxes for each dataset (in dataset order)
            me.legendHitBoxes = [];
        },
        // These methods are ordered by lifecycle. Utilities then follow.
        beforeUpdate: noop$2,
        update: function(maxWidth, maxHeight, margins) {
            var me = this;
            // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
            me.beforeUpdate();
            // Absorb the master measurements
            me.maxWidth = maxWidth;
            me.maxHeight = maxHeight;
            me.margins = margins;
            // Dimensions
            me.beforeSetDimensions();
            me.setDimensions();
            me.afterSetDimensions();
            // Labels
            me.beforeBuildLabels();
            me.buildLabels();
            me.afterBuildLabels();
            // Fit
            me.beforeFit();
            me.fit();
            me.afterFit();
            //
            me.afterUpdate();
            return me.minSize;
        },
        afterUpdate: noop$2,
        //
        beforeSetDimensions: noop$2,
        setDimensions: function() {
            var me = this;
            // Set the unconstrained dimension before label rotation
            if (me.isHorizontal()) {
                // Reset position before calculating rotation
                me.width = me.maxWidth;
                me.left = 0;
                me.right = me.width;
            } else {
                me.height = me.maxHeight;
                // Reset position before calculating rotation
                me.top = 0;
                me.bottom = me.height;
            }
            // Reset padding
            me.paddingLeft = 0;
            me.paddingTop = 0;
            me.paddingRight = 0;
            me.paddingBottom = 0;
            // Reset minSize
            me.minSize = {
                width: 0,
                height: 0
            };
        },
        afterSetDimensions: noop$2,
        //
        beforeBuildLabels: noop$2,
        buildLabels: noop$2,
        afterBuildLabels: noop$2,
        //
        beforeFit: noop$2,
        fit: function() {
            var me = this;
            var opts = me.options;
            var minSize = me.minSize = {};
            var isHorizontal = me.isHorizontal();
            var lineCount, textSize;
            if (!opts.display) {
                me.width = minSize.width = me.height = minSize.height = 0;
                return;
            }
            lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
            textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
            me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
            me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
        },
        afterFit: noop$2,
        // Shared Methods
        isHorizontal: function() {
            var pos = this.options.position;
            return pos === 'top' || pos === 'bottom';
        },
        // Actually draw the title block on the canvas
        draw: function() {
            var me = this;
            var ctx = me.ctx;
            var opts = me.options;
            if (!opts.display) return;
            var fontOpts = helpers$1.options._parseFont(opts);
            var lineHeight = fontOpts.lineHeight;
            var offset = lineHeight / 2 + opts.padding;
            var rotation = 0;
            var top = me.top;
            var left = me.left;
            var bottom = me.bottom;
            var right = me.right;
            var maxWidth, titleX, titleY;
            ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
            ctx.font = fontOpts.string;
            // Horizontal
            if (me.isHorizontal()) {
                titleX = left + (right - left) / 2; // midpoint of the width
                titleY = top + offset;
                maxWidth = right - left;
            } else {
                titleX = opts.position === 'left' ? left + offset : right - offset;
                titleY = top + (bottom - top) / 2;
                maxWidth = bottom - top;
                rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
            }
            ctx.save();
            ctx.translate(titleX, titleY);
            ctx.rotate(rotation);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            var text = opts.text;
            if (helpers$1.isArray(text)) {
                var y = 0;
                for(var i = 0; i < text.length; ++i){
                    ctx.fillText(text[i], 0, y, maxWidth);
                    y += lineHeight;
                }
            } else ctx.fillText(text, 0, 0, maxWidth);
            ctx.restore();
        }
    });
    function createNewTitleBlockAndAttach(chart, titleOpts) {
        var title = new Title({
            ctx: chart.ctx,
            options: titleOpts,
            chart: chart
        });
        core_layouts.configure(chart, title, titleOpts);
        core_layouts.addBox(chart, title);
        chart.titleBlock = title;
    }
    var plugin_title = {
        id: 'title',
        /**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */ _element: Title,
        beforeInit: function(chart) {
            var titleOpts = chart.options.title;
            if (titleOpts) createNewTitleBlockAndAttach(chart, titleOpts);
        },
        beforeUpdate: function(chart) {
            var titleOpts = chart.options.title;
            var titleBlock = chart.titleBlock;
            if (titleOpts) {
                helpers$1.mergeIf(titleOpts, core_defaults.global.title);
                if (titleBlock) {
                    core_layouts.configure(chart, titleBlock, titleOpts);
                    titleBlock.options = titleOpts;
                } else createNewTitleBlockAndAttach(chart, titleOpts);
            } else if (titleBlock) {
                core_layouts.removeBox(chart, titleBlock);
                delete chart.titleBlock;
            }
        }
    };
    var plugins = {};
    var filler = plugin_filler;
    var legend = plugin_legend;
    var title = plugin_title;
    plugins.filler = filler;
    plugins.legend = legend;
    plugins.title = title;
    /**
 * @namespace Chart
 */ core_controller.helpers = helpers$1;
    // @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
    core_helpers();
    core_controller._adapters = core_adapters;
    core_controller.Animation = core_animation;
    core_controller.animationService = core_animations;
    core_controller.controllers = controllers;
    core_controller.DatasetController = core_datasetController;
    core_controller.defaults = core_defaults;
    core_controller.Element = core_element;
    core_controller.elements = elements;
    core_controller.Interaction = core_interaction;
    core_controller.layouts = core_layouts;
    core_controller.platform = platform;
    core_controller.plugins = core_plugins;
    core_controller.Scale = core_scale;
    core_controller.scaleService = core_scaleService;
    core_controller.Ticks = core_ticks;
    core_controller.Tooltip = core_tooltip;
    // Register built-in scales
    core_controller.helpers.each(scales, function(scale, type) {
        core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
    });
    // Load to register built-in adapters (as side effects)
    // Loading built-in plugins
    for(var k in plugins)if (plugins.hasOwnProperty(k)) core_controller.plugins.register(plugins[k]);
    core_controller.platform.initialize();
    var src = core_controller;
    if (typeof window !== 'undefined') window.Chart = core_controller;
    // DEPRECATIONS
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */ core_controller.Chart = core_controller;
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.Legend = plugins.legend._element;
    /**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.Title = plugins.title._element;
    /**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */ core_controller.pluginService = core_controller.plugins;
    /**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */ core_controller.PluginBase = core_controller.Element.extend({});
    /**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */ core_controller.canvasHelpers = core_controller.helpers.canvas;
    /**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */ core_controller.layoutService = core_controller.layouts;
    /**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */ core_controller.LinearScaleBase = scale_linearbase;
    /**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */ core_controller.helpers.each([
        'Bar',
        'Bubble',
        'Doughnut',
        'Line',
        'PolarArea',
        'Radar',
        'Scatter'
    ], function(klass) {
        core_controller[klass] = function(ctx, cfg) {
            return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
                type: klass.charAt(0).toLowerCase() + klass.slice(1)
            }));
        };
    });
    return src;
});

});
parcelRegister("lwFFd", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});


parcelRegister("18li2", function(module, exports) {

var $7YZ47 = parcelRequire("7YZ47");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $0d370d876a00db75$var$isEqual(value, other) {
    return $7YZ47(value, other);
}
module.exports = $0d370d876a00db75$var$isEqual;

});
parcelRegister("7YZ47", function(module, exports) {

var $h0lES = parcelRequire("h0lES");

var $j6OnI = parcelRequire("j6OnI");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $5cfd8157fcc50a11$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$j6OnI(value) && !$j6OnI(other)) return value !== value && other !== other;
    return $h0lES(value, other, bitmask, customizer, $5cfd8157fcc50a11$var$baseIsEqual, stack);
}
module.exports = $5cfd8157fcc50a11$var$baseIsEqual;

});
parcelRegister("h0lES", function(module, exports) {

var $bol3e = parcelRequire("bol3e");

var $lrDxq = parcelRequire("lrDxq");

var $ivqYy = parcelRequire("ivqYy");

var $5qhQ8 = parcelRequire("5qhQ8");

var $99urM = parcelRequire("99urM");

var $doy0R = parcelRequire("doy0R");

var $lAY4l = parcelRequire("lAY4l");

var $fv2qo = parcelRequire("fv2qo");
/** Used to compose bitmasks for value comparisons. */ var $c6133ca71cfb5552$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $c6133ca71cfb5552$var$argsTag = '[object Arguments]', $c6133ca71cfb5552$var$arrayTag = '[object Array]', $c6133ca71cfb5552$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $c6133ca71cfb5552$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c6133ca71cfb5552$var$hasOwnProperty = $c6133ca71cfb5552$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $c6133ca71cfb5552$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $doy0R(object), othIsArr = $doy0R(other), objTag = objIsArr ? $c6133ca71cfb5552$var$arrayTag : $99urM(object), othTag = othIsArr ? $c6133ca71cfb5552$var$arrayTag : $99urM(other);
    objTag = objTag == $c6133ca71cfb5552$var$argsTag ? $c6133ca71cfb5552$var$objectTag : objTag;
    othTag = othTag == $c6133ca71cfb5552$var$argsTag ? $c6133ca71cfb5552$var$objectTag : othTag;
    var objIsObj = objTag == $c6133ca71cfb5552$var$objectTag, othIsObj = othTag == $c6133ca71cfb5552$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $lAY4l(object)) {
        if (!$lAY4l(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $bol3e);
        return objIsArr || $fv2qo(object) ? $lrDxq(object, other, bitmask, customizer, equalFunc, stack) : $ivqYy(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $c6133ca71cfb5552$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $c6133ca71cfb5552$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $c6133ca71cfb5552$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $bol3e);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $bol3e);
    return $5qhQ8(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $c6133ca71cfb5552$var$baseIsEqualDeep;

});
parcelRegister("bol3e", function(module, exports) {

var $9Z1eD = parcelRequire("9Z1eD");

var $9UFvR = parcelRequire("9UFvR");

var $7o8nv = parcelRequire("7o8nv");

var $7KmFW = parcelRequire("7KmFW");

var $15l9f = parcelRequire("15l9f");

var $9TGiO = parcelRequire("9TGiO");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $84b243e8c27b2c87$var$Stack(entries) {
    var data = this.__data__ = new $9Z1eD(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$84b243e8c27b2c87$var$Stack.prototype.clear = $9UFvR;
$84b243e8c27b2c87$var$Stack.prototype['delete'] = $7o8nv;
$84b243e8c27b2c87$var$Stack.prototype.get = $7KmFW;
$84b243e8c27b2c87$var$Stack.prototype.has = $15l9f;
$84b243e8c27b2c87$var$Stack.prototype.set = $9TGiO;
module.exports = $84b243e8c27b2c87$var$Stack;

});
parcelRegister("9Z1eD", function(module, exports) {

var $7jkdx = parcelRequire("7jkdx");

var $a1sAe = parcelRequire("a1sAe");

var $firge = parcelRequire("firge");

var $enlYV = parcelRequire("enlYV");

var $4ddrU = parcelRequire("4ddrU");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $744ac4cea5322b09$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$744ac4cea5322b09$var$ListCache.prototype.clear = $7jkdx;
$744ac4cea5322b09$var$ListCache.prototype['delete'] = $a1sAe;
$744ac4cea5322b09$var$ListCache.prototype.get = $firge;
$744ac4cea5322b09$var$ListCache.prototype.has = $enlYV;
$744ac4cea5322b09$var$ListCache.prototype.set = $4ddrU;
module.exports = $744ac4cea5322b09$var$ListCache;

});
parcelRegister("7jkdx", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $5529fd81b0128632$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $5529fd81b0128632$var$listCacheClear;

});

parcelRegister("a1sAe", function(module, exports) {

var $7roW4 = parcelRequire("7roW4");
/** Used for built-in method references. */ var $74c02b71ef24de5a$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $74c02b71ef24de5a$var$splice = $74c02b71ef24de5a$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $74c02b71ef24de5a$var$listCacheDelete(key) {
    var data = this.__data__, index = $7roW4(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $74c02b71ef24de5a$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $74c02b71ef24de5a$var$listCacheDelete;

});
parcelRegister("7roW4", function(module, exports) {

var $cwveb = parcelRequire("cwveb");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $56ae65b9c01155d5$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($cwveb(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $56ae65b9c01155d5$var$assocIndexOf;

});
parcelRegister("cwveb", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $91e0b262482092a2$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $91e0b262482092a2$var$eq;

});



parcelRegister("firge", function(module, exports) {

var $7roW4 = parcelRequire("7roW4");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b22daee5aeceae68$var$listCacheGet(key) {
    var data = this.__data__, index = $7roW4(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $b22daee5aeceae68$var$listCacheGet;

});

parcelRegister("enlYV", function(module, exports) {

var $7roW4 = parcelRequire("7roW4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a77443c729112c63$var$listCacheHas(key) {
    return $7roW4(this.__data__, key) > -1;
}
module.exports = $a77443c729112c63$var$listCacheHas;

});

parcelRegister("4ddrU", function(module, exports) {

var $7roW4 = parcelRequire("7roW4");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $3112cf0536f9e7df$var$listCacheSet(key, value) {
    var data = this.__data__, index = $7roW4(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $3112cf0536f9e7df$var$listCacheSet;

});


parcelRegister("9UFvR", function(module, exports) {

var $9Z1eD = parcelRequire("9Z1eD");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $73798b972efb9809$var$stackClear() {
    this.__data__ = new $9Z1eD;
    this.size = 0;
}
module.exports = $73798b972efb9809$var$stackClear;

});

parcelRegister("7o8nv", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $561146006c502746$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $561146006c502746$var$stackDelete;

});

parcelRegister("7KmFW", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5a3e6b26f67173d9$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $5a3e6b26f67173d9$var$stackGet;

});

parcelRegister("15l9f", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0ca6a9a4b1af7d29$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $0ca6a9a4b1af7d29$var$stackHas;

});

parcelRegister("9TGiO", function(module, exports) {

var $9Z1eD = parcelRequire("9Z1eD");

var $8gpOE = parcelRequire("8gpOE");

var $k07oG = parcelRequire("k07oG");
/** Used as the size to enable large array optimizations. */ var $734a10816f758857$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $734a10816f758857$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $9Z1eD) {
        var pairs = data.__data__;
        if (!$8gpOE || pairs.length < $734a10816f758857$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $k07oG(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $734a10816f758857$var$stackSet;

});
parcelRegister("8gpOE", function(module, exports) {

var $7V3LB = parcelRequire("7V3LB");

var $2a2fA = parcelRequire("2a2fA");
/* Built-in method references that are verified to be native. */ var $018d7b3956b4aa40$var$Map = $7V3LB($2a2fA, 'Map');
module.exports = $018d7b3956b4aa40$var$Map;

});
parcelRegister("7V3LB", function(module, exports) {

var $j4VrS = parcelRequire("j4VrS");

var $1b5Yz = parcelRequire("1b5Yz");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5c40c741cd6fbdc2$var$getNative(object, key) {
    var value = $1b5Yz(object, key);
    return $j4VrS(value) ? value : undefined;
}
module.exports = $5c40c741cd6fbdc2$var$getNative;

});
parcelRegister("j4VrS", function(module, exports) {

var $cHIy1 = parcelRequire("cHIy1");

var $clubE = parcelRequire("clubE");

var $aDTZF = parcelRequire("aDTZF");

var $gydXG = parcelRequire("gydXG");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $de3af420de22029e$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $de3af420de22029e$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $de3af420de22029e$var$funcProto = Function.prototype, $de3af420de22029e$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $de3af420de22029e$var$funcToString = $de3af420de22029e$var$funcProto.toString;
/** Used to check objects for own properties. */ var $de3af420de22029e$var$hasOwnProperty = $de3af420de22029e$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $de3af420de22029e$var$reIsNative = RegExp('^' + $de3af420de22029e$var$funcToString.call($de3af420de22029e$var$hasOwnProperty).replace($de3af420de22029e$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $de3af420de22029e$var$baseIsNative(value) {
    if (!$aDTZF(value) || $clubE(value)) return false;
    var pattern = $cHIy1(value) ? $de3af420de22029e$var$reIsNative : $de3af420de22029e$var$reIsHostCtor;
    return pattern.test($gydXG(value));
}
module.exports = $de3af420de22029e$var$baseIsNative;

});
parcelRegister("cHIy1", function(module, exports) {

var $6JJ0x = parcelRequire("6JJ0x");

var $aDTZF = parcelRequire("aDTZF");
/** `Object#toString` result references. */ var $93fc0e7031c9a310$var$asyncTag = '[object AsyncFunction]', $93fc0e7031c9a310$var$funcTag = '[object Function]', $93fc0e7031c9a310$var$genTag = '[object GeneratorFunction]', $93fc0e7031c9a310$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $93fc0e7031c9a310$var$isFunction(value) {
    if (!$aDTZF(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $6JJ0x(value);
    return tag == $93fc0e7031c9a310$var$funcTag || tag == $93fc0e7031c9a310$var$genTag || tag == $93fc0e7031c9a310$var$asyncTag || tag == $93fc0e7031c9a310$var$proxyTag;
}
module.exports = $93fc0e7031c9a310$var$isFunction;

});
parcelRegister("6JJ0x", function(module, exports) {

var $2RDKF = parcelRequire("2RDKF");

var $4rEQc = parcelRequire("4rEQc");

var $gSkcn = parcelRequire("gSkcn");
/** `Object#toString` result references. */ var $4e79db9f77860efa$var$nullTag = '[object Null]', $4e79db9f77860efa$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $4e79db9f77860efa$var$symToStringTag = $2RDKF ? $2RDKF.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $4e79db9f77860efa$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $4e79db9f77860efa$var$undefinedTag : $4e79db9f77860efa$var$nullTag;
    return $4e79db9f77860efa$var$symToStringTag && $4e79db9f77860efa$var$symToStringTag in Object(value) ? $4rEQc(value) : $gSkcn(value);
}
module.exports = $4e79db9f77860efa$var$baseGetTag;

});
parcelRegister("2RDKF", function(module, exports) {

var $2a2fA = parcelRequire("2a2fA");
/** Built-in value references. */ var $215f5dde46d82204$var$Symbol = $2a2fA.Symbol;
module.exports = $215f5dde46d82204$var$Symbol;

});
parcelRegister("2a2fA", function(module, exports) {

var $jqL6S = parcelRequire("jqL6S");
/** Detect free variable `self`. */ var $192e42d2440b962d$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $192e42d2440b962d$var$root = $jqL6S || $192e42d2440b962d$var$freeSelf || Function('return this')();
module.exports = $192e42d2440b962d$var$root;

});
parcelRegister("jqL6S", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $e254fd0e3fc253a0$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $e254fd0e3fc253a0$var$freeGlobal;

});



parcelRegister("4rEQc", function(module, exports) {

var $2RDKF = parcelRequire("2RDKF");
/** Used for built-in method references. */ var $33c95d3177d92d92$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $33c95d3177d92d92$var$hasOwnProperty = $33c95d3177d92d92$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $33c95d3177d92d92$var$nativeObjectToString = $33c95d3177d92d92$var$objectProto.toString;
/** Built-in value references. */ var $33c95d3177d92d92$var$symToStringTag = $2RDKF ? $2RDKF.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $33c95d3177d92d92$var$getRawTag(value) {
    var isOwn = $33c95d3177d92d92$var$hasOwnProperty.call(value, $33c95d3177d92d92$var$symToStringTag), tag = value[$33c95d3177d92d92$var$symToStringTag];
    try {
        value[$33c95d3177d92d92$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $33c95d3177d92d92$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$33c95d3177d92d92$var$symToStringTag] = tag;
        else delete value[$33c95d3177d92d92$var$symToStringTag];
    }
    return result;
}
module.exports = $33c95d3177d92d92$var$getRawTag;

});

parcelRegister("gSkcn", function(module, exports) {
/** Used for built-in method references. */ var $c4915b818996077b$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $c4915b818996077b$var$nativeObjectToString = $c4915b818996077b$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $c4915b818996077b$var$objectToString(value) {
    return $c4915b818996077b$var$nativeObjectToString.call(value);
}
module.exports = $c4915b818996077b$var$objectToString;

});


parcelRegister("aDTZF", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $7bf8fb12b8068006$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $7bf8fb12b8068006$var$isObject;

});


parcelRegister("clubE", function(module, exports) {

var $90sCB = parcelRequire("90sCB");
/** Used to detect methods masquerading as native. */ var $8fcedcb2d53a07cb$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($90sCB && $90sCB.keys && $90sCB.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $8fcedcb2d53a07cb$var$isMasked(func) {
    return !!$8fcedcb2d53a07cb$var$maskSrcKey && $8fcedcb2d53a07cb$var$maskSrcKey in func;
}
module.exports = $8fcedcb2d53a07cb$var$isMasked;

});
parcelRegister("90sCB", function(module, exports) {

var $2a2fA = parcelRequire("2a2fA");
/** Used to detect overreaching core-js shims. */ var $68ea50c7e583a23f$var$coreJsData = $2a2fA["__core-js_shared__"];
module.exports = $68ea50c7e583a23f$var$coreJsData;

});


parcelRegister("gydXG", function(module, exports) {
/** Used for built-in method references. */ var $c0caa6d08e1d242f$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $c0caa6d08e1d242f$var$funcToString = $c0caa6d08e1d242f$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $c0caa6d08e1d242f$var$toSource(func) {
    if (func != null) {
        try {
            return $c0caa6d08e1d242f$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $c0caa6d08e1d242f$var$toSource;

});


parcelRegister("1b5Yz", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $0dbb74358c2dd428$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $0dbb74358c2dd428$var$getValue;

});



parcelRegister("k07oG", function(module, exports) {

var $8gGHf = parcelRequire("8gGHf");

var $cCW0I = parcelRequire("cCW0I");

var $jNi9t = parcelRequire("jNi9t");

var $htabj = parcelRequire("htabj");

var $4ZMDL = parcelRequire("4ZMDL");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $03c1f5dd804a77bf$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$03c1f5dd804a77bf$var$MapCache.prototype.clear = $8gGHf;
$03c1f5dd804a77bf$var$MapCache.prototype['delete'] = $cCW0I;
$03c1f5dd804a77bf$var$MapCache.prototype.get = $jNi9t;
$03c1f5dd804a77bf$var$MapCache.prototype.has = $htabj;
$03c1f5dd804a77bf$var$MapCache.prototype.set = $4ZMDL;
module.exports = $03c1f5dd804a77bf$var$MapCache;

});
parcelRegister("8gGHf", function(module, exports) {

var $cDxnO = parcelRequire("cDxnO");

var $9Z1eD = parcelRequire("9Z1eD");

var $8gpOE = parcelRequire("8gpOE");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $6050eff99179d8f1$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $cDxnO,
        'map': new ($8gpOE || $9Z1eD),
        'string': new $cDxnO
    };
}
module.exports = $6050eff99179d8f1$var$mapCacheClear;

});
parcelRegister("cDxnO", function(module, exports) {

var $056JU = parcelRequire("056JU");

var $fjdlI = parcelRequire("fjdlI");

var $aj0ko = parcelRequire("aj0ko");

var $jnkQ6 = parcelRequire("jnkQ6");

var $7rFOf = parcelRequire("7rFOf");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $933305b7e37b03c1$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$933305b7e37b03c1$var$Hash.prototype.clear = $056JU;
$933305b7e37b03c1$var$Hash.prototype['delete'] = $fjdlI;
$933305b7e37b03c1$var$Hash.prototype.get = $aj0ko;
$933305b7e37b03c1$var$Hash.prototype.has = $jnkQ6;
$933305b7e37b03c1$var$Hash.prototype.set = $7rFOf;
module.exports = $933305b7e37b03c1$var$Hash;

});
parcelRegister("056JU", function(module, exports) {

var $3noWI = parcelRequire("3noWI");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $00f5b20eb3421083$var$hashClear() {
    this.__data__ = $3noWI ? $3noWI(null) : {};
    this.size = 0;
}
module.exports = $00f5b20eb3421083$var$hashClear;

});
parcelRegister("3noWI", function(module, exports) {

var $7V3LB = parcelRequire("7V3LB");
/* Built-in method references that are verified to be native. */ var $2756ded8a892cede$var$nativeCreate = $7V3LB(Object, 'create');
module.exports = $2756ded8a892cede$var$nativeCreate;

});


parcelRegister("fjdlI", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b252fc45ac072b90$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $b252fc45ac072b90$var$hashDelete;

});

parcelRegister("aj0ko", function(module, exports) {

var $3noWI = parcelRequire("3noWI");
/** Used to stand-in for `undefined` hash values. */ var $780beed5711d9c18$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $780beed5711d9c18$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $780beed5711d9c18$var$hasOwnProperty = $780beed5711d9c18$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $780beed5711d9c18$var$hashGet(key) {
    var data = this.__data__;
    if ($3noWI) {
        var result = data[key];
        return result === $780beed5711d9c18$var$HASH_UNDEFINED ? undefined : result;
    }
    return $780beed5711d9c18$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $780beed5711d9c18$var$hashGet;

});

parcelRegister("jnkQ6", function(module, exports) {

var $3noWI = parcelRequire("3noWI");
/** Used for built-in method references. */ var $e1b0548f6d6334e1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e1b0548f6d6334e1$var$hasOwnProperty = $e1b0548f6d6334e1$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e1b0548f6d6334e1$var$hashHas(key) {
    var data = this.__data__;
    return $3noWI ? data[key] !== undefined : $e1b0548f6d6334e1$var$hasOwnProperty.call(data, key);
}
module.exports = $e1b0548f6d6334e1$var$hashHas;

});

parcelRegister("7rFOf", function(module, exports) {

var $3noWI = parcelRequire("3noWI");
/** Used to stand-in for `undefined` hash values. */ var $56bb7c87d014907f$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $56bb7c87d014907f$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $3noWI && value === undefined ? $56bb7c87d014907f$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $56bb7c87d014907f$var$hashSet;

});



parcelRegister("cCW0I", function(module, exports) {

var $2BmMI = parcelRequire("2BmMI");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $93160851a8ea524f$var$mapCacheDelete(key) {
    var result = $2BmMI(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $93160851a8ea524f$var$mapCacheDelete;

});
parcelRegister("2BmMI", function(module, exports) {

var $17WI8 = parcelRequire("17WI8");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $1e50b60cb8da344b$var$getMapData(map, key) {
    var data = map.__data__;
    return $17WI8(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $1e50b60cb8da344b$var$getMapData;

});
parcelRegister("17WI8", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $0d23fca82c099ffe$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $0d23fca82c099ffe$var$isKeyable;

});



parcelRegister("jNi9t", function(module, exports) {

var $2BmMI = parcelRequire("2BmMI");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e690ac828f300799$var$mapCacheGet(key) {
    return $2BmMI(this, key).get(key);
}
module.exports = $e690ac828f300799$var$mapCacheGet;

});

parcelRegister("htabj", function(module, exports) {

var $2BmMI = parcelRequire("2BmMI");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $cb7d0ae893df36fb$var$mapCacheHas(key) {
    return $2BmMI(this, key).has(key);
}
module.exports = $cb7d0ae893df36fb$var$mapCacheHas;

});

parcelRegister("4ZMDL", function(module, exports) {

var $2BmMI = parcelRequire("2BmMI");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $3a3296e1f464a55a$var$mapCacheSet(key, value) {
    var data = $2BmMI(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $3a3296e1f464a55a$var$mapCacheSet;

});




parcelRegister("lrDxq", function(module, exports) {

var $eae67 = parcelRequire("eae67");

var $bcQg2 = parcelRequire("bcQg2");

var $gt6vG = parcelRequire("gt6vG");
/** Used to compose bitmasks for value comparisons. */ var $f9caca0a45c1814e$var$COMPARE_PARTIAL_FLAG = 1, $f9caca0a45c1814e$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $f9caca0a45c1814e$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $f9caca0a45c1814e$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $f9caca0a45c1814e$var$COMPARE_UNORDERED_FLAG ? new $eae67 : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$bcQg2(other, function(othValue, othIndex) {
                if (!$gt6vG(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $f9caca0a45c1814e$var$equalArrays;

});
parcelRegister("eae67", function(module, exports) {

var $k07oG = parcelRequire("k07oG");

var $7fHaF = parcelRequire("7fHaF");

var $4WofA = parcelRequire("4WofA");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a4fcef5a69aeffcf$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $k07oG;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a4fcef5a69aeffcf$var$SetCache.prototype.add = $a4fcef5a69aeffcf$var$SetCache.prototype.push = $7fHaF;
$a4fcef5a69aeffcf$var$SetCache.prototype.has = $4WofA;
module.exports = $a4fcef5a69aeffcf$var$SetCache;

});
parcelRegister("7fHaF", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $547b6bfd39325214$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $547b6bfd39325214$var$setCacheAdd(value) {
    this.__data__.set(value, $547b6bfd39325214$var$HASH_UNDEFINED);
    return this;
}
module.exports = $547b6bfd39325214$var$setCacheAdd;

});

parcelRegister("4WofA", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $398f63d9e1df2790$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $398f63d9e1df2790$var$setCacheHas;

});


parcelRegister("bcQg2", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $828959ff86f4c9fa$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $828959ff86f4c9fa$var$arraySome;

});

parcelRegister("gt6vG", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $bfd467820a0434b5$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $bfd467820a0434b5$var$cacheHas;

});


parcelRegister("ivqYy", function(module, exports) {

var $2RDKF = parcelRequire("2RDKF");

var $fGkgT = parcelRequire("fGkgT");

var $cwveb = parcelRequire("cwveb");

var $lrDxq = parcelRequire("lrDxq");

var $cEiET = parcelRequire("cEiET");

var $6bKOB = parcelRequire("6bKOB");
/** Used to compose bitmasks for value comparisons. */ var $d7900c105fcb5104$var$COMPARE_PARTIAL_FLAG = 1, $d7900c105fcb5104$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $d7900c105fcb5104$var$boolTag = '[object Boolean]', $d7900c105fcb5104$var$dateTag = '[object Date]', $d7900c105fcb5104$var$errorTag = '[object Error]', $d7900c105fcb5104$var$mapTag = '[object Map]', $d7900c105fcb5104$var$numberTag = '[object Number]', $d7900c105fcb5104$var$regexpTag = '[object RegExp]', $d7900c105fcb5104$var$setTag = '[object Set]', $d7900c105fcb5104$var$stringTag = '[object String]', $d7900c105fcb5104$var$symbolTag = '[object Symbol]';
var $d7900c105fcb5104$var$arrayBufferTag = '[object ArrayBuffer]', $d7900c105fcb5104$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $d7900c105fcb5104$var$symbolProto = $2RDKF ? $2RDKF.prototype : undefined, $d7900c105fcb5104$var$symbolValueOf = $d7900c105fcb5104$var$symbolProto ? $d7900c105fcb5104$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $d7900c105fcb5104$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $d7900c105fcb5104$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $d7900c105fcb5104$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $fGkgT(object), new $fGkgT(other))) return false;
            return true;
        case $d7900c105fcb5104$var$boolTag:
        case $d7900c105fcb5104$var$dateTag:
        case $d7900c105fcb5104$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $cwveb(+object, +other);
        case $d7900c105fcb5104$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $d7900c105fcb5104$var$regexpTag:
        case $d7900c105fcb5104$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $d7900c105fcb5104$var$mapTag:
            var convert = $cEiET;
        case $d7900c105fcb5104$var$setTag:
            var isPartial = bitmask & $d7900c105fcb5104$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $6bKOB);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $d7900c105fcb5104$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $lrDxq(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $d7900c105fcb5104$var$symbolTag:
            if ($d7900c105fcb5104$var$symbolValueOf) return $d7900c105fcb5104$var$symbolValueOf.call(object) == $d7900c105fcb5104$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $d7900c105fcb5104$var$equalByTag;

});
parcelRegister("fGkgT", function(module, exports) {

var $2a2fA = parcelRequire("2a2fA");
/** Built-in value references. */ var $b6aa80bba6e5ed80$var$Uint8Array = $2a2fA.Uint8Array;
module.exports = $b6aa80bba6e5ed80$var$Uint8Array;

});

parcelRegister("cEiET", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $9357b1a7db258d5d$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $9357b1a7db258d5d$var$mapToArray;

});

parcelRegister("6bKOB", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $481815ac6d10e4f1$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $481815ac6d10e4f1$var$setToArray;

});


parcelRegister("5qhQ8", function(module, exports) {

var $7ap6t = parcelRequire("7ap6t");
/** Used to compose bitmasks for value comparisons. */ var $3f2d38190a284186$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $3f2d38190a284186$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3f2d38190a284186$var$hasOwnProperty = $3f2d38190a284186$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $3f2d38190a284186$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $3f2d38190a284186$var$COMPARE_PARTIAL_FLAG, objProps = $7ap6t(object), objLength = objProps.length, othProps = $7ap6t(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $3f2d38190a284186$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $3f2d38190a284186$var$equalObjects;

});
parcelRegister("7ap6t", function(module, exports) {

var $gfvoK = parcelRequire("gfvoK");

var $27ijC = parcelRequire("27ijC");

var $09VrY = parcelRequire("09VrY");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $537cf097d541a180$var$getAllKeys(object) {
    return $gfvoK(object, $09VrY, $27ijC);
}
module.exports = $537cf097d541a180$var$getAllKeys;

});
parcelRegister("gfvoK", function(module, exports) {

var $8hU77 = parcelRequire("8hU77");

var $doy0R = parcelRequire("doy0R");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $bd46671a19fcac4e$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $doy0R(object) ? result : $8hU77(result, symbolsFunc(object));
}
module.exports = $bd46671a19fcac4e$var$baseGetAllKeys;

});
parcelRegister("8hU77", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $608b7047a6785d88$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $608b7047a6785d88$var$arrayPush;

});

parcelRegister("doy0R", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $9c07e681022874c1$var$isArray = Array.isArray;
module.exports = $9c07e681022874c1$var$isArray;

});


parcelRegister("27ijC", function(module, exports) {

var $e0Fq1 = parcelRequire("e0Fq1");

var $3iZ9a = parcelRequire("3iZ9a");
/** Used for built-in method references. */ var $18aa714841c0e5df$var$objectProto = Object.prototype;
/** Built-in value references. */ var $18aa714841c0e5df$var$propertyIsEnumerable = $18aa714841c0e5df$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $18aa714841c0e5df$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $18aa714841c0e5df$var$getSymbols = !$18aa714841c0e5df$var$nativeGetSymbols ? $3iZ9a : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $e0Fq1($18aa714841c0e5df$var$nativeGetSymbols(object), function(symbol) {
        return $18aa714841c0e5df$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $18aa714841c0e5df$var$getSymbols;

});
parcelRegister("e0Fq1", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $a33131a86072f870$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $a33131a86072f870$var$arrayFilter;

});

parcelRegister("3iZ9a", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $26827c0d3aa5a824$var$stubArray() {
    return [];
}
module.exports = $26827c0d3aa5a824$var$stubArray;

});


parcelRegister("09VrY", function(module, exports) {

var $bWZK1 = parcelRequire("bWZK1");

var $iGzd4 = parcelRequire("iGzd4");

var $es7Qj = parcelRequire("es7Qj");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $0007b3390381bc54$var$keys(object) {
    return $es7Qj(object) ? $bWZK1(object) : $iGzd4(object);
}
module.exports = $0007b3390381bc54$var$keys;

});
parcelRegister("bWZK1", function(module, exports) {

var $3aLLN = parcelRequire("3aLLN");

var $iRWXn = parcelRequire("iRWXn");

var $doy0R = parcelRequire("doy0R");

var $lAY4l = parcelRequire("lAY4l");

var $dJ8ns = parcelRequire("dJ8ns");

var $fv2qo = parcelRequire("fv2qo");
/** Used for built-in method references. */ var $8b3501035de5bfa0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8b3501035de5bfa0$var$hasOwnProperty = $8b3501035de5bfa0$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $8b3501035de5bfa0$var$arrayLikeKeys(value, inherited) {
    var isArr = $doy0R(value), isArg = !isArr && $iRWXn(value), isBuff = !isArr && !isArg && $lAY4l(value), isType = !isArr && !isArg && !isBuff && $fv2qo(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $3aLLN(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $8b3501035de5bfa0$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $dJ8ns(key, length)))) result.push(key);
    return result;
}
module.exports = $8b3501035de5bfa0$var$arrayLikeKeys;

});
parcelRegister("3aLLN", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $24f75c5d6479e717$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $24f75c5d6479e717$var$baseTimes;

});

parcelRegister("iRWXn", function(module, exports) {

var $4smYn = parcelRequire("4smYn");

var $j6OnI = parcelRequire("j6OnI");
/** Used for built-in method references. */ var $dbcae8c889eaa94c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dbcae8c889eaa94c$var$hasOwnProperty = $dbcae8c889eaa94c$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $dbcae8c889eaa94c$var$propertyIsEnumerable = $dbcae8c889eaa94c$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $dbcae8c889eaa94c$var$isArguments = $4smYn(function() {
    return arguments;
}()) ? $4smYn : function(value) {
    return $j6OnI(value) && $dbcae8c889eaa94c$var$hasOwnProperty.call(value, 'callee') && !$dbcae8c889eaa94c$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $dbcae8c889eaa94c$var$isArguments;

});
parcelRegister("4smYn", function(module, exports) {

var $6JJ0x = parcelRequire("6JJ0x");

var $j6OnI = parcelRequire("j6OnI");
/** `Object#toString` result references. */ var $33eb98de21929ab9$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $33eb98de21929ab9$var$baseIsArguments(value) {
    return $j6OnI(value) && $6JJ0x(value) == $33eb98de21929ab9$var$argsTag;
}
module.exports = $33eb98de21929ab9$var$baseIsArguments;

});
parcelRegister("j6OnI", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $de95a8915ccfaaf7$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $de95a8915ccfaaf7$var$isObjectLike;

});



parcelRegister("lAY4l", function(module, exports) {

var $2a2fA = parcelRequire("2a2fA");

var $hrZoc = parcelRequire("hrZoc");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $2a2fA.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $hrZoc;
module.exports = isBuffer;

});
parcelRegister("hrZoc", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $cb4493eb2121b3b4$var$stubFalse() {
    return false;
}
module.exports = $cb4493eb2121b3b4$var$stubFalse;

});


parcelRegister("dJ8ns", function(module, exports) {
/** Used as references for various `Number` constants. */ var $9fe5f9e717926dc1$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $9fe5f9e717926dc1$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $9fe5f9e717926dc1$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $9fe5f9e717926dc1$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $9fe5f9e717926dc1$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $9fe5f9e717926dc1$var$isIndex;

});

parcelRegister("fv2qo", function(module, exports) {

var $hMLtl = parcelRequire("hMLtl");

var $9E2dR = parcelRequire("9E2dR");

var $bk9Ht = parcelRequire("bk9Ht");
/* Node.js helper references. */ var $b48ba1c64e1c992b$var$nodeIsTypedArray = $bk9Ht && $bk9Ht.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $b48ba1c64e1c992b$var$isTypedArray = $b48ba1c64e1c992b$var$nodeIsTypedArray ? $9E2dR($b48ba1c64e1c992b$var$nodeIsTypedArray) : $hMLtl;
module.exports = $b48ba1c64e1c992b$var$isTypedArray;

});
parcelRegister("hMLtl", function(module, exports) {

var $6JJ0x = parcelRequire("6JJ0x");

var $hItEV = parcelRequire("hItEV");

var $j6OnI = parcelRequire("j6OnI");
/** `Object#toString` result references. */ var $cf2bbe5faf704332$var$argsTag = '[object Arguments]', $cf2bbe5faf704332$var$arrayTag = '[object Array]', $cf2bbe5faf704332$var$boolTag = '[object Boolean]', $cf2bbe5faf704332$var$dateTag = '[object Date]', $cf2bbe5faf704332$var$errorTag = '[object Error]', $cf2bbe5faf704332$var$funcTag = '[object Function]', $cf2bbe5faf704332$var$mapTag = '[object Map]', $cf2bbe5faf704332$var$numberTag = '[object Number]', $cf2bbe5faf704332$var$objectTag = '[object Object]', $cf2bbe5faf704332$var$regexpTag = '[object RegExp]', $cf2bbe5faf704332$var$setTag = '[object Set]', $cf2bbe5faf704332$var$stringTag = '[object String]', $cf2bbe5faf704332$var$weakMapTag = '[object WeakMap]';
var $cf2bbe5faf704332$var$arrayBufferTag = '[object ArrayBuffer]', $cf2bbe5faf704332$var$dataViewTag = '[object DataView]', $cf2bbe5faf704332$var$float32Tag = '[object Float32Array]', $cf2bbe5faf704332$var$float64Tag = '[object Float64Array]', $cf2bbe5faf704332$var$int8Tag = '[object Int8Array]', $cf2bbe5faf704332$var$int16Tag = '[object Int16Array]', $cf2bbe5faf704332$var$int32Tag = '[object Int32Array]', $cf2bbe5faf704332$var$uint8Tag = '[object Uint8Array]', $cf2bbe5faf704332$var$uint8ClampedTag = '[object Uint8ClampedArray]', $cf2bbe5faf704332$var$uint16Tag = '[object Uint16Array]', $cf2bbe5faf704332$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $cf2bbe5faf704332$var$typedArrayTags = {};
$cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$float32Tag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$float64Tag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$int8Tag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$int16Tag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$int32Tag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$uint8Tag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$uint8ClampedTag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$uint16Tag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$uint32Tag] = true;
$cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$argsTag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$arrayTag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$arrayBufferTag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$boolTag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$dataViewTag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$dateTag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$errorTag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$funcTag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$mapTag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$numberTag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$objectTag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$regexpTag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$setTag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$stringTag] = $cf2bbe5faf704332$var$typedArrayTags[$cf2bbe5faf704332$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $cf2bbe5faf704332$var$baseIsTypedArray(value) {
    return $j6OnI(value) && $hItEV(value.length) && !!$cf2bbe5faf704332$var$typedArrayTags[$6JJ0x(value)];
}
module.exports = $cf2bbe5faf704332$var$baseIsTypedArray;

});
parcelRegister("hItEV", function(module, exports) {
/** Used as references for various `Number` constants. */ var $ce5d8d6907b76734$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $ce5d8d6907b76734$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $ce5d8d6907b76734$var$MAX_SAFE_INTEGER;
}
module.exports = $ce5d8d6907b76734$var$isLength;

});


parcelRegister("9E2dR", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $705992d1cddcef18$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $705992d1cddcef18$var$baseUnary;

});

parcelRegister("bk9Ht", function(module, exports) {

var $jqL6S = parcelRequire("jqL6S");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $jqL6S.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("iGzd4", function(module, exports) {

var $abYlK = parcelRequire("abYlK");

var $29yPl = parcelRequire("29yPl");
/** Used for built-in method references. */ var $d9a77626aa5bcac8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d9a77626aa5bcac8$var$hasOwnProperty = $d9a77626aa5bcac8$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $d9a77626aa5bcac8$var$baseKeys(object) {
    if (!$abYlK(object)) return $29yPl(object);
    var result = [];
    for(var key in Object(object))if ($d9a77626aa5bcac8$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $d9a77626aa5bcac8$var$baseKeys;

});
parcelRegister("abYlK", function(module, exports) {
/** Used for built-in method references. */ var $76b9bea79a2de52c$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $76b9bea79a2de52c$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $76b9bea79a2de52c$var$objectProto;
    return value === proto;
}
module.exports = $76b9bea79a2de52c$var$isPrototype;

});

parcelRegister("29yPl", function(module, exports) {

var $5FkWu = parcelRequire("5FkWu");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $19176ff69b0542ec$var$nativeKeys = $5FkWu(Object.keys, Object);
module.exports = $19176ff69b0542ec$var$nativeKeys;

});
parcelRegister("5FkWu", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $420106d27c02a480$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $420106d27c02a480$var$overArg;

});



parcelRegister("es7Qj", function(module, exports) {

var $cHIy1 = parcelRequire("cHIy1");

var $hItEV = parcelRequire("hItEV");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $a859c39cbd840e28$var$isArrayLike(value) {
    return value != null && $hItEV(value.length) && !$cHIy1(value);
}
module.exports = $a859c39cbd840e28$var$isArrayLike;

});




parcelRegister("99urM", function(module, exports) {

var $1uUKc = parcelRequire("1uUKc");

var $8gpOE = parcelRequire("8gpOE");

var $cXzCD = parcelRequire("cXzCD");

var $a3CWJ = parcelRequire("a3CWJ");

var $l0iiW = parcelRequire("l0iiW");

var $6JJ0x = parcelRequire("6JJ0x");

var $gydXG = parcelRequire("gydXG");
/** `Object#toString` result references. */ var $6a9c92764fa868de$var$mapTag = '[object Map]', $6a9c92764fa868de$var$objectTag = '[object Object]', $6a9c92764fa868de$var$promiseTag = '[object Promise]', $6a9c92764fa868de$var$setTag = '[object Set]', $6a9c92764fa868de$var$weakMapTag = '[object WeakMap]';
var $6a9c92764fa868de$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $6a9c92764fa868de$var$dataViewCtorString = $gydXG($1uUKc), $6a9c92764fa868de$var$mapCtorString = $gydXG($8gpOE), $6a9c92764fa868de$var$promiseCtorString = $gydXG($cXzCD), $6a9c92764fa868de$var$setCtorString = $gydXG($a3CWJ), $6a9c92764fa868de$var$weakMapCtorString = $gydXG($l0iiW);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $6a9c92764fa868de$var$getTag = $6JJ0x;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($1uUKc && $6a9c92764fa868de$var$getTag(new $1uUKc(new ArrayBuffer(1))) != $6a9c92764fa868de$var$dataViewTag || $8gpOE && $6a9c92764fa868de$var$getTag(new $8gpOE) != $6a9c92764fa868de$var$mapTag || $cXzCD && $6a9c92764fa868de$var$getTag($cXzCD.resolve()) != $6a9c92764fa868de$var$promiseTag || $a3CWJ && $6a9c92764fa868de$var$getTag(new $a3CWJ) != $6a9c92764fa868de$var$setTag || $l0iiW && $6a9c92764fa868de$var$getTag(new $l0iiW) != $6a9c92764fa868de$var$weakMapTag) $6a9c92764fa868de$var$getTag = function(value) {
    var result = $6JJ0x(value), Ctor = result == $6a9c92764fa868de$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $gydXG(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $6a9c92764fa868de$var$dataViewCtorString:
            return $6a9c92764fa868de$var$dataViewTag;
        case $6a9c92764fa868de$var$mapCtorString:
            return $6a9c92764fa868de$var$mapTag;
        case $6a9c92764fa868de$var$promiseCtorString:
            return $6a9c92764fa868de$var$promiseTag;
        case $6a9c92764fa868de$var$setCtorString:
            return $6a9c92764fa868de$var$setTag;
        case $6a9c92764fa868de$var$weakMapCtorString:
            return $6a9c92764fa868de$var$weakMapTag;
    }
    return result;
};
module.exports = $6a9c92764fa868de$var$getTag;

});
parcelRegister("1uUKc", function(module, exports) {

var $7V3LB = parcelRequire("7V3LB");

var $2a2fA = parcelRequire("2a2fA");
/* Built-in method references that are verified to be native. */ var $11749c0484430200$var$DataView = $7V3LB($2a2fA, 'DataView');
module.exports = $11749c0484430200$var$DataView;

});

parcelRegister("cXzCD", function(module, exports) {

var $7V3LB = parcelRequire("7V3LB");

var $2a2fA = parcelRequire("2a2fA");
/* Built-in method references that are verified to be native. */ var $96f6a08fc135c0c3$var$Promise = $7V3LB($2a2fA, 'Promise');
module.exports = $96f6a08fc135c0c3$var$Promise;

});

parcelRegister("a3CWJ", function(module, exports) {

var $7V3LB = parcelRequire("7V3LB");

var $2a2fA = parcelRequire("2a2fA");
/* Built-in method references that are verified to be native. */ var $75286522efdae350$var$Set = $7V3LB($2a2fA, 'Set');
module.exports = $75286522efdae350$var$Set;

});

parcelRegister("l0iiW", function(module, exports) {

var $7V3LB = parcelRequire("7V3LB");

var $2a2fA = parcelRequire("2a2fA");
/* Built-in method references that are verified to be native. */ var $f4a7cbf14561ecbe$var$WeakMap = $7V3LB($2a2fA, 'WeakMap');
module.exports = $f4a7cbf14561ecbe$var$WeakMap;

});





parcelRegister("g3rS6", function(module, exports) {

var $vZurO = parcelRequire("vZurO");

var $3lLrZ = parcelRequire("3lLrZ");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $bb028be49deed822$var$keyBy = $3lLrZ(function(result, value, key) {
    $vZurO(result, key, value);
});
module.exports = $bb028be49deed822$var$keyBy;

});
parcelRegister("vZurO", function(module, exports) {

var $giN29 = parcelRequire("giN29");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $060298043b96eb9d$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $giN29) $giN29(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $060298043b96eb9d$var$baseAssignValue;

});
parcelRegister("giN29", function(module, exports) {

var $7V3LB = parcelRequire("7V3LB");
var $bde45cd5aab814f5$var$defineProperty = function() {
    try {
        var func = $7V3LB(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $bde45cd5aab814f5$var$defineProperty;

});


parcelRegister("3lLrZ", function(module, exports) {

var $4nZhL = parcelRequire("4nZhL");

var $3m9ak = parcelRequire("3m9ak");

var $kUgUA = parcelRequire("kUgUA");

var $doy0R = parcelRequire("doy0R");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $270823f57e30973b$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $doy0R(collection) ? $4nZhL : $3m9ak, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $kUgUA(iteratee, 2), accumulator);
    };
}
module.exports = $270823f57e30973b$var$createAggregator;

});
parcelRegister("4nZhL", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $3318d96c6d84e1aa$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $3318d96c6d84e1aa$var$arrayAggregator;

});

parcelRegister("3m9ak", function(module, exports) {

var $1h0Zv = parcelRequire("1h0Zv");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $271a8948e5e8b020$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $1h0Zv(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $271a8948e5e8b020$var$baseAggregator;

});
parcelRegister("1h0Zv", function(module, exports) {

var $cGSun = parcelRequire("cGSun");

var $04Oer = parcelRequire("04Oer");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $0ed825c2534f13d3$var$baseEach = $04Oer($cGSun);
module.exports = $0ed825c2534f13d3$var$baseEach;

});
parcelRegister("cGSun", function(module, exports) {

var $gBFPi = parcelRequire("gBFPi");

var $09VrY = parcelRequire("09VrY");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $93d3aca16e6435c3$var$baseForOwn(object, iteratee) {
    return object && $gBFPi(object, iteratee, $09VrY);
}
module.exports = $93d3aca16e6435c3$var$baseForOwn;

});
parcelRegister("gBFPi", function(module, exports) {

var $luaXx = parcelRequire("luaXx");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $c1708be525b62834$var$baseFor = $luaXx();
module.exports = $c1708be525b62834$var$baseFor;

});
parcelRegister("luaXx", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $fa44e694c3f46547$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $fa44e694c3f46547$var$createBaseFor;

});



parcelRegister("04Oer", function(module, exports) {

var $es7Qj = parcelRequire("es7Qj");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $00e756d656eb754c$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$es7Qj(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $00e756d656eb754c$var$createBaseEach;

});



parcelRegister("kUgUA", function(module, exports) {

var $cX8h0 = parcelRequire("cX8h0");

var $8N9F1 = parcelRequire("8N9F1");

var $gwLfG = parcelRequire("gwLfG");

var $doy0R = parcelRequire("doy0R");

var $h2mQs = parcelRequire("h2mQs");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $f38627f198113a63$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $gwLfG;
    if (typeof value == 'object') return $doy0R(value) ? $8N9F1(value[0], value[1]) : $cX8h0(value);
    return $h2mQs(value);
}
module.exports = $f38627f198113a63$var$baseIteratee;

});
parcelRegister("cX8h0", function(module, exports) {

var $2MTG5 = parcelRequire("2MTG5");

var $hybnE = parcelRequire("hybnE");

var $l26P3 = parcelRequire("l26P3");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $96e1699fd2ac218d$var$baseMatches(source) {
    var matchData = $hybnE(source);
    if (matchData.length == 1 && matchData[0][2]) return $l26P3(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $2MTG5(object, source, matchData);
    };
}
module.exports = $96e1699fd2ac218d$var$baseMatches;

});
parcelRegister("2MTG5", function(module, exports) {

var $bol3e = parcelRequire("bol3e");

var $7YZ47 = parcelRequire("7YZ47");
/** Used to compose bitmasks for value comparisons. */ var $207b40eb62d4dea4$var$COMPARE_PARTIAL_FLAG = 1, $207b40eb62d4dea4$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $207b40eb62d4dea4$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $bol3e;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $7YZ47(srcValue, objValue, $207b40eb62d4dea4$var$COMPARE_PARTIAL_FLAG | $207b40eb62d4dea4$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $207b40eb62d4dea4$var$baseIsMatch;

});

parcelRegister("hybnE", function(module, exports) {

var $iP8VZ = parcelRequire("iP8VZ");

var $09VrY = parcelRequire("09VrY");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $cc6e709222f91f9b$var$getMatchData(object) {
    var result = $09VrY(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $iP8VZ(value)
        ];
    }
    return result;
}
module.exports = $cc6e709222f91f9b$var$getMatchData;

});
parcelRegister("iP8VZ", function(module, exports) {

var $aDTZF = parcelRequire("aDTZF");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $db43eb8fe7c27c41$var$isStrictComparable(value) {
    return value === value && !$aDTZF(value);
}
module.exports = $db43eb8fe7c27c41$var$isStrictComparable;

});


parcelRegister("l26P3", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $f4ff13aaceca89f3$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $f4ff13aaceca89f3$var$matchesStrictComparable;

});


parcelRegister("8N9F1", function(module, exports) {

var $7YZ47 = parcelRequire("7YZ47");

var $ixP8V = parcelRequire("ixP8V");

var $gS0eT = parcelRequire("gS0eT");

var $dnjd3 = parcelRequire("dnjd3");

var $iP8VZ = parcelRequire("iP8VZ");

var $l26P3 = parcelRequire("l26P3");

var $aqGIw = parcelRequire("aqGIw");
/** Used to compose bitmasks for value comparisons. */ var $666a64b8b2ac9c6f$var$COMPARE_PARTIAL_FLAG = 1, $666a64b8b2ac9c6f$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $666a64b8b2ac9c6f$var$baseMatchesProperty(path, srcValue) {
    if ($dnjd3(path) && $iP8VZ(srcValue)) return $l26P3($aqGIw(path), srcValue);
    return function(object) {
        var objValue = $ixP8V(object, path);
        return objValue === undefined && objValue === srcValue ? $gS0eT(object, path) : $7YZ47(srcValue, objValue, $666a64b8b2ac9c6f$var$COMPARE_PARTIAL_FLAG | $666a64b8b2ac9c6f$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $666a64b8b2ac9c6f$var$baseMatchesProperty;

});
parcelRegister("ixP8V", function(module, exports) {

var $cxN8N = parcelRequire("cxN8N");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d802fafcf93e2e8c$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $cxN8N(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $d802fafcf93e2e8c$var$get;

});
parcelRegister("cxN8N", function(module, exports) {

var $ib7S7 = parcelRequire("ib7S7");

var $aqGIw = parcelRequire("aqGIw");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $921eaf793ec54119$var$baseGet(object, path) {
    path = $ib7S7(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$aqGIw(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $921eaf793ec54119$var$baseGet;

});
parcelRegister("ib7S7", function(module, exports) {

var $doy0R = parcelRequire("doy0R");

var $dnjd3 = parcelRequire("dnjd3");

var $6dzPb = parcelRequire("6dzPb");

var $5nPul = parcelRequire("5nPul");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $d3bf5c43d05e0822$var$castPath(value, object) {
    if ($doy0R(value)) return value;
    return $dnjd3(value, object) ? [
        value
    ] : $6dzPb($5nPul(value));
}
module.exports = $d3bf5c43d05e0822$var$castPath;

});
parcelRegister("dnjd3", function(module, exports) {

var $doy0R = parcelRequire("doy0R");

var $9iIoV = parcelRequire("9iIoV");
/** Used to match property names within property paths. */ var $9bcc52f2d9b6db55$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $9bcc52f2d9b6db55$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $9bcc52f2d9b6db55$var$isKey(value, object) {
    if ($doy0R(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $9iIoV(value)) return true;
    return $9bcc52f2d9b6db55$var$reIsPlainProp.test(value) || !$9bcc52f2d9b6db55$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $9bcc52f2d9b6db55$var$isKey;

});
parcelRegister("9iIoV", function(module, exports) {

var $6JJ0x = parcelRequire("6JJ0x");

var $j6OnI = parcelRequire("j6OnI");
/** `Object#toString` result references. */ var $6c583ca011ac6989$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6c583ca011ac6989$var$isSymbol(value) {
    return typeof value == 'symbol' || $j6OnI(value) && $6JJ0x(value) == $6c583ca011ac6989$var$symbolTag;
}
module.exports = $6c583ca011ac6989$var$isSymbol;

});


parcelRegister("6dzPb", function(module, exports) {

var $iCnqV = parcelRequire("iCnqV");
/** Used to match property names within property paths. */ var $486fbef4ecabc6bb$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $486fbef4ecabc6bb$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $486fbef4ecabc6bb$var$stringToPath = $iCnqV(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($486fbef4ecabc6bb$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($486fbef4ecabc6bb$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $486fbef4ecabc6bb$var$stringToPath;

});
parcelRegister("iCnqV", function(module, exports) {

var $hNeVr = parcelRequire("hNeVr");
/** Used as the maximum memoize cache size. */ var $d8ddf3f71f2d18df$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $d8ddf3f71f2d18df$var$memoizeCapped(func) {
    var result = $hNeVr(func, function(key) {
        if (cache.size === $d8ddf3f71f2d18df$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $d8ddf3f71f2d18df$var$memoizeCapped;

});
parcelRegister("hNeVr", function(module, exports) {

var $k07oG = parcelRequire("k07oG");
/** Error message constants. */ var $cf429723e774e0eb$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $cf429723e774e0eb$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($cf429723e774e0eb$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($cf429723e774e0eb$var$memoize.Cache || $k07oG);
    return memoized;
}
// Expose `MapCache`.
$cf429723e774e0eb$var$memoize.Cache = $k07oG;
module.exports = $cf429723e774e0eb$var$memoize;

});



parcelRegister("5nPul", function(module, exports) {

var $5oexy = parcelRequire("5oexy");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $3eb70a471e9a32f0$var$toString(value) {
    return value == null ? '' : $5oexy(value);
}
module.exports = $3eb70a471e9a32f0$var$toString;

});
parcelRegister("5oexy", function(module, exports) {

var $2RDKF = parcelRequire("2RDKF");

var $2tAzk = parcelRequire("2tAzk");

var $doy0R = parcelRequire("doy0R");

var $9iIoV = parcelRequire("9iIoV");
/** Used as references for various `Number` constants. */ var $3eca7909512d209e$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $3eca7909512d209e$var$symbolProto = $2RDKF ? $2RDKF.prototype : undefined, $3eca7909512d209e$var$symbolToString = $3eca7909512d209e$var$symbolProto ? $3eca7909512d209e$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $3eca7909512d209e$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($doy0R(value)) // Recursively convert values (susceptible to call stack limits).
    return $2tAzk(value, $3eca7909512d209e$var$baseToString) + '';
    if ($9iIoV(value)) return $3eca7909512d209e$var$symbolToString ? $3eca7909512d209e$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$3eca7909512d209e$var$INFINITY ? '-0' : result;
}
module.exports = $3eca7909512d209e$var$baseToString;

});
parcelRegister("2tAzk", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $1cdaa7fc93608664$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $1cdaa7fc93608664$var$arrayMap;

});




parcelRegister("aqGIw", function(module, exports) {

var $9iIoV = parcelRequire("9iIoV");
/** Used as references for various `Number` constants. */ var $797d77cfa812b181$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $797d77cfa812b181$var$toKey(value) {
    if (typeof value == 'string' || $9iIoV(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$797d77cfa812b181$var$INFINITY ? '-0' : result;
}
module.exports = $797d77cfa812b181$var$toKey;

});



parcelRegister("gS0eT", function(module, exports) {

var $e1N7k = parcelRequire("e1N7k");

var $fxMQF = parcelRequire("fxMQF");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $c481dffcf8912d2e$var$hasIn(object, path) {
    return object != null && $fxMQF(object, path, $e1N7k);
}
module.exports = $c481dffcf8912d2e$var$hasIn;

});
parcelRegister("e1N7k", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $a367425cb6fbbf0b$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $a367425cb6fbbf0b$var$baseHasIn;

});

parcelRegister("fxMQF", function(module, exports) {

var $ib7S7 = parcelRequire("ib7S7");

var $iRWXn = parcelRequire("iRWXn");

var $doy0R = parcelRequire("doy0R");

var $dJ8ns = parcelRequire("dJ8ns");

var $hItEV = parcelRequire("hItEV");

var $aqGIw = parcelRequire("aqGIw");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $b50fd459dad39c15$var$hasPath(object, path, hasFunc) {
    path = $ib7S7(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $aqGIw(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $hItEV(length) && $dJ8ns(key, length) && ($doy0R(object) || $iRWXn(object));
}
module.exports = $b50fd459dad39c15$var$hasPath;

});



parcelRegister("gwLfG", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $c08449c3d38bf1f9$var$identity(value) {
    return value;
}
module.exports = $c08449c3d38bf1f9$var$identity;

});

parcelRegister("h2mQs", function(module, exports) {

var $klmaq = parcelRequire("klmaq");

var $eeHvo = parcelRequire("eeHvo");

var $dnjd3 = parcelRequire("dnjd3");

var $aqGIw = parcelRequire("aqGIw");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $c67458200bc16329$var$property(path) {
    return $dnjd3(path) ? $klmaq($aqGIw(path)) : $eeHvo(path);
}
module.exports = $c67458200bc16329$var$property;

});
parcelRegister("klmaq", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $ecf6f6bc1354279b$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $ecf6f6bc1354279b$var$baseProperty;

});

parcelRegister("eeHvo", function(module, exports) {

var $cxN8N = parcelRequire("cxN8N");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $a5d41ebf2b7652c7$var$basePropertyDeep(path) {
    return function(object) {
        return $cxN8N(object, path);
    };
}
module.exports = $a5d41ebf2b7652c7$var$basePropertyDeep;

});





parcelRegister("9EiVH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7066888454da7c91$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $7zyNL = parcelRequire("7zyNL");

var $5EDe9 = parcelRequire("5EDe9");

var $3dGOs = parcelRequire("3dGOs");

var $2U22y = parcelRequire("2U22y");

var $lCeXu = parcelRequire("lCeXu");

var $dAFg4 = parcelRequire("dAFg4");

var $23x7n = parcelRequire("23x7n");

var $508Sg = parcelRequire("508Sg");

var $ghpJm = parcelRequire("ghpJm");
var $7066888454da7c91$var$FormRow = (0, $ghpJm.default)('form-row');
var $7066888454da7c91$var$defaultProps = {
    inline: false
};
var $7066888454da7c91$var$FormImpl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, inline = _ref.inline, className = _ref.className, validated = _ref.validated, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'form' : _ref$as, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "inline",
        "className",
        "validated",
        "as"
    ]);
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'form');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, validated && 'was-validated', inline && bsPrefix + "-inline")
    }));
});
$7066888454da7c91$var$FormImpl.displayName = 'Form';
$7066888454da7c91$var$FormImpl.defaultProps = $7066888454da7c91$var$defaultProps;
$7066888454da7c91$var$FormImpl.Row = $7066888454da7c91$var$FormRow;
$7066888454da7c91$var$FormImpl.Group = (0, $2U22y.default);
$7066888454da7c91$var$FormImpl.Control = (0, $3dGOs.default);
$7066888454da7c91$var$FormImpl.Check = (0, $7zyNL.default);
$7066888454da7c91$var$FormImpl.File = (0, $5EDe9.default);
$7066888454da7c91$var$FormImpl.Switch = (0, $23x7n.default);
$7066888454da7c91$var$FormImpl.Label = (0, $lCeXu.default);
$7066888454da7c91$var$FormImpl.Text = (0, $dAFg4.default);
var $7066888454da7c91$export$2e2bcd8739ae039 = $7066888454da7c91$var$FormImpl;

});
parcelRegister("7zyNL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5836cc2c6ad7b438$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");
parcelRequire("clW5X");

var $Fo7oF = parcelRequire("Fo7oF");

var $H8J4q = parcelRequire("H8J4q");

var $fVKO7 = parcelRequire("fVKO7");

var $5C0R6 = parcelRequire("5C0R6");

var $9F2UN = parcelRequire("9F2UN");

var $508Sg = parcelRequire("508Sg");
var $5836cc2c6ad7b438$var$FormCheck = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var id = _ref.id, bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, _ref$inline = _ref.inline, inline = _ref$inline === void 0 ? false : _ref$inline, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$isValid = _ref.isValid, isValid = _ref$isValid === void 0 ? false : _ref$isValid, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, _ref$feedbackTooltip = _ref.feedbackTooltip, feedbackTooltip = _ref$feedbackTooltip === void 0 ? false : _ref$feedbackTooltip, feedback = _ref.feedback, className = _ref.className, style = _ref.style, _ref$title = _ref.title, title = _ref$title === void 0 ? '' : _ref$title, _ref$type = _ref.type, type = _ref$type === void 0 ? 'checkbox' : _ref$type, label = _ref.label, children = _ref.children, propCustom = _ref.custom, _ref$as = _ref.as, as = _ref$as === void 0 ? 'input' : _ref$as, props = (0, $fjJNR.default)(_ref, [
        "id",
        "bsPrefix",
        "bsCustomPrefix",
        "inline",
        "disabled",
        "isValid",
        "isInvalid",
        "feedbackTooltip",
        "feedback",
        "className",
        "style",
        "title",
        "type",
        "label",
        "children",
        "custom",
        "as"
    ]);
    var custom = type === 'switch' ? true : propCustom;
    var _ref2 = custom ? [
        bsCustomPrefix,
        'custom-control'
    ] : [
        bsPrefix,
        'form-check'
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(prefix, defaultPrefix);
    var _useContext = (0, $Fo7oF.useContext)((0, $9F2UN.default)), controlId = _useContext.controlId;
    var innerFormContext = (0, $Fo7oF.useMemo)(function() {
        return {
            controlId: id || controlId,
            custom: custom
        };
    }, [
        controlId,
        custom,
        id
    ]);
    var hasLabel = custom || label != null && label !== false && !children;
    var input = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $fVKO7.default), (0, $elnlQ.default)({}, props, {
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        isStatic: !hasLabel,
        disabled: disabled,
        as: as
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $9F2UN.default).Provider, {
        value: innerFormContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", {
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix, custom && "custom-" + type, inline && bsPrefix + "-inline")
    }, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Fragment, null, input, hasLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $5C0R6.default), {
        title: title
    }, label), (isValid || isInvalid) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $H8J4q.default), {
        type: isValid ? 'valid' : 'invalid',
        tooltip: feedbackTooltip
    }, feedback))));
});
$5836cc2c6ad7b438$var$FormCheck.displayName = 'FormCheck';
$5836cc2c6ad7b438$var$FormCheck.Input = (0, $fVKO7.default);
$5836cc2c6ad7b438$var$FormCheck.Label = (0, $5C0R6.default);
var $5836cc2c6ad7b438$export$2e2bcd8739ae039 = $5836cc2c6ad7b438$var$FormCheck;

});
parcelRegister("H8J4q", function(module, exports) {

$parcel$export(module.exports, "default", () => $081ac90ec03bea55$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $d2bgE = parcelRequire("d2bgE");
var $081ac90ec03bea55$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).elementType
};
var $081ac90ec03bea55$var$Feedback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, className = _ref.className, _ref$type = _ref.type, type = _ref$type === void 0 ? 'valid' : _ref$type, _ref$tooltip = _ref.tooltip, tooltip = _ref$tooltip === void 0 ? false : _ref$tooltip, props = (0, $fjJNR.default)(_ref, [
        "as",
        "className",
        "type",
        "tooltip"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, type + "-" + (tooltip ? 'tooltip' : 'feedback'))
    }));
});
$081ac90ec03bea55$var$Feedback.displayName = 'Feedback';
$081ac90ec03bea55$var$Feedback.propTypes = $081ac90ec03bea55$var$propTypes;
var $081ac90ec03bea55$export$2e2bcd8739ae039 = $081ac90ec03bea55$var$Feedback;

});

parcelRegister("fVKO7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9907cd7ecf9ecc5$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $9F2UN = parcelRequire("9F2UN");

var $508Sg = parcelRequire("508Sg");
var $b9907cd7ecf9ecc5$var$FormCheckInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var id = _ref.id, bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, className = _ref.className, _ref$type = _ref.type, type = _ref$type === void 0 ? 'checkbox' : _ref$type, _ref$isValid = _ref.isValid, isValid = _ref$isValid === void 0 ? false : _ref$isValid, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, isStatic = _ref.isStatic, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'input' : _ref$as, props = (0, $fjJNR.default)(_ref, [
        "id",
        "bsPrefix",
        "bsCustomPrefix",
        "className",
        "type",
        "isValid",
        "isInvalid",
        "isStatic",
        "as"
    ]);
    var _useContext = (0, $Fo7oF.useContext)((0, $9F2UN.default)), controlId = _useContext.controlId, custom = _useContext.custom;
    var _ref2 = custom ? [
        bsCustomPrefix,
        'custom-control-input'
    ] : [
        bsPrefix,
        'form-check-input'
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(prefix, defaultPrefix);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, props, {
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid', isStatic && 'position-static')
    }));
});
$b9907cd7ecf9ecc5$var$FormCheckInput.displayName = 'FormCheckInput';
var $b9907cd7ecf9ecc5$export$2e2bcd8739ae039 = $b9907cd7ecf9ecc5$var$FormCheckInput;

});
parcelRegister("9F2UN", function(module, exports) {

$parcel$export(module.exports, "default", () => $708a3447ecff5cdb$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
var $708a3447ecff5cdb$var$FormContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createContext({
    controlId: undefined
});
var $708a3447ecff5cdb$export$2e2bcd8739ae039 = $708a3447ecff5cdb$var$FormContext;

});


parcelRegister("5C0R6", function(module, exports) {

$parcel$export(module.exports, "default", () => $41612a39acedd611$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $9F2UN = parcelRequire("9F2UN");

var $508Sg = parcelRequire("508Sg");
var $41612a39acedd611$var$FormCheckLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, className = _ref.className, htmlFor = _ref.htmlFor, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "bsCustomPrefix",
        "className",
        "htmlFor"
    ]);
    var _useContext = (0, $Fo7oF.useContext)((0, $9F2UN.default)), controlId = _useContext.controlId, custom = _useContext.custom;
    var _ref2 = custom ? [
        bsCustomPrefix,
        'custom-control-label'
    ] : [
        bsPrefix,
        'form-check-label'
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(prefix, defaultPrefix);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("label", (0, $elnlQ.default)({}, props, {
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix)
    }));
});
$41612a39acedd611$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $41612a39acedd611$export$2e2bcd8739ae039 = $41612a39acedd611$var$FormCheckLabel;

});


parcelRegister("5EDe9", function(module, exports) {

$parcel$export(module.exports, "default", () => $41df1dde1f60111f$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");
parcelRequire("clW5X");

var $H8J4q = parcelRequire("H8J4q");

var $kLozx = parcelRequire("kLozx");

var $k7a7w = parcelRequire("k7a7w");

var $9F2UN = parcelRequire("9F2UN");

var $508Sg = parcelRequire("508Sg");
var $41df1dde1f60111f$var$FormFile = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var id = _ref.id, bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$isValid = _ref.isValid, isValid = _ref$isValid === void 0 ? false : _ref$isValid, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, _ref$feedbackTooltip = _ref.feedbackTooltip, feedbackTooltip = _ref$feedbackTooltip === void 0 ? false : _ref$feedbackTooltip, feedback = _ref.feedback, className = _ref.className, style = _ref.style, label = _ref.label, children = _ref.children, custom = _ref.custom, lang = _ref.lang, dataBrowse = _ref['data-browse'], _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, _ref$inputAs = _ref.inputAs, inputAs = _ref$inputAs === void 0 ? 'input' : _ref$inputAs, props = (0, $fjJNR.default)(_ref, [
        "id",
        "bsPrefix",
        "bsCustomPrefix",
        "disabled",
        "isValid",
        "isInvalid",
        "feedbackTooltip",
        "feedback",
        "className",
        "style",
        "label",
        "children",
        "custom",
        "lang",
        "data-browse",
        "as",
        "inputAs"
    ]);
    var _ref2 = custom ? [
        bsCustomPrefix,
        'custom'
    ] : [
        bsPrefix,
        'form-file'
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(prefix, defaultPrefix);
    var type = 'file';
    var _useContext = (0, $Fo7oF.useContext)((0, $9F2UN.default)), controlId = _useContext.controlId;
    var innerFormContext = (0, $Fo7oF.useMemo)(function() {
        return {
            controlId: id || controlId,
            custom: custom
        };
    }, [
        controlId,
        custom,
        id
    ]);
    var hasLabel = label != null && label !== false && !children;
    var input = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $kLozx.default), (0, $elnlQ.default)({}, props, {
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: inputAs,
        lang: lang
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $9F2UN.default).Provider, {
        value: innerFormContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, {
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix, custom && "custom-" + type)
    }, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Fragment, null, custom ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Fragment, null, input, hasLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $k7a7w.default), {
        "data-browse": dataBrowse
    }, label)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Fragment, null, hasLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $k7a7w.default), null, label), input), (isValid || isInvalid) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $H8J4q.default), {
        type: isValid ? 'valid' : 'invalid',
        tooltip: feedbackTooltip
    }, feedback))));
});
$41df1dde1f60111f$var$FormFile.displayName = 'FormFile';
$41df1dde1f60111f$var$FormFile.Input = (0, $kLozx.default);
$41df1dde1f60111f$var$FormFile.Label = (0, $k7a7w.default);
var $41df1dde1f60111f$export$2e2bcd8739ae039 = $41df1dde1f60111f$var$FormFile;

});
parcelRegister("kLozx", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1db41f8553aa116$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $9F2UN = parcelRequire("9F2UN");

var $508Sg = parcelRequire("508Sg");
var $f1db41f8553aa116$var$FormFileInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var id = _ref.id, bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, className = _ref.className, isValid = _ref.isValid, isInvalid = _ref.isInvalid, lang = _ref.lang, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'input' : _ref$as, props = (0, $fjJNR.default)(_ref, [
        "id",
        "bsPrefix",
        "bsCustomPrefix",
        "className",
        "isValid",
        "isInvalid",
        "lang",
        "as"
    ]);
    var _useContext = (0, $Fo7oF.useContext)((0, $9F2UN.default)), controlId = _useContext.controlId, custom = _useContext.custom;
    var type = 'file';
    var _ref2 = custom ? [
        bsCustomPrefix,
        'custom-file-input'
    ] : [
        bsPrefix,
        'form-control-file'
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(prefix, defaultPrefix);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, props, {
        ref: ref,
        id: id || controlId,
        type: type,
        lang: lang,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    }));
});
$f1db41f8553aa116$var$FormFileInput.displayName = 'FormFileInput';
var $f1db41f8553aa116$export$2e2bcd8739ae039 = $f1db41f8553aa116$var$FormFileInput;

});

parcelRegister("k7a7w", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea4c4fc8f1629ebd$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $9F2UN = parcelRequire("9F2UN");

var $508Sg = parcelRequire("508Sg");
var $ea4c4fc8f1629ebd$var$FormFileLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, className = _ref.className, htmlFor = _ref.htmlFor, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "bsCustomPrefix",
        "className",
        "htmlFor"
    ]);
    var _useContext = (0, $Fo7oF.useContext)((0, $9F2UN.default)), controlId = _useContext.controlId, custom = _useContext.custom;
    var _ref2 = custom ? [
        bsCustomPrefix,
        'custom-file-label'
    ] : [
        bsPrefix,
        'form-file-label'
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(prefix, defaultPrefix);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("label", (0, $elnlQ.default)({}, props, {
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix),
        "data-browse": props['data-browse']
    }));
});
$ea4c4fc8f1629ebd$var$FormFileLabel.displayName = 'FormFileLabel';
var $ea4c4fc8f1629ebd$export$2e2bcd8739ae039 = $ea4c4fc8f1629ebd$var$FormFileLabel;

});


parcelRegister("3dGOs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2583cbb7adb13445$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");
parcelRequire("clW5X");

var $Fo7oF = parcelRequire("Fo7oF");
parcelRequire("8yRQ3");

var $H8J4q = parcelRequire("H8J4q");

var $9F2UN = parcelRequire("9F2UN");

var $508Sg = parcelRequire("508Sg");
var $2583cbb7adb13445$var$FormControl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, bsCustomPrefix = _ref.bsCustomPrefix, type = _ref.type, size = _ref.size, htmlSize = _ref.htmlSize, id = _ref.id, className = _ref.className, _ref$isValid = _ref.isValid, isValid = _ref$isValid === void 0 ? false : _ref$isValid, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, plaintext = _ref.plaintext, readOnly = _ref.readOnly, custom = _ref.custom, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'input' : _ref$as, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "bsCustomPrefix",
        "type",
        "size",
        "htmlSize",
        "id",
        "className",
        "isValid",
        "isInvalid",
        "plaintext",
        "readOnly",
        "custom",
        "as"
    ]);
    var _useContext = (0, $Fo7oF.useContext)((0, $9F2UN.default)), controlId = _useContext.controlId;
    var _ref2 = custom ? [
        bsCustomPrefix,
        'custom'
    ] : [
        bsPrefix,
        'form-control'
    ], prefix = _ref2[0], defaultPrefix = _ref2[1];
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(prefix, defaultPrefix);
    var classes;
    if (plaintext) {
        var _classes;
        classes = (_classes = {}, _classes[bsPrefix + "-plaintext"] = true, _classes);
    } else if (type === 'file') {
        var _classes2;
        classes = (_classes2 = {}, _classes2[bsPrefix + "-file"] = true, _classes2);
    } else if (type === 'range') {
        var _classes3;
        classes = (_classes3 = {}, _classes3[bsPrefix + "-range"] = true, _classes3);
    } else if (Component === 'select' && custom) {
        var _classes4;
        classes = (_classes4 = {}, _classes4[bsPrefix + "-select"] = true, _classes4[bsPrefix + "-select-" + size] = size, _classes4);
    } else {
        var _classes5;
        classes = (_classes5 = {}, _classes5[bsPrefix] = true, _classes5[bsPrefix + "-" + size] = size, _classes5);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, props, {
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, classes, isValid && "is-valid", isInvalid && "is-invalid")
    }));
});
$2583cbb7adb13445$var$FormControl.displayName = 'FormControl';
var $2583cbb7adb13445$export$2e2bcd8739ae039 = Object.assign($2583cbb7adb13445$var$FormControl, {
    Feedback: (0, $H8J4q.default)
});

});
parcelRegister("8yRQ3", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $63bb42ed69704e69$var$__DEV__ = false;
var $63bb42ed69704e69$var$warning = function() {};
if ($63bb42ed69704e69$var$__DEV__) {
    var $63bb42ed69704e69$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $63bb42ed69704e69$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $63bb42ed69704e69$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $63bb42ed69704e69$var$warning;

});


parcelRegister("2U22y", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $21d264e0f07f9b23$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $9F2UN = parcelRequire("9F2UN");

var $508Sg = parcelRequire("508Sg");
var $21d264e0f07f9b23$var$FormGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, children = _ref.children, controlId = _ref.controlId, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "className",
        "children",
        "controlId",
        "as"
    ]);
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'form-group');
    var context = (0, $Fo7oF.useMemo)(function() {
        return {
            controlId: controlId
        };
    }, [
        controlId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $9F2UN.default).Provider, {
        value: context
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix)
    }), children));
});
$21d264e0f07f9b23$var$FormGroup.displayName = 'FormGroup';
var $21d264e0f07f9b23$export$2e2bcd8739ae039 = $21d264e0f07f9b23$var$FormGroup;

});

parcelRegister("lCeXu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fbc8c0061d7c301b$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");
parcelRequire("8yRQ3");

var $azEbY = parcelRequire("azEbY");

var $9F2UN = parcelRequire("9F2UN");

var $508Sg = parcelRequire("508Sg");
var $fbc8c0061d7c301b$var$defaultProps = {
    column: false,
    srOnly: false
};
var $fbc8c0061d7c301b$var$FormLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'label' : _ref$as, bsPrefix = _ref.bsPrefix, column = _ref.column, srOnly = _ref.srOnly, className = _ref.className, htmlFor = _ref.htmlFor, props = (0, $fjJNR.default)(_ref, [
        "as",
        "bsPrefix",
        "column",
        "srOnly",
        "className",
        "htmlFor"
    ]);
    var _useContext = (0, $Fo7oF.useContext)((0, $9F2UN.default)), controlId = _useContext.controlId;
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'form-label');
    var columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = columnClass + " " + columnClass + "-" + column;
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix, srOnly && 'sr-only', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $azEbY.default), (0, $elnlQ.default)({
        as: "label",
        className: classes,
        htmlFor: htmlFor
    }, props));
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({
        ref: ref,
        className: classes,
        htmlFor: htmlFor
    }, props)));
});
$fbc8c0061d7c301b$var$FormLabel.displayName = 'FormLabel';
$fbc8c0061d7c301b$var$FormLabel.defaultProps = $fbc8c0061d7c301b$var$defaultProps;
var $fbc8c0061d7c301b$export$2e2bcd8739ae039 = $fbc8c0061d7c301b$var$FormLabel;

});
parcelRegister("azEbY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7b2c59983cbbf9b3$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");
var $7b2c59983cbbf9b3$var$DEVICE_SIZES = [
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
var $7b2c59983cbbf9b3$var$Col = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "className",
        "as"
    ]);
    var prefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'col');
    var spans = [];
    var classes = [];
    $7b2c59983cbbf9b3$var$DEVICE_SIZES.forEach(function(brkPoint) {
        var propValue = props[brkPoint];
        delete props[brkPoint];
        var span;
        var offset;
        var order;
        if (typeof propValue === 'object' && propValue != null) {
            var _propValue$span = propValue.span;
            span = _propValue$span === void 0 ? true : _propValue$span;
            offset = propValue.offset;
            order = propValue.order;
        } else span = propValue;
        var infix = brkPoint !== 'xs' ? "-" + brkPoint : '';
        if (span) spans.push(span === true ? "" + prefix + infix : "" + prefix + infix + "-" + span);
        if (order != null) classes.push("order" + infix + "-" + order);
        if (offset != null) classes.push("offset" + infix + "-" + offset);
    });
    if (!spans.length) spans.push(prefix); // plain 'col'
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T))).apply(void 0, [
            className
        ].concat(spans, classes))
    }));
});
$7b2c59983cbbf9b3$var$Col.displayName = 'Col';
var $7b2c59983cbbf9b3$export$2e2bcd8739ae039 = $7b2c59983cbbf9b3$var$Col;

});


parcelRegister("dAFg4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9e4ea42c43f38142$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");
var $9e4ea42c43f38142$var$FormText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'small' : _ref$as, muted = _ref.muted, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "className",
        "as",
        "muted"
    ]);
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix, muted && 'text-muted')
    }));
});
$9e4ea42c43f38142$var$FormText.displayName = 'FormText';
var $9e4ea42c43f38142$export$2e2bcd8739ae039 = $9e4ea42c43f38142$var$FormText;

});

parcelRegister("23x7n", function(module, exports) {

$parcel$export(module.exports, "default", () => $17f58d248181d8cb$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $Fo7oF = parcelRequire("Fo7oF");

var $7zyNL = parcelRequire("7zyNL");
var $17f58d248181d8cb$var$Switch = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $7zyNL.default), (0, $elnlQ.default)({}, props, {
        ref: ref,
        type: "switch"
    }));
});
$17f58d248181d8cb$var$Switch.displayName = 'Switch';
$17f58d248181d8cb$var$Switch.Input = (0, $7zyNL.default).Input;
$17f58d248181d8cb$var$Switch.Label = (0, $7zyNL.default).Label;
var $17f58d248181d8cb$export$2e2bcd8739ae039 = $17f58d248181d8cb$var$Switch;

});


parcelRegister("gT8dK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c4b828dde989a0f1$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");
var $c4b828dde989a0f1$var$defaultProps = {
    fluid: false
};
var $c4b828dde989a0f1$var$Container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, fluid = _ref.fluid, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, className = _ref.className, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "fluid",
        "as",
        "className"
    ]);
    var prefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'container');
    var suffix = typeof fluid === 'string' ? "-" + fluid : '-fluid';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, fluid ? "" + prefix + suffix : prefix)
    }));
});
$c4b828dde989a0f1$var$Container.displayName = 'Container';
$c4b828dde989a0f1$var$Container.defaultProps = $c4b828dde989a0f1$var$defaultProps;
var $c4b828dde989a0f1$export$2e2bcd8739ae039 = $c4b828dde989a0f1$var$Container;

});

parcelRegister("6adin", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $47cdfd6be9686f2f$var$_react = $47cdfd6be9686f2f$var$_interopRequireWildcard((parcelRequire("Fo7oF")));

var $47cdfd6be9686f2f$var$_propTypes = $47cdfd6be9686f2f$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $47cdfd6be9686f2f$var$_flatpickr = $47cdfd6be9686f2f$var$_interopRequireDefault((parcelRequire("7tt20")));
function $47cdfd6be9686f2f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $47cdfd6be9686f2f$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $47cdfd6be9686f2f$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $47cdfd6be9686f2f$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $47cdfd6be9686f2f$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $47cdfd6be9686f2f$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $47cdfd6be9686f2f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $47cdfd6be9686f2f$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $47cdfd6be9686f2f$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $47cdfd6be9686f2f$var$_typeof(obj);
}
function $47cdfd6be9686f2f$var$_extends() {
    $47cdfd6be9686f2f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $47cdfd6be9686f2f$var$_extends.apply(this, arguments);
}
function $47cdfd6be9686f2f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $47cdfd6be9686f2f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $47cdfd6be9686f2f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $47cdfd6be9686f2f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $47cdfd6be9686f2f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $47cdfd6be9686f2f$var$ownKeys(Object(source), true).forEach(function(key) {
            $47cdfd6be9686f2f$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $47cdfd6be9686f2f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $47cdfd6be9686f2f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $47cdfd6be9686f2f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $47cdfd6be9686f2f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $47cdfd6be9686f2f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $47cdfd6be9686f2f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $47cdfd6be9686f2f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $47cdfd6be9686f2f$var$_setPrototypeOf(subClass, superClass);
}
function $47cdfd6be9686f2f$var$_setPrototypeOf(o, p) {
    $47cdfd6be9686f2f$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $47cdfd6be9686f2f$var$_setPrototypeOf(o, p);
}
function $47cdfd6be9686f2f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $47cdfd6be9686f2f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $47cdfd6be9686f2f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $47cdfd6be9686f2f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $47cdfd6be9686f2f$var$_possibleConstructorReturn(this, result);
    };
}
function $47cdfd6be9686f2f$var$_possibleConstructorReturn(self, call) {
    if (call && ($47cdfd6be9686f2f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $47cdfd6be9686f2f$var$_assertThisInitialized(self);
}
function $47cdfd6be9686f2f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $47cdfd6be9686f2f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $47cdfd6be9686f2f$var$_getPrototypeOf(o) {
    $47cdfd6be9686f2f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $47cdfd6be9686f2f$var$_getPrototypeOf(o);
}
function $47cdfd6be9686f2f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $47cdfd6be9686f2f$var$hooks = [
    'onChange',
    'onOpen',
    'onClose',
    'onMonthChange',
    'onYearChange',
    'onReady',
    'onValueUpdate',
    'onDayCreate'
];
var $47cdfd6be9686f2f$var$hookPropType = $47cdfd6be9686f2f$var$_propTypes["default"].oneOfType([
    $47cdfd6be9686f2f$var$_propTypes["default"].func,
    $47cdfd6be9686f2f$var$_propTypes["default"].arrayOf($47cdfd6be9686f2f$var$_propTypes["default"].func)
]);
var $47cdfd6be9686f2f$var$callbacks = [
    'onCreate',
    'onDestroy'
];
var $47cdfd6be9686f2f$var$callbackPropTypes = $47cdfd6be9686f2f$var$_propTypes["default"].func;
var $47cdfd6be9686f2f$var$DateTimePicker = /*#__PURE__*/ function(_Component) {
    $47cdfd6be9686f2f$var$_inherits(DateTimePicker, _Component);
    var _super = $47cdfd6be9686f2f$var$_createSuper(DateTimePicker);
    function DateTimePicker() {
        var _this;
        $47cdfd6be9686f2f$var$_classCallCheck(this, DateTimePicker);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $47cdfd6be9686f2f$var$_defineProperty($47cdfd6be9686f2f$var$_assertThisInitialized(_this), "createFlatpickrInstance", function() {
            var options = $47cdfd6be9686f2f$var$_objectSpread({
                onClose: function onClose() {
                    _this.node.blur && _this.node.blur();
                }
            }, _this.props.options); // Add prop hooks to options
            $47cdfd6be9686f2f$var$hooks.forEach(function(hook) {
                if (_this.props[hook]) options[hook] = _this.props[hook];
            });
            _this.flatpickr = (0, $47cdfd6be9686f2f$var$_flatpickr["default"])(_this.node, options);
            if (_this.props.hasOwnProperty('value')) _this.flatpickr.setDate(_this.props.value, false);
            var onCreate = _this.props.onCreate;
            if (onCreate) onCreate(_this.flatpickr);
        });
        $47cdfd6be9686f2f$var$_defineProperty($47cdfd6be9686f2f$var$_assertThisInitialized(_this), "destroyFlatpickrInstance", function() {
            var onDestroy = _this.props.onDestroy;
            if (onDestroy) onDestroy(_this.flatpickr);
            _this.flatpickr.destroy();
            _this.flatpickr = null;
        });
        $47cdfd6be9686f2f$var$_defineProperty($47cdfd6be9686f2f$var$_assertThisInitialized(_this), "handleNodeChange", function(node) {
            _this.node = node;
            if (_this.flatpickr) {
                _this.destroyFlatpickrInstance();
                _this.createFlatpickrInstance();
            }
        });
        return _this;
    }
    $47cdfd6be9686f2f$var$_createClass(DateTimePicker, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this2 = this;
                var options = this.props.options;
                var prevOptions = prevProps.options;
                $47cdfd6be9686f2f$var$hooks.forEach(function(hook) {
                    if (_this2.props.hasOwnProperty(hook)) options[hook] = _this2.props[hook];
                     // Add prev ones too so we can compare against them later
                    if (prevProps.hasOwnProperty(hook)) prevOptions[hook] = prevProps[hook];
                });
                var optionsKeys = Object.getOwnPropertyNames(options);
                for(var index = optionsKeys.length - 1; index >= 0; index--){
                    var key = optionsKeys[index];
                    var value = options[key];
                    if (value !== prevOptions[key]) {
                        // Hook handlers must be set as an array
                        if ($47cdfd6be9686f2f$var$hooks.indexOf(key) !== -1 && !Array.isArray(value)) value = [
                            value
                        ];
                        this.flatpickr.set(key, value);
                    }
                }
                if (this.props.hasOwnProperty('value') && this.props.value !== prevProps.value) this.flatpickr.setDate(this.props.value, false);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.createFlatpickrInstance();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.destroyFlatpickrInstance();
            }
        },
        {
            key: "render",
            value: function render() {
                // eslint-disable-next-line no-unused-vars
                var _this$props = this.props, options = _this$props.options, defaultValue = _this$props.defaultValue, value = _this$props.value, children = _this$props.children, render = _this$props.render, props = $47cdfd6be9686f2f$var$_objectWithoutProperties(_this$props, [
                    "options",
                    "defaultValue",
                    "value",
                    "children",
                    "render"
                ]); // Don't pass hooks and callbacks to dom node
                $47cdfd6be9686f2f$var$hooks.forEach(function(hook) {
                    delete props[hook];
                });
                $47cdfd6be9686f2f$var$callbacks.forEach(function(callback) {
                    delete props[callback];
                });
                if (render) return render($47cdfd6be9686f2f$var$_objectSpread($47cdfd6be9686f2f$var$_objectSpread({}, props), {}, {
                    defaultValue: defaultValue,
                    value: value
                }), this.handleNodeChange);
                return options.wrap ? /*#__PURE__*/ $47cdfd6be9686f2f$var$_react["default"].createElement("div", $47cdfd6be9686f2f$var$_extends({}, props, {
                    ref: this.handleNodeChange
                }), children) : /*#__PURE__*/ $47cdfd6be9686f2f$var$_react["default"].createElement("input", $47cdfd6be9686f2f$var$_extends({}, props, {
                    defaultValue: defaultValue,
                    ref: this.handleNodeChange
                }));
            }
        }
    ]);
    return DateTimePicker;
}($47cdfd6be9686f2f$var$_react.Component);
$47cdfd6be9686f2f$var$_defineProperty($47cdfd6be9686f2f$var$DateTimePicker, "propTypes", {
    defaultValue: $47cdfd6be9686f2f$var$_propTypes["default"].string,
    options: $47cdfd6be9686f2f$var$_propTypes["default"].object,
    onChange: $47cdfd6be9686f2f$var$hookPropType,
    onOpen: $47cdfd6be9686f2f$var$hookPropType,
    onClose: $47cdfd6be9686f2f$var$hookPropType,
    onMonthChange: $47cdfd6be9686f2f$var$hookPropType,
    onYearChange: $47cdfd6be9686f2f$var$hookPropType,
    onReady: $47cdfd6be9686f2f$var$hookPropType,
    onValueUpdate: $47cdfd6be9686f2f$var$hookPropType,
    onDayCreate: $47cdfd6be9686f2f$var$hookPropType,
    onCreate: $47cdfd6be9686f2f$var$callbackPropTypes,
    onDestroy: $47cdfd6be9686f2f$var$callbackPropTypes,
    value: $47cdfd6be9686f2f$var$_propTypes["default"].oneOfType([
        $47cdfd6be9686f2f$var$_propTypes["default"].string,
        $47cdfd6be9686f2f$var$_propTypes["default"].array,
        $47cdfd6be9686f2f$var$_propTypes["default"].object,
        $47cdfd6be9686f2f$var$_propTypes["default"].number
    ]),
    children: $47cdfd6be9686f2f$var$_propTypes["default"].node,
    className: $47cdfd6be9686f2f$var$_propTypes["default"].string,
    render: $47cdfd6be9686f2f$var$_propTypes["default"].func
});
$47cdfd6be9686f2f$var$_defineProperty($47cdfd6be9686f2f$var$DateTimePicker, "defaultProps", {
    options: {}
});
var $47cdfd6be9686f2f$var$_default = $47cdfd6be9686f2f$var$DateTimePicker;
module.exports["default"] = $47cdfd6be9686f2f$var$_default;

});
parcelRegister("7tt20", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5711c2de98409f3f$export$2e2bcd8739ae039);

var $hG72I = parcelRequire("hG72I");

var $dtTsj = parcelRequire("dtTsj");

var $9BzEC = parcelRequire("9BzEC");

var $4N3a6 = parcelRequire("4N3a6");

var $PCWQn = parcelRequire("PCWQn");

var $gT8ru = parcelRequire("gT8ru");
parcelRequire("gnJAk");
var $5711c2de98409f3f$var$__assign = undefined && undefined.__assign || function() {
    $5711c2de98409f3f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5711c2de98409f3f$var$__assign.apply(this, arguments);
};
var $5711c2de98409f3f$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $5711c2de98409f3f$var$DEBOUNCED_CHANGE_MS = 300;
function $5711c2de98409f3f$var$FlatpickrInstance(element, instanceConfig) {
    var self = {
        config: $5711c2de98409f3f$var$__assign($5711c2de98409f3f$var$__assign({}, (0, $hG72I.defaults)), $5711c2de98409f3f$var$flatpickr.defaultConfig),
        l10n: (0, $dtTsj.default)
    };
    self.parseDate = (0, $PCWQn.createDateParser)({
        config: self.config,
        l10n: self.l10n
    });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self.onMouseOver = onMouseOver;
    self._createElement = (0, $4N3a6.createElement);
    self.createDay = createDay;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.updateValue = updateValue;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth: function(month, yr) {
                if (month === void 0) month = self.currentMonth;
                if (yr === void 0) yr = self.currentYear;
                if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                return self.l10n.daysInMonth[month];
            }
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile) build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self.isMobile && isSafari) positionCalendar();
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return ((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        var config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) return;
        else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.style.visibility = "hidden";
                self.calendarContainer.style.display = "block";
            }
            if (self.daysContainer !== undefined) {
                var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                self.daysContainer.style.width = daysWidth + "px";
                self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
                self.calendarContainer.style.removeProperty("visibility");
                self.calendarContainer.style.removeProperty("display");
            }
        });
    }
    function updateTime(e) {
        if (self.selectedDates.length === 0) {
            var defaultDate = self.config.minDate === undefined || (0, $PCWQn.compareDates)(new Date(), self.config.minDate) >= 0 ? new Date() : new Date(self.config.minDate.getTime());
            var defaults = (0, $PCWQn.getDefaultHours)(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [
                defaultDate
            ];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") timeWrapper(e);
        var prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) self._debouncedChange();
    }
    function ampm2military(hour, amPM) {
        return hour % 12 + 12 * (0, $9BzEC.int)(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch(hour % 24){
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined) return;
        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
        if (self.amPM !== undefined) hours = ampm2military(hours, self.amPM.textContent);
        var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && (0, $PCWQn.compareDates)(self.latestSelectedDateObj, self.config.minDate, true) === 0;
        var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && (0, $PCWQn.compareDates)(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
        if (self.config.maxTime !== undefined && self.config.minTime !== undefined && self.config.minTime > self.config.maxTime) {
            var minBound = (0, $PCWQn.calculateSecondsSinceMidnight)(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
            var maxBound = (0, $PCWQn.calculateSecondsSinceMidnight)(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
            var currentTime = (0, $PCWQn.calculateSecondsSinceMidnight)(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = (0, $PCWQn.parseSeconds)(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        } else {
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        var date = dateObj || self.latestSelectedDateObj;
        if (date && date instanceof Date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
    function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        if (!self.hourElement || !self.minuteElement || self.isMobile) return;
        self.hourElement.value = (0, $9BzEC.pad)(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (0, $9BzEC.int)(hours % 12 === 0) : hours);
        self.minuteElement.value = (0, $9BzEC.pad)(minutes);
        if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[(0, $9BzEC.int)(hours >= 12)];
        if (self.secondElement !== undefined) self.secondElement.value = (0, $9BzEC.pad)(seconds);
    }
    function onYearInput(event) {
        var eventTarget = (0, $4N3a6.getEventTarget)(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array) return event.forEach(function(ev) {
            return bind(element, ev, handler, options);
        });
        if (element instanceof Array) return element.forEach(function(el) {
            return bind(el, event, handler, options);
        });
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: function() {
                return element.removeEventListener(event, handler, options);
            }
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self.config.wrap) [
            "open",
            "close",
            "toggle",
            "clear"
        ].forEach(function(evt) {
            Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function(el) {
                return bind(el, "click", self[evt]);
            });
        });
        if (self.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = (0, $9BzEC.debounce)(onResize, 50);
        self._debouncedChange = (0, $9BzEC.debounce)(triggerChange, $5711c2de98409f3f$var$DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function(e) {
            if (self.config.mode === "range") onMouseOver((0, $4N3a6.getEventTarget)(e));
        });
        bind(self._input, "keydown", onKeyDown);
        if (self.calendarContainer !== undefined) bind(self.calendarContainer, "keydown", onKeyDown);
        if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
        else bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, {
            capture: true
        });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, [
                "keyup",
                "increment"
            ], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
            var selText = function(e) {
                return (0, $4N3a6.getEventTarget)(e).select();
            };
            bind(self.timeContainer, [
                "increment"
            ], updateTime);
            bind(self.timeContainer, "blur", updateTime, {
                capture: true
            });
            bind(self.timeContainer, "click", timeIncrement);
            bind([
                self.hourElement,
                self.minuteElement
            ], [
                "focus",
                "click"
            ], selText);
            if (self.secondElement !== undefined) bind(self.secondElement, "focus", function() {
                return self.secondElement && self.secondElement.select();
            });
            if (self.amPM !== undefined) bind(self.amPM, "click", function(e) {
                updateTime(e);
            });
        }
        if (self.config.allowInput) bind(self._input, "blur", onBlur);
    }
    function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
        var oldYear = self.currentYear;
        var oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        } catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
        self.redraw();
    }
    function timeIncrement(e) {
        var eventTarget = (0, $4N3a6.getEventTarget)(e);
        if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        var target = e && (0, $4N3a6.getEventTarget)(e);
        var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self.calendarContainer = (0, $4N3a6.createElement)("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = (0, $4N3a6.createElement)("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = (0, $4N3a6.createElement)("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = (0, $4N3a6.createElement)("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) fragment.appendChild(buildTime());
        (0, $4N3a6.toggleClass)(self.calendarContainer, "rangeMode", self.config.mode === "range");
        (0, $4N3a6.toggleClass)(self.calendarContainer, "animate", self.config.animate === true);
        (0, $4N3a6.toggleClass)(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config.static) {
                var wrapper = (0, $4N3a6.createElement)("div", "flatpickr-wrapper");
                if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput) wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = (0, $4N3a6.createElement)("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 && (0, $PCWQn.compareDates)(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    (0, $4N3a6.toggleClass)(dayElement, "startRange", self.selectedDates[0] && (0, $PCWQn.compareDates)(date, self.selectedDates[0], true) === 0);
                    (0, $4N3a6.toggleClass)(dayElement, "endRange", self.selectedDates[1] && (0, $PCWQn.compareDates)(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay") dayElement.classList.add("inRange");
                }
            }
        } else dayElement.classList.add("flatpickr-disabled");
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
        }
        if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range") onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        for(var m = startMonth; m != endMonth; m += delta){
            var month = self.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for(var i = startIndex; i != endIndex; i += delta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for(var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta){
            var month = self.daysContainer.children[m];
            var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
            var numMonthDays = month.children.length;
            for(var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined ? current : dayFocused ? activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) self._input.focus();
        else if (!dayFocused) focusOnDayElem(startElem);
        else getNextAvailableDay(startElem, offset);
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for(; dayNumber <= prevMonthDays; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        for(dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        for(var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++)days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        var dayContainer = (0, $4N3a6.createElement)("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) return;
        (0, $4N3a6.clearNode)(self.daysContainer);
        if (self.weekNumbers) (0, $4N3a6.clearNode)(self.weekNumbers);
        var frag = document.createDocumentFragment();
        for(var i = 0; i < self.config.showMonths; i++){
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver();
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;
        var shouldBuildMonth = function(month) {
            if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) return false;
            return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for(var i = 0; i < 12; i++){
            if (!shouldBuildMonth(i)) continue;
            var month = (0, $4N3a6.createElement)("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = (0, $gT8ru.monthToStr)(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) month.selected = true;
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = (0, $4N3a6.createElement)("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") monthElement = (0, $4N3a6.createElement)("span", "cur-month");
        else {
            self.monthsDropdownContainer = (0, $4N3a6.createElement)("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", function(e) {
                var target = (0, $4N3a6.getEventTarget)(e);
                var selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        var yearInput = (0, $4N3a6.createNumberInput)("cur-year", {
            tabindex: "-1"
        });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        var currentMonth = (0, $4N3a6.createElement)("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement
        };
    }
    function buildMonths() {
        (0, $4N3a6.clearNode)(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for(var m = self.config.showMonths; m--;){
            var month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = (0, $4N3a6.createElement)("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = (0, $4N3a6.createElement)("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = (0, $4N3a6.createElement)("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: function() {
                return self.__hidePrevMonthArrow;
            },
            set: function(bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    (0, $4N3a6.toggleClass)(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            }
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: function() {
                return self.__hideNextMonthArrow;
            },
            set: function(bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    (0, $4N3a6.toggleClass)(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            }
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
        var defaults = (0, $PCWQn.getDefaultHours)(self.config);
        self.timeContainer = (0, $4N3a6.createElement)("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        var separator = (0, $4N3a6.createElement)("span", "flatpickr-time-separator", ":");
        var hourInput = (0, $4N3a6.createNumberInput)("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = (0, $4N3a6.createNumberInput)("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = (0, $9BzEC.pad)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
        self.minuteElement.value = (0, $9BzEC.pad)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            var secondInput = (0, $4N3a6.createNumberInput)("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = (0, $9BzEC.pad)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild((0, $4N3a6.createElement)("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            self.amPM = (0, $4N3a6.createElement)("span", "flatpickr-am-pm", self.l10n.amPM[(0, $9BzEC.int)((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer) self.weekdayContainer = (0, $4N3a6.createElement)("div", "flatpickr-weekdays");
        else (0, $4N3a6.clearNode)(self.weekdayContainer);
        for(var i = self.config.showMonths; i--;){
            var container = (0, $4N3a6.createElement)("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) return;
        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = $5711c2de98409f3f$var$__spreadArrays(self.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = $5711c2de98409f3f$var$__spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        for(var i = self.config.showMonths; i--;)self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
    function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = (0, $4N3a6.createElement)("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild((0, $4N3a6.createElement)("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        var weekNumbers = (0, $4N3a6.createElement)("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) isOffset = true;
        var delta = isOffset ? value : value - self.currentMonth;
        if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) triggerChangeEvent = true;
        if (toInitial === void 0) toInitial = true;
        self.input.value = "";
        if (self.altInput !== undefined) self.altInput.value = "";
        if (self.mobileInput !== undefined) self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            var _a = (0, $PCWQn.getDefaultHours)(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent) triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) self.calendarContainer.classList.remove("open");
            if (self._input !== undefined) self._input.classList.remove("active");
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined) triggerEvent("onDestroy");
        for(var i = self._handlers.length; i--;)self._handlers[i].remove();
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        } else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config.static && self.calendarContainer.parentNode) {
                var wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while(wrapper.firstChild)wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config"
        ].forEach(function(k) {
            try {
                delete self[k];
            } catch (_) {}
        });
    }
    function isCalendarElem(elem) {
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            var eventTarget_1 = (0, $4N3a6.getEventTarget)(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
            var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
            var isIgnored = !self.config.ignoredFocusElements.some(function(elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self.config.allowInput) self.setDate(self._input.value, false, self.config.altInput ? self.config.altFormat : self.config.dateFormat);
                if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined && self.input.value !== "" && self.input.value !== undefined) updateTime();
                self.close();
                if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) self.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
        var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) timeless = true;
        var dateToCheck = self.parseDate(date, undefined, timeless);
        if (self.config.minDate && dateToCheck && (0, $PCWQn.compareDates)(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && (0, $PCWQn.compareDates)(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
        if (!self.config.enable && self.config.disable.length === 0) return true;
        if (dateToCheck === undefined) return false;
        var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for(var i = 0, d = void 0; i < array.length; i++){
            d = array[i];
            if (typeof d === "function" && d(dateToCheck)) return bool;
            else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;
            else if (typeof d === "string") {
                var parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
            } else if (typeof d === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self._input;
        var valueChanged = self._input.value.trimEnd() !== getDateStr();
        if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
    }
    function onKeyDown(e) {
        var eventTarget = (0, $4N3a6.getEventTarget)(e);
        var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
        var allowInput = self.config.allowInput;
        var allowKeydown = self.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
                self.close();
                return eventTarget.blur();
            } else self.open();
        } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
            var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);
            switch(e.keyCode){
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    } else selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self.daysContainer !== undefined && (allowInput === false || activeElement && isInView(activeElement))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    } else if (self.hourElement) self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if (self.daysContainer && eventTarget.$i !== undefined || eventTarget === self.input || eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                    } else if (eventTarget === self.currentYearElement) changeYear(self.currentYear - delta);
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement) self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM
                        ].concat(self.pluginElements).filter(function(x) {
                            return x;
                        });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
                default:
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) switch(e.key){
            case self.l10n.amPM[0].charAt(0):
            case self.l10n.amPM[0].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[0];
                setHoursFromInputs();
                updateValue();
                break;
            case self.l10n.amPM[1].charAt(0):
            case self.l10n.amPM[1].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[1];
                setHoursFromInputs();
                updateValue();
                break;
        }
        if (isInput || isCalendarElem(eventTarget)) triggerEvent("onKeyDown", e);
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) cellClass = "flatpickr-day";
        if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
        var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for(var t = rangeStartDate; t < rangeEndDate; t += (0, $PCWQn.duration).DAY)if (!isEnabled(new Date(t), true)) {
            containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
            if (t < initialDate && (!minRange || t > minRange)) minRange = t;
            else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
        }
        var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function(dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                [
                    "inRange",
                    "startRange",
                    "endRange"
                ].forEach(function(c) {
                    dayElem.classList.remove(c);
                });
                return;
            } else if (containsDisabled && !outOfRange) return;
            [
                "startRange",
                "inRange",
                "endRange",
                "notAllowed"
            ].forEach(function(c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && (0, $PCWQn.isBetween)(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) positionElement = self._positionElement;
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = (0, $4N3a6.getEventTarget)(e);
                if (eventTarget) eventTarget.blur();
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        } else if (self._input.disabled || self.config.inline) return;
        var wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
                return self.hourElement.select();
            }, 50);
        }
    }
    function minMaxDateSetter(type) {
        return function(date) {
            var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
            var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter(function(d) {
                    return isEnabled(d);
                });
                if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();
                else self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile"
        ];
        var userConfig = $5711c2de98409f3f$var$__assign($5711c2de98409f3f$var$__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: function() {
                return self.config._enable;
            },
            set: function(dates) {
                self.config._enable = parseDateRules(dates);
            }
        });
        Object.defineProperty(self.config, "disable", {
            get: function() {
                return self.config._disable;
            },
            set: function(dates) {
                self.config._disable = parseDateRules(dates);
            }
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = $5711c2de98409f3f$var$flatpickr.defaultConfig.dateFormat || (0, $hG72I.defaults).dateFormat;
            formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
            var defaultAltFormat = $5711c2de98409f3f$var$flatpickr.defaultConfig.altFormat || (0, $hG72I.defaults).altFormat;
            formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self.config, "minDate", {
            get: function() {
                return self.config._minDate;
            },
            set: minMaxDateSetter("min")
        });
        Object.defineProperty(self.config, "maxDate", {
            get: function() {
                return self.config._maxDate;
            },
            set: minMaxDateSetter("max")
        });
        var minMaxTimeSetter = function(type) {
            return function(val) {
                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
            };
        };
        Object.defineProperty(self.config, "minTime", {
            get: function() {
                return self.config._minTime;
            },
            set: minMaxTimeSetter("min")
        });
        Object.defineProperty(self.config, "maxTime", {
            get: function() {
                return self.config._maxTime;
            },
            set: minMaxTimeSetter("max")
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for(var i = 0; i < boolOpts.length; i++)self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
        (0, $hG72I.HOOKS).filter(function(hook) {
            return self.config[hook] !== undefined;
        }).forEach(function(hook) {
            self.config[hook] = (0, $9BzEC.arrayify)(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for(var i = 0; i < self.config.plugins.length; i++){
            var pluginConf = self.config.plugins[i](self) || {};
            for(var key in pluginConf){
                if ((0, $hG72I.HOOKS).indexOf(key) > -1) self.config[key] = (0, $9BzEC.arrayify)(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap ? element.querySelector("[data-input]") : element;
    }
    function setupLocale() {
        if (typeof self.config.locale !== "object" && typeof $5711c2de98409f3f$var$flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
        self.l10n = $5711c2de98409f3f$var$__assign($5711c2de98409f3f$var$__assign({}, $5711c2de98409f3f$var$flatpickr.l10ns.default), typeof self.config.locale === "object" ? self.config.locale : self.config.locale !== "default" ? $5711c2de98409f3f$var$flatpickr.l10ns[self.config.locale] : undefined);
        (0, $gT8ru.tokenRegex).D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
        (0, $gT8ru.tokenRegex).l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
        (0, $gT8ru.tokenRegex).M = "(" + self.l10n.months.shorthand.join("|") + ")";
        (0, $gT8ru.tokenRegex).F = "(" + self.l10n.months.longhand.join("|") + ")";
        (0, $gT8ru.tokenRegex).K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = $5711c2de98409f3f$var$__assign($5711c2de98409f3f$var$__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined && $5711c2de98409f3f$var$flatpickr.defaultConfig.time_24hr === undefined) self.config.time_24hr = self.l10n.time_24hr;
        self.formatDate = (0, $PCWQn.createDateFormatter)(self);
        self.parseDate = (0, $PCWQn.createDateParser)({
            config: self.config,
            l10n: self.l10n
        });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") return void self.config.position(self, customPositionElement);
        if (self.calendarContainer === undefined) return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function(acc, child) {
            return acc + child.offsetHeight;
        }, 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
        var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        (0, $4N3a6.toggleClass)(self.calendarContainer, "arrowTop", !showOnTop);
        (0, $4N3a6.toggleClass)(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline) return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        } else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        (0, $4N3a6.toggleClass)(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        (0, $4N3a6.toggleClass)(self.calendarContainer, "arrowCenter", isCenter);
        (0, $4N3a6.toggleClass)(self.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        (0, $4N3a6.toggleClass)(self.calendarContainer, "rightMost", rightMost);
        if (self.config.static) return;
        self.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self.calendarContainer.style.left = left + "px";
            self.calendarContainer.style.right = "auto";
        } else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = right + "px";
        } else {
            var doc = getDocumentStyleSheet();
            if (doc === undefined) return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            (0, $4N3a6.toggleClass)(self.calendarContainer, "rightMost", false);
            (0, $4N3a6.toggleClass)(self.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self.calendarContainer.style.left = centerLeft + "px";
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            try {
                sheet.cssRules;
            } catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile) return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) setTimeout(self.close, 0);
        else self.close();
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function(day) {
            return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
        };
        var t = (0, $4N3a6.findParent)((0, $4N3a6.getEventTarget)(e), isSelectable);
        if (t === undefined) return;
        var target = t;
        var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single") self.selectedDates = [
            selectedDate
        ];
        else if (self.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
            else self.selectedDates.push(selectedDate);
        } else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) self.clear(false, false);
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            if ((0, $PCWQn.compareDates)(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined && self.hourElement === undefined) self.selectedDateElem && self.selectedDateElem.focus();
        if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            var single = self.config.mode === "single" && !self.config.enableTime;
            var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
            if (single || range) focusAndClose();
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [
            setupLocale,
            updateWeekdays
        ],
        showMonths: [
            buildMonths,
            setCalendarWidth,
            buildWeekdays
        ],
        minDate: [
            jumpToDate
        ],
        maxDate: [
            jumpToDate
        ],
        positionElement: [
            updatePositionElement
        ],
        clickOpens: [
            function() {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                } else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            }
        ]
    };
    function set(option, value) {
        if (option !== null && typeof option === "object") {
            Object.assign(self.config, option);
            for(var key in option)if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function(x) {
                return x();
            });
        } else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function(x) {
                return x();
            });
            else if ((0, $hG72I.HOOKS).indexOf(option) > -1) self.config[option] = (0, $9BzEC.arrayify)(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array) dates = inputDate.map(function(d) {
            return self.parseDate(d, format);
        });
        else if (inputDate instanceof Date || typeof inputDate === "number") dates = [
            self.parseDate(inputDate, format)
        ];
        else if (typeof inputDate === "string") switch(self.config.mode){
            case "single":
            case "time":
                dates = [
                    self.parseDate(inputDate, format)
                ];
                break;
            case "multiple":
                dates = inputDate.split(self.config.conjunction).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            case "range":
                dates = inputDate.split(self.l10n.rangeSeparator).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            default:
                break;
        }
        else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function(d) {
            return d instanceof Date && isEnabled(d, false);
        });
        if (self.config.mode === "range") self.selectedDates.sort(function(a, b) {
            return a.getTime() - b.getTime();
        });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) triggerChange = false;
        if (format === void 0) format = self.config.dateFormat;
        if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) self.clear(false);
        updateValue(triggerChange);
        if (triggerChange) triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr.slice().map(function(rule) {
            if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self.parseDate(rule, undefined, true);
            else if (rule && typeof rule === "object" && rule.from && rule.to) return {
                from: self.parseDate(rule.from, undefined),
                to: self.parseDate(rule.to, undefined)
            };
            return rule;
        }).filter(function(x) {
            return x;
        });
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
        if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            self.altInput = (0, $4N3a6.createElement)(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
        self.mobileInput = (0, $4N3a6.createElement)("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
        if (self.selectedDates.length > 0) self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined) self.altInput.type = "hidden";
        try {
            if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        } catch (_a) {}
        bind(self.mobileInput, "change", function(e) {
            self.setDate((0, $4N3a6.getEventTarget)(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true) return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        if (self.config === undefined) return;
        var hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) for(var i = 0; hooks[i] && i < hooks.length; i++)hooks[i](self.selectedDates, self.input.value, self, data);
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for(var i = 0; i < self.selectedDates.length; i++){
            var selectedDate = self.selectedDates[i];
            if (selectedDate instanceof Date && (0, $PCWQn.compareDates)(selectedDate, date) === 0) return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
        return (0, $PCWQn.compareDates)(date, self.selectedDates[0]) >= 0 && (0, $PCWQn.compareDates)(date, self.selectedDates[1]) <= 0;
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
        self.yearElements.forEach(function(yearElement, i) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") self.monthElements[i].textContent = (0, $gT8ru.monthToStr)(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            else self.monthsDropdownContainer.value = d.getMonth().toString();
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat || (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
        return self.selectedDates.map(function(dObj) {
            return self.formatDate(dObj, format);
        }).filter(function(d, i, arr) {
            return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
        }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
    }
    function updateValue(triggerChange) {
        if (triggerChange === void 0) triggerChange = true;
        if (self.mobileInput !== undefined && self.mobileFormatStr) self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) self.altInput.value = getDateStr(self.config.altFormat);
        if (triggerChange !== false) triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = (0, $4N3a6.getEventTarget)(e);
        var isPrevMonth = self.prevMonthNav.contains(eventTarget);
        var isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
        else if (self.yearElements.indexOf(eventTarget) >= 0) eventTarget.select();
        else if (eventTarget.classList.contains("arrowUp")) self.changeYear(self.currentYear + 1);
        else if (eventTarget.classList.contains("arrowDown")) self.changeYear(self.currentYear - 1);
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = (0, $4N3a6.getEventTarget)(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) self.amPM.textContent = self.l10n.amPM[(0, $9BzEC.int)(self.amPM.textContent === self.l10n.amPM[0])];
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue = max + newValue + (0, $9BzEC.int)(!isHourElem) + ((0, $9BzEC.int)(isHourElem) && (0, $9BzEC.int)(!self.amPM));
                if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
            } else if (newValue > max) {
                newValue = input === self.hourElement ? newValue - max - (0, $9BzEC.int)(!self.amPM) : min;
                if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.l10n.amPM[(0, $9BzEC.int)(self.amPM.textContent === self.l10n.amPM[0])];
            input.value = (0, $9BzEC.pad)(newValue);
        }
    }
    init();
    return self;
}
function $5711c2de98409f3f$var$_flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
        return x instanceof HTMLElement;
    });
    var instances = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null) continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = $5711c2de98409f3f$var$FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        } catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
        return $5711c2de98409f3f$var$_flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function(config) {
        return $5711c2de98409f3f$var$_flatpickr([
            this
        ], config);
    };
}
var $5711c2de98409f3f$var$flatpickr = function(selector, config) {
    if (typeof selector === "string") return $5711c2de98409f3f$var$_flatpickr(window.document.querySelectorAll(selector), config);
    else if (selector instanceof Node) return $5711c2de98409f3f$var$_flatpickr([
        selector
    ], config);
    else return $5711c2de98409f3f$var$_flatpickr(selector, config);
};
$5711c2de98409f3f$var$flatpickr.defaultConfig = {};
$5711c2de98409f3f$var$flatpickr.l10ns = {
    en: $5711c2de98409f3f$var$__assign({}, (0, $dtTsj.default)),
    default: $5711c2de98409f3f$var$__assign({}, (0, $dtTsj.default))
};
$5711c2de98409f3f$var$flatpickr.localize = function(l10n) {
    $5711c2de98409f3f$var$flatpickr.l10ns.default = $5711c2de98409f3f$var$__assign($5711c2de98409f3f$var$__assign({}, $5711c2de98409f3f$var$flatpickr.l10ns.default), l10n);
};
$5711c2de98409f3f$var$flatpickr.setDefaults = function(config) {
    $5711c2de98409f3f$var$flatpickr.defaultConfig = $5711c2de98409f3f$var$__assign($5711c2de98409f3f$var$__assign({}, $5711c2de98409f3f$var$flatpickr.defaultConfig), config);
};
$5711c2de98409f3f$var$flatpickr.parseDate = (0, $PCWQn.createDateParser)({});
$5711c2de98409f3f$var$flatpickr.formatDate = (0, $PCWQn.createDateFormatter)({});
$5711c2de98409f3f$var$flatpickr.compareDates = (0, $PCWQn.compareDates);
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
    return $5711c2de98409f3f$var$_flatpickr(this, config);
};
Date.prototype.fp_incr = function(days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") window.flatpickr = $5711c2de98409f3f$var$flatpickr;
var $5711c2de98409f3f$export$2e2bcd8739ae039 = $5711c2de98409f3f$var$flatpickr;

});
parcelRegister("hG72I", function(module, exports) {

$parcel$export(module.exports, "HOOKS", () => $cdebd27acfe2d5c0$export$c34bb18505e1e253);
$parcel$export(module.exports, "defaults", () => $cdebd27acfe2d5c0$export$ebe90cb607ad99e);
var $cdebd27acfe2d5c0$export$c34bb18505e1e253 = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
];
var $cdebd27acfe2d5c0$export$ebe90cb607ad99e = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function(err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        var week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
};

});

parcelRegister("dtTsj", function(module, exports) {

$parcel$export(module.exports, "english", () => $9d09001fe8aa0a1a$export$33e6c23ebe2ee669);
$parcel$export(module.exports, "default", () => $9d09001fe8aa0a1a$export$2e2bcd8739ae039);
var $9d09001fe8aa0a1a$export$33e6c23ebe2ee669 = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch(s % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
};
var $9d09001fe8aa0a1a$export$2e2bcd8739ae039 = $9d09001fe8aa0a1a$export$33e6c23ebe2ee669;

});

parcelRegister("9BzEC", function(module, exports) {

$parcel$export(module.exports, "pad", () => $6fe339ed49f93881$export$5d04458e2a6c373e);
$parcel$export(module.exports, "int", () => $6fe339ed49f93881$export$7d260a2a5f8bc19e);
$parcel$export(module.exports, "debounce", () => $6fe339ed49f93881$export$61fc7d43ac8f84b0);
$parcel$export(module.exports, "arrayify", () => $6fe339ed49f93881$export$3131421a7d01b4fb);
var $6fe339ed49f93881$export$5d04458e2a6c373e = function(number, length) {
    if (length === void 0) length = 2;
    return ("000" + number).slice(length * -1);
};
var $6fe339ed49f93881$export$7d260a2a5f8bc19e = function(bool) {
    return bool === true ? 1 : 0;
};
function $6fe339ed49f93881$export$61fc7d43ac8f84b0(fn, wait) {
    var t;
    return function() {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
}
var $6fe339ed49f93881$export$3131421a7d01b4fb = function(obj) {
    return obj instanceof Array ? obj : [
        obj
    ];
};

});

parcelRegister("4N3a6", function(module, exports) {

$parcel$export(module.exports, "toggleClass", () => $37ce30f27dfdfe14$export$4a80062ca50b57c7);
$parcel$export(module.exports, "createElement", () => $37ce30f27dfdfe14$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "clearNode", () => $37ce30f27dfdfe14$export$51cfe97d637c237c);
$parcel$export(module.exports, "findParent", () => $37ce30f27dfdfe14$export$25245567f53f158f);
$parcel$export(module.exports, "createNumberInput", () => $37ce30f27dfdfe14$export$afe9d610a3284048);
$parcel$export(module.exports, "getEventTarget", () => $37ce30f27dfdfe14$export$e58f029f0fbfdb29);
function $37ce30f27dfdfe14$export$4a80062ca50b57c7(elem, className, bool) {
    if (bool === true) return elem.classList.add(className);
    elem.classList.remove(className);
}
function $37ce30f27dfdfe14$export$c8a8987d4410bf2d(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined) e.textContent = content;
    return e;
}
function $37ce30f27dfdfe14$export$51cfe97d637c237c(node) {
    while(node.firstChild)node.removeChild(node.firstChild);
}
function $37ce30f27dfdfe14$export$25245567f53f158f(node, condition) {
    if (condition(node)) return node;
    else if (node.parentNode) return $37ce30f27dfdfe14$export$25245567f53f158f(node.parentNode, condition);
    return undefined;
}
function $37ce30f27dfdfe14$export$afe9d610a3284048(inputClassName, opts) {
    var wrapper = $37ce30f27dfdfe14$export$c8a8987d4410bf2d("div", "numInputWrapper"), numInput = $37ce30f27dfdfe14$export$c8a8987d4410bf2d("input", "numInput " + inputClassName), arrowUp = $37ce30f27dfdfe14$export$c8a8987d4410bf2d("span", "arrowUp"), arrowDown = $37ce30f27dfdfe14$export$c8a8987d4410bf2d("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined) for(var key in opts)numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function $37ce30f27dfdfe14$export$e58f029f0fbfdb29(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    } catch (error) {
        return event.target;
    }
}

});

parcelRegister("PCWQn", function(module, exports) {

$parcel$export(module.exports, "createDateFormatter", () => $09b2f9d0a6bcb0c0$export$ff1a0b75284ac636);
$parcel$export(module.exports, "createDateParser", () => $09b2f9d0a6bcb0c0$export$cfa2ef2687faeda2);
$parcel$export(module.exports, "compareDates", () => $09b2f9d0a6bcb0c0$export$c4c806e061935577);
$parcel$export(module.exports, "isBetween", () => $09b2f9d0a6bcb0c0$export$a4d69fb5f2026c35);
$parcel$export(module.exports, "calculateSecondsSinceMidnight", () => $09b2f9d0a6bcb0c0$export$9fafc166baa96839);
$parcel$export(module.exports, "parseSeconds", () => $09b2f9d0a6bcb0c0$export$a4ce0def660bfe9e);
$parcel$export(module.exports, "duration", () => $09b2f9d0a6bcb0c0$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "getDefaultHours", () => $09b2f9d0a6bcb0c0$export$6df0e87d3fffbd14);

var $gT8ru = parcelRequire("gT8ru");

var $hG72I = parcelRequire("hG72I");

var $dtTsj = parcelRequire("dtTsj");
var $09b2f9d0a6bcb0c0$export$ff1a0b75284ac636 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $hG72I.defaults) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $dtTsj.english) : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function(dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) return config.formatDate(dateObj, frmt, locale);
        return frmt.split("").map(function(c, i, arr) {
            return (0, $gT8ru.formats)[c] && arr[i - 1] !== "\\" ? (0, $gT8ru.formats)[c](dateObj, locale, config) : c !== "\\" ? c : "";
        }).join("");
    };
};
var $09b2f9d0a6bcb0c0$export$cfa2ef2687faeda2 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $hG72I.defaults) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $dtTsj.english) : _c;
    return function(date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date) return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date) parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);
        else if (typeof date === "string") {
            var format = givenFormat || (config || (0, $hG72I.defaults)).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            } else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
            else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);
            else {
                var matched = void 0, ops = [];
                for(var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++){
                    var token = format[i];
                    var isBackSlash = token === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if ((0, $gT8ru.tokenRegex)[token] && !escaped) {
                        regexStr += (0, $gT8ru.tokenRegex)[token];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) ops[token !== "Y" ? "push" : "unshift"]({
                            fn: (0, $gT8ru.revFormat)[token],
                            val: match[++matchIndex]
                        });
                    } else if (!isBackSlash) regexStr += ".";
                }
                parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function(_a) {
                    var fn = _a.fn, val = _a.val;
                    return parsedDate = fn(parsedDate, val, locale) || parsedDate;
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
function $09b2f9d0a6bcb0c0$export$c4c806e061935577(date1, date2, timeless) {
    if (timeless === void 0) timeless = true;
    if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    return date1.getTime() - date2.getTime();
}
function $09b2f9d0a6bcb0c0$export$15d252ed5f5f8636(date1, date2) {
    return 3600 * (date1.getHours() - date2.getHours()) + 60 * (date1.getMinutes() - date2.getMinutes()) + date1.getSeconds() - date2.getSeconds();
}
var $09b2f9d0a6bcb0c0$export$a4d69fb5f2026c35 = function(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var $09b2f9d0a6bcb0c0$export$9fafc166baa96839 = function(hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var $09b2f9d0a6bcb0c0$export$a4ce0def660bfe9e = function(secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [
        hours,
        minutes,
        secondsSinceMidnight - hours * 3600 - minutes * 60
    ];
};
var $09b2f9d0a6bcb0c0$export$1f34108aa9eb96ab = {
    DAY: 86400000
};
function $09b2f9d0a6bcb0c0$export$6df0e87d3fffbd14(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) hours = minHour;
        if (hours === minHour && minutes < minMinutes) minutes = minMinutes;
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
    }
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}

});
parcelRegister("gT8ru", function(module, exports) {

$parcel$export(module.exports, "monthToStr", () => $c4b854df4dcce5eb$export$27a2dd9af757e89c);
$parcel$export(module.exports, "revFormat", () => $c4b854df4dcce5eb$export$9490b78b888a863f);
$parcel$export(module.exports, "tokenRegex", () => $c4b854df4dcce5eb$export$f5a8dc72fbf63af5);
$parcel$export(module.exports, "formats", () => $c4b854df4dcce5eb$export$55069460464ca7a9);

var $9BzEC = parcelRequire("9BzEC");
var $c4b854df4dcce5eb$var$doNothing = function() {
    return undefined;
};
var $c4b854df4dcce5eb$export$27a2dd9af757e89c = function(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var $c4b854df4dcce5eb$export$9490b78b888a863f = {
    D: $c4b854df4dcce5eb$var$doNothing,
    F: function(dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function(dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function(dateObj, amPM, locale) {
        dateObj.setHours(dateObj.getHours() % 12 + 12 * (0, $9BzEC.int)(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function(dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function(_, unixSeconds) {
        return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function(dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function(dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function(_, ISODate) {
        return new Date(ISODate);
    },
    d: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function(dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: $c4b854df4dcce5eb$var$doNothing,
    m: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function(_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: $c4b854df4dcce5eb$var$doNothing,
    y: function(dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    }
};
var $c4b854df4dcce5eb$export$f5a8dc72fbf63af5 = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
};
var $c4b854df4dcce5eb$export$55069460464ca7a9 = {
    Z: function(date) {
        return date.toISOString();
    },
    D: function(date, locale, options) {
        return locale.weekdays.shorthand[$c4b854df4dcce5eb$export$55069460464ca7a9.w(date, locale, options)];
    },
    F: function(date, locale, options) {
        return $c4b854df4dcce5eb$export$27a2dd9af757e89c($c4b854df4dcce5eb$export$55069460464ca7a9.n(date, locale, options) - 1, false, locale);
    },
    G: function(date, locale, options) {
        return (0, $9BzEC.pad)($c4b854df4dcce5eb$export$55069460464ca7a9.h(date, locale, options));
    },
    H: function(date) {
        return (0, $9BzEC.pad)(date.getHours());
    },
    J: function(date, locale) {
        return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    K: function(date, locale) {
        return locale.amPM[(0, $9BzEC.int)(date.getHours() > 11)];
    },
    M: function(date, locale) {
        return $c4b854df4dcce5eb$export$27a2dd9af757e89c(date.getMonth(), true, locale);
    },
    S: function(date) {
        return (0, $9BzEC.pad)(date.getSeconds());
    },
    U: function(date) {
        return date.getTime() / 1000;
    },
    W: function(date, _, options) {
        return options.getWeek(date);
    },
    Y: function(date) {
        return (0, $9BzEC.pad)(date.getFullYear(), 4);
    },
    d: function(date) {
        return (0, $9BzEC.pad)(date.getDate());
    },
    h: function(date) {
        return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    i: function(date) {
        return (0, $9BzEC.pad)(date.getMinutes());
    },
    j: function(date) {
        return date.getDate();
    },
    l: function(date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: function(date) {
        return (0, $9BzEC.pad)(date.getMonth() + 1);
    },
    n: function(date) {
        return date.getMonth() + 1;
    },
    s: function(date) {
        return date.getSeconds();
    },
    u: function(date) {
        return date.getTime();
    },
    w: function(date) {
        return date.getDay();
    },
    y: function(date) {
        return String(date.getFullYear()).substring(2);
    }
};

});


parcelRegister("gnJAk", function(module, exports) {
"use strict";
if (typeof Object.assign !== "function") Object.assign = function(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (!target) throw TypeError("Cannot convert undefined or null to object");
    var _loop_1 = function(source) {
        if (source) Object.keys(source).forEach(function(key) {
            return target[key] = source[key];
        });
    };
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var source = args_1[_a];
        _loop_1(source);
    }
    return target;
};

});



parcelRegister("5ePwi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3d0639510c175839$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $iO2KI = parcelRequire("iO2KI");
parcelRequire("1ndZg");
var $5VUYT = parcelRequire("5VUYT");

var $7i6aT = parcelRequire("7i6aT");

var $u5Mlg = parcelRequire("u5Mlg");

var $8TtJs = parcelRequire("8TtJs");

var $712fm = parcelRequire("712fm");

var $6VnXl = parcelRequire("6VnXl");

var $508Sg = parcelRequire("508Sg");

var $ghpJm = parcelRequire("ghpJm");
var $3d0639510c175839$var$DropdownHeader = (0, $ghpJm.default)('dropdown-header', {
    defaultProps: {
        role: 'heading'
    }
});
var $3d0639510c175839$var$DropdownDivider = (0, $ghpJm.default)('dropdown-divider', {
    defaultProps: {
        role: 'separator'
    }
});
var $3d0639510c175839$var$DropdownItemText = (0, $ghpJm.default)('dropdown-item-text', {
    Component: 'span'
});
var $3d0639510c175839$var$defaultProps = {
    navbar: false
};
var $3d0639510c175839$var$Dropdown = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(pProps, ref) {
    var _useUncontrolled = (0, $5VUYT.default)(pProps, {
        show: 'onToggle'
    }), bsPrefix = _useUncontrolled.bsPrefix, drop = _useUncontrolled.drop, show = _useUncontrolled.show, className = _useUncontrolled.className, alignRight = _useUncontrolled.alignRight, onSelect = _useUncontrolled.onSelect, onToggle = _useUncontrolled.onToggle, focusFirstItemOnShow = _useUncontrolled.focusFirstItemOnShow, _useUncontrolled$as = _useUncontrolled.as, Component = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as, _4 = _useUncontrolled.navbar, props = (0, $fjJNR.default)(_useUncontrolled, [
        "bsPrefix",
        "drop",
        "show",
        "className",
        "alignRight",
        "onSelect",
        "onToggle",
        "focusFirstItemOnShow",
        "as",
        "navbar"
    ]);
    var onSelectCtx = (0, $Fo7oF.useContext)((0, $6VnXl.default));
    var prefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'dropdown');
    var handleToggle = (0, $7i6aT.default)(function(nextShow, event, source) {
        if (source === void 0) source = event.type;
        if (event.currentTarget === document && (source !== 'keydown' || event.key === 'Escape')) source = 'rootClose';
        if (onToggle) onToggle(nextShow, event, {
            source: source
        });
    });
    var handleSelect = (0, $7i6aT.default)(function(key, event) {
        if (onSelectCtx) onSelectCtx(key, event);
        if (onSelect) onSelect(key, event);
        handleToggle(false, event, 'select');
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $6VnXl.default).Provider, {
        value: handleSelect
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $iO2KI.default), {
        drop: drop,
        show: show,
        alignEnd: alignRight,
        onToggle: handleToggle,
        focusFirstItemOnShow: focusFirstItemOnShow,
        itemSelector: "." + prefix + "-item:not(.disabled):not(:disabled)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, show && 'show', (!drop || drop === 'down') && prefix, drop === 'up' && 'dropup', drop === 'right' && 'dropright', drop === 'left' && 'dropleft')
    }))));
});
$3d0639510c175839$var$Dropdown.displayName = 'Dropdown';
$3d0639510c175839$var$Dropdown.defaultProps = $3d0639510c175839$var$defaultProps;
$3d0639510c175839$var$Dropdown.Divider = $3d0639510c175839$var$DropdownDivider;
$3d0639510c175839$var$Dropdown.Header = $3d0639510c175839$var$DropdownHeader;
$3d0639510c175839$var$Dropdown.Item = (0, $u5Mlg.default);
$3d0639510c175839$var$Dropdown.ItemText = $3d0639510c175839$var$DropdownItemText;
$3d0639510c175839$var$Dropdown.Menu = (0, $8TtJs.default);
$3d0639510c175839$var$Dropdown.Toggle = (0, $712fm.default);
var $3d0639510c175839$export$2e2bcd8739ae039 = $3d0639510c175839$var$Dropdown;

});
parcelRegister("iO2KI", function(module, exports) {

$parcel$export(module.exports, "default", () => $db0f081cbc1bac5e$export$2e2bcd8739ae039);

var $9ongT = parcelRequire("9ongT");

var $7nQFL = parcelRequire("7nQFL");

var $6XdXy = parcelRequire("6XdXy");

var $Fo7oF = parcelRequire("Fo7oF");

var $d2bgE = parcelRequire("d2bgE");
parcelRequire("1ndZg");
var $5VUYT = parcelRequire("5VUYT");

var $hZkdd = parcelRequire("hZkdd");

var $6OjZ2 = parcelRequire("6OjZ2");

var $8Bn0R = parcelRequire("8Bn0R");

var $31c7C = parcelRequire("31c7C");

var $acBel = parcelRequire("acBel");

var $duF8L = parcelRequire("duF8L");

var $a5rV6 = parcelRequire("a5rV6");
var $db0f081cbc1bac5e$var$propTypes = {
    /**
   * A render prop that returns the root dropdown element. The `props`
   * argument should spread through to an element containing _both_ the
   * menu and toggle in order to handle keyboard events for focus management.
   *
   * @type {Function ({
   *   props: {
   *     onKeyDown: (SyntheticEvent) => void,
   *   },
   * }) => React.Element}
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).node,
    /**
   * Determines the direction and location of the Menu in relation to it's Toggle.
   */ drop: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).oneOf([
        'up',
        'left',
        'right',
        'down'
    ]),
    /**
   * Controls the focus behavior for when the Dropdown is opened. Set to
   * `true` to always focus the first menu item, `keyboard` to focus only when
   * navigating via the keyboard, or `false` to disable completely
   *
   * The Default behavior is `false` **unless** the Menu has a `role="menu"`
   * where it will default to `keyboard` to match the recommended [ARIA Authoring practices](https://www.w3.org/TR/wai-aria-practices-1.1/#menubutton).
   */ focusFirstItemOnShow: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).oneOf([
        false,
        true,
        'keyboard'
    ]),
    /**
   * A css slector string that will return __focusable__ menu items.
   * Selectors should be relative to the menu component:
   * e.g. ` > li:not('.disabled')`
   */ itemSelector: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    /**
   * Align the menu to the 'end' side of the placement side of the Dropdown toggle. The default placement is `top-start` or `bottom-start`.
   */ alignEnd: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    /**
   * Whether or not the Dropdown is visible.
   *
   * @controllable onToggle
   */ show: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    /**
   * Sets the initial show position of the Dropdown.
   */ defaultShow: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    /**
   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
   * `show` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
   *
   * ```ts static
   * function(
   *   isOpen: boolean,
   *   event: SyntheticEvent,
   * ): void
   * ```
   *
   * @controllable show
   */ onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func
};
function $db0f081cbc1bac5e$var$useRefWithUpdate() {
    var forceUpdate = (0, $6OjZ2.default)();
    var ref = (0, $Fo7oF.useRef)(null);
    var attachRef = (0, $Fo7oF.useCallback)(function(element) {
        ref.current = element; // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $db0f081cbc1bac5e$var$Dropdown(_ref) {
    var drop = _ref.drop, alignEnd = _ref.alignEnd, defaultShow = _ref.defaultShow, rawShow = _ref.show, rawOnToggle = _ref.onToggle, _ref$itemSelector = _ref.itemSelector, itemSelector = _ref$itemSelector === void 0 ? '* > *' : _ref$itemSelector, focusFirstItemOnShow = _ref.focusFirstItemOnShow, children = _ref.children;
    var _useUncontrolledProp = (0, $5VUYT.useUncontrolledProp)(rawShow, defaultShow, rawOnToggle), show = _useUncontrolledProp[0], onToggle = _useUncontrolledProp[1]; // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    var _useRefWithUpdate = $db0f081cbc1bac5e$var$useRefWithUpdate(), menuRef = _useRefWithUpdate[0], setMenu = _useRefWithUpdate[1];
    var menuElement = menuRef.current;
    var _useRefWithUpdate2 = $db0f081cbc1bac5e$var$useRefWithUpdate(), toggleRef = _useRefWithUpdate2[0], setToggle = _useRefWithUpdate2[1];
    var toggleElement = toggleRef.current;
    var lastShow = (0, $hZkdd.default)(show);
    var lastSourceEvent = (0, $Fo7oF.useRef)(null);
    var focusInDropdown = (0, $Fo7oF.useRef)(false);
    var toggle = (0, $Fo7oF.useCallback)(function(nextShow, event) {
        onToggle(nextShow, event);
    }, [
        onToggle
    ]);
    var context = (0, $Fo7oF.useMemo)(function() {
        return {
            toggle: toggle,
            drop: drop,
            show: show,
            alignEnd: alignEnd,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        };
    }, [
        toggle,
        drop,
        show,
        alignEnd,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(document.activeElement);
    var focusToggle = (0, $31c7C.default)(function() {
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    var maybeFocusFirst = (0, $31c7C.default)(function() {
        var type = lastSourceEvent.current;
        var focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $9ongT.default)(menuRef.current, '[role=menu]') ? 'keyboard' : false;
        if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) return;
        var first = (0, $7nQFL.default)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $Fo7oF.useEffect)(function() {
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        } // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $Fo7oF.useEffect)(function() {
        lastSourceEvent.current = null;
    });
    var getNextFocusedChild = function getNextFocusedChild(current, offset) {
        if (!menuRef.current) return null;
        var items = (0, $7nQFL.default)(menuRef.current, itemSelector);
        var index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $8Bn0R.default)('keydown', function(event) {
        var _menuRef$current, _toggleRef$current;
        var key = event.key;
        var target = event.target;
        var fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        var fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target); // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        var isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === ' ' || key !== 'Escape' && fromMenu)) return;
        if (!fromMenu && !fromToggle) return;
        if (!menuRef.current && key === 'Tab') return;
        lastSourceEvent.current = event.type;
        switch(key){
            case 'ArrowUp':
                var next = getNextFocusedChild(target, -1);
                if (next && next.focus) next.focus();
                event.preventDefault();
                return;
            case 'ArrowDown':
                event.preventDefault();
                if (!show) onToggle(true, event);
                else {
                    var _next = getNextFocusedChild(target, 1);
                    if (_next && _next.focus) _next.focus();
                }
                return;
            case 'Tab':
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $6XdXy.default)(document, 'keyup', function(e) {
                    var _menuRef$current2;
                    if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, event);
                }, {
                    once: true
                });
                break;
            case 'Escape':
                event.preventDefault();
                event.stopPropagation();
                onToggle(false, event);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $acBel.default).Provider, {
        value: context
    }, children);
}
$db0f081cbc1bac5e$var$Dropdown.displayName = 'ReactOverlaysDropdown';
$db0f081cbc1bac5e$var$Dropdown.propTypes = $db0f081cbc1bac5e$var$propTypes;
$db0f081cbc1bac5e$var$Dropdown.Menu = (0, $duF8L.default);
$db0f081cbc1bac5e$var$Dropdown.Toggle = (0, $a5rV6.default);
var $db0f081cbc1bac5e$export$2e2bcd8739ae039 = $db0f081cbc1bac5e$var$Dropdown;

});
parcelRegister("9ongT", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d686831831042f7$export$2e2bcd8739ae039);
var $6d686831831042f7$var$matchesImpl;
function $6d686831831042f7$export$2e2bcd8739ae039(node, selector) {
    if (!$6d686831831042f7$var$matchesImpl) {
        var body = document.body;
        var nativeMatch = body.matches || body.matchesSelector || body.webkitMatchesSelector || body.mozMatchesSelector || body.msMatchesSelector;
        $6d686831831042f7$var$matchesImpl = function matchesImpl(n, s) {
            return nativeMatch.call(n, s);
        };
    }
    return $6d686831831042f7$var$matchesImpl(node, selector);
}

});

parcelRegister("7nQFL", function(module, exports) {

$parcel$export(module.exports, "default", () => $56038a159bd64dd0$export$2e2bcd8739ae039);
var $56038a159bd64dd0$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $56038a159bd64dd0$export$2e2bcd8739ae039(element, selector) {
    return $56038a159bd64dd0$var$toArray(element.querySelectorAll(selector));
}

});

parcelRegister("hZkdd", function(module, exports) {

$parcel$export(module.exports, "default", () => $d187cfe59481cb7f$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
function $d187cfe59481cb7f$export$2e2bcd8739ae039(value) {
    const ref = (0, $Fo7oF.useRef)(null);
    (0, $Fo7oF.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}

});

parcelRegister("6OjZ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f56e9ea50b55f35$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
function $4f56e9ea50b55f35$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $Fo7oF.useReducer)((state)=>!state, false);
    return dispatch;
}

});

parcelRegister("8Bn0R", function(module, exports) {

$parcel$export(module.exports, "default", () => $6433a1532f11183b$export$2e2bcd8739ae039);

var $6QlZB = parcelRequire("6QlZB");

var $Fo7oF = parcelRequire("Fo7oF");
function $6433a1532f11183b$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $Fo7oF.useCallback)(()=>document, []);
    return (0, $6QlZB.default)(documentTarget, event, handler, capture);
}

});
parcelRegister("6QlZB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fb8a8a8d55cce34$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");

var $31c7C = parcelRequire("31c7C");
function $4fb8a8a8d55cce34$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $31c7C.default)(listener);
    (0, $Fo7oF.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}

});
parcelRegister("31c7C", function(module, exports) {

$parcel$export(module.exports, "default", () => $232ade3bef3e8277$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");

var $1X1ti = parcelRequire("1X1ti");
function $232ade3bef3e8277$export$2e2bcd8739ae039(fn) {
    const ref = (0, $1X1ti.default)(fn);
    return (0, $Fo7oF.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}

});
parcelRegister("1X1ti", function(module, exports) {

$parcel$export(module.exports, "default", () => $16bc7159a30e3d6a$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $16bc7159a30e3d6a$var$useCommittedRef(value) {
    const ref = (0, $Fo7oF.useRef)(value);
    (0, $Fo7oF.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $16bc7159a30e3d6a$export$2e2bcd8739ae039 = $16bc7159a30e3d6a$var$useCommittedRef;

});




parcelRegister("acBel", function(module, exports) {

$parcel$export(module.exports, "default", () => $76d7e78da20c4999$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
var $76d7e78da20c4999$var$DropdownContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createContext(null);
var $76d7e78da20c4999$export$2e2bcd8739ae039 = $76d7e78da20c4999$var$DropdownContext;

});

parcelRegister("duF8L", function(module, exports) {

$parcel$export(module.exports, "useDropdownMenu", () => $9d2dfd50efd53ec1$export$133c4d08f3775d64);
$parcel$export(module.exports, "default", () => $9d2dfd50efd53ec1$export$2e2bcd8739ae039);

var $fjJNR = parcelRequire("fjJNR");

var $elnlQ = parcelRequire("elnlQ");

var $d2bgE = parcelRequire("d2bgE");

var $Fo7oF = parcelRequire("Fo7oF");

var $ct1ws = parcelRequire("ct1ws");

var $acBel = parcelRequire("acBel");

var $l395l = parcelRequire("l395l");

var $djPxk = parcelRequire("djPxk");

var $blTZd = parcelRequire("blTZd");
var $9d2dfd50efd53ec1$var$noop = function noop() {};
function $9d2dfd50efd53ec1$export$133c4d08f3775d64(options) {
    if (options === void 0) options = {};
    var context = (0, $Fo7oF.useContext)((0, $acBel.default));
    var _useCallbackRef = (0, $ct1ws.default)(), arrowElement = _useCallbackRef[0], attachArrowRef = _useCallbackRef[1];
    var hasShownRef = (0, $Fo7oF.useRef)(false);
    var _options = options, flip = _options.flip, offset = _options.offset, rootCloseEvent = _options.rootCloseEvent, _options$fixed = _options.fixed, fixed = _options$fixed === void 0 ? false : _options$fixed, _options$popperConfig = _options.popperConfig, popperConfig = _options$popperConfig === void 0 ? {} : _options$popperConfig, _options$usePopper = _options.usePopper, shouldUsePopper = _options$usePopper === void 0 ? !!context : _options$usePopper;
    var show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    var alignEnd = (context == null ? void 0 : context.alignEnd) == null ? options.alignEnd : context.alignEnd;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    var handleClose = function handleClose(e) {
        context == null || context.toggle(false, e);
    };
    var _ref = context || {}, drop = _ref.drop, setMenu = _ref.setMenu, menuElement = _ref.menuElement, toggleElement = _ref.toggleElement;
    var placement = alignEnd ? 'bottom-end' : 'bottom-start';
    if (drop === 'up') placement = alignEnd ? 'top-end' : 'top-start';
    else if (drop === 'right') placement = alignEnd ? 'right-end' : 'right-start';
    else if (drop === 'left') placement = alignEnd ? 'left-end' : 'left-start';
    var popper = (0, $l395l.default)(toggleElement, menuElement, (0, $blTZd.default)({
        placement: placement,
        enabled: !!(shouldUsePopper && show),
        enableEvents: show,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    var menuProps = (0, $elnlQ.default)({
        ref: setMenu || $9d2dfd50efd53ec1$var$noop,
        'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    var metadata = {
        show: show,
        alignEnd: alignEnd,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? (0, $elnlQ.default)({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $djPxk.default)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
var $9d2dfd50efd53ec1$var$propTypes = {
    /**
   * A render prop that returns a Menu element. The `props`
   * argument should spread through to **a component that can accept a ref**.
   *
   * @type {Function ({
   *   show: boolean,
   *   alignEnd: boolean,
   *   close: (?SyntheticEvent) => void,
   *   placement: Placement,
   *   update: () => void,
   *   forceUpdate: () => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     aria-labelledby: ?string
   *   },
   *   arrowProps: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *   },
   * }) => React.Element}
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func.isRequired,
    /**
   * Controls the visible state of the menu, generally this is
   * provided by the parent `Dropdown` component,
   * but may also be specified as a prop directly.
   */ show: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    /**
   * Aligns the dropdown menu to the 'end' of it's placement position.
   * Generally this is provided by the parent `Dropdown` component,
   * but may also be specified as a prop directly.
   */ alignEnd: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    /**
   * Enables the Popper.js `flip` modifier, allowing the Dropdown to
   * automatically adjust it's placement in case of overlap with the viewport or toggle.
   * Refer to the [flip docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled) for more info
   */ flip: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    usePopper: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).oneOf([
        true,
        false
    ]),
    /**
   * A set of popper options and props passed directly to react-popper's Popper component.
   */ popperConfig: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).object,
    /**
   * Override the default event used by RootCloseWrapper.
   */ rootCloseEvent: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string
};
var $9d2dfd50efd53ec1$var$defaultProps = {
    usePopper: true
};
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $9d2dfd50efd53ec1$var$DropdownMenu(_ref2) {
    var children = _ref2.children, options = (0, $fjJNR.default)(_ref2, [
        "children"
    ]);
    var _useDropdownMenu = $9d2dfd50efd53ec1$export$133c4d08f3775d64(options), props = _useDropdownMenu[0], meta = _useDropdownMenu[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Fragment, null, meta.hasShown ? children(props, meta) : null);
}
$9d2dfd50efd53ec1$var$DropdownMenu.displayName = 'ReactOverlaysDropdownMenu';
$9d2dfd50efd53ec1$var$DropdownMenu.propTypes = $9d2dfd50efd53ec1$var$propTypes;
$9d2dfd50efd53ec1$var$DropdownMenu.defaultProps = $9d2dfd50efd53ec1$var$defaultProps;
var /** @component */ $9d2dfd50efd53ec1$export$2e2bcd8739ae039 = $9d2dfd50efd53ec1$var$DropdownMenu;

});
parcelRegister("ct1ws", function(module, exports) {

$parcel$export(module.exports, "default", () => $91395fc9f7ece2ed$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
function $91395fc9f7ece2ed$export$2e2bcd8739ae039() {
    return (0, $Fo7oF.useState)(null);
}

});

parcelRegister("l395l", function(module, exports) {

$parcel$export(module.exports, "default", () => $f530ecebf4dffe1a$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $Fo7oF = parcelRequire("Fo7oF");

var $j0zhD = parcelRequire("j0zhD");

var $a6c7O = parcelRequire("a6c7O");
var $f530ecebf4dffe1a$var$initialPopperStyles = function initialPopperStyles(position) {
    return {
        position: position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
};
var $f530ecebf4dffe1a$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false
}; // In order to satisfy the current usage of options, including undefined
var $f530ecebf4dffe1a$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: function effect(_ref) {
        var state = _ref.state;
        return function() {
            var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper;
            if ('removeAttribute' in reference) {
                var ids = (reference.getAttribute('aria-describedby') || '').split(',').filter(function(id) {
                    return id.trim() !== popper.id;
                });
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        };
    },
    fn: function fn(_ref2) {
        var _popper$getAttribute;
        var state = _ref2.state;
        var _state$elements2 = state.elements, popper = _state$elements2.popper, reference = _state$elements2.reference;
        var role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            var ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? ids + "," + popper.id : popper.id);
        }
    }
};
var $f530ecebf4dffe1a$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {boolean=}    options.eventsEnabled have Popper listen on window resize events to reposition the element
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $f530ecebf4dffe1a$var$usePopper(referenceElement, popperElement, _temp) {
    var _ref3 = _temp === void 0 ? {} : _temp, _ref3$enabled = _ref3.enabled, enabled = _ref3$enabled === void 0 ? true : _ref3$enabled, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? 'bottom' : _ref3$placement, _ref3$strategy = _ref3.strategy, strategy = _ref3$strategy === void 0 ? 'absolute' : _ref3$strategy, _ref3$modifiers = _ref3.modifiers, modifiers = _ref3$modifiers === void 0 ? $f530ecebf4dffe1a$var$EMPTY_MODIFIERS : _ref3$modifiers, config = (0, $fjJNR.default)(_ref3, [
        "enabled",
        "placement",
        "strategy",
        "modifiers"
    ]);
    var popperInstanceRef = (0, $Fo7oF.useRef)();
    var update = (0, $Fo7oF.useCallback)(function() {
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    var forceUpdate = (0, $Fo7oF.useCallback)(function() {
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    var _useSafeState = (0, $j0zhD.default)((0, $Fo7oF.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: $f530ecebf4dffe1a$var$initialPopperStyles(strategy),
            arrow: {}
        }
    })), popperState = _useSafeState[0], setState = _useSafeState[1];
    var updateModifier = (0, $Fo7oF.useMemo)(function() {
        return {
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref4) {
                var state = _ref4.state;
                var styles = {};
                var attributes = {};
                Object.keys(state.elements).forEach(function(element) {
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        };
    }, [
        update,
        forceUpdate,
        setState
    ]);
    (0, $Fo7oF.useEffect)(function() {
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [].concat(modifiers, [
                updateModifier,
                $f530ecebf4dffe1a$var$disabledApplyStylesModifier
            ])
        }); // intentionally NOT re-running on new modifiers
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        strategy,
        placement,
        updateModifier,
        enabled
    ]);
    (0, $Fo7oF.useEffect)(function() {
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $a6c7O.createPopper)(referenceElement, popperElement, (0, $elnlQ.default)({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [].concat(modifiers, [
                $f530ecebf4dffe1a$var$ariaDescribedByModifier,
                updateModifier
            ])
        }));
        return function() {
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState(function(s) {
                    return (0, $elnlQ.default)({}, s, {
                        attributes: {},
                        styles: {
                            popper: $f530ecebf4dffe1a$var$initialPopperStyles(strategy)
                        }
                    });
                });
            }
        }; // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $f530ecebf4dffe1a$export$2e2bcd8739ae039 = $f530ecebf4dffe1a$var$usePopper;

});
parcelRegister("j0zhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd6962f2adb7edbe$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");

var $aSNtq = parcelRequire("aSNtq");
/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $dd6962f2adb7edbe$var$useSafeState(state) {
    const isMounted = (0, $aSNtq.default)();
    return [
        state[0],
        (0, $Fo7oF.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $dd6962f2adb7edbe$export$2e2bcd8739ae039 = $dd6962f2adb7edbe$var$useSafeState;

});
parcelRegister("aSNtq", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ec552f9bfdb9e90$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
function $7ec552f9bfdb9e90$export$2e2bcd8739ae039() {
    const mounted = (0, $Fo7oF.useRef)(true);
    const isMounted = (0, $Fo7oF.useRef)(()=>mounted.current);
    (0, $Fo7oF.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}

});


parcelRegister("a6c7O", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $75a3deb62ee2aa7b$export$8f7491d57c8f97a9);

var $2tIg8 = parcelRequire("2tIg8");

var $gS0p0 = parcelRequire("gS0p0");

var $iHh9T = parcelRequire("iHh9T");

var $2SHvX = parcelRequire("2SHvX");

var $gi3Er = parcelRequire("gi3Er");

var $eODNn = parcelRequire("eODNn");

var $efatD = parcelRequire("efatD");

var $3LLpM = parcelRequire("3LLpM");

var $hhTpe = parcelRequire("hhTpe");

var $1pJDh = parcelRequire("1pJDh");
var $75a3deb62ee2aa7b$export$8f7491d57c8f97a9 = (0, $1pJDh.popperGenerator)({
    defaultModifiers: [
        (0, $gi3Er.default),
        (0, $efatD.default),
        (0, $gS0p0.default),
        (0, $iHh9T.default),
        (0, $eODNn.default),
        (0, $2SHvX.default),
        (0, $3LLpM.default),
        (0, $2tIg8.default)
    ]
});

});
parcelRegister("2tIg8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ce09f2e2d81d151$export$2e2bcd8739ae039);

var $1SnTI = parcelRequire("1SnTI");

var $g7vj6 = parcelRequire("g7vj6");

var $3LN1m = parcelRequire("3LN1m");

var $jkc4w = parcelRequire("jkc4w");

var $imL4I = parcelRequire("imL4I");

var $hN2vT = parcelRequire("hN2vT");

var $4N0x4 = parcelRequire("4N0x4");

var $h6els = parcelRequire("h6els");

var $hhTpe = parcelRequire("hhTpe");
var $1ce09f2e2d81d151$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $4N0x4.default)(typeof padding !== 'number' ? padding : (0, $h6els.default)(padding, (0, $hhTpe.basePlacements)));
};
function $1ce09f2e2d81d151$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $1SnTI.default)(state.placement);
    var axis = (0, $imL4I.default)(basePlacement);
    var isVertical = [
        (0, $hhTpe.left),
        (0, $hhTpe.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $1ce09f2e2d81d151$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $g7vj6.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $hhTpe.top) : (0, $hhTpe.left);
    var maxProp = axis === 'y' ? (0, $hhTpe.bottom) : (0, $hhTpe.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $jkc4w.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $hN2vT.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $1ce09f2e2d81d151$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $3LN1m.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $1ce09f2e2d81d151$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $1ce09f2e2d81d151$var$arrow,
    effect: $1ce09f2e2d81d151$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});
parcelRegister("1SnTI", function(module, exports) {

$parcel$export(module.exports, "default", () => $15dd5f2aa7cc5093$export$2e2bcd8739ae039);

function $15dd5f2aa7cc5093$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("g7vj6", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbc595b49df4f4ce$export$2e2bcd8739ae039);

var $l4yA7 = parcelRequire("l4yA7");
function $bbc595b49df4f4ce$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $l4yA7.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRegister("l4yA7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f574cbe0f8dead89$export$2e2bcd8739ae039);

var $bCBQY = parcelRequire("bCBQY");

var $94iL3 = parcelRequire("94iL3");

var $ivLfz = parcelRequire("ivLfz");

var $kYhwl = parcelRequire("kYhwl");
function $f574cbe0f8dead89$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $bCBQY.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $94iL3.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $94iL3.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $bCBQY.isElement)(element) ? (0, $ivLfz.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $kYhwl.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("bCBQY", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $87609b34c890fc6a$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $87609b34c890fc6a$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $87609b34c890fc6a$export$af51f0f06c0f328a);

var $ivLfz = parcelRequire("ivLfz");
function $87609b34c890fc6a$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $ivLfz.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $87609b34c890fc6a$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $ivLfz.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $87609b34c890fc6a$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $ivLfz.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("ivLfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d79fc62161b19cee$export$2e2bcd8739ae039);
function $d79fc62161b19cee$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("94iL3", function(module, exports) {

$parcel$export(module.exports, "max", () => $69a309b1e124cb6c$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $69a309b1e124cb6c$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $69a309b1e124cb6c$export$2077e0241d6afd3c);
var $69a309b1e124cb6c$export$8960430cfd85939f = Math.max;
var $69a309b1e124cb6c$export$96ec731ed4dcb222 = Math.min;
var $69a309b1e124cb6c$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("kYhwl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4470077e319d336$export$2e2bcd8739ae039);

var $kqsAd = parcelRequire("kqsAd");
function $f4470077e319d336$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $kqsAd.default)());
}

});
parcelRegister("kqsAd", function(module, exports) {

$parcel$export(module.exports, "default", () => $edec685f945fe389$export$2e2bcd8739ae039);
function $edec685f945fe389$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});




parcelRegister("3LN1m", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bebc96932bd70d3$export$2e2bcd8739ae039);

var $bCBQY = parcelRequire("bCBQY");
function $2bebc96932bd70d3$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $bCBQY.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("jkc4w", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1193fd5ed1474a9$export$2e2bcd8739ae039);

var $ivLfz = parcelRequire("ivLfz");

var $kL7DG = parcelRequire("kL7DG");

var $3ggMd = parcelRequire("3ggMd");

var $bCBQY = parcelRequire("bCBQY");

var $3QiHS = parcelRequire("3QiHS");

var $1Eoyj = parcelRequire("1Eoyj");

var $kqsAd = parcelRequire("kqsAd");
function $e1193fd5ed1474a9$var$getTrueOffsetParent(element) {
    if (!(0, $bCBQY.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $3ggMd.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $e1193fd5ed1474a9$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $kqsAd.default)());
    var isIE = /Trident/i.test((0, $kqsAd.default)());
    if (isIE && (0, $bCBQY.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $3ggMd.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $1Eoyj.default)(element);
    if ((0, $bCBQY.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $bCBQY.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $kL7DG.default)(currentNode)) < 0){
        var css = (0, $3ggMd.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $e1193fd5ed1474a9$export$2e2bcd8739ae039(element) {
    var window = (0, $ivLfz.default)(element);
    var offsetParent = $e1193fd5ed1474a9$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $3QiHS.default)(offsetParent) && (0, $3ggMd.default)(offsetParent).position === 'static')offsetParent = $e1193fd5ed1474a9$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $kL7DG.default)(offsetParent) === 'html' || (0, $kL7DG.default)(offsetParent) === 'body' && (0, $3ggMd.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $e1193fd5ed1474a9$var$getContainingBlock(element) || window;
}

});
parcelRegister("kL7DG", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1ce1f634de21aff$export$2e2bcd8739ae039);
function $f1ce1f634de21aff$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("3ggMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $25ffe13164c841a6$export$2e2bcd8739ae039);

var $ivLfz = parcelRequire("ivLfz");
function $25ffe13164c841a6$export$2e2bcd8739ae039(element) {
    return (0, $ivLfz.default)(element).getComputedStyle(element);
}

});

parcelRegister("3QiHS", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc4bd2971e9ce74$export$2e2bcd8739ae039);

var $kL7DG = parcelRequire("kL7DG");
function $2cc4bd2971e9ce74$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $kL7DG.default)(element)) >= 0;
}

});

parcelRegister("1Eoyj", function(module, exports) {

$parcel$export(module.exports, "default", () => $133c927dadc80074$export$2e2bcd8739ae039);

var $kL7DG = parcelRequire("kL7DG");

var $5jzmn = parcelRequire("5jzmn");

var $bCBQY = parcelRequire("bCBQY");
function $133c927dadc80074$export$2e2bcd8739ae039(element) {
    if ((0, $kL7DG.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $bCBQY.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $5jzmn.default)(element) // fallback
    );
}

});
parcelRegister("5jzmn", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dea27d7a6d0c6eb$export$2e2bcd8739ae039);

var $bCBQY = parcelRequire("bCBQY");
function $3dea27d7a6d0c6eb$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $bCBQY.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRegister("imL4I", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5eecc2c235577c1$export$2e2bcd8739ae039);
function $d5eecc2c235577c1$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});

parcelRegister("hN2vT", function(module, exports) {

$parcel$export(module.exports, "within", () => $cf38f6648a932349$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $cf38f6648a932349$export$86c8af6d3ef0b4a);

var $94iL3 = parcelRequire("94iL3");
function $cf38f6648a932349$export$f28d906d67a997f3(min, value, max) {
    return (0, $94iL3.max)(min, (0, $94iL3.min)(value, max));
}
function $cf38f6648a932349$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $cf38f6648a932349$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRegister("4N0x4", function(module, exports) {

$parcel$export(module.exports, "default", () => $37cc26bf8e818f9b$export$2e2bcd8739ae039);

var $eP5ag = parcelRequire("eP5ag");
function $37cc26bf8e818f9b$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $eP5ag.default)(), paddingObject);
}

});
parcelRegister("eP5ag", function(module, exports) {

$parcel$export(module.exports, "default", () => $aca9d5b01f2cb64b$export$2e2bcd8739ae039);
function $aca9d5b01f2cb64b$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("h6els", function(module, exports) {

$parcel$export(module.exports, "default", () => $c72e1fdb5d407811$export$2e2bcd8739ae039);
function $c72e1fdb5d407811$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});

parcelRegister("hhTpe", function(module, exports) {

$parcel$export(module.exports, "top", () => $c95f00a5c05bb2ff$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $c95f00a5c05bb2ff$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $c95f00a5c05bb2ff$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $c95f00a5c05bb2ff$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $c95f00a5c05bb2ff$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $c95f00a5c05bb2ff$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $c95f00a5c05bb2ff$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $c95f00a5c05bb2ff$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $c95f00a5c05bb2ff$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $c95f00a5c05bb2ff$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $c95f00a5c05bb2ff$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $c95f00a5c05bb2ff$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $c95f00a5c05bb2ff$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $c95f00a5c05bb2ff$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $c95f00a5c05bb2ff$export$d087d3878fdf71d5);
var $c95f00a5c05bb2ff$export$1e95b668f3b82d = 'top';
var $c95f00a5c05bb2ff$export$40e543e69a8b3fbb = 'bottom';
var $c95f00a5c05bb2ff$export$79ffe56a765070d2 = 'right';
var $c95f00a5c05bb2ff$export$eabcd2c8791e7bf4 = 'left';
var $c95f00a5c05bb2ff$export$dfb5619354ba860 = 'auto';
var $c95f00a5c05bb2ff$export$aec2ce47c367b8c3 = [
    $c95f00a5c05bb2ff$export$1e95b668f3b82d,
    $c95f00a5c05bb2ff$export$40e543e69a8b3fbb,
    $c95f00a5c05bb2ff$export$79ffe56a765070d2,
    $c95f00a5c05bb2ff$export$eabcd2c8791e7bf4
];
var $c95f00a5c05bb2ff$export$b3571188c770cc5a = 'start';
var $c95f00a5c05bb2ff$export$bd5df0f255a350f8 = 'end';
var $c95f00a5c05bb2ff$export$390fd549c5303b4d = 'clippingParents';
var $c95f00a5c05bb2ff$export$d7b7311ec04a3e8f = 'viewport';
var $c95f00a5c05bb2ff$export$ae5ab1c730825774 = 'popper';
var $c95f00a5c05bb2ff$export$ca50aac9f3ba507f = 'reference';
var $c95f00a5c05bb2ff$export$368f9a87e87fa4e1 = /*#__PURE__*/ $c95f00a5c05bb2ff$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $c95f00a5c05bb2ff$export$b3571188c770cc5a,
        placement + "-" + $c95f00a5c05bb2ff$export$bd5df0f255a350f8
    ]);
}, []);
var $c95f00a5c05bb2ff$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($c95f00a5c05bb2ff$export$aec2ce47c367b8c3, [
    $c95f00a5c05bb2ff$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $c95f00a5c05bb2ff$export$b3571188c770cc5a,
        placement + "-" + $c95f00a5c05bb2ff$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $c95f00a5c05bb2ff$export$421679a7c3d56e = 'beforeRead';
var $c95f00a5c05bb2ff$export$aafa59e2e03f2942 = 'read';
var $c95f00a5c05bb2ff$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $c95f00a5c05bb2ff$export$c65e99957a05207c = 'beforeMain';
var $c95f00a5c05bb2ff$export$f22da7240b7add18 = 'main';
var $c95f00a5c05bb2ff$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $c95f00a5c05bb2ff$export$8d4d2d70e7d46032 = 'beforeWrite';
var $c95f00a5c05bb2ff$export$68d8715fc104d294 = 'write';
var $c95f00a5c05bb2ff$export$70a6e5159acce2e6 = 'afterWrite';
var $c95f00a5c05bb2ff$export$d087d3878fdf71d5 = [
    $c95f00a5c05bb2ff$export$421679a7c3d56e,
    $c95f00a5c05bb2ff$export$aafa59e2e03f2942,
    $c95f00a5c05bb2ff$export$6964f6c886723980,
    $c95f00a5c05bb2ff$export$c65e99957a05207c,
    $c95f00a5c05bb2ff$export$f22da7240b7add18,
    $c95f00a5c05bb2ff$export$bab79516f2d662fe,
    $c95f00a5c05bb2ff$export$8d4d2d70e7d46032,
    $c95f00a5c05bb2ff$export$68d8715fc104d294,
    $c95f00a5c05bb2ff$export$70a6e5159acce2e6
];

});


parcelRegister("gS0p0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c482006379b86439$export$2e2bcd8739ae039);

var $hhTpe = parcelRequire("hhTpe");

var $jkc4w = parcelRequire("jkc4w");

var $ivLfz = parcelRequire("ivLfz");

var $5jzmn = parcelRequire("5jzmn");

var $3ggMd = parcelRequire("3ggMd");

var $1SnTI = parcelRequire("1SnTI");

var $d3cHK = parcelRequire("d3cHK");

var $94iL3 = parcelRequire("94iL3");
var $c482006379b86439$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $c482006379b86439$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $94iL3.round)(x * dpr) / dpr || 0,
        y: (0, $94iL3.round)(y * dpr) / dpr || 0
    };
}
function $c482006379b86439$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $hhTpe.left);
    var sideY = (0, $hhTpe.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $jkc4w.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $ivLfz.default)(popper)) {
            offsetParent = (0, $5jzmn.default)(popper);
            if ((0, $3ggMd.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $hhTpe.top) || (placement === (0, $hhTpe.left) || placement === (0, $hhTpe.right)) && variation === (0, $hhTpe.end)) {
            sideY = (0, $hhTpe.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $hhTpe.left) || (placement === (0, $hhTpe.top) || placement === (0, $hhTpe.bottom)) && variation === (0, $hhTpe.end)) {
            sideX = (0, $hhTpe.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $c482006379b86439$var$unsetSides);
    var _ref4 = roundOffsets === true ? $c482006379b86439$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $ivLfz.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $c482006379b86439$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $1SnTI.default)(state.placement),
        variation: (0, $d3cHK.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $c482006379b86439$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $c482006379b86439$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c482006379b86439$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $c482006379b86439$var$computeStyles,
    data: {}
};

});
parcelRegister("d3cHK", function(module, exports) {

$parcel$export(module.exports, "default", () => $9805690d513a85a9$export$2e2bcd8739ae039);
function $9805690d513a85a9$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});


parcelRegister("iHh9T", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9c98d797b0078e0$export$2e2bcd8739ae039);

var $ivLfz = parcelRequire("ivLfz");
var $d9c98d797b0078e0$var$passive = {
    passive: true
};
function $d9c98d797b0078e0$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $ivLfz.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $d9c98d797b0078e0$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $d9c98d797b0078e0$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $d9c98d797b0078e0$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $d9c98d797b0078e0$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $d9c98d797b0078e0$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $d9c98d797b0078e0$var$effect,
    data: {}
};

});

parcelRegister("2SHvX", function(module, exports) {

$parcel$export(module.exports, "default", () => $219260ff3fc3172f$export$2e2bcd8739ae039);

var $ac92L = parcelRequire("ac92L");

var $1SnTI = parcelRequire("1SnTI");

var $geIhW = parcelRequire("geIhW");

var $lCV9k = parcelRequire("lCV9k");

var $jDEhh = parcelRequire("jDEhh");

var $hhTpe = parcelRequire("hhTpe");

var $d3cHK = parcelRequire("d3cHK");
function $219260ff3fc3172f$var$getExpandedFallbackPlacements(placement) {
    if ((0, $1SnTI.default)(placement) === (0, $hhTpe.auto)) return [];
    var oppositePlacement = (0, $ac92L.default)(placement);
    return [
        (0, $geIhW.default)(placement),
        oppositePlacement,
        (0, $geIhW.default)(oppositePlacement)
    ];
}
function $219260ff3fc3172f$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $1SnTI.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $ac92L.default)(preferredPlacement)
    ] : $219260ff3fc3172f$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $1SnTI.default)(placement) === (0, $hhTpe.auto) ? (0, $jDEhh.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $1SnTI.default)(placement);
        var isStartVariation = (0, $d3cHK.default)(placement) === (0, $hhTpe.start);
        var isVertical = [
            (0, $hhTpe.top),
            (0, $hhTpe.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $lCV9k.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $hhTpe.right) : (0, $hhTpe.left) : isStartVariation ? (0, $hhTpe.bottom) : (0, $hhTpe.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $ac92L.default)(mainVariationSide);
        var altVariationSide = (0, $ac92L.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $219260ff3fc3172f$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $219260ff3fc3172f$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("ac92L", function(module, exports) {

$parcel$export(module.exports, "default", () => $76c20a38ab6b3f71$export$2e2bcd8739ae039);
var $76c20a38ab6b3f71$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $76c20a38ab6b3f71$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $76c20a38ab6b3f71$var$hash[matched];
    });
}

});

parcelRegister("geIhW", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd204ee36cb8d8d6$export$2e2bcd8739ae039);
var $bd204ee36cb8d8d6$var$hash = {
    start: 'end',
    end: 'start'
};
function $bd204ee36cb8d8d6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $bd204ee36cb8d8d6$var$hash[matched];
    });
}

});

parcelRegister("lCV9k", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbe97a4357ced082$export$2e2bcd8739ae039);

var $9cbMu = parcelRequire("9cbMu");

var $5jzmn = parcelRequire("5jzmn");

var $l4yA7 = parcelRequire("l4yA7");

var $oJlNS = parcelRequire("oJlNS");

var $hQcqb = parcelRequire("hQcqb");

var $hhTpe = parcelRequire("hhTpe");

var $bCBQY = parcelRequire("bCBQY");

var $4N0x4 = parcelRequire("4N0x4");

var $h6els = parcelRequire("h6els");
function $fbe97a4357ced082$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $hhTpe.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $hhTpe.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $hhTpe.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $4N0x4.default)(typeof padding !== 'number' ? padding : (0, $h6els.default)(padding, (0, $hhTpe.basePlacements)));
    var altContext = elementContext === (0, $hhTpe.popper) ? (0, $hhTpe.reference) : (0, $hhTpe.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $9cbMu.default)((0, $bCBQY.isElement)(element) ? element : element.contextElement || (0, $5jzmn.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $l4yA7.default)(state.elements.reference);
    var popperOffsets = (0, $oJlNS.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $hQcqb.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $hhTpe.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $hhTpe.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $hhTpe.right),
                (0, $hhTpe.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $hhTpe.top),
                (0, $hhTpe.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("9cbMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b1e5f83001ff948$export$2e2bcd8739ae039);

var $hhTpe = parcelRequire("hhTpe");

var $gAqkl = parcelRequire("gAqkl");

var $8dBqp = parcelRequire("8dBqp");

var $8Mv9l = parcelRequire("8Mv9l");

var $jkc4w = parcelRequire("jkc4w");

var $5jzmn = parcelRequire("5jzmn");

var $3ggMd = parcelRequire("3ggMd");

var $bCBQY = parcelRequire("bCBQY");

var $l4yA7 = parcelRequire("l4yA7");

var $1Eoyj = parcelRequire("1Eoyj");

var $3LN1m = parcelRequire("3LN1m");

var $kL7DG = parcelRequire("kL7DG");

var $hQcqb = parcelRequire("hQcqb");

var $94iL3 = parcelRequire("94iL3");
function $6b1e5f83001ff948$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $l4yA7.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $6b1e5f83001ff948$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $hhTpe.viewport) ? (0, $hQcqb.default)((0, $gAqkl.default)(element, strategy)) : (0, $bCBQY.isElement)(clippingParent) ? $6b1e5f83001ff948$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $hQcqb.default)((0, $8dBqp.default)((0, $5jzmn.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $6b1e5f83001ff948$var$getClippingParents(element) {
    var clippingParents = (0, $8Mv9l.default)((0, $1Eoyj.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $3ggMd.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $bCBQY.isHTMLElement)(element) ? (0, $jkc4w.default)(element) : element;
    if (!(0, $bCBQY.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $bCBQY.isElement)(clippingParent) && (0, $3LN1m.default)(clippingParent, clipperElement) && (0, $kL7DG.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $6b1e5f83001ff948$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $6b1e5f83001ff948$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $6b1e5f83001ff948$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $94iL3.max)(rect.top, accRect.top);
        accRect.right = (0, $94iL3.min)(rect.right, accRect.right);
        accRect.bottom = (0, $94iL3.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $94iL3.max)(rect.left, accRect.left);
        return accRect;
    }, $6b1e5f83001ff948$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("gAqkl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1346e22c7e21709$export$2e2bcd8739ae039);

var $ivLfz = parcelRequire("ivLfz");

var $5jzmn = parcelRequire("5jzmn");

var $kXxZv = parcelRequire("kXxZv");

var $kYhwl = parcelRequire("kYhwl");
function $c1346e22c7e21709$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $ivLfz.default)(element);
    var html = (0, $5jzmn.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $kYhwl.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $kXxZv.default)(element),
        y: y
    };
}

});
parcelRegister("kXxZv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f423af3946de3719$export$2e2bcd8739ae039);

var $l4yA7 = parcelRequire("l4yA7");

var $5jzmn = parcelRequire("5jzmn");

var $gtYqj = parcelRequire("gtYqj");
function $f423af3946de3719$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $l4yA7.default)((0, $5jzmn.default)(element)).left + (0, $gtYqj.default)(element).scrollLeft;
}

});
parcelRegister("gtYqj", function(module, exports) {

$parcel$export(module.exports, "default", () => $bffe39983f375125$export$2e2bcd8739ae039);

var $ivLfz = parcelRequire("ivLfz");
function $bffe39983f375125$export$2e2bcd8739ae039(node) {
    var win = (0, $ivLfz.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRegister("8dBqp", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fbc917483f1891d$export$2e2bcd8739ae039);

var $5jzmn = parcelRequire("5jzmn");

var $3ggMd = parcelRequire("3ggMd");

var $kXxZv = parcelRequire("kXxZv");

var $gtYqj = parcelRequire("gtYqj");

var $94iL3 = parcelRequire("94iL3");
function $5fbc917483f1891d$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $5jzmn.default)(element);
    var winScroll = (0, $gtYqj.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $94iL3.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $94iL3.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $kXxZv.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $3ggMd.default)(body || html).direction === 'rtl') x += (0, $94iL3.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("8Mv9l", function(module, exports) {

$parcel$export(module.exports, "default", () => $664af8165ea7674c$export$2e2bcd8739ae039);

var $je75n = parcelRequire("je75n");

var $1Eoyj = parcelRequire("1Eoyj");

var $ivLfz = parcelRequire("ivLfz");

var $4WzWD = parcelRequire("4WzWD");
function $664af8165ea7674c$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $je75n.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $ivLfz.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $4WzWD.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($664af8165ea7674c$export$2e2bcd8739ae039((0, $1Eoyj.default)(target)));
}

});
parcelRegister("je75n", function(module, exports) {

$parcel$export(module.exports, "default", () => $dff4d2333e6c9aa0$export$2e2bcd8739ae039);

var $1Eoyj = parcelRequire("1Eoyj");

var $4WzWD = parcelRequire("4WzWD");

var $kL7DG = parcelRequire("kL7DG");

var $bCBQY = parcelRequire("bCBQY");
function $dff4d2333e6c9aa0$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $kL7DG.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $bCBQY.isHTMLElement)(node) && (0, $4WzWD.default)(node)) return node;
    return $dff4d2333e6c9aa0$export$2e2bcd8739ae039((0, $1Eoyj.default)(node));
}

});
parcelRegister("4WzWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $3998761459a278cf$export$2e2bcd8739ae039);

var $3ggMd = parcelRequire("3ggMd");
function $3998761459a278cf$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $3ggMd.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRegister("hQcqb", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfd0eda2dc5a03fa$export$2e2bcd8739ae039);
function $cfd0eda2dc5a03fa$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("oJlNS", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a56bb42b8ccac2$export$2e2bcd8739ae039);

var $1SnTI = parcelRequire("1SnTI");

var $d3cHK = parcelRequire("d3cHK");

var $imL4I = parcelRequire("imL4I");

var $hhTpe = parcelRequire("hhTpe");
function $04a56bb42b8ccac2$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $1SnTI.default)(placement) : null;
    var variation = placement ? (0, $d3cHK.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $hhTpe.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $hhTpe.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $hhTpe.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $hhTpe.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $imL4I.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $hhTpe.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $hhTpe.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRegister("jDEhh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c0e72daef58247$export$2e2bcd8739ae039);

var $d3cHK = parcelRequire("d3cHK");

var $hhTpe = parcelRequire("hhTpe");

var $lCV9k = parcelRequire("lCV9k");

var $1SnTI = parcelRequire("1SnTI");
function $e4c0e72daef58247$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $hhTpe.placements) : _options$allowedAutoP;
    var variation = (0, $d3cHK.default)(placement);
    var placements = variation ? flipVariations ? (0, $hhTpe.variationPlacements) : (0, $hhTpe.variationPlacements).filter(function(placement) {
        return (0, $d3cHK.default)(placement) === variation;
    }) : (0, $hhTpe.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $lCV9k.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $1SnTI.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("gi3Er", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdc128dee2b76820$export$2e2bcd8739ae039);

var $hhTpe = parcelRequire("hhTpe");

var $lCV9k = parcelRequire("lCV9k");
function $bdc128dee2b76820$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $bdc128dee2b76820$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $hhTpe.top),
        (0, $hhTpe.right),
        (0, $hhTpe.bottom),
        (0, $hhTpe.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $bdc128dee2b76820$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $lCV9k.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $lCV9k.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $bdc128dee2b76820$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $bdc128dee2b76820$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $bdc128dee2b76820$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $bdc128dee2b76820$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $bdc128dee2b76820$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $bdc128dee2b76820$var$hide
};

});

parcelRegister("eODNn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac949ab6758eae34$export$2e2bcd8739ae039);

var $1SnTI = parcelRequire("1SnTI");

var $hhTpe = parcelRequire("hhTpe");
function $ac949ab6758eae34$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $1SnTI.default)(placement);
    var invertDistance = [
        (0, $hhTpe.left),
        (0, $hhTpe.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $hhTpe.left),
        (0, $hhTpe.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ac949ab6758eae34$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $hhTpe.placements).reduce(function(acc, placement) {
        acc[placement] = $ac949ab6758eae34$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ac949ab6758eae34$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ac949ab6758eae34$var$offset
};

});

parcelRegister("efatD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5ea97ee8531c7e7$export$2e2bcd8739ae039);

var $oJlNS = parcelRequire("oJlNS");
function $a5ea97ee8531c7e7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $oJlNS.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $a5ea97ee8531c7e7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $a5ea97ee8531c7e7$var$popperOffsets,
    data: {}
};

});

parcelRegister("3LLpM", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bea8a7e09341a56$export$2e2bcd8739ae039);

var $hhTpe = parcelRequire("hhTpe");

var $1SnTI = parcelRequire("1SnTI");

var $imL4I = parcelRequire("imL4I");

var $iZw2H = parcelRequire("iZw2H");

var $hN2vT = parcelRequire("hN2vT");

var $g7vj6 = parcelRequire("g7vj6");

var $jkc4w = parcelRequire("jkc4w");

var $lCV9k = parcelRequire("lCV9k");

var $d3cHK = parcelRequire("d3cHK");

var $eP5ag = parcelRequire("eP5ag");

var $94iL3 = parcelRequire("94iL3");
function $2bea8a7e09341a56$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $lCV9k.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $1SnTI.default)(state.placement);
    var variation = (0, $d3cHK.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $imL4I.default)(basePlacement);
    var altAxis = (0, $iZw2H.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $hhTpe.top) : (0, $hhTpe.left);
        var altSide = mainAxis === 'y' ? (0, $hhTpe.bottom) : (0, $hhTpe.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $hhTpe.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $hhTpe.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $g7vj6.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $eP5ag.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $hN2vT.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $jkc4w.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $hN2vT.within)(tether ? (0, $94iL3.min)(min, tetherMin) : min, offset, tether ? (0, $94iL3.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $hhTpe.top) : (0, $hhTpe.left);
        var _altSide = mainAxis === 'x' ? (0, $hhTpe.bottom) : (0, $hhTpe.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $hhTpe.top),
            (0, $hhTpe.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $hN2vT.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $hN2vT.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $2bea8a7e09341a56$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $2bea8a7e09341a56$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("iZw2H", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd36c77596640244$export$2e2bcd8739ae039);
function $dd36c77596640244$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});


parcelRegister("1pJDh", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $107b85e7e09bb56d$export$ed5e13716264f202);

var $4CbKy = parcelRequire("4CbKy");

var $g7vj6 = parcelRequire("g7vj6");

var $8Mv9l = parcelRequire("8Mv9l");

var $jkc4w = parcelRequire("jkc4w");

var $8TzWi = parcelRequire("8TzWi");

var $hZkDH = parcelRequire("hZkDH");

var $l6UVb = parcelRequire("l6UVb");


var $bCBQY = parcelRequire("bCBQY");
var $107b85e7e09bb56d$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $107b85e7e09bb56d$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $107b85e7e09bb56d$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $107b85e7e09bb56d$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $107b85e7e09bb56d$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $bCBQY.isElement)(reference) ? (0, $8Mv9l.default)(reference) : reference.contextElement ? (0, $8Mv9l.default)(reference.contextElement) : [],
                    popper: (0, $8Mv9l.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $8TzWi.default)((0, $l6UVb.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$107b85e7e09bb56d$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $4CbKy.default)(reference, (0, $jkc4w.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $g7vj6.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $hZkDH.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$107b85e7e09bb56d$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $107b85e7e09bb56d$export$8f7491d57c8f97a9 = /*#__PURE__*/ $107b85e7e09bb56d$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("4CbKy", function(module, exports) {

$parcel$export(module.exports, "default", () => $35c3d34dc470dd4a$export$2e2bcd8739ae039);

var $l4yA7 = parcelRequire("l4yA7");

var $2Cy83 = parcelRequire("2Cy83");

var $kL7DG = parcelRequire("kL7DG");

var $bCBQY = parcelRequire("bCBQY");

var $kXxZv = parcelRequire("kXxZv");

var $5jzmn = parcelRequire("5jzmn");

var $4WzWD = parcelRequire("4WzWD");

var $94iL3 = parcelRequire("94iL3");
function $35c3d34dc470dd4a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $94iL3.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $94iL3.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $35c3d34dc470dd4a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $bCBQY.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $bCBQY.isHTMLElement)(offsetParent) && $35c3d34dc470dd4a$var$isElementScaled(offsetParent);
    var documentElement = (0, $5jzmn.default)(offsetParent);
    var rect = (0, $l4yA7.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $kL7DG.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $4WzWD.default)(documentElement)) scroll = (0, $2Cy83.default)(offsetParent);
        if ((0, $bCBQY.isHTMLElement)(offsetParent)) {
            offsets = (0, $l4yA7.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $kXxZv.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("2Cy83", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e899aab5a4064fe$export$2e2bcd8739ae039);

var $gtYqj = parcelRequire("gtYqj");

var $ivLfz = parcelRequire("ivLfz");

var $bCBQY = parcelRequire("bCBQY");

var $jDclK = parcelRequire("jDclK");
function $1e899aab5a4064fe$export$2e2bcd8739ae039(node) {
    if (node === (0, $ivLfz.default)(node) || !(0, $bCBQY.isHTMLElement)(node)) return (0, $gtYqj.default)(node);
    else return (0, $jDclK.default)(node);
}

});
parcelRegister("jDclK", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4ab3d3faf7520a2$export$2e2bcd8739ae039);
function $e4ab3d3faf7520a2$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRegister("8TzWi", function(module, exports) {

$parcel$export(module.exports, "default", () => $679f5697745f20c6$export$2e2bcd8739ae039);

var $hhTpe = parcelRequire("hhTpe");
function $679f5697745f20c6$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $679f5697745f20c6$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $679f5697745f20c6$var$order(modifiers); // order based on phase
    return (0, $hhTpe.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("hZkDH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d18824b5d3129afb$export$2e2bcd8739ae039);
function $d18824b5d3129afb$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("l6UVb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5e64fe3371dfda4$export$2e2bcd8739ae039);
function $f5e64fe3371dfda4$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});




parcelRegister("djPxk", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b2506d2672f24f6$export$2e2bcd8739ae039);

var $k0XxB = parcelRequire("k0XxB");

var $1KSyE = parcelRequire("1KSyE");

var $Fo7oF = parcelRequire("Fo7oF");

var $31c7C = parcelRequire("31c7C");

var $8yRQ3 = parcelRequire("8yRQ3");

var $jyDE7 = parcelRequire("jyDE7");
var $9b2506d2672f24f6$var$escapeKeyCode = 27;
var $9b2506d2672f24f6$var$noop = function noop() {};
function $9b2506d2672f24f6$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $9b2506d2672f24f6$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $9b2506d2672f24f6$var$getRefTarget = function getRefTarget(ref) {
    return ref && ('current' in ref ? ref.current : ref);
};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $9b2506d2672f24f6$var$useRootClose(ref, onRootClose, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, disabled = _ref.disabled, _ref$clickTrigger = _ref.clickTrigger, clickTrigger = _ref$clickTrigger === void 0 ? 'click' : _ref$clickTrigger;
    var preventMouseRootCloseRef = (0, $Fo7oF.useRef)(false);
    var onClose = onRootClose || $9b2506d2672f24f6$var$noop;
    var handleMouseCapture = (0, $Fo7oF.useCallback)(function(e) {
        var _e$composedPath$;
        var currentTarget = $9b2506d2672f24f6$var$getRefTarget(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($8yRQ3)))(!!currentTarget, "RootClose captured a close event but does not have a ref to compare it to. useRootClose(), should be passed a ref that resolves to a DOM node");
        preventMouseRootCloseRef.current = !currentTarget || $9b2506d2672f24f6$var$isModifiedEvent(e) || !$9b2506d2672f24f6$var$isLeftClickEvent(e) || !!(0, $k0XxB.default)(currentTarget, (_e$composedPath$ = e.composedPath == null ? void 0 : e.composedPath()[0]) != null ? _e$composedPath$ : e.target);
    }, [
        ref
    ]);
    var handleMouse = (0, $31c7C.default)(function(e) {
        if (!preventMouseRootCloseRef.current) onClose(e);
    });
    var handleKeyUp = (0, $31c7C.default)(function(e) {
        if (e.keyCode === $9b2506d2672f24f6$var$escapeKeyCode) onClose(e);
    });
    (0, $Fo7oF.useEffect)(function() {
        if (disabled || ref == null) return undefined; // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        var currentEvent = window.event;
        var doc = (0, $jyDE7.default)($9b2506d2672f24f6$var$getRefTarget(ref)); // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        var removeMouseCaptureListener = (0, $1KSyE.default)(doc, clickTrigger, handleMouseCapture, true);
        var removeMouseListener = (0, $1KSyE.default)(doc, clickTrigger, function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        var removeKeyupListener = (0, $1KSyE.default)(doc, 'keyup', function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        var mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map(function(el) {
            return (0, $1KSyE.default)(el, 'mousemove', $9b2506d2672f24f6$var$noop);
        });
        return function() {
            removeMouseCaptureListener();
            removeMouseListener();
            removeKeyupListener();
            mobileSafariHackListeners.forEach(function(remove) {
                return remove();
            });
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleMouse,
        handleKeyUp
    ]);
}
var $9b2506d2672f24f6$export$2e2bcd8739ae039 = $9b2506d2672f24f6$var$useRootClose;

});
parcelRegister("k0XxB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e921fe52c41509fa$export$2e2bcd8739ae039);
/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $e921fe52c41509fa$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

});

parcelRegister("jyDE7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3cff22b074d7d01$export$2e2bcd8739ae039);

var $kyq9h = parcelRequire("kyq9h");

var $f0c8d = parcelRequire("f0c8d");
var $e3cff22b074d7d01$export$2e2bcd8739ae039 = function(componentOrElement) {
    return (0, $kyq9h.default)((0, $f0c8d.default)(componentOrElement));
};

});
parcelRegister("f0c8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $aec0442650eaa51e$export$2e2bcd8739ae039);

var $bvYwR = parcelRequire("bvYwR");
function $aec0442650eaa51e$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($bvYwR))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}

});



parcelRegister("blTZd", function(module, exports) {

$parcel$export(module.exports, "default", () => $843d15999d044437$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");
function $843d15999d044437$export$ba6dad097c8f5c38(modifiers) {
    var result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
     // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach(function(m) {
        result[m.name] = m;
    });
    return result;
}
function $843d15999d044437$export$af3a999d4a134c86(map) {
    if (map === void 0) map = {};
    if (Array.isArray(map)) return map;
    return Object.keys(map).map(function(k) {
        map[k].name = k;
        return map[k];
    });
}
function $843d15999d044437$export$2e2bcd8739ae039(_ref) {
    var _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    var enabled = _ref.enabled, enableEvents = _ref.enableEvents, placement = _ref.placement, flip = _ref.flip, offset = _ref.offset, fixed = _ref.fixed, containerPadding = _ref.containerPadding, arrowElement = _ref.arrowElement, _ref$popperConfig = _ref.popperConfig, popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig;
    var modifiers = $843d15999d044437$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return (0, $elnlQ.default)({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $843d15999d044437$export$af3a999d4a134c86((0, $elnlQ.default)({}, modifiers, {
            eventListeners: {
                enabled: enableEvents
            },
            preventOverflow: (0, $elnlQ.default)({}, modifiers.preventOverflow, {
                options: containerPadding ? (0, $elnlQ.default)({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: (0, $elnlQ.default)({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: (0, $elnlQ.default)({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: (0, $elnlQ.default)({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: (0, $elnlQ.default)({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}

});


parcelRegister("a5rV6", function(module, exports) {

$parcel$export(module.exports, "useDropdownToggle", () => $75800753d1ffa77c$export$96df6c7c5036b9a2);
$parcel$export(module.exports, "default", () => $75800753d1ffa77c$export$2e2bcd8739ae039);

var $d2bgE = parcelRequire("d2bgE");

var $Fo7oF = parcelRequire("Fo7oF");

var $acBel = parcelRequire("acBel");
var $75800753d1ffa77c$var$noop = function noop() {};
function $75800753d1ffa77c$export$96df6c7c5036b9a2() {
    var _ref = (0, $Fo7oF.useContext)((0, $acBel.default)) || {}, _ref$show = _ref.show, show = _ref$show === void 0 ? false : _ref$show, _ref$toggle = _ref.toggle, toggle = _ref$toggle === void 0 ? $75800753d1ffa77c$var$noop : _ref$toggle, setToggle = _ref.setToggle;
    var handleClick = (0, $Fo7oF.useCallback)(function(e) {
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    return [
        {
            ref: setToggle || $75800753d1ffa77c$var$noop,
            onClick: handleClick,
            'aria-haspopup': true,
            'aria-expanded': !!show
        },
        {
            show: show,
            toggle: toggle
        }
    ];
}
var $75800753d1ffa77c$var$propTypes = {
    /**
   * A render prop that returns a Toggle element. The `props`
   * argument should spread through to **a component that can accept a ref**. Use
   * the `onToggle` argument to toggle the menu open or closed
   *
   * @type {Function ({
   *   show: boolean,
   *   toggle: (show: boolean) => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     aria-haspopup: true
   *     aria-expanded: boolean
   *   },
   * }) => React.Element}
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func.isRequired
};
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $75800753d1ffa77c$var$DropdownToggle(_ref2) {
    var children = _ref2.children;
    var _useDropdownToggle = $75800753d1ffa77c$export$96df6c7c5036b9a2(), props = _useDropdownToggle[0], meta = _useDropdownToggle[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Fragment, null, children(props, meta));
}
$75800753d1ffa77c$var$DropdownToggle.displayName = 'ReactOverlaysDropdownToggle';
$75800753d1ffa77c$var$DropdownToggle.propTypes = $75800753d1ffa77c$var$propTypes;
var /** @component */ $75800753d1ffa77c$export$2e2bcd8739ae039 = $75800753d1ffa77c$var$DropdownToggle;

});


parcelRegister("u5Mlg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $05a748fce67301bd$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $7i6aT = parcelRequire("7i6aT");

var $6VnXl = parcelRequire("6VnXl");

var $508Sg = parcelRequire("508Sg");

var $abXOP = parcelRequire("abXOP");

var $dwZwr = parcelRequire("dwZwr");
var $05a748fce67301bd$var$defaultProps = {
    as: (0, $dwZwr.default),
    disabled: false
};
var $05a748fce67301bd$var$DropdownItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, children = _ref.children, eventKey = _ref.eventKey, disabled = _ref.disabled, href = _ref.href, onClick = _ref.onClick, onSelect = _ref.onSelect, propActive = _ref.active, Component = _ref.as, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "className",
        "children",
        "eventKey",
        "disabled",
        "href",
        "onClick",
        "onSelect",
        "active",
        "as"
    ]);
    var prefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'dropdown-item');
    var onSelectCtx = (0, $Fo7oF.useContext)((0, $6VnXl.default));
    var navContext = (0, $Fo7oF.useContext)((0, $abXOP.default));
    var _ref2 = navContext || {}, activeKey = _ref2.activeKey; // TODO: Restrict eventKey to string in v5?
    var key = (0, $6VnXl.makeEventKey)(eventKey, href);
    var active = propActive == null && key != null ? (0, $6VnXl.makeEventKey)(activeKey) === key : propActive;
    var handleClick = (0, $7i6aT.default)(function(event) {
        // SafeAnchor handles the disabled case, but we handle it here
        // for other components
        if (disabled) return;
        if (onClick) onClick(event);
        if (onSelectCtx) onSelectCtx(key, event);
        if (onSelect) onSelect(key, event);
    });
    return(/*#__PURE__*/ // "TS2604: JSX element type 'Component' does not have any construct or call signatures."
    // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, props, {
        ref: ref,
        href: href,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, prefix, active && 'active', disabled && 'disabled'),
        onClick: handleClick
    }), children));
});
$05a748fce67301bd$var$DropdownItem.displayName = 'DropdownItem';
$05a748fce67301bd$var$DropdownItem.defaultProps = $05a748fce67301bd$var$defaultProps;
var $05a748fce67301bd$export$2e2bcd8739ae039 = $05a748fce67301bd$var$DropdownItem;

});
parcelRegister("abXOP", function(module, exports) {

$parcel$export(module.exports, "default", () => $76b955423198f49b$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
var $76b955423198f49b$var$NavContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createContext(null);
$76b955423198f49b$var$NavContext.displayName = 'NavContext';
var $76b955423198f49b$export$2e2bcd8739ae039 = $76b955423198f49b$var$NavContext;

});


parcelRegister("8TtJs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "alignPropType", () => $679a85fc341e72af$export$5dd51d61a30477bc);
$parcel$export(module.exports, "default", () => $679a85fc341e72af$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $d2bgE = parcelRequire("d2bgE");

var $Fo7oF = parcelRequire("Fo7oF");

var $duF8L = parcelRequire("duF8L");

var $2N1Ur = parcelRequire("2N1Ur");
parcelRequire("8yRQ3");

var $3Y4TI = parcelRequire("3Y4TI");

var $508Sg = parcelRequire("508Sg");

var $5uNhm = parcelRequire("5uNhm");

var $lDC2W = parcelRequire("lDC2W");
var $679a85fc341e72af$var$alignDirection = (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).oneOf([
    'left',
    'right'
]);
var $679a85fc341e72af$export$5dd51d61a30477bc = (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).oneOfType([
    $679a85fc341e72af$var$alignDirection,
    (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).shape({
        sm: $679a85fc341e72af$var$alignDirection
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).shape({
        md: $679a85fc341e72af$var$alignDirection
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).shape({
        lg: $679a85fc341e72af$var$alignDirection
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).shape({
        xl: $679a85fc341e72af$var$alignDirection
    })
]);
var $679a85fc341e72af$var$defaultProps = {
    align: 'left',
    alignRight: false,
    flip: true
};
var $679a85fc341e72af$var$DropdownMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, align = _ref.align, alignRight = _ref.alignRight, rootCloseEvent = _ref.rootCloseEvent, flip = _ref.flip, showProps = _ref.show, renderOnMount = _ref.renderOnMount, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, popperConfig = _ref.popperConfig, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "className",
        "align",
        "alignRight",
        "rootCloseEvent",
        "flip",
        "show",
        "renderOnMount",
        "as",
        "popperConfig"
    ]);
    var isNavbar = (0, $Fo7oF.useContext)((0, $3Y4TI.default));
    var prefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'dropdown-menu');
    var _usePopperMarginModif = (0, $lDC2W.default)(), popperRef = _usePopperMarginModif[0], marginModifiers = _usePopperMarginModif[1];
    var alignClasses = [];
    if (align) {
        if (typeof align === 'object') {
            var keys = Object.keys(align);
            if (keys.length) {
                var brkPoint = keys[0];
                var direction = align[brkPoint]; // .dropdown-menu-right is required for responsively aligning
                // left in addition to align left classes.
                // Reuse alignRight to toggle the class below.
                alignRight = direction === 'left';
                alignClasses.push(prefix + "-" + brkPoint + "-" + direction);
            }
        } else if (align === 'right') alignRight = true;
    }
    var _useDropdownMenu = (0, $duF8L.useDropdownMenu)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        alignEnd: alignRight,
        usePopper: !isNavbar && alignClasses.length === 0,
        popperConfig: (0, $elnlQ.default)({}, popperConfig, {
            modifiers: marginModifiers.concat((popperConfig == null ? void 0 : popperConfig.modifiers) || [])
        })
    }), menuProps = _useDropdownMenu[0], _useDropdownMenu$ = _useDropdownMenu[1], hasShown = _useDropdownMenu$.hasShown, popper = _useDropdownMenu$.popper, show = _useDropdownMenu$.show, alignEnd = _useDropdownMenu$.alignEnd, toggle = _useDropdownMenu$.toggle;
    menuProps.ref = (0, $2N1Ur.default)(popperRef, (0, $2N1Ur.default)((0, $5uNhm.default)(ref, 'DropdownMenu'), menuProps.ref));
    if (!hasShown && !renderOnMount) return null; // For custom components provide additional, non-DOM, props;
    if (typeof Component !== 'string') {
        menuProps.show = show;
        menuProps.close = function() {
            return toggle == null ? void 0 : toggle(false);
        };
        menuProps.alignRight = alignEnd;
    }
    var style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = (0, $elnlQ.default)({}, props.style, menuProps.style);
        props['x-placement'] = popper.placement;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, props, menuProps, {
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T))).apply(void 0, [
            className,
            prefix,
            show && 'show',
            alignEnd && prefix + "-right"
        ].concat(alignClasses))
    }));
});
$679a85fc341e72af$var$DropdownMenu.displayName = 'DropdownMenu';
$679a85fc341e72af$var$DropdownMenu.defaultProps = $679a85fc341e72af$var$defaultProps;
var $679a85fc341e72af$export$2e2bcd8739ae039 = $679a85fc341e72af$var$DropdownMenu;

});
parcelRegister("2N1Ur", function(module, exports) {

$parcel$export(module.exports, "default", () => $2081a382e0f64b4a$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
var $2081a382e0f64b4a$var$toFnRef = function toFnRef(ref) {
    return !ref || typeof ref === 'function' ? ref : function(value) {
        ref.current = value;
    };
};
function $2081a382e0f64b4a$export$c9058316764c140e(refA, refB) {
    var a = $2081a382e0f64b4a$var$toFnRef(refA);
    var b = $2081a382e0f64b4a$var$toFnRef(refB);
    return function(value) {
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $2081a382e0f64b4a$var$useMergedRefs(refA, refB) {
    return (0, $Fo7oF.useMemo)(function() {
        return $2081a382e0f64b4a$export$c9058316764c140e(refA, refB);
    }, [
        refA,
        refB
    ]);
}
var $2081a382e0f64b4a$export$2e2bcd8739ae039 = $2081a382e0f64b4a$var$useMergedRefs;

});

parcelRegister("3Y4TI", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e3ac642a19fef73$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
var $2e3ac642a19fef73$var$context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createContext(null);
$2e3ac642a19fef73$var$context.displayName = 'NavbarContext';
var $2e3ac642a19fef73$export$2e2bcd8739ae039 = $2e3ac642a19fef73$var$context;

});

parcelRegister("5uNhm", function(module, exports) {

$parcel$export(module.exports, "default", () => $4005fae2d6d3a60d$export$2e2bcd8739ae039);
parcelRequire("8Mkf1");
parcelRequire("Fo7oF");
parcelRequire("2N1Ur");
function $4005fae2d6d3a60d$export$2e2bcd8739ae039(ref, componentName) {
    var warningRef;
    return ref; // eslint-disable-next-line react-hooks/rules-of-hooks
}

});

parcelRegister("lDC2W", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc0ac0b51b32a58a$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");

var $9bhko = parcelRequire("9bhko");

var $508Sg = parcelRequire("508Sg");
function $fc0ac0b51b32a58a$var$getMargins(element) {
    var styles = window.getComputedStyle(element);
    var top = parseFloat(styles.marginTop) || 0;
    var right = parseFloat(styles.marginRight) || 0;
    var bottom = parseFloat(styles.marginBottom) || 0;
    var left = parseFloat(styles.marginLeft) || 0;
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
}
function $fc0ac0b51b32a58a$export$2e2bcd8739ae039() {
    var overlayRef = (0, $Fo7oF.useRef)(null);
    var margins = (0, $Fo7oF.useRef)(null);
    var popoverClass = (0, $508Sg.useBootstrapPrefix)(undefined, 'popover');
    var dropdownMenuClass = (0, $508Sg.useBootstrapPrefix)(undefined, 'dropdown-menu');
    var callback = (0, $Fo7oF.useCallback)(function(overlay) {
        if (!overlay || !((0, $9bhko.default)(overlay, popoverClass) || (0, $9bhko.default)(overlay, dropdownMenuClass))) return;
        margins.current = $fc0ac0b51b32a58a$var$getMargins(overlay);
        overlay.style.margin = '0';
        overlayRef.current = overlay;
    }, [
        popoverClass,
        dropdownMenuClass
    ]);
    var offset = (0, $Fo7oF.useMemo)(function() {
        return {
            name: 'offset',
            options: {
                offset: function offset(_ref) {
                    var placement = _ref.placement;
                    if (!margins.current) return [
                        0,
                        0
                    ];
                    var _margins$current = margins.current, top = _margins$current.top, left = _margins$current.left, bottom = _margins$current.bottom, right = _margins$current.right;
                    switch(placement.split('-')[0]){
                        case 'top':
                            return [
                                0,
                                bottom
                            ];
                        case 'left':
                            return [
                                0,
                                right
                            ];
                        case 'bottom':
                            return [
                                0,
                                top
                            ];
                        case 'right':
                            return [
                                0,
                                left
                            ];
                        default:
                            return [
                                0,
                                0
                            ];
                    }
                }
            }
        };
    }, [
        margins
    ]); // Converts popover arrow margin to arrow modifier padding
    var popoverArrowMargins = (0, $Fo7oF.useMemo)(function() {
        return {
            name: 'popoverArrowMargins',
            enabled: true,
            phase: 'main',
            requiresIfExists: [
                'arrow'
            ],
            effect: function effect(_ref2) {
                var state = _ref2.state;
                if (!overlayRef.current || !state.elements.arrow || !(0, $9bhko.default)(overlayRef.current, popoverClass) || !state.modifiersData['arrow#persistent']) return undefined;
                var _getMargins = $fc0ac0b51b32a58a$var$getMargins(state.elements.arrow), top = _getMargins.top, right = _getMargins.right;
                var padding = top || right;
                state.modifiersData['arrow#persistent'].padding = {
                    top: padding,
                    left: padding,
                    right: padding,
                    bottom: padding
                };
                state.elements.arrow.style.margin = '0';
                return function() {
                    if (state.elements.arrow) state.elements.arrow.style.margin = '';
                };
            }
        };
    }, [
        popoverClass
    ]);
    return [
        callback,
        [
            offset,
            popoverArrowMargins
        ]
    ];
}

});
parcelRegister("9bhko", function(module, exports) {

$parcel$export(module.exports, "default", () => $6af2951ab2daf452$export$2e2bcd8739ae039);
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $6af2951ab2daf452$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});



parcelRegister("712fm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $51ba5e8cf8d19f41$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");
parcelRequire("gJ3n2");

var $Fo7oF = parcelRequire("Fo7oF");

var $a5rV6 = parcelRequire("a5rV6");

var $2N1Ur = parcelRequire("2N1Ur");

var $6MAJg = parcelRequire("6MAJg");

var $508Sg = parcelRequire("508Sg");

var $5uNhm = parcelRequire("5uNhm");
var $51ba5e8cf8d19f41$var$DropdownToggle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, split = _ref.split, className = _ref.className, childBsPrefix = _ref.childBsPrefix, _ref$as = _ref.as, Component = _ref$as === void 0 ? (0, $6MAJg.default) : _ref$as, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "split",
        "className",
        "childBsPrefix",
        "as"
    ]);
    var prefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'dropdown-toggle');
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    var _useDropdownToggle = (0, $a5rV6.useDropdownToggle)(), toggleProps = _useDropdownToggle[0];
    toggleProps.ref = (0, $2N1Ur.default)(toggleProps.ref, (0, $5uNhm.default)(ref, 'DropdownToggle')); // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, prefix, split && prefix + "-split")
    }, toggleProps, props));
});
$51ba5e8cf8d19f41$var$DropdownToggle.displayName = 'DropdownToggle';
var $51ba5e8cf8d19f41$export$2e2bcd8739ae039 = $51ba5e8cf8d19f41$var$DropdownToggle;

});


parcelRegister("duIXv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9d30f38f6545af35$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $Fo7oF = parcelRequire("Fo7oF");

var $d2bgE = parcelRequire("d2bgE");

var $5ePwi = parcelRequire("5ePwi");

var $712fm = parcelRequire("712fm");

var $8TtJs = parcelRequire("8TtJs");
var $9d30f38f6545af35$var$propTypes = {
    /**
   * An html id attribute for the Toggle button, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   * @required
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).any,
    /** An `href` passed to the Toggle component */ href: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    /** An `onClick` handler passed to the Toggle component */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    /** The content of the non-toggle Button.  */ title: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).node.isRequired,
    /** Disables both Buttons  */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    /**
   * Aligns the dropdown menu responsively.
   *
   * _see [DropdownMenu](#dropdown-menu-props) for more details_
   *
   * @type {"left"|"right"|{ sm: "left"|"right" }|{ md: "left"|"right" }|{ lg: "left"|"right" }|{ xl: "left"|"right"} }
   */ menuAlign: (0, $8TtJs.alignPropType),
    /** An ARIA accessible role applied to the Menu component. When set to 'menu', The dropdown */ menuRole: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    /** Whether to render the dropdown menu in the DOM before the first time it is shown */ renderMenuOnMount: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    /**
   *  Which event when fired outside the component will cause it to be closed.
   *
   * _see [DropdownMenu](#dropdown-menu-props) for more details_
   */ rootCloseEvent: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    /** @ignore */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    /** @ignore */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    /** @ignore */ size: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string
};
/**
 * A convenience component for simple or general use dropdowns. Renders a `Button` toggle and all `children`
 * are passed directly to the default `Dropdown.Menu`. This component accepts all of
 * [`Dropdown`'s props](#dropdown-props).
 *
 * _All unknown props are passed through to the `Dropdown` component._ Only
 * the Button `variant`, `size` and `bsPrefix` props are passed to the toggle,
 * along with menu-related props are passed to the `Dropdown.Menu`
 */ var $9d30f38f6545af35$var$DropdownButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var title = _ref.title, children = _ref.children, bsPrefix = _ref.bsPrefix, rootCloseEvent = _ref.rootCloseEvent, variant = _ref.variant, size = _ref.size, menuAlign = _ref.menuAlign, menuRole = _ref.menuRole, renderMenuOnMount = _ref.renderMenuOnMount, disabled = _ref.disabled, href = _ref.href, id = _ref.id, props = (0, $fjJNR.default)(_ref, [
        "title",
        "children",
        "bsPrefix",
        "rootCloseEvent",
        "variant",
        "size",
        "menuAlign",
        "menuRole",
        "renderMenuOnMount",
        "disabled",
        "href",
        "id"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $5ePwi.default), (0, $elnlQ.default)({
        ref: ref
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $712fm.default), {
        id: id,
        href: href,
        size: size,
        variant: variant,
        disabled: disabled,
        childBsPrefix: bsPrefix
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $8TtJs.default), {
        align: menuAlign,
        role: menuRole,
        renderOnMount: renderMenuOnMount,
        rootCloseEvent: rootCloseEvent
    }, children));
});
$9d30f38f6545af35$var$DropdownButton.displayName = 'DropdownButton';
$9d30f38f6545af35$var$DropdownButton.propTypes = $9d30f38f6545af35$var$propTypes;
var $9d30f38f6545af35$export$2e2bcd8739ae039 = $9d30f38f6545af35$var$DropdownButton;

});

parcelRegister("9riOH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6df53b4bb24784c6$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");
parcelRequire("1ndZg");
var $5VUYT = parcelRequire("5VUYT");

var $ghpJm = parcelRequire("ghpJm");

var $ijbIQ = parcelRequire("ijbIQ");

var $jWuhj = parcelRequire("jWuhj");

var $6WY1Z = parcelRequire("6WY1Z");

var $508Sg = parcelRequire("508Sg");

var $3Y4TI = parcelRequire("3Y4TI");

var $6VnXl = parcelRequire("6VnXl");
var $6df53b4bb24784c6$var$NavbarText = (0, $ghpJm.default)('navbar-text', {
    Component: 'span'
});
var $6df53b4bb24784c6$var$defaultProps = {
    expand: true,
    variant: 'light',
    collapseOnSelect: false
};
var $6df53b4bb24784c6$var$Navbar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(props, ref) {
    var _useUncontrolled = (0, $5VUYT.default)(props, {
        expanded: 'onToggle'
    }), initialBsPrefix = _useUncontrolled.bsPrefix, expand = _useUncontrolled.expand, variant = _useUncontrolled.variant, bg = _useUncontrolled.bg, fixed = _useUncontrolled.fixed, sticky = _useUncontrolled.sticky, className = _useUncontrolled.className, children = _useUncontrolled.children, _useUncontrolled$as = _useUncontrolled.as, Component = _useUncontrolled$as === void 0 ? 'nav' : _useUncontrolled$as, expanded = _useUncontrolled.expanded, _onToggle = _useUncontrolled.onToggle, onSelect = _useUncontrolled.onSelect, collapseOnSelect = _useUncontrolled.collapseOnSelect, controlledProps = (0, $fjJNR.default)(_useUncontrolled, [
        "bsPrefix",
        "expand",
        "variant",
        "bg",
        "fixed",
        "sticky",
        "className",
        "children",
        "as",
        "expanded",
        "onToggle",
        "onSelect",
        "collapseOnSelect"
    ]);
    var bsPrefix = (0, $508Sg.useBootstrapPrefix)(initialBsPrefix, 'navbar');
    var handleCollapse = (0, $Fo7oF.useCallback)(function() {
        if (onSelect) onSelect.apply(void 0, arguments);
        if (collapseOnSelect && expanded) {
            if (_onToggle) _onToggle(false);
        }
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        _onToggle
    ]); // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== 'nav') controlledProps.role = 'navigation';
    var expandClass = bsPrefix + "-expand";
    if (typeof expand === 'string') expandClass = expandClass + "-" + expand;
    var navbarContext = (0, $Fo7oF.useMemo)(function() {
        return {
            onToggle: function onToggle() {
                return _onToggle && _onToggle(!expanded);
            },
            bsPrefix: bsPrefix,
            expanded: !!expanded
        };
    }, [
        bsPrefix,
        expanded,
        _onToggle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $3Y4TI.default).Provider, {
        value: navbarContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $6VnXl.default).Provider, {
        value: handleCollapse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({
        ref: ref
    }, controlledProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix, expand && expandClass, variant && bsPrefix + "-" + variant, bg && "bg-" + bg, sticky && "sticky-" + sticky, fixed && "fixed-" + fixed)
    }), children)));
});
$6df53b4bb24784c6$var$Navbar.defaultProps = $6df53b4bb24784c6$var$defaultProps;
$6df53b4bb24784c6$var$Navbar.displayName = 'Navbar';
$6df53b4bb24784c6$var$Navbar.Brand = (0, $ijbIQ.default);
$6df53b4bb24784c6$var$Navbar.Toggle = (0, $6WY1Z.default);
$6df53b4bb24784c6$var$Navbar.Collapse = (0, $jWuhj.default);
$6df53b4bb24784c6$var$Navbar.Text = $6df53b4bb24784c6$var$NavbarText;
var $6df53b4bb24784c6$export$2e2bcd8739ae039 = $6df53b4bb24784c6$var$Navbar;

});
parcelRegister("ijbIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d54318288da9d13f$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");
var $d54318288da9d13f$var$NavbarBrand = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, as = _ref.as, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "className",
        "as"
    ]);
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'navbar-brand');
    var Component = as || (props.href ? 'a' : 'span');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix)
    }));
});
$d54318288da9d13f$var$NavbarBrand.displayName = 'NavbarBrand';
var $d54318288da9d13f$export$2e2bcd8739ae039 = $d54318288da9d13f$var$NavbarBrand;

});

parcelRegister("jWuhj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e84aebbd3be8b192$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $Fo7oF = parcelRequire("Fo7oF");

var $ev6at = parcelRequire("ev6at");

var $508Sg = parcelRequire("508Sg");

var $3Y4TI = parcelRequire("3Y4TI");
var $e84aebbd3be8b192$var$NavbarCollapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var children = _ref.children, bsPrefix = _ref.bsPrefix, props = (0, $fjJNR.default)(_ref, [
        "children",
        "bsPrefix"
    ]);
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'navbar-collapse');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $3Y4TI.default).Consumer, null, function(context) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $ev6at.default), (0, $elnlQ.default)({
            in: !!(context && context.expanded)
        }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", {
            ref: ref,
            className: bsPrefix
        }, children));
    });
});
$e84aebbd3be8b192$var$NavbarCollapse.displayName = 'NavbarCollapse';
var $e84aebbd3be8b192$export$2e2bcd8739ae039 = $e84aebbd3be8b192$var$NavbarCollapse;

});

parcelRegister("6WY1Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $50f6b9cbb4c90090$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $7i6aT = parcelRequire("7i6aT");

var $508Sg = parcelRequire("508Sg");

var $3Y4TI = parcelRequire("3Y4TI");
var $50f6b9cbb4c90090$var$defaultProps = {
    label: 'Toggle navigation'
};
var $50f6b9cbb4c90090$var$NavbarToggle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, children = _ref.children, label = _ref.label, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, onClick = _ref.onClick, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "className",
        "children",
        "label",
        "as",
        "onClick"
    ]);
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'navbar-toggler');
    var _ref2 = (0, $Fo7oF.useContext)((0, $3Y4TI.default)) || {}, onToggle = _ref2.onToggle, expanded = _ref2.expanded;
    var handleClick = (0, $7i6aT.default)(function(e) {
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, props, {
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix, !expanded && 'collapsed')
    }), children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("span", {
        className: bsPrefix + "-icon"
    }));
});
$50f6b9cbb4c90090$var$NavbarToggle.displayName = 'NavbarToggle';
$50f6b9cbb4c90090$var$NavbarToggle.defaultProps = $50f6b9cbb4c90090$var$defaultProps;
var $50f6b9cbb4c90090$export$2e2bcd8739ae039 = $50f6b9cbb4c90090$var$NavbarToggle;

});


parcelRegister("eqoNU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a806bbed296cc877$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");
parcelRequire("clW5X");

var $Fo7oF = parcelRequire("Fo7oF");
parcelRequire("1ndZg");
var $5VUYT = parcelRequire("5VUYT");

var $508Sg = parcelRequire("508Sg");

var $3Y4TI = parcelRequire("3Y4TI");

var $exUOK = parcelRequire("exUOK");

var $1EiS7 = parcelRequire("1EiS7");

var $4sxXJ = parcelRequire("4sxXJ");

var $b4orm = parcelRequire("b4orm");
var $a806bbed296cc877$var$defaultProps = {
    justify: false,
    fill: false
};
var $a806bbed296cc877$var$Nav = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(uncontrolledProps, ref) {
    var _classNames;
    var _useUncontrolled = (0, $5VUYT.default)(uncontrolledProps, {
        activeKey: 'onSelect'
    }), _useUncontrolled$as = _useUncontrolled.as, as = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as, initialBsPrefix = _useUncontrolled.bsPrefix, variant = _useUncontrolled.variant, fill = _useUncontrolled.fill, justify = _useUncontrolled.justify, navbar = _useUncontrolled.navbar, className = _useUncontrolled.className, children = _useUncontrolled.children, activeKey = _useUncontrolled.activeKey, props = (0, $fjJNR.default)(_useUncontrolled, [
        "as",
        "bsPrefix",
        "variant",
        "fill",
        "justify",
        "navbar",
        "className",
        "children",
        "activeKey"
    ]);
    var bsPrefix = (0, $508Sg.useBootstrapPrefix)(initialBsPrefix, 'nav');
    var navbarBsPrefix;
    var cardHeaderBsPrefix;
    var isNavbar = false;
    var navbarContext = (0, $Fo7oF.useContext)((0, $3Y4TI.default));
    var cardContext = (0, $Fo7oF.useContext)((0, $exUOK.default));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardContext) cardHeaderBsPrefix = cardContext.cardHeaderBsPrefix;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $1EiS7.default), (0, $elnlQ.default)({
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, (_classNames = {}, _classNames[bsPrefix] = !isNavbar, _classNames[navbarBsPrefix + "-nav"] = isNavbar, _classNames[cardHeaderBsPrefix + "-" + variant] = !!cardHeaderBsPrefix, _classNames[bsPrefix + "-" + variant] = !!variant, _classNames[bsPrefix + "-fill"] = fill, _classNames[bsPrefix + "-justified"] = justify, _classNames))
    }, props), children);
});
$a806bbed296cc877$var$Nav.displayName = 'Nav';
$a806bbed296cc877$var$Nav.defaultProps = $a806bbed296cc877$var$defaultProps;
$a806bbed296cc877$var$Nav.Item = (0, $4sxXJ.default);
$a806bbed296cc877$var$Nav.Link = (0, $b4orm.default);
var $a806bbed296cc877$export$2e2bcd8739ae039 = $a806bbed296cc877$var$Nav;

});
parcelRegister("1EiS7", function(module, exports) {

$parcel$export(module.exports, "default", () => $13382a7490d9d05a$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $7nQFL = parcelRequire("7nQFL");

var $Fo7oF = parcelRequire("Fo7oF");

var $8VLW6 = parcelRequire("8VLW6");

var $2N1Ur = parcelRequire("2N1Ur");

var $abXOP = parcelRequire("abXOP");

var $6VnXl = parcelRequire("6VnXl");

var $ira3M = parcelRequire("ira3M");
// eslint-disable-next-line @typescript-eslint/no-empty-function
var $13382a7490d9d05a$var$noop = function noop() {};
var $13382a7490d9d05a$var$AbstractNav = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'ul' : _ref$as, onSelect = _ref.onSelect, activeKey = _ref.activeKey, role = _ref.role, onKeyDown = _ref.onKeyDown, props = (0, $fjJNR.default)(_ref, [
        "as",
        "onSelect",
        "activeKey",
        "role",
        "onKeyDown"
    ]);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    var forceUpdate = (0, $8VLW6.default)();
    var needsRefocusRef = (0, $Fo7oF.useRef)(false);
    var parentOnSelect = (0, $Fo7oF.useContext)((0, $6VnXl.default));
    var tabContext = (0, $Fo7oF.useContext)((0, $ira3M.default));
    var getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    var listNode = (0, $Fo7oF.useRef)(null);
    var getNextActiveChild = function getNextActiveChild(offset) {
        var currentListNode = listNode.current;
        if (!currentListNode) return null;
        var items = (0, $7nQFL.default)(currentListNode, '[data-rb-event-key]:not(.disabled)');
        var activeChild = currentListNode.querySelector('.active');
        if (!activeChild) return null;
        var index = items.indexOf(activeChild);
        if (index === -1) return null;
        var nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    var handleSelect = function handleSelect(key, event) {
        if (key == null) return;
        if (onSelect) onSelect(key, event);
        if (parentOnSelect) parentOnSelect(key, event);
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (onKeyDown) onKeyDown(event);
        var nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveChild(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveChild(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset.rbEventKey, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $Fo7oF.useEffect)(function() {
        if (listNode.current && needsRefocusRef.current) {
            var activeChild = listNode.current.querySelector('[data-rb-event-key].active');
            if (activeChild) activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    var mergedRef = (0, $2N1Ur.default)(ref, listNode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $6VnXl.default).Provider, {
        value: handleSelect
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $abXOP.default).Provider, {
        value: {
            role: role,
            // used by NavLink to determine it's role
            activeKey: (0, $6VnXl.makeEventKey)(activeKey),
            getControlledId: getControlledId || $13382a7490d9d05a$var$noop,
            getControllerId: getControllerId || $13382a7490d9d05a$var$noop
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, props, {
        onKeyDown: handleKeyDown,
        ref: mergedRef,
        role: role
    }))));
});
var $13382a7490d9d05a$export$2e2bcd8739ae039 = $13382a7490d9d05a$var$AbstractNav;

});
parcelRegister("8VLW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6808d4b527335396$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
function $6808d4b527335396$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are stricting equal to the last state value
    var _useReducer = (0, $Fo7oF.useReducer)(function(state) {
        return !state;
    }, false), dispatch = _useReducer[1];
    return dispatch;
}

});

parcelRegister("ira3M", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6c28d54ff0e3ddb$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
var $d6c28d54ff0e3ddb$var$TabContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createContext(null);
var $d6c28d54ff0e3ddb$export$2e2bcd8739ae039 = $d6c28d54ff0e3ddb$var$TabContext;

});


parcelRegister("4sxXJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $33f41f30756a7484$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");
var $33f41f30756a7484$var$NavItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, children = _ref.children, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "className",
        "children",
        "as"
    ]);
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix)
    }), children);
});
$33f41f30756a7484$var$NavItem.displayName = 'NavItem';
var $33f41f30756a7484$export$2e2bcd8739ae039 = $33f41f30756a7484$var$NavItem;

});

parcelRegister("b4orm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $02146f97deaf5429$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $dwZwr = parcelRequire("dwZwr");

var $8Mt43 = parcelRequire("8Mt43");

var $508Sg = parcelRequire("508Sg");
var $02146f97deaf5429$var$defaultProps = {
    disabled: false,
    as: (0, $dwZwr.default)
};
var $02146f97deaf5429$var$NavLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, disabled = _ref.disabled, className = _ref.className, href = _ref.href, eventKey = _ref.eventKey, onSelect = _ref.onSelect, as = _ref.as, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "disabled",
        "className",
        "href",
        "eventKey",
        "onSelect",
        "as"
    ]);
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'nav-link');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $8Mt43.default), (0, $elnlQ.default)({}, props, {
        href: href,
        ref: ref,
        eventKey: eventKey,
        as: as,
        disabled: disabled,
        onSelect: onSelect,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix, disabled && 'disabled')
    }));
});
$02146f97deaf5429$var$NavLink.displayName = 'NavLink';
$02146f97deaf5429$var$NavLink.defaultProps = $02146f97deaf5429$var$defaultProps;
var $02146f97deaf5429$export$2e2bcd8739ae039 = $02146f97deaf5429$var$NavLink;

});
parcelRegister("8Mt43", function(module, exports) {

$parcel$export(module.exports, "default", () => $664959fe5320506d$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $7i6aT = parcelRequire("7i6aT");
parcelRequire("8yRQ3");

var $abXOP = parcelRequire("abXOP");

var $6VnXl = parcelRequire("6VnXl");
var $664959fe5320506d$var$defaultProps = {
    disabled: false
};
var $664959fe5320506d$var$AbstractNavItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var active = _ref.active, className = _ref.className, eventKey = _ref.eventKey, onSelect = _ref.onSelect, onClick = _ref.onClick, Component = _ref.as, props = (0, $fjJNR.default)(_ref, [
        "active",
        "className",
        "eventKey",
        "onSelect",
        "onClick",
        "as"
    ]);
    var navKey = (0, $6VnXl.makeEventKey)(eventKey, props.href);
    var parentOnSelect = (0, $Fo7oF.useContext)((0, $6VnXl.default));
    var navContext = (0, $Fo7oF.useContext)((0, $abXOP.default));
    var isActive = active;
    if (navContext) {
        if (!props.role && navContext.role === 'tablist') props.role = 'tab';
        var contextControllerId = navContext.getControllerId(navKey);
        var contextControlledId = navContext.getControlledId(navKey);
        props['data-rb-event-key'] = navKey;
        props.id = contextControllerId || props.id;
        props['aria-controls'] = contextControlledId || props['aria-controls'];
        isActive = active == null && navKey != null ? navContext.activeKey === navKey : active;
    }
    if (props.role === 'tab') {
        if (props.disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
        props['aria-selected'] = isActive;
    }
    var handleOnclick = (0, $7i6aT.default)(function(e) {
        if (onClick) onClick(e);
        if (navKey == null) return;
        if (onSelect) onSelect(navKey, e);
        if (parentOnSelect) parentOnSelect(navKey, e);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, props, {
        ref: ref,
        onClick: handleOnclick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, isActive && 'active')
    }));
});
$664959fe5320506d$var$AbstractNavItem.defaultProps = $664959fe5320506d$var$defaultProps;
var $664959fe5320506d$export$2e2bcd8739ae039 = $664959fe5320506d$var$AbstractNavItem;

});



parcelRegister("27kov", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $18ac0e140cfc6ccd$export$2e2bcd8739ae039);

var $fjJNR = parcelRequire("fjJNR");

var $elnlQ = parcelRequire("elnlQ");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $ghpJm = parcelRequire("ghpJm");

var $508Sg = parcelRequire("508Sg");
var $18ac0e140cfc6ccd$var$InputGroupAppend = (0, $ghpJm.default)('input-group-append');
var $18ac0e140cfc6ccd$var$InputGroupPrepend = (0, $ghpJm.default)('input-group-prepend');
var $18ac0e140cfc6ccd$var$InputGroupText = (0, $ghpJm.default)('input-group-text', {
    Component: 'span'
});
var $18ac0e140cfc6ccd$var$InputGroupCheckbox = function InputGroupCheckbox(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement($18ac0e140cfc6ccd$var$InputGroupText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("input", (0, $elnlQ.default)({
        type: "checkbox"
    }, props)));
};
var $18ac0e140cfc6ccd$var$InputGroupRadio = function InputGroupRadio(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement($18ac0e140cfc6ccd$var$InputGroupText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("input", (0, $elnlQ.default)({
        type: "radio"
    }, props)));
};
/**
 *
 * @property {InputGroupAppend} Append
 * @property {InputGroupPrepend} Prepend
 * @property {InputGroupText} Text
 * @property {InputGroupRadio} Radio
 * @property {InputGroupCheckbox} Checkbox
 */ var $18ac0e140cfc6ccd$var$InputGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, size = _ref.size, hasValidation = _ref.hasValidation, className = _ref.className, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "size",
        "hasValidation",
        "className",
        "as"
    ]);
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'input-group');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix, size && bsPrefix + "-" + size, hasValidation && 'has-validation')
    }));
});
$18ac0e140cfc6ccd$var$InputGroup.displayName = 'InputGroup';
var $18ac0e140cfc6ccd$var$InputGroupWithExtras = (0, $elnlQ.default)({}, $18ac0e140cfc6ccd$var$InputGroup, {
    Text: $18ac0e140cfc6ccd$var$InputGroupText,
    Radio: $18ac0e140cfc6ccd$var$InputGroupRadio,
    Checkbox: $18ac0e140cfc6ccd$var$InputGroupCheckbox,
    Append: $18ac0e140cfc6ccd$var$InputGroupAppend,
    Prepend: $18ac0e140cfc6ccd$var$InputGroupPrepend
});
var $18ac0e140cfc6ccd$export$2e2bcd8739ae039 = $18ac0e140cfc6ccd$var$InputGroupWithExtras;

});

parcelRegister("jXWG9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e8910b65f2c13ebc$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");
parcelRequire("8yRQ3");
parcelRequire("1ndZg");
var $5VUYT = parcelRequire("5VUYT");

var $508Sg = parcelRequire("508Sg");

var $1EiS7 = parcelRequire("1EiS7");

var $4PQpn = parcelRequire("4PQpn");
var $e8910b65f2c13ebc$var$defaultProps = {
    variant: undefined,
    horizontal: undefined
};
var $e8910b65f2c13ebc$var$ListGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(props, ref) {
    var _useUncontrolled = (0, $5VUYT.default)(props, {
        activeKey: 'onSelect'
    }), className = _useUncontrolled.className, initialBsPrefix = _useUncontrolled.bsPrefix, variant = _useUncontrolled.variant, horizontal = _useUncontrolled.horizontal, _useUncontrolled$as = _useUncontrolled.as, as = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as, controlledProps = (0, $fjJNR.default)(_useUncontrolled, [
        "className",
        "bsPrefix",
        "variant",
        "horizontal",
        "as"
    ]);
    var bsPrefix = (0, $508Sg.useBootstrapPrefix)(initialBsPrefix, 'list-group');
    var horizontalVariant;
    if (horizontal) horizontalVariant = horizontal === true ? 'horizontal' : "horizontal-" + horizontal;
    else horizontalVariant = null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $1EiS7.default), (0, $elnlQ.default)({
        ref: ref
    }, controlledProps, {
        as: as,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix, variant && bsPrefix + "-" + variant, horizontalVariant && bsPrefix + "-" + horizontalVariant)
    }));
});
$e8910b65f2c13ebc$var$ListGroup.defaultProps = $e8910b65f2c13ebc$var$defaultProps;
$e8910b65f2c13ebc$var$ListGroup.displayName = 'ListGroup';
$e8910b65f2c13ebc$var$ListGroup.Item = (0, $4PQpn.default);
var $e8910b65f2c13ebc$export$2e2bcd8739ae039 = $e8910b65f2c13ebc$var$ListGroup;

});
parcelRegister("4PQpn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $38549409c9e082ac$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $8Mt43 = parcelRequire("8Mt43");

var $6VnXl = parcelRequire("6VnXl");

var $508Sg = parcelRequire("508Sg");
var $38549409c9e082ac$var$defaultProps = {
    variant: undefined,
    active: false,
    disabled: false
};
var $38549409c9e082ac$var$ListGroupItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, active = _ref.active, disabled = _ref.disabled, className = _ref.className, variant = _ref.variant, action = _ref.action, as = _ref.as, eventKey = _ref.eventKey, onClick = _ref.onClick, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "active",
        "disabled",
        "className",
        "variant",
        "action",
        "as",
        "eventKey",
        "onClick"
    ]);
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'list-group-item');
    var handleClick = (0, $Fo7oF.useCallback)(function(event) {
        if (disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        if (onClick) onClick(event);
    }, [
        disabled,
        onClick
    ]);
    if (disabled && props.tabIndex === undefined) {
        props.tabIndex = -1;
        props['aria-disabled'] = true;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $8Mt43.default), (0, $elnlQ.default)({
        ref: ref
    }, props, {
        // TODO: Restrict eventKey to string in v5?
        eventKey: (0, $6VnXl.makeEventKey)(eventKey, props.href) // eslint-disable-next-line no-nested-ternary
        ,
        as: as || (action ? props.href ? 'a' : 'button' : 'div'),
        onClick: handleClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix, active && 'active', disabled && 'disabled', variant && bsPrefix + "-" + variant, action && bsPrefix + "-action")
    }));
});
$38549409c9e082ac$var$ListGroupItem.defaultProps = $38549409c9e082ac$var$defaultProps;
$38549409c9e082ac$var$ListGroupItem.displayName = 'ListGroupItem';
var $38549409c9e082ac$export$2e2bcd8739ae039 = $38549409c9e082ac$var$ListGroupItem;

});


parcelRegister("7I3gr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $59cf2cac91e1329a$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $6XdXy = parcelRequire("6XdXy");

var $9m3pg = parcelRequire("9m3pg");

var $kyq9h = parcelRequire("kyq9h");

var $gXRE3 = parcelRequire("gXRE3");

var $6762L = parcelRequire("6762L");

var $7H9sN = parcelRequire("7H9sN");

var $7i6aT = parcelRequire("7i6aT");

var $jBB0G = parcelRequire("jBB0G");

var $3dbbQ = parcelRequire("3dbbQ");

var $Fo7oF = parcelRequire("Fo7oF");

var $2NjUn = parcelRequire("2NjUn");
parcelRequire("8yRQ3");

var $ecf8Q = parcelRequire("ecf8Q");

var $b5rGi = parcelRequire("b5rGi");

var $7R8os = parcelRequire("7R8os");

var $hrMMo = parcelRequire("hrMMo");

var $h6QVW = parcelRequire("h6QVW");

var $avYaS = parcelRequire("avYaS");

var $8BYaT = parcelRequire("8BYaT");

var $1pLWH = parcelRequire("1pLWH");

var $508Sg = parcelRequire("508Sg");
var $59cf2cac91e1329a$var$manager;
var $59cf2cac91e1329a$var$defaultProps = {
    show: false,
    backdrop: true,
    keyboard: true,
    autoFocus: true,
    enforceFocus: true,
    restoreFocus: true,
    animation: true,
    dialogAs: (0, $h6QVW.default)
};
/* eslint-disable no-use-before-define, react/no-multi-comp */ function $59cf2cac91e1329a$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $b5rGi.default), props);
}
function $59cf2cac91e1329a$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $b5rGi.default), props);
}
/* eslint-enable no-use-before-define */ var $59cf2cac91e1329a$var$Modal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, style = _ref.style, dialogClassName = _ref.dialogClassName, contentClassName = _ref.contentClassName, children = _ref.children, Dialog = _ref.dialogAs, ariaLabelledby = _ref['aria-labelledby'], show = _ref.show, animation = _ref.animation, backdrop = _ref.backdrop, keyboard = _ref.keyboard, onEscapeKeyDown = _ref.onEscapeKeyDown, onShow = _ref.onShow, onHide = _ref.onHide, container = _ref.container, autoFocus = _ref.autoFocus, enforceFocus = _ref.enforceFocus, restoreFocus = _ref.restoreFocus, restoreFocusOptions = _ref.restoreFocusOptions, onEntered = _ref.onEntered, onExit = _ref.onExit, onExiting = _ref.onExiting, onEnter = _ref.onEnter, onEntering = _ref.onEntering, onExited = _ref.onExited, backdropClassName = _ref.backdropClassName, propsManager = _ref.manager, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "className",
        "style",
        "dialogClassName",
        "contentClassName",
        "children",
        "dialogAs",
        "aria-labelledby",
        "show",
        "animation",
        "backdrop",
        "keyboard",
        "onEscapeKeyDown",
        "onShow",
        "onHide",
        "container",
        "autoFocus",
        "enforceFocus",
        "restoreFocus",
        "restoreFocusOptions",
        "onEntered",
        "onExit",
        "onExiting",
        "onEnter",
        "onEntering",
        "onExited",
        "backdropClassName",
        "manager"
    ]);
    var _useState = (0, $Fo7oF.useState)({}), modalStyle = _useState[0], setStyle = _useState[1];
    var _useState2 = (0, $Fo7oF.useState)(false), animateStaticModal = _useState2[0], setAnimateStaticModal = _useState2[1];
    var waitingForMouseUpRef = (0, $Fo7oF.useRef)(false);
    var ignoreBackdropClickRef = (0, $Fo7oF.useRef)(false);
    var removeStaticModalAnimationRef = (0, $Fo7oF.useRef)(null); // TODO: what's this type
    var _useCallbackRef = (0, $7H9sN.default)(), modal = _useCallbackRef[0], setModalRef = _useCallbackRef[1];
    var handleHide = (0, $7i6aT.default)(onHide);
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'modal');
    (0, $Fo7oF.useImperativeHandle)(ref, function() {
        return {
            get _modal () {
                return modal;
            }
        };
    }, [
        modal
    ]);
    var modalContext = (0, $Fo7oF.useMemo)(function() {
        return {
            onHide: handleHide
        };
    }, [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (!$59cf2cac91e1329a$var$manager) $59cf2cac91e1329a$var$manager = new (0, $ecf8Q.default)();
        return $59cf2cac91e1329a$var$manager;
    }
    function updateDialogStyle(node) {
        if (!(0, $9m3pg.default)) return;
        var containerIsOverflowing = getModalManager().isContainerOverflowing(modal);
        var modalIsOverflowing = node.scrollHeight > (0, $kyq9h.default)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $6762L.default)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $6762L.default)() : undefined
        });
    }
    var handleWindowResize = (0, $7i6aT.default)(function() {
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $jBB0G.default)(function() {
        (0, $gXRE3.default)(window, 'resize', handleWindowResize);
        if (removeStaticModalAnimationRef.current) removeStaticModalAnimationRef.current();
    }); // We prevent the modal from closing during a drag by detecting where the
    // the click originates from. If it starts in the modal and then ends outside
    // don't close.
    var handleDialogMouseDown = function handleDialogMouseDown() {
        waitingForMouseUpRef.current = true;
    };
    var handleMouseUp = function handleMouseUp(e) {
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    var handleStaticModalAnimation = function handleStaticModalAnimation() {
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $3dbbQ.default)(modal.dialog, function() {
            setAnimateStaticModal(false);
        });
    };
    var handleStaticBackdropClick = function handleStaticBackdropClick(e) {
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    var handleClick = function handleClick(e) {
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide();
    };
    var handleEscapeKeyDown = function handleEscapeKeyDown(e) {
        if (!keyboard && backdrop === 'static') {
            // Call preventDefault to stop modal from closing in react-overlays,
            // then play our animation.
            e.preventDefault();
            handleStaticModalAnimation();
        } else if (keyboard && onEscapeKeyDown) onEscapeKeyDown(e);
    };
    var handleEnter = function handleEnter(node) {
        if (node) {
            node.style.display = 'block';
            updateDialogStyle(node);
        }
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (onEnter) onEnter.apply(void 0, [
            node
        ].concat(args));
    };
    var handleExit = function handleExit(node) {
        if (removeStaticModalAnimationRef.current) removeStaticModalAnimationRef.current();
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        if (onExit) onExit.apply(void 0, [
            node
        ].concat(args));
    };
    var handleEntering = function handleEntering(node) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        if (onEntering) onEntering.apply(void 0, [
            node
        ].concat(args)); // FIXME: This should work even when animation is disabled.
        (0, $6XdXy.default)(window, 'resize', handleWindowResize);
    };
    var handleExited = function handleExited(node) {
        if (node) node.style.display = ''; // RHL removes it sometimes
        for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
        if (onExited) onExited.apply(void 0, args); // FIXME: This should work even when animation is disabled.
        (0, $gXRE3.default)(window, 'resize', handleWindowResize);
    };
    var renderBackdrop = (0, $Fo7oF.useCallback)(function(backdropProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", (0, $elnlQ.default)({}, backdropProps, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(bsPrefix + "-backdrop", backdropClassName, !animation && 'show')
        }));
    }, [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    var baseModalStyle = (0, $elnlQ.default)({}, style, modalStyle); // Sets `display` always block when `animation` is false
    if (!animation) baseModalStyle.display = 'block';
    var renderDialog = function renderDialog(dialogProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", (0, $elnlQ.default)({
            role: "dialog"
        }, dialogProps, {
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix, animateStaticModal && bsPrefix + "-static"),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "aria-labelledby": ariaLabelledby
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Dialog, (0, $elnlQ.default)({}, props, {
            onMouseDown: handleDialogMouseDown,
            className: dialogClassName,
            contentClassName: contentClassName
        }), children));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $hrMMo.default).Provider, {
        value: modalContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $2NjUn.default), {
        show: show,
        ref: setModalRef,
        backdrop: backdrop,
        container: container,
        keyboard: true // Always set true - see handleEscapeKeyDown
        ,
        autoFocus: autoFocus,
        enforceFocus: enforceFocus,
        restoreFocus: restoreFocus,
        restoreFocusOptions: restoreFocusOptions,
        onEscapeKeyDown: handleEscapeKeyDown,
        onShow: onShow,
        onHide: onHide,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: onEntered,
        onExit: handleExit,
        onExiting: onExiting,
        onExited: handleExited,
        manager: getModalManager(),
        containerClassName: bsPrefix + "-open",
        transition: animation ? $59cf2cac91e1329a$var$DialogTransition : undefined,
        backdropTransition: animation ? $59cf2cac91e1329a$var$BackdropTransition : undefined,
        renderBackdrop: renderBackdrop,
        renderDialog: renderDialog
    }));
});
$59cf2cac91e1329a$var$Modal.displayName = 'Modal';
$59cf2cac91e1329a$var$Modal.defaultProps = $59cf2cac91e1329a$var$defaultProps;
$59cf2cac91e1329a$var$Modal.Body = (0, $7R8os.default);
$59cf2cac91e1329a$var$Modal.Header = (0, $8BYaT.default);
$59cf2cac91e1329a$var$Modal.Title = (0, $1pLWH.default);
$59cf2cac91e1329a$var$Modal.Footer = (0, $avYaS.default);
$59cf2cac91e1329a$var$Modal.Dialog = (0, $h6QVW.default);
$59cf2cac91e1329a$var$Modal.TRANSITION_DURATION = 300;
$59cf2cac91e1329a$var$Modal.BACKDROP_TRANSITION_DURATION = 150;
var $59cf2cac91e1329a$export$2e2bcd8739ae039 = $59cf2cac91e1329a$var$Modal;

});
parcelRegister("6762L", function(module, exports) {

$parcel$export(module.exports, "default", () => $473815a22e717657$export$2e2bcd8739ae039);

var $9m3pg = parcelRequire("9m3pg");
var $473815a22e717657$var$size;
function $473815a22e717657$export$2e2bcd8739ae039(recalc) {
    if (!$473815a22e717657$var$size && $473815a22e717657$var$size !== 0 || recalc) {
        if (0, $9m3pg.default) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $473815a22e717657$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $473815a22e717657$var$size;
}

});

parcelRegister("7H9sN", function(module, exports) {

$parcel$export(module.exports, "default", () => $59a3e3d1e3d4553c$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
function $59a3e3d1e3d4553c$export$2e2bcd8739ae039() {
    return (0, $Fo7oF.useState)(null);
}

});

parcelRegister("jBB0G", function(module, exports) {

$parcel$export(module.exports, "default", () => $e45e2e6b70ebf8ae$export$2e2bcd8739ae039);

var $6UstH = parcelRequire("6UstH");

var $Fo7oF = parcelRequire("Fo7oF");
function $e45e2e6b70ebf8ae$export$2e2bcd8739ae039(fn) {
    var onUnmount = (0, $6UstH.default)(fn);
    (0, $Fo7oF.useEffect)(function() {
        return function() {
            return onUnmount.current();
        };
    }, []);
}

});
parcelRegister("6UstH", function(module, exports) {

$parcel$export(module.exports, "default", () => $507e102bf71647fb$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
function $507e102bf71647fb$export$2e2bcd8739ae039(value) {
    var valueRef = (0, $Fo7oF.useRef)(value);
    valueRef.current = value;
    return valueRef;
}

});


parcelRegister("2NjUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $208f99badb282725$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $Kp4Aq = parcelRequire("Kp4Aq");

var $k0XxB = parcelRequire("k0XxB");

var $9m3pg = parcelRequire("9m3pg");

var $1KSyE = parcelRequire("1KSyE");

var $d2bgE = parcelRequire("d2bgE");

var $Fo7oF = parcelRequire("Fo7oF");

var $bvYwR = parcelRequire("bvYwR");

var $aSNtq = parcelRequire("aSNtq");

var $3A80v = parcelRequire("3A80v");

var $hZkdd = parcelRequire("hZkdd");

var $31c7C = parcelRequire("31c7C");

var $i6eD5 = parcelRequire("i6eD5");

var $c0QzI = parcelRequire("c0QzI");
var $208f99badb282725$var$manager;
function $208f99badb282725$var$getManager() {
    if (!$208f99badb282725$var$manager) $208f99badb282725$var$manager = new (0, $i6eD5.default)();
    return $208f99badb282725$var$manager;
}
function $208f99badb282725$var$useModalManager(provided) {
    var modalManager = provided || $208f99badb282725$var$getManager();
    var modal = (0, $Fo7oF.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: function add(container, className) {
            return modalManager.add(modal.current, container, className);
        },
        remove: function remove() {
            return modalManager.remove(modal.current);
        },
        isTopModal: function isTopModal() {
            return modalManager.isTopModal(modal.current);
        },
        setDialogRef: (0, $Fo7oF.useCallback)(function(ref) {
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $Fo7oF.useCallback)(function(ref) {
            modal.current.backdrop = ref;
        }, [])
    });
}
var $208f99badb282725$var$Modal = /*#__PURE__*/ (0, $Fo7oF.forwardRef)(function(_ref, ref) {
    var _ref$show = _ref.show, show = _ref$show === void 0 ? false : _ref$show, _ref$role = _ref.role, role = _ref$role === void 0 ? 'dialog' : _ref$role, className = _ref.className, style = _ref.style, children = _ref.children, _ref$backdrop = _ref.backdrop, backdrop = _ref$backdrop === void 0 ? true : _ref$backdrop, _ref$keyboard = _ref.keyboard, keyboard = _ref$keyboard === void 0 ? true : _ref$keyboard, onBackdropClick = _ref.onBackdropClick, onEscapeKeyDown = _ref.onEscapeKeyDown, transition = _ref.transition, backdropTransition = _ref.backdropTransition, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$enforceFocus = _ref.enforceFocus, enforceFocus = _ref$enforceFocus === void 0 ? true : _ref$enforceFocus, _ref$restoreFocus = _ref.restoreFocus, restoreFocus = _ref$restoreFocus === void 0 ? true : _ref$restoreFocus, restoreFocusOptions = _ref.restoreFocusOptions, renderDialog = _ref.renderDialog, _ref$renderBackdrop = _ref.renderBackdrop, renderBackdrop = _ref$renderBackdrop === void 0 ? function(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", props);
    } : _ref$renderBackdrop, providedManager = _ref.manager, containerRef = _ref.container, containerClassName = _ref.containerClassName, onShow = _ref.onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? function() {} : _ref$onHide, onExit = _ref.onExit, onExited = _ref.onExited, onExiting = _ref.onExiting, onEnter = _ref.onEnter, onEntering = _ref.onEntering, onEntered = _ref.onEntered, rest = (0, $fjJNR.default)(_ref, [
        "show",
        "role",
        "className",
        "style",
        "children",
        "backdrop",
        "keyboard",
        "onBackdropClick",
        "onEscapeKeyDown",
        "transition",
        "backdropTransition",
        "autoFocus",
        "enforceFocus",
        "restoreFocus",
        "restoreFocusOptions",
        "renderDialog",
        "renderBackdrop",
        "manager",
        "container",
        "containerClassName",
        "onShow",
        "onHide",
        "onExit",
        "onExited",
        "onExiting",
        "onEnter",
        "onEntering",
        "onEntered"
    ]);
    var container = (0, $c0QzI.default)(containerRef);
    var modal = $208f99badb282725$var$useModalManager(providedManager);
    var isMounted = (0, $aSNtq.default)();
    var prevShow = (0, $hZkdd.default)(show);
    var _useState = (0, $Fo7oF.useState)(!show), exited = _useState[0], setExited = _useState[1];
    var lastFocusRef = (0, $Fo7oF.useRef)(null);
    (0, $Fo7oF.useImperativeHandle)(ref, function() {
        return modal;
    }, [
        modal
    ]);
    if ((0, $9m3pg.default) && !prevShow && show) lastFocusRef.current = (0, $Kp4Aq.default)();
    if (!transition && !show && !exited) setExited(true);
    else if (show && exited) setExited(false);
    var handleShow = (0, $31c7C.default)(function() {
        modal.add(container, containerClassName);
        removeKeydownListenerRef.current = (0, $1KSyE.default)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $1KSyE.default)(document, 'focus', // and so steals focus from it
        function() {
            return setTimeout(handleEnforceFocus);
        }, true);
        if (onShow) onShow();
         // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var currentActiveElement = (0, $Kp4Aq.default)(document);
            if (modal.dialog && currentActiveElement && !(0, $k0XxB.default)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    var handleHide = (0, $31c7C.default)(function() {
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    }); // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $Fo7oF.useEffect)(function() {
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]); // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $Fo7oF.useEffect)(function() {
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $3A80v.default)(function() {
        handleHide();
    }); // --------------------------------
    var handleEnforceFocus = (0, $31c7C.default)(function() {
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        var currentActiveElement = (0, $Kp4Aq.default)();
        if (modal.dialog && currentActiveElement && !(0, $k0XxB.default)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    var handleBackdropClick = (0, $31c7C.default)(function(e) {
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    var handleDocumentKeyDown = (0, $31c7C.default)(function(e) {
        if (keyboard && e.keyCode === 27 && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    var removeFocusListenerRef = (0, $Fo7oF.useRef)();
    var removeKeydownListenerRef = (0, $Fo7oF.useRef)();
    var handleHidden = function handleHidden() {
        setExited(true);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        onExited == null || onExited.apply(void 0, args);
    };
    var Transition = transition;
    if (!container || !(show || Transition && !exited)) return null;
    var dialogProps = (0, $elnlQ.default)({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    var dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", dialogProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).cloneElement(children, {
        role: 'document'
    }));
    if (Transition) dialog = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Transition, {
        appear: true,
        unmountOnExit: true,
        "in": !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    }, dialog);
    var backdropElement = null;
    if (backdrop) {
        var BackdropTransition = backdropTransition;
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        if (BackdropTransition) backdropElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(BackdropTransition, {
            appear: true,
            "in": !!show
        }, backdropElement);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bvYwR))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Fragment, null, backdropElement, dialog), container));
});
var $208f99badb282725$var$propTypes = {
    /**
   * Set the visibility of the Modal
   */ show: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    /**
   * A DOM element, a `ref` to an element, or function that returns either. The Modal is appended to it's `container` element.
   *
   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
   * page content can be placed behind a virtual backdrop as well as a visual one.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).any,
    /**
   * A callback fired when the Modal is opening.
   */ onShow: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    /**
   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
   *
   * The `onHide` callback only signals intent from the Modal,
   * you must actually set the `show` prop to `false` for the Modal to close.
   */ onHide: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    /**
   * Include a backdrop component.
   */ backdrop: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).oneOf([
            'static'
        ])
    ]),
    /**
   * A function that returns the dialog component. Useful for custom
   * rendering. **Note:** the component should make sure to apply the provided ref.
   *
   * ```js static
   * renderDialog={props => <MyDialog {...props} />}
   * ```
   */ renderDialog: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    /**
   * A function that returns a backdrop component. Useful for custom
   * backdrop rendering.
   *
   * ```js
   *  renderBackdrop={props => <MyBackdrop {...props} />}
   * ```
   */ renderBackdrop: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    /**
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   *
   * If preventDefault() is called on the keyboard event, closing the modal will be cancelled.
   */ onEscapeKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    /**
   * A callback fired when the backdrop, if specified, is clicked.
   */ onBackdropClick: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    /**
   * A css class or set of classes applied to the modal container when the modal is open,
   * and removed when it is closed.
   */ containerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    /**
   * Close the modal when escape key is pressed
   */ keyboard: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the dialog component.
   */ transition: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).elementType,
    /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the backdrop components.
   */ backdropTransition: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).elementType,
    /**
   * When `true` The modal will automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes. This also
   * works correctly with any Modal children that have the `autoFocus` prop.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    /**
   * When `true` The modal will prevent focus from leaving the Modal while open.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */ enforceFocus: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */ restoreFocus: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    /**
   * Options passed to focus function when `restoreFocus` is set to `true`
   *
   * @link  https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#Parameters
   */ restoreFocusOptions: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).shape({
        preventScroll: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool
    }),
    /**
   * Callback fired before the Modal transitions in
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    /**
   * Callback fired as the Modal begins to transition in
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    /**
   * Callback fired after the Modal finishes transitioning in
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    /**
   * Callback fired right before the Modal transitions out
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    /**
   * Callback fired as the Modal begins to transition out
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    /**
   * Callback fired after the Modal finishes transitioning out
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    /**
   * A ModalManager instance used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container
   */ manager: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).instanceOf((0, $i6eD5.default))
};
$208f99badb282725$var$Modal.displayName = 'Modal';
$208f99badb282725$var$Modal.propTypes = $208f99badb282725$var$propTypes;
var $208f99badb282725$export$2e2bcd8739ae039 = Object.assign($208f99badb282725$var$Modal, {
    Manager: (0, $i6eD5.default)
});

});
parcelRegister("Kp4Aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $08b7bef6a799cf0d$export$2e2bcd8739ae039);

var $kyq9h = parcelRequire("kyq9h");
function $08b7bef6a799cf0d$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $kyq9h.default)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}

});

parcelRegister("3A80v", function(module, exports) {

$parcel$export(module.exports, "default", () => $29baf1ed1258a745$export$2e2bcd8739ae039);

var $eaur1 = parcelRequire("eaur1");

var $Fo7oF = parcelRequire("Fo7oF");
function $29baf1ed1258a745$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $eaur1.default)(fn);
    (0, $Fo7oF.useEffect)(()=>()=>onUnmount.current(), []);
}

});
parcelRegister("eaur1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5099b9472e1cd1c$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
function $a5099b9472e1cd1c$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $Fo7oF.useRef)(value);
    valueRef.current = value;
    return valueRef;
}

});


parcelRegister("i6eD5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2d4229ba2c81d7c$export$2e2bcd8739ae039);

var $78ARM = parcelRequire("78ARM");

var $PLT6M = parcelRequire("PLT6M");

var $e0zyR = parcelRequire("e0zyR");

var $6762L = parcelRequire("6762L");

var $gcbMN = parcelRequire("gcbMN");

var $bGXn8 = parcelRequire("bGXn8");
function $d2d4229ba2c81d7c$var$findIndexOf(arr, cb) {
    var idx = -1;
    arr.some(function(d, i) {
        if (cb(d, i)) {
            idx = i;
            return true;
        }
        return false;
    });
    return idx;
}
/**
 * Proper state management for containers and the modals in those containers.
 *
 * @internal Used by the Modal to ensure proper styling of containers.
 */ var $d2d4229ba2c81d7c$var$ModalManager = /*#__PURE__*/ function() {
    function ModalManager(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$hideSiblingNodes = _ref.hideSiblingNodes, hideSiblingNodes = _ref$hideSiblingNodes === void 0 ? true : _ref$hideSiblingNodes, _ref$handleContainerO = _ref.handleContainerOverflow, handleContainerOverflow = _ref$handleContainerO === void 0 ? true : _ref$handleContainerO;
        this.hideSiblingNodes = void 0;
        this.handleContainerOverflow = void 0;
        this.modals = void 0;
        this.containers = void 0;
        this.data = void 0;
        this.scrollbarSize = void 0;
        this.hideSiblingNodes = hideSiblingNodes;
        this.handleContainerOverflow = handleContainerOverflow;
        this.modals = [];
        this.containers = [];
        this.data = [];
        this.scrollbarSize = (0, $6762L.default)();
    }
    var _proto = ModalManager.prototype;
    _proto.isContainerOverflowing = function isContainerOverflowing(modal) {
        var data = this.data[this.containerIndexFromModal(modal)];
        return data && data.overflowing;
    };
    _proto.containerIndexFromModal = function containerIndexFromModal(modal) {
        return $d2d4229ba2c81d7c$var$findIndexOf(this.data, function(d) {
            return d.modals.indexOf(modal) !== -1;
        });
    };
    _proto.setContainerStyle = function setContainerStyle(containerState, container) {
        var style = {
            overflow: 'hidden'
        }; // we are only interested in the actual `style` here
        // because we will override it
        containerState.style = {
            overflow: container.style.overflow,
            paddingRight: container.style.paddingRight
        };
        if (containerState.overflowing) // use computed style, here to get the real padding
        // to add our scrollbar width
        style.paddingRight = parseInt((0, $e0zyR.default)(container, 'paddingRight') || '0', 10) + this.scrollbarSize + "px";
        (0, $e0zyR.default)(container, style);
    };
    _proto.removeContainerStyle = function removeContainerStyle(containerState, container) {
        Object.assign(container.style, containerState.style);
    };
    _proto.add = function add(modal, container, className) {
        var modalIdx = this.modals.indexOf(modal);
        var containerIdx = this.containers.indexOf(container);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        if (this.hideSiblingNodes) (0, $bGXn8.hideSiblings)(container, modal);
        if (containerIdx !== -1) {
            this.data[containerIdx].modals.push(modal);
            return modalIdx;
        }
        var data = {
            modals: [
                modal
            ],
            // right now only the first modal of a container will have its classes applied
            classes: className ? className.split(/\s+/) : [],
            overflowing: (0, $gcbMN.default)(container)
        };
        if (this.handleContainerOverflow) this.setContainerStyle(data, container);
        data.classes.forEach((0, $78ARM.default).bind(null, container));
        this.containers.push(container);
        this.data.push(data);
        return modalIdx;
    };
    _proto.remove = function remove(modal) {
        var modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        var containerIdx = this.containerIndexFromModal(modal);
        var data = this.data[containerIdx];
        var container = this.containers[containerIdx];
        data.modals.splice(data.modals.indexOf(modal), 1);
        this.modals.splice(modalIdx, 1); // if that was the last modal in a container,
        // clean up the container
        if (data.modals.length === 0) {
            data.classes.forEach((0, $PLT6M.default).bind(null, container));
            if (this.handleContainerOverflow) this.removeContainerStyle(data, container);
            if (this.hideSiblingNodes) (0, $bGXn8.showSiblings)(container, modal);
            this.containers.splice(containerIdx, 1);
            this.data.splice(containerIdx, 1);
        } else if (this.hideSiblingNodes) {
            // otherwise make sure the next top modal is visible to a SR
            var _data$modals = data.modals[data.modals.length - 1], backdrop = _data$modals.backdrop, dialog = _data$modals.dialog;
            (0, $bGXn8.ariaHidden)(false, dialog);
            (0, $bGXn8.ariaHidden)(false, backdrop);
        }
    };
    _proto.isTopModal = function isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    };
    return ModalManager;
}();
var $d2d4229ba2c81d7c$export$2e2bcd8739ae039 = $d2d4229ba2c81d7c$var$ModalManager;

});
parcelRegister("78ARM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5325e0af4e621614$export$2e2bcd8739ae039);

var $9bhko = parcelRequire("9bhko");
function $5325e0af4e621614$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $9bhko.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

});

parcelRegister("PLT6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $09b9e91025a63eb1$export$2e2bcd8739ae039);
function $09b9e91025a63eb1$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $09b9e91025a63eb1$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $09b9e91025a63eb1$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $09b9e91025a63eb1$var$replaceClassName(element.className && element.className.baseVal || '', className));
}

});

parcelRegister("gcbMN", function(module, exports) {

$parcel$export(module.exports, "default", () => $bca6e8ced64e42e0$export$2e2bcd8739ae039);

var $igMdk = parcelRequire("igMdk");

var $kyq9h = parcelRequire("kyq9h");
function $bca6e8ced64e42e0$var$isBody(node) {
    return node && node.tagName.toLowerCase() === 'body';
}
function $bca6e8ced64e42e0$var$bodyIsOverflowing(node) {
    var doc = (0, $igMdk.default)(node) ? (0, $kyq9h.default)() : (0, $kyq9h.default)(node);
    var win = (0, $igMdk.default)(node) || doc.defaultView;
    return doc.body.clientWidth < win.innerWidth;
}
function $bca6e8ced64e42e0$export$2e2bcd8739ae039(container) {
    var win = (0, $igMdk.default)(container);
    return win || $bca6e8ced64e42e0$var$isBody(container) ? $bca6e8ced64e42e0$var$bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}

});
parcelRegister("igMdk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4cf1eef13d41e35$export$2e2bcd8739ae039);

var $hYM3j = parcelRequire("hYM3j");
function $d4cf1eef13d41e35$export$2e2bcd8739ae039(node) {
    if ('window' in node && node.window === node) return node;
    if ((0, $hYM3j.default)(node)) return node.defaultView || false;
    return false;
}

});
parcelRegister("hYM3j", function(module, exports) {

$parcel$export(module.exports, "default", () => $d16d507c11a7d8a6$export$2e2bcd8739ae039);
function $d16d507c11a7d8a6$export$2e2bcd8739ae039(element) {
    return 'nodeType' in element && element.nodeType === document.DOCUMENT_NODE;
}

});



parcelRegister("bGXn8", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", () => $8831ac003109c2c7$export$e1bd0c6150f13d96);
$parcel$export(module.exports, "hideSiblings", () => $8831ac003109c2c7$export$18dbef20832f547a);
$parcel$export(module.exports, "showSiblings", () => $8831ac003109c2c7$export$9b9b63d3e0115d40);
var $8831ac003109c2c7$var$BLACKLIST = [
    'template',
    'script',
    'style'
];
var $8831ac003109c2c7$var$isHidable = function isHidable(_ref) {
    var nodeType = _ref.nodeType, tagName = _ref.tagName;
    return nodeType === 1 && $8831ac003109c2c7$var$BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
};
var $8831ac003109c2c7$var$siblings = function siblings(container, exclude, cb) {
    [].forEach.call(container.children, function(node) {
        if (exclude.indexOf(node) === -1 && $8831ac003109c2c7$var$isHidable(node)) cb(node);
    });
};
function $8831ac003109c2c7$export$e1bd0c6150f13d96(hide, node) {
    if (!node) return;
    if (hide) node.setAttribute('aria-hidden', 'true');
    else node.removeAttribute('aria-hidden');
}
function $8831ac003109c2c7$export$18dbef20832f547a(container, _ref2) {
    var dialog = _ref2.dialog, backdrop = _ref2.backdrop;
    $8831ac003109c2c7$var$siblings(container, [
        dialog,
        backdrop
    ], function(node) {
        return $8831ac003109c2c7$export$e1bd0c6150f13d96(true, node);
    });
}
function $8831ac003109c2c7$export$9b9b63d3e0115d40(container, _ref3) {
    var dialog = _ref3.dialog, backdrop = _ref3.backdrop;
    $8831ac003109c2c7$var$siblings(container, [
        dialog,
        backdrop
    ], function(node) {
        return $8831ac003109c2c7$export$e1bd0c6150f13d96(false, node);
    });
}

});


parcelRegister("c0QzI", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bee446ee8327a74$export$2e2bcd8739ae039);

var $kyq9h = parcelRequire("kyq9h");

var $Fo7oF = parcelRequire("Fo7oF");
var $8bee446ee8327a74$export$c91fd81e6d65f84a = function resolveContainerRef(ref) {
    var _ref;
    if (typeof document === 'undefined') return null;
    if (ref == null) return (0, $kyq9h.default)().body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if ((_ref = ref) != null && _ref.nodeType) return ref || null;
    return null;
};
function $8bee446ee8327a74$export$2e2bcd8739ae039(ref, onResolved) {
    var _useState = (0, $Fo7oF.useState)(function() {
        return $8bee446ee8327a74$export$c91fd81e6d65f84a(ref);
    }), resolvedRef = _useState[0], setRef = _useState[1];
    if (!resolvedRef) {
        var earlyRef = $8bee446ee8327a74$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $Fo7oF.useEffect)(function() {
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $Fo7oF.useEffect)(function() {
        var nextRef = $8bee446ee8327a74$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}

});


parcelRegister("ecf8Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $a55dee7c63a5e11a$export$2e2bcd8739ae039);

var $bLCcc = parcelRequire("bLCcc");

var $e0zyR = parcelRequire("e0zyR");

var $7nQFL = parcelRequire("7nQFL");

var $6762L = parcelRequire("6762L");

var $i6eD5 = parcelRequire("i6eD5");
var $a55dee7c63a5e11a$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
var $a55dee7c63a5e11a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_ModalManager) {
    (0, $bLCcc.default)(BootstrapModalManager, _ModalManager);
    function BootstrapModalManager() {
        return _ModalManager.apply(this, arguments) || this;
    }
    var _proto = BootstrapModalManager.prototype;
    _proto.adjustAndStore = function adjustAndStore(prop, element, adjust) {
        var _css;
        var actual = element.style[prop]; // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        // @ts-ignore
        element.dataset[prop] = actual;
        (0, $e0zyR.default)(element, (_css = {}, _css[prop] = parseFloat((0, $e0zyR.default)(element, prop)) + adjust + "px", _css));
    };
    _proto.restore = function restore(prop, element) {
        var value = element.dataset[prop];
        if (value !== undefined) {
            var _css2;
            delete element.dataset[prop];
            (0, $e0zyR.default)(element, (_css2 = {}, _css2[prop] = value, _css2));
        }
    };
    _proto.setContainerStyle = function setContainerStyle(containerState, container) {
        var _this = this;
        _ModalManager.prototype.setContainerStyle.call(this, containerState, container);
        if (!containerState.overflowing) return;
        var size = (0, $6762L.default)();
        (0, $7nQFL.default)(container, $a55dee7c63a5e11a$var$Selector.FIXED_CONTENT).forEach(function(el) {
            return _this.adjustAndStore('paddingRight', el, size);
        });
        (0, $7nQFL.default)(container, $a55dee7c63a5e11a$var$Selector.STICKY_CONTENT).forEach(function(el) {
            return _this.adjustAndStore('marginRight', el, -size);
        });
        (0, $7nQFL.default)(container, $a55dee7c63a5e11a$var$Selector.NAVBAR_TOGGLER).forEach(function(el) {
            return _this.adjustAndStore('marginRight', el, size);
        });
    };
    _proto.removeContainerStyle = function removeContainerStyle(containerState, container) {
        var _this2 = this;
        _ModalManager.prototype.removeContainerStyle.call(this, containerState, container);
        (0, $7nQFL.default)(container, $a55dee7c63a5e11a$var$Selector.FIXED_CONTENT).forEach(function(el) {
            return _this2.restore('paddingRight', el);
        });
        (0, $7nQFL.default)(container, $a55dee7c63a5e11a$var$Selector.STICKY_CONTENT).forEach(function(el) {
            return _this2.restore('marginRight', el);
        });
        (0, $7nQFL.default)(container, $a55dee7c63a5e11a$var$Selector.NAVBAR_TOGGLER).forEach(function(el) {
            return _this2.restore('marginRight', el);
        });
    };
    return BootstrapModalManager;
}((0, $i6eD5.default));

});

parcelRegister("7R8os", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5b83fe6982d53131$export$2e2bcd8739ae039);

var $ghpJm = parcelRequire("ghpJm");
var $5b83fe6982d53131$export$2e2bcd8739ae039 = (0, $ghpJm.default)('modal-body');

});

parcelRegister("hrMMo", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb3acbe0f4534aeb$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
var $cb3acbe0f4534aeb$var$ModalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHide: function onHide() {}
});
var $cb3acbe0f4534aeb$export$2e2bcd8739ae039 = $cb3acbe0f4534aeb$var$ModalContext;

});

parcelRegister("h6QVW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c74c0eaee725a9fb$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");
var $c74c0eaee725a9fb$var$ModalDialog = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, contentClassName = _ref.contentClassName, centered = _ref.centered, size = _ref.size, children = _ref.children, scrollable = _ref.scrollable, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "className",
        "contentClassName",
        "centered",
        "size",
        "children",
        "scrollable"
    ]);
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'modal');
    var dialogClass = bsPrefix + "-dialog";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", (0, $elnlQ.default)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(dialogClass, className, size && bsPrefix + "-" + size, centered && dialogClass + "-centered", scrollable && dialogClass + "-scrollable")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(bsPrefix + "-content", contentClassName)
    }, children));
});
$c74c0eaee725a9fb$var$ModalDialog.displayName = 'ModalDialog';
var $c74c0eaee725a9fb$export$2e2bcd8739ae039 = $c74c0eaee725a9fb$var$ModalDialog;

});

parcelRegister("avYaS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7a7b7a04dfa7e9df$export$2e2bcd8739ae039);

var $ghpJm = parcelRequire("ghpJm");
var $7a7b7a04dfa7e9df$export$2e2bcd8739ae039 = (0, $ghpJm.default)('modal-footer');

});

parcelRegister("8BYaT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $645074e59f569b17$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $7i6aT = parcelRequire("7i6aT");

var $508Sg = parcelRequire("508Sg");

var $9vybq = parcelRequire("9vybq");

var $hrMMo = parcelRequire("hrMMo");
var $645074e59f569b17$var$defaultProps = {
    closeLabel: 'Close',
    closeButton: false
};
var $645074e59f569b17$var$ModalHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, closeLabel = _ref.closeLabel, closeButton = _ref.closeButton, onHide = _ref.onHide, className = _ref.className, children = _ref.children, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "closeLabel",
        "closeButton",
        "onHide",
        "className",
        "children"
    ]);
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'modal-header');
    var context = (0, $Fo7oF.useContext)((0, $hrMMo.default));
    var handleClick = (0, $7i6aT.default)(function() {
        if (context) context.onHide();
        if (onHide) onHide();
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", (0, $elnlQ.default)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix)
    }), children, closeButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $9vybq.default), {
        label: closeLabel,
        onClick: handleClick
    }));
});
$645074e59f569b17$var$ModalHeader.displayName = 'ModalHeader';
$645074e59f569b17$var$ModalHeader.defaultProps = $645074e59f569b17$var$defaultProps;
var $645074e59f569b17$export$2e2bcd8739ae039 = $645074e59f569b17$var$ModalHeader;

});

parcelRegister("1pLWH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $107d5146bf109770$export$2e2bcd8739ae039);

var $ghpJm = parcelRequire("ghpJm");

var $6Buwg = parcelRequire("6Buwg");
var $107d5146bf109770$var$DivStyledAsH4 = (0, $6Buwg.default)('h4');
var $107d5146bf109770$export$2e2bcd8739ae039 = (0, $ghpJm.default)('modal-title', {
    Component: $107d5146bf109770$var$DivStyledAsH4
});

});


parcelRegister("80dAi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0180eac7c18818d9$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $bLCcc = parcelRequire("bLCcc");

var $k0XxB = parcelRequire("k0XxB");

var $Fo7oF = parcelRequire("Fo7oF");

var $7sGzA = parcelRequire("7sGzA");

var $f0c8d = parcelRequire("f0c8d");
parcelRequire("8yRQ3");
parcelRequire("1ndZg");
var $5VUYT = parcelRequire("5VUYT");

var $kIpro = parcelRequire("kIpro");
var $0180eac7c18818d9$var$RefHolder = /*#__PURE__*/ function(_React$Component) {
    (0, $bLCcc.default)(RefHolder, _React$Component);
    function RefHolder() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = RefHolder.prototype;
    _proto.render = function render() {
        return this.props.children;
    };
    return RefHolder;
}((0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component);
function $0180eac7c18818d9$var$normalizeDelay(delay) {
    return delay && typeof delay === 'object' ? delay : {
        show: delay,
        hide: delay
    };
} // Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function $0180eac7c18818d9$var$handleMouseOverOut(handler, args, relatedNative) {
    var e = args[0];
    var target = e.currentTarget;
    var related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0, $k0XxB.default)(target, related)) handler.apply(void 0, args);
}
var $0180eac7c18818d9$var$defaultProps = {
    defaultShow: false,
    trigger: [
        'hover',
        'focus'
    ]
};
function $0180eac7c18818d9$var$OverlayTrigger(_ref) {
    var trigger = _ref.trigger, overlay = _ref.overlay, children = _ref.children, _ref$popperConfig = _ref.popperConfig, popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig, propsShow = _ref.show, _ref$defaultShow = _ref.defaultShow, defaultShow = _ref$defaultShow === void 0 ? false : _ref$defaultShow, onToggle = _ref.onToggle, propsDelay = _ref.delay, placement = _ref.placement, _ref$flip = _ref.flip, flip = _ref$flip === void 0 ? placement && placement.indexOf('auto') !== -1 : _ref$flip, props = (0, $fjJNR.default)(_ref, [
        "trigger",
        "overlay",
        "children",
        "popperConfig",
        "show",
        "defaultShow",
        "onToggle",
        "delay",
        "placement",
        "flip"
    ]);
    var triggerNodeRef = (0, $Fo7oF.useRef)(null);
    var timeout = (0, $7sGzA.default)();
    var hoverStateRef = (0, $Fo7oF.useRef)('');
    var _useUncontrolledProp = (0, $5VUYT.useUncontrolledProp)(propsShow, defaultShow, onToggle), show = _useUncontrolledProp[0], setShow = _useUncontrolledProp[1];
    var delay = $0180eac7c18818d9$var$normalizeDelay(propsDelay);
    var _ref2 = typeof children !== 'function' ? (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Children.only(children).props : {}, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick;
    var getTarget = (0, $Fo7oF.useCallback)(function() {
        return (0, $f0c8d.default)(triggerNodeRef.current);
    }, []);
    var handleShow = (0, $Fo7oF.useCallback)(function() {
        timeout.clear();
        hoverStateRef.current = 'show';
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(function() {
            if (hoverStateRef.current === 'show') setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    var handleHide = (0, $Fo7oF.useCallback)(function() {
        timeout.clear();
        hoverStateRef.current = 'hide';
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(function() {
            if (hoverStateRef.current === 'hide') setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    var handleFocus = (0, $Fo7oF.useCallback)(function() {
        handleShow();
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        onFocus == null || onFocus.apply(void 0, args);
    }, [
        handleShow,
        onFocus
    ]);
    var handleBlur = (0, $Fo7oF.useCallback)(function() {
        handleHide();
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        onBlur == null || onBlur.apply(void 0, args);
    }, [
        handleHide,
        onBlur
    ]);
    var handleClick = (0, $Fo7oF.useCallback)(function() {
        setShow(!show);
        if (onClick) onClick.apply(void 0, arguments);
    }, [
        onClick,
        setShow,
        show
    ]);
    var handleMouseOver = (0, $Fo7oF.useCallback)(function() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        $0180eac7c18818d9$var$handleMouseOverOut(handleShow, args, 'fromElement');
    }, [
        handleShow
    ]);
    var handleMouseOut = (0, $Fo7oF.useCallback)(function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        $0180eac7c18818d9$var$handleMouseOverOut(handleHide, args, 'toElement');
    }, [
        handleHide
    ]);
    var triggers = trigger == null ? [] : [].concat(trigger);
    var triggerProps = {};
    if (triggers.indexOf('click') !== -1) triggerProps.onClick = handleClick;
    if (triggers.indexOf('focus') !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf('hover') !== -1) {
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Fragment, null, typeof children === 'function' ? children((0, $elnlQ.default)({}, triggerProps, {
        ref: triggerNodeRef
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement($0180eac7c18818d9$var$RefHolder, {
        ref: triggerNodeRef
    }, /*#__PURE__*/ (0, $Fo7oF.cloneElement)(children, triggerProps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $kIpro.default), (0, $elnlQ.default)({}, props, {
        show: show,
        onHide: handleHide,
        flip: flip,
        placement: placement,
        popperConfig: popperConfig,
        target: getTarget
    }), overlay));
}
$0180eac7c18818d9$var$OverlayTrigger.defaultProps = $0180eac7c18818d9$var$defaultProps;
var $0180eac7c18818d9$export$2e2bcd8739ae039 = $0180eac7c18818d9$var$OverlayTrigger;

});
parcelRegister("7sGzA", function(module, exports) {

$parcel$export(module.exports, "default", () => $56ec2c0f07dbb22b$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");

var $ccjRw = parcelRequire("ccjRw");

var $jBB0G = parcelRequire("jBB0G");
/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ var $56ec2c0f07dbb22b$var$MAX_DELAY_MS = Math.pow(2, 31) - 1;
function $56ec2c0f07dbb22b$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    var delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $56ec2c0f07dbb22b$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(function() {
        return $56ec2c0f07dbb22b$var$setChainedTimeout(handleRef, fn, timeoutAtMs);
    }, $56ec2c0f07dbb22b$var$MAX_DELAY_MS);
}
function $56ec2c0f07dbb22b$export$2e2bcd8739ae039() {
    var isMounted = (0, $ccjRw.default)(); // types are confused between node and web here IDK
    var handleRef = (0, $Fo7oF.useRef)();
    (0, $jBB0G.default)(function() {
        return clearTimeout(handleRef.current);
    });
    return (0, $Fo7oF.useMemo)(function() {
        var clear = function clear() {
            return clearTimeout(handleRef.current);
        };
        function set(fn, delayMs) {
            if (delayMs === void 0) delayMs = 0;
            if (!isMounted()) return;
            clear();
            if (delayMs <= $56ec2c0f07dbb22b$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $56ec2c0f07dbb22b$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear
        };
    }, []);
}

});
parcelRegister("ccjRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e160341f21cc026$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
function $8e160341f21cc026$export$2e2bcd8739ae039() {
    var mounted = (0, $Fo7oF.useRef)(true);
    var isMounted = (0, $Fo7oF.useRef)(function() {
        return mounted.current;
    });
    (0, $Fo7oF.useEffect)(function() {
        return function() {
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}

});


parcelRegister("kIpro", function(module, exports) {

$parcel$export(module.exports, "default", () => $f14ba6b7ac989aac$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $Fo7oF = parcelRequire("Fo7oF");

var $fVt0T = parcelRequire("fVt0T");

var $k00Tx = parcelRequire("k00Tx");

var $f0c8d = parcelRequire("f0c8d");

var $lDC2W = parcelRequire("lDC2W");

var $b5rGi = parcelRequire("b5rGi");
var $f14ba6b7ac989aac$var$defaultProps = {
    transition: (0, $b5rGi.default),
    rootClose: false,
    show: false,
    placement: 'top'
};
function $f14ba6b7ac989aac$var$wrapRefs(props, arrowProps) {
    var ref = props.ref;
    var aRef = arrowProps.ref;
    props.ref = ref.__wrapped || (ref.__wrapped = function(r) {
        return ref((0, $f0c8d.default)(r));
    });
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = function(r) {
        return aRef((0, $f0c8d.default)(r));
    });
}
function $f14ba6b7ac989aac$var$Overlay(_ref) {
    var overlay = _ref.children, transition = _ref.transition, _ref$popperConfig = _ref.popperConfig, popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig, outerProps = (0, $fjJNR.default)(_ref, [
        "children",
        "transition",
        "popperConfig"
    ]);
    var popperRef = (0, $Fo7oF.useRef)({});
    var _usePopperMarginModif = (0, $lDC2W.default)(), ref = _usePopperMarginModif[0], marginModifiers = _usePopperMarginModif[1];
    var actualTransition = transition === true ? (0, $b5rGi.default) : transition || null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $k00Tx.default), (0, $elnlQ.default)({}, outerProps, {
        ref: ref,
        popperConfig: (0, $elnlQ.default)({}, popperConfig, {
            modifiers: marginModifiers.concat(popperConfig.modifiers || [])
        }),
        transition: actualTransition
    }), function(_ref2) {
        var _state$modifiersData$;
        var overlayProps = _ref2.props, arrowProps = _ref2.arrowProps, show = _ref2.show, update = _ref2.update, _ = _ref2.forceUpdate, placement = _ref2.placement, state = _ref2.state, props = (0, $fjJNR.default)(_ref2, [
            "props",
            "arrowProps",
            "show",
            "update",
            "forceUpdate",
            "placement",
            "state"
        ]);
        $f14ba6b7ac989aac$var$wrapRefs(overlayProps, arrowProps);
        var popper = Object.assign(popperRef.current, {
            state: state,
            scheduleUpdate: update,
            placement: placement,
            outOfBoundaries: (state == null ? void 0 : (_state$modifiersData$ = state.modifiersData.hide) == null ? void 0 : _state$modifiersData$.isReferenceHidden) || false
        });
        if (typeof overlay === 'function') return overlay((0, $elnlQ.default)({}, props, overlayProps, {
            placement: placement,
            show: show
        }, !transition && show && {
            className: 'show'
        }, {
            popper: popper,
            arrowProps: arrowProps
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).cloneElement(overlay, (0, $elnlQ.default)({}, props, overlayProps, {
            placement: placement,
            arrowProps: arrowProps,
            popper: popper,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(overlay.props.className, !transition && show && 'show'),
            style: (0, $elnlQ.default)({}, overlay.props.style, overlayProps.style)
        }));
    });
}
$f14ba6b7ac989aac$var$Overlay.defaultProps = $f14ba6b7ac989aac$var$defaultProps;
var $f14ba6b7ac989aac$export$2e2bcd8739ae039 = $f14ba6b7ac989aac$var$Overlay;

});
parcelRegister("k00Tx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8f4806f04d78797$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $d2bgE = parcelRequire("d2bgE");

var $Fo7oF = parcelRequire("Fo7oF");

var $bvYwR = parcelRequire("bvYwR");

var $ct1ws = parcelRequire("ct1ws");

var $8mcPK = parcelRequire("8mcPK");

var $hhTpe = parcelRequire("hhTpe");

var $l395l = parcelRequire("l395l");

var $djPxk = parcelRequire("djPxk");

var $c0QzI = parcelRequire("c0QzI");

var $blTZd = parcelRequire("blTZd");
/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ var $e8f4806f04d78797$var$Overlay = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(props, outerRef) {
    var flip = props.flip, offset = props.offset, placement = props.placement, _props$containerPaddi = props.containerPadding, containerPadding = _props$containerPaddi === void 0 ? 5 : _props$containerPaddi, _props$popperConfig = props.popperConfig, popperConfig = _props$popperConfig === void 0 ? {} : _props$popperConfig, Transition = props.transition;
    var _useCallbackRef = (0, $ct1ws.default)(), rootElement = _useCallbackRef[0], attachRef = _useCallbackRef[1];
    var _useCallbackRef2 = (0, $ct1ws.default)(), arrowElement = _useCallbackRef2[0], attachArrowRef = _useCallbackRef2[1];
    var mergedRef = (0, $8mcPK.default)(attachRef, outerRef);
    var container = (0, $c0QzI.default)(props.container);
    var target = (0, $c0QzI.default)(props.target);
    var _useState = (0, $Fo7oF.useState)(!props.show), exited = _useState[0], setExited = _useState[1];
    var _usePopper = (0, $l395l.default)(target, rootElement, (0, $blTZd.default)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    })), styles = _usePopper.styles, attributes = _usePopper.attributes, popper = (0, $fjJNR.default)(_usePopper, [
        "styles",
        "attributes"
    ]);
    if (props.show) {
        if (exited) setExited(false);
    } else if (!props.transition && !exited) setExited(true);
    var handleHidden = function handleHidden() {
        setExited(true);
        if (props.onExited) props.onExited.apply(props, arguments);
    }; // Don't un-render the overlay while it's transitioning out.
    var mountOverlay = props.show || Transition && !exited;
    (0, $djPxk.default)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    var child = props.children((0, $elnlQ.default)({}, popper, {
        show: !!props.show,
        props: (0, $elnlQ.default)({}, attributes.popper, {
            style: styles.popper,
            ref: mergedRef
        }),
        arrowProps: (0, $elnlQ.default)({}, attributes.arrow, {
            style: styles.arrow,
            ref: attachArrowRef
        })
    }));
    if (Transition) {
        var onExit = props.onExit, onExiting = props.onExiting, onEnter = props.onEnter, onEntering = props.onEntering, onEntered = props.onEntered;
        child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Transition, {
            "in": props.show,
            appear: true,
            onExit: onExit,
            onExiting: onExiting,
            onExited: handleHidden,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered
        }, child);
    }
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bvYwR))).createPortal(child, container) : null;
});
$e8f4806f04d78797$var$Overlay.displayName = 'Overlay';
$e8f4806f04d78797$var$Overlay.propTypes = {
    /**
   * Set the visibility of the Overlay
   */ show: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    /** Specify where the overlay element is positioned in relation to the target element */ placement: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).oneOf((0, $hhTpe.placements)),
    /**
   * A DOM Element, Ref to an element, or function that returns either. The `target` element is where
   * the overlay is positioned relative to.
   */ target: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).any,
    /**
   * A DOM Element, Ref to an element, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).any,
    /**
   * Enables the Popper.js `flip` modifier, allowing the Overlay to
   * automatically adjust it's placement in case of overlap with the viewport or toggle.
   * Refer to the [flip docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled) for more info
   */ flip: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    /**
   * A render prop that returns an element to overlay and position. See
   * the [react-popper documentation](https://github.com/FezVrasta/react-popper#children) for more info.
   *
   * @type {Function ({
   *   show: boolean,
   *   placement: Placement,
   *   update: () => void,
   *   forceUpdate: () => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     aria-labelledby: ?string
   *     [string]: string | number,
   *   },
   *   arrowProps: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     [string]: string | number,
   *   },
   * }) => React.Element}
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func.isRequired,
    /**
   * Control how much space there is between the edge of the boundary element and overlay.
   * A convenience shortcut to setting `popperConfig.modfiers.preventOverflow.padding`
   */ containerPadding: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).number,
    /**
   * A set of popper options and props passed directly to react-popper's Popper component.
   */ popperConfig: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).object,
    /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */ rootClose: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    /**
   * Specify event for toggling overlay
   */ rootCloseEvent: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).oneOf([
        'click',
        'mousedown'
    ]),
    /**
   * Specify disabled for disable RootCloseWrapper
   */ rootCloseDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */ onHide: function onHide(props) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (props.rootClose) {
            var _PropTypes$func;
            return (_PropTypes$func = (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func).isRequired.apply(_PropTypes$func, [
                props
            ].concat(args));
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func.apply((0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))), [
            props
        ].concat(args));
    },
    /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */ // @ts-ignore
    transition: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).elementType,
    /**
   * Callback fired before the Overlay transitions in
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    /**
   * Callback fired as the Overlay begins to transition in
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    /**
   * Callback fired after the Overlay finishes transitioning in
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    /**
   * Callback fired right before the Overlay transitions out
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    /**
   * Callback fired as the Overlay begins to transition out
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    /**
   * Callback fired after the Overlay finishes transitioning out
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func
};
var $e8f4806f04d78797$export$2e2bcd8739ae039 = $e8f4806f04d78797$var$Overlay;

});
parcelRegister("8mcPK", function(module, exports) {

$parcel$export(module.exports, "default", () => $615a55512e95a6fb$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
const $615a55512e95a6fb$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $615a55512e95a6fb$export$c9058316764c140e(refA, refB) {
    const a = $615a55512e95a6fb$var$toFnRef(refA);
    const b = $615a55512e95a6fb$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $615a55512e95a6fb$var$useMergedRefs(refA, refB) {
    return (0, $Fo7oF.useMemo)(()=>$615a55512e95a6fb$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $615a55512e95a6fb$export$2e2bcd8739ae039 = $615a55512e95a6fb$var$useMergedRefs;

});




parcelRegister("4M8Iw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $37a2682c02f233d5$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");

var $6j1mt = parcelRequire("6j1mt");
/**
 * @property {PageItem} Item
 * @property {PageItem} First
 * @property {PageItem} Prev
 * @property {PageItem} Ellipsis
 * @property {PageItem} Next
 * @property {PageItem} Last
 */ var $37a2682c02f233d5$var$Pagination = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, children = _ref.children, size = _ref.size, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "className",
        "children",
        "size"
    ]);
    var decoratedBsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'pagination');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("ul", (0, $elnlQ.default)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, decoratedBsPrefix, size && decoratedBsPrefix + "-" + size)
    }), children);
});
$37a2682c02f233d5$var$Pagination.First = (0, $6j1mt.First);
$37a2682c02f233d5$var$Pagination.Prev = (0, $6j1mt.Prev);
$37a2682c02f233d5$var$Pagination.Ellipsis = (0, $6j1mt.Ellipsis);
$37a2682c02f233d5$var$Pagination.Item = (0, $6j1mt.default);
$37a2682c02f233d5$var$Pagination.Next = (0, $6j1mt.Next);
$37a2682c02f233d5$var$Pagination.Last = (0, $6j1mt.Last);
var $37a2682c02f233d5$export$2e2bcd8739ae039 = $37a2682c02f233d5$var$Pagination;

});
parcelRegister("6j1mt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $497592c520bb9819$export$2e2bcd8739ae039);
$parcel$export(module.exports, "First", () => $497592c520bb9819$export$b25abba66f7be210);
$parcel$export(module.exports, "Prev", () => $497592c520bb9819$export$1b265216817111b9);
$parcel$export(module.exports, "Ellipsis", () => $497592c520bb9819$export$1297970233533a7d);
$parcel$export(module.exports, "Next", () => $497592c520bb9819$export$b820fc49f2736e85);
$parcel$export(module.exports, "Last", () => $497592c520bb9819$export$bed9238d8933c9a8);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $dwZwr = parcelRequire("dwZwr");
var $497592c520bb9819$var$defaultProps = {
    active: false,
    disabled: false,
    activeLabel: '(current)'
};
var $497592c520bb9819$var$PageItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var active = _ref.active, disabled = _ref.disabled, className = _ref.className, style = _ref.style, activeLabel = _ref.activeLabel, children = _ref.children, props = (0, $fjJNR.default)(_ref, [
        "active",
        "disabled",
        "className",
        "style",
        "activeLabel",
        "children"
    ]);
    var Component = active || disabled ? 'span' : (0, $dwZwr.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("li", {
        ref: ref,
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, 'page-item', {
            active: active,
            disabled: disabled
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({
        className: "page-link",
        disabled: disabled
    }, props), children, active && activeLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("span", {
        className: "sr-only"
    }, activeLabel)));
});
$497592c520bb9819$var$PageItem.defaultProps = $497592c520bb9819$var$defaultProps;
$497592c520bb9819$var$PageItem.displayName = 'PageItem';
var $497592c520bb9819$export$2e2bcd8739ae039 = $497592c520bb9819$var$PageItem;
function $497592c520bb9819$var$createButton(name, defaultValue, label) {
    if (label === void 0) label = name;
    function Button(_ref2) {
        var children = _ref2.children, props = (0, $fjJNR.default)(_ref2, [
            "children"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement($497592c520bb9819$var$PageItem, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("span", {
            "aria-hidden": "true"
        }, children || defaultValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("span", {
            className: "sr-only"
        }, label));
    }
    Button.displayName = name;
    return Button;
}
var $497592c520bb9819$export$b25abba66f7be210 = $497592c520bb9819$var$createButton('First', "\xab");
var $497592c520bb9819$export$1b265216817111b9 = $497592c520bb9819$var$createButton('Prev', "\u2039", 'Previous');
var $497592c520bb9819$export$1297970233533a7d = $497592c520bb9819$var$createButton('Ellipsis', "\u2026", 'More');
var $497592c520bb9819$export$b820fc49f2736e85 = $497592c520bb9819$var$createButton('Next', "\u203A");
var $497592c520bb9819$export$bed9238d8933c9a8 = $497592c520bb9819$var$createButton('Last', "\xbb");

});


parcelRegister("bFq9j", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $87e7ceb805d9577c$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");
parcelRequire("gJ3n2");

var $508Sg = parcelRequire("508Sg");

var $kXvFd = parcelRequire("kXvFd");

var $9rTga = parcelRequire("9rTga");
var $87e7ceb805d9577c$var$defaultProps = {
    placement: 'right'
};
var $87e7ceb805d9577c$var$Popover = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, placement = _ref.placement, className = _ref.className, style = _ref.style, children = _ref.children, content = _ref.content, arrowProps = _ref.arrowProps, _ = _ref.popper, _1 = _ref.show, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "placement",
        "className",
        "style",
        "children",
        "content",
        "arrowProps",
        "popper",
        "show"
    ]);
    var decoratedBsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'popover');
    var _ref2 = (placement == null ? void 0 : placement.split('-')) || [], primaryPlacement = _ref2[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", (0, $elnlQ.default)({
        ref: ref,
        role: "tooltip",
        style: style,
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, decoratedBsPrefix, primaryPlacement && "bs-popover-" + primaryPlacement)
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", (0, $elnlQ.default)({
        className: "arrow"
    }, arrowProps)), content ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $9rTga.default), null, children) : children);
});
$87e7ceb805d9577c$var$Popover.defaultProps = $87e7ceb805d9577c$var$defaultProps;
$87e7ceb805d9577c$var$Popover.Title = (0, $kXvFd.default);
$87e7ceb805d9577c$var$Popover.Content = (0, $9rTga.default);
var $87e7ceb805d9577c$export$2e2bcd8739ae039 = $87e7ceb805d9577c$var$Popover;

});
parcelRegister("kXvFd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f421e1183ca29306$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");
var $f421e1183ca29306$var$PopoverTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, bsPrefix = _ref.bsPrefix, className = _ref.className, children = _ref.children, props = (0, $fjJNR.default)(_ref, [
        "as",
        "bsPrefix",
        "className",
        "children"
    ]);
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'popover-header');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(bsPrefix, className)
    }), children);
});
var $f421e1183ca29306$export$2e2bcd8739ae039 = $f421e1183ca29306$var$PopoverTitle;

});

parcelRegister("9rTga", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6e1180214b6616f1$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");
var $6e1180214b6616f1$var$PopoverContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, bsPrefix = _ref.bsPrefix, className = _ref.className, children = _ref.children, props = (0, $fjJNR.default)(_ref, [
        "as",
        "bsPrefix",
        "className",
        "children"
    ]);
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'popover-body');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix)
    }), children);
});
var $6e1180214b6616f1$export$2e2bcd8739ae039 = $6e1180214b6616f1$var$PopoverContent;

});


parcelRegister("jmNSR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e196c445c8f0028e$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");

var $fn04P = parcelRequire("fn04P");
var $e196c445c8f0028e$var$ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `<ProgressBar>`.
 */ function $e196c445c8f0028e$var$onlyProgressBar(props, propName, componentName) {
    var children = props[propName];
    if (!children) return null;
    var error = null;
    (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Children.forEach(children, function(child) {
        if (error) return;
        /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */ var element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement($e196c445c8f0028e$var$ProgressBar, null);
        if (child.type === element.type) return;
        var childType = child.type;
        var childIdentifier = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).isValidElement(child) ? childType.displayName || childType.name || childType : child;
        error = new Error("Children of " + componentName + " can contain only ProgressBar " + ("components. Found " + childIdentifier + "."));
    });
    return error;
}
var $e196c445c8f0028e$var$defaultProps = {
    min: 0,
    max: 100,
    animated: false,
    isChild: false,
    srOnly: false,
    striped: false
};
function $e196c445c8f0028e$var$getPercentage(now, min, max) {
    var percentage = (now - min) / (max - min) * 100;
    return Math.round(percentage * $e196c445c8f0028e$var$ROUND_PRECISION) / $e196c445c8f0028e$var$ROUND_PRECISION;
}
function $e196c445c8f0028e$var$renderProgressBar(_ref, ref) {
    var _classNames;
    var min = _ref.min, now = _ref.now, max = _ref.max, label = _ref.label, srOnly = _ref.srOnly, striped = _ref.striped, animated = _ref.animated, className = _ref.className, style = _ref.style, variant = _ref.variant, bsPrefix = _ref.bsPrefix, props = (0, $fjJNR.default)(_ref, [
        "min",
        "now",
        "max",
        "label",
        "srOnly",
        "striped",
        "animated",
        "className",
        "style",
        "variant",
        "bsPrefix"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", (0, $elnlQ.default)({
        ref: ref
    }, props, {
        role: "progressbar",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix + "-bar", (_classNames = {}, _classNames["bg-" + variant] = variant, _classNames[bsPrefix + "-bar-animated"] = animated, _classNames[bsPrefix + "-bar-striped"] = animated || striped, _classNames)),
        style: (0, $elnlQ.default)({
            width: $e196c445c8f0028e$var$getPercentage(now, min, max) + "%"
        }, style),
        "aria-valuenow": now,
        "aria-valuemin": min,
        "aria-valuemax": max
    }), srOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("span", {
        className: "sr-only"
    }, label) : label);
}
var $e196c445c8f0028e$var$ProgressBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref2, ref) {
    var isChild = _ref2.isChild, props = (0, $fjJNR.default)(_ref2, [
        "isChild"
    ]);
    props.bsPrefix = (0, $508Sg.useBootstrapPrefix)(props.bsPrefix, 'progress');
    if (isChild) return $e196c445c8f0028e$var$renderProgressBar(props, ref);
    var min = props.min, now = props.now, max = props.max, label = props.label, srOnly = props.srOnly, striped = props.striped, animated = props.animated, bsPrefix = props.bsPrefix, variant = props.variant, className = props.className, children = props.children, wrapperProps = (0, $fjJNR.default)(props, [
        "min",
        "now",
        "max",
        "label",
        "srOnly",
        "striped",
        "animated",
        "bsPrefix",
        "variant",
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", (0, $elnlQ.default)({
        ref: ref
    }, wrapperProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix)
    }), children ? (0, $fn04P.map)(children, function(child) {
        return /*#__PURE__*/ (0, $Fo7oF.cloneElement)(child, {
            isChild: true
        });
    }) : $e196c445c8f0028e$var$renderProgressBar({
        min: min,
        now: now,
        max: max,
        label: label,
        srOnly: srOnly,
        striped: striped,
        animated: animated,
        bsPrefix: bsPrefix,
        variant: variant
    }, ref));
});
$e196c445c8f0028e$var$ProgressBar.displayName = 'ProgressBar';
$e196c445c8f0028e$var$ProgressBar.defaultProps = $e196c445c8f0028e$var$defaultProps;
var $e196c445c8f0028e$export$2e2bcd8739ae039 = $e196c445c8f0028e$var$ProgressBar;

});

parcelRegister("8Ljes", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6611a19e62268d73$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");
var $6611a19e62268d73$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, variant = _ref.variant, animation = _ref.animation, size = _ref.size, children = _ref.children, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, className = _ref.className, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "variant",
        "animation",
        "size",
        "children",
        "as",
        "className"
    ]);
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'spinner');
    var bsSpinnerPrefix = bsPrefix + "-" + animation;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsSpinnerPrefix, size && bsSpinnerPrefix + "-" + size, variant && "text-" + variant)
    }), children);
});
$6611a19e62268d73$var$Spinner.displayName = 'Spinner';
var $6611a19e62268d73$export$2e2bcd8739ae039 = $6611a19e62268d73$var$Spinner;

});

parcelRegister("hwLD9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $cc2a5f450c63bd6e$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");
var $cc2a5f450c63bd6e$var$DEVICE_SIZES = [
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
var $cc2a5f450c63bd6e$var$defaultProps = {
    noGutters: false
};
var $cc2a5f450c63bd6e$var$Row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, noGutters = _ref.noGutters, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "className",
        "noGutters",
        "as"
    ]);
    var decoratedBsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'row');
    var sizePrefix = decoratedBsPrefix + "-cols";
    var classes = [];
    $cc2a5f450c63bd6e$var$DEVICE_SIZES.forEach(function(brkPoint) {
        var propValue = props[brkPoint];
        delete props[brkPoint];
        var cols;
        if (propValue != null && typeof propValue === 'object') cols = propValue.cols;
        else cols = propValue;
        var infix = brkPoint !== 'xs' ? "-" + brkPoint : '';
        if (cols != null) classes.push("" + sizePrefix + infix + "-" + cols);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T))).apply(void 0, [
            className,
            decoratedBsPrefix,
            noGutters && 'no-gutters'
        ].concat(classes))
    }));
});
$cc2a5f450c63bd6e$var$Row.displayName = 'Row';
$cc2a5f450c63bd6e$var$Row.defaultProps = $cc2a5f450c63bd6e$var$defaultProps;
var $cc2a5f450c63bd6e$export$2e2bcd8739ae039 = $cc2a5f450c63bd6e$var$Row;

});

parcelRegister("27X8z", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $18ca1ba467d77d87$export$2e2bcd8739ae039);

var $bLCcc = parcelRequire("bLCcc");

var $Fo7oF = parcelRequire("Fo7oF");

var $g3fZa = parcelRequire("g3fZa");

var $ai3sv = parcelRequire("ai3sv");

var $gyJvA = parcelRequire("gyJvA");
/* eslint-disable react/require-render-return, react/no-unused-prop-types */ var $18ca1ba467d77d87$var$Tab = /*#__PURE__*/ function(_React$Component) {
    (0, $bLCcc.default)(Tab, _React$Component);
    function Tab() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Tab.prototype;
    _proto.render = function render() {
        throw new Error("ReactBootstrap: The `Tab` component is not meant to be rendered! It's an abstract component that is only valid as a direct Child of the `Tabs` Component. For custom tabs components use TabPane and TabsContainer directly");
    };
    return Tab;
}((0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component);
$18ca1ba467d77d87$var$Tab.Container = (0, $g3fZa.default);
$18ca1ba467d77d87$var$Tab.Content = (0, $ai3sv.default);
$18ca1ba467d77d87$var$Tab.Pane = (0, $gyJvA.default);
var $18ca1ba467d77d87$export$2e2bcd8739ae039 = $18ca1ba467d77d87$var$Tab;

});
parcelRegister("g3fZa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $baf95387e2a9ec21$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
parcelRequire("1ndZg");
var $5VUYT = parcelRequire("5VUYT");

var $ira3M = parcelRequire("ira3M");

var $6VnXl = parcelRequire("6VnXl");
var $baf95387e2a9ec21$var$TabContainer = function TabContainer(props) {
    var _useUncontrolled = (0, $5VUYT.default)(props, {
        activeKey: 'onSelect'
    }), id = _useUncontrolled.id, generateCustomChildId = _useUncontrolled.generateChildId, onSelect = _useUncontrolled.onSelect, activeKey = _useUncontrolled.activeKey, transition = _useUncontrolled.transition, mountOnEnter = _useUncontrolled.mountOnEnter, unmountOnExit = _useUncontrolled.unmountOnExit, children = _useUncontrolled.children;
    var generateChildId = (0, $Fo7oF.useMemo)(function() {
        return generateCustomChildId || function(key, type) {
            return id ? id + "-" + type + "-" + key : null;
        };
    }, [
        id,
        generateCustomChildId
    ]);
    var tabContext = (0, $Fo7oF.useMemo)(function() {
        return {
            onSelect: onSelect,
            activeKey: activeKey,
            transition: transition,
            mountOnEnter: mountOnEnter || false,
            unmountOnExit: unmountOnExit || false,
            getControlledId: function getControlledId(key) {
                return generateChildId(key, 'tabpane');
            },
            getControllerId: function getControllerId(key) {
                return generateChildId(key, 'tab');
            }
        };
    }, [
        onSelect,
        activeKey,
        transition,
        mountOnEnter,
        unmountOnExit,
        generateChildId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $ira3M.default).Provider, {
        value: tabContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $6VnXl.default).Provider, {
        value: onSelect || null
    }, children));
};
var $baf95387e2a9ec21$export$2e2bcd8739ae039 = $baf95387e2a9ec21$var$TabContainer;

});

parcelRegister("ai3sv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $77de44ab5e65ebe4$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");
var $77de44ab5e65ebe4$var$TabContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, className = _ref.className, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "as",
        "className"
    ]);
    var decoratedBsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'tab-content');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, decoratedBsPrefix)
    }));
});
var $77de44ab5e65ebe4$export$2e2bcd8739ae039 = $77de44ab5e65ebe4$var$TabContent;

});

parcelRegister("gyJvA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c0e31f5db0c85d0b$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");

var $ira3M = parcelRequire("ira3M");

var $6VnXl = parcelRequire("6VnXl");

var $b5rGi = parcelRequire("b5rGi");
function $c0e31f5db0c85d0b$var$useTabContext(props) {
    var context = (0, $Fo7oF.useContext)((0, $ira3M.default));
    if (!context) return props;
    var activeKey = context.activeKey, getControlledId = context.getControlledId, getControllerId = context.getControllerId, rest = (0, $fjJNR.default)(context, [
        "activeKey",
        "getControlledId",
        "getControllerId"
    ]);
    var shouldTransition = props.transition !== false && rest.transition !== false;
    var key = (0, $6VnXl.makeEventKey)(props.eventKey);
    return (0, $elnlQ.default)({}, props, {
        active: props.active == null && key != null ? (0, $6VnXl.makeEventKey)(activeKey) === key : props.active,
        id: getControlledId(props.eventKey),
        'aria-labelledby': getControllerId(props.eventKey),
        transition: shouldTransition && (props.transition || rest.transition || (0, $b5rGi.default)),
        mountOnEnter: props.mountOnEnter != null ? props.mountOnEnter : rest.mountOnEnter,
        unmountOnExit: props.unmountOnExit != null ? props.unmountOnExit : rest.unmountOnExit
    });
}
var $c0e31f5db0c85d0b$var$TabPane = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(props, ref) {
    var _useTabContext = $c0e31f5db0c85d0b$var$useTabContext(props), bsPrefix = _useTabContext.bsPrefix, className = _useTabContext.className, active = _useTabContext.active, onEnter = _useTabContext.onEnter, onEntering = _useTabContext.onEntering, onEntered = _useTabContext.onEntered, onExit = _useTabContext.onExit, onExiting = _useTabContext.onExiting, onExited = _useTabContext.onExited, mountOnEnter = _useTabContext.mountOnEnter, unmountOnExit = _useTabContext.unmountOnExit, Transition = _useTabContext.transition, _useTabContext$as = _useTabContext.as, Component = _useTabContext$as === void 0 ? 'div' : _useTabContext$as, _ = _useTabContext.eventKey, rest = (0, $fjJNR.default)(_useTabContext, [
        "bsPrefix",
        "className",
        "active",
        "onEnter",
        "onEntering",
        "onEntered",
        "onExit",
        "onExiting",
        "onExited",
        "mountOnEnter",
        "unmountOnExit",
        "transition",
        "as",
        "eventKey"
    ]);
    var prefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'tab-pane');
    if (!active && !Transition && unmountOnExit) return null;
    var pane = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({}, rest, {
        ref: ref,
        role: "tabpanel",
        "aria-hidden": !active,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, prefix, {
            active: active
        })
    }));
    if (Transition) pane = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Transition, {
        in: active,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit
    }, pane); // We provide an empty the TabContext so `<Nav>`s in `<TabPane>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $ira3M.default).Provider, {
        value: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $6VnXl.default).Provider, {
        value: null
    }, pane));
});
$c0e31f5db0c85d0b$var$TabPane.displayName = 'TabPane';
var $c0e31f5db0c85d0b$export$2e2bcd8739ae039 = $c0e31f5db0c85d0b$var$TabPane;

});


parcelRegister("a6Ywc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $75c9689966defe61$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");

var $508Sg = parcelRequire("508Sg");
var $75c9689966defe61$var$Table = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, striped = _ref.striped, bordered = _ref.bordered, borderless = _ref.borderless, hover = _ref.hover, size = _ref.size, variant = _ref.variant, responsive = _ref.responsive, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "className",
        "striped",
        "bordered",
        "borderless",
        "hover",
        "size",
        "variant",
        "responsive"
    ]);
    var decoratedBsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'table');
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, decoratedBsPrefix, variant && decoratedBsPrefix + "-" + variant, size && decoratedBsPrefix + "-" + size, striped && decoratedBsPrefix + "-striped", bordered && decoratedBsPrefix + "-bordered", borderless && decoratedBsPrefix + "-borderless", hover && decoratedBsPrefix + "-hover");
    var table = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("table", (0, $elnlQ.default)({}, props, {
        className: classes,
        ref: ref
    }));
    if (responsive) {
        var responsiveClass = decoratedBsPrefix + "-responsive";
        if (typeof responsive === 'string') responsiveClass = responsiveClass + "-" + responsive;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", {
            className: responsiveClass
        }, table);
    }
    return table;
});
var $75c9689966defe61$export$2e2bcd8739ae039 = $75c9689966defe61$var$Table;

});

parcelRegister("ep4SW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a7c730906c407876$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $fVt0T = parcelRequire("fVt0T");

var $Fo7oF = parcelRequire("Fo7oF");
parcelRequire("gJ3n2");

var $508Sg = parcelRequire("508Sg");
var $a7c730906c407876$var$defaultProps = {
    placement: 'right'
};
var $a7c730906c407876$var$Tooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, placement = _ref.placement, className = _ref.className, style = _ref.style, children = _ref.children, arrowProps = _ref.arrowProps, _ = _ref.popper, _2 = _ref.show, props = (0, $fjJNR.default)(_ref, [
        "bsPrefix",
        "placement",
        "className",
        "style",
        "children",
        "arrowProps",
        "popper",
        "show"
    ]);
    bsPrefix = (0, $508Sg.useBootstrapPrefix)(bsPrefix, 'tooltip');
    var _ref2 = (placement == null ? void 0 : placement.split('-')) || [], primaryPlacement = _ref2[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", (0, $elnlQ.default)({
        ref: ref,
        style: style,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($fVt0T)))(className, bsPrefix, "bs-tooltip-" + primaryPlacement)
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", (0, $elnlQ.default)({
        className: "arrow"
    }, arrowProps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("div", {
        className: bsPrefix + "-inner"
    }, children));
});
$a7c730906c407876$var$Tooltip.defaultProps = $a7c730906c407876$var$defaultProps;
$a7c730906c407876$var$Tooltip.displayName = 'Tooltip';
var $a7c730906c407876$export$2e2bcd8739ae039 = $a7c730906c407876$var$Tooltip;

});

parcelRegister("bI8Gq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $3yRq4.default;
    }
});

var $3yRq4 = parcelRequire("3yRq4");

});
parcelRegister("3yRq4", function(module, exports) {

$parcel$export(module.exports, "default", () => $297dfc15cbe729f9$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $Fo7oF = parcelRequire("Fo7oF");

var $72Yet = parcelRequire("72Yet");
function $297dfc15cbe729f9$export$2e2bcd8739ae039(path, displayName) {
    var Component = function Component(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $72Yet.default), (0, $elnlQ.default)({
            ref: ref
        }, props), path);
    };
    Component.muiName = (0, $72Yet.default).muiName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(Component));
}

});
parcelRegister("72Yet", function(module, exports) {

$parcel$export(module.exports, "default", () => $5217713ddd4ddee1$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");


var $5rVgt = parcelRequire("5rVgt");

var $bT5dp = parcelRequire("bT5dp");
var $5217713ddd4ddee1$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            userSelect: 'none',
            width: '1em',
            height: '1em',
            display: 'inline-block',
            fill: 'currentColor',
            flexShrink: 0,
            fontSize: theme.typography.pxToRem(24),
            transition: theme.transitions.create('fill', {
                duration: theme.transitions.duration.shorter
            })
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="action"`. */ colorAction: {
            color: theme.palette.action.active
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `color="disabled"`. */ colorDisabled: {
            color: theme.palette.action.disabled
        },
        /* Styles applied to the root element if `fontSize="inherit"`. */ fontSizeInherit: {
            fontSize: 'inherit'
        },
        /* Styles applied to the root element if `fontSize="small"`. */ fontSizeSmall: {
            fontSize: theme.typography.pxToRem(20)
        },
        /* Styles applied to the root element if `fontSize="large"`. */ fontSizeLarge: {
            fontSize: theme.typography.pxToRem(35)
        }
    };
};
var $5217713ddd4ddee1$var$SvgIcon = /*#__PURE__*/ $Fo7oF.forwardRef(function SvgIcon(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'inherit' : _props$color, _props$component = props.component, Component = _props$component === void 0 ? 'svg' : _props$component, _props$fontSize = props.fontSize, fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize, htmlColor = props.htmlColor, titleAccess = props.titleAccess, _props$viewBox = props.viewBox, viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox, other = (0, $67mp8.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "fontSize",
        "htmlColor",
        "titleAccess",
        "viewBox"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, $bT5dp.default)(color))], fontSize !== 'default' && fontSize !== 'medium' && classes["fontSize".concat((0, $bT5dp.default)(fontSize))]),
        focusable: "false",
        viewBox: viewBox,
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, other), children, titleAccess ? /*#__PURE__*/ $Fo7oF.createElement("title", null, titleAccess) : null);
});
$5217713ddd4ddee1$var$SvgIcon.muiName = 'SvgIcon';
var $5217713ddd4ddee1$export$2e2bcd8739ae039 = (0, $5rVgt.default)($5217713ddd4ddee1$export$9dd6ff9ea0189349, {
    name: 'MuiSvgIcon'
})($5217713ddd4ddee1$var$SvgIcon);

});
parcelRegister("67mp8", function(module, exports) {

$parcel$export(module.exports, "default", () => $4744c6947ddf21aa$export$2e2bcd8739ae039);

var $fjJNR = parcelRequire("fjJNR");
function $4744c6947ddf21aa$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $fjJNR.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});

parcelRegister("78z8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $5324886ef62514f8$export$2e2bcd8739ae039);
function $5324886ef62514f8$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $5324886ef62514f8$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $5324886ef62514f8$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $5324886ef62514f8$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $5324886ef62514f8$export$2e2bcd8739ae039 = $5324886ef62514f8$export$4f5d2d50c9deca37;

});

parcelRegister("5rVgt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f7be4f44dc57645$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $8Xy7O = parcelRequire("8Xy7O");

var $2si5T = parcelRequire("2si5T");
function $3f7be4f44dc57645$var$withStyles(stylesOrCreator, options) {
    return (0, $8Xy7O.default)(stylesOrCreator, (0, $elnlQ.default)({
        defaultTheme: (0, $2si5T.default)
    }, options));
}
var $3f7be4f44dc57645$export$2e2bcd8739ae039 = $3f7be4f44dc57645$var$withStyles;

});
parcelRegister("8Xy7O", function(module, exports) {

$parcel$export(module.exports, "default", () => $685e4dec021762da$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $1xoRX = parcelRequire("1xoRX");


var $cX6i1 = parcelRequire("cX6i1");

var $5IYgb = parcelRequire("5IYgb");

var $bauHK = parcelRequire("bauHK");
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var $685e4dec021762da$var$withStyles = function withStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function(Component) {
        var defaultTheme = options.defaultTheme, _options$withTheme = options.withTheme, withTheme = _options$withTheme === void 0 ? false : _options$withTheme, name = options.name, stylesOptions = (0, $67mp8.default)(options, [
            "defaultTheme",
            "withTheme",
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var useStyles = (0, $cX6i1.default)(stylesOrCreator, (0, $elnlQ.default)({
            defaultTheme: defaultTheme,
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var WithStyles = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function WithStyles(props, ref) {
            var classesProp = props.classes, innerRef = props.innerRef, other = (0, $67mp8.default)(props, [
                "classes",
                "innerRef"
            ]); // The wrapper receives only user supplied props, which could be a subset of
            // the actual props Component might receive due to merging with defaultProps.
            // So copying it here would give us the same result in the wrapper as well.
            var classes = useStyles((0, $elnlQ.default)({}, Component.defaultProps, props));
            var theme;
            var more = other;
            if (typeof name === 'string' || withTheme) {
                // name and withTheme are invariant in the outer scope
                // eslint-disable-next-line react-hooks/rules-of-hooks
                theme = (0, $bauHK.default)() || defaultTheme;
                if (name) more = (0, $5IYgb.default)({
                    theme: theme,
                    name: name,
                    props: other
                });
                 // Provide the theme to the wrapped component.
                // So we don't have to use the `withTheme()` Higher-order Component.
                if (withTheme && !more.theme) more.theme = theme;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, (0, $elnlQ.default)({
                ref: innerRef || ref,
                classes: classes
            }, more));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($1xoRX)))(WithStyles, Component);
        return WithStyles;
    };
};
var $685e4dec021762da$export$2e2bcd8739ae039 = $685e4dec021762da$var$withStyles;

});
parcelRegister("1xoRX", function(module, exports) {
'use strict';

var $7XcX3 = parcelRequire("7XcX3");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $11ec2a09dd4f5df9$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $11ec2a09dd4f5df9$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $11ec2a09dd4f5df9$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $11ec2a09dd4f5df9$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $11ec2a09dd4f5df9$var$TYPE_STATICS = {};
$11ec2a09dd4f5df9$var$TYPE_STATICS[$7XcX3.ForwardRef] = $11ec2a09dd4f5df9$var$FORWARD_REF_STATICS;
$11ec2a09dd4f5df9$var$TYPE_STATICS[$7XcX3.Memo] = $11ec2a09dd4f5df9$var$MEMO_STATICS;
function $11ec2a09dd4f5df9$var$getStatics(component) {
    // React v16.11 and below
    if ($7XcX3.isMemo(component)) return $11ec2a09dd4f5df9$var$MEMO_STATICS;
     // React v16.12 and above
    return $11ec2a09dd4f5df9$var$TYPE_STATICS[component['$$typeof']] || $11ec2a09dd4f5df9$var$REACT_STATICS;
}
var $11ec2a09dd4f5df9$var$defineProperty = Object.defineProperty;
var $11ec2a09dd4f5df9$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $11ec2a09dd4f5df9$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $11ec2a09dd4f5df9$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $11ec2a09dd4f5df9$var$getPrototypeOf = Object.getPrototypeOf;
var $11ec2a09dd4f5df9$var$objectPrototype = Object.prototype;
function $11ec2a09dd4f5df9$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($11ec2a09dd4f5df9$var$objectPrototype) {
            var inheritedComponent = $11ec2a09dd4f5df9$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $11ec2a09dd4f5df9$var$objectPrototype) $11ec2a09dd4f5df9$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $11ec2a09dd4f5df9$var$getOwnPropertyNames(sourceComponent);
        if ($11ec2a09dd4f5df9$var$getOwnPropertySymbols) keys = keys.concat($11ec2a09dd4f5df9$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $11ec2a09dd4f5df9$var$getStatics(targetComponent);
        var sourceStatics = $11ec2a09dd4f5df9$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$11ec2a09dd4f5df9$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $11ec2a09dd4f5df9$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $11ec2a09dd4f5df9$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $11ec2a09dd4f5df9$var$hoistNonReactStatics;

});
parcelRegister("7XcX3", function(module, exports) {
'use strict';

module.exports = (parcelRequire("59aql"));

});


parcelRegister("cX6i1", function(module, exports) {

$parcel$export(module.exports, "default", () => $96dfdfb5a0088f02$export$2e2bcd8739ae039);

var $67mp8 = parcelRequire("67mp8");

var $elnlQ = parcelRequire("elnlQ");

var $Fo7oF = parcelRequire("Fo7oF");

var $f4XEI = parcelRequire("f4XEI");

var $jOxwe = parcelRequire("jOxwe");

var $hdS6D = parcelRequire("hdS6D");

var $bauHK = parcelRequire("bauHK");

var $fGVcZ = parcelRequire("fGVcZ");

var $fuMBN = parcelRequire("fuMBN");

var $ge5yt = parcelRequire("ge5yt");

var $bESsu = parcelRequire("bESsu");
function $96dfdfb5a0088f02$var$getClasses(_ref, classes, Component) {
    var state = _ref.state, stylesOptions = _ref.stylesOptions;
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
     // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    var generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $jOxwe.default)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $96dfdfb5a0088f02$var$attach(_ref2, props) {
    var state = _ref2.state, theme = _ref2.theme, stylesOptions = _ref2.stylesOptions, stylesCreator = _ref2.stylesCreator, name = _ref2.name;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $hdS6D.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $hdS6D.default).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    var options = (0, $elnlQ.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        var staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $hdS6D.default).get(stylesOptions.sheetsCache, stylesCreator, theme);
        var styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $elnlQ.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $hdS6D.default).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $f4XEI.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $elnlQ.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $jOxwe.default)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $96dfdfb5a0088f02$var$update(_ref3, props) {
    var state = _ref3.state;
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $96dfdfb5a0088f02$var$detach(_ref4) {
    var state = _ref4.state, theme = _ref4.theme, stylesOptions = _ref4.stylesOptions, stylesCreator = _ref4.stylesCreator;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $hdS6D.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $hdS6D.default).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $96dfdfb5a0088f02$var$useSynchronousEffect(func, values) {
    var key = (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useRef([]);
    var output; // Store "generation" key. Just returns a new object every time
    var currentKey = (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useMemo(function() {
        return {};
    }, values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useEffect(function() {
        return function() {
            if (output) output();
        };
    }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $96dfdfb5a0088f02$export$2e2bcd8739ae039(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = options.name, classNamePrefixOption = options.classNamePrefix, Component = options.Component, _options$defaultTheme = options.defaultTheme, defaultTheme = _options$defaultTheme === void 0 ? (0, $bESsu.default) : _options$defaultTheme, stylesOptions2 = (0, $67mp8.default)(options, [
        "name",
        "classNamePrefix",
        "Component",
        "defaultTheme"
    ]);
    var stylesCreator = (0, $ge5yt.default)(stylesOrCreator);
    var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
    stylesCreator.options = {
        index: (0, $fuMBN.increment)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    var useStyles = function useStyles() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var theme = (0, $bauHK.default)() || defaultTheme;
        var stylesOptions = (0, $elnlQ.default)({}, (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useContext((0, $fGVcZ.StylesContext)), stylesOptions2);
        var instance = (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useRef();
        var shouldUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useRef();
        $96dfdfb5a0088f02$var$useSynchronousEffect(function() {
            var current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $96dfdfb5a0088f02$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return function() {
                $96dfdfb5a0088f02$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useEffect(function() {
            if (shouldUpdate.current) $96dfdfb5a0088f02$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        var classes = $96dfdfb5a0088f02$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}

});
parcelRegister("jOxwe", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6ccaffceaacafdc$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

function $e6ccaffceaacafdc$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var baseClasses = options.baseClasses, newClasses = options.newClasses, Component = options.Component;
    if (!newClasses) return baseClasses;
    var nextClasses = (0, $elnlQ.default)({}, baseClasses);
    Object.keys(newClasses).forEach(function(key) {
        if (newClasses[key]) nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    });
    return nextClasses;
}

});

parcelRegister("hdS6D", function(module, exports) {

$parcel$export(module.exports, "default", () => $c89d9ede1a0c0b00$export$2e2bcd8739ae039);
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var $c89d9ede1a0c0b00$var$multiKeyStore = {
    set: function set(cache, key1, key2, value) {
        var subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: function get(cache, key1, key2) {
        var subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: function _delete(cache, key1, key2) {
        var subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $c89d9ede1a0c0b00$export$2e2bcd8739ae039 = $c89d9ede1a0c0b00$var$multiKeyStore;

});

parcelRegister("bauHK", function(module, exports) {

$parcel$export(module.exports, "default", () => $82187231c84b69ac$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");

var $jpxeP = parcelRequire("jpxeP");
function $82187231c84b69ac$export$2e2bcd8739ae039() {
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useContext((0, $jpxeP.default));
    return theme;
}

});
parcelRegister("jpxeP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e21a2289bd88b347$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");
var $e21a2289bd88b347$var$ThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createContext(null);
var $e21a2289bd88b347$export$2e2bcd8739ae039 = $e21a2289bd88b347$var$ThemeContext;

});


parcelRegister("fGVcZ", function(module, exports) {

$parcel$export(module.exports, "StylesContext", () => $b6c727ae9291a34a$export$f4de434b269fe487);

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");



var $e1ryH = parcelRequire("e1ryH");

var $f4XEI = parcelRequire("f4XEI");

var $1TFFp = parcelRequire("1TFFp");
var $b6c727ae9291a34a$var$jss = (0, $f4XEI.create)((0, $1TFFp.default)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
var $b6c727ae9291a34a$var$generateClassName = (0, $e1ryH.default)(); // Exported for test purposes
var $b6c727ae9291a34a$export$70a8aea9ff58d1cd = new Map();
var $b6c727ae9291a34a$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $b6c727ae9291a34a$var$generateClassName,
    jss: $b6c727ae9291a34a$var$jss,
    sheetsCache: null,
    sheetsManager: $b6c727ae9291a34a$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
var $b6c727ae9291a34a$export$f4de434b269fe487 = (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createContext($b6c727ae9291a34a$var$defaultOptions);
var $b6c727ae9291a34a$var$injectFirstNode;
function $b6c727ae9291a34a$export$2e2bcd8739ae039(props) {
    var children = props.children, _props$injectFirst = props.injectFirst, injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst, _props$disableGenerat = props.disableGeneration, disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat, localOptions = (0, $67mp8.default)(props, [
        "children",
        "injectFirst",
        "disableGeneration"
    ]);
    var outerOptions = (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useContext($b6c727ae9291a34a$export$f4de434b269fe487);
    var context = (0, $elnlQ.default)({}, outerOptions, {
        disableGeneration: disableGeneration
    }, localOptions);
    if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
        if (!$b6c727ae9291a34a$var$injectFirstNode) {
            var head = document.head;
            $b6c727ae9291a34a$var$injectFirstNode = document.createComment('mui-inject-first');
            head.insertBefore($b6c727ae9291a34a$var$injectFirstNode, head.firstChild);
        }
        context.jss = (0, $f4XEI.create)({
            plugins: (0, $1TFFp.default)().plugins,
            insertionPoint: $b6c727ae9291a34a$var$injectFirstNode
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement($b6c727ae9291a34a$export$f4de434b269fe487.Provider, {
        value: context
    }, children);
}

});
parcelRegister("e1ryH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a356893e53ee6936$export$2e2bcd8739ae039);

var $18Npe = parcelRequire("18Npe");
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */ var $a356893e53ee6936$var$pseudoClasses = [
    'checked',
    'disabled',
    'error',
    'focused',
    'focusVisible',
    'required',
    'expanded',
    'selected'
]; // Returns a function which generates unique class names based on counters.
function $a356893e53ee6936$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$disableGloba = options.disableGlobal, disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba, _options$productionPr = options.productionPrefix, productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr, _options$seed = options.seed, seed = _options$seed === void 0 ? '' : _options$seed;
    var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
    var ruleCounter = 0;
    var getNextCounterId = function getNextCounterId() {
        ruleCounter += 1;
        return ruleCounter;
    };
    return function(rule, styleSheet) {
        var name = styleSheet.options.name; // Is a global static MUI style?
        if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($a356893e53ee6936$var$pseudoClasses.indexOf(rule.key) !== -1) return "Mui-".concat(rule.key);
            var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
            if (!styleSheet.options.theme[0, $18Npe.default] || seed !== '') return prefix;
            return "".concat(prefix, "-").concat(getNextCounterId());
        }
        var suffix;
        return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    };
}

});
parcelRegister("18Npe", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d4cdccc4d28b30e$export$2e2bcd8739ae039);
var $0d4cdccc4d28b30e$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $0d4cdccc4d28b30e$export$2e2bcd8739ae039 = $0d4cdccc4d28b30e$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});


parcelRegister("1TFFp", function(module, exports) {

$parcel$export(module.exports, "default", () => $161b3faa0c6fb895$export$2e2bcd8739ae039);

var $cfABj = parcelRequire("cfABj");

var $2PPTL = parcelRequire("2PPTL");

var $kxkiE = parcelRequire("kxkiE");

var $lup98 = parcelRequire("lup98");

var $9Myrq = parcelRequire("9Myrq");

var $aFsr0 = parcelRequire("aFsr0");

var $1xPEY = parcelRequire("1xPEY");
function $161b3faa0c6fb895$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $cfABj.default)(),
            (0, $2PPTL.default)(),
            (0, $kxkiE.default)(),
            (0, $lup98.default)(),
            (0, $9Myrq.default)(),
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === 'undefined' ? null : (0, $aFsr0.default)(),
            (0, $1xPEY.default)()
        ]
    };
}

});
parcelRegister("cfABj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8eb346e314861cf3$export$2e2bcd8739ae039);


var $f4XEI = parcelRequire("f4XEI");
var $8eb346e314861cf3$var$now = Date.now();
var $8eb346e314861cf3$var$fnValuesNs = "fnValues" + $8eb346e314861cf3$var$now;
var $8eb346e314861cf3$var$fnRuleNs = "fnStyle" + ++$8eb346e314861cf3$var$now;
var $8eb346e314861cf3$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== 'function') return null;
            var rule = (0, $f4XEI.createRule)(name, {}, options);
            rule[$8eb346e314861cf3$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($8eb346e314861cf3$var$fnValuesNs in rule || $8eb346e314861cf3$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== 'function') continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$8eb346e314861cf3$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$8eb346e314861cf3$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$8eb346e314861cf3$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $8eb346e314861cf3$export$2e2bcd8739ae039 = $8eb346e314861cf3$var$functionPlugin;

});

parcelRegister("2PPTL", function(module, exports) {

$parcel$export(module.exports, "default", () => $21089a27a4ee882e$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $f4XEI = parcelRequire("f4XEI");
var $21089a27a4ee882e$var$at = '@global';
var $21089a27a4ee882e$var$atPrefix = '@global ';
var $21089a27a4ee882e$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = 'global';
        this.at = $21089a27a4ee882e$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $f4XEI.RuleList)((0, $elnlQ.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    };
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $21089a27a4ee882e$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = 'global';
        this.at = $21089a27a4ee882e$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($21089a27a4ee882e$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $elnlQ.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : '';
    };
    return GlobalPrefixedRule;
}();
var $21089a27a4ee882e$var$separatorRegExp = /\s*,\s*/g;
function $21089a27a4ee882e$var$addScope(selector, scope) {
    var parts = selector.split($21089a27a4ee882e$var$separatorRegExp);
    var scoped = '';
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ', ';
    }
    return scoped;
}
function $21089a27a4ee882e$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$21089a27a4ee882e$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $elnlQ.default)({}, options, {
        selector: $21089a27a4ee882e$var$addScope(name, rule.selector)
    }));
    delete style[$21089a27a4ee882e$var$at];
}
function $21089a27a4ee882e$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== '@' || prop.substr(0, $21089a27a4ee882e$var$at.length) !== $21089a27a4ee882e$var$at) continue;
        var selector = $21089a27a4ee882e$var$addScope(prop.substr($21089a27a4ee882e$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $elnlQ.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $21089a27a4ee882e$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $21089a27a4ee882e$var$at) return new $21089a27a4ee882e$var$GlobalContainerRule(name, styles, options);
        if (name[0] === '@' && name.substr(0, $21089a27a4ee882e$var$atPrefix.length) === $21089a27a4ee882e$var$atPrefix) return new $21089a27a4ee882e$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== 'style' || !sheet) return;
        $21089a27a4ee882e$var$handleNestedGlobalContainerRule(rule, sheet);
        $21089a27a4ee882e$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $21089a27a4ee882e$export$2e2bcd8739ae039 = $21089a27a4ee882e$var$jssGlobal;

});

parcelRegister("kxkiE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef36a2d46498bd47$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $ef36a2d46498bd47$var$separatorRegExp = /\s*,\s*/g;
var $ef36a2d46498bd47$var$parentRegExp = /&/g;
var $ef36a2d46498bd47$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $ef36a2d46498bd47$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($ef36a2d46498bd47$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($ef36a2d46498bd47$var$separatorRegExp);
        var result = '';
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf('&') !== -1 ? nested.replace($ef36a2d46498bd47$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $elnlQ.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $elnlQ.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style') return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf('&') !== -1;
            var isNestedConditional = prop[0] === '@';
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($ef36a2d46498bd47$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ('replaceRule' in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $elnlQ.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $elnlQ.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $ef36a2d46498bd47$export$2e2bcd8739ae039 = $ef36a2d46498bd47$var$jssNested;

});

parcelRegister("lup98", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa4fe7e0cb6ce81a$export$2e2bcd8739ae039);

var $7h5Vx = parcelRequire("7h5Vx");
/**
 * Convert camel cased property names to dash separated.
 */ function $fa4fe7e0cb6ce81a$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf('--') === 0 ? prop : (0, $7h5Vx.default)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($fa4fe7e0cb6ce81a$var$convertCase);
        else converted.fallbacks = $fa4fe7e0cb6ce81a$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $fa4fe7e0cb6ce81a$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $fa4fe7e0cb6ce81a$var$convertCase(style[index]);
            return style;
        }
        return $fa4fe7e0cb6ce81a$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf('--') === 0) return value;
        var hyphenatedProp = (0, $7h5Vx.default)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $fa4fe7e0cb6ce81a$export$2e2bcd8739ae039 = $fa4fe7e0cb6ce81a$var$camelCase;

});
parcelRegister("7h5Vx", function(module, exports) {

$parcel$export(module.exports, "default", () => $54beb7e8c114c0a9$export$2e2bcd8739ae039);
/* eslint-disable no-var, prefer-template */ var $54beb7e8c114c0a9$var$uppercasePattern = /[A-Z]/g;
var $54beb7e8c114c0a9$var$msPattern = /^ms-/;
var $54beb7e8c114c0a9$var$cache = {};
function $54beb7e8c114c0a9$var$toHyphenLower(match) {
    return '-' + match.toLowerCase();
}
function $54beb7e8c114c0a9$var$hyphenateStyleName(name) {
    if ($54beb7e8c114c0a9$var$cache.hasOwnProperty(name)) return $54beb7e8c114c0a9$var$cache[name];
    var hName = name.replace($54beb7e8c114c0a9$var$uppercasePattern, $54beb7e8c114c0a9$var$toHyphenLower);
    return $54beb7e8c114c0a9$var$cache[name] = $54beb7e8c114c0a9$var$msPattern.test(hName) ? '-' + hName : hName;
}
var $54beb7e8c114c0a9$export$2e2bcd8739ae039 = $54beb7e8c114c0a9$var$hyphenateStyleName;

});


parcelRegister("9Myrq", function(module, exports) {

$parcel$export(module.exports, "default", () => $71f35018cff21beb$export$2e2bcd8739ae039);

var $f4XEI = parcelRequire("f4XEI");
var $71f35018cff21beb$var$px = (0, $f4XEI.hasCSSTOMSupport) && CSS ? CSS.px : 'px';
var $71f35018cff21beb$var$ms = (0, $f4XEI.hasCSSTOMSupport) && CSS ? CSS.ms : 'ms';
var $71f35018cff21beb$var$percent = (0, $f4XEI.hasCSSTOMSupport) && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $71f35018cff21beb$var$defaultUnits = {
    // Animation properties
    'animation-delay': $71f35018cff21beb$var$ms,
    'animation-duration': $71f35018cff21beb$var$ms,
    // Background properties
    'background-position': $71f35018cff21beb$var$px,
    'background-position-x': $71f35018cff21beb$var$px,
    'background-position-y': $71f35018cff21beb$var$px,
    'background-size': $71f35018cff21beb$var$px,
    // Border Properties
    border: $71f35018cff21beb$var$px,
    'border-bottom': $71f35018cff21beb$var$px,
    'border-bottom-left-radius': $71f35018cff21beb$var$px,
    'border-bottom-right-radius': $71f35018cff21beb$var$px,
    'border-bottom-width': $71f35018cff21beb$var$px,
    'border-left': $71f35018cff21beb$var$px,
    'border-left-width': $71f35018cff21beb$var$px,
    'border-radius': $71f35018cff21beb$var$px,
    'border-right': $71f35018cff21beb$var$px,
    'border-right-width': $71f35018cff21beb$var$px,
    'border-top': $71f35018cff21beb$var$px,
    'border-top-left-radius': $71f35018cff21beb$var$px,
    'border-top-right-radius': $71f35018cff21beb$var$px,
    'border-top-width': $71f35018cff21beb$var$px,
    'border-width': $71f35018cff21beb$var$px,
    'border-block': $71f35018cff21beb$var$px,
    'border-block-end': $71f35018cff21beb$var$px,
    'border-block-end-width': $71f35018cff21beb$var$px,
    'border-block-start': $71f35018cff21beb$var$px,
    'border-block-start-width': $71f35018cff21beb$var$px,
    'border-block-width': $71f35018cff21beb$var$px,
    'border-inline': $71f35018cff21beb$var$px,
    'border-inline-end': $71f35018cff21beb$var$px,
    'border-inline-end-width': $71f35018cff21beb$var$px,
    'border-inline-start': $71f35018cff21beb$var$px,
    'border-inline-start-width': $71f35018cff21beb$var$px,
    'border-inline-width': $71f35018cff21beb$var$px,
    'border-start-start-radius': $71f35018cff21beb$var$px,
    'border-start-end-radius': $71f35018cff21beb$var$px,
    'border-end-start-radius': $71f35018cff21beb$var$px,
    'border-end-end-radius': $71f35018cff21beb$var$px,
    // Margin properties
    margin: $71f35018cff21beb$var$px,
    'margin-bottom': $71f35018cff21beb$var$px,
    'margin-left': $71f35018cff21beb$var$px,
    'margin-right': $71f35018cff21beb$var$px,
    'margin-top': $71f35018cff21beb$var$px,
    'margin-block': $71f35018cff21beb$var$px,
    'margin-block-end': $71f35018cff21beb$var$px,
    'margin-block-start': $71f35018cff21beb$var$px,
    'margin-inline': $71f35018cff21beb$var$px,
    'margin-inline-end': $71f35018cff21beb$var$px,
    'margin-inline-start': $71f35018cff21beb$var$px,
    // Padding properties
    padding: $71f35018cff21beb$var$px,
    'padding-bottom': $71f35018cff21beb$var$px,
    'padding-left': $71f35018cff21beb$var$px,
    'padding-right': $71f35018cff21beb$var$px,
    'padding-top': $71f35018cff21beb$var$px,
    'padding-block': $71f35018cff21beb$var$px,
    'padding-block-end': $71f35018cff21beb$var$px,
    'padding-block-start': $71f35018cff21beb$var$px,
    'padding-inline': $71f35018cff21beb$var$px,
    'padding-inline-end': $71f35018cff21beb$var$px,
    'padding-inline-start': $71f35018cff21beb$var$px,
    // Mask properties
    'mask-position-x': $71f35018cff21beb$var$px,
    'mask-position-y': $71f35018cff21beb$var$px,
    'mask-size': $71f35018cff21beb$var$px,
    // Width and height properties
    height: $71f35018cff21beb$var$px,
    width: $71f35018cff21beb$var$px,
    'min-height': $71f35018cff21beb$var$px,
    'max-height': $71f35018cff21beb$var$px,
    'min-width': $71f35018cff21beb$var$px,
    'max-width': $71f35018cff21beb$var$px,
    // Position properties
    bottom: $71f35018cff21beb$var$px,
    left: $71f35018cff21beb$var$px,
    top: $71f35018cff21beb$var$px,
    right: $71f35018cff21beb$var$px,
    inset: $71f35018cff21beb$var$px,
    'inset-block': $71f35018cff21beb$var$px,
    'inset-block-end': $71f35018cff21beb$var$px,
    'inset-block-start': $71f35018cff21beb$var$px,
    'inset-inline': $71f35018cff21beb$var$px,
    'inset-inline-end': $71f35018cff21beb$var$px,
    'inset-inline-start': $71f35018cff21beb$var$px,
    // Shadow properties
    'box-shadow': $71f35018cff21beb$var$px,
    'text-shadow': $71f35018cff21beb$var$px,
    // Column properties
    'column-gap': $71f35018cff21beb$var$px,
    'column-rule': $71f35018cff21beb$var$px,
    'column-rule-width': $71f35018cff21beb$var$px,
    'column-width': $71f35018cff21beb$var$px,
    // Font and text properties
    'font-size': $71f35018cff21beb$var$px,
    'font-size-delta': $71f35018cff21beb$var$px,
    'letter-spacing': $71f35018cff21beb$var$px,
    'text-decoration-thickness': $71f35018cff21beb$var$px,
    'text-indent': $71f35018cff21beb$var$px,
    'text-stroke': $71f35018cff21beb$var$px,
    'text-stroke-width': $71f35018cff21beb$var$px,
    'word-spacing': $71f35018cff21beb$var$px,
    // Motion properties
    motion: $71f35018cff21beb$var$px,
    'motion-offset': $71f35018cff21beb$var$px,
    // Outline properties
    outline: $71f35018cff21beb$var$px,
    'outline-offset': $71f35018cff21beb$var$px,
    'outline-width': $71f35018cff21beb$var$px,
    // Perspective properties
    perspective: $71f35018cff21beb$var$px,
    'perspective-origin-x': $71f35018cff21beb$var$percent,
    'perspective-origin-y': $71f35018cff21beb$var$percent,
    // Transform properties
    'transform-origin': $71f35018cff21beb$var$percent,
    'transform-origin-x': $71f35018cff21beb$var$percent,
    'transform-origin-y': $71f35018cff21beb$var$percent,
    'transform-origin-z': $71f35018cff21beb$var$percent,
    // Transition properties
    'transition-delay': $71f35018cff21beb$var$ms,
    'transition-duration': $71f35018cff21beb$var$ms,
    // Alignment properties
    'vertical-align': $71f35018cff21beb$var$px,
    'flex-basis': $71f35018cff21beb$var$px,
    // Some random properties
    'shape-margin': $71f35018cff21beb$var$px,
    size: $71f35018cff21beb$var$px,
    gap: $71f35018cff21beb$var$px,
    // Grid properties
    grid: $71f35018cff21beb$var$px,
    'grid-gap': $71f35018cff21beb$var$px,
    'row-gap': $71f35018cff21beb$var$px,
    'grid-row-gap': $71f35018cff21beb$var$px,
    'grid-column-gap': $71f35018cff21beb$var$px,
    'grid-template-rows': $71f35018cff21beb$var$px,
    'grid-template-columns': $71f35018cff21beb$var$px,
    'grid-auto-rows': $71f35018cff21beb$var$px,
    'grid-auto-columns': $71f35018cff21beb$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    'box-shadow-x': $71f35018cff21beb$var$px,
    'box-shadow-y': $71f35018cff21beb$var$px,
    'box-shadow-blur': $71f35018cff21beb$var$px,
    'box-shadow-spread': $71f35018cff21beb$var$px,
    'font-line-height': $71f35018cff21beb$var$px,
    'text-shadow-x': $71f35018cff21beb$var$px,
    'text-shadow-y': $71f35018cff21beb$var$px,
    'text-shadow-blur': $71f35018cff21beb$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $71f35018cff21beb$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $71f35018cff21beb$var$units = $71f35018cff21beb$var$addCamelCasedVersion($71f35018cff21beb$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $71f35018cff21beb$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $71f35018cff21beb$var$iterate(prop, value[i], options);
    else if (typeof value === 'object') {
        if (prop === 'fallbacks') for(var innerProp in value)value[innerProp] = $71f35018cff21beb$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $71f35018cff21beb$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === 'number' && isNaN(value) === false) {
        var unit = options[prop] || $71f35018cff21beb$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $71f35018cff21beb$var$px)) return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $71f35018cff21beb$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $71f35018cff21beb$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        for(var prop in style)style[prop] = $71f35018cff21beb$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $71f35018cff21beb$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $71f35018cff21beb$export$2e2bcd8739ae039 = $71f35018cff21beb$var$defaultUnit;

});

parcelRegister("aFsr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c43ca41fcd04b50$export$2e2bcd8739ae039);

var $14QUJ = parcelRequire("14QUJ");

var $f4XEI = parcelRequire("f4XEI");
/**
 * Add vendor prefix to a property name when needed.
 */ function $7c43ca41fcd04b50$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === 'keyframes') {
            var atRule = rule;
            atRule.at = (0, $14QUJ.supportedKeyframes)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === 'fallbacks' && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $14QUJ.supportedProperty)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $14QUJ.supportedValue)(supportedProp, (0, $f4XEI.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $14QUJ.supportedValue)(prop, (0, $f4XEI.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $7c43ca41fcd04b50$export$2e2bcd8739ae039 = $7c43ca41fcd04b50$var$jssVendorPrefixer;

});
parcelRegister("14QUJ", function(module, exports) {

$parcel$export(module.exports, "supportedKeyframes", () => $0c8f35c8ff14b79c$export$b6aa0648d950180a);
$parcel$export(module.exports, "supportedProperty", () => $0c8f35c8ff14b79c$export$ce097f82c2e4551a);
$parcel$export(module.exports, "supportedValue", () => $0c8f35c8ff14b79c$export$511766124059c277);

var $6gRhZ = parcelRequire("6gRhZ");

var $83MhR = parcelRequire("83MhR");
// Export javascript style and css style vendor prefixes.
var $0c8f35c8ff14b79c$var$js = '';
var $0c8f35c8ff14b79c$var$css = '';
var $0c8f35c8ff14b79c$var$vendor = '';
var $0c8f35c8ff14b79c$var$browser = '';
var $0c8f35c8ff14b79c$var$isTouch = (0, $6gRhZ.default) && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
if (0, $6gRhZ.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $0c8f35c8ff14b79c$var$jsCssMap = {
        Moz: '-moz-',
        ms: '-ms-',
        O: '-o-',
        Webkit: '-webkit-'
    };
    var $0c8f35c8ff14b79c$var$_document$createEleme = document.createElement('p'), $0c8f35c8ff14b79c$var$style = $0c8f35c8ff14b79c$var$_document$createEleme.style;
    var $0c8f35c8ff14b79c$var$testProp = 'Transform';
    for(var $0c8f35c8ff14b79c$var$key in $0c8f35c8ff14b79c$var$jsCssMap)if ($0c8f35c8ff14b79c$var$key + $0c8f35c8ff14b79c$var$testProp in $0c8f35c8ff14b79c$var$style) {
        $0c8f35c8ff14b79c$var$js = $0c8f35c8ff14b79c$var$key;
        $0c8f35c8ff14b79c$var$css = $0c8f35c8ff14b79c$var$jsCssMap[$0c8f35c8ff14b79c$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($0c8f35c8ff14b79c$var$js === 'Webkit' && 'msHyphens' in $0c8f35c8ff14b79c$var$style) {
        $0c8f35c8ff14b79c$var$js = 'ms';
        $0c8f35c8ff14b79c$var$css = $0c8f35c8ff14b79c$var$jsCssMap.ms;
        $0c8f35c8ff14b79c$var$browser = 'edge';
    } // Correctly detect the Safari browser.
    if ($0c8f35c8ff14b79c$var$js === 'Webkit' && '-apple-trailing-word' in $0c8f35c8ff14b79c$var$style) $0c8f35c8ff14b79c$var$vendor = 'apple';
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $0c8f35c8ff14b79c$export$82e9f45cca5ba907 = {
    js: $0c8f35c8ff14b79c$var$js,
    css: $0c8f35c8ff14b79c$var$css,
    vendor: $0c8f35c8ff14b79c$var$vendor,
    browser: $0c8f35c8ff14b79c$var$browser,
    isTouch: $0c8f35c8ff14b79c$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $0c8f35c8ff14b79c$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($0c8f35c8ff14b79c$export$82e9f45cca5ba907.js === 'ms') return key;
    return "@" + $0c8f35c8ff14b79c$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $0c8f35c8ff14b79c$var$appearence = {
    noPrefill: [
        'appearance'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'appearance') return false;
        if ($0c8f35c8ff14b79c$export$82e9f45cca5ba907.js === 'ms') return "-webkit-" + prop;
        return $0c8f35c8ff14b79c$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $0c8f35c8ff14b79c$var$colorAdjust = {
    noPrefill: [
        'color-adjust'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'color-adjust') return false;
        if ($0c8f35c8ff14b79c$export$82e9f45cca5ba907.js === 'Webkit') return $0c8f35c8ff14b79c$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $0c8f35c8ff14b79c$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $0c8f35c8ff14b79c$var$toUpper(match, c) {
    return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $0c8f35c8ff14b79c$var$camelize(str) {
    return str.replace($0c8f35c8ff14b79c$var$regExp, $0c8f35c8ff14b79c$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $0c8f35c8ff14b79c$var$pascalize(str) {
    return $0c8f35c8ff14b79c$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $0c8f35c8ff14b79c$var$mask = {
    noPrefill: [
        'mask'
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($0c8f35c8ff14b79c$export$82e9f45cca5ba907.js === 'Webkit') {
            var longhand = 'mask-image';
            if ($0c8f35c8ff14b79c$var$camelize(longhand) in style) return prop;
            if ($0c8f35c8ff14b79c$export$82e9f45cca5ba907.js + $0c8f35c8ff14b79c$var$pascalize(longhand) in style) return $0c8f35c8ff14b79c$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $0c8f35c8ff14b79c$var$textOrientation = {
    noPrefill: [
        'text-orientation'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'text-orientation') return false;
        if ($0c8f35c8ff14b79c$export$82e9f45cca5ba907.vendor === 'apple' && !$0c8f35c8ff14b79c$export$82e9f45cca5ba907.isTouch) return $0c8f35c8ff14b79c$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $0c8f35c8ff14b79c$var$transform = {
    noPrefill: [
        'transform'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transform') return false;
        if (options.transform) return prop;
        return $0c8f35c8ff14b79c$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $0c8f35c8ff14b79c$var$transition = {
    noPrefill: [
        'transition'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transition') return false;
        if (options.transition) return prop;
        return $0c8f35c8ff14b79c$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $0c8f35c8ff14b79c$var$writingMode = {
    noPrefill: [
        'writing-mode'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'writing-mode') return false;
        if ($0c8f35c8ff14b79c$export$82e9f45cca5ba907.js === 'Webkit' || $0c8f35c8ff14b79c$export$82e9f45cca5ba907.js === 'ms' && $0c8f35c8ff14b79c$export$82e9f45cca5ba907.browser !== 'edge') return $0c8f35c8ff14b79c$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $0c8f35c8ff14b79c$var$userSelect = {
    noPrefill: [
        'user-select'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'user-select') return false;
        if ($0c8f35c8ff14b79c$export$82e9f45cca5ba907.js === 'Moz' || $0c8f35c8ff14b79c$export$82e9f45cca5ba907.js === 'ms' || $0c8f35c8ff14b79c$export$82e9f45cca5ba907.vendor === 'apple') return $0c8f35c8ff14b79c$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $0c8f35c8ff14b79c$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($0c8f35c8ff14b79c$export$82e9f45cca5ba907.js === 'Webkit') {
            var jsProp = "WebkitColumn" + $0c8f35c8ff14b79c$var$pascalize(prop);
            return jsProp in style ? $0c8f35c8ff14b79c$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($0c8f35c8ff14b79c$export$82e9f45cca5ba907.js === 'Moz') {
            var _jsProp = "page" + $0c8f35c8ff14b79c$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $0c8f35c8ff14b79c$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($0c8f35c8ff14b79c$export$82e9f45cca5ba907.js === 'Moz') return prop;
        var newProp = prop.replace('-inline', '');
        return $0c8f35c8ff14b79c$export$82e9f45cca5ba907.js + $0c8f35c8ff14b79c$var$pascalize(newProp) in style ? $0c8f35c8ff14b79c$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $0c8f35c8ff14b79c$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $0c8f35c8ff14b79c$var$camelize(prop) in style ? prop : false;
    }
};
var $0c8f35c8ff14b79c$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $0c8f35c8ff14b79c$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
        if (prop[0] === '-' && prop[1] === '-') return prop;
        if ($0c8f35c8ff14b79c$export$82e9f45cca5ba907.js + pascalized in style) return $0c8f35c8ff14b79c$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($0c8f35c8ff14b79c$export$82e9f45cca5ba907.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $0c8f35c8ff14b79c$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== 'scroll-snap') return false;
        if ($0c8f35c8ff14b79c$export$82e9f45cca5ba907.js === 'ms') return "" + $0c8f35c8ff14b79c$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $0c8f35c8ff14b79c$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'overscroll-behavior') return false;
        if ($0c8f35c8ff14b79c$export$82e9f45cca5ba907.js === 'ms') return $0c8f35c8ff14b79c$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $0c8f35c8ff14b79c$var$propMap = {
    'flex-grow': 'flex-positive',
    'flex-shrink': 'flex-negative',
    'flex-basis': 'flex-preferred-size',
    'justify-content': 'flex-pack',
    order: 'flex-order',
    'align-items': 'flex-align',
    'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $0c8f35c8ff14b79c$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $0c8f35c8ff14b79c$var$propMap[prop];
        if (!newProp) return false;
        return $0c8f35c8ff14b79c$export$82e9f45cca5ba907.js + $0c8f35c8ff14b79c$var$pascalize(newProp) in style ? $0c8f35c8ff14b79c$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $0c8f35c8ff14b79c$var$propMap$1 = {
    flex: 'box-flex',
    'flex-grow': 'box-flex',
    'flex-direction': [
        'box-orient',
        'box-direction'
    ],
    order: 'box-ordinal-group',
    'align-items': 'box-align',
    'flex-flow': [
        'box-orient',
        'box-direction'
    ],
    'justify-content': 'box-pack'
};
var $0c8f35c8ff14b79c$var$propKeys = Object.keys($0c8f35c8ff14b79c$var$propMap$1);
var $0c8f35c8ff14b79c$var$prefixCss = function prefixCss(p) {
    return $0c8f35c8ff14b79c$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $0c8f35c8ff14b79c$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($0c8f35c8ff14b79c$var$propKeys.indexOf(prop) > -1) {
            var newProp = $0c8f35c8ff14b79c$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $0c8f35c8ff14b79c$export$82e9f45cca5ba907.js + $0c8f35c8ff14b79c$var$pascalize(newProp) in style ? $0c8f35c8ff14b79c$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($0c8f35c8ff14b79c$export$82e9f45cca5ba907.js + $0c8f35c8ff14b79c$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($0c8f35c8ff14b79c$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $0c8f35c8ff14b79c$var$plugins = [
    $0c8f35c8ff14b79c$var$appearence,
    $0c8f35c8ff14b79c$var$colorAdjust,
    $0c8f35c8ff14b79c$var$mask,
    $0c8f35c8ff14b79c$var$textOrientation,
    $0c8f35c8ff14b79c$var$transform,
    $0c8f35c8ff14b79c$var$transition,
    $0c8f35c8ff14b79c$var$writingMode,
    $0c8f35c8ff14b79c$var$userSelect,
    $0c8f35c8ff14b79c$var$breakPropsOld,
    $0c8f35c8ff14b79c$var$inlineLogicalOld,
    $0c8f35c8ff14b79c$var$unprefixed,
    $0c8f35c8ff14b79c$var$prefixed,
    $0c8f35c8ff14b79c$var$scrollSnap,
    $0c8f35c8ff14b79c$var$overscrollBehavior,
    $0c8f35c8ff14b79c$var$flex2012,
    $0c8f35c8ff14b79c$var$flex2009
];
var $0c8f35c8ff14b79c$var$propertyDetectors = $0c8f35c8ff14b79c$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $0c8f35c8ff14b79c$var$noPrefill = $0c8f35c8ff14b79c$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $83MhR.default)(p.noPrefill));
    return a;
}, []);
var $0c8f35c8ff14b79c$var$el;
var $0c8f35c8ff14b79c$var$cache = {};
if (0, $6gRhZ.default) {
    $0c8f35c8ff14b79c$var$el = document.createElement('p'); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $0c8f35c8ff14b79c$var$computed = window.getComputedStyle(document.documentElement, '');
    for(var $0c8f35c8ff14b79c$var$key$1 in $0c8f35c8ff14b79c$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($0c8f35c8ff14b79c$var$key$1)) $0c8f35c8ff14b79c$var$cache[$0c8f35c8ff14b79c$var$computed[$0c8f35c8ff14b79c$var$key$1]] = $0c8f35c8ff14b79c$var$computed[$0c8f35c8ff14b79c$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $0c8f35c8ff14b79c$var$noPrefill.forEach(function(x) {
        return delete $0c8f35c8ff14b79c$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $0c8f35c8ff14b79c$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$0c8f35c8ff14b79c$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($0c8f35c8ff14b79c$var$cache[prop] != null) return $0c8f35c8ff14b79c$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === 'transition' || prop === 'transform') options[prop] = prop in $0c8f35c8ff14b79c$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $0c8f35c8ff14b79c$var$propertyDetectors.length; i++){
        $0c8f35c8ff14b79c$var$cache[prop] = $0c8f35c8ff14b79c$var$propertyDetectors[i](prop, $0c8f35c8ff14b79c$var$el.style, options); // Break loop, if value found.
        if ($0c8f35c8ff14b79c$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $0c8f35c8ff14b79c$var$el.style[prop] = '';
    } catch (err) {
        return false;
    }
    return $0c8f35c8ff14b79c$var$cache[prop];
}
var $0c8f35c8ff14b79c$var$cache$1 = {};
var $0c8f35c8ff14b79c$var$transitionProperties = {
    transition: 1,
    'transition-property': 1,
    '-webkit-transition': 1,
    '-webkit-transition-property': 1
};
var $0c8f35c8ff14b79c$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $0c8f35c8ff14b79c$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $0c8f35c8ff14b79c$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === 'var') return 'var';
    if (p1 === 'all') return 'all';
    if (p2 === 'all') return ', all';
    var prefixedValue = p1 ? $0c8f35c8ff14b79c$export$ce097f82c2e4551a(p1) : ", " + $0c8f35c8ff14b79c$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $6gRhZ.default) $0c8f35c8ff14b79c$var$el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $0c8f35c8ff14b79c$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$0c8f35c8ff14b79c$var$el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($0c8f35c8ff14b79c$var$cache$1[cacheKey] != null) return $0c8f35c8ff14b79c$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $0c8f35c8ff14b79c$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $0c8f35c8ff14b79c$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($0c8f35c8ff14b79c$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($0c8f35c8ff14b79c$var$transPropsRegExp, $0c8f35c8ff14b79c$var$prefixTransitionCallback);
    else if ($0c8f35c8ff14b79c$var$el$1.style[property] === '') {
        // Value with a vendor prefix.
        prefixedValue = $0c8f35c8ff14b79c$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === '-ms-flex') $0c8f35c8ff14b79c$var$el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
        $0c8f35c8ff14b79c$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($0c8f35c8ff14b79c$var$el$1.style[property] === '') {
            $0c8f35c8ff14b79c$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $0c8f35c8ff14b79c$var$el$1.style[property] = ''; // Write current value to cache.
    $0c8f35c8ff14b79c$var$cache$1[cacheKey] = prefixedValue;
    return $0c8f35c8ff14b79c$var$cache$1[cacheKey];
}

});
parcelRegister("83MhR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5de40f5d0dac3a4c$export$2e2bcd8739ae039);

var $8KJH0 = parcelRequire("8KJH0");

var $aWElp = parcelRequire("aWElp");

var $graxV = parcelRequire("graxV");

var $8wrfz = parcelRequire("8wrfz");
function $5de40f5d0dac3a4c$export$2e2bcd8739ae039(r) {
    return (0, $8KJH0.default)(r) || (0, $aWElp.default)(r) || (0, $graxV.default)(r) || (0, $8wrfz.default)();
}

});
parcelRegister("8KJH0", function(module, exports) {

$parcel$export(module.exports, "default", () => $65f6103b38eff4fb$export$2e2bcd8739ae039);

var $FOHfT = parcelRequire("FOHfT");
function $65f6103b38eff4fb$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $FOHfT.default)(r);
}

});
parcelRegister("FOHfT", function(module, exports) {

$parcel$export(module.exports, "default", () => $07db27c085c2302a$export$2e2bcd8739ae039);
function $07db27c085c2302a$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("aWElp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f7e9daf96b7e4e4$export$2e2bcd8739ae039);
function $7f7e9daf96b7e4e4$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("graxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf7759356f0c5b7a$export$2e2bcd8739ae039);

var $FOHfT = parcelRequire("FOHfT");
function $bf7759356f0c5b7a$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $FOHfT.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $FOHfT.default)(r, a) : void 0;
    }
}

});

parcelRegister("8wrfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $63467337e233d043$export$2e2bcd8739ae039);
function $63467337e233d043$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("1xPEY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1200f2157be6ba1d$export$2e2bcd8739ae039);
/**
 * Sort props by length.
 */ function $1200f2157be6ba1d$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== 'style') return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $1200f2157be6ba1d$export$2e2bcd8739ae039 = $1200f2157be6ba1d$var$jssPropsSort;

});



parcelRegister("fuMBN", function(module, exports) {

$parcel$export(module.exports, "increment", () => $b47f5d03af9c684c$export$a2647aa13413c947);
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var $b47f5d03af9c684c$var$indexCounter = -1000000000;
function $b47f5d03af9c684c$export$a2647aa13413c947() {
    $b47f5d03af9c684c$var$indexCounter += 1;
    return $b47f5d03af9c684c$var$indexCounter;
}

});

parcelRegister("ge5yt", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd02434923a2ec6f$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");
parcelRequire("69Iz3");

var $dbHGl = parcelRequire("dbHGl");

function $bd02434923a2ec6f$export$2e2bcd8739ae039(stylesOrCreator) {
    var themingEnabled = typeof stylesOrCreator === 'function';
    return {
        create: function create(theme, name) {
            var styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.overrides || !theme.overrides[name]) return styles;
            var overrides = theme.overrides[name];
            var stylesWithOverrides = (0, $elnlQ.default)({}, styles);
            Object.keys(overrides).forEach(function(key) {
                stylesWithOverrides[key] = (0, $dbHGl.default)(stylesWithOverrides[key], overrides[key]);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}

});
parcelRegister("dbHGl", function(module, exports) {

$parcel$export(module.exports, "default", () => $999e2fc5c508b19e$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $69Iz3 = parcelRequire("69Iz3");
function $999e2fc5c508b19e$export$53b83ca8eaab0383(item) {
    return item && (0, $69Iz3.default)(item) === 'object' && item.constructor === Object;
}
function $999e2fc5c508b19e$export$2e2bcd8739ae039(target, source) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        clone: true
    };
    var output = options.clone ? (0, $elnlQ.default)({}, target) : target;
    if ($999e2fc5c508b19e$export$53b83ca8eaab0383(target) && $999e2fc5c508b19e$export$53b83ca8eaab0383(source)) Object.keys(source).forEach(function(key) {
        // Avoid prototype pollution
        if (key === '__proto__') return;
        if ($999e2fc5c508b19e$export$53b83ca8eaab0383(source[key]) && key in target) output[key] = $999e2fc5c508b19e$export$2e2bcd8739ae039(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}

});


parcelRegister("bESsu", function(module, exports) {

$parcel$export(module.exports, "default", () => $87cdac7a493667e5$export$2e2bcd8739ae039);
// We use the same empty object to ref count the styles that don't need a theme object.
var $87cdac7a493667e5$var$noopTheme = {};
var $87cdac7a493667e5$export$2e2bcd8739ae039 = $87cdac7a493667e5$var$noopTheme;

});


parcelRegister("5IYgb", function(module, exports) {

$parcel$export(module.exports, "default", () => $42afce350d3e5414$export$2e2bcd8739ae039);
/* eslint-disable no-restricted-syntax */ function $42afce350d3e5414$export$2e2bcd8739ae039(params) {
    var theme = params.theme, name = params.name, props = params.props;
    if (!theme || !theme.props || !theme.props[name]) return props;
     // Resolve default props, code borrow from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    var defaultProps = theme.props[name];
    var propName;
    for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
    return props;
}

});


parcelRegister("2si5T", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c9c3b62256c88df$export$2e2bcd8739ae039);

var $bdmad = parcelRequire("bdmad");
var $1c9c3b62256c88df$var$defaultTheme = (0, $bdmad.default)();
var $1c9c3b62256c88df$export$2e2bcd8739ae039 = $1c9c3b62256c88df$var$defaultTheme;

});
parcelRegister("bdmad", function(module, exports) {

$parcel$export(module.exports, "default", () => $82a219d9b1b8f3a2$export$2e2bcd8739ae039);
parcelRequire("d2vKa");

var $67mp8 = parcelRequire("67mp8");

var $dbHGl = parcelRequire("dbHGl");

var $3zP4o = parcelRequire("3zP4o");

var $fkH7t = parcelRequire("fkH7t");

var $9Uuf9 = parcelRequire("9Uuf9");

var $bmWAH = parcelRequire("bmWAH");

var $iMppy = parcelRequire("iMppy");

var $h14Q2 = parcelRequire("h14Q2");

var $ad7QU = parcelRequire("ad7QU");

var $6N3by = parcelRequire("6N3by");

var $o4akA = parcelRequire("o4akA");
function $82a219d9b1b8f3a2$var$createTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = (0, $67mp8.default)(options, [
        "breakpoints",
        "mixins",
        "palette",
        "spacing",
        "typography"
    ]);
    var palette = (0, $9Uuf9.default)(paletteInput);
    var breakpoints = (0, $3zP4o.default)(breakpointsInput);
    var spacing = (0, $ad7QU.default)(spacingInput);
    var muiTheme = (0, $dbHGl.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        mixins: (0, $fkH7t.default)(breakpoints, spacing, mixinsInput),
        overrides: {},
        // Inject custom styles
        palette: palette,
        props: {},
        // Provide default props
        shadows: (0, $iMppy.default),
        typography: (0, $bmWAH.default)(palette, typographyInput),
        spacing: spacing,
        shape: (0, $h14Q2.default),
        transitions: (0, $6N3by.default),
        zIndex: (0, $o4akA.default)
    }, other);
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $dbHGl.default)(acc, argument);
    }, muiTheme);
    var pseudoClasses, traverse;
    return muiTheme;
}
var $82a219d9b1b8f3a2$var$warnedOnce = false;
function $82a219d9b1b8f3a2$export$c469355549431d9b() {
    return $82a219d9b1b8f3a2$var$createTheme.apply(void 0, arguments);
}
var $82a219d9b1b8f3a2$export$2e2bcd8739ae039 = $82a219d9b1b8f3a2$var$createTheme;

});
parcelRegister("d2vKa", function(module, exports) {

$parcel$export(module.exports, "default", () => $97e415decc6b9f8b$export$2e2bcd8739ae039);

var $8ki5x = parcelRequire("8ki5x");
function $97e415decc6b9f8b$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $8ki5x.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("3zP4o", function(module, exports) {

$parcel$export(module.exports, "default", () => $29ac4163acf9c700$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");
var $29ac4163acf9c700$export$ed97f33186d4b816 = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
]; // Keep in mind that @media is inclusive by the CSS specification.
function $29ac4163acf9c700$export$2e2bcd8739ae039(breakpoints) {
    var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = (0, $67mp8.default)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    function up(key) {
        var value = typeof values[key] === 'number' ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    }
    function down(key) {
        var endIndex = $29ac4163acf9c700$export$ed97f33186d4b816.indexOf(key) + 1;
        var upperbound = values[$29ac4163acf9c700$export$ed97f33186d4b816[endIndex]];
        if (endIndex === $29ac4163acf9c700$export$ed97f33186d4b816.length) // xl down applies to all sizes
        return up('xs');
        var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }
    function between(start, end) {
        var endIndex = $29ac4163acf9c700$export$ed97f33186d4b816.indexOf(end);
        if (endIndex === $29ac4163acf9c700$export$ed97f33186d4b816.length - 1) return up(start);
        return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[$29ac4163acf9c700$export$ed97f33186d4b816[endIndex + 1]] === 'number' ? values[$29ac4163acf9c700$export$ed97f33186d4b816[endIndex + 1]] : end) - step / 100).concat(unit, ")");
    }
    function only(key) {
        return between(key, key);
    }
    var warnedOnce = false;
    function width(key) {
        return values[key];
    }
    return (0, $elnlQ.default)({
        keys: $29ac4163acf9c700$export$ed97f33186d4b816,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        width: width
    }, other);
}

});

parcelRegister("fkH7t", function(module, exports) {

$parcel$export(module.exports, "default", () => $b29a2bea5a0a8df0$export$2e2bcd8739ae039);

var $d2vKa = parcelRequire("d2vKa");

var $elnlQ = parcelRequire("elnlQ");
function $b29a2bea5a0a8df0$export$2e2bcd8739ae039(breakpoints, spacing, mixins) {
    var _toolbar;
    return (0, $elnlQ.default)({
        gutters: function gutters() {
            var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            console.warn([
                'Material-UI: theme.mixins.gutters() is deprecated.',
                'You can use the source of the mixin directly:',
                "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "
            ].join('\n'));
            return (0, $elnlQ.default)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, (0, $d2vKa.default)({}, breakpoints.up('sm'), (0, $elnlQ.default)({
                paddingLeft: spacing(3),
                paddingRight: spacing(3)
            }, styles[breakpoints.up('sm')])));
        },
        toolbar: (_toolbar = {
            minHeight: 56
        }, (0, $d2vKa.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
            minHeight: 48
        }), (0, $d2vKa.default)(_toolbar, breakpoints.up('sm'), {
            minHeight: 64
        }), _toolbar)
    }, mixins);
}

});

parcelRegister("9Uuf9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7370cdbf4f375807$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $dbHGl = parcelRequire("dbHGl");
var $3Oo4t = parcelRequire("3Oo4t");

var $gUShx = parcelRequire("gUShx");

var $5Rr3U = parcelRequire("5Rr3U");

var $bh2Zs = parcelRequire("bh2Zs");

var $h5jeG = parcelRequire("h5jeG");

var $j2mzQ = parcelRequire("j2mzQ");

var $C1zks = parcelRequire("C1zks");

var $32Ykm = parcelRequire("32Ykm");

var $aG21b = parcelRequire("aG21b");

var $8Hh6N = parcelRequire("8Hh6N");
var $7370cdbf4f375807$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.54)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)',
        // Text hints.
        hint: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $gUShx.default).white,
        default: (0, $5Rr3U.default)[50]
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
var $7370cdbf4f375807$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $gUShx.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        hint: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: (0, $5Rr3U.default)[800],
        default: '#303030'
    },
    action: {
        active: (0, $gUShx.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $7370cdbf4f375807$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $8Hh6N.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $8Hh6N.darken)(intent.main, tonalOffsetDark);
    }
}
function $7370cdbf4f375807$export$2e2bcd8739ae039(palette) {
    var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
        light: (0, $bh2Zs.default)[300],
        main: (0, $bh2Zs.default)[500],
        dark: (0, $bh2Zs.default)[700]
    } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
        light: (0, $h5jeG.default).A200,
        main: (0, $h5jeG.default).A400,
        dark: (0, $h5jeG.default).A700
    } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
        light: (0, $j2mzQ.default)[300],
        main: (0, $j2mzQ.default)[500],
        dark: (0, $j2mzQ.default)[700]
    } : _palette$error, _palette$warning = palette.warning, warning = _palette$warning === void 0 ? {
        light: (0, $C1zks.default)[300],
        main: (0, $C1zks.default)[500],
        dark: (0, $C1zks.default)[700]
    } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
        light: (0, $32Ykm.default)[300],
        main: (0, $32Ykm.default)[500],
        dark: (0, $32Ykm.default)[700]
    } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
        light: (0, $aG21b.default)[300],
        main: (0, $aG21b.default)[500],
        dark: (0, $aG21b.default)[700]
    } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? 'light' : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = (0, $67mp8.default)(palette, [
        "primary",
        "secondary",
        "error",
        "warning",
        "info",
        "success",
        "type",
        "contrastThreshold",
        "tonalOffset"
    ]); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        var contrastText = (0, $8Hh6N.getContrastRatio)(background, $7370cdbf4f375807$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $7370cdbf4f375807$export$55ce6f3a06c59543.text.primary : $7370cdbf4f375807$export$a43af521ac8c3202.text.primary;
        var contrast;
        return contrastText;
    }
    var augmentColor = function augmentColor(color) {
        var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
        var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
        color = (0, $elnlQ.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.main) throw new Error((0, $3Oo4t.default)(4, mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $3Oo4t.default)(5, JSON.stringify(color.main)));
        $7370cdbf4f375807$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $7370cdbf4f375807$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    var types = {
        dark: $7370cdbf4f375807$export$55ce6f3a06c59543,
        light: $7370cdbf4f375807$export$a43af521ac8c3202
    };
    var paletteOutput = (0, $dbHGl.default)((0, $elnlQ.default)({
        // A collection of common colors.
        common: (0, $gUShx.default),
        // The palette type, can be light or dark.
        type: type,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor(primary),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor(error),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor(warning),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor(info),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor(success),
        // The grey colors.
        grey: (0, $5Rr3U.default),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText: getContrastText,
        // Generate a rich color object.
        augmentColor: augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: tonalOffset
    }, types[type]), other);
    return paletteOutput;
}

});
parcelRegister("3Oo4t", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c68b6a6ad04a7a4$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $2c68b6a6ad04a7a4$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ var url = 'https://mui.com/production-error/?code=' + code;
    for(var i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});

parcelRegister("gUShx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c50bfb8afa571603$export$2e2bcd8739ae039);
var $c50bfb8afa571603$var$common = {
    black: '#000',
    white: '#fff'
};
var $c50bfb8afa571603$export$2e2bcd8739ae039 = $c50bfb8afa571603$var$common;

});

parcelRegister("5Rr3U", function(module, exports) {

$parcel$export(module.exports, "default", () => $4446e4f37a3caffd$export$2e2bcd8739ae039);
var $4446e4f37a3caffd$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161'
};
var $4446e4f37a3caffd$export$2e2bcd8739ae039 = $4446e4f37a3caffd$var$grey;

});

parcelRegister("bh2Zs", function(module, exports) {

$parcel$export(module.exports, "default", () => $83539a10e85bfb35$export$2e2bcd8739ae039);
var $83539a10e85bfb35$var$indigo = {
    50: '#e8eaf6',
    100: '#c5cae9',
    200: '#9fa8da',
    300: '#7986cb',
    400: '#5c6bc0',
    500: '#3f51b5',
    600: '#3949ab',
    700: '#303f9f',
    800: '#283593',
    900: '#1a237e',
    A100: '#8c9eff',
    A200: '#536dfe',
    A400: '#3d5afe',
    A700: '#304ffe'
};
var $83539a10e85bfb35$export$2e2bcd8739ae039 = $83539a10e85bfb35$var$indigo;

});

parcelRegister("h5jeG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c701d31bc15e1062$export$2e2bcd8739ae039);
var $c701d31bc15e1062$var$pink = {
    50: '#fce4ec',
    100: '#f8bbd0',
    200: '#f48fb1',
    300: '#f06292',
    400: '#ec407a',
    500: '#e91e63',
    600: '#d81b60',
    700: '#c2185b',
    800: '#ad1457',
    900: '#880e4f',
    A100: '#ff80ab',
    A200: '#ff4081',
    A400: '#f50057',
    A700: '#c51162'
};
var $c701d31bc15e1062$export$2e2bcd8739ae039 = $c701d31bc15e1062$var$pink;

});

parcelRegister("j2mzQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddbfb798259702e3$export$2e2bcd8739ae039);
var $ddbfb798259702e3$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $ddbfb798259702e3$export$2e2bcd8739ae039 = $ddbfb798259702e3$var$red;

});

parcelRegister("C1zks", function(module, exports) {

$parcel$export(module.exports, "default", () => $0724c4428aa2d4bf$export$2e2bcd8739ae039);
var $0724c4428aa2d4bf$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $0724c4428aa2d4bf$export$2e2bcd8739ae039 = $0724c4428aa2d4bf$var$orange;

});

parcelRegister("32Ykm", function(module, exports) {

$parcel$export(module.exports, "default", () => $23805abe4a931003$export$2e2bcd8739ae039);
var $23805abe4a931003$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $23805abe4a931003$export$2e2bcd8739ae039 = $23805abe4a931003$var$blue;

});

parcelRegister("aG21b", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c5f64655dbede56$export$2e2bcd8739ae039);
var $7c5f64655dbede56$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $7c5f64655dbede56$export$2e2bcd8739ae039 = $7c5f64655dbede56$var$green;

});

parcelRegister("8Hh6N", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", () => $654f9c48372e7f5e$export$d061e26956a60b0a);
$parcel$export(module.exports, "emphasize", () => $654f9c48372e7f5e$export$e665714f76e581fd);
$parcel$export(module.exports, "darken", () => $654f9c48372e7f5e$export$4b073707ff63303);
$parcel$export(module.exports, "lighten", () => $654f9c48372e7f5e$export$c0816ed86df316af);
$parcel$export(module.exports, "fade", () => $654f9c48372e7f5e$export$cbea29d068a2e18f);
$parcel$export(module.exports, "alpha", () => $654f9c48372e7f5e$export$58f0f39f63f3cf42);

var $3Oo4t = parcelRequire("3Oo4t");
/* eslint-disable no-use-before-define */ /**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $654f9c48372e7f5e$var$clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.min(Math.max(min, value), max);
}
function $654f9c48372e7f5e$export$5a544e13ad4e1fa5(color) {
    color = color.substr(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
    var colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map(function(n) {
        return n + n;
    });
    return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function(n, index) {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', '), ")") : '';
}
function $654f9c48372e7f5e$var$intToHex(int) {
    var hex = int.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
}
function $654f9c48372e7f5e$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    var _decomposeColor = $654f9c48372e7f5e$export$677b39864803984e(color), values = _decomposeColor.values;
    return "#".concat(values.map(function(n) {
        return $654f9c48372e7f5e$var$intToHex(n);
    }).join(''));
}
function $654f9c48372e7f5e$export$29fb7152bd3f781a(color) {
    color = $654f9c48372e7f5e$export$677b39864803984e(color);
    var _color = color, values = _color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    var type = 'rgb';
    var rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $654f9c48372e7f5e$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $654f9c48372e7f5e$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $654f9c48372e7f5e$export$677b39864803984e($654f9c48372e7f5e$export$5a544e13ad4e1fa5(color));
    var marker = color.indexOf('(');
    var type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla'
    ].indexOf(type) === -1) throw new Error((0, $3Oo4t.default)(3, color));
    var values = color.substring(marker + 1, color.length - 1).split(',');
    values = values.map(function(value) {
        return parseFloat(value);
    });
    return {
        type: type,
        values: values
    };
}
function $654f9c48372e7f5e$export$211a73f2b8c10ce4(color) {
    var type = color.type;
    var values = color.values;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function(n, i) {
        return i < 3 ? parseInt(n, 10) : n;
    });
    else if (type.indexOf('hsl') !== -1) {
        values[1] = "".concat(values[1], "%");
        values[2] = "".concat(values[2], "%");
    }
    return "".concat(type, "(").concat(values.join(', '), ")");
}
function $654f9c48372e7f5e$export$d061e26956a60b0a(foreground, background) {
    var lumA = $654f9c48372e7f5e$export$c852d90bf7403b62(foreground);
    var lumB = $654f9c48372e7f5e$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $654f9c48372e7f5e$export$c852d90bf7403b62(color) {
    color = $654f9c48372e7f5e$export$677b39864803984e(color);
    var rgb = color.type === 'hsl' ? $654f9c48372e7f5e$export$677b39864803984e($654f9c48372e7f5e$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map(function(val) {
        val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $654f9c48372e7f5e$export$e665714f76e581fd(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
    return $654f9c48372e7f5e$export$c852d90bf7403b62(color) > 0.5 ? $654f9c48372e7f5e$export$4b073707ff63303(color, coefficient) : $654f9c48372e7f5e$export$c0816ed86df316af(color, coefficient);
}
var $654f9c48372e7f5e$var$warnedOnce = false;
function $654f9c48372e7f5e$export$cbea29d068a2e18f(color, value) {
    return $654f9c48372e7f5e$export$58f0f39f63f3cf42(color, value);
}
function $654f9c48372e7f5e$export$58f0f39f63f3cf42(color, value) {
    color = $654f9c48372e7f5e$export$677b39864803984e(color);
    value = $654f9c48372e7f5e$var$clamp(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    color.values[3] = value;
    return $654f9c48372e7f5e$export$211a73f2b8c10ce4(color);
}
function $654f9c48372e7f5e$export$4b073707ff63303(color, coefficient) {
    color = $654f9c48372e7f5e$export$677b39864803984e(color);
    coefficient = $654f9c48372e7f5e$var$clamp(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(var i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $654f9c48372e7f5e$export$211a73f2b8c10ce4(color);
}
function $654f9c48372e7f5e$export$c0816ed86df316af(color, coefficient) {
    color = $654f9c48372e7f5e$export$677b39864803984e(color);
    coefficient = $654f9c48372e7f5e$var$clamp(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(var i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    return $654f9c48372e7f5e$export$211a73f2b8c10ce4(color);
}

});


parcelRegister("bmWAH", function(module, exports) {

$parcel$export(module.exports, "default", () => $846f32badf9b5570$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $dbHGl = parcelRequire("dbHGl");
function $846f32badf9b5570$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
var $846f32badf9b5570$var$warnedOnce = false;
function $846f32badf9b5570$var$roundWithDeprecationWarning(value) {
    return $846f32badf9b5570$var$round(value);
}
var $846f32badf9b5570$var$caseAllCaps = {
    textTransform: 'uppercase'
};
var $846f32badf9b5570$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $846f32badf9b5570$export$2e2bcd8739ae039(palette, typography) {
    var _ref = typeof typography === 'function' ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? $846f32badf9b5570$var$defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0, $67mp8.default)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    var coef = fontSize / 14;
    var pxToRem = pxToRem2 || function(size) {
        return "".concat(size / htmlFontSize * coef, "rem");
    };
    var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
        return (0, $elnlQ.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight: lineHeight
        }, fontFamily === $846f32badf9b5570$var$defaultFontFamily ? {
            letterSpacing: "".concat($846f32badf9b5570$var$round(letterSpacing / size), "em")
        } : {}, casing, allVariants);
    };
    var variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $846f32badf9b5570$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $846f32badf9b5570$var$caseAllCaps)
    };
    return (0, $dbHGl.default)((0, $elnlQ.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        round: $846f32badf9b5570$var$roundWithDeprecationWarning,
        // TODO v5: remove
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("iMppy", function(module, exports) {

$parcel$export(module.exports, "default", () => $dac06bd7661c869f$export$2e2bcd8739ae039);
var $dac06bd7661c869f$var$shadowKeyUmbraOpacity = 0.2;
var $dac06bd7661c869f$var$shadowKeyPenumbraOpacity = 0.14;
var $dac06bd7661c869f$var$shadowAmbientShadowOpacity = 0.12;
function $dac06bd7661c869f$var$createShadow() {
    return [
        "".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat($dac06bd7661c869f$var$shadowKeyUmbraOpacity, ")"),
        "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat($dac06bd7661c869f$var$shadowKeyPenumbraOpacity, ")"),
        "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat($dac06bd7661c869f$var$shadowAmbientShadowOpacity, ")")
    ].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var $dac06bd7661c869f$var$shadows = [
    'none',
    $dac06bd7661c869f$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $dac06bd7661c869f$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $dac06bd7661c869f$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $dac06bd7661c869f$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $dac06bd7661c869f$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $dac06bd7661c869f$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $dac06bd7661c869f$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $dac06bd7661c869f$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $dac06bd7661c869f$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $dac06bd7661c869f$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $dac06bd7661c869f$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $dac06bd7661c869f$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $dac06bd7661c869f$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $dac06bd7661c869f$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $dac06bd7661c869f$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $dac06bd7661c869f$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $dac06bd7661c869f$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $dac06bd7661c869f$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $dac06bd7661c869f$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $dac06bd7661c869f$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $dac06bd7661c869f$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $dac06bd7661c869f$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $dac06bd7661c869f$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $dac06bd7661c869f$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $dac06bd7661c869f$export$2e2bcd8739ae039 = $dac06bd7661c869f$var$shadows;

});

parcelRegister("h14Q2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c636486e39edea9b$export$2e2bcd8739ae039);
var $c636486e39edea9b$var$shape = {
    borderRadius: 4
};
var $c636486e39edea9b$export$2e2bcd8739ae039 = $c636486e39edea9b$var$shape;

});

parcelRegister("ad7QU", function(module, exports) {

$parcel$export(module.exports, "default", () => $76f135960839b15d$export$2e2bcd8739ae039);

var $56mxq = parcelRequire("56mxq");
var $76f135960839b15d$var$warnOnce;
function $76f135960839b15d$export$2e2bcd8739ae039() {
    var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
    // Smaller components, such as icons and type, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    var transform = (0, $56mxq.createUnarySpacing)({
        spacing: spacingInput
    });
    var spacing = function spacing() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 0) return transform(1);
        if (args.length === 1) return transform(args[0]);
        return args.map(function(argument) {
            if (typeof argument === 'string') return argument;
            var output = transform(argument);
            return typeof output === 'number' ? "".concat(output, "px") : output;
        }).join(' ');
    }; // Backward compatibility, to remove in v5.
    Object.defineProperty(spacing, 'unit', {
        get: function get() {
            return spacingInput;
        }
    });
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("56mxq", function(module, exports) {

$parcel$export(module.exports, "createUnarySpacing", () => $3b6efedf41da2119$export$1def6f833384e3d1);
$parcel$export(module.exports, "default", () => $3b6efedf41da2119$export$2e2bcd8739ae039);

var $8YHhK = parcelRequire("8YHhK");


var $6QKVZ = parcelRequire("6QKVZ");

var $fb3vv = parcelRequire("fb3vv");

var $2Mrdt = parcelRequire("2Mrdt");
var $3b6efedf41da2119$var$properties = {
    m: 'margin',
    p: 'padding'
};
var $3b6efedf41da2119$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
var $3b6efedf41da2119$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
var $3b6efedf41da2119$var$getCssProperties = (0, $2Mrdt.default)(function(prop) {
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($3b6efedf41da2119$var$aliases[prop]) prop = $3b6efedf41da2119$var$aliases[prop];
        else return [
            prop
        ];
    }
    var _prop$split = prop.split(''), _prop$split2 = (0, $8YHhK.default)(_prop$split, 2), a = _prop$split2[0], b = _prop$split2[1];
    var property = $3b6efedf41da2119$var$properties[a];
    var direction = $3b6efedf41da2119$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map(function(dir) {
        return property + dir;
    }) : [
        property + direction
    ];
});
var $3b6efedf41da2119$var$spacingKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY'
];
function $3b6efedf41da2119$export$1def6f833384e3d1(theme) {
    var themeSpacing = theme.spacing || 8;
    if (typeof themeSpacing === 'number') return function(abs) {
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return function(abs) {
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return function() {
        return undefined;
    };
}
function $3b6efedf41da2119$var$getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    var abs = Math.abs(propValue);
    var transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return "-".concat(transformed);
}
function $3b6efedf41da2119$var$getStyleFromPropValue(cssProperties, transformer) {
    return function(propValue) {
        return cssProperties.reduce(function(acc, cssProperty) {
            acc[cssProperty] = $3b6efedf41da2119$var$getValue(transformer, propValue);
            return acc;
        }, {});
    };
}
function $3b6efedf41da2119$var$spacing(props) {
    var theme = props.theme;
    var transformer = $3b6efedf41da2119$export$1def6f833384e3d1(theme);
    return Object.keys(props).map(function(prop) {
        // Using a hash computation over an array iteration could be faster, but with only 28 items,
        // it's doesn't worth the bundle size.
        if ($3b6efedf41da2119$var$spacingKeys.indexOf(prop) === -1) return null;
        var cssProperties = $3b6efedf41da2119$var$getCssProperties(prop);
        var styleFromPropValue = $3b6efedf41da2119$var$getStyleFromPropValue(cssProperties, transformer);
        var propValue = props[prop];
        return (0, $6QKVZ.handleBreakpoints)(props, propValue, styleFromPropValue);
    }).reduce((0, $fb3vv.default), {});
}
$3b6efedf41da2119$var$spacing.propTypes = {};
$3b6efedf41da2119$var$spacing.filterProps = $3b6efedf41da2119$var$spacingKeys;
var $3b6efedf41da2119$export$2e2bcd8739ae039 = $3b6efedf41da2119$var$spacing;

});
parcelRegister("8YHhK", function(module, exports) {

$parcel$export(module.exports, "default", () => $689580e2f9f73e0c$export$2e2bcd8739ae039);

var $9tJ2C = parcelRequire("9tJ2C");

var $1Q460 = parcelRequire("1Q460");

var $graxV = parcelRequire("graxV");

var $86nLB = parcelRequire("86nLB");
function $689580e2f9f73e0c$export$2e2bcd8739ae039(r, e) {
    return (0, $9tJ2C.default)(r) || (0, $1Q460.default)(r, e) || (0, $graxV.default)(r, e) || (0, $86nLB.default)();
}

});
parcelRegister("9tJ2C", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e69c2bff8cdcccd$export$2e2bcd8739ae039);
function $6e69c2bff8cdcccd$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("1Q460", function(module, exports) {

$parcel$export(module.exports, "default", () => $156dd326f1a6e607$export$2e2bcd8739ae039);
function $156dd326f1a6e607$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("86nLB", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e6151d57a2a77fe$export$2e2bcd8739ae039);
function $5e6151d57a2a77fe$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("6QKVZ", function(module, exports) {

$parcel$export(module.exports, "handleBreakpoints", () => $4fcc0192ab754ad1$export$88347efdb2e19abd);

var $83MhR = parcelRequire("83MhR");

var $elnlQ = parcelRequire("elnlQ");

var $69Iz3 = parcelRequire("69Iz3");


var $fb3vv = parcelRequire("fb3vv");
// For instance with the first breakpoint xs: [xs, sm[.
var $4fcc0192ab754ad1$var$values = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
};
var $4fcc0192ab754ad1$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: function up(key) {
        return "@media (min-width:".concat($4fcc0192ab754ad1$var$values[key], "px)");
    }
};
function $4fcc0192ab754ad1$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    if (Array.isArray(propValue)) {
        var themeBreakpoints = props.theme.breakpoints || $4fcc0192ab754ad1$var$defaultBreakpoints;
        return propValue.reduce(function(acc, item, index) {
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if ((0, $69Iz3.default)(propValue) === 'object') {
        var _themeBreakpoints = props.theme.breakpoints || $4fcc0192ab754ad1$var$defaultBreakpoints;
        return Object.keys(propValue).reduce(function(acc, breakpoint) {
            acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
            return acc;
        }, {});
    }
    var output = styleFromPropValue(propValue);
    return output;
}
function $4fcc0192ab754ad1$var$breakpoints(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var base = styleFunction(props);
        var themeBreakpoints = props.theme.breakpoints || $4fcc0192ab754ad1$var$defaultBreakpoints;
        var extended = themeBreakpoints.keys.reduce(function(acc, key) {
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $elnlQ.default)({
                    theme: props.theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $fb3vv.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ].concat((0, $83MhR.default)(styleFunction.filterProps));
    return newStyleFunction;
}
var $4fcc0192ab754ad1$export$2e2bcd8739ae039 = $4fcc0192ab754ad1$var$breakpoints;

});
parcelRegister("fb3vv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ca9a9161e93497$export$2e2bcd8739ae039);

var $dbHGl = parcelRequire("dbHGl");
function $b0ca9a9161e93497$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $dbHGl.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $b0ca9a9161e93497$export$2e2bcd8739ae039 = $b0ca9a9161e93497$var$merge;

});


parcelRegister("2Mrdt", function(module, exports) {

$parcel$export(module.exports, "default", () => $20652d159e977e92$export$2e2bcd8739ae039);
function $20652d159e977e92$export$2e2bcd8739ae039(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("6N3by", function(module, exports) {

$parcel$export(module.exports, "duration", () => $4f19ca3f40e99582$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "default", () => $4f19ca3f40e99582$export$2e2bcd8739ae039);

var $67mp8 = parcelRequire("67mp8");
var $4f19ca3f40e99582$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
var $4f19ca3f40e99582$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $4f19ca3f40e99582$var$formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
var /**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */ $4f19ca3f40e99582$export$2e2bcd8739ae039 = {
    easing: $4f19ca3f40e99582$export$24c5ac7c37452e7d,
    duration: $4f19ca3f40e99582$export$1f34108aa9eb96ab,
    create: function create() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            'all'
        ];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$duration = options.duration, durationOption = _options$duration === void 0 ? $4f19ca3f40e99582$export$1f34108aa9eb96ab.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? $4f19ca3f40e99582$export$24c5ac7c37452e7d.easeInOut : _options$easing, _options$delay = options.delay, delay = _options$delay === void 0 ? 0 : _options$delay, other = (0, $67mp8.default)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        var isString, isNumber;
        return (Array.isArray(props) ? props : [
            props
        ]).map(function(animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : $4f19ca3f40e99582$var$formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : $4f19ca3f40e99582$var$formatMs(delay));
        }).join(',');
    },
    getAutoHeightDuration: function getAutoHeightDuration(height) {
        if (!height) return 0;
        var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
    }
};

});

parcelRegister("o4akA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0485793697337d87$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var $0485793697337d87$var$zIndex = {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $0485793697337d87$export$2e2bcd8739ae039 = $0485793697337d87$var$zIndex;

});




parcelRegister("bT5dp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a78e063ead6f02c$export$2e2bcd8739ae039);

var $3Oo4t = parcelRequire("3Oo4t");
function $8a78e063ead6f02c$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $3Oo4t.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});




parcelRegister("djSQb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("e3Eh1")).default);

var $e3Eh1 = parcelRequire("e3Eh1");

});
parcelRegister("e3Eh1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3c095fbaa7e7ec9$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $a3c095fbaa7e7ec9$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});


parcelRegister("j7L58", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("g3NvN")).default);

var $g3NvN = parcelRequire("g3NvN");

});
parcelRegister("g3NvN", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb13552fa998f560$export$2e2bcd8739ae039);
function $bb13552fa998f560$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $bb13552fa998f560$export$2e2bcd8739ae039 = $bb13552fa998f560$var$clamp;

});


parcelRegister("edCRM", function(module, exports) {
function $a5a06da03fd3ca6b$var$_extends() {
    return module.exports = $a5a06da03fd3ca6b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a5a06da03fd3ca6b$var$_extends.apply(null, arguments);
}
module.exports = $a5a06da03fd3ca6b$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1Z1cO", function(module, exports) {
function $171c6c5aa45b5547$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $171c6c5aa45b5547$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8wjNP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6340ac48cea81ee7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_processStyles", () => $6340ac48cea81ee7$export$e00380445f2b9e0c);
$parcel$export(module.exports, "internal_serializeStyles", () => $6340ac48cea81ee7$export$13a2d3ef13012b32);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("aAHV6")).T);
$parcel$export(module.exports, "keyframes", () => (parcelRequire("euOyk")).keyframes);
$parcel$export(module.exports, "css", () => (parcelRequire("euOyk")).css);
$parcel$export(module.exports, "StyledEngineProvider", () => (parcelRequire("6ist2")).default);
$parcel$export(module.exports, "GlobalStyles", () => (parcelRequire("4kjTM")).default);
/**
 * @mui/styled-engine v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $8FVu0 = parcelRequire("8FVu0");

var $kl99S = parcelRequire("kl99S");

var $euOyk = parcelRequire("euOyk");
var $aAHV6 = parcelRequire("aAHV6");

var $6ist2 = parcelRequire("6ist2");

var $4kjTM = parcelRequire("4kjTM");
'use client';
function $6340ac48cea81ee7$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $8FVu0.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $6340ac48cea81ee7$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};
// Emotion only accepts an array, but we want to avoid allocations
const $6340ac48cea81ee7$var$wrapper = [];
function $6340ac48cea81ee7$export$13a2d3ef13012b32(styles) {
    $6340ac48cea81ee7$var$wrapper[0] = styles;
    return (0, $kl99S.serializeStyles)($6340ac48cea81ee7$var$wrapper);
}

});
parcelRegister("8FVu0", function(module, exports) {

$parcel$export(module.exports, "default", () => $650ebdfcbff994b4$export$2e2bcd8739ae039);

var $feXR3 = parcelRequire("feXR3");
parcelRequire("edCRM");

parcelRequire("kl99S");
parcelRequire("4TV24");
parcelRequire("hVlia");
parcelRequire("Fo7oF");
parcelRequire("cBngt");
var $650ebdfcbff994b4$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $650ebdfcbff994b4$export$2e2bcd8739ae039 = (0, $feXR3.default).bind(null);
$650ebdfcbff994b4$var$tags.forEach(function(tagName) {
    $650ebdfcbff994b4$export$2e2bcd8739ae039[tagName] = $650ebdfcbff994b4$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("feXR3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b18697bd5580384a$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");
parcelRequire("euOyk");
var $aAHV6 = parcelRequire("aAHV6");

var $kl99S = parcelRequire("kl99S");

var $4TV24 = parcelRequire("4TV24");

var $hVlia = parcelRequire("hVlia");

var $Fo7oF = parcelRequire("Fo7oF");

var $cBngt = parcelRequire("cBngt");
var $b18697bd5580384a$var$isBrowser = typeof document !== 'undefined';
var $b18697bd5580384a$var$isDevelopment = false;
var $b18697bd5580384a$var$testOmitPropsOnStringTag = (0, $cBngt.default);
var $b18697bd5580384a$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $b18697bd5580384a$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $b18697bd5580384a$var$testOmitPropsOnStringTag : $b18697bd5580384a$var$testOmitPropsOnComponent;
};
var $b18697bd5580384a$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $b18697bd5580384a$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $hVlia.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $4TV24.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $hVlia.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$b18697bd5580384a$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $Fo7oF.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $b18697bd5580384a$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $b18697bd5580384a$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $b18697bd5580384a$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $aAHV6.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $Fo7oF.useContext((0, $aAHV6.T));
            }
            if (typeof props.className === 'string') className = (0, $hVlia.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $kl99S.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $b18697bd5580384a$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $Fo7oF.createElement($Fo7oF.Fragment, null, /*#__PURE__*/ $Fo7oF.createElement($b18697bd5580384a$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $Fo7oF.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $b18697bd5580384a$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $elnlQ.default)({}, options, nextOptions, {
                shouldForwardProp: $b18697bd5580384a$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("euOyk", function(module, exports) {

$parcel$export(module.exports, "Global", () => $a8db14b8ce0aff4b$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $a8db14b8ce0aff4b$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $a8db14b8ce0aff4b$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("aAHV6")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("aAHV6")).w);

var $aAHV6 = parcelRequire("aAHV6");

var $Fo7oF = parcelRequire("Fo7oF");

var $hVlia = parcelRequire("hVlia");

var $4TV24 = parcelRequire("4TV24");

var $kl99S = parcelRequire("kl99S");
parcelRequire("htUC7");
parcelRequire("edCRM");
parcelRequire("20pPH");

parcelRequire("1xoRX");
var $a8db14b8ce0aff4b$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $aAHV6.h).call(props, 'css')) return $Fo7oF.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $aAHV6.E);
    createElementArgArray[1] = (0, $aAHV6.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $Fo7oF.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($a8db14b8ce0aff4b$export$c8a8987d4410bf2d || ($a8db14b8ce0aff4b$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $a8db14b8ce0aff4b$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $aAHV6.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $kl99S.serializeStyles)([
        styles
    ], undefined, $Fo7oF.useContext((0, $aAHV6.T)));
    if (!(0, $aAHV6.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $Fo7oF.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $Fo7oF.useRef();
    (0, $4TV24.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $4TV24.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $hVlia.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $a8db14b8ce0aff4b$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $kl99S.serializeStyles)(args);
}
function $a8db14b8ce0aff4b$export$d25ddfdf17c3ad3e() {
    var insertable = $a8db14b8ce0aff4b$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $a8db14b8ce0aff4b$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $a8db14b8ce0aff4b$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $hVlia.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $a8db14b8ce0aff4b$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $4TV24.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $hVlia.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $aAHV6.i) && res !== undefined) rules += res;
        }
        if (!(0, $aAHV6.i)) return rules;
    });
    if (!(0, $aAHV6.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $Fo7oF.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $a8db14b8ce0aff4b$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $aAHV6.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $aAHV6.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $kl99S.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $hVlia.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $aAHV6.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $a8db14b8ce0aff4b$var$merge(cache.registered, css, $a8db14b8ce0aff4b$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $Fo7oF.useContext((0, $aAHV6.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $Fo7oF.createElement($Fo7oF.Fragment, null, /*#__PURE__*/ $Fo7oF.createElement($a8db14b8ce0aff4b$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("aAHV6", function(module, exports) {

$parcel$export(module.exports, "a", () => $7b5f55c29e7a7fd3$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $7b5f55c29e7a7fd3$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $7b5f55c29e7a7fd3$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $7b5f55c29e7a7fd3$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $7b5f55c29e7a7fd3$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $7b5f55c29e7a7fd3$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $7b5f55c29e7a7fd3$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $7b5f55c29e7a7fd3$export$a9c23c6ac3fc3eca);

var $Fo7oF = parcelRequire("Fo7oF");

var $htUC7 = parcelRequire("htUC7");

var $elnlQ = parcelRequire("elnlQ");

var $20pPH = parcelRequire("20pPH");

var $3ReAr = parcelRequire("3ReAr");

var $hVlia = parcelRequire("hVlia");

var $kl99S = parcelRequire("kl99S");

var $4TV24 = parcelRequire("4TV24");
var $7b5f55c29e7a7fd3$export$407448d2b89b1813 = false;
var $7b5f55c29e7a7fd3$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $7b5f55c29e7a7fd3$var$EmotionCacheContext = /* #__PURE__ */ $Fo7oF.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $htUC7.default)({
    key: 'css'
}) : null);
var $7b5f55c29e7a7fd3$export$e7094788287c5e9b = $7b5f55c29e7a7fd3$var$EmotionCacheContext.Provider;
var $7b5f55c29e7a7fd3$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $Fo7oF.useContext)($7b5f55c29e7a7fd3$var$EmotionCacheContext);
};
var $7b5f55c29e7a7fd3$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $Fo7oF.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $Fo7oF.useContext)($7b5f55c29e7a7fd3$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$7b5f55c29e7a7fd3$export$23f2a1d2818174ef) $7b5f55c29e7a7fd3$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $Fo7oF.useContext)($7b5f55c29e7a7fd3$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $htUC7.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $Fo7oF.createElement($7b5f55c29e7a7fd3$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $7b5f55c29e7a7fd3$export$971d5caa766a69d7 = /* #__PURE__ */ $Fo7oF.createContext({});
var $7b5f55c29e7a7fd3$export$3b14a55fb2447963 = function useTheme() {
    return $Fo7oF.useContext($7b5f55c29e7a7fd3$export$971d5caa766a69d7);
};
var $7b5f55c29e7a7fd3$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $elnlQ.default)({}, outerTheme, theme);
};
var $7b5f55c29e7a7fd3$var$createCacheWithTheme = /* #__PURE__ */ (0, $20pPH.default)(function(outerTheme) {
    return (0, $20pPH.default)(function(theme) {
        return $7b5f55c29e7a7fd3$var$getTheme(outerTheme, theme);
    });
});
var $7b5f55c29e7a7fd3$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $Fo7oF.useContext($7b5f55c29e7a7fd3$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $7b5f55c29e7a7fd3$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $Fo7oF.createElement($7b5f55c29e7a7fd3$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $7b5f55c29e7a7fd3$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $Fo7oF.forwardRef(function render(props, ref) {
        var theme = $Fo7oF.useContext($7b5f55c29e7a7fd3$export$971d5caa766a69d7);
        return /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $3ReAr.default)(WithTheme, Component);
}
var $7b5f55c29e7a7fd3$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $7b5f55c29e7a7fd3$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $7b5f55c29e7a7fd3$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($7b5f55c29e7a7fd3$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$7b5f55c29e7a7fd3$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $7b5f55c29e7a7fd3$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $hVlia.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $4TV24.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $hVlia.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$7b5f55c29e7a7fd3$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $Fo7oF.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $7b5f55c29e7a7fd3$var$Emotion = /* #__PURE__ */ $7b5f55c29e7a7fd3$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$7b5f55c29e7a7fd3$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $hVlia.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $kl99S.serializeStyles)(registeredStyles, undefined, $Fo7oF.useContext($7b5f55c29e7a7fd3$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($7b5f55c29e7a7fd3$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $7b5f55c29e7a7fd3$var$typePropName && !$7b5f55c29e7a7fd3$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $Fo7oF.createElement($Fo7oF.Fragment, null, /*#__PURE__*/ $Fo7oF.createElement($7b5f55c29e7a7fd3$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $Fo7oF.createElement(WrappedComponent, newProps));
});
var $7b5f55c29e7a7fd3$export$a9c23c6ac3fc3eca = $7b5f55c29e7a7fd3$var$Emotion;

});
parcelRegister("htUC7", function(module, exports) {

$parcel$export(module.exports, "default", () => $cba10f7013b71f24$export$2e2bcd8739ae039);

var $bjKQW = parcelRequire("bjKQW");

var $c2evV = parcelRequire("c2evV");

var $20pPH = parcelRequire("20pPH");

var $esBaA = parcelRequire("esBaA");
var $cba10f7013b71f24$var$isBrowser = typeof document !== 'undefined';
var $cba10f7013b71f24$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $c2evV.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $c2evV.token)(character)) break;
        (0, $c2evV.next)();
    }
    return (0, $c2evV.slice)(begin, (0, $c2evV.position));
};
var $cba10f7013b71f24$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $c2evV.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $c2evV.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $cba10f7013b71f24$var$identifierWithPointTracking((0, $c2evV.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $c2evV.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $c2evV.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $c2evV.from)(character);
    }
    while (character = (0, $c2evV.next)());
    return parsed;
};
var $cba10f7013b71f24$var$getRules = function getRules(value, points) {
    return (0, $c2evV.dealloc)($cba10f7013b71f24$var$toRules((0, $c2evV.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $cba10f7013b71f24$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $cba10f7013b71f24$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$cba10f7013b71f24$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $cba10f7013b71f24$var$fixedElements.set(element, true);
    var points = [];
    var rules = $cba10f7013b71f24$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $cba10f7013b71f24$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $cba10f7013b71f24$var$prefix(value, length) {
    switch((0, $c2evV.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $c2evV.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $c2evV.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $c2evV.WEBKIT) + value + (0, $c2evV.MOZ) + value + (0, $c2evV.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $c2evV.WEBKIT) + value + (0, $c2evV.MS) + value + value;
        // order
        case 6165:
            return (0, $c2evV.WEBKIT) + value + (0, $c2evV.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $c2evV.WEBKIT) + value + (0, $c2evV.replace)(value, /(\w+).+(:[^]+)/, (0, $c2evV.WEBKIT) + 'box-$1$2' + (0, $c2evV.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $c2evV.WEBKIT) + value + (0, $c2evV.MS) + 'flex-item-' + (0, $c2evV.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $c2evV.WEBKIT) + value + (0, $c2evV.MS) + 'flex-line-pack' + (0, $c2evV.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $c2evV.WEBKIT) + value + (0, $c2evV.MS) + (0, $c2evV.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $c2evV.WEBKIT) + value + (0, $c2evV.MS) + (0, $c2evV.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $c2evV.WEBKIT) + 'box-' + (0, $c2evV.replace)(value, '-grow', '') + (0, $c2evV.WEBKIT) + value + (0, $c2evV.MS) + (0, $c2evV.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $c2evV.WEBKIT) + (0, $c2evV.replace)(value, /([^-])(transform)/g, '$1' + (0, $c2evV.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $c2evV.replace)((0, $c2evV.replace)((0, $c2evV.replace)(value, /(zoom-|grab)/, (0, $c2evV.WEBKIT) + '$1'), /(image-set)/, (0, $c2evV.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $c2evV.replace)(value, /(image-set\([^]*)/, (0, $c2evV.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $c2evV.replace)((0, $c2evV.replace)(value, /(.+:)(flex-)?(.*)/, (0, $c2evV.WEBKIT) + 'box-pack:$3' + (0, $c2evV.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $c2evV.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $c2evV.replace)(value, /(.+)-inline(.+)/, (0, $c2evV.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $c2evV.strlen)(value) - 1 - length > 6) switch((0, $c2evV.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $c2evV.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $c2evV.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $c2evV.WEBKIT) + '$2-$3' + '$1' + (0, $c2evV.MOZ) + ((0, $c2evV.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $c2evV.indexof)(value, 'stretch') ? $cba10f7013b71f24$var$prefix((0, $c2evV.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $c2evV.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $c2evV.charat)(value, (0, $c2evV.strlen)(value) - 3 - (~(0, $c2evV.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $c2evV.replace)(value, ':', ':' + (0, $c2evV.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $c2evV.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $c2evV.WEBKIT) + ((0, $c2evV.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $c2evV.WEBKIT) + '$2$3' + '$1' + (0, $c2evV.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $c2evV.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $c2evV.WEBKIT) + value + (0, $c2evV.MS) + (0, $c2evV.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $c2evV.WEBKIT) + value + (0, $c2evV.MS) + (0, $c2evV.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $c2evV.WEBKIT) + value + (0, $c2evV.MS) + (0, $c2evV.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $c2evV.WEBKIT) + value + (0, $c2evV.MS) + value + value;
    }
    return value;
}
var $cba10f7013b71f24$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $c2evV.DECLARATION:
                element["return"] = $cba10f7013b71f24$var$prefix(element.value, element.length);
                break;
            case 0, $c2evV.KEYFRAMES:
                return (0, $c2evV.serialize)([
                    (0, $c2evV.copy)(element, {
                        value: (0, $c2evV.replace)(element.value, '@', '@' + (0, $c2evV.WEBKIT))
                    })
                ], callback);
            case 0, $c2evV.RULESET:
                if (element.length) return (0, $c2evV.combine)(element.props, function(value) {
                    switch((0, $c2evV.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $c2evV.serialize)([
                                (0, $c2evV.copy)(element, {
                                    props: [
                                        (0, $c2evV.replace)(value, /:(read-\w+)/, ':' + (0, $c2evV.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $c2evV.serialize)([
                                (0, $c2evV.copy)(element, {
                                    props: [
                                        (0, $c2evV.replace)(value, /:(plac\w+)/, ':' + (0, $c2evV.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $c2evV.copy)(element, {
                                    props: [
                                        (0, $c2evV.replace)(value, /:(plac\w+)/, ':' + (0, $c2evV.MOZ) + '$1')
                                    ]
                                }),
                                (0, $c2evV.copy)(element, {
                                    props: [
                                        (0, $c2evV.replace)(value, /:(plac\w+)/, (0, $c2evV.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $cba10f7013b71f24$var$getServerStylisCache = $cba10f7013b71f24$var$isBrowser ? undefined : (0, $20pPH.default)(function() {
    return (0, $esBaA.default)(function() {
        return {};
    });
});
var $cba10f7013b71f24$var$defaultStylisPlugins = [
    $cba10f7013b71f24$var$prefixer
];
var $cba10f7013b71f24$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($cba10f7013b71f24$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $cba10f7013b71f24$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($cba10f7013b71f24$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $cba10f7013b71f24$var$compat,
        $cba10f7013b71f24$var$removeLabel
    ];
    if (!$cba10f7013b71f24$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $c2evV.stringify),
            (0, $c2evV.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $c2evV.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $c2evV.serialize)((0, $c2evV.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $c2evV.stringify)
        ];
        var _serializer = (0, $c2evV.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $c2evV.serialize)((0, $c2evV.compile)(styles), _serializer);
        };
        var serverStylisCache = $cba10f7013b71f24$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $bjKQW.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("bjKQW", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $83d5d00d03d10f38$export$9d753cd7ae895cce);
var $83d5d00d03d10f38$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $83d5d00d03d10f38$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $83d5d00d03d10f38$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $83d5d00d03d10f38$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$83d5d00d03d10f38$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($83d5d00d03d10f38$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $83d5d00d03d10f38$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("c2evV", function(module, exports) {

$parcel$export(module.exports, "MS", () => $69b5aebc0a70ef7d$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $69b5aebc0a70ef7d$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $69b5aebc0a70ef7d$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $69b5aebc0a70ef7d$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $69b5aebc0a70ef7d$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $69b5aebc0a70ef7d$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $69b5aebc0a70ef7d$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $69b5aebc0a70ef7d$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $69b5aebc0a70ef7d$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $69b5aebc0a70ef7d$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $69b5aebc0a70ef7d$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $69b5aebc0a70ef7d$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $69b5aebc0a70ef7d$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $69b5aebc0a70ef7d$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $69b5aebc0a70ef7d$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $69b5aebc0a70ef7d$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $69b5aebc0a70ef7d$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $69b5aebc0a70ef7d$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $69b5aebc0a70ef7d$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $69b5aebc0a70ef7d$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $69b5aebc0a70ef7d$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $69b5aebc0a70ef7d$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $69b5aebc0a70ef7d$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $69b5aebc0a70ef7d$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $69b5aebc0a70ef7d$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $69b5aebc0a70ef7d$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $69b5aebc0a70ef7d$export$38bcb760f1d4871c);
var $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 = "-ms-";
var $69b5aebc0a70ef7d$export$2c0f367103c8d01c = "-moz-";
var $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 = "-webkit-";
var $69b5aebc0a70ef7d$export$a29989082612d0d9 = "comm";
var $69b5aebc0a70ef7d$export$aa3a2e812ca8570d = "rule";
var $69b5aebc0a70ef7d$export$527d108ccf083c2b = "decl";
var $69b5aebc0a70ef7d$export$d3d35020fa5b54f0 = "@page";
var $69b5aebc0a70ef7d$export$500415a86c544f73 = "@media";
var $69b5aebc0a70ef7d$export$a763edbf796b780a = "@import";
var $69b5aebc0a70ef7d$export$2790aeb8b4e5c826 = "@charset";
var $69b5aebc0a70ef7d$export$1cc683e23b84b133 = "@viewport";
var $69b5aebc0a70ef7d$export$9447a5efea57e862 = "@supports";
var $69b5aebc0a70ef7d$export$ef011b4e114b1fba = "@document";
var $69b5aebc0a70ef7d$export$6aad947bda0f3f46 = "@namespace";
var $69b5aebc0a70ef7d$export$b44a8529a35fcb60 = "@keyframes";
var $69b5aebc0a70ef7d$export$2c16de31893252e6 = "@font-face";
var $69b5aebc0a70ef7d$export$3d846dd52e150c6f = "@counter-style";
var $69b5aebc0a70ef7d$export$22314bfbb57653fe = "@font-feature-values";
var $69b5aebc0a70ef7d$export$d773506282b3cfe6 = "@layer";
var $69b5aebc0a70ef7d$export$2335f513bbd82c6d = Math.abs;
var $69b5aebc0a70ef7d$export$6788812c4e6611e6 = String.fromCharCode;
var $69b5aebc0a70ef7d$export$e6e34fd1f2686227 = Object.assign;
function $69b5aebc0a70ef7d$export$d6af199866bfb566(e, r) {
    return $69b5aebc0a70ef7d$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $69b5aebc0a70ef7d$export$a9db5e087081082d(e, 0)) << 2 ^ $69b5aebc0a70ef7d$export$a9db5e087081082d(e, 1)) << 2 ^ $69b5aebc0a70ef7d$export$a9db5e087081082d(e, 2)) << 2 ^ $69b5aebc0a70ef7d$export$a9db5e087081082d(e, 3) : 0;
}
function $69b5aebc0a70ef7d$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $69b5aebc0a70ef7d$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $69b5aebc0a70ef7d$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $69b5aebc0a70ef7d$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $69b5aebc0a70ef7d$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $69b5aebc0a70ef7d$export$36776f635604f274(e) {
    return e.length;
}
function $69b5aebc0a70ef7d$export$f9084667e487ed46(e) {
    return e.length;
}
function $69b5aebc0a70ef7d$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $69b5aebc0a70ef7d$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $69b5aebc0a70ef7d$export$53f1d5ea8de3d7c = 1;
var $69b5aebc0a70ef7d$export$4e0c71f277ca26b3 = 1;
var $69b5aebc0a70ef7d$export$f24224f1c91d8156 = 0;
var $69b5aebc0a70ef7d$export$5880b8b5730aff45 = 0;
var $69b5aebc0a70ef7d$export$c0306caf338ac095 = 0;
var $69b5aebc0a70ef7d$export$30a86d91af8ff6e6 = "";
function $69b5aebc0a70ef7d$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $69b5aebc0a70ef7d$export$53f1d5ea8de3d7c,
        column: $69b5aebc0a70ef7d$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $69b5aebc0a70ef7d$export$784d13d8ee351f07(e, r) {
    return $69b5aebc0a70ef7d$export$e6e34fd1f2686227($69b5aebc0a70ef7d$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $69b5aebc0a70ef7d$export$eba6f6f03b0a92e7() {
    return $69b5aebc0a70ef7d$export$c0306caf338ac095;
}
function $69b5aebc0a70ef7d$export$232faf9add678146() {
    $69b5aebc0a70ef7d$export$c0306caf338ac095 = $69b5aebc0a70ef7d$export$5880b8b5730aff45 > 0 ? $69b5aebc0a70ef7d$export$a9db5e087081082d($69b5aebc0a70ef7d$export$30a86d91af8ff6e6, --$69b5aebc0a70ef7d$export$5880b8b5730aff45) : 0;
    if ($69b5aebc0a70ef7d$export$4e0c71f277ca26b3--, $69b5aebc0a70ef7d$export$c0306caf338ac095 === 10) $69b5aebc0a70ef7d$export$4e0c71f277ca26b3 = 1, $69b5aebc0a70ef7d$export$53f1d5ea8de3d7c--;
    return $69b5aebc0a70ef7d$export$c0306caf338ac095;
}
function $69b5aebc0a70ef7d$export$48cfd1e771a65c4f() {
    $69b5aebc0a70ef7d$export$c0306caf338ac095 = $69b5aebc0a70ef7d$export$5880b8b5730aff45 < $69b5aebc0a70ef7d$export$f24224f1c91d8156 ? $69b5aebc0a70ef7d$export$a9db5e087081082d($69b5aebc0a70ef7d$export$30a86d91af8ff6e6, $69b5aebc0a70ef7d$export$5880b8b5730aff45++) : 0;
    if ($69b5aebc0a70ef7d$export$4e0c71f277ca26b3++, $69b5aebc0a70ef7d$export$c0306caf338ac095 === 10) $69b5aebc0a70ef7d$export$4e0c71f277ca26b3 = 1, $69b5aebc0a70ef7d$export$53f1d5ea8de3d7c++;
    return $69b5aebc0a70ef7d$export$c0306caf338ac095;
}
function $69b5aebc0a70ef7d$export$4d3fb11e950abb9e() {
    return $69b5aebc0a70ef7d$export$a9db5e087081082d($69b5aebc0a70ef7d$export$30a86d91af8ff6e6, $69b5aebc0a70ef7d$export$5880b8b5730aff45);
}
function $69b5aebc0a70ef7d$export$e88cb2efb12ae807() {
    return $69b5aebc0a70ef7d$export$5880b8b5730aff45;
}
function $69b5aebc0a70ef7d$export$58adb3bec8346d0f(e, r) {
    return $69b5aebc0a70ef7d$export$2f35ab04d2335697($69b5aebc0a70ef7d$export$30a86d91af8ff6e6, e, r);
}
function $69b5aebc0a70ef7d$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $69b5aebc0a70ef7d$export$2de70f21292aac9e(e) {
    return $69b5aebc0a70ef7d$export$53f1d5ea8de3d7c = $69b5aebc0a70ef7d$export$4e0c71f277ca26b3 = 1, $69b5aebc0a70ef7d$export$f24224f1c91d8156 = $69b5aebc0a70ef7d$export$36776f635604f274($69b5aebc0a70ef7d$export$30a86d91af8ff6e6 = e), $69b5aebc0a70ef7d$export$5880b8b5730aff45 = 0, [];
}
function $69b5aebc0a70ef7d$export$45918ac1574455b1(e) {
    return $69b5aebc0a70ef7d$export$30a86d91af8ff6e6 = "", e;
}
function $69b5aebc0a70ef7d$export$410ac95b9ec204b8(e) {
    return $69b5aebc0a70ef7d$export$87c2784dc9fc4ab($69b5aebc0a70ef7d$export$58adb3bec8346d0f($69b5aebc0a70ef7d$export$5880b8b5730aff45 - 1, $69b5aebc0a70ef7d$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $69b5aebc0a70ef7d$export$660b2ee2d4fb4eff(e) {
    return $69b5aebc0a70ef7d$export$45918ac1574455b1($69b5aebc0a70ef7d$export$5f8c09e3ae6f64e1($69b5aebc0a70ef7d$export$2de70f21292aac9e(e)));
}
function $69b5aebc0a70ef7d$export$7af1228ff777d175(e) {
    while($69b5aebc0a70ef7d$export$c0306caf338ac095 = $69b5aebc0a70ef7d$export$4d3fb11e950abb9e())if ($69b5aebc0a70ef7d$export$c0306caf338ac095 < 33) $69b5aebc0a70ef7d$export$48cfd1e771a65c4f();
    else break;
    return $69b5aebc0a70ef7d$export$9e1725a4cfeada27(e) > 2 || $69b5aebc0a70ef7d$export$9e1725a4cfeada27($69b5aebc0a70ef7d$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $69b5aebc0a70ef7d$export$5f8c09e3ae6f64e1(e) {
    while($69b5aebc0a70ef7d$export$48cfd1e771a65c4f())switch($69b5aebc0a70ef7d$export$9e1725a4cfeada27($69b5aebc0a70ef7d$export$c0306caf338ac095)){
        case 0:
            $69b5aebc0a70ef7d$export$10d8903dec122b9d($69b5aebc0a70ef7d$export$c2ab62c7bf24634($69b5aebc0a70ef7d$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $69b5aebc0a70ef7d$export$10d8903dec122b9d($69b5aebc0a70ef7d$export$410ac95b9ec204b8($69b5aebc0a70ef7d$export$c0306caf338ac095), e);
            break;
        default:
            $69b5aebc0a70ef7d$export$10d8903dec122b9d($69b5aebc0a70ef7d$export$6788812c4e6611e6($69b5aebc0a70ef7d$export$c0306caf338ac095), e);
    }
    return e;
}
function $69b5aebc0a70ef7d$export$955ba06d119e085e(e, r) {
    while(--r && $69b5aebc0a70ef7d$export$48cfd1e771a65c4f())if ($69b5aebc0a70ef7d$export$c0306caf338ac095 < 48 || $69b5aebc0a70ef7d$export$c0306caf338ac095 > 102 || $69b5aebc0a70ef7d$export$c0306caf338ac095 > 57 && $69b5aebc0a70ef7d$export$c0306caf338ac095 < 65 || $69b5aebc0a70ef7d$export$c0306caf338ac095 > 70 && $69b5aebc0a70ef7d$export$c0306caf338ac095 < 97) break;
    return $69b5aebc0a70ef7d$export$58adb3bec8346d0f(e, $69b5aebc0a70ef7d$export$e88cb2efb12ae807() + (r < 6 && $69b5aebc0a70ef7d$export$4d3fb11e950abb9e() == 32 && $69b5aebc0a70ef7d$export$48cfd1e771a65c4f() == 32));
}
function $69b5aebc0a70ef7d$export$c889f2fcc19dbf12(e) {
    while($69b5aebc0a70ef7d$export$48cfd1e771a65c4f())switch($69b5aebc0a70ef7d$export$c0306caf338ac095){
        case e:
            return $69b5aebc0a70ef7d$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $69b5aebc0a70ef7d$export$c889f2fcc19dbf12($69b5aebc0a70ef7d$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $69b5aebc0a70ef7d$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $69b5aebc0a70ef7d$export$48cfd1e771a65c4f();
            break;
    }
    return $69b5aebc0a70ef7d$export$5880b8b5730aff45;
}
function $69b5aebc0a70ef7d$export$4254d4e2b3745c4c(e, r) {
    while($69b5aebc0a70ef7d$export$48cfd1e771a65c4f())if (e + $69b5aebc0a70ef7d$export$c0306caf338ac095 === 57) break;
    else if (e + $69b5aebc0a70ef7d$export$c0306caf338ac095 === 84 && $69b5aebc0a70ef7d$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $69b5aebc0a70ef7d$export$58adb3bec8346d0f(r, $69b5aebc0a70ef7d$export$5880b8b5730aff45 - 1) + "*" + $69b5aebc0a70ef7d$export$6788812c4e6611e6(e === 47 ? e : $69b5aebc0a70ef7d$export$48cfd1e771a65c4f());
}
function $69b5aebc0a70ef7d$export$c2ab62c7bf24634(e) {
    while(!$69b5aebc0a70ef7d$export$9e1725a4cfeada27($69b5aebc0a70ef7d$export$4d3fb11e950abb9e()))$69b5aebc0a70ef7d$export$48cfd1e771a65c4f();
    return $69b5aebc0a70ef7d$export$58adb3bec8346d0f(e, $69b5aebc0a70ef7d$export$5880b8b5730aff45);
}
function $69b5aebc0a70ef7d$export$ef7acd7185315e22(e) {
    return $69b5aebc0a70ef7d$export$45918ac1574455b1($69b5aebc0a70ef7d$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $69b5aebc0a70ef7d$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $69b5aebc0a70ef7d$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $69b5aebc0a70ef7d$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $69b5aebc0a70ef7d$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($69b5aebc0a70ef7d$export$f8e21b1e77979a08(j += $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed($69b5aebc0a70ef7d$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $69b5aebc0a70ef7d$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $69b5aebc0a70ef7d$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $69b5aebc0a70ef7d$export$955ba06d119e085e($69b5aebc0a70ef7d$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($69b5aebc0a70ef7d$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $69b5aebc0a70ef7d$export$10d8903dec122b9d($69b5aebc0a70ef7d$export$4a34f930e789283c($69b5aebc0a70ef7d$export$4254d4e2b3745c4c($69b5aebc0a70ef7d$export$48cfd1e771a65c4f(), $69b5aebc0a70ef7d$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $69b5aebc0a70ef7d$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $69b5aebc0a70ef7d$export$36776f635604f274(j) - l) $69b5aebc0a70ef7d$export$10d8903dec122b9d(p > 32 ? $69b5aebc0a70ef7d$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $69b5aebc0a70ef7d$export$f8483753829ec8f3($69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $69b5aebc0a70ef7d$export$10d8903dec122b9d(y = $69b5aebc0a70ef7d$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $69b5aebc0a70ef7d$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $69b5aebc0a70ef7d$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $69b5aebc0a70ef7d$export$98e6a39c04603d36(e, y, y, n && $69b5aebc0a70ef7d$export$10d8903dec122b9d($69b5aebc0a70ef7d$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $69b5aebc0a70ef7d$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $69b5aebc0a70ef7d$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $69b5aebc0a70ef7d$export$232faf9add678146() == 125) continue;
            }
            switch(j += $69b5aebc0a70ef7d$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($69b5aebc0a70ef7d$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($69b5aebc0a70ef7d$export$4d3fb11e950abb9e() === 45) j += $69b5aebc0a70ef7d$export$410ac95b9ec204b8($69b5aebc0a70ef7d$export$48cfd1e771a65c4f());
                    v = $69b5aebc0a70ef7d$export$4d3fb11e950abb9e(), o = l = $69b5aebc0a70ef7d$export$36776f635604f274(g = j += $69b5aebc0a70ef7d$export$c2ab62c7bf24634($69b5aebc0a70ef7d$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $69b5aebc0a70ef7d$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $69b5aebc0a70ef7d$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $69b5aebc0a70ef7d$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $69b5aebc0a70ef7d$export$2f35ab04d2335697(e, v + 1, v = $69b5aebc0a70ef7d$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $69b5aebc0a70ef7d$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $69b5aebc0a70ef7d$export$35059013cd4a06db(e, r, a, s === 0 ? $69b5aebc0a70ef7d$export$aa3a2e812ca8570d : i, f, o, l);
}
function $69b5aebc0a70ef7d$export$4a34f930e789283c(e, r, a) {
    return $69b5aebc0a70ef7d$export$35059013cd4a06db(e, r, a, $69b5aebc0a70ef7d$export$a29989082612d0d9, $69b5aebc0a70ef7d$export$6788812c4e6611e6($69b5aebc0a70ef7d$export$eba6f6f03b0a92e7()), $69b5aebc0a70ef7d$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $69b5aebc0a70ef7d$export$f8483753829ec8f3(e, r, a, n) {
    return $69b5aebc0a70ef7d$export$35059013cd4a06db(e, r, a, $69b5aebc0a70ef7d$export$527d108ccf083c2b, $69b5aebc0a70ef7d$export$2f35ab04d2335697(e, 0, n), $69b5aebc0a70ef7d$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $69b5aebc0a70ef7d$export$82e9f45cca5ba907(n, c, s) {
    switch($69b5aebc0a70ef7d$export$d6af199866bfb566(n, c)){
        case 5103:
            return $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $69b5aebc0a70ef7d$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + n + $69b5aebc0a70ef7d$export$2c0f367103c8d01c + n + $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($69b5aebc0a70ef7d$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + n + $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + n + $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + n + $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + n + $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + n + $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + n + $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + "box-$1$2" + $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + n + $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + "flex-item-" + $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$69b5aebc0a70ef7d$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + "grid-row-" + $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + n + $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + "flex-line-pack" + $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + n + $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + n + $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + "box-" + $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, "-grow", "") + $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + n + $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed($69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed($69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed($69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + "box-pack:$3" + $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$69b5aebc0a70ef7d$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + "grid-column-align" + $69b5aebc0a70ef7d$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $69b5aebc0a70ef7d$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$69b5aebc0a70ef7d$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$69b5aebc0a70ef7d$export$f8e21b1e77979a08(s, "span") ? $69b5aebc0a70ef7d$export$4659b591c19bdf3d(s, /\d+/) : +$69b5aebc0a70ef7d$export$4659b591c19bdf3d(s, /\d+/) - +$69b5aebc0a70ef7d$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $69b5aebc0a70ef7d$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed($69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($69b5aebc0a70ef7d$export$36776f635604f274(n) - 1 - c > 6) switch($69b5aebc0a70ef7d$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($69b5aebc0a70ef7d$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $69b5aebc0a70ef7d$export$2c0f367103c8d01c + ($69b5aebc0a70ef7d$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$69b5aebc0a70ef7d$export$f8e21b1e77979a08(n, "stretch") ? $69b5aebc0a70ef7d$export$82e9f45cca5ba907($69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($69b5aebc0a70ef7d$export$a9db5e087081082d(n, c + 6) === 121) return $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, ":", ":" + $69b5aebc0a70ef7d$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($69b5aebc0a70ef7d$export$a9db5e087081082d(n, $69b5aebc0a70ef7d$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + ($69b5aebc0a70ef7d$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, ":", ":" + $69b5aebc0a70ef7d$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $69b5aebc0a70ef7d$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $69b5aebc0a70ef7d$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $69b5aebc0a70ef7d$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $69b5aebc0a70ef7d$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $69b5aebc0a70ef7d$export$a763edbf796b780a:
        case $69b5aebc0a70ef7d$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $69b5aebc0a70ef7d$export$a29989082612d0d9:
            return "";
        case $69b5aebc0a70ef7d$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $69b5aebc0a70ef7d$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $69b5aebc0a70ef7d$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $69b5aebc0a70ef7d$export$36776f635604f274(a = $69b5aebc0a70ef7d$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $69b5aebc0a70ef7d$export$5a7767152ae0305f(e) {
    var r = $69b5aebc0a70ef7d$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $69b5aebc0a70ef7d$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $69b5aebc0a70ef7d$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $69b5aebc0a70ef7d$export$527d108ccf083c2b:
                n.return = $69b5aebc0a70ef7d$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $69b5aebc0a70ef7d$export$b44a8529a35fcb60:
                return $69b5aebc0a70ef7d$export$dfdc1655ccc5b9cb([
                    $69b5aebc0a70ef7d$export$784d13d8ee351f07(n, {
                        value: $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $69b5aebc0a70ef7d$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $69b5aebc0a70ef7d$export$aa3a2e812ca8570d:
                if (n.length) return $69b5aebc0a70ef7d$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($69b5aebc0a70ef7d$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $69b5aebc0a70ef7d$export$dfdc1655ccc5b9cb([
                                $69b5aebc0a70ef7d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $69b5aebc0a70ef7d$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $69b5aebc0a70ef7d$export$dfdc1655ccc5b9cb([
                                $69b5aebc0a70ef7d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $69b5aebc0a70ef7d$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $69b5aebc0a70ef7d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $69b5aebc0a70ef7d$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $69b5aebc0a70ef7d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $69b5aebc0a70ef7d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $69b5aebc0a70ef7d$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $69b5aebc0a70ef7d$export$76a88f7de6507443(e) {
    switch(e.type){
        case $69b5aebc0a70ef7d$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $69b5aebc0a70ef7d$export$1be1fc439b849fdf($69b5aebc0a70ef7d$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($69b5aebc0a70ef7d$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $69b5aebc0a70ef7d$export$2f35ab04d2335697(r, 1, $69b5aebc0a70ef7d$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $69b5aebc0a70ef7d$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $69b5aebc0a70ef7d$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $69b5aebc0a70ef7d$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("20pPH", function(module, exports) {

$parcel$export(module.exports, "default", () => $175f9ec02e77683a$export$2e2bcd8739ae039);
var $175f9ec02e77683a$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("esBaA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a870835a905914ac$export$2e2bcd8739ae039);
function $a870835a905914ac$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("3ReAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf1a2f3c1b45fcd$export$2e2bcd8739ae039);

var $1xoRX = parcelRequire("1xoRX");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $2cf1a2f3c1b45fcd$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1xoRX)))(targetComponent, sourceComponent);
};

});

parcelRegister("hVlia", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $d0c846b46ad584cf$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $d0c846b46ad584cf$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $d0c846b46ad584cf$export$6f077d94b33a01aa);
var $d0c846b46ad584cf$var$isBrowser = typeof document !== 'undefined';
function $d0c846b46ad584cf$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $d0c846b46ad584cf$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $d0c846b46ad584cf$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $d0c846b46ad584cf$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $d0c846b46ad584cf$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$d0c846b46ad584cf$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$d0c846b46ad584cf$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("kl99S", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $ececdf72c0ee2c37$export$6321afa313b251b5);

var $g0ttT = parcelRequire("g0ttT");

var $1drlI = parcelRequire("1drlI");

var $esBaA = parcelRequire("esBaA");
var $ececdf72c0ee2c37$var$isDevelopment = false;
var $ececdf72c0ee2c37$var$hyphenateRegex = /[A-Z]|^ms/g;
var $ececdf72c0ee2c37$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $ececdf72c0ee2c37$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $ececdf72c0ee2c37$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $ececdf72c0ee2c37$var$processStyleName = /* #__PURE__ */ (0, $esBaA.default)(function(styleName) {
    return $ececdf72c0ee2c37$var$isCustomProperty(styleName) ? styleName : styleName.replace($ececdf72c0ee2c37$var$hyphenateRegex, '-$&').toLowerCase();
});
var $ececdf72c0ee2c37$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($ececdf72c0ee2c37$var$animationRegex, function(match, p1, p2) {
                $ececdf72c0ee2c37$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $ececdf72c0ee2c37$var$cursor
                };
                return p1;
            });
    }
    if ((0, $1drlI.default)[key] !== 1 && !$ececdf72c0ee2c37$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $ececdf72c0ee2c37$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $ececdf72c0ee2c37$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $ececdf72c0ee2c37$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $ececdf72c0ee2c37$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $ececdf72c0ee2c37$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $ececdf72c0ee2c37$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $ececdf72c0ee2c37$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $ececdf72c0ee2c37$var$cursor;
                var result = interpolation(mergedProps);
                $ececdf72c0ee2c37$var$cursor = previousCursor;
                return $ececdf72c0ee2c37$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $ececdf72c0ee2c37$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $ececdf72c0ee2c37$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($ececdf72c0ee2c37$var$isProcessableValue(asString)) string += $ececdf72c0ee2c37$var$processStyleName(key) + ":" + $ececdf72c0ee2c37$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $ececdf72c0ee2c37$var$isDevelopment) throw new Error($ececdf72c0ee2c37$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($ececdf72c0ee2c37$var$isProcessableValue(value[_i])) string += $ececdf72c0ee2c37$var$processStyleName(key) + ":" + $ececdf72c0ee2c37$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $ececdf72c0ee2c37$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $ececdf72c0ee2c37$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $ececdf72c0ee2c37$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $ececdf72c0ee2c37$var$cursor;
function $ececdf72c0ee2c37$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $ececdf72c0ee2c37$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $ececdf72c0ee2c37$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $ececdf72c0ee2c37$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $ececdf72c0ee2c37$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $ececdf72c0ee2c37$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $g0ttT.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $ececdf72c0ee2c37$var$cursor
    };
}

});
parcelRegister("g0ttT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba7383c0eb50c433$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $ba7383c0eb50c433$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("1drlI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e2c385571d0f596$export$2e2bcd8739ae039);
var $0e2c385571d0f596$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("4TV24", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $391889ea0f9f19c8$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $391889ea0f9f19c8$export$811a713a7276cb9d);

var $Fo7oF = parcelRequire("Fo7oF");
var $391889ea0f9f19c8$var$isBrowser = typeof document !== 'undefined';
var $391889ea0f9f19c8$var$syncFallback = function syncFallback(create) {
    return create();
};
var $391889ea0f9f19c8$var$useInsertionEffect = $Fo7oF.useInsertionEffect ? $Fo7oF.useInsertionEffect : false;
var $391889ea0f9f19c8$export$db21c7ffa21794e7 = !$391889ea0f9f19c8$var$isBrowser ? $391889ea0f9f19c8$var$syncFallback : $391889ea0f9f19c8$var$useInsertionEffect || $391889ea0f9f19c8$var$syncFallback;
var $391889ea0f9f19c8$export$811a713a7276cb9d = $391889ea0f9f19c8$var$useInsertionEffect || $Fo7oF.useLayoutEffect;

});



parcelRegister("cBngt", function(module, exports) {

$parcel$export(module.exports, "default", () => $92cafc9e37e6950a$export$2e2bcd8739ae039);

var $esBaA = parcelRequire("esBaA");
// eslint-disable-next-line no-undef
var $92cafc9e37e6950a$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $92cafc9e37e6950a$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $esBaA.default)(function(prop) {
    return $92cafc9e37e6950a$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("6ist2", function(module, exports) {

$parcel$export(module.exports, "default", () => $495a8188957ce360$export$2e2bcd8739ae039);

var $Fo7oF = parcelRequire("Fo7oF");


var $aAHV6 = parcelRequire("aAHV6");

var $htUC7 = parcelRequire("htUC7");

var $eFTP6 = parcelRequire("eFTP6");
'use client';
function $495a8188957ce360$var$getCache(injectFirst, enableCssLayer) {
    const emotionCache = (0, $htUC7.default)({
        key: 'css',
        prepend: injectFirst
    });
    if (enableCssLayer) {
        const prevInsert = emotionCache.insert;
        emotionCache.insert = (...args)=>{
            if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
            args[1].styles = `@layer mui {${args[1].styles}}`;
            return prevInsert(...args);
        };
    }
    return emotionCache;
}
const $495a8188957ce360$var$cacheMap = new Map();
function $495a8188957ce360$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $Fo7oF.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $495a8188957ce360$var$cacheMap.has(cacheKey)) return $495a8188957ce360$var$cacheMap.get(cacheKey);
        const fresh = $495a8188957ce360$var$getCache(injectFirst, enableCssLayer);
        $495a8188957ce360$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    if (injectFirst || enableCssLayer) return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $aAHV6.C), {
        value: cache,
        children: children
    });
    return children;
}

});
parcelRegister("eFTP6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("59RB5"));

});


parcelRegister("4kjTM", function(module, exports) {

$parcel$export(module.exports, "default", () => $32687722bf92cbfe$export$2e2bcd8739ae039);
parcelRequire("Fo7oF");


var $euOyk = parcelRequire("euOyk");

var $eFTP6 = parcelRequire("eFTP6");
'use client';
function $32687722bf92cbfe$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $32687722bf92cbfe$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($32687722bf92cbfe$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $euOyk.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("b7grI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("g00EB")).default);

var $g00EB = parcelRequire("g00EB");

});
parcelRegister("g00EB", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba5d2742c57bfdec$export$2e2bcd8739ae039);

var $e3Eh1 = parcelRequire("e3Eh1");
function $ba5d2742c57bfdec$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $e3Eh1.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("5tOGm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("9PaWw")).default);

var $9PaWw = parcelRequire("9PaWw");
$parcel$exportWildcard(module.exports, $9PaWw);

});
parcelRegister("9PaWw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", () => $72715d85eef2219c$export$aad197c7121a6651);
$parcel$export(module.exports, "default", () => $72715d85eef2219c$export$2e2bcd8739ae039);

var $jZvnc = parcelRequire("jZvnc");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $72715d85eef2219c$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $72715d85eef2219c$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($72715d85eef2219c$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $72715d85eef2219c$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $72715d85eef2219c$export$aad197c7121a6651(Component) || fallback;
}
function $72715d85eef2219c$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $72715d85eef2219c$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $72715d85eef2219c$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $72715d85eef2219c$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $jZvnc.ForwardRef:
            return $72715d85eef2219c$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $jZvnc.Memo:
            return $72715d85eef2219c$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("jZvnc", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gR708"));

});
parcelRegister("gR708", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $c45706e0b0b57ad5$export$a7c73072b1a182ae, (v) => $c45706e0b0b57ad5$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $c45706e0b0b57ad5$export$9f27bc3417b4524d, (v) => $c45706e0b0b57ad5$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $c45706e0b0b57ad5$export$db77ccec0bb4ccac, (v) => $c45706e0b0b57ad5$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $c45706e0b0b57ad5$export$8392c0c9d3dcbd35, (v) => $c45706e0b0b57ad5$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $c45706e0b0b57ad5$export$ffb0004e005737fa, (v) => $c45706e0b0b57ad5$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $c45706e0b0b57ad5$export$b624eff549462981, (v) => $c45706e0b0b57ad5$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $c45706e0b0b57ad5$export$7897aa7841a5380c, (v) => $c45706e0b0b57ad5$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $c45706e0b0b57ad5$export$602eac185826482c, (v) => $c45706e0b0b57ad5$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $c45706e0b0b57ad5$export$e2c29f18771995cb, (v) => $c45706e0b0b57ad5$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $c45706e0b0b57ad5$export$5f8d39834fd61797, (v) => $c45706e0b0b57ad5$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $c45706e0b0b57ad5$export$74bf444e3cd11ea5, (v) => $c45706e0b0b57ad5$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $c45706e0b0b57ad5$export$998bcd577473dd93, (v) => $c45706e0b0b57ad5$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $c45706e0b0b57ad5$export$b706b080d889d2c9, (v) => $c45706e0b0b57ad5$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $c45706e0b0b57ad5$export$5be5a87408f70ddc, (v) => $c45706e0b0b57ad5$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $c45706e0b0b57ad5$export$45a5e7f76e0caa8d, (v) => $c45706e0b0b57ad5$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $c45706e0b0b57ad5$export$455c2e768291efa6, (v) => $c45706e0b0b57ad5$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $c45706e0b0b57ad5$export$9522e17588c12572, (v) => $c45706e0b0b57ad5$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $c45706e0b0b57ad5$export$2110ac352bb060b9, (v) => $c45706e0b0b57ad5$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $c45706e0b0b57ad5$export$56885ab8b9c456ab, (v) => $c45706e0b0b57ad5$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $c45706e0b0b57ad5$export$d927fcb6adf8f9de, (v) => $c45706e0b0b57ad5$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $c45706e0b0b57ad5$export$b82d16f27459e05a, (v) => $c45706e0b0b57ad5$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $c45706e0b0b57ad5$export$522c17b4f5e123e8, (v) => $c45706e0b0b57ad5$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $c45706e0b0b57ad5$export$1aabd8a0274ecfd6, (v) => $c45706e0b0b57ad5$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $c45706e0b0b57ad5$export$3d6c20d97e46b957, (v) => $c45706e0b0b57ad5$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $c45706e0b0b57ad5$export$9b621391a187a31a, (v) => $c45706e0b0b57ad5$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $c45706e0b0b57ad5$export$f5bbd400c2f4426f, (v) => $c45706e0b0b57ad5$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c45706e0b0b57ad5$export$a7c73072b1a182ae;
var $c45706e0b0b57ad5$export$9f27bc3417b4524d;
var $c45706e0b0b57ad5$export$db77ccec0bb4ccac;
var $c45706e0b0b57ad5$export$8392c0c9d3dcbd35;
var $c45706e0b0b57ad5$export$ffb0004e005737fa;
var $c45706e0b0b57ad5$export$b624eff549462981;
var $c45706e0b0b57ad5$export$7897aa7841a5380c;
var $c45706e0b0b57ad5$export$602eac185826482c;
var $c45706e0b0b57ad5$export$e2c29f18771995cb;
var $c45706e0b0b57ad5$export$5f8d39834fd61797;
var $c45706e0b0b57ad5$export$74bf444e3cd11ea5;
var $c45706e0b0b57ad5$export$998bcd577473dd93;
var $c45706e0b0b57ad5$export$b706b080d889d2c9;
var $c45706e0b0b57ad5$export$5be5a87408f70ddc;
var $c45706e0b0b57ad5$export$45a5e7f76e0caa8d;
var $c45706e0b0b57ad5$export$455c2e768291efa6;
var $c45706e0b0b57ad5$export$9522e17588c12572;
var $c45706e0b0b57ad5$export$2110ac352bb060b9;
var $c45706e0b0b57ad5$export$56885ab8b9c456ab;
var $c45706e0b0b57ad5$export$d927fcb6adf8f9de;
var $c45706e0b0b57ad5$export$b82d16f27459e05a;
var $c45706e0b0b57ad5$export$522c17b4f5e123e8;
var $c45706e0b0b57ad5$export$1aabd8a0274ecfd6;
var $c45706e0b0b57ad5$export$3d6c20d97e46b957;
var $c45706e0b0b57ad5$export$9b621391a187a31a;
var $c45706e0b0b57ad5$export$f5bbd400c2f4426f;
"use strict";
var $c45706e0b0b57ad5$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $c45706e0b0b57ad5$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $c45706e0b0b57ad5$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $c45706e0b0b57ad5$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $c45706e0b0b57ad5$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $c45706e0b0b57ad5$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $c45706e0b0b57ad5$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $c45706e0b0b57ad5$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $c45706e0b0b57ad5$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $c45706e0b0b57ad5$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $c45706e0b0b57ad5$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $c45706e0b0b57ad5$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $c45706e0b0b57ad5$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $c45706e0b0b57ad5$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $c45706e0b0b57ad5$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $c45706e0b0b57ad5$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $c45706e0b0b57ad5$var$REACT_FRAGMENT_TYPE:
                    case $c45706e0b0b57ad5$var$REACT_PROFILER_TYPE:
                    case $c45706e0b0b57ad5$var$REACT_STRICT_MODE_TYPE:
                    case $c45706e0b0b57ad5$var$REACT_SUSPENSE_TYPE:
                    case $c45706e0b0b57ad5$var$REACT_SUSPENSE_LIST_TYPE:
                    case $c45706e0b0b57ad5$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $c45706e0b0b57ad5$var$REACT_CONTEXT_TYPE:
                            case $c45706e0b0b57ad5$var$REACT_FORWARD_REF_TYPE:
                            case $c45706e0b0b57ad5$var$REACT_LAZY_TYPE:
                            case $c45706e0b0b57ad5$var$REACT_MEMO_TYPE:
                                return object;
                            case $c45706e0b0b57ad5$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $c45706e0b0b57ad5$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$c45706e0b0b57ad5$export$a7c73072b1a182ae = $c45706e0b0b57ad5$var$REACT_CONSUMER_TYPE;
$c45706e0b0b57ad5$export$9f27bc3417b4524d = $c45706e0b0b57ad5$var$REACT_CONTEXT_TYPE;
$c45706e0b0b57ad5$export$db77ccec0bb4ccac = $c45706e0b0b57ad5$var$REACT_ELEMENT_TYPE;
$c45706e0b0b57ad5$export$8392c0c9d3dcbd35 = $c45706e0b0b57ad5$var$REACT_FORWARD_REF_TYPE;
$c45706e0b0b57ad5$export$ffb0004e005737fa = $c45706e0b0b57ad5$var$REACT_FRAGMENT_TYPE;
$c45706e0b0b57ad5$export$b624eff549462981 = $c45706e0b0b57ad5$var$REACT_LAZY_TYPE;
$c45706e0b0b57ad5$export$7897aa7841a5380c = $c45706e0b0b57ad5$var$REACT_MEMO_TYPE;
$c45706e0b0b57ad5$export$602eac185826482c = $c45706e0b0b57ad5$var$REACT_PORTAL_TYPE;
$c45706e0b0b57ad5$export$e2c29f18771995cb = $c45706e0b0b57ad5$var$REACT_PROFILER_TYPE;
$c45706e0b0b57ad5$export$5f8d39834fd61797 = $c45706e0b0b57ad5$var$REACT_STRICT_MODE_TYPE;
$c45706e0b0b57ad5$export$74bf444e3cd11ea5 = $c45706e0b0b57ad5$var$REACT_SUSPENSE_TYPE;
$c45706e0b0b57ad5$export$998bcd577473dd93 = $c45706e0b0b57ad5$var$REACT_SUSPENSE_LIST_TYPE;
$c45706e0b0b57ad5$export$b706b080d889d2c9 = function(object) {
    return $c45706e0b0b57ad5$var$typeOf(object) === $c45706e0b0b57ad5$var$REACT_CONSUMER_TYPE;
};
$c45706e0b0b57ad5$export$5be5a87408f70ddc = function(object) {
    return $c45706e0b0b57ad5$var$typeOf(object) === $c45706e0b0b57ad5$var$REACT_CONTEXT_TYPE;
};
$c45706e0b0b57ad5$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $c45706e0b0b57ad5$var$REACT_ELEMENT_TYPE;
};
$c45706e0b0b57ad5$export$455c2e768291efa6 = function(object) {
    return $c45706e0b0b57ad5$var$typeOf(object) === $c45706e0b0b57ad5$var$REACT_FORWARD_REF_TYPE;
};
$c45706e0b0b57ad5$export$9522e17588c12572 = function(object) {
    return $c45706e0b0b57ad5$var$typeOf(object) === $c45706e0b0b57ad5$var$REACT_FRAGMENT_TYPE;
};
$c45706e0b0b57ad5$export$2110ac352bb060b9 = function(object) {
    return $c45706e0b0b57ad5$var$typeOf(object) === $c45706e0b0b57ad5$var$REACT_LAZY_TYPE;
};
$c45706e0b0b57ad5$export$56885ab8b9c456ab = function(object) {
    return $c45706e0b0b57ad5$var$typeOf(object) === $c45706e0b0b57ad5$var$REACT_MEMO_TYPE;
};
$c45706e0b0b57ad5$export$d927fcb6adf8f9de = function(object) {
    return $c45706e0b0b57ad5$var$typeOf(object) === $c45706e0b0b57ad5$var$REACT_PORTAL_TYPE;
};
$c45706e0b0b57ad5$export$b82d16f27459e05a = function(object) {
    return $c45706e0b0b57ad5$var$typeOf(object) === $c45706e0b0b57ad5$var$REACT_PROFILER_TYPE;
};
$c45706e0b0b57ad5$export$522c17b4f5e123e8 = function(object) {
    return $c45706e0b0b57ad5$var$typeOf(object) === $c45706e0b0b57ad5$var$REACT_STRICT_MODE_TYPE;
};
$c45706e0b0b57ad5$export$1aabd8a0274ecfd6 = function(object) {
    return $c45706e0b0b57ad5$var$typeOf(object) === $c45706e0b0b57ad5$var$REACT_SUSPENSE_TYPE;
};
$c45706e0b0b57ad5$export$3d6c20d97e46b957 = function(object) {
    return $c45706e0b0b57ad5$var$typeOf(object) === $c45706e0b0b57ad5$var$REACT_SUSPENSE_LIST_TYPE;
};
$c45706e0b0b57ad5$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $c45706e0b0b57ad5$var$REACT_FRAGMENT_TYPE || type === $c45706e0b0b57ad5$var$REACT_PROFILER_TYPE || type === $c45706e0b0b57ad5$var$REACT_STRICT_MODE_TYPE || type === $c45706e0b0b57ad5$var$REACT_SUSPENSE_TYPE || type === $c45706e0b0b57ad5$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $c45706e0b0b57ad5$var$REACT_LAZY_TYPE || type.$$typeof === $c45706e0b0b57ad5$var$REACT_MEMO_TYPE || type.$$typeof === $c45706e0b0b57ad5$var$REACT_CONTEXT_TYPE || type.$$typeof === $c45706e0b0b57ad5$var$REACT_CONSUMER_TYPE || type.$$typeof === $c45706e0b0b57ad5$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $c45706e0b0b57ad5$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$c45706e0b0b57ad5$export$f5bbd400c2f4426f = $c45706e0b0b57ad5$var$typeOf;

});




parcelRegister("3X7TK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("aJsfD")).default);
$parcel$export(module.exports, "private_createBreakpoints", () => (parcelRequire("ji96P")).default);
$parcel$export(module.exports, "unstable_applyStyles", () => (parcelRequire("3sVYT")).default);

var $aJsfD = parcelRequire("aJsfD");

var $ji96P = parcelRequire("ji96P");

var $3sVYT = parcelRequire("3sVYT");

});
parcelRegister("aJsfD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d04056e0561cf47$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $biRRW = parcelRequire("biRRW");

var $ji96P = parcelRequire("ji96P");

var $6vNnv = parcelRequire("6vNnv");

var $438ze = parcelRequire("438ze");

var $ak9Gk = parcelRequire("ak9Gk");

var $agTT6 = parcelRequire("agTT6");

var $3sVYT = parcelRequire("3sVYT");
const $7d04056e0561cf47$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $7d04056e0561cf47$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $fjJNR.default)(options, $7d04056e0561cf47$var$_excluded);
    const breakpoints = (0, $ji96P.default)(breakpointsInput);
    const spacing = (0, $438ze.default)(spacingInput);
    let muiTheme = (0, $biRRW.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $elnlQ.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $elnlQ.default)({}, (0, $6vNnv.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $3sVYT.default);
    muiTheme = args.reduce((acc, argument)=>(0, $biRRW.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $elnlQ.default)({}, (0, $agTT6.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $ak9Gk.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $7d04056e0561cf47$export$2e2bcd8739ae039 = $7d04056e0561cf47$var$createTheme;

});
parcelRegister("biRRW", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $83ab296c50a46983$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $83ab296c50a46983$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $Fo7oF = parcelRequire("Fo7oF");
function $83ab296c50a46983$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $83ab296c50a46983$var$deepClone(source) {
    if (/*#__PURE__*/ $Fo7oF.isValidElement(source) || !$83ab296c50a46983$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $83ab296c50a46983$var$deepClone(source[key]);
    });
    return output;
}
function $83ab296c50a46983$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $elnlQ.default)({}, target) : target;
    if ($83ab296c50a46983$export$53b83ca8eaab0383(target) && $83ab296c50a46983$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $Fo7oF.isValidElement(source[key])) output[key] = source[key];
        else if ($83ab296c50a46983$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $83ab296c50a46983$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $83ab296c50a46983$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $83ab296c50a46983$export$53b83ca8eaab0383(source[key]) ? $83ab296c50a46983$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("ji96P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0b6c3a52c900f74$export$2e2bcd8739ae039);

var $fjJNR = parcelRequire("fjJNR");

var $elnlQ = parcelRequire("elnlQ");
const $e0b6c3a52c900f74$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $e0b6c3a52c900f74$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $e0b6c3a52c900f74$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $elnlQ.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $e0b6c3a52c900f74$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $fjJNR.default)(breakpoints, $e0b6c3a52c900f74$var$_excluded);
    const sortedValues = $e0b6c3a52c900f74$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $elnlQ.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("6vNnv", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bdbf0cea99c907b$export$2e2bcd8739ae039);
const $4bdbf0cea99c907b$var$shape = {
    borderRadius: 4
};
var $4bdbf0cea99c907b$export$2e2bcd8739ae039 = $4bdbf0cea99c907b$var$shape;

});

parcelRegister("438ze", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f2e168a5c6c00f1$export$2e2bcd8739ae039);

var $3qlx4 = parcelRequire("3qlx4");
function $2f2e168a5c6c00f1$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $3qlx4.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("3qlx4", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $27e480ac87419801$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $27e480ac87419801$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $27e480ac87419801$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $27e480ac87419801$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $27e480ac87419801$export$6f98e8eaf0be1996);


var $fzLrD = parcelRequire("fzLrD");

var $gW1XO = parcelRequire("gW1XO");

var $1ZsaT = parcelRequire("1ZsaT");

var $lpY54 = parcelRequire("lpY54");
const $27e480ac87419801$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $27e480ac87419801$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $27e480ac87419801$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $27e480ac87419801$var$getCssProperties = (0, $lpY54.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($27e480ac87419801$var$aliases[prop]) prop = $27e480ac87419801$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $27e480ac87419801$var$properties[a];
    const direction = $27e480ac87419801$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $27e480ac87419801$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $27e480ac87419801$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $27e480ac87419801$var$spacingKeys = [
    ...$27e480ac87419801$export$aab52a0dde05ad8a,
    ...$27e480ac87419801$export$f8397d44f03ab6ad
];
function $27e480ac87419801$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $gW1XO.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $27e480ac87419801$export$1def6f833384e3d1(theme) {
    return $27e480ac87419801$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $27e480ac87419801$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $27e480ac87419801$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $27e480ac87419801$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $27e480ac87419801$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $27e480ac87419801$var$getCssProperties(prop);
    const styleFromPropValue = $27e480ac87419801$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $fzLrD.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $27e480ac87419801$var$style(props, keys) {
    const transformer = $27e480ac87419801$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$27e480ac87419801$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $1ZsaT.default), {});
}
function $27e480ac87419801$export$7ede87f9b603dd3c(props) {
    return $27e480ac87419801$var$style(props, $27e480ac87419801$export$aab52a0dde05ad8a);
}
$27e480ac87419801$export$7ede87f9b603dd3c.propTypes = {};
$27e480ac87419801$export$7ede87f9b603dd3c.filterProps = $27e480ac87419801$export$aab52a0dde05ad8a;
function $27e480ac87419801$export$6f98e8eaf0be1996(props) {
    return $27e480ac87419801$var$style(props, $27e480ac87419801$export$f8397d44f03ab6ad);
}
$27e480ac87419801$export$6f98e8eaf0be1996.propTypes = {};
$27e480ac87419801$export$6f98e8eaf0be1996.filterProps = $27e480ac87419801$export$f8397d44f03ab6ad;
function $27e480ac87419801$var$spacing(props) {
    return $27e480ac87419801$var$style(props, $27e480ac87419801$var$spacingKeys);
}
$27e480ac87419801$var$spacing.propTypes = {};
$27e480ac87419801$var$spacing.filterProps = $27e480ac87419801$var$spacingKeys;
var $27e480ac87419801$export$2e2bcd8739ae039 = $27e480ac87419801$var$spacing;

});
parcelRegister("fzLrD", function(module, exports) {

$parcel$export(module.exports, "values", () => $b56eed70d025c9fe$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $b56eed70d025c9fe$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $b56eed70d025c9fe$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $b56eed70d025c9fe$export$8922c90b6e020726);

var $elnlQ = parcelRequire("elnlQ");


var $biRRW = parcelRequire("biRRW");

var $1ZsaT = parcelRequire("1ZsaT");
const $b56eed70d025c9fe$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $b56eed70d025c9fe$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$b56eed70d025c9fe$export$68c286be0e7e55b7[key]}px)`
};
function $b56eed70d025c9fe$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $b56eed70d025c9fe$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $b56eed70d025c9fe$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $b56eed70d025c9fe$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $b56eed70d025c9fe$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $b56eed70d025c9fe$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $elnlQ.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $1ZsaT.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $b56eed70d025c9fe$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $b56eed70d025c9fe$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $b56eed70d025c9fe$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $b56eed70d025c9fe$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $biRRW.default)(prev, next), {});
    return $b56eed70d025c9fe$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $b56eed70d025c9fe$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $b56eed70d025c9fe$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $b56eed70d025c9fe$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $b56eed70d025c9fe$export$2e2bcd8739ae039 = $b56eed70d025c9fe$var$breakpoints;

});
parcelRegister("1ZsaT", function(module, exports) {

$parcel$export(module.exports, "default", () => $173157d5593b4dcf$export$2e2bcd8739ae039);

var $biRRW = parcelRequire("biRRW");
function $173157d5593b4dcf$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $biRRW.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $173157d5593b4dcf$export$2e2bcd8739ae039 = $173157d5593b4dcf$var$merge;

});


parcelRegister("gW1XO", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $c543960e1424e373$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $c543960e1424e373$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $c543960e1424e373$export$2e2bcd8739ae039);

var $g00EB = parcelRequire("g00EB");


var $fzLrD = parcelRequire("fzLrD");
function $c543960e1424e373$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $c543960e1424e373$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $c543960e1424e373$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $c543960e1424e373$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $c543960e1424e373$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $c543960e1424e373$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $c543960e1424e373$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $g00EB.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $fzLrD.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $c543960e1424e373$export$2e2bcd8739ae039 = $c543960e1424e373$var$style;

});

parcelRegister("lpY54", function(module, exports) {

$parcel$export(module.exports, "default", () => $f97a89916d903ee1$export$2e2bcd8739ae039);
function $f97a89916d903ee1$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("ak9Gk", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => $78434833b77d3850$export$7d53d8bf2911e013);
$parcel$export(module.exports, "default", () => $78434833b77d3850$export$2e2bcd8739ae039);

var $g00EB = parcelRequire("g00EB");

var $1ZsaT = parcelRequire("1ZsaT");

var $gW1XO = parcelRequire("gW1XO");

var $fzLrD = parcelRequire("fzLrD");

var $agTT6 = parcelRequire("agTT6");
function $78434833b77d3850$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $78434833b77d3850$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $78434833b77d3850$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $gW1XO.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $gW1XO.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $gW1XO.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $g00EB.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $fzLrD.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $agTT6.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $fzLrD.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $78434833b77d3850$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $1ZsaT.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $fzLrD.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($78434833b77d3850$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $1ZsaT.default)(css, breakpointsValues);
                        }
                    } else css = (0, $1ZsaT.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $fzLrD.removeUnusedBreakpoints)(breakpointsKeys, css)
            };
            return (0, $fzLrD.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $78434833b77d3850$var$styleFunctionSx = $78434833b77d3850$export$7d53d8bf2911e013();
$78434833b77d3850$var$styleFunctionSx.filterProps = [
    'sx'
];
var $78434833b77d3850$export$2e2bcd8739ae039 = $78434833b77d3850$var$styleFunctionSx;

});
parcelRegister("agTT6", function(module, exports) {

$parcel$export(module.exports, "default", () => $77a6c0275a43d154$export$2e2bcd8739ae039);

var $3qlx4 = parcelRequire("3qlx4");

var $5v4Sy = parcelRequire("5v4Sy");

var $5WN9V = parcelRequire("5WN9V");

var $lHyMD = parcelRequire("lHyMD");

var $gtLr4 = parcelRequire("gtLr4");
const $77a6c0275a43d154$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $5v4Sy.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $5v4Sy.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $5v4Sy.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $5v4Sy.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $5v4Sy.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $5v4Sy.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $5v4Sy.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $lHyMD.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $lHyMD.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $lHyMD.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $3qlx4.padding)
    },
    pt: {
        style: (0, $3qlx4.padding)
    },
    pr: {
        style: (0, $3qlx4.padding)
    },
    pb: {
        style: (0, $3qlx4.padding)
    },
    pl: {
        style: (0, $3qlx4.padding)
    },
    px: {
        style: (0, $3qlx4.padding)
    },
    py: {
        style: (0, $3qlx4.padding)
    },
    padding: {
        style: (0, $3qlx4.padding)
    },
    paddingTop: {
        style: (0, $3qlx4.padding)
    },
    paddingRight: {
        style: (0, $3qlx4.padding)
    },
    paddingBottom: {
        style: (0, $3qlx4.padding)
    },
    paddingLeft: {
        style: (0, $3qlx4.padding)
    },
    paddingX: {
        style: (0, $3qlx4.padding)
    },
    paddingY: {
        style: (0, $3qlx4.padding)
    },
    paddingInline: {
        style: (0, $3qlx4.padding)
    },
    paddingInlineStart: {
        style: (0, $3qlx4.padding)
    },
    paddingInlineEnd: {
        style: (0, $3qlx4.padding)
    },
    paddingBlock: {
        style: (0, $3qlx4.padding)
    },
    paddingBlockStart: {
        style: (0, $3qlx4.padding)
    },
    paddingBlockEnd: {
        style: (0, $3qlx4.padding)
    },
    m: {
        style: (0, $3qlx4.margin)
    },
    mt: {
        style: (0, $3qlx4.margin)
    },
    mr: {
        style: (0, $3qlx4.margin)
    },
    mb: {
        style: (0, $3qlx4.margin)
    },
    ml: {
        style: (0, $3qlx4.margin)
    },
    mx: {
        style: (0, $3qlx4.margin)
    },
    my: {
        style: (0, $3qlx4.margin)
    },
    margin: {
        style: (0, $3qlx4.margin)
    },
    marginTop: {
        style: (0, $3qlx4.margin)
    },
    marginRight: {
        style: (0, $3qlx4.margin)
    },
    marginBottom: {
        style: (0, $3qlx4.margin)
    },
    marginLeft: {
        style: (0, $3qlx4.margin)
    },
    marginX: {
        style: (0, $3qlx4.margin)
    },
    marginY: {
        style: (0, $3qlx4.margin)
    },
    marginInline: {
        style: (0, $3qlx4.margin)
    },
    marginInlineStart: {
        style: (0, $3qlx4.margin)
    },
    marginInlineEnd: {
        style: (0, $3qlx4.margin)
    },
    marginBlock: {
        style: (0, $3qlx4.margin)
    },
    marginBlockStart: {
        style: (0, $3qlx4.margin)
    },
    marginBlockEnd: {
        style: (0, $3qlx4.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $5WN9V.gap)
    },
    rowGap: {
        style: (0, $5WN9V.rowGap)
    },
    columnGap: {
        style: (0, $5WN9V.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $gtLr4.sizingTransform)
    },
    maxWidth: {
        style: (0, $gtLr4.maxWidth)
    },
    minWidth: {
        transform: (0, $gtLr4.sizingTransform)
    },
    height: {
        transform: (0, $gtLr4.sizingTransform)
    },
    maxHeight: {
        transform: (0, $gtLr4.sizingTransform)
    },
    minHeight: {
        transform: (0, $gtLr4.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $77a6c0275a43d154$export$2e2bcd8739ae039 = $77a6c0275a43d154$var$defaultSxConfig;

});
parcelRegister("5v4Sy", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $4013a1d385835d99$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $4013a1d385835d99$export$7a57f79000377ca2);


var $gW1XO = parcelRequire("gW1XO");

var $dfwrD = parcelRequire("dfwrD");

var $3qlx4 = parcelRequire("3qlx4");

var $fzLrD = parcelRequire("fzLrD");
function $4013a1d385835d99$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $4013a1d385835d99$var$createBorderStyle(prop, transform) {
    return (0, $gW1XO.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $4013a1d385835d99$export$1edee58a52776cd9 = $4013a1d385835d99$var$createBorderStyle('border', $4013a1d385835d99$export$34e2febe53ae29cc);
const $4013a1d385835d99$export$f9a7b6bd24892946 = $4013a1d385835d99$var$createBorderStyle('borderTop', $4013a1d385835d99$export$34e2febe53ae29cc);
const $4013a1d385835d99$export$5abca33e6be905d2 = $4013a1d385835d99$var$createBorderStyle('borderRight', $4013a1d385835d99$export$34e2febe53ae29cc);
const $4013a1d385835d99$export$e2ce9f12a980a822 = $4013a1d385835d99$var$createBorderStyle('borderBottom', $4013a1d385835d99$export$34e2febe53ae29cc);
const $4013a1d385835d99$export$47658cca1a909427 = $4013a1d385835d99$var$createBorderStyle('borderLeft', $4013a1d385835d99$export$34e2febe53ae29cc);
const $4013a1d385835d99$export$e7fb0694ba2404fc = $4013a1d385835d99$var$createBorderStyle('borderColor');
const $4013a1d385835d99$export$126a92c968acdb85 = $4013a1d385835d99$var$createBorderStyle('borderTopColor');
const $4013a1d385835d99$export$85cc51cb8fbb8c0e = $4013a1d385835d99$var$createBorderStyle('borderRightColor');
const $4013a1d385835d99$export$340b0327727f6d1a = $4013a1d385835d99$var$createBorderStyle('borderBottomColor');
const $4013a1d385835d99$export$60beef91a985b4bf = $4013a1d385835d99$var$createBorderStyle('borderLeftColor');
const $4013a1d385835d99$export$f9258c55612cbed7 = $4013a1d385835d99$var$createBorderStyle('outline', $4013a1d385835d99$export$34e2febe53ae29cc);
const $4013a1d385835d99$export$621fe586efeb64b9 = $4013a1d385835d99$var$createBorderStyle('outlineColor');
const $4013a1d385835d99$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $3qlx4.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $3qlx4.getValue)(transformer, propValue)
            });
        return (0, $fzLrD.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$4013a1d385835d99$export$7a57f79000377ca2.propTypes = {};
$4013a1d385835d99$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $4013a1d385835d99$var$borders = (0, $dfwrD.default)($4013a1d385835d99$export$1edee58a52776cd9, $4013a1d385835d99$export$f9a7b6bd24892946, $4013a1d385835d99$export$5abca33e6be905d2, $4013a1d385835d99$export$e2ce9f12a980a822, $4013a1d385835d99$export$47658cca1a909427, $4013a1d385835d99$export$e7fb0694ba2404fc, $4013a1d385835d99$export$126a92c968acdb85, $4013a1d385835d99$export$85cc51cb8fbb8c0e, $4013a1d385835d99$export$340b0327727f6d1a, $4013a1d385835d99$export$60beef91a985b4bf, $4013a1d385835d99$export$7a57f79000377ca2, $4013a1d385835d99$export$f9258c55612cbed7, $4013a1d385835d99$export$621fe586efeb64b9);
var $4013a1d385835d99$export$2e2bcd8739ae039 = $4013a1d385835d99$var$borders;

});
parcelRegister("dfwrD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a55d7e728228346$export$2e2bcd8739ae039);

var $1ZsaT = parcelRequire("1ZsaT");
function $9a55d7e728228346$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $1ZsaT.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $9a55d7e728228346$export$2e2bcd8739ae039 = $9a55d7e728228346$var$compose;

});


parcelRegister("5WN9V", function(module, exports) {

$parcel$export(module.exports, "gap", () => $4548807afb8ea08d$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $4548807afb8ea08d$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $4548807afb8ea08d$export$8a833ffa5f5dbeda);

var $gW1XO = parcelRequire("gW1XO");

var $dfwrD = parcelRequire("dfwrD");

var $3qlx4 = parcelRequire("3qlx4");

var $fzLrD = parcelRequire("fzLrD");

const $4548807afb8ea08d$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $3qlx4.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $3qlx4.getValue)(transformer, propValue)
            });
        return (0, $fzLrD.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$4548807afb8ea08d$export$5df9adcb0db95e1e.propTypes = {};
$4548807afb8ea08d$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $4548807afb8ea08d$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $3qlx4.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $3qlx4.getValue)(transformer, propValue)
            });
        return (0, $fzLrD.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$4548807afb8ea08d$export$ec60d70ff941a580.propTypes = {};
$4548807afb8ea08d$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $4548807afb8ea08d$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $3qlx4.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $3qlx4.getValue)(transformer, propValue)
            });
        return (0, $fzLrD.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$4548807afb8ea08d$export$8a833ffa5f5dbeda.propTypes = {};
$4548807afb8ea08d$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $4548807afb8ea08d$export$baf44164ca3a34e8 = (0, $gW1XO.default)({
    prop: 'gridColumn'
});
const $4548807afb8ea08d$export$8f7213a1cd01e832 = (0, $gW1XO.default)({
    prop: 'gridRow'
});
const $4548807afb8ea08d$export$b0e0abbc49ba668 = (0, $gW1XO.default)({
    prop: 'gridAutoFlow'
});
const $4548807afb8ea08d$export$bcd8b929d4b4142 = (0, $gW1XO.default)({
    prop: 'gridAutoColumns'
});
const $4548807afb8ea08d$export$e5039a674e14c828 = (0, $gW1XO.default)({
    prop: 'gridAutoRows'
});
const $4548807afb8ea08d$export$42bd9088661ffb03 = (0, $gW1XO.default)({
    prop: 'gridTemplateColumns'
});
const $4548807afb8ea08d$export$920682ae05b999bc = (0, $gW1XO.default)({
    prop: 'gridTemplateRows'
});
const $4548807afb8ea08d$export$1b88fbdd482fd33a = (0, $gW1XO.default)({
    prop: 'gridTemplateAreas'
});
const $4548807afb8ea08d$export$bdb486e40d52d26f = (0, $gW1XO.default)({
    prop: 'gridArea'
});
const $4548807afb8ea08d$var$grid = (0, $dfwrD.default)($4548807afb8ea08d$export$5df9adcb0db95e1e, $4548807afb8ea08d$export$ec60d70ff941a580, $4548807afb8ea08d$export$8a833ffa5f5dbeda, $4548807afb8ea08d$export$baf44164ca3a34e8, $4548807afb8ea08d$export$8f7213a1cd01e832, $4548807afb8ea08d$export$b0e0abbc49ba668, $4548807afb8ea08d$export$bcd8b929d4b4142, $4548807afb8ea08d$export$e5039a674e14c828, $4548807afb8ea08d$export$42bd9088661ffb03, $4548807afb8ea08d$export$920682ae05b999bc, $4548807afb8ea08d$export$1b88fbdd482fd33a, $4548807afb8ea08d$export$bdb486e40d52d26f);
var $4548807afb8ea08d$export$2e2bcd8739ae039 = $4548807afb8ea08d$var$grid;

});

parcelRegister("lHyMD", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $fcc898668e4fb552$export$dbaffd4420ea0ac6);

var $gW1XO = parcelRequire("gW1XO");

var $dfwrD = parcelRequire("dfwrD");
function $fcc898668e4fb552$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $fcc898668e4fb552$export$35e9368ef982300f = (0, $gW1XO.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $fcc898668e4fb552$export$dbaffd4420ea0ac6
});
const $fcc898668e4fb552$export$2506f56c10355b33 = (0, $gW1XO.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $fcc898668e4fb552$export$dbaffd4420ea0ac6
});
const $fcc898668e4fb552$export$8c5a050822fd698c = (0, $gW1XO.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $fcc898668e4fb552$export$dbaffd4420ea0ac6
});
const $fcc898668e4fb552$var$palette = (0, $dfwrD.default)($fcc898668e4fb552$export$35e9368ef982300f, $fcc898668e4fb552$export$2506f56c10355b33, $fcc898668e4fb552$export$8c5a050822fd698c);
var $fcc898668e4fb552$export$2e2bcd8739ae039 = $fcc898668e4fb552$var$palette;

});

parcelRegister("gtLr4", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $bff4267eb175b1b3$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $bff4267eb175b1b3$export$488fda99655ff65a);

var $gW1XO = parcelRequire("gW1XO");

var $dfwrD = parcelRequire("dfwrD");

var $fzLrD = parcelRequire("fzLrD");
function $bff4267eb175b1b3$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $bff4267eb175b1b3$export$7e3df82ee760448c = (0, $gW1XO.default)({
    prop: 'width',
    transform: $bff4267eb175b1b3$export$8afece71750ec241
});
const $bff4267eb175b1b3$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $fzLrD.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $bff4267eb175b1b3$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $fzLrD.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$bff4267eb175b1b3$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $bff4267eb175b1b3$export$ee148fbbe8357dd2 = (0, $gW1XO.default)({
    prop: 'minWidth',
    transform: $bff4267eb175b1b3$export$8afece71750ec241
});
const $bff4267eb175b1b3$export$ac607276a8fe9f0a = (0, $gW1XO.default)({
    prop: 'height',
    transform: $bff4267eb175b1b3$export$8afece71750ec241
});
const $bff4267eb175b1b3$export$dc0d8bd0b94f8570 = (0, $gW1XO.default)({
    prop: 'maxHeight',
    transform: $bff4267eb175b1b3$export$8afece71750ec241
});
const $bff4267eb175b1b3$export$a43cf604e12f3b17 = (0, $gW1XO.default)({
    prop: 'minHeight',
    transform: $bff4267eb175b1b3$export$8afece71750ec241
});
const $bff4267eb175b1b3$export$ffed9f14fb65e276 = (0, $gW1XO.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $bff4267eb175b1b3$export$8afece71750ec241
});
const $bff4267eb175b1b3$export$905076ed6620e671 = (0, $gW1XO.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $bff4267eb175b1b3$export$8afece71750ec241
});
const $bff4267eb175b1b3$export$6ccc93f785106a58 = (0, $gW1XO.default)({
    prop: 'boxSizing'
});
const $bff4267eb175b1b3$var$sizing = (0, $dfwrD.default)($bff4267eb175b1b3$export$7e3df82ee760448c, $bff4267eb175b1b3$export$488fda99655ff65a, $bff4267eb175b1b3$export$ee148fbbe8357dd2, $bff4267eb175b1b3$export$ac607276a8fe9f0a, $bff4267eb175b1b3$export$dc0d8bd0b94f8570, $bff4267eb175b1b3$export$a43cf604e12f3b17, $bff4267eb175b1b3$export$6ccc93f785106a58);
var $bff4267eb175b1b3$export$2e2bcd8739ae039 = $bff4267eb175b1b3$var$sizing;

});



parcelRegister("3sVYT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2860f6796bb013ef$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $2860f6796bb013ef$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("5pVfa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("ak9Gk")).default);
$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => (parcelRequire("ak9Gk")).unstable_createStyleFunctionSx);
$parcel$export(module.exports, "extendSxProp", () => (parcelRequire("8ayIK")).default);
$parcel$export(module.exports, "unstable_defaultSxConfig", () => (parcelRequire("agTT6")).default);

var $ak9Gk = parcelRequire("ak9Gk");

var $8ayIK = parcelRequire("8ayIK");

var $agTT6 = parcelRequire("agTT6");

});
parcelRegister("8ayIK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f2a30b76c390dbf$export$2e2bcd8739ae039);

var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $biRRW = parcelRequire("biRRW");

var $agTT6 = parcelRequire("agTT6");
const $5f2a30b76c390dbf$var$_excluded = [
    "sx"
];
const $5f2a30b76c390dbf$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $agTT6.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $5f2a30b76c390dbf$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $fjJNR.default)(props, $5f2a30b76c390dbf$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $5f2a30b76c390dbf$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $biRRW.isPlainObject)(result)) return systemProps;
        return (0, $elnlQ.default)({}, systemProps, result);
    };
    else finalSx = (0, $elnlQ.default)({}, systemProps, inSx);
    return (0, $elnlQ.default)({}, otherProps, {
        sx: finalSx
    });
}

});


parcelRegister("74m7k", function(module, exports) {



(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types",
        "./loader"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("Fo7oF")), (parcelRequire("d2bgE")), (parcelRequire("80kya")));
    }
})(module.exports, function(exports1, _react, _propTypes, _loader) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.default = Loader;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var _slicedToArray = function() {
        function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
                for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                    _arr.push(_s.value);
                    if (i && _arr.length === i) break;
                }
            } catch (err) {
                _d = true;
                _e = err;
            } finally{
                try {
                    if (!_n && _i["return"]) _i["return"]();
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        return function(arr, i) {
            if (Array.isArray(arr)) return arr;
            else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
            else throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }();
    var componentNames = [
        "Audio",
        "BallTriangle",
        "Bars",
        "Circles",
        "Grid",
        "Hearts",
        "Oval",
        "Puff",
        "Rings",
        "TailSpin",
        "ThreeDots",
        "Watch",
        "RevolvingDot",
        "Triangle",
        "Plane",
        "MutatingDots",
        "CradleLoader"
    ];
    function componentName(type) {
        if (componentNames.includes(type)) return _loader.Spinner[type];
        return _loader.Spinner.Audio;
    }
    /**
   * @return {null}
   */ function Loader(props) {
        var _useState = (0, _react.useState)(true), _useState2 = _slicedToArray(_useState, 2), display = _useState2[0], setDisplay = _useState2[1];
        (0, _react.useEffect)(function() {
            var timer = void 0;
            if (props.timeout && props.timeout > 0) timer = setTimeout(function() {
                setDisplay(false);
            }, props.timeout);
            return function() {
                if (timer) clearTimeout(timer);
            };
        });
        if (!props.visible || props.visible === "false") return null;
        return display ? _react2.default.createElement("div", {
            "aria-busy": "true",
            className: props.className,
            style: props.style
        }, _react2.default.createElement(componentName(props.type), _extends({}, props))) : null;
    }
    Loader.propTypes = {
        type: _propTypes2.default.oneOf([].concat(componentNames)),
        style: _propTypes2.default.objectOf(_propTypes2.default.string),
        className: _propTypes2.default.string,
        visible: _propTypes2.default.oneOfType([
            _propTypes2.default.bool,
            _propTypes2.default.string
        ]),
        timeout: _propTypes2.default.number
    };
    Loader.defaultProps = {
        type: "Audio",
        style: {},
        className: "",
        visible: true,
        timeout: 0
    };
});

});
parcelRegister("80kya", function(module, exports) {

















(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./Circles",
        "./Watch",
        "./Audio",
        "./BallTriangle",
        "./Bars",
        "./CradleLoader",
        "./Grid",
        "./Hearts",
        "./MutatingDots",
        "./Oval",
        "./Plane",
        "./Puff",
        "./RevolvingDot",
        "./Rings",
        "./TailSpin",
        "./ThreeDots",
        "./Triangle"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("5d8Tz")), (parcelRequire("6Au9B")), (parcelRequire("dGZqx")), (parcelRequire("19Ocw")), (parcelRequire("bPYz4")), (parcelRequire("fK6wS")), (parcelRequire("3wzLE")), (parcelRequire("clAnN")), (parcelRequire("bpf5r")), (parcelRequire("8jZFK")), (parcelRequire("2XAAz")), (parcelRequire("fEMmz")), (parcelRequire("lKq17")), (parcelRequire("aVvOT")), (parcelRequire("eLM4T")), (parcelRequire("9rO5s")), (parcelRequire("ksoy4")));
    }
})(module.exports, function(exports1, _Circles, _Watch, _Audio, _BallTriangle, _Bars, _CradleLoader, _Grid, _Hearts, _MutatingDots, _Oval, _Plane, _Puff, _RevolvingDot, _Rings, _TailSpin, _ThreeDots, _Triangle) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Spinner = undefined;
    var Spinner = exports1.Spinner = {
        Circles: _Circles.Circles,
        Audio: _Audio.Audio,
        BallTriangle: _BallTriangle.BallTriangle,
        Bars: _Bars.Bars,
        CradleLoader: _CradleLoader.CradleLoader,
        Grid: _Grid.Grid,
        Hearts: _Hearts.Hearts,
        MutatingDots: _MutatingDots.MutatingDots,
        Oval: _Oval.Oval,
        Plane: _Plane.Plane,
        Puff: _Puff.Puff,
        RevolvingDot: _RevolvingDot.RevolvingDot,
        Rings: _Rings.Rings,
        TailSpin: _TailSpin.TailSpin,
        ThreeDots: _ThreeDots.ThreeDots,
        Triangle: _Triangle.Triangle,
        Watch: _Watch.Watch
    };
});

});
parcelRegister("5d8Tz", function(module, exports) {


(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("Fo7oF")), (parcelRequire("d2bgE")));
    }
})(module.exports, function(exports1, _react, _propTypes) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Circles = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var Circles = exports1.Circles = function Circles(props) {
        return _react2.default.createElement("svg", {
            width: props.width,
            height: props.height,
            viewBox: "0 0 135 135",
            xmlns: "http://www.w3.org/2000/svg",
            fill: props.color,
            "aria-label": props.label
        }, _react2.default.createElement("path", {
            d: "M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z"
        }, _react2.default.createElement("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 67 67",
            to: "-360 67 67",
            dur: "2.5s",
            repeatCount: "indefinite"
        })), _react2.default.createElement("path", {
            d: "M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z"
        }, _react2.default.createElement("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 67 67",
            to: "360 67 67",
            dur: "8s",
            repeatCount: "indefinite"
        })));
    };
    Circles.propTypes = {
        height: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        width: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        color: _propTypes2.default.string,
        label: _propTypes2.default.string
    };
    Circles.defaultProps = {
        height: 80,
        width: 80,
        color: "green",
        label: "audio-loading"
    };
});

});

parcelRegister("6Au9B", function(module, exports) {


(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("Fo7oF")), (parcelRequire("d2bgE")));
    }
})(module.exports, function(exports1, _react, _propTypes) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Watch = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var Watch = exports1.Watch = function Watch(props) {
        return _react2.default.createElement("svg", {
            width: props.width,
            height: props.height,
            version: "1.1",
            id: "L2",
            xmlns: "http://www.w3.org/2000/svg",
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "aria-label": props.label
        }, _react2.default.createElement("circle", {
            fill: "none",
            stroke: props.color,
            strokeWidth: "4",
            strokeMiterlimit: "10",
            cx: "50",
            cy: "50",
            r: props.radius
        }), _react2.default.createElement("line", {
            fill: "none",
            strokeLinecap: "round",
            stroke: props.color,
            strokeWidth: "4",
            strokeMiterlimit: "10",
            x1: "50",
            y1: "50",
            x2: "85",
            y2: "50.5"
        }, _react2.default.createElement("animateTransform", {
            attributeName: "transform",
            dur: "2s",
            type: "rotate",
            from: "0 50 50",
            to: "360 50 50",
            repeatCount: "indefinite"
        })), _react2.default.createElement("line", {
            fill: "none",
            strokeLinecap: "round",
            stroke: props.color,
            strokeWidth: "4",
            strokeMiterlimit: "10",
            x1: "50",
            y1: "50",
            x2: "49.5",
            y2: "74"
        }, _react2.default.createElement("animateTransform", {
            attributeName: "transform",
            dur: "15s",
            type: "rotate",
            from: "0 50 50",
            to: "360 50 50",
            repeatCount: "indefinite"
        })));
    };
    Watch.propTypes = {
        height: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        width: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        color: _propTypes2.default.string,
        label: _propTypes2.default.string,
        radius: _propTypes2.default.number
    };
    Watch.defaultProps = {
        height: 80,
        width: 80,
        color: "green",
        label: "audio-loading",
        radius: 48
    };
});

});

parcelRegister("dGZqx", function(module, exports) {


(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("Fo7oF")), (parcelRequire("d2bgE")));
    }
})(module.exports, function(exports1, _react, _propTypes) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Audio = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var Audio = exports1.Audio = function Audio(props) {
        return _react2.default.createElement("svg", {
            height: props.height,
            width: props.width,
            fill: props.color,
            viewBox: "0 0 55 80",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-label": props.label
        }, _react2.default.createElement("g", {
            transform: "matrix(1 0 0 -1 0 80)"
        }, _react2.default.createElement("rect", {
            width: "10",
            height: "20",
            rx: "3"
        }, _react2.default.createElement("animate", {
            attributeName: "height",
            begin: "0s",
            dur: "4.3s",
            values: "20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("rect", {
            x: "15",
            width: "10",
            height: "80",
            rx: "3"
        }, _react2.default.createElement("animate", {
            attributeName: "height",
            begin: "0s",
            dur: "2s",
            values: "80;55;33;5;75;23;73;33;12;14;60;80",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("rect", {
            x: "30",
            width: "10",
            height: "50",
            rx: "3"
        }, _react2.default.createElement("animate", {
            attributeName: "height",
            begin: "0s",
            dur: "1.4s",
            values: "50;34;78;23;56;23;34;76;80;54;21;50",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("rect", {
            x: "45",
            width: "10",
            height: "30",
            rx: "3"
        }, _react2.default.createElement("animate", {
            attributeName: "height",
            begin: "0s",
            dur: "2s",
            values: "30;45;13;80;56;72;45;76;34;23;67;30",
            calcMode: "linear",
            repeatCount: "indefinite"
        }))));
    };
    Audio.propTypes = {
        height: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        width: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        color: _propTypes2.default.string,
        label: _propTypes2.default.string
    };
    Audio.defaultProps = {
        height: 80,
        width: 80,
        color: "green",
        label: "audio-loading"
    };
});

});

parcelRegister("19Ocw", function(module, exports) {


(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("Fo7oF")), (parcelRequire("d2bgE")));
    }
})(module.exports, function(exports1, _react, _propTypes) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.BallTriangle = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var BallTriangle = exports1.BallTriangle = function BallTriangle(props) {
        return _react2.default.createElement("svg", {
            height: props.height,
            width: props.width,
            stroke: props.color,
            viewBox: "0 0 57 57",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-label": props.label
        }, _react2.default.createElement("g", {
            fill: "none",
            fillRule: "evenodd"
        }, _react2.default.createElement("g", {
            transform: "translate(1 1)",
            strokeWidth: "2"
        }, _react2.default.createElement("circle", {
            cx: "5",
            cy: "50",
            r: props.radius
        }, _react2.default.createElement("animate", {
            attributeName: "cy",
            begin: "0s",
            dur: "2.2s",
            values: "50;5;50;50",
            calcMode: "linear",
            repeatCount: "indefinite"
        }), _react2.default.createElement("animate", {
            attributeName: "cx",
            begin: "0s",
            dur: "2.2s",
            values: "5;27;49;5",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("circle", {
            cx: "27",
            cy: "5",
            r: props.radius
        }, _react2.default.createElement("animate", {
            attributeName: "cy",
            begin: "0s",
            dur: "2.2s",
            from: "5",
            to: "5",
            values: "5;50;50;5",
            calcMode: "linear",
            repeatCount: "indefinite"
        }), _react2.default.createElement("animate", {
            attributeName: "cx",
            begin: "0s",
            dur: "2.2s",
            from: "27",
            to: "27",
            values: "27;49;5;27",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("circle", {
            cx: "49",
            cy: "50",
            r: props.radius
        }, _react2.default.createElement("animate", {
            attributeName: "cy",
            begin: "0s",
            dur: "2.2s",
            values: "50;50;5;50",
            calcMode: "linear",
            repeatCount: "indefinite"
        }), _react2.default.createElement("animate", {
            attributeName: "cx",
            from: "49",
            to: "49",
            begin: "0s",
            dur: "2.2s",
            values: "49;5;27;49",
            calcMode: "linear",
            repeatCount: "indefinite"
        })))));
    };
    BallTriangle.propTypes = {
        height: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        width: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        color: _propTypes2.default.string,
        label: _propTypes2.default.string,
        radius: _propTypes2.default.number
    };
    BallTriangle.defaultProps = {
        height: 80,
        width: 80,
        color: "green",
        radius: 5,
        label: "audio-loading"
    };
});

});

parcelRegister("bPYz4", function(module, exports) {


(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("Fo7oF")), (parcelRequire("d2bgE")));
    }
})(module.exports, function(exports1, _react, _propTypes) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Bars = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var Bars = exports1.Bars = function Bars(props) {
        return _react2.default.createElement("svg", {
            width: props.width,
            height: props.height,
            fill: props.color,
            viewBox: "0 0 135 140",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-label": props.label
        }, _react2.default.createElement("rect", {
            y: "10",
            width: "15",
            height: "120",
            rx: "6"
        }, _react2.default.createElement("animate", {
            attributeName: "height",
            begin: "0.5s",
            dur: "1s",
            values: "120;110;100;90;80;70;60;50;40;140;120",
            calcMode: "linear",
            repeatCount: "indefinite"
        }), _react2.default.createElement("animate", {
            attributeName: "y",
            begin: "0.5s",
            dur: "1s",
            values: "10;15;20;25;30;35;40;45;50;0;10",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("rect", {
            x: "30",
            y: "10",
            width: "15",
            height: "120",
            rx: "6"
        }, _react2.default.createElement("animate", {
            attributeName: "height",
            begin: "0.25s",
            dur: "1s",
            values: "120;110;100;90;80;70;60;50;40;140;120",
            calcMode: "linear",
            repeatCount: "indefinite"
        }), _react2.default.createElement("animate", {
            attributeName: "y",
            begin: "0.25s",
            dur: "1s",
            values: "10;15;20;25;30;35;40;45;50;0;10",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("rect", {
            x: "60",
            width: "15",
            height: "140",
            rx: "6"
        }, _react2.default.createElement("animate", {
            attributeName: "height",
            begin: "0s",
            dur: "1s",
            values: "120;110;100;90;80;70;60;50;40;140;120",
            calcMode: "linear",
            repeatCount: "indefinite"
        }), _react2.default.createElement("animate", {
            attributeName: "y",
            begin: "0s",
            dur: "1s",
            values: "10;15;20;25;30;35;40;45;50;0;10",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("rect", {
            x: "90",
            y: "10",
            width: "15",
            height: "120",
            rx: "6"
        }, _react2.default.createElement("animate", {
            attributeName: "height",
            begin: "0.25s",
            dur: "1s",
            values: "120;110;100;90;80;70;60;50;40;140;120",
            calcMode: "linear",
            repeatCount: "indefinite"
        }), _react2.default.createElement("animate", {
            attributeName: "y",
            begin: "0.25s",
            dur: "1s",
            values: "10;15;20;25;30;35;40;45;50;0;10",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("rect", {
            x: "120",
            y: "10",
            width: "15",
            height: "120",
            rx: "6"
        }, _react2.default.createElement("animate", {
            attributeName: "height",
            begin: "0.5s",
            dur: "1s",
            values: "120;110;100;90;80;70;60;50;40;140;120",
            calcMode: "linear",
            repeatCount: "indefinite"
        }), _react2.default.createElement("animate", {
            attributeName: "y",
            begin: "0.5s",
            dur: "1s",
            values: "10;15;20;25;30;35;40;45;50;0;10",
            calcMode: "linear",
            repeatCount: "indefinite"
        })));
    };
    Bars.propTypes = {
        height: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        width: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        color: _propTypes2.default.string,
        label: _propTypes2.default.string
    };
    Bars.defaultProps = {
        height: 80,
        width: 80,
        color: "green",
        label: "audio-loading"
    };
});

});

parcelRegister("fK6wS", function(module, exports) {


(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("Fo7oF")), (parcelRequire("d2bgE")));
    }
})(module.exports, function(exports1, _react, _propTypes) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.CradleLoader = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var CradleLoader = exports1.CradleLoader = function CradleLoader(props) {
        return _react2.default.createElement("div", {
            "aria-label": props.label,
            role: "presentation",
            className: "container"
        }, _react2.default.createElement("div", {
            className: "react-spinner-loader-swing"
        }, _react2.default.createElement("div", {
            className: "react-spinner-loader-swing-l"
        }), _react2.default.createElement("div", null), _react2.default.createElement("div", null), _react2.default.createElement("div", null), _react2.default.createElement("div", null), _react2.default.createElement("div", null), _react2.default.createElement("div", {
            className: "react-spinner-loader-swing-r"
        })), _react2.default.createElement("div", {
            className: "react-spinner-loader-shadow"
        }, _react2.default.createElement("div", {
            className: "react-spinner-loader-shadow-l"
        }), _react2.default.createElement("div", null), _react2.default.createElement("div", null), _react2.default.createElement("div", null), _react2.default.createElement("div", null), _react2.default.createElement("div", null), _react2.default.createElement("div", {
            className: "react-spinner-loader-shadow-r"
        })));
    };
    CradleLoader.propTypes = {
        label: _propTypes2.default.string
    };
    CradleLoader.defaultProps = {
        label: "audio-loading"
    };
});

});

parcelRegister("3wzLE", function(module, exports) {


(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("Fo7oF")), (parcelRequire("d2bgE")));
    }
})(module.exports, function(exports1, _react, _propTypes) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Grid = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var Grid = exports1.Grid = function Grid(props) {
        return _react2.default.createElement("svg", {
            width: props.width,
            height: props.height,
            viewBox: "0 0 105 105",
            fill: props.color,
            "aria-label": props.label
        }, _react2.default.createElement("circle", {
            cx: "12.5",
            cy: "12.5",
            r: props.radius
        }, _react2.default.createElement("animate", {
            attributeName: "fill-opacity",
            begin: "0s",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("circle", {
            cx: "12.5",
            cy: "52.5",
            r: props.radius
        }, _react2.default.createElement("animate", {
            attributeName: "fill-opacity",
            begin: "100ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("circle", {
            cx: "52.5",
            cy: "12.5",
            r: props.radius
        }, _react2.default.createElement("animate", {
            attributeName: "fill-opacity",
            begin: "300ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("circle", {
            cx: "52.5",
            cy: "52.5",
            r: props.radius
        }, _react2.default.createElement("animate", {
            attributeName: "fill-opacity",
            begin: "600ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("circle", {
            cx: "92.5",
            cy: "12.5",
            r: props.radius
        }, _react2.default.createElement("animate", {
            attributeName: "fill-opacity",
            begin: "800ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("circle", {
            cx: "92.5",
            cy: "52.5",
            r: props.radius
        }, _react2.default.createElement("animate", {
            attributeName: "fill-opacity",
            begin: "400ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("circle", {
            cx: "12.5",
            cy: "92.5",
            r: props.radius
        }, _react2.default.createElement("animate", {
            attributeName: "fill-opacity",
            begin: "700ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("circle", {
            cx: "52.5",
            cy: "92.5",
            r: props.radius
        }, _react2.default.createElement("animate", {
            attributeName: "fill-opacity",
            begin: "500ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("circle", {
            cx: "92.5",
            cy: "92.5",
            r: props.radius
        }, _react2.default.createElement("animate", {
            attributeName: "fill-opacity",
            begin: "200ms",
            dur: "1s",
            values: "1;.2;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })));
    };
    Grid.propTypes = {
        height: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        width: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        color: _propTypes2.default.string,
        label: _propTypes2.default.string,
        radius: _propTypes2.default.number
    };
    Grid.defaultProps = {
        height: 80,
        width: 80,
        color: "green",
        radius: 12.5,
        label: "audio-loading"
    };
});

});

parcelRegister("clAnN", function(module, exports) {


(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("Fo7oF")), (parcelRequire("d2bgE")));
    }
})(module.exports, function(exports1, _react, _propTypes) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Hearts = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var Hearts = exports1.Hearts = function Hearts(props) {
        return _react2.default.createElement("svg", {
            width: props.width,
            height: props.height,
            viewBox: "0 0 140 64",
            xmlns: "http://www.w3.org/2000/svg",
            fill: props.color,
            "aria-label": props.label
        }, _react2.default.createElement("path", {
            d: "M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.717-6.002 11.47-7.65 17.305-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z",
            attributeName: "fill-opacity",
            from: "0",
            to: ".5"
        }, _react2.default.createElement("animate", {
            attributeName: "fill-opacity",
            begin: "0s",
            dur: "1.4s",
            values: "0.5;1;0.5",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("path", {
            d: "M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.592-2.32 17.307 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z",
            attributeName: "fill-opacity",
            from: "0",
            to: ".5"
        }, _react2.default.createElement("animate", {
            attributeName: "fill-opacity",
            begin: "0.7s",
            dur: "1.4s",
            values: "0.5;1;0.5",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("path", {
            d: "M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"
        }));
    };
    Hearts.propTypes = {
        height: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        width: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        color: _propTypes2.default.string,
        label: _propTypes2.default.string
    };
    Hearts.defaultProps = {
        height: 80,
        width: 80,
        color: "green",
        label: "audio-loading"
    };
});

});

parcelRegister("bpf5r", function(module, exports) {


(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("Fo7oF")), (parcelRequire("d2bgE")));
    }
})(module.exports, function(exports1, _react, _propTypes) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.MutatingDots = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var MutatingDots = exports1.MutatingDots = function MutatingDots(props) {
        return _react2.default.createElement("svg", {
            id: "goo-loader",
            width: props.width,
            height: props.height,
            "aria-label": props.label
        }, _react2.default.createElement("filter", {
            id: "fancy-goo"
        }, _react2.default.createElement("feGaussianBlur", {
            "in": "SourceGraphic",
            stdDeviation: "6",
            result: "blur"
        }), _react2.default.createElement("feColorMatrix", {
            "in": "blur",
            mode: "matrix",
            values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9",
            result: "goo"
        }), _react2.default.createElement("feComposite", {
            "in": "SourceGraphic",
            in2: "goo",
            operator: "atop"
        })), _react2.default.createElement("g", {
            filter: "url(#fancy-goo)"
        }, _react2.default.createElement("animateTransform", {
            id: "mainAnim",
            attributeName: "transform",
            attributeType: "XML",
            type: "rotate",
            from: "0 50 50",
            to: "359 50 50",
            dur: "1.2s",
            repeatCount: "indefinite"
        }), _react2.default.createElement("circle", {
            cx: "50%",
            cy: "40",
            r: props.radius,
            fill: props.color
        }, _react2.default.createElement("animate", {
            id: "cAnim1",
            attributeType: "XML",
            attributeName: "cy",
            dur: "0.6s",
            begin: "0;cAnim1.end+0.2s",
            calcMode: "spline",
            values: "40;20;40",
            keyTimes: "0;0.3;1",
            keySplines: "0.175, 0.885, 0.320, 1.5; 0.175, 0.885, 0.320, 1.5"
        })), _react2.default.createElement("circle", {
            cx: "50%",
            cy: "60",
            r: props.radius,
            fill: props.secondaryColor
        }, _react2.default.createElement("animate", {
            id: "cAnim2",
            attributeType: "XML",
            attributeName: "cy",
            dur: "0.6s",
            begin: "0.4s;cAnim2.end+0.2s",
            calcMode: "spline",
            values: "60;80;60",
            keyTimes: "0;0.3;1",
            keySplines: "0.175, 0.885, 0.320, 1.5;0.175, 0.885, 0.320, 1.5"
        }))));
    };
    MutatingDots.propTypes = {
        width: _propTypes2.default.number,
        secondaryColor: _propTypes2.default.string,
        height: _propTypes2.default.number,
        color: _propTypes2.default.string,
        radius: _propTypes2.default.number,
        label: _propTypes2.default.string
    };
    MutatingDots.defaultProps = {
        width: 80,
        height: 90,
        color: "green",
        radius: 11,
        secondaryColor: "green",
        label: "audio-loading"
    };
});

});

parcelRegister("8jZFK", function(module, exports) {


(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("Fo7oF")), (parcelRequire("d2bgE")));
    }
})(module.exports, function(exports1, _react, _propTypes) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Oval = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var Oval = exports1.Oval = function Oval(props) {
        return _react2.default.createElement("svg", {
            width: props.width,
            height: props.height,
            viewBox: "0 0 38 38",
            xmlns: "http://www.w3.org/2000/svg",
            stroke: props.color,
            "aria-label": props.label
        }, _react2.default.createElement("g", {
            fill: "none",
            fillRule: "evenodd"
        }, _react2.default.createElement("g", {
            transform: "translate(1 1)",
            strokeWidth: "2"
        }, _react2.default.createElement("circle", {
            strokeOpacity: ".5",
            cx: "18",
            cy: "18",
            r: props.radius
        }), _react2.default.createElement("path", {
            d: "M36 18c0-9.94-8.06-18-18-18"
        }, _react2.default.createElement("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 18 18",
            to: "360 18 18",
            dur: "1s",
            repeatCount: "indefinite"
        })))));
    };
    Oval.propTypes = {
        height: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        width: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        color: _propTypes2.default.string,
        label: _propTypes2.default.string,
        radius: _propTypes2.default.number
    };
    Oval.defaultProps = {
        height: 80,
        width: 80,
        color: "green",
        label: "audio-loading",
        radius: 18
    };
});

});

parcelRegister("2XAAz", function(module, exports) {


(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("Fo7oF")), (parcelRequire("d2bgE")));
    }
})(module.exports, function(exports1, _react, _propTypes) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Plane = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var Plane = exports1.Plane = function Plane(props) {
        return _react2.default.createElement("svg", {
            className: "react-spinner-loader-svg-calLoader",
            xmlns: "http://www.w3.org/2000/svg",
            width: "230",
            height: "230",
            "aria-label": props.label
        }, _react2.default.createElement("desc", null, "Plane animation. Loading "), _react2.default.createElement("path", {
            className: "react-spinner-loader-cal-loader__path",
            style: {
                stroke: props.secondaryColor
            },
            d: "M86.429 40c63.616-20.04 101.511 25.08 107.265 61.93 6.487 41.54-18.593 76.99-50.6 87.643-59.46 19.791-101.262-23.577-107.142-62.616C29.398 83.441 59.945 48.343 86.43 40z",
            fill: "none",
            stroke: "#0099cc",
            strokeWidth: "4",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "10 10 10 10 10 10 10 432",
            strokeDashoffset: "77"
        }), _react2.default.createElement("path", {
            className: "cal-loader__plane",
            style: {
                fill: props.color
            },
            d: "M141.493 37.93c-1.087-.927-2.942-2.002-4.32-2.501-2.259-.824-3.252-.955-9.293-1.172-4.017-.146-5.197-.23-5.47-.37-.766-.407-1.526-1.448-7.114-9.773-4.8-7.145-5.344-7.914-6.327-8.976-1.214-1.306-1.396-1.378-3.79-1.473-1.036-.04-2-.043-2.153-.002-.353.1-.87.586-1 .952-.139.399-.076.71.431 2.22.241.72 1.029 3.386 1.742 5.918 1.644 5.844 2.378 8.343 2.863 9.705.206.601.33 1.1.275 1.125-.24.097-10.56 1.066-11.014 1.032a3.532 3.532 0 0 1-1.002-.276l-.487-.246-2.044-2.613c-2.234-2.87-2.228-2.864-3.35-3.309-.717-.287-2.82-.386-3.276-.163-.457.237-.727.644-.737 1.152-.018.39.167.805 1.916 4.373 1.06 2.166 1.964 4.083 1.998 4.27.04.179.004.521-.076.75-.093.228-1.109 2.064-2.269 4.088-1.921 3.34-2.11 3.711-2.123 4.107-.008.25.061.557.168.725.328.512.72.644 1.966.676 1.32.029 2.352-.236 3.05-.762.222-.171 1.275-1.313 2.412-2.611 1.918-2.185 2.048-2.32 2.45-2.505.241-.111.601-.232.82-.271.267-.058 2.213.201 5.912.8 3.036.48 5.525.894 5.518.914 0 .026-.121.306-.27.638-.54 1.198-1.515 3.842-3.35 9.021-1.029 2.913-2.107 5.897-2.4 6.62-.703 1.748-.725 1.833-.594 2.286.137.46.45.833.872 1.012.41.177 3.823.24 4.37.085.852-.25 1.44-.688 2.312-1.724 1.166-1.39 3.169-3.948 6.771-8.661 5.8-7.583 6.561-8.49 7.387-8.702.233-.065 2.828-.056 5.784.011 5.827.138 6.64.09 8.62-.5 2.24-.67 4.035-1.65 5.517-3.016 1.136-1.054 1.135-1.014.207-1.962-.357-.38-.767-.777-.902-.893z",
            fill: "#000033"
        }));
    };
    Plane.propTypes = {
        secondaryColor: _propTypes2.default.string,
        color: _propTypes2.default.string,
        label: _propTypes2.default.string
    };
    Plane.defaultProps = {
        secondaryColor: "grey",
        color: "#FFA500",
        label: "async-loading"
    };
});

});

parcelRegister("fEMmz", function(module, exports) {


(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("Fo7oF")), (parcelRequire("d2bgE")));
    }
})(module.exports, function(exports1, _react, _propTypes) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Puff = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var Puff = exports1.Puff = function Puff(props) {
        return _react2.default.createElement("svg", {
            width: props.width,
            height: props.height,
            viewBox: "0 0 44 44",
            xmlns: "http://www.w3.org/2000/svg",
            stroke: props.color,
            "aria-label": props.label
        }, _react2.default.createElement("g", {
            fill: "none",
            fillRule: "evenodd",
            strokeWidth: "2"
        }, _react2.default.createElement("circle", {
            cx: "22",
            cy: "22",
            r: props.radius
        }, _react2.default.createElement("animate", {
            attributeName: "r",
            begin: "0s",
            dur: "1.8s",
            values: "1; 20",
            calcMode: "spline",
            keyTimes: "0; 1",
            keySplines: "0.165, 0.84, 0.44, 1",
            repeatCount: "indefinite"
        }), _react2.default.createElement("animate", {
            attributeName: "strokeOpacity",
            begin: "0s",
            dur: "1.8s",
            values: "1; 0",
            calcMode: "spline",
            keyTimes: "0; 1",
            keySplines: "0.3, 0.61, 0.355, 1",
            repeatCount: "indefinite"
        })), _react2.default.createElement("circle", {
            cx: "22",
            cy: "22",
            r: props.radius
        }, _react2.default.createElement("animate", {
            attributeName: "r",
            begin: "-0.9s",
            dur: "1.8s",
            values: "1; 20",
            calcMode: "spline",
            keyTimes: "0; 1",
            keySplines: "0.165, 0.84, 0.44, 1",
            repeatCount: "indefinite"
        }), _react2.default.createElement("animate", {
            attributeName: "strokeOpacity",
            begin: "-0.9s",
            dur: "1.8s",
            values: "1; 0",
            calcMode: "spline",
            keyTimes: "0; 1",
            keySplines: "0.3, 0.61, 0.355, 1",
            repeatCount: "indefinite"
        }))));
    };
    Puff.propTypes = {
        height: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        width: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        color: _propTypes2.default.string,
        label: _propTypes2.default.string,
        radius: _propTypes2.default.number
    };
    Puff.defaultProps = {
        height: 80,
        width: 80,
        color: "green",
        label: "audio-loading",
        radius: 1
    };
});

});

parcelRegister("lKq17", function(module, exports) {


(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("Fo7oF")), (parcelRequire("d2bgE")));
    }
})(module.exports, function(exports1, _react, _propTypes) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.RevolvingDot = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var RevolvingDot = exports1.RevolvingDot = function RevolvingDot(props) {
        return _react2.default.createElement("svg", {
            version: "1.1",
            width: props.width,
            height: props.height,
            xmlns: "http://www.w3.org/2000/svg",
            x: "0px",
            y: "0px",
            "aria-label": props.label
        }, _react2.default.createElement("circle", {
            fill: "none",
            stroke: props.color,
            strokeWidth: "4",
            cx: "50",
            cy: "50",
            r: props.radius + 38,
            style: {
                opacity: 0.5
            }
        }), _react2.default.createElement("circle", {
            fill: props.color,
            stroke: props.color,
            strokeWidth: "3",
            cx: "8",
            cy: "54",
            r: props.radius
        }, _react2.default.createElement("animateTransform", {
            attributeName: "transform",
            dur: "2s",
            type: "rotate",
            from: "0 50 48",
            to: "360 50 52",
            repeatCount: "indefinite"
        })));
    };
    RevolvingDot.propTypes = {
        height: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        width: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        color: _propTypes2.default.string,
        label: _propTypes2.default.string,
        radius: _propTypes2.default.number
    };
    RevolvingDot.defaultProps = {
        height: 80,
        width: 80,
        color: "green",
        label: "audio-loading",
        radius: 6
    };
});

});

parcelRegister("aVvOT", function(module, exports) {


(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("Fo7oF")), (parcelRequire("d2bgE")));
    }
})(module.exports, function(exports1, _react, _propTypes) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Rings = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var Rings = exports1.Rings = function Rings(props) {
        return _react2.default.createElement("svg", {
            width: props.width,
            height: props.height,
            viewBox: "0 0 45 45",
            xmlns: "http://www.w3.org/2000/svg",
            stroke: props.color,
            "aria-label": props.label
        }, _react2.default.createElement("g", {
            fill: "none",
            fillRule: "evenodd",
            transform: "translate(1 1)",
            strokeWidth: "2"
        }, _react2.default.createElement("circle", {
            cx: "22",
            cy: "22",
            r: props.radius,
            strokeOpacity: "0"
        }, _react2.default.createElement("animate", {
            attributeName: "r",
            begin: "1.5s",
            dur: "3s",
            values: "6;22",
            calcMode: "linear",
            repeatCount: "indefinite"
        }), _react2.default.createElement("animate", {
            attributeName: "stroke-opacity",
            begin: "1.5s",
            dur: "3s",
            values: "1;0",
            calcMode: "linear",
            repeatCount: "indefinite"
        }), _react2.default.createElement("animate", {
            attributeName: "stroke-width",
            begin: "1.5s",
            dur: "3s",
            values: "2;0",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("circle", {
            cx: "22",
            cy: "22",
            r: props.radius,
            strokeOpacity: "0"
        }, _react2.default.createElement("animate", {
            attributeName: "r",
            begin: "3s",
            dur: "3s",
            values: "6;22",
            calcMode: "linear",
            repeatCount: "indefinite"
        }), _react2.default.createElement("animate", {
            attributeName: "strokeOpacity",
            begin: "3s",
            dur: "3s",
            values: "1;0",
            calcMode: "linear",
            repeatCount: "indefinite"
        }), _react2.default.createElement("animate", {
            attributeName: "strokeWidth",
            begin: "3s",
            dur: "3s",
            values: "2;0",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("circle", {
            cx: "22",
            cy: "22",
            r: props.radius + 2
        }, _react2.default.createElement("animate", {
            attributeName: "r",
            begin: "0s",
            dur: "1.5s",
            values: "6;1;2;3;4;5;6",
            calcMode: "linear",
            repeatCount: "indefinite"
        }))));
    };
    Rings.propTypes = {
        height: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        width: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        color: _propTypes2.default.string,
        label: _propTypes2.default.string,
        radius: _propTypes2.default.number
    };
    Rings.defaultProps = {
        height: 80,
        width: 80,
        color: "green",
        radius: 6,
        label: "audio-loading"
    };
});

});

parcelRegister("eLM4T", function(module, exports) {


(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("Fo7oF")), (parcelRequire("d2bgE")));
    }
})(module.exports, function(exports1, _react, _propTypes) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.TailSpin = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var TailSpin = exports1.TailSpin = function TailSpin(props) {
        return _react2.default.createElement("svg", {
            width: props.width,
            height: props.height,
            viewBox: "0 0 38 38",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-label": props.label
        }, _react2.default.createElement("defs", null, _react2.default.createElement("linearGradient", {
            x1: "8.042%",
            y1: "0%",
            x2: "65.682%",
            y2: "23.865%",
            id: "a"
        }, _react2.default.createElement("stop", {
            stopColor: props.color,
            stopOpacity: "0",
            offset: "0%"
        }), _react2.default.createElement("stop", {
            stopColor: props.color,
            stopOpacity: ".631",
            offset: "63.146%"
        }), _react2.default.createElement("stop", {
            stopColor: props.color,
            offset: "100%"
        }))), _react2.default.createElement("g", {
            fill: "none",
            fillRule: "evenodd"
        }, _react2.default.createElement("g", {
            transform: "translate(1 1)"
        }, _react2.default.createElement("path", {
            d: "M36 18c0-9.94-8.06-18-18-18",
            id: "Oval-2",
            stroke: props.color,
            strokeWidth: "2"
        }, _react2.default.createElement("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 18 18",
            to: "360 18 18",
            dur: "0.9s",
            repeatCount: "indefinite"
        })), _react2.default.createElement("circle", {
            fill: "#fff",
            cx: "36",
            cy: "18",
            r: props.radius
        }, _react2.default.createElement("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 18 18",
            to: "360 18 18",
            dur: "0.9s",
            repeatCount: "indefinite"
        })))));
    };
    TailSpin.propTypes = {
        height: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        width: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        color: _propTypes2.default.string,
        label: _propTypes2.default.string,
        radius: _propTypes2.default.number
    };
    TailSpin.defaultProps = {
        height: 80,
        width: 80,
        color: "green",
        radius: 1,
        label: "audio-loading"
    };
});

});

parcelRegister("9rO5s", function(module, exports) {


(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("Fo7oF")), (parcelRequire("d2bgE")));
    }
})(module.exports, function(exports1, _react, _propTypes) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.ThreeDots = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var ThreeDots = exports1.ThreeDots = function ThreeDots(props) {
        return _react2.default.createElement("svg", {
            width: props.width,
            height: props.height,
            viewBox: "0 0 120 30",
            xmlns: "http://www.w3.org/2000/svg",
            fill: props.color,
            "aria-label": props.label
        }, _react2.default.createElement("circle", {
            cx: "15",
            cy: "15",
            r: props.radius + 6
        }, _react2.default.createElement("animate", {
            attributeName: "r",
            from: "15",
            to: "15",
            begin: "0s",
            dur: "0.8s",
            values: "15;9;15",
            calcMode: "linear",
            repeatCount: "indefinite"
        }), _react2.default.createElement("animate", {
            attributeName: "fillOpacity",
            from: "1",
            to: "1",
            begin: "0s",
            dur: "0.8s",
            values: "1;.5;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("circle", {
            cx: "60",
            cy: "15",
            r: props.radius,
            attributeName: "fillOpacity",
            from: "1",
            to: "0.3"
        }, _react2.default.createElement("animate", {
            attributeName: "r",
            from: "9",
            to: "9",
            begin: "0s",
            dur: "0.8s",
            values: "9;15;9",
            calcMode: "linear",
            repeatCount: "indefinite"
        }), _react2.default.createElement("animate", {
            attributeName: "fillOpacity",
            from: "0.5",
            to: "0.5",
            begin: "0s",
            dur: "0.8s",
            values: ".5;1;.5",
            calcMode: "linear",
            repeatCount: "indefinite"
        })), _react2.default.createElement("circle", {
            cx: "105",
            cy: "15",
            r: props.radius + 6
        }, _react2.default.createElement("animate", {
            attributeName: "r",
            from: "15",
            to: "15",
            begin: "0s",
            dur: "0.8s",
            values: "15;9;15",
            calcMode: "linear",
            repeatCount: "indefinite"
        }), _react2.default.createElement("animate", {
            attributeName: "fillOpacity",
            from: "1",
            to: "1",
            begin: "0s",
            dur: "0.8s",
            values: "1;.5;1",
            calcMode: "linear",
            repeatCount: "indefinite"
        })));
    };
    ThreeDots.propTypes = {
        height: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        width: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        color: _propTypes2.default.string,
        label: _propTypes2.default.string,
        radius: _propTypes2.default.number
    };
    ThreeDots.defaultProps = {
        height: 80,
        width: 80,
        color: "green",
        label: "audio-loading",
        radius: 9
    };
});

});

parcelRegister("ksoy4", function(module, exports) {


(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("Fo7oF")), (parcelRequire("d2bgE")));
    }
})(module.exports, function(exports1, _react, _propTypes) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Triangle = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var Triangle = exports1.Triangle = function Triangle(props) {
        return _react2.default.createElement("div", {
            className: "react-spinner-loader-svg"
        }, _react2.default.createElement("svg", {
            id: "triangle",
            width: props.width,
            height: props.height,
            viewBox: "-3 -4 39 39",
            "aria-label": props.label
        }, _react2.default.createElement("polygon", {
            fill: "transparent",
            stroke: props.color,
            strokeWidth: "1",
            points: "16,0 32,32 0,32"
        })));
    };
    Triangle.propTypes = {
        height: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        width: _propTypes2.default.oneOfType([
            _propTypes2.default.string,
            _propTypes2.default.number
        ]),
        color: _propTypes2.default.string,
        label: _propTypes2.default.string
    };
    Triangle.defaultProps = {
        height: 80,
        width: 80,
        color: "green",
        label: "audio-loading"
    };
});

});




var $eFTP6 = parcelRequire("eFTP6");
var $9a05c68f35451eac$exports = {};
(function(global1) {
    /**
   * Polyfill URLSearchParams
   *
   * Inspired from : https://github.com/WebReflection/url-search-params/blob/master/src/url-search-params.js
   */ var checkIfIteratorIsSupported = function() {
        try {
            return !!Symbol.iterator;
        } catch (error) {
            return false;
        }
    };
    var iteratorSupported = checkIfIteratorIsSupported();
    var createIterator = function(items) {
        var iterator = {
            next: function() {
                var value = items.shift();
                return {
                    done: value === void 0,
                    value: value
                };
            }
        };
        if (iteratorSupported) iterator[Symbol.iterator] = function() {
            return iterator;
        };
        return iterator;
    };
    /**
   * Search param name and values should be encoded according to https://url.spec.whatwg.org/#urlencoded-serializing
   * encodeURIComponent() produces the same result except encoding spaces as `%20` instead of `+`.
   */ var serializeParam = function(value) {
        return encodeURIComponent(value).replace(/%20/g, '+');
    };
    var deserializeParam = function(value) {
        return decodeURIComponent(String(value).replace(/\+/g, ' '));
    };
    var polyfillURLSearchParams = function() {
        var URLSearchParams = function(searchString) {
            Object.defineProperty(this, '_entries', {
                writable: true,
                value: {}
            });
            var typeofSearchString = typeof searchString;
            if (typeofSearchString === 'undefined') ;
            else if (typeofSearchString === 'string') {
                if (searchString !== '') this._fromString(searchString);
            } else if (searchString instanceof URLSearchParams) {
                var _this = this;
                searchString.forEach(function(value, name) {
                    _this.append(name, value);
                });
            } else if (searchString !== null && typeofSearchString === 'object') {
                if (Object.prototype.toString.call(searchString) === '[object Array]') for(var i = 0; i < searchString.length; i++){
                    var entry = searchString[i];
                    if (Object.prototype.toString.call(entry) === '[object Array]' || entry.length !== 2) this.append(entry[0], entry[1]);
                    else throw new TypeError('Expected [string, any] as entry at index ' + i + ' of URLSearchParams\'s input');
                }
                else {
                    for(var key in searchString)if (searchString.hasOwnProperty(key)) this.append(key, searchString[key]);
                }
            } else throw new TypeError('Unsupported input\'s type for URLSearchParams');
        };
        var proto = URLSearchParams.prototype;
        proto.append = function(name, value) {
            if (name in this._entries) this._entries[name].push(String(value));
            else this._entries[name] = [
                String(value)
            ];
        };
        proto.delete = function(name) {
            delete this._entries[name];
        };
        proto.get = function(name) {
            return name in this._entries ? this._entries[name][0] : null;
        };
        proto.getAll = function(name) {
            return name in this._entries ? this._entries[name].slice(0) : [];
        };
        proto.has = function(name) {
            return name in this._entries;
        };
        proto.set = function(name, value) {
            this._entries[name] = [
                String(value)
            ];
        };
        proto.forEach = function(callback, thisArg) {
            var entries;
            for(var name in this._entries)if (this._entries.hasOwnProperty(name)) {
                entries = this._entries[name];
                for(var i = 0; i < entries.length; i++)callback.call(thisArg, entries[i], name, this);
            }
        };
        proto.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return createIterator(items);
        };
        proto.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return createIterator(items);
        };
        proto.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return createIterator(items);
        };
        if (iteratorSupported) proto[Symbol.iterator] = proto.entries;
        proto.toString = function() {
            var searchArray = [];
            this.forEach(function(value, name) {
                searchArray.push(serializeParam(name) + '=' + serializeParam(value));
            });
            return searchArray.join('&');
        };
        Object.defineProperty(proto, 'size', {
            get: function() {
                return this._entries ? Object.keys(this._entries).length : 0;
            }
        });
        global1.URLSearchParams = URLSearchParams;
    };
    var checkIfURLSearchParamsSupported = function() {
        try {
            var URLSearchParams = global1.URLSearchParams;
            return new URLSearchParams('?a=1').toString() === 'a=1' && typeof URLSearchParams.prototype.set === 'function' && typeof URLSearchParams.prototype.entries === 'function';
        } catch (e) {
            return false;
        }
    };
    if (!checkIfURLSearchParamsSupported()) polyfillURLSearchParams();
    var proto = global1.URLSearchParams.prototype;
    if (typeof proto.sort !== 'function') proto.sort = function() {
        var _this = this;
        var items = [];
        this.forEach(function(value, name) {
            items.push([
                name,
                value
            ]);
            if (!_this._entries) _this.delete(name);
        });
        items.sort(function(a, b) {
            if (a[0] < b[0]) return -1;
            else if (a[0] > b[0]) return 1;
            else return 0;
        });
        if (_this._entries) _this._entries = {};
        for(var i = 0; i < items.length; i++)this.append(items[i][0], items[i][1]);
    };
    if (typeof proto._fromString !== 'function') Object.defineProperty(proto, '_fromString', {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function(searchString) {
            if (this._entries) this._entries = {};
            else {
                var keys = [];
                this.forEach(function(value, name) {
                    keys.push(name);
                });
                for(var i = 0; i < keys.length; i++)this.delete(keys[i]);
            }
            searchString = searchString.replace(/^\?/, '');
            var attributes = searchString.split('&');
            var attribute;
            for(var i = 0; i < attributes.length; i++){
                attribute = attributes[i].split('=');
                this.append(deserializeParam(attribute[0]), attribute.length > 1 ? deserializeParam(attribute.slice(1).join('=')) : '');
            }
        }
    });
// HTMLAnchorElement
})(typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : $9a05c68f35451eac$exports);
(function(global1) {
    /**
   * Polyfill URL
   *
   * Inspired from : https://github.com/arv/DOM-URL-Polyfill/blob/master/src/url.js
   */ var checkIfURLIsSupported = function() {
        try {
            var u = new global1.URL('b', 'http://a');
            u.pathname = 'c d';
            return u.href === 'http://a/c%20d' && u.searchParams;
        } catch (e) {
            return false;
        }
    };
    var polyfillURL = function() {
        var _URL = global1.URL;
        var URL = function(url, base) {
            if (typeof url !== 'string') url = String(url);
            if (base && typeof base !== 'string') base = String(base);
            // Only create another document if the base is different from current location.
            var doc = document, baseElement;
            if (base && (global1.location === void 0 || base !== global1.location.href)) {
                var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
                if (isIE11) base = base.toLowerCase();
                doc = document.implementation.createHTMLDocument('');
                baseElement = doc.createElement('base');
                baseElement.href = base;
                doc.head.appendChild(baseElement);
                try {
                    if (baseElement.href.indexOf(base) !== 0) throw new Error(baseElement.href);
                } catch (err) {
                    throw new Error('URL unable to set base ' + base + ' due to ' + err);
                }
            }
            var anchorElement = doc.createElement('a');
            anchorElement.href = url;
            if (baseElement) {
                doc.body.appendChild(anchorElement);
                anchorElement.href = anchorElement.href; // force href to refresh
            }
            var inputElement = doc.createElement('input');
            inputElement.type = 'url';
            inputElement.value = url;
            if (anchorElement.protocol === ':' || !/:/.test(anchorElement.href) || !inputElement.checkValidity() && !base) throw new TypeError('Invalid URL');
            Object.defineProperty(this, '_anchorElement', {
                value: anchorElement
            });
            // create a linked searchParams which reflect its changes on URL
            var searchParams = new global1.URLSearchParams(this.search);
            var enableSearchUpdate = true;
            var enableSearchParamsUpdate = true;
            var _this = this;
            [
                'append',
                'delete',
                'set'
            ].forEach(function(methodName) {
                var method = searchParams[methodName];
                searchParams[methodName] = function() {
                    method.apply(searchParams, arguments);
                    if (enableSearchUpdate) {
                        enableSearchParamsUpdate = false;
                        _this.search = searchParams.toString();
                        enableSearchParamsUpdate = true;
                    }
                };
            });
            Object.defineProperty(this, 'searchParams', {
                value: searchParams,
                enumerable: true
            });
            var search = void 0;
            Object.defineProperty(this, '_updateSearchParams', {
                enumerable: false,
                configurable: false,
                writable: false,
                value: function() {
                    if (this.search !== search) {
                        search = this.search;
                        if (enableSearchParamsUpdate) {
                            enableSearchUpdate = false;
                            this.searchParams._fromString(this.search);
                            enableSearchUpdate = true;
                        }
                    }
                }
            });
        };
        var proto = URL.prototype;
        var linkURLWithAnchorAttribute = function(attributeName) {
            Object.defineProperty(proto, attributeName, {
                get: function() {
                    return this._anchorElement[attributeName];
                },
                set: function(value) {
                    this._anchorElement[attributeName] = value;
                },
                enumerable: true
            });
        };
        [
            'hash',
            'host',
            'hostname',
            'port',
            'protocol'
        ].forEach(function(attributeName) {
            linkURLWithAnchorAttribute(attributeName);
        });
        Object.defineProperty(proto, 'search', {
            get: function() {
                return this._anchorElement['search'];
            },
            set: function(value) {
                this._anchorElement['search'] = value;
                this._updateSearchParams();
            },
            enumerable: true
        });
        Object.defineProperties(proto, {
            'toString': {
                get: function() {
                    var _this = this;
                    return function() {
                        return _this.href;
                    };
                }
            },
            'href': {
                get: function() {
                    return this._anchorElement.href.replace(/\?$/, '');
                },
                set: function(value) {
                    this._anchorElement.href = value;
                    this._updateSearchParams();
                },
                enumerable: true
            },
            'pathname': {
                get: function() {
                    return this._anchorElement.pathname.replace(/(^\/?)/, '/');
                },
                set: function(value) {
                    this._anchorElement.pathname = value;
                },
                enumerable: true
            },
            'origin': {
                get: function() {
                    // get expected port from protocol
                    var expectedPort = {
                        'http:': 80,
                        'https:': 443,
                        'ftp:': 21
                    }[this._anchorElement.protocol];
                    // add port to origin if, expected port is different than actual port
                    // and it is not empty f.e http://foo:8080
                    // 8080 != 80 && 8080 != ''
                    var addPortToOrigin = this._anchorElement.port != expectedPort && this._anchorElement.port !== '';
                    return this._anchorElement.protocol + '//' + this._anchorElement.hostname + (addPortToOrigin ? ':' + this._anchorElement.port : '');
                },
                enumerable: true
            },
            'password': {
                get: function() {
                    return '';
                },
                set: function(value) {},
                enumerable: true
            },
            'username': {
                get: function() {
                    return '';
                },
                set: function(value) {},
                enumerable: true
            }
        });
        URL.createObjectURL = function(blob) {
            return _URL.createObjectURL.apply(_URL, arguments);
        };
        URL.revokeObjectURL = function(url) {
            return _URL.revokeObjectURL.apply(_URL, arguments);
        };
        global1.URL = URL;
    };
    if (!checkIfURLIsSupported()) polyfillURL();
    if (global1.location !== void 0 && !('origin' in global1.location)) {
        var getOrigin = function() {
            return global1.location.protocol + '//' + global1.location.hostname + (global1.location.port ? ':' + global1.location.port : '');
        };
        try {
            Object.defineProperty(global1.location, 'origin', {
                get: getOrigin,
                enumerable: true
            });
        } catch (e) {
            setInterval(function() {
                global1.location.origin = getOrigin();
            }, 100);
        }
    }
})(typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : $9a05c68f35451eac$exports);


"use strict";
"use strict";
var $40eda3d290c1d2c0$exports = {};
'use strict';

var $gtY0w = parcelRequire("gtY0w");

var $lXZiV = parcelRequire("lXZiV");

var $8iMRJ = parcelRequire("8iMRJ");

var $2SWGI = parcelRequire("2SWGI");

var $bIIwe = parcelRequire("bIIwe");

var $gfLLt = parcelRequire("gfLLt");
var $f61d36e6d152f8da$require$META = $gfLLt.KEY;

var $QlNUq = parcelRequire("QlNUq");

var $4CirF = parcelRequire("4CirF");

var $aXF7u = parcelRequire("aXF7u");

var $jwR22 = parcelRequire("jwR22");

var $fqMqf = parcelRequire("fqMqf");

var $8IDtE = parcelRequire("8IDtE");

var $lWstx = parcelRequire("lWstx");
var $a733da55fba03ed7$exports = {};
// all enumerable object keys, includes symbols

var $1ttxT = parcelRequire("1ttxT");

var $iZji0 = parcelRequire("iZji0");

var $iC2yD = parcelRequire("iC2yD");
$a733da55fba03ed7$exports = function(it) {
    var result = $1ttxT(it);
    var getSymbols = $iZji0.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $iC2yD.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};



var $1y0po = parcelRequire("1y0po");

var $bmSbf = parcelRequire("bmSbf");

var $lD7l7 = parcelRequire("lD7l7");

var $7bwTf = parcelRequire("7bwTf");

var $5T7Du = parcelRequire("5T7Du");

var $01Csn = parcelRequire("01Csn");

var $cttRt = parcelRequire("cttRt");

var $3upGD = parcelRequire("3upGD");

var $4nIN6 = parcelRequire("4nIN6");

var $11pTE = parcelRequire("11pTE");

var $iZji0 = parcelRequire("iZji0");

var $8QaBR = parcelRequire("8QaBR");

var $1ttxT = parcelRequire("1ttxT");
var $f61d36e6d152f8da$var$gOPD = $11pTE.f;
var $f61d36e6d152f8da$var$dP = $8QaBR.f;
var $f61d36e6d152f8da$var$gOPN = $4nIN6.f;
var $f61d36e6d152f8da$var$$Symbol = $gtY0w.Symbol;
var $f61d36e6d152f8da$var$$JSON = $gtY0w.JSON;
var $f61d36e6d152f8da$var$_stringify = $f61d36e6d152f8da$var$$JSON && $f61d36e6d152f8da$var$$JSON.stringify;
var $f61d36e6d152f8da$var$PROTOTYPE = 'prototype';
var $f61d36e6d152f8da$var$HIDDEN = $fqMqf('_hidden');
var $f61d36e6d152f8da$var$TO_PRIMITIVE = $fqMqf('toPrimitive');
var $f61d36e6d152f8da$var$isEnum = {}.propertyIsEnumerable;
var $f61d36e6d152f8da$var$SymbolRegistry = $4CirF('symbol-registry');
var $f61d36e6d152f8da$var$AllSymbols = $4CirF('symbols');
var $f61d36e6d152f8da$var$OPSymbols = $4CirF('op-symbols');
var $f61d36e6d152f8da$var$ObjectProto = Object[$f61d36e6d152f8da$var$PROTOTYPE];
var $f61d36e6d152f8da$var$USE_NATIVE = typeof $f61d36e6d152f8da$var$$Symbol == 'function' && !!$iZji0.f;
var $f61d36e6d152f8da$var$QObject = $gtY0w.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $f61d36e6d152f8da$var$setter = !$f61d36e6d152f8da$var$QObject || !$f61d36e6d152f8da$var$QObject[$f61d36e6d152f8da$var$PROTOTYPE] || !$f61d36e6d152f8da$var$QObject[$f61d36e6d152f8da$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $f61d36e6d152f8da$var$setSymbolDesc = $8iMRJ && $QlNUq(function() {
    return $3upGD($f61d36e6d152f8da$var$dP({}, 'a', {
        get: function() {
            return $f61d36e6d152f8da$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $f61d36e6d152f8da$var$gOPD($f61d36e6d152f8da$var$ObjectProto, key);
    if (protoDesc) delete $f61d36e6d152f8da$var$ObjectProto[key];
    $f61d36e6d152f8da$var$dP(it, key, D);
    if (protoDesc && it !== $f61d36e6d152f8da$var$ObjectProto) $f61d36e6d152f8da$var$dP($f61d36e6d152f8da$var$ObjectProto, key, protoDesc);
} : $f61d36e6d152f8da$var$dP;
var $f61d36e6d152f8da$var$wrap = function(tag) {
    var sym = $f61d36e6d152f8da$var$AllSymbols[tag] = $3upGD($f61d36e6d152f8da$var$$Symbol[$f61d36e6d152f8da$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $f61d36e6d152f8da$var$isSymbol = $f61d36e6d152f8da$var$USE_NATIVE && typeof $f61d36e6d152f8da$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $f61d36e6d152f8da$var$$Symbol;
};
var $f61d36e6d152f8da$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $f61d36e6d152f8da$var$ObjectProto) $f61d36e6d152f8da$var$$defineProperty($f61d36e6d152f8da$var$OPSymbols, key, D);
    $bmSbf(it);
    key = $01Csn(key, true);
    $bmSbf(D);
    if ($lXZiV($f61d36e6d152f8da$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$lXZiV(it, $f61d36e6d152f8da$var$HIDDEN)) $f61d36e6d152f8da$var$dP(it, $f61d36e6d152f8da$var$HIDDEN, $cttRt(1, {}));
            it[$f61d36e6d152f8da$var$HIDDEN][key] = true;
        } else {
            if ($lXZiV(it, $f61d36e6d152f8da$var$HIDDEN) && it[$f61d36e6d152f8da$var$HIDDEN][key]) it[$f61d36e6d152f8da$var$HIDDEN][key] = false;
            D = $3upGD(D, {
                enumerable: $cttRt(0, false)
            });
        }
        return $f61d36e6d152f8da$var$setSymbolDesc(it, key, D);
    }
    return $f61d36e6d152f8da$var$dP(it, key, D);
};
var $f61d36e6d152f8da$var$$defineProperties = function defineProperties(it, P) {
    $bmSbf(it);
    var keys = $a733da55fba03ed7$exports(P = $5T7Du(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$f61d36e6d152f8da$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $f61d36e6d152f8da$var$$create = function create(it, P) {
    return P === undefined ? $3upGD(it) : $f61d36e6d152f8da$var$$defineProperties($3upGD(it), P);
};
var $f61d36e6d152f8da$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $f61d36e6d152f8da$var$isEnum.call(this, key = $01Csn(key, true));
    if (this === $f61d36e6d152f8da$var$ObjectProto && $lXZiV($f61d36e6d152f8da$var$AllSymbols, key) && !$lXZiV($f61d36e6d152f8da$var$OPSymbols, key)) return false;
    return E || !$lXZiV(this, key) || !$lXZiV($f61d36e6d152f8da$var$AllSymbols, key) || $lXZiV(this, $f61d36e6d152f8da$var$HIDDEN) && this[$f61d36e6d152f8da$var$HIDDEN][key] ? E : true;
};
var $f61d36e6d152f8da$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $5T7Du(it);
    key = $01Csn(key, true);
    if (it === $f61d36e6d152f8da$var$ObjectProto && $lXZiV($f61d36e6d152f8da$var$AllSymbols, key) && !$lXZiV($f61d36e6d152f8da$var$OPSymbols, key)) return;
    var D = $f61d36e6d152f8da$var$gOPD(it, key);
    if (D && $lXZiV($f61d36e6d152f8da$var$AllSymbols, key) && !($lXZiV(it, $f61d36e6d152f8da$var$HIDDEN) && it[$f61d36e6d152f8da$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $f61d36e6d152f8da$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $f61d36e6d152f8da$var$gOPN($5T7Du(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$lXZiV($f61d36e6d152f8da$var$AllSymbols, key = names[i++]) && key != $f61d36e6d152f8da$var$HIDDEN && key != $f61d36e6d152f8da$require$META) result.push(key);
    return result;
};
var $f61d36e6d152f8da$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $f61d36e6d152f8da$var$ObjectProto;
    var names = $f61d36e6d152f8da$var$gOPN(IS_OP ? $f61d36e6d152f8da$var$OPSymbols : $5T7Du(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($lXZiV($f61d36e6d152f8da$var$AllSymbols, key = names[i++]) && (IS_OP ? $lXZiV($f61d36e6d152f8da$var$ObjectProto, key) : true)) result.push($f61d36e6d152f8da$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$f61d36e6d152f8da$var$USE_NATIVE) {
    $f61d36e6d152f8da$var$$Symbol = function Symbol() {
        if (this instanceof $f61d36e6d152f8da$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $jwR22(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $f61d36e6d152f8da$var$ObjectProto) $set.call($f61d36e6d152f8da$var$OPSymbols, value);
            if ($lXZiV(this, $f61d36e6d152f8da$var$HIDDEN) && $lXZiV(this[$f61d36e6d152f8da$var$HIDDEN], tag)) this[$f61d36e6d152f8da$var$HIDDEN][tag] = false;
            $f61d36e6d152f8da$var$setSymbolDesc(this, tag, $cttRt(1, value));
        };
        if ($8iMRJ && $f61d36e6d152f8da$var$setter) $f61d36e6d152f8da$var$setSymbolDesc($f61d36e6d152f8da$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $f61d36e6d152f8da$var$wrap(tag);
    };
    $bIIwe($f61d36e6d152f8da$var$$Symbol[$f61d36e6d152f8da$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $11pTE.f = $f61d36e6d152f8da$var$$getOwnPropertyDescriptor;
    $8QaBR.f = $f61d36e6d152f8da$var$$defineProperty;
    (parcelRequire("60lWN")).f = $4nIN6.f = $f61d36e6d152f8da$var$$getOwnPropertyNames;
    (parcelRequire("iC2yD")).f = $f61d36e6d152f8da$var$$propertyIsEnumerable;
    $iZji0.f = $f61d36e6d152f8da$var$$getOwnPropertySymbols;
    if ($8iMRJ && !(parcelRequire("8qcv4"))) $bIIwe($f61d36e6d152f8da$var$ObjectProto, 'propertyIsEnumerable', $f61d36e6d152f8da$var$$propertyIsEnumerable, true);
    $8IDtE.f = function(name) {
        return $f61d36e6d152f8da$var$wrap($fqMqf(name));
    };
}
$2SWGI($2SWGI.G + $2SWGI.W + $2SWGI.F * !$f61d36e6d152f8da$var$USE_NATIVE, {
    Symbol: $f61d36e6d152f8da$var$$Symbol
});
for(var $f61d36e6d152f8da$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $f61d36e6d152f8da$var$j = 0; $f61d36e6d152f8da$var$es6Symbols.length > $f61d36e6d152f8da$var$j;)$fqMqf($f61d36e6d152f8da$var$es6Symbols[$f61d36e6d152f8da$var$j++]);
for(var $f61d36e6d152f8da$var$wellKnownSymbols = $1ttxT($fqMqf.store), $f61d36e6d152f8da$var$k = 0; $f61d36e6d152f8da$var$wellKnownSymbols.length > $f61d36e6d152f8da$var$k;)$lWstx($f61d36e6d152f8da$var$wellKnownSymbols[$f61d36e6d152f8da$var$k++]);
$2SWGI($2SWGI.S + $2SWGI.F * !$f61d36e6d152f8da$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $lXZiV($f61d36e6d152f8da$var$SymbolRegistry, key += '') ? $f61d36e6d152f8da$var$SymbolRegistry[key] : $f61d36e6d152f8da$var$SymbolRegistry[key] = $f61d36e6d152f8da$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$f61d36e6d152f8da$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $f61d36e6d152f8da$var$SymbolRegistry)if ($f61d36e6d152f8da$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $f61d36e6d152f8da$var$setter = true;
    },
    useSimple: function() {
        $f61d36e6d152f8da$var$setter = false;
    }
});
$2SWGI($2SWGI.S + $2SWGI.F * !$f61d36e6d152f8da$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $f61d36e6d152f8da$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $f61d36e6d152f8da$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $f61d36e6d152f8da$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $f61d36e6d152f8da$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $f61d36e6d152f8da$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $f61d36e6d152f8da$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $f61d36e6d152f8da$var$FAILS_ON_PRIMITIVES = $QlNUq(function() {
    $iZji0.f(1);
});
$2SWGI($2SWGI.S + $2SWGI.F * $f61d36e6d152f8da$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $iZji0.f($7bwTf(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$f61d36e6d152f8da$var$$JSON && $2SWGI($2SWGI.S + $2SWGI.F * (!$f61d36e6d152f8da$var$USE_NATIVE || $QlNUq(function() {
    var S = $f61d36e6d152f8da$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $f61d36e6d152f8da$var$_stringify([
        S
    ]) != '[null]' || $f61d36e6d152f8da$var$_stringify({
        a: S
    }) != '{}' || $f61d36e6d152f8da$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$lD7l7(replacer) && it === undefined || $f61d36e6d152f8da$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$1y0po(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$f61d36e6d152f8da$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $f61d36e6d152f8da$var$_stringify.apply($f61d36e6d152f8da$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$f61d36e6d152f8da$var$$Symbol[$f61d36e6d152f8da$var$PROTOTYPE][$f61d36e6d152f8da$var$TO_PRIMITIVE] || (parcelRequire("disfj"))($f61d36e6d152f8da$var$$Symbol[$f61d36e6d152f8da$var$PROTOTYPE], $f61d36e6d152f8da$var$TO_PRIMITIVE, $f61d36e6d152f8da$var$$Symbol[$f61d36e6d152f8da$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$aXF7u($f61d36e6d152f8da$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$aXF7u(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$aXF7u($gtY0w.JSON, 'JSON', true);



var $2SWGI = parcelRequire("2SWGI");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$2SWGI($2SWGI.S, 'Object', {
    create: (parcelRequire("3upGD"))
});



var $2SWGI = parcelRequire("2SWGI");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$2SWGI($2SWGI.S + $2SWGI.F * !(parcelRequire("8iMRJ")), 'Object', {
    defineProperty: (parcelRequire("8QaBR")).f
});



var $2SWGI = parcelRequire("2SWGI");


// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$2SWGI($2SWGI.S + $2SWGI.F * !(parcelRequire("8iMRJ")), 'Object', {
    defineProperties: (parcelRequire("829ny"))
});


// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)

var $5T7Du = parcelRequire("5T7Du");

var $11pTE = parcelRequire("11pTE");
var $2d2b626d5b643d2a$require$$getOwnPropertyDescriptor = $11pTE.f;

(parcelRequire("gb8Uy"))('getOwnPropertyDescriptor', function() {
    return function getOwnPropertyDescriptor(it, key) {
        return $2d2b626d5b643d2a$require$$getOwnPropertyDescriptor($5T7Du(it), key);
    };
});


// 19.1.2.9 Object.getPrototypeOf(O)

var $7bwTf = parcelRequire("7bwTf");

var $5nB59 = parcelRequire("5nB59");

(parcelRequire("gb8Uy"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $5nB59($7bwTf(it));
    };
});


// 19.1.2.14 Object.keys(O)

var $7bwTf = parcelRequire("7bwTf");

var $1ttxT = parcelRequire("1ttxT");

(parcelRequire("gb8Uy"))('keys', function() {
    return function keys(it) {
        return $1ttxT($7bwTf(it));
    };
});


// 19.1.2.7 Object.getOwnPropertyNames(O)


(parcelRequire("gb8Uy"))('getOwnPropertyNames', function() {
    return (parcelRequire("4nIN6")).f;
});


// 19.1.2.5 Object.freeze(O)

var $lD7l7 = parcelRequire("lD7l7");

var $gfLLt = parcelRequire("gfLLt");
var $12e6560b6a87fde7$require$meta = $gfLLt.onFreeze;

(parcelRequire("gb8Uy"))('freeze', function($freeze) {
    return function freeze(it) {
        return $freeze && $lD7l7(it) ? $freeze($12e6560b6a87fde7$require$meta(it)) : it;
    };
});


// 19.1.2.17 Object.seal(O)

var $lD7l7 = parcelRequire("lD7l7");

var $gfLLt = parcelRequire("gfLLt");
var $e62d43de5fa20922$require$meta = $gfLLt.onFreeze;

(parcelRequire("gb8Uy"))('seal', function($seal) {
    return function seal(it) {
        return $seal && $lD7l7(it) ? $seal($e62d43de5fa20922$require$meta(it)) : it;
    };
});


// 19.1.2.15 Object.preventExtensions(O)

var $lD7l7 = parcelRequire("lD7l7");

var $gfLLt = parcelRequire("gfLLt");
var $c4800243886efc4b$require$meta = $gfLLt.onFreeze;

(parcelRequire("gb8Uy"))('preventExtensions', function($preventExtensions) {
    return function preventExtensions(it) {
        return $preventExtensions && $lD7l7(it) ? $preventExtensions($c4800243886efc4b$require$meta(it)) : it;
    };
});


// 19.1.2.12 Object.isFrozen(O)

var $lD7l7 = parcelRequire("lD7l7");

(parcelRequire("gb8Uy"))('isFrozen', function($isFrozen) {
    return function isFrozen(it) {
        return $lD7l7(it) ? $isFrozen ? $isFrozen(it) : false : true;
    };
});


// 19.1.2.13 Object.isSealed(O)

var $lD7l7 = parcelRequire("lD7l7");

(parcelRequire("gb8Uy"))('isSealed', function($isSealed) {
    return function isSealed(it) {
        return $lD7l7(it) ? $isSealed ? $isSealed(it) : false : true;
    };
});


// 19.1.2.11 Object.isExtensible(O)

var $lD7l7 = parcelRequire("lD7l7");

(parcelRequire("gb8Uy"))('isExtensible', function($isExtensible) {
    return function isExtensible(it) {
        return $lD7l7(it) ? $isExtensible ? $isExtensible(it) : true : false;
    };
});


// 19.1.3.1 Object.assign(target, source)

var $2SWGI = parcelRequire("2SWGI");

$2SWGI($2SWGI.S + $2SWGI.F, 'Object', {
    assign: (parcelRequire("eHB8s"))
});


// 19.1.3.10 Object.is(value1, value2)

var $2SWGI = parcelRequire("2SWGI");

$2SWGI($2SWGI.S, 'Object', {
    is: (parcelRequire("382Uw"))
});


// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $2SWGI = parcelRequire("2SWGI");

$2SWGI($2SWGI.S, 'Object', {
    setPrototypeOf: (parcelRequire("FiBqq")).set
});


'use strict';

var $03JDo = parcelRequire("03JDo");
var $280ddc84839d8907$var$test = {};

var $fqMqf = parcelRequire("fqMqf");
$280ddc84839d8907$var$test[$fqMqf('toStringTag')] = 'z';

if ($280ddc84839d8907$var$test + '' != '[object z]') (parcelRequire("bIIwe"))(Object.prototype, 'toString', function toString() {
    return '[object ' + $03JDo(this) + ']';
}, true);


// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)

var $2SWGI = parcelRequire("2SWGI");

$2SWGI($2SWGI.P, 'Function', {
    bind: (parcelRequire("i9XH1"))
});



var $8QaBR = parcelRequire("8QaBR");
var $6ebc12c09d019381$require$dP = $8QaBR.f;
var $6ebc12c09d019381$var$FProto = Function.prototype;
var $6ebc12c09d019381$var$nameRE = /^\s*function ([^ (]*)/;
var $6ebc12c09d019381$var$NAME = 'name';

// 19.2.4.2 name
$6ebc12c09d019381$var$NAME in $6ebc12c09d019381$var$FProto || (parcelRequire("8iMRJ")) && $6ebc12c09d019381$require$dP($6ebc12c09d019381$var$FProto, $6ebc12c09d019381$var$NAME, {
    configurable: true,
    get: function() {
        try {
            return ('' + this).match($6ebc12c09d019381$var$nameRE)[1];
        } catch (e) {
            return '';
        }
    }
});


'use strict';

var $lD7l7 = parcelRequire("lD7l7");

var $5nB59 = parcelRequire("5nB59");

var $ab9fc0e420940156$var$HAS_INSTANCE = (parcelRequire("fqMqf"))('hasInstance');
var $ab9fc0e420940156$var$FunctionProto = Function.prototype;

// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!($ab9fc0e420940156$var$HAS_INSTANCE in $ab9fc0e420940156$var$FunctionProto)) (parcelRequire("8QaBR")).f($ab9fc0e420940156$var$FunctionProto, $ab9fc0e420940156$var$HAS_INSTANCE, {
    value: function(O) {
        if (typeof this != 'function' || !$lD7l7(O)) return false;
        if (!$lD7l7(this.prototype)) return O instanceof this;
        // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
        while(O = $5nB59(O))if (this.prototype === O) return true;
        return false;
    }
});



var $2SWGI = parcelRequire("2SWGI");
var $9d4c8e313a8218f1$exports = {};

var $gtY0w = parcelRequire("gtY0w");
var $9d4c8e313a8218f1$require$$parseInt = $gtY0w.parseInt;

var $7fWUt = parcelRequire("7fWUt");
var $9d4c8e313a8218f1$require$$trim = $7fWUt.trim;

var $d7QKc = parcelRequire("d7QKc");
var $9d4c8e313a8218f1$var$hex = /^[-+]?0[xX]/;
$9d4c8e313a8218f1$exports = $9d4c8e313a8218f1$require$$parseInt($d7QKc + '08') !== 8 || $9d4c8e313a8218f1$require$$parseInt($d7QKc + '0x16') !== 22 ? function parseInt(str, radix) {
    var string = $9d4c8e313a8218f1$require$$trim(String(str), 3);
    return $9d4c8e313a8218f1$require$$parseInt(string, radix >>> 0 || ($9d4c8e313a8218f1$var$hex.test(string) ? 16 : 10));
} : $9d4c8e313a8218f1$require$$parseInt;


// 18.2.5 parseInt(string, radix)
$2SWGI($2SWGI.G + $2SWGI.F * (parseInt != $9d4c8e313a8218f1$exports), {
    parseInt: $9d4c8e313a8218f1$exports
});



var $2SWGI = parcelRequire("2SWGI");
var $52de8d132fd39028$exports = {};

var $gtY0w = parcelRequire("gtY0w");
var $52de8d132fd39028$require$$parseFloat = $gtY0w.parseFloat;

var $7fWUt = parcelRequire("7fWUt");
var $52de8d132fd39028$require$$trim = $7fWUt.trim;

$52de8d132fd39028$exports = 1 / $52de8d132fd39028$require$$parseFloat((parcelRequire("d7QKc")) + '-0') !== -Infinity ? function parseFloat(str) {
    var string = $52de8d132fd39028$require$$trim(String(str), 3);
    var result = $52de8d132fd39028$require$$parseFloat(string);
    return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $52de8d132fd39028$require$$parseFloat;


// 18.2.4 parseFloat(string)
$2SWGI($2SWGI.G + $2SWGI.F * (parseFloat != $52de8d132fd39028$exports), {
    parseFloat: $52de8d132fd39028$exports
});


'use strict';

var $gtY0w = parcelRequire("gtY0w");

var $lXZiV = parcelRequire("lXZiV");

var $1Wc55 = parcelRequire("1Wc55");

var $gFUup = parcelRequire("gFUup");

var $01Csn = parcelRequire("01Csn");

var $QlNUq = parcelRequire("QlNUq");

var $60lWN = parcelRequire("60lWN");
var $4c430e436bf5c0a1$require$gOPN = $60lWN.f;

var $11pTE = parcelRequire("11pTE");
var $4c430e436bf5c0a1$require$gOPD = $11pTE.f;

var $8QaBR = parcelRequire("8QaBR");
var $4c430e436bf5c0a1$require$dP = $8QaBR.f;

var $7fWUt = parcelRequire("7fWUt");
var $4c430e436bf5c0a1$require$$trim = $7fWUt.trim;
var $4c430e436bf5c0a1$var$NUMBER = 'Number';
var $4c430e436bf5c0a1$var$$Number = $gtY0w[$4c430e436bf5c0a1$var$NUMBER];
var $4c430e436bf5c0a1$var$Base = $4c430e436bf5c0a1$var$$Number;
var $4c430e436bf5c0a1$var$proto = $4c430e436bf5c0a1$var$$Number.prototype;

// Opera ~12 has broken Object#toString
var $4c430e436bf5c0a1$var$BROKEN_COF = $1Wc55((parcelRequire("3upGD"))($4c430e436bf5c0a1$var$proto)) == $4c430e436bf5c0a1$var$NUMBER;
var $4c430e436bf5c0a1$var$TRIM = 'trim' in String.prototype;
// 7.1.3 ToNumber(argument)
var $4c430e436bf5c0a1$var$toNumber = function(argument) {
    var it = $01Csn(argument, false);
    if (typeof it == 'string' && it.length > 2) {
        it = $4c430e436bf5c0a1$var$TRIM ? it.trim() : $4c430e436bf5c0a1$require$$trim(it, 3);
        var first = it.charCodeAt(0);
        var third, radix, maxCode;
        if (first === 43 || first === 45) {
            third = it.charCodeAt(2);
            if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
        } else if (first === 48) {
            switch(it.charCodeAt(1)){
                case 66:
                case 98:
                    radix = 2;
                    maxCode = 49;
                    break; // fast equal /^0b[01]+$/i
                case 79:
                case 111:
                    radix = 8;
                    maxCode = 55;
                    break; // fast equal /^0o[0-7]+$/i
                default:
                    return +it;
            }
            for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
                code = digits.charCodeAt(i);
                // parseInt parses a string to a first unavailable symbol
                // but ToNumber should return NaN if a string contains unavailable symbols
                if (code < 48 || code > maxCode) return NaN;
            }
            return parseInt(digits, radix);
        }
    }
    return +it;
};


if (!$4c430e436bf5c0a1$var$$Number(' 0o1') || !$4c430e436bf5c0a1$var$$Number('0b1') || $4c430e436bf5c0a1$var$$Number('+0x1')) {
    $4c430e436bf5c0a1$var$$Number = function Number(value) {
        var it = arguments.length < 1 ? 0 : value;
        var that = this;
        return that instanceof $4c430e436bf5c0a1$var$$Number && ($4c430e436bf5c0a1$var$BROKEN_COF ? $QlNUq(function() {
            $4c430e436bf5c0a1$var$proto.valueOf.call(that);
        }) : $1Wc55(that) != $4c430e436bf5c0a1$var$NUMBER) ? $gFUup(new $4c430e436bf5c0a1$var$Base($4c430e436bf5c0a1$var$toNumber(it)), that, $4c430e436bf5c0a1$var$$Number) : $4c430e436bf5c0a1$var$toNumber(it);
    };
    for(var $4c430e436bf5c0a1$var$keys = (parcelRequire("8iMRJ")) ? $4c430e436bf5c0a1$require$gOPN($4c430e436bf5c0a1$var$Base) : // ES3:
    "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(','), $4c430e436bf5c0a1$var$j = 0, $4c430e436bf5c0a1$var$key; $4c430e436bf5c0a1$var$keys.length > $4c430e436bf5c0a1$var$j; $4c430e436bf5c0a1$var$j++)if ($lXZiV($4c430e436bf5c0a1$var$Base, $4c430e436bf5c0a1$var$key = $4c430e436bf5c0a1$var$keys[$4c430e436bf5c0a1$var$j]) && !$lXZiV($4c430e436bf5c0a1$var$$Number, $4c430e436bf5c0a1$var$key)) $4c430e436bf5c0a1$require$dP($4c430e436bf5c0a1$var$$Number, $4c430e436bf5c0a1$var$key, $4c430e436bf5c0a1$require$gOPD($4c430e436bf5c0a1$var$Base, $4c430e436bf5c0a1$var$key));
    $4c430e436bf5c0a1$var$$Number.prototype = $4c430e436bf5c0a1$var$proto;
    $4c430e436bf5c0a1$var$proto.constructor = $4c430e436bf5c0a1$var$$Number;
    (parcelRequire("bIIwe"))($gtY0w, $4c430e436bf5c0a1$var$NUMBER, $4c430e436bf5c0a1$var$$Number);
}


'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $l8CUX = parcelRequire("l8CUX");
var $0f255c1c3b9a6230$exports = {};

var $1Wc55 = parcelRequire("1Wc55");
$0f255c1c3b9a6230$exports = function(it, msg) {
    if (typeof it != 'number' && $1Wc55(it) != 'Number') throw TypeError(msg);
    return +it;
};



var $iBPed = parcelRequire("iBPed");
var $b9e101fc62898480$var$$toFixed = 1.0.toFixed;
var $b9e101fc62898480$var$floor = Math.floor;
var $b9e101fc62898480$var$data = [
    0,
    0,
    0,
    0,
    0,
    0
];
var $b9e101fc62898480$var$ERROR = 'Number.toFixed: incorrect invocation!';
var $b9e101fc62898480$var$ZERO = '0';
var $b9e101fc62898480$var$multiply = function(n, c) {
    var i = -1;
    var c2 = c;
    while(++i < 6){
        c2 += n * $b9e101fc62898480$var$data[i];
        $b9e101fc62898480$var$data[i] = c2 % 1e7;
        c2 = $b9e101fc62898480$var$floor(c2 / 1e7);
    }
};
var $b9e101fc62898480$var$divide = function(n) {
    var i = 6;
    var c = 0;
    while(--i >= 0){
        c += $b9e101fc62898480$var$data[i];
        $b9e101fc62898480$var$data[i] = $b9e101fc62898480$var$floor(c / n);
        c = c % n * 1e7;
    }
};
var $b9e101fc62898480$var$numToString = function() {
    var i = 6;
    var s = '';
    while(--i >= 0)if (s !== '' || i === 0 || $b9e101fc62898480$var$data[i] !== 0) {
        var t = String($b9e101fc62898480$var$data[i]);
        s = s === '' ? t : s + $iBPed.call($b9e101fc62898480$var$ZERO, 7 - t.length) + t;
    }
    return s;
};
var $b9e101fc62898480$var$pow = function(x, n, acc) {
    return n === 0 ? acc : n % 2 === 1 ? $b9e101fc62898480$var$pow(x, n - 1, acc * x) : $b9e101fc62898480$var$pow(x * x, n / 2, acc);
};
var $b9e101fc62898480$var$log = function(x) {
    var n = 0;
    var x2 = x;
    while(x2 >= 4096){
        n += 12;
        x2 /= 4096;
    }
    while(x2 >= 2){
        n += 1;
        x2 /= 2;
    }
    return n;
};

$2SWGI($2SWGI.P + $2SWGI.F * (!!$b9e101fc62898480$var$$toFixed && (0.00008.toFixed(3) !== '0.000' || 0.9.toFixed(0) !== '1' || 1.255.toFixed(2) !== '1.25' || 1000000000000000128.0.toFixed(0) !== '1000000000000000128') || !(parcelRequire("QlNUq"))(function() {
    // V8 ~ Android 4.3-
    $b9e101fc62898480$var$$toFixed.call({});
})), 'Number', {
    toFixed: function toFixed(fractionDigits) {
        var x = $0f255c1c3b9a6230$exports(this, $b9e101fc62898480$var$ERROR);
        var f = $l8CUX(fractionDigits);
        var s = '';
        var m = $b9e101fc62898480$var$ZERO;
        var e, z, j, k;
        if (f < 0 || f > 20) throw RangeError($b9e101fc62898480$var$ERROR);
        // eslint-disable-next-line no-self-compare
        if (x != x) return 'NaN';
        if (x <= -1000000000000000000000 || x >= 1e21) return String(x);
        if (x < 0) {
            s = '-';
            x = -x;
        }
        if (x > 1e-21) {
            e = $b9e101fc62898480$var$log(x * $b9e101fc62898480$var$pow(2, 69, 1)) - 69;
            z = e < 0 ? x * $b9e101fc62898480$var$pow(2, -e, 1) : x / $b9e101fc62898480$var$pow(2, e, 1);
            z *= 0x10000000000000;
            e = 52 - e;
            if (e > 0) {
                $b9e101fc62898480$var$multiply(0, z);
                j = f;
                while(j >= 7){
                    $b9e101fc62898480$var$multiply(1e7, 0);
                    j -= 7;
                }
                $b9e101fc62898480$var$multiply($b9e101fc62898480$var$pow(10, j, 1), 0);
                j = e - 1;
                while(j >= 23){
                    $b9e101fc62898480$var$divide(8388608);
                    j -= 23;
                }
                $b9e101fc62898480$var$divide(1 << j);
                $b9e101fc62898480$var$multiply(1, 1);
                $b9e101fc62898480$var$divide(2);
                m = $b9e101fc62898480$var$numToString();
            } else {
                $b9e101fc62898480$var$multiply(0, z);
                $b9e101fc62898480$var$multiply(1 << -e, 0);
                m = $b9e101fc62898480$var$numToString() + $iBPed.call($b9e101fc62898480$var$ZERO, f);
            }
        }
        if (f > 0) {
            k = m.length;
            m = s + (k <= f ? '0.' + $iBPed.call($b9e101fc62898480$var$ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
        } else m = s + m;
        return m;
    }
});


'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $QlNUq = parcelRequire("QlNUq");

var $23f1c50822438441$var$$toPrecision = 1.0.toPrecision;
$2SWGI($2SWGI.P + $2SWGI.F * ($QlNUq(function() {
    // IE7-
    return $23f1c50822438441$var$$toPrecision.call(1, undefined) !== '1';
}) || !$QlNUq(function() {
    // V8 ~ Android 4.3-
    $23f1c50822438441$var$$toPrecision.call({});
})), 'Number', {
    toPrecision: function toPrecision(precision) {
        var that = $0f255c1c3b9a6230$exports(this, 'Number#toPrecision: incorrect invocation!');
        return precision === undefined ? $23f1c50822438441$var$$toPrecision.call(that) : $23f1c50822438441$var$$toPrecision.call(that, precision);
    }
});


// 20.1.2.1 Number.EPSILON

var $2SWGI = parcelRequire("2SWGI");
$2SWGI($2SWGI.S, 'Number', {
    EPSILON: Math.pow(2, -52)
});


// 20.1.2.2 Number.isFinite(number)

var $2SWGI = parcelRequire("2SWGI");

var $gtY0w = parcelRequire("gtY0w");
var $2307e1108fdb4d42$require$_isFinite = $gtY0w.isFinite;
$2SWGI($2SWGI.S, 'Number', {
    isFinite: function isFinite(it) {
        return typeof it == 'number' && $2307e1108fdb4d42$require$_isFinite(it);
    }
});


// 20.1.2.3 Number.isInteger(number)

var $2SWGI = parcelRequire("2SWGI");

$2SWGI($2SWGI.S, 'Number', {
    isInteger: (parcelRequire("JyvOH"))
});


// 20.1.2.4 Number.isNaN(number)

var $2SWGI = parcelRequire("2SWGI");
$2SWGI($2SWGI.S, 'Number', {
    isNaN: function isNaN(number) {
        // eslint-disable-next-line no-self-compare
        return number != number;
    }
});


// 20.1.2.5 Number.isSafeInteger(number)

var $2SWGI = parcelRequire("2SWGI");

var $JyvOH = parcelRequire("JyvOH");
var $1feb9bb2511e38ae$var$abs = Math.abs;
$2SWGI($2SWGI.S, 'Number', {
    isSafeInteger: function isSafeInteger(number) {
        return $JyvOH(number) && $1feb9bb2511e38ae$var$abs(number) <= 0x1fffffffffffff;
    }
});


// 20.1.2.6 Number.MAX_SAFE_INTEGER

var $2SWGI = parcelRequire("2SWGI");
$2SWGI($2SWGI.S, 'Number', {
    MAX_SAFE_INTEGER: 0x1fffffffffffff
});


// 20.1.2.10 Number.MIN_SAFE_INTEGER

var $2SWGI = parcelRequire("2SWGI");
$2SWGI($2SWGI.S, 'Number', {
    MIN_SAFE_INTEGER: -9007199254740991
});



var $2SWGI = parcelRequire("2SWGI");

// 20.1.2.12 Number.parseFloat(string)
$2SWGI($2SWGI.S + $2SWGI.F * (Number.parseFloat != $52de8d132fd39028$exports), 'Number', {
    parseFloat: $52de8d132fd39028$exports
});



var $2SWGI = parcelRequire("2SWGI");

// 20.1.2.13 Number.parseInt(string, radix)
$2SWGI($2SWGI.S + $2SWGI.F * (Number.parseInt != $9d4c8e313a8218f1$exports), 'Number', {
    parseInt: $9d4c8e313a8218f1$exports
});


// 20.2.2.3 Math.acosh(x)

var $2SWGI = parcelRequire("2SWGI");

var $aWXLh = parcelRequire("aWXLh");
var $b05ef73bdc2eb06b$var$sqrt = Math.sqrt;
var $b05ef73bdc2eb06b$var$$acosh = Math.acosh;
$2SWGI($2SWGI.S + $2SWGI.F * !($b05ef73bdc2eb06b$var$$acosh && Math.floor($b05ef73bdc2eb06b$var$$acosh(Number.MAX_VALUE)) == 710 && $b05ef73bdc2eb06b$var$$acosh(Infinity) == Infinity), 'Math', {
    acosh: function acosh(x) {
        return (x = +x) < 1 ? NaN : x > 94906265.62425156 ? Math.log(x) + Math.LN2 : $aWXLh(x - 1 + $b05ef73bdc2eb06b$var$sqrt(x - 1) * $b05ef73bdc2eb06b$var$sqrt(x + 1));
    }
});


// 20.2.2.5 Math.asinh(x)

var $2SWGI = parcelRequire("2SWGI");
var $5cc629c56ea02431$var$$asinh = Math.asinh;
function $5cc629c56ea02431$var$asinh(x) {
    return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -$5cc629c56ea02431$var$asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}
// Tor Browser bug: Math.asinh(0) -> -0
$2SWGI($2SWGI.S + $2SWGI.F * !($5cc629c56ea02431$var$$asinh && 1 / $5cc629c56ea02431$var$$asinh(0) > 0), 'Math', {
    asinh: $5cc629c56ea02431$var$asinh
});


// 20.2.2.7 Math.atanh(x)

var $2SWGI = parcelRequire("2SWGI");
var $7aa77844d5a5b775$var$$atanh = Math.atanh;
// Tor Browser bug: Math.atanh(-0) -> 0
$2SWGI($2SWGI.S + $2SWGI.F * !($7aa77844d5a5b775$var$$atanh && 1 / $7aa77844d5a5b775$var$$atanh(-0) < 0), 'Math', {
    atanh: function atanh(x) {
        return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
    }
});


// 20.2.2.9 Math.cbrt(x)

var $2SWGI = parcelRequire("2SWGI");

var $4LpWx = parcelRequire("4LpWx");
$2SWGI($2SWGI.S, 'Math', {
    cbrt: function cbrt(x) {
        return $4LpWx(x = +x) * Math.pow(Math.abs(x), 1 / 3);
    }
});


// 20.2.2.11 Math.clz32(x)

var $2SWGI = parcelRequire("2SWGI");
$2SWGI($2SWGI.S, 'Math', {
    clz32: function clz32(x) {
        return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
    }
});


// 20.2.2.12 Math.cosh(x)

var $2SWGI = parcelRequire("2SWGI");
var $58dcc9e5346a62b7$var$exp = Math.exp;
$2SWGI($2SWGI.S, 'Math', {
    cosh: function cosh(x) {
        return ($58dcc9e5346a62b7$var$exp(x = +x) + $58dcc9e5346a62b7$var$exp(-x)) / 2;
    }
});


// 20.2.2.14 Math.expm1(x)

var $2SWGI = parcelRequire("2SWGI");
var $e8e05928b51e16f6$exports = {};
// 20.2.2.14 Math.expm1(x)
var $e8e05928b51e16f6$var$$expm1 = Math.expm1;
$e8e05928b51e16f6$exports = !$e8e05928b51e16f6$var$$expm1 || $e8e05928b51e16f6$var$$expm1(10) > 22025.465794806719 || $e8e05928b51e16f6$var$$expm1(10) < 22025.4657948067165168 || $e8e05928b51e16f6$var$$expm1(-0.00000000000000002) != -0.00000000000000002 ? function expm1(x) {
    return (x = +x) == 0 ? x : x > -0.000001 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $e8e05928b51e16f6$var$$expm1;


$2SWGI($2SWGI.S + $2SWGI.F * ($e8e05928b51e16f6$exports != Math.expm1), 'Math', {
    expm1: $e8e05928b51e16f6$exports
});


// 20.2.2.16 Math.fround(x)

var $2SWGI = parcelRequire("2SWGI");

$2SWGI($2SWGI.S, 'Math', {
    fround: (parcelRequire("8KeG3"))
});


// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])

var $2SWGI = parcelRequire("2SWGI");
var $637aa9d2555bb93d$var$abs = Math.abs;
$2SWGI($2SWGI.S, 'Math', {
    hypot: function hypot(value1, value2) {
        var sum = 0;
        var i = 0;
        var aLen = arguments.length;
        var larg = 0;
        var arg, div;
        while(i < aLen){
            arg = $637aa9d2555bb93d$var$abs(arguments[i++]);
            if (larg < arg) {
                div = larg / arg;
                sum = sum * div * div + 1;
                larg = arg;
            } else if (arg > 0) {
                div = arg / larg;
                sum += div * div;
            } else sum += arg;
        }
        return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
    }
});


// 20.2.2.18 Math.imul(x, y)

var $2SWGI = parcelRequire("2SWGI");
var $82799cfa4df846bc$var$$imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$2SWGI($2SWGI.S + $2SWGI.F * (parcelRequire("QlNUq"))(function() {
    return $82799cfa4df846bc$var$$imul(0xffffffff, 5) != -5 || $82799cfa4df846bc$var$$imul.length != 2;
}), 'Math', {
    imul: function imul(x, y) {
        var UINT16 = 0xffff;
        var xn = +x;
        var yn = +y;
        var xl = UINT16 & xn;
        var yl = UINT16 & yn;
        return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
    }
});


// 20.2.2.21 Math.log10(x)

var $2SWGI = parcelRequire("2SWGI");
$2SWGI($2SWGI.S, 'Math', {
    log10: function log10(x) {
        return Math.log(x) * Math.LOG10E;
    }
});


// 20.2.2.20 Math.log1p(x)

var $2SWGI = parcelRequire("2SWGI");

$2SWGI($2SWGI.S, 'Math', {
    log1p: (parcelRequire("aWXLh"))
});


// 20.2.2.22 Math.log2(x)

var $2SWGI = parcelRequire("2SWGI");
$2SWGI($2SWGI.S, 'Math', {
    log2: function log2(x) {
        return Math.log(x) / Math.LN2;
    }
});


// 20.2.2.28 Math.sign(x)

var $2SWGI = parcelRequire("2SWGI");

$2SWGI($2SWGI.S, 'Math', {
    sign: (parcelRequire("4LpWx"))
});


// 20.2.2.30 Math.sinh(x)

var $2SWGI = parcelRequire("2SWGI");

var $b020ba72d98de6e4$var$exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$2SWGI($2SWGI.S + $2SWGI.F * (parcelRequire("QlNUq"))(function() {
    return !Math.sinh(-0.00000000000000002) != -0.00000000000000002;
}), 'Math', {
    sinh: function sinh(x) {
        return Math.abs(x = +x) < 1 ? ($e8e05928b51e16f6$exports(x) - $e8e05928b51e16f6$exports(-x)) / 2 : ($b020ba72d98de6e4$var$exp(x - 1) - $b020ba72d98de6e4$var$exp(-x - 1)) * (Math.E / 2);
    }
});


// 20.2.2.33 Math.tanh(x)

var $2SWGI = parcelRequire("2SWGI");

var $0a97324037e243de$var$exp = Math.exp;
$2SWGI($2SWGI.S, 'Math', {
    tanh: function tanh(x) {
        var a = $e8e05928b51e16f6$exports(x = +x);
        var b = $e8e05928b51e16f6$exports(-x);
        return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / ($0a97324037e243de$var$exp(x) + $0a97324037e243de$var$exp(-x));
    }
});


// 20.2.2.34 Math.trunc(x)

var $2SWGI = parcelRequire("2SWGI");
$2SWGI($2SWGI.S, 'Math', {
    trunc: function trunc(it) {
        return (it > 0 ? Math.floor : Math.ceil)(it);
    }
});



var $2SWGI = parcelRequire("2SWGI");

var $anH1q = parcelRequire("anH1q");
var $29011ae2b3754512$var$fromCharCode = String.fromCharCode;
var $29011ae2b3754512$var$$fromCodePoint = String.fromCodePoint;
// length should be 1, old FF problem
$2SWGI($2SWGI.S + $2SWGI.F * (!!$29011ae2b3754512$var$$fromCodePoint && $29011ae2b3754512$var$$fromCodePoint.length != 1), 'String', {
    // 21.1.2.2 String.fromCodePoint(...codePoints)
    fromCodePoint: function fromCodePoint(x) {
        var res = [];
        var aLen = arguments.length;
        var i = 0;
        var code;
        while(aLen > i){
            code = +arguments[i++];
            if ($anH1q(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
            res.push(code < 0x10000 ? $29011ae2b3754512$var$fromCharCode(code) : $29011ae2b3754512$var$fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
        }
        return res.join('');
    }
});



var $2SWGI = parcelRequire("2SWGI");

var $5T7Du = parcelRequire("5T7Du");

var $2Stpr = parcelRequire("2Stpr");
$2SWGI($2SWGI.S, 'String', {
    // 21.1.2.4 String.raw(callSite, ...substitutions)
    raw: function raw(callSite) {
        var tpl = $5T7Du(callSite.raw);
        var len = $2Stpr(tpl.length);
        var aLen = arguments.length;
        var res = [];
        var i = 0;
        while(len > i){
            res.push(String(tpl[i++]));
            if (i < aLen) res.push(String(arguments[i]));
        }
        return res.join('');
    }
});


'use strict';

// 21.1.3.25 String.prototype.trim()
(parcelRequire("7fWUt"))('trim', function($trim) {
    return function trim() {
        return $trim(this, 3);
    };
});


'use strict';

var $408ec36ffd1e8d08$var$$at = (parcelRequire("9o1Sc"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("aRtjl"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $408ec36ffd1e8d08$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});


'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $d81c0da78cbe2ecb$var$$at = (parcelRequire("9o1Sc"))(false);
$2SWGI($2SWGI.P, 'String', {
    // 21.1.3.3 String.prototype.codePointAt(pos)
    codePointAt: function codePointAt(pos) {
        return $d81c0da78cbe2ecb$var$$at(this, pos);
    }
});


// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $2Stpr = parcelRequire("2Stpr");
var $56c57a9ca723d120$exports = {};
// helper for String#{startsWith, endsWith, includes}
var $299f890668ddb66c$exports = {};
// 7.2.8 IsRegExp(argument)

var $lD7l7 = parcelRequire("lD7l7");

var $1Wc55 = parcelRequire("1Wc55");

var $299f890668ddb66c$var$MATCH = (parcelRequire("fqMqf"))('match');
$299f890668ddb66c$exports = function(it) {
    var isRegExp;
    return $lD7l7(it) && ((isRegExp = it[$299f890668ddb66c$var$MATCH]) !== undefined ? !!isRegExp : $1Wc55(it) == 'RegExp');
};



var $duF9G = parcelRequire("duF9G");
$56c57a9ca723d120$exports = function(that, searchString, NAME) {
    if ($299f890668ddb66c$exports(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
    return String($duF9G(that));
};


var $c58b787b167cfada$var$ENDS_WITH = 'endsWith';
var $c58b787b167cfada$var$$endsWith = ''[$c58b787b167cfada$var$ENDS_WITH];

$2SWGI($2SWGI.P + $2SWGI.F * (parcelRequire("5iXJY"))($c58b787b167cfada$var$ENDS_WITH), 'String', {
    endsWith: function endsWith(searchString /* , endPosition = @length */ ) {
        var that = $56c57a9ca723d120$exports(this, searchString, $c58b787b167cfada$var$ENDS_WITH);
        var endPosition = arguments.length > 1 ? arguments[1] : undefined;
        var len = $2Stpr(that.length);
        var end = endPosition === undefined ? len : Math.min($2Stpr(endPosition), len);
        var search = String(searchString);
        return $c58b787b167cfada$var$$endsWith ? $c58b787b167cfada$var$$endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
    }
});


// 21.1.3.7 String.prototype.includes(searchString, position = 0)
'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $3b980a21f5d38e0f$var$INCLUDES = 'includes';

$2SWGI($2SWGI.P + $2SWGI.F * (parcelRequire("5iXJY"))($3b980a21f5d38e0f$var$INCLUDES), 'String', {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$56c57a9ca723d120$exports(this, searchString, $3b980a21f5d38e0f$var$INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
    }
});



var $2SWGI = parcelRequire("2SWGI");

$2SWGI($2SWGI.P, 'String', {
    // 21.1.3.13 String.prototype.repeat(count)
    repeat: (parcelRequire("iBPed"))
});


// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $2Stpr = parcelRequire("2Stpr");

var $f2cc6dbcd5371f20$var$STARTS_WITH = 'startsWith';
var $f2cc6dbcd5371f20$var$$startsWith = ''[$f2cc6dbcd5371f20$var$STARTS_WITH];

$2SWGI($2SWGI.P + $2SWGI.F * (parcelRequire("5iXJY"))($f2cc6dbcd5371f20$var$STARTS_WITH), 'String', {
    startsWith: function startsWith(searchString /* , position = 0 */ ) {
        var that = $56c57a9ca723d120$exports(this, searchString, $f2cc6dbcd5371f20$var$STARTS_WITH);
        var index = $2Stpr(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        var search = String(searchString);
        return $f2cc6dbcd5371f20$var$$startsWith ? $f2cc6dbcd5371f20$var$$startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
    }
});


'use strict';

// B.2.3.2 String.prototype.anchor(name)
(parcelRequire("eu17v"))('anchor', function(createHTML) {
    return function anchor(name) {
        return createHTML(this, 'a', 'name', name);
    };
});


'use strict';

// B.2.3.3 String.prototype.big()
(parcelRequire("eu17v"))('big', function(createHTML) {
    return function big() {
        return createHTML(this, 'big', '', '');
    };
});


'use strict';

// B.2.3.4 String.prototype.blink()
(parcelRequire("eu17v"))('blink', function(createHTML) {
    return function blink() {
        return createHTML(this, 'blink', '', '');
    };
});


'use strict';

// B.2.3.5 String.prototype.bold()
(parcelRequire("eu17v"))('bold', function(createHTML) {
    return function bold() {
        return createHTML(this, 'b', '', '');
    };
});


'use strict';

// B.2.3.6 String.prototype.fixed()
(parcelRequire("eu17v"))('fixed', function(createHTML) {
    return function fixed() {
        return createHTML(this, 'tt', '', '');
    };
});


'use strict';

// B.2.3.7 String.prototype.fontcolor(color)
(parcelRequire("eu17v"))('fontcolor', function(createHTML) {
    return function fontcolor(color) {
        return createHTML(this, 'font', 'color', color);
    };
});


'use strict';

// B.2.3.8 String.prototype.fontsize(size)
(parcelRequire("eu17v"))('fontsize', function(createHTML) {
    return function fontsize(size) {
        return createHTML(this, 'font', 'size', size);
    };
});


'use strict';

// B.2.3.9 String.prototype.italics()
(parcelRequire("eu17v"))('italics', function(createHTML) {
    return function italics() {
        return createHTML(this, 'i', '', '');
    };
});


'use strict';

// B.2.3.10 String.prototype.link(url)
(parcelRequire("eu17v"))('link', function(createHTML) {
    return function link(url) {
        return createHTML(this, 'a', 'href', url);
    };
});


'use strict';

// B.2.3.11 String.prototype.small()
(parcelRequire("eu17v"))('small', function(createHTML) {
    return function small() {
        return createHTML(this, 'small', '', '');
    };
});


'use strict';

// B.2.3.12 String.prototype.strike()
(parcelRequire("eu17v"))('strike', function(createHTML) {
    return function strike() {
        return createHTML(this, 'strike', '', '');
    };
});


'use strict';

// B.2.3.13 String.prototype.sub()
(parcelRequire("eu17v"))('sub', function(createHTML) {
    return function sub() {
        return createHTML(this, 'sub', '', '');
    };
});


'use strict';

// B.2.3.14 String.prototype.sup()
(parcelRequire("eu17v"))('sup', function(createHTML) {
    return function sup() {
        return createHTML(this, 'sup', '', '');
    };
});


// 20.3.3.1 / 15.9.4.4 Date.now()

var $2SWGI = parcelRequire("2SWGI");
$2SWGI($2SWGI.S, 'Date', {
    now: function() {
        return new Date().getTime();
    }
});


'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $7bwTf = parcelRequire("7bwTf");

var $01Csn = parcelRequire("01Csn");

$2SWGI($2SWGI.P + $2SWGI.F * (parcelRequire("QlNUq"))(function() {
    return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({
        toISOString: function() {
            return 1;
        }
    }) !== 1;
}), 'Date', {
    // eslint-disable-next-line no-unused-vars
    toJSON: function toJSON(key) {
        var O = $7bwTf(this);
        var pv = $01Csn(O);
        return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
    }
});


// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()

var $2SWGI = parcelRequire("2SWGI");
var $9e3fdee4d6ae43a2$exports = {};
'use strict';

var $QlNUq = parcelRequire("QlNUq");
var $9e3fdee4d6ae43a2$var$getTime = Date.prototype.getTime;
var $9e3fdee4d6ae43a2$var$$toISOString = Date.prototype.toISOString;
var $9e3fdee4d6ae43a2$var$lz = function(num) {
    return num > 9 ? num : '0' + num;
};
// PhantomJS / old WebKit has a broken implementations
$9e3fdee4d6ae43a2$exports = $QlNUq(function() {
    return $9e3fdee4d6ae43a2$var$$toISOString.call(new Date(-50000000000000 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !$QlNUq(function() {
    $9e3fdee4d6ae43a2$var$$toISOString.call(new Date(NaN));
}) ? function toISOString() {
    if (!isFinite($9e3fdee4d6ae43a2$var$getTime.call(this))) throw RangeError('Invalid time value');
    var d = this;
    var y = d.getUTCFullYear();
    var m = d.getUTCMilliseconds();
    var s = y < 0 ? '-' : y > 9999 ? '+' : '';
    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) + '-' + $9e3fdee4d6ae43a2$var$lz(d.getUTCMonth() + 1) + '-' + $9e3fdee4d6ae43a2$var$lz(d.getUTCDate()) + 'T' + $9e3fdee4d6ae43a2$var$lz(d.getUTCHours()) + ':' + $9e3fdee4d6ae43a2$var$lz(d.getUTCMinutes()) + ':' + $9e3fdee4d6ae43a2$var$lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + $9e3fdee4d6ae43a2$var$lz(m)) + 'Z';
} : $9e3fdee4d6ae43a2$var$$toISOString;


// PhantomJS / old WebKit has a broken implementations
$2SWGI($2SWGI.P + $2SWGI.F * (Date.prototype.toISOString !== $9e3fdee4d6ae43a2$exports), 'Date', {
    toISOString: $9e3fdee4d6ae43a2$exports
});


var $a352905caa5d8b59$var$DateProto = Date.prototype;
var $a352905caa5d8b59$var$INVALID_DATE = 'Invalid Date';
var $a352905caa5d8b59$var$TO_STRING = 'toString';
var $a352905caa5d8b59$var$$toString = $a352905caa5d8b59$var$DateProto[$a352905caa5d8b59$var$TO_STRING];
var $a352905caa5d8b59$var$getTime = $a352905caa5d8b59$var$DateProto.getTime;

if (new Date(NaN) + '' != $a352905caa5d8b59$var$INVALID_DATE) (parcelRequire("bIIwe"))($a352905caa5d8b59$var$DateProto, $a352905caa5d8b59$var$TO_STRING, function toString() {
    var value = $a352905caa5d8b59$var$getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $a352905caa5d8b59$var$$toString.call(this) : $a352905caa5d8b59$var$INVALID_DATE;
});



var $4c43efc5fe54923e$var$TO_PRIMITIVE = (parcelRequire("fqMqf"))('toPrimitive');
var $4c43efc5fe54923e$var$proto = Date.prototype;


if (!($4c43efc5fe54923e$var$TO_PRIMITIVE in $4c43efc5fe54923e$var$proto)) (parcelRequire("disfj"))($4c43efc5fe54923e$var$proto, $4c43efc5fe54923e$var$TO_PRIMITIVE, (parcelRequire("kSJfZ")));


// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)

var $2SWGI = parcelRequire("2SWGI");

$2SWGI($2SWGI.S, 'Array', {
    isArray: (parcelRequire("1y0po"))
});


'use strict';

var $3eawb = parcelRequire("3eawb");

var $2SWGI = parcelRequire("2SWGI");

var $7bwTf = parcelRequire("7bwTf");

var $2Kbie = parcelRequire("2Kbie");

var $g4dgh = parcelRequire("g4dgh");

var $2Stpr = parcelRequire("2Stpr");
var $ec78b45bb3fccb2c$exports = {};
'use strict';

var $8QaBR = parcelRequire("8QaBR");

var $cttRt = parcelRequire("cttRt");
$ec78b45bb3fccb2c$exports = function(object, index, value) {
    if (index in object) $8QaBR.f(object, index, $cttRt(0, value));
    else object[index] = value;
};



var $ljgC0 = parcelRequire("ljgC0");

$2SWGI($2SWGI.S + $2SWGI.F * !(parcelRequire("gkPUi"))(function(iter) {
    Array.from(iter);
}), 'Array', {
    // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
    from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
        var O = $7bwTf(arrayLike);
        var C = typeof this == 'function' ? this : Array;
        var aLen = arguments.length;
        var mapfn = aLen > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var index = 0;
        var iterFn = $ljgC0(O);
        var length, result, step, iterator;
        if (mapping) mapfn = $3eawb(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
        // if object isn't iterable or it's array with default iterator - use simple case
        if (iterFn != undefined && !(C == Array && $g4dgh(iterFn))) for(iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++)$ec78b45bb3fccb2c$exports(result, index, mapping ? $2Kbie(iterator, mapfn, [
            step.value,
            index
        ], true) : step.value);
        else {
            length = $2Stpr(O.length);
            for(result = new C(length); length > index; index++)$ec78b45bb3fccb2c$exports(result, index, mapping ? mapfn(O[index], index) : O[index]);
        }
        result.length = index;
        return result;
    }
});


'use strict';

var $2SWGI = parcelRequire("2SWGI");


// WebKit Array.of isn't generic
$2SWGI($2SWGI.S + $2SWGI.F * (parcelRequire("QlNUq"))(function() {
    function F() {}
    return !(Array.of.call(F) instanceof F);
}), 'Array', {
    // 22.1.2.3 Array.of( ...items)
    of: function of() {
        var index = 0;
        var aLen = arguments.length;
        var result = new (typeof this == 'function' ? this : Array)(aLen);
        while(aLen > index)$ec78b45bb3fccb2c$exports(result, index, arguments[index++]);
        result.length = aLen;
        return result;
    }
});


'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $5T7Du = parcelRequire("5T7Du");
var $1e02a1e6f42be00b$var$arrayJoin = [].join;


// fallback for not array-like strings
$2SWGI($2SWGI.P + $2SWGI.F * ((parcelRequire("aAgUs")) != Object || !(parcelRequire("613qq"))($1e02a1e6f42be00b$var$arrayJoin)), 'Array', {
    join: function join(separator) {
        return $1e02a1e6f42be00b$var$arrayJoin.call($5T7Du(this), separator === undefined ? ',' : separator);
    }
});


'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $kDGgr = parcelRequire("kDGgr");

var $1Wc55 = parcelRequire("1Wc55");

var $anH1q = parcelRequire("anH1q");

var $2Stpr = parcelRequire("2Stpr");
var $9601679cfccd4abb$var$arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$2SWGI($2SWGI.P + $2SWGI.F * (parcelRequire("QlNUq"))(function() {
    if ($kDGgr) $9601679cfccd4abb$var$arraySlice.call($kDGgr);
}), 'Array', {
    slice: function slice(begin, end) {
        var len = $2Stpr(this.length);
        var klass = $1Wc55(this);
        end = end === undefined ? len : end;
        if (klass == 'Array') return $9601679cfccd4abb$var$arraySlice.call(this, begin, end);
        var start = $anH1q(begin, len);
        var upTo = $anH1q(end, len);
        var size = $2Stpr(upTo - start);
        var cloned = new Array(size);
        var i = 0;
        for(; i < size; i++)cloned[i] = klass == 'String' ? this.charAt(start + i) : this[start + i];
        return cloned;
    }
});


'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $aXqxV = parcelRequire("aXqxV");

var $7bwTf = parcelRequire("7bwTf");

var $QlNUq = parcelRequire("QlNUq");
var $1f2d2253f1c361fe$var$$sort = [].sort;
var $1f2d2253f1c361fe$var$test = [
    1,
    2,
    3
];

$2SWGI($2SWGI.P + $2SWGI.F * ($QlNUq(function() {
    // IE8-
    $1f2d2253f1c361fe$var$test.sort(undefined);
}) || !$QlNUq(function() {
    // V8 bug
    $1f2d2253f1c361fe$var$test.sort(null);
// Old WebKit
}) || !(parcelRequire("613qq"))($1f2d2253f1c361fe$var$$sort)), 'Array', {
    // 22.1.3.25 Array.prototype.sort(comparefn)
    sort: function sort(comparefn) {
        return comparefn === undefined ? $1f2d2253f1c361fe$var$$sort.call($7bwTf(this)) : $1f2d2253f1c361fe$var$$sort.call($7bwTf(this), $aXqxV(comparefn));
    }
});


'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $f9598e0b8d052b94$var$$forEach = (parcelRequire("3gy3i"))(0);

var $f9598e0b8d052b94$var$STRICT = (parcelRequire("613qq"))([].forEach, true);
$2SWGI($2SWGI.P + $2SWGI.F * !$f9598e0b8d052b94$var$STRICT, 'Array', {
    // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
    forEach: function forEach(callbackfn /* , thisArg */ ) {
        return $f9598e0b8d052b94$var$$forEach(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $2438f06fa7edc0e8$var$$map = (parcelRequire("3gy3i"))(1);

$2SWGI($2SWGI.P + $2SWGI.F * !(parcelRequire("613qq"))([].map, true), 'Array', {
    // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
    map: function map(callbackfn /* , thisArg */ ) {
        return $2438f06fa7edc0e8$var$$map(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $96b18532804cd64f$var$$filter = (parcelRequire("3gy3i"))(2);

$2SWGI($2SWGI.P + $2SWGI.F * !(parcelRequire("613qq"))([].filter, true), 'Array', {
    // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $96b18532804cd64f$var$$filter(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $c5225cf1455656b1$var$$some = (parcelRequire("3gy3i"))(3);

$2SWGI($2SWGI.P + $2SWGI.F * !(parcelRequire("613qq"))([].some, true), 'Array', {
    // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
    some: function some(callbackfn /* , thisArg */ ) {
        return $c5225cf1455656b1$var$$some(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $5a7ba8c050fd4488$var$$every = (parcelRequire("3gy3i"))(4);

$2SWGI($2SWGI.P + $2SWGI.F * !(parcelRequire("613qq"))([].every, true), 'Array', {
    // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
    every: function every(callbackfn /* , thisArg */ ) {
        return $5a7ba8c050fd4488$var$$every(this, callbackfn, arguments[1]);
    }
});


'use strict';

var $2SWGI = parcelRequire("2SWGI");
var $48493d15adc6a627$exports = {};

var $aXqxV = parcelRequire("aXqxV");

var $7bwTf = parcelRequire("7bwTf");

var $aAgUs = parcelRequire("aAgUs");

var $2Stpr = parcelRequire("2Stpr");
$48493d15adc6a627$exports = function(that, callbackfn, aLen, memo, isRight) {
    $aXqxV(callbackfn);
    var O = $7bwTf(that);
    var self = $aAgUs(O);
    var length = $2Stpr(O.length);
    var index = isRight ? length - 1 : 0;
    var i = isRight ? -1 : 1;
    if (aLen < 2) for(;;){
        if (index in self) {
            memo = self[index];
            index += i;
            break;
        }
        index += i;
        if (isRight ? index < 0 : length <= index) throw TypeError('Reduce of empty array with no initial value');
    }
    for(; isRight ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
    return memo;
};



$2SWGI($2SWGI.P + $2SWGI.F * !(parcelRequire("613qq"))([].reduce, true), 'Array', {
    // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        return $48493d15adc6a627$exports(this, callbackfn, arguments.length, arguments[1], false);
    }
});


'use strict';

var $2SWGI = parcelRequire("2SWGI");


$2SWGI($2SWGI.P + $2SWGI.F * !(parcelRequire("613qq"))([].reduceRight, true), 'Array', {
    // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
    reduceRight: function reduceRight(callbackfn /* , initialValue */ ) {
        return $48493d15adc6a627$exports(this, callbackfn, arguments.length, arguments[1], true);
    }
});


'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $d168090603cfe0e2$var$$indexOf = (parcelRequire("2zzLE"))(false);
var $d168090603cfe0e2$var$$native = [].indexOf;
var $d168090603cfe0e2$var$NEGATIVE_ZERO = !!$d168090603cfe0e2$var$$native && 1 / [
    1
].indexOf(1, -0) < 0;

$2SWGI($2SWGI.P + $2SWGI.F * ($d168090603cfe0e2$var$NEGATIVE_ZERO || !(parcelRequire("613qq"))($d168090603cfe0e2$var$$native)), 'Array', {
    // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
    indexOf: function indexOf(searchElement /* , fromIndex = 0 */ ) {
        return $d168090603cfe0e2$var$NEGATIVE_ZERO ? $d168090603cfe0e2$var$$native.apply(this, arguments) || 0 : $d168090603cfe0e2$var$$indexOf(this, searchElement, arguments[1]);
    }
});


'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $5T7Du = parcelRequire("5T7Du");

var $l8CUX = parcelRequire("l8CUX");

var $2Stpr = parcelRequire("2Stpr");
var $47f9ce1b0b1a1b31$var$$native = [].lastIndexOf;
var $47f9ce1b0b1a1b31$var$NEGATIVE_ZERO = !!$47f9ce1b0b1a1b31$var$$native && 1 / [
    1
].lastIndexOf(1, -0) < 0;

$2SWGI($2SWGI.P + $2SWGI.F * ($47f9ce1b0b1a1b31$var$NEGATIVE_ZERO || !(parcelRequire("613qq"))($47f9ce1b0b1a1b31$var$$native)), 'Array', {
    // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */ ) {
        // convert -0 to +0
        if ($47f9ce1b0b1a1b31$var$NEGATIVE_ZERO) return $47f9ce1b0b1a1b31$var$$native.apply(this, arguments) || 0;
        var O = $5T7Du(this);
        var length = $2Stpr(O.length);
        var index = length - 1;
        if (arguments.length > 1) index = Math.min(index, $l8CUX(arguments[1]));
        if (index < 0) index = length + index;
        for(; index >= 0; index--)if (index in O) {
            if (O[index] === searchElement) return index || 0;
        }
        return -1;
    }
});


// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var $2SWGI = parcelRequire("2SWGI");

$2SWGI($2SWGI.P, 'Array', {
    copyWithin: (parcelRequire("kavIj"))
});

(parcelRequire("fUASv"))('copyWithin');


// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var $2SWGI = parcelRequire("2SWGI");

$2SWGI($2SWGI.P, 'Array', {
    fill: (parcelRequire("hI6TD"))
});

(parcelRequire("fUASv"))('fill');


'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $a20cd5fe44bdbf31$var$$find = (parcelRequire("3gy3i"))(5);
var $a20cd5fe44bdbf31$var$KEY = 'find';
var $a20cd5fe44bdbf31$var$forced = true;
// Shouldn't skip holes
if ($a20cd5fe44bdbf31$var$KEY in []) Array(1)[$a20cd5fe44bdbf31$var$KEY](function() {
    $a20cd5fe44bdbf31$var$forced = false;
});
$2SWGI($2SWGI.P + $2SWGI.F * $a20cd5fe44bdbf31$var$forced, 'Array', {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $a20cd5fe44bdbf31$var$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

(parcelRequire("fUASv"))($a20cd5fe44bdbf31$var$KEY);


'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $a91598cdecd7a0a5$var$$find = (parcelRequire("3gy3i"))(6);
var $a91598cdecd7a0a5$var$KEY = 'findIndex';
var $a91598cdecd7a0a5$var$forced = true;
// Shouldn't skip holes
if ($a91598cdecd7a0a5$var$KEY in []) Array(1)[$a91598cdecd7a0a5$var$KEY](function() {
    $a91598cdecd7a0a5$var$forced = false;
});
$2SWGI($2SWGI.P + $2SWGI.F * $a91598cdecd7a0a5$var$forced, 'Array', {
    findIndex: function findIndex(callbackfn /* , that = undefined */ ) {
        return $a91598cdecd7a0a5$var$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

(parcelRequire("fUASv"))($a91598cdecd7a0a5$var$KEY);



(parcelRequire("bDRPQ"))('Array');


parcelRequire("i0uZ5");

var $gtY0w = parcelRequire("gtY0w");

var $gFUup = parcelRequire("gFUup");

var $8QaBR = parcelRequire("8QaBR");
var $5c49dd42e121ebc6$require$dP = $8QaBR.f;

var $60lWN = parcelRequire("60lWN");
var $5c49dd42e121ebc6$require$gOPN = $60lWN.f;


var $jVwmq = parcelRequire("jVwmq");
var $5c49dd42e121ebc6$var$$RegExp = $gtY0w.RegExp;
var $5c49dd42e121ebc6$var$Base = $5c49dd42e121ebc6$var$$RegExp;
var $5c49dd42e121ebc6$var$proto = $5c49dd42e121ebc6$var$$RegExp.prototype;
var $5c49dd42e121ebc6$var$re1 = /a/g;
var $5c49dd42e121ebc6$var$re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var $5c49dd42e121ebc6$var$CORRECT_NEW = new $5c49dd42e121ebc6$var$$RegExp($5c49dd42e121ebc6$var$re1) !== $5c49dd42e121ebc6$var$re1;



var $fqMqf = parcelRequire("fqMqf");

if ((parcelRequire("8iMRJ")) && (!$5c49dd42e121ebc6$var$CORRECT_NEW || (parcelRequire("QlNUq"))(function() {
    $5c49dd42e121ebc6$var$re2[$fqMqf('match')] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return $5c49dd42e121ebc6$var$$RegExp($5c49dd42e121ebc6$var$re1) != $5c49dd42e121ebc6$var$re1 || $5c49dd42e121ebc6$var$$RegExp($5c49dd42e121ebc6$var$re2) == $5c49dd42e121ebc6$var$re2 || $5c49dd42e121ebc6$var$$RegExp($5c49dd42e121ebc6$var$re1, 'i') != '/a/i';
}))) {
    $5c49dd42e121ebc6$var$$RegExp = function RegExp(p, f) {
        var tiRE = this instanceof $5c49dd42e121ebc6$var$$RegExp;
        var piRE = $299f890668ddb66c$exports(p);
        var fiU = f === undefined;
        return !tiRE && piRE && p.constructor === $5c49dd42e121ebc6$var$$RegExp && fiU ? p : $gFUup($5c49dd42e121ebc6$var$CORRECT_NEW ? new $5c49dd42e121ebc6$var$Base(piRE && !fiU ? p.source : p, f) : $5c49dd42e121ebc6$var$Base((piRE = p instanceof $5c49dd42e121ebc6$var$$RegExp) ? p.source : p, piRE && fiU ? $jVwmq.call(p) : f), tiRE ? this : $5c49dd42e121ebc6$var$proto, $5c49dd42e121ebc6$var$$RegExp);
    };
    var $5c49dd42e121ebc6$var$proxy = function(key) {
        key in $5c49dd42e121ebc6$var$$RegExp || $5c49dd42e121ebc6$require$dP($5c49dd42e121ebc6$var$$RegExp, key, {
            configurable: true,
            get: function() {
                return $5c49dd42e121ebc6$var$Base[key];
            },
            set: function(it) {
                $5c49dd42e121ebc6$var$Base[key] = it;
            }
        });
    };
    for(var $5c49dd42e121ebc6$var$keys = $5c49dd42e121ebc6$require$gOPN($5c49dd42e121ebc6$var$Base), $5c49dd42e121ebc6$var$i = 0; $5c49dd42e121ebc6$var$keys.length > $5c49dd42e121ebc6$var$i;)$5c49dd42e121ebc6$var$proxy($5c49dd42e121ebc6$var$keys[$5c49dd42e121ebc6$var$i++]);
    $5c49dd42e121ebc6$var$proto.constructor = $5c49dd42e121ebc6$var$$RegExp;
    $5c49dd42e121ebc6$var$$RegExp.prototype = $5c49dd42e121ebc6$var$proto;
    (parcelRequire("bIIwe"))($gtY0w, 'RegExp', $5c49dd42e121ebc6$var$$RegExp);
}

(parcelRequire("bDRPQ"))('RegExp');


parcelRequire("cwKrQ");
'use strict';
// 21.2.5.3 get RegExp.prototype.flags()



if ((parcelRequire("8iMRJ")) && /./g.flags != 'g') (parcelRequire("8QaBR")).f(RegExp.prototype, 'flags', {
    configurable: true,
    get: (parcelRequire("jVwmq"))
});



var $bmSbf = parcelRequire("bmSbf");

var $jVwmq = parcelRequire("jVwmq");

var $8iMRJ = parcelRequire("8iMRJ");
var $58c1eafd168577f8$var$TO_STRING = 'toString';
var $58c1eafd168577f8$var$$toString = /./[$58c1eafd168577f8$var$TO_STRING];

var $58c1eafd168577f8$var$define = function(fn) {
    (parcelRequire("bIIwe"))(RegExp.prototype, $58c1eafd168577f8$var$TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if ((parcelRequire("QlNUq"))(function() {
    return $58c1eafd168577f8$var$$toString.call({
        source: 'a',
        flags: 'b'
    }) != '/a/b';
})) $58c1eafd168577f8$var$define(function toString() {
    var R = $bmSbf(this);
    return '/'.concat(R.source, '/', 'flags' in R ? R.flags : !$8iMRJ && R instanceof RegExp ? $jVwmq.call(R) : undefined);
});
else if ($58c1eafd168577f8$var$$toString.name != $58c1eafd168577f8$var$TO_STRING) $58c1eafd168577f8$var$define(function toString() {
    return $58c1eafd168577f8$var$$toString.call(this);
});



'use strict';

var $bmSbf = parcelRequire("bmSbf");

var $2Stpr = parcelRequire("2Stpr");
var $5ed59e2f08a2c1f9$exports = {};
'use strict';

var $5ed59e2f08a2c1f9$var$at = (parcelRequire("9o1Sc"))(true);
// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
$5ed59e2f08a2c1f9$exports = function(S, index, unicode) {
    return index + (unicode ? $5ed59e2f08a2c1f9$var$at(S, index).length : 1);
};


var $64cafe97791abf3e$exports = {};
'use strict';

var $03JDo = parcelRequire("03JDo");
var $64cafe97791abf3e$var$builtinExec = RegExp.prototype.exec;
// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
$64cafe97791abf3e$exports = function(R, S) {
    var exec = R.exec;
    if (typeof exec === 'function') {
        var result = exec.call(R, S);
        if (typeof result !== 'object') throw new TypeError('RegExp exec method returned something other than an Object or null');
        return result;
    }
    if ($03JDo(R) !== 'RegExp') throw new TypeError('RegExp#exec called on incompatible receiver');
    return $64cafe97791abf3e$var$builtinExec.call(R, S);
};



// @@match logic
(parcelRequire("h6eDo"))('match', 1, function(defined, MATCH, $match, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = defined(this);
            var fn = regexp == undefined ? undefined : regexp[MATCH];
            return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
        function(regexp) {
            var res = maybeCallNative($match, regexp, this);
            if (res.done) return res.value;
            var rx = $bmSbf(regexp);
            var S = String(this);
            if (!rx.global) return $64cafe97791abf3e$exports(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = $64cafe97791abf3e$exports(rx, S)) !== null){
                var matchStr = String(result[0]);
                A[n] = matchStr;
                if (matchStr === '') rx.lastIndex = $5ed59e2f08a2c1f9$exports(S, $2Stpr(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});


'use strict';

var $bmSbf = parcelRequire("bmSbf");

var $7bwTf = parcelRequire("7bwTf");

var $2Stpr = parcelRequire("2Stpr");

var $l8CUX = parcelRequire("l8CUX");


var $39dafcda9205ab51$var$max = Math.max;
var $39dafcda9205ab51$var$min = Math.min;
var $39dafcda9205ab51$var$floor = Math.floor;
var $39dafcda9205ab51$var$SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var $39dafcda9205ab51$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
var $39dafcda9205ab51$var$maybeToString = function(it) {
    return it === undefined ? it : String(it);
};

// @@replace logic
(parcelRequire("h6eDo"))('replace', 2, function(defined, REPLACE, $replace, maybeCallNative) {
    return [
        // `String.prototype.replace` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = defined(this);
            var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
            return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
        function(regexp, replaceValue) {
            var res = maybeCallNative($replace, regexp, this, replaceValue);
            if (res.done) return res.value;
            var rx = $bmSbf(regexp);
            var S = String(this);
            var functionalReplace = typeof replaceValue === 'function';
            if (!functionalReplace) replaceValue = String(replaceValue);
            var global = rx.global;
            if (global) {
                var fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            while(true){
                var result = $64cafe97791abf3e$exports(rx, S);
                if (result === null) break;
                results.push(result);
                if (!global) break;
                var matchStr = String(result[0]);
                if (matchStr === '') rx.lastIndex = $5ed59e2f08a2c1f9$exports(S, $2Stpr(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = '';
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = String(result[0]);
                var position = $39dafcda9205ab51$var$max($39dafcda9205ab51$var$min($l8CUX(result.index), S.length), 0);
                var captures = [];
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)captures.push($39dafcda9205ab51$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = [
                        matched
                    ].concat(captures, position, S);
                    if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
                    var replacement = String(replaceValue.apply(undefined, replacerArgs));
                } else replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + S.slice(nextSourcePosition);
        }
    ];
    // https://tc39.github.io/ecma262/#sec-getsubstitution
    function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
        var tailPos = position + matched.length;
        var m = captures.length;
        var symbols = $39dafcda9205ab51$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
        if (namedCaptures !== undefined) {
            namedCaptures = $7bwTf(namedCaptures);
            symbols = $39dafcda9205ab51$var$SUBSTITUTION_SYMBOLS;
        }
        return $replace.call(replacement, symbols, function(match, ch) {
            var capture;
            switch(ch.charAt(0)){
                case '$':
                    return '$';
                case '&':
                    return matched;
                case '`':
                    return str.slice(0, position);
                case "'":
                    return str.slice(tailPos);
                case '<':
                    capture = namedCaptures[ch.slice(1, -1)];
                    break;
                default:
                    var n = +ch;
                    if (n === 0) return match;
                    if (n > m) {
                        var f = $39dafcda9205ab51$var$floor(n / 10);
                        if (f === 0) return match;
                        if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
                        return match;
                    }
                    capture = captures[n - 1];
            }
            return capture === undefined ? '' : capture;
        });
    }
});


'use strict';

var $bmSbf = parcelRequire("bmSbf");

var $382Uw = parcelRequire("382Uw");


// @@search logic
(parcelRequire("h6eDo"))('search', 1, function(defined, SEARCH, $search, maybeCallNative) {
    return [
        // `String.prototype.search` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.search
        function search(regexp) {
            var O = defined(this);
            var fn = regexp == undefined ? undefined : regexp[SEARCH];
            return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
        },
        // `RegExp.prototype[@@search]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
        function(regexp) {
            var res = maybeCallNative($search, regexp, this);
            if (res.done) return res.value;
            var rx = $bmSbf(regexp);
            var S = String(this);
            var previousLastIndex = rx.lastIndex;
            if (!$382Uw(previousLastIndex, 0)) rx.lastIndex = 0;
            var result = $64cafe97791abf3e$exports(rx, S);
            if (!$382Uw(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
            return result === null ? -1 : result.index;
        }
    ];
});


'use strict';


var $bmSbf = parcelRequire("bmSbf");

var $jrtAb = parcelRequire("jrtAb");


var $2Stpr = parcelRequire("2Stpr");


var $isEge = parcelRequire("isEge");

var $QlNUq = parcelRequire("QlNUq");
var $0f1ee57e7ddc5959$var$$min = Math.min;
var $0f1ee57e7ddc5959$var$$push = [].push;
var $0f1ee57e7ddc5959$var$$SPLIT = 'split';
var $0f1ee57e7ddc5959$var$LENGTH = 'length';
var $0f1ee57e7ddc5959$var$LAST_INDEX = 'lastIndex';
var $0f1ee57e7ddc5959$var$MAX_UINT32 = 0xffffffff;
// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var $0f1ee57e7ddc5959$var$SUPPORTS_Y = !$QlNUq(function() {
    RegExp($0f1ee57e7ddc5959$var$MAX_UINT32, 'y');
});

// @@split logic
(parcelRequire("h6eDo"))('split', 2, function(defined, SPLIT, $split, maybeCallNative) {
    var internalSplit;
    if ('abbc'[$0f1ee57e7ddc5959$var$$SPLIT](/(b)*/)[1] == 'c' || 'test'[$0f1ee57e7ddc5959$var$$SPLIT](/(?:)/, -1)[$0f1ee57e7ddc5959$var$LENGTH] != 4 || 'ab'[$0f1ee57e7ddc5959$var$$SPLIT](/(?:ab)*/)[$0f1ee57e7ddc5959$var$LENGTH] != 2 || '.'[$0f1ee57e7ddc5959$var$$SPLIT](/(.?)(.?)/)[$0f1ee57e7ddc5959$var$LENGTH] != 4 || '.'[$0f1ee57e7ddc5959$var$$SPLIT](/()()/)[$0f1ee57e7ddc5959$var$LENGTH] > 1 || ''[$0f1ee57e7ddc5959$var$$SPLIT](/.?/)[$0f1ee57e7ddc5959$var$LENGTH]) // based on es5-shim implementation, need to rework it
    internalSplit = function(separator, limit) {
        var string = String(this);
        if (separator === undefined && limit === 0) return [];
        // If `separator` is not a regex, use native split
        if (!$299f890668ddb66c$exports(separator)) return $split.call(string, separator, limit);
        var output = [];
        var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
        var lastLastIndex = 0;
        var splitLimit = limit === undefined ? $0f1ee57e7ddc5959$var$MAX_UINT32 : limit >>> 0;
        // Make `global` and avoid `lastIndex` issues by working with a copy
        var separatorCopy = new RegExp(separator.source, flags + 'g');
        var match, lastIndex, lastLength;
        while(match = $isEge.call(separatorCopy, string)){
            lastIndex = separatorCopy[$0f1ee57e7ddc5959$var$LAST_INDEX];
            if (lastIndex > lastLastIndex) {
                output.push(string.slice(lastLastIndex, match.index));
                if (match[$0f1ee57e7ddc5959$var$LENGTH] > 1 && match.index < string[$0f1ee57e7ddc5959$var$LENGTH]) $0f1ee57e7ddc5959$var$$push.apply(output, match.slice(1));
                lastLength = match[0][$0f1ee57e7ddc5959$var$LENGTH];
                lastLastIndex = lastIndex;
                if (output[$0f1ee57e7ddc5959$var$LENGTH] >= splitLimit) break;
            }
            if (separatorCopy[$0f1ee57e7ddc5959$var$LAST_INDEX] === match.index) separatorCopy[$0f1ee57e7ddc5959$var$LAST_INDEX]++; // Avoid an infinite loop
        }
        if (lastLastIndex === string[$0f1ee57e7ddc5959$var$LENGTH]) {
            if (lastLength || !separatorCopy.test('')) output.push('');
        } else output.push(string.slice(lastLastIndex));
        return output[$0f1ee57e7ddc5959$var$LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
    else if ('0'[$0f1ee57e7ddc5959$var$$SPLIT](undefined, 0)[$0f1ee57e7ddc5959$var$LENGTH]) internalSplit = function(separator, limit) {
        return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
    else internalSplit = $split;
    return [
        // `String.prototype.split` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.split
        function split(separator, limit) {
            var O = defined(this);
            var splitter = separator == undefined ? undefined : separator[SPLIT];
            return splitter !== undefined ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
        },
        // `RegExp.prototype[@@split]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
        //
        // NOTE: This cannot be properly polyfilled in engines that don't support
        // the 'y' flag.
        function(regexp, limit) {
            var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
            if (res.done) return res.value;
            var rx = $bmSbf(regexp);
            var S = String(this);
            var C = $jrtAb(rx, RegExp);
            var unicodeMatching = rx.unicode;
            var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + ($0f1ee57e7ddc5959$var$SUPPORTS_Y ? 'y' : 'g');
            // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.
            var splitter = new C($0f1ee57e7ddc5959$var$SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
            var lim = limit === undefined ? $0f1ee57e7ddc5959$var$MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return $64cafe97791abf3e$exports(splitter, S) === null ? [
                S
            ] : [];
            var p = 0;
            var q = 0;
            var A = [];
            while(q < S.length){
                splitter.lastIndex = $0f1ee57e7ddc5959$var$SUPPORTS_Y ? q : 0;
                var z = $64cafe97791abf3e$exports(splitter, $0f1ee57e7ddc5959$var$SUPPORTS_Y ? S : S.slice(q));
                var e;
                if (z === null || (e = $0f1ee57e7ddc5959$var$$min($2Stpr(splitter.lastIndex + ($0f1ee57e7ddc5959$var$SUPPORTS_Y ? 0 : q)), S.length)) === p) q = $5ed59e2f08a2c1f9$exports(S, q, unicodeMatching);
                else {
                    A.push(S.slice(p, q));
                    if (A.length === lim) return A;
                    for(var i = 1; i <= z.length - 1; i++){
                        A.push(z[i]);
                        if (A.length === lim) return A;
                    }
                    q = p = e;
                }
            }
            A.push(S.slice(p));
            return A;
        }
    ];
});


'use strict';

var $8qcv4 = parcelRequire("8qcv4");

var $gtY0w = parcelRequire("gtY0w");

var $3eawb = parcelRequire("3eawb");

var $03JDo = parcelRequire("03JDo");

var $2SWGI = parcelRequire("2SWGI");

var $lD7l7 = parcelRequire("lD7l7");

var $aXqxV = parcelRequire("aXqxV");

var $1PWRj = parcelRequire("1PWRj");

var $5uNQA = parcelRequire("5uNQA");

var $jrtAb = parcelRequire("jrtAb");

var $jlcCz = parcelRequire("jlcCz");
var $222c6fcce9fa5390$require$task = $jlcCz.set;

var $222c6fcce9fa5390$var$microtask = (parcelRequire("6mCZJ"))();
var $cafed3c5d7a13208$exports = {};

$parcel$export($cafed3c5d7a13208$exports, "f", () => $cafed3c5d7a13208$export$2d1720544b23b823, (v) => $cafed3c5d7a13208$export$2d1720544b23b823 = v);
var $cafed3c5d7a13208$export$2d1720544b23b823;
'use strict';

var $aXqxV = parcelRequire("aXqxV");
function $cafed3c5d7a13208$var$PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $aXqxV(resolve);
    this.reject = $aXqxV(reject);
}
$cafed3c5d7a13208$export$2d1720544b23b823 = function(C) {
    return new $cafed3c5d7a13208$var$PromiseCapability(C);
};


var $d8fc643b3a4a7716$exports = {};
$d8fc643b3a4a7716$exports = function(exec) {
    try {
        return {
            e: false,
            v: exec()
        };
    } catch (e) {
        return {
            e: true,
            v: e
        };
    }
};


var $ddb91af34f91b412$exports = {};

var $gtY0w = parcelRequire("gtY0w");
var $ddb91af34f91b412$var$navigator = $gtY0w.navigator;
$ddb91af34f91b412$exports = $ddb91af34f91b412$var$navigator && $ddb91af34f91b412$var$navigator.userAgent || '';


var $df82bd50ce9839e2$exports = {};

var $bmSbf = parcelRequire("bmSbf");

var $lD7l7 = parcelRequire("lD7l7");

$df82bd50ce9839e2$exports = function(C, x) {
    $bmSbf(C);
    if ($lD7l7(x) && x.constructor === C) return x;
    var promiseCapability = $cafed3c5d7a13208$export$2d1720544b23b823(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};


var $222c6fcce9fa5390$var$PROMISE = 'Promise';
var $222c6fcce9fa5390$var$TypeError = $gtY0w.TypeError;
var $222c6fcce9fa5390$var$process = $gtY0w.process;
var $222c6fcce9fa5390$var$versions = $222c6fcce9fa5390$var$process && $222c6fcce9fa5390$var$process.versions;
var $222c6fcce9fa5390$var$v8 = $222c6fcce9fa5390$var$versions && $222c6fcce9fa5390$var$versions.v8 || '';
var $222c6fcce9fa5390$var$$Promise = $gtY0w[$222c6fcce9fa5390$var$PROMISE];
var $222c6fcce9fa5390$var$isNode = $03JDo($222c6fcce9fa5390$var$process) == 'process';
var $222c6fcce9fa5390$var$empty = function() {};
var $222c6fcce9fa5390$var$Internal, $222c6fcce9fa5390$var$newGenericPromiseCapability, $222c6fcce9fa5390$var$OwnPromiseCapability, $222c6fcce9fa5390$var$Wrapper;
var $222c6fcce9fa5390$var$newPromiseCapability = $222c6fcce9fa5390$var$newGenericPromiseCapability = $cafed3c5d7a13208$export$2d1720544b23b823;

var $222c6fcce9fa5390$var$USE_NATIVE = !!function() {
    try {
        // correct subclassing with @@species support
        var promise = $222c6fcce9fa5390$var$$Promise.resolve(1);
        var FakePromise = (promise.constructor = {})[(parcelRequire("fqMqf"))('species')] = function(exec) {
            exec($222c6fcce9fa5390$var$empty, $222c6fcce9fa5390$var$empty);
        };
        // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
        return ($222c6fcce9fa5390$var$isNode || typeof PromiseRejectionEvent == 'function') && promise.then($222c6fcce9fa5390$var$empty) instanceof FakePromise && $222c6fcce9fa5390$var$v8.indexOf('6.6') !== 0 && $ddb91af34f91b412$exports.indexOf('Chrome/66') === -1;
    } catch (e) {}
}();
// helpers
var $222c6fcce9fa5390$var$isThenable = function(it) {
    var then;
    return $lD7l7(it) && typeof (then = it.then) == 'function' ? then : false;
};
var $222c6fcce9fa5390$var$notify = function(promise, isReject) {
    if (promise._n) return;
    promise._n = true;
    var chain = promise._c;
    $222c6fcce9fa5390$var$microtask(function() {
        var value = promise._v;
        var ok = promise._s == 1;
        var i = 0;
        var run = function(reaction) {
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
                if (handler) {
                    if (!ok) {
                        if (promise._h == 2) $222c6fcce9fa5390$var$onHandleUnhandled(promise);
                        promise._h = 1;
                    }
                    if (handler === true) result = value;
                    else {
                        if (domain) domain.enter();
                        result = handler(value); // may throw
                        if (domain) {
                            domain.exit();
                            exited = true;
                        }
                    }
                    if (result === reaction.promise) reject($222c6fcce9fa5390$var$TypeError('Promise-chain cycle'));
                    else if (then = $222c6fcce9fa5390$var$isThenable(result)) then.call(result, resolve, reject);
                    else resolve(result);
                } else reject(value);
            } catch (e) {
                if (domain && !exited) domain.exit();
                reject(e);
            }
        };
        while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
        promise._c = [];
        promise._n = false;
        if (isReject && !promise._h) $222c6fcce9fa5390$var$onUnhandled(promise);
    });
};
var $222c6fcce9fa5390$var$onUnhandled = function(promise) {
    $222c6fcce9fa5390$require$task.call($gtY0w, function() {
        var value = promise._v;
        var unhandled = $222c6fcce9fa5390$var$isUnhandled(promise);
        var result, handler, console;
        if (unhandled) {
            result = $d8fc643b3a4a7716$exports(function() {
                if ($222c6fcce9fa5390$var$isNode) $222c6fcce9fa5390$var$process.emit('unhandledRejection', value, promise);
                else if (handler = $gtY0w.onunhandledrejection) handler({
                    promise: promise,
                    reason: value
                });
                else if ((console = $gtY0w.console) && console.error) console.error('Unhandled promise rejection', value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            promise._h = $222c6fcce9fa5390$var$isNode || $222c6fcce9fa5390$var$isUnhandled(promise) ? 2 : 1;
        }
        promise._a = undefined;
        if (unhandled && result.e) throw result.v;
    });
};
var $222c6fcce9fa5390$var$isUnhandled = function(promise) {
    return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var $222c6fcce9fa5390$var$onHandleUnhandled = function(promise) {
    $222c6fcce9fa5390$require$task.call($gtY0w, function() {
        var handler;
        if ($222c6fcce9fa5390$var$isNode) $222c6fcce9fa5390$var$process.emit('rejectionHandled', promise);
        else if (handler = $gtY0w.onrejectionhandled) handler({
            promise: promise,
            reason: promise._v
        });
    });
};
var $222c6fcce9fa5390$var$$reject = function(value) {
    var promise = this;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    promise._v = value;
    promise._s = 2;
    if (!promise._a) promise._a = promise._c.slice();
    $222c6fcce9fa5390$var$notify(promise, true);
};
var $222c6fcce9fa5390$var$$resolve = function(value) {
    var promise = this;
    var then;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    try {
        if (promise === value) throw $222c6fcce9fa5390$var$TypeError("Promise can't be resolved itself");
        if (then = $222c6fcce9fa5390$var$isThenable(value)) $222c6fcce9fa5390$var$microtask(function() {
            var wrapper = {
                _w: promise,
                _d: false
            }; // wrap
            try {
                then.call(value, $3eawb($222c6fcce9fa5390$var$$resolve, wrapper, 1), $3eawb($222c6fcce9fa5390$var$$reject, wrapper, 1));
            } catch (e) {
                $222c6fcce9fa5390$var$$reject.call(wrapper, e);
            }
        });
        else {
            promise._v = value;
            promise._s = 1;
            $222c6fcce9fa5390$var$notify(promise, false);
        }
    } catch (e) {
        $222c6fcce9fa5390$var$$reject.call({
            _w: promise,
            _d: false
        }, e); // wrap
    }
};

// constructor polyfill
if (!$222c6fcce9fa5390$var$USE_NATIVE) {
    // 25.4.3.1 Promise(executor)
    $222c6fcce9fa5390$var$$Promise = function Promise(executor) {
        $1PWRj(this, $222c6fcce9fa5390$var$$Promise, $222c6fcce9fa5390$var$PROMISE, '_h');
        $aXqxV(executor);
        $222c6fcce9fa5390$var$Internal.call(this);
        try {
            executor($3eawb($222c6fcce9fa5390$var$$resolve, this, 1), $3eawb($222c6fcce9fa5390$var$$reject, this, 1));
        } catch (err) {
            $222c6fcce9fa5390$var$$reject.call(this, err);
        }
    };
    // eslint-disable-next-line no-unused-vars
    $222c6fcce9fa5390$var$Internal = function Promise(executor) {
        this._c = []; // <- awaiting reactions
        this._a = undefined; // <- checked in isUnhandled reactions
        this._s = 0; // <- state
        this._d = false; // <- done
        this._v = undefined; // <- value
        this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
        this._n = false; // <- notify
    };
    $222c6fcce9fa5390$var$Internal.prototype = (parcelRequire("8wIxQ"))($222c6fcce9fa5390$var$$Promise.prototype, {
        // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
        then: function then(onFulfilled, onRejected) {
            var reaction = $222c6fcce9fa5390$var$newPromiseCapability($jrtAb(this, $222c6fcce9fa5390$var$$Promise));
            reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
            reaction.fail = typeof onRejected == 'function' && onRejected;
            reaction.domain = $222c6fcce9fa5390$var$isNode ? $222c6fcce9fa5390$var$process.domain : undefined;
            this._c.push(reaction);
            if (this._a) this._a.push(reaction);
            if (this._s) $222c6fcce9fa5390$var$notify(this, false);
            return reaction.promise;
        },
        // 25.4.5.1 Promise.prototype.catch(onRejected)
        'catch': function(onRejected) {
            return this.then(undefined, onRejected);
        }
    });
    $222c6fcce9fa5390$var$OwnPromiseCapability = function() {
        var promise = new $222c6fcce9fa5390$var$Internal();
        this.promise = promise;
        this.resolve = $3eawb($222c6fcce9fa5390$var$$resolve, promise, 1);
        this.reject = $3eawb($222c6fcce9fa5390$var$$reject, promise, 1);
    };
    $cafed3c5d7a13208$exports.f = $222c6fcce9fa5390$var$newPromiseCapability = function(C) {
        return C === $222c6fcce9fa5390$var$$Promise || C === $222c6fcce9fa5390$var$Wrapper ? new $222c6fcce9fa5390$var$OwnPromiseCapability(C) : $222c6fcce9fa5390$var$newGenericPromiseCapability(C);
    };
}
$2SWGI($2SWGI.G + $2SWGI.W + $2SWGI.F * !$222c6fcce9fa5390$var$USE_NATIVE, {
    Promise: $222c6fcce9fa5390$var$$Promise
});

(parcelRequire("aXF7u"))($222c6fcce9fa5390$var$$Promise, $222c6fcce9fa5390$var$PROMISE);

(parcelRequire("bDRPQ"))($222c6fcce9fa5390$var$PROMISE);

$222c6fcce9fa5390$var$Wrapper = (parcelRequire("8a19U"))[$222c6fcce9fa5390$var$PROMISE];
// statics
$2SWGI($2SWGI.S + $2SWGI.F * !$222c6fcce9fa5390$var$USE_NATIVE, $222c6fcce9fa5390$var$PROMISE, {
    // 25.4.4.5 Promise.reject(r)
    reject: function reject(r) {
        var capability = $222c6fcce9fa5390$var$newPromiseCapability(this);
        var $$reject = capability.reject;
        $$reject(r);
        return capability.promise;
    }
});
$2SWGI($2SWGI.S + $2SWGI.F * ($8qcv4 || !$222c6fcce9fa5390$var$USE_NATIVE), $222c6fcce9fa5390$var$PROMISE, {
    // 25.4.4.6 Promise.resolve(x)
    resolve: function resolve(x) {
        return $df82bd50ce9839e2$exports($8qcv4 && this === $222c6fcce9fa5390$var$Wrapper ? $222c6fcce9fa5390$var$$Promise : this, x);
    }
});

$2SWGI($2SWGI.S + $2SWGI.F * !($222c6fcce9fa5390$var$USE_NATIVE && (parcelRequire("gkPUi"))(function(iter) {
    $222c6fcce9fa5390$var$$Promise.all(iter)['catch']($222c6fcce9fa5390$var$empty);
})), $222c6fcce9fa5390$var$PROMISE, {
    // 25.4.4.1 Promise.all(iterable)
    all: function all(iterable) {
        var C = this;
        var capability = $222c6fcce9fa5390$var$newPromiseCapability(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $d8fc643b3a4a7716$exports(function() {
            var values = [];
            var index = 0;
            var remaining = 1;
            $5uNQA(iterable, false, function(promise) {
                var $index = index++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                C.resolve(promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[$index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.e) reject(result.v);
        return capability.promise;
    },
    // 25.4.4.4 Promise.race(iterable)
    race: function race(iterable) {
        var C = this;
        var capability = $222c6fcce9fa5390$var$newPromiseCapability(C);
        var reject = capability.reject;
        var result = $d8fc643b3a4a7716$exports(function() {
            $5uNQA(iterable, false, function(promise) {
                C.resolve(promise).then(capability.resolve, reject);
            });
        });
        if (result.e) reject(result.v);
        return capability.promise;
    }
});


var $c866f7677dadc4af$exports = {};
'use strict';
var $b2c1d9aedb9ff713$exports = {};
'use strict';

var $8QaBR = parcelRequire("8QaBR");
var $b2c1d9aedb9ff713$require$dP = $8QaBR.f;

var $3upGD = parcelRequire("3upGD");

var $8wIxQ = parcelRequire("8wIxQ");

var $3eawb = parcelRequire("3eawb");

var $1PWRj = parcelRequire("1PWRj");

var $5uNQA = parcelRequire("5uNQA");

var $aRtjl = parcelRequire("aRtjl");

var $3DTXB = parcelRequire("3DTXB");

var $bDRPQ = parcelRequire("bDRPQ");

var $8iMRJ = parcelRequire("8iMRJ");

var $gfLLt = parcelRequire("gfLLt");
var $b2c1d9aedb9ff713$require$fastKey = $gfLLt.fastKey;
var $5eb459100acebf57$exports = {};

var $lD7l7 = parcelRequire("lD7l7");
$5eb459100acebf57$exports = function(it, TYPE) {
    if (!$lD7l7(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
    return it;
};


var $b2c1d9aedb9ff713$var$SIZE = $8iMRJ ? '_s' : 'size';
var $b2c1d9aedb9ff713$var$getEntry = function(that, key) {
    // fast case
    var index = $b2c1d9aedb9ff713$require$fastKey(key);
    var entry;
    if (index !== 'F') return that._i[index];
    // frozen object case
    for(entry = that._f; entry; entry = entry.n){
        if (entry.k == key) return entry;
    }
};
$b2c1d9aedb9ff713$exports = {
    getConstructor: function(wrapper, NAME, IS_MAP, ADDER) {
        var C = wrapper(function(that, iterable) {
            $1PWRj(that, C, NAME, '_i');
            that._t = NAME; // collection type
            that._i = $3upGD(null); // index
            that._f = undefined; // first entry
            that._l = undefined; // last entry
            that[$b2c1d9aedb9ff713$var$SIZE] = 0; // size
            if (iterable != undefined) $5uNQA(iterable, IS_MAP, that[ADDER], that);
        });
        $8wIxQ(C.prototype, {
            // 23.1.3.1 Map.prototype.clear()
            // 23.2.3.2 Set.prototype.clear()
            clear: function clear() {
                for(var that = $5eb459100acebf57$exports(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n){
                    entry.r = true;
                    if (entry.p) entry.p = entry.p.n = undefined;
                    delete data[entry.i];
                }
                that._f = that._l = undefined;
                that[$b2c1d9aedb9ff713$var$SIZE] = 0;
            },
            // 23.1.3.3 Map.prototype.delete(key)
            // 23.2.3.4 Set.prototype.delete(value)
            'delete': function(key) {
                var that = $5eb459100acebf57$exports(this, NAME);
                var entry = $b2c1d9aedb9ff713$var$getEntry(that, key);
                if (entry) {
                    var next = entry.n;
                    var prev = entry.p;
                    delete that._i[entry.i];
                    entry.r = true;
                    if (prev) prev.n = next;
                    if (next) next.p = prev;
                    if (that._f == entry) that._f = next;
                    if (that._l == entry) that._l = prev;
                    that[$b2c1d9aedb9ff713$var$SIZE]--;
                }
                return !!entry;
            },
            // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
            // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                $5eb459100acebf57$exports(this, NAME);
                var f = $3eawb(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
                var entry;
                while(entry = entry ? entry.n : this._f){
                    f(entry.v, entry.k, this);
                    // revert to the last existing entry
                    while(entry && entry.r)entry = entry.p;
                }
            },
            // 23.1.3.7 Map.prototype.has(key)
            // 23.2.3.7 Set.prototype.has(value)
            has: function has(key) {
                return !!$b2c1d9aedb9ff713$var$getEntry($5eb459100acebf57$exports(this, NAME), key);
            }
        });
        if ($8iMRJ) $b2c1d9aedb9ff713$require$dP(C.prototype, 'size', {
            get: function() {
                return $5eb459100acebf57$exports(this, NAME)[$b2c1d9aedb9ff713$var$SIZE];
            }
        });
        return C;
    },
    def: function(that, key, value) {
        var entry = $b2c1d9aedb9ff713$var$getEntry(that, key);
        var prev, index;
        // change existing entry
        if (entry) entry.v = value;
        else {
            that._l = entry = {
                i: index = $b2c1d9aedb9ff713$require$fastKey(key, true),
                k: key,
                v: value,
                p: prev = that._l,
                n: undefined,
                r: false // <- removed
            };
            if (!that._f) that._f = entry;
            if (prev) prev.n = entry;
            that[$b2c1d9aedb9ff713$var$SIZE]++;
            // add to index
            if (index !== 'F') that._i[index] = entry;
        }
        return that;
    },
    getEntry: $b2c1d9aedb9ff713$var$getEntry,
    setStrong: function(C, NAME, IS_MAP) {
        // add .keys, .values, .entries, [@@iterator]
        // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
        $aRtjl(C, NAME, function(iterated, kind) {
            this._t = $5eb459100acebf57$exports(iterated, NAME); // target
            this._k = kind; // kind
            this._l = undefined; // previous
        }, function() {
            var that = this;
            var kind = that._k;
            var entry = that._l;
            // revert to the last existing entry
            while(entry && entry.r)entry = entry.p;
            // get next entry
            if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
                // or finish the iteration
                that._t = undefined;
                return $3DTXB(1);
            }
            // return step by kind
            if (kind == 'keys') return $3DTXB(0, entry.k);
            if (kind == 'values') return $3DTXB(0, entry.v);
            return $3DTXB(0, [
                entry.k,
                entry.v
            ]);
        }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
        // add [@@species], 23.1.2.2, 23.2.2.2
        $bDRPQ(NAME);
    }
};



var $c866f7677dadc4af$var$MAP = 'Map';

// 23.1 Map Objects
$c866f7677dadc4af$exports = (parcelRequire("ixLuk"))($c866f7677dadc4af$var$MAP, function(get) {
    return function Map() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
}, {
    // 23.1.3.6 Map.prototype.get(key)
    get: function get(key) {
        var entry = $b2c1d9aedb9ff713$exports.getEntry($5eb459100acebf57$exports(this, $c866f7677dadc4af$var$MAP), key);
        return entry && entry.v;
    },
    // 23.1.3.9 Map.prototype.set(key, value)
    set: function set(key, value) {
        return $b2c1d9aedb9ff713$exports.def($5eb459100acebf57$exports(this, $c866f7677dadc4af$var$MAP), key === 0 ? 0 : key, value);
    }
}, $b2c1d9aedb9ff713$exports, true);


var $db5925b24fb7ec35$exports = {};
'use strict';


var $db5925b24fb7ec35$var$SET = 'Set';

// 23.2 Set Objects
$db5925b24fb7ec35$exports = (parcelRequire("ixLuk"))($db5925b24fb7ec35$var$SET, function(get) {
    return function Set() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
}, {
    // 23.2.3.1 Set.prototype.add(value)
    add: function add(value) {
        return $b2c1d9aedb9ff713$exports.def($5eb459100acebf57$exports(this, $db5925b24fb7ec35$var$SET), value = value === 0 ? 0 : value, value);
    }
}, $b2c1d9aedb9ff713$exports);


var $9fadd100279a7fbc$exports = {};
'use strict';

var $gtY0w = parcelRequire("gtY0w");

var $9fadd100279a7fbc$var$each = (parcelRequire("3gy3i"))(0);

var $bIIwe = parcelRequire("bIIwe");

var $gfLLt = parcelRequire("gfLLt");

var $eHB8s = parcelRequire("eHB8s");
var $9aa355ec3c3e482c$exports = {};
'use strict';

var $8wIxQ = parcelRequire("8wIxQ");

var $gfLLt = parcelRequire("gfLLt");
var $9aa355ec3c3e482c$require$getWeak = $gfLLt.getWeak;

var $bmSbf = parcelRequire("bmSbf");

var $lD7l7 = parcelRequire("lD7l7");

var $1PWRj = parcelRequire("1PWRj");

var $5uNQA = parcelRequire("5uNQA");

var $3gy3i = parcelRequire("3gy3i");

var $lXZiV = parcelRequire("lXZiV");

var $9aa355ec3c3e482c$var$arrayFind = $3gy3i(5);
var $9aa355ec3c3e482c$var$arrayFindIndex = $3gy3i(6);
var $9aa355ec3c3e482c$var$id = 0;
// fallback for uncaught frozen keys
var $9aa355ec3c3e482c$var$uncaughtFrozenStore = function(that) {
    return that._l || (that._l = new $9aa355ec3c3e482c$var$UncaughtFrozenStore());
};
var $9aa355ec3c3e482c$var$UncaughtFrozenStore = function() {
    this.a = [];
};
var $9aa355ec3c3e482c$var$findUncaughtFrozen = function(store, key) {
    return $9aa355ec3c3e482c$var$arrayFind(store.a, function(it) {
        return it[0] === key;
    });
};
$9aa355ec3c3e482c$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $9aa355ec3c3e482c$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$9aa355ec3c3e482c$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $9aa355ec3c3e482c$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.a.push([
            key,
            value
        ]);
    },
    'delete': function(key) {
        var index = $9aa355ec3c3e482c$var$arrayFindIndex(this.a, function(it) {
            return it[0] === key;
        });
        if (~index) this.a.splice(index, 1);
        return !!~index;
    }
};
$9aa355ec3c3e482c$exports = {
    getConstructor: function(wrapper, NAME, IS_MAP, ADDER) {
        var C = wrapper(function(that, iterable) {
            $1PWRj(that, C, NAME, '_i');
            that._t = NAME; // collection type
            that._i = $9aa355ec3c3e482c$var$id++; // collection id
            that._l = undefined; // leak store for uncaught frozen objects
            if (iterable != undefined) $5uNQA(iterable, IS_MAP, that[ADDER], that);
        });
        $8wIxQ(C.prototype, {
            // 23.3.3.2 WeakMap.prototype.delete(key)
            // 23.4.3.3 WeakSet.prototype.delete(value)
            'delete': function(key) {
                if (!$lD7l7(key)) return false;
                var data = $9aa355ec3c3e482c$require$getWeak(key);
                if (data === true) return $9aa355ec3c3e482c$var$uncaughtFrozenStore($5eb459100acebf57$exports(this, NAME))['delete'](key);
                return data && $lXZiV(data, this._i) && delete data[this._i];
            },
            // 23.3.3.4 WeakMap.prototype.has(key)
            // 23.4.3.4 WeakSet.prototype.has(value)
            has: function has(key) {
                if (!$lD7l7(key)) return false;
                var data = $9aa355ec3c3e482c$require$getWeak(key);
                if (data === true) return $9aa355ec3c3e482c$var$uncaughtFrozenStore($5eb459100acebf57$exports(this, NAME)).has(key);
                return data && $lXZiV(data, this._i);
            }
        });
        return C;
    },
    def: function(that, key, value) {
        var data = $9aa355ec3c3e482c$require$getWeak($bmSbf(key), true);
        if (data === true) $9aa355ec3c3e482c$var$uncaughtFrozenStore(that).set(key, value);
        else data[that._i] = value;
        return that;
    },
    ufstore: $9aa355ec3c3e482c$var$uncaughtFrozenStore
};



var $lD7l7 = parcelRequire("lD7l7");


var $9fadd100279a7fbc$var$IS_IE11 = !$gtY0w.ActiveXObject && 'ActiveXObject' in $gtY0w;
var $9fadd100279a7fbc$var$WEAK_MAP = 'WeakMap';
var $9fadd100279a7fbc$var$getWeak = $gfLLt.getWeak;
var $9fadd100279a7fbc$var$isExtensible = Object.isExtensible;
var $9fadd100279a7fbc$var$uncaughtFrozenStore = $9aa355ec3c3e482c$exports.ufstore;
var $9fadd100279a7fbc$var$InternalMap;
var $9fadd100279a7fbc$var$wrapper = function(get) {
    return function WeakMap() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
};
var $9fadd100279a7fbc$var$methods = {
    // 23.3.3.3 WeakMap.prototype.get(key)
    get: function get(key) {
        if ($lD7l7(key)) {
            var data = $9fadd100279a7fbc$var$getWeak(key);
            if (data === true) return $9fadd100279a7fbc$var$uncaughtFrozenStore($5eb459100acebf57$exports(this, $9fadd100279a7fbc$var$WEAK_MAP)).get(key);
            return data ? data[this._i] : undefined;
        }
    },
    // 23.3.3.5 WeakMap.prototype.set(key, value)
    set: function set(key, value) {
        return $9aa355ec3c3e482c$exports.def($5eb459100acebf57$exports(this, $9fadd100279a7fbc$var$WEAK_MAP), key, value);
    }
};

// 23.3 WeakMap Objects
var $9fadd100279a7fbc$var$$WeakMap = $9fadd100279a7fbc$exports = (parcelRequire("ixLuk"))($9fadd100279a7fbc$var$WEAK_MAP, $9fadd100279a7fbc$var$wrapper, $9fadd100279a7fbc$var$methods, $9aa355ec3c3e482c$exports, true, true);
// IE11 WeakMap frozen keys fix
if ($5eb459100acebf57$exports && $9fadd100279a7fbc$var$IS_IE11) {
    $9fadd100279a7fbc$var$InternalMap = $9aa355ec3c3e482c$exports.getConstructor($9fadd100279a7fbc$var$wrapper, $9fadd100279a7fbc$var$WEAK_MAP);
    $eHB8s($9fadd100279a7fbc$var$InternalMap.prototype, $9fadd100279a7fbc$var$methods);
    $gfLLt.NEED = true;
    $9fadd100279a7fbc$var$each([
        'delete',
        'has',
        'get',
        'set'
    ], function(key) {
        var proto = $9fadd100279a7fbc$var$$WeakMap.prototype;
        var method = proto[key];
        $bIIwe(proto, key, function(a, b) {
            // store frozen objects on internal weakmap shim
            if ($lD7l7(a) && !$9fadd100279a7fbc$var$isExtensible(a)) {
                if (!this._f) this._f = new $9fadd100279a7fbc$var$InternalMap();
                var result = this._f[key](a, b);
                return key == 'set' ? this : result;
            // store all the rest on native weakmap
            }
            return method.call(this, a, b);
        });
    });
}


'use strict';


var $ccf7aa418e4a0b84$var$WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
(parcelRequire("ixLuk"))($ccf7aa418e4a0b84$var$WEAK_SET, function(get) {
    return function WeakSet() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
}, {
    // 23.4.3.1 WeakSet.prototype.add(value)
    add: function add(value) {
        return $9aa355ec3c3e482c$exports.def($5eb459100acebf57$exports(this, $ccf7aa418e4a0b84$var$WEAK_SET), value, true);
    }
}, $9aa355ec3c3e482c$exports, false, true);


'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $fCxik = parcelRequire("fCxik");

var $3ftQA = parcelRequire("3ftQA");

var $bmSbf = parcelRequire("bmSbf");

var $anH1q = parcelRequire("anH1q");

var $2Stpr = parcelRequire("2Stpr");

var $lD7l7 = parcelRequire("lD7l7");

var $gtY0w = parcelRequire("gtY0w");
var $0e28b3bd268caec8$require$ArrayBuffer = $gtY0w.ArrayBuffer;

var $jrtAb = parcelRequire("jrtAb");
var $0e28b3bd268caec8$var$$ArrayBuffer = $3ftQA.ArrayBuffer;
var $0e28b3bd268caec8$var$$DataView = $3ftQA.DataView;
var $0e28b3bd268caec8$var$$isView = $fCxik.ABV && $0e28b3bd268caec8$require$ArrayBuffer.isView;
var $0e28b3bd268caec8$var$$slice = $0e28b3bd268caec8$var$$ArrayBuffer.prototype.slice;
var $0e28b3bd268caec8$var$VIEW = $fCxik.VIEW;
var $0e28b3bd268caec8$var$ARRAY_BUFFER = 'ArrayBuffer';
$2SWGI($2SWGI.G + $2SWGI.W + $2SWGI.F * ($0e28b3bd268caec8$require$ArrayBuffer !== $0e28b3bd268caec8$var$$ArrayBuffer), {
    ArrayBuffer: $0e28b3bd268caec8$var$$ArrayBuffer
});
$2SWGI($2SWGI.S + $2SWGI.F * !$fCxik.CONSTR, $0e28b3bd268caec8$var$ARRAY_BUFFER, {
    // 24.1.3.1 ArrayBuffer.isView(arg)
    isView: function isView(it) {
        return $0e28b3bd268caec8$var$$isView && $0e28b3bd268caec8$var$$isView(it) || $lD7l7(it) && $0e28b3bd268caec8$var$VIEW in it;
    }
});

$2SWGI($2SWGI.P + $2SWGI.U + $2SWGI.F * (parcelRequire("QlNUq"))(function() {
    return !new $0e28b3bd268caec8$var$$ArrayBuffer(2).slice(1, undefined).byteLength;
}), $0e28b3bd268caec8$var$ARRAY_BUFFER, {
    // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
    slice: function slice(start, end) {
        if ($0e28b3bd268caec8$var$$slice !== undefined && end === undefined) return $0e28b3bd268caec8$var$$slice.call($bmSbf(this), start); // FF fix
        var len = $bmSbf(this).byteLength;
        var first = $anH1q(start, len);
        var fin = $anH1q(end === undefined ? len : end, len);
        var result = new ($jrtAb(this, $0e28b3bd268caec8$var$$ArrayBuffer))($2Stpr(fin - first));
        var viewS = new $0e28b3bd268caec8$var$$DataView(this);
        var viewT = new $0e28b3bd268caec8$var$$DataView(result);
        var index = 0;
        while(first < fin)viewT.setUint8(index++, viewS.getUint8(first++));
        return result;
    }
});

(parcelRequire("bDRPQ"))($0e28b3bd268caec8$var$ARRAY_BUFFER);



var $2SWGI = parcelRequire("2SWGI");


$2SWGI($2SWGI.G + $2SWGI.W + $2SWGI.F * !(parcelRequire("fCxik")).ABV, {
    DataView: (parcelRequire("3ftQA")).DataView
});



(parcelRequire("lrRPW"))('Int8', 1, function(init) {
    return function Int8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("lrRPW"))('Uint8', 1, function(init) {
    return function Uint8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("lrRPW"))('Uint8', 1, function(init) {
    return function Uint8ClampedArray(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
}, true);



(parcelRequire("lrRPW"))('Int16', 2, function(init) {
    return function Int16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("lrRPW"))('Uint16', 2, function(init) {
    return function Uint16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("lrRPW"))('Int32', 4, function(init) {
    return function Int32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("lrRPW"))('Uint32', 4, function(init) {
    return function Uint32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("lrRPW"))('Float32', 4, function(init) {
    return function Float32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});



(parcelRequire("lrRPW"))('Float64', 8, function(init) {
    return function Float64Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});


// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)

var $2SWGI = parcelRequire("2SWGI");

var $aXqxV = parcelRequire("aXqxV");

var $bmSbf = parcelRequire("bmSbf");

var $e9f7875e087e3672$var$rApply = ((parcelRequire("gtY0w")).Reflect || {}).apply;
var $e9f7875e087e3672$var$fApply = Function.apply;

// MS Edge argumentsList argument is optional
$2SWGI($2SWGI.S + $2SWGI.F * !(parcelRequire("QlNUq"))(function() {
    $e9f7875e087e3672$var$rApply(function() {});
}), 'Reflect', {
    apply: function apply(target, thisArgument, argumentsList) {
        var T = $aXqxV(target);
        var L = $bmSbf(argumentsList);
        return $e9f7875e087e3672$var$rApply ? $e9f7875e087e3672$var$rApply(T, thisArgument, L) : $e9f7875e087e3672$var$fApply.call(T, thisArgument, L);
    }
});


// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])

var $2SWGI = parcelRequire("2SWGI");

var $3upGD = parcelRequire("3upGD");

var $aXqxV = parcelRequire("aXqxV");

var $bmSbf = parcelRequire("bmSbf");

var $lD7l7 = parcelRequire("lD7l7");

var $QlNUq = parcelRequire("QlNUq");

var $i9XH1 = parcelRequire("i9XH1");

var $8aa06b77961ecbb6$var$rConstruct = ((parcelRequire("gtY0w")).Reflect || {}).construct;
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var $8aa06b77961ecbb6$var$NEW_TARGET_BUG = $QlNUq(function() {
    function F() {}
    return !($8aa06b77961ecbb6$var$rConstruct(function() {}, [], F) instanceof F);
});
var $8aa06b77961ecbb6$var$ARGS_BUG = !$QlNUq(function() {
    $8aa06b77961ecbb6$var$rConstruct(function() {});
});
$2SWGI($2SWGI.S + $2SWGI.F * ($8aa06b77961ecbb6$var$NEW_TARGET_BUG || $8aa06b77961ecbb6$var$ARGS_BUG), 'Reflect', {
    construct: function construct(Target, args /* , newTarget */ ) {
        $aXqxV(Target);
        $bmSbf(args);
        var newTarget = arguments.length < 3 ? Target : $aXqxV(arguments[2]);
        if ($8aa06b77961ecbb6$var$ARGS_BUG && !$8aa06b77961ecbb6$var$NEW_TARGET_BUG) return $8aa06b77961ecbb6$var$rConstruct(Target, args, newTarget);
        if (Target == newTarget) {
            // w/o altered newTarget, optimization for 0-4 arguments
            switch(args.length){
                case 0:
                    return new Target();
                case 1:
                    return new Target(args[0]);
                case 2:
                    return new Target(args[0], args[1]);
                case 3:
                    return new Target(args[0], args[1], args[2]);
                case 4:
                    return new Target(args[0], args[1], args[2], args[3]);
            }
            // w/o altered newTarget, lot of arguments case
            var $args = [
                null
            ];
            $args.push.apply($args, args);
            return new ($i9XH1.apply(Target, $args))();
        }
        // with altered newTarget, not support built-in constructors
        var proto = newTarget.prototype;
        var instance = $3upGD($lD7l7(proto) ? proto : Object.prototype);
        var result = Function.apply.call(Target, instance, args);
        return $lD7l7(result) ? result : instance;
    }
});


// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)

var $8QaBR = parcelRequire("8QaBR");

var $2SWGI = parcelRequire("2SWGI");

var $bmSbf = parcelRequire("bmSbf");

var $01Csn = parcelRequire("01Csn");

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$2SWGI($2SWGI.S + $2SWGI.F * (parcelRequire("QlNUq"))(function() {
    // eslint-disable-next-line no-undef
    Reflect.defineProperty($8QaBR.f({}, 1, {
        value: 1
    }), 1, {
        value: 2
    });
}), 'Reflect', {
    defineProperty: function defineProperty(target, propertyKey, attributes) {
        $bmSbf(target);
        propertyKey = $01Csn(propertyKey, true);
        $bmSbf(attributes);
        try {
            $8QaBR.f(target, propertyKey, attributes);
            return true;
        } catch (e) {
            return false;
        }
    }
});


// 26.1.4 Reflect.deleteProperty(target, propertyKey)

var $2SWGI = parcelRequire("2SWGI");

var $11pTE = parcelRequire("11pTE");
var $dbe2c4181dacd110$require$gOPD = $11pTE.f;

var $bmSbf = parcelRequire("bmSbf");
$2SWGI($2SWGI.S, 'Reflect', {
    deleteProperty: function deleteProperty(target, propertyKey) {
        var desc = $dbe2c4181dacd110$require$gOPD($bmSbf(target), propertyKey);
        return desc && !desc.configurable ? false : delete target[propertyKey];
    }
});


'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $bmSbf = parcelRequire("bmSbf");
var $441d40ca0c6300b5$var$Enumerate = function(iterated) {
    this._t = $bmSbf(iterated); // target
    this._i = 0; // next index
    var keys = this._k = []; // keys
    var key;
    for(key in iterated)keys.push(key);
};

(parcelRequire("kCznt"))($441d40ca0c6300b5$var$Enumerate, 'Object', function() {
    var that = this;
    var keys = that._k;
    var key;
    do {
        if (that._i >= keys.length) return {
            value: undefined,
            done: true
        };
    }while (!((key = keys[that._i++]) in that._t));
    return {
        value: key,
        done: false
    };
});
$2SWGI($2SWGI.S, 'Reflect', {
    enumerate: function enumerate(target) {
        return new $441d40ca0c6300b5$var$Enumerate(target);
    }
});


// 26.1.6 Reflect.get(target, propertyKey [, receiver])

var $11pTE = parcelRequire("11pTE");

var $5nB59 = parcelRequire("5nB59");

var $lXZiV = parcelRequire("lXZiV");

var $2SWGI = parcelRequire("2SWGI");

var $lD7l7 = parcelRequire("lD7l7");

var $bmSbf = parcelRequire("bmSbf");
function $8cdede366ba5ff83$var$get(target, propertyKey /* , receiver */ ) {
    var receiver = arguments.length < 3 ? target : arguments[2];
    var desc, proto;
    if ($bmSbf(target) === receiver) return target[propertyKey];
    if (desc = $11pTE.f(target, propertyKey)) return $lXZiV(desc, 'value') ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
    if ($lD7l7(proto = $5nB59(target))) return $8cdede366ba5ff83$var$get(proto, propertyKey, receiver);
}
$2SWGI($2SWGI.S, 'Reflect', {
    get: $8cdede366ba5ff83$var$get
});


// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)

var $11pTE = parcelRequire("11pTE");

var $2SWGI = parcelRequire("2SWGI");

var $bmSbf = parcelRequire("bmSbf");
$2SWGI($2SWGI.S, 'Reflect', {
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
        return $11pTE.f($bmSbf(target), propertyKey);
    }
});


// 26.1.8 Reflect.getPrototypeOf(target)

var $2SWGI = parcelRequire("2SWGI");

var $5nB59 = parcelRequire("5nB59");

var $bmSbf = parcelRequire("bmSbf");
$2SWGI($2SWGI.S, 'Reflect', {
    getPrototypeOf: function getPrototypeOf(target) {
        return $5nB59($bmSbf(target));
    }
});


// 26.1.9 Reflect.has(target, propertyKey)

var $2SWGI = parcelRequire("2SWGI");
$2SWGI($2SWGI.S, 'Reflect', {
    has: function has(target, propertyKey) {
        return propertyKey in target;
    }
});


// 26.1.10 Reflect.isExtensible(target)

var $2SWGI = parcelRequire("2SWGI");

var $bmSbf = parcelRequire("bmSbf");
var $722d0df0ce229022$var$$isExtensible = Object.isExtensible;
$2SWGI($2SWGI.S, 'Reflect', {
    isExtensible: function isExtensible(target) {
        $bmSbf(target);
        return $722d0df0ce229022$var$$isExtensible ? $722d0df0ce229022$var$$isExtensible(target) : true;
    }
});


// 26.1.11 Reflect.ownKeys(target)

var $2SWGI = parcelRequire("2SWGI");

$2SWGI($2SWGI.S, 'Reflect', {
    ownKeys: (parcelRequire("bzgfn"))
});


// 26.1.12 Reflect.preventExtensions(target)

var $2SWGI = parcelRequire("2SWGI");

var $bmSbf = parcelRequire("bmSbf");
var $a8b41df04bf5c820$var$$preventExtensions = Object.preventExtensions;
$2SWGI($2SWGI.S, 'Reflect', {
    preventExtensions: function preventExtensions(target) {
        $bmSbf(target);
        try {
            if ($a8b41df04bf5c820$var$$preventExtensions) $a8b41df04bf5c820$var$$preventExtensions(target);
            return true;
        } catch (e) {
            return false;
        }
    }
});


// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])

var $8QaBR = parcelRequire("8QaBR");

var $11pTE = parcelRequire("11pTE");

var $5nB59 = parcelRequire("5nB59");

var $lXZiV = parcelRequire("lXZiV");

var $2SWGI = parcelRequire("2SWGI");

var $cttRt = parcelRequire("cttRt");

var $bmSbf = parcelRequire("bmSbf");

var $lD7l7 = parcelRequire("lD7l7");
function $70f7ba07c431b090$var$set(target, propertyKey, V /* , receiver */ ) {
    var receiver = arguments.length < 4 ? target : arguments[3];
    var ownDesc = $11pTE.f($bmSbf(target), propertyKey);
    var existingDescriptor, proto;
    if (!ownDesc) {
        if ($lD7l7(proto = $5nB59(target))) return $70f7ba07c431b090$var$set(proto, propertyKey, V, receiver);
        ownDesc = $cttRt(0);
    }
    if ($lXZiV(ownDesc, 'value')) {
        if (ownDesc.writable === false || !$lD7l7(receiver)) return false;
        if (existingDescriptor = $11pTE.f(receiver, propertyKey)) {
            if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
            existingDescriptor.value = V;
            $8QaBR.f(receiver, propertyKey, existingDescriptor);
        } else $8QaBR.f(receiver, propertyKey, $cttRt(0, V));
        return true;
    }
    return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}
$2SWGI($2SWGI.S, 'Reflect', {
    set: $70f7ba07c431b090$var$set
});


// 26.1.14 Reflect.setPrototypeOf(target, proto)

var $2SWGI = parcelRequire("2SWGI");

var $FiBqq = parcelRequire("FiBqq");
if ($FiBqq) $2SWGI($2SWGI.S, 'Reflect', {
    setPrototypeOf: function setPrototypeOf(target, proto) {
        $FiBqq.check(target, proto);
        try {
            $FiBqq.set(target, proto);
            return true;
        } catch (e) {
            return false;
        }
    }
});



$40eda3d290c1d2c0$exports = (parcelRequire("8a19U"));


var $f739618c136719c5$exports = {};
'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $2af667d2a674bd67$var$$includes = (parcelRequire("2zzLE"))(true);
$2SWGI($2SWGI.P, 'Array', {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $2af667d2a674bd67$var$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});

(parcelRequire("fUASv"))('includes');



$f739618c136719c5$exports = (parcelRequire("8a19U")).Array.includes;


var $18ea4d5fae33e967$exports = {};
'use strict';

var $2SWGI = parcelRequire("2SWGI");
var $952e55dda7ea8008$exports = {};
'use strict';

var $1y0po = parcelRequire("1y0po");

var $lD7l7 = parcelRequire("lD7l7");

var $2Stpr = parcelRequire("2Stpr");

var $3eawb = parcelRequire("3eawb");

var $952e55dda7ea8008$var$IS_CONCAT_SPREADABLE = (parcelRequire("fqMqf"))('isConcatSpreadable');
function $952e55dda7ea8008$var$flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
    var targetIndex = start;
    var sourceIndex = 0;
    var mapFn = mapper ? $3eawb(mapper, thisArg, 3) : false;
    var element, spreadable;
    while(sourceIndex < sourceLen){
        if (sourceIndex in source) {
            element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
            spreadable = false;
            if ($lD7l7(element)) {
                spreadable = element[$952e55dda7ea8008$var$IS_CONCAT_SPREADABLE];
                spreadable = spreadable !== undefined ? !!spreadable : $1y0po(element);
            }
            if (spreadable && depth > 0) targetIndex = $952e55dda7ea8008$var$flattenIntoArray(target, original, element, $2Stpr(element.length), targetIndex, depth - 1) - 1;
            else {
                if (targetIndex >= 0x1fffffffffffff) throw TypeError();
                target[targetIndex] = element;
            }
            targetIndex++;
        }
        sourceIndex++;
    }
    return targetIndex;
}
$952e55dda7ea8008$exports = $952e55dda7ea8008$var$flattenIntoArray;



var $7bwTf = parcelRequire("7bwTf");

var $2Stpr = parcelRequire("2Stpr");

var $aXqxV = parcelRequire("aXqxV");

var $5Yuv1 = parcelRequire("5Yuv1");
$2SWGI($2SWGI.P, 'Array', {
    flatMap: function flatMap(callbackfn /* , thisArg */ ) {
        var O = $7bwTf(this);
        var sourceLen, A;
        $aXqxV(callbackfn);
        sourceLen = $2Stpr(O.length);
        A = $5Yuv1(O, 0);
        $952e55dda7ea8008$exports(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
        return A;
    }
});

(parcelRequire("fUASv"))('flatMap');



$18ea4d5fae33e967$exports = (parcelRequire("8a19U")).Array.flatMap;


var $4ac4db74544fcba4$exports = {};
'use strict';

var $2SWGI = parcelRequire("2SWGI");
var $95ae5c63ebcb5d6f$exports = {};
// https://github.com/tc39/proposal-string-pad-start-end

var $2Stpr = parcelRequire("2Stpr");

var $iBPed = parcelRequire("iBPed");

var $duF9G = parcelRequire("duF9G");
$95ae5c63ebcb5d6f$exports = function(that, maxLength, fillString, left) {
    var S = String($duF9G(that));
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : String(fillString);
    var intMaxLength = $2Stpr(maxLength);
    if (intMaxLength <= stringLength || fillStr == '') return S;
    var fillLen = intMaxLength - stringLength;
    var stringFiller = $iBPed.call(fillStr, Math.ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
    return left ? stringFiller + S : S + stringFiller;
};



// https://github.com/zloirock/core-js/issues/280
var $0b5b006331bbb8c1$var$WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test($ddb91af34f91b412$exports);
$2SWGI($2SWGI.P + $2SWGI.F * $0b5b006331bbb8c1$var$WEBKIT_BUG, 'String', {
    padStart: function padStart(maxLength /* , fillString = ' ' */ ) {
        return $95ae5c63ebcb5d6f$exports(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
    }
});



$4ac4db74544fcba4$exports = (parcelRequire("8a19U")).String.padStart;


var $8fdaa82fa662a7dc$exports = {};
'use strict';

var $2SWGI = parcelRequire("2SWGI");


// https://github.com/zloirock/core-js/issues/280
var $4466b8296a2ea011$var$WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test($ddb91af34f91b412$exports);
$2SWGI($2SWGI.P + $2SWGI.F * $4466b8296a2ea011$var$WEBKIT_BUG, 'String', {
    padEnd: function padEnd(maxLength /* , fillString = ' ' */ ) {
        return $95ae5c63ebcb5d6f$exports(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
    }
});



$8fdaa82fa662a7dc$exports = (parcelRequire("8a19U")).String.padEnd;


var $5b259eeebe89090a$exports = {};
'use strict';

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
(parcelRequire("7fWUt"))('trimLeft', function($trim) {
    return function trimLeft() {
        return $trim(this, 1);
    };
}, 'trimStart');



$5b259eeebe89090a$exports = (parcelRequire("8a19U")).String.trimLeft;


var $15979ef82b5b0b69$exports = {};
'use strict';

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
(parcelRequire("7fWUt"))('trimRight', function($trim) {
    return function trimRight() {
        return $trim(this, 2);
    };
}, 'trimEnd');



$15979ef82b5b0b69$exports = (parcelRequire("8a19U")).String.trimRight;


var $01f8ca6ac4d16266$exports = {};

(parcelRequire("lWstx"))('asyncIterator');



$01f8ca6ac4d16266$exports = (parcelRequire("8IDtE")).f('asyncIterator');


var $e2316ed6b32c0928$exports = {};
// https://github.com/tc39/proposal-object-getownpropertydescriptors

var $2SWGI = parcelRequire("2SWGI");

var $bzgfn = parcelRequire("bzgfn");

var $5T7Du = parcelRequire("5T7Du");

var $11pTE = parcelRequire("11pTE");

$2SWGI($2SWGI.S, 'Object', {
    getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
        var O = $5T7Du(object);
        var getDesc = $11pTE.f;
        var keys = $bzgfn(O);
        var result = {};
        var i = 0;
        var key, desc;
        while(keys.length > i){
            desc = getDesc(O, key = keys[i++]);
            if (desc !== undefined) $ec78b45bb3fccb2c$exports(result, key, desc);
        }
        return result;
    }
});



$e2316ed6b32c0928$exports = (parcelRequire("8a19U")).Object.getOwnPropertyDescriptors;


var $cbb79d2018d00da8$exports = {};
// https://github.com/tc39/proposal-object-values-entries

var $2SWGI = parcelRequire("2SWGI");

var $d4d04e7f9afbb51d$var$$values = (parcelRequire("4SA5N"))(false);
$2SWGI($2SWGI.S, 'Object', {
    values: function values(it) {
        return $d4d04e7f9afbb51d$var$$values(it);
    }
});



$cbb79d2018d00da8$exports = (parcelRequire("8a19U")).Object.values;


var $c13696e67b897f28$exports = {};
// https://github.com/tc39/proposal-object-values-entries

var $2SWGI = parcelRequire("2SWGI");

var $0572b472a21a0de1$var$$entries = (parcelRequire("4SA5N"))(true);
$2SWGI($2SWGI.S, 'Object', {
    entries: function entries(it) {
        return $0572b472a21a0de1$var$$entries(it);
    }
});



$c13696e67b897f28$exports = (parcelRequire("8a19U")).Object.entries;


var $5cfd2accce9be279$exports = {};
'use strict';

// https://github.com/tc39/proposal-promise-finally
'use strict';

var $2SWGI = parcelRequire("2SWGI");

var $8a19U = parcelRequire("8a19U");

var $gtY0w = parcelRequire("gtY0w");

var $jrtAb = parcelRequire("jrtAb");

$2SWGI($2SWGI.P + $2SWGI.R, 'Promise', {
    'finally': function(onFinally) {
        var C = $jrtAb(this, $8a19U.Promise || $gtY0w.Promise);
        var isFunction = typeof onFinally == 'function';
        return this.then(isFunction ? function(x) {
            return $df82bd50ce9839e2$exports(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $df82bd50ce9839e2$exports(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});



$5cfd2accce9be279$exports = (parcelRequire("8a19U")).Promise['finally'];


var $362ff6ab2a35afe7$exports = {};
// ie9- setTimeout & setInterval additional parameters fix

var $gtY0w = parcelRequire("gtY0w");

var $2SWGI = parcelRequire("2SWGI");

var $837d80be9f7605c3$var$slice = [].slice;
var $837d80be9f7605c3$var$MSIE = /MSIE .\./.test($ddb91af34f91b412$exports); // <- dirty ie9- check
var $837d80be9f7605c3$var$wrap = function(set) {
    return function(fn, time /* , ...args */ ) {
        var boundArgs = arguments.length > 2;
        var args = boundArgs ? $837d80be9f7605c3$var$slice.call(arguments, 2) : false;
        return set(boundArgs ? function() {
            // eslint-disable-next-line no-new-func
            (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
        } : fn, time);
    };
};
$2SWGI($2SWGI.G + $2SWGI.B + $2SWGI.F * $837d80be9f7605c3$var$MSIE, {
    setTimeout: $837d80be9f7605c3$var$wrap($gtY0w.setTimeout),
    setInterval: $837d80be9f7605c3$var$wrap($gtY0w.setInterval)
});



var $2SWGI = parcelRequire("2SWGI");

var $jlcCz = parcelRequire("jlcCz");
$2SWGI($2SWGI.G + $2SWGI.B, {
    setImmediate: $jlcCz.set,
    clearImmediate: $jlcCz.clear
});



var $i0uZ5 = parcelRequire("i0uZ5");

var $1ttxT = parcelRequire("1ttxT");

var $bIIwe = parcelRequire("bIIwe");

var $gtY0w = parcelRequire("gtY0w");

var $disfj = parcelRequire("disfj");

var $1VgEQ = parcelRequire("1VgEQ");

var $fqMqf = parcelRequire("fqMqf");
var $b43588d09d44cc3c$var$ITERATOR = $fqMqf('iterator');
var $b43588d09d44cc3c$var$TO_STRING_TAG = $fqMqf('toStringTag');
var $b43588d09d44cc3c$var$ArrayValues = $1VgEQ.Array;
var $b43588d09d44cc3c$var$DOMIterables = {
    CSSRuleList: true,
    CSSStyleDeclaration: false,
    CSSValueList: false,
    ClientRectList: false,
    DOMRectList: false,
    DOMStringList: false,
    DOMTokenList: true,
    DataTransferItemList: false,
    FileList: false,
    HTMLAllCollection: false,
    HTMLCollection: false,
    HTMLFormElement: false,
    HTMLSelectElement: false,
    MediaList: true,
    MimeTypeArray: false,
    NamedNodeMap: false,
    NodeList: true,
    PaintRequestList: false,
    Plugin: false,
    PluginArray: false,
    SVGLengthList: false,
    SVGNumberList: false,
    SVGPathSegList: false,
    SVGPointList: false,
    SVGStringList: false,
    SVGTransformList: false,
    SourceBufferList: false,
    StyleSheetList: true,
    TextTrackCueList: false,
    TextTrackList: false,
    TouchList: false
};
for(var $b43588d09d44cc3c$var$collections = $1ttxT($b43588d09d44cc3c$var$DOMIterables), $b43588d09d44cc3c$var$i = 0; $b43588d09d44cc3c$var$i < $b43588d09d44cc3c$var$collections.length; $b43588d09d44cc3c$var$i++){
    var $b43588d09d44cc3c$var$NAME = $b43588d09d44cc3c$var$collections[$b43588d09d44cc3c$var$i];
    var $b43588d09d44cc3c$var$explicit = $b43588d09d44cc3c$var$DOMIterables[$b43588d09d44cc3c$var$NAME];
    var $b43588d09d44cc3c$var$Collection = $gtY0w[$b43588d09d44cc3c$var$NAME];
    var $b43588d09d44cc3c$var$proto = $b43588d09d44cc3c$var$Collection && $b43588d09d44cc3c$var$Collection.prototype;
    var $b43588d09d44cc3c$var$key;
    if ($b43588d09d44cc3c$var$proto) {
        if (!$b43588d09d44cc3c$var$proto[$b43588d09d44cc3c$var$ITERATOR]) $disfj($b43588d09d44cc3c$var$proto, $b43588d09d44cc3c$var$ITERATOR, $b43588d09d44cc3c$var$ArrayValues);
        if (!$b43588d09d44cc3c$var$proto[$b43588d09d44cc3c$var$TO_STRING_TAG]) $disfj($b43588d09d44cc3c$var$proto, $b43588d09d44cc3c$var$TO_STRING_TAG, $b43588d09d44cc3c$var$NAME);
        $1VgEQ[$b43588d09d44cc3c$var$NAME] = $b43588d09d44cc3c$var$ArrayValues;
        if ($b43588d09d44cc3c$var$explicit) {
            for($b43588d09d44cc3c$var$key in $i0uZ5)if (!$b43588d09d44cc3c$var$proto[$b43588d09d44cc3c$var$key]) $bIIwe($b43588d09d44cc3c$var$proto, $b43588d09d44cc3c$var$key, $i0uZ5[$b43588d09d44cc3c$var$key], true);
        }
    }
}



$362ff6ab2a35afe7$exports = (parcelRequire("8a19U"));


var $e2def199b73abd5a$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e2def199b73abd5a$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $e2def199b73abd5a$exports));
try {
    regeneratorRuntime = $e2def199b73abd5a$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $e2def199b73abd5a$var$runtime;
    else Function("r", "regeneratorRuntime = r")($e2def199b73abd5a$var$runtime);
}





var $76feb42d9fcd5fd7$var$_global = $76feb42d9fcd5fd7$var$_interopRequireDefault((parcelRequire("XHXMy")));
function $76feb42d9fcd5fd7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
if ($76feb42d9fcd5fd7$var$_global["default"]._babelPolyfill && typeof console !== "undefined" && console.warn) console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended and may have consequences if different versions of the polyfills are applied sequentially. If you do need to load the polyfill more than once, use @babel/polyfill/noConflict instead to bypass the warning.");
$76feb42d9fcd5fd7$var$_global["default"]._babelPolyfill = true;


parcelRequire("Fo7oF");
var $37f57d781b7d3ff8$export$882461b6382ed46c;
var $37f57d781b7d3ff8$export$757ceba2d55c277e;
'use strict';

var $bvYwR = parcelRequire("bvYwR");
var $37f57d781b7d3ff8$var$i;
$37f57d781b7d3ff8$export$882461b6382ed46c = $bvYwR.createRoot;
$37f57d781b7d3ff8$export$757ceba2d55c277e = $bvYwR.hydrateRoot;


var $ce5cc9264d10c15d$exports = {};
/**
 * @salte-auth/salte-auth JavaScript Library v3.1.8
 *
 * @license MIT (https://github.com/salte-auth/salte-auth/blob/master/LICENSE)
 *
 * Made with ♥ by Ceci Woodward <ceci@salte.io>, Dave Woodward <dave@salte.io>
 */ !function(e, t) {
    t($ce5cc9264d10c15d$exports);
}($ce5cc9264d10c15d$exports, function(e) {
    "use strict";
    function t(e) {
        return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
    }
    function r(e, t) {
        return e(t = {
            exports: {}
        }, t.exports), t.exports;
    }
    var n = t(r(function(e) {
        function t(e, t, r, n, o, i, a) {
            try {
                var c = e[i](a), u = c.value;
            } catch (e) {
                return void r(e);
            }
            c.done ? t(u) : Promise.resolve(u).then(n, o);
        }
        e.exports = function(e) {
            return function() {
                var r = this, n = arguments;
                return new Promise(function(o, i) {
                    var a = e.apply(r, n);
                    function c(e) {
                        t(a, o, i, c, u, "next", e);
                    }
                    function u(e) {
                        t(a, o, i, c, u, "throw", e);
                    }
                    c(void 0);
                });
            };
        }, e.exports.default = e.exports, e.exports.__esModule = !0;
    })), o = t(r(function(e) {
        e.exports = function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }, e.exports.default = e.exports, e.exports.__esModule = !0;
    })), i = t(r(function(e) {
        function t(e, t) {
            for(var r = 0; r < t.length; r++){
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
            }
        }
        e.exports = function(e, r, n) {
            return r && t(e.prototype, r), n && t(e, n), e;
        }, e.exports.default = e.exports, e.exports.__esModule = !0;
    })), a = r(function(e) {
        e.exports = function(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }, e.exports.default = e.exports, e.exports.__esModule = !0;
    }), c = t(a), u = r(function(e) {
        function t(r, n) {
            return e.exports = t = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            }, e.exports.default = e.exports, e.exports.__esModule = !0, t(r, n);
        }
        e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
    });
    t(u);
    var s = t(r(function(e) {
        e.exports = function(e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
                constructor: {
                    value: e,
                    writable: !0,
                    configurable: !0
                }
            }), t && u(e, t);
        }, e.exports.default = e.exports, e.exports.__esModule = !0;
    })), l = r(function(e) {
        function t(r) {
            return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? (e.exports = t = function(e) {
                return typeof e;
            }, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = t = function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, e.exports.default = e.exports, e.exports.__esModule = !0), t(r);
        }
        e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
    }), f = t(l), p = t(r(function(e) {
        var t = l.default;
        e.exports = function(e, r) {
            return !r || "object" !== t(r) && "function" != typeof r ? a(e) : r;
        }, e.exports.default = e.exports, e.exports.__esModule = !0;
    })), h = r(function(e) {
        function t(r) {
            return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, e.exports.default = e.exports, e.exports.__esModule = !0, t(r);
        }
        e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
    }), d = t(h), v = t(r(function(e) {
        e.exports = function(e, t, r) {
            return t in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r, e;
        }, e.exports.default = e.exports, e.exports.__esModule = !0;
    })), y = r(function(e) {
        var t = function(e) {
            var t, r = Object.prototype, n = r.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", c = o.toStringTag || "@@toStringTag";
            function u(e, t, r) {
                return Object.defineProperty(e, t, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }), e[t];
            }
            try {
                u({}, "");
            } catch (e) {
                u = function(e, t, r) {
                    return e[t] = r;
                };
            }
            function s(e, t, r, n) {
                var o = t && t.prototype instanceof y ? t : y, i = Object.create(o.prototype), a = new P(n || []);
                return i._invoke = function(e, t, r) {
                    var n = f;
                    return function(o, i) {
                        if (n === h) throw new Error("Generator is already running");
                        if (n === d) {
                            if ("throw" === o) throw i;
                            return T();
                        }
                        for(r.method = o, r.arg = i;;){
                            var a = r.delegate;
                            if (a) {
                                var c = O(a, r);
                                if (c) {
                                    if (c === v) continue;
                                    return c;
                                }
                            }
                            if ("next" === r.method) r.sent = r._sent = r.arg;
                            else if ("throw" === r.method) {
                                if (n === f) throw n = d, r.arg;
                                r.dispatchException(r.arg);
                            } else "return" === r.method && r.abrupt("return", r.arg);
                            n = h;
                            var u = l(e, t, r);
                            if ("normal" === u.type) {
                                if (n = r.done ? d : p, u.arg === v) continue;
                                return {
                                    value: u.arg,
                                    done: r.done
                                };
                            }
                            "throw" === u.type && (n = d, r.method = "throw", r.arg = u.arg);
                        }
                    };
                }(e, r, a), i;
            }
            function l(e, t, r) {
                try {
                    return {
                        type: "normal",
                        arg: e.call(t, r)
                    };
                } catch (e) {
                    return {
                        type: "throw",
                        arg: e
                    };
                }
            }
            e.wrap = s;
            var f = "suspendedStart", p = "suspendedYield", h = "executing", d = "completed", v = {};
            function y() {}
            function g() {}
            function x() {}
            var m = {};
            m[i] = function() {
                return this;
            };
            var w = Object.getPrototypeOf, k = w && w(w(j([])));
            k && k !== r && n.call(k, i) && (m = k);
            var b = x.prototype = y.prototype = Object.create(m);
            function _(e) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(t) {
                    u(e, t, function(e) {
                        return this._invoke(t, e);
                    });
                });
            }
            function R(e, t) {
                function r(o, i, a, c) {
                    var u = l(e[o], e, i);
                    if ("throw" !== u.type) {
                        var s = u.arg, f = s.value;
                        return f && "object" == typeof f && n.call(f, "__await") ? t.resolve(f.__await).then(function(e) {
                            r("next", e, a, c);
                        }, function(e) {
                            r("throw", e, a, c);
                        }) : t.resolve(f).then(function(e) {
                            s.value = e, a(s);
                        }, function(e) {
                            return r("throw", e, a, c);
                        });
                    }
                    c(u.arg);
                }
                var o;
                this._invoke = function(e, n) {
                    function i() {
                        return new t(function(t, o) {
                            r(e, n, t, o);
                        });
                    }
                    return o = o ? o.then(i, i) : i();
                };
            }
            function O(e, r) {
                var n = e.iterator[r.method];
                if (n === t) {
                    if (r.delegate = null, "throw" === r.method) {
                        if (e.iterator.return && (r.method = "return", r.arg = t, O(e, r), "throw" === r.method)) return v;
                        r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
                    }
                    return v;
                }
                var o = l(n, e.iterator, r.arg);
                if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, v;
                var i = o.arg;
                return i ? i.done ? (r[e.resultName] = i.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, v) : i : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, v);
            }
            function E(e) {
                var t = {
                    tryLoc: e[0]
                };
                1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
            }
            function S(e) {
                var t = e.completion || {};
                t.type = "normal", delete t.arg, e.completion = t;
            }
            function P(e) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], e.forEach(E, this), this.reset(!0);
            }
            function j(e) {
                if (e) {
                    var r = e[i];
                    if (r) return r.call(e);
                    if ("function" == typeof e.next) return e;
                    if (!isNaN(e.length)) {
                        var o = -1, a = function r() {
                            for(; ++o < e.length;)if (n.call(e, o)) return r.value = e[o], r.done = !1, r;
                            return r.value = t, r.done = !0, r;
                        };
                        return a.next = a;
                    }
                }
                return {
                    next: T
                };
            }
            function T() {
                return {
                    value: t,
                    done: !0
                };
            }
            return g.prototype = b.constructor = x, x.constructor = g, g.displayName = u(x, c, "GeneratorFunction"), e.isGeneratorFunction = function(e) {
                var t = "function" == typeof e && e.constructor;
                return !!t && (t === g || "GeneratorFunction" === (t.displayName || t.name));
            }, e.mark = function(e) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(e, x) : (e.__proto__ = x, u(e, c, "GeneratorFunction")), e.prototype = Object.create(b), e;
            }, e.awrap = function(e) {
                return {
                    __await: e
                };
            }, _(R.prototype), R.prototype[a] = function() {
                return this;
            }, e.AsyncIterator = R, e.async = function(t, r, n, o, i) {
                void 0 === i && (i = Promise);
                var a = new R(s(t, r, n, o), i);
                return e.isGeneratorFunction(r) ? a : a.next().then(function(e) {
                    return e.done ? e.value : a.next();
                });
            }, _(b), u(b, c, "Generator"), b[i] = function() {
                return this;
            }, b.toString = function() {
                return "[object Generator]";
            }, e.keys = function(e) {
                var t = [];
                for(var r in e)t.push(r);
                return t.reverse(), function r() {
                    for(; t.length;){
                        var n = t.pop();
                        if (n in e) return r.value = n, r.done = !1, r;
                    }
                    return r.done = !0, r;
                };
            }, e.values = j, P.prototype = {
                constructor: P,
                reset: function(e) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(S), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
                },
                stop: function() {
                    this.done = !0;
                    var e = this.tryEntries[0].completion;
                    if ("throw" === e.type) throw e.arg;
                    return this.rval;
                },
                dispatchException: function(e) {
                    if (this.done) throw e;
                    var r = this;
                    function o(n, o) {
                        return c.type = "throw", c.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var a = this.tryEntries[i], c = a.completion;
                        if ("root" === a.tryLoc) return o("end");
                        if (a.tryLoc <= this.prev) {
                            var u = n.call(a, "catchLoc"), s = n.call(a, "finallyLoc");
                            if (u && s) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            } else if (u) {
                                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                            } else {
                                if (!s) throw new Error("try statement without catch or finally");
                                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function(e, t) {
                    for(var r = this.tryEntries.length - 1; r >= 0; --r){
                        var o = this.tryEntries[r];
                        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                            var i = o;
                            break;
                        }
                    }
                    i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
                    var a = i ? i.completion : {};
                    return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, v) : this.complete(a);
                },
                complete: function(e, t) {
                    if ("throw" === e.type) throw e.arg;
                    return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), v;
                },
                finish: function(e) {
                    for(var t = this.tryEntries.length - 1; t >= 0; --t){
                        var r = this.tryEntries[t];
                        if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), S(r), v;
                    }
                },
                catch: function(e) {
                    for(var t = this.tryEntries.length - 1; t >= 0; --t){
                        var r = this.tryEntries[t];
                        if (r.tryLoc === e) {
                            var n = r.completion;
                            if ("throw" === n.type) {
                                var o = n.arg;
                                S(r);
                            }
                            return o;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function(e, r, n) {
                    return this.delegate = {
                        iterator: j(e),
                        resultName: r,
                        nextLoc: n
                    }, "next" === this.method && (this.arg = t), v;
                }
            }, e;
        }(e.exports);
        try {
            regeneratorRuntime = t;
        } catch (e) {
            Function("r", "regeneratorRuntime = r")(t);
        }
    });
    function g(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, n = d(e);
            if (t) {
                var o = d(this).constructor;
                r = Reflect.construct(n, arguments, o);
            } else r = n.apply(this, arguments);
            return p(this, r);
        };
    }
    var x = r(function(e) {
        e.exports = function(e) {
            return -1 !== Function.toString.call(e).indexOf("[native code]");
        }, e.exports.default = e.exports, e.exports.__esModule = !0;
    });
    t(x);
    var m = r(function(e) {
        e.exports = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }, e.exports.default = e.exports, e.exports.__esModule = !0;
    });
    t(m);
    var w = r(function(e) {
        function t(r, n, o) {
            return m() ? (e.exports = t = Reflect.construct, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = t = function(e, t, r) {
                var n = [
                    null
                ];
                n.push.apply(n, t);
                var o = new (Function.bind.apply(e, n));
                return r && u(o, r.prototype), o;
            }, e.exports.default = e.exports, e.exports.__esModule = !0), t.apply(null, arguments);
        }
        e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
    });
    function k(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, n = d(e);
            if (t) {
                var o = d(this).constructor;
                r = Reflect.construct(n, arguments, o);
            } else r = n.apply(this, arguments);
            return p(this, r);
        };
    }
    t(w);
    var b = function(e) {
        s(r, e);
        var t = k(r);
        function r(e) {
            var n, i = e.message, a = e.code;
            return o(this, r), n = t.call(this, i), v(c(n), "code", void 0), n.code = a, n;
        }
        return r;
    }(t(r(function(e) {
        function t(r) {
            var n = "function" == typeof Map ? new Map : void 0;
            return e.exports = t = function(e) {
                if (null === e || !x(e)) return e;
                if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== n) {
                    if (n.has(e)) return n.get(e);
                    n.set(e, t);
                }
                function t() {
                    return w(e, arguments, h(this).constructor);
                }
                return t.prototype = Object.create(e.prototype, {
                    constructor: {
                        value: t,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), u(t, e);
            }, e.exports.default = e.exports, e.exports.__esModule = !0, t(r);
        }
        e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
    }))(Error)), _ = function() {
        function e(t) {
            o(this, e), this.config = t || {};
        }
        return i(e, [
            {
                key: "required",
                value: function() {
                    for(var e = this, t = arguments.length, r = new Array(t), n = 0; n < t; n++)r[n] = arguments[n];
                    var o = r.filter(function(t) {
                        return void 0 === e.config[t];
                    });
                    if (o.length > 0) throw new b({
                        code: "missing_required_properties",
                        message: "Missing the following required fields. (".concat(o.join(", "), ")")
                    });
                }
            }
        ]), e;
    }(), R = function() {
        function e() {
            o(this, e);
        }
        return i(e, null, [
            {
                key: "setup",
                value: function(t) {
                    this.hasSetup && !t || (this.hasSetup = !0, this.interceptors = [], this.real || (this.real = window.fetch), window.fetch && (window.fetch = function() {
                        var t = n(y.mark(function t(r, n) {
                            var o, i, a;
                            return y.wrap(function(t) {
                                for(;;)switch(t.prev = t.next){
                                    case 0:
                                        o = r instanceof Request ? r : new Request(r, n), i = 0;
                                    case 2:
                                        if (!(i < e.interceptors.length)) {
                                            t.next = 9;
                                            break;
                                        }
                                        return a = e.interceptors[i], t.next = 6, Promise.resolve(a(o));
                                    case 6:
                                        i++, t.next = 2;
                                        break;
                                    case 9:
                                        return t.abrupt("return", e.real.call(this, o));
                                    case 10:
                                    case "end":
                                        return t.stop();
                                }
                            }, t, this);
                        }));
                        return function(e, r) {
                            return t.apply(this, arguments);
                        };
                    }()));
                }
            },
            {
                key: "add",
                value: function(e) {
                    this.setup(), this.interceptors.push(e);
                }
            }
        ]), e;
    }();
    v(R, "real", void 0), v(R, "hasSetup", !1), v(R, "interceptors", void 0);
    var O = !1, E = [];
    function S() {
        E.forEach(function(e) {
            return e();
        });
    }
    var P = function() {
        function e() {
            o(this, e);
        }
        return i(e, null, [
            {
                key: "route",
                value: function(e) {
                    O || (window.addEventListener("popstate", S, {
                        passive: !0
                    }), window.addEventListener("click", S, {
                        passive: !0
                    }), setTimeout(S), O = !0), E.push(e);
                }
            },
            {
                key: "create",
                value: function(e, t) {
                    var r = document.createEvent("Event");
                    return r.initEvent(e, t.bubbles || !1, t.cancelable || !0), r.detail = t.detail, r;
                }
            },
            {
                key: "isCrossDomainError",
                value: function(e) {
                    return e instanceof DOMException || "Permission denied" === e.message;
                }
            }
        ]), e;
    }(), j = function() {
        function e() {
            o(this, e);
        }
        return i(e, null, [
            {
                key: "setup",
                value: function(t) {
                    if (!this.hasSetup || t) {
                        this.hasSetup = !0, this.interceptors = [], this.realOpen || (this.realOpen = XMLHttpRequest.prototype.open), this.realSend || (this.realSend = XMLHttpRequest.prototype.send);
                        var r = XMLHttpRequest.prototype;
                        r.open = function() {
                            for(var t = arguments.length, r = new Array(t), n = 0; n < t; n++)r[n] = arguments[n];
                            var o = r[1];
                            return this.$url = o, e.realOpen.apply(this, r);
                        }, r.send = function(t) {
                            for(var r = this, n = [], o = 0; o < e.interceptors.length; o++){
                                var i = e.interceptors[o];
                                n.push(i(this, t));
                            }
                            Promise.all(n).then(function() {
                                e.realSend.call(r, t);
                            }).catch(function(e) {
                                r.dispatchEvent(P.create("error", {
                                    detail: e
                                }));
                            });
                        };
                    }
                }
            },
            {
                key: "add",
                value: function(e) {
                    this.setup(), this.interceptors.push(e);
                }
            }
        ]), e;
    }();
    v(j, "realOpen", void 0), v(j, "realSend", void 0), v(j, "hasSetup", !1), v(j, "interceptors", void 0);
    var T = Object.freeze({
        __proto__: null,
        Fetch: R,
        XHR: j
    }), M = r(function(e) {
        e.exports = function(e) {
            if (Array.isArray(e)) return e;
        }, e.exports.default = e.exports, e.exports.__esModule = !0;
    });
    t(M);
    var L = r(function(e) {
        e.exports = function(e, t) {
            var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
            if (null != r) {
                var n, o, i = [], a = !0, c = !1;
                try {
                    for(r = r.call(e); !(a = (n = r.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
                } catch (e) {
                    c = !0, o = e;
                } finally{
                    try {
                        a || null == r.return || r.return();
                    } finally{
                        if (c) throw o;
                    }
                }
                return i;
            }
        }, e.exports.default = e.exports, e.exports.__esModule = !0;
    });
    t(L);
    var $ = r(function(e) {
        e.exports = function(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
            return n;
        }, e.exports.default = e.exports, e.exports.__esModule = !0;
    });
    t($);
    var A = r(function(e) {
        e.exports = function(e, t) {
            if (e) {
                if ("string" == typeof e) return $(e, t);
                var r = Object.prototype.toString.call(e).slice(8, -1);
                return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? $(e, t) : void 0;
            }
        }, e.exports.default = e.exports, e.exports.__esModule = !0;
    });
    t(A);
    var B = r(function(e) {
        e.exports = function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }, e.exports.default = e.exports, e.exports.__esModule = !0;
    });
    t(B);
    var q, U, I, D = t(r(function(e) {
        e.exports = function(e, t) {
            return M(e) || L(e, t) || A(e, t) || B();
        }, e.exports.default = e.exports, e.exports.__esModule = !0;
    })), C = function() {
        function e() {
            o(this, e);
        }
        return i(e, null, [
            {
                key: "origin",
                get: function() {
                    return "".concat(location.protocol, "//").concat(location.host);
                }
            },
            {
                key: "resolve",
                value: function(e) {
                    return q || (q = document.implementation.createHTMLDocument("url"), U = q.createElement("base"), I = q.createElement("a"), q.head.appendChild(U)), U.href = window.location.protocol + "//" + window.location.host, I.href = e.replace(/ /g, "%20"), I.href.replace(/\/$/, "");
                }
            },
            {
                key: "match",
                value: function(e, t) {
                    var r = this;
                    if (t instanceof Array) {
                        var n = this.resolve(e), o = H.find(t, function(e) {
                            return e instanceof RegExp ? !!n.match(e) : 0 === n.indexOf(r.resolve(e));
                        });
                        return !!o;
                    }
                    return !0 === t;
                }
            },
            {
                key: "parse",
                value: function(e) {
                    var t = e.search, r = e.hash, n = [];
                    t && (n = n.concat(t.replace("?", "").split("&"))), r && (n = n.concat(r.replace("#", "").split("&")));
                    var o = {};
                    return H.forEach(n, function(e) {
                        var t = e.split("="), r = D(t, 2), n = r[0], i = r[1];
                        o[n] = i;
                    }), o;
                }
            },
            {
                key: "url",
                value: function(e, t) {
                    var r = e;
                    return H.forEach(t, function(e, t) {
                        H.includes([
                            void 0,
                            null,
                            ""
                        ], e) || (r += "".concat(-1 === r.indexOf("?") ? "?" : "&").concat(t, "=").concat(encodeURIComponent(e)));
                    }), r;
                }
            }
        ]), e;
    }(), N = {}, H = function() {
        function e() {
            o(this, e);
        }
        var t;
        return i(e, null, [
            {
                key: "includes",
                value: function(e, t) {
                    return -1 !== e.indexOf(t);
                }
            },
            {
                key: "forEach",
                value: function(e, t) {
                    if (Array.isArray(e)) for(var r = 0; r < e.length; r++)t(e[r], r);
                    else for(var n in e)t(e[n], n);
                }
            },
            {
                key: "find",
                value: function(e, t) {
                    if (Array.isArray(e)) for(var r = 0; r < e.length; r++){
                        var n = e[r];
                        if (t(n, r)) return n;
                    }
                    else for(var o in e){
                        var i = e[o];
                        if (t(i, o)) return i;
                    }
                    return null;
                }
            },
            {
                key: "assign",
                value: function(e) {
                    for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
                    return this.forEach(r, function(t) {
                        for(var r in t)e[r] = t[r];
                    }), e;
                }
            },
            {
                key: "defaults",
                value: function(e) {
                    for(var t = this, r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)n[o - 1] = arguments[o];
                    return this.forEach(n, function(r) {
                        for(var n in r)t.isObject(e[n]) && t.isObject(r[n]) ? e[n] = t.defaults(e[n], r[n]) : void 0 === e[n] && (e[n] = r[n]);
                    }), e;
                }
            },
            {
                key: "isObject",
                value: function(e) {
                    return "object" === f(e) && !Array.isArray(e);
                }
            },
            {
                key: "iframe",
                value: (t = n(y.mark(function e(t) {
                    var r, n, o, i, a = this;
                    return y.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return r = t.url, n = t.redirectUrl, o = t.visible, (i = document.createElement("iframe")).setAttribute("owner", "@salte-auth/salte-auth"), o ? (this.assign(i.style, {
                                    border: "none",
                                    bottom: 0,
                                    height: "100%",
                                    left: 0,
                                    position: "fixed",
                                    right: 0,
                                    top: 0,
                                    width: "100%",
                                    zIndex: 9999,
                                    opacity: 0,
                                    transition: "0.5s opacity"
                                }), setTimeout(function() {
                                    return i.style.opacity = "1";
                                })) : i.style.display = "none", i.src = r, document.body.appendChild(i), e.abrupt("return", new Promise(function(e, t) {
                                    var r = setInterval(function() {
                                        try {
                                            var o = i.contentWindow.location;
                                            if (0 !== o.href.indexOf(n)) return;
                                            var c = C.parse(o);
                                            a.removeIframe(i), clearInterval(r), e(c);
                                        } catch (e) {
                                            if (P.isCrossDomainError(e)) return;
                                            a.removeIframe(i), clearInterval(r), t(e);
                                        }
                                    });
                                }));
                            case 7:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function(e) {
                    return t.apply(this, arguments);
                })
            },
            {
                key: "removeIframe",
                value: function(e) {
                    e.parentElement && e.parentElement.removeChild(e);
                }
            },
            {
                key: "debounce",
                value: function(e, t, r) {
                    clearTimeout(N[e]), N[e] = window.setTimeout(function() {
                        delete N[e], t();
                    }, r);
                }
            }
        ]), e;
    }(), F = function() {
        function e(t) {
            o(this, e), v(this, "baseKey", void 0), this.baseKey = t;
        }
        return i(e, [
            {
                key: "has",
                value: function(e) {
                    return !H.includes([
                        void 0,
                        null
                    ], this.get(e));
                }
            },
            {
                key: "key",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
                    return this.baseKey && -1 === e.indexOf(this.baseKey) ? "".concat(this.baseKey, ".").concat(e) : e;
                }
            }
        ], [
            {
                key: "supported",
                value: function() {
                    return !0;
                }
            }
        ]), e;
    }();
    function z(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, n = d(e);
            if (t) {
                var o = d(this).constructor;
                r = Reflect.construct(n, arguments, o);
            } else r = n.apply(this, arguments);
            return p(this, r);
        };
    }
    var G = function(e) {
        s(r, e);
        var t = z(r);
        function r() {
            return o(this, r), t.apply(this, arguments);
        }
        return i(r, [
            {
                key: "get",
                value: function(e, t) {
                    var r = document.cookie.match(new RegExp("".concat(this.key(e), "=([^;]+)"))), n = r && r[1].trim();
                    return H.includes([
                        void 0,
                        null
                    ], n) ? H.includes([
                        void 0,
                        null
                    ], t) ? null : t : n;
                }
            },
            {
                key: "set",
                value: function(e, t) {
                    H.includes([
                        void 0,
                        null
                    ], t) ? this.delete(e) : document.cookie = "".concat(this.key(e), "=").concat(t, "; SameSite=Lax");
                }
            },
            {
                key: "delete",
                value: function(e) {
                    document.cookie = "".concat(this.key(e), "=; expires=").concat(new Date(0).toUTCString());
                }
            },
            {
                key: "clear",
                value: function() {
                    var e = this, t = this.key(), r = document.cookie.split(";");
                    H.forEach(r, function(r) {
                        var n = r.trim().split("="), o = D(n, 1)[0];
                        0 === o.indexOf(t) && e.delete(o);
                    });
                }
            }
        ], [
            {
                key: "supported",
                value: function() {
                    return !0 === navigator.cookieEnabled;
                }
            }
        ]), r;
    }(F);
    function X(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, n = d(e);
            if (t) {
                var o = d(this).constructor;
                r = Reflect.construct(n, arguments, o);
            } else r = n.apply(this, arguments);
            return p(this, r);
        };
    }
    var K = function(e) {
        s(r, e);
        var t = X(r);
        function r() {
            return o(this, r), t.apply(this, arguments);
        }
        return i(r, [
            {
                key: "get",
                value: function(e, t) {
                    var r = localStorage.getItem(this.key(e));
                    return H.includes([
                        void 0,
                        null
                    ], r) ? H.includes([
                        void 0,
                        null
                    ], t) ? null : t : r;
                }
            },
            {
                key: "set",
                value: function(e, t) {
                    H.includes([
                        void 0,
                        null
                    ], t) ? this.delete(e) : localStorage.setItem(this.key(e), t);
                }
            },
            {
                key: "delete",
                value: function(e) {
                    localStorage.removeItem(this.key(e));
                }
            },
            {
                key: "clear",
                value: function() {
                    var e = this.key();
                    for(var t in localStorage)0 === t.indexOf(e) && this.delete(t);
                }
            }
        ]), r;
    }(F);
    function V(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, n = d(e);
            if (t) {
                var o = d(this).constructor;
                r = Reflect.construct(n, arguments, o);
            } else r = n.apply(this, arguments);
            return p(this, r);
        };
    }
    var Y = function(e) {
        s(r, e);
        var t = V(r);
        function r() {
            return o(this, r), t.apply(this, arguments);
        }
        return i(r, [
            {
                key: "get",
                value: function(e, t) {
                    var r = sessionStorage.getItem(this.key(e));
                    return H.includes([
                        void 0,
                        null
                    ], r) ? H.includes([
                        void 0,
                        null
                    ], t) ? null : t : r;
                }
            },
            {
                key: "set",
                value: function(e, t) {
                    H.includes([
                        void 0,
                        null
                    ], t) ? this.delete(e) : sessionStorage.setItem(this.key(e), t);
                }
            },
            {
                key: "delete",
                value: function(e) {
                    sessionStorage.removeItem(this.key(e));
                }
            },
            {
                key: "clear",
                value: function() {
                    var e = this.key();
                    for(var t in sessionStorage)0 === t.indexOf(e) && this.delete(t);
                }
            }
        ]), r;
    }(F), J = {
        cookie: G,
        local: K,
        session: Y
    }, W = Object.freeze({
        __proto__: null,
        StorageTypes: J,
        CookieStorage: G,
        LocalStorage: K,
        SessionStorage: Y
    }), Q = function() {
        function e(t, r, n) {
            o(this, e), v(this, "raw", void 0), v(this, "expiration", void 0), v(this, "type", void 0), this.raw = t, this.expiration = H.includes([
                void 0,
                null
            ], r) ? null : Number(r), this.type = n;
        }
        return i(e, [
            {
                key: "expired",
                get: function() {
                    return !this.raw || this.expiration <= Date.now();
                }
            }
        ]), e;
    }(), Z = function() {
        function e(t) {
            o(this, e), v(this, "raw", void 0), v(this, "user", void 0), this.raw = t, this.user = e.parse(this.raw);
        }
        return i(e, [
            {
                key: "expired",
                get: function() {
                    return !this.user || 1e3 * this.user.exp <= Date.now();
                }
            }
        ], [
            {
                key: "parse",
                value: function(e) {
                    try {
                        var t = e.split(".");
                        if (3 !== t.length) throw new b({
                            code: "invalid_id_token",
                            message: "ID Token didn't match the desired format. ({header}.{payload}.{validation})"
                        });
                        return JSON.parse(atob(t[1].replace(/-/g, "+").replace(/_/g, "/")));
                    } catch (e) {
                        return null;
                    }
                }
            }
        ]), e;
    }(), ee = function() {
        function e(t, r) {
            o(this, e), v(this, "name", void 0), v(this, "level", void 0), this.name = t, this.level = "string" == typeof r ? this.toLevel(r) : r;
        }
        return i(e, [
            {
                key: "trace",
                value: function(e) {
                    for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
                    this.log.apply(this, [
                        "trace",
                        e
                    ].concat(r));
                }
            },
            {
                key: "info",
                value: function(e) {
                    for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
                    this.log.apply(this, [
                        "info",
                        e
                    ].concat(r));
                }
            },
            {
                key: "warn",
                value: function(e) {
                    for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
                    this.log.apply(this, [
                        "warn",
                        e
                    ].concat(r));
                }
            },
            {
                key: "error",
                value: function(e) {
                    for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
                    this.log.apply(this, [
                        "error",
                        e
                    ].concat(r));
                }
            },
            {
                key: "log",
                value: function(e, t) {
                    if (this.enabled(e)) {
                        for(var r, n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)o[i - 2] = arguments[i];
                        (r = console).log.apply(r, [
                            "".concat(e, ": ").concat(t)
                        ].concat(o));
                    }
                }
            },
            {
                key: "enabled",
                value: function(e) {
                    return !1 !== this.level && (!0 === this.level || this.level <= this.toLevel(e));
                }
            },
            {
                key: "toLevel",
                value: function(t) {
                    return H.find(e.levels, function(e, r) {
                        return r === t;
                    });
                }
            }
        ]), e;
    }();
    v(ee, "levels", {
        trace: 0,
        info: 1,
        warn: 2,
        error: 3
    });
    var te = function() {
        function e() {
            o(this, e);
        }
        return i(e, null, [
            {
                key: "dedupe",
                value: function() {
                    var e = {};
                    return function(t, r) {
                        return e[t] || (e[t] = r().then(function(r) {
                            return delete e[t], r;
                        }).catch(function(r) {
                            throw delete e[t], r;
                        })), e[t];
                    };
                }
            }
        ]), e;
    }(), re = Object.freeze({
        __proto__: null,
        Interceptors: T,
        StorageHelpers: W,
        AccessToken: Q,
        IDToken: Z,
        Common: H,
        Events: P,
        URL: C,
        Logger: ee,
        Dedupe: te
    });
    function ne(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, n = d(e);
            if (t) {
                var o = d(this).constructor;
                r = Reflect.construct(n, arguments, o);
            } else r = n.apply(this, arguments);
            return p(this, r);
        };
    }
    var oe = [
        "cookie",
        "session",
        "local"
    ], ie = function(e) {
        s(r, e);
        var t = ne(r);
        function r(e) {
            var n;
            o(this, r), n = t.call(this, e), v(c(n), "storage", void 0), n.config = H.defaults(n.config, {
                storage: H.find(oe, function(e) {
                    return J[e].supported();
                })
            });
            var i = J[n.config.storage];
            if (!i) throw new b({
                code: "invalid_storage",
                message: "Storage doesn't exist for the given value. (".concat(n.config.storage, ")")
            });
            return n.storage = new i(n.key), n;
        }
        return i(r, [
            {
                key: "key",
                get: function() {
                    return "salte.auth";
                }
            }
        ]), r;
    }(_);
    function ae(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, n = d(e);
            if (t) {
                var o = d(this).constructor;
                r = Reflect.construct(n, arguments, o);
            } else r = n.apply(this, arguments);
            return p(this, r);
        };
    }
    function ce(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, n = d(e);
            if (t) {
                var o = d(this).constructor;
                r = Reflect.construct(n, arguments, o);
            } else r = n.apply(this, arguments);
            return p(this, r);
        };
    }
    for(var ue = function(e) {
        s(r, e);
        var t = ce(r);
        function r(e) {
            var n;
            return o(this, r), (n = t.call(this, e)).config = H.defaults(n.config, {
                redirectUrl: location.origin,
                level: "warn"
            }), n;
        }
        return i(r, [
            {
                key: "redirectUrl",
                value: function(e) {
                    return "string" == typeof this.config.redirectUrl ? this.config.redirectUrl : this.config.redirectUrl[e];
                }
            }
        ]), r;
    }(function(e) {
        s(r, e);
        var t = ae(r);
        function r() {
            var e;
            o(this, r);
            for(var n = arguments.length, i = new Array(n), a = 0; a < n; a++)i[a] = arguments[a];
            return e = t.call.apply(t, [
                this
            ].concat(i)), v(c(e), "listeners", new Map), e;
        }
        return i(r, [
            {
                key: "on",
                value: function(e, t) {
                    this.listeners.has(e) || this.listeners.set(e, []), this.listeners.get(e).push(t);
                }
            },
            {
                key: "off",
                value: function(e, t) {
                    if (this.listeners.has(e)) {
                        var r = this.listeners.get(e);
                        if (r.length) {
                            var n = r.indexOf(t);
                            -1 !== n && r.splice(n, 1);
                        }
                    }
                }
            },
            {
                key: "emit",
                value: function(e) {
                    for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
                    if (this.listeners.has(e)) {
                        var o = this.listeners.get(e);
                        H.forEach(o, function(e) {
                            return e.apply(void 0, r);
                        });
                    }
                }
            }
        ]), r;
    }(ie)), se = self.crypto || self.msCrypto, le = "-_", fe = 36; fe--;)le += fe.toString(36);
    for(fe = 36; fe-- - 10;)le += fe.toString(36).toUpperCase();
    var pe = function(e) {
        var t = "", r = se.getRandomValues(new Uint8Array(e || 21));
        for(fe = e || 21; fe--;)t += le[63 & r[fe]];
        return t;
    };
    function he(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, n = d(e);
            if (t) {
                var o = d(this).constructor;
                r = Reflect.construct(n, arguments, o);
            } else r = n.apply(this, arguments);
            return p(this, r);
        };
    }
    var de = function(e) {
        s(r, e);
        var t = he(r);
        function r(e) {
            var n;
            return o(this, r), n = t.call(this, e), v(c(n), "logger", void 0), v(c(n), "url", C.url), v(c(n), "dedupe", te.dedupe()), n.config = H.defaults(n.config, {
                validation: !0,
                level: "warn"
            }), n.logger = new ee("@salte-auth/salte-auth:providers/".concat(n.$name), n.config.level), n;
        }
        return i(r, [
            {
                key: "validation",
                value: function(e) {
                    return "object" === f(this.config.validation) ? !0 === this.config.validation[e] : !0 === this.config.validation;
                }
            },
            {
                key: "$name",
                get: function() {
                    return this.config.name || this.name;
                }
            },
            {
                key: "key",
                get: function() {
                    return "salte.auth.provider.".concat(this.$name);
                }
            },
            {
                key: "logout",
                get: function() {
                    throw new b({
                        code: "logout_not_supported",
                        message: "This provider doesn't support logout."
                    });
                }
            }
        ]), r;
    }(ue);
    function ve(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, n);
        }
        return r;
    }
    function ye(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ve(Object(r), !0).forEach(function(t) {
                v(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ve(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
        }
        return e;
    }
    function ge(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, n = d(e);
            if (t) {
                var o = d(this).constructor;
                r = Reflect.construct(n, arguments, o);
            } else r = n.apply(this, arguments);
            return p(this, r);
        };
    }
    var xe = function(e) {
        s(a, e);
        var t, r = ge(a);
        function a(e) {
            var t;
            return o(this, a), t = r.call(this, e), v(c(t), "accessToken", void 0), t.sync(), t;
        }
        return i(a, [
            {
                key: "connected",
                value: function() {
                    this.required("clientID", "responseType");
                }
            },
            {
                key: "secure",
                value: (t = n(y.mark(function e(t) {
                    return y.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if ("token" !== this.config.responseType) {
                                    e.next = 13;
                                    break;
                                }
                                if (!this.accessToken.expired) {
                                    e.next = 3;
                                    break;
                                }
                                return e.abrupt("return", "login");
                            case 3:
                                if (!t) {
                                    e.next = 13;
                                    break;
                                }
                                if (!(t instanceof Request)) {
                                    e.next = 8;
                                    break;
                                }
                                t.headers.set("Authorization", "Bearer ".concat(this.accessToken.raw)), e.next = 13;
                                break;
                            case 8:
                                if (!(t instanceof XMLHttpRequest)) {
                                    e.next = 12;
                                    break;
                                }
                                t.setRequestHeader("Authorization", "Bearer ".concat(this.accessToken.raw)), e.next = 13;
                                break;
                            case 12:
                                throw new b({
                                    code: "unknown_request",
                                    message: "Unknown request type. (".concat(t, ")")
                                });
                            case 13:
                                return e.abrupt("return", !0);
                            case 14:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function(e) {
                    return t.apply(this, arguments);
                })
            },
            {
                key: "$validate",
                value: function(e) {
                    try {
                        if (!e) throw new b({
                            code: "empty_response",
                            message: "The response provided was empty, this is most likely due to the configured handler not providing it."
                        });
                        if (e.error) throw new b({
                            code: e.error,
                            message: "".concat(e.error_description ? e.error_description : e.error).concat(e.error_uri ? " (".concat(e.error_uri, ")") : "")
                        });
                        var t = e.code, r = e.access_token, n = e.state, o = e.expires_in, i = e.token_type;
                        if (this.validation("state") && this.storage.get("state") !== n) throw new b({
                            code: "invalid_state",
                            message: "State provided by identity provider did not match local state."
                        });
                        var a = this.storage.get("response-type", "").split(" ");
                        if (H.includes(a, "code")) {
                            if (!t) throw new b({
                                code: "invalid_code",
                                message: "Expected a code to be returned by the Provider."
                            });
                        } else if (H.includes(a, "token") && !r) throw new b({
                            code: "invalid_access_token",
                            message: "Expected an access token to be returned by the Provider."
                        });
                        t ? (this.storage.set("code.raw", t), this.storage.delete("access-token.raw"), this.storage.delete("access-token.expiration"), this.storage.delete("access-token.type")) : r && (this.storage.set("access-token.raw", r), this.storage.set("access-token.expiration", Date.now() + 1e3 * Number(o)), this.storage.set("access-token.type", i), this.storage.delete("code.raw"));
                    } finally{
                        this.storage.delete("state");
                    }
                }
            },
            {
                key: "validate",
                value: function(e) {
                    this.logger.trace("[validate] (options): ", e);
                    try {
                        this.$validate(e);
                    } catch (e) {
                        throw this.emit("login", e), e;
                    } finally{
                        this.sync();
                    }
                    this.emit("login", null, this.code || this.accessToken);
                }
            },
            {
                key: "code",
                get: function() {
                    return this.storage.get("code.raw");
                }
            },
            {
                key: "$login",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = "".concat(this.$name, "-state-").concat(pe()), r = e.responseType || this.config.responseType;
                    return this.storage.set("state", t), this.storage.set("response-type", r), this.url(this.login, ye(ye({}, this.config.queryParams && this.config.queryParams("login")), {}, {
                        client_id: this.config.clientID,
                        response_type: r,
                        redirect_uri: this.redirectUrl("login"),
                        scope: this.config.scope,
                        state: t
                    }));
                }
            },
            {
                key: "sync",
                value: function() {
                    this.logger.trace("[sync] updating access token"), this.accessToken = new Q(this.storage.get("access-token.raw"), this.storage.get("access-token.expiration"), this.storage.get("access-token.type"));
                }
            }
        ]), a;
    }(de), me = r(function(e) {
        e.exports = function(e, t) {
            for(; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = h(e)););
            return e;
        }, e.exports.default = e.exports, e.exports.__esModule = !0;
    });
    t(me);
    var we = t(r(function(e) {
        function t(r, n, o) {
            return "undefined" != typeof Reflect && Reflect.get ? (e.exports = t = Reflect.get, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = t = function(e, t, r) {
                var n = me(e, t);
                if (n) {
                    var o = Object.getOwnPropertyDescriptor(n, t);
                    return o.get ? o.get.call(r) : o.value;
                }
            }, e.exports.default = e.exports, e.exports.__esModule = !0), t(r, n, o || r);
        }
        e.exports = t, e.exports.default = e.exports, e.exports.__esModule = !0;
    }));
    function ke(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, n = d(e);
            if (t) {
                var o = d(this).constructor;
                r = Reflect.construct(n, arguments, o);
            } else r = n.apply(this, arguments);
            return p(this, r);
        };
    }
    var be = function(e) {
        s(a, e);
        var t, r = ke(a);
        function a(e) {
            var t;
            return o(this, a), t = r.call(this, e), v(c(t), "idToken", void 0), t.config.renewal = "object" === f(t.config.renewal) ? t.config.renewal : {
                type: t.config.renewal
            }, t.config = H.defaults(t.config, {
                responseType: "id_token",
                scope: "openid",
                renewal: {
                    type: "auto",
                    buffer: 6e4
                }
            }), t.sync(), t;
        }
        return i(a, [
            {
                key: "secure",
                value: (t = n(y.mark(function e(t) {
                    var r = this;
                    return y.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                if (!H.includes([
                                    "id_token",
                                    "id_token token",
                                    "token"
                                ], this.config.responseType)) {
                                    e.next = 17;
                                    break;
                                }
                                if (!this.idToken.expired) {
                                    e.next = 4;
                                    break;
                                }
                                return this.logger.trace("[secure]: ID Token has expired, requesting login..."), e.abrupt("return", "login");
                            case 4:
                                if (!this.accessToken.expired) {
                                    e.next = 7;
                                    break;
                                }
                                return e.next = 7, this.dedupe("access-token", n(y.mark(function e() {
                                    var t;
                                    return y.wrap(function(e) {
                                        for(;;)switch(e.prev = e.next){
                                            case 0:
                                                return r.logger.info("[secure]: Expired access token detected, retrieving..."), e.next = 3, H.iframe({
                                                    redirectUrl: r.redirectUrl("login"),
                                                    url: r.$login({
                                                        prompt: "none",
                                                        responseType: "token"
                                                    })
                                                });
                                            case 3:
                                                t = e.sent, r.logger.info("[secure]: Access token retrieved! Validating..."), r.validate(t);
                                            case 6:
                                            case "end":
                                                return e.stop();
                                        }
                                    }, e);
                                })));
                            case 7:
                                if (!t) {
                                    e.next = 17;
                                    break;
                                }
                                if (!(t instanceof Request)) {
                                    e.next = 12;
                                    break;
                                }
                                t.headers.set("Authorization", "Bearer ".concat(this.accessToken.raw)), e.next = 17;
                                break;
                            case 12:
                                if (!(t instanceof XMLHttpRequest)) {
                                    e.next = 16;
                                    break;
                                }
                                t.setRequestHeader("Authorization", "Bearer ".concat(this.accessToken.raw)), e.next = 17;
                                break;
                            case 16:
                                throw new b({
                                    code: "unknown_request",
                                    message: "Unknown request type. (".concat(t, ")")
                                });
                            case 17:
                                return e.abrupt("return", !0);
                            case 18:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function(e) {
                    return t.apply(this, arguments);
                })
            },
            {
                key: "$validate",
                value: function(e) {
                    try {
                        we(d(a.prototype), "$validate", this).call(this, e);
                        var t = e.id_token, r = e.code;
                        if (t) {
                            var n = e.id_token, o = Z.parse(n);
                            if (!o) throw new b({
                                code: "invalid_id_token",
                                message: "Failed to parse user information due to invalid id token."
                            });
                            if (this.validation("nonce") && this.storage.get("nonce") !== o.nonce) throw new b({
                                code: "invalid_nonce",
                                message: "Nonce provided by identity provider did not match the local nonce."
                            });
                            this.storage.set("id-token.raw", n);
                        } else r && this.storage.delete("id-token.raw");
                    } finally{
                        this.storage.delete("nonce");
                    }
                }
            },
            {
                key: "validate",
                value: function(e) {
                    this.logger.trace("[validate] (options): ", e);
                    try {
                        this.$validate(e);
                    } catch (e) {
                        throw this.emit("login", e), e;
                    } finally{
                        this.sync();
                    }
                    var t = this.storage.get("response-type", ""), r = t.split(" ");
                    if (H.includes(r, "id_token")) this.emit("login", null, this.idToken);
                    else if (H.includes(r, "token")) this.emit("login", null, this.accessToken);
                    else {
                        if (!H.includes(r, "code")) throw new b({
                            code: "invalid_response_type",
                            message: "Unknown Response Type (".concat(t, ")")
                        });
                        this.emit("login", null, this.code);
                    }
                }
            },
            {
                key: "$login",
                value: function(e) {
                    var t = "".concat(this.$name, "-nonce-").concat(pe());
                    return this.storage.set("nonce", t), this.url(we(d(a.prototype), "$login", this).call(this, e), {
                        prompt: e && e.prompt,
                        nonce: t
                    });
                }
            },
            {
                key: "sync",
                value: function() {
                    we(d(a.prototype), "sync", this).call(this), this.logger.trace("[sync] updating id token"), this.idToken = new Z(this.storage.get("id-token.raw"));
                }
            }
        ]), a;
    }(xe);
    function _e(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, n = d(e);
            if (t) {
                var o = d(this).constructor;
                r = Reflect.construct(n, arguments, o);
            } else r = n.apply(this, arguments);
            return p(this, r);
        };
    }
    var Re = function(e) {
        s(r, e);
        var t = _e(r);
        function r(e) {
            var n;
            return o(this, r), (n = t.call(this, e)).required("login"), n;
        }
        return i(r, [
            {
                key: "name",
                get: function() {
                    return "generic.oauth2";
                }
            },
            {
                key: "login",
                get: function() {
                    return this.config.login.apply(this);
                }
            }
        ]), r;
    }(xe), Oe = function(e) {
        s(r, e);
        var t = _e(r);
        function r(e) {
            var n;
            return o(this, r), (n = t.call(this, e)).required("login", "logout"), n;
        }
        return i(r, [
            {
                key: "name",
                get: function() {
                    return "generic.openid";
                }
            },
            {
                key: "login",
                get: function() {
                    return this.config.login.apply(this);
                }
            },
            {
                key: "logout",
                get: function() {
                    return this.config.logout.apply(this);
                }
            }
        ]), r;
    }(be), Ee = Object.freeze({
        __proto__: null,
        OAuth2: Re,
        OpenID: Oe
    });
    function Se(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, n = d(e);
            if (t) {
                var o = d(this).constructor;
                r = Reflect.construct(n, arguments, o);
            } else r = n.apply(this, arguments);
            return p(this, r);
        };
    }
    var Pe = function(e) {
        s(r, e);
        var t = Se(r);
        function r(e) {
            var n;
            return o(this, r), n = t.call(this, e), v(c(n), "logger", void 0), n.config = H.defaults(n.config, {
                navigate: "reload",
                level: "warn"
            }), n.logger = new ee("@salte-auth/salte-auth:handlers/".concat(n.$name), n.config.level), n;
        }
        return i(r, [
            {
                key: "$name",
                get: function() {
                    return this.config.name || this.name;
                }
            },
            {
                key: "key",
                get: function() {
                    return "salte.auth.handler.".concat(this.$name);
                }
            },
            {
                key: "navigate",
                value: function(e) {
                    "history" === this.config.navigate && 0 === e.indexOf(C.origin) && history.pushState("", document.title, e), location.href = e;
                }
            }
        ]), r;
    }(ie);
    function je(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, n = d(e);
            if (t) {
                var o = d(this).constructor;
                r = Reflect.construct(n, arguments, o);
            } else r = n.apply(this, arguments);
            return p(this, r);
        };
    }
    var Te = function(e) {
        s(l, e);
        var t, r, a, u = je(l);
        function l(e) {
            var t;
            o(this, l), t = u.call(this, e), v(c(t), "logger", void 0), v(c(t), "mixin", void 0), t.required("providers", "handlers"), t.config = H.defaults(t.config, {
                validation: !0,
                level: "warn"
            }), t.logger = new ee("@salte-auth/salte-auth:core", t.config.level), H.forEach(t.config.providers, function(e) {
                e.connected && e.connected(), e.on("login", function(r, n) {
                    t.emit("login", r, {
                        provider: e.$name,
                        data: n
                    });
                }), e.on("logout", function(r) {
                    t.emit("logout", r, {
                        provider: e.$name
                    });
                });
            });
            var r, i = t.storage.get("action"), a = i ? t.provider(t.storage.get("provider")) : null, f = i ? t.storage.get("handler") : null;
            if (!H.includes([
                void 0,
                null,
                "login",
                "logout"
            ], i)) throw new b({
                code: "unknown_action",
                message: "Unable to finish redirect due to an unknown action! (".concat(i, ")")
            });
            return H.forEach(t.config.handlers, function(e) {
                e.connected && (e.$name === f ? a.dedupe(i, n(y.mark(function r() {
                    var n;
                    return y.wrap(function(r) {
                        for(;;)switch(r.prev = r.next){
                            case 0:
                                return t.logger.trace("[constructor]: wrapping up authentication for ".concat(e.$name, "...")), r.next = 3, new Promise(function(e) {
                                    return setTimeout(e);
                                });
                            case 3:
                                n = e.connected({
                                    action: i
                                }), "login" === i ? (a.validate(n), t.logger.info("[constructor]: login complete")) : (a.storage.clear(), a.sync(), a.emit("logout"), t.logger.info("[constructor]: logout complete"));
                            case 5:
                            case "end":
                                return r.stop();
                        }
                    }, r);
                }))) : e.connected({
                    action: null
                }));
            }), t.storage.delete("action"), t.storage.delete("provider"), t.storage.delete("handler"), R.add(function() {
                var e = n(y.mark(function e(r) {
                    var n, o;
                    return y.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                n = 0;
                            case 1:
                                if (!(n < t.config.providers.length)) {
                                    e.next = 9;
                                    break;
                                }
                                if (o = t.config.providers[n], !C.match(r.url, o.config.endpoints)) {
                                    e.next = 6;
                                    break;
                                }
                                return e.next = 6, t.$secure(o, r);
                            case 6:
                                n++, e.next = 1;
                                break;
                            case 9:
                            case "end":
                                return e.stop();
                        }
                    }, e);
                }));
                return function(t) {
                    return e.apply(this, arguments);
                };
            }()), j.add(function() {
                var e = n(y.mark(function e(r) {
                    var n, o;
                    return y.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                n = 0;
                            case 1:
                                if (!(n < t.config.providers.length)) {
                                    e.next = 9;
                                    break;
                                }
                                if (o = t.config.providers[n], !C.match(r.$url, o.config.endpoints)) {
                                    e.next = 6;
                                    break;
                                }
                                return e.next = 6, t.$secure(o, r);
                            case 6:
                                n++, e.next = 1;
                                break;
                            case 9:
                            case "end":
                                return e.stop();
                        }
                    }, e);
                }));
                return function(t) {
                    return e.apply(this, arguments);
                };
            }()), P.route(n(y.mark(function e() {
                var r, n;
                return y.wrap(function(e) {
                    for(;;)switch(e.prev = e.next){
                        case 0:
                            r = 0;
                        case 1:
                            if (!(r < t.config.providers.length)) {
                                e.next = 9;
                                break;
                            }
                            if (n = t.config.providers[r], !C.match(location.href, n.config.routes)) {
                                e.next = 6;
                                break;
                            }
                            return e.next = 6, t.$secure(n);
                        case 6:
                            r++, e.next = 1;
                            break;
                        case 9:
                        case "end":
                            return e.stop();
                    }
                }, e);
            }))), t.mixin = (r = c(t), function(e) {
                return function(e) {
                    s(n, e);
                    var t = g(n);
                    function n() {
                        var e;
                        o(this, n);
                        for(var i = arguments.length, a = new Array(i), u = 0; u < i; u++)a[u] = arguments[u];
                        return e = t.call.apply(t, [
                            this
                        ].concat(a)), v(c(e), "auth", void 0), e.auth = r, e.auth.on("login", function() {
                            e.requestUpdate && e.requestUpdate("auth");
                        }), e.auth.on("logout", function() {
                            e.requestUpdate && e.requestUpdate("auth");
                        }), e;
                    }
                    return n;
                }(e);
            }), t;
        }
        return i(l, [
            {
                key: "login",
                value: (a = n(y.mark(function e(t) {
                    var r, o, i = this;
                    return y.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return r = "string" == typeof t ? {
                                    provider: t
                                } : t, o = this.provider(r.provider), e.abrupt("return", o.dedupe("login", n(y.mark(function e() {
                                    var t, n;
                                    return y.wrap(function(e) {
                                        for(;;)switch(e.prev = e.next){
                                            case 0:
                                                return t = i.handler(r.handler), e.prev = 1, i.storage.set("action", "login"), i.storage.set("provider", o.$name), i.storage.set("handler", t.$name), i.logger.info("[login]: logging in with ".concat(o.$name, " via ").concat(t.$name, "...")), e.next = 8, t.open({
                                                    redirectUrl: o.redirectUrl("login"),
                                                    url: o.$login()
                                                });
                                            case 8:
                                                n = e.sent, i.logger.trace("[login]: validating response...", n), o.validate(n), i.logger.info("[login]: login complete");
                                            case 12:
                                                return e.prev = 12, i.storage.delete("action"), i.storage.delete("provider"), i.storage.delete("handler"), e.finish(12);
                                            case 17:
                                            case "end":
                                                return e.stop();
                                        }
                                    }, e, null, [
                                        [
                                            1,
                                            ,
                                            12,
                                            17
                                        ]
                                    ]);
                                }))));
                            case 3:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function(e) {
                    return a.apply(this, arguments);
                })
            },
            {
                key: "logout",
                value: (r = n(y.mark(function e(t) {
                    var r, o, i = this;
                    return y.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                return r = "string" == typeof t ? {
                                    provider: t
                                } : t, o = this.provider(r.provider), e.abrupt("return", o.dedupe("logout", n(y.mark(function e() {
                                    var t;
                                    return y.wrap(function(e) {
                                        for(;;)switch(e.prev = e.next){
                                            case 0:
                                                return e.prev = 0, t = i.handler(r.handler), i.storage.set("action", "logout"), i.storage.set("provider", o.$name), i.storage.set("handler", t.$name), i.logger.info("[logout]: logging out with ".concat(o.$name, " via ").concat(t.$name, "...")), e.next = 8, t.open({
                                                    redirectUrl: o.redirectUrl("logout"),
                                                    url: C.url(o.logout, o.config.queryParams && o.config.queryParams("logout"))
                                                });
                                            case 8:
                                                o.storage.clear(), o.sync(), o.emit("logout"), i.logger.info("[logout]: logout complete"), e.next = 18;
                                                break;
                                            case 14:
                                                throw e.prev = 14, e.t0 = e.catch(0), o.emit("logout", e.t0), e.t0;
                                            case 18:
                                                return e.prev = 18, i.storage.delete("action"), i.storage.delete("provider"), i.storage.delete("handler"), e.finish(18);
                                            case 23:
                                            case "end":
                                                return e.stop();
                                        }
                                    }, e, null, [
                                        [
                                            0,
                                            14,
                                            18,
                                            23
                                        ]
                                    ]);
                                }))));
                            case 3:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function(e) {
                    return r.apply(this, arguments);
                })
            },
            {
                key: "provider",
                value: function(e) {
                    var t = H.find(this.config.providers, function(t) {
                        return t.$name === e;
                    });
                    if (!t) throw new b({
                        code: "invalid_provider",
                        message: "Unable to locate provider with the given name. (".concat(e, ")")
                    });
                    return t;
                }
            },
            {
                key: "handler",
                value: function(e) {
                    var t = void 0 === e ? H.find(this.config.handlers, function(e) {
                        return Boolean(e.config.default);
                    }) : H.find(this.config.handlers, function(t) {
                        return t.$name === e;
                    });
                    if (!t) throw new b({
                        code: "invalid_handler",
                        message: "Unable to locate handler with the given name. (".concat(e, ")")
                    });
                    return t;
                }
            },
            {
                key: "$secure",
                value: (t = n(y.mark(function e(t, r) {
                    var n, o;
                    return y.wrap(function(e) {
                        for(;;)switch(e.prev = e.next){
                            case 0:
                                n = this.handler(), o = null;
                            case 2:
                                if (!0 === o) {
                                    e.next = 13;
                                    break;
                                }
                                return e.next = 5, t.secure(r);
                            case 5:
                                if ("login" !== (o = e.sent)) {
                                    e.next = 11;
                                    break;
                                }
                                if (n.auto) {
                                    e.next = 9;
                                    break;
                                }
                                throw new b({
                                    code: "auto_unsupported",
                                    message: "The default handler doesn't support automatic authentication! (".concat(n.$name, ")")
                                });
                            case 9:
                                return e.next = 11, this.login({
                                    provider: t.$name,
                                    handler: n.$name
                                });
                            case 11:
                                e.next = 2;
                                break;
                            case 13:
                            case "end":
                                return e.stop();
                        }
                    }, e, this);
                })), function(e, r) {
                    return t.apply(this, arguments);
                })
            }
        ]), l;
    }(ue);
    e.Generic = Ee, e.Handler = Pe, e.OAuth2Provider = xe, e.OpenIDProvider = be, e.Provider = de, e.SalteAuth = Te, e.SalteAuthError = b, e.Utils = re, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});



class $323cff57bc50acf8$export$2d8d895a0a0f636e extends (0, $ce5cc9264d10c15d$exports.Handler) {
    constructor(config){
        super(config);
        this.config = (0, $ce5cc9264d10c15d$exports.Utils).Common.defaults(this.config, {
            timeout: 10000
        });
    }
    get name() {
        return 'redirect';
    }
    get auto() {
        return true;
    }
    connected(_ref) {
        var { action: action } = _ref;
        if (!action) return;
        var origin = this.storage.get('origin');
        if (!origin) return;
        this.storage.delete('origin');
        if (action === 'login') {
            // Does it make sense to navigate on 'logout'?
            // NOTE: This order, matters since navigate modifies the location.
            var parsed = (0, $ce5cc9264d10c15d$exports.Utils).URL.parse(location);
            this.navigate(origin);
            return parsed;
        }
    }
    open(_ref2) {
        var { url: url, timeout: timeout = this.config.timeout } = _ref2;
        this.storage.set('origin', location.href);
        this.navigate(url);
        return new Promise((_resolve, reject)=>{
            setTimeout(()=>{
                reject(new (0, $ce5cc9264d10c15d$exports.SalteAuthError)({
                    code: 'redirect_timeout',
                    message: "Timed out while redirecting."
                }));
            }, timeout);
        });
    }
}



class $ee6f099c33c2813e$export$a09ea15be966180e extends (0, $ce5cc9264d10c15d$exports.OpenIDProvider) {
    constructor(config){
        super(config);
    }
    get name() {
        return 'okta';
    }
    get login() {
        return this.url("".concat(this.config.url, "/oauth2/v1/authorize"));
    }
    get logout() {
        return this.url("".concat(this.config.url, "/oauth2/v1/logout"), {
            id_token_hint: this.idToken.raw,
            post_logout_redirect_uri: this.redirectUrl('logout')
        });
    }
}


const $c8fcd73ceb71c905$var$configs = {
    'localhost': {
        environment: 'local',
        api: 'https://api-alfa-utilities-fc-devl.jdf-alfa2-devl-vpn2.eu.e10.c01.johndeerecloud.com',
        core: 'https://fc-devl-r2-core-financeconnect.deere.com',
        pos: 'https://fc-devl-r2-pos-financeconnect.deere.com',
        auth: {
            url: 'https://sso-dev.johndeere.com',
            clientId: '0oanv6n8xoGVjF4Pt0h7'
        }
    },
    'fc-devl-casemanagement-financeconnect.deere.com': {
        environment: 'devl',
        api: 'https://api-alfa-utilities-fc-devl.jdf-alfa2-devl-vpn2.eu.e10.c01.johndeerecloud.com',
        core: 'https://fc-devl-r2-core-financeconnect.deere.com',
        pos: 'https://fc-devl-r2-pos-financeconnect.deere.com',
        auth: {
            url: 'https://sso-dev.johndeere.com',
            clientId: '0oanv6n8xoGVjF4Pt0h7'
        }
    },
    'fc-qual-casemanagement-financeconnect.deere.com': {
        environment: 'qual',
        api: 'https://api-alfa-utilities-fc-qual.alfa2-qual-floating.eu.e10.c01.johndeerecloud.com',
        core: 'https://fc-qual-r2-core-financeconnect.deere.com',
        pos: 'https://pos-gateway-fc-qual.alfa2-qual-floating.eu.e10.c01.johndeerecloud.com',
        auth: {
            url: 'https://sso-qual.johndeere.com',
            clientId: '0oao6s3bwt9Sx96Df0h7'
        }
    },
    'casemanagement-financeconnect.deere.com': {
        environment: 'prod',
        core: 'https://r2-core-financeconnect.deere.com',
        pos: 'https://financeconnect.deere.com',
        auth: {
            url: 'https://sso.johndeere.com',
            clientId: '0oacc5powaRBBgTEC1t7'
        }
    }
};
const $c8fcd73ceb71c905$export$e506a1d27d1eaa20 = $c8fcd73ceb71c905$var$configs[location.hostname];
$c8fcd73ceb71c905$export$e506a1d27d1eaa20.FONT_DOMAIN = 'https://fonts.googleapis.com';
if (!$c8fcd73ceb71c905$export$e506a1d27d1eaa20.api) $c8fcd73ceb71c905$export$e506a1d27d1eaa20.api = `https://api-${location.hostname}`;
$c8fcd73ceb71c905$export$e506a1d27d1eaa20.isDevelopmentEnvironment = [
    'local',
    'devl'
].includes($c8fcd73ceb71c905$export$e506a1d27d1eaa20.environment);
$c8fcd73ceb71c905$export$e506a1d27d1eaa20.isProductionEnvironment = [
    'prod'
].includes($c8fcd73ceb71c905$export$e506a1d27d1eaa20.environment);
$c8fcd73ceb71c905$export$e506a1d27d1eaa20.isQualityEnvironment = [
    'qual'
].includes($c8fcd73ceb71c905$export$e506a1d27d1eaa20.environment);


/* eslint-disable no-prototype-builtins */ var $8754da8e5db2aca5$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== 'undefined' && $parcel$global || {};
var $8754da8e5db2aca5$var$support = {
    searchParams: 'URLSearchParams' in $8754da8e5db2aca5$var$g,
    iterable: 'Symbol' in $8754da8e5db2aca5$var$g && 'iterator' in Symbol,
    blob: 'FileReader' in $8754da8e5db2aca5$var$g && 'Blob' in $8754da8e5db2aca5$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in $8754da8e5db2aca5$var$g,
    arrayBuffer: 'ArrayBuffer' in $8754da8e5db2aca5$var$g
};
function $8754da8e5db2aca5$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($8754da8e5db2aca5$var$support.arrayBuffer) {
    var $8754da8e5db2aca5$var$viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var $8754da8e5db2aca5$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $8754da8e5db2aca5$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $8754da8e5db2aca5$var$normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $8754da8e5db2aca5$var$normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $8754da8e5db2aca5$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($8754da8e5db2aca5$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $8754da8e5db2aca5$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $8754da8e5db2aca5$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$8754da8e5db2aca5$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $8754da8e5db2aca5$var$normalizeName(name);
    value = $8754da8e5db2aca5$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
$8754da8e5db2aca5$export$79b704688b15c0f4.prototype['delete'] = function(name) {
    delete this.map[$8754da8e5db2aca5$var$normalizeName(name)];
};
$8754da8e5db2aca5$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $8754da8e5db2aca5$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$8754da8e5db2aca5$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($8754da8e5db2aca5$var$normalizeName(name));
};
$8754da8e5db2aca5$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$8754da8e5db2aca5$var$normalizeName(name)] = $8754da8e5db2aca5$var$normalizeValue(value);
};
$8754da8e5db2aca5$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$8754da8e5db2aca5$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $8754da8e5db2aca5$var$iteratorFor(items);
};
$8754da8e5db2aca5$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $8754da8e5db2aca5$var$iteratorFor(items);
};
$8754da8e5db2aca5$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $8754da8e5db2aca5$var$iteratorFor(items);
};
if ($8754da8e5db2aca5$var$support.iterable) $8754da8e5db2aca5$export$79b704688b15c0f4.prototype[Symbol.iterator] = $8754da8e5db2aca5$export$79b704688b15c0f4.prototype.entries;
function $8754da8e5db2aca5$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function $8754da8e5db2aca5$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $8754da8e5db2aca5$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $8754da8e5db2aca5$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $8754da8e5db2aca5$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $8754da8e5db2aca5$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise;
}
function $8754da8e5db2aca5$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function $8754da8e5db2aca5$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $8754da8e5db2aca5$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = '';
        } else if (typeof body === 'string') this._bodyText = body;
        else if ($8754da8e5db2aca5$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($8754da8e5db2aca5$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($8754da8e5db2aca5$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($8754da8e5db2aca5$var$support.arrayBuffer && $8754da8e5db2aca5$var$support.blob && $8754da8e5db2aca5$var$isDataView(body)) {
            this._bodyArrayBuffer = $8754da8e5db2aca5$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($8754da8e5db2aca5$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $8754da8e5db2aca5$var$isArrayBufferView(body))) this._bodyArrayBuffer = $8754da8e5db2aca5$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if ($8754da8e5db2aca5$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if ($8754da8e5db2aca5$var$support.blob) this.blob = function() {
        var rejected = $8754da8e5db2aca5$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $8754da8e5db2aca5$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($8754da8e5db2aca5$var$support.blob) return this.blob().then($8754da8e5db2aca5$var$readBlobAsArrayBuffer);
        else throw new Error('could not read as ArrayBuffer');
    };
    this.text = function() {
        var rejected = $8754da8e5db2aca5$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $8754da8e5db2aca5$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($8754da8e5db2aca5$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if ($8754da8e5db2aca5$var$support.formData) this.formData = function() {
        return this.text().then($8754da8e5db2aca5$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $8754da8e5db2aca5$var$methods = [
    'CONNECT',
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
    'TRACE'
];
function $8754da8e5db2aca5$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $8754da8e5db2aca5$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $8754da8e5db2aca5$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $8754da8e5db2aca5$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $8754da8e5db2aca5$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $8754da8e5db2aca5$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new $8754da8e5db2aca5$export$79b704688b15c0f4(options.headers);
    this.method = $8754da8e5db2aca5$var$normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ('AbortController' in $8754da8e5db2aca5$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
$8754da8e5db2aca5$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $8754da8e5db2aca5$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $8754da8e5db2aca5$var$decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $8754da8e5db2aca5$var$parseHeaders(rawHeaders) {
    var headers = new $8754da8e5db2aca5$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn('Response ' + error.message);
            }
        }
    });
    return headers;
}
$8754da8e5db2aca5$var$Body.call($8754da8e5db2aca5$export$7fa6c5b6f8193917.prototype);
function $8754da8e5db2aca5$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $8754da8e5db2aca5$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new $8754da8e5db2aca5$export$79b704688b15c0f4(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
$8754da8e5db2aca5$var$Body.call($8754da8e5db2aca5$export$9f633d56d7ec90d3.prototype);
$8754da8e5db2aca5$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $8754da8e5db2aca5$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $8754da8e5db2aca5$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$8754da8e5db2aca5$export$9f633d56d7ec90d3.error = function() {
    var response = new $8754da8e5db2aca5$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ''
    });
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response;
};
var $8754da8e5db2aca5$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$8754da8e5db2aca5$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($8754da8e5db2aca5$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new $8754da8e5db2aca5$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $8754da8e5db2aca5$export$fe58bcf938607f6a = $8754da8e5db2aca5$var$g.DOMException;
try {
    new $8754da8e5db2aca5$export$fe58bcf938607f6a();
} catch (err) {
    $8754da8e5db2aca5$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $8754da8e5db2aca5$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $8754da8e5db2aca5$export$fe58bcf938607f6a.prototype.constructor = $8754da8e5db2aca5$export$fe58bcf938607f6a;
}
function $8754da8e5db2aca5$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $8754da8e5db2aca5$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $8754da8e5db2aca5$export$fe58bcf938607f6a('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $8754da8e5db2aca5$var$parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $8754da8e5db2aca5$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request timed out'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $8754da8e5db2aca5$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && $8754da8e5db2aca5$var$g.location.href ? $8754da8e5db2aca5$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if ($8754da8e5db2aca5$var$support.blob) xhr.responseType = 'blob';
            else if ($8754da8e5db2aca5$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof $8754da8e5db2aca5$export$79b704688b15c0f4 || $8754da8e5db2aca5$var$g.Headers && init.headers instanceof $8754da8e5db2aca5$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($8754da8e5db2aca5$var$normalizeName(name));
                xhr.setRequestHeader(name, $8754da8e5db2aca5$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
$8754da8e5db2aca5$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$8754da8e5db2aca5$var$g.fetch) {
    $8754da8e5db2aca5$var$g.fetch = $8754da8e5db2aca5$export$e7aa7bc5c1b3cfb3;
    $8754da8e5db2aca5$var$g.Headers = $8754da8e5db2aca5$export$79b704688b15c0f4;
    $8754da8e5db2aca5$var$g.Request = $8754da8e5db2aca5$export$7fa6c5b6f8193917;
    $8754da8e5db2aca5$var$g.Response = $8754da8e5db2aca5$export$9f633d56d7ec90d3;
}




async function $c04283212adf4fb0$export$c4b7edec3f76b207(url, options = {}) {
    options.query = options.query || {};
    if (url.startsWith('/api')) {
        options.headers = options.headers || {};
        options.headers.Authorization = `Bearer ${(0, $1982a4c5f4dd80b7$export$73693bad9f5880b0).config.providers[0].idToken.raw}`;
        if ((0, $c8fcd73ceb71c905$export$e506a1d27d1eaa20).isDevelopmentEnvironment) {
            if ((0, $1982a4c5f4dd80b7$export$69d4516a6fd8e701).overrideRole) options.headers['X-Role-Override'] = (0, $1982a4c5f4dd80b7$export$69d4516a6fd8e701).overrideRole;
            if (localStorage.getItem('localhost') === 'true') return await $c04283212adf4fb0$export$c4b7edec3f76b207(url.replace('/api', 'http://localhost:8080'), options);
        }
        return await $c04283212adf4fb0$export$c4b7edec3f76b207(url.replace('/api', (0, $c8fcd73ceb71c905$export$e506a1d27d1eaa20).api), options);
    } else {
        const request = new URL(url);
        const entries = Object.entries(options.query).sort(([key], [otherKey])=>{
            return key.localeCompare(otherKey);
        });
        for (const [key, value] of entries){
            if (Array.isArray(value)) value.sort().forEach((v)=>request.searchParams.append(key, v));
            else if (value) request.searchParams.append(key, value);
        }
        const response = await window.fetch(request, options);
        const content = response.headers.get('Content-Type') && response.headers.get('Content-Type').includes('application/json') ? await response.json() : await response.text();
        return response.status >= 400 ? Promise.reject(content) : content;
    }
}
const $c04283212adf4fb0$var$cache = {};
async function $c04283212adf4fb0$export$60ad299e2e6f36fe(url, options = {}, rebuildCache) {
    const key = btoa(url) + btoa(JSON.stringify(options));
    if (rebuildCache) delete $c04283212adf4fb0$var$cache[key];
    if (!$c04283212adf4fb0$var$cache[key]) {
        options.cacheDuration = options.cacheDuration || 1000; // One second.
        $c04283212adf4fb0$var$cache[key] = $c04283212adf4fb0$export$c4b7edec3f76b207(url, options).finally(()=>{
            if (options.cacheDuration !== 'forever') setTimeout(()=>{
                delete $c04283212adf4fb0$var$cache[key];
            }, options.cacheDuration);
        });
    }
    return await $c04283212adf4fb0$var$cache[key];
}


const $1982a4c5f4dd80b7$export$73693bad9f5880b0 = new (0, $ce5cc9264d10c15d$exports.SalteAuth)({
    providers: [
        new (0, $ee6f099c33c2813e$export$a09ea15be966180e)({
            url: (0, $c8fcd73ceb71c905$export$e506a1d27d1eaa20).auth.url,
            clientID: (0, $c8fcd73ceb71c905$export$e506a1d27d1eaa20).auth.clientId,
            responseType: 'id_token',
            redirectUrl: location.origin,
            scope: 'openid profile',
            routes: true,
            loginType: 'redirect'
        })
    ],
    handlers: [
        new (0, $323cff57bc50acf8$export$2d8d895a0a0f636e)({
            default: true,
            url: location.origin
        })
    ]
});
let $1982a4c5f4dd80b7$var$_userPromise = null;
let $1982a4c5f4dd80b7$var$_user = null;
class $1982a4c5f4dd80b7$export$69d4516a6fd8e701 {
    static logout(provider) {
        $1982a4c5f4dd80b7$export$73693bad9f5880b0.logout(provider);
    }
    static get user() {
        if (!$1982a4c5f4dd80b7$var$_userPromise) $1982a4c5f4dd80b7$var$_userPromise = (0, $c04283212adf4fb0$export$c4b7edec3f76b207)('/api/users/current').then((user)=>{
            $1982a4c5f4dd80b7$var$_user = user;
            return $1982a4c5f4dd80b7$var$_user;
        });
        return $1982a4c5f4dd80b7$var$_userPromise;
    }
    static get overrideRole() {
        return localStorage.getItem('aui.override-role');
    }
    static get role() {
        const role = $1982a4c5f4dd80b7$var$_user && $1982a4c5f4dd80b7$var$_user.role || null;
        if (role === 'ADMIN') return this.overrideRole || role;
        return role;
    }
    static set role(role) {
        localStorage.setItem('aui.override-role', role);
    }
    static name({ id: id, firstName: firstName, lastName: lastName, includeID: includeID }) {
        if (firstName && lastName) {
            const fullName = `${firstName} ${lastName}`;
            if (includeID) return `${fullName} (${id})`;
            return fullName;
        }
        return id;
    }
}



var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");

var $67mp8 = parcelRequire("67mp8");

var $elnlQ = parcelRequire("elnlQ");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");


var $5rVgt = parcelRequire("5rVgt");
var $fe0aa9e32766c0f5$export$9dd6ff9ea0189349 = function styles(theme) {
    var elevations = {};
    theme.shadows.forEach(function(shadow, index) {
        elevations["elevation".concat(index)] = {
            boxShadow: shadow
        };
    });
    return (0, $elnlQ.default)({
        /* Styles applied to the root element. */ root: {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            transition: theme.transitions.create('box-shadow')
        },
        /* Styles applied to the root element if `square={false}`. */ rounded: {
            borderRadius: theme.shape.borderRadius
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            border: "1px solid ".concat(theme.palette.divider)
        }
    }, elevations);
};
var $fe0aa9e32766c0f5$var$Paper = /*#__PURE__*/ $Fo7oF.forwardRef(function Paper(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$square = props.square, square = _props$square === void 0 ? false : _props$square, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 1 : _props$elevation, _props$variant = props.variant, variant = _props$variant === void 0 ? 'elevation' : _props$variant, other = (0, $67mp8.default)(props, [
        "classes",
        "className",
        "component",
        "square",
        "elevation",
        "variant"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
        ref: ref
    }, other));
});
var $fe0aa9e32766c0f5$export$2e2bcd8739ae039 = (0, $5rVgt.default)($fe0aa9e32766c0f5$export$9dd6ff9ea0189349, {
    name: 'MuiPaper'
})($fe0aa9e32766c0f5$var$Paper);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");

var $bT5dp = parcelRequire("bT5dp");
var $b6511d47df71b02c$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            margin: 0
        },
        /* Styles applied to the root element if `variant="body2"`. */ body2: theme.typography.body2,
        /* Styles applied to the root element if `variant="body1"`. */ body1: theme.typography.body1,
        /* Styles applied to the root element if `variant="caption"`. */ caption: theme.typography.caption,
        /* Styles applied to the root element if `variant="button"`. */ button: theme.typography.button,
        /* Styles applied to the root element if `variant="h1"`. */ h1: theme.typography.h1,
        /* Styles applied to the root element if `variant="h2"`. */ h2: theme.typography.h2,
        /* Styles applied to the root element if `variant="h3"`. */ h3: theme.typography.h3,
        /* Styles applied to the root element if `variant="h4"`. */ h4: theme.typography.h4,
        /* Styles applied to the root element if `variant="h5"`. */ h5: theme.typography.h5,
        /* Styles applied to the root element if `variant="h6"`. */ h6: theme.typography.h6,
        /* Styles applied to the root element if `variant="subtitle1"`. */ subtitle1: theme.typography.subtitle1,
        /* Styles applied to the root element if `variant="subtitle2"`. */ subtitle2: theme.typography.subtitle2,
        /* Styles applied to the root element if `variant="overline"`. */ overline: theme.typography.overline,
        /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */ srOnly: {
            position: 'absolute',
            height: 1,
            width: 1,
            overflow: 'hidden'
        },
        /* Styles applied to the root element if `align="left"`. */ alignLeft: {
            textAlign: 'left'
        },
        /* Styles applied to the root element if `align="center"`. */ alignCenter: {
            textAlign: 'center'
        },
        /* Styles applied to the root element if `align="right"`. */ alignRight: {
            textAlign: 'right'
        },
        /* Styles applied to the root element if `align="justify"`. */ alignJustify: {
            textAlign: 'justify'
        },
        /* Styles applied to the root element if `nowrap={true}`. */ noWrap: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        /* Styles applied to the root element if `gutterBottom={true}`. */ gutterBottom: {
            marginBottom: '0.35em'
        },
        /* Styles applied to the root element if `paragraph={true}`. */ paragraph: {
            marginBottom: 16
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit'
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="textPrimary"`. */ colorTextPrimary: {
            color: theme.palette.text.primary
        },
        /* Styles applied to the root element if `color="textSecondary"`. */ colorTextSecondary: {
            color: theme.palette.text.secondary
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `display="inline"`. */ displayInline: {
            display: 'inline'
        },
        /* Styles applied to the root element if `display="block"`. */ displayBlock: {
            display: 'block'
        }
    };
};
var $b6511d47df71b02c$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p'
};
var $b6511d47df71b02c$var$Typography = /*#__PURE__*/ $Fo7oF.forwardRef(function Typography(props, ref) {
    var _props$align = props.align, align = _props$align === void 0 ? 'inherit' : _props$align, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'initial' : _props$color, component = props.component, _props$display = props.display, display = _props$display === void 0 ? 'initial' : _props$display, _props$gutterBottom = props.gutterBottom, gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom, _props$noWrap = props.noWrap, noWrap = _props$noWrap === void 0 ? false : _props$noWrap, _props$paragraph = props.paragraph, paragraph = _props$paragraph === void 0 ? false : _props$paragraph, _props$variant = props.variant, variant = _props$variant === void 0 ? 'body1' : _props$variant, _props$variantMapping = props.variantMapping, variantMapping = _props$variantMapping === void 0 ? $b6511d47df71b02c$var$defaultVariantMapping : _props$variantMapping, other = (0, $67mp8.default)(props, [
        "align",
        "classes",
        "className",
        "color",
        "component",
        "display",
        "gutterBottom",
        "noWrap",
        "paragraph",
        "variant",
        "variantMapping"
    ]);
    var Component = component || (paragraph ? 'p' : variantMapping[variant] || $b6511d47df71b02c$var$defaultVariantMapping[variant]) || 'span';
    return /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat((0, $bT5dp.default)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat((0, $bT5dp.default)(align))], display !== 'initial' && classes["display".concat((0, $bT5dp.default)(display))]),
        ref: ref
    }, other));
});
var $b6511d47df71b02c$export$2e2bcd8739ae039 = (0, $5rVgt.default)($b6511d47df71b02c$export$9dd6ff9ea0189349, {
    name: 'MuiTypography'
})($b6511d47df71b02c$var$Typography);



var $67mp8 = parcelRequire("67mp8");

var $elnlQ = parcelRequire("elnlQ");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");

var $8Hh6N = parcelRequire("8Hh6N");

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $bvYwR = parcelRequire("bvYwR");

var $78z8j = parcelRequire("78z8j");


var $Fo7oF = parcelRequire("Fo7oF");
// TODO v5: consider to make it private
function $797ab9d955819a25$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


function $1c1bbc2541ed2058$export$2e2bcd8739ae039(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */ return $Fo7oF.useMemo(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            (0, $797ab9d955819a25$export$2e2bcd8739ae039)(refA, refValue);
            (0, $797ab9d955819a25$export$2e2bcd8739ae039)(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}



var $Fo7oF = parcelRequire("Fo7oF");
var $0555362ea49db74e$var$useEnhancedEffect = typeof window !== 'undefined' ? $Fo7oF.useLayoutEffect : $Fo7oF.useEffect;
function $0555362ea49db74e$export$2e2bcd8739ae039(fn) {
    var ref = $Fo7oF.useRef(fn);
    $0555362ea49db74e$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return $Fo7oF.useCallback(function() {
        return (0, ref.current).apply(void 0, arguments);
    }, []);
}




var $5rVgt = parcelRequire("5rVgt");
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $Fo7oF = parcelRequire("Fo7oF");

var $bvYwR = parcelRequire("bvYwR");
var $ef37cdf34d04c3a7$var$hadKeyboardEvent = true;
var $ef37cdf34d04c3a7$var$hadFocusVisibleRecently = false;
var $ef37cdf34d04c3a7$var$hadFocusVisibleRecentlyTimeout = null;
var $ef37cdf34d04c3a7$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */ function $ef37cdf34d04c3a7$var$focusTriggersKeyboardModality(node) {
    var type = node.type, tagName = node.tagName;
    if (tagName === 'INPUT' && $ef37cdf34d04c3a7$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $ef37cdf34d04c3a7$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $ef37cdf34d04c3a7$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $ef37cdf34d04c3a7$var$handlePointerDown() {
    $ef37cdf34d04c3a7$var$hadKeyboardEvent = false;
}
function $ef37cdf34d04c3a7$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($ef37cdf34d04c3a7$var$hadFocusVisibleRecently) $ef37cdf34d04c3a7$var$hadKeyboardEvent = true;
    }
}
function $ef37cdf34d04c3a7$var$prepare(doc) {
    doc.addEventListener('keydown', $ef37cdf34d04c3a7$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $ef37cdf34d04c3a7$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $ef37cdf34d04c3a7$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $ef37cdf34d04c3a7$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $ef37cdf34d04c3a7$var$handleVisibilityChange, true);
}
function $ef37cdf34d04c3a7$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $ef37cdf34d04c3a7$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $ef37cdf34d04c3a7$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $ef37cdf34d04c3a7$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $ef37cdf34d04c3a7$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $ef37cdf34d04c3a7$var$handleVisibilityChange, true);
}
function $ef37cdf34d04c3a7$var$isFocusVisible(event) {
    var target = event.target;
    try {
        return target.matches(':focus-visible');
    } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    // no need for validFocusTarget check. the user does that by attaching it to
    // focusable events only
    return $ef37cdf34d04c3a7$var$hadKeyboardEvent || $ef37cdf34d04c3a7$var$focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */ function $ef37cdf34d04c3a7$var$handleBlurVisible() {
    // To detect a tab/window switch, we look for a blur event followed
    // rapidly by a visibility change.
    // If we don't see a visibility change within 100ms, it's probably a
    // regular focus change.
    $ef37cdf34d04c3a7$var$hadFocusVisibleRecently = true;
    window.clearTimeout($ef37cdf34d04c3a7$var$hadFocusVisibleRecentlyTimeout);
    $ef37cdf34d04c3a7$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
        $ef37cdf34d04c3a7$var$hadFocusVisibleRecently = false;
    }, 100);
}
function $ef37cdf34d04c3a7$export$2e2bcd8739ae039() {
    var ref = $Fo7oF.useCallback(function(instance) {
        var node = $bvYwR.findDOMNode(instance);
        if (node != null) $ef37cdf34d04c3a7$var$prepare(node.ownerDocument);
    }, []);
    return {
        isFocusVisible: $ef37cdf34d04c3a7$var$isFocusVisible,
        onBlurVisible: $ef37cdf34d04c3a7$var$handleBlurVisible,
        ref: ref
    };
}



var $elnlQ = parcelRequire("elnlQ");

var $83MhR = parcelRequire("83MhR");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $fjJNR = parcelRequire("fjJNR");

var $elnlQ = parcelRequire("elnlQ");

var $bnz4d = parcelRequire("bnz4d");

var $bLCcc = parcelRequire("bLCcc");


var $Fo7oF = parcelRequire("Fo7oF");

var $a8RX5 = parcelRequire("a8RX5");

var $Fo7oF = parcelRequire("Fo7oF");
function $a0319a2bead7043d$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $Fo7oF.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $Fo7oF.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $a0319a2bead7043d$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $a0319a2bead7043d$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $a0319a2bead7043d$export$fa71e2345c31d7a2(props, onExited) {
    return $a0319a2bead7043d$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $Fo7oF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $a0319a2bead7043d$var$getProp(child, 'appear', props),
            enter: $a0319a2bead7043d$var$getProp(child, 'enter', props),
            exit: $a0319a2bead7043d$var$getProp(child, 'exit', props)
        });
    });
}
function $a0319a2bead7043d$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $a0319a2bead7043d$export$bbc8a025727ea824(nextProps.children);
    var children = $a0319a2bead7043d$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $Fo7oF.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $Fo7oF.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $Fo7oF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $a0319a2bead7043d$var$getProp(child, 'exit', nextProps),
            enter: $a0319a2bead7043d$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $Fo7oF.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $Fo7oF.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $Fo7oF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $a0319a2bead7043d$var$getProp(child, 'exit', nextProps),
            enter: $a0319a2bead7043d$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $7568199b92ec00e5$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $7568199b92ec00e5$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $7568199b92ec00e5$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $bLCcc.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $bnz4d.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $a0319a2bead7043d$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $a0319a2bead7043d$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $a0319a2bead7043d$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $elnlQ.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $fjJNR.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $7568199b92ec00e5$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $a8RX5.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $a8RX5.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component);
$7568199b92ec00e5$var$TransitionGroup.propTypes = {};
$7568199b92ec00e5$var$TransitionGroup.defaultProps = $7568199b92ec00e5$var$defaultProps;
var $7568199b92ec00e5$export$2e2bcd8739ae039 = $7568199b92ec00e5$var$TransitionGroup;



var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5d703dc8fba427ee$var$useEnhancedEffect = typeof window === 'undefined' ? $Fo7oF.useEffect : $Fo7oF.useLayoutEffect;
/**
 * @ignore - internal component.
 */ function $5d703dc8fba427ee$var$Ripple(props) {
    var classes = props.classes, _props$pulsate = props.pulsate, pulsate = _props$pulsate === void 0 ? false : _props$pulsate, rippleX = props.rippleX, rippleY = props.rippleY, rippleSize = props.rippleSize, inProp = props.in, _props$onExited = props.onExited, onExited = _props$onExited === void 0 ? function() {} : _props$onExited, timeout = props.timeout;
    var _React$useState = $Fo7oF.useState(false), leaving = _React$useState[0], setLeaving = _React$useState[1];
    var rippleClassName = (0, $78z8j.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    var childClassName = (0, $78z8j.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    var handleExited = (0, $0555362ea49db74e$export$2e2bcd8739ae039)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
    $5d703dc8fba427ee$var$useEnhancedEffect(function() {
        if (!inProp) {
            // react-transition-group#onExit
            setLeaving(true); // react-transition-group#onExited
            var timeoutId = setTimeout(handleExited, timeout);
            return function() {
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        handleExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
    }, /*#__PURE__*/ $Fo7oF.createElement("span", {
        className: childClassName
    }));
}
var $5d703dc8fba427ee$export$2e2bcd8739ae039 = $5d703dc8fba427ee$var$Ripple;


var $52462c9f0d9f38f4$var$DURATION = 550;
var $52462c9f0d9f38f4$export$95d0c9356b2231a3 = 80;
var $52462c9f0d9f38f4$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            overflow: 'hidden',
            pointerEvents: 'none',
            position: 'absolute',
            zIndex: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: 'inherit'
        },
        /* Styles applied to the internal `Ripple` components `ripple` class. */ ripple: {
            opacity: 0,
            position: 'absolute'
        },
        /* Styles applied to the internal `Ripple` components `rippleVisible` class. */ rippleVisible: {
            opacity: 0.3,
            transform: 'scale(1)',
            animation: "$enter ".concat($52462c9f0d9f38f4$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */ ripplePulsate: {
            animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
        },
        /* Styles applied to the internal `Ripple` components `child` class. */ child: {
            opacity: 1,
            display: 'block',
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            backgroundColor: 'currentColor'
        },
        /* Styles applied to the internal `Ripple` components `childLeaving` class. */ childLeaving: {
            opacity: 0,
            animation: "$exit ".concat($52462c9f0d9f38f4$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `childPulsate` class. */ childPulsate: {
            position: 'absolute',
            left: 0,
            top: 0,
            animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
        },
        '@keyframes enter': {
            '0%': {
                transform: 'scale(0)',
                opacity: 0.1
            },
            '100%': {
                transform: 'scale(1)',
                opacity: 0.3
            }
        },
        '@keyframes exit': {
            '0%': {
                opacity: 1
            },
            '100%': {
                opacity: 0
            }
        },
        '@keyframes pulsate': {
            '0%': {
                transform: 'scale(1)'
            },
            '50%': {
                transform: 'scale(0.92)'
            },
            '100%': {
                transform: 'scale(1)'
            }
        }
    };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ var $52462c9f0d9f38f4$var$TouchRipple = /*#__PURE__*/ $Fo7oF.forwardRef(function TouchRipple(props, ref) {
    var _props$center = props.center, centerProp = _props$center === void 0 ? false : _props$center, classes = props.classes, className = props.className, other = (0, $67mp8.default)(props, [
        "center",
        "classes",
        "className"
    ]);
    var _React$useState = $Fo7oF.useState([]), ripples = _React$useState[0], setRipples = _React$useState[1];
    var nextKey = $Fo7oF.useRef(0);
    var rippleCallback = $Fo7oF.useRef(null);
    $Fo7oF.useEffect(function() {
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]); // Used to filter out mouse emulated events on mobile.
    var ignoringMouseDown = $Fo7oF.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    var startTimer = $Fo7oF.useRef(null); // This is the hook called once the previous timeout is ready.
    var startTimerCommit = $Fo7oF.useRef(null);
    var container = $Fo7oF.useRef(null);
    $Fo7oF.useEffect(function() {
        return function() {
            clearTimeout(startTimer.current);
        };
    }, []);
    var startCommit = $Fo7oF.useCallback(function(params) {
        var pulsate = params.pulsate, rippleX = params.rippleX, rippleY = params.rippleY, rippleSize = params.rippleSize, cb = params.cb;
        setRipples(function(oldRipples) {
            return [].concat((0, $83MhR.default)(oldRipples), [
                /*#__PURE__*/ $Fo7oF.createElement((0, $5d703dc8fba427ee$export$2e2bcd8739ae039), {
                    key: nextKey.current,
                    classes: classes,
                    timeout: $52462c9f0d9f38f4$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                })
            ]);
        });
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    var start = $Fo7oF.useCallback(function() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var cb = arguments.length > 2 ? arguments[2] : undefined;
        var _options$pulsate = options.pulsate, pulsate = _options$pulsate === void 0 ? false : _options$pulsate, _options$center = options.center, center = _options$center === void 0 ? centerProp || options.pulsate : _options$center, _options$fakeElement = options.fakeElement, fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
        if (event.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event.type === 'touchstart') ignoringMouseDown.current = true;
        var element = fakeElement ? null : container.current;
        var rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        }; // Get the size of the ripple
        var rippleX;
        var rippleY;
        var rippleSize;
        if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            var _ref = event.touches ? event.touches[0] : event, clientX = _ref.clientX, clientY = _ref.clientY;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
        } // Touche devices
        if (event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = function() {
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                }; // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(function() {
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $52462c9f0d9f38f4$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    var pulsate = $Fo7oF.useCallback(function() {
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    var stop = $Fo7oF.useCallback(function(event, cb) {
        clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event.type === 'touchend' && startTimerCommit.current) {
            event.persist();
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(function() {
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples(function(oldRipples) {
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $Fo7oF.useImperativeHandle(ref, function() {
        return {
            pulsate: pulsate,
            start: start,
            stop: stop
        };
    }, [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement("span", (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className),
        ref: container
    }, other), /*#__PURE__*/ $Fo7oF.createElement((0, $7568199b92ec00e5$export$2e2bcd8739ae039), {
        component: null,
        exit: true
    }, ripples));
});
var $52462c9f0d9f38f4$export$2e2bcd8739ae039 = (0, $5rVgt.default)($52462c9f0d9f38f4$export$9dd6ff9ea0189349, {
    flip: false,
    name: 'MuiTouchRipple'
})(/*#__PURE__*/ $Fo7oF.memo($52462c9f0d9f38f4$var$TouchRipple));


var $67b46b5fd967aa2b$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        '-moz-appearance': 'none',
        // Reset
        '-webkit-appearance': 'none',
        // Reset
        textDecoration: 'none',
        // So we take precedent over the style of a native <a /> element.
        color: 'inherit',
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        '&$disabled': {
            pointerEvents: 'none',
            // Disable link interactions
            cursor: 'default'
        },
        '@media print': {
            colorAdjust: 'exact'
        }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
    /* Pseudo-class applied to the root element if keyboard focused. */ focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ var $67b46b5fd967aa2b$var$ButtonBase = /*#__PURE__*/ $Fo7oF.forwardRef(function ButtonBase(props, ref) {
    var action = props.action, buttonRefProp = props.buttonRef, _props$centerRipple = props.centerRipple, centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple, children = props.children, classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? 'button' : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$disableTouchRi = props.disableTouchRipple, disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi, _props$focusRipple = props.focusRipple, focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple, focusVisibleClassName = props.focusVisibleClassName, onBlur = props.onBlur, onClick = props.onClick, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, onDragLeave = props.onDragLeave, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, TouchRippleProps = props.TouchRippleProps, _props$type = props.type, type = _props$type === void 0 ? 'button' : _props$type, other = (0, $67mp8.default)(props, [
        "action",
        "buttonRef",
        "centerRipple",
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "disableRipple",
        "disableTouchRipple",
        "focusRipple",
        "focusVisibleClassName",
        "onBlur",
        "onClick",
        "onFocus",
        "onFocusVisible",
        "onKeyDown",
        "onKeyUp",
        "onMouseDown",
        "onMouseLeave",
        "onMouseUp",
        "onTouchEnd",
        "onTouchMove",
        "onTouchStart",
        "onDragLeave",
        "tabIndex",
        "TouchRippleProps",
        "type"
    ]);
    var buttonRef = $Fo7oF.useRef(null);
    function getButtonNode() {
        // #StrictMode ready
        return $bvYwR.findDOMNode(buttonRef.current);
    }
    var rippleRef = $Fo7oF.useRef(null);
    var _React$useState = $Fo7oF.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    if (disabled && focusVisible) setFocusVisible(false);
    var _useIsFocusVisible = (0, $ef37cdf34d04c3a7$export$2e2bcd8739ae039)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    $Fo7oF.useImperativeHandle(action, function() {
        return {
            focusVisible: function focusVisible() {
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        };
    }, []);
    $Fo7oF.useEffect(function() {
        if (focusVisible && focusRipple && !disableRipple) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible
    ]);
    function useRippleHandler(rippleAction, eventCallback) {
        var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
        return (0, $0555362ea49db74e$export$2e2bcd8739ae039)(function(event) {
            if (eventCallback) eventCallback(event);
            var ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    var handleMouseDown = useRippleHandler('start', onMouseDown);
    var handleDragLeave = useRippleHandler('stop', onDragLeave);
    var handleMouseUp = useRippleHandler('stop', onMouseUp);
    var handleMouseLeave = useRippleHandler('stop', function(event) {
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    var handleTouchStart = useRippleHandler('start', onTouchStart);
    var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    var handleTouchMove = useRippleHandler('stop', onTouchMove);
    var handleBlur = useRippleHandler('stop', function(event) {
        if (focusVisible) {
            onBlurVisible(event);
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    }, false);
    var handleFocus = (0, $0555362ea49db74e$export$2e2bcd8739ae039)(function(event) {
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if (isFocusVisible(event)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    var isNonNativeButton = function isNonNativeButton() {
        var button = getButtonNode();
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ var keydownRef = $Fo7oF.useRef(false);
    var handleKeyDown = (0, $0555362ea49db74e$export$2e2bcd8739ae039)(function(event) {
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
         // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    var handleKeyUp = (0, $0555362ea49db74e$export$2e2bcd8739ae039)(function(event) {
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
         // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    var ComponentProp = component;
    if (ComponentProp === 'button' && other.href) ComponentProp = 'a';
    var buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type;
        buttonProps.disabled = disabled;
    } else {
        if (ComponentProp !== 'a' || !other.href) buttonProps.role = 'button';
        buttonProps['aria-disabled'] = disabled;
    }
    var handleUserRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(buttonRefProp, ref);
    var handleOwnRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(focusVisibleRef, buttonRef);
    var handleRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(handleUserRef, handleOwnRef);
    var _React$useState2 = $Fo7oF.useState(false), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    $Fo7oF.useEffect(function() {
        setMountedState(true);
    }, []);
    var enableTouchRipple = mountedState && !disableRipple && !disabled;
    return /*#__PURE__*/ $Fo7oF.createElement(ComponentProp, (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className, focusVisible && [
            classes.focusVisible,
            focusVisibleClassName
        ], disabled && classes.disabled),
        onBlur: handleBlur,
        onClick: onClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex
    }, buttonProps, other), children, enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ $Fo7oF.createElement((0, $52462c9f0d9f38f4$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        ref: rippleRef,
        center: centerRipple
    }, TouchRippleProps)) : null);
});
var $67b46b5fd967aa2b$export$2e2bcd8739ae039 = (0, $5rVgt.default)($67b46b5fd967aa2b$export$9dd6ff9ea0189349, {
    name: 'MuiButtonBase'
})($67b46b5fd967aa2b$var$ButtonBase);



var $bT5dp = parcelRequire("bT5dp");
var $896fad33a17d8629$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $elnlQ.default)({}, theme.typography.button, {
            boxSizing: 'border-box',
            minWidth: 64,
            padding: '6px 16px',
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.text.primary,
            transition: theme.transitions.create([
                'background-color',
                'box-shadow',
                'border'
            ], {
                duration: theme.transitions.duration.short
            }),
            '&:hover': {
                textDecoration: 'none',
                backgroundColor: (0, $8Hh6N.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                },
                '&$disabled': {
                    backgroundColor: 'transparent'
                }
            },
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        }),
        /* Styles applied to the span element that wraps the children. */ label: {
            width: '100%',
            // Ensure the correct width for iOS Safari
            display: 'inherit',
            alignItems: 'inherit',
            justifyContent: 'inherit'
        },
        /* Styles applied to the root element if `variant="text"`. */ text: {
            padding: '6px 8px'
        },
        /* Styles applied to the root element if `variant="text"` and `color="primary"`. */ textPrimary: {
            color: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: (0, $8Hh6N.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */ textSecondary: {
            color: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: (0, $8Hh6N.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            padding: '5px 15px',
            border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
            '&$disabled': {
                border: "1px solid ".concat(theme.palette.action.disabledBackground)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat((0, $8Hh6N.alpha)(theme.palette.primary.main, 0.5)),
            '&:hover': {
                border: "1px solid ".concat(theme.palette.primary.main),
                backgroundColor: (0, $8Hh6N.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat((0, $8Hh6N.alpha)(theme.palette.secondary.main, 0.5)),
            '&:hover': {
                border: "1px solid ".concat(theme.palette.secondary.main),
                backgroundColor: (0, $8Hh6N.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&$disabled': {
                border: "1px solid ".concat(theme.palette.action.disabled)
            }
        },
        /* Styles applied to the root element if `variant="contained"`. */ contained: {
            color: theme.palette.getContrastText(theme.palette.grey[300]),
            backgroundColor: theme.palette.grey[300],
            boxShadow: theme.shadows[2],
            '&:hover': {
                backgroundColor: theme.palette.grey.A100,
                boxShadow: theme.shadows[4],
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    boxShadow: theme.shadows[2],
                    backgroundColor: theme.palette.grey[300]
                },
                '&$disabled': {
                    backgroundColor: theme.palette.action.disabledBackground
                }
            },
            '&$focusVisible': {
                boxShadow: theme.shadows[6]
            },
            '&:active': {
                boxShadow: theme.shadows[8]
            },
            '&$disabled': {
                color: theme.palette.action.disabled,
                boxShadow: theme.shadows[0],
                backgroundColor: theme.palette.action.disabledBackground
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */ containedPrimary: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.palette.primary.main
                }
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */ containedSecondary: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: theme.palette.secondary.dark,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.palette.secondary.main
                }
            }
        },
        /* Styles applied to the root element if `disableElevation={true}`. */ disableElevation: {
            boxShadow: 'none',
            '&:hover': {
                boxShadow: 'none'
            },
            '&$focusVisible': {
                boxShadow: 'none'
            },
            '&:active': {
                boxShadow: 'none'
            },
            '&$disabled': {
                boxShadow: 'none'
            }
        },
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focusVisible: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit',
            borderColor: 'currentColor'
        },
        /* Styles applied to the root element if `size="small"` and `variant="text"`. */ textSizeSmall: {
            padding: '4px 5px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="text"`. */ textSizeLarge: {
            padding: '8px 11px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */ outlinedSizeSmall: {
            padding: '3px 9px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */ outlinedSizeLarge: {
            padding: '7px 21px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="contained"`. */ containedSizeSmall: {
            padding: '4px 10px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="contained"`. */ containedSizeLarge: {
            padding: '8px 22px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {},
        /* Styles applied to the root element if `size="large"`. */ sizeLarge: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: '100%'
        },
        /* Styles applied to the startIcon element if supplied. */ startIcon: {
            display: 'inherit',
            marginRight: 8,
            marginLeft: -4,
            '&$iconSizeSmall': {
                marginLeft: -2
            }
        },
        /* Styles applied to the endIcon element if supplied. */ endIcon: {
            display: 'inherit',
            marginRight: -4,
            marginLeft: 8,
            '&$iconSizeSmall': {
                marginRight: -2
            }
        },
        /* Styles applied to the icon element if supplied and `size="small"`. */ iconSizeSmall: {
            '& > *:first-child': {
                fontSize: 18
            }
        },
        /* Styles applied to the icon element if supplied and `size="medium"`. */ iconSizeMedium: {
            '& > *:first-child': {
                fontSize: 20
            }
        },
        /* Styles applied to the icon element if supplied and `size="large"`. */ iconSizeLarge: {
            '& > *:first-child': {
                fontSize: 22
            }
        }
    };
};
var $896fad33a17d8629$var$Button = /*#__PURE__*/ $Fo7oF.forwardRef(function Button(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, _props$component = props.component, component = _props$component === void 0 ? 'button' : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableElevati = props.disableElevation, disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, endIconProp = props.endIcon, focusVisibleClassName = props.focusVisibleClassName, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, startIconProp = props.startIcon, _props$type = props.type, type = _props$type === void 0 ? 'button' : _props$type, _props$variant = props.variant, variant = _props$variant === void 0 ? 'text' : _props$variant, other = (0, $67mp8.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "endIcon",
        "focusVisibleClassName",
        "fullWidth",
        "size",
        "startIcon",
        "type",
        "variant"
    ]);
    var startIcon = startIconProp && /*#__PURE__*/ $Fo7oF.createElement("span", {
        className: (0, $78z8j.default)(classes.startIcon, classes["iconSize".concat((0, $bT5dp.default)(size))])
    }, startIconProp);
    var endIcon = endIconProp && /*#__PURE__*/ $Fo7oF.createElement("span", {
        className: (0, $78z8j.default)(classes.endIcon, classes["iconSize".concat((0, $bT5dp.default)(size))])
    }, endIconProp);
    return /*#__PURE__*/ $Fo7oF.createElement((0, $67b46b5fd967aa2b$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat((0, $bT5dp.default)(color))], size !== 'medium' && [
            classes["".concat(variant, "Size").concat((0, $bT5dp.default)(size))],
            classes["size".concat((0, $bT5dp.default)(size))]
        ], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $78z8j.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other), /*#__PURE__*/ $Fo7oF.createElement("span", {
        className: classes.label
    }, startIcon, children, endIcon));
});
var $896fad33a17d8629$export$2e2bcd8739ae039 = (0, $5rVgt.default)($896fad33a17d8629$export$9dd6ff9ea0189349, {
    name: 'MuiButton'
})($896fad33a17d8629$var$Button);




var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");
var $460f76674a4a7bbb$exports = {};

$parcel$export($460f76674a4a7bbb$exports, "navbar", () => $460f76674a4a7bbb$export$58733aaf927c3bbe, (v) => $460f76674a4a7bbb$export$58733aaf927c3bbe = v);
$parcel$export($460f76674a4a7bbb$exports, "menuItemFirstActive", () => $460f76674a4a7bbb$export$9b55323664a07623, (v) => $460f76674a4a7bbb$export$9b55323664a07623 = v);
$parcel$export($460f76674a4a7bbb$exports, "menuItemActive", () => $460f76674a4a7bbb$export$f61f80c92d0119b6, (v) => $460f76674a4a7bbb$export$f61f80c92d0119b6 = v);
$parcel$export($460f76674a4a7bbb$exports, "logout", () => $460f76674a4a7bbb$export$a0973bcfe11b05c9, (v) => $460f76674a4a7bbb$export$a0973bcfe11b05c9 = v);
var $460f76674a4a7bbb$export$58733aaf927c3bbe;
var $460f76674a4a7bbb$export$9b55323664a07623;
var $460f76674a4a7bbb$export$f61f80c92d0119b6;
var $460f76674a4a7bbb$export$a0973bcfe11b05c9;
$460f76674a4a7bbb$export$58733aaf927c3bbe = "navbar_4fb7cf";
$460f76674a4a7bbb$export$9b55323664a07623 = "menuItemFirstActive_4fb7cf";
$460f76674a4a7bbb$export$f61f80c92d0119b6 = "menuItemActive_4fb7cf";
$460f76674a4a7bbb$export$a0973bcfe11b05c9 = "logout_4fb7cf";


var $ebc81e85cd9d0f88$exports = {};
"use strict";
Object.defineProperty($ebc81e85cd9d0f88$exports, "__esModule", {
    value: true
});
var $ebc81e85cd9d0f88$var$SL_NOT_INITIALIZED = 'Smartlook client is not initialized.';
$ebc81e85cd9d0f88$exports.default = {
    init: function(key, params) {
        var w = window;
        if (w.smartlook) {
            console.warn('Smartlook client is already initialized.');
            return false;
        }
        w.smartlook = function() {
            w.smartlook.api.push(arguments);
        };
        w.smartlook.api = [];
        var initParams = params;
        var src = 'https://web-sdk.smartlook.com/recorder.js';
        if (initParams === null || initParams === void 0 ? void 0 : initParams.relayProxyUrl) try {
            var constructedUrl = new URL('/recorder.js', initParams.relayProxyUrl);
            initParams.host = constructedUrl.host;
            src = constructedUrl.toString();
        } catch (e) {
            console.error('Smartlook init param `relayProxyUrl` is not valid. Please provide full url like `https://my-proxy-domain.com/`.');
            return false;
        }
        w.smartlook('init', key, initParams);
        var head = window.document.getElementsByTagName('head')[0];
        var script = window.document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.crossOrigin = 'anonymous';
        script.src = src;
        head.appendChild(script);
        return true;
    },
    identify: function(userId, props) {
        var w = window;
        if (!w.smartlook) {
            console.warn($ebc81e85cd9d0f88$var$SL_NOT_INITIALIZED);
            return false;
        }
        if (!userId) {
            console.warn('Smartlook - User ID must be provided');
            return false;
        }
        w.smartlook('identify', userId, props);
        return true;
    },
    anonymize: function() {
        var w = window;
        if (!w.smartlook) {
            console.warn($ebc81e85cd9d0f88$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('anonymize');
        return true;
    },
    track: function(eventName, props) {
        var w = window;
        if (!w.smartlook) {
            console.warn($ebc81e85cd9d0f88$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('track', eventName, props);
        return true;
    },
    disable: function() {
        var w = window;
        if (!w.smartlook) {
            console.warn($ebc81e85cd9d0f88$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('disable');
        return true;
    },
    record: function(params) {
        var w = window;
        if (!w.smartlook) {
            console.warn($ebc81e85cd9d0f88$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('record', params);
        return true;
    },
    getData: function(callback) {
        var w = window;
        if (!w.smartlook) {
            console.warn($ebc81e85cd9d0f88$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook(callback);
        return true;
    },
    restart: function() {
        var w = window;
        if (!w.smartlook) {
            console.warn($ebc81e85cd9d0f88$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('restart');
        return true;
    },
    pause: function() {
        var w = window;
        if (!w.smartlook) {
            console.warn($ebc81e85cd9d0f88$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('pause');
        return true;
    },
    resume: function() {
        var w = window;
        if (!w.smartlook) {
            console.warn($ebc81e85cd9d0f88$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('resume');
        return true;
    },
    error: function(error) {
        var w = window;
        if (!w.smartlook) {
            console.warn($ebc81e85cd9d0f88$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('error', error);
        return true;
    },
    navigation: function(locationOrPath) {
        var w = window;
        if (!w.smartlook) {
            console.warn($ebc81e85cd9d0f88$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('navigation', locationOrPath);
        return true;
    },
    properties: function(properties) {
        var w = window;
        if (!w.smartlook) {
            console.warn($ebc81e85cd9d0f88$var$SL_NOT_INITIALIZED);
            return false;
        }
        w.smartlook('properties', properties);
        return true;
    },
    initialized: function() {
        var w = window;
        return !!w.smartlook;
    },
    get playUrl () {
        var w = window;
        return w.smartlook.playUrl;
    },
    get sessionId () {
        var w1 = window;
        return w1.smartlook.sessionId;
    },
    get visitorId () {
        var w2 = window;
        return w2.smartlook.visitorId;
    },
    get recordId () {
        var w3 = window;
        return w3.smartlook.recordId;
    },
    get key () {
        var w4 = window;
        return w4.smartlook.key;
    },
    get version () {
        var w5 = window;
        return w5.smartlook.version;
    }
};


/**
 * react-router v7.18.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $Fo7oF = parcelRequire("Fo7oF");
var $5a9c912afef4aac7$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-62JRHF6Z.mjs"
});
var $5a9c912afef4aac7$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $5a9c912afef4aac7$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $5a9c912afef4aac7$var$__typeError("Cannot " + msg);
var $5a9c912afef4aac7$var$__privateGet = (obj, member, getter)=>($5a9c912afef4aac7$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $5a9c912afef4aac7$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $5a9c912afef4aac7$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $5a9c912afef4aac7$var$__privateSet = (obj, member, value, setter)=>($5a9c912afef4aac7$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/url.ts
var $5a9c912afef4aac7$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var $5a9c912afef4aac7$export$825a82322d91916e = /^[\\/]{2}/;
function $5a9c912afef4aac7$var$normalizeProtocolRelativeUrl(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}
// lib/router/history.ts
var $5a9c912afef4aac7$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($5a9c912afef4aac7$export$e19cd5f9376f8cee || {});
var $5a9c912afef4aac7$var$PopStateEventType = "popstate";
function $5a9c912afef4aac7$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $5a9c912afef4aac7$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $5a9c912afef4aac7$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $5a9c912afef4aac7$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $5a9c912afef4aac7$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $5a9c912afef4aac7$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $5a9c912afef4aac7$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $5a9c912afef4aac7$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $5a9c912afef4aac7$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $5a9c912afef4aac7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $5a9c912afef4aac7$export$fe53371bee54353d(to);
    }
    return $5a9c912afef4aac7$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $5a9c912afef4aac7$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $5a9c912afef4aac7$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $5a9c912afef4aac7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $5a9c912afef4aac7$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $5a9c912afef4aac7$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $5a9c912afef4aac7$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $5a9c912afef4aac7$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $5a9c912afef4aac7$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $5a9c912afef4aac7$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $5a9c912afef4aac7$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $5a9c912afef4aac7$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $5a9c912afef4aac7$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $5a9c912afef4aac7$var$createKey(),
        mask: mask
    };
    return location;
}
function $5a9c912afef4aac7$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $5a9c912afef4aac7$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $5a9c912afef4aac7$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $5a9c912afef4aac7$var$isLocation(to) ? to : $5a9c912afef4aac7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $5a9c912afef4aac7$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $5a9c912afef4aac7$var$isLocation(to) ? to : $5a9c912afef4aac7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $5a9c912afef4aac7$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $5a9c912afef4aac7$var$createBrowserURLImpl(window2, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($5a9c912afef4aac7$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($5a9c912afef4aac7$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $5a9c912afef4aac7$var$createBrowserURLImpl(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $5a9c912afef4aac7$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $5a9c912afef4aac7$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && $5a9c912afef4aac7$export$825a82322d91916e.test(href)) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $5a9c912afef4aac7$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $5a9c912afef4aac7$var$_map;
var $5a9c912afef4aac7$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $5a9c912afef4aac7$var$__privateAdd(this, $5a9c912afef4aac7$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($5a9c912afef4aac7$var$__privateGet(this, $5a9c912afef4aac7$var$_map).has(context)) return $5a9c912afef4aac7$var$__privateGet(this, $5a9c912afef4aac7$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $5a9c912afef4aac7$var$__privateGet(this, $5a9c912afef4aac7$var$_map).set(context, value);
    }
};
$5a9c912afef4aac7$var$_map = new WeakMap();
var $5a9c912afef4aac7$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $5a9c912afef4aac7$var$isUnsupportedLazyRouteObjectKey(key) {
    return $5a9c912afef4aac7$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $5a9c912afef4aac7$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $5a9c912afef4aac7$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $5a9c912afef4aac7$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $5a9c912afef4aac7$var$isIndexRoute(route) {
    return route.index === true;
}
function $5a9c912afef4aac7$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $5a9c912afef4aac7$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $5a9c912afef4aac7$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($5a9c912afef4aac7$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $5a9c912afef4aac7$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $5a9c912afef4aac7$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $5a9c912afef4aac7$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $5a9c912afef4aac7$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $5a9c912afef4aac7$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $5a9c912afef4aac7$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $5a9c912afef4aac7$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $5a9c912afef4aac7$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $5a9c912afef4aac7$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $5a9c912afef4aac7$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $5a9c912afef4aac7$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $5a9c912afef4aac7$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $5a9c912afef4aac7$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $5a9c912afef4aac7$var$flattenAndRankRoutes(routes) {
    let branches = $5a9c912afef4aac7$var$flattenRoutes(routes);
    $5a9c912afef4aac7$var$rankRouteBranches(branches);
    return branches;
}
function $5a9c912afef4aac7$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $5a9c912afef4aac7$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $5a9c912afef4aac7$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $5a9c912afef4aac7$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $5a9c912afef4aac7$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $5a9c912afef4aac7$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta2, i)=>{
                let [matcher, params] = $5a9c912afef4aac7$var$compilePath(meta2.relativePath, meta2.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta2,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $5a9c912afef4aac7$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $5a9c912afef4aac7$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $5a9c912afef4aac7$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $5a9c912afef4aac7$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $5a9c912afef4aac7$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $5a9c912afef4aac7$var$paramRe = /^:[\w-]+$/;
var $5a9c912afef4aac7$var$dynamicSegmentValue = 3;
var $5a9c912afef4aac7$var$indexRouteValue = 2;
var $5a9c912afef4aac7$var$emptySegmentValue = 1;
var $5a9c912afef4aac7$var$staticSegmentValue = 10;
var $5a9c912afef4aac7$var$splatPenalty = -2;
var $5a9c912afef4aac7$var$isSplat = (s)=>s === "*";
function $5a9c912afef4aac7$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($5a9c912afef4aac7$var$isSplat)) initialScore += $5a9c912afef4aac7$var$splatPenalty;
    if (index) initialScore += $5a9c912afef4aac7$var$indexRouteValue;
    return segments.filter((s)=>!$5a9c912afef4aac7$var$isSplat(s)).reduce((score, segment)=>score + ($5a9c912afef4aac7$var$paramRe.test(segment) ? $5a9c912afef4aac7$var$dynamicSegmentValue : segment === "" ? $5a9c912afef4aac7$var$emptySegmentValue : $5a9c912afef4aac7$var$staticSegmentValue), initialScore);
}
function $5a9c912afef4aac7$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $5a9c912afef4aac7$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = // Use precomputed matcher if it exists
        meta.matcher && meta.compiledParams ? $5a9c912afef4aac7$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $5a9c912afef4aac7$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $5a9c912afef4aac7$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $5a9c912afef4aac7$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $5a9c912afef4aac7$var$normalizePathname($5a9c912afef4aac7$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $5a9c912afef4aac7$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $5a9c912afef4aac7$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $5a9c912afef4aac7$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $5a9c912afef4aac7$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $5a9c912afef4aac7$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $5a9c912afef4aac7$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    return $5a9c912afef4aac7$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $5a9c912afef4aac7$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $5a9c912afef4aac7$var$compilePath(path, caseSensitive = false, end = true) {
    $5a9c912afef4aac7$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $5a9c912afef4aac7$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $5a9c912afef4aac7$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $5a9c912afef4aac7$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $5a9c912afef4aac7$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $5a9c912afef4aac7$var$joinPaths([
        basename,
        pathname
    ]);
}
var $5a9c912afef4aac7$var$isAbsoluteUrl = (url)=>$5a9c912afef4aac7$var$ABSOLUTE_URL_REGEX.test(url);
function $5a9c912afef4aac7$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $5a9c912afef4aac7$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $5a9c912afef4aac7$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $5a9c912afef4aac7$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $5a9c912afef4aac7$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $5a9c912afef4aac7$var$normalizeSearch(search),
        hash: $5a9c912afef4aac7$var$normalizeHash(hash)
    };
}
function $5a9c912afef4aac7$var$resolvePathname(relativePath, fromPathname) {
    let segments = $5a9c912afef4aac7$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $5a9c912afef4aac7$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $5a9c912afef4aac7$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $5a9c912afef4aac7$var$getResolveToMatches(matches) {
    let pathMatches = $5a9c912afef4aac7$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $5a9c912afef4aac7$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $5a9c912afef4aac7$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $5a9c912afef4aac7$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $5a9c912afef4aac7$var$getInvalidPathError("?", "pathname", "search", to));
        $5a9c912afef4aac7$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $5a9c912afef4aac7$var$getInvalidPathError("#", "pathname", "hash", to));
        $5a9c912afef4aac7$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $5a9c912afef4aac7$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $5a9c912afef4aac7$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $5a9c912afef4aac7$var$removeDoubleSlashes = (path)=>path.replace(/[\\/]{2,}/g, "/");
var $5a9c912afef4aac7$var$joinPaths = (paths)=>$5a9c912afef4aac7$var$removeDoubleSlashes(paths.join("/"));
var $5a9c912afef4aac7$var$removeTrailingSlash = (path)=>path.replace(/\/+$/, "");
var $5a9c912afef4aac7$var$normalizePathname = (pathname)=>$5a9c912afef4aac7$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $5a9c912afef4aac7$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $5a9c912afef4aac7$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $5a9c912afef4aac7$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $5a9c912afef4aac7$export$4051a07651545597(data2, init) {
    return new $5a9c912afef4aac7$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $5a9c912afef4aac7$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $5a9c912afef4aac7$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $5a9c912afef4aac7$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $5a9c912afef4aac7$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $5a9c912afef4aac7$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $5a9c912afef4aac7$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $5a9c912afef4aac7$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $5a9c912afef4aac7$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $5a9c912afef4aac7$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $5a9c912afef4aac7$var$joinPaths(parts) || "/";
}
var $5a9c912afef4aac7$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $5a9c912afef4aac7$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$5a9c912afef4aac7$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($5a9c912afef4aac7$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = $5a9c912afef4aac7$export$825a82322d91916e.test(to) ? new URL($5a9c912afef4aac7$var$normalizeProtocolRelativeUrl(to, currentUrl.protocol)) : new URL(to);
        let path = $5a9c912afef4aac7$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $5a9c912afef4aac7$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $5a9c912afef4aac7$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $5a9c912afef4aac7$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $5a9c912afef4aac7$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $5a9c912afef4aac7$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$5a9c912afef4aac7$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $5a9c912afef4aac7$var$wrapImpl(aggregated[key], original, (...args)=>$5a9c912afef4aac7$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$5a9c912afef4aac7$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$5a9c912afef4aac7$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $5a9c912afef4aac7$var$wrapImpl(aggregated.middleware, original, (...args)=>$5a9c912afef4aac7$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$5a9c912afef4aac7$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $5a9c912afef4aac7$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$5a9c912afef4aac7$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $5a9c912afef4aac7$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $5a9c912afef4aac7$export$fe53371bee54353d(to) : ".",
                ...$5a9c912afef4aac7$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$5a9c912afef4aac7$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$5a9c912afef4aac7$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $5a9c912afef4aac7$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$5a9c912afef4aac7$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$5a9c912afef4aac7$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $5a9c912afef4aac7$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $5a9c912afef4aac7$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $5a9c912afef4aac7$var$getReadonlyRequest(request),
            context: context != null ? $5a9c912afef4aac7$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $5a9c912afef4aac7$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $5a9c912afef4aac7$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $5a9c912afef4aac7$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $5a9c912afef4aac7$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $5a9c912afef4aac7$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $5a9c912afef4aac7$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $5a9c912afef4aac7$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $5a9c912afef4aac7$var$getReadonlyContext(context)
    };
}
function $5a9c912afef4aac7$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $5a9c912afef4aac7$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $5a9c912afef4aac7$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $5a9c912afef4aac7$var$getReadonlyContext(context) {
    if ($5a9c912afef4aac7$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $5a9c912afef4aac7$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $5a9c912afef4aac7$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $5a9c912afef4aac7$var$objectProtoNames;
}
// lib/router/router.ts
var $5a9c912afef4aac7$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $5a9c912afef4aac7$var$validMutationMethods = new Set($5a9c912afef4aac7$var$validMutationMethodsArr);
var $5a9c912afef4aac7$var$validRequestMethodsArr = [
    "GET",
    ...$5a9c912afef4aac7$var$validMutationMethodsArr
];
var $5a9c912afef4aac7$var$validRequestMethods = new Set($5a9c912afef4aac7$var$validRequestMethodsArr);
var $5a9c912afef4aac7$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $5a9c912afef4aac7$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $5a9c912afef4aac7$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $5a9c912afef4aac7$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $5a9c912afef4aac7$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $5a9c912afef4aac7$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $5a9c912afef4aac7$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $5a9c912afef4aac7$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $5a9c912afef4aac7$var$_routes, $5a9c912afef4aac7$var$_branches, $5a9c912afef4aac7$var$_hmrRoutes, $5a9c912afef4aac7$var$_hmrBranches;
var $5a9c912afef4aac7$var$DataRoutes = class {
    constructor(routes){
        $5a9c912afef4aac7$var$__privateAdd(this, $5a9c912afef4aac7$var$_routes);
        $5a9c912afef4aac7$var$__privateAdd(this, $5a9c912afef4aac7$var$_branches);
        $5a9c912afef4aac7$var$__privateAdd(this, $5a9c912afef4aac7$var$_hmrRoutes);
        $5a9c912afef4aac7$var$__privateAdd(this, $5a9c912afef4aac7$var$_hmrBranches);
        $5a9c912afef4aac7$var$__privateSet(this, $5a9c912afef4aac7$var$_routes, routes);
        $5a9c912afef4aac7$var$__privateSet(this, $5a9c912afef4aac7$var$_branches, $5a9c912afef4aac7$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $5a9c912afef4aac7$var$__privateGet(this, $5a9c912afef4aac7$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $5a9c912afef4aac7$var$__privateGet(this, $5a9c912afef4aac7$var$_hmrRoutes) ?? $5a9c912afef4aac7$var$__privateGet(this, $5a9c912afef4aac7$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $5a9c912afef4aac7$var$__privateGet(this, $5a9c912afef4aac7$var$_hmrBranches) ?? $5a9c912afef4aac7$var$__privateGet(this, $5a9c912afef4aac7$var$_branches);
    }
    get hasHMRRoutes() {
        return $5a9c912afef4aac7$var$__privateGet(this, $5a9c912afef4aac7$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $5a9c912afef4aac7$var$__privateSet(this, $5a9c912afef4aac7$var$_routes, routes);
        $5a9c912afef4aac7$var$__privateSet(this, $5a9c912afef4aac7$var$_branches, $5a9c912afef4aac7$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $5a9c912afef4aac7$var$__privateSet(this, $5a9c912afef4aac7$var$_hmrRoutes, routes);
        $5a9c912afef4aac7$var$__privateSet(this, $5a9c912afef4aac7$var$_hmrBranches, $5a9c912afef4aac7$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($5a9c912afef4aac7$var$__privateGet(this, $5a9c912afef4aac7$var$_hmrRoutes)) {
            $5a9c912afef4aac7$var$__privateSet(this, $5a9c912afef4aac7$var$_routes, $5a9c912afef4aac7$var$__privateGet(this, $5a9c912afef4aac7$var$_hmrRoutes));
            $5a9c912afef4aac7$var$__privateSet(this, $5a9c912afef4aac7$var$_branches, $5a9c912afef4aac7$var$__privateGet(this, $5a9c912afef4aac7$var$_hmrBranches));
            $5a9c912afef4aac7$var$__privateSet(this, $5a9c912afef4aac7$var$_hmrRoutes, void 0);
            $5a9c912afef4aac7$var$__privateSet(this, $5a9c912afef4aac7$var$_hmrBranches, void 0);
        }
    }
};
$5a9c912afef4aac7$var$_routes = new WeakMap();
$5a9c912afef4aac7$var$_branches = new WeakMap();
$5a9c912afef4aac7$var$_hmrRoutes = new WeakMap();
$5a9c912afef4aac7$var$_hmrBranches = new WeakMap();
function $5a9c912afef4aac7$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $5a9c912afef4aac7$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $5a9c912afef4aac7$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$5a9c912afef4aac7$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $5a9c912afef4aac7$var$DataRoutes($5a9c912afef4aac7$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $5a9c912afef4aac7$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $5a9c912afef4aac7$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $5a9c912afef4aac7$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $5a9c912afef4aac7$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$5a9c912afef4aac7$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $5a9c912afef4aac7$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $5a9c912afef4aac7$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $5a9c912afef4aac7$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $5a9c912afef4aac7$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $5a9c912afef4aac7$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$5a9c912afef4aac7$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $5a9c912afef4aac7$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $5a9c912afef4aac7$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $5a9c912afef4aac7$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $5a9c912afef4aac7$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $5a9c912afef4aac7$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $5a9c912afef4aac7$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $5a9c912afef4aac7$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $5a9c912afef4aac7$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $5a9c912afef4aac7$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: "",
                search: "",
                hash: "",
                ...partialPath
            };
        }
        let currentLocation = state.location;
        let nextLocation = $5a9c912afef4aac7$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $5a9c912afef4aac7$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $5a9c912afef4aac7$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $5a9c912afef4aac7$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $5a9c912afef4aac7$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $5a9c912afef4aac7$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $5a9c912afef4aac7$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $5a9c912afef4aac7$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $5a9c912afef4aac7$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $5a9c912afef4aac7$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $5a9c912afef4aac7$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($5a9c912afef4aac7$var$isErrorResult(result) && $5a9c912afef4aac7$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $5a9c912afef4aac7$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $5a9c912afef4aac7$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$5a9c912afef4aac7$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $5a9c912afef4aac7$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $5a9c912afef4aac7$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $5a9c912afef4aac7$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $5a9c912afef4aac7$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $5a9c912afef4aac7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $5a9c912afef4aac7$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($5a9c912afef4aac7$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $5a9c912afef4aac7$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($5a9c912afef4aac7$var$isErrorResult(result)) {
            let boundaryMatch = $5a9c912afef4aac7$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $5a9c912afef4aac7$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $5a9c912afef4aac7$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $5a9c912afef4aac7$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $5a9c912afef4aac7$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $5a9c912afef4aac7$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $5a9c912afef4aac7$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$5a9c912afef4aac7$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $5a9c912afef4aac7$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $5a9c912afef4aac7$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $5a9c912afef4aac7$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$5a9c912afef4aac7$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $5a9c912afef4aac7$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $5a9c912afef4aac7$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $5a9c912afef4aac7$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $5a9c912afef4aac7$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $5a9c912afef4aac7$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $5a9c912afef4aac7$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $5a9c912afef4aac7$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $5a9c912afef4aac7$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $5a9c912afef4aac7$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $5a9c912afef4aac7$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $5a9c912afef4aac7$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $5a9c912afef4aac7$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $5a9c912afef4aac7$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($5a9c912afef4aac7$var$isRedirectResult(actionResult) || $5a9c912afef4aac7$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $5a9c912afef4aac7$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($5a9c912afef4aac7$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $5a9c912afef4aac7$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $5a9c912afef4aac7$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($5a9c912afef4aac7$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $5a9c912afef4aac7$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $5a9c912afef4aac7$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $5a9c912afef4aac7$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $5a9c912afef4aac7$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $5a9c912afef4aac7$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $5a9c912afef4aac7$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $5a9c912afef4aac7$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $5a9c912afef4aac7$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $5a9c912afef4aac7$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $5a9c912afef4aac7$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $5a9c912afef4aac7$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $5a9c912afef4aac7$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $5a9c912afef4aac7$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $5a9c912afef4aac7$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $5a9c912afef4aac7$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $5a9c912afef4aac7$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $5a9c912afef4aac7$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $5a9c912afef4aac7$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $5a9c912afef4aac7$var$getDoneFetcher(void 0));
            return;
        }
        if ($5a9c912afef4aac7$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $5a9c912afef4aac7$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($5a9c912afef4aac7$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $5a9c912afef4aac7$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $5a9c912afef4aac7$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $5a9c912afef4aac7$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $5a9c912afef4aac7$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($5a9c912afef4aac7$var$isAbsoluteUrl(location)) {
                const url = $5a9c912afef4aac7$var$createBrowserURLImpl(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $5a9c912afef4aac7$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $5a9c912afef4aac7$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($5a9c912afef4aac7$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $5a9c912afef4aac7$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $5a9c912afef4aac7$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $5a9c912afef4aac7$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$5a9c912afef4aac7$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($5a9c912afef4aac7$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $5a9c912afef4aac7$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $5a9c912afef4aac7$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $5a9c912afef4aac7$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $5a9c912afef4aac7$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $5a9c912afef4aac7$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $5a9c912afef4aac7$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $5a9c912afef4aac7$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $5a9c912afef4aac7$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $5a9c912afef4aac7$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $5a9c912afef4aac7$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $5a9c912afef4aac7$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $5a9c912afef4aac7$export$386d57f03f0b2883;
        $5a9c912afef4aac7$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $5a9c912afef4aac7$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $5a9c912afef4aac7$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $5a9c912afef4aac7$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $5a9c912afef4aac7$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$5a9c912afef4aac7$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $5a9c912afef4aac7$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $5a9c912afef4aac7$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $5a9c912afef4aac7$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $5a9c912afef4aac7$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $5a9c912afef4aac7$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $5a9c912afef4aac7$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($5a9c912afef4aac7$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $5a9c912afef4aac7$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $5a9c912afef4aac7$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $5a9c912afef4aac7$export$3336b097a6fbc59a(routes, opts) {
    $5a9c912afef4aac7$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $5a9c912afef4aac7$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$5a9c912afef4aac7$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $5a9c912afef4aac7$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $5a9c912afef4aac7$var$flattenAndRankRoutes(dataRoutes);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $5a9c912afef4aac7$var$defaultNormalizePath;
        let method = request.method;
        let location = $5a9c912afef4aac7$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $5a9c912afef4aac7$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $5a9c912afef4aac7$export$b8d3e69d4b3eff04();
        if (!$5a9c912afef4aac7$var$isValidMethod(method) && method !== "HEAD") {
            let error = $5a9c912afef4aac7$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $5a9c912afef4aac7$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $5a9c912afef4aac7$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $5a9c912afef4aac7$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $5a9c912afef4aac7$export$f5708dca728d7177(requestContext instanceof $5a9c912afef4aac7$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $5a9c912afef4aac7$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $5a9c912afef4aac7$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $5a9c912afef4aac7$var$createDataFunctionUrl(request, location),
                    pattern: $5a9c912afef4aac7$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($5a9c912afef4aac7$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($5a9c912afef4aac7$export$6e80290866a84dd4(error)) return error;
                    if ($5a9c912afef4aac7$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $5a9c912afef4aac7$export$f2680fa305b734ca(error.status, error.statusText, await $5a9c912afef4aac7$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($5a9c912afef4aac7$export$e0163cfdf7bc9cfa(error)) error = $5a9c912afef4aac7$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $5a9c912afef4aac7$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $5a9c912afef4aac7$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $5a9c912afef4aac7$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $5a9c912afef4aac7$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $5a9c912afef4aac7$export$f5708dca728d7177($5a9c912afef4aac7$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($5a9c912afef4aac7$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($5a9c912afef4aac7$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $5a9c912afef4aac7$var$defaultNormalizePath;
        let method = request.method;
        let location = $5a9c912afef4aac7$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $5a9c912afef4aac7$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $5a9c912afef4aac7$export$b8d3e69d4b3eff04();
        if (!$5a9c912afef4aac7$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $5a9c912afef4aac7$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $5a9c912afef4aac7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $5a9c912afef4aac7$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $5a9c912afef4aac7$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $5a9c912afef4aac7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $5a9c912afef4aac7$export$f5708dca728d7177(requestContext instanceof $5a9c912afef4aac7$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $5a9c912afef4aac7$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $5a9c912afef4aac7$var$runServerMiddlewarePipeline({
                request: request,
                url: $5a9c912afef4aac7$var$createDataFunctionUrl(request, location),
                pattern: $5a9c912afef4aac7$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $5a9c912afef4aac7$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($5a9c912afef4aac7$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($5a9c912afef4aac7$var$dataWithResponseInitToResponse(error));
                if ($5a9c912afef4aac7$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($5a9c912afef4aac7$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $5a9c912afef4aac7$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($5a9c912afef4aac7$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $5a9c912afef4aac7$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $5a9c912afef4aac7$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($5a9c912afef4aac7$var$isDataStrategyResult(e) && $5a9c912afef4aac7$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($5a9c912afef4aac7$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $5a9c912afef4aac7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $5a9c912afef4aac7$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $5a9c912afef4aac7$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($5a9c912afef4aac7$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($5a9c912afef4aac7$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($5a9c912afef4aac7$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $5a9c912afef4aac7$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $5a9c912afef4aac7$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($5a9c912afef4aac7$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $5a9c912afef4aac7$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $5a9c912afef4aac7$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $5a9c912afef4aac7$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $5a9c912afef4aac7$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $5a9c912afef4aac7$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $5a9c912afef4aac7$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $5a9c912afef4aac7$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $5a9c912afef4aac7$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $5a9c912afef4aac7$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $5a9c912afef4aac7$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $5a9c912afef4aac7$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $5a9c912afef4aac7$var$callDataStrategyImpl(dataStrategy || $5a9c912afef4aac7$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($5a9c912afef4aac7$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $5a9c912afef4aac7$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($5a9c912afef4aac7$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($5a9c912afef4aac7$export$e0163cfdf7bc9cfa(result.result)) throw $5a9c912afef4aac7$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $5a9c912afef4aac7$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $5a9c912afef4aac7$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $5a9c912afef4aac7$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $5a9c912afef4aac7$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $5a9c912afef4aac7$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $5a9c912afef4aac7$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $5a9c912afef4aac7$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $5a9c912afef4aac7$var$resolveTo(to ? to : ".", $5a9c912afef4aac7$var$getResolveToMatches(contextualMatches), $5a9c912afef4aac7$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $5a9c912afef4aac7$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $5a9c912afef4aac7$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $5a9c912afef4aac7$export$fe53371bee54353d(path);
}
function $5a9c912afef4aac7$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$5a9c912afef4aac7$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$5a9c912afef4aac7$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $5a9c912afef4aac7$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $5a9c912afef4aac7$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $5a9c912afef4aac7$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$5a9c912afef4aac7$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$5a9c912afef4aac7$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $5a9c912afef4aac7$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $5a9c912afef4aac7$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $5a9c912afef4aac7$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $5a9c912afef4aac7$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $5a9c912afef4aac7$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($5a9c912afef4aac7$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $5a9c912afef4aac7$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $5a9c912afef4aac7$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $5a9c912afef4aac7$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $5a9c912afef4aac7$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $5a9c912afef4aac7$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $5a9c912afef4aac7$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $5a9c912afef4aac7$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$5a9c912afef4aac7$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $5a9c912afef4aac7$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($5a9c912afef4aac7$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $5a9c912afef4aac7$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($5a9c912afef4aac7$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $5a9c912afef4aac7$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $5a9c912afef4aac7$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $5a9c912afef4aac7$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $5a9c912afef4aac7$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $5a9c912afef4aac7$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $5a9c912afef4aac7$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $5a9c912afef4aac7$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($5a9c912afef4aac7$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $5a9c912afef4aac7$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $5a9c912afef4aac7$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $5a9c912afef4aac7$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$5a9c912afef4aac7$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $5a9c912afef4aac7$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $5a9c912afef4aac7$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $5a9c912afef4aac7$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $5a9c912afef4aac7$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $5a9c912afef4aac7$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$5a9c912afef4aac7$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $5a9c912afef4aac7$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $5a9c912afef4aac7$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $5a9c912afef4aac7$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$5a9c912afef4aac7$var$isSameRoute(aChild, bChild))) ?? false;
}
var $5a9c912afef4aac7$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $5a9c912afef4aac7$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $5a9c912afef4aac7$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $5a9c912afef4aac7$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $5a9c912afef4aac7$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $5a9c912afef4aac7$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $5a9c912afef4aac7$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $5a9c912afef4aac7$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $5a9c912afef4aac7$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $5a9c912afef4aac7$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $5a9c912afef4aac7$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $5a9c912afef4aac7$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $5a9c912afef4aac7$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $5a9c912afef4aac7$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $5a9c912afef4aac7$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $5a9c912afef4aac7$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $5a9c912afef4aac7$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $5a9c912afef4aac7$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $5a9c912afef4aac7$var$isNonNullable(value) {
    return value !== void 0;
}
function $5a9c912afef4aac7$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $5a9c912afef4aac7$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($5a9c912afef4aac7$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $5a9c912afef4aac7$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $5a9c912afef4aac7$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $5a9c912afef4aac7$var$defaultDataStrategy(args);
    return $5a9c912afef4aac7$var$runClientMiddlewarePipeline(args, ()=>$5a9c912afef4aac7$var$defaultDataStrategy(args));
}
function $5a9c912afef4aac7$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $5a9c912afef4aac7$var$runMiddlewarePipeline(args, handler, processResult, $5a9c912afef4aac7$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $5a9c912afef4aac7$export$e0163cfdf7bc9cfa(result) ? $5a9c912afef4aac7$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $5a9c912afef4aac7$var$runClientMiddlewarePipeline(args, handler) {
    return $5a9c912afef4aac7$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($5a9c912afef4aac7$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $5a9c912afef4aac7$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $5a9c912afef4aac7$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $5a9c912afef4aac7$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $5a9c912afef4aac7$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $5a9c912afef4aac7$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $5a9c912afef4aac7$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $5a9c912afef4aac7$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $5a9c912afef4aac7$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $5a9c912afef4aac7$var$loadLazyRoute(match.route, $5a9c912afef4aac7$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $5a9c912afef4aac7$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $5a9c912afef4aac7$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $5a9c912afef4aac7$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $5a9c912afef4aac7$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $5a9c912afef4aac7$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$5a9c912afef4aac7$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($5a9c912afef4aac7$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $5a9c912afef4aac7$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $5a9c912afef4aac7$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $5a9c912afef4aac7$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $5a9c912afef4aac7$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $5a9c912afef4aac7$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $5a9c912afef4aac7$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $5a9c912afef4aac7$var$createDataFunctionUrl(request, path),
        pattern: $5a9c912afef4aac7$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $5a9c912afef4aac7$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $5a9c912afef4aac7$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $5a9c912afef4aac7$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $5a9c912afef4aac7$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $5a9c912afef4aac7$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $5a9c912afef4aac7$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $5a9c912afef4aac7$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $5a9c912afef4aac7$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($5a9c912afef4aac7$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $5a9c912afef4aac7$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $5a9c912afef4aac7$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($5a9c912afef4aac7$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $5a9c912afef4aac7$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $5a9c912afef4aac7$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $5a9c912afef4aac7$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($5a9c912afef4aac7$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $5a9c912afef4aac7$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $5a9c912afef4aac7$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$5a9c912afef4aac7$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $5a9c912afef4aac7$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $5a9c912afef4aac7$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $5a9c912afef4aac7$export$961a3ef7a4da3a39(location) {
    try {
        return $5a9c912afef4aac7$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $5a9c912afef4aac7$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($5a9c912afef4aac7$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = $5a9c912afef4aac7$export$825a82322d91916e.test(normalizedLocation) ? new URL($5a9c912afef4aac7$var$normalizeProtocolRelativeUrl(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($5a9c912afef4aac7$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = $5a9c912afef4aac7$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $5a9c912afef4aac7$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($5a9c912afef4aac7$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $5a9c912afef4aac7$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($5a9c912afef4aac7$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $5a9c912afef4aac7$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $5a9c912afef4aac7$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $5a9c912afef4aac7$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $5a9c912afef4aac7$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $5a9c912afef4aac7$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $5a9c912afef4aac7$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $5a9c912afef4aac7$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $5a9c912afef4aac7$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $5a9c912afef4aac7$export$f5708dca728d7177(!$5a9c912afef4aac7$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($5a9c912afef4aac7$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $5a9c912afef4aac7$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $5a9c912afef4aac7$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $5a9c912afef4aac7$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $5a9c912afef4aac7$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $5a9c912afef4aac7$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $5a9c912afef4aac7$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($5a9c912afef4aac7$var$isErrorResult(result)) {
            let boundaryMatch = $5a9c912afef4aac7$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($5a9c912afef4aac7$var$isRedirectResult(result)) $5a9c912afef4aac7$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $5a9c912afef4aac7$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $5a9c912afef4aac7$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $5a9c912afef4aac7$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $5a9c912afef4aac7$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $5a9c912afef4aac7$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $5a9c912afef4aac7$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $5a9c912afef4aac7$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $5a9c912afef4aac7$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $5a9c912afef4aac7$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $5a9c912afef4aac7$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($5a9c912afef4aac7$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $5a9c912afef4aac7$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $5a9c912afef4aac7$export$8ccf933b0513f8d0(path) : path;
    return $5a9c912afef4aac7$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $5a9c912afef4aac7$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $5a9c912afef4aac7$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $5a9c912afef4aac7$var$dataWithResponseInitToErrorResponse(data2) {
    return new $5a9c912afef4aac7$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $5a9c912afef4aac7$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $5a9c912afef4aac7$var$isDataStrategyResult(value));
}
function $5a9c912afef4aac7$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $5a9c912afef4aac7$var$isRedirectDataStrategyResult(result) {
    return $5a9c912afef4aac7$export$3f1eb41d9a6a6a27(result.result) && $5a9c912afef4aac7$var$redirectStatusCodes.has(result.result.status);
}
function $5a9c912afef4aac7$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $5a9c912afef4aac7$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $5a9c912afef4aac7$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $5a9c912afef4aac7$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $5a9c912afef4aac7$export$794b2760043cf8cd(statusCode) {
    return $5a9c912afef4aac7$var$redirectStatusCodes.has(statusCode);
}
function $5a9c912afef4aac7$export$6e80290866a84dd4(result) {
    return $5a9c912afef4aac7$export$3f1eb41d9a6a6a27(result) && $5a9c912afef4aac7$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $5a9c912afef4aac7$var$isValidMethod(method) {
    return $5a9c912afef4aac7$var$validRequestMethods.has(method.toUpperCase());
}
function $5a9c912afef4aac7$export$cbae47800eb95bc3(method) {
    return $5a9c912afef4aac7$var$validMutationMethods.has(method.toUpperCase());
}
function $5a9c912afef4aac7$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $5a9c912afef4aac7$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $5a9c912afef4aac7$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $5a9c912afef4aac7$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $5a9c912afef4aac7$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $5a9c912afef4aac7$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $5a9c912afef4aac7$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $5a9c912afef4aac7$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $5a9c912afef4aac7$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $5a9c912afef4aac7$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $5a9c912afef4aac7$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $5a9c912afef4aac7$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($5a9c912afef4aac7$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $5a9c912afef4aac7$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($5a9c912afef4aac7$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $5a9c912afef4aac7$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $5a9c912afef4aac7$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $5a9c912afef4aac7$export$2eeee58951ff3c1c = $Fo7oF.createContext(null);
$5a9c912afef4aac7$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $5a9c912afef4aac7$export$315e3ffb01f217 = $Fo7oF.createContext(null);
$5a9c912afef4aac7$export$315e3ffb01f217.displayName = "DataRouterState";
var $5a9c912afef4aac7$export$717f757c655223f1 = $Fo7oF.createContext(false);
function $5a9c912afef4aac7$var$useIsRSCRouterContext() {
    return $Fo7oF.useContext($5a9c912afef4aac7$export$717f757c655223f1);
}
var $5a9c912afef4aac7$export$3681f408decb40d1 = $Fo7oF.createContext({
    isTransitioning: false
});
$5a9c912afef4aac7$export$3681f408decb40d1.displayName = "ViewTransition";
var $5a9c912afef4aac7$export$cb3f1df1bef00a39 = $Fo7oF.createContext(/* @__PURE__ */ new Map());
$5a9c912afef4aac7$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $5a9c912afef4aac7$var$AwaitContext = $Fo7oF.createContext(null);
$5a9c912afef4aac7$var$AwaitContext.displayName = "Await";
var $5a9c912afef4aac7$export$2666c20e15407622 = (props)=>$Fo7oF.createElement($5a9c912afef4aac7$var$AwaitContext.Provider, props);
var $5a9c912afef4aac7$export$3044ab7fdabeaee6 = $Fo7oF.createContext(null);
$5a9c912afef4aac7$export$3044ab7fdabeaee6.displayName = "Navigation";
var $5a9c912afef4aac7$export$e6a44b110a0c44d3 = $Fo7oF.createContext(null);
$5a9c912afef4aac7$export$e6a44b110a0c44d3.displayName = "Location";
var $5a9c912afef4aac7$export$aac280ed165a4397 = $Fo7oF.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$5a9c912afef4aac7$export$aac280ed165a4397.displayName = "Route";
var $5a9c912afef4aac7$var$RouteErrorContext = $Fo7oF.createContext(null);
$5a9c912afef4aac7$var$RouteErrorContext.displayName = "RouteError";
var $5a9c912afef4aac7$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $5a9c912afef4aac7$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $5a9c912afef4aac7$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $5a9c912afef4aac7$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $5a9c912afef4aac7$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$5a9c912afef4aac7$var$ERROR_DIGEST_BASE}:${$5a9c912afef4aac7$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $5a9c912afef4aac7$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$5a9c912afef4aac7$var$ERROR_DIGEST_BASE}:${$5a9c912afef4aac7$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $5a9c912afef4aac7$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $5a9c912afef4aac7$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $5a9c912afef4aac7$export$f5708dca728d7177($5a9c912afef4aac7$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $Fo7oF.useContext($5a9c912afef4aac7$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $5a9c912afef4aac7$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $5a9c912afef4aac7$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $5a9c912afef4aac7$export$9c954a9d03d32f4a() {
    return $Fo7oF.useContext($5a9c912afef4aac7$export$e6a44b110a0c44d3) != null;
}
function $5a9c912afef4aac7$export$45d76561a5302f2b() {
    $5a9c912afef4aac7$export$f5708dca728d7177($5a9c912afef4aac7$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $Fo7oF.useContext($5a9c912afef4aac7$export$e6a44b110a0c44d3).location;
}
function $5a9c912afef4aac7$export$1b3f31771c5d07c() {
    return $Fo7oF.useContext($5a9c912afef4aac7$export$e6a44b110a0c44d3).navigationType;
}
function $5a9c912afef4aac7$export$6c330e8992e8a295(pattern) {
    $5a9c912afef4aac7$export$f5708dca728d7177($5a9c912afef4aac7$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $5a9c912afef4aac7$export$45d76561a5302f2b();
    return $Fo7oF.useMemo(()=>$5a9c912afef4aac7$export$81336c211d5ff295(pattern, $5a9c912afef4aac7$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $5a9c912afef4aac7$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $5a9c912afef4aac7$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $Fo7oF.useContext($5a9c912afef4aac7$export$3044ab7fdabeaee6).static;
    if (!isStatic) $Fo7oF.useLayoutEffect(cb);
}
function $5a9c912afef4aac7$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $Fo7oF.useContext($5a9c912afef4aac7$export$aac280ed165a4397);
    return isDataRoute ? $5a9c912afef4aac7$var$useNavigateStable() : $5a9c912afef4aac7$var$useNavigateUnstable();
}
function $5a9c912afef4aac7$var$useNavigateUnstable() {
    $5a9c912afef4aac7$export$f5708dca728d7177($5a9c912afef4aac7$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $Fo7oF.useContext($5a9c912afef4aac7$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $Fo7oF.useContext($5a9c912afef4aac7$export$3044ab7fdabeaee6);
    let { matches: matches } = $Fo7oF.useContext($5a9c912afef4aac7$export$aac280ed165a4397);
    let { pathname: locationPathname } = $5a9c912afef4aac7$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($5a9c912afef4aac7$var$getResolveToMatches(matches));
    let activeRef = $Fo7oF.useRef(false);
    $5a9c912afef4aac7$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $Fo7oF.useCallback((to, options = {})=>{
        $5a9c912afef4aac7$var$warning(activeRef.current, $5a9c912afef4aac7$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $5a9c912afef4aac7$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $5a9c912afef4aac7$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $5a9c912afef4aac7$var$OutletContext = $Fo7oF.createContext(null);
function $5a9c912afef4aac7$export$4138103a3ae699cc() {
    return $Fo7oF.useContext($5a9c912afef4aac7$var$OutletContext);
}
function $5a9c912afef4aac7$export$a3be3530d8e40d0b(context) {
    let outlet = $Fo7oF.useContext($5a9c912afef4aac7$export$aac280ed165a4397).outlet;
    return $Fo7oF.useMemo(()=>outlet && /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $5a9c912afef4aac7$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $Fo7oF.useContext($5a9c912afef4aac7$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $5a9c912afef4aac7$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $Fo7oF.useContext($5a9c912afef4aac7$export$aac280ed165a4397);
    let { pathname: locationPathname } = $5a9c912afef4aac7$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($5a9c912afef4aac7$var$getResolveToMatches(matches));
    return $Fo7oF.useMemo(()=>$5a9c912afef4aac7$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $5a9c912afef4aac7$export$5d3fca4a98652595(routes, locationArg) {
    return $5a9c912afef4aac7$var$useRoutesImpl(routes, locationArg);
}
function $5a9c912afef4aac7$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $5a9c912afef4aac7$export$f5708dca728d7177($5a9c912afef4aac7$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $Fo7oF.useContext($5a9c912afef4aac7$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $Fo7oF.useContext($5a9c912afef4aac7$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($5a9c912afef4aac7$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $5a9c912afef4aac7$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $5a9c912afef4aac7$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $5a9c912afef4aac7$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $5a9c912afef4aac7$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $5a9c912afef4aac7$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($5a9c912afef4aac7$export$945fecf35a8ef089) {
        $5a9c912afef4aac7$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $5a9c912afef4aac7$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $5a9c912afef4aac7$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $5a9c912afef4aac7$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $5a9c912afef4aac7$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $5a9c912afef4aac7$var$DefaultErrorComponent() {
    let error = $5a9c912afef4aac7$export$ed527bf60f6e05f2();
    let message = $5a9c912afef4aac7$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($5a9c912afef4aac7$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $Fo7oF.createElement($Fo7oF.Fragment, null, /* @__PURE__ */ $Fo7oF.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $Fo7oF.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $Fo7oF.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $Fo7oF.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $Fo7oF.createElement($Fo7oF.Fragment, null, /* @__PURE__ */ $Fo7oF.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $Fo7oF.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $Fo7oF.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $5a9c912afef4aac7$var$defaultErrorElement = /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$var$DefaultErrorComponent, null);
var $5a9c912afef4aac7$var$RenderErrorBoundary = class extends $Fo7oF.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $5a9c912afef4aac7$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$5a9c912afef4aac7$var$RenderErrorBoundary.contextType = $5a9c912afef4aac7$export$717f757c655223f1;
var $5a9c912afef4aac7$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $5a9c912afef4aac7$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $Fo7oF.useContext($5a9c912afef4aac7$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $5a9c912afef4aac7$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $5a9c912afef4aac7$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $5a9c912afef4aac7$var$parseToInfo(redirect2.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            if ($5a9c912afef4aac7$export$961a3ef7a4da3a39(target)) throw new Error("Invalid redirect location");
            if ($5a9c912afef4aac7$var$isBrowser && !$5a9c912afef4aac7$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $5a9c912afef4aac7$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $Fo7oF.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $5a9c912afef4aac7$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $Fo7oF.useContext($5a9c912afef4aac7$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $5a9c912afef4aac7$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $5a9c912afef4aac7$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $5a9c912afef4aac7$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $5a9c912afef4aac7$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $5a9c912afef4aac7$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $Fo7oF.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $5a9c912afef4aac7$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $5a9c912afef4aac7$var$useDataRouterContext(hookName) {
    let ctx = $Fo7oF.useContext($5a9c912afef4aac7$export$2eeee58951ff3c1c);
    $5a9c912afef4aac7$export$f5708dca728d7177(ctx, $5a9c912afef4aac7$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $5a9c912afef4aac7$var$useDataRouterState(hookName) {
    let state = $Fo7oF.useContext($5a9c912afef4aac7$export$315e3ffb01f217);
    $5a9c912afef4aac7$export$f5708dca728d7177(state, $5a9c912afef4aac7$var$getDataRouterConsoleError(hookName));
    return state;
}
function $5a9c912afef4aac7$var$useRouteContext(hookName) {
    let route = $Fo7oF.useContext($5a9c912afef4aac7$export$aac280ed165a4397);
    $5a9c912afef4aac7$export$f5708dca728d7177(route, $5a9c912afef4aac7$var$getDataRouterConsoleError(hookName));
    return route;
}
function $5a9c912afef4aac7$var$useCurrentRouteId(hookName) {
    let route = $5a9c912afef4aac7$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $5a9c912afef4aac7$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $5a9c912afef4aac7$var$useRouteId() {
    return $5a9c912afef4aac7$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $5a9c912afef4aac7$export$d0fd4b7106de2769() {
    let state = $5a9c912afef4aac7$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $Fo7oF.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $5a9c912afef4aac7$export$600dc272ed516c15() {
    let dataRouterContext = $5a9c912afef4aac7$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $5a9c912afef4aac7$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $Fo7oF.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $Fo7oF.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $5a9c912afef4aac7$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $5a9c912afef4aac7$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $Fo7oF.useMemo(()=>matches.map((m)=>$5a9c912afef4aac7$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $5a9c912afef4aac7$export$1448a5050d252c4d() {
    let state = $5a9c912afef4aac7$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $5a9c912afef4aac7$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $5a9c912afef4aac7$export$fd5d37484eab868d(routeId) {
    let state = $5a9c912afef4aac7$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $5a9c912afef4aac7$export$fdc00f3f26066d5e() {
    let state = $5a9c912afef4aac7$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $5a9c912afef4aac7$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $5a9c912afef4aac7$export$ed527bf60f6e05f2() {
    let error = $Fo7oF.useContext($5a9c912afef4aac7$var$RouteErrorContext);
    let state = $5a9c912afef4aac7$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $5a9c912afef4aac7$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $5a9c912afef4aac7$export$78a72ddb39bdd145() {
    let value = $Fo7oF.useContext($5a9c912afef4aac7$var$AwaitContext);
    return value?._data;
}
function $5a9c912afef4aac7$export$17f53340677d5831() {
    let value = $Fo7oF.useContext($5a9c912afef4aac7$var$AwaitContext);
    return value?._error;
}
var $5a9c912afef4aac7$var$blockerId = 0;
function $5a9c912afef4aac7$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $5a9c912afef4aac7$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $5a9c912afef4aac7$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $Fo7oF.useState("");
    let blockerFunction = $Fo7oF.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $5a9c912afef4aac7$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $5a9c912afef4aac7$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $Fo7oF.useEffect(()=>{
        let key = String(++$5a9c912afef4aac7$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $Fo7oF.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $5a9c912afef4aac7$export$386d57f03f0b2883;
}
function $5a9c912afef4aac7$var$useNavigateStable() {
    let { router: router } = $5a9c912afef4aac7$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $5a9c912afef4aac7$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $Fo7oF.useRef(false);
    $5a9c912afef4aac7$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $Fo7oF.useCallback(async (to, options = {})=>{
        $5a9c912afef4aac7$var$warning(activeRef.current, $5a9c912afef4aac7$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $5a9c912afef4aac7$var$alreadyWarned = {};
function $5a9c912afef4aac7$var$warningOnce(key, cond, message) {
    if (!cond && !$5a9c912afef4aac7$var$alreadyWarned[key]) {
        $5a9c912afef4aac7$var$alreadyWarned[key] = true;
        $5a9c912afef4aac7$var$warning(false, message);
    }
}
function $5a9c912afef4aac7$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $5a9c912afef4aac7$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $5a9c912afef4aac7$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $5a9c912afef4aac7$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $5a9c912afef4aac7$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $5a9c912afef4aac7$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $Fo7oF.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$5a9c912afef4aac7$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $Fo7oF.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$5a9c912afef4aac7$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $Fo7oF.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $5a9c912afef4aac7$var$alreadyWarned2 = {};
function $5a9c912afef4aac7$export$5b28268982f175ba(condition, message) {
    if (!condition && !$5a9c912afef4aac7$var$alreadyWarned2[message]) {
        $5a9c912afef4aac7$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $5a9c912afef4aac7$var$USE_OPTIMISTIC = "useOptimistic";
var $5a9c912afef4aac7$var$useOptimisticImpl = $Fo7oF[$5a9c912afef4aac7$var$USE_OPTIMISTIC];
var $5a9c912afef4aac7$var$stableUseOptimisticSetter = ()=>void 0;
function $5a9c912afef4aac7$var$useOptimisticSafe(val) {
    if ($5a9c912afef4aac7$var$useOptimisticImpl) return $5a9c912afef4aac7$var$useOptimisticImpl(val);
    else return [
        val,
        $5a9c912afef4aac7$var$stableUseOptimisticSetter
    ];
}
function $5a9c912afef4aac7$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($5a9c912afef4aac7$export$945fecf35a8ef089) {
            if (route.element) $5a9c912afef4aac7$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $Fo7oF.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($5a9c912afef4aac7$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $5a9c912afef4aac7$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $Fo7oF.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($5a9c912afef4aac7$export$945fecf35a8ef089) {
            if (route.errorElement) $5a9c912afef4aac7$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $Fo7oF.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $5a9c912afef4aac7$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $5a9c912afef4aac7$export$f30f7e456d254e83(routes, opts) {
    return $5a9c912afef4aac7$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $5a9c912afef4aac7$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $5a9c912afef4aac7$export$e2fd2c03906469db,
        mapRouteProperties: $5a9c912afef4aac7$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $5a9c912afef4aac7$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $5a9c912afef4aac7$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $5a9c912afef4aac7$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $Fo7oF.useState(router.state);
    let [state, setOptimisticState] = $5a9c912afef4aac7$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $Fo7oF.useState();
    let [vtContext, setVtContext] = $Fo7oF.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $Fo7oF.useState();
    let [transition, setTransition] = $Fo7oF.useState();
    let [interruption, setInterruption] = $Fo7oF.useState();
    let fetcherData = $Fo7oF.useRef(/* @__PURE__ */ new Map());
    let setState = $Fo7oF.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $5a9c912afef4aac7$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $5a9c912afef4aac7$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $5a9c912afef4aac7$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $Fo7oF.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$5a9c912afef4aac7$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $Fo7oF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $Fo7oF.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $5a9c912afef4aac7$var$Deferred());
    }, [
        vtContext
    ]);
    $Fo7oF.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $Fo7oF.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$5a9c912afef4aac7$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $Fo7oF.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $Fo7oF.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $Fo7oF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $Fo7oF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $Fo7oF.createElement($Fo7oF.Fragment, null, /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $5a9c912afef4aac7$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $5a9c912afef4aac7$var$MemoizedDataRoutes = $Fo7oF.memo($5a9c912afef4aac7$var$DataRoutes2);
function $5a9c912afef4aac7$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $5a9c912afef4aac7$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $5a9c912afef4aac7$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $Fo7oF.useRef();
    if (historyRef.current == null) historyRef.current = $5a9c912afef4aac7$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $Fo7oF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $Fo7oF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $Fo7oF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $Fo7oF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $5a9c912afef4aac7$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $5a9c912afef4aac7$export$f5708dca728d7177($5a9c912afef4aac7$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $Fo7oF.useContext($5a9c912afef4aac7$export$3044ab7fdabeaee6);
    $5a9c912afef4aac7$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $Fo7oF.useContext($5a9c912afef4aac7$export$aac280ed165a4397);
    let { pathname: locationPathname } = $5a9c912afef4aac7$export$45d76561a5302f2b();
    let navigate = $5a9c912afef4aac7$export$9770f232ac06a008();
    let path = $5a9c912afef4aac7$var$resolveTo(to, $5a9c912afef4aac7$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $Fo7oF.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $5a9c912afef4aac7$export$910ae8079b2c2852(props) {
    return $5a9c912afef4aac7$export$a3be3530d8e40d0b(props.context);
}
function $5a9c912afef4aac7$export$e7b0ac011bb776c6(props) {
    $5a9c912afef4aac7$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $5a9c912afef4aac7$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $5a9c912afef4aac7$export$f5708dca728d7177(!$5a9c912afef4aac7$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $Fo7oF.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $5a9c912afef4aac7$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $Fo7oF.useMemo(()=>{
        let trailingPathname = $5a9c912afef4aac7$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $5a9c912afef4aac7$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $5a9c912afef4aac7$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $5a9c912afef4aac7$export$5d3fca4a98652595($5a9c912afef4aac7$export$16da398f5434bdec(children), location);
}
function $5a9c912afef4aac7$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $Fo7oF.useContext($5a9c912afef4aac7$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $Fo7oF.useContext($5a9c912afef4aac7$export$315e3ffb01f217);
    let onError = $Fo7oF.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $5a9c912afef4aac7$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$var$ResolveAwait, null, children));
}
var $5a9c912afef4aac7$var$AwaitErrorBoundary = class extends $Fo7oF.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $5a9c912afef4aac7$var$ResolveAwait({ children: children }) {
    let data2 = $5a9c912afef4aac7$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $Fo7oF.createElement($Fo7oF.Fragment, null, toRender);
}
function $5a9c912afef4aac7$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $Fo7oF.Children.forEach(children, (element, index)=>{
        if (!$Fo7oF.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $Fo7oF.Fragment) {
            routes.push.apply(routes, $5a9c912afef4aac7$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $5a9c912afef4aac7$export$f5708dca728d7177(element.type === $5a9c912afef4aac7$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $5a9c912afef4aac7$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $5a9c912afef4aac7$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $5a9c912afef4aac7$export$9b5b6d122dea0c88 = $5a9c912afef4aac7$export$16da398f5434bdec;
function $5a9c912afef4aac7$export$daf73786167a7f72(matches) {
    return $5a9c912afef4aac7$var$_renderMatches(matches);
}
function $5a9c912afef4aac7$var$useRouteComponentProps() {
    return {
        params: $5a9c912afef4aac7$export$99eaa27ddbbb95ef(),
        loaderData: $5a9c912afef4aac7$export$1448a5050d252c4d(),
        actionData: $5a9c912afef4aac7$export$fdc00f3f26066d5e(),
        matches: $5a9c912afef4aac7$export$2378eb7f5ff86053()
    };
}
function $5a9c912afef4aac7$export$6c4f3826290c37af({ children: children }) {
    const props = $5a9c912afef4aac7$var$useRouteComponentProps();
    return $Fo7oF.cloneElement(children, props);
}
function $5a9c912afef4aac7$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $5a9c912afef4aac7$var$useRouteComponentProps();
        return $Fo7oF.createElement(Component4, props);
    };
}
function $5a9c912afef4aac7$var$useHydrateFallbackProps() {
    return {
        params: $5a9c912afef4aac7$export$99eaa27ddbbb95ef(),
        loaderData: $5a9c912afef4aac7$export$1448a5050d252c4d(),
        actionData: $5a9c912afef4aac7$export$fdc00f3f26066d5e()
    };
}
function $5a9c912afef4aac7$export$f8cff34f39c1932a({ children: children }) {
    const props = $5a9c912afef4aac7$var$useHydrateFallbackProps();
    return $Fo7oF.cloneElement(children, props);
}
function $5a9c912afef4aac7$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $5a9c912afef4aac7$var$useHydrateFallbackProps();
        return $Fo7oF.createElement(HydrateFallback, props);
    };
}
function $5a9c912afef4aac7$var$useErrorBoundaryProps() {
    return {
        params: $5a9c912afef4aac7$export$99eaa27ddbbb95ef(),
        loaderData: $5a9c912afef4aac7$export$1448a5050d252c4d(),
        actionData: $5a9c912afef4aac7$export$fdc00f3f26066d5e(),
        error: $5a9c912afef4aac7$export$ed527bf60f6e05f2()
    };
}
function $5a9c912afef4aac7$export$e5afde5c4b6d747b({ children: children }) {
    const props = $5a9c912afef4aac7$var$useErrorBoundaryProps();
    return $Fo7oF.cloneElement(children, props);
}
function $5a9c912afef4aac7$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $5a9c912afef4aac7$var$useErrorBoundaryProps();
        return $Fo7oF.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $5a9c912afef4aac7$var$defaultMethod = "get";
var $5a9c912afef4aac7$var$defaultEncType = "application/x-www-form-urlencoded";
function $5a9c912afef4aac7$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $5a9c912afef4aac7$var$isButtonElement(object) {
    return $5a9c912afef4aac7$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $5a9c912afef4aac7$var$isFormElement(object) {
    return $5a9c912afef4aac7$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $5a9c912afef4aac7$var$isInputElement(object) {
    return $5a9c912afef4aac7$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $5a9c912afef4aac7$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $5a9c912afef4aac7$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$5a9c912afef4aac7$var$isModifiedEvent(event);
}
function $5a9c912afef4aac7$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $5a9c912afef4aac7$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $5a9c912afef4aac7$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $5a9c912afef4aac7$var$_formDataSupportsSubmitter = null;
function $5a9c912afef4aac7$var$isFormDataSubmitterSupported() {
    if ($5a9c912afef4aac7$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $5a9c912afef4aac7$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $5a9c912afef4aac7$var$_formDataSupportsSubmitter = true;
    }
    return $5a9c912afef4aac7$var$_formDataSupportsSubmitter;
}
var $5a9c912afef4aac7$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $5a9c912afef4aac7$var$getFormEncType(encType) {
    if (encType != null && !$5a9c912afef4aac7$var$supportedFormEncTypes.has(encType)) {
        $5a9c912afef4aac7$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$5a9c912afef4aac7$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $5a9c912afef4aac7$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($5a9c912afef4aac7$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $5a9c912afef4aac7$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $5a9c912afef4aac7$var$defaultMethod;
        encType = $5a9c912afef4aac7$var$getFormEncType(target.getAttribute("enctype")) || $5a9c912afef4aac7$var$defaultEncType;
        formData = new FormData(target);
    } else if ($5a9c912afef4aac7$var$isButtonElement(target) || $5a9c912afef4aac7$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $5a9c912afef4aac7$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $5a9c912afef4aac7$var$defaultMethod;
        encType = $5a9c912afef4aac7$var$getFormEncType(target.getAttribute("formenctype")) || $5a9c912afef4aac7$var$getFormEncType(form.getAttribute("enctype")) || $5a9c912afef4aac7$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$5a9c912afef4aac7$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($5a9c912afef4aac7$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $5a9c912afef4aac7$var$defaultMethod;
        action = null;
        encType = $5a9c912afef4aac7$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $5a9c912afef4aac7$var$HOLE = -1;
var $5a9c912afef4aac7$var$NAN = -2;
var $5a9c912afef4aac7$var$NEGATIVE_INFINITY = -3;
var $5a9c912afef4aac7$var$NEGATIVE_ZERO = -4;
var $5a9c912afef4aac7$var$NULL = -5;
var $5a9c912afef4aac7$var$POSITIVE_INFINITY = -6;
var $5a9c912afef4aac7$var$UNDEFINED = -7;
var $5a9c912afef4aac7$var$TYPE_BIGINT = "B";
var $5a9c912afef4aac7$var$TYPE_DATE = "D";
var $5a9c912afef4aac7$var$TYPE_ERROR = "E";
var $5a9c912afef4aac7$var$TYPE_MAP = "M";
var $5a9c912afef4aac7$var$TYPE_NULL_OBJECT = "N";
var $5a9c912afef4aac7$var$TYPE_PROMISE = "P";
var $5a9c912afef4aac7$var$TYPE_REGEXP = "R";
var $5a9c912afef4aac7$var$TYPE_SET = "S";
var $5a9c912afef4aac7$var$TYPE_SYMBOL = "Y";
var $5a9c912afef4aac7$var$TYPE_URL = "U";
var $5a9c912afef4aac7$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $5a9c912afef4aac7$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $5a9c912afef4aac7$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $5a9c912afef4aac7$var$TIME_LIMIT_MS = 1;
var $5a9c912afef4aac7$var$getNow = ()=>Date.now();
var $5a9c912afef4aac7$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $5a9c912afef4aac7$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $5a9c912afef4aac7$var$UNDEFINED;
    if (input === null) return $5a9c912afef4aac7$var$NULL;
    if (Number.isNaN(input)) return $5a9c912afef4aac7$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $5a9c912afef4aac7$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $5a9c912afef4aac7$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $5a9c912afef4aac7$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $5a9c912afef4aac7$var$stringify.call(this, stack);
    return index;
}
async function $5a9c912afef4aac7$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $5a9c912afef4aac7$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $5a9c912afef4aac7$var$UNDEFINED;
        if (value === null) return $5a9c912afef4aac7$var$NULL;
        if (Number.isNaN(value)) return $5a9c912afef4aac7$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $5a9c912afef4aac7$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $5a9c912afef4aac7$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $5a9c912afef4aac7$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $5a9c912afef4aac7$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $5a9c912afef4aac7$var$TIME_LIMIT_MS) {
            await $5a9c912afef4aac7$var$yieldToMain();
            lastYieldTime = $5a9c912afef4aac7$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$5a9c912afef4aac7$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$5a9c912afef4aac7$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$5a9c912afef4aac7$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $5a9c912afef4aac7$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$5a9c912afef4aac7$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$5a9c912afef4aac7$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$5a9c912afef4aac7$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$5a9c912afef4aac7$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$5a9c912afef4aac7$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$5a9c912afef4aac7$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$5a9c912afef4aac7$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$5a9c912afef4aac7$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$5a9c912afef4aac7$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$5a9c912afef4aac7$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($5a9c912afef4aac7$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $5a9c912afef4aac7$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $5a9c912afef4aac7$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $5a9c912afef4aac7$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $5a9c912afef4aac7$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $5a9c912afef4aac7$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $5a9c912afef4aac7$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $5a9c912afef4aac7$var$hydrate.call(this, startIndex);
}
function $5a9c912afef4aac7$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $5a9c912afef4aac7$var$UNDEFINED:
                set(void 0);
                continue;
            case $5a9c912afef4aac7$var$NULL:
                set(null);
                continue;
            case $5a9c912afef4aac7$var$NAN:
                set(NaN);
                continue;
            case $5a9c912afef4aac7$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $5a9c912afef4aac7$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $5a9c912afef4aac7$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $5a9c912afef4aac7$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $5a9c912afef4aac7$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $5a9c912afef4aac7$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $5a9c912afef4aac7$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $5a9c912afef4aac7$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $5a9c912afef4aac7$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $5a9c912afef4aac7$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $5a9c912afef4aac7$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $5a9c912afef4aac7$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $5a9c912afef4aac7$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $5a9c912afef4aac7$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $5a9c912afef4aac7$var$globalObj && $5a9c912afef4aac7$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $5a9c912afef4aac7$var$globalObj && typeof $5a9c912afef4aac7$var$globalObj[errorType] === "function" ? new $5a9c912afef4aac7$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $5a9c912afef4aac7$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $5a9c912afef4aac7$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $5a9c912afef4aac7$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $5a9c912afef4aac7$var$Deferred2();
    const reader = readable.pipeThrough($5a9c912afef4aac7$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $5a9c912afef4aac7$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $5a9c912afef4aac7$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $5a9c912afef4aac7$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $5a9c912afef4aac7$var$unflatten.call(this, line)
    };
}
async function $5a9c912afef4aac7$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $5a9c912afef4aac7$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $5a9c912afef4aac7$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $5a9c912afef4aac7$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $5a9c912afef4aac7$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $5a9c912afef4aac7$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $5a9c912afef4aac7$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $5a9c912afef4aac7$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$5a9c912afef4aac7$var$TYPE_PROMISE}${deferredId}:[["${$5a9c912afef4aac7$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$5a9c912afef4aac7$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$5a9c912afef4aac7$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $5a9c912afef4aac7$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$5a9c912afef4aac7$var$TYPE_ERROR}${deferredId}:[["${$5a9c912afef4aac7$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$5a9c912afef4aac7$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$5a9c912afef4aac7$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $5a9c912afef4aac7$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $5a9c912afef4aac7$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $5a9c912afef4aac7$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $5a9c912afef4aac7$export$4cf11838cdc2a8a8(html) {
    return html.replace($5a9c912afef4aac7$var$ESCAPE_REGEX, (match)=>$5a9c912afef4aac7$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $5a9c912afef4aac7$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $5a9c912afef4aac7$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $5a9c912afef4aac7$var$SingleFetchNoResultError = class extends Error {
};
var $5a9c912afef4aac7$export$ae9272e641ead836 = 202;
var $5a9c912afef4aac7$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $5a9c912afef4aac7$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $Fo7oF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$5a9c912afef4aac7$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $Fo7oF.createElement($Fo7oF.Fragment, null, scriptTag, /* @__PURE__ */ $Fo7oF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $Fo7oF.createElement($Fo7oF.Fragment, null, scriptTag, /* @__PURE__ */ $Fo7oF.createElement($Fo7oF.Suspense, null, /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $5a9c912afef4aac7$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $5a9c912afef4aac7$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $5a9c912afef4aac7$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $5a9c912afef4aac7$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $5a9c912afef4aac7$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $5a9c912afef4aac7$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $5a9c912afef4aac7$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $5a9c912afef4aac7$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $5a9c912afef4aac7$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $5a9c912afef4aac7$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $5a9c912afef4aac7$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $5a9c912afef4aac7$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($5a9c912afef4aac7$export$3f1eb41d9a6a6a27(result.result) || $5a9c912afef4aac7$export$972111febbeef05b(result.result) || $5a9c912afef4aac7$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $5a9c912afef4aac7$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $5a9c912afef4aac7$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $5a9c912afef4aac7$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $5a9c912afef4aac7$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$5a9c912afef4aac7$var$createDeferred2());
    let singleFetchDfd = $5a9c912afef4aac7$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $5a9c912afef4aac7$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $5a9c912afef4aac7$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $5a9c912afef4aac7$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $5a9c912afef4aac7$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $5a9c912afef4aac7$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $5a9c912afef4aac7$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $5a9c912afef4aac7$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $5a9c912afef4aac7$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $5a9c912afef4aac7$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $5a9c912afef4aac7$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $5a9c912afef4aac7$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$5a9c912afef4aac7$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$5a9c912afef4aac7$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $5a9c912afef4aac7$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $5a9c912afef4aac7$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $5a9c912afef4aac7$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $5a9c912afef4aac7$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $5a9c912afef4aac7$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $5a9c912afef4aac7$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($5a9c912afef4aac7$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $5a9c912afef4aac7$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $5a9c912afef4aac7$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($5a9c912afef4aac7$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$5a9c912afef4aac7$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $5a9c912afef4aac7$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $5a9c912afef4aac7$export$4023ad4ecd4126a2(body, global) {
    return $5a9c912afef4aac7$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $5a9c912afef4aac7$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $5a9c912afef4aac7$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$5a9c912afef4aac7$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $5a9c912afef4aac7$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $5a9c912afef4aac7$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $5a9c912afef4aac7$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $5a9c912afef4aac7$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $5a9c912afef4aac7$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $5a9c912afef4aac7$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $5a9c912afef4aac7$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $5a9c912afef4aac7$var$getModuleLinkHrefs(matches, manifest);
    return $5a9c912afef4aac7$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $5a9c912afef4aac7$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $5a9c912afef4aac7$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $5a9c912afef4aac7$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($5a9c912afef4aac7$var$prefetchStyleLink));
}
async function $5a9c912afef4aac7$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$5a9c912afef4aac7$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$5a9c912afef4aac7$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$5a9c912afef4aac7$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($5a9c912afef4aac7$var$prefetchStyleLink));
}
async function $5a9c912afef4aac7$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $5a9c912afef4aac7$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $5a9c912afef4aac7$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $5a9c912afef4aac7$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $5a9c912afef4aac7$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $5a9c912afef4aac7$var$dedupeLinkDescriptors(links.flat(1).filter($5a9c912afef4aac7$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $5a9c912afef4aac7$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $5a9c912afef4aac7$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $5a9c912afef4aac7$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $5a9c912afef4aac7$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $5a9c912afef4aac7$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $5a9c912afef4aac7$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$5a9c912afef4aac7$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($5a9c912afef4aac7$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $5a9c912afef4aac7$var$_isPreloadSupported;
function $5a9c912afef4aac7$var$isPreloadSupported() {
    if ($5a9c912afef4aac7$var$_isPreloadSupported !== void 0) return $5a9c912afef4aac7$var$_isPreloadSupported;
    let el = document.createElement("link");
    $5a9c912afef4aac7$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $5a9c912afef4aac7$var$_isPreloadSupported;
}
function $5a9c912afef4aac7$var$RemixRootDefaultHydrateFallback() {
    let { nonce: nonce } = $5a9c912afef4aac7$var$useFrameworkContext();
    return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $5a9c912afef4aac7$export$945fecf35a8ef089 ? /* @__PURE__ */ $Fo7oF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $5a9c912afef4aac7$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $5a9c912afef4aac7$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $5a9c912afef4aac7$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $5a9c912afef4aac7$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$var$RemixRootDefaultErrorBoundary, {
            error: $5a9c912afef4aac7$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $Fo7oF.createElement(routeModule.Layout, null, /* @__PURE__ */ $Fo7oF.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $Fo7oF.createElement(routeModule.Layout, null, /* @__PURE__ */ $Fo7oF.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $Fo7oF.createElement(routeModule.Layout, null, /* @__PURE__ */ $Fo7oF.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $5a9c912afef4aac7$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $5a9c912afef4aac7$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $5a9c912afef4aac7$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$5a9c912afef4aac7$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $5a9c912afef4aac7$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $5a9c912afef4aac7$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $5a9c912afef4aac7$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $5a9c912afef4aac7$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $5a9c912afef4aac7$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $5a9c912afef4aac7$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $5a9c912afef4aac7$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $5a9c912afef4aac7$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $5a9c912afef4aac7$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $5a9c912afef4aac7$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $5a9c912afef4aac7$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $5a9c912afef4aac7$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $5a9c912afef4aac7$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$5a9c912afef4aac7$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $5a9c912afef4aac7$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $5a9c912afef4aac7$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $5a9c912afef4aac7$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $5a9c912afef4aac7$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $5a9c912afef4aac7$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $5a9c912afef4aac7$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $5a9c912afef4aac7$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $5a9c912afef4aac7$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $5a9c912afef4aac7$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $5a9c912afef4aac7$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $5a9c912afef4aac7$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $5a9c912afef4aac7$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $5a9c912afef4aac7$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $5a9c912afef4aac7$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $5a9c912afef4aac7$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $5a9c912afef4aac7$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $5a9c912afef4aac7$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $5a9c912afef4aac7$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $5a9c912afef4aac7$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $5a9c912afef4aac7$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $5a9c912afef4aac7$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $5a9c912afef4aac7$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $5a9c912afef4aac7$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $5a9c912afef4aac7$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $5a9c912afef4aac7$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $5a9c912afef4aac7$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $5a9c912afef4aac7$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $5a9c912afef4aac7$var$nextPaths = /* @__PURE__ */ new Set();
var $5a9c912afef4aac7$var$discoveredPathsMaxSize = 1e3;
var $5a9c912afef4aac7$var$discoveredPaths = /* @__PURE__ */ new Set();
var $5a9c912afef4aac7$export$b5915cf27fa06b9f = 7680;
function $5a9c912afef4aac7$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $5a9c912afef4aac7$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $5a9c912afef4aac7$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $5a9c912afef4aac7$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $5a9c912afef4aac7$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$5a9c912afef4aac7$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($5a9c912afef4aac7$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $5a9c912afef4aac7$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $5a9c912afef4aac7$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $5a9c912afef4aac7$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $Fo7oF.useEffect(()=>{
        if (!$5a9c912afef4aac7$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$5a9c912afef4aac7$var$discoveredPaths.has(pathname)) $5a9c912afef4aac7$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($5a9c912afef4aac7$var$nextPaths.keys()).filter((path)=>{
                if ($5a9c912afef4aac7$var$discoveredPaths.has(path)) {
                    $5a9c912afef4aac7$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $5a9c912afef4aac7$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $5a9c912afef4aac7$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $5a9c912afef4aac7$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $5a9c912afef4aac7$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $5a9c912afef4aac7$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $5a9c912afef4aac7$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $5a9c912afef4aac7$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($5a9c912afef4aac7$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $5a9c912afef4aac7$export$b5915cf27fa06b9f) {
        $5a9c912afef4aac7$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($5a9c912afef4aac7$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($5a9c912afef4aac7$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($5a9c912afef4aac7$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$5a9c912afef4aac7$var$addToFifoQueue(p, $5a9c912afef4aac7$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $5a9c912afef4aac7$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $5a9c912afef4aac7$var$addToFifoQueue(path, queue) {
    if (queue.size >= $5a9c912afef4aac7$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $5a9c912afef4aac7$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $5a9c912afef4aac7$var$useDataRouterContext2() {
    let context = $Fo7oF.useContext($5a9c912afef4aac7$export$2eeee58951ff3c1c);
    $5a9c912afef4aac7$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $5a9c912afef4aac7$var$useDataRouterStateContext() {
    let context = $Fo7oF.useContext($5a9c912afef4aac7$export$315e3ffb01f217);
    $5a9c912afef4aac7$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $5a9c912afef4aac7$export$208d6a3bc3aa62bd = $Fo7oF.createContext(void 0);
$5a9c912afef4aac7$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $5a9c912afef4aac7$var$useFrameworkContext() {
    let context = $Fo7oF.useContext($5a9c912afef4aac7$export$208d6a3bc3aa62bd);
    $5a9c912afef4aac7$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $5a9c912afef4aac7$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $Fo7oF.useContext($5a9c912afef4aac7$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $Fo7oF.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $Fo7oF.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $Fo7oF.useRef(null);
    $Fo7oF.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $Fo7oF.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $5a9c912afef4aac7$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $5a9c912afef4aac7$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $5a9c912afef4aac7$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $5a9c912afef4aac7$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $5a9c912afef4aac7$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $5a9c912afef4aac7$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $5a9c912afef4aac7$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$5a9c912afef4aac7$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $5a9c912afef4aac7$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $5a9c912afef4aac7$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $5a9c912afef4aac7$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $5a9c912afef4aac7$var$useDataRouterStateContext();
    let matches = $5a9c912afef4aac7$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $Fo7oF.useMemo(()=>$5a9c912afef4aac7$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $Fo7oF.createElement($Fo7oF.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $Fo7oF.createElement("style", {
        [$5a9c912afef4aac7$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $Fo7oF.createElement("link", {
        [$5a9c912afef4aac7$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$5a9c912afef4aac7$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $Fo7oF.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $5a9c912afef4aac7$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $5a9c912afef4aac7$var$useIsRSCRouterContext();
    let { nonce: contextNonce } = $5a9c912afef4aac7$var$useFrameworkContext();
    let { router: router } = $5a9c912afef4aac7$var$useDataRouterContext2();
    let matches = $Fo7oF.useMemo(()=>$5a9c912afef4aac7$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $5a9c912afef4aac7$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $5a9c912afef4aac7$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $Fo7oF.useState([]);
    $Fo7oF.useEffect(()=>{
        let interrupted = false;
        $5a9c912afef4aac7$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $5a9c912afef4aac7$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $5a9c912afef4aac7$export$45d76561a5302f2b();
    let { future: future } = $5a9c912afef4aac7$var$useFrameworkContext();
    let { basename: basename } = $5a9c912afef4aac7$var$useDataRouterContext2();
    let dataHrefs = $Fo7oF.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $5a9c912afef4aac7$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $Fo7oF.createElement($Fo7oF.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $Fo7oF.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $5a9c912afef4aac7$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $5a9c912afef4aac7$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $5a9c912afef4aac7$var$useFrameworkContext();
    let { basename: basename } = $5a9c912afef4aac7$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $5a9c912afef4aac7$var$useDataRouterStateContext();
    let newMatchesForData = $Fo7oF.useMemo(()=>$5a9c912afef4aac7$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $Fo7oF.useMemo(()=>$5a9c912afef4aac7$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $Fo7oF.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $5a9c912afef4aac7$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $Fo7oF.useMemo(()=>$5a9c912afef4aac7$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $5a9c912afef4aac7$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $Fo7oF.createElement($Fo7oF.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $Fo7oF.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $Fo7oF.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $Fo7oF.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $5a9c912afef4aac7$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $5a9c912afef4aac7$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $5a9c912afef4aac7$var$useDataRouterStateContext();
    let location = $5a9c912afef4aac7$export$45d76561a5302f2b();
    let _matches = $5a9c912afef4aac7$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $Fo7oF.createElement($Fo7oF.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$5a9c912afef4aac7$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $Fo7oF.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $Fo7oF.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $Fo7oF.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $Fo7oF.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $5a9c912afef4aac7$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $Fo7oF.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $5a9c912afef4aac7$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $5a9c912afef4aac7$var$isHydrated = false;
function $5a9c912afef4aac7$export$3be068dde909e563() {
    $5a9c912afef4aac7$var$isHydrated = true;
}
function $5a9c912afef4aac7$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $5a9c912afef4aac7$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $5a9c912afef4aac7$var$useDataRouterContext2();
    let { matches: routerMatches } = $5a9c912afef4aac7$var$useDataRouterStateContext();
    let isRSCRouterContext = $5a9c912afef4aac7$var$useIsRSCRouterContext();
    let enableFogOfWar = $5a9c912afef4aac7$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $5a9c912afef4aac7$var$getActiveMatches(routerMatches, null, isSpaMode);
    $Fo7oF.useEffect(()=>{
        $5a9c912afef4aac7$export$3be068dde909e563();
    }, []);
    let initialScripts = $Fo7oF.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $5a9c912afef4aac7$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($5a9c912afef4aac7$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $Fo7oF.createElement($Fo7oF.Fragment, null, /* @__PURE__ */ $Fo7oF.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $Fo7oF.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $5a9c912afef4aac7$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($5a9c912afef4aac7$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $5a9c912afef4aac7$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $5a9c912afef4aac7$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $Fo7oF.createElement($Fo7oF.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $Fo7oF.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $Fo7oF.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $Fo7oF.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $Fo7oF.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $5a9c912afef4aac7$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $5a9c912afef4aac7$export$32e57f52df4b6e34 = class extends $Fo7oF.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $5a9c912afef4aac7$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = $5a9c912afef4aac7$var$useFrameworkContext();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $Fo7oF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($5a9c912afef4aac7$export$972111febbeef05b(error)) return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $Fo7oF.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $5a9c912afef4aac7$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $Fo7oF.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $Fo7oF.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $5a9c912afef4aac7$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $5a9c912afef4aac7$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $Fo7oF.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $Fo7oF.createElement("head", null, /* @__PURE__ */ $Fo7oF.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $Fo7oF.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $Fo7oF.createElement("title", null, title)), /* @__PURE__ */ $Fo7oF.createElement("body", null, /* @__PURE__ */ $Fo7oF.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$ff0bf87698939488, null) : null)));
}
var $5a9c912afef4aac7$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($5a9c912afef4aac7$var$isBrowser2) window.__reactRouterVersion = "7.18.2";
} catch (e) {}
function $5a9c912afef4aac7$export$1f3f55432a00e06d(routes, opts) {
    return $5a9c912afef4aac7$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $5a9c912afef4aac7$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $5a9c912afef4aac7$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $5a9c912afef4aac7$export$9269a41d8c4635e,
        hydrationRouteProperties: $5a9c912afef4aac7$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $5a9c912afef4aac7$export$1ba7ed8a3a7b3765(routes, opts) {
    return $5a9c912afef4aac7$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $5a9c912afef4aac7$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $5a9c912afef4aac7$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $5a9c912afef4aac7$export$9269a41d8c4635e,
        hydrationRouteProperties: $5a9c912afef4aac7$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $5a9c912afef4aac7$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $5a9c912afef4aac7$var$deserializeErrors(state.errors)
    };
    return state;
}
function $5a9c912afef4aac7$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $5a9c912afef4aac7$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (typeof val.__subType === "string" && $5a9c912afef4aac7$var$SUPPORTED_ERROR_TYPES.includes(val.__subType)) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $5a9c912afef4aac7$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $Fo7oF.useRef();
    if (historyRef.current == null) historyRef.current = $5a9c912afef4aac7$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $Fo7oF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $Fo7oF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $Fo7oF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $Fo7oF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $5a9c912afef4aac7$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $Fo7oF.useRef();
    if (historyRef.current == null) historyRef.current = $5a9c912afef4aac7$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $Fo7oF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $Fo7oF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $Fo7oF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $Fo7oF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $5a9c912afef4aac7$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $Fo7oF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $Fo7oF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $Fo7oF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $Fo7oF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$5a9c912afef4aac7$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $5a9c912afef4aac7$export$a6c7ac8248d6e38a = $Fo7oF.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $Fo7oF.useContext($5a9c912afef4aac7$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $5a9c912afef4aac7$var$ABSOLUTE_URL_REGEX.test(to);
    let parsed = $5a9c912afef4aac7$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $5a9c912afef4aac7$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $5a9c912afef4aac7$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $5a9c912afef4aac7$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $5a9c912afef4aac7$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $5a9c912afef4aac7$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $5a9c912afef4aac7$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $Fo7oF.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $5a9c912afef4aac7$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $Fo7oF.createElement($Fo7oF.Fragment, null, link, /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$5a9c912afef4aac7$export$a6c7ac8248d6e38a.displayName = "Link";
var $5a9c912afef4aac7$export$b0d92dbee9b5b60d = $Fo7oF.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $5a9c912afef4aac7$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $5a9c912afef4aac7$export$45d76561a5302f2b();
    let routerState = $Fo7oF.useContext($5a9c912afef4aac7$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $Fo7oF.useContext($5a9c912afef4aac7$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $5a9c912afef4aac7$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $5a9c912afef4aac7$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$5a9c912afef4aac7$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $5a9c912afef4aac7$export$a7fed597f4b8afd8 = $Fo7oF.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $5a9c912afef4aac7$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $Fo7oF.useContext($5a9c912afef4aac7$export$3044ab7fdabeaee6);
    let submit = $5a9c912afef4aac7$export$47c85c6e3a081d3();
    let formAction = $5a9c912afef4aac7$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $5a9c912afef4aac7$var$ABSOLUTE_URL_REGEX.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $Fo7oF.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $Fo7oF.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$5a9c912afef4aac7$export$a7fed597f4b8afd8.displayName = "Form";
function $5a9c912afef4aac7$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $Fo7oF.useContext($5a9c912afef4aac7$export$208d6a3bc3aa62bd);
    let { basename: basename } = $Fo7oF.useContext($5a9c912afef4aac7$export$3044ab7fdabeaee6);
    let location = $5a9c912afef4aac7$export$45d76561a5302f2b();
    let matches = $5a9c912afef4aac7$export$2378eb7f5ff86053();
    $5a9c912afef4aac7$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $Fo7oF.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $5a9c912afef4aac7$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $Fo7oF.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$5a9c912afef4aac7$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $5a9c912afef4aac7$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$5a9c912afef4aac7$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$5a9c912afef4aac7$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $5a9c912afef4aac7$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $5a9c912afef4aac7$var$useDataRouterContext3(hookName) {
    let ctx = $Fo7oF.useContext($5a9c912afef4aac7$export$2eeee58951ff3c1c);
    $5a9c912afef4aac7$export$f5708dca728d7177(ctx, $5a9c912afef4aac7$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $5a9c912afef4aac7$var$useDataRouterState2(hookName) {
    let state = $Fo7oF.useContext($5a9c912afef4aac7$export$315e3ffb01f217);
    $5a9c912afef4aac7$export$f5708dca728d7177(state, $5a9c912afef4aac7$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $5a9c912afef4aac7$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $5a9c912afef4aac7$export$9770f232ac06a008();
    let location = $5a9c912afef4aac7$export$45d76561a5302f2b();
    let path = $5a9c912afef4aac7$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $Fo7oF.useCallback((event)=>{
        if ($5a9c912afef4aac7$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $5a9c912afef4aac7$export$fe53371bee54353d(location) === $5a9c912afef4aac7$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $Fo7oF.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $5a9c912afef4aac7$export$f1a78c17382fe22a(defaultInit) {
    $5a9c912afef4aac7$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $Fo7oF.useRef($5a9c912afef4aac7$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $Fo7oF.useRef(false);
    let location = $5a9c912afef4aac7$export$45d76561a5302f2b();
    let searchParams = $Fo7oF.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $5a9c912afef4aac7$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $5a9c912afef4aac7$export$9770f232ac06a008();
    let setSearchParams = $Fo7oF.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $5a9c912afef4aac7$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $5a9c912afef4aac7$var$fetcherId = 0;
var $5a9c912afef4aac7$var$getUniqueFetcherId = ()=>`__${String(++$5a9c912afef4aac7$var$fetcherId)}__`;
function $5a9c912afef4aac7$export$47c85c6e3a081d3() {
    let { router: router } = $5a9c912afef4aac7$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $Fo7oF.useContext($5a9c912afef4aac7$export$3044ab7fdabeaee6);
    let currentRouteId = $5a9c912afef4aac7$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $Fo7oF.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $5a9c912afef4aac7$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $5a9c912afef4aac7$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $5a9c912afef4aac7$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $Fo7oF.useContext($5a9c912afef4aac7$export$3044ab7fdabeaee6);
    let routeContext = $Fo7oF.useContext($5a9c912afef4aac7$export$aac280ed165a4397);
    $5a9c912afef4aac7$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$5a9c912afef4aac7$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $5a9c912afef4aac7$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $5a9c912afef4aac7$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $5a9c912afef4aac7$export$fe53371bee54353d(path);
}
function $5a9c912afef4aac7$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $5a9c912afef4aac7$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $5a9c912afef4aac7$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $Fo7oF.useContext($5a9c912afef4aac7$export$cb3f1df1bef00a39);
    let route = $Fo7oF.useContext($5a9c912afef4aac7$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $5a9c912afef4aac7$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $5a9c912afef4aac7$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $5a9c912afef4aac7$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $Fo7oF.useId();
    let [fetcherKey, setFetcherKey] = $Fo7oF.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $Fo7oF.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $Fo7oF.useCallback(async (href, opts)=>{
        $5a9c912afef4aac7$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $5a9c912afef4aac7$export$47c85c6e3a081d3();
    let submit = $Fo7oF.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $Fo7oF.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $Fo7oF.useMemo(()=>{
        let FetcherForm2 = $Fo7oF.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $5a9c912afef4aac7$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $Fo7oF.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $5a9c912afef4aac7$export$fa996778a3a31087() {
    let state = $5a9c912afef4aac7$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $Fo7oF.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $5a9c912afef4aac7$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $5a9c912afef4aac7$var$savedScrollPositions = {};
function $5a9c912afef4aac7$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $5a9c912afef4aac7$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $5a9c912afef4aac7$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $5a9c912afef4aac7$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $5a9c912afef4aac7$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $Fo7oF.useContext($5a9c912afef4aac7$export$3044ab7fdabeaee6);
    let location = $5a9c912afef4aac7$export$45d76561a5302f2b();
    let matches = $5a9c912afef4aac7$export$2378eb7f5ff86053();
    let navigation = $5a9c912afef4aac7$export$d0fd4b7106de2769();
    $Fo7oF.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $5a9c912afef4aac7$var$usePageHide($Fo7oF.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $5a9c912afef4aac7$var$getScrollRestorationKey(location, matches, basename, getKey);
            $5a9c912afef4aac7$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $5a9c912afef4aac7$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($5a9c912afef4aac7$var$savedScrollPositions));
        } catch (error) {
            $5a9c912afef4aac7$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $Fo7oF.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $5a9c912afef4aac7$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $5a9c912afef4aac7$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $Fo7oF.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($5a9c912afef4aac7$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$5a9c912afef4aac7$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $Fo7oF.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $5a9c912afef4aac7$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $5a9c912afef4aac7$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $Fo7oF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $5a9c912afef4aac7$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $Fo7oF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $5a9c912afef4aac7$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $5a9c912afef4aac7$export$b273b3273281a049(when);
    $Fo7oF.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $Fo7oF.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $5a9c912afef4aac7$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $Fo7oF.useContext($5a9c912afef4aac7$export$3681f408decb40d1);
    $5a9c912afef4aac7$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $5a9c912afef4aac7$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $5a9c912afef4aac7$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $5a9c912afef4aac7$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $5a9c912afef4aac7$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $5a9c912afef4aac7$export$81336c211d5ff295(path.pathname, nextPath) != null || $5a9c912afef4aac7$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $5a9c912afef4aac7$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $5a9c912afef4aac7$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $5a9c912afef4aac7$var$getStatelessNavigator();
    return /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $5a9c912afef4aac7$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $5a9c912afef4aac7$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $5a9c912afef4aac7$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $5a9c912afef4aac7$var$serializeErrors(context.errors)
        };
        let json = $5a9c912afef4aac7$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $Fo7oF.createElement($Fo7oF.Fragment, null, /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $Fo7oF.createElement($5a9c912afef4aac7$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $Fo7oF.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $5a9c912afef4aac7$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($5a9c912afef4aac7$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $5a9c912afef4aac7$var$getStatelessNavigator() {
    return {
        createHref: $5a9c912afef4aac7$var$createHref,
        encodeLocation: $5a9c912afef4aac7$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $5a9c912afef4aac7$export$69163f0b72ec60d9(routes, opts) {
    return $5a9c912afef4aac7$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $5a9c912afef4aac7$export$9269a41d8c4635e
    });
}
function $5a9c912afef4aac7$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $5a9c912afef4aac7$export$87cb1a9238dc3fba(routes, $5a9c912afef4aac7$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $5a9c912afef4aac7$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $5a9c912afef4aac7$var$createHref,
        encodeLocation: $5a9c912afef4aac7$var$encodeLocation,
        getFetcher () {
            return $5a9c912afef4aac7$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $5a9c912afef4aac7$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $5a9c912afef4aac7$var$createHref(to) {
    return typeof to === "string" ? to : $5a9c912afef4aac7$export$fe53371bee54353d(to);
}
function $5a9c912afef4aac7$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $5a9c912afef4aac7$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $5a9c912afef4aac7$var$ABSOLUTE_URL_REGEX.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}


var $2e3699713c7ad81e$exports = {};
"use strict";
Object.defineProperty($2e3699713c7ad81e$exports, "__esModule", {
    value: true
});
Object.defineProperty($2e3699713c7ad81e$exports, "Accordion", {
    enumerable: true,
    get: function get() {
        return $b034af101ea681b3$exports.Accordion;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "AccordionItem", {
    enumerable: true,
    get: function get() {
        return $b034af101ea681b3$exports.AccordionItem;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Alert", {
    enumerable: true,
    get: function get() {
        return $b7c15acc5eba3374$exports.Alert;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Badge", {
    enumerable: true,
    get: function get() {
        return $90569e0fc0c07919$exports.Badge;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Breadcrumb", {
    enumerable: true,
    get: function get() {
        return $8b2c5a84ce299160$exports.Breadcrumb;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Button", {
    enumerable: true,
    get: function get() {
        return $ecd15074f048ae13$exports.Button;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "ButtonToolbar", {
    enumerable: true,
    get: function get() {
        return $ecd15074f048ae13$exports.ButtonToolbar;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "ToggleButton", {
    enumerable: true,
    get: function get() {
        return $ecd15074f048ae13$exports.ToggleButton;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "IconButton", {
    enumerable: true,
    get: function get() {
        return $ecd15074f048ae13$exports.IconButton;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "ButtonGroup", {
    enumerable: true,
    get: function get() {
        return $03bd35f26aa17a61$exports.ButtonGroup;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "ToggleButtonGroup", {
    enumerable: true,
    get: function get() {
        return $03bd35f26aa17a61$exports.ToggleButtonGroup;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Card", {
    enumerable: true,
    get: function get() {
        return $39e1fd9bee0414a6$exports.Card;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "ChartsGraphs", {
    enumerable: true,
    get: function get() {
        return $e4d10c195820bf5d$exports.ChartsGraphs;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Checkbox", {
    enumerable: true,
    get: function get() {
        return $97926ea47e1ed60f$exports.Checkbox;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Col", {
    enumerable: true,
    get: function get() {
        return $d47f5a20d5173fdb$exports.Col;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Collapse", {
    enumerable: true,
    get: function get() {
        return $7731c56aebd43b74$exports.Collapse;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Container", {
    enumerable: true,
    get: function get() {
        return $9ed08f53b88f75a9$exports.Container;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "DatePicker", {
    enumerable: true,
    get: function get() {
        return $23120b195cc4628c$exports.DatePicker;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Dropdown", {
    enumerable: true,
    get: function get() {
        return $7539a0d62b4a3f5e$exports.Dropdown;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "DropdownButton", {
    enumerable: true,
    get: function get() {
        return $7539a0d62b4a3f5e$exports.DropdownButton;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "FileUpload", {
    enumerable: true,
    get: function get() {
        return $33c78908635c6d26$exports.FileUpload;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Footer", {
    enumerable: true,
    get: function get() {
        return $9a231b0fc0814be6$exports.Footer;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "FooterLink", {
    enumerable: true,
    get: function get() {
        return $9a231b0fc0814be6$exports.FooterLink;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Form", {
    enumerable: true,
    get: function get() {
        return $e115e9f32f94e5cf$exports.Form;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Header", {
    enumerable: true,
    get: function get() {
        return $00346f62e9f6f288$exports.Header;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "HeaderButtonBack", {
    enumerable: true,
    get: function get() {
        return $00346f62e9f6f288$exports.HeaderButtonBack;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "HeaderContext", {
    enumerable: true,
    get: function get() {
        return $00346f62e9f6f288$exports.HeaderContext;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "HelperText", {
    enumerable: true,
    get: function get() {
        return $93f03239d9e68f5a$exports.HelperText;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "InputGroup", {
    enumerable: true,
    get: function get() {
        return $190bc81c671cdca6$exports.InputGroup;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "InputGroupSelect", {
    enumerable: true,
    get: function get() {
        return $190bc81c671cdca6$exports.InputGroupSelect;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "List", {
    enumerable: true,
    get: function get() {
        return $9c142335d2b8ec6f$exports.List;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "ListItem", {
    enumerable: true,
    get: function get() {
        return $9c142335d2b8ec6f$exports.ListItem;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "ListGroup", {
    enumerable: true,
    get: function get() {
        return $9c142335d2b8ec6f$exports.ListGroup;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Modal", {
    enumerable: true,
    get: function get() {
        return $b34be20ee0a3cabd$exports.Modal;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "CloseButton", {
    enumerable: true,
    get: function get() {
        return $b34be20ee0a3cabd$exports.CloseButton;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Nav", {
    enumerable: true,
    get: function get() {
        return $bcd440a0b285e0c3$exports.Nav;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "NavWidget", {
    enumerable: true,
    get: function get() {
        return $bcd440a0b285e0c3$exports.NavWidget;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "OverlayTrigger", {
    enumerable: true,
    get: function get() {
        return $ea0992e05dad91c6$exports.OverlayTrigger;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Pagination", {
    enumerable: true,
    get: function get() {
        return $884fc36dcfc434f7$exports.Pagination;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "PaginationWrapper", {
    enumerable: true,
    get: function get() {
        return $884fc36dcfc434f7$exports.PaginationWrapper;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Popover", {
    enumerable: true,
    get: function get() {
        return $b6ea26e70b7c7b4b$exports.Popover;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "ProgressBar", {
    enumerable: true,
    get: function get() {
        return $3193994ad931e0c3$exports.ProgressBar;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Spinner", {
    enumerable: true,
    get: function get() {
        return $3193994ad931e0c3$exports.Spinner;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "RadioButton", {
    enumerable: true,
    get: function get() {
        return $02cb4431385bd849$exports.RadioButton;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Row", {
    enumerable: true,
    get: function get() {
        return $75338f2eae319813$exports.Row;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "SearchClearButton", {
    enumerable: true,
    get: function get() {
        return $3f501adbefa810dd$exports.SearchClearButton;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "SearchInput", {
    enumerable: true,
    get: function get() {
        return $3f501adbefa810dd$exports.SearchInput;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "SearchSubmitButton", {
    enumerable: true,
    get: function get() {
        return $3f501adbefa810dd$exports.SearchSubmitButton;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Search", {
    enumerable: true,
    get: function get() {
        return $3f501adbefa810dd$exports.Search;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "SideNav", {
    enumerable: true,
    get: function get() {
        return $ca1ee2f974bdec31$exports.SideNav;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "StatusIndicator", {
    enumerable: true,
    get: function get() {
        return $7911e4a90168a382$exports.StatusIndicator;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Tab", {
    enumerable: true,
    get: function get() {
        return $a64da7150ce0918e$exports.Tab;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Table", {
    enumerable: true,
    get: function get() {
        return $421209a146ee874c$exports.Table;
    }
});
Object.defineProperty($2e3699713c7ad81e$exports, "Tooltip", {
    enumerable: true,
    get: function get() {
        return $50ca62b9df3a8f84$exports.Tooltip;
    }
});
var $b034af101ea681b3$exports = {};
"use strict";
Object.defineProperty($b034af101ea681b3$exports, "__esModule", {
    value: true
});
Object.defineProperty($b034af101ea681b3$exports, "Accordion", {
    enumerable: true,
    get: function get() {
        return $cf31f1c271f7f026$exports.Accordion;
    }
});
Object.defineProperty($b034af101ea681b3$exports, "AccordionItem", {
    enumerable: true,
    get: function get() {
        return $7a1fbad810b0d036$exports.AccordionItem;
    }
});
var $cf31f1c271f7f026$exports = {};
"use strict";
Object.defineProperty($cf31f1c271f7f026$exports, "__esModule", {
    value: true
});
$cf31f1c271f7f026$exports.Accordion = void 0;

var $cf31f1c271f7f026$var$_react = $cf31f1c271f7f026$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $cf31f1c271f7f026$var$_propTypes = $cf31f1c271f7f026$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $cf31f1c271f7f026$var$_classnames = $cf31f1c271f7f026$var$_interopRequireDefault((parcelRequire("fVt0T")));

var $cf31f1c271f7f026$var$_Accordion = $cf31f1c271f7f026$var$_interopRequireDefault((parcelRequire("8ziF9")));
var $7a1fbad810b0d036$exports = {};
"use strict";
function $7a1fbad810b0d036$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $7a1fbad810b0d036$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $7a1fbad810b0d036$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $7a1fbad810b0d036$var$_typeof(obj);
}
Object.defineProperty($7a1fbad810b0d036$exports, "__esModule", {
    value: true
});
$7a1fbad810b0d036$exports.AccordionItem = void 0;

var $7a1fbad810b0d036$var$_react = $7a1fbad810b0d036$var$_interopRequireWildcard((parcelRequire("Fo7oF")));

var $7a1fbad810b0d036$var$_propTypes = $7a1fbad810b0d036$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $7a1fbad810b0d036$var$_Button = $7a1fbad810b0d036$var$_interopRequireDefault((parcelRequire("6MAJg")));

var $7a1fbad810b0d036$var$_Accordion = $7a1fbad810b0d036$var$_interopRequireDefault((parcelRequire("8ziF9")));

var $7a1fbad810b0d036$var$_AccordionContext = $7a1fbad810b0d036$var$_interopRequireDefault((parcelRequire("6A5XN")));

var $7a1fbad810b0d036$var$_Card = $7a1fbad810b0d036$var$_interopRequireDefault((parcelRequire("drDkQ")));
function $7a1fbad810b0d036$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $7a1fbad810b0d036$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $7a1fbad810b0d036$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $7a1fbad810b0d036$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $7a1fbad810b0d036$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $7a1fbad810b0d036$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $7a1fbad810b0d036$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7a1fbad810b0d036$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7a1fbad810b0d036$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7a1fbad810b0d036$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $7a1fbad810b0d036$var$ChevronRightIcon = function ChevronRightIcon(props) {
    return /*#__PURE__*/ $7a1fbad810b0d036$var$_react["default"].createElement("svg", props, /*#__PURE__*/ $7a1fbad810b0d036$var$_react["default"].createElement("path", {
        d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
    }), /*#__PURE__*/ $7a1fbad810b0d036$var$_react["default"].createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0V0z"
    }));
};
$7a1fbad810b0d036$var$ChevronRightIcon.defaultProps = $7a1fbad810b0d036$var$_defineProperty({
    focusable: "false",
    'aria-hidden': "true",
    fill: "#666",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
}, "focusable", 'false');
var $7a1fbad810b0d036$var$AccordionItem = function AccordionItem(_ref) {
    var children = _ref.children, title = _ref.title, summary = _ref.summary, id = _ref.id, props = $7a1fbad810b0d036$var$_objectWithoutProperties(_ref, [
        "children",
        "title",
        "summary",
        "id"
    ]);
    var contextEventKey = (0, $7a1fbad810b0d036$var$_react.useContext)($7a1fbad810b0d036$var$_AccordionContext["default"]);
    return /*#__PURE__*/ $7a1fbad810b0d036$var$_react["default"].createElement($7a1fbad810b0d036$var$_Card["default"], props, /*#__PURE__*/ $7a1fbad810b0d036$var$_react["default"].createElement($7a1fbad810b0d036$var$_Card["default"].Header, null, /*#__PURE__*/ $7a1fbad810b0d036$var$_react["default"].createElement("h5", {
        className: "uxf-accordion-item"
    }, /*#__PURE__*/ $7a1fbad810b0d036$var$_react["default"].createElement($7a1fbad810b0d036$var$_Accordion["default"].Toggle, {
        as: $7a1fbad810b0d036$var$_Button["default"],
        variant: "link",
        "aria-expanded": contextEventKey === id,
        "aria-controls": id,
        eventKey: id
    }, /*#__PURE__*/ $7a1fbad810b0d036$var$_react["default"].createElement($7a1fbad810b0d036$var$ChevronRightIcon, {
        className: "uxf-accordion-icon"
    }), /*#__PURE__*/ $7a1fbad810b0d036$var$_react["default"].createElement("span", {
        className: "uxf-accordion-title"
    }, title), /*#__PURE__*/ $7a1fbad810b0d036$var$_react["default"].createElement("span", {
        className: "uxf-accordion-summary"
    }, summary)))), /*#__PURE__*/ $7a1fbad810b0d036$var$_react["default"].createElement($7a1fbad810b0d036$var$_Accordion["default"].Collapse, {
        id: id,
        eventKey: id
    }, /*#__PURE__*/ $7a1fbad810b0d036$var$_react["default"].createElement($7a1fbad810b0d036$var$_Card["default"].Body, null, children)));
};
$7a1fbad810b0d036$exports.AccordionItem = $7a1fbad810b0d036$var$AccordionItem;
$7a1fbad810b0d036$var$AccordionItem.propTypes = {
    /**
   * Title of item within accordion
   */ title: $7a1fbad810b0d036$var$_propTypes["default"].node,
    /**
   * Id of the accordion item's content. Corresponds to the collapse component that gets triggered when this has been clicked.
   * This is also used to improve accessibility by connecting content to toggle button.
   */ id: $7a1fbad810b0d036$var$_propTypes["default"].string.isRequired,
    /**
   * Additional text/content added to right of accordion title
   */ summary: $7a1fbad810b0d036$var$_propTypes["default"].node
};


function $cf31f1c271f7f026$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $cf31f1c271f7f026$var$_extends() {
    $cf31f1c271f7f026$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cf31f1c271f7f026$var$_extends.apply(this, arguments);
}
function $cf31f1c271f7f026$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $cf31f1c271f7f026$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $cf31f1c271f7f026$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $cf31f1c271f7f026$var$Accordion = function Accordion(_ref) {
    var children = _ref.children, className = _ref.className, props = $cf31f1c271f7f026$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    var classes = (0, $cf31f1c271f7f026$var$_classnames["default"])("uxf-accordion", className);
    return /*#__PURE__*/ $cf31f1c271f7f026$var$_react["default"].createElement($cf31f1c271f7f026$var$_Accordion["default"], $cf31f1c271f7f026$var$_extends({
        bsPrefix: " ",
        className: classes
    }, props), children);
};
$cf31f1c271f7f026$exports.Accordion = $cf31f1c271f7f026$var$Accordion;
$cf31f1c271f7f026$var$Accordion.propTypes = {
    /** Set a custom element for this component */ as: $cf31f1c271f7f026$var$_propTypes["default"].elementType,
    /** The current active key that corresponds to the currently expanded card */ activeKey: $cf31f1c271f7f026$var$_propTypes["default"].string,
    /** The default active key that is expanded on start */ defaultActiveKey: $cf31f1c271f7f026$var$_propTypes["default"].string
};
$cf31f1c271f7f026$var$Accordion.Item = $7a1fbad810b0d036$exports.AccordionItem;





var $b7c15acc5eba3374$exports = {};
"use strict";
Object.defineProperty($b7c15acc5eba3374$exports, "__esModule", {
    value: true
});
Object.defineProperty($b7c15acc5eba3374$exports, "Alert", {
    enumerable: true,
    get: function get() {
        return $f3e77dd368559298$exports.Alert;
    }
});
var $f3e77dd368559298$exports = {};
"use strict";
Object.defineProperty($f3e77dd368559298$exports, "__esModule", {
    value: true
});
$f3e77dd368559298$exports.Alert = void 0;

var $f3e77dd368559298$var$_react = $f3e77dd368559298$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $f3e77dd368559298$var$_propTypes = $f3e77dd368559298$var$_interopRequireDefault((parcelRequire("d2bgE")));
var $a4b6aef9eb213b5c$exports = {};
'use strict';
Object.defineProperty($a4b6aef9eb213b5c$exports, "__esModule", {
    value: true
});
$a4b6aef9eb213b5c$exports.isRequiredForA11y = $a4b6aef9eb213b5c$exports.elementType = $a4b6aef9eb213b5c$exports.deprecated = $a4b6aef9eb213b5c$exports.componentOrElement = $a4b6aef9eb213b5c$exports.all = undefined;

var $clW5X = parcelRequire("clW5X");
var $a4b6aef9eb213b5c$var$_all2 = $a4b6aef9eb213b5c$var$_interopRequireDefault($clW5X);
var $c738c89453e28ecb$exports = {};
'use strict';
Object.defineProperty($c738c89453e28ecb$exports, "__esModule", {
    value: true
});
var $c738c89453e28ecb$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var $Fo7oF = parcelRequire("Fo7oF");
var $c738c89453e28ecb$var$_react2 = $c738c89453e28ecb$var$_interopRequireDefault($Fo7oF);

var $f6O08 = parcelRequire("f6O08");
var $c738c89453e28ecb$var$_createChainableTypeChecker2 = $c738c89453e28ecb$var$_interopRequireDefault($f6O08);
function $c738c89453e28ecb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c738c89453e28ecb$var$validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var propType = typeof propValue === 'undefined' ? 'undefined' : $c738c89453e28ecb$var$_typeof(propValue);
    if ($c738c89453e28ecb$var$_react2.default.isValidElement(propValue)) return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
    if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
    return null;
}
$c738c89453e28ecb$exports.default = (0, $c738c89453e28ecb$var$_createChainableTypeChecker2.default)($c738c89453e28ecb$var$validate);
$c738c89453e28ecb$exports = $c738c89453e28ecb$exports['default'];


var $a4b6aef9eb213b5c$var$_componentOrElement2 = $a4b6aef9eb213b5c$var$_interopRequireDefault($c738c89453e28ecb$exports);
var $6d12db7b0ad42ca6$exports = {};
'use strict';
Object.defineProperty($6d12db7b0ad42ca6$exports, "__esModule", {
    value: true
});
$6d12db7b0ad42ca6$exports.default = $6d12db7b0ad42ca6$var$deprecated;

var $8yRQ3 = parcelRequire("8yRQ3");
var $6d12db7b0ad42ca6$var$_warning2 = $6d12db7b0ad42ca6$var$_interopRequireDefault($8yRQ3);
function $6d12db7b0ad42ca6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6d12db7b0ad42ca6$var$warned = {};
function $6d12db7b0ad42ca6$var$deprecated(validator, reason) {
    return function validate(props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || '<<anonymous>>';
        var propFullNameSafe = propFullName || propName;
        if (props[propName] != null) {
            var messageKey = componentName + '.' + propName;
            (0, $6d12db7b0ad42ca6$var$_warning2.default)($6d12db7b0ad42ca6$var$warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));
            $6d12db7b0ad42ca6$var$warned[messageKey] = true;
        }
        for(var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++)args[_key - 5] = arguments[_key];
        return validator.apply(undefined, [
            props,
            propName,
            componentName,
            location,
            propFullName
        ].concat(args));
    };
}
/* eslint-disable no-underscore-dangle */ function $6d12db7b0ad42ca6$var$_resetWarned() {
    $6d12db7b0ad42ca6$var$warned = {};
}
$6d12db7b0ad42ca6$var$deprecated._resetWarned = $6d12db7b0ad42ca6$var$_resetWarned;
/* eslint-enable no-underscore-dangle */ $6d12db7b0ad42ca6$exports = $6d12db7b0ad42ca6$exports['default'];


var $a4b6aef9eb213b5c$var$_deprecated2 = $a4b6aef9eb213b5c$var$_interopRequireDefault($6d12db7b0ad42ca6$exports);
var $8c9d31b3ef94c519$exports = {};
'use strict';
Object.defineProperty($8c9d31b3ef94c519$exports, "__esModule", {
    value: true
});

var $Fo7oF = parcelRequire("Fo7oF");
var $8c9d31b3ef94c519$var$_react2 = $8c9d31b3ef94c519$var$_interopRequireDefault($Fo7oF);

var $7XcX3 = parcelRequire("7XcX3");

var $f6O08 = parcelRequire("f6O08");
var $8c9d31b3ef94c519$var$_createChainableTypeChecker2 = $8c9d31b3ef94c519$var$_interopRequireDefault($f6O08);
function $8c9d31b3ef94c519$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8c9d31b3ef94c519$var$elementType(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    if ($8c9d31b3ef94c519$var$_react2.default.isValidElement(propValue)) return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
    if (!(0, $7XcX3.isValidElementType)(propValue)) return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
    return null;
}
$8c9d31b3ef94c519$exports.default = (0, $8c9d31b3ef94c519$var$_createChainableTypeChecker2.default)($8c9d31b3ef94c519$var$elementType);
$8c9d31b3ef94c519$exports = $8c9d31b3ef94c519$exports['default'];


var $a4b6aef9eb213b5c$var$_elementType2 = $a4b6aef9eb213b5c$var$_interopRequireDefault($8c9d31b3ef94c519$exports);

var $gJ3n2 = parcelRequire("gJ3n2");
var $a4b6aef9eb213b5c$var$_isRequiredForA11y2 = $a4b6aef9eb213b5c$var$_interopRequireDefault($gJ3n2);
function $a4b6aef9eb213b5c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$a4b6aef9eb213b5c$exports.all = $a4b6aef9eb213b5c$var$_all2.default;
$a4b6aef9eb213b5c$exports.componentOrElement = $a4b6aef9eb213b5c$var$_componentOrElement2.default;
$a4b6aef9eb213b5c$exports.deprecated = $a4b6aef9eb213b5c$var$_deprecated2.default;
$a4b6aef9eb213b5c$exports.elementType = $a4b6aef9eb213b5c$var$_elementType2.default;
$a4b6aef9eb213b5c$exports.isRequiredForA11y = $a4b6aef9eb213b5c$var$_isRequiredForA11y2.default;



var $f3e77dd368559298$var$_Alert = $f3e77dd368559298$var$_interopRequireDefault((parcelRequire("gQ4vH")));
function $f3e77dd368559298$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $f3e77dd368559298$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f3e77dd368559298$var$_extends() {
    $f3e77dd368559298$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f3e77dd368559298$var$_extends.apply(this, arguments);
}
function $f3e77dd368559298$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f3e77dd368559298$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f3e77dd368559298$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f3e77dd368559298$var$CheckIcon = function CheckIcon(props) {
    return /*#__PURE__*/ $f3e77dd368559298$var$_react["default"].createElement("svg", props, /*#__PURE__*/ $f3e77dd368559298$var$_react["default"].createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), /*#__PURE__*/ $f3e77dd368559298$var$_react["default"].createElement("path", {
        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    }));
};
$f3e77dd368559298$var$CheckIcon.defaultProps = $f3e77dd368559298$var$_defineProperty({
    focusable: "false",
    'aria-hidden': "true",
    fill: "#666",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
}, "focusable", 'false');
var $f3e77dd368559298$var$WarningIcon = function WarningIcon(props) {
    return /*#__PURE__*/ $f3e77dd368559298$var$_react["default"].createElement("svg", props, /*#__PURE__*/ $f3e77dd368559298$var$_react["default"].createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), /*#__PURE__*/ $f3e77dd368559298$var$_react["default"].createElement("path", {
        d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
    }));
};
$f3e77dd368559298$var$WarningIcon.defaultProps = $f3e77dd368559298$var$_defineProperty({
    focusable: "false",
    'aria-hidden': "true",
    fill: "#666",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
}, "focusable", 'false');
var $f3e77dd368559298$var$InfoIcon = function InfoIcon(props) {
    return /*#__PURE__*/ $f3e77dd368559298$var$_react["default"].createElement("svg", props, /*#__PURE__*/ $f3e77dd368559298$var$_react["default"].createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0V0z"
    }), /*#__PURE__*/ $f3e77dd368559298$var$_react["default"].createElement("path", {
        d: "M11 7h2v2h-2zm0 4h2v6h-2z"
    }), /*#__PURE__*/ $f3e77dd368559298$var$_react["default"].createElement("path", {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
    }));
};
$f3e77dd368559298$var$InfoIcon.defaultProps = $f3e77dd368559298$var$_defineProperty({
    focusable: "false",
    'aria-hidden': "true",
    fill: "#666",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
}, "focusable", 'false');
var $f3e77dd368559298$var$Alert = function Alert(_ref) {
    var variant = _ref.variant, accessibilityLabel = _ref.accessibilityLabel, children = _ref.children, props = $f3e77dd368559298$var$_objectWithoutProperties(_ref, [
        "variant",
        "accessibilityLabel",
        "children"
    ]);
    var icon = {
        success: $f3e77dd368559298$var$CheckIcon,
        warning: $f3e77dd368559298$var$WarningIcon,
        danger: $f3e77dd368559298$var$WarningIcon,
        info: $f3e77dd368559298$var$InfoIcon
    };
    var IconComponent = icon[variant];
    return /*#__PURE__*/ $f3e77dd368559298$var$_react["default"].createElement($f3e77dd368559298$var$_Alert["default"], $f3e77dd368559298$var$_extends({
        variant: variant
    }, props), accessibilityLabel && /*#__PURE__*/ $f3e77dd368559298$var$_react["default"].createElement("span", {
        className: "sr-only"
    }, accessibilityLabel), /*#__PURE__*/ $f3e77dd368559298$var$_react["default"].createElement(IconComponent, {
        className: "uxf-alert-icon"
    }), /*#__PURE__*/ $f3e77dd368559298$var$_react["default"].createElement("div", {
        className: "uxf-alert-content"
    }, children));
};
$f3e77dd368559298$exports.Alert = $f3e77dd368559298$var$Alert;
$f3e77dd368559298$var$Alert.propTypes = {
    /**
   * Change the underlying component CSS base class name and modifier class names prefix
   * @default 'alert'
   */ bsPrefix: $f3e77dd368559298$var$_propTypes["default"].string,
    /**
   * The Alert visual variant
   *
   * `"success"` `"danger"` `"warning"` `"info"`
   */ variant: $f3e77dd368559298$var$_propTypes["default"].string.isRequired,
    /**
   * Renders a properly aligned dismiss button, as well as
   * adding extra horizontal padding to the Alert.
   */ dismissible: $f3e77dd368559298$var$_propTypes["default"].bool,
    /**
   * Controls the visual state of the Alert.
   *
   * @controllable onClose
   */ show: $f3e77dd368559298$var$_propTypes["default"].bool,
    /**
   * Callback fired when alert is closed.
   *
   * @controllable show
   */ onClose: $f3e77dd368559298$var$_propTypes["default"].func,
    /**
   * Sets the text for alert close button.
   */ closeLabel: $f3e77dd368559298$var$_propTypes["default"].string,
    /**
   * Animate the alert dismissal. Defaults to using `<Fade>` animation or use
   * `false` to disable. A custom `react-transition-group` Transition can also
   * be provided.
   */ transition: $f3e77dd368559298$var$_propTypes["default"].oneOfType([
        $f3e77dd368559298$var$_propTypes["default"].bool,
        $a4b6aef9eb213b5c$exports.elementType
    ]),
    /**
   * Sets the label for assistive technology tools
   */ accessibilityLabel: $f3e77dd368559298$var$_propTypes["default"].string
};
$f3e77dd368559298$var$Alert.defaultProps = {
    variant: "success"
};




var $90569e0fc0c07919$exports = {};
"use strict";
Object.defineProperty($90569e0fc0c07919$exports, "__esModule", {
    value: true
});
Object.defineProperty($90569e0fc0c07919$exports, "Badge", {
    enumerable: true,
    get: function get() {
        return $d25c1dbb3f28ccf2$exports.Badge;
    }
});
var $d25c1dbb3f28ccf2$exports = {};
"use strict";
Object.defineProperty($d25c1dbb3f28ccf2$exports, "__esModule", {
    value: true
});
$d25c1dbb3f28ccf2$exports.Badge = void 0;

var $d25c1dbb3f28ccf2$var$_react = $d25c1dbb3f28ccf2$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $d25c1dbb3f28ccf2$var$_propTypes = $d25c1dbb3f28ccf2$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $d25c1dbb3f28ccf2$var$_classnames = $d25c1dbb3f28ccf2$var$_interopRequireDefault((parcelRequire("fVt0T")));

var $d25c1dbb3f28ccf2$var$_Badge = $d25c1dbb3f28ccf2$var$_interopRequireDefault((parcelRequire("jVxV5")));
function $d25c1dbb3f28ccf2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $d25c1dbb3f28ccf2$var$_extends() {
    $d25c1dbb3f28ccf2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d25c1dbb3f28ccf2$var$_extends.apply(this, arguments);
}
function $d25c1dbb3f28ccf2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d25c1dbb3f28ccf2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d25c1dbb3f28ccf2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d25c1dbb3f28ccf2$var$Badge = function Badge(_ref) {
    var badgeCount = _ref.badgeCount, className = _ref.className, children = _ref.children, props = $d25c1dbb3f28ccf2$var$_objectWithoutProperties(_ref, [
        "badgeCount",
        "className",
        "children"
    ]);
    var classes = (0, $d25c1dbb3f28ccf2$var$_classnames["default"])(badgeCount && "uxf-badge-count", className);
    return /*#__PURE__*/ $d25c1dbb3f28ccf2$var$_react["default"].createElement($d25c1dbb3f28ccf2$var$_Badge["default"], $d25c1dbb3f28ccf2$var$_extends({
        className: classes
    }, props), children);
};
$d25c1dbb3f28ccf2$exports.Badge = $d25c1dbb3f28ccf2$var$Badge;
$d25c1dbb3f28ccf2$var$Badge.propTypes = {
    /**
   * Change the underlying component CSS base class name and modifier class names prefix
   *
   * default 'badge'
   */ bsPrefix: $d25c1dbb3f28ccf2$var$_propTypes["default"].string,
    /**
   * Adds the badge count modifier class
   */ badgeCount: $d25c1dbb3f28ccf2$var$_propTypes["default"].bool,
    /**
   * The visual style of the badge
   *
   * `"primary"` `"secondary"`
   */ variant: $d25c1dbb3f28ccf2$var$_propTypes["default"].string.isRequired,
    /**
   * Add the pill modifier to make badges more rounded with
   * some additional horizontal padding
   */ pill: $d25c1dbb3f28ccf2$var$_propTypes["default"].bool,
    /** Set a custom element for this component */ as: $d25c1dbb3f28ccf2$var$_propTypes["default"].elementType
};
$d25c1dbb3f28ccf2$var$Badge.defaultProps = {
    variant: "primary",
    badgeCount: false
};




var $8b2c5a84ce299160$exports = {};
"use strict";
Object.defineProperty($8b2c5a84ce299160$exports, "__esModule", {
    value: true
});
Object.defineProperty($8b2c5a84ce299160$exports, "Breadcrumb", {
    enumerable: true,
    get: function get() {
        return $c0b09721104fbffd$exports.Breadcrumb;
    }
});
var $c0b09721104fbffd$exports = {};
"use strict";
Object.defineProperty($c0b09721104fbffd$exports, "__esModule", {
    value: true
});
$c0b09721104fbffd$exports.Breadcrumb = void 0;

var $c0b09721104fbffd$var$_react = $c0b09721104fbffd$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $c0b09721104fbffd$var$_propTypes = $c0b09721104fbffd$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $c0b09721104fbffd$var$_classnames = $c0b09721104fbffd$var$_interopRequireDefault((parcelRequire("fVt0T")));

var $c0b09721104fbffd$var$_Breadcrumb = $c0b09721104fbffd$var$_interopRequireDefault((parcelRequire("9uT02")));
function $c0b09721104fbffd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $c0b09721104fbffd$var$_extends() {
    $c0b09721104fbffd$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c0b09721104fbffd$var$_extends.apply(this, arguments);
}
function $c0b09721104fbffd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c0b09721104fbffd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $c0b09721104fbffd$var$ownKeys(Object(source), true).forEach(function(key) {
            $c0b09721104fbffd$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $c0b09721104fbffd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c0b09721104fbffd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c0b09721104fbffd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c0b09721104fbffd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c0b09721104fbffd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $c0b09721104fbffd$var$Breadcrumb = function Breadcrumb(_ref) {
    var dropLast = _ref.dropLast, links = _ref.links, _ref$as = _ref.as, Heading = _ref$as === void 0 ? "h1" : _ref$as, headingClassName = _ref.headingClassName, breadcrumbItemProps = _ref.breadcrumbItemProps, linkProps = _ref.linkProps, props = $c0b09721104fbffd$var$_objectWithoutProperties(_ref, [
        "dropLast",
        "links",
        "as",
        "headingClassName",
        "breadcrumbItemProps",
        "linkProps"
    ]);
    var headingClasses = (0, $c0b09721104fbffd$var$_classnames["default"])("h2", headingClassName);
    return /*#__PURE__*/ $c0b09721104fbffd$var$_react["default"].createElement($c0b09721104fbffd$var$_Breadcrumb["default"], $c0b09721104fbffd$var$_extends({
        listProps: dropLast && {
            className: "uxf-breadcrumb-drop-last"
        }
    }, props), links.map(function(link) {
        if (links.indexOf(link) !== links.length - 1) return /*#__PURE__*/ $c0b09721104fbffd$var$_react["default"].createElement($c0b09721104fbffd$var$_Breadcrumb["default"].Item, $c0b09721104fbffd$var$_extends({
            href: link.href,
            key: link.href || link.to,
            linkProps: $c0b09721104fbffd$var$_objectSpread({
                to: link.to
            }, linkProps)
        }, breadcrumbItemProps), link.title);
        else return /*#__PURE__*/ $c0b09721104fbffd$var$_react["default"].createElement($c0b09721104fbffd$var$_Breadcrumb["default"].Item, $c0b09721104fbffd$var$_extends({
            active: true,
            "aria-current": "page",
            key: link.href || link.to,
            href: link.href,
            linkProps: $c0b09721104fbffd$var$_objectSpread({
                to: link.to
            }, linkProps)
        }, breadcrumbItemProps), dropLast ? /*#__PURE__*/ $c0b09721104fbffd$var$_react["default"].createElement(Heading, {
            className: headingClasses
        }, link.title) : link.title);
    }));
};
$c0b09721104fbffd$exports.Breadcrumb = $c0b09721104fbffd$var$Breadcrumb;
$c0b09721104fbffd$var$Breadcrumb.propTypes = {
    /**
   * Change the underlying component CSS base class name and modifier class names prefix
   * @default 'breadcrumb'
   */ bsPrefix: $c0b09721104fbffd$var$_propTypes["default"].string,
    /**
   * ARIA label for the nav element
   * https://www.w3.org/TR/wai-aria-practices/#breadcrumb
   */ label: $c0b09721104fbffd$var$_propTypes["default"].string,
    /**
   * Additional props passed as-is to the underlying `<ol>` element
   */ listProps: $c0b09721104fbffd$var$_propTypes["default"].object,
    /**
   * Additional props passed as-is to the underlying link for non-active items.
   */ linkProps: $c0b09721104fbffd$var$_propTypes["default"].object,
    /** Set a custom element for this component */ as: $c0b09721104fbffd$var$_propTypes["default"].elementType,
    /**
   * Uses current page in breadcrumb as a page heading
   */ dropLast: $c0b09721104fbffd$var$_propTypes["default"].bool.isRequired,
    /**
   * Links included within breadcrumb
   */ links: $c0b09721104fbffd$var$_propTypes["default"].array.isRequired,
    /**
   * Classes added to Breadcrumb `dropLast` variation heading
   */ headingClassName: $c0b09721104fbffd$var$_propTypes["default"].string,
    /**
   * Additional props passed as-is to the underlying Breadcrumb.Item elements
   */ breadcrumbItemProps: $c0b09721104fbffd$var$_propTypes["default"].object
};
$c0b09721104fbffd$var$Breadcrumb.defaultProps = {
    dropLast: false,
    links: [
        {
            title: "test1",
            href: "/"
        },
        {
            title: "test2",
            href: "/"
        },
        {
            title: "test3",
            href: "/"
        }
    ]
};




var $ecd15074f048ae13$exports = {};
"use strict";
Object.defineProperty($ecd15074f048ae13$exports, "__esModule", {
    value: true
});
Object.defineProperty($ecd15074f048ae13$exports, "Button", {
    enumerable: true,
    get: function get() {
        return $57aacf0457ba1905$exports.Button;
    }
});
Object.defineProperty($ecd15074f048ae13$exports, "ToggleButton", {
    enumerable: true,
    get: function get() {
        return $441be0a98c73c58e$exports.ToggleButton;
    }
});
Object.defineProperty($ecd15074f048ae13$exports, "IconButton", {
    enumerable: true,
    get: function get() {
        return $61315a7afd9ed9bc$exports.IconButton;
    }
});
Object.defineProperty($ecd15074f048ae13$exports, "ButtonToolbar", {
    enumerable: true,
    get: function get() {
        return $3fd6c7baac11a515$exports.ButtonToolbar;
    }
});
var $57aacf0457ba1905$exports = {};
"use strict";
Object.defineProperty($57aacf0457ba1905$exports, "__esModule", {
    value: true
});
$57aacf0457ba1905$exports.Button = void 0;

var $57aacf0457ba1905$var$_react = $57aacf0457ba1905$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $57aacf0457ba1905$var$_propTypes = $57aacf0457ba1905$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $57aacf0457ba1905$var$_Button = $57aacf0457ba1905$var$_interopRequireDefault((parcelRequire("6MAJg")));
function $57aacf0457ba1905$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $57aacf0457ba1905$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $57aacf0457ba1905$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $57aacf0457ba1905$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $57aacf0457ba1905$var$Button = function Button(_ref) {
    var children = _ref.children, props = $57aacf0457ba1905$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $57aacf0457ba1905$var$_react["default"].createElement($57aacf0457ba1905$var$_Button["default"], props, children);
};
$57aacf0457ba1905$exports.Button = $57aacf0457ba1905$var$Button;
$57aacf0457ba1905$var$Button.propTypes = {
    /**
   * Change the underlying component CSS base class name and modifier class names prefix
   * @default 'btn'
   */ bsPrefix: $57aacf0457ba1905$var$_propTypes["default"].string,
    /**
   * One or more button variant combinations
   *
   * buttons may be one of a variety of visual variants such as:
   *
   * `"primary"` `"secondary"` `"outline-primary"` `"outline-uxf-yellow"` `"outline-uxf-white"` `"uxf-filter"`
   *
   */ variant: $57aacf0457ba1905$var$_propTypes["default"].string,
    /**
   * Specifies a large or small button.
   *
   * `"sm"` `"lg"`
   */ size: $57aacf0457ba1905$var$_propTypes["default"].string,
    /** Spans the full width of the Button parent */ block: $57aacf0457ba1905$var$_propTypes["default"].bool,
    /** Manually set the visual state of the button to `:active` */ active: $57aacf0457ba1905$var$_propTypes["default"].bool,
    /**
   * Disables the Button, preventing mouse events,
   * even if the underlying component is an `<a>` element
   */ disabled: $57aacf0457ba1905$var$_propTypes["default"].bool,
    /** Providing a `href` will render an `<a>` element, _styled_ as a button. */ href: $57aacf0457ba1905$var$_propTypes["default"].string,
    /**
   * Defines HTML button type attribute.
   *
   * default 'button'
   */ type: $57aacf0457ba1905$var$_propTypes["default"].oneOf([
        "button",
        "reset",
        "submit",
        null
    ]),
    /** Set a custom element for this component */ as: $57aacf0457ba1905$var$_propTypes["default"].elementType
};


var $441be0a98c73c58e$exports = {};
"use strict";
Object.defineProperty($441be0a98c73c58e$exports, "__esModule", {
    value: true
});
$441be0a98c73c58e$exports.ToggleButton = void 0;

var $441be0a98c73c58e$var$_react = $441be0a98c73c58e$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $441be0a98c73c58e$var$_propTypes = $441be0a98c73c58e$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $441be0a98c73c58e$var$_ToggleButton = $441be0a98c73c58e$var$_interopRequireDefault((parcelRequire("eB6H1")));
function $441be0a98c73c58e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $441be0a98c73c58e$var$_extends() {
    $441be0a98c73c58e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $441be0a98c73c58e$var$_extends.apply(this, arguments);
}
function $441be0a98c73c58e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $441be0a98c73c58e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $441be0a98c73c58e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $441be0a98c73c58e$var$ToggleButton = function ToggleButton(_ref) {
    var children = _ref.children, props = $441be0a98c73c58e$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $441be0a98c73c58e$var$_react["default"].createElement($441be0a98c73c58e$var$_ToggleButton["default"], $441be0a98c73c58e$var$_extends({
        variant: "uxf-toggle"
    }, props), children);
};
$441be0a98c73c58e$exports.ToggleButton = $441be0a98c73c58e$var$ToggleButton;
$441be0a98c73c58e$var$ToggleButton.propTypes = {
    /**
   * The `<input>` element `type`
   */ type: $441be0a98c73c58e$var$_propTypes["default"].oneOf([
        "checkbox",
        "radio"
    ]),
    /**
   * The HTML input name, used to group like checkboxes or radio buttons together
   * semantically
   */ name: $441be0a98c73c58e$var$_propTypes["default"].string,
    /**
   * The checked state of the input, managed by `<ToggleButtonGroup>` automatically
   */ checked: $441be0a98c73c58e$var$_propTypes["default"].bool,
    /**
   * The disabled state of both the label and input
   */ disabled: $441be0a98c73c58e$var$_propTypes["default"].bool,
    /**
   * A callback fired when the underlying input element changes. This is passed
   * directly to the `<input>` so shares the same signature as a native `onChange` event.
   */ onChange: $441be0a98c73c58e$var$_propTypes["default"].func,
    /**
   * The value of the input, should be unique amongst it's siblings when nested in a
   * `ToggleButtonGroup`.
   */ value: $441be0a98c73c58e$var$_propTypes["default"].any,
    /**
   * A ref attached to the `<input>` element
   * @type {ReactRef}
   */ inputRef: $441be0a98c73c58e$var$_propTypes["default"].any
};


var $61315a7afd9ed9bc$exports = {};
"use strict";
Object.defineProperty($61315a7afd9ed9bc$exports, "__esModule", {
    value: true
});
$61315a7afd9ed9bc$exports.IconButton = void 0;

var $61315a7afd9ed9bc$var$_react = $61315a7afd9ed9bc$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $61315a7afd9ed9bc$var$_propTypes = $61315a7afd9ed9bc$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $61315a7afd9ed9bc$var$_classnames = $61315a7afd9ed9bc$var$_interopRequireDefault((parcelRequire("fVt0T")));

var $61315a7afd9ed9bc$var$_Button = $61315a7afd9ed9bc$var$_interopRequireDefault((parcelRequire("6MAJg")));
function $61315a7afd9ed9bc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $61315a7afd9ed9bc$var$_extends() {
    $61315a7afd9ed9bc$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $61315a7afd9ed9bc$var$_extends.apply(this, arguments);
}
function $61315a7afd9ed9bc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $61315a7afd9ed9bc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $61315a7afd9ed9bc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $61315a7afd9ed9bc$var$IconButton = function IconButton(_ref) {
    var noHover = _ref.noHover, className = _ref.className, ariaLabel = _ref.ariaLabel, children = _ref.children, props = $61315a7afd9ed9bc$var$_objectWithoutProperties(_ref, [
        "noHover",
        "className",
        "ariaLabel",
        "children"
    ]);
    var classes = (0, $61315a7afd9ed9bc$var$_classnames["default"])(noHover && "btn-uxf-icon-no-hover", className);
    return /*#__PURE__*/ $61315a7afd9ed9bc$var$_react["default"].createElement($61315a7afd9ed9bc$var$_Button["default"], $61315a7afd9ed9bc$var$_extends({
        className: classes,
        variant: "uxf-icon",
        "aria-label": ariaLabel
    }, props), children);
};
$61315a7afd9ed9bc$exports.IconButton = $61315a7afd9ed9bc$var$IconButton;
$61315a7afd9ed9bc$var$IconButton.propTypes = {
    /**
   * Label for assistive technologies
   */ ariaLabel: $61315a7afd9ed9bc$var$_propTypes["default"].string.isRequired,
    /**
   * Adds the `btn-uxf-icon-no-hover` modifier to remove background-color on hover
   */ noHover: $61315a7afd9ed9bc$var$_propTypes["default"].bool
};
$61315a7afd9ed9bc$var$IconButton.defaultProps = {
    noHover: false
};


var $3fd6c7baac11a515$exports = {};
"use strict";
Object.defineProperty($3fd6c7baac11a515$exports, "__esModule", {
    value: true
});
$3fd6c7baac11a515$exports.ButtonToolbar = void 0;

var $3fd6c7baac11a515$var$_react = $3fd6c7baac11a515$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $3fd6c7baac11a515$var$_propTypes = $3fd6c7baac11a515$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $3fd6c7baac11a515$var$_ButtonToolbar = $3fd6c7baac11a515$var$_interopRequireDefault((parcelRequire("6EcT1")));
function $3fd6c7baac11a515$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $3fd6c7baac11a515$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3fd6c7baac11a515$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3fd6c7baac11a515$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3fd6c7baac11a515$var$ButtonToolbar = function ButtonToolbar(_ref) {
    var children = _ref.children, props = $3fd6c7baac11a515$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $3fd6c7baac11a515$var$_react["default"].createElement($3fd6c7baac11a515$var$_ButtonToolbar["default"], props, children);
};
$3fd6c7baac11a515$exports.ButtonToolbar = $3fd6c7baac11a515$var$ButtonToolbar;
$3fd6c7baac11a515$var$ButtonToolbar.propTypes = {
    /**
   * Change the underlying component CSS base class name and modifier class names prefix
   *
   * default 'btn-toolbar'
   */ bsPrefix: $3fd6c7baac11a515$var$_propTypes["default"].string,
    /**
   * default 'toolbar'
   *
   * The ARIA role describing the button toolbar. Generally the default
   * "toolbar" role is correct. An `aria-label` or `aria-labelledby`
   * prop is also recommended.
   */ role: $3fd6c7baac11a515$var$_propTypes["default"].string
};




var $03bd35f26aa17a61$exports = {};
"use strict";
Object.defineProperty($03bd35f26aa17a61$exports, "__esModule", {
    value: true
});
Object.defineProperty($03bd35f26aa17a61$exports, "ButtonGroup", {
    enumerable: true,
    get: function get() {
        return $f77c88cda52cd0c9$exports.ButtonGroup;
    }
});
Object.defineProperty($03bd35f26aa17a61$exports, "ToggleButtonGroup", {
    enumerable: true,
    get: function get() {
        return $f5e1244eee116a26$exports.ToggleButtonGroup;
    }
});
var $f77c88cda52cd0c9$exports = {};
"use strict";
Object.defineProperty($f77c88cda52cd0c9$exports, "__esModule", {
    value: true
});
$f77c88cda52cd0c9$exports.ButtonGroup = void 0;

var $f77c88cda52cd0c9$var$_react = $f77c88cda52cd0c9$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $f77c88cda52cd0c9$var$_propTypes = $f77c88cda52cd0c9$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $f77c88cda52cd0c9$var$_ButtonGroup = $f77c88cda52cd0c9$var$_interopRequireDefault((parcelRequire("4k5Ek")));
function $f77c88cda52cd0c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $f77c88cda52cd0c9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f77c88cda52cd0c9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f77c88cda52cd0c9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f77c88cda52cd0c9$var$ButtonGroup = function ButtonGroup(_ref) {
    var children = _ref.children, props = $f77c88cda52cd0c9$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $f77c88cda52cd0c9$var$_react["default"].createElement($f77c88cda52cd0c9$var$_ButtonGroup["default"], props, children);
};
$f77c88cda52cd0c9$exports.ButtonGroup = $f77c88cda52cd0c9$var$ButtonGroup;
$f77c88cda52cd0c9$var$ButtonGroup.propTypes = {
    /**
   * Change the underlying component CSS base class name and modifier class names prefix
   * @default 'btn-group'
   */ bsPrefix: $f77c88cda52cd0c9$var$_propTypes["default"].string,
    /**
   * Sets the size for all Buttons in the group.
   *
   * `"sm"` `"lg"`
   */ size: $f77c88cda52cd0c9$var$_propTypes["default"].string,
    /** Make the set of Buttons appear vertically stacked. */ vertical: $f77c88cda52cd0c9$var$_propTypes["default"].bool,
    /**
   * Display as a button toggle group.
   *
   * (Generally it's better to use `ToggleButtonGroup` directly)
   */ toggle: $f77c88cda52cd0c9$var$_propTypes["default"].bool,
    /**
   * An ARIA role describing the button group. Usually the default
   * "group" role is fine. An `aria-label` or `aria-labelledby`
   * prop is also recommended.
   */ role: $f77c88cda52cd0c9$var$_propTypes["default"].string,
    /** Set a custom element for this component */ as: $f77c88cda52cd0c9$var$_propTypes["default"].elementType
};


var $f5e1244eee116a26$exports = {};
"use strict";
Object.defineProperty($f5e1244eee116a26$exports, "__esModule", {
    value: true
});
$f5e1244eee116a26$exports.ToggleButtonGroup = void 0;

var $f5e1244eee116a26$var$_react = $f5e1244eee116a26$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $f5e1244eee116a26$var$_propTypes = $f5e1244eee116a26$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $f5e1244eee116a26$var$_classnames = $f5e1244eee116a26$var$_interopRequireDefault((parcelRequire("fVt0T")));

var $f5e1244eee116a26$var$_ToggleButtonGroup = $f5e1244eee116a26$var$_interopRequireDefault((parcelRequire("563PU")));
function $f5e1244eee116a26$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $f5e1244eee116a26$var$_extends() {
    $f5e1244eee116a26$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f5e1244eee116a26$var$_extends.apply(this, arguments);
}
function $f5e1244eee116a26$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f5e1244eee116a26$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f5e1244eee116a26$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f5e1244eee116a26$var$ToggleButtonGroup = function ToggleButtonGroup(_ref) {
    var ariaLabel = _ref.ariaLabel, className = _ref.className, includeLabel = _ref.includeLabel, disabled = _ref.disabled, label = _ref.label, children = _ref.children, props = $f5e1244eee116a26$var$_objectWithoutProperties(_ref, [
        "ariaLabel",
        "className",
        "includeLabel",
        "disabled",
        "label",
        "children"
    ]);
    return includeLabel ? /*#__PURE__*/ $f5e1244eee116a26$var$_react["default"].createElement("fieldset", null, /*#__PURE__*/ $f5e1244eee116a26$var$_react["default"].createElement("legend", {
        className: (0, $f5e1244eee116a26$var$_classnames["default"])("uxf-legend", disabled && "uxf-legend-disabled")
    }, label), /*#__PURE__*/ $f5e1244eee116a26$var$_react["default"].createElement($f5e1244eee116a26$var$_ToggleButtonGroup["default"], $f5e1244eee116a26$var$_extends({
        "aria-label": ariaLabel
    }, props), children)) : /*#__PURE__*/ $f5e1244eee116a26$var$_react["default"].createElement($f5e1244eee116a26$var$_ToggleButtonGroup["default"], $f5e1244eee116a26$var$_extends({
        className: className,
        "aria-label": ariaLabel
    }, props), children);
};
$f5e1244eee116a26$exports.ToggleButtonGroup = $f5e1244eee116a26$var$ToggleButtonGroup;
$f5e1244eee116a26$var$ToggleButtonGroup.defaultProps = {
    label: "Example Label",
    includeLabel: false,
    disabled: false
};
$f5e1244eee116a26$var$ToggleButtonGroup.propTypes = {
    /**
   * Optional label (legend) that describes the
   * contents of the toggle group
   */ label: $f5e1244eee116a26$var$_propTypes["default"].string,
    /**
   * Conditional that decides whether or not
   * to include label.
   */ includeLabel: $f5e1244eee116a26$var$_propTypes["default"].bool,
    /**
   * Adds disabled class to label
   */ disabled: $f5e1244eee116a26$var$_propTypes["default"].bool,
    /**
   * Aria-label of button group. This notifies individuals using a screen reader
   * that they are on a button group component. It is required if the role is "group"
   */ ariaLabel: $f5e1244eee116a26$var$_propTypes["default"].string,
    /**
   * An HTML `<input>` name for each child button.
   *
   * __Required if `type` is set to `'radio'`__
   */ name: $f5e1244eee116a26$var$_propTypes["default"].string,
    /**
   * The value, or array of values, of the active (pressed) buttons
   *
   * @controllable onChange
   */ value: $f5e1244eee116a26$var$_propTypes["default"].any,
    /**
   * Callback fired when a button is pressed, depending on whether the `type`
   * is `'radio'` or `'checkbox'`, `onChange` will be called with the value or
   * array of active values
   *
   * @controllable value
   */ onChange: $f5e1244eee116a26$var$_propTypes["default"].func,
    /**
   * The input `type` of the rendered buttons, determines the toggle behavior
   * of the buttons
   */ type: $f5e1244eee116a26$var$_propTypes["default"].oneOf([
        "checkbox",
        "radio"
    ]).isRequired,
    /**
   * Sets the size for all Buttons in the group.
   *
   * `"sm"` `"lg"`
   */ size: $f5e1244eee116a26$var$_propTypes["default"].string,
    /** Make the set of Buttons appear vertically stacked. */ vertical: $f5e1244eee116a26$var$_propTypes["default"].bool
};




var $39e1fd9bee0414a6$exports = {};
"use strict";
Object.defineProperty($39e1fd9bee0414a6$exports, "__esModule", {
    value: true
});
Object.defineProperty($39e1fd9bee0414a6$exports, "Card", {
    enumerable: true,
    get: function get() {
        return $d537d4126537ab9d$exports.Card;
    }
});
var $d537d4126537ab9d$exports = {};
"use strict";
Object.defineProperty($d537d4126537ab9d$exports, "__esModule", {
    value: true
});
$d537d4126537ab9d$exports.Card = void 0;

var $d537d4126537ab9d$var$_react = $d537d4126537ab9d$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $d537d4126537ab9d$var$_propTypes = $d537d4126537ab9d$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $d537d4126537ab9d$var$_Card = $d537d4126537ab9d$var$_interopRequireDefault((parcelRequire("drDkQ")));

var $d537d4126537ab9d$var$_createWithBsPrefix = $d537d4126537ab9d$var$_interopRequireDefault((parcelRequire("dP1T5")));

var $d537d4126537ab9d$var$_divWithClassName = $d537d4126537ab9d$var$_interopRequireDefault((parcelRequire("734S2")));

var $d537d4126537ab9d$var$_CardImg = $d537d4126537ab9d$var$_interopRequireDefault((parcelRequire("f7rri")));
function $d537d4126537ab9d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $d537d4126537ab9d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d537d4126537ab9d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d537d4126537ab9d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d537d4126537ab9d$var$DivStyledAsH5 = (0, $d537d4126537ab9d$var$_divWithClassName["default"])("h5");
var $d537d4126537ab9d$var$DivStyledAsH6 = (0, $d537d4126537ab9d$var$_divWithClassName["default"])("h6");
var $d537d4126537ab9d$var$CardBody = (0, $d537d4126537ab9d$var$_createWithBsPrefix["default"])("card-body");
var $d537d4126537ab9d$var$Card = function Card(_ref) {
    var children = _ref.children, props = $d537d4126537ab9d$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $d537d4126537ab9d$var$_react["default"].createElement($d537d4126537ab9d$var$_Card["default"], props, children);
};
$d537d4126537ab9d$exports.Card = $d537d4126537ab9d$var$Card;
$d537d4126537ab9d$var$Card.propTypes = {
    /**
   * Change the underlying component CSS base class name and modifier class names prefix
   *
   * default 'card'
   */ bsPrefix: $d537d4126537ab9d$var$_propTypes["default"].string,
    /**
   * Sets card background
   * `"primary"` `"secondary"` `"success"` `"danger"` `"warning"` `"info"` `"dark"`
   */ bg: $d537d4126537ab9d$var$_propTypes["default"].string,
    /**
   * Sets card text color
   *
   * `"primary"` `"secondary"` `"success"` `"danger"` `"warning"` `"info"` `"white"` `"light"` `"dark"`
   */ text: $d537d4126537ab9d$var$_propTypes["default"].string,
    /**
   * Sets card border color
   *
   * `"primary"` `"secondary"` `"success"` `"danger"` `"warning"` `"info"` `"dark"`
   */ border: $d537d4126537ab9d$var$_propTypes["default"].string,
    /**
   * When this prop is set, it creates a Card with a Card.Body inside
   * passing the children directly to it
   */ body: $d537d4126537ab9d$var$_propTypes["default"].bool,
    /** Set a custom element for this component */ as: $d537d4126537ab9d$var$_propTypes["default"].elementType
};
$d537d4126537ab9d$var$Card.Img = $d537d4126537ab9d$var$_CardImg["default"];
$d537d4126537ab9d$var$Card.Title = (0, $d537d4126537ab9d$var$_createWithBsPrefix["default"])("card-title", {
    Component: $d537d4126537ab9d$var$DivStyledAsH5
});
$d537d4126537ab9d$var$Card.Subtitle = (0, $d537d4126537ab9d$var$_createWithBsPrefix["default"])("card-subtitle", {
    Component: $d537d4126537ab9d$var$DivStyledAsH6
});
$d537d4126537ab9d$var$Card.Body = $d537d4126537ab9d$var$CardBody;
$d537d4126537ab9d$var$Card.Link = (0, $d537d4126537ab9d$var$_createWithBsPrefix["default"])("card-link", {
    Component: "a"
});
$d537d4126537ab9d$var$Card.Text = (0, $d537d4126537ab9d$var$_createWithBsPrefix["default"])("card-text", {
    Component: "p"
});
$d537d4126537ab9d$var$Card.Header = (0, $d537d4126537ab9d$var$_createWithBsPrefix["default"])("card-header");
$d537d4126537ab9d$var$Card.Footer = (0, $d537d4126537ab9d$var$_createWithBsPrefix["default"])("card-footer");
$d537d4126537ab9d$var$Card.ImgOverlay = (0, $d537d4126537ab9d$var$_createWithBsPrefix["default"])("card-img-overlay");




var $e4d10c195820bf5d$exports = {};
"use strict";
Object.defineProperty($e4d10c195820bf5d$exports, "__esModule", {
    value: true
});
Object.defineProperty($e4d10c195820bf5d$exports, "ChartsGraphs", {
    enumerable: true,
    get: function get() {
        return $a0fc5fd1e2398f62$exports.ChartsGraphs;
    }
});
var $a0fc5fd1e2398f62$exports = {};
"use strict";
Object.defineProperty($a0fc5fd1e2398f62$exports, "__esModule", {
    value: true
});
$a0fc5fd1e2398f62$exports.ChartsGraphs = void 0;

var $a0fc5fd1e2398f62$var$_react = $a0fc5fd1e2398f62$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $a0fc5fd1e2398f62$var$_propTypes = $a0fc5fd1e2398f62$var$_interopRequireDefault((parcelRequire("d2bgE")));
var $a2aa24e69de8df16$exports = {};
"use strict";
Object.defineProperty($a2aa24e69de8df16$exports, "__esModule", {
    value: true
});
Object.defineProperty($a2aa24e69de8df16$exports, "Chart", {
    enumerable: true,
    get: function get() {
        return $a2aa24e69de8df16$var$_chart["default"];
    }
});
$a2aa24e69de8df16$exports.defaults = $a2aa24e69de8df16$exports.Scatter = $a2aa24e69de8df16$exports.Bubble = $a2aa24e69de8df16$exports.Polar = $a2aa24e69de8df16$exports.Radar = $a2aa24e69de8df16$exports.HorizontalBar = $a2aa24e69de8df16$exports.Bar = $a2aa24e69de8df16$exports.Line = $a2aa24e69de8df16$exports.Pie = $a2aa24e69de8df16$exports.Doughnut = $a2aa24e69de8df16$exports["default"] = void 0;

var $a2aa24e69de8df16$var$_react = $a2aa24e69de8df16$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $a2aa24e69de8df16$var$_propTypes = $a2aa24e69de8df16$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $a2aa24e69de8df16$var$_chart = $a2aa24e69de8df16$var$_interopRequireDefault((parcelRequire("d8VTR")));

var $a2aa24e69de8df16$var$_isEqual = $a2aa24e69de8df16$var$_interopRequireDefault((parcelRequire("18li2")));

var $a2aa24e69de8df16$var$_keyBy = $a2aa24e69de8df16$var$_interopRequireDefault((parcelRequire("g3rS6")));
function $a2aa24e69de8df16$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a2aa24e69de8df16$var$_extends() {
    $a2aa24e69de8df16$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a2aa24e69de8df16$var$_extends.apply(this, arguments);
}
function $a2aa24e69de8df16$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a2aa24e69de8df16$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a2aa24e69de8df16$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a2aa24e69de8df16$var$_typeof(obj);
}
function $a2aa24e69de8df16$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a2aa24e69de8df16$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a2aa24e69de8df16$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a2aa24e69de8df16$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a2aa24e69de8df16$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a2aa24e69de8df16$var$ownKeys(Object(source), true).forEach(function(key) {
            $a2aa24e69de8df16$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a2aa24e69de8df16$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a2aa24e69de8df16$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a2aa24e69de8df16$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a2aa24e69de8df16$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a2aa24e69de8df16$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a2aa24e69de8df16$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $a2aa24e69de8df16$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $a2aa24e69de8df16$var$_setPrototypeOf(subClass, superClass);
}
function $a2aa24e69de8df16$var$_setPrototypeOf(o, p) {
    $a2aa24e69de8df16$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a2aa24e69de8df16$var$_setPrototypeOf(o, p);
}
function $a2aa24e69de8df16$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a2aa24e69de8df16$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $a2aa24e69de8df16$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $a2aa24e69de8df16$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a2aa24e69de8df16$var$_possibleConstructorReturn(this, result);
    };
}
function $a2aa24e69de8df16$var$_possibleConstructorReturn(self, call) {
    if (call && ($a2aa24e69de8df16$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $a2aa24e69de8df16$var$_assertThisInitialized(self);
}
function $a2aa24e69de8df16$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a2aa24e69de8df16$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a2aa24e69de8df16$var$_getPrototypeOf(o) {
    $a2aa24e69de8df16$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a2aa24e69de8df16$var$_getPrototypeOf(o);
}
function $a2aa24e69de8df16$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $a2aa24e69de8df16$var$NODE_ENV = false;
var $a2aa24e69de8df16$var$ChartComponent = /*#__PURE__*/ function(_React$Component) {
    $a2aa24e69de8df16$var$_inherits(ChartComponent, _React$Component);
    var _super = $a2aa24e69de8df16$var$_createSuper(ChartComponent);
    function ChartComponent() {
        var _this;
        $a2aa24e69de8df16$var$_classCallCheck(this, ChartComponent);
        _this = _super.call(this);
        $a2aa24e69de8df16$var$_defineProperty($a2aa24e69de8df16$var$_assertThisInitialized(_this), "handleOnClick", function(event) {
            var instance = _this.chartInstance;
            var _this$props = _this.props, getDatasetAtEvent = _this$props.getDatasetAtEvent, getElementAtEvent = _this$props.getElementAtEvent, getElementsAtEvent = _this$props.getElementsAtEvent, onElementsClick = _this$props.onElementsClick;
            getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
            getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
            getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
            onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
        });
        $a2aa24e69de8df16$var$_defineProperty($a2aa24e69de8df16$var$_assertThisInitialized(_this), "ref", function(element) {
            _this.element = element;
        });
        _this.chartInstance = undefined;
        return _this;
    }
    $a2aa24e69de8df16$var$_createClass(ChartComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.renderChart();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this.props.redraw) {
                    this.destroyChart();
                    this.renderChart();
                    return;
                }
                this.updateChart();
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var _this$props2 = this.props, redraw = _this$props2.redraw, type = _this$props2.type, options = _this$props2.options, plugins = _this$props2.plugins, legend = _this$props2.legend, height = _this$props2.height, width = _this$props2.width;
                if (nextProps.redraw === true) return true;
                if (height !== nextProps.height || width !== nextProps.width) return true;
                if (type !== nextProps.type) return true;
                if (!(0, $a2aa24e69de8df16$var$_isEqual["default"])(legend, nextProps.legend)) return true;
                if (!(0, $a2aa24e69de8df16$var$_isEqual["default"])(options, nextProps.options)) return true;
                var nextData = this.transformDataProp(nextProps);
                if (!(0, $a2aa24e69de8df16$var$_isEqual["default"])(this.shadowDataProp, nextData)) return true;
                return !(0, $a2aa24e69de8df16$var$_isEqual["default"])(plugins, nextProps.plugins);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.destroyChart();
            }
        },
        {
            key: "transformDataProp",
            value: function transformDataProp(props) {
                var data = props.data;
                if (typeof data == 'function') {
                    var node = this.element;
                    return data(node);
                } else return data;
            } // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
        },
        {
            key: "memoizeDataProps",
            value: function memoizeDataProps() {
                if (!this.props.data) return;
                var data = this.transformDataProp(this.props);
                this.shadowDataProp = $a2aa24e69de8df16$var$_objectSpread($a2aa24e69de8df16$var$_objectSpread({}, data), {}, {
                    datasets: data.datasets && data.datasets.map(function(set) {
                        return $a2aa24e69de8df16$var$_objectSpread({}, set);
                    })
                });
                this.saveCurrentDatasets(); // to remove the dataset metadata from this chart when the chart is destroyed
                return data;
            }
        },
        {
            key: "checkDatasets",
            value: function checkDatasets(datasets) {
                var isDev = $a2aa24e69de8df16$var$NODE_ENV !== 'production' && $a2aa24e69de8df16$var$NODE_ENV !== 'prod';
                var usingCustomKeyProvider = this.props.datasetKeyProvider !== ChartComponent.getLabelAsKey;
                var multipleDatasets = datasets.length > 1;
                if (isDev && multipleDatasets && !usingCustomKeyProvider) {
                    var shouldWarn = false;
                    datasets.forEach(function(dataset) {
                        if (!dataset.label) shouldWarn = true;
                    });
                    if (shouldWarn) console.error('[react-chartjs-2] Warning: Each dataset needs a unique key. By default, the "label" property on each dataset is used. Alternatively, you may provide a "datasetKeyProvider" as a prop that returns a unique key.');
                }
            }
        },
        {
            key: "getCurrentDatasets",
            value: function getCurrentDatasets() {
                return this.chartInstance && this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
            }
        },
        {
            key: "saveCurrentDatasets",
            value: function saveCurrentDatasets() {
                var _this2 = this;
                this.datasets = this.datasets || {};
                var currentDatasets = this.getCurrentDatasets();
                currentDatasets.forEach(function(d) {
                    _this2.datasets[_this2.props.datasetKeyProvider(d)] = d;
                });
            }
        },
        {
            key: "updateChart",
            value: function updateChart() {
                var _this3 = this;
                var options = this.props.options;
                var data = this.memoizeDataProps(this.props);
                if (!this.chartInstance) return;
                if (options) this.chartInstance.options = $a2aa24e69de8df16$var$_chart["default"].helpers.configMerge(this.chartInstance.options, options);
                 // Pipe datasets to chart instance datasets enabling
                // seamless transitions
                var currentDatasets = this.getCurrentDatasets();
                var nextDatasets = data.datasets || [];
                this.checkDatasets(currentDatasets);
                var currentDatasetsIndexed = (0, $a2aa24e69de8df16$var$_keyBy["default"])(currentDatasets, this.props.datasetKeyProvider); // We can safely replace the dataset array, as long as we retain the _meta property
                // on each dataset.
                this.chartInstance.config.data.datasets = nextDatasets.map(function(next) {
                    var current = currentDatasetsIndexed[_this3.props.datasetKeyProvider(next)];
                    if (current && current.type === next.type && next.data) {
                        // Be robust to no data. Relevant for other update mechanisms as in chartjs-plugin-streaming.
                        // The data array must be edited in place. As chart.js adds listeners to it.
                        current.data.splice(next.data.length);
                        next.data.forEach(function(point, pid) {
                            current.data[pid] = next.data[pid];
                        });
                        var _data = next.data, otherProps = $a2aa24e69de8df16$var$_objectWithoutProperties(next, [
                            "data"
                        ]); // Merge properties. Notice a weakness here. If a property is removed
                        // from next, it will be retained by current and never disappears.
                        // Workaround is to set value to null or undefined in next.
                        return $a2aa24e69de8df16$var$_objectSpread($a2aa24e69de8df16$var$_objectSpread({}, current), otherProps);
                    } else return next;
                });
                var datasets = data.datasets, rest = $a2aa24e69de8df16$var$_objectWithoutProperties(data, [
                    "datasets"
                ]);
                this.chartInstance.config.data = $a2aa24e69de8df16$var$_objectSpread($a2aa24e69de8df16$var$_objectSpread({}, this.chartInstance.config.data), rest);
                this.chartInstance.update();
            }
        },
        {
            key: "renderChart",
            value: function renderChart() {
                var _this$props3 = this.props, options = _this$props3.options, legend = _this$props3.legend, type = _this$props3.type, plugins = _this$props3.plugins;
                var node = this.element;
                var data = this.memoizeDataProps();
                if (typeof legend !== 'undefined' && !(0, $a2aa24e69de8df16$var$_isEqual["default"])(ChartComponent.defaultProps.legend, legend)) options.legend = legend;
                this.chartInstance = new $a2aa24e69de8df16$var$_chart["default"](node, {
                    type: type,
                    data: data,
                    options: options,
                    plugins: plugins
                });
            }
        },
        {
            key: "destroyChart",
            value: function destroyChart() {
                if (!this.chartInstance) return;
                 // Put all of the datasets that have existed in the chart back on the chart
                // so that the metadata associated with this chart get destroyed.
                // This allows the datasets to be used in another chart. This can happen,
                // for example, in a tabbed UI where the chart gets created each time the
                // tab gets switched to the chart and uses the same data).
                this.saveCurrentDatasets();
                var datasets = Object.values(this.datasets);
                this.chartInstance.config.data.datasets = datasets;
                this.chartInstance.destroy();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, height = _this$props4.height, width = _this$props4.width, id = _this$props4.id;
                return /*#__PURE__*/ $a2aa24e69de8df16$var$_react["default"].createElement("canvas", {
                    ref: this.ref,
                    height: height,
                    width: width,
                    id: id,
                    onClick: this.handleOnClick
                });
            }
        }
    ]);
    return ChartComponent;
}($a2aa24e69de8df16$var$_react["default"].Component);
$a2aa24e69de8df16$var$_defineProperty($a2aa24e69de8df16$var$ChartComponent, "getLabelAsKey", function(d) {
    return d.label;
});
$a2aa24e69de8df16$var$_defineProperty($a2aa24e69de8df16$var$ChartComponent, "propTypes", {
    data: $a2aa24e69de8df16$var$_propTypes["default"].oneOfType([
        $a2aa24e69de8df16$var$_propTypes["default"].object,
        $a2aa24e69de8df16$var$_propTypes["default"].func
    ]).isRequired,
    getDatasetAtEvent: $a2aa24e69de8df16$var$_propTypes["default"].func,
    getElementAtEvent: $a2aa24e69de8df16$var$_propTypes["default"].func,
    getElementsAtEvent: $a2aa24e69de8df16$var$_propTypes["default"].func,
    height: $a2aa24e69de8df16$var$_propTypes["default"].number,
    legend: $a2aa24e69de8df16$var$_propTypes["default"].object,
    onElementsClick: $a2aa24e69de8df16$var$_propTypes["default"].func,
    options: $a2aa24e69de8df16$var$_propTypes["default"].object,
    plugins: $a2aa24e69de8df16$var$_propTypes["default"].arrayOf($a2aa24e69de8df16$var$_propTypes["default"].object),
    redraw: $a2aa24e69de8df16$var$_propTypes["default"].bool,
    type: function type(props, propName, componentName) {
        if (!$a2aa24e69de8df16$var$_chart["default"].controllers[props[propName]]) return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
    },
    width: $a2aa24e69de8df16$var$_propTypes["default"].number,
    datasetKeyProvider: $a2aa24e69de8df16$var$_propTypes["default"].func
});
$a2aa24e69de8df16$var$_defineProperty($a2aa24e69de8df16$var$ChartComponent, "defaultProps", {
    legend: {
        display: true,
        position: 'bottom'
    },
    type: 'doughnut',
    height: 150,
    width: 300,
    redraw: false,
    options: {},
    datasetKeyProvider: $a2aa24e69de8df16$var$ChartComponent.getLabelAsKey
});
var $a2aa24e69de8df16$var$_default = $a2aa24e69de8df16$var$ChartComponent;
$a2aa24e69de8df16$exports["default"] = $a2aa24e69de8df16$var$_default;
var $a2aa24e69de8df16$var$Doughnut = /*#__PURE__*/ function(_React$Component2) {
    $a2aa24e69de8df16$var$_inherits(Doughnut, _React$Component2);
    var _super2 = $a2aa24e69de8df16$var$_createSuper(Doughnut);
    function Doughnut() {
        $a2aa24e69de8df16$var$_classCallCheck(this, Doughnut);
        return _super2.apply(this, arguments);
    }
    $a2aa24e69de8df16$var$_createClass(Doughnut, [
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                return /*#__PURE__*/ $a2aa24e69de8df16$var$_react["default"].createElement($a2aa24e69de8df16$var$ChartComponent, $a2aa24e69de8df16$var$_extends({}, this.props, {
                    ref: function ref(_ref) {
                        return _this4.chartInstance = _ref && _ref.chartInstance;
                    },
                    type: "doughnut"
                }));
            }
        }
    ]);
    return Doughnut;
}($a2aa24e69de8df16$var$_react["default"].Component);
$a2aa24e69de8df16$exports.Doughnut = $a2aa24e69de8df16$var$Doughnut;
var $a2aa24e69de8df16$var$Pie = /*#__PURE__*/ function(_React$Component3) {
    $a2aa24e69de8df16$var$_inherits(Pie, _React$Component3);
    var _super3 = $a2aa24e69de8df16$var$_createSuper(Pie);
    function Pie() {
        $a2aa24e69de8df16$var$_classCallCheck(this, Pie);
        return _super3.apply(this, arguments);
    }
    $a2aa24e69de8df16$var$_createClass(Pie, [
        {
            key: "render",
            value: function render() {
                var _this5 = this;
                return /*#__PURE__*/ $a2aa24e69de8df16$var$_react["default"].createElement($a2aa24e69de8df16$var$ChartComponent, $a2aa24e69de8df16$var$_extends({}, this.props, {
                    ref: function ref(_ref2) {
                        return _this5.chartInstance = _ref2 && _ref2.chartInstance;
                    },
                    type: "pie"
                }));
            }
        }
    ]);
    return Pie;
}($a2aa24e69de8df16$var$_react["default"].Component);
$a2aa24e69de8df16$exports.Pie = $a2aa24e69de8df16$var$Pie;
var $a2aa24e69de8df16$var$Line = /*#__PURE__*/ function(_React$Component4) {
    $a2aa24e69de8df16$var$_inherits(Line, _React$Component4);
    var _super4 = $a2aa24e69de8df16$var$_createSuper(Line);
    function Line() {
        $a2aa24e69de8df16$var$_classCallCheck(this, Line);
        return _super4.apply(this, arguments);
    }
    $a2aa24e69de8df16$var$_createClass(Line, [
        {
            key: "render",
            value: function render() {
                var _this6 = this;
                return /*#__PURE__*/ $a2aa24e69de8df16$var$_react["default"].createElement($a2aa24e69de8df16$var$ChartComponent, $a2aa24e69de8df16$var$_extends({}, this.props, {
                    ref: function ref(_ref3) {
                        return _this6.chartInstance = _ref3 && _ref3.chartInstance;
                    },
                    type: "line"
                }));
            }
        }
    ]);
    return Line;
}($a2aa24e69de8df16$var$_react["default"].Component);
$a2aa24e69de8df16$exports.Line = $a2aa24e69de8df16$var$Line;
var $a2aa24e69de8df16$var$Bar = /*#__PURE__*/ function(_React$Component5) {
    $a2aa24e69de8df16$var$_inherits(Bar, _React$Component5);
    var _super5 = $a2aa24e69de8df16$var$_createSuper(Bar);
    function Bar() {
        $a2aa24e69de8df16$var$_classCallCheck(this, Bar);
        return _super5.apply(this, arguments);
    }
    $a2aa24e69de8df16$var$_createClass(Bar, [
        {
            key: "render",
            value: function render() {
                var _this7 = this;
                return /*#__PURE__*/ $a2aa24e69de8df16$var$_react["default"].createElement($a2aa24e69de8df16$var$ChartComponent, $a2aa24e69de8df16$var$_extends({}, this.props, {
                    ref: function ref(_ref4) {
                        return _this7.chartInstance = _ref4 && _ref4.chartInstance;
                    },
                    type: "bar"
                }));
            }
        }
    ]);
    return Bar;
}($a2aa24e69de8df16$var$_react["default"].Component);
$a2aa24e69de8df16$exports.Bar = $a2aa24e69de8df16$var$Bar;
var $a2aa24e69de8df16$var$HorizontalBar = /*#__PURE__*/ function(_React$Component6) {
    $a2aa24e69de8df16$var$_inherits(HorizontalBar, _React$Component6);
    var _super6 = $a2aa24e69de8df16$var$_createSuper(HorizontalBar);
    function HorizontalBar() {
        $a2aa24e69de8df16$var$_classCallCheck(this, HorizontalBar);
        return _super6.apply(this, arguments);
    }
    $a2aa24e69de8df16$var$_createClass(HorizontalBar, [
        {
            key: "render",
            value: function render() {
                var _this8 = this;
                return /*#__PURE__*/ $a2aa24e69de8df16$var$_react["default"].createElement($a2aa24e69de8df16$var$ChartComponent, $a2aa24e69de8df16$var$_extends({}, this.props, {
                    ref: function ref(_ref5) {
                        return _this8.chartInstance = _ref5 && _ref5.chartInstance;
                    },
                    type: "horizontalBar"
                }));
            }
        }
    ]);
    return HorizontalBar;
}($a2aa24e69de8df16$var$_react["default"].Component);
$a2aa24e69de8df16$exports.HorizontalBar = $a2aa24e69de8df16$var$HorizontalBar;
var $a2aa24e69de8df16$var$Radar = /*#__PURE__*/ function(_React$Component7) {
    $a2aa24e69de8df16$var$_inherits(Radar, _React$Component7);
    var _super7 = $a2aa24e69de8df16$var$_createSuper(Radar);
    function Radar() {
        $a2aa24e69de8df16$var$_classCallCheck(this, Radar);
        return _super7.apply(this, arguments);
    }
    $a2aa24e69de8df16$var$_createClass(Radar, [
        {
            key: "render",
            value: function render() {
                var _this9 = this;
                return /*#__PURE__*/ $a2aa24e69de8df16$var$_react["default"].createElement($a2aa24e69de8df16$var$ChartComponent, $a2aa24e69de8df16$var$_extends({}, this.props, {
                    ref: function ref(_ref6) {
                        return _this9.chartInstance = _ref6 && _ref6.chartInstance;
                    },
                    type: "radar"
                }));
            }
        }
    ]);
    return Radar;
}($a2aa24e69de8df16$var$_react["default"].Component);
$a2aa24e69de8df16$exports.Radar = $a2aa24e69de8df16$var$Radar;
var $a2aa24e69de8df16$var$Polar = /*#__PURE__*/ function(_React$Component8) {
    $a2aa24e69de8df16$var$_inherits(Polar, _React$Component8);
    var _super8 = $a2aa24e69de8df16$var$_createSuper(Polar);
    function Polar() {
        $a2aa24e69de8df16$var$_classCallCheck(this, Polar);
        return _super8.apply(this, arguments);
    }
    $a2aa24e69de8df16$var$_createClass(Polar, [
        {
            key: "render",
            value: function render() {
                var _this10 = this;
                return /*#__PURE__*/ $a2aa24e69de8df16$var$_react["default"].createElement($a2aa24e69de8df16$var$ChartComponent, $a2aa24e69de8df16$var$_extends({}, this.props, {
                    ref: function ref(_ref7) {
                        return _this10.chartInstance = _ref7 && _ref7.chartInstance;
                    },
                    type: "polarArea"
                }));
            }
        }
    ]);
    return Polar;
}($a2aa24e69de8df16$var$_react["default"].Component);
$a2aa24e69de8df16$exports.Polar = $a2aa24e69de8df16$var$Polar;
var $a2aa24e69de8df16$var$Bubble = /*#__PURE__*/ function(_React$Component9) {
    $a2aa24e69de8df16$var$_inherits(Bubble, _React$Component9);
    var _super9 = $a2aa24e69de8df16$var$_createSuper(Bubble);
    function Bubble() {
        $a2aa24e69de8df16$var$_classCallCheck(this, Bubble);
        return _super9.apply(this, arguments);
    }
    $a2aa24e69de8df16$var$_createClass(Bubble, [
        {
            key: "render",
            value: function render() {
                var _this11 = this;
                return /*#__PURE__*/ $a2aa24e69de8df16$var$_react["default"].createElement($a2aa24e69de8df16$var$ChartComponent, $a2aa24e69de8df16$var$_extends({}, this.props, {
                    ref: function ref(_ref8) {
                        return _this11.chartInstance = _ref8 && _ref8.chartInstance;
                    },
                    type: "bubble"
                }));
            }
        }
    ]);
    return Bubble;
}($a2aa24e69de8df16$var$_react["default"].Component);
$a2aa24e69de8df16$exports.Bubble = $a2aa24e69de8df16$var$Bubble;
var $a2aa24e69de8df16$var$Scatter = /*#__PURE__*/ function(_React$Component10) {
    $a2aa24e69de8df16$var$_inherits(Scatter, _React$Component10);
    var _super10 = $a2aa24e69de8df16$var$_createSuper(Scatter);
    function Scatter() {
        $a2aa24e69de8df16$var$_classCallCheck(this, Scatter);
        return _super10.apply(this, arguments);
    }
    $a2aa24e69de8df16$var$_createClass(Scatter, [
        {
            key: "render",
            value: function render() {
                var _this12 = this;
                return /*#__PURE__*/ $a2aa24e69de8df16$var$_react["default"].createElement($a2aa24e69de8df16$var$ChartComponent, $a2aa24e69de8df16$var$_extends({}, this.props, {
                    ref: function ref(_ref9) {
                        return _this12.chartInstance = _ref9 && _ref9.chartInstance;
                    },
                    type: "scatter"
                }));
            }
        }
    ]);
    return Scatter;
}($a2aa24e69de8df16$var$_react["default"].Component);
$a2aa24e69de8df16$exports.Scatter = $a2aa24e69de8df16$var$Scatter;
var $a2aa24e69de8df16$var$defaults = $a2aa24e69de8df16$var$_chart["default"].defaults;
$a2aa24e69de8df16$exports.defaults = $a2aa24e69de8df16$var$defaults;


function $a0fc5fd1e2398f62$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $a0fc5fd1e2398f62$var$_extends() {
    $a0fc5fd1e2398f62$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a0fc5fd1e2398f62$var$_extends.apply(this, arguments);
}
function $a0fc5fd1e2398f62$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a0fc5fd1e2398f62$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a0fc5fd1e2398f62$var$ownKeys(Object(source), true).forEach(function(key) {
            $a0fc5fd1e2398f62$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a0fc5fd1e2398f62$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a0fc5fd1e2398f62$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a0fc5fd1e2398f62$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a0fc5fd1e2398f62$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a0fc5fd1e2398f62$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a0fc5fd1e2398f62$var$_typeof(obj);
}
// Set defaults.
$a2aa24e69de8df16$exports.defaults.global.responsive = true;
$a2aa24e69de8df16$exports.defaults.global.maintainAspectRatio = false;
var $a0fc5fd1e2398f62$var$colors = [
    "#367C2B",
    "#FFDE00",
    "#BAB994",
    "#333333",
    "#FFB000",
    "#E5E6E6",
    "#717A80",
    "#FFF494",
    "#A3AE58"
];
var $a0fc5fd1e2398f62$var$typeCheck = function typeCheck(o) {
    return typeof o !== "undefined" && o !== null;
}; // Commons for bar and horizontal bar chart.
var $a0fc5fd1e2398f62$var$barDataTypeCommons = function barDataTypeCommons(props) {
    var colorIndex = 0;
    var data = props.data.datasets && props.data.datasets.map(function(dataset) {
        !$a0fc5fd1e2398f62$var$typeCheck(dataset.backgroundColor) && (dataset.backgroundColor = $a0fc5fd1e2398f62$var$colors);
    });
    var options = props.options && $a0fc5fd1e2398f62$var$_typeof(props.options) === "object" && $a0fc5fd1e2398f62$var$_objectSpread({}, props.options);
    $a0fc5fd1e2398f62$var$typeCheck(props.legend) && /* this type check insures there is not a legend and is not displayed */ (props.legend.display = false);
    return {
        data: data,
        options: options
    };
};
var $a0fc5fd1e2398f62$var$ChartsGraphs = function ChartsGraphs(props) {
    var dataType = {
        bar: function bar() {
            var _barDataTypeCommons = $a0fc5fd1e2398f62$var$barDataTypeCommons(props), data = _barDataTypeCommons.data, options = _barDataTypeCommons.options;
            return /*#__PURE__*/ $a0fc5fd1e2398f62$var$_react["default"].createElement("div", {
                className: "position-relative"
            }, /*#__PURE__*/ $a0fc5fd1e2398f62$var$_react["default"].createElement($a2aa24e69de8df16$exports.Bar, $a0fc5fd1e2398f62$var$_extends({
                data: true,
                options: options
            }, props)));
        },
        horizontalBar: function horizontalBar() {
            var _barDataTypeCommons2 = $a0fc5fd1e2398f62$var$barDataTypeCommons(props), data = _barDataTypeCommons2.data, options = _barDataTypeCommons2.options;
            return /*#__PURE__*/ $a0fc5fd1e2398f62$var$_react["default"].createElement("div", {
                className: "position-relative"
            }, /*#__PURE__*/ $a0fc5fd1e2398f62$var$_react["default"].createElement($a2aa24e69de8df16$exports.HorizontalBar, $a0fc5fd1e2398f62$var$_extends({
                data: true,
                options: options
            }, props)));
        },
        line: function line() {
            var colorIndex = 0;
            var data = props.data.datasets && props.data.datasets.map(function(dataset) {
                var incrementBrandColor = false;
                if (!dataset.borderColor) {
                    dataset.borderColor = $a0fc5fd1e2398f62$var$colors[colorIndex];
                    incrementBrandColor = true;
                }
                if (!dataset.backgroundColor) {
                    dataset.backgroundColor = $a0fc5fd1e2398f62$var$colors[colorIndex];
                    incrementBrandColor = true;
                }
                !dataset.fill && (dataset.fill = false);
                incrementBrandColor && (colorIndex = $a0fc5fd1e2398f62$var$colors[colorIndex + 1] ? colorIndex + 1 : 0);
            });
            return /*#__PURE__*/ $a0fc5fd1e2398f62$var$_react["default"].createElement("div", {
                className: "position-relative"
            }, /*#__PURE__*/ $a0fc5fd1e2398f62$var$_react["default"].createElement($a2aa24e69de8df16$exports.Line, $a0fc5fd1e2398f62$var$_extends({
                data: true,
                options: true
            }, props)));
        },
        pie: function pie() {
            var data = props.data.datasets && props.data.datasets.map(function(dataset) {
                return (dataset.backgroundColor === undefined || dataset.backgroundColor === null) && (dataset.backgroundColor = $a0fc5fd1e2398f62$var$colors);
            });
            return /*#__PURE__*/ $a0fc5fd1e2398f62$var$_react["default"].createElement("div", {
                className: "position-relative"
            }, /*#__PURE__*/ $a0fc5fd1e2398f62$var$_react["default"].createElement($a2aa24e69de8df16$exports.Pie, $a0fc5fd1e2398f62$var$_extends({
                data: true,
                options: true
            }, props)));
        },
        doughnut: function doughnut() {
            var data = props.data.datasets && props.data.datasets.map(function(dataset) {
                return (dataset.backgroundColor === undefined || dataset.backgroundColor === null) && (dataset.backgroundColor = $a0fc5fd1e2398f62$var$colors);
            });
            return /*#__PURE__*/ $a0fc5fd1e2398f62$var$_react["default"].createElement("div", {
                className: "position-relative"
            }, /*#__PURE__*/ $a0fc5fd1e2398f62$var$_react["default"].createElement($a2aa24e69de8df16$exports.Doughnut, $a0fc5fd1e2398f62$var$_extends({
                data: true,
                options: true
            }, props)));
        }
    };
    var Component = dataType[props.type];
    return /*#__PURE__*/ $a0fc5fd1e2398f62$var$_react["default"].createElement(Component, null);
};
$a0fc5fd1e2398f62$exports.ChartsGraphs = $a0fc5fd1e2398f62$var$ChartsGraphs;
$a0fc5fd1e2398f62$var$ChartsGraphs.propTypes = {
    /**
   * The type of Chart/Graph to generate
   * @type {('bar'|'horizontalBar'|'line'|'pie'|'doughnut')}
   */ type: $a0fc5fd1e2398f62$var$_propTypes["default"].oneOf([
        "bar",
        "horizontalBar",
        "line",
        "pie",
        "doughnut"
    ]).isRequired,
    /**
   * Object passed that includes data to display on Chart/Graph
   */ data: $a0fc5fd1e2398f62$var$_propTypes["default"].object.isRequired,
    /**
   * Configuration options provided by Chart.js
   */ options: $a0fc5fd1e2398f62$var$_propTypes["default"].object,
    /**
   * Plugins that will be registered to this chart (check the [Chart.js documentation](https://www.chartjs.org/docs/2.7.3/developers/plugins.html) for more info)
   */ plugins: $a0fc5fd1e2398f62$var$_propTypes["default"].object
};




var $97926ea47e1ed60f$exports = {};
"use strict";
Object.defineProperty($97926ea47e1ed60f$exports, "__esModule", {
    value: true
});
Object.defineProperty($97926ea47e1ed60f$exports, "Checkbox", {
    enumerable: true,
    get: function get() {
        return $08b429da6f013ad6$exports.Checkbox;
    }
});
var $08b429da6f013ad6$exports = {};
"use strict";
Object.defineProperty($08b429da6f013ad6$exports, "__esModule", {
    value: true
});
$08b429da6f013ad6$exports.Checkbox = void 0;

var $08b429da6f013ad6$var$_react = $08b429da6f013ad6$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $08b429da6f013ad6$var$_propTypes = $08b429da6f013ad6$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $08b429da6f013ad6$var$_Form = $08b429da6f013ad6$var$_interopRequireDefault((parcelRequire("9EiVH")));
function $08b429da6f013ad6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $08b429da6f013ad6$var$_extends() {
    $08b429da6f013ad6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $08b429da6f013ad6$var$_extends.apply(this, arguments);
}
function $08b429da6f013ad6$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $08b429da6f013ad6$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $08b429da6f013ad6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $08b429da6f013ad6$var$Checkbox = function Checkbox(_ref) {
    var children = _ref.children, props = $08b429da6f013ad6$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $08b429da6f013ad6$var$_react["default"].createElement($08b429da6f013ad6$var$_Form["default"].Check, $08b429da6f013ad6$var$_extends({
        custom: true
    }, props));
};
$08b429da6f013ad6$exports.Checkbox = $08b429da6f013ad6$var$Checkbox;
$08b429da6f013ad6$var$Checkbox.propTypes = {
    /**
   * The underlying HTML element to use when rendering the Checkbox.
   *
   * @type {('input'|elementType)}
   */ as: $08b429da6f013ad6$var$_propTypes["default"].elementType,
    /** A HTML id attribute, necessary for proper form accessibility. */ id: $08b429da6f013ad6$var$_propTypes["default"].string,
    inline: $08b429da6f013ad6$var$_propTypes["default"].bool,
    disabled: $08b429da6f013ad6$var$_propTypes["default"].bool,
    title: $08b429da6f013ad6$var$_propTypes["default"].string,
    /** A label, necessary for proper form accessibility. */ label: $08b429da6f013ad6$var$_propTypes["default"].node,
    /** Manually style the input as valid */ isValid: $08b429da6f013ad6$var$_propTypes["default"].bool,
    /** Manually style the input as invalid */ isInvalid: $08b429da6f013ad6$var$_propTypes["default"].bool,
    /** Display feedback as a tooltip. */ feedbackTooltip: $08b429da6f013ad6$var$_propTypes["default"].bool,
    /** A message to display when the input is in a validation state */ feedback: $08b429da6f013ad6$var$_propTypes["default"].node
};




var $d47f5a20d5173fdb$exports = {};
"use strict";
Object.defineProperty($d47f5a20d5173fdb$exports, "__esModule", {
    value: true
});
Object.defineProperty($d47f5a20d5173fdb$exports, "Col", {
    enumerable: true,
    get: function get() {
        return $8f138cc4034e646e$exports.Col;
    }
});
var $8f138cc4034e646e$exports = {};
"use strict";
Object.defineProperty($8f138cc4034e646e$exports, "__esModule", {
    value: true
});
$8f138cc4034e646e$exports.Col = void 0;

var $8f138cc4034e646e$var$_react = $8f138cc4034e646e$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $8f138cc4034e646e$var$_propTypes = $8f138cc4034e646e$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $8f138cc4034e646e$var$_Col = $8f138cc4034e646e$var$_interopRequireDefault((parcelRequire("azEbY")));
function $8f138cc4034e646e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $8f138cc4034e646e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8f138cc4034e646e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8f138cc4034e646e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $8f138cc4034e646e$var$Col = function Col(_ref) {
    var children = _ref.children, props = $8f138cc4034e646e$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $8f138cc4034e646e$var$_react["default"].createElement($8f138cc4034e646e$var$_Col["default"], props, children);
};
$8f138cc4034e646e$exports.Col = $8f138cc4034e646e$var$Col;
var $8f138cc4034e646e$var$colSize = $8f138cc4034e646e$var$_propTypes["default"].oneOfType([
    $8f138cc4034e646e$var$_propTypes["default"].bool,
    $8f138cc4034e646e$var$_propTypes["default"].number,
    $8f138cc4034e646e$var$_propTypes["default"].string,
    $8f138cc4034e646e$var$_propTypes["default"].oneOf([
        "auto"
    ])
]);
var $8f138cc4034e646e$var$stringOrNumber = $8f138cc4034e646e$var$_propTypes["default"].oneOfType([
    $8f138cc4034e646e$var$_propTypes["default"].number,
    $8f138cc4034e646e$var$_propTypes["default"].string
]);
var $8f138cc4034e646e$var$column = $8f138cc4034e646e$var$_propTypes["default"].oneOfType([
    $8f138cc4034e646e$var$colSize,
    $8f138cc4034e646e$var$_propTypes["default"].shape({
        size: $8f138cc4034e646e$var$colSize,
        order: $8f138cc4034e646e$var$stringOrNumber,
        offset: $8f138cc4034e646e$var$stringOrNumber
    })
]);
$8f138cc4034e646e$var$Col.propTypes = {
    /**
   * Change the underlying component CSS base class name and modifier class names prefix
   * @default 'col'
   */ bsPrefix: $8f138cc4034e646e$var$_propTypes["default"].string,
    /** Set a custom element for this component */ as: $8f138cc4034e646e$var$_propTypes["default"].elementType,
    /**
   * The number of columns to span on extra small devices (<576px)
   *
   * @type {(boolean|"auto"|number|{ span: boolean|"auto"|number, offset: number, order: "first"|"last"|number })}
   */ xs: $8f138cc4034e646e$var$column,
    /**
   * The number of columns to span on small devices (≥576px)
   *
   * @type {(boolean|"auto"|number|{ span: boolean|"auto"|number, offset: number, order: "first"|"last"|number })}
   */ sm: $8f138cc4034e646e$var$column,
    /**
   * The number of columns to span on medium devices (≥768px)
   *
   * @type {(boolean|"auto"|number|{ span: boolean|"auto"|number, offset: number, order: "first"|"last"|number })}
   */ md: $8f138cc4034e646e$var$column,
    /**
   * The number of columns to span on large devices (≥992px)
   *
   * @type {(boolean|"auto"|number|{ span: boolean|"auto"|number, offset: number, order: "first"|"last"|number })}
   */ lg: $8f138cc4034e646e$var$column,
    /**
   * The number of columns to span on extra large devices (≥1200px)
   *
   * @type {(boolean|"auto"|number|{ span: boolean|"auto"|number, offset: number, order: "first"|"last"|number })}
   */ xl: $8f138cc4034e646e$var$column
};




var $7731c56aebd43b74$exports = {};
"use strict";
Object.defineProperty($7731c56aebd43b74$exports, "__esModule", {
    value: true
});
Object.defineProperty($7731c56aebd43b74$exports, "Collapse", {
    enumerable: true,
    get: function get() {
        return $298235b6bc761a12$exports.Collapse;
    }
});
var $298235b6bc761a12$exports = {};
"use strict";
Object.defineProperty($298235b6bc761a12$exports, "__esModule", {
    value: true
});
$298235b6bc761a12$exports.Collapse = void 0;

var $298235b6bc761a12$var$_react = $298235b6bc761a12$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $298235b6bc761a12$var$_propTypes = $298235b6bc761a12$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $298235b6bc761a12$var$_Collapse = $298235b6bc761a12$var$_interopRequireDefault((parcelRequire("ev6at")));
function $298235b6bc761a12$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $298235b6bc761a12$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $298235b6bc761a12$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $298235b6bc761a12$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $298235b6bc761a12$var$Collapse = function Collapse(_ref) {
    var children = _ref.children, props = $298235b6bc761a12$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $298235b6bc761a12$var$_react["default"].createElement($298235b6bc761a12$var$_Collapse["default"], props, children);
};
$298235b6bc761a12$exports.Collapse = $298235b6bc761a12$var$Collapse;
$298235b6bc761a12$var$Collapse.propTypes = {
    /**
   * Show the component; triggers the expand or collapse animation
   */ "in": $298235b6bc761a12$var$_propTypes["default"].bool,
    /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */ mountOnEnter: $298235b6bc761a12$var$_propTypes["default"].bool,
    /**
   * Unmount the component (remove it from the DOM) when it is collapsed
   */ unmountOnExit: $298235b6bc761a12$var$_propTypes["default"].bool,
    /**
   * Run the expand animation when the component mounts, if it is initially
   * shown
   */ appear: $298235b6bc761a12$var$_propTypes["default"].bool,
    /**
   * Duration of the collapse animation in milliseconds, to ensure that
   * finishing callbacks are fired even if the original browser transition end
   * events are canceled
   */ timeout: $298235b6bc761a12$var$_propTypes["default"].number,
    /**
   * Callback fired before the component expands
   */ onEnter: $298235b6bc761a12$var$_propTypes["default"].func,
    /**
   * Callback fired after the component starts to expand
   */ onEntering: $298235b6bc761a12$var$_propTypes["default"].func,
    /**
   * Callback fired after the component has expanded
   */ onEntered: $298235b6bc761a12$var$_propTypes["default"].func,
    /**
   * Callback fired before the component collapses
   */ onExit: $298235b6bc761a12$var$_propTypes["default"].func,
    /**
   * Callback fired after the component starts to collapse
   */ onExiting: $298235b6bc761a12$var$_propTypes["default"].func,
    /**
   * Callback fired after the component has collapsed
   */ onExited: $298235b6bc761a12$var$_propTypes["default"].func,
    /**
   * The dimension used when collapsing, or a function that returns the
   * dimension
   *
   * _Note: Bootstrap only partially supports 'width'!
   * You will need to supply your own CSS animation for the `.width` CSS class._
   */ dimension: $298235b6bc761a12$var$_propTypes["default"].oneOfType([
        $298235b6bc761a12$var$_propTypes["default"].oneOf([
            'height',
            'width'
        ]),
        $298235b6bc761a12$var$_propTypes["default"].func
    ]),
    /**
   * Function that returns the height or width of the animating DOM node
   *
   * Allows for providing some custom logic for how much the Collapse component
   * should animate in its specified dimension. Called with the current
   * dimension prop value and the DOM node.
   *
   * @default element.offsetWidth | element.offsetHeight
   */ getDimensionValue: $298235b6bc761a12$var$_propTypes["default"].func,
    /**
   * ARIA role of collapsible element
   */ role: $298235b6bc761a12$var$_propTypes["default"].string
};




var $9ed08f53b88f75a9$exports = {};
"use strict";
Object.defineProperty($9ed08f53b88f75a9$exports, "__esModule", {
    value: true
});
Object.defineProperty($9ed08f53b88f75a9$exports, "Container", {
    enumerable: true,
    get: function get() {
        return $eb350c94f52d1ee0$exports.Container;
    }
});
var $eb350c94f52d1ee0$exports = {};
"use strict";
Object.defineProperty($eb350c94f52d1ee0$exports, "__esModule", {
    value: true
});
$eb350c94f52d1ee0$exports.Container = void 0;

var $eb350c94f52d1ee0$var$_react = $eb350c94f52d1ee0$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $eb350c94f52d1ee0$var$_propTypes = $eb350c94f52d1ee0$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $eb350c94f52d1ee0$var$_Container = $eb350c94f52d1ee0$var$_interopRequireDefault((parcelRequire("gT8dK")));
function $eb350c94f52d1ee0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $eb350c94f52d1ee0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $eb350c94f52d1ee0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $eb350c94f52d1ee0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $eb350c94f52d1ee0$var$Container = function Container(_ref) {
    var children = _ref.children, props = $eb350c94f52d1ee0$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $eb350c94f52d1ee0$var$_react["default"].createElement($eb350c94f52d1ee0$var$_Container["default"], props, children);
};
$eb350c94f52d1ee0$exports.Container = $eb350c94f52d1ee0$var$Container;
$eb350c94f52d1ee0$var$Container.propTypes = {
    /**
   * @default 'container'
   */ bsPrefix: $eb350c94f52d1ee0$var$_propTypes["default"].string,
    /**
   * Allow the Container to fill all of its available horizontal space.
   * @type {(true|"sm"|"md"|"lg"|"xl")}
   */ fluid: $eb350c94f52d1ee0$var$_propTypes["default"].oneOfType([
        $eb350c94f52d1ee0$var$_propTypes["default"].bool,
        $eb350c94f52d1ee0$var$_propTypes["default"].oneOf([
            "sm",
            "md",
            "lg",
            "xl"
        ])
    ]),
    /** Set a custom element for this component */ as: $eb350c94f52d1ee0$var$_propTypes["default"].elementType
};




var $23120b195cc4628c$exports = {};
"use strict";
Object.defineProperty($23120b195cc4628c$exports, "__esModule", {
    value: true
});
Object.defineProperty($23120b195cc4628c$exports, "DatePicker", {
    enumerable: true,
    get: function get() {
        return $2dad4da8fa6a31f0$exports.DatePicker;
    }
});
var $2dad4da8fa6a31f0$exports = {};
"use strict";
Object.defineProperty($2dad4da8fa6a31f0$exports, "__esModule", {
    value: true
});
$2dad4da8fa6a31f0$exports.DatePicker = void 0;

var $2dad4da8fa6a31f0$var$_react = $2dad4da8fa6a31f0$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $2dad4da8fa6a31f0$var$_propTypes = $2dad4da8fa6a31f0$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $2dad4da8fa6a31f0$var$_reactFlatpickr = $2dad4da8fa6a31f0$var$_interopRequireDefault((parcelRequire("6adin")));

var $2dad4da8fa6a31f0$var$_Form = $2dad4da8fa6a31f0$var$_interopRequireDefault((parcelRequire("9EiVH")));
function $2dad4da8fa6a31f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $2dad4da8fa6a31f0$var$_extends() {
    $2dad4da8fa6a31f0$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2dad4da8fa6a31f0$var$_extends.apply(this, arguments);
}
function $2dad4da8fa6a31f0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2dad4da8fa6a31f0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2dad4da8fa6a31f0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $2dad4da8fa6a31f0$var$DatePicker = function DatePicker(_ref) {
    var labelText = _ref.labelText, inputAriaLabel = _ref.inputAriaLabel, id = _ref.id, placeholder = _ref.placeholder, options = _ref.options, hideLabel = _ref.hideLabel, disableMobile = _ref.disableMobile, dateFormat = _ref.dateFormat, flatPickrOptions = _ref.flatPickrOptions, inputProps = _ref.inputProps, props = $2dad4da8fa6a31f0$var$_objectWithoutProperties(_ref, [
        "labelText",
        "inputAriaLabel",
        "id",
        "placeholder",
        "options",
        "hideLabel",
        "disableMobile",
        "dateFormat",
        "flatPickrOptions",
        "inputProps"
    ]);
    return /*#__PURE__*/ $2dad4da8fa6a31f0$var$_react["default"].createElement("div", $2dad4da8fa6a31f0$var$_extends({
        className: "uxf-date-picker"
    }, props), !hideLabel && /*#__PURE__*/ $2dad4da8fa6a31f0$var$_react["default"].createElement($2dad4da8fa6a31f0$var$_Form["default"].Label, {
        htmlFor: id,
        className: "uxf-date-picker-label uxf-label"
    }, labelText), /*#__PURE__*/ $2dad4da8fa6a31f0$var$_react["default"].createElement($2dad4da8fa6a31f0$var$_reactFlatpickr["default"], $2dad4da8fa6a31f0$var$_extends({
        id: id,
        placeholder: placeholder,
        className: "form-control uxf-date-picker-input",
        "aria-label": inputAriaLabel,
        "data-date-format": dateFormat,
        "data-disable-mobile": disableMobile,
        options: flatPickrOptions,
        "data-next-arrow": "<svg class=\"uxf-btn-icon\" fill=\"#666666\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z\"/><path fill=\"none\" d=\"M0 0h24v24H0V0z\"/></svg>",
        "data-prev-arrow": "<svg class=\"uxf-btn-icon\" fill=\"#666666\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\"><path d=\"M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z\" /><path fill=\"none\" d=\"M0 0h24v24H0V0z\" /></svg>"
    }, inputProps)));
};
$2dad4da8fa6a31f0$exports.DatePicker = $2dad4da8fa6a31f0$var$DatePicker;
$2dad4da8fa6a31f0$var$DatePicker.propTypes = {
    /**
   * Input label text
   * @default 'Select Date'
   */ labelText: $2dad4da8fa6a31f0$var$_propTypes["default"].string,
    /**
   * Label for assistive technology users
   * to know format expected within input.
   */ inputAriaLabel: $2dad4da8fa6a31f0$var$_propTypes["default"].string.isRequired,
    /**
   * Unique id used for Flatpickr
   */ id: $2dad4da8fa6a31f0$var$_propTypes["default"].string.isRequired,
    /**
   * Placeholder text within input
   */ placeholder: $2dad4da8fa6a31f0$var$_propTypes["default"].string,
    /**
   * Controls display of label
   */ hideLabel: $2dad4da8fa6a31f0$var$_propTypes["default"].bool,
    /**
   * Disables native datetime inputs on mobile devices
   */ disableMobile: $2dad4da8fa6a31f0$var$_propTypes["default"].bool,
    /**
   * Format of date expected by Flatpickr
   */ dateFormat: $2dad4da8fa6a31f0$var$_propTypes["default"].string,
    /**
   * Flatpickr options: https://flatpickr.js.org/options/
   */ flatPickrOptions: $2dad4da8fa6a31f0$var$_propTypes["default"].object,
    /**
   * Add props to internal input
   */ inputProps: $2dad4da8fa6a31f0$var$_propTypes["default"].object
};
$2dad4da8fa6a31f0$var$DatePicker.defaultProps = {
    labelText: "Select Date",
    placeholder: "dd-mmm-yyyy",
    hideLabel: false,
    disableMobile: true,
    dateFormat: "d-M-Y"
};




var $7539a0d62b4a3f5e$exports = {};
"use strict";
Object.defineProperty($7539a0d62b4a3f5e$exports, "__esModule", {
    value: true
});
Object.defineProperty($7539a0d62b4a3f5e$exports, "Dropdown", {
    enumerable: true,
    get: function get() {
        return $cd4ae0b91213ae37$exports.Dropdown;
    }
});
Object.defineProperty($7539a0d62b4a3f5e$exports, "DropdownButton", {
    enumerable: true,
    get: function get() {
        return $3e9f57389e564134$exports.DropdownButton;
    }
});
var $cd4ae0b91213ae37$exports = {};
"use strict";
Object.defineProperty($cd4ae0b91213ae37$exports, "__esModule", {
    value: true
});
$cd4ae0b91213ae37$exports.Dropdown = void 0;

var $cd4ae0b91213ae37$var$_react = $cd4ae0b91213ae37$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $cd4ae0b91213ae37$var$_propTypes = $cd4ae0b91213ae37$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $cd4ae0b91213ae37$var$_Dropdown = $cd4ae0b91213ae37$var$_interopRequireDefault((parcelRequire("5ePwi")));

var $cd4ae0b91213ae37$var$_DropdownToggle = $cd4ae0b91213ae37$var$_interopRequireDefault((parcelRequire("712fm")));

var $cd4ae0b91213ae37$var$_DropdownMenu = $cd4ae0b91213ae37$var$_interopRequireDefault((parcelRequire("8TtJs")));

var $cd4ae0b91213ae37$var$_DropdownItem = $cd4ae0b91213ae37$var$_interopRequireDefault((parcelRequire("u5Mlg")));

var $cd4ae0b91213ae37$var$_createWithBsPrefix = $cd4ae0b91213ae37$var$_interopRequireDefault((parcelRequire("dP1T5")));
function $cd4ae0b91213ae37$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $cd4ae0b91213ae37$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $cd4ae0b91213ae37$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $cd4ae0b91213ae37$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $cd4ae0b91213ae37$var$DropdownHeader = (0, $cd4ae0b91213ae37$var$_createWithBsPrefix["default"])("dropdown-header", {
    defaultProps: {
        role: "heading"
    }
});
var $cd4ae0b91213ae37$var$DropdownDivider = (0, $cd4ae0b91213ae37$var$_createWithBsPrefix["default"])("dropdown-divider", {
    defaultProps: {
        role: "separator"
    }
});
var $cd4ae0b91213ae37$var$DropdownItemText = (0, $cd4ae0b91213ae37$var$_createWithBsPrefix["default"])("dropdown-item-text", {
    Component: "span"
});
var $cd4ae0b91213ae37$var$Dropdown = function Dropdown(_ref) {
    var children = _ref.children, props = $cd4ae0b91213ae37$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $cd4ae0b91213ae37$var$_react["default"].createElement($cd4ae0b91213ae37$var$_Dropdown["default"], props, children);
};
$cd4ae0b91213ae37$exports.Dropdown = $cd4ae0b91213ae37$var$Dropdown;
$cd4ae0b91213ae37$var$Dropdown.propTypes = {
    /**
   * Change the underlying component CSS base class name and modifier class names prefix
   * @default 'dropdown'
   */ bsPrefix: $cd4ae0b91213ae37$var$_propTypes["default"].string,
    /**
   * Determines the direction and location of the Menu in relation to it's Toggle.
   */ drop: $cd4ae0b91213ae37$var$_propTypes["default"].oneOf([
        "up",
        "left",
        "right",
        "down"
    ]),
    as: $cd4ae0b91213ae37$var$_propTypes["default"].elementType,
    /**
   * Align the menu to the right side of the Dropdown toggle
   */ alignRight: $cd4ae0b91213ae37$var$_propTypes["default"].bool,
    /**
   * Whether or not the Dropdown is visible.
   *
   * @controllable onToggle
   */ show: $cd4ae0b91213ae37$var$_propTypes["default"].bool,
    /**
   * Allow Dropdown to flip in case of an overlapping on the reference element. For more information refer to
   * Popper.js's flip [docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled).
   *
   */ flip: $cd4ae0b91213ae37$var$_propTypes["default"].bool,
    /**
   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
   * `show` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
   *
   * @controllable show
   */ onToggle: $cd4ae0b91213ae37$var$_propTypes["default"].func,
    /**
   * A callback fired when a menu item is selected.
   */ onSelect: $cd4ae0b91213ae37$var$_propTypes["default"].func,
    /**
   * Controls the focus behavior for when the Dropdown is opened. Set to
   * `true` to always focus the first menu item, `keyboard` to focus only when
   * navigating via the keyboard, or `false` to disable completely
   *
   * The Default behavior is `false` **unless** the Menu has a `role="menu"`
   * where it will default to `keyboard` to match the recommended [ARIA Authoring practices](https://www.w3.org/TR/wai-aria-practices-1.1/#menubutton).
   */ focusFirstItemOnShow: $cd4ae0b91213ae37$var$_propTypes["default"].oneOf([
        false,
        true,
        "keyboard"
    ]),
    /** @private */ navbar: $cd4ae0b91213ae37$var$_propTypes["default"].bool
};
$cd4ae0b91213ae37$var$Dropdown.Divider = $cd4ae0b91213ae37$var$DropdownDivider;
$cd4ae0b91213ae37$var$Dropdown.Header = $cd4ae0b91213ae37$var$DropdownHeader;
$cd4ae0b91213ae37$var$Dropdown.Item = $cd4ae0b91213ae37$var$_DropdownItem["default"];
$cd4ae0b91213ae37$var$Dropdown.ItemText = $cd4ae0b91213ae37$var$DropdownItemText;
$cd4ae0b91213ae37$var$Dropdown.Menu = $cd4ae0b91213ae37$var$_DropdownMenu["default"];
$cd4ae0b91213ae37$var$Dropdown.Toggle = $cd4ae0b91213ae37$var$_DropdownToggle["default"];


var $3e9f57389e564134$exports = {};
"use strict";
Object.defineProperty($3e9f57389e564134$exports, "__esModule", {
    value: true
});
$3e9f57389e564134$exports.DropdownButton = void 0;

var $3e9f57389e564134$var$_react = $3e9f57389e564134$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $3e9f57389e564134$var$_propTypes = $3e9f57389e564134$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $3e9f57389e564134$var$_DropdownButton = $3e9f57389e564134$var$_interopRequireDefault((parcelRequire("duIXv")));
function $3e9f57389e564134$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $3e9f57389e564134$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3e9f57389e564134$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3e9f57389e564134$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3e9f57389e564134$var$DropdownButton = function DropdownButton(_ref) {
    var children = _ref.children, props = $3e9f57389e564134$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $3e9f57389e564134$var$_react["default"].createElement($3e9f57389e564134$var$_DropdownButton["default"], props, children);
};
$3e9f57389e564134$exports.DropdownButton = $3e9f57389e564134$var$DropdownButton;
$3e9f57389e564134$var$DropdownButton.propTypes = {
    /**
   * An html id attribute for the Toggle button, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   */ id: $3e9f57389e564134$var$_propTypes["default"].any,
    /** An `href` passed to the Toggle component */ href: $3e9f57389e564134$var$_propTypes["default"].string,
    /** An `onClick` handler passed to the Toggle component */ onClick: $3e9f57389e564134$var$_propTypes["default"].func,
    /** The content of the non-toggle Button.  */ title: $3e9f57389e564134$var$_propTypes["default"].node,
    /** Disables both Buttons  */ disabled: $3e9f57389e564134$var$_propTypes["default"].bool,
    /** An ARIA accessible role applied to the Menu component. When set to 'menu', The dropdown */ menuRole: $3e9f57389e564134$var$_propTypes["default"].string,
    /**
   *  Which event when fired outside the component will cause it to be closed.     *
   */ rootCloseEvent: $3e9f57389e564134$var$_propTypes["default"].string,
    /** @ignore */ bsPrefix: $3e9f57389e564134$var$_propTypes["default"].string,
    /** @ignore */ variant: $3e9f57389e564134$var$_propTypes["default"].string,
    /** @ignore */ size: $3e9f57389e564134$var$_propTypes["default"].string
};




var $33c78908635c6d26$exports = {};
"use strict";
Object.defineProperty($33c78908635c6d26$exports, "__esModule", {
    value: true
});
Object.defineProperty($33c78908635c6d26$exports, "FileUpload", {
    enumerable: true,
    get: function get() {
        return $5e3fda7e8848d899$exports.FileUpload;
    }
});
var $5e3fda7e8848d899$exports = {};
"use strict";
function $5e3fda7e8848d899$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5e3fda7e8848d899$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5e3fda7e8848d899$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5e3fda7e8848d899$var$_typeof(obj);
}
Object.defineProperty($5e3fda7e8848d899$exports, "__esModule", {
    value: true
});
$5e3fda7e8848d899$exports.FileUpload = void 0;

var $5e3fda7e8848d899$var$_react = $5e3fda7e8848d899$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $5e3fda7e8848d899$var$_propTypes = $5e3fda7e8848d899$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $5e3fda7e8848d899$var$_classnames = $5e3fda7e8848d899$var$_interopRequireDefault((parcelRequire("fVt0T")));
function $5e3fda7e8848d899$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $5e3fda7e8848d899$var$_extends() {
    $5e3fda7e8848d899$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5e3fda7e8848d899$var$_extends.apply(this, arguments);
}
function $5e3fda7e8848d899$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5e3fda7e8848d899$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5e3fda7e8848d899$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5e3fda7e8848d899$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5e3fda7e8848d899$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5e3fda7e8848d899$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5e3fda7e8848d899$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5e3fda7e8848d899$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5e3fda7e8848d899$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $5e3fda7e8848d899$var$_setPrototypeOf(subClass, superClass);
}
function $5e3fda7e8848d899$var$_setPrototypeOf(o, p) {
    $5e3fda7e8848d899$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5e3fda7e8848d899$var$_setPrototypeOf(o, p);
}
function $5e3fda7e8848d899$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5e3fda7e8848d899$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5e3fda7e8848d899$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5e3fda7e8848d899$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5e3fda7e8848d899$var$_possibleConstructorReturn(this, result);
    };
}
function $5e3fda7e8848d899$var$_possibleConstructorReturn(self, call) {
    if (call && ($5e3fda7e8848d899$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $5e3fda7e8848d899$var$_assertThisInitialized(self);
}
function $5e3fda7e8848d899$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5e3fda7e8848d899$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5e3fda7e8848d899$var$_getPrototypeOf(o) {
    $5e3fda7e8848d899$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5e3fda7e8848d899$var$_getPrototypeOf(o);
}
var $5e3fda7e8848d899$var$FileUpload = /*#__PURE__*/ function(_React$Component) {
    $5e3fda7e8848d899$var$_inherits(FileUpload, _React$Component);
    var _super = $5e3fda7e8848d899$var$_createSuper(FileUpload);
    function FileUpload(props) {
        var _this;
        $5e3fda7e8848d899$var$_classCallCheck(this, FileUpload);
        _this = _super.call(this, props);
        _this.state = {
            activeFile: false,
            activeFileLabel: []
        };
        _this.handleRemoveClick = _this.handleRemoveClick.bind($5e3fda7e8848d899$var$_assertThisInitialized(_this));
        _this.handleChange = _this.handleChange.bind($5e3fda7e8848d899$var$_assertThisInitialized(_this));
        _this.openFileInput = _this.openFileInput.bind($5e3fda7e8848d899$var$_assertThisInitialized(_this));
        return _this;
    }
    $5e3fda7e8848d899$var$_createClass(FileUpload, [
        {
            key: "handleRemoveClick",
            value: function handleRemoveClick() {
                this.setState({
                    activeFileLabel: []
                });
                this.setState({
                    activeFile: false
                });
                this.fileUpload.value = "";
                this.fileUploadLabel.focus();
            }
        },
        {
            key: "handleChange",
            value: function handleChange(e) {
                if (e.target.files.length > 0) {
                    this.setState({
                        activeFile: true
                    });
                    var fileNameLabelArray = [];
                    for(var x = 0; x < e.target.files.length; x++){
                        var fileName = e.target.files[x]["name"];
                        fileNameLabelArray.push(fileName);
                        this.setState({
                            activeFileLabel: fileNameLabelArray
                        });
                    }
                } else this.setState({
                    activeFile: false
                });
                this.fileUploadLabel.focus();
            }
        },
        {
            key: "openFileInput",
            value: function openFileInput(e) {
                if (e.which == 13 || e.which == 32) {
                    // Prevents space bar click from moving page down when file upload dialog closes
                    e.preventDefault();
                    this.fileUpload.click();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, id = _this$props.id, className = _this$props.className, label = _this$props.label, variant = _this$props.variant, multiple = _this$props.multiple, props = $5e3fda7e8848d899$var$_objectWithoutProperties(_this$props, [
                    "id",
                    "className",
                    "label",
                    "variant",
                    "multiple"
                ]);
                var labelClasses = (0, $5e3fda7e8848d899$var$_classnames["default"])("btn", "uxf-file-input", variant);
                var fileUploadClasses = (0, $5e3fda7e8848d899$var$_classnames["default"])("custom-file", className);
                var fileLabelList = this.state.activeFileLabel.map(function(fileLabel, index) {
                    return /*#__PURE__*/ $5e3fda7e8848d899$var$_react["default"].createElement("div", {
                        className: "uxf-file-input-group",
                        key: index
                    }, /*#__PURE__*/ $5e3fda7e8848d899$var$_react["default"].createElement("p", {
                        className: "uxf-file-input-text text-truncate"
                    }, fileLabel), !multiple && /*#__PURE__*/ $5e3fda7e8848d899$var$_react["default"].createElement("button", {
                        onClick: _this2.handleRemoveClick,
                        className: "btn uxf-btn-icon",
                        "aria-label": "Remove File"
                    }, /*#__PURE__*/ $5e3fda7e8848d899$var$_react["default"].createElement("svg", {
                        fill: "#666666",
                        focusable: "false",
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24"
                    }, /*#__PURE__*/ $5e3fda7e8848d899$var$_react["default"].createElement("path", {
                        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                    }), /*#__PURE__*/ $5e3fda7e8848d899$var$_react["default"].createElement("path", {
                        d: "M0 0h24v24H0z",
                        fill: "none"
                    }))));
                });
                return /*#__PURE__*/ $5e3fda7e8848d899$var$_react["default"].createElement("div", $5e3fda7e8848d899$var$_extends({
                    className: fileUploadClasses
                }, props), /*#__PURE__*/ $5e3fda7e8848d899$var$_react["default"].createElement("input", {
                    type: "file",
                    id: id,
                    tabIndex: "-1",
                    ref: function ref(_ref) {
                        return _this2.fileUpload = _ref;
                    },
                    className: "custom-file-input",
                    multiple: multiple,
                    onChange: this.handleChange
                }), /*#__PURE__*/ $5e3fda7e8848d899$var$_react["default"].createElement("label", {
                    className: labelClasses,
                    ref: function ref(_ref2) {
                        return _this2.fileUploadLabel = _ref2;
                    },
                    tabIndex: "0",
                    onKeyDown: this.openFileInput,
                    htmlFor: id
                }, label), !this.state.activeFile && /*#__PURE__*/ $5e3fda7e8848d899$var$_react["default"].createElement("p", {
                    className: "uxf-file-input-text"
                }, "No file chosen"), this.state.activeFile && fileLabelList);
            }
        }
    ]);
    return FileUpload;
}($5e3fda7e8848d899$var$_react["default"].Component);
$5e3fda7e8848d899$exports.FileUpload = $5e3fda7e8848d899$var$FileUpload;
$5e3fda7e8848d899$var$FileUpload.propTypes = {
    /**
   * An html id attribute for the FileUpload input, necessary for assistive technologies, such as screen readers.
   */ id: $5e3fda7e8848d899$var$_propTypes["default"].string.isRequired,
    /**
   * Button variant. Gives the option to select type of button.
   */ variant: $5e3fda7e8848d899$var$_propTypes["default"].string,
    /**
   * Label associated with file input.
   */ label: $5e3fda7e8848d899$var$_propTypes["default"].string,
    /**
   * Gives the option to add multiple files at one time.
   */ multiple: $5e3fda7e8848d899$var$_propTypes["default"].bool
};
$5e3fda7e8848d899$var$FileUpload.defaultProps = {
    variant: "btn-secondary",
    label: "Choose file",
    multiple: false
};




var $9a231b0fc0814be6$exports = {};
"use strict";
Object.defineProperty($9a231b0fc0814be6$exports, "__esModule", {
    value: true
});
Object.defineProperty($9a231b0fc0814be6$exports, "Footer", {
    enumerable: true,
    get: function get() {
        return $3399e72362120eee$exports.Footer;
    }
});
Object.defineProperty($9a231b0fc0814be6$exports, "FooterLink", {
    enumerable: true,
    get: function get() {
        return $54641e9b35a71167$exports.FooterLink;
    }
});
var $3399e72362120eee$exports = {};
"use strict";
Object.defineProperty($3399e72362120eee$exports, "__esModule", {
    value: true
});
$3399e72362120eee$exports.Footer = void 0;

var $3399e72362120eee$var$_propTypes = $3399e72362120eee$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $3399e72362120eee$var$_classnames = $3399e72362120eee$var$_interopRequireDefault((parcelRequire("fVt0T")));

var $3399e72362120eee$var$_react = $3399e72362120eee$var$_interopRequireDefault((parcelRequire("Fo7oF")));
function $3399e72362120eee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $3399e72362120eee$var$_extends() {
    $3399e72362120eee$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3399e72362120eee$var$_extends.apply(this, arguments);
}
function $3399e72362120eee$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3399e72362120eee$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3399e72362120eee$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3399e72362120eee$var$Footer = function Footer(_ref) {
    var className = _ref.className, children = _ref.children, copyright = _ref.copyright, copyrightPrepend = _ref.copyrightPrepend, copyrightAppend = _ref.copyrightAppend, currentYear = _ref.currentYear, props = $3399e72362120eee$var$_objectWithoutProperties(_ref, [
        "className",
        "children",
        "copyright",
        "copyrightPrepend",
        "copyrightAppend",
        "currentYear"
    ]);
    var classes = (0, $3399e72362120eee$var$_classnames["default"])('footer', 'uxf-footer', className);
    var copyrightMessage = "".concat(copyrightPrepend, " ").concat(currentYear, " ").concat(copyrightAppend);
    return /*#__PURE__*/ $3399e72362120eee$var$_react["default"].createElement("footer", $3399e72362120eee$var$_extends({
        className: classes
    }, props, {
        role: "contentinfo"
    }), /*#__PURE__*/ $3399e72362120eee$var$_react["default"].createElement("div", {
        className: "container-fluid"
    }, /*#__PURE__*/ $3399e72362120eee$var$_react["default"].createElement("div", {
        className: "row"
    }, /*#__PURE__*/ $3399e72362120eee$var$_react["default"].createElement("div", {
        className: "col-24"
    }, children, copyright && /*#__PURE__*/ $3399e72362120eee$var$_react["default"].createElement("span", {
        className: "uxf-footer-legal"
    }, copyrightMessage)))));
};
$3399e72362120eee$exports.Footer = $3399e72362120eee$var$Footer;
$3399e72362120eee$var$Footer.propTypes = {
    /**
   * Display copyright with footer
   */ copyright: $3399e72362120eee$var$_propTypes["default"].bool,
    /**
   * Content that comes before year in copyright
   */ copyrightPrepend: $3399e72362120eee$var$_propTypes["default"].string,
    /**
   * Content that comes after year in copyright
   */ copyrightAppend: $3399e72362120eee$var$_propTypes["default"].string,
    /**
   * Year associated with copyright (usually current year)
   */ currentYear: $3399e72362120eee$var$_propTypes["default"].oneOfType([
        $3399e72362120eee$var$_propTypes["default"].string,
        $3399e72362120eee$var$_propTypes["default"].number
    ])
};
$3399e72362120eee$var$Footer.defaultProps = {
    copyright: true,
    copyrightPrepend: "Copyright \xa9",
    copyrightAppend: 'Deere & Company. All Rights Reserved.',
    currentYear: new Date().getFullYear()
};


var $54641e9b35a71167$exports = {};
"use strict";
Object.defineProperty($54641e9b35a71167$exports, "__esModule", {
    value: true
});
$54641e9b35a71167$exports.FooterLink = void 0;

var $54641e9b35a71167$var$_propTypes = $54641e9b35a71167$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $54641e9b35a71167$var$_classnames = $54641e9b35a71167$var$_interopRequireDefault((parcelRequire("fVt0T")));

var $54641e9b35a71167$var$_react = $54641e9b35a71167$var$_interopRequireDefault((parcelRequire("Fo7oF")));
function $54641e9b35a71167$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $54641e9b35a71167$var$_extends() {
    $54641e9b35a71167$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $54641e9b35a71167$var$_extends.apply(this, arguments);
}
function $54641e9b35a71167$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $54641e9b35a71167$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $54641e9b35a71167$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $54641e9b35a71167$var$FooterLink = function FooterLink(_ref) {
    var className = _ref.className, children = _ref.children, Component = _ref.as, href = _ref.href, props = $54641e9b35a71167$var$_objectWithoutProperties(_ref, [
        "className",
        "children",
        "as",
        "href"
    ]);
    var classes = (0, $54641e9b35a71167$var$_classnames["default"])("uxf-footer-link", className);
    return /*#__PURE__*/ $54641e9b35a71167$var$_react["default"].createElement(Component, $54641e9b35a71167$var$_extends({
        href: href,
        className: classes
    }, props), children);
};
$54641e9b35a71167$exports.FooterLink = $54641e9b35a71167$var$FooterLink;
$54641e9b35a71167$var$FooterLink.propTypes = {
    /**
   * Link associated with Footer item
   */ href: $54641e9b35a71167$var$_propTypes["default"].string,
    /**
   * Set a custom element for this component.
   * @default 'a'
   */ as: $54641e9b35a71167$var$_propTypes["default"].elementType
};
$54641e9b35a71167$var$FooterLink.defaultProps = {
    as: "a"
};




var $e115e9f32f94e5cf$exports = {};
"use strict";
Object.defineProperty($e115e9f32f94e5cf$exports, "__esModule", {
    value: true
});
Object.defineProperty($e115e9f32f94e5cf$exports, "Form", {
    enumerable: true,
    get: function get() {
        return $3412a277646738a4$exports.Form;
    }
});
var $3412a277646738a4$exports = {};
"use strict";
Object.defineProperty($3412a277646738a4$exports, "__esModule", {
    value: true
});
$3412a277646738a4$exports.Form = void 0;

var $3412a277646738a4$var$_react = $3412a277646738a4$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $3412a277646738a4$var$_propTypes = $3412a277646738a4$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $3412a277646738a4$var$_Form = $3412a277646738a4$var$_interopRequireDefault((parcelRequire("9EiVH")));

var $3412a277646738a4$var$_createWithBsPrefix = $3412a277646738a4$var$_interopRequireDefault((parcelRequire("dP1T5")));

var $3412a277646738a4$var$_FormGroup = $3412a277646738a4$var$_interopRequireDefault((parcelRequire("2U22y")));

var $3412a277646738a4$var$_FormControl = $3412a277646738a4$var$_interopRequireDefault((parcelRequire("3dGOs")));

var $3412a277646738a4$var$_FormCheck = $3412a277646738a4$var$_interopRequireDefault((parcelRequire("7zyNL")));

var $3412a277646738a4$var$_FormLabel = $3412a277646738a4$var$_interopRequireDefault((parcelRequire("lCeXu")));

var $3412a277646738a4$var$_FormText = $3412a277646738a4$var$_interopRequireDefault((parcelRequire("dAFg4")));
function $3412a277646738a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $3412a277646738a4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3412a277646738a4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3412a277646738a4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3412a277646738a4$var$Form = function Form(_ref) {
    var children = _ref.children, props = $3412a277646738a4$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $3412a277646738a4$var$_react["default"].createElement($3412a277646738a4$var$_Form["default"], props, children);
};
$3412a277646738a4$exports.Form = $3412a277646738a4$var$Form;
$3412a277646738a4$var$Form.propTypes = {
    /**
   * @default {'form'}
   */ bsPrefix: $3412a277646738a4$var$_propTypes["default"].string,
    /**
   * Display the series of labels, form controls,
   * and buttons on a single horizontal row
   */ inline: $3412a277646738a4$var$_propTypes["default"].bool,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: $3412a277646738a4$var$_propTypes["default"].bool,
    as: $3412a277646738a4$var$_propTypes["default"].elementType
};
$3412a277646738a4$var$Form.Row = (0, $3412a277646738a4$var$_createWithBsPrefix["default"])("form-row");
$3412a277646738a4$var$Form.Group = $3412a277646738a4$var$_FormGroup["default"];
$3412a277646738a4$var$Form.Control = $3412a277646738a4$var$_FormControl["default"];
$3412a277646738a4$var$Form.Check = $3412a277646738a4$var$_FormCheck["default"];
$3412a277646738a4$var$Form.Label = $3412a277646738a4$var$_FormLabel["default"];
$3412a277646738a4$var$Form.Text = $3412a277646738a4$var$_FormText["default"];




var $00346f62e9f6f288$exports = {};
"use strict";
Object.defineProperty($00346f62e9f6f288$exports, "__esModule", {
    value: true
});
Object.defineProperty($00346f62e9f6f288$exports, "Header", {
    enumerable: true,
    get: function get() {
        return $8ab8f70d72091036$exports.Header;
    }
});
Object.defineProperty($00346f62e9f6f288$exports, "HeaderContext", {
    enumerable: true,
    get: function get() {
        return $8ab8f70d72091036$exports.HeaderContext;
    }
});
Object.defineProperty($00346f62e9f6f288$exports, "HeaderButtonBack", {
    enumerable: true,
    get: function get() {
        return $f0ab6cc09508342d$exports.HeaderButtonBack;
    }
});
var $8ab8f70d72091036$exports = {};
"use strict";
function $8ab8f70d72091036$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $8ab8f70d72091036$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $8ab8f70d72091036$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $8ab8f70d72091036$var$_typeof(obj);
}
Object.defineProperty($8ab8f70d72091036$exports, "__esModule", {
    value: true
});
$8ab8f70d72091036$exports.Header = $8ab8f70d72091036$exports.HeaderContext = void 0;

var $8ab8f70d72091036$var$_react = $8ab8f70d72091036$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $8ab8f70d72091036$var$_propTypes = $8ab8f70d72091036$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $8ab8f70d72091036$var$_classnames = $8ab8f70d72091036$var$_interopRequireDefault((parcelRequire("fVt0T")));

var $8ab8f70d72091036$var$_Form = $8ab8f70d72091036$var$_interopRequireDefault((parcelRequire("9EiVH")));

var $8ab8f70d72091036$var$_Button = $8ab8f70d72091036$var$_interopRequireDefault((parcelRequire("6MAJg")));

var $8ab8f70d72091036$var$_Navbar = $8ab8f70d72091036$var$_interopRequireDefault((parcelRequire("9riOH")));

var $8ab8f70d72091036$var$_Nav = $8ab8f70d72091036$var$_interopRequireDefault((parcelRequire("eqoNU")));
var $3f501adbefa810dd$exports = {};
"use strict";
Object.defineProperty($3f501adbefa810dd$exports, "__esModule", {
    value: true
});
Object.defineProperty($3f501adbefa810dd$exports, "SearchClearButton", {
    enumerable: true,
    get: function get() {
        return $39cc8fa87370ff56$exports.SearchClearButton;
    }
});
Object.defineProperty($3f501adbefa810dd$exports, "SearchInput", {
    enumerable: true,
    get: function get() {
        return $ed9937aac3a48dec$exports.SearchInput;
    }
});
Object.defineProperty($3f501adbefa810dd$exports, "SearchSubmitButton", {
    enumerable: true,
    get: function get() {
        return $5a4d05987da8bd28$exports.SearchSubmitButton;
    }
});
Object.defineProperty($3f501adbefa810dd$exports, "Search", {
    enumerable: true,
    get: function get() {
        return $1109cda295b130f4$exports.Search;
    }
});
var $39cc8fa87370ff56$exports = {};
"use strict";
Object.defineProperty($39cc8fa87370ff56$exports, "__esModule", {
    value: true
});
$39cc8fa87370ff56$exports.SearchClearButton = void 0;

var $39cc8fa87370ff56$var$_react = $39cc8fa87370ff56$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $39cc8fa87370ff56$var$_classnames = $39cc8fa87370ff56$var$_interopRequireDefault((parcelRequire("fVt0T")));

var $39cc8fa87370ff56$var$_propTypes = $39cc8fa87370ff56$var$_interopRequireDefault((parcelRequire("d2bgE")));

function $39cc8fa87370ff56$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $39cc8fa87370ff56$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $39cc8fa87370ff56$var$_extends() {
    $39cc8fa87370ff56$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $39cc8fa87370ff56$var$_extends.apply(this, arguments);
}
function $39cc8fa87370ff56$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $39cc8fa87370ff56$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $39cc8fa87370ff56$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $39cc8fa87370ff56$var$ClearIcon = function ClearIcon(props) {
    return /*#__PURE__*/ $39cc8fa87370ff56$var$_react["default"].createElement("svg", props, /*#__PURE__*/ $39cc8fa87370ff56$var$_react["default"].createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }), /*#__PURE__*/ $39cc8fa87370ff56$var$_react["default"].createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }));
};
$39cc8fa87370ff56$var$ClearIcon.defaultProps = $39cc8fa87370ff56$var$_defineProperty({
    focusable: "false",
    'aria-hidden': "true",
    fill: "#666",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
}, "focusable", 'false');
var $39cc8fa87370ff56$var$SearchClearButton = function SearchClearButton(_ref) {
    var ariaLabel = _ref.ariaLabel, className = _ref.className, props = $39cc8fa87370ff56$var$_objectWithoutProperties(_ref, [
        "ariaLabel",
        "className"
    ]);
    var classes = (0, $39cc8fa87370ff56$var$_classnames["default"])('uxf-search-bar-clear-icon', className);
    return /*#__PURE__*/ $39cc8fa87370ff56$var$_react["default"].createElement($ecd15074f048ae13$exports.Button, $39cc8fa87370ff56$var$_extends({
        variant: "uxf-icon",
        type: "reset",
        "aria-label": ariaLabel,
        className: classes
    }, props), /*#__PURE__*/ $39cc8fa87370ff56$var$_react["default"].createElement($39cc8fa87370ff56$var$ClearIcon, {
        className: "uxf-icon-remove"
    }));
};
$39cc8fa87370ff56$exports.SearchClearButton = $39cc8fa87370ff56$var$SearchClearButton;
$39cc8fa87370ff56$var$SearchClearButton.propTypes = {
    /**
   *  Aria-label of clear button. This notifies individuals using a screen
   *  reader that they are on the clear search component.
   */ ariaLabel: $39cc8fa87370ff56$var$_propTypes["default"].string.isRequired
};


var $ed9937aac3a48dec$exports = {};
"use strict";
Object.defineProperty($ed9937aac3a48dec$exports, "__esModule", {
    value: true
});
$ed9937aac3a48dec$exports.SearchInput = void 0;

var $ed9937aac3a48dec$var$_react = $ed9937aac3a48dec$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $ed9937aac3a48dec$var$_classnames = $ed9937aac3a48dec$var$_interopRequireDefault((parcelRequire("fVt0T")));

var $ed9937aac3a48dec$var$_propTypes = $ed9937aac3a48dec$var$_interopRequireDefault((parcelRequire("d2bgE")));

function $ed9937aac3a48dec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $ed9937aac3a48dec$var$_extends() {
    $ed9937aac3a48dec$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ed9937aac3a48dec$var$_extends.apply(this, arguments);
}
function $ed9937aac3a48dec$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ed9937aac3a48dec$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ed9937aac3a48dec$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $ed9937aac3a48dec$var$SearchInput = function SearchInput(_ref) {
    var ariaLabel = _ref.ariaLabel, placeholder = _ref.placeholder, className = _ref.className, innerRef = _ref.innerRef, props = $ed9937aac3a48dec$var$_objectWithoutProperties(_ref, [
        "ariaLabel",
        "placeholder",
        "className",
        "innerRef"
    ]);
    var classes = (0, $ed9937aac3a48dec$var$_classnames["default"])('uxf-search-bar', className);
    return /*#__PURE__*/ $ed9937aac3a48dec$var$_react["default"].createElement($e115e9f32f94e5cf$exports.Form.Control, $ed9937aac3a48dec$var$_extends({
        ref: innerRef,
        type: "search",
        className: classes,
        "aria-label": ariaLabel,
        placeholder: placeholder
    }, props));
};
$ed9937aac3a48dec$exports.SearchInput = $ed9937aac3a48dec$var$SearchInput;
$ed9937aac3a48dec$var$SearchInput.propTypes = {
    /**
   * Aria-label of search input. This is required due to the
   * search component not having a label associated with it.
   */ ariaLabel: $ed9937aac3a48dec$var$_propTypes["default"].string.isRequired,
    /**
   * Placeholder for search input.
   */ placeholder: $ed9937aac3a48dec$var$_propTypes["default"].string
};
$ed9937aac3a48dec$var$SearchInput.defaultProps = {
    placeholder: 'Search'
};


var $5a4d05987da8bd28$exports = {};
"use strict";
Object.defineProperty($5a4d05987da8bd28$exports, "__esModule", {
    value: true
});
$5a4d05987da8bd28$exports.SearchSubmitButton = void 0;

var $5a4d05987da8bd28$var$_react = $5a4d05987da8bd28$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $5a4d05987da8bd28$var$_propTypes = $5a4d05987da8bd28$var$_interopRequireDefault((parcelRequire("d2bgE")));

function $5a4d05987da8bd28$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $5a4d05987da8bd28$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5a4d05987da8bd28$var$_extends() {
    $5a4d05987da8bd28$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5a4d05987da8bd28$var$_extends.apply(this, arguments);
}
function $5a4d05987da8bd28$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5a4d05987da8bd28$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5a4d05987da8bd28$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $5a4d05987da8bd28$var$SubmitIcon = function SubmitIcon(props) {
    return /*#__PURE__*/ $5a4d05987da8bd28$var$_react["default"].createElement("svg", props, /*#__PURE__*/ $5a4d05987da8bd28$var$_react["default"].createElement("path", {
        d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
    }), /*#__PURE__*/ $5a4d05987da8bd28$var$_react["default"].createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }));
};
$5a4d05987da8bd28$var$SubmitIcon.defaultProps = $5a4d05987da8bd28$var$_defineProperty({
    focusable: "false",
    'aria-hidden': "true",
    fill: "#666",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
}, "focusable", 'false');
var $5a4d05987da8bd28$var$SearchSubmitButton = function SearchSubmitButton(_ref) {
    var ariaLabel = _ref.ariaLabel, onClick = _ref.onClick, className = _ref.className, props = $5a4d05987da8bd28$var$_objectWithoutProperties(_ref, [
        "ariaLabel",
        "onClick",
        "className"
    ]);
    return /*#__PURE__*/ $5a4d05987da8bd28$var$_react["default"].createElement($ecd15074f048ae13$exports.Button, $5a4d05987da8bd28$var$_extends({
        variant: "uxf-search",
        type: "submit",
        "aria-label": ariaLabel,
        className: className,
        onClick: onClick
    }, props), /*#__PURE__*/ $5a4d05987da8bd28$var$_react["default"].createElement($5a4d05987da8bd28$var$SubmitIcon, {
        className: "uxf-icon-search"
    }));
};
$5a4d05987da8bd28$exports.SearchSubmitButton = $5a4d05987da8bd28$var$SearchSubmitButton;
$5a4d05987da8bd28$var$SearchSubmitButton.propTypes = {
    /**
   * Aria-label for search submit icon since icon has no text associated with it.
   */ ariaLabel: $5a4d05987da8bd28$var$_propTypes["default"].string.isRequired,
    /**
   * Function associated with 'click' of submit icon
   */ onClick: $5a4d05987da8bd28$var$_propTypes["default"].func
};


var $1109cda295b130f4$exports = {};
"use strict";
function $1109cda295b130f4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $1109cda295b130f4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $1109cda295b130f4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $1109cda295b130f4$var$_typeof(obj);
}
Object.defineProperty($1109cda295b130f4$exports, "__esModule", {
    value: true
});
$1109cda295b130f4$exports.Search = void 0;

var $1109cda295b130f4$var$_react = $1109cda295b130f4$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $1109cda295b130f4$var$_propTypes = $1109cda295b130f4$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $190bc81c671cdca6$exports = {};
"use strict";
Object.defineProperty($190bc81c671cdca6$exports, "__esModule", {
    value: true
});
Object.defineProperty($190bc81c671cdca6$exports, "InputGroup", {
    enumerable: true,
    get: function get() {
        return $506c557edfdf5384$exports.InputGroup;
    }
});
Object.defineProperty($190bc81c671cdca6$exports, "InputGroupSelect", {
    enumerable: true,
    get: function get() {
        return $892088afb95ad9a7$exports.InputGroupSelect;
    }
});
var $506c557edfdf5384$exports = {};
"use strict";
Object.defineProperty($506c557edfdf5384$exports, "__esModule", {
    value: true
});
$506c557edfdf5384$exports.InputGroup = void 0;

var $506c557edfdf5384$var$_react = $506c557edfdf5384$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $506c557edfdf5384$var$_propTypes = $506c557edfdf5384$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $506c557edfdf5384$var$_InputGroup = $506c557edfdf5384$var$_interopRequireDefault((parcelRequire("27kov")));

var $506c557edfdf5384$var$_createWithBsPrefix = $506c557edfdf5384$var$_interopRequireDefault((parcelRequire("dP1T5")));
function $506c557edfdf5384$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $506c557edfdf5384$var$_extends() {
    $506c557edfdf5384$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $506c557edfdf5384$var$_extends.apply(this, arguments);
}
function $506c557edfdf5384$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $506c557edfdf5384$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $506c557edfdf5384$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $506c557edfdf5384$var$InputGroup = function InputGroup(_ref) {
    var children = _ref.children, props = $506c557edfdf5384$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $506c557edfdf5384$var$_react["default"].createElement($506c557edfdf5384$var$_InputGroup["default"], props, children);
};
$506c557edfdf5384$exports.InputGroup = $506c557edfdf5384$var$InputGroup;
$506c557edfdf5384$var$InputGroup.propTypes = {
    /** @default 'input-group' */ bsPrefix: $506c557edfdf5384$var$_propTypes["default"].string,
    /**
   * Control the size of buttons and form elements from the top-level .
   *
   * `"sm"` `"lg"`
   */ size: $506c557edfdf5384$var$_propTypes["default"].string,
    as: $506c557edfdf5384$var$_propTypes["default"].elementType
};
var $506c557edfdf5384$var$InputGroupAppend = (0, $506c557edfdf5384$var$_createWithBsPrefix["default"])("input-group-append");
var $506c557edfdf5384$var$InputGroupPrepend = (0, $506c557edfdf5384$var$_createWithBsPrefix["default"])("input-group-prepend");
var $506c557edfdf5384$var$InputGroupText = (0, $506c557edfdf5384$var$_createWithBsPrefix["default"])("input-group-text", {
    Component: "span"
});
var $506c557edfdf5384$var$InputGroupCheckbox = function InputGroupCheckbox(props) {
    return /*#__PURE__*/ $506c557edfdf5384$var$_react["default"].createElement($506c557edfdf5384$var$InputGroupText, null, /*#__PURE__*/ $506c557edfdf5384$var$_react["default"].createElement("input", $506c557edfdf5384$var$_extends({
        type: "checkbox"
    }, props)));
};
var $506c557edfdf5384$var$InputGroupRadio = function InputGroupRadio(props) {
    return /*#__PURE__*/ $506c557edfdf5384$var$_react["default"].createElement($506c557edfdf5384$var$InputGroupText, null, /*#__PURE__*/ $506c557edfdf5384$var$_react["default"].createElement("input", $506c557edfdf5384$var$_extends({
        type: "radio"
    }, props)));
};
$506c557edfdf5384$var$InputGroup.Text = $506c557edfdf5384$var$InputGroupText;
$506c557edfdf5384$var$InputGroup.Radio = $506c557edfdf5384$var$InputGroupRadio;
$506c557edfdf5384$var$InputGroup.Checkbox = $506c557edfdf5384$var$InputGroupCheckbox;
$506c557edfdf5384$var$InputGroup.Append = $506c557edfdf5384$var$InputGroupAppend;
$506c557edfdf5384$var$InputGroup.Prepend = $506c557edfdf5384$var$InputGroupPrepend;


var $892088afb95ad9a7$exports = {};
"use strict";
function $892088afb95ad9a7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $892088afb95ad9a7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $892088afb95ad9a7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $892088afb95ad9a7$var$_typeof(obj);
}
Object.defineProperty($892088afb95ad9a7$exports, "__esModule", {
    value: true
});
$892088afb95ad9a7$exports.InputGroupSelect = void 0;

var $892088afb95ad9a7$var$_propTypes = $892088afb95ad9a7$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $892088afb95ad9a7$var$_react = $892088afb95ad9a7$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $892088afb95ad9a7$var$_classnames = $892088afb95ad9a7$var$_interopRequireDefault((parcelRequire("fVt0T")));


function $892088afb95ad9a7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $892088afb95ad9a7$var$_extends() {
    $892088afb95ad9a7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $892088afb95ad9a7$var$_extends.apply(this, arguments);
}
function $892088afb95ad9a7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $892088afb95ad9a7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $892088afb95ad9a7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $892088afb95ad9a7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $892088afb95ad9a7$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $892088afb95ad9a7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $892088afb95ad9a7$var$_setPrototypeOf(subClass, superClass);
}
function $892088afb95ad9a7$var$_setPrototypeOf(o, p) {
    $892088afb95ad9a7$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $892088afb95ad9a7$var$_setPrototypeOf(o, p);
}
function $892088afb95ad9a7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $892088afb95ad9a7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $892088afb95ad9a7$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $892088afb95ad9a7$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $892088afb95ad9a7$var$_possibleConstructorReturn(this, result);
    };
}
function $892088afb95ad9a7$var$_possibleConstructorReturn(self, call) {
    if (call && ($892088afb95ad9a7$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $892088afb95ad9a7$var$_assertThisInitialized(self);
}
function $892088afb95ad9a7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $892088afb95ad9a7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $892088afb95ad9a7$var$_getPrototypeOf(o) {
    $892088afb95ad9a7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $892088afb95ad9a7$var$_getPrototypeOf(o);
}
function $892088afb95ad9a7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $892088afb95ad9a7$var$InputGroupSelect = /*#__PURE__*/ function(_React$Component) {
    $892088afb95ad9a7$var$_inherits(InputGroupSelect, _React$Component);
    var _super = $892088afb95ad9a7$var$_createSuper(InputGroupSelect);
    function InputGroupSelect(props) {
        var _this;
        $892088afb95ad9a7$var$_classCallCheck(this, InputGroupSelect);
        _this = _super.call(this, props);
        $892088afb95ad9a7$var$_defineProperty($892088afb95ad9a7$var$_assertThisInitialized(_this), "onSelectedItemChange", function(event) {
            _this.setState({
                selectedItem: event.target.value
            });
        });
        _this.onSelectedItemChange = _this.onSelectedItemChange.bind($892088afb95ad9a7$var$_assertThisInitialized(_this));
        _this.state = {
            selectedItem: props.value
        };
        return _this;
    }
    $892088afb95ad9a7$var$_createClass(InputGroupSelect, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, ariaLabel = _this$props.ariaLabel, selectProps = _this$props.selectProps, spanProps = _this$props.spanProps;
                var spanClasses = (0, $892088afb95ad9a7$var$_classnames["default"])('dropdown-toggle', 'uxf-custom-select', spanProps.className);
                var selectClasses = (0, $892088afb95ad9a7$var$_classnames["default"])('custom-select', selectProps.className);
                return /*#__PURE__*/ $892088afb95ad9a7$var$_react["default"].createElement($892088afb95ad9a7$var$_react["default"].Fragment, null, /*#__PURE__*/ $892088afb95ad9a7$var$_react["default"].createElement($e115e9f32f94e5cf$exports.Form.Control, $892088afb95ad9a7$var$_extends({
                    className: selectClasses,
                    "aria-label": ariaLabel,
                    onChange: this.onSelectedItemChange,
                    value: this.state.selectedItem,
                    as: "select"
                }, selectProps), children), /*#__PURE__*/ $892088afb95ad9a7$var$_react["default"].createElement($ecd15074f048ae13$exports.Button, $892088afb95ad9a7$var$_extends({
                    as: "span",
                    "aria-hidden": "true",
                    type: null,
                    className: spanClasses
                }, spanProps), this.state.selectedItem));
            }
        }
    ]);
    return InputGroupSelect;
}($892088afb95ad9a7$var$_react["default"].Component);
$892088afb95ad9a7$exports.InputGroupSelect = $892088afb95ad9a7$var$InputGroupSelect;
$892088afb95ad9a7$var$InputGroupSelect.propTypes = {
    /**
    * Aria-label of input. This is required due to the
    * input group component not having a label associated with it.
  */ ariaLabel: $892088afb95ad9a7$var$_propTypes["default"].string.isRequired,
    /**
    * Additional props passed to the select element
  */ selectProps: $892088afb95ad9a7$var$_propTypes["default"].object,
    /**
    * Additional props passed to the span element
  */ spanProps: $892088afb95ad9a7$var$_propTypes["default"].object
};
$892088afb95ad9a7$var$InputGroupSelect.defaultProps = {
    selectProps: {},
    spanProps: {}
};





var $1109cda295b130f4$var$_classnames = $1109cda295b130f4$var$_interopRequireDefault((parcelRequire("fVt0T")));
var $c3a2548915580ec0$exports = {};
"use strict";
Object.defineProperty($c3a2548915580ec0$exports, "__esModule", {
    value: true
});
$c3a2548915580ec0$exports.composeEventHandlers = $c3a2548915580ec0$var$composeEventHandlers;
/**
 * Based off Zendesk Utilities Library
 * Original License - Apache-2.0
 * https://github.com/zendeskgarden/react-containers/blob/main/packages/utilities/src/utils/composeEventHandlers.ts
 *
 * We are using the .some() array method to iterate through all
 * the provided functions and stop if defaultPrevented is true.
*/ function $c3a2548915580ec0$var$composeEventHandlers() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            fn && fn.apply(void 0, [
                event
            ].concat(args));
            return event && event.defaultPrevented;
        });
    };
}


function $1109cda295b130f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1109cda295b130f4$var$_extends() {
    $1109cda295b130f4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1109cda295b130f4$var$_extends.apply(this, arguments);
}
function $1109cda295b130f4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1109cda295b130f4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1109cda295b130f4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1109cda295b130f4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1109cda295b130f4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1109cda295b130f4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $1109cda295b130f4$var$_setPrototypeOf(subClass, superClass);
}
function $1109cda295b130f4$var$_setPrototypeOf(o, p) {
    $1109cda295b130f4$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1109cda295b130f4$var$_setPrototypeOf(o, p);
}
function $1109cda295b130f4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1109cda295b130f4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1109cda295b130f4$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1109cda295b130f4$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1109cda295b130f4$var$_possibleConstructorReturn(this, result);
    };
}
function $1109cda295b130f4$var$_possibleConstructorReturn(self, call) {
    if (call && ($1109cda295b130f4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $1109cda295b130f4$var$_assertThisInitialized(self);
}
function $1109cda295b130f4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1109cda295b130f4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1109cda295b130f4$var$_getPrototypeOf(o) {
    $1109cda295b130f4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1109cda295b130f4$var$_getPrototypeOf(o);
}
function $1109cda295b130f4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $1109cda295b130f4$var$Search = /*#__PURE__*/ function(_React$Component) {
    $1109cda295b130f4$var$_inherits(Search, _React$Component);
    var _super = $1109cda295b130f4$var$_createSuper(Search);
    function Search(props) {
        var _this;
        $1109cda295b130f4$var$_classCallCheck(this, Search);
        _this = _super.call(this, props);
        _this.state = {
            inputValue: ''
        };
        _this.inputRef = /*#__PURE__*/ $1109cda295b130f4$var$_react["default"].createRef();
        _this.handleClear = _this.handleClear.bind($1109cda295b130f4$var$_assertThisInitialized(_this));
        _this.handleChange = _this.handleChange.bind($1109cda295b130f4$var$_assertThisInitialized(_this));
        return _this;
    }
    $1109cda295b130f4$var$_createClass(Search, [
        {
            key: "handleClear",
            value: function handleClear() {
                this.setState({
                    inputValue: ''
                });
                this.inputRef.current.focus();
            }
        },
        {
            key: "handleChange",
            value: function handleChange(e) {
                this.setState({
                    inputValue: e.target.value
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, clearBtnProps = _this$props.clearBtnProps, submitBtnProps = _this$props.submitBtnProps, inputProps = _this$props.inputProps, onChange = _this$props.onChange, onClear = _this$props.onClear;
                var submitBtnClasses = (0, $1109cda295b130f4$var$_classnames["default"])('uxf-search-bar-submit-icon', submitBtnProps.className);
                var inputEventHandlers = (0, $c3a2548915580ec0$exports.composeEventHandlers)(onChange, this.handleChange);
                var clearEventHandlers = (0, $c3a2548915580ec0$exports.composeEventHandlers)(onClear, this.handleClear);
                return /*#__PURE__*/ $1109cda295b130f4$var$_react["default"].createElement($1109cda295b130f4$var$_react["default"].Fragment, null, /*#__PURE__*/ $1109cda295b130f4$var$_react["default"].createElement($3f501adbefa810dd$exports.SearchInput, $1109cda295b130f4$var$_extends({
                    onChange: inputEventHandlers,
                    value: this.state.inputValue,
                    ariaLabel: inputProps.ariaLabel,
                    innerRef: this.inputRef,
                    className: this.state.inputValue && 'active'
                }, inputProps)), /*#__PURE__*/ $1109cda295b130f4$var$_react["default"].createElement($190bc81c671cdca6$exports.InputGroup.Append, null, /*#__PURE__*/ $1109cda295b130f4$var$_react["default"].createElement($3f501adbefa810dd$exports.SearchClearButton, $1109cda295b130f4$var$_extends({
                    onClick: clearEventHandlers,
                    ariaLabel: clearBtnProps.ariaLabel
                }, clearBtnProps)), /*#__PURE__*/ $1109cda295b130f4$var$_react["default"].createElement($3f501adbefa810dd$exports.SearchSubmitButton, $1109cda295b130f4$var$_extends({
                    ariaLabel: submitBtnProps.ariaLabel,
                    className: submitBtnClasses
                }, submitBtnProps))));
            }
        }
    ]);
    return Search;
}($1109cda295b130f4$var$_react["default"].Component);
$1109cda295b130f4$exports.Search = $1109cda295b130f4$var$Search;
$1109cda295b130f4$var$_defineProperty($1109cda295b130f4$var$Search, "propTypes", {
    /**
   * Additional props passed to the clear button
   */ clearBtnProps: $1109cda295b130f4$var$_propTypes["default"].object,
    /**
   * Additional props passed to the search submit button
   */ submitBtnProps: $1109cda295b130f4$var$_propTypes["default"].object,
    /**
   * Additional props passed to the search input
   */ inputProps: $1109cda295b130f4$var$_propTypes["default"].object,
    /**
   * onChange event of input triggered when input is updated
   */ onChange: $1109cda295b130f4$var$_propTypes["default"].func,
    /**
   * onClear event triggered when clear button is selected
   */ onClear: $1109cda295b130f4$var$_propTypes["default"].func
});
$1109cda295b130f4$var$_defineProperty($1109cda295b130f4$var$Search, "defaultProps", {
    clearBtnProps: {},
    submitBtnProps: {},
    inputProps: {}
});




function $8ab8f70d72091036$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $8ab8f70d72091036$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8ab8f70d72091036$var$_extends() {
    $8ab8f70d72091036$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8ab8f70d72091036$var$_extends.apply(this, arguments);
}
function $8ab8f70d72091036$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8ab8f70d72091036$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8ab8f70d72091036$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8ab8f70d72091036$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8ab8f70d72091036$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $8ab8f70d72091036$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8ab8f70d72091036$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8ab8f70d72091036$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $8ab8f70d72091036$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $8ab8f70d72091036$var$_setPrototypeOf(subClass, superClass);
}
function $8ab8f70d72091036$var$_setPrototypeOf(o, p) {
    $8ab8f70d72091036$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8ab8f70d72091036$var$_setPrototypeOf(o, p);
}
function $8ab8f70d72091036$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8ab8f70d72091036$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $8ab8f70d72091036$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $8ab8f70d72091036$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8ab8f70d72091036$var$_possibleConstructorReturn(this, result);
    };
}
function $8ab8f70d72091036$var$_possibleConstructorReturn(self, call) {
    if (call && ($8ab8f70d72091036$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $8ab8f70d72091036$var$_assertThisInitialized(self);
}
function $8ab8f70d72091036$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8ab8f70d72091036$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8ab8f70d72091036$var$_getPrototypeOf(o) {
    $8ab8f70d72091036$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8ab8f70d72091036$var$_getPrototypeOf(o);
}
var $8ab8f70d72091036$var$SearchIcon = function SearchIcon(props) {
    return /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("svg", props, /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("path", {
        d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
    }), /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }));
};
$8ab8f70d72091036$var$SearchIcon.defaultProps = $8ab8f70d72091036$var$_defineProperty({
    focusable: "false",
    'aria-hidden': "true",
    fill: "#666",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
}, "focusable", 'false');
var $8ab8f70d72091036$var$MenuIcon = function MenuIcon(props) {
    return /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("svg", props, /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("path", {
        d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
    }));
};
$8ab8f70d72091036$var$MenuIcon.defaultProps = $8ab8f70d72091036$var$_defineProperty({
    focusable: "false",
    'aria-hidden': "true",
    fill: "#666",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
}, "focusable", 'false');
var $8ab8f70d72091036$var$CancelIcon = function CancelIcon(props) {
    return /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("svg", props, /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }), /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }));
};
$8ab8f70d72091036$var$CancelIcon.defaultProps = $8ab8f70d72091036$var$_defineProperty({
    focusable: "false",
    'aria-hidden': "true",
    fill: "#666",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
}, "focusable", 'false');
var $8ab8f70d72091036$var$HeaderContext = /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createContext();
$8ab8f70d72091036$exports.HeaderContext = $8ab8f70d72091036$var$HeaderContext;
var $8ab8f70d72091036$var$NOOP = function NOOP() {
    return undefined;
};
var $8ab8f70d72091036$var$Header = /*#__PURE__*/ function(_React$Component) {
    $8ab8f70d72091036$var$_inherits(Header, _React$Component);
    var _super = $8ab8f70d72091036$var$_createSuper(Header);
    function Header(props) {
        var _this;
        $8ab8f70d72091036$var$_classCallCheck(this, Header);
        _this = _super.call(this, props);
        _this.state = {
            openSearch: false,
            openMenu: false,
            inputValue: "",
            isMobile: false
        };
        _this.inputRef = /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createRef();
        _this.handleClearBtnClick = _this.handleClearBtnClick.bind($8ab8f70d72091036$var$_assertThisInitialized(_this));
        _this.handleInputChange = _this.handleInputChange.bind($8ab8f70d72091036$var$_assertThisInitialized(_this));
        _this.handleSearchBtnClick = _this.handleSearchBtnClick.bind($8ab8f70d72091036$var$_assertThisInitialized(_this));
        _this.setWrapperRef = _this.setWrapperRef.bind($8ab8f70d72091036$var$_assertThisInitialized(_this));
        _this.setNavWrapperRef = _this.setNavWrapperRef.bind($8ab8f70d72091036$var$_assertThisInitialized(_this));
        _this.handleClickOutside = _this.handleClickOutside.bind($8ab8f70d72091036$var$_assertThisInitialized(_this));
        _this.handleMenuClick = _this.handleMenuClick.bind($8ab8f70d72091036$var$_assertThisInitialized(_this));
        _this.getWindowWidth = _this.getWindowWidth.bind($8ab8f70d72091036$var$_assertThisInitialized(_this));
        _this.onClickLink = _this.onClickLink.bind($8ab8f70d72091036$var$_assertThisInitialized(_this));
        return _this;
    }
    $8ab8f70d72091036$var$_createClass(Header, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener("mousedown", this.handleClickOutside);
                document.addEventListener("keyup", this.handleClickOutside);
                this.getWindowWidth();
                window.addEventListener("resize", this.getWindowWidth);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("mousedown", this.handleClickOutside);
                document.removeEventListener("keyup", this.handleClickOutside);
                window.removeEventListener("resize", this.getWindowWidth);
            }
        },
        {
            key: "getWindowWidth",
            value: function getWindowWidth() {
                if (window.innerWidth < this.props.menuBreakpoint) this.setState({
                    isMobile: true
                });
                else {
                    this.setState({
                        isMobile: false
                    });
                    this.setState({
                        openMenu: false
                    });
                    document.body.classList.remove("uxf-backdrop");
                    document.documentElement.classList.remove("uxf-backdrop");
                }
            }
        },
        {
            key: "handleClearBtnClick",
            value: function handleClearBtnClick() {
                this.setState({
                    inputValue: ""
                });
                this.inputRef.current.focus();
            }
        },
        {
            key: "handleInputChange",
            value: function handleInputChange(event) {
                this.setState({
                    inputValue: event.target.value
                });
            }
        },
        {
            key: "handleSearchBtnClick",
            value: function handleSearchBtnClick(event) {
                var currentState = this.state.openSearch;
                !currentState && event.preventDefault();
                !currentState && this.inputRef.current.focus();
                this.setState({
                    openSearch: !currentState
                });
                if (this.inputRef.current.value === "") event.preventDefault();
            }
        },
        {
            key: "handleMenuClick",
            value: function handleMenuClick() {
                var currentState = this.state.openMenu;
                this.setState({
                    openMenu: !currentState
                });
                if (!currentState && this.state.isMobile) {
                    document.body.classList.add("uxf-backdrop");
                    document.documentElement.classList.add("uxf-backdrop");
                } else {
                    document.body.classList.remove("uxf-backdrop");
                    document.documentElement.classList.remove("uxf-backdrop");
                }
            }
        },
        {
            key: "setWrapperRef",
            value: function setWrapperRef(node) {
                this.wrapperRef = node;
            }
        },
        {
            key: "setNavWrapperRef",
            value: function setNavWrapperRef(node) {
                this.navWrapperRef = node;
            }
        },
        {
            key: "handleClickOutside",
            value: function handleClickOutside(event) {
                if (this.wrapperRef && !this.wrapperRef.contains(event.target) && !this.mobileSearchBtn.contains(event.target)) this.setState({
                    openSearch: false
                });
                if (this.navWrapperRef && !this.navWrapperRef.contains(event.target)) {
                    if (this.state.openMenu) this.handleMenuClick();
                }
            }
        },
        {
            key: "onClickLink",
            value: function onClickLink() {
                if (this.state.isMobile) this.handleMenuClick();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, variant = _this$props.variant, className = _this$props.className, pageHeading = _this$props.pageHeading, pageHeadingLink = _this$props.pageHeadingLink, clearBtnProps = _this$props.clearBtnProps, submitBtnProps = _this$props.submitBtnProps, inputProps = _this$props.inputProps, navProps = _this$props.navProps, navbarProps = _this$props.navbarProps, formProps = _this$props.formProps, headerTitleComponent = _this$props.headerTitleComponent, logoLink = _this$props.logoLink, logoAriaLabel = _this$props.logoAriaLabel, closeIconAriaLabel = _this$props.closeIconAriaLabel, children = _this$props.children, search = _this$props.search, mobileMenu = _this$props.mobileMenu, navbar = _this$props.navbar, navbarCustom = _this$props.navbarCustom, skipLink = _this$props.skipLink, skipLinkText = _this$props.skipLinkText, menuBreakpoint = _this$props.menuBreakpoint, _this$props$logoLinkO = _this$props.logoLinkOnClick, logoLinkOnClick = _this$props$logoLinkO === void 0 ? $8ab8f70d72091036$var$NOOP : _this$props$logoLinkO, _this$props$pageHeadi = _this$props.pageHeadingLinkOnClick, pageHeadingLinkOnClick = _this$props$pageHeadi === void 0 ? $8ab8f70d72091036$var$NOOP : _this$props$pageHeadi, props = $8ab8f70d72091036$var$_objectWithoutProperties(_this$props, [
                    "variant",
                    "className",
                    "pageHeading",
                    "pageHeadingLink",
                    "clearBtnProps",
                    "submitBtnProps",
                    "inputProps",
                    "navProps",
                    "navbarProps",
                    "formProps",
                    "headerTitleComponent",
                    "logoLink",
                    "logoAriaLabel",
                    "closeIconAriaLabel",
                    "children",
                    "search",
                    "mobileMenu",
                    "navbar",
                    "navbarCustom",
                    "skipLink",
                    "skipLinkText",
                    "menuBreakpoint",
                    "logoLinkOnClick",
                    "pageHeadingLinkOnClick"
                ]);
                var classes = (0, $8ab8f70d72091036$var$_classnames["default"])("uxf-header", "navbar", !headerTitleComponent && "uxf-header-no-user", !search && "uxf-header-no-search", !mobileMenu && "uxf-header-no-menu", navbarCustom && !this.state.isMobile && "uxf-header-navbar-expanded", navbarCustom && "uxf-header-navbar", navbarCustom && menuBreakpoint >= 1200 && "uxf-header-navbar-xl", variant, className);
                var formClasses = (0, $8ab8f70d72091036$var$_classnames["default"])("uxf-header-search", "navbar-form", this.state.openSearch && "uxf-header-search-shown", formProps.className);
                var logoClasses = (0, $8ab8f70d72091036$var$_classnames["default"])("uxf-logo", variant === "uxf-header-jdf" && "uxf-logo-jdf", variant === "uxf-header-jdf-inline" && "uxf-logo-jdf-inline", variant === "uxf-header-bjd" && "uxf-logo-bjd");
                var inputClasses = (0, $8ab8f70d72091036$var$_classnames["default"])(this.state.inputValue && this.state.openSearch && "active", inputProps.className);
                var navbarClasses = (0, $8ab8f70d72091036$var$_classnames["default"])("uxf-top-nav", navbarCustom && !this.state.isMobile && "uxf-navbar-expanded", navbarCustom && this.state.isMobile && "uxf-navbar-mobile-active", navbarProps.className);
                return /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("div", {
                    ref: this.setNavWrapperRef
                }, /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("div", {
                    className: "uxf-skip-link"
                }, /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("a", {
                    className: "sr-only sr-only-focusable",
                    href: skipLink
                }, skipLinkText)), /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("header", $8ab8f70d72091036$var$_extends({
                    as: "header",
                    className: classes
                }, props), variant !== "uxf-header-unbranded" && /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("a", {
                    "aria-label": logoAriaLabel,
                    onClick: logoLinkOnClick,
                    href: logoLink
                }, /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("div", {
                    className: logoClasses
                })), /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("div", {
                    className: "uxf-header-title"
                }, /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("span", {
                    className: "h1 uxf-header-title-heading"
                }, /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("a", {
                    className: "uxf-header-title-link",
                    onClick: pageHeadingLinkOnClick,
                    href: pageHeadingLink,
                    "aria-label": variant === "uxf-header-unbranded" ? logoAriaLabel : undefined
                }, pageHeading)), headerTitleComponent), search && /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement($8ab8f70d72091036$var$_Button["default"], {
                    variant: "uxf-mobile-search",
                    className: "uxf-btn-search",
                    "aria-controls": "uxf-search-input",
                    "aria-expanded": this.state.openSearch,
                    onClick: this.handleSearchBtnClick,
                    ref: function ref(node) {
                        _this2.mobileSearchBtn = node;
                    }
                }, /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("span", {
                    className: "sr-only"
                }, "Toggle Search"), /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement($8ab8f70d72091036$var$SearchIcon, {
                    className: "uxf-icon-search"
                })), mobileMenu && navbar && /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement($8ab8f70d72091036$var$_Navbar["default"].Toggle, {
                    "aria-controls": "uxf-header-navbar",
                    "aria-expanded": this.state.openMenu,
                    onClick: this.handleMenuClick
                }, /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement($8ab8f70d72091036$var$MenuIcon, {
                    className: "menu-icon"
                })), search && /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement($8ab8f70d72091036$var$_Form["default"], $8ab8f70d72091036$var$_extends({
                    role: "search",
                    className: formClasses,
                    ref: this.setWrapperRef
                }, formProps), /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement($3f501adbefa810dd$exports.SearchInput, $8ab8f70d72091036$var$_extends({
                    id: "uxf-search-input",
                    tabIndex: this.state.openSearch ? 0 : -1,
                    onChange: this.handleInputChange,
                    value: this.state.inputValue,
                    ariaLabel: inputProps.ariaLabel,
                    innerRef: this.inputRef,
                    className: inputClasses,
                    placeholder: inputProps.placeholder
                }, inputProps)), /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement($3f501adbefa810dd$exports.SearchClearButton, $8ab8f70d72091036$var$_extends({
                    onClick: this.handleClearBtnClick,
                    ariaLabel: clearBtnProps.ariaLabel,
                    className: clearBtnProps.className
                }, clearBtnProps)), /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement($3f501adbefa810dd$exports.SearchSubmitButton, $8ab8f70d72091036$var$_extends({
                    ariaLabel: submitBtnProps.ariaLabel,
                    className: submitBtnProps.className,
                    onClick: this.handleSearchBtnClick,
                    "aria-controls": "uxf-search-input",
                    "aria-expanded": this.state.openSearch
                }, submitBtnProps)), /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement($8ab8f70d72091036$var$_Button["default"], {
                    type: "submit",
                    variant: "uxf-mobile-search"
                }, "Go"))), navbar && /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement($8ab8f70d72091036$var$_Navbar["default"], $8ab8f70d72091036$var$_extends({
                    variant: "uxf",
                    expand: "md",
                    className: navbarClasses
                }, navbarProps), /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement($8ab8f70d72091036$var$_Navbar["default"].Collapse, {
                    "in": this.state.openMenu,
                    id: "uxf-header-navbar"
                }, /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement($8ab8f70d72091036$var$_Nav["default"], navProps, /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement($8ab8f70d72091036$var$_Nav["default"].Item, {
                    className: "uxf-nav-back"
                }, /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement($8ab8f70d72091036$var$_Button["default"], {
                    variant: "link",
                    className: "navbar-back",
                    onClick: this.handleMenuClick,
                    "aria-label": closeIconAriaLabel,
                    "aria-controls": "uxf-header-navbar",
                    "aria-expanded": this.state.openMenu
                }, /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement($8ab8f70d72091036$var$CancelIcon, null))), /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement($8ab8f70d72091036$var$HeaderContext.Provider, {
                    value: {
                        onClickLink: this.onClickLink
                    }
                }, navbarCustom && this.state.isMobile && headerTitleComponent && /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("div", {
                    className: "uxf-header-dropdown-mobile nav-item"
                }, headerTitleComponent), children))), /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("span", {
                    className: "h1 uxf-nav-title"
                }, /*#__PURE__*/ $8ab8f70d72091036$var$_react["default"].createElement("a", {
                    href: pageHeadingLink
                }, pageHeading))));
            }
        }
    ]);
    return Header;
}($8ab8f70d72091036$var$_react["default"].Component);
$8ab8f70d72091036$exports.Header = $8ab8f70d72091036$var$Header;
$8ab8f70d72091036$var$Header.propTypes = {
    /**
   * Variations of Header
   * `"uxf-header-unbranded"` `"uxf-header-jdf"` `"uxf-header-jdf-inline"` `"uxf-header-bjd"`
   */ variant: $8ab8f70d72091036$var$_propTypes["default"].string,
    /**
   * Additional props passed to the clear search button
   */ clearBtnProps: $8ab8f70d72091036$var$_propTypes["default"].object,
    /**
   * Additional props passed to the submit search button
   */ submitBtnProps: $8ab8f70d72091036$var$_propTypes["default"].object,
    /**
   * Additional props passed to the search input
   */ inputProps: $8ab8f70d72091036$var$_propTypes["default"].object,
    /**
   * Additional props passed to the nav
   */ navProps: $8ab8f70d72091036$var$_propTypes["default"].object,
    /**
   * Additional props passed to the navbar
   */ navbarProps: $8ab8f70d72091036$var$_propTypes["default"].object,
    /**
   * Additional props passed to the form
   */ formProps: $8ab8f70d72091036$var$_propTypes["default"].object,
    /**
   * H1 heading of page (usually name of application)
   */ pageHeading: $8ab8f70d72091036$var$_propTypes["default"].string,
    /**
   * Link associated with heading (usually points to app home page)
   */ pageHeadingLink: $8ab8f70d72091036$var$_propTypes["default"].string.isRequired,
    /**
   * An onClick handler that is fired when the page heading link is clicked.
   */ pageHeadingLinkOnClick: $8ab8f70d72091036$var$_propTypes["default"].func,
    /**
   * Accepts a React component for adding a subheader or dropdown beneath heading
   */ headerTitleComponent: $8ab8f70d72091036$var$_propTypes["default"].element,
    /**
   * Includes a search in header
   */ search: $8ab8f70d72091036$var$_propTypes["default"].bool,
    /**
   * Includes mobileMenu in header
   */ mobileMenu: $8ab8f70d72091036$var$_propTypes["default"].bool,
    /**
   * Breakpoint for mobile menu.
   * Default in UXFrame CSS is 768px.
   * You must set navbarCustom to true for this prop to update the CSS.
   */ menuBreakpoint: $8ab8f70d72091036$var$_propTypes["default"].number,
    /**
   * Link associated with logo (usually points to home page)
   */ logoLink: $8ab8f70d72091036$var$_propTypes["default"].string.isRequired,
    /**
   * An onClick handler that is fired when the logo link is clicked.
   */ logoLinkOnClick: $8ab8f70d72091036$var$_propTypes["default"].func,
    /**
   * Aria-label added to logo for screen readers. This should be something like 'home page'
   * and most likely will not be the company name. Users with assistive technologies know which company's
   * site they are on, so putting the company name here is redundant.
   */ logoAriaLabel: $8ab8f70d72091036$var$_propTypes["default"].string,
    /**
   * Aria-label for close icon since icon has no text associated with it.
   */ closeIconAriaLabel: $8ab8f70d72091036$var$_propTypes["default"].string,
    /**
   * Includes a navbar
   */ navbar: $8ab8f70d72091036$var$_propTypes["default"].bool,
    /**
   * Uses custom header/navbar with ability to switch breakpoint
   * from the default 768px used. This property must be set to true
   * for the menuBreakpoint prop to work for values other than 768.
   */ navbarCustom: $8ab8f70d72091036$var$_propTypes["default"].bool,
    /**
   * Should point to id of main content. This allows users using screen readers or their keyboard
   * to quickly get to the main content of the site and avoid nav elements.
   */ skipLink: $8ab8f70d72091036$var$_propTypes["default"].string.isRequired,
    /**
   * Text associated with skip link
   */ skipLinkText: $8ab8f70d72091036$var$_propTypes["default"].string
};
$8ab8f70d72091036$var$Header.defaultProps = {
    clearBtnProps: {},
    submitBtnProps: {},
    inputProps: {},
    navProps: {},
    navbarProps: {},
    formProps: {},
    pageHeading: "Application Name",
    search: true,
    mobileMenu: true,
    logoAriaLabel: "home page",
    closeIconAriaLabel: "Close navigation menu",
    navbar: true,
    navbarCustom: false,
    skipLinkText: "Skip to main content",
    menuBreakpoint: 768
};


var $f0ab6cc09508342d$exports = {};
"use strict";
Object.defineProperty($f0ab6cc09508342d$exports, "__esModule", {
    value: true
});
$f0ab6cc09508342d$exports.HeaderButtonBack = void 0;

var $f0ab6cc09508342d$var$_classnames = $f0ab6cc09508342d$var$_interopRequireDefault((parcelRequire("fVt0T")));

var $f0ab6cc09508342d$var$_react = $f0ab6cc09508342d$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $bcd440a0b285e0c3$exports = {};
"use strict";
Object.defineProperty($bcd440a0b285e0c3$exports, "__esModule", {
    value: true
});
Object.defineProperty($bcd440a0b285e0c3$exports, "Nav", {
    enumerable: true,
    get: function get() {
        return $bb782340c7c0a75a$exports.Nav;
    }
});
Object.defineProperty($bcd440a0b285e0c3$exports, "NavWidget", {
    enumerable: true,
    get: function get() {
        return $41ecb75deafecb6f$exports.NavWidget;
    }
});
var $bb782340c7c0a75a$exports = {};
"use strict";
Object.defineProperty($bb782340c7c0a75a$exports, "__esModule", {
    value: true
});
$bb782340c7c0a75a$exports.Nav = void 0;

var $bb782340c7c0a75a$var$_propTypes = $bb782340c7c0a75a$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $bb782340c7c0a75a$var$_all = $bb782340c7c0a75a$var$_interopRequireDefault((parcelRequire("clW5X")));

var $bb782340c7c0a75a$var$_react = $bb782340c7c0a75a$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $bb782340c7c0a75a$var$_Nav = $bb782340c7c0a75a$var$_interopRequireDefault((parcelRequire("eqoNU")));

var $bb782340c7c0a75a$var$_NavItem = $bb782340c7c0a75a$var$_interopRequireDefault((parcelRequire("4sxXJ")));

var $bb782340c7c0a75a$var$_NavLink = $bb782340c7c0a75a$var$_interopRequireDefault((parcelRequire("b4orm")));
function $bb782340c7c0a75a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $bb782340c7c0a75a$var$_extends() {
    $bb782340c7c0a75a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bb782340c7c0a75a$var$_extends.apply(this, arguments);
}
function $bb782340c7c0a75a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bb782340c7c0a75a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bb782340c7c0a75a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $bb782340c7c0a75a$var$Nav = function Nav(_ref) {
    var className = _ref.className, children = _ref.children, ariaLabel = _ref.ariaLabel, props = $bb782340c7c0a75a$var$_objectWithoutProperties(_ref, [
        "className",
        "children",
        "ariaLabel"
    ]);
    return /*#__PURE__*/ $bb782340c7c0a75a$var$_react["default"].createElement($bb782340c7c0a75a$var$_Nav["default"], $bb782340c7c0a75a$var$_extends({}, props, {
        className: className,
        "aria-label": ariaLabel
    }), children);
};
$bb782340c7c0a75a$exports.Nav = $bb782340c7c0a75a$var$Nav;
$bb782340c7c0a75a$var$Nav.propTypes = {
    /**
   * Aria-label for element
   */ ariaLabel: $bb782340c7c0a75a$var$_propTypes["default"].string,
    /**
   * @default 'nav'
   */ bsPrefix: $bb782340c7c0a75a$var$_propTypes["default"].string,
    /** @private */ navbarBsPrefix: $bb782340c7c0a75a$var$_propTypes["default"].string,
    /** @private */ cardHeaderBsPrefix: $bb782340c7c0a75a$var$_propTypes["default"].string,
    /**
   * The visual variant of the nav items.
   *
   * `"tabs"` `"pills"`
   */ variant: $bb782340c7c0a75a$var$_propTypes["default"].string,
    /**
   * Marks the NavItem with a matching `eventKey` (or `href` if present) as active.
   *
   * @type {string}
   */ activeKey: $bb782340c7c0a75a$var$_propTypes["default"].any,
    /**
   * Have all `NavItem`s proportionately fill all available width.
   */ fill: $bb782340c7c0a75a$var$_propTypes["default"].bool,
    /**
   * Have all `NavItem`s evenly fill all available width.
   *
   * @type {boolean}
   */ justify: (0, $bb782340c7c0a75a$var$_all["default"])($bb782340c7c0a75a$var$_propTypes["default"].bool, function(_ref2) {
        var justify = _ref2.justify, navbar = _ref2.navbar;
        return justify && navbar ? Error("justify navbar `Nav`s are not supported") : null;
    }),
    /**
   * A callback fired when a NavItem is selected.
   */ onSelect: $bb782340c7c0a75a$var$_propTypes["default"].func,
    /**
   * ARIA role for the Nav, in the context of a TabContainer, the default will
   * be set to "tablist", but can be overridden by the Nav when set explicitly.
   *
   * When the role is "tablist", NavLink focus is managed according to
   * the ARIA authoring practices for tabs:
   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
   */ role: $bb782340c7c0a75a$var$_propTypes["default"].string,
    /**
   * Apply styling an alignment for use in a Navbar. This prop will be set
   * automatically when the Nav is used inside a Navbar.
   */ navbar: $bb782340c7c0a75a$var$_propTypes["default"].bool,
    as: $bb782340c7c0a75a$var$_propTypes["default"].elementType,
    /** @private */ onKeyDown: $bb782340c7c0a75a$var$_propTypes["default"].func
};
$bb782340c7c0a75a$var$Nav.Item = $bb782340c7c0a75a$var$_NavItem["default"];
$bb782340c7c0a75a$var$Nav.Link = $bb782340c7c0a75a$var$_NavLink["default"];


var $41ecb75deafecb6f$exports = {};
"use strict";
Object.defineProperty($41ecb75deafecb6f$exports, "__esModule", {
    value: true
});
$41ecb75deafecb6f$exports.NavWidget = void 0;

var $41ecb75deafecb6f$var$_react = $41ecb75deafecb6f$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $41ecb75deafecb6f$var$_propTypes = $41ecb75deafecb6f$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $41ecb75deafecb6f$var$_classnames = $41ecb75deafecb6f$var$_interopRequireDefault((parcelRequire("fVt0T")));

var $41ecb75deafecb6f$var$_Button = $41ecb75deafecb6f$var$_interopRequireDefault((parcelRequire("6MAJg")));
function $41ecb75deafecb6f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $41ecb75deafecb6f$var$_extends() {
    $41ecb75deafecb6f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $41ecb75deafecb6f$var$_extends.apply(this, arguments);
}
function $41ecb75deafecb6f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $41ecb75deafecb6f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $41ecb75deafecb6f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $41ecb75deafecb6f$var$NavWidget = function NavWidget(_ref) {
    var ariaLabel = _ref.ariaLabel, value = _ref.value, variant = _ref.variant, maxValue = _ref.maxValue, className = _ref.className, children = _ref.children, props = $41ecb75deafecb6f$var$_objectWithoutProperties(_ref, [
        "ariaLabel",
        "value",
        "variant",
        "maxValue",
        "className",
        "children"
    ]);
    var classes = (0, $41ecb75deafecb6f$var$_classnames["default"])('uxf-nav-widget', variant == 'notification' && 'uxf-notification-widget', variant == 'cart' && 'uxf-cart-widget', className);
    var parsedValue = parseInt(value);
    if (parsedValue > maxValue) parsedValue = "".concat(maxValue, "+");
    var currentAriaLabel = variant == 'notification' ? "".concat(parsedValue, " ").concat(variant, "s") : "".concat(parsedValue, " ").concat(variant, " items");
    var emptyAriaLabel = currentAriaLabel;
    if (parseInt(parsedValue) > 0) emptyAriaLabel = null;
    return /*#__PURE__*/ $41ecb75deafecb6f$var$_react["default"].createElement($41ecb75deafecb6f$var$_react["default"].Fragment, null, /*#__PURE__*/ $41ecb75deafecb6f$var$_react["default"].createElement($41ecb75deafecb6f$var$_Button["default"], $41ecb75deafecb6f$var$_extends({
        variant: "link",
        className: classes,
        "aria-label": ariaLabel && emptyAriaLabel ? ariaLabel : emptyAriaLabel
    }, props), children, parseInt(parsedValue) > 0 && /*#__PURE__*/ $41ecb75deafecb6f$var$_react["default"].createElement("span", {
        className: "uxf-badge-number",
        "aria-label": ariaLabel ? ariaLabel : currentAriaLabel
    }, parsedValue)));
};
$41ecb75deafecb6f$exports.NavWidget = $41ecb75deafecb6f$var$NavWidget;
$41ecb75deafecb6f$var$NavWidget.propTypes = {
    /**
   * Aria-label for navigation widget button. This is generated automatically for notifications and cart items.
   */ ariaLabel: $41ecb75deafecb6f$var$_propTypes["default"].string,
    /**
   * Number associated with widget. For example, the number of items in a cart or the number of notifications.
   */ value: $41ecb75deafecb6f$var$_propTypes["default"].oneOfType([
        $41ecb75deafecb6f$var$_propTypes["default"].string,
        $41ecb75deafecb6f$var$_propTypes["default"].number
    ]),
    /**
   * Variant of widget. Default options include 'notification' and 'cart'
   */ variant: $41ecb75deafecb6f$var$_propTypes["default"].string,
    /**
   * Max value. A max value of 99 will display '99+' if there are
   * more than 99 items.
   */ maxValue: $41ecb75deafecb6f$var$_propTypes["default"].number
};
$41ecb75deafecb6f$var$NavWidget.defaultProps = {
    value: 0,
    variant: 'notification',
    maxValue: 99
};




function $f0ab6cc09508342d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $f0ab6cc09508342d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f0ab6cc09508342d$var$_extends() {
    $f0ab6cc09508342d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f0ab6cc09508342d$var$_extends.apply(this, arguments);
}
function $f0ab6cc09508342d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f0ab6cc09508342d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f0ab6cc09508342d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f0ab6cc09508342d$var$ChevronLeftIcon = function ChevronLeftIcon(props) {
    return /*#__PURE__*/ $f0ab6cc09508342d$var$_react["default"].createElement("svg", props, /*#__PURE__*/ $f0ab6cc09508342d$var$_react["default"].createElement("path", {
        d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
    }), /*#__PURE__*/ $f0ab6cc09508342d$var$_react["default"].createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0V0z"
    }));
};
$f0ab6cc09508342d$var$ChevronLeftIcon.defaultProps = $f0ab6cc09508342d$var$_defineProperty({
    focusable: "false",
    'aria-hidden': "true",
    fill: "#666",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
}, "focusable", 'false');
var $f0ab6cc09508342d$var$HeaderButtonBack = function HeaderButtonBack(_ref) {
    var className = _ref.className, children = _ref.children, props = $f0ab6cc09508342d$var$_objectWithoutProperties(_ref, [
        "className",
        "children"
    ]);
    var classes = (0, $f0ab6cc09508342d$var$_classnames["default"])("uxf-back-link", className);
    return /*#__PURE__*/ $f0ab6cc09508342d$var$_react["default"].createElement($7539a0d62b4a3f5e$exports.Dropdown.Toggle, $f0ab6cc09508342d$var$_extends({
        className: classes,
        as: $bcd440a0b285e0c3$exports.Nav.Link,
        bsPrefix: " "
    }, props), /*#__PURE__*/ $f0ab6cc09508342d$var$_react["default"].createElement($f0ab6cc09508342d$var$ChevronLeftIcon, null), " ", children);
};
$f0ab6cc09508342d$exports.HeaderButtonBack = $f0ab6cc09508342d$var$HeaderButtonBack;




var $93f03239d9e68f5a$exports = {};
"use strict";
Object.defineProperty($93f03239d9e68f5a$exports, "__esModule", {
    value: true
});
Object.defineProperty($93f03239d9e68f5a$exports, "HelperText", {
    enumerable: true,
    get: function get() {
        return $014f4dd4530e78ee$exports.HelperText;
    }
});
var $014f4dd4530e78ee$exports = {};
"use strict";
Object.defineProperty($014f4dd4530e78ee$exports, "__esModule", {
    value: true
});
$014f4dd4530e78ee$exports.HelperText = void 0;

var $014f4dd4530e78ee$var$_propTypes = $014f4dd4530e78ee$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $014f4dd4530e78ee$var$_classnames = $014f4dd4530e78ee$var$_interopRequireDefault((parcelRequire("fVt0T")));

var $014f4dd4530e78ee$var$_react = $014f4dd4530e78ee$var$_interopRequireDefault((parcelRequire("Fo7oF")));
function $014f4dd4530e78ee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $014f4dd4530e78ee$var$_extends() {
    $014f4dd4530e78ee$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $014f4dd4530e78ee$var$_extends.apply(this, arguments);
}
function $014f4dd4530e78ee$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $014f4dd4530e78ee$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $014f4dd4530e78ee$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $014f4dd4530e78ee$var$HelperText = function HelperText(_ref) {
    var helperText = _ref.helperText, helperTextId = _ref.helperTextId, className = _ref.className, children = _ref.children, smallProps = _ref.smallProps, props = $014f4dd4530e78ee$var$_objectWithoutProperties(_ref, [
        "helperText",
        "helperTextId",
        "className",
        "children",
        "smallProps"
    ]);
    var classes = (0, $014f4dd4530e78ee$var$_classnames["default"])("form-text", "text-muted", smallProps.className);
    return /*#__PURE__*/ $014f4dd4530e78ee$var$_react["default"].createElement("div", $014f4dd4530e78ee$var$_extends({}, props, {
        className: className
    }), children, /*#__PURE__*/ $014f4dd4530e78ee$var$_react["default"].createElement("small", $014f4dd4530e78ee$var$_extends({
        id: helperTextId
    }, smallProps, {
        className: classes
    }), helperText));
};
$014f4dd4530e78ee$exports.HelperText = $014f4dd4530e78ee$var$HelperText;
$014f4dd4530e78ee$var$HelperText.propTypes = {
    /**
   * Text associated with input.
   */ helperText: $014f4dd4530e78ee$var$_propTypes["default"].string.isRequired,
    /**
   * An html id attribute for the HelperText, necessary for assistive technologies, such as screen readers.
   */ helperTextId: $014f4dd4530e78ee$var$_propTypes["default"].string.isRequired,
    /**
   * Properties passed down to `<small>`
   */ smallProps: $014f4dd4530e78ee$var$_propTypes["default"].object
};
$014f4dd4530e78ee$var$HelperText.defaultProps = {
    smallProps: {}
};





var $9c142335d2b8ec6f$exports = {};
"use strict";
Object.defineProperty($9c142335d2b8ec6f$exports, "__esModule", {
    value: true
});
Object.defineProperty($9c142335d2b8ec6f$exports, "List", {
    enumerable: true,
    get: function get() {
        return $a9a1e150881a7f7d$exports.List;
    }
});
Object.defineProperty($9c142335d2b8ec6f$exports, "ListItem", {
    enumerable: true,
    get: function get() {
        return $b2d5389d2c66c0fd$exports.ListItem;
    }
});
Object.defineProperty($9c142335d2b8ec6f$exports, "ListGroup", {
    enumerable: true,
    get: function get() {
        return $5c1f3837b8bc9587$exports.ListGroup;
    }
});
var $a9a1e150881a7f7d$exports = {};
"use strict";
Object.defineProperty($a9a1e150881a7f7d$exports, "__esModule", {
    value: true
});
$a9a1e150881a7f7d$exports.List = void 0;

var $a9a1e150881a7f7d$var$_classnames = $a9a1e150881a7f7d$var$_interopRequireDefault((parcelRequire("fVt0T")));

var $a9a1e150881a7f7d$var$_propTypes = $a9a1e150881a7f7d$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $a9a1e150881a7f7d$var$_react = $a9a1e150881a7f7d$var$_interopRequireDefault((parcelRequire("Fo7oF")));
function $a9a1e150881a7f7d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $a9a1e150881a7f7d$var$_extends() {
    $a9a1e150881a7f7d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a9a1e150881a7f7d$var$_extends.apply(this, arguments);
}
function $a9a1e150881a7f7d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a9a1e150881a7f7d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a9a1e150881a7f7d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a9a1e150881a7f7d$var$List = function List(_ref) {
    var className = _ref.className, children = _ref.children, variant = _ref.variant, Component = _ref.as, props = $a9a1e150881a7f7d$var$_objectWithoutProperties(_ref, [
        "className",
        "children",
        "variant",
        "as"
    ]);
    var classes = (0, $a9a1e150881a7f7d$var$_classnames["default"])(className, variant);
    return /*#__PURE__*/ $a9a1e150881a7f7d$var$_react["default"].createElement(Component, $a9a1e150881a7f7d$var$_extends({}, props, {
        className: classes ? classes : null
    }), children);
};
$a9a1e150881a7f7d$exports.List = $a9a1e150881a7f7d$var$List;
$a9a1e150881a7f7d$var$List.propTypes = {
    /**
   * One or more list variant combinations
   *
   * `"uxf-ul"` `"list-unstyled"` `"uxf-line-separated"` `"uxf-dl"` `"uxf-dl-horizontal"` `"list-inline"`
   */ variant: $a9a1e150881a7f7d$var$_propTypes["default"].string,
    /** Set a custom element for this component */ as: $a9a1e150881a7f7d$var$_propTypes["default"].elementType
};
$a9a1e150881a7f7d$var$List.defaultProps = {
    variant: "",
    as: "ul"
};


var $b2d5389d2c66c0fd$exports = {};
"use strict";
Object.defineProperty($b2d5389d2c66c0fd$exports, "__esModule", {
    value: true
});
$b2d5389d2c66c0fd$exports.ListItem = void 0;

var $b2d5389d2c66c0fd$var$_classnames = $b2d5389d2c66c0fd$var$_interopRequireDefault((parcelRequire("fVt0T")));

var $b2d5389d2c66c0fd$var$_propTypes = $b2d5389d2c66c0fd$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $b2d5389d2c66c0fd$var$_react = $b2d5389d2c66c0fd$var$_interopRequireDefault((parcelRequire("Fo7oF")));
function $b2d5389d2c66c0fd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b2d5389d2c66c0fd$var$_extends() {
    $b2d5389d2c66c0fd$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b2d5389d2c66c0fd$var$_extends.apply(this, arguments);
}
function $b2d5389d2c66c0fd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b2d5389d2c66c0fd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b2d5389d2c66c0fd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b2d5389d2c66c0fd$var$ListItem = function ListItem(_ref) {
    var className = _ref.className, variant = _ref.variant, children = _ref.children, props = $b2d5389d2c66c0fd$var$_objectWithoutProperties(_ref, [
        "className",
        "variant",
        "children"
    ]);
    var classes = (0, $b2d5389d2c66c0fd$var$_classnames["default"])(className, variant);
    return /*#__PURE__*/ $b2d5389d2c66c0fd$var$_react["default"].createElement("li", $b2d5389d2c66c0fd$var$_extends({}, props, {
        className: classes ? classes : null
    }), children);
};
$b2d5389d2c66c0fd$exports.ListItem = $b2d5389d2c66c0fd$var$ListItem;
$b2d5389d2c66c0fd$var$ListItem.propTypes = {
    /**
   * One or more list item variant combinations
   *
   * `"list-inline-item"`
   */ variant: $b2d5389d2c66c0fd$var$_propTypes["default"].string
};
$b2d5389d2c66c0fd$var$ListItem.defaultProps = {
    variant: ""
};


var $5c1f3837b8bc9587$exports = {};
"use strict";
Object.defineProperty($5c1f3837b8bc9587$exports, "__esModule", {
    value: true
});
$5c1f3837b8bc9587$exports.ListGroup = void 0;

var $5c1f3837b8bc9587$var$_react = $5c1f3837b8bc9587$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $5c1f3837b8bc9587$var$_propTypes = $5c1f3837b8bc9587$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $5c1f3837b8bc9587$var$_ListGroup = $5c1f3837b8bc9587$var$_interopRequireDefault((parcelRequire("jXWG9")));

var $5c1f3837b8bc9587$var$_ListGroupItem = $5c1f3837b8bc9587$var$_interopRequireDefault((parcelRequire("4PQpn")));
function $5c1f3837b8bc9587$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $5c1f3837b8bc9587$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5c1f3837b8bc9587$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5c1f3837b8bc9587$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $5c1f3837b8bc9587$var$ListGroup = function ListGroup(_ref) {
    var children = _ref.children, props = $5c1f3837b8bc9587$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $5c1f3837b8bc9587$var$_react["default"].createElement($5c1f3837b8bc9587$var$_ListGroup["default"], props, children);
};
$5c1f3837b8bc9587$exports.ListGroup = $5c1f3837b8bc9587$var$ListGroup;
$5c1f3837b8bc9587$var$ListGroup.propTypes = {
    /**
   * @default 'list-group'
   */ bsPrefix: $5c1f3837b8bc9587$var$_propTypes["default"].string,
    /**
   * Adds a variant to the list-group
   *
   * @type {('flush')}
   */ variant: $5c1f3837b8bc9587$var$_propTypes["default"].oneOf([
        "flush",
        null
    ]),
    /**
   * Changes the flow of the list group items from vertical to horizontal.
   * A value of `null` (the default) sets it to vertical for all breakpoints;
   * Just including the prop sets it for all breakpoints, while `{sm|md|lg|xl}`
   * makes the list group horizontal starting at that breakpoint’s `min-width`.
   * @type {(true|'sm'|'md'|'lg'|'xl')}
   */ horizontal: $5c1f3837b8bc9587$var$_propTypes["default"].oneOf([
        true,
        "sm",
        "md",
        "lg",
        "xl",
        null
    ]),
    /**
   * You can use a custom element type for this component.
   */ as: $5c1f3837b8bc9587$var$_propTypes["default"].elementType
};
$5c1f3837b8bc9587$var$ListGroup.Item = $5c1f3837b8bc9587$var$_ListGroupItem["default"];




var $b34be20ee0a3cabd$exports = {};
"use strict";
Object.defineProperty($b34be20ee0a3cabd$exports, "__esModule", {
    value: true
});
Object.defineProperty($b34be20ee0a3cabd$exports, "Modal", {
    enumerable: true,
    get: function get() {
        return $6485546c5ad9fad1$exports.Modal;
    }
});
Object.defineProperty($b34be20ee0a3cabd$exports, "CloseButton", {
    enumerable: true,
    get: function get() {
        return $cabb4142450a1094$exports.CloseButton;
    }
});
var $6485546c5ad9fad1$exports = {};
"use strict";
Object.defineProperty($6485546c5ad9fad1$exports, "__esModule", {
    value: true
});
$6485546c5ad9fad1$exports.Modal = void 0;

var $6485546c5ad9fad1$var$_react = $6485546c5ad9fad1$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $6485546c5ad9fad1$var$_propTypes = $6485546c5ad9fad1$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $6485546c5ad9fad1$var$_Modal = $6485546c5ad9fad1$var$_interopRequireDefault((parcelRequire("7I3gr")));

var $6485546c5ad9fad1$var$_ModalBody = $6485546c5ad9fad1$var$_interopRequireDefault((parcelRequire("7R8os")));

var $6485546c5ad9fad1$var$_ModalDialog = $6485546c5ad9fad1$var$_interopRequireDefault((parcelRequire("h6QVW")));

var $6485546c5ad9fad1$var$_ModalFooter = $6485546c5ad9fad1$var$_interopRequireDefault((parcelRequire("avYaS")));

var $6485546c5ad9fad1$var$_ModalHeader = $6485546c5ad9fad1$var$_interopRequireDefault((parcelRequire("8BYaT")));

var $6485546c5ad9fad1$var$_ModalTitle = $6485546c5ad9fad1$var$_interopRequireDefault((parcelRequire("1pLWH")));
function $6485546c5ad9fad1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6485546c5ad9fad1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6485546c5ad9fad1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6485546c5ad9fad1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $6485546c5ad9fad1$var$Modal = function Modal(_ref) {
    var children = _ref.children, props = $6485546c5ad9fad1$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $6485546c5ad9fad1$var$_react["default"].createElement($6485546c5ad9fad1$var$_Modal["default"], props, children);
};
$6485546c5ad9fad1$exports.Modal = $6485546c5ad9fad1$var$Modal;
$6485546c5ad9fad1$var$Modal.propTypes = {
    /**
   * @default 'modal'
   */ bsPrefix: $6485546c5ad9fad1$var$_propTypes["default"].string,
    /**
   * Render a large, extra large or small modal.
   *
   * `"sm"` `"lg"` `"xl"`
   */ size: $6485546c5ad9fad1$var$_propTypes["default"].string,
    /**
   * vertically center the Dialog in the window
   */ centered: $6485546c5ad9fad1$var$_propTypes["default"].bool,
    /**
   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
   * trigger an "onHide" when clicked.
   */ backdrop: $6485546c5ad9fad1$var$_propTypes["default"].oneOf([
        "static",
        true,
        false
    ]),
    /**
   * Add an optional extra class name to .modal-backdrop
   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
   */ backdropClassName: $6485546c5ad9fad1$var$_propTypes["default"].string,
    /**
   * Close the modal when escape key is pressed
   */ keyboard: $6485546c5ad9fad1$var$_propTypes["default"].bool,
    /**
   * Allows scrolling the `<Modal.Body>` instead of the entire Modal when overflowing.
   */ scrollable: $6485546c5ad9fad1$var$_propTypes["default"].bool,
    /**
   * Open and close the Modal with a slide and fade animation.
   */ animation: $6485546c5ad9fad1$var$_propTypes["default"].bool,
    /**
   * A css class to apply to the Modal dialog DOM node.
   */ dialogClassName: $6485546c5ad9fad1$var$_propTypes["default"].string,
    /**
   * A Component type that provides the modal content Markup. This is a useful
   * prop when you want to use your own styles and markup to create a custom
   * modal component.
   */ dialogAs: $6485546c5ad9fad1$var$_propTypes["default"].elementType,
    /**
   * When `true` The modal will automatically shift focus to itself when it
   * opens, and replace it to the last focused element when it closes.
   * Generally this should never be set to false as it makes the Modal less
   * accessible to assistive technologies, like screen-readers.
   */ autoFocus: $6485546c5ad9fad1$var$_propTypes["default"].bool,
    /**
   * When `true` The modal will prevent focus from leaving the Modal while
   * open. Consider leaving the default value here, as it is necessary to make
   * the Modal work well with assistive technologies, such as screen readers.
   */ enforceFocus: $6485546c5ad9fad1$var$_propTypes["default"].bool,
    /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */ restoreFocus: $6485546c5ad9fad1$var$_propTypes["default"].bool,
    /**
   * Options passed to focus function when `restoreFocus` is set to `true`
   *
   * @link  https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#Parameters
   */ restoreFocusOptions: $6485546c5ad9fad1$var$_propTypes["default"].shape({
        preventScroll: $6485546c5ad9fad1$var$_propTypes["default"].bool
    }),
    /**
   * When `true` The modal will show itself.
   */ show: $6485546c5ad9fad1$var$_propTypes["default"].bool,
    /**
   * A callback fired when the Modal is opening.
   */ onShow: $6485546c5ad9fad1$var$_propTypes["default"].func,
    /**
   * A callback fired when the header closeButton or non-static backdrop is
   * clicked. Required if either are specified.
   */ onHide: $6485546c5ad9fad1$var$_propTypes["default"].func,
    /**
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   */ onEscapeKeyDown: $6485546c5ad9fad1$var$_propTypes["default"].func,
    /**
   * Callback fired before the Modal transitions in
   */ onEnter: $6485546c5ad9fad1$var$_propTypes["default"].func,
    /**
   * Callback fired as the Modal begins to transition in
   */ onEntering: $6485546c5ad9fad1$var$_propTypes["default"].func,
    /**
   * Callback fired after the Modal finishes transitioning in
   */ onEntered: $6485546c5ad9fad1$var$_propTypes["default"].func,
    /**
   * Callback fired right before the Modal transitions out
   */ onExit: $6485546c5ad9fad1$var$_propTypes["default"].func,
    /**
   * Callback fired as the Modal begins to transition out
   */ onExiting: $6485546c5ad9fad1$var$_propTypes["default"].func,
    /**
   * Callback fired after the Modal finishes transitioning out
   */ onExited: $6485546c5ad9fad1$var$_propTypes["default"].func,
    /**
   * A ModalManager instance used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container
   */ manager: $6485546c5ad9fad1$var$_propTypes["default"].object,
    /**
   * @private
   */ container: $6485546c5ad9fad1$var$_propTypes["default"].any
};
$6485546c5ad9fad1$var$Modal.Body = $6485546c5ad9fad1$var$_ModalBody["default"];
$6485546c5ad9fad1$var$Modal.Header = $6485546c5ad9fad1$var$_ModalHeader["default"];
$6485546c5ad9fad1$var$Modal.Title = $6485546c5ad9fad1$var$_ModalTitle["default"];
$6485546c5ad9fad1$var$Modal.Footer = $6485546c5ad9fad1$var$_ModalFooter["default"];
$6485546c5ad9fad1$var$Modal.Dialog = $6485546c5ad9fad1$var$_ModalDialog["default"];
$6485546c5ad9fad1$var$Modal.TRANSITION_DURATION = 300;
$6485546c5ad9fad1$var$Modal.BACKDROP_TRANSITION_DURATION = 150;


var $cabb4142450a1094$exports = {};
"use strict";
Object.defineProperty($cabb4142450a1094$exports, "__esModule", {
    value: true
});
$cabb4142450a1094$exports.CloseButton = void 0;

var $cabb4142450a1094$var$_propTypes = $cabb4142450a1094$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $cabb4142450a1094$var$_react = $cabb4142450a1094$var$_interopRequireDefault((parcelRequire("Fo7oF")));
function $cabb4142450a1094$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $cabb4142450a1094$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $cabb4142450a1094$var$CloseIcon = function CloseIcon(props) {
    return /*#__PURE__*/ $cabb4142450a1094$var$_react["default"].createElement("svg", props, /*#__PURE__*/ $cabb4142450a1094$var$_react["default"].createElement("path", {
        d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }), /*#__PURE__*/ $cabb4142450a1094$var$_react["default"].createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }));
};
$cabb4142450a1094$var$CloseIcon.defaultProps = $cabb4142450a1094$var$_defineProperty({
    focusable: "false",
    'aria-hidden': "true",
    fill: "#666",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
}, "focusable", 'false');
var $cabb4142450a1094$var$CloseButton = function CloseButton(_ref) {
    var label = _ref.label, onClick = _ref.onClick;
    return /*#__PURE__*/ $cabb4142450a1094$var$_react["default"].createElement("button", {
        type: "button",
        className: "btn uxf-btn-icon",
        onClick: onClick,
        "aria-label": label
    }, /*#__PURE__*/ $cabb4142450a1094$var$_react["default"].createElement($cabb4142450a1094$var$CloseIcon, null));
};
$cabb4142450a1094$exports.CloseButton = $cabb4142450a1094$var$CloseButton;
$cabb4142450a1094$var$CloseButton.propTypes = {
    /**
   * Aria-label for close icon since icon has no text associated with it.
   */ label: $cabb4142450a1094$var$_propTypes["default"].string.isRequired,
    /**
   * Function associated with 'click' of close icon
   */ onClick: $cabb4142450a1094$var$_propTypes["default"].func
};
$cabb4142450a1094$var$CloseButton.defaultProps = {
    label: 'Close'
};





var $ea0992e05dad91c6$exports = {};
"use strict";
Object.defineProperty($ea0992e05dad91c6$exports, "__esModule", {
    value: true
});
Object.defineProperty($ea0992e05dad91c6$exports, "OverlayTrigger", {
    enumerable: true,
    get: function get() {
        return $a2598427a5c3ff2c$exports.OverlayTrigger;
    }
});
var $a2598427a5c3ff2c$exports = {};
"use strict";
Object.defineProperty($a2598427a5c3ff2c$exports, "__esModule", {
    value: true
});
$a2598427a5c3ff2c$exports.OverlayTrigger = void 0;

var $a2598427a5c3ff2c$var$_react = $a2598427a5c3ff2c$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $a2598427a5c3ff2c$var$_propTypes = $a2598427a5c3ff2c$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $a2598427a5c3ff2c$var$_OverlayTrigger = $a2598427a5c3ff2c$var$_interopRequireDefault((parcelRequire("80dAi")));
function $a2598427a5c3ff2c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $a2598427a5c3ff2c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a2598427a5c3ff2c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a2598427a5c3ff2c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a2598427a5c3ff2c$var$OverlayTrigger = function OverlayTrigger(_ref) {
    var children = _ref.children, props = $a2598427a5c3ff2c$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $a2598427a5c3ff2c$var$_react["default"].createElement($a2598427a5c3ff2c$var$_OverlayTrigger["default"], props, children);
};
$a2598427a5c3ff2c$exports.OverlayTrigger = $a2598427a5c3ff2c$var$OverlayTrigger;
var $a2598427a5c3ff2c$var$triggerType = $a2598427a5c3ff2c$var$_propTypes["default"].oneOf([
    "click",
    "hover",
    "focus"
]);
$a2598427a5c3ff2c$var$OverlayTrigger.propTypes = {
    children: $a2598427a5c3ff2c$var$_propTypes["default"].oneOfType([
        $a2598427a5c3ff2c$var$_propTypes["default"].element,
        $a2598427a5c3ff2c$var$_propTypes["default"].func
    ]),
    /**
   * Specify which action or actions trigger Overlay visibility
   *
   * @type {'hover' | 'click' |'focus' | Array<'hover' | 'click' |'focus'>}
   */ trigger: $a2598427a5c3ff2c$var$_propTypes["default"].oneOfType([
        $a2598427a5c3ff2c$var$triggerType,
        $a2598427a5c3ff2c$var$_propTypes["default"].arrayOf($a2598427a5c3ff2c$var$triggerType)
    ]),
    /**
   * A millisecond delay amount to show and hide the Overlay once triggered
   */ delay: $a2598427a5c3ff2c$var$_propTypes["default"].oneOfType([
        $a2598427a5c3ff2c$var$_propTypes["default"].number,
        $a2598427a5c3ff2c$var$_propTypes["default"].shape({
            show: $a2598427a5c3ff2c$var$_propTypes["default"].number,
            hide: $a2598427a5c3ff2c$var$_propTypes["default"].number
        })
    ]),
    /**
   * The visibility of the Overlay. `show` is a _controlled_ prop so should be paired
   * with `onToggle` to avoid breaking user interactions.
   *
   * Manually toggling `show` does **not** wait for `delay` to change the visibility.
   *
   * @controllable onToggle
   */ show: $a2598427a5c3ff2c$var$_propTypes["default"].bool,
    /**
   * The initial visibility state of the Overlay.
   */ defaultShow: $a2598427a5c3ff2c$var$_propTypes["default"].bool,
    /**
   * A callback that fires when the user triggers a change in tooltip visibility.
   *
   * `onToggle` is called with the desired next `show`, and generally should be passed
   * back to the `show` prop. `onToggle` fires _after_ the configured `delay`
   *
   * @controllable `show`
   */ onToggle: $a2598427a5c3ff2c$var$_propTypes["default"].func,
    /**
    The initial flip state of the Overlay.
   */ flip: $a2598427a5c3ff2c$var$_propTypes["default"].bool,
    /**
   * An element or text to overlay next to the target.
   */ overlay: $a2598427a5c3ff2c$var$_propTypes["default"].oneOfType([
        $a2598427a5c3ff2c$var$_propTypes["default"].func,
        $a2598427a5c3ff2c$var$_propTypes["default"].element
    ]),
    /**
   * A Popper.js config object passed to the the underlying popper instance.
   */ popperConfig: $a2598427a5c3ff2c$var$_propTypes["default"].object,
    // Overridden props from `<Overlay>`.
    /**
   * @private
   */ target: $a2598427a5c3ff2c$var$_propTypes["default"].oneOf([
        null
    ]),
    /**
   * @private
   */ onHide: $a2598427a5c3ff2c$var$_propTypes["default"].oneOf([
        null
    ]),
    /**
   * The placement of the Overlay in relation to it's `target`.
   */ placement: $a2598427a5c3ff2c$var$_propTypes["default"].oneOf([
        "auto-start",
        "auto",
        "auto-end",
        "top-start",
        "top",
        "top-end",
        "right-start",
        "right",
        "right-end",
        "bottom-end",
        "bottom",
        "bottom-start",
        "left-end",
        "left",
        "left-start"
    ])
};




var $884fc36dcfc434f7$exports = {};
"use strict";
Object.defineProperty($884fc36dcfc434f7$exports, "__esModule", {
    value: true
});
Object.defineProperty($884fc36dcfc434f7$exports, "Pagination", {
    enumerable: true,
    get: function get() {
        return $77efcb78f751805f$exports.Pagination;
    }
});
Object.defineProperty($884fc36dcfc434f7$exports, "PaginationWrapper", {
    enumerable: true,
    get: function get() {
        return $be8118529078a72d$exports.PaginationWrapper;
    }
});
var $77efcb78f751805f$exports = {};
"use strict";
function $77efcb78f751805f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $77efcb78f751805f$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $77efcb78f751805f$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $77efcb78f751805f$var$_typeof(obj);
}
Object.defineProperty($77efcb78f751805f$exports, "__esModule", {
    value: true
});
$77efcb78f751805f$exports.Pagination = void 0;

var $77efcb78f751805f$var$_react = $77efcb78f751805f$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $77efcb78f751805f$var$_propTypes = $77efcb78f751805f$var$_interopRequireDefault((parcelRequire("d2bgE")));


var $77efcb78f751805f$var$_Pagination = $77efcb78f751805f$var$_interopRequireDefault((parcelRequire("4M8Iw")));

var $77efcb78f751805f$var$_PageItem = $77efcb78f751805f$var$_interopRequireWildcard((parcelRequire("6j1mt")));
function $77efcb78f751805f$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $77efcb78f751805f$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $77efcb78f751805f$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $77efcb78f751805f$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $77efcb78f751805f$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $77efcb78f751805f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $77efcb78f751805f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $77efcb78f751805f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $77efcb78f751805f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $77efcb78f751805f$var$Pagination = function Pagination(_ref) {
    var children = _ref.children, className = _ref.className, size = _ref.size, props = $77efcb78f751805f$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "size"
    ]);
    return /*#__PURE__*/ $77efcb78f751805f$var$_react["default"].createElement($884fc36dcfc434f7$exports.PaginationWrapper, props, /*#__PURE__*/ $77efcb78f751805f$var$_react["default"].createElement($77efcb78f751805f$var$_Pagination["default"], {
        className: className,
        size: size
    }, children));
};
$77efcb78f751805f$exports.Pagination = $77efcb78f751805f$var$Pagination;
$77efcb78f751805f$var$Pagination.propTypes = {
    /**
   * @default 'pagination'
   * */ bsPrefix: $77efcb78f751805f$var$_propTypes["default"].string,
    /**
   * Set's the size of all PageItems.
   *
   * `"sm"` `"lg"`
   */ size: $77efcb78f751805f$var$_propTypes["default"].string
};
$77efcb78f751805f$var$Pagination.First = $77efcb78f751805f$var$_PageItem.First;
$77efcb78f751805f$var$Pagination.Prev = $77efcb78f751805f$var$_PageItem.Prev;
$77efcb78f751805f$var$Pagination.Ellipsis = $77efcb78f751805f$var$_PageItem.Ellipsis;
$77efcb78f751805f$var$Pagination.Item = $77efcb78f751805f$var$_PageItem["default"];
$77efcb78f751805f$var$Pagination.Next = $77efcb78f751805f$var$_PageItem.Next;
$77efcb78f751805f$var$Pagination.Last = $77efcb78f751805f$var$_PageItem.Last;


var $be8118529078a72d$exports = {};
"use strict";
Object.defineProperty($be8118529078a72d$exports, "__esModule", {
    value: true
});
$be8118529078a72d$exports.PaginationWrapper = void 0;

var $be8118529078a72d$var$_classnames = $be8118529078a72d$var$_interopRequireDefault((parcelRequire("fVt0T")));

var $be8118529078a72d$var$_propTypes = $be8118529078a72d$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $be8118529078a72d$var$_react = $be8118529078a72d$var$_interopRequireDefault((parcelRequire("Fo7oF")));

function $be8118529078a72d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $be8118529078a72d$var$PaginationWrapper = function PaginationWrapper(_ref) {
    var className = _ref.className, children = _ref.children, pageResults = _ref.pageResults, text = _ref.text, ariaLabel = _ref.ariaLabel;
    return pageResults ? /*#__PURE__*/ $be8118529078a72d$var$_react["default"].createElement("div", {
        className: (0, $be8118529078a72d$var$_classnames["default"])(className, "uxf-pagination")
    }, /*#__PURE__*/ $be8118529078a72d$var$_react["default"].createElement("p", null, text), /*#__PURE__*/ $be8118529078a72d$var$_react["default"].createElement($bcd440a0b285e0c3$exports.Nav, {
        ariaLabel: ariaLabel
    }, children)) : /*#__PURE__*/ $be8118529078a72d$var$_react["default"].createElement($bcd440a0b285e0c3$exports.Nav, {
        ariaLabel: ariaLabel
    }, children);
};
$be8118529078a72d$exports.PaginationWrapper = $be8118529078a72d$var$PaginationWrapper;
$be8118529078a72d$var$PaginationWrapper.propTypes = {
    /**
   * Conditional display of page results
   */ pageResults: $be8118529078a72d$var$_propTypes["default"].bool,
    /**
   * Text displayed before pagination. Usually indicates place in search results.
   */ text: $be8118529078a72d$var$_propTypes["default"].string,
    /**
   * Aria-label of pagination navigation (Nav). This notifies individuals using
   * assistive technologies that they are on a pagination component.
   */ ariaLabel: $be8118529078a72d$var$_propTypes["default"].string.isRequired
};




var $b6ea26e70b7c7b4b$exports = {};
"use strict";
Object.defineProperty($b6ea26e70b7c7b4b$exports, "__esModule", {
    value: true
});
Object.defineProperty($b6ea26e70b7c7b4b$exports, "Popover", {
    enumerable: true,
    get: function get() {
        return $2a4de985f361457b$exports.Popover;
    }
});
var $2a4de985f361457b$exports = {};
"use strict";
function $2a4de985f361457b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2a4de985f361457b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2a4de985f361457b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2a4de985f361457b$var$_typeof(obj);
}
Object.defineProperty($2a4de985f361457b$exports, "__esModule", {
    value: true
});
$2a4de985f361457b$exports.Popover = void 0;

var $2a4de985f361457b$var$_react = $2a4de985f361457b$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $2a4de985f361457b$var$_propTypes = $2a4de985f361457b$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $2a4de985f361457b$var$_isRequiredForA11y = $2a4de985f361457b$var$_interopRequireDefault((parcelRequire("gJ3n2")));

var $2a4de985f361457b$var$_Popover = $2a4de985f361457b$var$_interopRequireDefault((parcelRequire("bFq9j")));

var $2a4de985f361457b$var$_PopoverTitle = $2a4de985f361457b$var$_interopRequireDefault((parcelRequire("kXvFd")));

var $2a4de985f361457b$var$_PopoverContent = $2a4de985f361457b$var$_interopRequireDefault((parcelRequire("9rTga")));
function $2a4de985f361457b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $2a4de985f361457b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2a4de985f361457b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2a4de985f361457b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2a4de985f361457b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2a4de985f361457b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $2a4de985f361457b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2a4de985f361457b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2a4de985f361457b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $2a4de985f361457b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $2a4de985f361457b$var$_setPrototypeOf(subClass, superClass);
}
function $2a4de985f361457b$var$_setPrototypeOf(o, p) {
    $2a4de985f361457b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2a4de985f361457b$var$_setPrototypeOf(o, p);
}
function $2a4de985f361457b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2a4de985f361457b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $2a4de985f361457b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $2a4de985f361457b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $2a4de985f361457b$var$_possibleConstructorReturn(this, result);
    };
}
function $2a4de985f361457b$var$_possibleConstructorReturn(self, call) {
    if (call && ($2a4de985f361457b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $2a4de985f361457b$var$_assertThisInitialized(self);
}
function $2a4de985f361457b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2a4de985f361457b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $2a4de985f361457b$var$_getPrototypeOf(o) {
    $2a4de985f361457b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2a4de985f361457b$var$_getPrototypeOf(o);
}
var $2a4de985f361457b$var$Popover = /*#__PURE__*/ function(_React$Component) {
    $2a4de985f361457b$var$_inherits(Popover, _React$Component);
    var _super = $2a4de985f361457b$var$_createSuper(Popover);
    function Popover() {
        $2a4de985f361457b$var$_classCallCheck(this, Popover);
        return _super.apply(this, arguments);
    }
    $2a4de985f361457b$var$_createClass(Popover, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, props = $2a4de985f361457b$var$_objectWithoutProperties(_this$props, [
                    "children"
                ]);
                return /*#__PURE__*/ $2a4de985f361457b$var$_react["default"].createElement($2a4de985f361457b$var$_Popover["default"], props, children);
            }
        }
    ]);
    return Popover;
}($2a4de985f361457b$var$_react["default"].Component);
$2a4de985f361457b$exports.Popover = $2a4de985f361457b$var$Popover;
$2a4de985f361457b$var$Popover.propTypes = {
    /**
   * @default 'popover'
   */ bsPrefix: $2a4de985f361457b$var$_propTypes["default"].string,
    /**
   * An html id attribute, necessary for accessibility
   * @type {string|number}
   * @required
   */ id: (0, $2a4de985f361457b$var$_isRequiredForA11y["default"])($2a4de985f361457b$var$_propTypes["default"].oneOfType([
        $2a4de985f361457b$var$_propTypes["default"].string,
        $2a4de985f361457b$var$_propTypes["default"].number
    ])),
    /**
   * Sets the direction the Popover is positioned towards.
   *
   * > This is generally provided by the `Overlay` component positioning the popover
   */ placement: $2a4de985f361457b$var$_propTypes["default"].oneOf([
        "auto",
        "top",
        "bottom",
        "left",
        "right"
    ]),
    /**
   * An Overlay injected set of props for positioning the popover arrow.
   *
   * > This is generally provided by the `Overlay` component positioning the popover
   */ arrowProps: $2a4de985f361457b$var$_propTypes["default"].shape({
        ref: $2a4de985f361457b$var$_propTypes["default"].any,
        style: $2a4de985f361457b$var$_propTypes["default"].object
    }),
    /**
   * When this prop is set, it creates a Popover with a Popover.Content inside
   * passing the children directly to it
   */ content: $2a4de985f361457b$var$_propTypes["default"].bool,
    /** @private */ popper: $2a4de985f361457b$var$_propTypes["default"].object,
    /** @private */ show: $2a4de985f361457b$var$_propTypes["default"].bool
};
$2a4de985f361457b$var$Popover.Title = $2a4de985f361457b$var$_PopoverTitle["default"];
$2a4de985f361457b$var$Popover.Content = $2a4de985f361457b$var$_PopoverContent["default"];




var $3193994ad931e0c3$exports = {};
"use strict";
Object.defineProperty($3193994ad931e0c3$exports, "__esModule", {
    value: true
});
Object.defineProperty($3193994ad931e0c3$exports, "ProgressBar", {
    enumerable: true,
    get: function get() {
        return $9701e9cbf32e2912$exports.ProgressBar;
    }
});
Object.defineProperty($3193994ad931e0c3$exports, "Spinner", {
    enumerable: true,
    get: function get() {
        return $78a93462a1d0088d$exports.Spinner;
    }
});
var $9701e9cbf32e2912$exports = {};
"use strict";
Object.defineProperty($9701e9cbf32e2912$exports, "__esModule", {
    value: true
});
$9701e9cbf32e2912$exports.ProgressBar = void 0;

var $9701e9cbf32e2912$var$_react = $9701e9cbf32e2912$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $9701e9cbf32e2912$var$_propTypes = $9701e9cbf32e2912$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $9701e9cbf32e2912$var$_ProgressBar = $9701e9cbf32e2912$var$_interopRequireDefault((parcelRequire("jmNSR")));
function $9701e9cbf32e2912$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $9701e9cbf32e2912$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9701e9cbf32e2912$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9701e9cbf32e2912$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $9701e9cbf32e2912$var$ProgressBar = function ProgressBar(_ref) {
    var children = _ref.children, props = $9701e9cbf32e2912$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $9701e9cbf32e2912$var$_react["default"].createElement($9701e9cbf32e2912$var$_ProgressBar["default"], props, children);
};
$9701e9cbf32e2912$exports.ProgressBar = $9701e9cbf32e2912$var$ProgressBar;
$9701e9cbf32e2912$var$ProgressBar.propTypes = {
    /**
   * Minimum value progress can begin from
   */ min: $9701e9cbf32e2912$var$_propTypes["default"].number,
    /**
   * Current value of progress
   */ now: $9701e9cbf32e2912$var$_propTypes["default"].number,
    /**
   * Maximum value progress can reach
   */ max: $9701e9cbf32e2912$var$_propTypes["default"].number,
    /**
   * Show label that represents visual percentage.
   * e.g. 60%
   */ label: $9701e9cbf32e2912$var$_propTypes["default"].node,
    /**
   * "Screen Reader Only"
   * Hides the label visually.
   */ srOnly: $9701e9cbf32e2912$var$_propTypes["default"].bool,
    /**
   * Uses a gradient to create a striped effect.
   */ striped: $9701e9cbf32e2912$var$_propTypes["default"].bool,
    /**
   * Animate's the stripes from right to left
   */ animated: $9701e9cbf32e2912$var$_propTypes["default"].bool,
    /**
   * @private
   * @default 'progress-bar'
   */ bsPrefix: $9701e9cbf32e2912$var$_propTypes["default"].string,
    /**
   * Sets the background class of the progress bar.
   *
   * `"success"` `"danger"` `"warning"` `"info"`
   */ variant: $9701e9cbf32e2912$var$_propTypes["default"].string,
    /**
   * @private
   */ isChild: $9701e9cbf32e2912$var$_propTypes["default"].bool
};


var $78a93462a1d0088d$exports = {};
"use strict";
Object.defineProperty($78a93462a1d0088d$exports, "__esModule", {
    value: true
});
$78a93462a1d0088d$exports.Spinner = void 0;

var $78a93462a1d0088d$var$_react = $78a93462a1d0088d$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $78a93462a1d0088d$var$_propTypes = $78a93462a1d0088d$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $78a93462a1d0088d$var$_Spinner = $78a93462a1d0088d$var$_interopRequireDefault((parcelRequire("8Ljes")));
function $78a93462a1d0088d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $78a93462a1d0088d$var$_extends() {
    $78a93462a1d0088d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $78a93462a1d0088d$var$_extends.apply(this, arguments);
}
function $78a93462a1d0088d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $78a93462a1d0088d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $78a93462a1d0088d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $78a93462a1d0088d$var$Spinner = function Spinner(_ref) {
    var accessibilityLabel = _ref.accessibilityLabel, children = _ref.children, props = $78a93462a1d0088d$var$_objectWithoutProperties(_ref, [
        "accessibilityLabel",
        "children"
    ]);
    return /*#__PURE__*/ $78a93462a1d0088d$var$_react["default"].createElement($78a93462a1d0088d$var$_Spinner["default"], $78a93462a1d0088d$var$_extends({}, props, {
        role: "status"
    }), accessibilityLabel && /*#__PURE__*/ $78a93462a1d0088d$var$_react["default"].createElement("span", {
        className: "sr-only"
    }, accessibilityLabel), children);
};
$78a93462a1d0088d$exports.Spinner = $78a93462a1d0088d$var$Spinner;
$78a93462a1d0088d$var$Spinner.propTypes = {
    /**
   * Change the underlying component CSS base class name and modifier class names prefix
   * @default 'spinner'
   */ bsPrefix: $78a93462a1d0088d$var$_propTypes["default"].string,
    /**
   * Changes the animation style of the spinner.
   */ animation: $78a93462a1d0088d$var$_propTypes["default"].string,
    /**
   * This component may be used to wrap child elements or components.
   */ children: $78a93462a1d0088d$var$_propTypes["default"].element,
    /**
   * @default div
   */ as: $78a93462a1d0088d$var$_propTypes["default"].elementType,
    /**
   * Label for assistive technology users
   * to know what kind of status change is occurring.
   */ accessibilityLabel: $78a93462a1d0088d$var$_propTypes["default"].string
};




var $02cb4431385bd849$exports = {};
"use strict";
Object.defineProperty($02cb4431385bd849$exports, "__esModule", {
    value: true
});
Object.defineProperty($02cb4431385bd849$exports, "RadioButton", {
    enumerable: true,
    get: function get() {
        return $e24a54bbad1986c1$exports.RadioButton;
    }
});
var $e24a54bbad1986c1$exports = {};
"use strict";
Object.defineProperty($e24a54bbad1986c1$exports, "__esModule", {
    value: true
});
$e24a54bbad1986c1$exports.RadioButton = void 0;

var $e24a54bbad1986c1$var$_react = $e24a54bbad1986c1$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $e24a54bbad1986c1$var$_propTypes = $e24a54bbad1986c1$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $e24a54bbad1986c1$var$_Form = $e24a54bbad1986c1$var$_interopRequireDefault((parcelRequire("9EiVH")));
function $e24a54bbad1986c1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e24a54bbad1986c1$var$_extends() {
    $e24a54bbad1986c1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e24a54bbad1986c1$var$_extends.apply(this, arguments);
}
function $e24a54bbad1986c1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e24a54bbad1986c1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e24a54bbad1986c1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e24a54bbad1986c1$var$RadioButton = function RadioButton(_ref) {
    var children = _ref.children, props = $e24a54bbad1986c1$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $e24a54bbad1986c1$var$_react["default"].createElement($e24a54bbad1986c1$var$_Form["default"].Check, $e24a54bbad1986c1$var$_extends({
        type: "radio",
        custom: true
    }, props));
};
$e24a54bbad1986c1$exports.RadioButton = $e24a54bbad1986c1$var$RadioButton;
$e24a54bbad1986c1$var$RadioButton.propTypes = {
    /**
   * The underlying HTML element to use when rendering the RadioButton.
   *
   * @type {('input'|elementType)}
   */ as: $e24a54bbad1986c1$var$_propTypes["default"].elementType,
    /** A HTML id attribute, necessary for proper form accessibility. */ id: $e24a54bbad1986c1$var$_propTypes["default"].string,
    inline: $e24a54bbad1986c1$var$_propTypes["default"].bool,
    disabled: $e24a54bbad1986c1$var$_propTypes["default"].bool,
    title: $e24a54bbad1986c1$var$_propTypes["default"].string,
    /** A label, necessary for proper form accessibility. */ label: $e24a54bbad1986c1$var$_propTypes["default"].node,
    /** Manually style the input as valid */ isValid: $e24a54bbad1986c1$var$_propTypes["default"].bool,
    /** Manually style the input as invalid */ isInvalid: $e24a54bbad1986c1$var$_propTypes["default"].bool,
    /** Display feedback as a tooltip. */ feedbackTooltip: $e24a54bbad1986c1$var$_propTypes["default"].bool,
    /** A message to display when the input is in a validation state */ feedback: $e24a54bbad1986c1$var$_propTypes["default"].node
};




var $75338f2eae319813$exports = {};
"use strict";
Object.defineProperty($75338f2eae319813$exports, "__esModule", {
    value: true
});
Object.defineProperty($75338f2eae319813$exports, "Row", {
    enumerable: true,
    get: function get() {
        return $9b4ffdbf2a851e7a$exports.Row;
    }
});
var $9b4ffdbf2a851e7a$exports = {};
"use strict";
Object.defineProperty($9b4ffdbf2a851e7a$exports, "__esModule", {
    value: true
});
$9b4ffdbf2a851e7a$exports.Row = void 0;

var $9b4ffdbf2a851e7a$var$_react = $9b4ffdbf2a851e7a$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $9b4ffdbf2a851e7a$var$_propTypes = $9b4ffdbf2a851e7a$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $9b4ffdbf2a851e7a$var$_Row = $9b4ffdbf2a851e7a$var$_interopRequireDefault((parcelRequire("hwLD9")));
function $9b4ffdbf2a851e7a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $9b4ffdbf2a851e7a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9b4ffdbf2a851e7a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9b4ffdbf2a851e7a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $9b4ffdbf2a851e7a$var$Row = function Row(_ref) {
    var children = _ref.children, props = $9b4ffdbf2a851e7a$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $9b4ffdbf2a851e7a$var$_react["default"].createElement($9b4ffdbf2a851e7a$var$_Row["default"], props, children);
};
$9b4ffdbf2a851e7a$exports.Row = $9b4ffdbf2a851e7a$var$Row;
$9b4ffdbf2a851e7a$var$Row.propTypes = {
    /**
   * Change the underlying component CSS base class name and modifier class names prefix
   * @default 'row'
   */ bsPrefix: $9b4ffdbf2a851e7a$var$_propTypes["default"].string,
    /**
   * Removes the gutter spacing between `Col`s as well as any added negative margins.
   */ noGutters: $9b4ffdbf2a851e7a$var$_propTypes["default"].bool,
    /** Set a custom element for this component */ as: $9b4ffdbf2a851e7a$var$_propTypes["default"].elementType
};





var $ca1ee2f974bdec31$exports = {};
"use strict";
Object.defineProperty($ca1ee2f974bdec31$exports, "__esModule", {
    value: true
});
Object.defineProperty($ca1ee2f974bdec31$exports, "SideNav", {
    enumerable: true,
    get: function get() {
        return $299b8208c0b5e44d$exports.SideNav;
    }
});
var $299b8208c0b5e44d$exports = {};
"use strict";
Object.defineProperty($299b8208c0b5e44d$exports, "__esModule", {
    value: true
});
$299b8208c0b5e44d$exports.SideNav = void 0;

var $299b8208c0b5e44d$var$_react = $299b8208c0b5e44d$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $299b8208c0b5e44d$var$_propTypes = $299b8208c0b5e44d$var$_interopRequireDefault((parcelRequire("d2bgE")));



var $299b8208c0b5e44d$var$_classnames = $299b8208c0b5e44d$var$_interopRequireDefault((parcelRequire("fVt0T")));
function $299b8208c0b5e44d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $299b8208c0b5e44d$var$_extends() {
    $299b8208c0b5e44d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $299b8208c0b5e44d$var$_extends.apply(this, arguments);
}
function $299b8208c0b5e44d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $299b8208c0b5e44d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $299b8208c0b5e44d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $299b8208c0b5e44d$var$SideNav = function SideNav(_ref) {
    var className = _ref.className, children = _ref.children, listClassName = _ref.listClassName, whiteBackground = _ref.whiteBackground, ariaLabel = _ref.ariaLabel, props = $299b8208c0b5e44d$var$_objectWithoutProperties(_ref, [
        "className",
        "children",
        "listClassName",
        "whiteBackground",
        "ariaLabel"
    ]);
    var classes = (0, $299b8208c0b5e44d$var$_classnames["default"])(className, "uxf-side-nav");
    var listClasses = (0, $299b8208c0b5e44d$var$_classnames["default"])(listClassName, !whiteBackground && "card", "nav flex-column");
    return /*#__PURE__*/ $299b8208c0b5e44d$var$_react["default"].createElement($bcd440a0b285e0c3$exports.Nav, $299b8208c0b5e44d$var$_extends({
        className: classes,
        ariaLabel: ariaLabel
    }, props), /*#__PURE__*/ $299b8208c0b5e44d$var$_react["default"].createElement($9c142335d2b8ec6f$exports.List, {
        className: listClasses
    }, children));
};
$299b8208c0b5e44d$exports.SideNav = $299b8208c0b5e44d$var$SideNav;
$299b8208c0b5e44d$var$SideNav.propTypes = {
    /**
   * Applies white background to side navigation
   */ whiteBackground: $299b8208c0b5e44d$var$_propTypes["default"].bool,
    /**
   * Aria-label for navigation element.
   */ ariaLabel: $299b8208c0b5e44d$var$_propTypes["default"].string.isRequired,
    /**
   * Class name added to inner List component
   */ listClassName: $299b8208c0b5e44d$var$_propTypes["default"].string
};
$299b8208c0b5e44d$var$SideNav.defaultProps = {
    whiteBackground: false
};




var $7911e4a90168a382$exports = {};
"use strict";
Object.defineProperty($7911e4a90168a382$exports, "__esModule", {
    value: true
});
Object.defineProperty($7911e4a90168a382$exports, "StatusIndicator", {
    enumerable: true,
    get: function get() {
        return $9cb543cac040056a$exports.StatusIndicator;
    }
});
var $9cb543cac040056a$exports = {};
"use strict";
Object.defineProperty($9cb543cac040056a$exports, "__esModule", {
    value: true
});
$9cb543cac040056a$exports.StatusIndicator = void 0;

var $9cb543cac040056a$var$_propTypes = $9cb543cac040056a$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $9cb543cac040056a$var$_classnames = $9cb543cac040056a$var$_interopRequireDefault((parcelRequire("fVt0T")));

var $9cb543cac040056a$var$_react = $9cb543cac040056a$var$_interopRequireDefault((parcelRequire("Fo7oF")));
function $9cb543cac040056a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $9cb543cac040056a$var$_extends() {
    $9cb543cac040056a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9cb543cac040056a$var$_extends.apply(this, arguments);
}
function $9cb543cac040056a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9cb543cac040056a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9cb543cac040056a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $9cb543cac040056a$var$StatusIndicator = function StatusIndicator(_ref) {
    var accessibilityLabel = _ref.accessibilityLabel, className = _ref.className, variant = _ref.variant, prefix = _ref.prefix, props = $9cb543cac040056a$var$_objectWithoutProperties(_ref, [
        "accessibilityLabel",
        "className",
        "variant",
        "prefix"
    ]);
    var classes = (0, $9cb543cac040056a$var$_classnames["default"])("uxf-statusDot", "".concat(prefix, "-").concat(variant), className);
    return /*#__PURE__*/ $9cb543cac040056a$var$_react["default"].createElement($9cb543cac040056a$var$_react["default"].Fragment, null, /*#__PURE__*/ $9cb543cac040056a$var$_react["default"].createElement("span", $9cb543cac040056a$var$_extends({
        className: classes
    }, props)), accessibilityLabel && /*#__PURE__*/ $9cb543cac040056a$var$_react["default"].createElement("span", {
        className: "sr-only"
    }, accessibilityLabel));
};
$9cb543cac040056a$exports.StatusIndicator = $9cb543cac040056a$var$StatusIndicator;
$9cb543cac040056a$var$StatusIndicator.propTypes = {
    /**
   * Prefix for status indicator variant
   */ prefix: $9cb543cac040056a$var$_propTypes["default"].string,
    /**
   * Status indicator variants
   *
   * `"success"` `"warning"` `"danger"` `"info"`
   */ variant: $9cb543cac040056a$var$_propTypes["default"].string,
    /**
   * Used to provide additional context to assistive technologies
   */ accessibilityLabel: $9cb543cac040056a$var$_propTypes["default"].string
};
$9cb543cac040056a$var$StatusIndicator.defaultProps = {
    prefix: "uxf-statusDot",
    variant: "success"
};




var $a64da7150ce0918e$exports = {};
"use strict";
Object.defineProperty($a64da7150ce0918e$exports, "__esModule", {
    value: true
});
Object.defineProperty($a64da7150ce0918e$exports, "Tab", {
    enumerable: true,
    get: function get() {
        return $e7f5cd9acf984eab$exports.Tab;
    }
});
var $e7f5cd9acf984eab$exports = {};
"use strict";
Object.defineProperty($e7f5cd9acf984eab$exports, "__esModule", {
    value: true
});
$e7f5cd9acf984eab$exports.Tab = void 0;

var $e7f5cd9acf984eab$var$_react = $e7f5cd9acf984eab$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $e7f5cd9acf984eab$var$_Tab = $e7f5cd9acf984eab$var$_interopRequireDefault((parcelRequire("27X8z")));

var $e7f5cd9acf984eab$var$_TabContainer = $e7f5cd9acf984eab$var$_interopRequireDefault((parcelRequire("g3fZa")));

var $e7f5cd9acf984eab$var$_TabContent = $e7f5cd9acf984eab$var$_interopRequireDefault((parcelRequire("ai3sv")));

var $e7f5cd9acf984eab$var$_TabPane = $e7f5cd9acf984eab$var$_interopRequireDefault((parcelRequire("gyJvA")));
function $e7f5cd9acf984eab$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e7f5cd9acf984eab$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e7f5cd9acf984eab$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e7f5cd9acf984eab$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e7f5cd9acf984eab$var$Tab = function Tab(_ref) {
    var children = _ref.children, props = $e7f5cd9acf984eab$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $e7f5cd9acf984eab$var$_react["default"].createElement($e7f5cd9acf984eab$var$_Tab["default"], props, children);
};
$e7f5cd9acf984eab$exports.Tab = $e7f5cd9acf984eab$var$Tab;
$e7f5cd9acf984eab$var$Tab.Container = $e7f5cd9acf984eab$var$_TabContainer["default"];
$e7f5cd9acf984eab$var$Tab.Content = $e7f5cd9acf984eab$var$_TabContent["default"];
$e7f5cd9acf984eab$var$Tab.Pane = $e7f5cd9acf984eab$var$_TabPane["default"];




var $421209a146ee874c$exports = {};
"use strict";
Object.defineProperty($421209a146ee874c$exports, "__esModule", {
    value: true
});
Object.defineProperty($421209a146ee874c$exports, "Table", {
    enumerable: true,
    get: function get() {
        return $e17e6d42b0ccd76c$exports.Table;
    }
});
var $e17e6d42b0ccd76c$exports = {};
"use strict";
Object.defineProperty($e17e6d42b0ccd76c$exports, "__esModule", {
    value: true
});
$e17e6d42b0ccd76c$exports.Table = void 0;

var $e17e6d42b0ccd76c$var$_react = $e17e6d42b0ccd76c$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $e17e6d42b0ccd76c$var$_propTypes = $e17e6d42b0ccd76c$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $e17e6d42b0ccd76c$var$_Table = $e17e6d42b0ccd76c$var$_interopRequireDefault((parcelRequire("a6Ywc")));
function $e17e6d42b0ccd76c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e17e6d42b0ccd76c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e17e6d42b0ccd76c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e17e6d42b0ccd76c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e17e6d42b0ccd76c$var$Table = function Table(_ref) {
    var children = _ref.children, props = $e17e6d42b0ccd76c$var$_objectWithoutProperties(_ref, [
        "children"
    ]);
    return /*#__PURE__*/ $e17e6d42b0ccd76c$var$_react["default"].createElement($e17e6d42b0ccd76c$var$_Table["default"], props, children);
};
$e17e6d42b0ccd76c$exports.Table = $e17e6d42b0ccd76c$var$Table;
$e17e6d42b0ccd76c$var$Table.propTypes = {
    /**
   * @default 'table'
   */ bsPrefix: $e17e6d42b0ccd76c$var$_propTypes["default"].string,
    /**
   * Adds zebra-striping to any table row within the `<tbody>`.
   */ striped: $e17e6d42b0ccd76c$var$_propTypes["default"].bool,
    /**
   * Adds borders on all sides of the table and cells.
   */ bordered: $e17e6d42b0ccd76c$var$_propTypes["default"].bool,
    /**
   * Removes all borders on the table and cells, including table header.
   */ borderless: $e17e6d42b0ccd76c$var$_propTypes["default"].bool,
    /**
   * Enable a hover state on table rows within a `<tbody>`.
   */ hover: $e17e6d42b0ccd76c$var$_propTypes["default"].bool,
    /**
   * Make tables more compact by cutting cell padding in half by setting
   * size as `sm`.
   */ size: $e17e6d42b0ccd76c$var$_propTypes["default"].string,
    /**
   * Responsive tables allow tables to be scrolled horizontally with ease.
   * Across every breakpoint, use `responsive` for horizontally
   * scrolling tables. Responsive tables are wrapped automatically in a `div`.
   * Use `responsive="sm"`, `responsive="md"`, `responsive="lg"`, or
   * `responsive="xl"` as needed to create responsive tables up to
   * a particular breakpoint. From that breakpoint and up, the table will
   * behave normally and not scroll horizontally.
   */ responsive: $e17e6d42b0ccd76c$var$_propTypes["default"].oneOfType([
        $e17e6d42b0ccd76c$var$_propTypes["default"].bool,
        $e17e6d42b0ccd76c$var$_propTypes["default"].string
    ])
};




var $50ca62b9df3a8f84$exports = {};
"use strict";
Object.defineProperty($50ca62b9df3a8f84$exports, "__esModule", {
    value: true
});
Object.defineProperty($50ca62b9df3a8f84$exports, "Tooltip", {
    enumerable: true,
    get: function get() {
        return $3ea946a2cdd92861$exports.Tooltip;
    }
});
var $3ea946a2cdd92861$exports = {};
"use strict";
function $3ea946a2cdd92861$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3ea946a2cdd92861$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $3ea946a2cdd92861$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3ea946a2cdd92861$var$_typeof(obj);
}
Object.defineProperty($3ea946a2cdd92861$exports, "__esModule", {
    value: true
});
$3ea946a2cdd92861$exports.Tooltip = void 0;

var $3ea946a2cdd92861$var$_react = $3ea946a2cdd92861$var$_interopRequireDefault((parcelRequire("Fo7oF")));

var $3ea946a2cdd92861$var$_propTypes = $3ea946a2cdd92861$var$_interopRequireDefault((parcelRequire("d2bgE")));

var $3ea946a2cdd92861$var$_isRequiredForA11y = $3ea946a2cdd92861$var$_interopRequireDefault((parcelRequire("gJ3n2")));

var $3ea946a2cdd92861$var$_Tooltip = $3ea946a2cdd92861$var$_interopRequireDefault((parcelRequire("ep4SW")));
function $3ea946a2cdd92861$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $3ea946a2cdd92861$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3ea946a2cdd92861$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3ea946a2cdd92861$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3ea946a2cdd92861$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3ea946a2cdd92861$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3ea946a2cdd92861$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3ea946a2cdd92861$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3ea946a2cdd92861$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $3ea946a2cdd92861$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $3ea946a2cdd92861$var$_setPrototypeOf(subClass, superClass);
}
function $3ea946a2cdd92861$var$_setPrototypeOf(o, p) {
    $3ea946a2cdd92861$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3ea946a2cdd92861$var$_setPrototypeOf(o, p);
}
function $3ea946a2cdd92861$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3ea946a2cdd92861$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3ea946a2cdd92861$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3ea946a2cdd92861$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3ea946a2cdd92861$var$_possibleConstructorReturn(this, result);
    };
}
function $3ea946a2cdd92861$var$_possibleConstructorReturn(self, call) {
    if (call && ($3ea946a2cdd92861$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $3ea946a2cdd92861$var$_assertThisInitialized(self);
}
function $3ea946a2cdd92861$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3ea946a2cdd92861$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3ea946a2cdd92861$var$_getPrototypeOf(o) {
    $3ea946a2cdd92861$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3ea946a2cdd92861$var$_getPrototypeOf(o);
}
var $3ea946a2cdd92861$var$Tooltip = /*#__PURE__*/ function(_React$Component) {
    $3ea946a2cdd92861$var$_inherits(Tooltip, _React$Component);
    var _super = $3ea946a2cdd92861$var$_createSuper(Tooltip);
    function Tooltip() {
        $3ea946a2cdd92861$var$_classCallCheck(this, Tooltip);
        return _super.apply(this, arguments);
    }
    $3ea946a2cdd92861$var$_createClass(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, props = $3ea946a2cdd92861$var$_objectWithoutProperties(_this$props, [
                    "children"
                ]);
                return /*#__PURE__*/ $3ea946a2cdd92861$var$_react["default"].createElement($3ea946a2cdd92861$var$_Tooltip["default"], props, children);
            }
        }
    ]);
    return Tooltip;
}($3ea946a2cdd92861$var$_react["default"].Component);
$3ea946a2cdd92861$exports.Tooltip = $3ea946a2cdd92861$var$Tooltip;
$3ea946a2cdd92861$var$Tooltip.propTypes = {
    /**
   * @default 'tooltip'
   */ bsPrefix: $3ea946a2cdd92861$var$_propTypes["default"].string,
    /**
   * An html id attribute, necessary for accessibility
   * @type {string|number}
   * @required
   */ id: (0, $3ea946a2cdd92861$var$_isRequiredForA11y["default"])($3ea946a2cdd92861$var$_propTypes["default"].oneOfType([
        $3ea946a2cdd92861$var$_propTypes["default"].string,
        $3ea946a2cdd92861$var$_propTypes["default"].number
    ])),
    /**
   * Sets the direction the Tooltip is positioned towards.
   *
   * > This is generally provided by the `Overlay` component positioning the tooltip
   */ placement: $3ea946a2cdd92861$var$_propTypes["default"].oneOf([
        "auto-start",
        "auto",
        "auto-end",
        "top-start",
        "top",
        "top-end",
        "right-start",
        "right",
        "right-end",
        "bottom-end",
        "bottom",
        "bottom-start",
        "left-end",
        "left",
        "left-start"
    ]),
    /**
   * An Overlay injected set of props for positioning the tooltip arrow.
   *
   * > This is generally provided by the `Overlay` component positioning the tooltip
   *
   * @type {{ ref: ReactRef, style: Object }}
   */ arrowProps: $3ea946a2cdd92861$var$_propTypes["default"].shape({
        ref: $3ea946a2cdd92861$var$_propTypes["default"].any,
        style: $3ea946a2cdd92861$var$_propTypes["default"].object
    }),
    /** @private */ popper: $3ea946a2cdd92861$var$_propTypes["default"].object,
    /** @private */ show: $3ea946a2cdd92861$var$_propTypes["default"].any
};







var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $d2vKa = parcelRequire("d2vKa");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");

var $bT5dp = parcelRequire("bT5dp");
var $85f6784786c38cd6$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $d2vKa.default)({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            display: 'block'
        }, theme.breakpoints.up('sm'), {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }),
        /* Styles applied to the root element if `disableGutters={true}`. */ disableGutters: {
            paddingLeft: 0,
            paddingRight: 0
        },
        /* Styles applied to the root element if `fixed={true}`. */ fixed: Object.keys(theme.breakpoints.values).reduce(function(acc, breakpoint) {
            var value = theme.breakpoints.values[breakpoint];
            if (value !== 0) acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: value
            };
            return acc;
        }, {}),
        /* Styles applied to the root element if `maxWidth="xs"`. */ maxWidthXs: (0, $d2vKa.default)({}, theme.breakpoints.up('xs'), {
            maxWidth: Math.max(theme.breakpoints.values.xs, 444)
        }),
        /* Styles applied to the root element if `maxWidth="sm"`. */ maxWidthSm: (0, $d2vKa.default)({}, theme.breakpoints.up('sm'), {
            maxWidth: theme.breakpoints.values.sm
        }),
        /* Styles applied to the root element if `maxWidth="md"`. */ maxWidthMd: (0, $d2vKa.default)({}, theme.breakpoints.up('md'), {
            maxWidth: theme.breakpoints.values.md
        }),
        /* Styles applied to the root element if `maxWidth="lg"`. */ maxWidthLg: (0, $d2vKa.default)({}, theme.breakpoints.up('lg'), {
            maxWidth: theme.breakpoints.values.lg
        }),
        /* Styles applied to the root element if `maxWidth="xl"`. */ maxWidthXl: (0, $d2vKa.default)({}, theme.breakpoints.up('xl'), {
            maxWidth: theme.breakpoints.values.xl
        })
    };
};
var $85f6784786c38cd6$var$Container = /*#__PURE__*/ $Fo7oF.forwardRef(function Container(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$fixed = props.fixed, fixed = _props$fixed === void 0 ? false : _props$fixed, _props$maxWidth = props.maxWidth, maxWidth = _props$maxWidth === void 0 ? 'lg' : _props$maxWidth, other = (0, $67mp8.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "fixed",
        "maxWidth"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className, fixed && classes.fixed, disableGutters && classes.disableGutters, maxWidth !== false && classes["maxWidth".concat((0, $bT5dp.default)(String(maxWidth)))]),
        ref: ref
    }, other));
});
var $85f6784786c38cd6$export$2e2bcd8739ae039 = (0, $5rVgt.default)($85f6784786c38cd6$export$9dd6ff9ea0189349, {
    name: 'MuiContainer'
})($85f6784786c38cd6$var$Container);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");

var $bT5dp = parcelRequire("bT5dp");

var $cbe03892a40445d8$export$9dd6ff9ea0189349 = function styles(theme) {
    var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
    return {
        /* Styles applied to the root element. */ root: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            boxSizing: 'border-box',
            // Prevent padding issue with the Modal and fixed positioned AppBar.
            zIndex: theme.zIndex.appBar,
            flexShrink: 0
        },
        /* Styles applied to the root element if `position="fixed"`. */ positionFixed: {
            position: 'fixed',
            top: 0,
            left: 'auto',
            right: 0,
            '@media print': {
                // Prevent the app bar to be visible on each printed page.
                position: 'absolute'
            }
        },
        /* Styles applied to the root element if `position="absolute"`. */ positionAbsolute: {
            position: 'absolute',
            top: 0,
            left: 'auto',
            right: 0
        },
        /* Styles applied to the root element if `position="sticky"`. */ positionSticky: {
            // ⚠️ sticky is not supported by IE 11.
            position: 'sticky',
            top: 0,
            left: 'auto',
            right: 0
        },
        /* Styles applied to the root element if `position="static"`. */ positionStatic: {
            position: 'static'
        },
        /* Styles applied to the root element if `position="relative"`. */ positionRelative: {
            position: 'relative'
        },
        /* Styles applied to the root element if `color="default"`. */ colorDefault: {
            backgroundColor: backgroundColorDefault,
            color: theme.palette.getContrastText(backgroundColorDefault)
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit'
        },
        /* Styles applied to the root element if `color="transparent"`. */ colorTransparent: {
            backgroundColor: 'transparent',
            color: 'inherit'
        }
    };
};
var $cbe03892a40445d8$var$AppBar = /*#__PURE__*/ $Fo7oF.forwardRef(function AppBar(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, _props$position = props.position, position = _props$position === void 0 ? 'fixed' : _props$position, other = (0, $67mp8.default)(props, [
        "classes",
        "className",
        "color",
        "position"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement((0, $fe0aa9e32766c0f5$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        square: true,
        component: "header",
        elevation: 4,
        className: (0, $78z8j.default)(classes.root, classes["position".concat((0, $bT5dp.default)(position))], classes["color".concat((0, $bT5dp.default)(color))], className, position === 'fixed' && 'mui-fixed'),
        ref: ref
    }, other));
});
var $cbe03892a40445d8$export$2e2bcd8739ae039 = (0, $5rVgt.default)($cbe03892a40445d8$export$9dd6ff9ea0189349, {
    name: 'MuiAppBar'
})($cbe03892a40445d8$var$AppBar);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $d2vKa = parcelRequire("d2vKa");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");
var $04d9144fb2276d87$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center'
        },
        /* Styles applied to the root element if `disableGutters={false}`. */ gutters: (0, $d2vKa.default)({
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        }, theme.breakpoints.up('sm'), {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }),
        /* Styles applied to the root element if `variant="regular"`. */ regular: theme.mixins.toolbar,
        /* Styles applied to the root element if `variant="dense"`. */ dense: {
            minHeight: 48
        }
    };
};
var $04d9144fb2276d87$var$Toolbar = /*#__PURE__*/ $Fo7oF.forwardRef(function Toolbar(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$variant = props.variant, variant = _props$variant === void 0 ? 'regular' : _props$variant, other = (0, $67mp8.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "variant"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, classes[variant], className, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
var $04d9144fb2276d87$export$2e2bcd8739ae039 = (0, $5rVgt.default)($04d9144fb2276d87$export$9dd6ff9ea0189349, {
    name: 'MuiToolbar'
})($04d9144fb2276d87$var$Toolbar);


var $ae742c06fae423df$exports = {};
"use strict";
var $368639c97fe780bf$exports = {};
function $368639c97fe780bf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
$368639c97fe780bf$exports = $368639c97fe780bf$var$_interopRequireDefault, $368639c97fe780bf$exports.__esModule = true, $368639c97fe780bf$exports["default"] = $368639c97fe780bf$exports;


var $e542637ee86bba6a$exports = {};
var $2ee4deb55dba7e41$exports = {};
function $2ee4deb55dba7e41$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2ee4deb55dba7e41$exports = $2ee4deb55dba7e41$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2ee4deb55dba7e41$exports.__esModule = true, $2ee4deb55dba7e41$exports["default"] = $2ee4deb55dba7e41$exports, $2ee4deb55dba7e41$var$_typeof(o);
}
$2ee4deb55dba7e41$exports = $2ee4deb55dba7e41$var$_typeof, $2ee4deb55dba7e41$exports.__esModule = true, $2ee4deb55dba7e41$exports["default"] = $2ee4deb55dba7e41$exports;


var $e542637ee86bba6a$var$_typeof = $2ee4deb55dba7e41$exports.default;
function $e542637ee86bba6a$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($e542637ee86bba6a$exports = $e542637ee86bba6a$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != $e542637ee86bba6a$var$_typeof(e) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    }, $e542637ee86bba6a$exports.__esModule = true, $e542637ee86bba6a$exports["default"] = $e542637ee86bba6a$exports)(e, t);
}
$e542637ee86bba6a$exports = $e542637ee86bba6a$var$_interopRequireWildcard, $e542637ee86bba6a$exports.__esModule = true, $e542637ee86bba6a$exports["default"] = $e542637ee86bba6a$exports;


Object.defineProperty($ae742c06fae423df$exports, "__esModule", {
    value: true
});
$ae742c06fae423df$exports.default = void 0;

var $ae742c06fae423df$var$React = $e542637ee86bba6a$exports((parcelRequire("Fo7oF")));

var $ae742c06fae423df$var$_createSvgIcon = $368639c97fe780bf$exports((parcelRequire("bI8Gq")));
var $ae742c06fae423df$var$_default = (0, $ae742c06fae423df$var$_createSvgIcon.default)(/*#__PURE__*/ $ae742c06fae423df$var$React.createElement("path", {
    d: "M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z"
}), 'PowerSettingsNew');
$ae742c06fae423df$exports.default = $ae742c06fae423df$var$_default;



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");


var $Fo7oF = parcelRequire("Fo7oF");

var $Fo7oF = parcelRequire("Fo7oF");
/**
 * @ignore - internal component.
 */ var $8d9862aa244cad11$var$FormControlContext = $Fo7oF.createContext();
function $8d9862aa244cad11$export$62ecd8ad1bbe1a18() {
    return $Fo7oF.useContext($8d9862aa244cad11$var$FormControlContext);
}
var $8d9862aa244cad11$export$2e2bcd8739ae039 = $8d9862aa244cad11$var$FormControlContext;


function $da6b73123b6a85ad$export$2e2bcd8739ae039() {
    return $Fo7oF.useContext((0, $8d9862aa244cad11$export$2e2bcd8739ae039));
}



var $5rVgt = parcelRequire("5rVgt");


var $bT5dp = parcelRequire("bT5dp");
var $1d79a71788b0c844$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'inline-flex',
            alignItems: 'center',
            cursor: 'pointer',
            // For correct alignment with the text.
            verticalAlign: 'middle',
            WebkitTapHighlightColor: 'transparent',
            marginLeft: -11,
            marginRight: 16,
            // used for row presentation of radio/checkbox
            '&$disabled': {
                cursor: 'default'
            }
        },
        /* Styles applied to the root element if `labelPlacement="start"`. */ labelPlacementStart: {
            flexDirection: 'row-reverse',
            marginLeft: 16,
            // used for row presentation of radio/checkbox
            marginRight: -11
        },
        /* Styles applied to the root element if `labelPlacement="top"`. */ labelPlacementTop: {
            flexDirection: 'column-reverse',
            marginLeft: 16
        },
        /* Styles applied to the root element if `labelPlacement="bottom"`. */ labelPlacementBottom: {
            flexDirection: 'column',
            marginLeft: 16
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the label's Typography component. */ label: {
            '&$disabled': {
                color: theme.palette.text.disabled
            }
        }
    };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ var $1d79a71788b0c844$var$FormControlLabel = /*#__PURE__*/ $Fo7oF.forwardRef(function FormControlLabel(props, ref) {
    var checked = props.checked, classes = props.classes, className = props.className, control = props.control, disabledProp = props.disabled, inputRef = props.inputRef, label = props.label, _props$labelPlacement = props.labelPlacement, labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement, name = props.name, onChange = props.onChange, value = props.value, other = (0, $67mp8.default)(props, [
        "checked",
        "classes",
        "className",
        "control",
        "disabled",
        "inputRef",
        "label",
        "labelPlacement",
        "name",
        "onChange",
        "value"
    ]);
    var muiFormControl = (0, $da6b73123b6a85ad$export$2e2bcd8739ae039)();
    var disabled = disabledProp;
    if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') disabled = control.props.disabled;
    if (typeof disabled === 'undefined' && muiFormControl) disabled = muiFormControl.disabled;
    var controlProps = {
        disabled: disabled
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach(function(key) {
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    return /*#__PURE__*/ $Fo7oF.createElement("label", (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className, labelPlacement !== 'end' && classes["labelPlacement".concat((0, $bT5dp.default)(labelPlacement))], disabled && classes.disabled),
        ref: ref
    }, other), /*#__PURE__*/ $Fo7oF.cloneElement(control, controlProps), /*#__PURE__*/ $Fo7oF.createElement((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
        component: "span",
        className: (0, $78z8j.default)(classes.label, disabled && classes.disabled)
    }, label));
});
var $1d79a71788b0c844$export$2e2bcd8739ae039 = (0, $5rVgt.default)($1d79a71788b0c844$export$9dd6ff9ea0189349, {
    name: 'MuiFormControlLabel'
})($1d79a71788b0c844$var$FormControlLabel);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");


var $5rVgt = parcelRequire("5rVgt");

var $8Hh6N = parcelRequire("8Hh6N");

var $bT5dp = parcelRequire("bT5dp");

var $elnlQ = parcelRequire("elnlQ");

var $8YHhK = parcelRequire("8YHhK");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ 
var $Fo7oF = parcelRequire("Fo7oF");
function $c6d3b036d5d216ae$export$2e2bcd8739ae039(_ref) {
    var controlled = _ref.controlled, defaultProp = _ref.default, name = _ref.name, _ref$state = _ref.state, state = _ref$state === void 0 ? 'value' : _ref$state;
    var _React$useRef = $Fo7oF.useRef(controlled !== undefined), isControlled = _React$useRef.current;
    var _React$useState = $Fo7oF.useState(defaultProp), valueState = _React$useState[0], setValue = _React$useState[1];
    var value = isControlled ? controlled : valueState;
    var _React$useRef2, defaultValue;
    var setValueIfUncontrolled = $Fo7oF.useCallback(function(newValue) {
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}




var $5rVgt = parcelRequire("5rVgt");

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");


var $5rVgt = parcelRequire("5rVgt");

var $8Hh6N = parcelRequire("8Hh6N");


var $bT5dp = parcelRequire("bT5dp");
var $c6e28b9de0df1599$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            textAlign: 'center',
            flex: '0 0 auto',
            fontSize: theme.typography.pxToRem(24),
            padding: 12,
            borderRadius: '50%',
            overflow: 'visible',
            // Explicitly set the default value to solve a bug on IE 11.
            color: theme.palette.action.active,
            transition: theme.transitions.create('background-color', {
                duration: theme.transitions.duration.shortest
            }),
            '&:hover': {
                backgroundColor: (0, $8Hh6N.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&$disabled': {
                backgroundColor: 'transparent',
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `edge="start"`. */ edgeStart: {
            marginLeft: -12,
            '$sizeSmall&': {
                marginLeft: -3
            }
        },
        /* Styles applied to the root element if `edge="end"`. */ edgeEnd: {
            marginRight: -12,
            '$sizeSmall&': {
                marginRight: -3
            }
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit'
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: (0, $8Hh6N.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: (0, $8Hh6N.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: 3,
            fontSize: theme.typography.pxToRem(18)
        },
        /* Styles applied to the children container element. */ label: {
            width: '100%',
            display: 'flex',
            alignItems: 'inherit',
            justifyContent: 'inherit'
        }
    };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */ var $c6e28b9de0df1599$var$IconButton = /*#__PURE__*/ $Fo7oF.forwardRef(function IconButton(props, ref) {
    var _props$edge = props.edge, edge = _props$edge === void 0 ? false : _props$edge, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, other = (0, $67mp8.default)(props, [
        "edge",
        "children",
        "classes",
        "className",
        "color",
        "disabled",
        "disableFocusRipple",
        "size"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement((0, $67b46b5fd967aa2b$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className, color !== 'default' && classes["color".concat((0, $bT5dp.default)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, $bT5dp.default)(size))], {
            'start': classes.edgeStart,
            'end': classes.edgeEnd
        }[edge]),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other), /*#__PURE__*/ $Fo7oF.createElement("span", {
        className: classes.label
    }, children));
});
var $c6e28b9de0df1599$export$2e2bcd8739ae039 = (0, $5rVgt.default)($c6e28b9de0df1599$export$9dd6ff9ea0189349, {
    name: 'MuiIconButton'
})($c6e28b9de0df1599$var$IconButton);


var $b46bfdb01167da1e$export$9dd6ff9ea0189349 = {
    root: {
        padding: 9
    },
    checked: {},
    disabled: {},
    input: {
        cursor: 'inherit',
        position: 'absolute',
        opacity: 0,
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        margin: 0,
        padding: 0,
        zIndex: 1
    }
};
/**
 * @ignore - internal component.
 */ var $b46bfdb01167da1e$var$SwitchBase = /*#__PURE__*/ $Fo7oF.forwardRef(function SwitchBase(props, ref) {
    var autoFocus = props.autoFocus, checkedProp = props.checked, checkedIcon = props.checkedIcon, classes = props.classes, className = props.className, defaultChecked = props.defaultChecked, disabledProp = props.disabled, icon = props.icon, id = props.id, inputProps = props.inputProps, inputRef = props.inputRef, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, readOnly = props.readOnly, required = props.required, tabIndex = props.tabIndex, type = props.type, value = props.value, other = (0, $67mp8.default)(props, [
        "autoFocus",
        "checked",
        "checkedIcon",
        "classes",
        "className",
        "defaultChecked",
        "disabled",
        "icon",
        "id",
        "inputProps",
        "inputRef",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "readOnly",
        "required",
        "tabIndex",
        "type",
        "value"
    ]);
    var _useControlled = (0, $c6d3b036d5d216ae$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    }), _useControlled2 = (0, $8YHhK.default)(_useControlled, 2), checked = _useControlled2[0], setCheckedState = _useControlled2[1];
    var muiFormControl = (0, $da6b73123b6a85ad$export$2e2bcd8739ae039)();
    var handleFocus = function handleFocus(event) {
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    var handleBlur = function handleBlur(event) {
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    var handleInputChange = function handleInputChange(event) {
        var newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v5: remove the second argument.
        onChange(event, newChecked);
    };
    var disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    var hasLabelFor = type === 'checkbox' || type === 'radio';
    return /*#__PURE__*/ $Fo7oF.createElement((0, $c6e28b9de0df1599$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        component: "span",
        className: (0, $78z8j.default)(classes.root, className, checked && classes.checked, disabled && classes.disabled),
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ref: ref
    }, other), /*#__PURE__*/ $Fo7oF.createElement("input", (0, $elnlQ.default)({
        autoFocus: autoFocus,
        checked: checkedProp,
        defaultChecked: defaultChecked,
        className: classes.input,
        disabled: disabled,
        id: hasLabelFor && id,
        name: name,
        onChange: handleInputChange,
        readOnly: readOnly,
        ref: inputRef,
        required: required,
        tabIndex: tabIndex,
        type: type,
        value: value
    }, inputProps)), checked ? checkedIcon : icon);
}); // NB: If changed, please update Checkbox, Switch and Radio
var $b46bfdb01167da1e$export$2e2bcd8739ae039 = (0, $5rVgt.default)($b46bfdb01167da1e$export$9dd6ff9ea0189349, {
    name: 'PrivateSwitchBase'
})($b46bfdb01167da1e$var$SwitchBase);


var $e7fce3dd40da0110$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'inline-flex',
            width: 58,
            height: 38,
            overflow: 'hidden',
            padding: 12,
            boxSizing: 'border-box',
            position: 'relative',
            flexShrink: 0,
            zIndex: 0,
            // Reset the stacking context.
            verticalAlign: 'middle',
            // For correct alignment with the text.
            '@media print': {
                colorAdjust: 'exact'
            }
        },
        /* Styles applied to the root element if `edge="start"`. */ edgeStart: {
            marginLeft: -8
        },
        /* Styles applied to the root element if `edge="end"`. */ edgeEnd: {
            marginRight: -8
        },
        /* Styles applied to the internal `SwitchBase` component's `root` class. */ switchBase: {
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 1,
            // Render above the focus ripple.
            color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
            transition: theme.transitions.create([
                'left',
                'transform'
            ], {
                duration: theme.transitions.duration.shortest
            }),
            '&$checked': {
                transform: 'translateX(20px)'
            },
            '&$disabled': {
                color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
            },
            '&$checked + $track': {
                opacity: 0.5
            },
            '&$disabled + $track': {
                opacity: theme.palette.type === 'light' ? 0.12 : 0.1
            }
        },
        /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */ colorPrimary: {
            '&$checked': {
                color: theme.palette.primary.main,
                '&:hover': {
                    backgroundColor: (0, $8Hh6N.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                    '@media (hover: none)': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            '&$disabled': {
                color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
            },
            '&$checked + $track': {
                backgroundColor: theme.palette.primary.main
            },
            '&$disabled + $track': {
                backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
            }
        },
        /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */ colorSecondary: {
            '&$checked': {
                color: theme.palette.secondary.main,
                '&:hover': {
                    backgroundColor: (0, $8Hh6N.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                    '@media (hover: none)': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            '&$disabled': {
                color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
            },
            '&$checked + $track': {
                backgroundColor: theme.palette.secondary.main
            },
            '&$disabled + $track': {
                backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
            }
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            width: 40,
            height: 24,
            padding: 7,
            '& $thumb': {
                width: 16,
                height: 16
            },
            '& $switchBase': {
                padding: 4,
                '&$checked': {
                    transform: 'translateX(16px)'
                }
            }
        },
        /* Pseudo-class applied to the internal `SwitchBase` component's `checked` class. */ checked: {},
        /* Pseudo-class applied to the internal SwitchBase component's disabled class. */ disabled: {},
        /* Styles applied to the internal SwitchBase component's input element. */ input: {
            left: '-100%',
            width: '300%'
        },
        /* Styles used to create the thumb passed to the internal `SwitchBase` component `icon` prop. */ thumb: {
            boxShadow: theme.shadows[1],
            backgroundColor: 'currentColor',
            width: 20,
            height: 20,
            borderRadius: '50%'
        },
        /* Styles applied to the track element. */ track: {
            height: '100%',
            width: '100%',
            borderRadius: 7,
            zIndex: -1,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], {
                duration: theme.transitions.duration.shortest
            }),
            backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
            opacity: theme.palette.type === 'light' ? 0.38 : 0.3
        }
    };
};
var $e7fce3dd40da0110$var$Switch = /*#__PURE__*/ $Fo7oF.forwardRef(function Switch(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'secondary' : _props$color, _props$edge = props.edge, edge = _props$edge === void 0 ? false : _props$edge, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, other = (0, $67mp8.default)(props, [
        "classes",
        "className",
        "color",
        "edge",
        "size"
    ]);
    var icon = /*#__PURE__*/ $Fo7oF.createElement("span", {
        className: classes.thumb
    });
    return /*#__PURE__*/ $Fo7oF.createElement("span", {
        className: (0, $78z8j.default)(classes.root, className, {
            'start': classes.edgeStart,
            'end': classes.edgeEnd
        }[edge], size === "small" && classes["size".concat((0, $bT5dp.default)(size))])
    }, /*#__PURE__*/ $Fo7oF.createElement((0, $b46bfdb01167da1e$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        type: "checkbox",
        icon: icon,
        checkedIcon: icon,
        classes: {
            root: (0, $78z8j.default)(classes.switchBase, classes["color".concat((0, $bT5dp.default)(color))]),
            input: classes.input,
            checked: classes.checked,
            disabled: classes.disabled
        },
        ref: ref
    }, other)), /*#__PURE__*/ $Fo7oF.createElement("span", {
        className: classes.track
    }));
});
var $e7fce3dd40da0110$export$2e2bcd8739ae039 = (0, $5rVgt.default)($e7fce3dd40da0110$export$9dd6ff9ea0189349, {
    name: 'MuiSwitch'
})($e7fce3dd40da0110$var$Switch);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $7bfc6f913d3b5ac4$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
function $7bfc6f913d3b5ac4$export$d652b828d7fdeff8(obj) {
    var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return obj && ($7bfc6f913d3b5ac4$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $7bfc6f913d3b5ac4$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
function $7bfc6f913d3b5ac4$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $5rVgt = parcelRequire("5rVgt");

var $bT5dp = parcelRequire("bT5dp");

var $Fo7oF = parcelRequire("Fo7oF");
function $827a4e6aa58d6073$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $Fo7oF.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}



var $9b463858a269c96b$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top' // Fix alignment issue on Safari.
    },
    /* Styles applied to the root element if `margin="normal"`. */ marginNormal: {
        marginTop: 16,
        marginBottom: 8
    },
    /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
        marginTop: 8,
        marginBottom: 4
    },
    /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
        width: '100%'
    }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️Only one input can be used within a FormControl.
 */ var $9b463858a269c96b$var$FormControl = /*#__PURE__*/ $Fo7oF.forwardRef(function FormControl(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, visuallyFocused = props.focused, _props$hiddenLabel = props.hiddenLabel, hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel, _props$margin = props.margin, margin = _props$margin === void 0 ? 'none' : _props$margin, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, size = props.size, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $67mp8.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "fullWidth",
        "focused",
        "hiddenLabel",
        "margin",
        "required",
        "size",
        "variant"
    ]);
    var _React$useState = $Fo7oF.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialAdornedStart = false;
        if (children) $Fo7oF.Children.forEach(children, function(child) {
            if (!(0, $827a4e6aa58d6073$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            var input = (0, $827a4e6aa58d6073$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $7bfc6f913d3b5ac4$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    }), adornedStart = _React$useState[0], setAdornedStart = _React$useState[1];
    var _React$useState2 = $Fo7oF.useState(function() {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialFilled = false;
        if (children) $Fo7oF.Children.forEach(children, function(child) {
            if (!(0, $827a4e6aa58d6073$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $7bfc6f913d3b5ac4$export$d652b828d7fdeff8)(child.props, true)) initialFilled = true;
        });
        return initialFilled;
    }), filled = _React$useState2[0], setFilled = _React$useState2[1];
    var _React$useState3 = $Fo7oF.useState(false), _focused = _React$useState3[0], setFocused = _React$useState3[1];
    var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;
    if (disabled && focused) setFocused(false);
    var registerEffect;
    var registeredInput;
    var onFilled = $Fo7oF.useCallback(function() {
        setFilled(true);
    }, []);
    var onEmpty = $Fo7oF.useCallback(function() {
        setFilled(false);
    }, []);
    var childContext = {
        adornedStart: adornedStart,
        setAdornedStart: setAdornedStart,
        color: color,
        disabled: disabled,
        error: error,
        filled: filled,
        focused: focused,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: (size === 'small' ? 'dense' : undefined) || margin,
        onBlur: function onBlur() {
            setFocused(false);
        },
        onEmpty: onEmpty,
        onFilled: onFilled,
        onFocus: function onFocus() {
            setFocused(true);
        },
        registerEffect: registerEffect,
        required: required,
        variant: variant
    };
    return /*#__PURE__*/ $Fo7oF.createElement((0, $8d9862aa244cad11$export$2e2bcd8739ae039).Provider, {
        value: childContext
    }, /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className, margin !== 'none' && classes["margin".concat((0, $bT5dp.default)(margin))], fullWidth && classes.fullWidth),
        ref: ref
    }, other), children));
});
var $9b463858a269c96b$export$2e2bcd8739ae039 = (0, $5rVgt.default)($9b463858a269c96b$export$9dd6ff9ea0189349, {
    name: 'MuiFormControl'
})($9b463858a269c96b$var$FormControl);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");
function $13260d58a3dda9e0$export$2e2bcd8739ae039(_ref) {
    var props = _ref.props, states = _ref.states, muiFormControl = _ref.muiFormControl;
    return states.reduce(function(acc, state) {
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}




var $5rVgt = parcelRequire("5rVgt");

var $67mp8 = parcelRequire("67mp8");

var $elnlQ = parcelRequire("elnlQ");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");



var $bT5dp = parcelRequire("bT5dp");

var $5rVgt = parcelRequire("5rVgt");
var $66b2444448c45e3e$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $elnlQ.default)({
            color: theme.palette.text.secondary
        }, theme.typography.body1, {
            lineHeight: 1,
            padding: 0,
            '&$focused': {
                color: theme.palette.primary.main
            },
            '&$disabled': {
                color: theme.palette.text.disabled
            },
            '&$error': {
                color: theme.palette.error.main
            }
        }),
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            '&$focused': {
                color: theme.palette.secondary.main
            }
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Styles applied to the asterisk element. */ asterisk: {
            '&$error': {
                color: theme.palette.error.main
            }
        }
    };
};
var $66b2444448c45e3e$var$FormLabel = /*#__PURE__*/ $Fo7oF.forwardRef(function FormLabel(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, color = props.color, _props$component = props.component, Component = _props$component === void 0 ? 'label' : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, required = props.required, other = (0, $67mp8.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "required"
    ]);
    var muiFormControl = (0, $da6b73123b6a85ad$export$2e2bcd8739ae039)();
    var fcs = (0, $13260d58a3dda9e0$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    return /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, classes["color".concat((0, $bT5dp.default)(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
        ref: ref
    }, other), children, fcs.required && /*#__PURE__*/ $Fo7oF.createElement("span", {
        "aria-hidden": true,
        className: (0, $78z8j.default)(classes.asterisk, fcs.error && classes.error)
    }, "\u2009", '*'));
});
var $66b2444448c45e3e$export$2e2bcd8739ae039 = (0, $5rVgt.default)($66b2444448c45e3e$export$9dd6ff9ea0189349, {
    name: 'MuiFormLabel'
})($66b2444448c45e3e$var$FormLabel);


var $72e841643b7cb579$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'block',
            transformOrigin: 'top left'
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {},
        /* Pseudo-class applied to the asterisk element. */ asterisk: {},
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            position: 'absolute',
            left: 0,
            top: 0,
            // slight alteration to spec spacing to match visual spec result
            transform: 'translate(0, 24px) scale(1)'
        },
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            // Compensation for the `Input.inputDense` style.
            transform: 'translate(0, 21px) scale(1)'
        },
        /* Styles applied to the `input` element if `shrink={true}`. */ shrink: {
            transform: 'translate(0, 1.5px) scale(0.75)',
            transformOrigin: 'top left'
        },
        /* Styles applied to the `input` element if `disableAnimation={false}`. */ animated: {
            transition: theme.transitions.create([
                'color',
                'transform'
            ], {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the root element if `variant="filled"`. */ filled: {
            // Chrome's autofill feature gives the input field a yellow background.
            // Since the input field is behind the label in the HTML tree,
            // the input field is drawn last and hides the label with an opaque background color.
            // zIndex: 1 will raise the label above opaque background-colors of input.
            zIndex: 1,
            pointerEvents: 'none',
            transform: 'translate(12px, 20px) scale(1)',
            '&$marginDense': {
                transform: 'translate(12px, 17px) scale(1)'
            },
            '&$shrink': {
                transform: 'translate(12px, 10px) scale(0.75)',
                '&$marginDense': {
                    transform: 'translate(12px, 7px) scale(0.75)'
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            // see comment above on filled.zIndex
            zIndex: 1,
            pointerEvents: 'none',
            transform: 'translate(14px, 20px) scale(1)',
            '&$marginDense': {
                transform: 'translate(14px, 12px) scale(1)'
            },
            '&$shrink': {
                transform: 'translate(14px, -6px) scale(0.75)'
            }
        }
    };
};
var $72e841643b7cb579$var$InputLabel = /*#__PURE__*/ $Fo7oF.forwardRef(function InputLabel(props, ref) {
    var classes = props.classes, className = props.className, _props$disableAnimati = props.disableAnimation, disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati, margin = props.margin, shrinkProp = props.shrink, variant = props.variant, other = (0, $67mp8.default)(props, [
        "classes",
        "className",
        "disableAnimation",
        "margin",
        "shrink",
        "variant"
    ]);
    var muiFormControl = (0, $da6b73123b6a85ad$export$2e2bcd8739ae039)();
    var shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    var fcs = (0, $13260d58a3dda9e0$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'margin',
            'variant'
        ]
    });
    return /*#__PURE__*/ $Fo7oF.createElement((0, $66b2444448c45e3e$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        "data-shrink": shrink,
        className: (0, $78z8j.default)(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === 'dense' && classes.marginDense, {
            'filled': classes.filled,
            'outlined': classes.outlined
        }[fcs.variant]),
        classes: {
            focused: classes.focused,
            disabled: classes.disabled,
            error: classes.error,
            required: classes.required,
            asterisk: classes.asterisk
        },
        ref: ref
    }, other));
});
var $72e841643b7cb579$export$2e2bcd8739ae039 = (0, $5rVgt.default)($72e841643b7cb579$export$9dd6ff9ea0189349, {
    name: 'MuiInputLabel'
})($72e841643b7cb579$var$InputLabel);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $jOxwe = parcelRequire("jOxwe");

var $elnlQ = parcelRequire("elnlQ");

var $8YHhK = parcelRequire("8YHhK");

var $67mp8 = parcelRequire("67mp8");

var $69Iz3 = parcelRequire("69Iz3");

var $3Oo4t = parcelRequire("3Oo4t");

var $Fo7oF = parcelRequire("Fo7oF");
parcelRequire("7XcX3");


var $78z8j = parcelRequire("78z8j");
function $19cc7a4a973836a5$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $bT5dp = parcelRequire("bT5dp");

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");
parcelRequire("7XcX3");


var $78z8j = parcelRequire("78z8j");


var $5rVgt = parcelRequire("5rVgt");

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $bvYwR = parcelRequire("bvYwR");

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $6f88adb62ae78218$export$2e2bcd8739ae039(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
    var timeout;
    function debounced() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        // eslint-disable-next-line consistent-this
        var that = this;
        var later = function later() {
            func.apply(that, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = function() {
        clearTimeout(timeout);
    };
    return debounced;
}



var $78z8j = parcelRequire("78z8j");


function $aa34b46abbb8342b$export$2e2bcd8739ae039(node) {
    var doc = (0, $19cc7a4a973836a5$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $f5393b90dfc3d6af$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    return funcs.reduce(function(acc, func) {
        if (func == null) return acc;
        return function chainedFunction() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, function() {});
}




var $5rVgt = parcelRequire("5rVgt");

var $67mp8 = parcelRequire("67mp8");

var $elnlQ = parcelRequire("elnlQ");

var $Fo7oF = parcelRequire("Fo7oF");

var $bvYwR = parcelRequire("bvYwR");


var $5IYgb = parcelRequire("5IYgb");
var $bauHK = parcelRequire("bauHK");




var $Fo7oF = parcelRequire("Fo7oF");

var $bvYwR = parcelRequire("bvYwR");





function $7105c4b49b050e4f$var$getContainer(container) {
    container = typeof container === 'function' ? container() : container; // #StrictMode ready
    return $bvYwR.findDOMNode(container);
}
var $7105c4b49b050e4f$var$useEnhancedEffect = typeof window !== 'undefined' ? $Fo7oF.useLayoutEffect : $Fo7oF.useEffect;
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */ var $7105c4b49b050e4f$var$Portal = /*#__PURE__*/ $Fo7oF.forwardRef(function Portal(props, ref) {
    var children = props.children, container = props.container, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, onRendered = props.onRendered;
    var _React$useState = $Fo7oF.useState(null), mountNode = _React$useState[0], setMountNode = _React$useState[1];
    var handleRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(/*#__PURE__*/ $Fo7oF.isValidElement(children) ? children.ref : null, ref);
    $7105c4b49b050e4f$var$useEnhancedEffect(function() {
        if (!disablePortal) setMountNode($7105c4b49b050e4f$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    $7105c4b49b050e4f$var$useEnhancedEffect(function() {
        if (mountNode && !disablePortal) {
            (0, $797ab9d955819a25$export$2e2bcd8739ae039)(ref, mountNode);
            return function() {
                (0, $797ab9d955819a25$export$2e2bcd8739ae039)(ref, null);
            };
        }
        return undefined;
    }, [
        ref,
        mountNode,
        disablePortal
    ]);
    $7105c4b49b050e4f$var$useEnhancedEffect(function() {
        if (onRendered && (mountNode || disablePortal)) onRendered();
    }, [
        onRendered,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $Fo7oF.isValidElement(children)) return /*#__PURE__*/ $Fo7oF.cloneElement(children, {
            ref: handleRef
        });
        return children;
    }
    return mountNode ? /*#__PURE__*/ $bvYwR.createPortal(children, mountNode) : mountNode;
});
var $7105c4b49b050e4f$export$2e2bcd8739ae039 = $7105c4b49b050e4f$var$Portal;






var $o4akA = parcelRequire("o4akA");
function $79e75fc78697f660$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



var $fxzEt = parcelRequire("fxzEt");

var $83MhR = parcelRequire("83MhR");
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function $1ed94bc3149187fc$export$2e2bcd8739ae039() {
    var scrollDiv = document.createElement('div');
    scrollDiv.style.width = '99px';
    scrollDiv.style.height = '99px';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    scrollDiv.style.overflow = 'scroll';
    document.body.appendChild(scrollDiv);
    var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarSize;
}




function $ce6f4a3a1572072b$var$isOverflowing(container) {
    var doc = (0, $19cc7a4a973836a5$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $aa34b46abbb8342b$export$2e2bcd8739ae039)(doc).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $ce6f4a3a1572072b$export$e1bd0c6150f13d96(node, show) {
    if (show) node.setAttribute('aria-hidden', 'true');
    else node.removeAttribute('aria-hidden');
}
function $ce6f4a3a1572072b$var$getPaddingRight(node) {
    return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
}
function $ce6f4a3a1572072b$var$ariaHiddenSiblings(container, mountNode, currentNode) {
    var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var show = arguments.length > 4 ? arguments[4] : undefined;
    var blacklist = [
        mountNode,
        currentNode
    ].concat((0, $83MhR.default)(nodesToExclude));
    var blacklistTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE'
    ];
    [].forEach.call(container.children, function(node) {
        if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) $ce6f4a3a1572072b$export$e1bd0c6150f13d96(node, show);
    });
}
function $ce6f4a3a1572072b$var$findIndexOf(containerInfo, callback) {
    var idx = -1;
    containerInfo.some(function(item, index) {
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $ce6f4a3a1572072b$var$handleContainer(containerInfo, props) {
    var restoreStyle = [];
    var restorePaddings = [];
    var container = containerInfo.container;
    var fixedNodes;
    if (!props.disableScrollLock) {
        if ($ce6f4a3a1572072b$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            var scrollbarSize = (0, $1ed94bc3149187fc$export$2e2bcd8739ae039)();
            restoreStyle.push({
                value: container.style.paddingRight,
                key: 'padding-right',
                el: container
            }); // Use computed style, here to get the real padding to add our scrollbar width.
            container.style['padding-right'] = "".concat($ce6f4a3a1572072b$var$getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
            fixedNodes = (0, $19cc7a4a973836a5$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedNodes, function(node) {
                restorePaddings.push(node.style.paddingRight);
                node.style.paddingRight = "".concat($ce6f4a3a1572072b$var$getPaddingRight(node) + scrollbarSize, "px");
            });
        } // Improve Gatsby support
        // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
        var parent = container.parentElement;
        var scrollContainer = parent.nodeName === 'HTML' && window.getComputedStyle(parent)['overflow-y'] === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            key: 'overflow',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    var restore = function restore() {
        if (fixedNodes) [].forEach.call(fixedNodes, function(node, i) {
            if (restorePaddings[i]) node.style.paddingRight = restorePaddings[i];
            else node.style.removeProperty('padding-right');
        });
        restoreStyle.forEach(function(_ref) {
            var value = _ref.value, el = _ref.el, key = _ref.key;
            if (value) el.style.setProperty(key, value);
            else el.style.removeProperty(key);
        });
    };
    return restore;
}
function $ce6f4a3a1572072b$var$getHiddenSiblings(container) {
    var hiddenSiblings = [];
    [].forEach.call(container.children, function(node) {
        if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(node);
    });
    return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */ var $ce6f4a3a1572072b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ModalManager() {
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, ModalManager);
        // this.modals[modalIndex] = modal
        this.modals = []; // this.containers[containerIndex] = {
        //   modals: [],
        //   container,
        //   restore: null,
        // }
        this.containers = [];
    }
    (0, $fxzEt.default)(ModalManager, [
        {
            key: "add",
            value: function add(modal, container) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex !== -1) return modalIndex;
                modalIndex = this.modals.length;
                this.modals.push(modal); // If the modal we are adding is already in the DOM.
                if (modal.modalRef) $ce6f4a3a1572072b$export$e1bd0c6150f13d96(modal.modalRef, false);
                var hiddenSiblingNodes = $ce6f4a3a1572072b$var$getHiddenSiblings(container);
                $ce6f4a3a1572072b$var$ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
                var containerIndex = $ce6f4a3a1572072b$var$findIndexOf(this.containers, function(item) {
                    return item.container === container;
                });
                if (containerIndex !== -1) {
                    this.containers[containerIndex].modals.push(modal);
                    return modalIndex;
                }
                this.containers.push({
                    modals: [
                        modal
                    ],
                    container: container,
                    restore: null,
                    hiddenSiblingNodes: hiddenSiblingNodes
                });
                return modalIndex;
            }
        },
        {
            key: "mount",
            value: function mount(modal, props) {
                var containerIndex = $ce6f4a3a1572072b$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                if (!containerInfo.restore) containerInfo.restore = $ce6f4a3a1572072b$var$handleContainer(containerInfo, props);
            }
        },
        {
            key: "remove",
            value: function remove(modal) {
                var modalIndex = this.modals.indexOf(modal);
                if (modalIndex === -1) return modalIndex;
                var containerIndex = $ce6f4a3a1572072b$var$findIndexOf(this.containers, function(item) {
                    return item.modals.indexOf(modal) !== -1;
                });
                var containerInfo = this.containers[containerIndex];
                containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
                this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
                if (containerInfo.modals.length === 0) {
                    // The modal might be closed before it had the chance to be mounted in the DOM.
                    if (containerInfo.restore) containerInfo.restore();
                    if (modal.modalRef) // In case the modal wasn't in the DOM yet.
                    $ce6f4a3a1572072b$export$e1bd0c6150f13d96(modal.modalRef, true);
                    $ce6f4a3a1572072b$var$ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
                    this.containers.splice(containerIndex, 1);
                } else {
                    // Otherwise make sure the next top modal is visible to a screen reader.
                    var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
                    // aria-hidden because the dom element doesn't exist either
                    // when modal was unmounted before modalRef gets null
                    if (nextTop.modalRef) $ce6f4a3a1572072b$export$e1bd0c6150f13d96(nextTop.modalRef, false);
                }
                return modalIndex;
            }
        },
        {
            key: "isTopModal",
            value: function isTopModal(modal) {
                return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
            }
        }
    ]);
    return ModalManager;
}();


/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */ 
var $Fo7oF = parcelRequire("Fo7oF");

var $bvYwR = parcelRequire("bvYwR");




/**
 * Utility component that locks focus inside the component.
 */ function $488d93e46dc468e0$var$Unstable_TrapFocus(props) {
    var children = props.children, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, getDoc = props.getDoc, isEnabled = props.isEnabled, open = props.open;
    var ignoreNextEnforceFocus = $Fo7oF.useRef();
    var sentinelStart = $Fo7oF.useRef(null);
    var sentinelEnd = $Fo7oF.useRef(null);
    var nodeToRestore = $Fo7oF.useRef();
    var rootRef = $Fo7oF.useRef(null); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $Fo7oF.useCallback(function(instance) {
        // #StrictMode ready
        rootRef.current = $bvYwR.findDOMNode(instance);
    }, []);
    var handleRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(children.ref, handleOwnRef);
    var prevOpenRef = $Fo7oF.useRef();
    $Fo7oF.useEffect(function() {
        prevOpenRef.current = open;
    }, [
        open
    ]);
    if (!prevOpenRef.current && open && typeof window !== 'undefined') // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
    $Fo7oF.useEffect(function() {
        if (!open) return;
        var doc = (0, $19cc7a4a973836a5$export$2e2bcd8739ae039)(rootRef.current); // We might render an empty child.
        if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', -1);
            rootRef.current.focus();
        }
        var contain = function contain() {
            var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (rootRef.current && !rootRef.current.contains(doc.activeElement)) rootRef.current.focus();
        };
        var loopFocus = function loopFocus(event) {
            // 9 = Tab
            if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) return;
             // Make sure the next tab starts from the right place.
            if (doc.activeElement === rootRef.current) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (event.shiftKey) sentinelEnd.current.focus();
                else sentinelStart.current.focus();
            }
        };
        doc.addEventListener('focus', contain, true);
        doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        var interval = setInterval(function() {
            contain();
        }, 50);
        return function() {
            clearInterval(interval);
            doc.removeEventListener('focus', contain, true);
            doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE 11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE 11 have a focus method.
                // Once IE 11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) nodeToRestore.current.focus();
                nodeToRestore.current = null;
            }
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement($Fo7oF.Fragment, null, /*#__PURE__*/ $Fo7oF.createElement("div", {
        tabIndex: 0,
        ref: sentinelStart,
        "data-test": "sentinelStart"
    }), /*#__PURE__*/ $Fo7oF.cloneElement(children, {
        ref: handleRef
    }), /*#__PURE__*/ $Fo7oF.createElement("div", {
        tabIndex: 0,
        ref: sentinelEnd,
        "data-test": "sentinelEnd"
    }));
}
var $488d93e46dc468e0$export$2e2bcd8739ae039 = $488d93e46dc468e0$var$Unstable_TrapFocus;



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");

var $d00bd41b3462b0bb$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        zIndex: -1,
        position: 'fixed',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    },
    /* Styles applied to the root element if `invisible={true}`. */ invisible: {
        backgroundColor: 'transparent'
    }
};
/**
 * @ignore - internal component.
 */ var $d00bd41b3462b0bb$var$SimpleBackdrop = /*#__PURE__*/ $Fo7oF.forwardRef(function SimpleBackdrop(props, ref) {
    var _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, other = (0, $67mp8.default)(props, [
        "invisible",
        "open"
    ]);
    return open ? /*#__PURE__*/ $Fo7oF.createElement("div", (0, $elnlQ.default)({
        "aria-hidden": true,
        ref: ref
    }, other, {
        style: (0, $elnlQ.default)({}, $d00bd41b3462b0bb$export$9dd6ff9ea0189349.root, invisible ? $d00bd41b3462b0bb$export$9dd6ff9ea0189349.invisible : {}, other.style)
    })) : null;
});
var $d00bd41b3462b0bb$export$2e2bcd8739ae039 = $d00bd41b3462b0bb$var$SimpleBackdrop;


function $1a75137825249088$var$getContainer(container) {
    container = typeof container === 'function' ? container() : container;
    return $bvYwR.findDOMNode(container);
}
function $1a75137825249088$var$getHasTransition(props) {
    return props.children ? props.children.props.hasOwnProperty('in') : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
var $1a75137825249088$var$defaultManager = new (0, $ce6f4a3a1572072b$export$2e2bcd8739ae039)();
var $1a75137825249088$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: 'fixed',
            zIndex: theme.zIndex.modal,
            right: 0,
            bottom: 0,
            top: 0,
            left: 0
        },
        /* Styles applied to the root element if the `Modal` has exited. */ hidden: {
            visibility: 'hidden'
        }
    };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ var $1a75137825249088$var$Modal = /*#__PURE__*/ $Fo7oF.forwardRef(function Modal(inProps, ref) {
    var theme = (0, $bauHK.default)();
    var props = (0, $5IYgb.default)({
        name: 'MuiModal',
        props: (0, $elnlQ.default)({}, inProps),
        theme: theme
    });
    var _props$BackdropCompon = props.BackdropComponent, BackdropComponent = _props$BackdropCompon === void 0 ? (0, $d00bd41b3462b0bb$export$2e2bcd8739ae039) : _props$BackdropCompon, BackdropProps = props.BackdropProps, children = props.children, _props$closeAfterTran = props.closeAfterTransition, closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran, container = props.container, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableBackdro = props.disableBackdropClick, disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableEscapeK = props.disableEscapeKeyDown, disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, _props$disableScrollL = props.disableScrollLock, disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL, _props$hideBackdrop = props.hideBackdrop, hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop, _props$keepMounted = props.keepMounted, keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted, _props$manager = props.manager, manager = _props$manager === void 0 ? $1a75137825249088$var$defaultManager : _props$manager, onBackdropClick = props.onBackdropClick, onClose = props.onClose, onEscapeKeyDown = props.onEscapeKeyDown, onRendered = props.onRendered, open = props.open, other = (0, $67mp8.default)(props, [
        "BackdropComponent",
        "BackdropProps",
        "children",
        "closeAfterTransition",
        "container",
        "disableAutoFocus",
        "disableBackdropClick",
        "disableEnforceFocus",
        "disableEscapeKeyDown",
        "disablePortal",
        "disableRestoreFocus",
        "disableScrollLock",
        "hideBackdrop",
        "keepMounted",
        "manager",
        "onBackdropClick",
        "onClose",
        "onEscapeKeyDown",
        "onRendered",
        "open"
    ]);
    var _React$useState = $Fo7oF.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var modal = $Fo7oF.useRef({});
    var mountNodeRef = $Fo7oF.useRef(null);
    var modalRef = $Fo7oF.useRef(null);
    var handleRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(modalRef, ref);
    var hasTransition = $1a75137825249088$var$getHasTransition(props);
    var getDoc = function getDoc() {
        return (0, $19cc7a4a973836a5$export$2e2bcd8739ae039)(mountNodeRef.current);
    };
    var getModal = function getModal() {
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    var handleMounted = function handleMounted() {
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        }); // Fix a bug on Chrome where the scroll isn't initially 0.
        modalRef.current.scrollTop = 0;
    };
    var handleOpen = (0, $0555362ea49db74e$export$2e2bcd8739ae039)(function() {
        var resolvedContainer = $1a75137825249088$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer); // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    var isTopModal = $Fo7oF.useCallback(function() {
        return manager.isTopModal(getModal());
    }, [
        manager
    ]);
    var handlePortalRef = (0, $0555362ea49db74e$export$2e2bcd8739ae039)(function(node) {
        mountNodeRef.current = node;
        if (!node) return;
        if (onRendered) onRendered();
        if (open && isTopModal()) handleMounted();
        else (0, $ce6f4a3a1572072b$export$e1bd0c6150f13d96)(modalRef.current, true);
    });
    var handleClose = $Fo7oF.useCallback(function() {
        manager.remove(getModal());
    }, [
        manager
    ]);
    $Fo7oF.useEffect(function() {
        return function() {
            handleClose();
        };
    }, [
        handleClose
    ]);
    $Fo7oF.useEffect(function() {
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    var handleExited = function handleExited() {
        setExited(true);
        if (closeAfterTransition) handleClose();
    };
    var handleBackdropClick = function handleBackdropClick(event) {
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (!disableBackdropClick && onClose) onClose(event, 'backdropClick');
    };
    var handleKeyDown = function handleKeyDown(event) {
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviours like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== 'Escape' || !isTopModal()) return;
        if (onEscapeKeyDown) onEscapeKeyDown(event);
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, 'escapeKeyDown');
        }
    };
    var inlineStyle = $1a75137825249088$export$9dd6ff9ea0189349(theme || {
        zIndex: (0, $o4akA.default)
    });
    var childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = children.props.tabIndex || '-1';
     // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $f5393b90dfc3d6af$export$2e2bcd8739ae039)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $f5393b90dfc3d6af$export$2e2bcd8739ae039)(handleExited, children.props.onExited);
    }
    return /*#__PURE__*/ $Fo7oF.createElement((0, $7105c4b49b050e4f$export$2e2bcd8739ae039), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal
    }, /*#__PURE__*/ $Fo7oF.createElement("div", (0, $elnlQ.default)({
        ref: handleRef,
        onKeyDown: handleKeyDown,
        role: "presentation"
    }, other, {
        style: (0, $elnlQ.default)({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
    }), hideBackdrop ? null : /*#__PURE__*/ $Fo7oF.createElement(BackdropComponent, (0, $elnlQ.default)({
        open: open,
        onClick: handleBackdropClick
    }, BackdropProps)), /*#__PURE__*/ $Fo7oF.createElement((0, $488d93e46dc468e0$export$2e2bcd8739ae039), {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        getDoc: getDoc,
        isEnabled: isTopModal,
        open: open
    }, /*#__PURE__*/ $Fo7oF.cloneElement(children, childProps))));
});
var $1a75137825249088$export$2e2bcd8739ae039 = $1a75137825249088$var$Modal;



var $elnlQ = parcelRequire("elnlQ");

var $8YHhK = parcelRequire("8YHhK");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $dOG8L = parcelRequire("dOG8L");

var $bauHK = parcelRequire("bauHK");
parcelRequire("Fo7oF");

var $2si5T = parcelRequire("2si5T");
function $c6db41e315144c8b$export$2e2bcd8739ae039() {
    var theme = (0, $bauHK.default)() || (0, $2si5T.default);
    return theme;
}


var $f7011715ddf0f929$export$b7a864e1eaef9de5 = function reflow(node) {
    return node.scrollTop;
};
function $f7011715ddf0f929$export$8cb1e9b404609ae9(props, options) {
    var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style;
    return {
        duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        delay: style.transitionDelay
    };
}



function $60073b28508896e0$var$getScale(value) {
    return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}
var $60073b28508896e0$var$styles = {
    entering: {
        opacity: 1,
        transform: $60073b28508896e0$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $60073b28508896e0$var$Grow = /*#__PURE__*/ $Fo7oF.forwardRef(function Grow(props, ref) {
    var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? 'auto' : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $dOG8L.default) : _props$TransitionComp, other = (0, $67mp8.default)(props, [
        "children",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var timer = $Fo7oF.useRef();
    var autoTimeout = $Fo7oF.useRef();
    var theme = (0, $c6db41e315144c8b$export$2e2bcd8739ae039)();
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $Fo7oF.useRef(null);
    var foreignRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(children.ref, ref);
    var handleRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $8YHhK.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $f7011715ddf0f929$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        var _getTransitionProps = (0, $f7011715ddf0f929$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: 'enter'
        }), transitionDuration = _getTransitionProps.duration, delay = _getTransitionProps.delay;
        var duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: duration * 0.666,
                delay: delay
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var _getTransitionProps2 = (0, $f7011715ddf0f929$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: 'exit'
        }), transitionDuration = _getTransitionProps2.duration, delay = _getTransitionProps2.delay;
        var duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: duration * 0.666,
                delay: delay || duration * 0.333
            })
        ].join(',');
        node.style.opacity = '0';
        node.style.transform = $60073b28508896e0$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
        var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
        if (timeout === 'auto') timer.current = setTimeout(next, autoTimeout.current || 0);
    };
    $Fo7oF.useEffect(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ $Fo7oF.createElement(TransitionComponent, (0, $elnlQ.default)({
        appear: true,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: addEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $Fo7oF.cloneElement(children, (0, $elnlQ.default)({
            style: (0, $elnlQ.default)({
                opacity: 0,
                transform: $60073b28508896e0$var$getScale(0.75),
                visibility: state === 'exited' && !inProp ? 'hidden' : undefined
            }, $60073b28508896e0$var$styles[state], style, children.props.style),
            ref: handleRef
        }, childProps));
    });
});
$60073b28508896e0$var$Grow.muiSupportAuto = true;
var $60073b28508896e0$export$2e2bcd8739ae039 = $60073b28508896e0$var$Grow;



function $41ed658adbcb63fb$export$6fcff0dc60346367(rect, vertical) {
    var offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $41ed658adbcb63fb$export$a6a488ff68b1bf7b(rect, horizontal) {
    var offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $41ed658adbcb63fb$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map(function(n) {
        return typeof n === 'number' ? "".concat(n, "px") : n;
    }).join(' ');
} // Sum the scrollTop between two elements.
function $41ed658adbcb63fb$var$getScrollParent(parent, child) {
    var element = child;
    var scrollTop = 0;
    while(element && element !== parent){
        element = element.parentElement;
        scrollTop += element.scrollTop;
    }
    return scrollTop;
}
function $41ed658adbcb63fb$var$getAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
var $41ed658adbcb63fb$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the `Paper` component. */ paper: {
        position: 'absolute',
        overflowY: 'auto',
        overflowX: 'hidden',
        // So we see the popover when it's empty.
        // It's most likely on issue on userland.
        minWidth: 16,
        minHeight: 16,
        maxWidth: 'calc(100% - 32px)',
        maxHeight: 'calc(100% - 32px)',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $41ed658adbcb63fb$var$Popover = /*#__PURE__*/ $Fo7oF.forwardRef(function Popover(props, ref) {
    var action = props.action, anchorEl = props.anchorEl, _props$anchorOrigin = props.anchorOrigin, anchorOrigin = _props$anchorOrigin === void 0 ? {
        vertical: 'top',
        horizontal: 'left'
    } : _props$anchorOrigin, anchorPosition = props.anchorPosition, _props$anchorReferenc = props.anchorReference, anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc, children = props.children, classes = props.classes, className = props.className, containerProp = props.container, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 8 : _props$elevation, getContentAnchorEl = props.getContentAnchorEl, _props$marginThreshol = props.marginThreshold, marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, _props$transformOrigi = props.transformOrigin, transformOrigin = _props$transformOrigi === void 0 ? {
        vertical: 'top',
        horizontal: 'left'
    } : _props$transformOrigi, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $60073b28508896e0$export$2e2bcd8739ae039) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura, _props$TransitionProp = props.TransitionProps, TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp, other = (0, $67mp8.default)(props, [
        "action",
        "anchorEl",
        "anchorOrigin",
        "anchorPosition",
        "anchorReference",
        "children",
        "classes",
        "className",
        "container",
        "elevation",
        "getContentAnchorEl",
        "marginThreshold",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "open",
        "PaperProps",
        "transformOrigin",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps"
    ]);
    var paperRef = $Fo7oF.useRef(); // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    var getAnchorOffset = $Fo7oF.useCallback(function(contentAnchorOffset) {
        if (anchorReference === 'anchorPosition') return anchorPosition;
        var resolvedAnchorEl = $41ed658adbcb63fb$var$getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover
        var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $19cc7a4a973836a5$export$2e2bcd8739ae039)(paperRef.current).body;
        var anchorRect = anchorElement.getBoundingClientRect();
        var box;
        var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
        return {
            top: anchorRect.top + $41ed658adbcb63fb$export$6fcff0dc60346367(anchorRect, anchorVertical),
            left: anchorRect.left + $41ed658adbcb63fb$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]); // Returns the vertical offset of inner content to anchor the transform on if provided
    var getContentAnchorOffset = $Fo7oF.useCallback(function(element) {
        var contentAnchorOffset = 0;
        if (getContentAnchorEl && anchorReference === 'anchorEl') {
            var contentAnchorEl = getContentAnchorEl(element);
            if (contentAnchorEl && element.contains(contentAnchorEl)) {
                var scrollTop = $41ed658adbcb63fb$var$getScrollParent(element, contentAnchorEl);
                contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
            } // != the default value
        }
        return contentAnchorOffset;
    }, [
        anchorOrigin.vertical,
        anchorReference,
        getContentAnchorEl
    ]); // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use
    var getTransformOrigin = $Fo7oF.useCallback(function(elemRect) {
        var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return {
            vertical: $41ed658adbcb63fb$export$6fcff0dc60346367(elemRect, transformOrigin.vertical) + contentAnchorOffset,
            horizontal: $41ed658adbcb63fb$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    var getPositioningStyle = $Fo7oF.useCallback(function(element) {
        // Check if the parent has requested anchoring on an inner content node
        var contentAnchorOffset = getContentAnchorOffset(element);
        var elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        }; // Get the transform origin point on the element itself
        var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $41ed658adbcb63fb$var$getTransformOriginValue(elemTransformOrigin)
        };
         // Get the offset of of the anchoring element
        var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning
        var top = anchorOffset.top - elemTransformOrigin.vertical;
        var left = anchorOffset.left - elemTransformOrigin.horizontal;
        var bottom = top + elemRect.height;
        var right = left + elemRect.width; // Use the parent window of the anchorEl if provided
        var containerWindow = (0, $aa34b46abbb8342b$export$2e2bcd8739ae039)($41ed658adbcb63fb$var$getAnchorEl(anchorEl)); // Window thresholds taking required margin into account
        var heightThreshold = containerWindow.innerHeight - marginThreshold;
        var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            var diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            var _diff = bottom - heightThreshold;
            top -= _diff;
            elemTransformOrigin.vertical += _diff;
        }
        if (left < marginThreshold) {
            var _diff2 = left - marginThreshold;
            left -= _diff2;
            elemTransformOrigin.horizontal += _diff2;
        } else if (right > widthThreshold) {
            var _diff3 = right - widthThreshold;
            left -= _diff3;
            elemTransformOrigin.horizontal += _diff3;
        }
        return {
            top: "".concat(Math.round(top), "px"),
            left: "".concat(Math.round(left), "px"),
            transformOrigin: $41ed658adbcb63fb$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getContentAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    var setPositioningStyles = $Fo7oF.useCallback(function() {
        var element = paperRef.current;
        if (!element) return;
        var positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
    }, [
        getPositioningStyle
    ]);
    var handleEntering = function handleEntering(element, isAppearing) {
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    var handlePaperRef = $Fo7oF.useCallback(function(instance) {
        // #StrictMode ready
        paperRef.current = $bvYwR.findDOMNode(instance);
    }, []);
    $Fo7oF.useEffect(function() {
        if (open) setPositioningStyles();
    });
    $Fo7oF.useImperativeHandle(action, function() {
        return open ? {
            updatePosition: function updatePosition() {
                setPositioningStyles();
            }
        } : null;
    }, [
        open,
        setPositioningStyles
    ]);
    $Fo7oF.useEffect(function() {
        if (!open) return undefined;
        var handleResize = (0, $6f88adb62ae78218$export$2e2bcd8739ae039)(function() {
            setPositioningStyles();
        });
        window.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener('resize', handleResize);
        };
    }, [
        open,
        setPositioningStyles
    ]);
    var transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
     // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    var container = containerProp || (anchorEl ? (0, $19cc7a4a973836a5$export$2e2bcd8739ae039)($41ed658adbcb63fb$var$getAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ $Fo7oF.createElement((0, $1a75137825249088$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        container: container,
        open: open,
        ref: ref,
        BackdropProps: {
            invisible: true
        },
        className: (0, $78z8j.default)(classes.root, className)
    }, other), /*#__PURE__*/ $Fo7oF.createElement(TransitionComponent, (0, $elnlQ.default)({
        appear: true,
        in: open,
        onEnter: onEnter,
        onEntered: onEntered,
        onExit: onExit,
        onExited: onExited,
        onExiting: onExiting,
        timeout: transitionDuration
    }, TransitionProps, {
        onEntering: (0, $f5393b90dfc3d6af$export$2e2bcd8739ae039)(handleEntering, TransitionProps.onEntering)
    }), /*#__PURE__*/ $Fo7oF.createElement((0, $fe0aa9e32766c0f5$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        elevation: elevation,
        ref: handlePaperRef
    }, PaperProps, {
        className: (0, $78z8j.default)(classes.paper, PaperProps.className)
    }), children)));
});
var $41ed658adbcb63fb$export$2e2bcd8739ae039 = (0, $5rVgt.default)($41ed658adbcb63fb$export$9dd6ff9ea0189349, {
    name: 'MuiPopover'
})($41ed658adbcb63fb$var$Popover);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");
parcelRequire("7XcX3");


var $bvYwR = parcelRequire("bvYwR");


var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");

var $Fo7oF = parcelRequire("Fo7oF");
/**
 * @ignore - internal component.
 */ var $e072d90b3b716aaf$var$ListContext = $Fo7oF.createContext({});
var $e072d90b3b716aaf$export$2e2bcd8739ae039 = $e072d90b3b716aaf$var$ListContext;


var $3bedfddd0d7b5bec$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    },
    /* Styles applied to the root element if `disablePadding={false}`. */ padding: {
        paddingTop: 8,
        paddingBottom: 8
    },
    /* Styles applied to the root element if dense. */ dense: {},
    /* Styles applied to the root element if a `subheader` is provided. */ subheader: {
        paddingTop: 0
    }
};
var $3bedfddd0d7b5bec$var$List = /*#__PURE__*/ $Fo7oF.forwardRef(function List(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'ul' : _props$component, _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disablePadding = props.disablePadding, disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding, subheader = props.subheader, other = (0, $67mp8.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "dense",
        "disablePadding",
        "subheader"
    ]);
    var context = $Fo7oF.useMemo(function() {
        return {
            dense: dense
        };
    }, [
        dense
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement((0, $e072d90b3b716aaf$export$2e2bcd8739ae039).Provider, {
        value: context
    }, /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
        ref: ref
    }, other), subheader, children));
});
var $3bedfddd0d7b5bec$export$2e2bcd8739ae039 = (0, $5rVgt.default)($3bedfddd0d7b5bec$export$9dd6ff9ea0189349, {
    name: 'MuiList'
})($3bedfddd0d7b5bec$var$List);




function $a6d7c56af9b42ce0$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $a6d7c56af9b42ce0$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $a6d7c56af9b42ce0$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    var text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $a6d7c56af9b42ce0$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    var wrappedOnce = false;
    var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        } // Same logic as useAutocomplete.js
        var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$a6d7c56af9b42ce0$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return;
        }
    }
}
var $a6d7c56af9b42ce0$var$useEnhancedEffect = typeof window === 'undefined' ? $Fo7oF.useEffect : $Fo7oF.useLayoutEffect;
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ var $a6d7c56af9b42ce0$var$MenuList = /*#__PURE__*/ $Fo7oF.forwardRef(function MenuList(props, ref) {
    var actions = props.actions, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$autoFocusItem = props.autoFocusItem, autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem, children = props.children, className = props.className, _props$disabledItemsF = props.disabledItemsFocusable, disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF, _props$disableListWra = props.disableListWrap, disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra, onKeyDown = props.onKeyDown, _props$variant = props.variant, variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant, other = (0, $67mp8.default)(props, [
        "actions",
        "autoFocus",
        "autoFocusItem",
        "children",
        "className",
        "disabledItemsFocusable",
        "disableListWrap",
        "onKeyDown",
        "variant"
    ]);
    var listRef = $Fo7oF.useRef(null);
    var textCriteriaRef = $Fo7oF.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    $a6d7c56af9b42ce0$var$useEnhancedEffect(function() {
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $Fo7oF.useImperativeHandle(actions, function() {
        return {
            adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                var noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    var scrollbarSize = "".concat((0, $1ed94bc3149187fc$export$2e2bcd8739ae039)(true), "px");
                    listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
                }
                return listRef.current;
            }
        };
    }, []);
    var handleKeyDown = function handleKeyDown(event) {
        var list = listRef.current;
        var key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ var currentFocus = (0, $19cc7a4a973836a5$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $a6d7c56af9b42ce0$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $a6d7c56af9b42ce0$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $a6d7c56af9b42ce0$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $a6d7c56af9b42ce0$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $a6d7c56af9b42ce0$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $a6d7c56af9b42ce0$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $a6d7c56af9b42ce0$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $a6d7c56af9b42ce0$var$previousItem);
        } else if (key.length === 1) {
            var criteria = textCriteriaRef.current;
            var lowerKey = key.toLowerCase();
            var currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            var keepFocusOnCurrent = currentFocus && !criteria.repeating && $a6d7c56af9b42ce0$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $a6d7c56af9b42ce0$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $a6d7c56af9b42ce0$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    var handleOwnRef = $Fo7oF.useCallback(function(instance) {
        // #StrictMode ready
        listRef.current = $bvYwR.findDOMNode(instance);
    }, []);
    var handleRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(handleOwnRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $Fo7oF.Children.forEach(children, function(child, index) {
        if (!/*#__PURE__*/ $Fo7oF.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $Fo7oF.Children.map(children, function(child, index) {
        if (index === activeItemIndex) {
            var newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $Fo7oF.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ $Fo7oF.createElement((0, $3bedfddd0d7b5bec$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other), items);
});
var $a6d7c56af9b42ce0$export$2e2bcd8739ae039 = $a6d7c56af9b42ce0$var$MenuList;



var $bvYwR = parcelRequire("bvYwR");



var $4258bc98dbe3c638$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
var $4258bc98dbe3c638$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
var $4258bc98dbe3c638$export$9dd6ff9ea0189349 = {
    /* Styles applied to the `Paper` component. */ paper: {
        // specZ: The maximum height of a simple menu should be one or more rows less than the view
        // height. This ensures a tapable area outside of the simple menu with which to dismiss
        // the menu.
        maxHeight: 'calc(100% - 96px)',
        // Add iOS momentum scrolling.
        WebkitOverflowScrolling: 'touch'
    },
    /* Styles applied to the `List` component via `MenuList`. */ list: {
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }
};
var $4258bc98dbe3c638$var$Menu = /*#__PURE__*/ $Fo7oF.forwardRef(function Menu(props, ref) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, children = props.children, classes = props.classes, _props$disableAutoFoc = props.disableAutoFocusItem, disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$MenuListProps = props.MenuListProps, MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps, onClose = props.onClose, onEnteringProp = props.onEntering, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, PopoverClasses = props.PopoverClasses, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura, _props$TransitionProp = props.TransitionProps;
    _props$TransitionProp = _props$TransitionProp === void 0 ? {} : _props$TransitionProp;
    var onEntering = _props$TransitionProp.onEntering, TransitionProps = (0, $67mp8.default)(_props$TransitionProp, [
        "onEntering"
    ]), _props$variant = props.variant, variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant, other = (0, $67mp8.default)(props, [
        "autoFocus",
        "children",
        "classes",
        "disableAutoFocusItem",
        "MenuListProps",
        "onClose",
        "onEntering",
        "open",
        "PaperProps",
        "PopoverClasses",
        "transitionDuration",
        "TransitionProps",
        "variant"
    ]);
    var theme = (0, $c6db41e315144c8b$export$2e2bcd8739ae039)();
    var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    var menuListActionsRef = $Fo7oF.useRef(null);
    var contentAnchorRef = $Fo7oF.useRef(null);
    var getContentAnchorEl = function getContentAnchorEl() {
        return contentAnchorRef.current;
    };
    var handleEntering = function handleEntering(element, isAppearing) {
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEnteringProp) onEnteringProp(element, isAppearing);
        if (onEntering) onEntering(element, isAppearing);
    };
    var handleListKeyDown = function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $Fo7oF.Children.map(children, function(child, index) {
        if (!/*#__PURE__*/ $Fo7oF.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant !== "menu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    var items = $Fo7oF.Children.map(children, function(child, index) {
        if (index === activeItemIndex) return /*#__PURE__*/ $Fo7oF.cloneElement(child, {
            ref: function ref(instance) {
                // #StrictMode ready
                contentAnchorRef.current = $bvYwR.findDOMNode(instance);
                (0, $797ab9d955819a25$export$2e2bcd8739ae039)(child.ref, instance);
            }
        });
        return child;
    });
    return /*#__PURE__*/ $Fo7oF.createElement((0, $41ed658adbcb63fb$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        getContentAnchorEl: getContentAnchorEl,
        classes: PopoverClasses,
        onClose: onClose,
        TransitionProps: (0, $elnlQ.default)({
            onEntering: handleEntering
        }, TransitionProps),
        anchorOrigin: theme.direction === 'rtl' ? $4258bc98dbe3c638$var$RTL_ORIGIN : $4258bc98dbe3c638$var$LTR_ORIGIN,
        transformOrigin: theme.direction === 'rtl' ? $4258bc98dbe3c638$var$RTL_ORIGIN : $4258bc98dbe3c638$var$LTR_ORIGIN,
        PaperProps: (0, $elnlQ.default)({}, PaperProps, {
            classes: (0, $elnlQ.default)({}, PaperProps.classes, {
                root: classes.paper
            })
        }),
        open: open,
        ref: ref,
        transitionDuration: transitionDuration
    }, other), /*#__PURE__*/ $Fo7oF.createElement((0, $a6d7c56af9b42ce0$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        onKeyDown: handleListKeyDown,
        actions: menuListActionsRef,
        autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
        autoFocusItem: autoFocusItem,
        variant: variant
    }, MenuListProps, {
        className: (0, $78z8j.default)(classes.list, MenuListProps.className)
    }), items));
});
var $4258bc98dbe3c638$export$2e2bcd8739ae039 = (0, $5rVgt.default)($4258bc98dbe3c638$export$9dd6ff9ea0189349, {
    name: 'MuiMenu'
})($4258bc98dbe3c638$var$Menu);





function $aa7b33b5759b88de$var$areEqualValues(a, b) {
    if ((0, $69Iz3.default)(b) === 'object' && b !== null) return a === b;
    return String(a) === String(b);
}
function $aa7b33b5759b88de$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
/**
 * @ignore - internal component.
 */ var $aa7b33b5759b88de$var$SelectInput = /*#__PURE__*/ $Fo7oF.forwardRef(function SelectInput(props, ref) {
    var ariaLabel = props['aria-label'], autoFocus = props.autoFocus, autoWidth = props.autoWidth, children = props.children, classes = props.classes, className = props.className, defaultValue = props.defaultValue, disabled = props.disabled, displayEmpty = props.displayEmpty, IconComponent = props.IconComponent, inputRefProp = props.inputRef, labelId = props.labelId, _props$MenuProps = props.MenuProps, MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps, multiple = props.multiple, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClose = props.onClose, onFocus = props.onFocus, onOpen = props.onOpen, openProp = props.open, readOnly = props.readOnly, renderValue = props.renderValue, _props$SelectDisplayP = props.SelectDisplayProps, SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP, tabIndexProp = props.tabIndex, type = props.type, valueProp = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $67mp8.default)(props, [
        "aria-label",
        "autoFocus",
        "autoWidth",
        "children",
        "classes",
        "className",
        "defaultValue",
        "disabled",
        "displayEmpty",
        "IconComponent",
        "inputRef",
        "labelId",
        "MenuProps",
        "multiple",
        "name",
        "onBlur",
        "onChange",
        "onClose",
        "onFocus",
        "onOpen",
        "open",
        "readOnly",
        "renderValue",
        "SelectDisplayProps",
        "tabIndex",
        "type",
        "value",
        "variant"
    ]);
    var _useControlled = (0, $c6d3b036d5d216ae$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    }), _useControlled2 = (0, $8YHhK.default)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
    var inputRef = $Fo7oF.useRef(null);
    var _React$useState = $Fo7oF.useState(null), displayNode = _React$useState[0], setDisplayNode = _React$useState[1];
    var _React$useRef = $Fo7oF.useRef(openProp != null), isOpenControlled = _React$useRef.current;
    var _React$useState2 = $Fo7oF.useState(), menuMinWidthState = _React$useState2[0], setMenuMinWidthState = _React$useState2[1];
    var _React$useState3 = $Fo7oF.useState(false), openState = _React$useState3[0], setOpenState = _React$useState3[1];
    var handleRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(ref, inputRefProp);
    $Fo7oF.useImperativeHandle(handleRef, function() {
        return {
            focus: function focus() {
                displayNode.focus();
            },
            node: inputRef.current,
            value: value
        };
    }, [
        displayNode,
        value
    ]);
    $Fo7oF.useEffect(function() {
        if (autoFocus && displayNode) displayNode.focus();
    }, [
        autoFocus,
        displayNode
    ]);
    $Fo7oF.useEffect(function() {
        if (displayNode) {
            var label = (0, $19cc7a4a973836a5$export$2e2bcd8739ae039)(displayNode).getElementById(labelId);
            if (label) {
                var handler = function handler() {
                    if (getSelection().isCollapsed) displayNode.focus();
                };
                label.addEventListener('click', handler);
                return function() {
                    label.removeEventListener('click', handler);
                };
            }
        }
        return undefined;
    }, [
        labelId,
        displayNode
    ]);
    var update = function update(open, event) {
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
            setOpenState(open);
        }
    };
    var handleMouseDown = function handleMouseDown(event) {
        // Ignore everything but left-click
        if (event.button !== 0) return;
         // Hijack the default focus behavior.
        event.preventDefault();
        displayNode.focus();
        update(true, event);
    };
    var handleClose = function handleClose(event) {
        update(false, event);
    };
    var childrenArray = $Fo7oF.Children.toArray(children); // Support autofill.
    var handleChange = function handleChange(event) {
        var index = childrenArray.map(function(child) {
            return child.props.value;
        }).indexOf(event.target.value);
        if (index === -1) return;
        var child = childrenArray[index];
        setValue(child.props.value);
        if (onChange) onChange(event, child);
    };
    var handleItemClick = function handleItemClick(child) {
        return function(event) {
            if (!multiple) update(false, event);
            var newValue;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                var itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value === newValue) return;
            setValue(newValue);
            if (onChange) {
                event.persist(); // Preact support, target is read only property on a native event.
                Object.defineProperty(event, 'target', {
                    writable: true,
                    value: {
                        value: newValue,
                        name: name
                    }
                });
                onChange(event, child);
            }
        };
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (!readOnly) {
            var validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    var open = displayNode !== null && (isOpenControlled ? openProp : openState);
    var handleBlur = function handleBlur(event) {
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            event.persist(); // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    var display;
    var displaySingle;
    var displayMultiple = [];
    var computeDisplay = false;
    var foundMatch = false; // No need to display any value if the field is empty.
    if ((0, $7bfc6f913d3b5ac4$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    var items = childrenArray.map(function(child) {
        if (!/*#__PURE__*/ $Fo7oF.isValidElement(child)) return null;
        var selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $3Oo4t.default)(2));
            selected = value.some(function(v) {
                return $aa7b33b5759b88de$var$areEqualValues(v, child.props.value);
            });
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $aa7b33b5759b88de$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $Fo7oF.cloneElement(child, {
            'aria-selected': selected ? 'true' : undefined,
            onClick: handleItemClick(child),
            onKeyUp: function onKeyUp(event) {
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    if (computeDisplay) display = multiple ? displayMultiple.join(', ') : displaySingle;
     // Avoid performing a layout computation in the render method.
    var menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = displayNode.clientWidth;
    var tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
    return /*#__PURE__*/ $Fo7oF.createElement($Fo7oF.Fragment, null, /*#__PURE__*/ $Fo7oF.createElement("div", (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
        ref: setDisplayNode,
        tabIndex: tabIndex,
        role: "button",
        "aria-disabled": disabled ? 'true' : undefined,
        "aria-expanded": open ? 'true' : undefined,
        "aria-haspopup": "listbox",
        "aria-label": ariaLabel,
        "aria-labelledby": [
            labelId,
            buttonId
        ].filter(Boolean).join(' ') || undefined,
        onKeyDown: handleKeyDown,
        onMouseDown: disabled || readOnly ? null : handleMouseDown,
        onBlur: handleBlur,
        onFocus: onFocus
    }, SelectDisplayProps, {
        // The id is required for proper a11y
        id: buttonId
    }), $aa7b33b5759b88de$var$isEmpty(display) ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $Fo7oF.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: '&#8203;'
        }
    }) : display), /*#__PURE__*/ $Fo7oF.createElement("input", (0, $elnlQ.default)({
        value: Array.isArray(value) ? value.join(',') : value,
        name: name,
        ref: inputRef,
        "aria-hidden": true,
        onChange: handleChange,
        tabIndex: -1,
        className: classes.nativeInput,
        autoFocus: autoFocus
    }, other)), /*#__PURE__*/ $Fo7oF.createElement(IconComponent, {
        className: (0, $78z8j.default)(classes.icon, classes["icon".concat((0, $bT5dp.default)(variant))], open && classes.iconOpen, disabled && classes.disabled)
    }), /*#__PURE__*/ $Fo7oF.createElement((0, $4258bc98dbe3c638$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        id: "menu-".concat(name || ''),
        anchorEl: displayNode,
        open: open,
        onClose: handleClose
    }, MenuProps, {
        MenuListProps: (0, $elnlQ.default)({
            'aria-labelledby': labelId,
            role: 'listbox',
            disableListWrap: true
        }, MenuProps.MenuListProps),
        PaperProps: (0, $elnlQ.default)({}, MenuProps.PaperProps, {
            style: (0, $elnlQ.default)({
                minWidth: menuMinWidth
            }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
        })
    }), items));
});
var $aa7b33b5759b88de$export$2e2bcd8739ae039 = $aa7b33b5759b88de$var$SelectInput;





var $5rVgt = parcelRequire("5rVgt");

var $Fo7oF = parcelRequire("Fo7oF");

var $3yRq4 = parcelRequire("3yRq4");
var /**
 * @ignore - internal component.
 */ $8646bd5353849a70$export$2e2bcd8739ae039 = (0, $3yRq4.default)(/*#__PURE__*/ $Fo7oF.createElement("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");


var $67mp8 = parcelRequire("67mp8");

var $elnlQ = parcelRequire("elnlQ");

var $3Oo4t = parcelRequire("3Oo4t");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");



var $5rVgt = parcelRequire("5rVgt");

var $bT5dp = parcelRequire("bT5dp");


var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");




function $4f9a8a369d63f706$var$getStyleValue(computedStyle, property) {
    return parseInt(computedStyle[property], 10) || 0;
}
var $4f9a8a369d63f706$var$useEnhancedEffect = typeof window !== 'undefined' ? $Fo7oF.useLayoutEffect : $Fo7oF.useEffect;
var $4f9a8a369d63f706$var$styles = {
    /* Styles applied to the shadow textarea element. */ shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
var $4f9a8a369d63f706$var$TextareaAutosize = /*#__PURE__*/ $Fo7oF.forwardRef(function TextareaAutosize(props, ref) {
    var onChange = props.onChange, rows = props.rows, rowsMax = props.rowsMax, rowsMinProp = props.rowsMin, maxRowsProp = props.maxRows, _props$minRows = props.minRows, minRowsProp = _props$minRows === void 0 ? 1 : _props$minRows, style = props.style, value = props.value, other = (0, $67mp8.default)(props, [
        "onChange",
        "rows",
        "rowsMax",
        "rowsMin",
        "maxRows",
        "minRows",
        "style",
        "value"
    ]);
    var maxRows = maxRowsProp || rowsMax;
    var minRows = rows || rowsMinProp || minRowsProp;
    var _React$useRef = $Fo7oF.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $Fo7oF.useRef(null);
    var handleRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(ref, inputRef);
    var shadowRef = $Fo7oF.useRef(null);
    var renders = $Fo7oF.useRef(0);
    var _React$useState = $Fo7oF.useState({}), state = _React$useState[0], setState = _React$useState[1];
    var syncHeight = $Fo7oF.useCallback(function() {
        var input = inputRef.current;
        var computedStyle = window.getComputedStyle(input);
        var inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || 'x';
        if (inputShallow.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += ' ';
        var boxSizing = computedStyle['box-sizing'];
        var padding = $4f9a8a369d63f706$var$getStyleValue(computedStyle, 'padding-bottom') + $4f9a8a369d63f706$var$getStyleValue(computedStyle, 'padding-top');
        var border = $4f9a8a369d63f706$var$getStyleValue(computedStyle, 'border-bottom-width') + $4f9a8a369d63f706$var$getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content
        var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row
        inputShallow.value = 'x';
        var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content
        var outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.
        var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        var overflow = Math.abs(outerHeight - innerHeight) <= 1;
        setState(function(prevState) {
            // Need a large enough difference to update the height.
            // This prevents infinite rendering loop.
            if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
                renders.current += 1;
                return {
                    overflow: overflow,
                    outerHeightStyle: outerHeightStyle
                };
            }
            return prevState;
        });
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    $Fo7oF.useEffect(function() {
        var handleResize = (0, $6f88adb62ae78218$export$2e2bcd8739ae039)(function() {
            renders.current = 0;
            syncHeight();
        });
        window.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener('resize', handleResize);
        };
    }, [
        syncHeight
    ]);
    $4f9a8a369d63f706$var$useEnhancedEffect(function() {
        syncHeight();
    });
    $Fo7oF.useEffect(function() {
        renders.current = 0;
    }, [
        value
    ]);
    var handleChange = function handleChange(event) {
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ $Fo7oF.createElement($Fo7oF.Fragment, null, /*#__PURE__*/ $Fo7oF.createElement("textarea", (0, $elnlQ.default)({
        value: value,
        onChange: handleChange,
        ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
        ,
        rows: minRows,
        style: (0, $elnlQ.default)({
            height: state.outerHeightStyle,
            // Need a large enough difference to allow scrolling.
            // This prevents infinite rendering loop.
            overflow: state.overflow ? 'hidden' : null
        }, style)
    }, other)), /*#__PURE__*/ $Fo7oF.createElement("textarea", {
        "aria-hidden": true,
        className: props.className,
        readOnly: true,
        ref: shadowRef,
        tabIndex: -1,
        style: (0, $elnlQ.default)({}, $4f9a8a369d63f706$var$styles.shadow, style)
    }));
});
var $4f9a8a369d63f706$export$2e2bcd8739ae039 = $4f9a8a369d63f706$var$TextareaAutosize;



var $41b69e38887ce9df$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === 'light';
    var placeholder = {
        color: 'currentColor',
        opacity: light ? 0.42 : 0.5,
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    var placeholderHidden = {
        opacity: '0 !important'
    };
    var placeholderVisible = {
        opacity: light ? 0.42 : 0.5
    };
    return {
        '@global': {
            '@keyframes mui-auto-fill': {},
            '@keyframes mui-auto-fill-cancel': {}
        },
        /* Styles applied to the root element. */ root: (0, $elnlQ.default)({}, theme.typography.body1, {
            color: theme.palette.text.primary,
            lineHeight: '1.1876em',
            // Reset (19px), match the native input line-height
            boxSizing: 'border-box',
            // Prevent padding issue with fullWidth.
            position: 'relative',
            cursor: 'text',
            display: 'inline-flex',
            alignItems: 'center',
            '&$disabled': {
                color: theme.palette.text.disabled,
                cursor: 'default'
            }
        }),
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {},
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {},
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            '&$marginDense': {
                paddingTop: 3
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: '100%'
        },
        /* Styles applied to the `input` element. */ input: {
            font: 'inherit',
            letterSpacing: 'inherit',
            color: 'currentColor',
            padding: "".concat(6, "px 0 ").concat(7, "px"),
            border: 0,
            boxSizing: 'content-box',
            background: 'none',
            height: '1.1876em',
            // Reset (19px), match the native input line-height
            margin: 0,
            // Reset for Safari
            WebkitTapHighlightColor: 'transparent',
            display: 'block',
            // Make the flex item shrink with Firefox
            minWidth: 0,
            width: '100%',
            // Fix IE 11 width issue
            animationName: 'mui-auto-fill-cancel',
            animationDuration: '10ms',
            '&::-webkit-input-placeholder': placeholder,
            '&::-moz-placeholder': placeholder,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholder,
            // IE 11
            '&::-ms-input-placeholder': placeholder,
            // Edge
            '&:focus': {
                outline: 0
            },
            // Reset Firefox invalid required input style
            '&:invalid': {
                boxShadow: 'none'
            },
            '&::-webkit-search-decoration': {
                // Remove the padding when type=search.
                '-webkit-appearance': 'none'
            },
            // Show and hide the placeholder logic
            'label[data-shrink=false] + $formControl &': {
                '&::-webkit-input-placeholder': placeholderHidden,
                '&::-moz-placeholder': placeholderHidden,
                // Firefox 19+
                '&:-ms-input-placeholder': placeholderHidden,
                // IE 11
                '&::-ms-input-placeholder': placeholderHidden,
                // Edge
                '&:focus::-webkit-input-placeholder': placeholderVisible,
                '&:focus::-moz-placeholder': placeholderVisible,
                // Firefox 19+
                '&:focus:-ms-input-placeholder': placeholderVisible,
                // IE 11
                '&:focus::-ms-input-placeholder': placeholderVisible // Edge
            },
            '&$disabled': {
                opacity: 1 // Reset iOS opacity
            },
            '&:-webkit-autofill': {
                animationDuration: '5000s',
                animationName: 'mui-auto-fill'
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 3
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            height: 'auto',
            resize: 'none',
            padding: 0
        },
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {
            // Improve type search style.
            '-moz-appearance': 'textfield',
            '-webkit-appearance': 'textfield'
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {},
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {},
        /* Styles applied to the `input` element if `hiddenLabel={true}`. */ inputHiddenLabel: {}
    };
};
var $41b69e38887ce9df$var$useEnhancedEffect = typeof window === 'undefined' ? $Fo7oF.useEffect : $Fo7oF.useLayoutEffect;
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ var $41b69e38887ce9df$var$InputBase = /*#__PURE__*/ $Fo7oF.forwardRef(function InputBase(props, ref) {
    var ariaDescribedby = props['aria-describedby'], autoComplete = props.autoComplete, autoFocus = props.autoFocus, classes = props.classes, className = props.className, color = props.color, defaultValue = props.defaultValue, disabled = props.disabled, endAdornment = props.endAdornment, error = props.error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, id = props.id, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent, _props$inputProps = props.inputProps, inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps, inputRefProp = props.inputRef, margin = props.margin, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClick = props.onClick, onFocus = props.onFocus, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, placeholder = props.placeholder, readOnly = props.readOnly, renderSuffix = props.renderSuffix, rows = props.rows, rowsMax = props.rowsMax, rowsMin = props.rowsMin, maxRows = props.maxRows, minRows = props.minRows, startAdornment = props.startAdornment, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, valueProp = props.value, other = (0, $67mp8.default)(props, [
        "aria-describedby",
        "autoComplete",
        "autoFocus",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "endAdornment",
        "error",
        "fullWidth",
        "id",
        "inputComponent",
        "inputProps",
        "inputRef",
        "margin",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onClick",
        "onFocus",
        "onKeyDown",
        "onKeyUp",
        "placeholder",
        "readOnly",
        "renderSuffix",
        "rows",
        "rowsMax",
        "rowsMin",
        "maxRows",
        "minRows",
        "startAdornment",
        "type",
        "value"
    ]);
    var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    var _React$useRef = $Fo7oF.useRef(value != null), isControlled = _React$useRef.current;
    var inputRef = $Fo7oF.useRef();
    var handleInputRefWarning = $Fo7oF.useCallback(function(instance) {}, []);
    var handleInputPropsRefProp = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(inputPropsProp.ref, handleInputRefWarning);
    var handleInputRefProp = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(inputRefProp, handleInputPropsRefProp);
    var handleInputRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(inputRef, handleInputRefProp);
    var _React$useState = $Fo7oF.useState(false), focused = _React$useState[0], setFocused = _React$useState[1];
    var muiFormControl = (0, $8d9862aa244cad11$export$62ecd8ad1bbe1a18)();
    var fcs = (0, $13260d58a3dda9e0$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'margin',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $Fo7oF.useEffect(function() {
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    var onFilled = muiFormControl && muiFormControl.onFilled;
    var onEmpty = muiFormControl && muiFormControl.onEmpty;
    var checkDirty = $Fo7oF.useCallback(function(obj) {
        if ((0, $7bfc6f913d3b5ac4$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    $41b69e38887ce9df$var$useEnhancedEffect(function() {
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    var handleFocus = function handleFocus(event) {
        // Fix a bug with IE 11 where the focus/blur events are triggered
        // while the input is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    var handleBlur = function handleBlur(event) {
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    var handleChange = function handleChange(event) {
        if (!isControlled) {
            var element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $3Oo4t.default)(1));
            checkDirty({
                value: element.value
            });
        }
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (inputPropsProp.onChange) inputPropsProp.onChange.apply(inputPropsProp, [
            event
        ].concat(args));
         // Perform in the willUpdate
        if (onChange) onChange.apply(void 0, [
            event
        ].concat(args));
    }; // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $Fo7oF.useEffect(function() {
        checkDirty(inputRef.current);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var handleClick = function handleClick(event) {
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    var InputComponent = inputComponent;
    var inputProps = (0, $elnlQ.default)({}, inputPropsProp, {
        ref: handleInputRef
    });
    if (typeof InputComponent !== 'string') inputProps = (0, $elnlQ.default)({
        // Rename ref to inputRef as we don't know the
        // provided `inputComponent` structure.
        inputRef: handleInputRef,
        type: type
    }, inputProps, {
        ref: null
    });
    else if (multiline) {
        if (rows && !maxRows && !minRows && !rowsMax && !rowsMin) InputComponent = 'textarea';
        else {
            inputProps = (0, $elnlQ.default)({
                minRows: rows || minRows,
                rowsMax: rowsMax,
                maxRows: maxRows
            }, inputProps);
            InputComponent = (0, $4f9a8a369d63f706$export$2e2bcd8739ae039);
        }
    } else inputProps = (0, $elnlQ.default)({
        type: type
    }, inputProps);
    var handleAutoFill = function handleAutoFill(event) {
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $Fo7oF.useEffect(function() {
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement("div", (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, classes["color".concat((0, $bT5dp.default)(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === 'dense' && classes.marginDense),
        onClick: handleClick,
        ref: ref
    }, other), startAdornment, /*#__PURE__*/ $Fo7oF.createElement((0, $8d9862aa244cad11$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $Fo7oF.createElement(InputComponent, (0, $elnlQ.default)({
        "aria-invalid": fcs.error,
        "aria-describedby": ariaDescribedby,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        disabled: fcs.disabled,
        id: id,
        onAnimationStart: handleAutoFill,
        name: name,
        placeholder: placeholder,
        readOnly: readOnly,
        required: fcs.required,
        rows: rows,
        value: value,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    }, inputProps, {
        className: (0, $78z8j.default)(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === 'search' && classes.inputTypeSearch, fcs.margin === 'dense' && classes.inputMarginDense),
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus
    }))), endAdornment, renderSuffix ? renderSuffix((0, $elnlQ.default)({}, fcs, {
        startAdornment: startAdornment
    })) : null);
});
var $41b69e38887ce9df$export$2e2bcd8739ae039 = (0, $5rVgt.default)($41b69e38887ce9df$export$9dd6ff9ea0189349, {
    name: 'MuiInputBase'
})($41b69e38887ce9df$var$InputBase);



var $5rVgt = parcelRequire("5rVgt");
var $38f814057e5cea08$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === 'light';
    var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative'
        },
        /* Styles applied to the root element if the component is a descendant of `FormControl`. */ formControl: {
            'label + &': {
                marginTop: 16
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            '&$underline:after': {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            '&:after': {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: 'absolute',
                right: 0,
                transform: 'scaleX(0)',
                transition: theme.transitions.create('transform', {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: 'none' // Transparent to the hover style.
            },
            '&$focused:after': {
                transform: 'scaleX(1)'
            },
            '&$error:after': {
                borderBottomColor: theme.palette.error.main,
                transform: 'scaleX(1)' // error is always underlined in red
            },
            '&:before': {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: 'absolute',
                right: 0,
                transition: theme.transitions.create('border-bottom-color', {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: 'none' // Transparent to the hover style.
            },
            '&:hover:not($disabled):before': {
                borderBottom: "2px solid ".concat(theme.palette.text.primary),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    borderBottom: "1px solid ".concat(bottomLineColor)
                }
            },
            '&$disabled:before': {
                borderBottomStyle: 'dotted'
            }
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {},
        /* Styles applied to the `input` element. */ input: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {},
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {},
        /* Styles applied to the `input` element if `type="search"`. */ inputTypeSearch: {}
    };
};
var $38f814057e5cea08$var$Input = /*#__PURE__*/ $Fo7oF.forwardRef(function Input(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, other = (0, $67mp8.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement((0, $41b69e38887ce9df$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        classes: (0, $elnlQ.default)({}, classes, {
            root: (0, $78z8j.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$38f814057e5cea08$var$Input.muiName = 'Input';
var $38f814057e5cea08$export$2e2bcd8739ae039 = (0, $5rVgt.default)($38f814057e5cea08$export$9dd6ff9ea0189349, {
    name: 'MuiInput'
})($38f814057e5cea08$var$Input);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");


var $bT5dp = parcelRequire("bT5dp");
/**
 * @ignore - internal component.
 */ var $3e8941cc13673022$var$NativeSelectInput = /*#__PURE__*/ $Fo7oF.forwardRef(function NativeSelectInput(props, ref) {
    var classes = props.classes, className = props.className, disabled = props.disabled, IconComponent = props.IconComponent, inputRef = props.inputRef, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $67mp8.default)(props, [
        "classes",
        "className",
        "disabled",
        "IconComponent",
        "inputRef",
        "variant"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement($Fo7oF.Fragment, null, /*#__PURE__*/ $Fo7oF.createElement("select", (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, classes.select, classes[variant], className, disabled && classes.disabled),
        disabled: disabled,
        ref: inputRef || ref
    }, other)), props.multiple ? null : /*#__PURE__*/ $Fo7oF.createElement(IconComponent, {
        className: (0, $78z8j.default)(classes.icon, classes["icon".concat((0, $bT5dp.default)(variant))], disabled && classes.disabled)
    }));
});
var $3e8941cc13673022$export$2e2bcd8739ae039 = $3e8941cc13673022$var$NativeSelectInput;



var $5rVgt = parcelRequire("5rVgt");




var $8d7a9f0163072876$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the select component `root` class. */ root: {},
        /* Styles applied to the select component `select` class. */ select: {
            '-moz-appearance': 'none',
            // Reset
            '-webkit-appearance': 'none',
            // Reset
            // When interacting quickly, the text can end up selected.
            // Native select can't be selected either.
            userSelect: 'none',
            borderRadius: 0,
            // Reset
            minWidth: 16,
            // So it doesn't collapse.
            cursor: 'pointer',
            '&:focus': {
                // Show that it's not an text input
                backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
                borderRadius: 0 // Reset Chrome style
            },
            // Remove IE 11 arrow
            '&::-ms-expand': {
                display: 'none'
            },
            '&$disabled': {
                cursor: 'default'
            },
            '&[multiple]': {
                height: 'auto'
            },
            '&:not([multiple]) option, &:not([multiple]) optgroup': {
                backgroundColor: theme.palette.background.paper
            },
            '&&': {
                paddingRight: 24
            }
        },
        /* Styles applied to the select component if `variant="filled"`. */ filled: {
            '&&': {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component if `variant="outlined"`. */ outlined: {
            borderRadius: theme.shape.borderRadius,
            '&&': {
                paddingRight: 32
            }
        },
        /* Styles applied to the select component `selectMenu` class. */ selectMenu: {
            height: 'auto',
            // Resets for multpile select with chips
            minHeight: '1.1876em',
            // Required for select\text-field height consistency
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden'
        },
        /* Pseudo-class applied to the select component `disabled` class. */ disabled: {},
        /* Styles applied to the icon component. */ icon: {
            // We use a position absolute over a flexbox in order to forward the pointer events
            // to the input and to support wrapping tags..
            position: 'absolute',
            right: 0,
            top: 'calc(50% - 12px)',
            // Center vertically
            pointerEvents: 'none',
            // Don't block pointer events on the select under the icon.
            color: theme.palette.action.active,
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the icon component if the popup is open. */ iconOpen: {
            transform: 'rotate(180deg)'
        },
        /* Styles applied to the icon component if `variant="filled"`. */ iconFilled: {
            right: 7
        },
        /* Styles applied to the icon component if `variant="outlined"`. */ iconOutlined: {
            right: 7
        },
        /* Styles applied to the underlying native input component. */ nativeInput: {
            bottom: 0,
            left: 0,
            position: 'absolute',
            opacity: 0,
            pointerEvents: 'none',
            width: '100%'
        }
    };
};
var $8d7a9f0163072876$var$defaultInput = /*#__PURE__*/ $Fo7oF.createElement((0, $38f814057e5cea08$export$2e2bcd8739ae039), null);
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */ var $8d7a9f0163072876$var$NativeSelect = /*#__PURE__*/ $Fo7oF.forwardRef(function NativeSelect(props, ref) {
    var children = props.children, classes = props.classes, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $8646bd5353849a70$export$2e2bcd8739ae039) : _props$IconComponent, _props$input = props.input, input = _props$input === void 0 ? $8d7a9f0163072876$var$defaultInput : _props$input, inputProps = props.inputProps, variant = props.variant, other = (0, $67mp8.default)(props, [
        "children",
        "classes",
        "IconComponent",
        "input",
        "inputProps",
        "variant"
    ]);
    var muiFormControl = (0, $da6b73123b6a85ad$export$2e2bcd8739ae039)();
    var fcs = (0, $13260d58a3dda9e0$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant'
        ]
    });
    return /*#__PURE__*/ $Fo7oF.cloneElement(input, (0, $elnlQ.default)({
        // Most of the logic is implemented in `NativeSelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: (0, $3e8941cc13673022$export$2e2bcd8739ae039),
        inputProps: (0, $elnlQ.default)({
            children: children,
            classes: classes,
            IconComponent: IconComponent,
            variant: fcs.variant,
            type: undefined
        }, inputProps, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$8d7a9f0163072876$var$NativeSelect.muiName = 'Select';
var $8d7a9f0163072876$export$2e2bcd8739ae039 = (0, $5rVgt.default)($8d7a9f0163072876$export$9dd6ff9ea0189349, {
    name: 'MuiNativeSelect'
})($8d7a9f0163072876$var$NativeSelect);




var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");



var $5rVgt = parcelRequire("5rVgt");
var $b6e922bb21e953ab$export$9dd6ff9ea0189349 = function styles(theme) {
    var light = theme.palette.type === 'light';
    var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            backgroundColor: backgroundColor,
            borderTopLeftRadius: theme.shape.borderRadius,
            borderTopRightRadius: theme.shape.borderRadius,
            transition: theme.transitions.create('background-color', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            '&:hover': {
                backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: backgroundColor
                }
            },
            '&$focused': {
                backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
            },
            '&$disabled': {
                backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
            }
        },
        /* Styles applied to the root element if color secondary. */ colorSecondary: {
            '&$underline:after': {
                borderBottomColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if `disableUnderline={false}`. */ underline: {
            '&:after': {
                borderBottom: "2px solid ".concat(theme.palette.primary.main),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '""',
                position: 'absolute',
                right: 0,
                transform: 'scaleX(0)',
                transition: theme.transitions.create('transform', {
                    duration: theme.transitions.duration.shorter,
                    easing: theme.transitions.easing.easeOut
                }),
                pointerEvents: 'none' // Transparent to the hover style.
            },
            '&$focused:after': {
                transform: 'scaleX(1)'
            },
            '&$error:after': {
                borderBottomColor: theme.palette.error.main,
                transform: 'scaleX(1)' // error is always underlined in red
            },
            '&:before': {
                borderBottom: "1px solid ".concat(bottomLineColor),
                left: 0,
                bottom: 0,
                // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
                content: '"\\00a0"',
                position: 'absolute',
                right: 0,
                transition: theme.transitions.create('border-bottom-color', {
                    duration: theme.transitions.duration.shorter
                }),
                pointerEvents: 'none' // Transparent to the hover style.
            },
            '&:hover:before': {
                borderBottom: "1px solid ".concat(theme.palette.text.primary)
            },
            '&$disabled:before': {
                borderBottomStyle: 'dotted'
            }
        },
        /* Pseudo-class applied to the root element if the component is focused. */ focused: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 12
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 12
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: '27px 12px 10px',
            '&$marginDense': {
                paddingTop: 23,
                paddingBottom: 6
            }
        },
        /* Styles applied to the `input` element. */ input: {
            padding: '27px 12px 10px',
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
                caretColor: theme.palette.type === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 23,
            paddingBottom: 6
        },
        /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */ inputHiddenLabel: {
            paddingTop: 18,
            paddingBottom: 19,
            '&$inputMarginDense': {
                paddingTop: 10,
                paddingBottom: 11
            }
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $b6e922bb21e953ab$var$FilledInput = /*#__PURE__*/ $Fo7oF.forwardRef(function FilledInput(props, ref) {
    var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, other = (0, $67mp8.default)(props, [
        "disableUnderline",
        "classes",
        "fullWidth",
        "inputComponent",
        "multiline",
        "type"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement((0, $41b69e38887ce9df$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        classes: (0, $elnlQ.default)({}, classes, {
            root: (0, $78z8j.default)(classes.root, !disableUnderline && classes.underline),
            underline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$b6e922bb21e953ab$var$FilledInput.muiName = 'Input';
var $b6e922bb21e953ab$export$2e2bcd8739ae039 = (0, $5rVgt.default)($b6e922bb21e953ab$export$9dd6ff9ea0189349, {
    name: 'MuiFilledInput'
})($b6e922bb21e953ab$var$FilledInput);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");



var $d2vKa = parcelRequire("d2vKa");

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");


var $bT5dp = parcelRequire("bT5dp");
var $af3ba4f801f35d2b$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            position: 'absolute',
            bottom: 0,
            right: 0,
            top: -5,
            left: 0,
            margin: 0,
            padding: '0 8px',
            pointerEvents: 'none',
            borderRadius: 'inherit',
            borderStyle: 'solid',
            borderWidth: 1,
            overflow: 'hidden'
        },
        /* Styles applied to the legend element when `labelWidth` is provided. */ legend: {
            textAlign: 'left',
            padding: 0,
            lineHeight: '11px',
            // sync with `height` in `legend` styles
            transition: theme.transitions.create('width', {
                duration: 150,
                easing: theme.transitions.easing.easeOut
            })
        },
        /* Styles applied to the legend element. */ legendLabelled: {
            display: 'block',
            width: 'auto',
            textAlign: 'left',
            padding: 0,
            height: 11,
            // sync with `lineHeight` in `legend` styles
            fontSize: '0.75em',
            visibility: 'hidden',
            maxWidth: 0.01,
            transition: theme.transitions.create('max-width', {
                duration: 50,
                easing: theme.transitions.easing.easeOut
            }),
            '& > span': {
                paddingLeft: 5,
                paddingRight: 5,
                display: 'inline-block'
            }
        },
        /* Styles applied to the legend element is notched. */ legendNotched: {
            maxWidth: 1000,
            transition: theme.transitions.create('max-width', {
                duration: 100,
                easing: theme.transitions.easing.easeOut,
                delay: 50
            })
        }
    };
};
/**
 * @ignore - internal component.
 */ var $af3ba4f801f35d2b$var$NotchedOutline = /*#__PURE__*/ $Fo7oF.forwardRef(function NotchedOutline(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, label = props.label, labelWidthProp = props.labelWidth, notched = props.notched, style = props.style, other = (0, $67mp8.default)(props, [
        "children",
        "classes",
        "className",
        "label",
        "labelWidth",
        "notched",
        "style"
    ]);
    var theme = (0, $c6db41e315144c8b$export$2e2bcd8739ae039)();
    var align = theme.direction === 'rtl' ? 'right' : 'left';
    if (label !== undefined) return /*#__PURE__*/ $Fo7oF.createElement("fieldset", (0, $elnlQ.default)({
        "aria-hidden": true,
        className: (0, $78z8j.default)(classes.root, className),
        ref: ref,
        style: style
    }, other), /*#__PURE__*/ $Fo7oF.createElement("legend", {
        className: (0, $78z8j.default)(classes.legendLabelled, notched && classes.legendNotched)
    }, label ? /*#__PURE__*/ $Fo7oF.createElement("span", null, label) : /*#__PURE__*/ $Fo7oF.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: '&#8203;'
        }
    })));
    var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
    return /*#__PURE__*/ $Fo7oF.createElement("fieldset", (0, $elnlQ.default)({
        "aria-hidden": true,
        style: (0, $elnlQ.default)((0, $d2vKa.default)({}, "padding".concat((0, $bT5dp.default)(align)), 8), style),
        className: (0, $78z8j.default)(classes.root, className),
        ref: ref
    }, other), /*#__PURE__*/ $Fo7oF.createElement("legend", {
        className: classes.legend,
        style: {
            // IE 11: fieldset with legend does not render
            // a border radius. This maintains consistency
            // by always having a legend rendered
            width: notched ? labelWidth : 0.01
        }
    }, /*#__PURE__*/ $Fo7oF.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: '&#8203;'
        }
    })));
});
var $af3ba4f801f35d2b$export$2e2bcd8739ae039 = (0, $5rVgt.default)($af3ba4f801f35d2b$export$9dd6ff9ea0189349, {
    name: 'PrivateNotchedOutline'
})($af3ba4f801f35d2b$var$NotchedOutline);



var $5rVgt = parcelRequire("5rVgt");
var $fdb477e77e9cf80d$export$9dd6ff9ea0189349 = function styles(theme) {
    var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            borderRadius: theme.shape.borderRadius,
            '&:hover $notchedOutline': {
                borderColor: theme.palette.text.primary
            },
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                '&:hover $notchedOutline': {
                    borderColor: borderColor
                }
            },
            '&$focused $notchedOutline': {
                borderColor: theme.palette.primary.main,
                borderWidth: 2
            },
            '&$error $notchedOutline': {
                borderColor: theme.palette.error.main
            },
            '&$disabled $notchedOutline': {
                borderColor: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if the color is secondary. */ colorSecondary: {
            '&$focused $notchedOutline': {
                borderColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the root element if the component is focused. */ focused: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `startAdornment` is provided. */ adornedStart: {
            paddingLeft: 14
        },
        /* Styles applied to the root element if `endAdornment` is provided. */ adornedEnd: {
            paddingRight: 14
        },
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Styles applied to the `input` element if `margin="dense"`. */ marginDense: {},
        /* Styles applied to the root element if `multiline={true}`. */ multiline: {
            padding: '18.5px 14px',
            '&$marginDense': {
                paddingTop: 10.5,
                paddingBottom: 10.5
            }
        },
        /* Styles applied to the `NotchedOutline` element. */ notchedOutline: {
            borderColor: borderColor
        },
        /* Styles applied to the `input` element. */ input: {
            padding: '18.5px 14px',
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
                caretColor: theme.palette.type === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        /* Styles applied to the `input` element if `margin="dense"`. */ inputMarginDense: {
            paddingTop: 10.5,
            paddingBottom: 10.5
        },
        /* Styles applied to the `input` element if `multiline={true}`. */ inputMultiline: {
            padding: 0
        },
        /* Styles applied to the `input` element if `startAdornment` is provided. */ inputAdornedStart: {
            paddingLeft: 0
        },
        /* Styles applied to the `input` element if `endAdornment` is provided. */ inputAdornedEnd: {
            paddingRight: 0
        }
    };
};
var $fdb477e77e9cf80d$var$OutlinedInput = /*#__PURE__*/ $Fo7oF.forwardRef(function OutlinedInput(props, ref) {
    var classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent, label = props.label, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, notched = props.notched, _props$type = props.type, type = _props$type === void 0 ? 'text' : _props$type, other = (0, $67mp8.default)(props, [
        "classes",
        "fullWidth",
        "inputComponent",
        "label",
        "labelWidth",
        "multiline",
        "notched",
        "type"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement((0, $41b69e38887ce9df$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        renderSuffix: function renderSuffix(state) {
            return /*#__PURE__*/ $Fo7oF.createElement((0, $af3ba4f801f35d2b$export$2e2bcd8739ae039), {
                className: classes.notchedOutline,
                label: label,
                labelWidth: labelWidth,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            });
        },
        classes: (0, $elnlQ.default)({}, classes, {
            root: (0, $78z8j.default)(classes.root, classes.underline),
            notchedOutline: null
        }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other));
});
$fdb477e77e9cf80d$var$OutlinedInput.muiName = 'Input';
var $fdb477e77e9cf80d$export$2e2bcd8739ae039 = (0, $5rVgt.default)($fdb477e77e9cf80d$export$9dd6ff9ea0189349, {
    name: 'MuiOutlinedInput'
})($fdb477e77e9cf80d$var$OutlinedInput);


var $96006197b33869f9$export$9dd6ff9ea0189349 = (0, $8d7a9f0163072876$export$9dd6ff9ea0189349);
var $96006197b33869f9$var$_ref = /*#__PURE__*/ $Fo7oF.createElement((0, $38f814057e5cea08$export$2e2bcd8739ae039), null);
var $96006197b33869f9$var$_ref2 = /*#__PURE__*/ $Fo7oF.createElement((0, $b6e922bb21e953ab$export$2e2bcd8739ae039), null);
var $96006197b33869f9$var$Select = /*#__PURE__*/ $Fo7oF.forwardRef(function Select(props, ref) {
    var _props$autoWidth = props.autoWidth, autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth, children = props.children, classes = props.classes, _props$displayEmpty = props.displayEmpty, displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $8646bd5353849a70$export$2e2bcd8739ae039) : _props$IconComponent, id = props.id, input = props.input, inputProps = props.inputProps, label = props.label, labelId = props.labelId, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, MenuProps = props.MenuProps, _props$multiple = props.multiple, multiple = _props$multiple === void 0 ? false : _props$multiple, _props$native = props.native, native = _props$native === void 0 ? false : _props$native, onClose = props.onClose, onOpen = props.onOpen, open = props.open, renderValue = props.renderValue, SelectDisplayProps = props.SelectDisplayProps, _props$variant = props.variant, variantProps = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $67mp8.default)(props, [
        "autoWidth",
        "children",
        "classes",
        "displayEmpty",
        "IconComponent",
        "id",
        "input",
        "inputProps",
        "label",
        "labelId",
        "labelWidth",
        "MenuProps",
        "multiple",
        "native",
        "onClose",
        "onOpen",
        "open",
        "renderValue",
        "SelectDisplayProps",
        "variant"
    ]);
    var inputComponent = native ? (0, $3e8941cc13673022$export$2e2bcd8739ae039) : (0, $aa7b33b5759b88de$export$2e2bcd8739ae039);
    var muiFormControl = (0, $da6b73123b6a85ad$export$2e2bcd8739ae039)();
    var fcs = (0, $13260d58a3dda9e0$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant'
        ]
    });
    var variant = fcs.variant || variantProps;
    var InputComponent = input || ({
        standard: $96006197b33869f9$var$_ref,
        outlined: /*#__PURE__*/ $Fo7oF.createElement((0, $fdb477e77e9cf80d$export$2e2bcd8739ae039), {
            label: label,
            labelWidth: labelWidth
        }),
        filled: $96006197b33869f9$var$_ref2
    })[variant];
    return /*#__PURE__*/ $Fo7oF.cloneElement(InputComponent, (0, $elnlQ.default)({
        // Most of the logic is implemented in `SelectInput`.
        // The `Select` component is a simple API wrapper to expose something better to play with.
        inputComponent: inputComponent,
        inputProps: (0, $elnlQ.default)({
            children: children,
            IconComponent: IconComponent,
            variant: variant,
            type: undefined,
            // We render a select. We can ignore the type provided by the `Input`.
            multiple: multiple
        }, native ? {
            id: id
        } : {
            autoWidth: autoWidth,
            displayEmpty: displayEmpty,
            labelId: labelId,
            MenuProps: MenuProps,
            onClose: onClose,
            onOpen: onOpen,
            open: open,
            renderValue: renderValue,
            SelectDisplayProps: (0, $elnlQ.default)({
                id: id
            }, SelectDisplayProps)
        }, inputProps, {
            classes: inputProps ? (0, $jOxwe.default)({
                baseClasses: classes,
                newClasses: inputProps.classes,
                Component: Select
            }) : classes
        }, input ? input.props.inputProps : {}),
        ref: ref
    }, other));
});
$96006197b33869f9$var$Select.muiName = 'Select';
var $96006197b33869f9$export$2e2bcd8739ae039 = (0, $5rVgt.default)($96006197b33869f9$export$9dd6ff9ea0189349, {
    name: 'MuiSelect'
})($96006197b33869f9$var$Select);



var $67mp8 = parcelRequire("67mp8");

var $d2vKa = parcelRequire("d2vKa");

var $elnlQ = parcelRequire("elnlQ");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");


var $5rVgt = parcelRequire("5rVgt");





var $bvYwR = parcelRequire("bvYwR");
var $621c589264f13158$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */ root: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            position: 'relative',
            textDecoration: 'none',
            width: '100%',
            boxSizing: 'border-box',
            textAlign: 'left',
            paddingTop: 8,
            paddingBottom: 8,
            '&$focusVisible': {
                backgroundColor: theme.palette.action.selected
            },
            '&$selected, &$selected:hover': {
                backgroundColor: theme.palette.action.selected
            },
            '&$disabled': {
                opacity: 0.5
            }
        },
        /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */ container: {
            position: 'relative'
        },
        /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */ focusVisible: {},
        /* Styles applied to the `component` element if dense. */ dense: {
            paddingTop: 4,
            paddingBottom: 4
        },
        /* Styles applied to the `component` element if `alignItems="flex-start"`. */ alignItemsFlexStart: {
            alignItems: 'flex-start'
        },
        /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the inner `component` element if `divider={true}`. */ divider: {
            borderBottom: "1px solid ".concat(theme.palette.divider),
            backgroundClip: 'padding-box'
        },
        /* Styles applied to the inner `component` element if `disableGutters={false}`. */ gutters: {
            paddingLeft: 16,
            paddingRight: 16
        },
        /* Styles applied to the inner `component` element if `button={true}`. */ button: {
            transition: theme.transitions.create('background-color', {
                duration: theme.transitions.duration.shortest
            }),
            '&:hover': {
                textDecoration: 'none',
                backgroundColor: theme.palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */ secondaryAction: {
            // Add some space to avoid collision as `ListItemSecondaryAction`
            // is absolutely positioned.
            paddingRight: 48
        },
        /* Pseudo-class applied to the root element if `selected={true}`. */ selected: {}
    };
};
var $621c589264f13158$var$useEnhancedEffect = typeof window === 'undefined' ? $Fo7oF.useEffect : $Fo7oF.useLayoutEffect;
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ var $621c589264f13158$var$ListItem = /*#__PURE__*/ $Fo7oF.forwardRef(function ListItem(props, ref) {
    var _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$button = props.button, button = _props$button === void 0 ? false : _props$button, childrenProp = props.children, classes = props.classes, className = props.className, componentProp = props.component, _props$ContainerCompo = props.ContainerComponent, ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo, _props$ContainerProps = props.ContainerProps;
    _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
    var ContainerClassName = _props$ContainerProps.className, ContainerProps = (0, $67mp8.default)(_props$ContainerProps, [
        "className"
    ]), _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$divider = props.divider, divider = _props$divider === void 0 ? false : _props$divider, focusVisibleClassName = props.focusVisibleClassName, _props$selected = props.selected, selected = _props$selected === void 0 ? false : _props$selected, other = (0, $67mp8.default)(props, [
        "alignItems",
        "autoFocus",
        "button",
        "children",
        "classes",
        "className",
        "component",
        "ContainerComponent",
        "ContainerProps",
        "dense",
        "disabled",
        "disableGutters",
        "divider",
        "focusVisibleClassName",
        "selected"
    ]);
    var context = $Fo7oF.useContext((0, $e072d90b3b716aaf$export$2e2bcd8739ae039));
    var childContext = {
        dense: dense || context.dense || false,
        alignItems: alignItems
    };
    var listItemRef = $Fo7oF.useRef(null);
    $621c589264f13158$var$useEnhancedEffect(function() {
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    var children = $Fo7oF.Children.toArray(childrenProp);
    var hasSecondaryAction = children.length && (0, $827a4e6aa58d6073$export$2e2bcd8739ae039)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    var handleOwnRef = $Fo7oF.useCallback(function(instance) {
        // #StrictMode ready
        listItemRef.current = $bvYwR.findDOMNode(instance);
    }, []);
    var handleRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(handleOwnRef, ref);
    var componentProps = (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
        disabled: disabled
    }, other);
    var Component = componentProp || 'li';
    if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, $78z8j.default)(classes.focusVisible, focusVisibleClassName);
        Component = (0, $67b46b5fd967aa2b$export$2e2bcd8739ae039);
    }
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ $Fo7oF.createElement((0, $e072d90b3b716aaf$export$2e2bcd8739ae039).Provider, {
            value: childContext
        }, /*#__PURE__*/ $Fo7oF.createElement(ContainerComponent, (0, $elnlQ.default)({
            className: (0, $78z8j.default)(classes.container, ContainerClassName),
            ref: handleRef
        }, ContainerProps), /*#__PURE__*/ $Fo7oF.createElement(Component, componentProps, children), children.pop()));
    }
    return /*#__PURE__*/ $Fo7oF.createElement((0, $e072d90b3b716aaf$export$2e2bcd8739ae039).Provider, {
        value: childContext
    }, /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        ref: handleRef
    }, componentProps), children));
});
var $621c589264f13158$export$2e2bcd8739ae039 = (0, $5rVgt.default)($621c589264f13158$export$9dd6ff9ea0189349, {
    name: 'MuiListItem'
})($621c589264f13158$var$ListItem);


var $404ed5acf13336e9$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $elnlQ.default)({}, theme.typography.body1, (0, $d2vKa.default)({
            minHeight: 48,
            paddingTop: 6,
            paddingBottom: 6,
            boxSizing: 'border-box',
            width: 'auto',
            overflow: 'hidden',
            whiteSpace: 'nowrap'
        }, theme.breakpoints.up('sm'), {
            minHeight: 'auto'
        })),
        // TODO v5: remove
        /* Styles applied to the root element if `disableGutters={false}`. */ gutters: {},
        /* Styles applied to the root element if `selected={true}`. */ selected: {},
        /* Styles applied to the root element if dense. */ dense: (0, $elnlQ.default)({}, theme.typography.body2, {
            minHeight: 'auto'
        })
    };
};
var $404ed5acf13336e9$var$MenuItem = /*#__PURE__*/ $Fo7oF.forwardRef(function MenuItem(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? 'li' : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, ListItemClasses = props.ListItemClasses, _props$role = props.role, role = _props$role === void 0 ? 'menuitem' : _props$role, selected = props.selected, tabIndexProp = props.tabIndex, other = (0, $67mp8.default)(props, [
        "classes",
        "className",
        "component",
        "disableGutters",
        "ListItemClasses",
        "role",
        "selected",
        "tabIndex"
    ]);
    var tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ $Fo7oF.createElement((0, $621c589264f13158$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        button: true,
        role: role,
        tabIndex: tabIndex,
        component: component,
        selected: selected,
        disableGutters: disableGutters,
        classes: (0, $elnlQ.default)({
            dense: classes.dense
        }, ListItemClasses),
        className: (0, $78z8j.default)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
        ref: ref
    }, other));
});
var $404ed5acf13336e9$export$2e2bcd8739ae039 = (0, $5rVgt.default)($404ed5acf13336e9$export$9dd6ff9ea0189349, {
    name: 'MuiMenuItem'
})($404ed5acf13336e9$var$MenuItem);



var $67mp8 = parcelRequire("67mp8");

var $elnlQ = parcelRequire("elnlQ");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");


var $c94ade5afe509790$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $c94ade5afe509790$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
function $c94ade5afe509790$var$generateGrid(globalStyles, theme, breakpoint) {
    var styles = {};
    $c94ade5afe509790$var$GRID_SIZES.forEach(function(size) {
        var key = "grid-".concat(breakpoint, "-").concat(size);
        if (size === true) {
            // For the auto layouting
            styles[key] = {
                flexBasis: 0,
                flexGrow: 1,
                maxWidth: '100%'
            };
            return;
        }
        if (size === 'auto') {
            styles[key] = {
                flexBasis: 'auto',
                flexGrow: 0,
                maxWidth: 'none'
            };
            return;
        } // Keep 7 significant numbers.
        var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
        // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
        styles[key] = {
            flexBasis: width,
            flexGrow: 0,
            maxWidth: width
        };
    }); // No need for a media query for the first size.
    if (breakpoint === 'xs') (0, $elnlQ.default)(globalStyles, styles);
    else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
}
function $c94ade5afe509790$var$getOffset(val) {
    var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var parse = parseFloat(val);
    return "".concat(parse / div).concat(String(val).replace(String(parse), '') || 'px');
}
function $c94ade5afe509790$var$generateGutter(theme, breakpoint) {
    var styles = {};
    $c94ade5afe509790$var$SPACINGS.forEach(function(spacing) {
        var themeSpacing = theme.spacing(spacing);
        if (themeSpacing === 0) return;
        styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
            margin: "-".concat($c94ade5afe509790$var$getOffset(themeSpacing, 2)),
            width: "calc(100% + ".concat($c94ade5afe509790$var$getOffset(themeSpacing), ")"),
            '& > $item': {
                padding: $c94ade5afe509790$var$getOffset(themeSpacing, 2)
            }
        };
    });
    return styles;
} // Default CSS values
var $c94ade5afe509790$export$9dd6ff9ea0189349 = function styles(theme) {
    return (0, $elnlQ.default)({
        /* Styles applied to the root element. */ root: {},
        /* Styles applied to the root element if `container={true}`. */ container: {
            boxSizing: 'border-box',
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%'
        },
        /* Styles applied to the root element if `item={true}`. */ item: {
            boxSizing: 'border-box',
            margin: '0' // For instance, it's useful when used with a `figure` element.
        },
        /* Styles applied to the root element if `zeroMinWidth={true}`. */ zeroMinWidth: {
            minWidth: 0
        },
        /* Styles applied to the root element if `direction="column"`. */ 'direction-xs-column': {
            flexDirection: 'column'
        },
        /* Styles applied to the root element if `direction="column-reverse"`. */ 'direction-xs-column-reverse': {
            flexDirection: 'column-reverse'
        },
        /* Styles applied to the root element if `direction="row-reverse"`. */ 'direction-xs-row-reverse': {
            flexDirection: 'row-reverse'
        },
        /* Styles applied to the root element if `wrap="nowrap"`. */ 'wrap-xs-nowrap': {
            flexWrap: 'nowrap'
        },
        /* Styles applied to the root element if `wrap="reverse"`. */ 'wrap-xs-wrap-reverse': {
            flexWrap: 'wrap-reverse'
        },
        /* Styles applied to the root element if `alignItems="center"`. */ 'align-items-xs-center': {
            alignItems: 'center'
        },
        /* Styles applied to the root element if `alignItems="flex-start"`. */ 'align-items-xs-flex-start': {
            alignItems: 'flex-start'
        },
        /* Styles applied to the root element if `alignItems="flex-end"`. */ 'align-items-xs-flex-end': {
            alignItems: 'flex-end'
        },
        /* Styles applied to the root element if `alignItems="baseline"`. */ 'align-items-xs-baseline': {
            alignItems: 'baseline'
        },
        /* Styles applied to the root element if `alignContent="center"`. */ 'align-content-xs-center': {
            alignContent: 'center'
        },
        /* Styles applied to the root element if `alignContent="flex-start"`. */ 'align-content-xs-flex-start': {
            alignContent: 'flex-start'
        },
        /* Styles applied to the root element if `alignContent="flex-end"`. */ 'align-content-xs-flex-end': {
            alignContent: 'flex-end'
        },
        /* Styles applied to the root element if `alignContent="space-between"`. */ 'align-content-xs-space-between': {
            alignContent: 'space-between'
        },
        /* Styles applied to the root element if `alignContent="space-around"`. */ 'align-content-xs-space-around': {
            alignContent: 'space-around'
        },
        /* Styles applied to the root element if `justifyContent="center"`. */ 'justify-content-xs-center': {
            justifyContent: 'center'
        },
        /* Styles applied to the root element if `justifyContent="flex-end"`. */ 'justify-content-xs-flex-end': {
            justifyContent: 'flex-end'
        },
        /* Styles applied to the root element if `justifyContent="space-between"`. */ 'justify-content-xs-space-between': {
            justifyContent: 'space-between'
        },
        /* Styles applied to the root element if `justifyContent="space-around"`. */ 'justify-content-xs-space-around': {
            justifyContent: 'space-around'
        },
        /* Styles applied to the root element if `justifyContent="space-evenly"`. */ 'justify-content-xs-space-evenly': {
            justifyContent: 'space-evenly'
        }
    }, $c94ade5afe509790$var$generateGutter(theme, 'xs'), theme.breakpoints.keys.reduce(function(accumulator, key) {
        // Use side effect over immutability for better performance.
        $c94ade5afe509790$var$generateGrid(accumulator, theme, key);
        return accumulator;
    }, {}));
};
var $c94ade5afe509790$var$Grid = /*#__PURE__*/ $Fo7oF.forwardRef(function Grid(props, ref) {
    var _props$alignContent = props.alignContent, alignContent = _props$alignContent === void 0 ? 'stretch' : _props$alignContent, _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? 'stretch' : _props$alignItems, classes = props.classes, classNameProp = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$container = props.container, container = _props$container === void 0 ? false : _props$container, _props$direction = props.direction, direction = _props$direction === void 0 ? 'row' : _props$direction, _props$item = props.item, item = _props$item === void 0 ? false : _props$item, justify = props.justify, _props$justifyContent = props.justifyContent, justifyContent = _props$justifyContent === void 0 ? 'flex-start' : _props$justifyContent, _props$lg = props.lg, lg = _props$lg === void 0 ? false : _props$lg, _props$md = props.md, md = _props$md === void 0 ? false : _props$md, _props$sm = props.sm, sm = _props$sm === void 0 ? false : _props$sm, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 0 : _props$spacing, _props$wrap = props.wrap, wrap = _props$wrap === void 0 ? 'wrap' : _props$wrap, _props$xl = props.xl, xl = _props$xl === void 0 ? false : _props$xl, _props$xs = props.xs, xs = _props$xs === void 0 ? false : _props$xs, _props$zeroMinWidth = props.zeroMinWidth, zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth, other = (0, $67mp8.default)(props, [
        "alignContent",
        "alignItems",
        "classes",
        "className",
        "component",
        "container",
        "direction",
        "item",
        "justify",
        "justifyContent",
        "lg",
        "md",
        "sm",
        "spacing",
        "wrap",
        "xl",
        "xs",
        "zeroMinWidth"
    ]);
    var className = (0, $78z8j.default)(classes.root, classNameProp, container && [
        classes.container,
        spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]
    ], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== 'row' && classes["direction-xs-".concat(String(direction))], wrap !== 'wrap' && classes["wrap-xs-".concat(String(wrap))], alignItems !== 'stretch' && classes["align-items-xs-".concat(String(alignItems))], alignContent !== 'stretch' && classes["align-content-xs-".concat(String(alignContent))], (justify || justifyContent) !== 'flex-start' && classes["justify-content-xs-".concat(String(justify || justifyContent))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
    return /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        className: className,
        ref: ref
    }, other));
});
var $c94ade5afe509790$var$StyledGrid = (0, $5rVgt.default)($c94ade5afe509790$export$9dd6ff9ea0189349, {
    name: 'MuiGrid'
})($c94ade5afe509790$var$Grid);
var $c94ade5afe509790$var$requireProp;
var $c94ade5afe509790$export$2e2bcd8739ae039 = $c94ade5afe509790$var$StyledGrid;



var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");

var $830464d107593492$exports = {};
$830464d107593492$exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAl8AAACWCAMAAADXGR16AAAABGdBTUEAALGPC%2FxhBQAAACBjSFJNAAB6JQAAgIMAAPn%2FAACA6QAAdTAAAOpgAAA6mAAAF2%2BSX8VGAAAACXBIWXMAAC4jAAAuIwF4pT92AAABWWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI%2BCiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24%2BCiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY%2BCjwveDp4bXBtZXRhPgpMwidZAAAAY1BMVEUAAAAzdzM6eyk2fSs1fS03eyo2eys3fCw2fCo1fSs3eys2fCw1fCs2fCs2eys2fCv%2F3gDy1wLl0QXZywjMxQrAvw2zuRCnsxKarRWNphiBoBp0mh1olCBbjiJPiCVCgig2fCsEbGHrAAAAEHRSTlMADx8vP09fb3%2BPn6%2B%2Fz9%2Fv%2Bt8hjgAAEmRJREFUeNrs2s2WojAQBWD8GURasQIhhJCQ%2B%2F5PORkbkLaVI3Yv5pzUtxFZwII6dUmRhLH%2Fz36%2FT7O5NJxJGPuR7f6QfZwueOZy%2BsgO%2B23C2Er7Q37Cq075gbsZe9E2PZ6x3jlPuZOxZZs0L%2FC%2BgmuMPbXLzvjOWaO1klJWNKrCP6W1sQ7fnY%2B7hLE7u2OBr7zVjSxpmZCNtj2%2BKrjE2FJx%2BU5LQa8TUneeS4w9sknPmOmNKumOlLLRc004Q3dKZXrMnA%2BbhMVul19w0zUVzVRSt9bhGWdbLSuaKZsOMzmPLeKWnjDxphY0kY1xeI0zjaSb2nhMzmnCIrVJC0xMTSNRtxZrubYWD0usyDgmo5RdMHJK0EC2Du9yraSBUBajyyFh0dli4NtyalzG42d8N5Vq2XoMeOganyOu%2BqkeVIff0d0u6XCVJSw2BQIr6ZM0Hr%2FHm%2Bm6FkGRsMj8QeDoSjQ9lmmHlfpG0FWPgOcUsckRKArKF1qXJo3VTEVBgyBPWFQ2QCCIhMUrKlJYzwoigeCSsKikCLqhvTzT1XY6JNJYTxFRh%2BBPwmLygaAmIrdcHrLHp5Kox2qOiBQHZHQ2CDwRlVikSLjxiBTWKzkgY5QiMETUYpEvxwJriQTWazggY5SP8dhjmSESHoElIssByV5yGVaPFR7pa9nO3rvU0L%2BofTMgecQamf24etR4TBMpP60A%2FfCr3wxIh4D3s8Yjuz35J5ygysPquiSiStamfLO%2B7DgD4U0U8TgNyVXiqZaopDsa600pfEpYJDYIelqaOPSKvmvxhnoIWCQsEvtxOmHwhBb0j1S6tVYrQVcWK4336fgbd0yy24v7Q666bpJ2GPm%2F7Z3pmrI6DIBb1rIW9w0193%2BVZxaJTg6EFqp8M%2FL%2BmkedRs3bUkMp66rCl1vQjJO7eRHYO9FMv1bQynGx2J6oJFjrtwUDZSNH3F%2B7VFFBNzpPVfDXLlCAD67d06%2FDCSjX20qb82m%2FWVVn63Pc8IGe%2Ffriz%2B%2Bp4DfVr6PVJKpqLqk9ghWHZubmzX51U0Z%2FZhSLbhVU4wURl%2BOyQhZHsOPcVDbC2S8O%2FQs%2FWveVHWvmfDW3XcDqDLZUVbWBD9TsF0%2F5N35i57ey5xr6OO9WDkqs69tPg3z2q49E%2FAH0bcK%2BN7vMDAeu%2BrC%2FwAB2twl%2BOfvVS%2FH7Z2GyOS145OUaX7ynE%2FzZr3cQLMCcszUryhmGgi4H7%2B5XkRPKPyhYhMesbjYVZQGDwWNx%2BDy%2F%2FEil%2BTeZigIxFbxfQdtG3Rnc%2BQsLARTOubs5LSrCBpAJfkCyfnlxBpQ89tp2o2rwRTt%2B3hCJb%2FLe%2F0nyBju%2F6D5GiKLvlych75wFPxRDGvsdH5HHf7h0aFVVa5NNvZADDGd9C5Y8w68gg3byiEm0cZz%2BA1cODdZ%2BIZGGB3yriVtO3jkLfigenXjkIxoQPLwYzw6xnDdVQw3D2dwOxrl7v4KcrSe58QsFc%2B4XIjNizFR%2BIYkc6FdJyhP8yNMAI9jf%2Fr9w7ZdMgCeTDv2CzKVflJRkamq%2FoJDD%2FCLlCY66auBWul5N%2FDrDB479kgX0UfoO%2FYLUmV%2B8YPm0fqFgo%2FyqzYcvdrK2XXCmYjT3fvka%2BtG%2BQ79AufSLUgDiTekXklv7hYtXjfy6VMgOOrmuqu3VzC%2Fp0i%2BpwQTtO%2FQLoif65QOSTOoXEg31a2%2B0GnVXIXten9XVaAVF4NKvAswopUO%2FIHTkF3%2BELP4Nv8oxfkEvS94vZNsn2BP8ol9%2BFgcSK5b651Mu%2FdL%2B8%2FzyAJFM4Z%2BQkHeucwb6ocqcQnoT%2BYj99a%2FQ2K9zZejXpULBXuaXBw9oJbmKZeDILxTMvV90SA4N%2FxEJbOr%2FwJarlYaGpP8jUhRWpAwOj8i2dwn0ysCv0J1feUsVoqtyUbj0C0rpxC%2F%2BlWoav%2BgPp3ygX2viQ%2B9J7iVwnHqGuEZQ5cwvr2vOjURwJ3DpFxTSvV80fDalXyKBhuF%2BraGHi8XCwuqTC2fq2q1fCZBHWMEyp35B%2Fiy%2F5D3EpH4Fr%2FDraLH%2Ba80fQ9fO%2FSoNvs4MEOnUL0id%2B0WjlX%2FfL7pDwHJfX%2BGDc%2F1BayH28jK%2FfEA8k59j4Xi%2F8hTuJM%2F2Cyb1K3yFX6uqj9V6vT%2FUF%2FTr8DK%2FYmjIjOpJyoFfIqNzPvd%2B5f%2BGX%2Bkr%2FKpMWWwO3y5uX%2BZXShPd0w1zkuhUtZNyfsmCCOberxIaTN6v1%2FoNlaqNwMKvCDp%2FP6pWhvhVV5Ys9i85PpIP7JlNZ0zr4ZxfPwTT%2FiuOjwykuQB4lKlfXpgCfToHniF%2BnSo7DoA8368S02xYr3Til%2FA1Eew183v3fpniPc%2BvfWUFX1917ZfhZCN36hcRrJTO%2FfJ%2FRJver1wM9YupmF7q%2BvMG7svKkh100jwb%2F3a%2FRETqrM78Iq2n%2F4Rf3gC%2F4u7Lhy4nvF37EOr%2B84%2B%2F3q8fguVO%2FaI%2FeKf3KxZ2frHrJ07bZTWO9Tv4JVK4kzr2Sz%2B8cnq%2FUuHOr%2FOiQpwPYFfnfmk2p0jp3C8qmFO%2FIkDE9H7FYpxfF3KycTybURdwu69PSGjQ7vwiZTCXft0bzib3K%2FfFML%2B8pvhQk23EHXB51vp75bi%2BGgftxP1%2BUcHc%2BRUDEhm9X9nqVxG04dn4VSZ%2BxzwjaEU8ghlvKXct6%2BN%2Bu64QNzWw4xi%2FiE8hSUX%2BuvNDiKfhju%2FKL1%2BT4fYl54eQBO5k%2FDyWB1fEUwk%2BOcEn9R4dc1ADw9X%2BWgxFk2%2FaAyR41fntdhVAl%2BP9oqOieplf5G02xCP8KvAXXcty1cUVvrkeN5U9V2YDMPaTm0986cy9MFifo4Vbv0QIhNF%2BeQUgWr7YL7QI8Yf7leOWI4QtVklRsUVlx%2BkpGxjKklnqDGn%2FdCZ17ZeIHPsVajJ6TOCXJCcnBvqVdJ4g2v5fkRPZIXOx3uz3p%2FqbTUXZQhurcaeHZPb%2FhVeS3VSSGuA590sk7vyiu2jk4uV%2BYRtIxvg1%2BAKP%2FadBZ1q9qo%2F7Lw51DVRIwnLU8ntftBEUdNym%2Bc081klIhXu%2FROrKLxnl8Ij2JvALAyJqqF8hc4HtEa80M2NlssvhxbS8mussJq%2Fxfn75JRnMyXZC5BKrBs%2BlX0gx3q8giJMCCKGYzC%2BRwZ1gmF%2F8BgGnhZVg15XBSe66Oep6Rqs3i1zdSPISfhJ1TrGLJAzEJ36oClpafIpfsrDwi4d%2BxNftz9Q90wVtvX8OKYAdoIXz8kOwi7lg5BC5uNpvn2P%2BMQruAMV%2F%2F%2B79ElI%2Fwa9ITOmX8EnDQ%2FwqcU5EwHulLU5gzK5vho9zvWKwX%2FyvZp5CuvYL8bVrv3QopvVLxHBHDfILN8hcMSsLN2cwpV5Wj6wvXVc%2FpmP9iugBykov936JwLFfuScm8Iufgtn7hT8gWWNWuwuYcT0sf67DJ08bX72dm%2Bhld4jMpHDpFyVy6ZeOhZjYLzoF84b4FfZugH%2Fd4elqM34W%2B5dHQB6mesEov3TElCX5jLn3C1HO%2FNJKisn9olOwYohfErPec9BbgzmXH4PYum6Z3svhfmGNiyJT6Cb1hHO%2FKKkbv4pICjGJX%2FygnAzwS5TkDFHnEHYAG8675YNhV7ixxun9cL9S5ix2oqENjXa59YuSj%2FarTCNPIBP7RftMOMCvzOgGfec1VhuGKIbyVqbTexHlZfvXLwVLmBRA%2FycUju%2BvkHSevcobOj9WJ0pFgRSUF95foesjIZnN%2FRXoJR5nYDktt2DN%2BbD6ca67bqr3kTDBD2KlkttnI18%2Fgwzi238lKv5zN7T%2BZeANkg%2FQwwWGcNk%2FlFr399sjz7wJzR0gN%2FAkjvdS6wrv%2FjjzLmQ4736qYPWjxqmYeReipgJ2gmexu63WOTaH4UjMvAteswZ%2FC09j8z2v3zR12nnO%2FUYUt%2FOCC3ga18%2FmL7C4LTosxMz7kDSHsBM8BRwfT1VV7X7pfY1nBuM%2F%2BQCJlYlVU2XzxcwbUbo8QPKrp5dzdeL9eMUBEs73JdOJmHkn8AC5gSeyq%2BbD45vSHCCrbQ1OobfvXs2Hx3ckuZVYP1gf4RkcHzbFj8XMe%2BHBB5dl9cVidwG3XPa3ppfX%2Bdz2W1LgIPPF6ngFV1wfWr0tgZt5NyL4pt7iikAXiuHGO83Ubj73%2BJ5I3XL9z%2BZwgTFcDijXco9NaTHzfngpIOftAr3Yna4whOtph54utjUg6Tz7ek%2Bk0oCc7opVq93xDDZcjg%2F7OC02J0C0mu16X2RUdm6Bv94d6yv0ca2Pu%2FWiQhbbE9wpo3lZTgvBF%2B%2FR8YL059UZ6%2F%2FvJ1fXl%2Fa7yGy%2BzULW%2BzO5qswaPzBB3l%2BLAnvBNwbtez3hfUFxFcSLkhyQMletLUk%2BhsQvoQPy9MTIqIBH6n2jDVGtof3ZfQ2PFLEU5lhv1YKvDejVgnF%2F%2B6pTH41bExFIEGUbBL9oim7phQG%2F11ba9x7wO%2FpX8JKS3ooIJWNAtY5nZgP1F%2FsF0XC%2FUmZP1%2BFB6GyXUkZWfnmNmfLX%2BPWBrwpo2Rlzw9xIbbne7FvmaAXKNY1fEA71y2NuC0KDRJZBIg3dFL6FXyncUL%2FJrw%2B8ONPQRl3Xh%2F0jB7zFOyWLMTWT%2BaX9gX6l0JD2%2BgWmQeh%2BsGWqwuCTUGUlNCgDv2gn0N7v8uuTQOUwFJytjvUrVz14XX5pFMzWL8xczgxgQ4PIopEr9kiXLtFo6hfXCfISPkh%2Fn1%2Bf%2BHFagB1FGgfCBZgani6%2FkgKnJlz7TOZK0ZU6DKJuQTzDIKhXGYj%2FE5YoGPGL6QRBBJ94v9KvL4IYt9dlKfME1ZreL3VLZSHZ9pnMRYJJ3cAgBT9fUkQw1q8MPsjFrRf8Xr%2B%2B8b%2F3DSmAUnzvJOILwtR%2BCU9j7pn2meGLSR0GkaVNkIT%2FRYDb5IUGfgU3d5pe8Mv9aqsteoJhar9w193Utn0fJWBSR4LkJkH8Hr3QGi15v7DpXGAv%2BEN%2BIf%2B2X00%2BU4v28ZlSdKWOBtHGQXKDimyMr%2BH9wuELe8Hs14v9wqVtiVX7wcMgE7UUIDqCpHwQbLgQPGg37xcOX9gLZr9e7RfmPmLa5xNc0oPfiCCpUbY93OEX%2FeKHLxzAZr9e6Rc7o8b22eELUxewfgllFEQarhBXEX0z%2FPCFA9js18v9wkq8z7TPDF8tAxgTJGSDhCihKegXP3xhL5j9erFf%2BBxo36x9HL741NEgaV8QHErleL%2Fo8IW9YPZrAr9kgbln2qfDF5s6%2ByD4dyFG%2B4XSR%2FSBYPbr9X4JrLFz7dPhi0kdF6RkgsAniRO%2FyqYTkF4w%2B2XpV5l3Y%2BqX8DURjPGrwMz1pI4G8TAI61c80C9%2B%2BMJeMPtl4xePqV%2Bkxs75hZnjUscHKWRHEB%2BbsfaLGb5IL5j9er1fmCZIGb9I5pjUdQXx%2BSDBOL%2F4ToC9YPZrCr%2Bwxs75RTPHP8oHce8X3wmwF8x%2BTeEX3o01ZvyimeMfVp16gnLtF6c7HcBmv176%2B5GueI5I%2B72Zo4%2BzQRIM4nz%2BxduOjxezX1P4RWvs2D6TOfYJPkjUFsSRXzFRmPaC2a9p%2FBJYAiXtMwlinlFMeRagLYjGv8f4JTVxnfaC2a8p%2FKI1dmyf5kcHbZCkWgfBv7MxfmFcSIIWEvgkmv2axC%2B8YbmW7e0r6CNi%2FKKCee3nH%2FVIv6SGHsrZrwn8IiVQbJ%2FJHJ86%2ByAhzv96kIxfCnqJZr%2Bm8IvmnravwCh1I4Jos%2FVfkVaS%2BGXTCaCc%2FZrKLyyBYvtWmQMte%2F1CKSC3Xr%2BKb0Qrr90vBQZEs19T%2BYWCYftk3qy6SAFfPzSIj0ssODIMhH6RTlCoTsqvCLNfE%2FmFHkFC2pf8wQt%2FXUqjIPFNMBIkb7RjSADj%2FN8vxfuChZTZr8n8whIotk8yx6dOjQniQa9gEVaBW%2FzysBP09YLZr6n8wtxjuZMZvpjUWQWh1%2F9L5t%2FQQOIXmcDxvWD2azq%2FZAEN%2BKqEJIJJHR8EaQmCkyso2iN5xe1p2eqXB6QTML1g9msSv6hgiskckzr7IPTR1O%2FYJh71on7R4YvvBbNfk%2FhFaxGKyRyTOqMgJQlCtCti%2F1GuKAOqF%2FrFdQK%2BF3y7rHje86YqLv2i%2BBpTz2SOSZ19ECSFO3mmPvmx%2F1UmBfWL6wR8L4Ae3vimUE79oviYeiZzTOrMgmgMQraR60bHLaVam06AvWD2a0K%2FcKmpeeYwdeCZBgkB7PaPxjNDxC%2BLToC9YPZrIr9oFjBzpqlLrYNQJM62uBsFoF9MJ2AGsNmvEffXQLru3%2BGZtx98YX4%2FF39IEIoMk1xDg86TyGPv3%2BGZ7%2BjnBfh1BCbMt0T%2Fs3z7M9%2BaaWbGiv8A66Oz1I08NNoAAAAASUVORK5CYII%3D";


var $a4d1b927fd6b4dd7$exports = {};

$parcel$export($a4d1b927fd6b4dd7$exports, "root", () => $a4d1b927fd6b4dd7$export$e8e78c978b129247, (v) => $a4d1b927fd6b4dd7$export$e8e78c978b129247 = v);
$parcel$export($a4d1b927fd6b4dd7$exports, "bars", () => $a4d1b927fd6b4dd7$export$60912654947077e3, (v) => $a4d1b927fd6b4dd7$export$60912654947077e3 = v);
$parcel$export($a4d1b927fd6b4dd7$exports, "link", () => $a4d1b927fd6b4dd7$export$9c30223ca0a664fb, (v) => $a4d1b927fd6b4dd7$export$9c30223ca0a664fb = v);
$parcel$export($a4d1b927fd6b4dd7$exports, "green", () => $a4d1b927fd6b4dd7$export$955a2ebd2fb142ae, (v) => $a4d1b927fd6b4dd7$export$955a2ebd2fb142ae = v);
$parcel$export($a4d1b927fd6b4dd7$exports, "yellow", () => $a4d1b927fd6b4dd7$export$594c5a8758200c32, (v) => $a4d1b927fd6b4dd7$export$594c5a8758200c32 = v);
$parcel$export($a4d1b927fd6b4dd7$exports, "image", () => $a4d1b927fd6b4dd7$export$5c452ff88e35e47d, (v) => $a4d1b927fd6b4dd7$export$5c452ff88e35e47d = v);
var $a4d1b927fd6b4dd7$export$e8e78c978b129247;
var $a4d1b927fd6b4dd7$export$60912654947077e3;
var $a4d1b927fd6b4dd7$export$9c30223ca0a664fb;
var $a4d1b927fd6b4dd7$export$955a2ebd2fb142ae;
var $a4d1b927fd6b4dd7$export$594c5a8758200c32;
var $a4d1b927fd6b4dd7$export$5c452ff88e35e47d;
$a4d1b927fd6b4dd7$export$e8e78c978b129247 = "root_bc2ecc";
$a4d1b927fd6b4dd7$export$60912654947077e3 = "bars_bc2ecc";
$a4d1b927fd6b4dd7$export$9c30223ca0a664fb = "link_bc2ecc";
$a4d1b927fd6b4dd7$export$955a2ebd2fb142ae = "green_bc2ecc";
$a4d1b927fd6b4dd7$export$594c5a8758200c32 = "yellow_bc2ecc";
$a4d1b927fd6b4dd7$export$5c452ff88e35e47d = "image_bc2ecc";


function $9d6b5b5c04a4d1e6$export$36f2c31d1240b26b({ className: className, style: style, bars: bars, component: Component }) {
    Component = Component || (0, $5a9c912afef4aac7$export$a6c7ac8248d6e38a);
    return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a4d1b927fd6b4dd7$exports))).root} ${className}`,
        style: style,
        children: [
            bars && /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a4d1b927fd6b4dd7$exports))).bars,
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a4d1b927fd6b4dd7$exports))).green
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a4d1b927fd6b4dd7$exports))).yellow
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)(Component, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a4d1b927fd6b4dd7$exports))).link,
                to: "/",
                children: /*#__PURE__*/ (0, $eFTP6.jsx)("img", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a4d1b927fd6b4dd7$exports))).image,
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($830464d107593492$exports)))
                })
            })
        ]
    });
}



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");


var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");


var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");

var $8Hh6N = parcelRequire("8Hh6N");
var $b04338db8f46de7f$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            height: 1,
            margin: 0,
            // Reset browser default style.
            border: 'none',
            flexShrink: 0,
            backgroundColor: theme.palette.divider
        },
        /* Styles applied to the root element if `absolute={true}`. */ absolute: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%'
        },
        /* Styles applied to the root element if `variant="inset"`. */ inset: {
            marginLeft: 72
        },
        /* Styles applied to the root element if `light={true}`. */ light: {
            backgroundColor: (0, $8Hh6N.alpha)(theme.palette.divider, 0.08)
        },
        /* Styles applied to the root element if `variant="middle"`. */ middle: {
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2)
        },
        /* Styles applied to the root element if `orientation="vertical"`. */ vertical: {
            height: '100%',
            width: 1
        },
        /* Styles applied to the root element if `flexItem={true}`. */ flexItem: {
            alignSelf: 'stretch',
            height: 'auto'
        }
    };
};
var $b04338db8f46de7f$var$Divider = /*#__PURE__*/ $Fo7oF.forwardRef(function Divider(props, ref) {
    var _props$absolute = props.absolute, absolute = _props$absolute === void 0 ? false : _props$absolute, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'hr' : _props$component, _props$flexItem = props.flexItem, flexItem = _props$flexItem === void 0 ? false : _props$flexItem, _props$light = props.light, light = _props$light === void 0 ? false : _props$light, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation, _props$role = props.role, role = _props$role === void 0 ? Component !== 'hr' ? 'separator' : undefined : _props$role, _props$variant = props.variant, variant = _props$variant === void 0 ? 'fullWidth' : _props$variant, other = (0, $67mp8.default)(props, [
        "absolute",
        "classes",
        "className",
        "component",
        "flexItem",
        "light",
        "orientation",
        "role",
        "variant"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className, variant !== 'fullWidth' && classes[variant], absolute && classes.absolute, flexItem && classes.flexItem, light && classes.light, orientation === 'vertical' && classes.vertical),
        role: role,
        ref: ref
    }, other));
});
var $b04338db8f46de7f$export$2e2bcd8739ae039 = (0, $5rVgt.default)($b04338db8f46de7f$export$9dd6ff9ea0189349, {
    name: 'MuiDivider'
})($b04338db8f46de7f$var$Divider);





var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");


var $5rVgt = parcelRequire("5rVgt");

var $bT5dp = parcelRequire("bT5dp");
var $75157c5b2ba08cec$var$SIZE = 44;
var $75157c5b2ba08cec$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'inline-block'
        },
        /* Styles applied to the root element if `variant="static"`. */ static: {
            transition: theme.transitions.create('transform')
        },
        /* Styles applied to the root element if `variant="indeterminate"`. */ indeterminate: {
            animation: '$circular-rotate 1.4s linear infinite'
        },
        /* Styles applied to the root element if `variant="determinate"`. */ determinate: {
            transition: theme.transitions.create('transform')
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the `svg` element. */ svg: {
            display: 'block' // Keeps the progress centered
        },
        /* Styles applied to the `circle` svg path. */ circle: {
            stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
        },
        /* Styles applied to the `circle` svg path if `variant="static"`. */ circleStatic: {
            transition: theme.transitions.create('stroke-dashoffset')
        },
        /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */ circleIndeterminate: {
            animation: '$circular-dash 1.4s ease-in-out infinite',
            // Some default value that looks fine waiting for the animation to kicks in.
            strokeDasharray: '80px, 200px',
            strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
        },
        /* Styles applied to the `circle` svg path if `variant="determinate"`. */ circleDeterminate: {
            transition: theme.transitions.create('stroke-dashoffset')
        },
        '@keyframes circular-rotate': {
            '0%': {
                // Fix IE 11 wobbly
                transformOrigin: '50% 50%'
            },
            '100%': {
                transform: 'rotate(360deg)'
            }
        },
        '@keyframes circular-dash': {
            '0%': {
                strokeDasharray: '1px, 200px',
                strokeDashoffset: '0px'
            },
            '50%': {
                strokeDasharray: '100px, 200px',
                strokeDashoffset: '-15px'
            },
            '100%': {
                strokeDasharray: '100px, 200px',
                strokeDashoffset: '-125px'
            }
        },
        /* Styles applied to the `circle` svg path if `disableShrink={true}`. */ circleDisableShrink: {
            animation: 'none'
        }
    };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ var $75157c5b2ba08cec$var$CircularProgress = /*#__PURE__*/ $Fo7oF.forwardRef(function CircularProgress(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, _props$disableShrink = props.disableShrink, disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink, _props$size = props.size, size = _props$size === void 0 ? 40 : _props$size, style = props.style, _props$thickness = props.thickness, thickness = _props$thickness === void 0 ? 3.6 : _props$thickness, _props$value = props.value, value = _props$value === void 0 ? 0 : _props$value, _props$variant = props.variant, variant = _props$variant === void 0 ? 'indeterminate' : _props$variant, other = (0, $67mp8.default)(props, [
        "classes",
        "className",
        "color",
        "disableShrink",
        "size",
        "style",
        "thickness",
        "value",
        "variant"
    ]);
    var circleStyle = {};
    var rootStyle = {};
    var rootProps = {};
    if (variant === 'determinate' || variant === 'static') {
        var circumference = 2 * Math.PI * (($75157c5b2ba08cec$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ $Fo7oF.createElement("div", (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, $bT5dp.default)(color))], {
            'determinate': classes.determinate,
            'indeterminate': classes.indeterminate,
            'static': classes.static
        }[variant]),
        style: (0, $elnlQ.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ref: ref,
        role: "progressbar"
    }, rootProps, other), /*#__PURE__*/ $Fo7oF.createElement("svg", {
        className: classes.svg,
        viewBox: "".concat($75157c5b2ba08cec$var$SIZE / 2, " ").concat($75157c5b2ba08cec$var$SIZE / 2, " ").concat($75157c5b2ba08cec$var$SIZE, " ").concat($75157c5b2ba08cec$var$SIZE)
    }, /*#__PURE__*/ $Fo7oF.createElement("circle", {
        className: (0, $78z8j.default)(classes.circle, disableShrink && classes.circleDisableShrink, {
            'determinate': classes.circleDeterminate,
            'indeterminate': classes.circleIndeterminate,
            'static': classes.circleStatic
        }[variant]),
        style: circleStyle,
        cx: $75157c5b2ba08cec$var$SIZE,
        cy: $75157c5b2ba08cec$var$SIZE,
        r: ($75157c5b2ba08cec$var$SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
    })));
});
var $75157c5b2ba08cec$export$2e2bcd8739ae039 = (0, $5rVgt.default)($75157c5b2ba08cec$export$9dd6ff9ea0189349, {
    name: 'MuiCircularProgress',
    flip: false
})($75157c5b2ba08cec$var$CircularProgress);


var $a926ab2bc105161b$exports = {};

$parcel$export($a926ab2bc105161b$exports, "root", () => $a926ab2bc105161b$export$e8e78c978b129247, (v) => $a926ab2bc105161b$export$e8e78c978b129247 = v);
$parcel$export($a926ab2bc105161b$exports, "progress", () => $a926ab2bc105161b$export$504d7abb21fa8c9, (v) => $a926ab2bc105161b$export$504d7abb21fa8c9 = v);
$parcel$export($a926ab2bc105161b$exports, "visible", () => $a926ab2bc105161b$export$664c6d24e3175067, (v) => $a926ab2bc105161b$export$664c6d24e3175067 = v);
$parcel$export($a926ab2bc105161b$exports, "children", () => $a926ab2bc105161b$export$bacb5cc5a11aef16, (v) => $a926ab2bc105161b$export$bacb5cc5a11aef16 = v);
$parcel$export($a926ab2bc105161b$exports, "hideChildren", () => $a926ab2bc105161b$export$d7dd7df5471facab, (v) => $a926ab2bc105161b$export$d7dd7df5471facab = v);
var $a926ab2bc105161b$export$e8e78c978b129247;
var $a926ab2bc105161b$export$504d7abb21fa8c9;
var $a926ab2bc105161b$export$664c6d24e3175067;
var $a926ab2bc105161b$export$bacb5cc5a11aef16;
var $a926ab2bc105161b$export$d7dd7df5471facab;
$a926ab2bc105161b$export$e8e78c978b129247 = "root_84eb27";
$a926ab2bc105161b$export$504d7abb21fa8c9 = "progress_84eb27";
$a926ab2bc105161b$export$664c6d24e3175067 = "visible_84eb27";
$a926ab2bc105161b$export$bacb5cc5a11aef16 = "children_84eb27";
$a926ab2bc105161b$export$d7dd7df5471facab = "hideChildren_84eb27";


function $7a4d3ef3435842af$export$669f6ea7d267feaf({ size: size = 40, loading: loading, children: children, hideChildren: hideChildren, style: style, ...props }) {
    return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
        ...props,
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($a926ab2bc105161b$exports))).root} ${loading ? (0, (/*@__PURE__*/$parcel$interopDefault($a926ab2bc105161b$exports))).visible : ''} ${hideChildren ? (0, (/*@__PURE__*/$parcel$interopDefault($a926ab2bc105161b$exports))).hideChildren : ''}`,
        style: Object.assign({}, style || {}, {
            minHeight: `${size}px`
        }),
        children: [
            /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a926ab2bc105161b$exports))).progress,
                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $75157c5b2ba08cec$export$2e2bcd8739ae039), {
                    size: size
                })
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($a926ab2bc105161b$exports))).children,
                children: children
            })
        ]
    });
}



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");


var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");








var $67mp8 = parcelRequire("67mp8");

var $elnlQ = parcelRequire("elnlQ");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");



var $5rVgt = parcelRequire("5rVgt");
var $a8ffd2282305d44d$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $elnlQ.default)({
            color: theme.palette.text.secondary
        }, theme.typography.caption, {
            textAlign: 'left',
            marginTop: 3,
            margin: 0,
            '&$disabled': {
                color: theme.palette.text.disabled
            },
            '&$error': {
                color: theme.palette.error.main
            }
        }),
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `margin="dense"`. */ marginDense: {
            marginTop: 4
        },
        /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */ contained: {
            marginLeft: 14,
            marginRight: 14
        },
        /* Pseudo-class applied to the root element if `focused={true}`. */ focused: {},
        /* Pseudo-class applied to the root element if `filled={true}`. */ filled: {},
        /* Pseudo-class applied to the root element if `required={true}`. */ required: {}
    };
};
var $a8ffd2282305d44d$var$FormHelperText = /*#__PURE__*/ $Fo7oF.forwardRef(function FormHelperText(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'p' : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, margin = props.margin, required = props.required, variant = props.variant, other = (0, $67mp8.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "error",
        "filled",
        "focused",
        "margin",
        "required",
        "variant"
    ]);
    var muiFormControl = (0, $da6b73123b6a85ad$export$2e2bcd8739ae039)();
    var fcs = (0, $13260d58a3dda9e0$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'margin',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    return /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, (fcs.variant === 'filled' || fcs.variant === 'outlined') && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === 'dense' && classes.marginDense),
        ref: ref
    }, other), children === ' ' ? /*#__PURE__*/ // eslint-disable-next-line react/no-danger
    $Fo7oF.createElement("span", {
        dangerouslySetInnerHTML: {
            __html: '&#8203;'
        }
    }) : children);
});
var $a8ffd2282305d44d$export$2e2bcd8739ae039 = (0, $5rVgt.default)($a8ffd2282305d44d$export$9dd6ff9ea0189349, {
    name: 'MuiFormHelperText'
})($a8ffd2282305d44d$var$FormHelperText);




var $5rVgt = parcelRequire("5rVgt");
var $3a4ed32c219a2dd3$var$variantComponent = {
    standard: (0, $38f814057e5cea08$export$2e2bcd8739ae039),
    filled: (0, $b6e922bb21e953ab$export$2e2bcd8739ae039),
    outlined: (0, $fdb477e77e9cf80d$export$2e2bcd8739ae039)
};
var $3a4ed32c219a2dd3$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {}
};
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ var $3a4ed32c219a2dd3$var$TextField = /*#__PURE__*/ $Fo7oF.forwardRef(function TextField(props, ref) {
    var autoComplete = props.autoComplete, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, defaultValue = props.defaultValue, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, FormHelperTextProps = props.FormHelperTextProps, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, helperText = props.helperText, hiddenLabel = props.hiddenLabel, id = props.id, InputLabelProps = props.InputLabelProps, inputProps = props.inputProps, InputProps = props.InputProps, inputRef = props.inputRef, label = props.label, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, placeholder = props.placeholder, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, rows = props.rows, rowsMax = props.rowsMax, maxRows = props.maxRows, minRows = props.minRows, _props$select = props.select, select = _props$select === void 0 ? false : _props$select, SelectProps = props.SelectProps, type = props.type, value = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $67mp8.default)(props, [
        "autoComplete",
        "autoFocus",
        "children",
        "classes",
        "className",
        "color",
        "defaultValue",
        "disabled",
        "error",
        "FormHelperTextProps",
        "fullWidth",
        "helperText",
        "hiddenLabel",
        "id",
        "InputLabelProps",
        "inputProps",
        "InputProps",
        "inputRef",
        "label",
        "multiline",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "placeholder",
        "required",
        "rows",
        "rowsMax",
        "maxRows",
        "minRows",
        "select",
        "SelectProps",
        "type",
        "value",
        "variant"
    ]);
    var InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        if (label) {
            var _InputLabelProps$requ;
            var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
            InputMore.label = /*#__PURE__*/ $Fo7oF.createElement($Fo7oF.Fragment, null, label, displayRequired && "\xA0*");
        }
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
    var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
    var InputComponent = $3a4ed32c219a2dd3$var$variantComponent[variant];
    var InputElement = /*#__PURE__*/ $Fo7oF.createElement(InputComponent, (0, $elnlQ.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        rowsMax: rowsMax,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ $Fo7oF.createElement((0, $9b463858a269c96b$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        ref: ref,
        required: required,
        color: color,
        variant: variant
    }, other), label && /*#__PURE__*/ $Fo7oF.createElement((0, $72e841643b7cb579$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        htmlFor: id,
        id: inputLabelId
    }, InputLabelProps), label), select ? /*#__PURE__*/ $Fo7oF.createElement((0, $96006197b33869f9$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        "aria-describedby": helperTextId,
        id: id,
        labelId: inputLabelId,
        value: value,
        input: InputElement
    }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/ $Fo7oF.createElement((0, $a8ffd2282305d44d$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        id: helperTextId
    }, FormHelperTextProps), helperText));
});
var $3a4ed32c219a2dd3$export$2e2bcd8739ae039 = (0, $5rVgt.default)($3a4ed32c219a2dd3$export$9dd6ff9ea0189349, {
    name: 'MuiTextField'
})($3a4ed32c219a2dd3$var$TextField);




var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");






let $265673b79ab87217$var$identifier = 0;
function $265673b79ab87217$export$626a0430d29b9cc1({ countries: countries, loading: loading, onChange: onChange, ...props }) {
    const [id, setID] = (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useState();
    const [_countries, setCountries] = (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useState([]);
    (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useEffect(()=>{
        setID($265673b79ab87217$var$identifier++);
        (0, $c04283212adf4fb0$export$60ad299e2e6f36fe)('/api/countries', {
            cacheDuration: 'forever'
        }).then((activeCountries)=>{
            setCountries(Object.entries(activeCountries).map(([key, value])=>({
                    value: key,
                    label: value
                })).concat(countries.filter((country)=>!activeCountries[country]).map((country)=>({
                    value: country,
                    label: country
                }))));
        });
    }, []);
    return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $7a4d3ef3435842af$export$669f6ea7d267feaf), {
        ...props,
        loading: loading,
        children: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $9b463858a269c96b$export$2e2bcd8739ae039), {
            style: {
                minWidth: 320,
                marginRight: '10px'
            },
            variant: "outlined",
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $72e841643b7cb579$export$2e2bcd8739ae039), {
                    htmlFor: `countries-${id}`,
                    children: "Countries"
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $96006197b33869f9$export$2e2bcd8739ae039), {
                    disabled: loading,
                    inputProps: {
                        name: 'countries',
                        id: `countries-${id}`
                    },
                    labelWidth: 65,
                    multiple: true,
                    onChange: async ({ target: target })=>onChange(target.value),
                    style: {
                        maxHeight: '2.5em'
                    },
                    value: countries,
                    children: _countries.map((country)=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                            value: country.value,
                            children: country.label
                        }, country.value))
                })
            ]
        })
    });
}



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");






var $d2bgE = parcelRequire("d2bgE");
let $ceb704039c196cfa$var$identifier = 0;
function $ceb704039c196cfa$export$f783f1f51c5374cf({ role: role, loading: loading, onChange: onChange }) {
    const [id, setID] = (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useState();
    (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useEffect(()=>{
        setID($ceb704039c196cfa$var$identifier++);
    }, []);
    return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $7a4d3ef3435842af$export$669f6ea7d267feaf), {
        loading: loading,
        children: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $9b463858a269c96b$export$2e2bcd8739ae039), {
            style: {
                minWidth: 195
            },
            variant: "outlined",
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $72e841643b7cb579$export$2e2bcd8739ae039), {
                    htmlFor: `role-${id}`,
                    children: "Role"
                }),
                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $96006197b33869f9$export$2e2bcd8739ae039), {
                    disabled: loading,
                    inputProps: {
                        name: 'role',
                        id: `role-${id}`
                    },
                    labelWidth: 35,
                    onChange: async ({ target: target })=>onChange(target.value),
                    style: {
                        maxHeight: '2.5em'
                    },
                    value: role,
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                            value: 'ADMIN',
                            children: "Admin"
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                            value: 'ASSIGN',
                            children: "Assignment"
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                            value: 'VIEW',
                            children: "View Only"
                        })
                    ]
                })
            ]
        })
    });
}
$ceb704039c196cfa$export$f783f1f51c5374cf.propTypes = {
    role: $d2bgE.string,
    loading: $d2bgE.symbol,
    onChange: $d2bgE.object
};



var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");
var $7cc31d65d26a8fbf$exports = {};

$parcel$export($7cc31d65d26a8fbf$exports, "root", () => $7cc31d65d26a8fbf$export$e8e78c978b129247, (v) => $7cc31d65d26a8fbf$export$e8e78c978b129247 = v);
$parcel$export($7cc31d65d26a8fbf$exports, "dot", () => $7cc31d65d26a8fbf$export$94132a0e348806d4, (v) => $7cc31d65d26a8fbf$export$94132a0e348806d4 = v);
var $7cc31d65d26a8fbf$export$e8e78c978b129247;
var $7cc31d65d26a8fbf$export$94132a0e348806d4;
$7cc31d65d26a8fbf$export$e8e78c978b129247 = "root_dc264c";
$7cc31d65d26a8fbf$export$94132a0e348806d4 = "dot_dc264c";


function $9cdb8eaf07a9f9ce$export$d046b3c4a416f60d({ className: className, color: color, ...props }) {
    return /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
        ...props,
        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($7cc31d65d26a8fbf$exports))).root} ${className || ''}`,
        children: /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($7cc31d65d26a8fbf$exports))).dot,
            style: {
                background: color
            }
        })
    });
}



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");

function $c86b14d6c620df5c$export$c7bd411105e2dec3({ id: id, firstName: firstName, lastName: lastName, includeID: includeID }) {
    const [name, setName] = (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useState();
    (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useEffect(()=>{
        setName((0, $1982a4c5f4dd80b7$export$69d4516a6fd8e701).name({
            id: id,
            firstName: firstName,
            lastName: lastName,
            includeID: includeID
        }));
    }, []);
    return /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
        title: id,
        children: name
    });
}


var $50041eb00b3db974$exports = {};

$parcel$export($50041eb00b3db974$exports, "root", () => $50041eb00b3db974$export$e8e78c978b129247, (v) => $50041eb00b3db974$export$e8e78c978b129247 = v);
$parcel$export($50041eb00b3db974$exports, "name", () => $50041eb00b3db974$export$a8ff84c12d48cfa6, (v) => $50041eb00b3db974$export$a8ff84c12d48cfa6 = v);
$parcel$export($50041eb00b3db974$exports, "pending", () => $50041eb00b3db974$export$264e3233dc30e054, (v) => $50041eb00b3db974$export$264e3233dc30e054 = v);
var $50041eb00b3db974$export$e8e78c978b129247;
var $50041eb00b3db974$export$a8ff84c12d48cfa6;
var $50041eb00b3db974$export$264e3233dc30e054;
$50041eb00b3db974$export$e8e78c978b129247 = "root_fcc155";
$50041eb00b3db974$export$a8ff84c12d48cfa6 = "name_fcc155";
$50041eb00b3db974$export$264e3233dc30e054 = "pending_fcc155";


class $aa88761d7d92247c$export$f6de3d6fa65fab3a extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    constructor(props){
        super(props);
        const { user: user } = props;
        this.state = {
            loading: false,
            uid: user && user.id || '',
            role: user && user.role || 'VIEW',
            countries: user && user.countries.map(({ id: id })=>id.countryCode) || []
        };
    }
    componentDidUpdate(_, prevState) {
        if (prevState.countries !== this.state.countries) this.saveCountries();
        if (prevState.role !== this.state.role) this.saveRole();
    }
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
            alignItems: "center",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($50041eb00b3db974$exports))).root,
            container: true,
            justifyContent: "space-between",
            style: this.props.style,
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                    alignItems: "center",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($50041eb00b3db974$exports))).name,
                    container: true,
                    item: true,
                    xs: true,
                    children: [
                        this.props.editUid ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $3a4ed32c219a2dd3$export$2e2bcd8739ae039), {
                            id: 'racf-id' + this.state.uid,
                            margin: "none",
                            onBlur: ()=>this.saveRole(),
                            onChange: ({ target: target })=>this.setState({
                                    uid: target.value
                                }),
                            placeholder: "RACF ID",
                            size: "small",
                            value: this.state.uid,
                            variant: "outlined"
                        }) : /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c86b14d6c620df5c$export$c7bd411105e2dec3), {
                            ...this.props.user,
                            includeID: true
                        }),
                        this.props.user && this.props.user.pending && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $9cdb8eaf07a9f9ce$export$d046b3c4a416f60d), {
                            color: "#FFC107",
                            style: {
                                marginLeft: 10
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                    alignItems: "center",
                    container: true,
                    item: true,
                    justifyContent: "flex-end",
                    xs: true,
                    children: [
                        this.props.user && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $265673b79ab87217$export$626a0430d29b9cc1), {
                            countries: this.state.countries,
                            disabled: !this.props.user,
                            loading: this.props.loading,
                            onChange: (countries)=>{
                                this.setState({
                                    countries: countries
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $ceb704039c196cfa$export$f783f1f51c5374cf), {
                            loading: this.props.loading,
                            onChange: async (role)=>{
                                this.setState({
                                    role: role
                                });
                            },
                            role: this.state.role
                        })
                    ]
                })
            ]
        });
    }
    async deleteUser(id) {
        await (0, $c04283212adf4fb0$export$c4b7edec3f76b207)(`/api/users/${id}`, {
            method: 'DELETE'
        });
    }
    async saveRole() {
        if (!this.props.user && (!this.state.uid || !this.state.role)) return;
        this.setState({
            loading: true
        });
        let updatedUser;
        try {
            if (this.props.user && this.props.user.id !== this.state.uid) await this.deleteUser(this.props.user.id);
            if (this.state.uid) updatedUser = await (0, $c04283212adf4fb0$export$c4b7edec3f76b207)(`/api/users/${this.state.uid}/role`, {
                method: 'POST',
                query: {
                    role: this.state.role
                }
            });
            if (this.props.clearAfterSave) this.setState({
                uid: '',
                role: 'VIEW'
            });
        } finally{
            this.setState({
                loading: false
            });
        }
        this.props.onChange(updatedUser);
    }
    async saveCountries() {
        if (!this.props.user) return;
        this.setState({
            loading: true
        });
        try {
            await (0, $c04283212adf4fb0$export$c4b7edec3f76b207)(`/api/users/${this.props.user.id}/countries`, {
                method: 'POST',
                query: {
                    country: this.state.countries
                }
            });
        } finally{
            this.setState({
                loading: false
            });
        }
    }
}


var $b6c59dc619b37958$exports = {};

$parcel$export($b6c59dc619b37958$exports, "root", () => $b6c59dc619b37958$export$e8e78c978b129247, (v) => $b6c59dc619b37958$export$e8e78c978b129247 = v);
$parcel$export($b6c59dc619b37958$exports, "usersCardItem", () => $b6c59dc619b37958$export$f35188403b2e265c, (v) => $b6c59dc619b37958$export$f35188403b2e265c = v);
var $b6c59dc619b37958$export$e8e78c978b129247;
var $b6c59dc619b37958$export$f35188403b2e265c;
$b6c59dc619b37958$export$e8e78c978b129247 = "root_4020a2";
$b6c59dc619b37958$export$f35188403b2e265c = "usersCardItem_4020a2";


class $be02d0f0d6529012$export$882e6c35ce64278b extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    constructor(props){
        super(props);
        this.state = {
            users: []
        };
    }
    componentDidMount() {
        this.getUsers();
    }
    async getUsers() {
        this.setState({
            loading: true
        });
        try {
            this.setState({
                users: await (0, $c04283212adf4fb0$export$c4b7edec3f76b207)('/api/users', {
                    query: {
                        includePending: true,
                        sort: 'role,asc'
                    }
                })
            });
        } finally{
            this.setState({
                loading: false
            });
        }
    }
    async updateRole(id, role) {
        return await (0, $c04283212adf4fb0$export$c4b7edec3f76b207)(`/api/users/${id}/role`, {
            method: 'POST',
            query: {
                role: role
            }
        });
    }
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $fe0aa9e32766c0f5$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($b6c59dc619b37958$exports))).root,
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                    variant: "caption",
                    children: "Changes are automatically saved."
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $aa88761d7d92247c$export$f6de3d6fa65fab3a), {
                    clearAfterSave: true,
                    editUid: true,
                    onChange: (user)=>{
                        this.setState((prevState)=>({
                                users: [
                                    ...prevState.users,
                                    user
                                ]
                            }));
                    },
                    style: {
                        marginTop: 10
                    }
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                    style: {
                        marginTop: 10,
                        marginBottom: 10
                    },
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b04338db8f46de7f$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $7a4d3ef3435842af$export$669f6ea7d267feaf), {
                    hideChildren: true,
                    loading: this.state.loading,
                    children: this.state.users.map((user, index)=>/*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $aa88761d7d92247c$export$f6de3d6fa65fab3a), {
                                    editUid: user.pending,
                                    onChange: (user)=>{
                                        this.setState((prevState)=>({
                                                users: user ? prevState.users.map((existingUser, userIndex)=>userIndex === index ? user : existingUser) : prevState.users.filter((_, userIndex)=>userIndex !== index)
                                            }));
                                    },
                                    user: user
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                                    style: {
                                        marginTop: 10,
                                        marginBottom: 10
                                    },
                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b04338db8f46de7f$export$2e2bcd8739ae039), {})
                                })
                            ]
                        }, user.id))
                })
            ]
        });
    }
}


class $093873bf3b86cc30$export$b25f57c16f88d7e0 extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
            style: {
                marginBottom: 10
            },
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                    style: {
                        marginBottom: 10
                    },
                    variant: "h5",
                    children: "Admin"
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $be02d0f0d6529012$export$882e6c35ce64278b), {})
            ]
        });
    }
}



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");


var $5rVgt = parcelRequire("5rVgt");
var $c140a9ec31059532$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        overflow: 'hidden'
    }
};
var $c140a9ec31059532$var$Card = /*#__PURE__*/ $Fo7oF.forwardRef(function Card(props, ref) {
    var classes = props.classes, className = props.className, _props$raised = props.raised, raised = _props$raised === void 0 ? false : _props$raised, other = (0, $67mp8.default)(props, [
        "classes",
        "className",
        "raised"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement((0, $fe0aa9e32766c0f5$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className),
        elevation: raised ? 8 : 1,
        ref: ref
    }, other));
});
var $c140a9ec31059532$export$2e2bcd8739ae039 = (0, $5rVgt.default)($c140a9ec31059532$export$9dd6ff9ea0189349, {
    name: 'MuiCard'
})($c140a9ec31059532$var$Card);




var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");
var $5925addb94d391de$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        padding: 16,
        '&:last-child': {
            paddingBottom: 24
        }
    }
};
var $5925addb94d391de$var$CardContent = /*#__PURE__*/ $Fo7oF.forwardRef(function CardContent(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, other = (0, $67mp8.default)(props, [
        "classes",
        "className",
        "component"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className),
        ref: ref
    }, other));
});
var $5925addb94d391de$export$2e2bcd8739ae039 = (0, $5rVgt.default)($5925addb94d391de$export$9dd6ff9ea0189349, {
    name: 'MuiCardContent'
})($5925addb94d391de$var$CardContent);








class $85fc3684d282153b$export$c57a80c7944cc612 extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    constructor(props){
        super(props);
        this.state = {
            id: '',
            firstName: '',
            lastName: '',
            role: '',
            associatedDealerNumber: '',
            country: '',
            comments: ''
        };
        this.handleChange = this.handleChange.bind(this);
    }
    async save() {
        this.setState({
            loading: true
        });
        try {
            await (0, $c04283212adf4fb0$export$c4b7edec3f76b207)('/api/alfa/users', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(this.state)
            });
        } finally{
            this.setState({
                loading: false
            });
        }
    }
    handleChange(name) {
        return (e)=>{
            this.setState({
                [name]: e.target.value
            });
        };
    }
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                    style: {
                        marginBottom: 10
                    },
                    variant: "h5",
                    children: "Add a new FC User"
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c140a9ec31059532$export$2e2bcd8739ae039), {
                    style: {
                        marginBottom: 20,
                        margin: 'auto'
                    },
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $5925addb94d391de$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                            style: {
                                marginRight: '30vw'
                            },
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    container: true,
                                    direction: "row",
                                    item: true,
                                    spacing: 3,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            alignItems: "flex-start",
                                            container: true,
                                            direction: "column",
                                            item: true,
                                            justifyContent: "space-around",
                                            sm: 6,
                                            xs: 12,
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                                    style: {
                                                        fontWeight: 'bold'
                                                    },
                                                    children: "RACF ID"
                                                }),
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $3a4ed32c219a2dd3$export$2e2bcd8739ae039), {
                                                    id: "id",
                                                    margin: "none",
                                                    onChange: this.handleChange('id'),
                                                    placeholder: "TMFE66E",
                                                    size: "small",
                                                    value: this.state.id,
                                                    variant: "outlined"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            alignItems: "flex-start",
                                            container: true,
                                            direction: "column",
                                            item: true,
                                            justifyContent: "space-around",
                                            sm: 6,
                                            xs: 12,
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                                    style: {
                                                        fontWeight: 'bold'
                                                    },
                                                    children: "Associated Dealer"
                                                }),
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $3a4ed32c219a2dd3$export$2e2bcd8739ae039), {
                                                    id: "associated-dealer",
                                                    margin: "none",
                                                    onChange: this.handleChange('associatedDealerNumber'),
                                                    placeholder: "TALF00025",
                                                    size: "small",
                                                    value: this.state.associatedDealerNumber,
                                                    variant: "outlined"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            alignItems: "flex-start",
                                            container: true,
                                            direction: "column",
                                            item: true,
                                            justifyContent: "space-around",
                                            sm: 6,
                                            xs: 12,
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                                    style: {
                                                        fontWeight: 'bold'
                                                    },
                                                    children: "First Name"
                                                }),
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $3a4ed32c219a2dd3$export$2e2bcd8739ae039), {
                                                    id: "first-name",
                                                    margin: "none",
                                                    onChange: this.handleChange('firstName'),
                                                    placeholder: "Jim",
                                                    size: "small",
                                                    value: this.state.firstName,
                                                    variant: "outlined"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            alignItems: "flex-start",
                                            container: true,
                                            direction: "column",
                                            item: true,
                                            justifyContent: "space-around",
                                            sm: 6,
                                            xs: 12,
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                                    style: {
                                                        fontWeight: 'bold'
                                                    },
                                                    children: "Role"
                                                }),
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $3a4ed32c219a2dd3$export$2e2bcd8739ae039), {
                                                    id: "role-name",
                                                    margin: "none",
                                                    onChange: this.handleChange('role'),
                                                    placeholder: "ASMGB",
                                                    size: "small",
                                                    value: this.state.role,
                                                    variant: "outlined"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            alignItems: "flex-start",
                                            container: true,
                                            direction: "column",
                                            item: true,
                                            justifyContent: "space-around",
                                            sm: 6,
                                            xs: 12,
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                                    style: {
                                                        fontWeight: 'bold'
                                                    },
                                                    children: "Last Name"
                                                }),
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $3a4ed32c219a2dd3$export$2e2bcd8739ae039), {
                                                    id: "last-name",
                                                    margin: "none",
                                                    onChange: this.handleChange('lastName'),
                                                    placeholder: "Gleason",
                                                    size: "small",
                                                    value: this.state.lastName,
                                                    variant: "outlined"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            alignItems: "flex-start",
                                            container: true,
                                            direction: "column",
                                            item: true,
                                            justifyContent: "space-around",
                                            sm: 6,
                                            xs: 12,
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                                    style: {
                                                        fontWeight: 'bold'
                                                    },
                                                    children: "Country"
                                                }),
                                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $96006197b33869f9$export$2e2bcd8739ae039), {
                                                    inputProps: {
                                                        name: 'country',
                                                        id: 'country'
                                                    },
                                                    onChange: this.handleChange('country'),
                                                    style: {
                                                        minWidth: 220,
                                                        maxHeight: '2.5em'
                                                    },
                                                    value: "UK",
                                                    variant: "outlined",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                            value: "UK",
                                                            children: "United Kingdom"
                                                        }),
                                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                            value: "DE",
                                                            children: "Germany"
                                                        }),
                                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                            value: "ES",
                                                            children: "Spain"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            alignItems: "flex-start",
                                            container: true,
                                            direction: "column",
                                            item: true,
                                            justifyContent: "space-around",
                                            sm: 12,
                                            xs: 12,
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                                    style: {
                                                        fontWeight: 'bold'
                                                    },
                                                    children: "Comments"
                                                }),
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $3a4ed32c219a2dd3$export$2e2bcd8739ae039), {
                                                    id: "comments",
                                                    margin: "none",
                                                    onChange: this.handleChange('comments'),
                                                    placeholder: "Adding new user TM3663FE",
                                                    size: "small",
                                                    value: this.state.comments,
                                                    variant: "outlined"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    alignItems: "flex-start",
                                    container: true,
                                    direction: "row",
                                    item: true,
                                    justifyContent: "space-between",
                                    sm: 3,
                                    style: {
                                        marginTop: 20
                                    },
                                    xs: 12,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                                            variant: "contained",
                                            children: "Clear"
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                                            style: {
                                                position: 'relative'
                                            },
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                                                color: "primary",
                                                onClick: ()=>this.save(),
                                                //disabled={this.state.loading}
                                                variant: "contained",
                                                children: "Save"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        });
    }
}



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");









var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");

var $d2bgE = parcelRequire("d2bgE");

var $elnlQ = parcelRequire("elnlQ");

var $cX6i1 = parcelRequire("cX6i1");

var $2si5T = parcelRequire("2si5T");
function $43f27ed29b5bb141$var$makeStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return (0, $cX6i1.default)(stylesOrCreator, (0, $elnlQ.default)({
        defaultTheme: (0, $2si5T.default)
    }, options));
}
var $43f27ed29b5bb141$export$2e2bcd8739ae039 = $43f27ed29b5bb141$var$makeStyles;



var $67mp8 = parcelRequire("67mp8");

var $elnlQ = parcelRequire("elnlQ");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");


var $5rVgt = parcelRequire("5rVgt");

var $Fo7oF = parcelRequire("Fo7oF");
/**
 * @ignore - internal component.
 */ var $ce01e7a8df509645$var$TableContext = $Fo7oF.createContext();
var $ce01e7a8df509645$export$2e2bcd8739ae039 = $ce01e7a8df509645$var$TableContext;


var $0c4ceb83c44a630e$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'table',
            width: '100%',
            borderCollapse: 'collapse',
            borderSpacing: 0,
            '& caption': (0, $elnlQ.default)({}, theme.typography.body2, {
                padding: theme.spacing(2),
                color: theme.palette.text.secondary,
                textAlign: 'left',
                captionSide: 'bottom'
            })
        },
        /* Styles applied to the root element if `stickyHeader={true}`. */ stickyHeader: {
            borderCollapse: 'separate'
        }
    };
};
var $0c4ceb83c44a630e$var$defaultComponent = 'table';
var $0c4ceb83c44a630e$var$Table = /*#__PURE__*/ $Fo7oF.forwardRef(function Table(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? $0c4ceb83c44a630e$var$defaultComponent : _props$component, _props$padding = props.padding, padding = _props$padding === void 0 ? 'normal' : _props$padding, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, _props$stickyHeader = props.stickyHeader, stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader, other = (0, $67mp8.default)(props, [
        "classes",
        "className",
        "component",
        "padding",
        "size",
        "stickyHeader"
    ]);
    var table = $Fo7oF.useMemo(function() {
        return {
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        };
    }, [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement((0, $ce01e7a8df509645$export$2e2bcd8739ae039).Provider, {
        value: table
    }, /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        role: Component === $0c4ceb83c44a630e$var$defaultComponent ? null : 'table',
        ref: ref,
        className: (0, $78z8j.default)(classes.root, className, stickyHeader && classes.stickyHeader)
    }, other)));
});
var $0c4ceb83c44a630e$export$2e2bcd8739ae039 = (0, $5rVgt.default)($0c4ceb83c44a630e$export$9dd6ff9ea0189349, {
    name: 'MuiTable'
})($0c4ceb83c44a630e$var$Table);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");

var $Fo7oF = parcelRequire("Fo7oF");
/**
 * @ignore - internal component.
 */ var $ce754b410f3ed8d3$var$Tablelvl2Context = $Fo7oF.createContext();
var $ce754b410f3ed8d3$export$2e2bcd8739ae039 = $ce754b410f3ed8d3$var$Tablelvl2Context;


var $b5b6ab7f22f12380$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'table-row-group'
    }
};
var $b5b6ab7f22f12380$var$tablelvl2 = {
    variant: 'body'
};
var $b5b6ab7f22f12380$var$defaultComponent = 'tbody';
var $b5b6ab7f22f12380$var$TableBody = /*#__PURE__*/ $Fo7oF.forwardRef(function TableBody(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? $b5b6ab7f22f12380$var$defaultComponent : _props$component, other = (0, $67mp8.default)(props, [
        "classes",
        "className",
        "component"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement((0, $ce754b410f3ed8d3$export$2e2bcd8739ae039).Provider, {
        value: $b5b6ab7f22f12380$var$tablelvl2
    }, /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className),
        ref: ref,
        role: Component === $b5b6ab7f22f12380$var$defaultComponent ? null : 'rowgroup'
    }, other)));
});
var $b5b6ab7f22f12380$export$2e2bcd8739ae039 = (0, $5rVgt.default)($b5b6ab7f22f12380$export$9dd6ff9ea0189349, {
    name: 'MuiTableBody'
})($b5b6ab7f22f12380$var$TableBody);



var $67mp8 = parcelRequire("67mp8");

var $elnlQ = parcelRequire("elnlQ");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");


var $5rVgt = parcelRequire("5rVgt");

var $bT5dp = parcelRequire("bT5dp");

var $8Hh6N = parcelRequire("8Hh6N");


var $924d8ef775c5c9f0$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $elnlQ.default)({}, theme.typography.body2, {
            display: 'table-cell',
            verticalAlign: 'inherit',
            // Workaround for a rendering bug with spanned columns in Chrome 62.0.
            // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
            borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? (0, $8Hh6N.lighten)((0, $8Hh6N.alpha)(theme.palette.divider, 1), 0.88) : (0, $8Hh6N.darken)((0, $8Hh6N.alpha)(theme.palette.divider, 1), 0.68)),
            textAlign: 'left',
            padding: 16
        }),
        /* Styles applied to the root element if `variant="head"` or `context.table.head`. */ head: {
            color: theme.palette.text.primary,
            lineHeight: theme.typography.pxToRem(24),
            fontWeight: theme.typography.fontWeightMedium
        },
        /* Styles applied to the root element if `variant="body"` or `context.table.body`. */ body: {
            color: theme.palette.text.primary
        },
        /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */ footer: {
            color: theme.palette.text.secondary,
            lineHeight: theme.typography.pxToRem(21),
            fontSize: theme.typography.pxToRem(12)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: '6px 24px 6px 16px',
            '&:last-child': {
                paddingRight: 16
            },
            '&$paddingCheckbox': {
                width: 24,
                // prevent the checkbox column from growing
                padding: '0 12px 0 16px',
                '&:last-child': {
                    paddingLeft: 12,
                    paddingRight: 16
                },
                '& > *': {
                    padding: 0
                }
            }
        },
        /* Styles applied to the root element if `padding="checkbox"`. */ paddingCheckbox: {
            width: 48,
            // prevent the checkbox column from growing
            padding: '0 0 0 4px',
            '&:last-child': {
                paddingLeft: 0,
                paddingRight: 4
            }
        },
        /* Styles applied to the root element if `padding="none"`. */ paddingNone: {
            padding: 0,
            '&:last-child': {
                padding: 0
            }
        },
        /* Styles applied to the root element if `align="left"`. */ alignLeft: {
            textAlign: 'left'
        },
        /* Styles applied to the root element if `align="center"`. */ alignCenter: {
            textAlign: 'center'
        },
        /* Styles applied to the root element if `align="right"`. */ alignRight: {
            textAlign: 'right',
            flexDirection: 'row-reverse'
        },
        /* Styles applied to the root element if `align="justify"`. */ alignJustify: {
            textAlign: 'justify'
        },
        /* Styles applied to the root element if `context.table.stickyHeader={true}`. */ stickyHeader: {
            position: 'sticky',
            top: 0,
            left: 0,
            zIndex: 2,
            backgroundColor: theme.palette.background.default
        }
    };
};
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ var $924d8ef775c5c9f0$var$TableCell = /*#__PURE__*/ $Fo7oF.forwardRef(function TableCell(props, ref) {
    var _props$align = props.align, align = _props$align === void 0 ? 'inherit' : _props$align, classes = props.classes, className = props.className, component = props.component, paddingProp = props.padding, scopeProp = props.scope, sizeProp = props.size, sortDirection = props.sortDirection, variantProp = props.variant, other = (0, $67mp8.default)(props, [
        "align",
        "classes",
        "className",
        "component",
        "padding",
        "scope",
        "size",
        "sortDirection",
        "variant"
    ]);
    var table = $Fo7oF.useContext((0, $ce01e7a8df509645$export$2e2bcd8739ae039));
    var tablelvl2 = $Fo7oF.useContext((0, $ce754b410f3ed8d3$export$2e2bcd8739ae039));
    var isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    var role;
    var Component;
    if (component) {
        Component = component;
        role = isHeadCell ? 'columnheader' : 'cell';
    } else Component = isHeadCell ? 'th' : 'td';
    var scope = scopeProp;
    if (!scope && isHeadCell) scope = 'col';
    var padding = paddingProp || (table && table.padding ? table.padding : 'normal');
    var size = sizeProp || (table && table.size ? table.size : 'medium');
    var variant = variantProp || tablelvl2 && tablelvl2.variant;
    var ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        ref: ref,
        className: (0, $78z8j.default)(classes.root, classes[variant], className, align !== 'inherit' && classes["align".concat((0, $bT5dp.default)(align))], padding !== 'normal' && classes["padding".concat((0, $bT5dp.default)(padding))], size !== 'medium' && classes["size".concat((0, $bT5dp.default)(size))], variant === 'head' && table && table.stickyHeader && classes.stickyHeader),
        "aria-sort": ariaSort,
        role: role,
        scope: scope
    }, other));
});
var $924d8ef775c5c9f0$export$2e2bcd8739ae039 = (0, $5rVgt.default)($924d8ef775c5c9f0$export$9dd6ff9ea0189349, {
    name: 'MuiTableCell'
})($924d8ef775c5c9f0$var$TableCell);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");
var $38bdee8745793da0$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        width: '100%',
        overflowX: 'auto'
    }
};
var $38bdee8745793da0$var$TableContainer = /*#__PURE__*/ $Fo7oF.forwardRef(function TableContainer(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, other = (0, $67mp8.default)(props, [
        "classes",
        "className",
        "component"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        ref: ref,
        className: (0, $78z8j.default)(classes.root, className)
    }, other));
});
var $38bdee8745793da0$export$2e2bcd8739ae039 = (0, $5rVgt.default)($38bdee8745793da0$export$9dd6ff9ea0189349, {
    name: 'MuiTableContainer'
})($38bdee8745793da0$var$TableContainer);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");

var $814252108fd031b4$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'table-header-group'
    }
};
var $814252108fd031b4$var$tablelvl2 = {
    variant: 'head'
};
var $814252108fd031b4$var$defaultComponent = 'thead';
var $814252108fd031b4$var$TableHead = /*#__PURE__*/ $Fo7oF.forwardRef(function TableHead(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? $814252108fd031b4$var$defaultComponent : _props$component, other = (0, $67mp8.default)(props, [
        "classes",
        "className",
        "component"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement((0, $ce754b410f3ed8d3$export$2e2bcd8739ae039).Provider, {
        value: $814252108fd031b4$var$tablelvl2
    }, /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className),
        ref: ref,
        role: Component === $814252108fd031b4$var$defaultComponent ? null : 'rowgroup'
    }, other)));
});
var $814252108fd031b4$export$2e2bcd8739ae039 = (0, $5rVgt.default)($814252108fd031b4$export$9dd6ff9ea0189349, {
    name: 'MuiTableHead'
})($814252108fd031b4$var$TableHead);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");


var $8Hh6N = parcelRequire("8Hh6N");
var $e6915f08e195d274$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            color: 'inherit',
            display: 'table-row',
            verticalAlign: 'middle',
            // We disable the focus ring for mouse, touch and keyboard users.
            outline: 0,
            '&$hover:hover': {
                backgroundColor: theme.palette.action.hover
            },
            '&$selected, &$selected:hover': {
                backgroundColor: (0, $8Hh6N.alpha)(theme.palette.secondary.main, theme.palette.action.selectedOpacity)
            }
        },
        /* Pseudo-class applied to the root element if `selected={true}`. */ selected: {},
        /* Pseudo-class applied to the root element if `hover={true}`. */ hover: {},
        /* Styles applied to the root element if table variant="head". */ head: {},
        /* Styles applied to the root element if table variant="footer". */ footer: {}
    };
};
var $e6915f08e195d274$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ var $e6915f08e195d274$var$TableRow = /*#__PURE__*/ $Fo7oF.forwardRef(function TableRow(props, ref) {
    var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? $e6915f08e195d274$var$defaultComponent : _props$component, _props$hover = props.hover, hover = _props$hover === void 0 ? false : _props$hover, _props$selected = props.selected, selected = _props$selected === void 0 ? false : _props$selected, other = (0, $67mp8.default)(props, [
        "classes",
        "className",
        "component",
        "hover",
        "selected"
    ]);
    var tablelvl2 = $Fo7oF.useContext((0, $ce754b410f3ed8d3$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        ref: ref,
        className: (0, $78z8j.default)(classes.root, className, tablelvl2 && ({
            'head': classes.head,
            'footer': classes.footer
        })[tablelvl2.variant], hover && classes.hover, selected && classes.selected),
        role: Component === $e6915f08e195d274$var$defaultComponent ? null : 'row'
    }, other));
});
var $e6915f08e195d274$export$2e2bcd8739ae039 = (0, $5rVgt.default)($e6915f08e195d274$export$9dd6ff9ea0189349, {
    name: 'MuiTableRow'
})($e6915f08e195d274$var$TableRow);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $Fo7oF = parcelRequire("Fo7oF");

var $3yRq4 = parcelRequire("3yRq4");
var /**
 * @ignore - internal component.
 */ $951c0981cbb1bae5$export$2e2bcd8739ae039 = (0, $3yRq4.default)(/*#__PURE__*/ $Fo7oF.createElement("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');



var $5rVgt = parcelRequire("5rVgt");


var $bT5dp = parcelRequire("bT5dp");
var $b606d0832a5935be$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            cursor: 'pointer',
            display: 'inline-flex',
            justifyContent: 'flex-start',
            flexDirection: 'inherit',
            alignItems: 'center',
            '&:focus': {
                color: theme.palette.text.secondary
            },
            '&:hover': {
                color: theme.palette.text.secondary,
                '& $icon': {
                    opacity: 0.5
                }
            },
            '&$active': {
                color: theme.palette.text.primary,
                // && instead of & is a workaround for https://github.com/cssinjs/jss/issues/1045
                '&& $icon': {
                    opacity: 1,
                    color: theme.palette.text.secondary
                }
            }
        },
        /* Pseudo-class applied to the root element if `active={true}`. */ active: {},
        /* Styles applied to the icon component. */ icon: {
            fontSize: 18,
            marginRight: 4,
            marginLeft: 4,
            opacity: 0,
            transition: theme.transitions.create([
                'opacity',
                'transform'
            ], {
                duration: theme.transitions.duration.shorter
            }),
            userSelect: 'none'
        },
        /* Styles applied to the icon component if `direction="desc"`. */ iconDirectionDesc: {
            transform: 'rotate(0deg)'
        },
        /* Styles applied to the icon component if `direction="asc"`. */ iconDirectionAsc: {
            transform: 'rotate(180deg)'
        }
    };
};
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */ var $b606d0832a5935be$var$TableSortLabel = /*#__PURE__*/ $Fo7oF.forwardRef(function TableSortLabel(props, ref) {
    var _props$active = props.active, active = _props$active === void 0 ? false : _props$active, children = props.children, classes = props.classes, className = props.className, _props$direction = props.direction, direction = _props$direction === void 0 ? 'asc' : _props$direction, _props$hideSortIcon = props.hideSortIcon, hideSortIcon = _props$hideSortIcon === void 0 ? false : _props$hideSortIcon, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? (0, $951c0981cbb1bae5$export$2e2bcd8739ae039) : _props$IconComponent, other = (0, $67mp8.default)(props, [
        "active",
        "children",
        "classes",
        "className",
        "direction",
        "hideSortIcon",
        "IconComponent"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement((0, $67b46b5fd967aa2b$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className, active && classes.active),
        component: "span",
        disableRipple: true,
        ref: ref
    }, other), children, hideSortIcon && !active ? null : /*#__PURE__*/ $Fo7oF.createElement(IconComponent, {
        className: (0, $78z8j.default)(classes.icon, classes["iconDirection".concat((0, $bT5dp.default)(direction))])
    }));
});
var $b606d0832a5935be$export$2e2bcd8739ae039 = (0, $5rVgt.default)($b606d0832a5935be$export$9dd6ff9ea0189349, {
    name: 'MuiTableSortLabel'
})($b606d0832a5935be$var$TableSortLabel);




var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");

var $d2vKa = parcelRequire("d2vKa");


var $6QKVZ = parcelRequire("6QKVZ");
function $d37c7a67c37a889c$var$getPath(obj, path) {
    if (!path || typeof path !== 'string') return null;
    return path.split('.').reduce(function(acc, item) {
        return acc && acc[item] ? acc[item] : null;
    }, obj);
}
function $d37c7a67c37a889c$var$style(options) {
    var prop = options.prop, _options$cssProperty = options.cssProperty, cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty, themeKey = options.themeKey, transform = options.transform;
    var fn = function fn(props) {
        if (props[prop] == null) return null;
        var propValue = props[prop];
        var theme = props.theme;
        var themeMapping = $d37c7a67c37a889c$var$getPath(theme, themeKey) || {};
        var styleFromPropValue = function styleFromPropValue(propValueFinal) {
            var value;
            if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
            else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || propValueFinal;
            else {
                value = $d37c7a67c37a889c$var$getPath(themeMapping, propValueFinal) || propValueFinal;
                if (transform) value = transform(value);
            }
            if (cssProperty === false) return value;
            return (0, $d2vKa.default)({}, cssProperty, value);
        };
        return (0, $6QKVZ.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $d37c7a67c37a889c$export$2e2bcd8739ae039 = $d37c7a67c37a889c$var$style;


parcelRequire("elnlQ");

var $fb3vv = parcelRequire("fb3vv");
function $b32825a8ee1bb05b$var$compose() {
    for(var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++)styles[_key] = arguments[_key];
    var fn = function fn(props) {
        return styles.reduce(function(acc, style) {
            var output = style(props);
            if (output) return (0, $fb3vv.default)(acc, output);
            return acc;
        }, {});
    }; // Alternative approach that doesn't yield any performance gain.
    // const handlers = styles.reduce((acc, style) => {
    //   style.filterProps.forEach(prop => {
    //     acc[prop] = style;
    //   });
    //   return acc;
    // }, {});
    // const fn = props => {
    //   return Object.keys(props).reduce((acc, prop) => {
    //     if (handlers[prop]) {
    //       return merge(acc, handlers[prop](props));
    //     }
    //     return acc;
    //   }, {});
    // };
    fn.propTypes = {};
    fn.filterProps = styles.reduce(function(acc, style) {
        return acc.concat(style.filterProps);
    }, []);
    return fn;
}
var $b32825a8ee1bb05b$export$2e2bcd8739ae039 = $b32825a8ee1bb05b$var$compose;


function $893e0fbc946256d7$var$getBorder(value) {
    if (typeof value !== 'number') return value;
    return "".concat(value, "px solid");
}
var $893e0fbc946256d7$export$1edee58a52776cd9 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'border',
    themeKey: 'borders',
    transform: $893e0fbc946256d7$var$getBorder
});
var $893e0fbc946256d7$export$f9a7b6bd24892946 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'borderTop',
    themeKey: 'borders',
    transform: $893e0fbc946256d7$var$getBorder
});
var $893e0fbc946256d7$export$5abca33e6be905d2 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'borderRight',
    themeKey: 'borders',
    transform: $893e0fbc946256d7$var$getBorder
});
var $893e0fbc946256d7$export$e2ce9f12a980a822 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'borderBottom',
    themeKey: 'borders',
    transform: $893e0fbc946256d7$var$getBorder
});
var $893e0fbc946256d7$export$47658cca1a909427 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'borderLeft',
    themeKey: 'borders',
    transform: $893e0fbc946256d7$var$getBorder
});
var $893e0fbc946256d7$export$e7fb0694ba2404fc = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'borderColor',
    themeKey: 'palette'
});
var $893e0fbc946256d7$export$7a57f79000377ca2 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'borderRadius',
    themeKey: 'shape'
});
var $893e0fbc946256d7$var$borders = (0, $b32825a8ee1bb05b$export$2e2bcd8739ae039)($893e0fbc946256d7$export$1edee58a52776cd9, $893e0fbc946256d7$export$f9a7b6bd24892946, $893e0fbc946256d7$export$5abca33e6be905d2, $893e0fbc946256d7$export$e2ce9f12a980a822, $893e0fbc946256d7$export$47658cca1a909427, $893e0fbc946256d7$export$e7fb0694ba2404fc, $893e0fbc946256d7$export$7a57f79000377ca2);
var $893e0fbc946256d7$export$2e2bcd8739ae039 = $893e0fbc946256d7$var$borders;



var $a1fa642430ba9cae$export$95a5c40fb210fe3e = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'displayPrint',
    cssProperty: false,
    transform: function transform(value) {
        return {
            '@media print': {
                display: value
            }
        };
    }
});
var $a1fa642430ba9cae$export$e5efd59aba9975ad = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'display'
});
var $a1fa642430ba9cae$export$f6530fb6e67e00bd = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'overflow'
});
var $a1fa642430ba9cae$export$f00f69a6f0e8c5b6 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'textOverflow'
});
var $a1fa642430ba9cae$export$91fa9ac3f4021ce4 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'visibility'
});
var $a1fa642430ba9cae$export$9ef81298ca34ad41 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'whiteSpace'
});
var $a1fa642430ba9cae$export$2e2bcd8739ae039 = (0, $b32825a8ee1bb05b$export$2e2bcd8739ae039)($a1fa642430ba9cae$export$95a5c40fb210fe3e, $a1fa642430ba9cae$export$e5efd59aba9975ad, $a1fa642430ba9cae$export$f6530fb6e67e00bd, $a1fa642430ba9cae$export$f00f69a6f0e8c5b6, $a1fa642430ba9cae$export$91fa9ac3f4021ce4, $a1fa642430ba9cae$export$9ef81298ca34ad41);



var $270fc8c07dcc3174$export$d2ad290394bbc49d = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'flexBasis'
});
var $270fc8c07dcc3174$export$84c3c16c9ed6c908 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'flexDirection'
});
var $270fc8c07dcc3174$export$9a4bcd01f5c204bc = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'flexWrap'
});
var $270fc8c07dcc3174$export$8dea3061ba53bfd1 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'justifyContent'
});
var $270fc8c07dcc3174$export$898d9006406726bd = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'alignItems'
});
var $270fc8c07dcc3174$export$38c32c6918694134 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'alignContent'
});
var $270fc8c07dcc3174$export$aaaeab0fac9a3ccb = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'order'
});
var $270fc8c07dcc3174$export$97691fbb80847c19 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'flex'
});
var $270fc8c07dcc3174$export$36c65c169152373d = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'flexGrow'
});
var $270fc8c07dcc3174$export$2670ac60b02109d2 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'flexShrink'
});
var $270fc8c07dcc3174$export$4545dd3632cb520b = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'alignSelf'
});
var $270fc8c07dcc3174$export$55e6b7a7f0eaa3ff = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'justifyItems'
});
var $270fc8c07dcc3174$export$d012640ac9a6446f = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'justifySelf'
});
var $270fc8c07dcc3174$var$flexbox = (0, $b32825a8ee1bb05b$export$2e2bcd8739ae039)($270fc8c07dcc3174$export$d2ad290394bbc49d, $270fc8c07dcc3174$export$84c3c16c9ed6c908, $270fc8c07dcc3174$export$9a4bcd01f5c204bc, $270fc8c07dcc3174$export$8dea3061ba53bfd1, $270fc8c07dcc3174$export$898d9006406726bd, $270fc8c07dcc3174$export$38c32c6918694134, $270fc8c07dcc3174$export$aaaeab0fac9a3ccb, $270fc8c07dcc3174$export$97691fbb80847c19, $270fc8c07dcc3174$export$36c65c169152373d, $270fc8c07dcc3174$export$2670ac60b02109d2, $270fc8c07dcc3174$export$4545dd3632cb520b, $270fc8c07dcc3174$export$55e6b7a7f0eaa3ff, $270fc8c07dcc3174$export$d012640ac9a6446f);
var $270fc8c07dcc3174$export$2e2bcd8739ae039 = $270fc8c07dcc3174$var$flexbox;



var $24a47961ae575216$export$62ffeaf1cd78b2a6 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'gridGap'
});
var $24a47961ae575216$export$d6171c086ca0de0 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'gridColumnGap'
});
var $24a47961ae575216$export$8bb113508eaa54d = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'gridRowGap'
});
var $24a47961ae575216$export$baf44164ca3a34e8 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'gridColumn'
});
var $24a47961ae575216$export$8f7213a1cd01e832 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'gridRow'
});
var $24a47961ae575216$export$b0e0abbc49ba668 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'gridAutoFlow'
});
var $24a47961ae575216$export$bcd8b929d4b4142 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'gridAutoColumns'
});
var $24a47961ae575216$export$e5039a674e14c828 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'gridAutoRows'
});
var $24a47961ae575216$export$42bd9088661ffb03 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'gridTemplateColumns'
});
var $24a47961ae575216$export$920682ae05b999bc = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'gridTemplateRows'
});
var $24a47961ae575216$export$1b88fbdd482fd33a = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'gridTemplateAreas'
});
var $24a47961ae575216$export$bdb486e40d52d26f = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'gridArea'
});
var $24a47961ae575216$var$grid = (0, $b32825a8ee1bb05b$export$2e2bcd8739ae039)($24a47961ae575216$export$62ffeaf1cd78b2a6, $24a47961ae575216$export$d6171c086ca0de0, $24a47961ae575216$export$8bb113508eaa54d, $24a47961ae575216$export$baf44164ca3a34e8, $24a47961ae575216$export$8f7213a1cd01e832, $24a47961ae575216$export$b0e0abbc49ba668, $24a47961ae575216$export$bcd8b929d4b4142, $24a47961ae575216$export$e5039a674e14c828, $24a47961ae575216$export$42bd9088661ffb03, $24a47961ae575216$export$920682ae05b999bc, $24a47961ae575216$export$1b88fbdd482fd33a, $24a47961ae575216$export$bdb486e40d52d26f);
var $24a47961ae575216$export$2e2bcd8739ae039 = $24a47961ae575216$var$grid;



var $9986f0b344537c7c$export$35e9368ef982300f = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'color',
    themeKey: 'palette'
});
var $9986f0b344537c7c$export$2506f56c10355b33 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette'
});
var $9986f0b344537c7c$var$palette = (0, $b32825a8ee1bb05b$export$2e2bcd8739ae039)($9986f0b344537c7c$export$35e9368ef982300f, $9986f0b344537c7c$export$2506f56c10355b33);
var $9986f0b344537c7c$export$2e2bcd8739ae039 = $9986f0b344537c7c$var$palette;



var $94054cf4c58c16a3$export$5880b8b5730aff45 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'position'
});
var $94054cf4c58c16a3$export$56446adcecbeec34 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'zIndex',
    themeKey: 'zIndex'
});
var $94054cf4c58c16a3$export$1e95b668f3b82d = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'top'
});
var $94054cf4c58c16a3$export$79ffe56a765070d2 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'right'
});
var $94054cf4c58c16a3$export$40e543e69a8b3fbb = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'bottom'
});
var $94054cf4c58c16a3$export$eabcd2c8791e7bf4 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'left'
});
var $94054cf4c58c16a3$export$2e2bcd8739ae039 = (0, $b32825a8ee1bb05b$export$2e2bcd8739ae039)($94054cf4c58c16a3$export$5880b8b5730aff45, $94054cf4c58c16a3$export$56446adcecbeec34, $94054cf4c58c16a3$export$1e95b668f3b82d, $94054cf4c58c16a3$export$79ffe56a765070d2, $94054cf4c58c16a3$export$40e543e69a8b3fbb, $94054cf4c58c16a3$export$eabcd2c8791e7bf4);


var $f1d24391b5e642a3$var$boxShadow = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'boxShadow',
    themeKey: 'shadows'
});
var $f1d24391b5e642a3$export$2e2bcd8739ae039 = $f1d24391b5e642a3$var$boxShadow;



function $24ea7329aee355f2$var$transform(value) {
    return value <= 1 ? "".concat(value * 100, "%") : value;
}
var $24ea7329aee355f2$export$7e3df82ee760448c = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'width',
    transform: $24ea7329aee355f2$var$transform
});
var $24ea7329aee355f2$export$488fda99655ff65a = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'maxWidth',
    transform: $24ea7329aee355f2$var$transform
});
var $24ea7329aee355f2$export$ee148fbbe8357dd2 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'minWidth',
    transform: $24ea7329aee355f2$var$transform
});
var $24ea7329aee355f2$export$ac607276a8fe9f0a = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'height',
    transform: $24ea7329aee355f2$var$transform
});
var $24ea7329aee355f2$export$dc0d8bd0b94f8570 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'maxHeight',
    transform: $24ea7329aee355f2$var$transform
});
var $24ea7329aee355f2$export$a43cf604e12f3b17 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'minHeight',
    transform: $24ea7329aee355f2$var$transform
});
var $24ea7329aee355f2$export$ffed9f14fb65e276 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'width',
    transform: $24ea7329aee355f2$var$transform
});
var $24ea7329aee355f2$export$905076ed6620e671 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'height',
    transform: $24ea7329aee355f2$var$transform
});
var $24ea7329aee355f2$export$6ccc93f785106a58 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'boxSizing'
});
var $24ea7329aee355f2$var$sizing = (0, $b32825a8ee1bb05b$export$2e2bcd8739ae039)($24ea7329aee355f2$export$7e3df82ee760448c, $24ea7329aee355f2$export$488fda99655ff65a, $24ea7329aee355f2$export$ee148fbbe8357dd2, $24ea7329aee355f2$export$ac607276a8fe9f0a, $24ea7329aee355f2$export$dc0d8bd0b94f8570, $24ea7329aee355f2$export$a43cf604e12f3b17, $24ea7329aee355f2$export$6ccc93f785106a58);
var $24ea7329aee355f2$export$2e2bcd8739ae039 = $24ea7329aee355f2$var$sizing;


var $56mxq = parcelRequire("56mxq");
var $83MhR = parcelRequire("83MhR");

var $elnlQ = parcelRequire("elnlQ");



var $fb3vv = parcelRequire("fb3vv");
function $d52c47f5d5d7b01c$var$omit(input, fields) {
    var output = {};
    Object.keys(input).forEach(function(prop) {
        if (fields.indexOf(prop) === -1) output[prop] = input[prop];
    });
    return output;
}
var $d52c47f5d5d7b01c$var$warnedOnce = false;
function $d52c47f5d5d7b01c$var$styleFunctionSx(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var output = styleFunction(props);
        if (props.css) return (0, $elnlQ.default)({}, (0, $fb3vv.default)(output, styleFunction((0, $elnlQ.default)({
            theme: props.theme
        }, props.css))), $d52c47f5d5d7b01c$var$omit(props.css, [
            styleFunction.filterProps
        ]));
        if (props.sx) return (0, $elnlQ.default)({}, (0, $fb3vv.default)(output, styleFunction((0, $elnlQ.default)({
            theme: props.theme
        }, props.sx))), $d52c47f5d5d7b01c$var$omit(props.sx, [
            styleFunction.filterProps
        ]));
        return output;
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'css',
        'sx'
    ].concat((0, $83MhR.default)(styleFunction.filterProps));
    return newStyleFunction;
}
function $d52c47f5d5d7b01c$export$dbf350e5966cf602(styleFunction) {
    return $d52c47f5d5d7b01c$var$styleFunctionSx(styleFunction);
}
var $d52c47f5d5d7b01c$export$2e2bcd8739ae039 = $d52c47f5d5d7b01c$var$styleFunctionSx;



var $fd333ba7b8bff022$export$a5975749f0374264 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'fontFamily',
    themeKey: 'typography'
});
var $fd333ba7b8bff022$export$85e3c3ca0c6fb93 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'fontSize',
    themeKey: 'typography'
});
var $fd333ba7b8bff022$export$a827189a08c5a3a3 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'fontStyle',
    themeKey: 'typography'
});
var $fd333ba7b8bff022$export$bc0b29e67df3229e = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'fontWeight',
    themeKey: 'typography'
});
var $fd333ba7b8bff022$export$3eb52878e4502ad1 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'letterSpacing'
});
var $fd333ba7b8bff022$export$c9b91427b594e14 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'lineHeight'
});
var $fd333ba7b8bff022$export$a87999391cd10ae9 = (0, $d37c7a67c37a889c$export$2e2bcd8739ae039)({
    prop: 'textAlign'
});
var $fd333ba7b8bff022$var$typography = (0, $b32825a8ee1bb05b$export$2e2bcd8739ae039)($fd333ba7b8bff022$export$a5975749f0374264, $fd333ba7b8bff022$export$85e3c3ca0c6fb93, $fd333ba7b8bff022$export$a827189a08c5a3a3, $fd333ba7b8bff022$export$bc0b29e67df3229e, $fd333ba7b8bff022$export$3eb52878e4502ad1, $fd333ba7b8bff022$export$c9b91427b594e14, $fd333ba7b8bff022$export$a87999391cd10ae9);
var $fd333ba7b8bff022$export$2e2bcd8739ae039 = $fd333ba7b8bff022$var$typography;



var $elnlQ = parcelRequire("elnlQ");

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");

var $78z8j = parcelRequire("78z8j");



var $1xoRX = parcelRequire("1xoRX");

var $cX6i1 = parcelRequire("cX6i1");
function $1d956bd326468b8e$var$omit(input, fields) {
    var output = {};
    Object.keys(input).forEach(function(prop) {
        if (fields.indexOf(prop) === -1) output[prop] = input[prop];
    });
    return output;
} // styled-components's API removes the mapping between components and styles.
function $1d956bd326468b8e$export$2e2bcd8739ae039(Component) {
    var componentCreator = function componentCreator(style) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var name = options.name, stylesOptions = (0, $67mp8.default)(options, [
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var stylesOrCreator = typeof style === 'function' ? function(theme) {
            return {
                root: function root(props) {
                    return style((0, $elnlQ.default)({
                        theme: theme
                    }, props));
                }
            };
        } : {
            root: style
        };
        var useStyles = (0, $cX6i1.default)(stylesOrCreator, (0, $elnlQ.default)({
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var filterProps;
        var propTypes = {};
        if (style.filterProps) {
            filterProps = style.filterProps;
            delete style.filterProps;
        }
        /* eslint-disable react/forbid-foreign-prop-types */ if (style.propTypes) {
            propTypes = style.propTypes;
            delete style.propTypes;
        }
        /* eslint-enable react/forbid-foreign-prop-types */ var StyledComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef(function StyledComponent(props, ref) {
            var children = props.children, classNameProp = props.className, clone = props.clone, ComponentProp = props.component, other = (0, $67mp8.default)(props, [
                "children",
                "className",
                "clone",
                "component"
            ]);
            var classes = useStyles(props);
            var className = (0, $78z8j.default)(classes.root, classNameProp);
            var spread = other;
            if (filterProps) spread = $1d956bd326468b8e$var$omit(spread, filterProps);
            if (clone) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).cloneElement(children, (0, $elnlQ.default)({
                className: (0, $78z8j.default)(children.props.className, className)
            }, spread));
            if (typeof children === 'function') return children((0, $elnlQ.default)({
                className: className
            }, spread));
            var FinalComponent = ComponentProp || Component;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement(FinalComponent, (0, $elnlQ.default)({
                ref: ref,
                className: className
            }, spread), children);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($1xoRX)))(StyledComponent, Component);
        return StyledComponent;
    };
    return componentCreator;
}



var $2si5T = parcelRequire("2si5T");
var $ef3cd9827425a984$var$styled = function styled(Component) {
    var componentCreator = (0, $1d956bd326468b8e$export$2e2bcd8739ae039)(Component);
    return function(style, options) {
        return componentCreator(style, (0, $elnlQ.default)({
            defaultTheme: (0, $2si5T.default)
        }, options));
    };
};
var $ef3cd9827425a984$export$2e2bcd8739ae039 = $ef3cd9827425a984$var$styled;


var $5b05347dc97ebaf8$export$8b4cd039ebcc4f7b = (0, $d52c47f5d5d7b01c$export$2e2bcd8739ae039)((0, $b32825a8ee1bb05b$export$2e2bcd8739ae039)((0, $893e0fbc946256d7$export$2e2bcd8739ae039), (0, $a1fa642430ba9cae$export$2e2bcd8739ae039), (0, $270fc8c07dcc3174$export$2e2bcd8739ae039), (0, $24a47961ae575216$export$2e2bcd8739ae039), (0, $94054cf4c58c16a3$export$2e2bcd8739ae039), (0, $9986f0b344537c7c$export$2e2bcd8739ae039), (0, $f1d24391b5e642a3$export$2e2bcd8739ae039), (0, $24ea7329aee355f2$export$2e2bcd8739ae039), (0, $56mxq.default), (0, $fd333ba7b8bff022$export$2e2bcd8739ae039)));
/**
 * @ignore - do not document.
 */ var $5b05347dc97ebaf8$var$Box = (0, $ef3cd9827425a984$export$2e2bcd8739ae039)('div')($5b05347dc97ebaf8$export$8b4cd039ebcc4f7b, {
    name: 'MuiBox'
});
var $5b05347dc97ebaf8$export$2e2bcd8739ae039 = $5b05347dc97ebaf8$var$Box;



var $elnlQ = parcelRequire("elnlQ");

var $8YHhK = parcelRequire("8YHhK");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");

var $78z8j = parcelRequire("78z8j");



var $dOG8L = parcelRequire("dOG8L");

var $5rVgt = parcelRequire("5rVgt");

var $6N3by = parcelRequire("6N3by");




var $3d1b9735f1beaaf9$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            height: 0,
            overflow: 'hidden',
            transition: theme.transitions.create('height')
        },
        /* Styles applied to the root element when the transition has entered. */ entered: {
            height: 'auto',
            overflow: 'visible'
        },
        /* Styles applied to the root element when the transition has exited and `collapsedSize` != 0px. */ hidden: {
            visibility: 'hidden'
        },
        /* Styles applied to the outer wrapper element. */ wrapper: {
            // Hack to get children with a negative margin to not falsify the height computation.
            display: 'flex'
        },
        /* Styles applied to the inner wrapper element. */ wrapperInner: {
            width: '100%'
        }
    };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $3d1b9735f1beaaf9$var$Collapse = /*#__PURE__*/ $Fo7oF.forwardRef(function Collapse(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, collapsedHeight = props.collapsedHeight, _props$collapsedSize = props.collapsedSize, collapsedSizeProp = _props$collapsedSize === void 0 ? '0px' : _props$collapsedSize, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? (0, $6N3by.duration).standard : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $dOG8L.default) : _props$TransitionComp, other = (0, $67mp8.default)(props, [
        "children",
        "classes",
        "className",
        "collapsedHeight",
        "collapsedSize",
        "component",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var theme = (0, $c6db41e315144c8b$export$2e2bcd8739ae039)();
    var timer = $Fo7oF.useRef();
    var wrapperRef = $Fo7oF.useRef(null);
    var autoTransitionDuration = $Fo7oF.useRef();
    var collapsedSize = typeof (collapsedHeight || collapsedSizeProp) === 'number' ? "".concat(collapsedHeight || collapsedSizeProp, "px") : collapsedHeight || collapsedSizeProp;
    $Fo7oF.useEffect(function() {
        return function() {
            clearTimeout(timer.current);
        };
    }, []);
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $Fo7oF.useRef(null);
    var handleRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(ref, enableStrictModeCompat ? nodeRef : undefined);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $8YHhK.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        node.style.height = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntering = normalizedTransitionCallback(function(node, isAppearing) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        var _getTransitionProps = (0, $f7011715ddf0f929$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: 'enter'
        }), transitionDuration = _getTransitionProps.duration;
        if (timeout === 'auto') {
            var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
            node.style.transitionDuration = "".concat(duration2, "ms");
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
        node.style.height = "".concat(wrapperHeight, "px");
        if (onEntering) onEntering(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(function(node, isAppearing) {
        node.style.height = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    var handleExit = normalizedTransitionCallback(function(node) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        node.style.height = "".concat(wrapperHeight, "px");
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var handleExiting = normalizedTransitionCallback(function(node) {
        var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
        var _getTransitionProps2 = (0, $f7011715ddf0f929$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: 'exit'
        }), transitionDuration = _getTransitionProps2.duration;
        if (timeout === 'auto') {
            var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
            node.style.transitionDuration = "".concat(duration2, "ms");
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
        node.style.height = collapsedSize;
        if (onExiting) onExiting(node);
    });
    var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
        var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
        if (timeout === 'auto') timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    };
    return /*#__PURE__*/ $Fo7oF.createElement(TransitionComponent, (0, $elnlQ.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: addEndListener,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        timeout: timeout === 'auto' ? null : timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
            className: (0, $78z8j.default)(classes.root, classes.container, className, {
                'entered': classes.entered,
                'exited': !inProp && collapsedSize === '0px' && classes.hidden
            }[state]),
            style: (0, $elnlQ.default)({
                minHeight: collapsedSize
            }, style),
            ref: handleRef
        }, childProps), /*#__PURE__*/ $Fo7oF.createElement("div", {
            className: classes.wrapper,
            ref: wrapperRef
        }, /*#__PURE__*/ $Fo7oF.createElement("div", {
            className: classes.wrapperInner
        }, children)));
    });
});
$3d1b9735f1beaaf9$var$Collapse.muiSupportAuto = true;
var $3d1b9735f1beaaf9$export$2e2bcd8739ae039 = (0, $5rVgt.default)($3d1b9735f1beaaf9$export$9dd6ff9ea0189349, {
    name: 'MuiCollapse'
})($3d1b9735f1beaaf9$var$Collapse);





var $050d10d83b7c7041$exports = {};
"use strict";


Object.defineProperty($050d10d83b7c7041$exports, "__esModule", {
    value: true
});
$050d10d83b7c7041$exports.default = void 0;

var $050d10d83b7c7041$var$React = $e542637ee86bba6a$exports((parcelRequire("Fo7oF")));

var $050d10d83b7c7041$var$_createSvgIcon = $368639c97fe780bf$exports((parcelRequire("bI8Gq")));
var $050d10d83b7c7041$var$_default = (0, $050d10d83b7c7041$var$_createSvgIcon.default)(/*#__PURE__*/ $050d10d83b7c7041$var$React.createElement("path", {
    d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
}), 'KeyboardArrowDown');
$050d10d83b7c7041$exports.default = $050d10d83b7c7041$var$_default;


var $b2b44968505dfb82$exports = {};
"use strict";


Object.defineProperty($b2b44968505dfb82$exports, "__esModule", {
    value: true
});
$b2b44968505dfb82$exports.default = void 0;

var $b2b44968505dfb82$var$React = $e542637ee86bba6a$exports((parcelRequire("Fo7oF")));

var $b2b44968505dfb82$var$_createSvgIcon = $368639c97fe780bf$exports((parcelRequire("bI8Gq")));
var $b2b44968505dfb82$var$_default = (0, $b2b44968505dfb82$var$_createSvgIcon.default)(/*#__PURE__*/ $b2b44968505dfb82$var$React.createElement("path", {
    d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
}), 'KeyboardArrowUp');
$b2b44968505dfb82$exports.default = $b2b44968505dfb82$var$_default;





var $2260333d3ecc242c$exports = {};

$parcel$export($2260333d3ecc242c$exports, "paper", () => $2260333d3ecc242c$export$914772be44022da8, (v) => $2260333d3ecc242c$export$914772be44022da8 = v);
$parcel$export($2260333d3ecc242c$exports, "downloadSignedDocDiv", () => $2260333d3ecc242c$export$3584f402298bae2b, (v) => $2260333d3ecc242c$export$3584f402298bae2b = v);
$parcel$export($2260333d3ecc242c$exports, "downloadDocRadio", () => $2260333d3ecc242c$export$42062a5e47277074, (v) => $2260333d3ecc242c$export$42062a5e47277074 = v);
$parcel$export($2260333d3ecc242c$exports, "downloadFiles", () => $2260333d3ecc242c$export$645fa2d1e9407b63, (v) => $2260333d3ecc242c$export$645fa2d1e9407b63 = v);
$parcel$export($2260333d3ecc242c$exports, "downloadIcon", () => $2260333d3ecc242c$export$33eb75283052a3f, (v) => $2260333d3ecc242c$export$33eb75283052a3f = v);
$parcel$export($2260333d3ecc242c$exports, "downloadError", () => $2260333d3ecc242c$export$aceee0b7fb53a3f5, (v) => $2260333d3ecc242c$export$aceee0b7fb53a3f5 = v);
$parcel$export($2260333d3ecc242c$exports, "warningTooltip", () => $2260333d3ecc242c$export$16a2573cf730e74c, (v) => $2260333d3ecc242c$export$16a2573cf730e74c = v);
$parcel$export($2260333d3ecc242c$exports, "warningDiv", () => $2260333d3ecc242c$export$9a5dac540164f5e9, (v) => $2260333d3ecc242c$export$9a5dac540164f5e9 = v);
$parcel$export($2260333d3ecc242c$exports, "documentInfoPopup", () => $2260333d3ecc242c$export$6f4cb443e36bb638, (v) => $2260333d3ecc242c$export$6f4cb443e36bb638 = v);
$parcel$export($2260333d3ecc242c$exports, "primaryQuoteIcon", () => $2260333d3ecc242c$export$a0cb7f487766ea2c, (v) => $2260333d3ecc242c$export$a0cb7f487766ea2c = v);
$parcel$export($2260333d3ecc242c$exports, "dropdownMenuDiv", () => $2260333d3ecc242c$export$51d4575c21970eb, (v) => $2260333d3ecc242c$export$51d4575c21970eb = v);
$parcel$export($2260333d3ecc242c$exports, "dropdownFeature", () => $2260333d3ecc242c$export$3e2206985ec5c7b1, (v) => $2260333d3ecc242c$export$3e2206985ec5c7b1 = v);
var $2260333d3ecc242c$export$914772be44022da8;
var $2260333d3ecc242c$export$3584f402298bae2b;
var $2260333d3ecc242c$export$42062a5e47277074;
var $2260333d3ecc242c$export$645fa2d1e9407b63;
var $2260333d3ecc242c$export$33eb75283052a3f;
var $2260333d3ecc242c$export$aceee0b7fb53a3f5;
var $2260333d3ecc242c$export$16a2573cf730e74c;
var $2260333d3ecc242c$export$9a5dac540164f5e9;
var $2260333d3ecc242c$export$6f4cb443e36bb638;
var $2260333d3ecc242c$export$a0cb7f487766ea2c;
var $2260333d3ecc242c$export$51d4575c21970eb;
var $2260333d3ecc242c$export$3e2206985ec5c7b1;
$2260333d3ecc242c$export$914772be44022da8 = "paper_471e5d";
$2260333d3ecc242c$export$3584f402298bae2b = "downloadSignedDocDiv_471e5d";
$2260333d3ecc242c$export$42062a5e47277074 = "downloadDocRadio_471e5d";
$2260333d3ecc242c$export$645fa2d1e9407b63 = "downloadFiles_471e5d";
$2260333d3ecc242c$export$33eb75283052a3f = "downloadIcon_471e5d";
$2260333d3ecc242c$export$aceee0b7fb53a3f5 = "downloadError_471e5d";
$2260333d3ecc242c$export$16a2573cf730e74c = "warningTooltip_471e5d";
$2260333d3ecc242c$export$9a5dac540164f5e9 = "warningDiv_471e5d";
$2260333d3ecc242c$export$6f4cb443e36bb638 = "documentInfoPopup_471e5d";
$2260333d3ecc242c$export$a0cb7f487766ea2c = "primaryQuoteIcon_471e5d";
$2260333d3ecc242c$export$51d4575c21970eb = "dropdownMenuDiv_471e5d";
$2260333d3ecc242c$export$3e2206985ec5c7b1 = "dropdownFeature_471e5d";



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");


var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");
var $7f1abf5179463735$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            flex: '1 1 auto'
        },
        /* Styles applied to the root element if `orientation="horizontal"`. */ horizontal: {},
        /* Styles applied to the root element if `orientation="vertical"`. */ vertical: {
            marginLeft: 12,
            // half icon
            padding: '0 0 8px'
        },
        /* Styles applied to the root element if `alternativeLabel={true}`. */ alternativeLabel: {
            position: 'absolute',
            top: 12,
            left: 'calc(-50% + 20px)',
            right: 'calc(50% + 20px)'
        },
        /* Pseudo-class applied to the root element if `active={true}`. */ active: {},
        /* Pseudo-class applied to the root element if `completed={true}`. */ completed: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the line element. */ line: {
            display: 'block',
            borderColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
        },
        /* Styles applied to the root element if `orientation="horizontal"`. */ lineHorizontal: {
            borderTopStyle: 'solid',
            borderTopWidth: 1
        },
        /* Styles applied to the root element if `orientation="vertical"`. */ lineVertical: {
            borderLeftStyle: 'solid',
            borderLeftWidth: 1,
            minHeight: 24
        }
    };
};
var $7f1abf5179463735$var$StepConnector = /*#__PURE__*/ $Fo7oF.forwardRef(function StepConnector(props, ref) {
    var active = props.active, _props$alternativeLab = props.alternativeLabel, alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab, classes = props.classes, className = props.className, completed = props.completed, disabled = props.disabled, index = props.index, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation, other = (0, $67mp8.default)(props, [
        "active",
        "alternativeLabel",
        "classes",
        "className",
        "completed",
        "disabled",
        "index",
        "orientation"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement("div", (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel, active && classes.active, completed && classes.completed, disabled && classes.disabled),
        ref: ref
    }, other), /*#__PURE__*/ $Fo7oF.createElement("span", {
        className: (0, $78z8j.default)(classes.line, {
            'horizontal': classes.lineHorizontal,
            'vertical': classes.lineVertical
        }[orientation])
    }));
});
var $7f1abf5179463735$export$2e2bcd8739ae039 = (0, $5rVgt.default)($7f1abf5179463735$export$9dd6ff9ea0189349, {
    name: 'MuiStepConnector'
})($7f1abf5179463735$var$StepConnector);


var $2a2dbee2872ed1ff$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'flex',
        padding: 24
    },
    /* Styles applied to the root element if `orientation="horizontal"`. */ horizontal: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    /* Styles applied to the root element if `orientation="vertical"`. */ vertical: {
        flexDirection: 'column'
    },
    /* Styles applied to the root element if `alternativeLabel={true}`. */ alternativeLabel: {
        alignItems: 'flex-start'
    }
};
var $2a2dbee2872ed1ff$var$defaultConnector = /*#__PURE__*/ $Fo7oF.createElement((0, $7f1abf5179463735$export$2e2bcd8739ae039), null);
var $2a2dbee2872ed1ff$var$Stepper = /*#__PURE__*/ $Fo7oF.forwardRef(function Stepper(props, ref) {
    var _props$activeStep = props.activeStep, activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep, _props$alternativeLab = props.alternativeLabel, alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab, children = props.children, classes = props.classes, className = props.className, _props$connector = props.connector, connectorProp = _props$connector === void 0 ? $2a2dbee2872ed1ff$var$defaultConnector : _props$connector, _props$nonLinear = props.nonLinear, nonLinear = _props$nonLinear === void 0 ? false : _props$nonLinear, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation, other = (0, $67mp8.default)(props, [
        "activeStep",
        "alternativeLabel",
        "children",
        "classes",
        "className",
        "connector",
        "nonLinear",
        "orientation"
    ]);
    var connector = /*#__PURE__*/ $Fo7oF.isValidElement(connectorProp) ? /*#__PURE__*/ $Fo7oF.cloneElement(connectorProp, {
        orientation: orientation
    }) : null;
    var childrenArray = $Fo7oF.Children.toArray(children);
    var steps = childrenArray.map(function(step, index) {
        var state = {
            index: index,
            active: false,
            completed: false,
            disabled: false
        };
        if (activeStep === index) state.active = true;
        else if (!nonLinear && activeStep > index) state.completed = true;
        else if (!nonLinear && activeStep < index) state.disabled = true;
        return /*#__PURE__*/ $Fo7oF.cloneElement(step, (0, $elnlQ.default)({
            alternativeLabel: alternativeLabel,
            connector: connector,
            last: index + 1 === childrenArray.length,
            orientation: orientation
        }, state, step.props));
    });
    return /*#__PURE__*/ $Fo7oF.createElement((0, $fe0aa9e32766c0f5$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        square: true,
        elevation: 0,
        className: (0, $78z8j.default)(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel),
        ref: ref
    }, other), steps);
});
var $2a2dbee2872ed1ff$export$2e2bcd8739ae039 = (0, $5rVgt.default)($2a2dbee2872ed1ff$export$9dd6ff9ea0189349, {
    name: 'MuiStepper'
})($2a2dbee2872ed1ff$var$Stepper);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");
parcelRequire("7XcX3");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");
var $b7cae7699bf248ce$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the root element if `orientation="horizontal"`. */ horizontal: {
        paddingLeft: 8,
        paddingRight: 8
    },
    /* Styles applied to the root element if `orientation="vertical"`. */ vertical: {},
    /* Styles applied to the root element if `alternativeLabel={true}`. */ alternativeLabel: {
        flex: 1,
        position: 'relative'
    },
    /* Pseudo-class applied to the root element if `completed={true}`. */ completed: {}
};
var $b7cae7699bf248ce$var$Step = /*#__PURE__*/ $Fo7oF.forwardRef(function Step(props, ref) {
    var _props$active = props.active, active = _props$active === void 0 ? false : _props$active, alternativeLabel = props.alternativeLabel, children = props.children, classes = props.classes, className = props.className, _props$completed = props.completed, completed = _props$completed === void 0 ? false : _props$completed, connectorProp = props.connector, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$expanded = props.expanded, expanded = _props$expanded === void 0 ? false : _props$expanded, index = props.index, last = props.last, orientation = props.orientation, other = (0, $67mp8.default)(props, [
        "active",
        "alternativeLabel",
        "children",
        "classes",
        "className",
        "completed",
        "connector",
        "disabled",
        "expanded",
        "index",
        "last",
        "orientation"
    ]);
    var connector = connectorProp ? /*#__PURE__*/ $Fo7oF.cloneElement(connectorProp, {
        orientation: orientation,
        alternativeLabel: alternativeLabel,
        index: index,
        active: active,
        completed: completed,
        disabled: disabled
    }) : null;
    var newChildren = /*#__PURE__*/ $Fo7oF.createElement("div", (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel, completed && classes.completed),
        ref: ref
    }, other), connector && alternativeLabel && index !== 0 ? connector : null, $Fo7oF.Children.map(children, function(child) {
        if (!/*#__PURE__*/ $Fo7oF.isValidElement(child)) return null;
        return /*#__PURE__*/ $Fo7oF.cloneElement(child, (0, $elnlQ.default)({
            active: active,
            alternativeLabel: alternativeLabel,
            completed: completed,
            disabled: disabled,
            expanded: expanded,
            last: last,
            icon: index + 1,
            orientation: orientation
        }, child.props));
    }));
    if (connector && !alternativeLabel && index !== 0) return /*#__PURE__*/ $Fo7oF.createElement($Fo7oF.Fragment, null, connector, newChildren);
    return newChildren;
});
var $b7cae7699bf248ce$export$2e2bcd8739ae039 = (0, $5rVgt.default)($b7cae7699bf248ce$export$9dd6ff9ea0189349, {
    name: 'MuiStep'
})($b7cae7699bf248ce$var$Step);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");


var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $Fo7oF = parcelRequire("Fo7oF");

var $3yRq4 = parcelRequire("3yRq4");
var /**
 * @ignore - internal component.
 */ $d2e230784a283c76$export$2e2bcd8739ae039 = (0, $3yRq4.default)(/*#__PURE__*/ $Fo7oF.createElement("path", {
    d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), 'CheckCircle');



var $Fo7oF = parcelRequire("Fo7oF");

var $3yRq4 = parcelRequire("3yRq4");
var /**
 * @ignore - internal component.
 */ $ea52cd8195062d1e$export$2e2bcd8739ae039 = (0, $3yRq4.default)(/*#__PURE__*/ $Fo7oF.createElement("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning');



var $5rVgt = parcelRequire("5rVgt");

var $72Yet = parcelRequire("72Yet");
var $74de1f35dc5dc886$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'block',
            color: theme.palette.text.disabled,
            '&$completed': {
                color: theme.palette.primary.main
            },
            '&$active': {
                color: theme.palette.primary.main
            },
            '&$error': {
                color: theme.palette.error.main
            }
        },
        /* Styles applied to the SVG text element. */ text: {
            fill: theme.palette.primary.contrastText,
            fontSize: theme.typography.caption.fontSize,
            fontFamily: theme.typography.fontFamily
        },
        /* Pseudo-class applied to the root element if `active={true}`. */ active: {},
        /* Pseudo-class applied to the root element if `completed={true}`. */ completed: {},
        /* Pseudo-class applied to the root element if `error={true}`. */ error: {}
    };
};
var $74de1f35dc5dc886$var$_ref = /*#__PURE__*/ $Fo7oF.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12"
});
var $74de1f35dc5dc886$var$StepIcon = /*#__PURE__*/ $Fo7oF.forwardRef(function StepIcon(props, ref) {
    var _props$completed = props.completed, completed = _props$completed === void 0 ? false : _props$completed, icon = props.icon, _props$active = props.active, active = _props$active === void 0 ? false : _props$active, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, classes = props.classes;
    if (typeof icon === 'number' || typeof icon === 'string') {
        var className = (0, $78z8j.default)(classes.root, active && classes.active, error && classes.error, completed && classes.completed);
        if (error) return /*#__PURE__*/ $Fo7oF.createElement((0, $ea52cd8195062d1e$export$2e2bcd8739ae039), {
            className: className,
            ref: ref
        });
        if (completed) return /*#__PURE__*/ $Fo7oF.createElement((0, $d2e230784a283c76$export$2e2bcd8739ae039), {
            className: className,
            ref: ref
        });
        return /*#__PURE__*/ $Fo7oF.createElement((0, $72Yet.default), {
            className: className,
            ref: ref
        }, $74de1f35dc5dc886$var$_ref, /*#__PURE__*/ $Fo7oF.createElement("text", {
            className: classes.text,
            x: "12",
            y: "16",
            textAnchor: "middle"
        }, icon));
    }
    return icon;
});
var $74de1f35dc5dc886$export$2e2bcd8739ae039 = (0, $5rVgt.default)($74de1f35dc5dc886$export$9dd6ff9ea0189349, {
    name: 'MuiStepIcon'
})($74de1f35dc5dc886$var$StepIcon);


var $7a09dab997ab6c9a$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'flex',
            alignItems: 'center',
            '&$alternativeLabel': {
                flexDirection: 'column'
            },
            '&$disabled': {
                cursor: 'default'
            }
        },
        /* Styles applied to the root element if `orientation="horizontal"`. */ horizontal: {},
        /* Styles applied to the root element if `orientation="vertical"`. */ vertical: {},
        /* Styles applied to the `Typography` component which wraps `children`. */ label: {
            color: theme.palette.text.secondary,
            '&$active': {
                color: theme.palette.text.primary,
                fontWeight: 500
            },
            '&$completed': {
                color: theme.palette.text.primary,
                fontWeight: 500
            },
            '&$alternativeLabel': {
                textAlign: 'center',
                marginTop: 16
            },
            '&$error': {
                color: theme.palette.error.main
            }
        },
        /* Pseudo-class applied to the `Typography` component if `active={true}`. */ active: {},
        /* Pseudo-class applied to the `Typography` component if `completed={true}`. */ completed: {},
        /* Pseudo-class applied to the root element and `Typography` component if `error={true}`. */ error: {},
        /* Pseudo-class applied to the root element and `Typography` component if `disabled={true}`. */ disabled: {},
        /* Styles applied to the `icon` container element. */ iconContainer: {
            flexShrink: 0,
            // Fix IE 11 issue
            display: 'flex',
            paddingRight: 8,
            '&$alternativeLabel': {
                paddingRight: 0
            }
        },
        /* Pseudo-class applied to the root and icon container and `Typography` if `alternativeLabel={true}`. */ alternativeLabel: {},
        /* Styles applied to the container element which wraps `Typography` and `optional`. */ labelContainer: {
            width: '100%'
        }
    };
};
var $7a09dab997ab6c9a$var$StepLabel = /*#__PURE__*/ $Fo7oF.forwardRef(function StepLabel(props, ref) {
    var _props$active = props.active, active = _props$active === void 0 ? false : _props$active, _props$alternativeLab = props.alternativeLabel, alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab, children = props.children, classes = props.classes, className = props.className, _props$completed = props.completed, completed = _props$completed === void 0 ? false : _props$completed, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, expanded = props.expanded, icon = props.icon, last = props.last, optional = props.optional, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation, StepIconComponentProp = props.StepIconComponent, StepIconProps = props.StepIconProps, other = (0, $67mp8.default)(props, [
        "active",
        "alternativeLabel",
        "children",
        "classes",
        "className",
        "completed",
        "disabled",
        "error",
        "expanded",
        "icon",
        "last",
        "optional",
        "orientation",
        "StepIconComponent",
        "StepIconProps"
    ]);
    var StepIconComponent = StepIconComponentProp;
    if (icon && !StepIconComponent) StepIconComponent = (0, $74de1f35dc5dc886$export$2e2bcd8739ae039);
    return /*#__PURE__*/ $Fo7oF.createElement("span", (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, classes[orientation], className, disabled && classes.disabled, alternativeLabel && classes.alternativeLabel, error && classes.error),
        ref: ref
    }, other), icon || StepIconComponent ? /*#__PURE__*/ $Fo7oF.createElement("span", {
        className: (0, $78z8j.default)(classes.iconContainer, alternativeLabel && classes.alternativeLabel)
    }, /*#__PURE__*/ $Fo7oF.createElement(StepIconComponent, (0, $elnlQ.default)({
        completed: completed,
        active: active,
        error: error,
        icon: icon
    }, StepIconProps))) : null, /*#__PURE__*/ $Fo7oF.createElement("span", {
        className: classes.labelContainer
    }, children ? /*#__PURE__*/ $Fo7oF.createElement((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
        variant: "body2",
        component: "span",
        display: "block",
        className: (0, $78z8j.default)(classes.label, alternativeLabel && classes.alternativeLabel, completed && classes.completed, active && classes.active, error && classes.error)
    }, children) : null, optional));
});
$7a09dab997ab6c9a$var$StepLabel.muiName = 'StepLabel';
var $7a09dab997ab6c9a$export$2e2bcd8739ae039 = (0, $5rVgt.default)($7a09dab997ab6c9a$export$9dd6ff9ea0189349, {
    name: 'MuiStepLabel'
})($7a09dab997ab6c9a$var$StepLabel);



var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");


var $72Yet = parcelRequire("72Yet");

async function $978f9aa25fa80483$export$2e2bcd8739ae039(envelopeId, signer) {
    const body = {
        envelopeID: envelopeId,
        signerName: signer.signerName,
        signerEmail: signer.signerEmail,
        routingOrder: signer.signingOrder,
        clientUserId: null
    };
    try {
        const signNowURL = await (0, $c04283212adf4fb0$export$c4b7edec3f76b207)('/api/esign/sign-now', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify(body)
        });
        const a = document.createElement('a');
        a.target = '_blank';
        a.rel = 'noopener';
        a.href = signNowURL.url;
        a.click();
    } catch (err) {
        /* eslint-disable no-console */ console.log('Error fetching sign-now url:', err);
    }
}


const $f4267c9105e002e8$export$19bc16ee58e19b3d = ({ className: className })=>/*#__PURE__*/ (0, $eFTP6.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $eFTP6.jsxs)("svg", {
            "aria-hidden": "true",
            focusable: "false",
            height: "24",
            viewBox: "0 0 24 24",
            width: "24",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)("path", {
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)("path", {
                    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z",
                    fill: "#D24625",
                    fillRule: "nonzero"
                })
            ]
        })
    });
const $f4267c9105e002e8$export$63b4fc557d1c57af = ({ className: className, size: size })=>/*#__PURE__*/ (0, $eFTP6.jsx)("span", {
        className: className,
        children: /*#__PURE__*/ (0, $eFTP6.jsxs)("svg", {
            "aria-hidden": "true",
            fill: "#367c2b",
            focusable: "false",
            height: size,
            viewBox: "0 0 24 24",
            width: size,
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)("path", {
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)("path", {
                    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                })
            ]
        })
    });
const $f4267c9105e002e8$export$5068802198d106bd = ({ className: className })=>/*#__PURE__*/ (0, $eFTP6.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $eFTP6.jsxs)("svg", {
            "aria-hidden": "true",
            fill: "#666666",
            focusable: "false",
            height: "24",
            viewBox: "0 0 24 24",
            width: "24",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)("path", {
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)("path", {
                    d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"
                })
            ]
        })
    });
const $f4267c9105e002e8$export$7dcc8f518762622d = ({ className: className })=>/*#__PURE__*/ (0, $eFTP6.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $eFTP6.jsxs)("svg", {
            "aria-hidden": "true",
            fill: "#666666",
            focusable: "false",
            height: "24",
            viewBox: "0 0 24 24",
            width: "24",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)("path", {
                    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)("path", {
                    d: "M0 0h24v24H0z",
                    fill: "none"
                })
            ]
        })
    });
const $f4267c9105e002e8$export$f7dc499a72baa103 = ()=>/*#__PURE__*/ (0, $eFTP6.jsx)("div", {
        children: /*#__PURE__*/ (0, $eFTP6.jsxs)("svg", {
            "aria-hidden": "true",
            focusable: "false",
            height: "24",
            viewBox: "0 0 24 24",
            width: "24",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)("path", {
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)("path", {
                    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z",
                    fill: "#D24625",
                    fillRule: "nonzero"
                })
            ]
        })
    });
const $f4267c9105e002e8$export$7b50ffef9166d695 = ()=>/*#__PURE__*/ (0, $eFTP6.jsx)("div", {
        children: /*#__PURE__*/ (0, $eFTP6.jsxs)("svg", {
            "aria-hidden": "true",
            fill: "#666666",
            focusable: "false",
            height: "20",
            viewBox: "0 0 24 24",
            width: "20",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)("path", {
                    d: "M17.65 6.35A7.958 7.958 0 0 0 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)("path", {
                    d: "M0 0h24v24H0z",
                    fill: "none"
                })
            ]
        })
    });
const $f4267c9105e002e8$export$fe708d541030d854 = ({ size: size })=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Spinner), {
        accessibilityLabel: "Processing...",
        animation: "border",
        className: 'uxf-spinner-border-' + size
    });
const $f4267c9105e002e8$export$92c8767b874048d = ({ color: color })=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $72Yet.default), {
        children: /*#__PURE__*/ (0, $eFTP6.jsxs)("svg", {
            "aria-hidden": "true",
            fill: color,
            focusable: "false",
            height: "23",
            viewBox: "0 0 24 24",
            width: "23",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)("path", {
                    d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)("path", {
                    d: "M0 0h24v24H0z",
                    fill: "none"
                })
            ]
        })
    });
function $f4267c9105e002e8$export$fd4688af832bd039({ signer: signer, envelopeId: envelopeId }) {
    const handleSignNowClick = (e)=>{
        e.stopPropagation();
        (0, $978f9aa25fa80483$export$2e2bcd8739ae039)(envelopeId, signer);
    };
    return /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
        className: "pl-2",
        onClick: (e)=>handleSignNowClick(e),
        title: "Sign now",
        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $72Yet.default), {
            children: /*#__PURE__*/ (0, $eFTP6.jsxs)("svg", {
                "aria-hidden": "true",
                className: "pl-1",
                fill: "#FFFFFF",
                focusable: "false",
                height: "24",
                viewBox: "0 0 24 24",
                width: "20",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsx)("path", {
                        d: "M0 0h24v24H0z",
                        fill: "none"
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)("path", {
                        d: "M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
                    })
                ]
            })
        })
    });
}


const $ce7657dc4dcb9e28$export$a47fb462a08de82f = ()=>Math.floor(Math.random() * 100000 + 1);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $Fo7oF = parcelRequire("Fo7oF");

var $3yRq4 = parcelRequire("3yRq4");
var /**
 * @ignore - internal component.
 */ $961b6156cd6d3fb4$export$2e2bcd8739ae039 = (0, $3yRq4.default)(/*#__PURE__*/ $Fo7oF.createElement("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');



var $5rVgt = parcelRequire("5rVgt");

var $8Hh6N = parcelRequire("8Hh6N");



var $bT5dp = parcelRequire("bT5dp");

var $88209bc93a38e520$export$9dd6ff9ea0189349 = function styles(theme) {
    var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
    var deleteIconColor = (0, $8Hh6N.alpha)(theme.palette.text.primary, 0.26);
    return {
        /* Styles applied to the root element. */ root: {
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(13),
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 32,
            color: theme.palette.getContrastText(backgroundColor),
            backgroundColor: backgroundColor,
            borderRadius: 16,
            whiteSpace: 'nowrap',
            transition: theme.transitions.create([
                'background-color',
                'box-shadow'
            ]),
            // label will inherit this from root, then `clickable` class overrides this for both
            cursor: 'default',
            // We disable the focus ring for mouse, touch and keyboard users.
            outline: 0,
            textDecoration: 'none',
            border: 'none',
            // Remove `button` border
            padding: 0,
            // Remove `button` padding
            verticalAlign: 'middle',
            boxSizing: 'border-box',
            '&$disabled': {
                opacity: 0.5,
                pointerEvents: 'none'
            },
            '& $avatar': {
                marginLeft: 5,
                marginRight: -6,
                width: 24,
                height: 24,
                color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
                fontSize: theme.typography.pxToRem(12)
            },
            '& $avatarColorPrimary': {
                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.primary.dark
            },
            '& $avatarColorSecondary': {
                color: theme.palette.secondary.contrastText,
                backgroundColor: theme.palette.secondary.dark
            },
            '& $avatarSmall': {
                marginLeft: 4,
                marginRight: -4,
                width: 18,
                height: 18,
                fontSize: theme.typography.pxToRem(10)
            }
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            height: 24
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */ clickable: {
            userSelect: 'none',
            WebkitTapHighlightColor: 'transparent',
            cursor: 'pointer',
            '&:hover, &:focus': {
                backgroundColor: (0, $8Hh6N.emphasize)(backgroundColor, 0.08)
            },
            '&:active': {
                boxShadow: theme.shadows[1]
            }
        },
        /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */ clickableColorPrimary: {
            '&:hover, &:focus': {
                backgroundColor: (0, $8Hh6N.emphasize)(theme.palette.primary.main, 0.08)
            }
        },
        /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */ clickableColorSecondary: {
            '&:hover, &:focus': {
                backgroundColor: (0, $8Hh6N.emphasize)(theme.palette.secondary.main, 0.08)
            }
        },
        /* Styles applied to the root element if `onDelete` is defined. */ deletable: {
            '&:focus': {
                backgroundColor: (0, $8Hh6N.emphasize)(backgroundColor, 0.08)
            }
        },
        /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */ deletableColorPrimary: {
            '&:focus': {
                backgroundColor: (0, $8Hh6N.emphasize)(theme.palette.primary.main, 0.2)
            }
        },
        /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */ deletableColorSecondary: {
            '&:focus': {
                backgroundColor: (0, $8Hh6N.emphasize)(theme.palette.secondary.main, 0.2)
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            backgroundColor: 'transparent',
            border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
            '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
                backgroundColor: (0, $8Hh6N.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
            },
            '& $avatar': {
                marginLeft: 4
            },
            '& $avatarSmall': {
                marginLeft: 2
            },
            '& $icon': {
                marginLeft: 4
            },
            '& $iconSmall': {
                marginLeft: 2
            },
            '& $deleteIcon': {
                marginRight: 5
            },
            '& $deleteIconSmall': {
                marginRight: 3
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat(theme.palette.primary.main),
            '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
                backgroundColor: (0, $8Hh6N.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat(theme.palette.secondary.main),
            '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
                backgroundColor: (0, $8Hh6N.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
            }
        },
        // TODO v5: remove
        /* Styles applied to the `avatar` element. */ avatar: {},
        /* Styles applied to the `avatar` element if `size="small"`. */ avatarSmall: {},
        /* Styles applied to the `avatar` element if `color="primary"`. */ avatarColorPrimary: {},
        /* Styles applied to the `avatar` element if `color="secondary"`. */ avatarColorSecondary: {},
        /* Styles applied to the `icon` element. */ icon: {
            color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
            marginLeft: 5,
            marginRight: -6
        },
        /* Styles applied to the `icon` element if `size="small"`. */ iconSmall: {
            width: 18,
            height: 18,
            marginLeft: 4,
            marginRight: -4
        },
        /* Styles applied to the `icon` element if `color="primary"`. */ iconColorPrimary: {
            color: 'inherit'
        },
        /* Styles applied to the `icon` element if `color="secondary"`. */ iconColorSecondary: {
            color: 'inherit'
        },
        /* Styles applied to the label `span` element. */ label: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            paddingLeft: 12,
            paddingRight: 12,
            whiteSpace: 'nowrap'
        },
        /* Styles applied to the label `span` element if `size="small"`. */ labelSmall: {
            paddingLeft: 8,
            paddingRight: 8
        },
        /* Styles applied to the `deleteIcon` element. */ deleteIcon: {
            WebkitTapHighlightColor: 'transparent',
            color: deleteIconColor,
            height: 22,
            width: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: (0, $8Hh6N.alpha)(deleteIconColor, 0.4)
            }
        },
        /* Styles applied to the `deleteIcon` element if `size="small"`. */ deleteIconSmall: {
            height: 16,
            width: 16,
            marginRight: 4,
            marginLeft: -4
        },
        /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */ deleteIconColorPrimary: {
            color: (0, $8Hh6N.alpha)(theme.palette.primary.contrastText, 0.7),
            '&:hover, &:active': {
                color: theme.palette.primary.contrastText
            }
        },
        /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */ deleteIconColorSecondary: {
            color: (0, $8Hh6N.alpha)(theme.palette.secondary.contrastText, 0.7),
            '&:hover, &:active': {
                color: theme.palette.secondary.contrastText
            }
        },
        /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */ deleteIconOutlinedColorPrimary: {
            color: (0, $8Hh6N.alpha)(theme.palette.primary.main, 0.7),
            '&:hover, &:active': {
                color: theme.palette.primary.main
            }
        },
        /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */ deleteIconOutlinedColorSecondary: {
            color: (0, $8Hh6N.alpha)(theme.palette.secondary.main, 0.7),
            '&:hover, &:active': {
                color: theme.palette.secondary.main
            }
        }
    };
};
function $88209bc93a38e520$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ var $88209bc93a38e520$var$Chip = /*#__PURE__*/ $Fo7oF.forwardRef(function Chip(props, ref) {
    var avatarProp = props.avatar, classes = props.classes, className = props.className, clickableProp = props.clickable, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, ComponentProp = props.component, deleteIconProp = props.deleteIcon, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, iconProp = props.icon, label = props.label, onClick = props.onClick, onDelete = props.onDelete, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, _props$variant = props.variant, variant = _props$variant === void 0 ? 'default' : _props$variant, other = (0, $67mp8.default)(props, [
        "avatar",
        "classes",
        "className",
        "clickable",
        "color",
        "component",
        "deleteIcon",
        "disabled",
        "icon",
        "label",
        "onClick",
        "onDelete",
        "onKeyDown",
        "onKeyUp",
        "size",
        "variant"
    ]);
    var chipRef = $Fo7oF.useRef(null);
    var handleRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(chipRef, ref);
    var handleDeleteIconClick = function handleDeleteIconClick(event) {
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    var handleKeyDown = function handleKeyDown(event) {
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $88209bc93a38e520$var$isDeleteKeyboardEvent(event)) // will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    var handleKeyUp = function handleKeyUp(event) {
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $88209bc93a38e520$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === 'Escape' && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    var clickable = clickableProp !== false && onClick ? true : clickableProp;
    var small = size === 'small';
    var Component = ComponentProp || (clickable ? (0, $67b46b5fd967aa2b$export$2e2bcd8739ae039) : 'div');
    var moreProps = Component === (0, $67b46b5fd967aa2b$export$2e2bcd8739ae039) ? {
        component: 'div'
    } : {};
    var deleteIcon = null;
    if (onDelete) {
        var customClasses = (0, $78z8j.default)(color !== 'default' && (variant === "default" ? classes["deleteIconColor".concat((0, $bT5dp.default)(color))] : classes["deleteIconOutlinedColor".concat((0, $bT5dp.default)(color))]), small && classes.deleteIconSmall);
        deleteIcon = deleteIconProp && /*#__PURE__*/ $Fo7oF.isValidElement(deleteIconProp) ? /*#__PURE__*/ $Fo7oF.cloneElement(deleteIconProp, {
            className: (0, $78z8j.default)(deleteIconProp.props.className, classes.deleteIcon, customClasses),
            onClick: handleDeleteIconClick
        }) : /*#__PURE__*/ $Fo7oF.createElement((0, $961b6156cd6d3fb4$export$2e2bcd8739ae039), {
            className: (0, $78z8j.default)(classes.deleteIcon, customClasses),
            onClick: handleDeleteIconClick
        });
    }
    var avatar = null;
    if (avatarProp && /*#__PURE__*/ $Fo7oF.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $Fo7oF.cloneElement(avatarProp, {
        className: (0, $78z8j.default)(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== 'default' && classes["avatarColor".concat((0, $bT5dp.default)(color))])
    });
    var icon = null;
    if (iconProp && /*#__PURE__*/ $Fo7oF.isValidElement(iconProp)) icon = /*#__PURE__*/ $Fo7oF.cloneElement(iconProp, {
        className: (0, $78z8j.default)(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== 'default' && classes["iconColor".concat((0, $bT5dp.default)(color))])
    });
    return /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        role: clickable || onDelete ? 'button' : undefined,
        className: (0, $78z8j.default)(classes.root, className, color !== 'default' && [
            classes["color".concat((0, $bT5dp.default)(color))],
            clickable && classes["clickableColor".concat((0, $bT5dp.default)(color))],
            onDelete && classes["deletableColor".concat((0, $bT5dp.default)(color))]
        ], variant !== "default" && [
            classes.outlined,
            {
                'primary': classes.outlinedPrimary,
                'secondary': classes.outlinedSecondary
            }[color]
        ], disabled && classes.disabled, small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable),
        "aria-disabled": disabled ? true : undefined,
        tabIndex: clickable || onDelete ? 0 : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef
    }, moreProps, other), avatar || icon, /*#__PURE__*/ $Fo7oF.createElement("span", {
        className: (0, $78z8j.default)(classes.label, small && classes.labelSmall)
    }, label), deleteIcon);
});
var $88209bc93a38e520$export$2e2bcd8739ae039 = (0, $5rVgt.default)($88209bc93a38e520$export$9dd6ff9ea0189349, {
    name: 'MuiChip'
})($88209bc93a38e520$var$Chip);



var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");


var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $d2vKa = parcelRequire("d2vKa");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");

var $bT5dp = parcelRequire("bT5dp");



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");

var $elnlQ = parcelRequire("elnlQ");

var $8YHhK = parcelRequire("8YHhK");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $dOG8L = parcelRequire("dOG8L");

var $6N3by = parcelRequire("6N3by");



var $44d4d41e4c45d846$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
var $44d4d41e4c45d846$var$defaultTimeout = {
    enter: (0, $6N3by.duration).enteringScreen,
    exit: (0, $6N3by.duration).leavingScreen
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $44d4d41e4c45d846$var$Fade = /*#__PURE__*/ $Fo7oF.forwardRef(function Fade(props, ref) {
    var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $dOG8L.default) : _props$TransitionComp, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? $44d4d41e4c45d846$var$defaultTimeout : _props$timeout, other = (0, $67mp8.default)(props, [
        "children",
        "disableStrictModeCompat",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "TransitionComponent",
        "timeout"
    ]);
    var theme = (0, $c6db41e315144c8b$export$2e2bcd8739ae039)();
    var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
    var nodeRef = $Fo7oF.useRef(null);
    var foreignRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(children.ref, ref);
    var handleRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(enableStrictModeCompat ? nodeRef : undefined, foreignRef);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(nodeOrAppearing, maybeAppearing) {
            if (callback) {
                var _ref = enableStrictModeCompat ? [
                    nodeRef.current,
                    nodeOrAppearing
                ] : [
                    nodeOrAppearing,
                    maybeAppearing
                ], _ref2 = (0, $8YHhK.default)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(node);
                else callback(node, isAppearing);
            }
        };
    };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        (0, $f7011715ddf0f929$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        var transitionProps = (0, $f7011715ddf0f929$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var transitionProps = (0, $f7011715ddf0f929$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(onExited);
    return /*#__PURE__*/ $Fo7oF.createElement(TransitionComponent, (0, $elnlQ.default)({
        appear: true,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        timeout: timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $Fo7oF.cloneElement(children, (0, $elnlQ.default)({
            style: (0, $elnlQ.default)({
                opacity: 0,
                visibility: state === 'exited' && !inProp ? 'hidden' : undefined
            }, $44d4d41e4c45d846$var$styles[state], style, children.props.style),
            ref: handleRef
        }, childProps));
    });
});
var $44d4d41e4c45d846$export$2e2bcd8739ae039 = $44d4d41e4c45d846$var$Fade;


var $eb7b6c5456053c3a$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        // Improve scrollable dialog support.
        zIndex: -1,
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    },
    /* Styles applied to the root element if `invisible={true}`. */ invisible: {
        backgroundColor: 'transparent'
    }
};
var $eb7b6c5456053c3a$var$Backdrop = /*#__PURE__*/ $Fo7oF.forwardRef(function Backdrop(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, transitionDuration = props.transitionDuration, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $44d4d41e4c45d846$export$2e2bcd8739ae039) : _props$TransitionComp, other = (0, $67mp8.default)(props, [
        "children",
        "classes",
        "className",
        "invisible",
        "open",
        "transitionDuration",
        "TransitionComponent"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement(TransitionComponent, (0, $elnlQ.default)({
        in: open,
        timeout: transitionDuration
    }, other), /*#__PURE__*/ $Fo7oF.createElement("div", {
        className: (0, $78z8j.default)(classes.root, className, invisible && classes.invisible),
        "aria-hidden": true,
        ref: ref
    }, children));
});
var $eb7b6c5456053c3a$export$2e2bcd8739ae039 = (0, $5rVgt.default)($eb7b6c5456053c3a$export$9dd6ff9ea0189349, {
    name: 'MuiBackdrop'
})($eb7b6c5456053c3a$var$Backdrop);




var $6N3by = parcelRequire("6N3by");

var $06c828c7d8d76aa9$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            '@media print': {
                // Use !important to override the Modal inline-style.
                position: 'absolute !important'
            }
        },
        /* Styles applied to the container element if `scroll="paper"`. */ scrollPaper: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        /* Styles applied to the container element if `scroll="body"`. */ scrollBody: {
            overflowY: 'auto',
            overflowX: 'hidden',
            textAlign: 'center',
            '&:after': {
                content: '""',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0'
            }
        },
        /* Styles applied to the container element. */ container: {
            height: '100%',
            '@media print': {
                height: 'auto'
            },
            // We disable the focus ring for mouse, touch and keyboard users.
            outline: 0
        },
        /* Styles applied to the `Paper` component. */ paper: {
            margin: 32,
            position: 'relative',
            overflowY: 'auto',
            // Fix IE 11 issue, to remove at some point.
            '@media print': {
                overflowY: 'visible',
                boxShadow: 'none'
            }
        },
        /* Styles applied to the `Paper` component if `scroll="paper"`. */ paperScrollPaper: {
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'calc(100% - 64px)'
        },
        /* Styles applied to the `Paper` component if `scroll="body"`. */ paperScrollBody: {
            display: 'inline-block',
            verticalAlign: 'middle',
            textAlign: 'left' // 'initial' doesn't work on IE 11
        },
        /* Styles applied to the `Paper` component if `maxWidth=false`. */ paperWidthFalse: {
            maxWidth: 'calc(100% - 64px)'
        },
        /* Styles applied to the `Paper` component if `maxWidth="xs"`. */ paperWidthXs: {
            maxWidth: Math.max(theme.breakpoints.values.xs, 444),
            '&$paperScrollBody': (0, $d2vKa.default)({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="sm"`. */ paperWidthSm: {
            maxWidth: theme.breakpoints.values.sm,
            '&$paperScrollBody': (0, $d2vKa.default)({}, theme.breakpoints.down(theme.breakpoints.values.sm + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="md"`. */ paperWidthMd: {
            maxWidth: theme.breakpoints.values.md,
            '&$paperScrollBody': (0, $d2vKa.default)({}, theme.breakpoints.down(theme.breakpoints.values.md + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="lg"`. */ paperWidthLg: {
            maxWidth: theme.breakpoints.values.lg,
            '&$paperScrollBody': (0, $d2vKa.default)({}, theme.breakpoints.down(theme.breakpoints.values.lg + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `maxWidth="xl"`. */ paperWidthXl: {
            maxWidth: theme.breakpoints.values.xl,
            '&$paperScrollBody': (0, $d2vKa.default)({}, theme.breakpoints.down(theme.breakpoints.values.xl + 64), {
                maxWidth: 'calc(100% - 64px)'
            })
        },
        /* Styles applied to the `Paper` component if `fullWidth={true}`. */ paperFullWidth: {
            width: 'calc(100% - 64px)'
        },
        /* Styles applied to the `Paper` component if `fullScreen={true}`. */ paperFullScreen: {
            margin: 0,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: 'none',
            borderRadius: 0,
            '&$paperScrollBody': {
                margin: 0,
                maxWidth: '100%'
            }
        }
    };
};
var $06c828c7d8d76aa9$var$defaultTransitionDuration = {
    enter: (0, $6N3by.duration).enteringScreen,
    exit: (0, $6N3by.duration).leavingScreen
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ var $06c828c7d8d76aa9$var$Dialog = /*#__PURE__*/ $Fo7oF.forwardRef(function Dialog(props, ref) {
    var BackdropProps = props.BackdropProps, children = props.children, classes = props.classes, className = props.className, _props$disableBackdro = props.disableBackdropClick, disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableEscapeK = props.disableEscapeKeyDown, disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK, _props$fullScreen = props.fullScreen, fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$maxWidth = props.maxWidth, maxWidth = _props$maxWidth === void 0 ? 'sm' : _props$maxWidth, onBackdropClick = props.onBackdropClick, onClose = props.onClose, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onEscapeKeyDown = props.onEscapeKeyDown, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, open = props.open, _props$PaperComponent = props.PaperComponent, PaperComponent = _props$PaperComponent === void 0 ? (0, $fe0aa9e32766c0f5$export$2e2bcd8739ae039) : _props$PaperComponent, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, _props$scroll = props.scroll, scroll = _props$scroll === void 0 ? 'paper' : _props$scroll, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $44d4d41e4c45d846$export$2e2bcd8739ae039) : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? $06c828c7d8d76aa9$var$defaultTransitionDuration : _props$transitionDura, TransitionProps = props.TransitionProps, ariaDescribedby = props['aria-describedby'], ariaLabelledby = props['aria-labelledby'], other = (0, $67mp8.default)(props, [
        "BackdropProps",
        "children",
        "classes",
        "className",
        "disableBackdropClick",
        "disableEscapeKeyDown",
        "fullScreen",
        "fullWidth",
        "maxWidth",
        "onBackdropClick",
        "onClose",
        "onEnter",
        "onEntered",
        "onEntering",
        "onEscapeKeyDown",
        "onExit",
        "onExited",
        "onExiting",
        "open",
        "PaperComponent",
        "PaperProps",
        "scroll",
        "TransitionComponent",
        "transitionDuration",
        "TransitionProps",
        "aria-describedby",
        "aria-labelledby"
    ]);
    var mouseDownTarget = $Fo7oF.useRef();
    var handleMouseDown = function handleMouseDown(event) {
        mouseDownTarget.current = event.target;
    };
    var handleBackdropClick = function handleBackdropClick(event) {
        // Ignore the events not coming from the "backdrop"
        // We don't want to close the dialog when clicking the dialog content.
        if (event.target !== event.currentTarget) return;
         // Make sure the event starts and ends on the same DOM element.
        if (event.target !== mouseDownTarget.current) return;
        mouseDownTarget.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (!disableBackdropClick && onClose) onClose(event, 'backdropClick');
    };
    return /*#__PURE__*/ $Fo7oF.createElement((0, $1a75137825249088$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className),
        BackdropComponent: (0, $eb7b6c5456053c3a$export$2e2bcd8739ae039),
        BackdropProps: (0, $elnlQ.default)({
            transitionDuration: transitionDuration
        }, BackdropProps),
        closeAfterTransition: true
    }, disableBackdropClick ? {
        disableBackdropClick: disableBackdropClick
    } : {}, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        onEscapeKeyDown: onEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref
    }, other), /*#__PURE__*/ $Fo7oF.createElement(TransitionComponent, (0, $elnlQ.default)({
        appear: true,
        in: open,
        timeout: transitionDuration,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited,
        role: "none presentation"
    }, TransitionProps), /*#__PURE__*/ $Fo7oF.createElement("div", {
        className: (0, $78z8j.default)(classes.container, classes["scroll".concat((0, $bT5dp.default)(scroll))]),
        onMouseUp: handleBackdropClick,
        onMouseDown: handleMouseDown
    }, /*#__PURE__*/ $Fo7oF.createElement(PaperComponent, (0, $elnlQ.default)({
        elevation: 24,
        role: "dialog",
        "aria-describedby": ariaDescribedby,
        "aria-labelledby": ariaLabelledby
    }, PaperProps, {
        className: (0, $78z8j.default)(classes.paper, classes["paperScroll".concat((0, $bT5dp.default)(scroll))], classes["paperWidth".concat((0, $bT5dp.default)(String(maxWidth)))], PaperProps.className, fullScreen && classes.paperFullScreen, fullWidth && classes.paperFullWidth)
    }), children))));
});
var $06c828c7d8d76aa9$export$2e2bcd8739ae039 = (0, $5rVgt.default)($06c828c7d8d76aa9$export$9dd6ff9ea0189349, {
    name: 'MuiDialog'
})($06c828c7d8d76aa9$var$Dialog);



var $57b96121aa7aac71$exports = {};
"use strict";


Object.defineProperty($57b96121aa7aac71$exports, "__esModule", {
    value: true
});
$57b96121aa7aac71$exports.default = void 0;

var $57b96121aa7aac71$var$React = $e542637ee86bba6a$exports((parcelRequire("Fo7oF")));

var $57b96121aa7aac71$var$_createSvgIcon = $368639c97fe780bf$exports((parcelRequire("bI8Gq")));
var $57b96121aa7aac71$var$_default = (0, $57b96121aa7aac71$var$_createSvgIcon.default)(/*#__PURE__*/ $57b96121aa7aac71$var$React.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');
$57b96121aa7aac71$exports.default = $57b96121aa7aac71$var$_default;





var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");
var $1c55bad717a43115$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            flex: '1 1 auto',
            WebkitOverflowScrolling: 'touch',
            // Add iOS momentum scrolling.
            overflowY: 'auto',
            padding: '8px 24px',
            '&:first-child': {
                // dialog without title
                paddingTop: 20
            }
        },
        /* Styles applied to the root element if `dividers={true}`. */ dividers: {
            padding: '16px 24px',
            borderTop: "1px solid ".concat(theme.palette.divider),
            borderBottom: "1px solid ".concat(theme.palette.divider)
        }
    };
};
var $1c55bad717a43115$var$DialogContent = /*#__PURE__*/ $Fo7oF.forwardRef(function DialogContent(props, ref) {
    var classes = props.classes, className = props.className, _props$dividers = props.dividers, dividers = _props$dividers === void 0 ? false : _props$dividers, other = (0, $67mp8.default)(props, [
        "classes",
        "className",
        "dividers"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement("div", (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className, dividers && classes.dividers),
        ref: ref
    }, other));
});
var $1c55bad717a43115$export$2e2bcd8739ae039 = (0, $5rVgt.default)($1c55bad717a43115$export$9dd6ff9ea0189349, {
    name: 'MuiDialogContent'
})($1c55bad717a43115$var$DialogContent);


var $21bf5b2cd2866b79$exports = {};
"use strict";


Object.defineProperty($21bf5b2cd2866b79$exports, "__esModule", {
    value: true
});
$21bf5b2cd2866b79$exports.default = void 0;

var $21bf5b2cd2866b79$var$React = $e542637ee86bba6a$exports((parcelRequire("Fo7oF")));

var $21bf5b2cd2866b79$var$_createSvgIcon = $368639c97fe780bf$exports((parcelRequire("bI8Gq")));
var $21bf5b2cd2866b79$var$_default = (0, $21bf5b2cd2866b79$var$_createSvgIcon.default)(/*#__PURE__*/ $21bf5b2cd2866b79$var$React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
}), 'AccountCircle');
$21bf5b2cd2866b79$exports.default = $21bf5b2cd2866b79$var$_default;



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");
var $1b29532bd4542510$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'flex',
        alignItems: 'center',
        padding: 8,
        justifyContent: 'flex-end',
        flex: '0 0 auto'
    },
    /* Styles applied to the root element if `disableSpacing={false}`. */ spacing: {
        '& > :not(:first-child)': {
            marginLeft: 8
        }
    }
};
var $1b29532bd4542510$var$DialogActions = /*#__PURE__*/ $Fo7oF.forwardRef(function DialogActions(props, ref) {
    var _props$disableSpacing = props.disableSpacing, disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing, classes = props.classes, className = props.className, other = (0, $67mp8.default)(props, [
        "disableSpacing",
        "classes",
        "className"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement("div", (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className, !disableSpacing && classes.spacing),
        ref: ref
    }, other));
});
var $1b29532bd4542510$export$2e2bcd8739ae039 = (0, $5rVgt.default)($1b29532bd4542510$export$9dd6ff9ea0189349, {
    name: 'MuiDialogActions'
})($1b29532bd4542510$var$DialogActions);


var $0045f42ade89216a$exports = {};

$parcel$export($0045f42ade89216a$exports, "declinedDiv", () => $0045f42ade89216a$export$c971eb08ca17ce51, (v) => $0045f42ade89216a$export$c971eb08ca17ce51 = v);
$parcel$export($0045f42ade89216a$exports, "dialogContentRow", () => $0045f42ade89216a$export$7840920ab919725e, (v) => $0045f42ade89216a$export$7840920ab919725e = v);
var $0045f42ade89216a$export$c971eb08ca17ce51;
var $0045f42ade89216a$export$7840920ab919725e;
$0045f42ade89216a$export$c971eb08ca17ce51 = "declinedDiv_7fef8e";
$0045f42ade89216a$export$7840920ab919725e = "dialogContentRow_7fef8e";



/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ /******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $21175c20cefb0343$var$extendStatics = function(d, b) {
    $21175c20cefb0343$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $21175c20cefb0343$var$extendStatics(d, b);
};
function $21175c20cefb0343$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $21175c20cefb0343$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $21175c20cefb0343$export$18ce0697a983be9b = function() {
    $21175c20cefb0343$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $21175c20cefb0343$export$18ce0697a983be9b.apply(this, arguments);
};
function $21175c20cefb0343$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $21175c20cefb0343$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $21175c20cefb0343$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $21175c20cefb0343$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $21175c20cefb0343$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $21175c20cefb0343$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $21175c20cefb0343$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $21175c20cefb0343$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $21175c20cefb0343$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $21175c20cefb0343$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $21175c20cefb0343$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $21175c20cefb0343$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $21175c20cefb0343$export$45d3717a4c69092e(o, m, p);
}
function $21175c20cefb0343$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $21175c20cefb0343$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $21175c20cefb0343$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($21175c20cefb0343$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $21175c20cefb0343$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $21175c20cefb0343$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $21175c20cefb0343$export$10c90e4f7922046c(v) {
    return this instanceof $21175c20cefb0343$export$10c90e4f7922046c ? (this.v = v, this) : new $21175c20cefb0343$export$10c90e4f7922046c(v);
}
function $21175c20cefb0343$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $21175c20cefb0343$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $21175c20cefb0343$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $21175c20cefb0343$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $21175c20cefb0343$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $21175c20cefb0343$export$19a8beecd37a4c45 === "function" ? $21175c20cefb0343$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $21175c20cefb0343$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $21175c20cefb0343$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $21175c20cefb0343$var$ownKeys = function(o) {
    $21175c20cefb0343$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $21175c20cefb0343$var$ownKeys(o);
};
function $21175c20cefb0343$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $21175c20cefb0343$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $21175c20cefb0343$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $21175c20cefb0343$var$__setModuleDefault(result, mod);
    return result;
}
function $21175c20cefb0343$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $21175c20cefb0343$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $21175c20cefb0343$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $21175c20cefb0343$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $21175c20cefb0343$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $21175c20cefb0343$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $21175c20cefb0343$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $21175c20cefb0343$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $21175c20cefb0343$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $21175c20cefb0343$export$2e2bcd8739ae039 = {
    __extends: $21175c20cefb0343$export$a8ba968b8961cb8a,
    __assign: $21175c20cefb0343$export$18ce0697a983be9b,
    __rest: $21175c20cefb0343$export$3c9a16f847548506,
    __decorate: $21175c20cefb0343$export$29e00dfd3077644b,
    __param: $21175c20cefb0343$export$d5ad3fd78186038f,
    __esDecorate: $21175c20cefb0343$export$3a84e1ae4e97e9b0,
    __runInitializers: $21175c20cefb0343$export$d831c04e792af3d,
    __propKey: $21175c20cefb0343$export$6a2a36740a146cb8,
    __setFunctionName: $21175c20cefb0343$export$d1a06452d3489bc7,
    __metadata: $21175c20cefb0343$export$f1db080c865becb9,
    __awaiter: $21175c20cefb0343$export$1050f835b63b671e,
    __generator: $21175c20cefb0343$export$67ebef60e6f28a6,
    __createBinding: $21175c20cefb0343$export$45d3717a4c69092e,
    __exportStar: $21175c20cefb0343$export$f33643c0debef087,
    __values: $21175c20cefb0343$export$19a8beecd37a4c45,
    __read: $21175c20cefb0343$export$8d051b38c9118094,
    __spread: $21175c20cefb0343$export$afc72e2116322959,
    __spreadArrays: $21175c20cefb0343$export$6388937ca91ccae8,
    __spreadArray: $21175c20cefb0343$export$1216008129fb82ed,
    __await: $21175c20cefb0343$export$10c90e4f7922046c,
    __asyncGenerator: $21175c20cefb0343$export$e427f37a30a4de9b,
    __asyncDelegator: $21175c20cefb0343$export$bbd80228419bb833,
    __asyncValues: $21175c20cefb0343$export$e3b29a3d6162315f,
    __makeTemplateObject: $21175c20cefb0343$export$4fb47efe1390b86f,
    __importStar: $21175c20cefb0343$export$c21735bcef00d192,
    __importDefault: $21175c20cefb0343$export$da59b14a69baef04,
    __classPrivateFieldGet: $21175c20cefb0343$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $21175c20cefb0343$export$d40a35129aaff81f,
    __classPrivateFieldIn: $21175c20cefb0343$export$81fdc39f203e4e04,
    __addDisposableResource: $21175c20cefb0343$export$88ac25d8e944e405,
    __disposeResources: $21175c20cefb0343$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $21175c20cefb0343$export$889dfb5d17574b0b
};



var $Fo7oF = parcelRequire("Fo7oF");


var $Fo7oF = parcelRequire("Fo7oF");

//
// Main
//
function $63a4f6f651251ed6$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $63a4f6f651251ed6$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $63a4f6f651251ed6$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $63a4f6f651251ed6$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $63a4f6f651251ed6$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $63a4f6f651251ed6$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $63a4f6f651251ed6$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $63a4f6f651251ed6$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $63a4f6f651251ed6$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $63a4f6f651251ed6$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $63a4f6f651251ed6$var$monadic : $63a4f6f651251ed6$var$variadic;
    return $63a4f6f651251ed6$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $63a4f6f651251ed6$var$strategyVariadic(fn, options) {
    return $63a4f6f651251ed6$var$assemble(fn, this, $63a4f6f651251ed6$var$variadic, options.cache.create(), options.serializer);
}
function $63a4f6f651251ed6$var$strategyMonadic(fn, options) {
    return $63a4f6f651251ed6$var$assemble(fn, this, $63a4f6f651251ed6$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $63a4f6f651251ed6$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $63a4f6f651251ed6$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$63a4f6f651251ed6$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$63a4f6f651251ed6$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $63a4f6f651251ed6$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $63a4f6f651251ed6$var$ObjectWithoutPrototypeCache();
    }
};
var $63a4f6f651251ed6$export$c5491a8691a23b9e = {
    variadic: $63a4f6f651251ed6$var$strategyVariadic,
    monadic: $63a4f6f651251ed6$var$strategyMonadic
};


function $a1cc92d68b9862b4$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $a1cc92d68b9862b4$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $a1cc92d68b9862b4$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $a1cc92d68b9862b4$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $a1cc92d68b9862b4$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $a1cc92d68b9862b4$export$3fae2929ed23c202(map, pl, field) {
    return $a1cc92d68b9862b4$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $a1cc92d68b9862b4$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $a1cc92d68b9862b4$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $a1cc92d68b9862b4$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
function $a1cc92d68b9862b4$export$e4e12d57dd938668(target, name, value) {
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: value
    });
}
var $a1cc92d68b9862b4$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $a1cc92d68b9862b4$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
var $a1cc92d68b9862b4$export$a99e4aaac79eeead = (0, $63a4f6f651251ed6$export$fc10aeed3a532e2a)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $21175c20cefb0343$export$1216008129fb82ed)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $63a4f6f651251ed6$export$c5491a8691a23b9e).variadic
});
var $a1cc92d68b9862b4$export$b479a1a2d8754359 = (0, $63a4f6f651251ed6$export$fc10aeed3a532e2a)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $21175c20cefb0343$export$1216008129fb82ed)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $63a4f6f651251ed6$export$c5491a8691a23b9e).variadic
});
var $a1cc92d68b9862b4$export$569bb3095db8432e = (0, $63a4f6f651251ed6$export$fc10aeed3a532e2a)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $21175c20cefb0343$export$1216008129fb82ed)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $63a4f6f651251ed6$export$c5491a8691a23b9e).variadic
});
var $a1cc92d68b9862b4$export$e124bc7d23dd0e5a = (0, $63a4f6f651251ed6$export$fc10aeed3a532e2a)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.Locale).bind.apply(_a, (0, $21175c20cefb0343$export$1216008129fb82ed)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $63a4f6f651251ed6$export$c5491a8691a23b9e).variadic
});
var $a1cc92d68b9862b4$export$a1209f8c6068edc3 = (0, $63a4f6f651251ed6$export$fc10aeed3a532e2a)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.ListFormat).bind.apply(_a, (0, $21175c20cefb0343$export$1216008129fb82ed)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $63a4f6f651251ed6$export$c5491a8691a23b9e).variadic
});



var $14bbb6d14d7e0b5b$exports = {};

$parcel$defineInteropFlag($14bbb6d14d7e0b5b$exports);
$parcel$export($14bbb6d14d7e0b5b$exports, "ErrorCode", () => $cdd1aad0435a7fe4$export$d4e71bc0b80dc0fb);
$parcel$export($14bbb6d14d7e0b5b$exports, "FormatError", () => $cdd1aad0435a7fe4$export$7369836851cc1329);
$parcel$export($14bbb6d14d7e0b5b$exports, "isFormatXMLElementFn", () => $9f488594d2e0e5a5$export$df0c12a2d414a163);

$parcel$export($14bbb6d14d7e0b5b$exports, "IntlMessageFormat", () => $9c3192b3aeeea51e$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ /*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 


var $fa46c6fbc425a38f$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($fa46c6fbc425a38f$export$896afd8541959ee5 || ($fa46c6fbc425a38f$export$896afd8541959ee5 = {}));




var $4c8d81aafd70cb25$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($4c8d81aafd70cb25$export$b87f371cbc396fcf || ($4c8d81aafd70cb25$export$b87f371cbc396fcf = {}));
var $4c8d81aafd70cb25$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($4c8d81aafd70cb25$export$906452485466fa53 || ($4c8d81aafd70cb25$export$906452485466fa53 = {}));
function $4c8d81aafd70cb25$export$cfa10c5697238752(el) {
    return el.type === $4c8d81aafd70cb25$export$b87f371cbc396fcf.literal;
}
function $4c8d81aafd70cb25$export$4f55724281bdfaf9(el) {
    return el.type === $4c8d81aafd70cb25$export$b87f371cbc396fcf.argument;
}
function $4c8d81aafd70cb25$export$e11187b219e191e1(el) {
    return el.type === $4c8d81aafd70cb25$export$b87f371cbc396fcf.number;
}
function $4c8d81aafd70cb25$export$32d811605da75f40(el) {
    return el.type === $4c8d81aafd70cb25$export$b87f371cbc396fcf.date;
}
function $4c8d81aafd70cb25$export$34ec46f596b1702f(el) {
    return el.type === $4c8d81aafd70cb25$export$b87f371cbc396fcf.time;
}
function $4c8d81aafd70cb25$export$dcfe1c11d168b5a1(el) {
    return el.type === $4c8d81aafd70cb25$export$b87f371cbc396fcf.select;
}
function $4c8d81aafd70cb25$export$6c796d116f0a4fbc(el) {
    return el.type === $4c8d81aafd70cb25$export$b87f371cbc396fcf.plural;
}
function $4c8d81aafd70cb25$export$c0ece297bdd0c082(el) {
    return el.type === $4c8d81aafd70cb25$export$b87f371cbc396fcf.pound;
}
function $4c8d81aafd70cb25$export$5c83de34745812b(el) {
    return el.type === $4c8d81aafd70cb25$export$b87f371cbc396fcf.tag;
}
function $4c8d81aafd70cb25$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $4c8d81aafd70cb25$export$906452485466fa53.number);
}
function $4c8d81aafd70cb25$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $4c8d81aafd70cb25$export$906452485466fa53.dateTime);
}
function $4c8d81aafd70cb25$export$f0ac572c1121c662(value) {
    return {
        type: $4c8d81aafd70cb25$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $4c8d81aafd70cb25$export$425e864b0ba114f1(value, style) {
    return {
        type: $4c8d81aafd70cb25$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}


// @generated from regex-gen.ts
var $7fad7ea435e2de95$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $7fad7ea435e2de95$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;


/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $853a42bcd78c3501$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $853a42bcd78c3501$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($853a42bcd78c3501$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}



// @generated from regex-gen.ts
var $3c13bfdbb29d230f$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;


function $d5c44d4794a9e2c1$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $3c13bfdbb29d230f$export$2b8db14d8bcaece7)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $d5c44d4794a9e2c1$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $d5c44d4794a9e2c1$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $d5c44d4794a9e2c1$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $d5c44d4794a9e2c1$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $d5c44d4794a9e2c1$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $d5c44d4794a9e2c1$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($d5c44d4794a9e2c1$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $d5c44d4794a9e2c1$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $d5c44d4794a9e2c1$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$d5c44d4794a9e2c1$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $d5c44d4794a9e2c1$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $d5c44d4794a9e2c1$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $d5c44d4794a9e2c1$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $d5c44d4794a9e2c1$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, all), $d5c44d4794a9e2c1$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, all), $d5c44d4794a9e2c1$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($d5c44d4794a9e2c1$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($d5c44d4794a9e2c1$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($d5c44d4794a9e2c1$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($d5c44d4794a9e2c1$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, result), $d5c44d4794a9e2c1$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($d5c44d4794a9e2c1$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, result), $d5c44d4794a9e2c1$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $d5c44d4794a9e2c1$var$parseSign(token.stem);
        if (signOpts) result = (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $d5c44d4794a9e2c1$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}




// @generated from time-data-gen.ts
// prettier-ignore  
var $678b4a74d46c5a5e$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};


function $a8b16cc5e9659c4e$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $a8b16cc5e9659c4e$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $a8b16cc5e9659c4e$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $678b4a74d46c5a5e$export$a8c9209db4084317)[regionTag || ''] || (0, $678b4a74d46c5a5e$export$a8c9209db4084317)[languageTag || ''] || (0, $678b4a74d46c5a5e$export$a8c9209db4084317)["".concat(languageTag, "-001")] || (0, $678b4a74d46c5a5e$export$a8c9209db4084317)['001'];
    return hourCycles[0];
}


var $ae1edc3560a01a63$var$_a;
var $ae1edc3560a01a63$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $7fad7ea435e2de95$export$523451f94304dd6c).source, "*"));
var $ae1edc3560a01a63$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $7fad7ea435e2de95$export$523451f94304dd6c).source, "*$"));
function $ae1edc3560a01a63$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $ae1edc3560a01a63$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $ae1edc3560a01a63$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $ae1edc3560a01a63$var$hasNativeFromEntries = !!Object.fromEntries;
var $ae1edc3560a01a63$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $ae1edc3560a01a63$var$hasTrimStart = !!String.prototype.trimStart;
var $ae1edc3560a01a63$var$hasTrimEnd = !!String.prototype.trimEnd;
var $ae1edc3560a01a63$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $ae1edc3560a01a63$var$isSafeInteger = $ae1edc3560a01a63$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $ae1edc3560a01a63$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $ae1edc3560a01a63$var$re = $ae1edc3560a01a63$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $ae1edc3560a01a63$var$REGEX_SUPPORTS_U_AND_Y = (($ae1edc3560a01a63$var$_a = $ae1edc3560a01a63$var$re.exec('a')) === null || $ae1edc3560a01a63$var$_a === void 0 ? void 0 : $ae1edc3560a01a63$var$_a[0]) === 'a';
} catch (_) {
    $ae1edc3560a01a63$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $ae1edc3560a01a63$var$startsWith = $ae1edc3560a01a63$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $ae1edc3560a01a63$var$fromCodePoint = $ae1edc3560a01a63$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $ae1edc3560a01a63$var$fromEntries = // native
$ae1edc3560a01a63$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $ae1edc3560a01a63$var$codePointAt = $ae1edc3560a01a63$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $ae1edc3560a01a63$var$trimStart = $ae1edc3560a01a63$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($ae1edc3560a01a63$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $ae1edc3560a01a63$var$trimEnd = $ae1edc3560a01a63$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($ae1edc3560a01a63$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $ae1edc3560a01a63$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $ae1edc3560a01a63$var$matchIdentifierAtIndex;
if ($ae1edc3560a01a63$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $ae1edc3560a01a63$var$IDENTIFIER_PREFIX_RE_1 = $ae1edc3560a01a63$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $ae1edc3560a01a63$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $ae1edc3560a01a63$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $ae1edc3560a01a63$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$ae1edc3560a01a63$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $ae1edc3560a01a63$var$codePointAt(s, index);
        if (c === undefined || $ae1edc3560a01a63$var$_isWhiteSpace(c) || $ae1edc3560a01a63$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $ae1edc3560a01a63$var$fromCodePoint.apply(void 0, match);
};
var $ae1edc3560a01a63$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $4c8d81aafd70cb25$export$b87f371cbc396fcf).pound,
                    location: $ae1edc3560a01a63$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $ae1edc3560a01a63$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $ae1edc3560a01a63$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $4c8d81aafd70cb25$export$b87f371cbc396fcf).literal,
                value: "<".concat(tagName, "/>"),
                location: $ae1edc3560a01a63$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$ae1edc3560a01a63$var$_isAlpha(this.char())) return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).INVALID_TAG, $ae1edc3560a01a63$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $ae1edc3560a01a63$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).INVALID_TAG, $ae1edc3560a01a63$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $4c8d81aafd70cb25$export$b87f371cbc396fcf).tag,
                        value: tagName,
                        children: children,
                        location: $ae1edc3560a01a63$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).UNCLOSED_TAG, $ae1edc3560a01a63$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).INVALID_TAG, $ae1edc3560a01a63$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $ae1edc3560a01a63$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $ae1edc3560a01a63$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $4c8d81aafd70cb25$export$b87f371cbc396fcf).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$ae1edc3560a01a63$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $ae1edc3560a01a63$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $ae1edc3560a01a63$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $ae1edc3560a01a63$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).EMPTY_ARGUMENT, $ae1edc3560a01a63$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).MALFORMED_ARGUMENT, $ae1edc3560a01a63$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $ae1edc3560a01a63$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $4c8d81aafd70cb25$export$b87f371cbc396fcf).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $ae1edc3560a01a63$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $ae1edc3560a01a63$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).MALFORMED_ARGUMENT, $ae1edc3560a01a63$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $ae1edc3560a01a63$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $ae1edc3560a01a63$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).EXPECT_ARGUMENT_TYPE, $ae1edc3560a01a63$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $ae1edc3560a01a63$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).EXPECT_ARGUMENT_STYLE, $ae1edc3560a01a63$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $ae1edc3560a01a63$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $ae1edc3560a01a63$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $ae1edc3560a01a63$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $ae1edc3560a01a63$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $4c8d81aafd70cb25$export$b87f371cbc396fcf).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $a8b16cc5e9659c4e$export$29c5368be8904d27)(skeleton, this.locale);
                        var style = {
                            type: (0, $4c8d81aafd70cb25$export$906452485466fa53).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $853a42bcd78c3501$export$f7b99fb377fe69fa)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $4c8d81aafd70cb25$export$b87f371cbc396fcf).date : (0, $4c8d81aafd70cb25$export$b87f371cbc396fcf).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $4c8d81aafd70cb25$export$b87f371cbc396fcf).number : argType === 'date' ? (0, $4c8d81aafd70cb25$export$b87f371cbc396fcf).date : (0, $4c8d81aafd70cb25$export$b87f371cbc396fcf).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_OPTIONS, $ae1edc3560a01a63$var$createLocation(typeEndPosition_1, (0, $21175c20cefb0343$export$18ce0697a983be9b)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $ae1edc3560a01a63$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $fa46c6fbc425a38f$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $fa46c6fbc425a38f$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $ae1edc3560a01a63$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $4c8d81aafd70cb25$export$b87f371cbc396fcf).select,
                        value: value,
                        options: $ae1edc3560a01a63$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $4c8d81aafd70cb25$export$b87f371cbc396fcf).plural,
                        value: value,
                        options: $ae1edc3560a01a63$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).INVALID_ARGUMENT_TYPE, $ae1edc3560a01a63$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $ae1edc3560a01a63$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $ae1edc3560a01a63$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $d5c44d4794a9e2c1$export$71cee2f16fba2480)(skeleton);
        } catch (e) {
            return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $4c8d81aafd70cb25$export$906452485466fa53).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $d5c44d4794a9e2c1$export$47c6f8480bda3e11)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $fa46c6fbc425a38f$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $fa46c6fbc425a38f$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $ae1edc3560a01a63$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $fa46c6fbc425a38f$export$896afd8541959ee5).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $fa46c6fbc425a38f$export$896afd8541959ee5).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $fa46c6fbc425a38f$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $fa46c6fbc425a38f$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $ae1edc3560a01a63$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $ae1edc3560a01a63$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $fa46c6fbc425a38f$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $fa46c6fbc425a38f$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, $ae1edc3560a01a63$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $fa46c6fbc425a38f$export$896afd8541959ee5).MISSING_OTHER_CLAUSE, $ae1edc3560a01a63$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $ae1edc3560a01a63$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$ae1edc3560a01a63$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $ae1edc3560a01a63$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($ae1edc3560a01a63$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $ae1edc3560a01a63$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $ae1edc3560a01a63$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $ae1edc3560a01a63$var$_isAlphaOrSlash(codepoint) {
    return $ae1edc3560a01a63$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $ae1edc3560a01a63$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $ae1edc3560a01a63$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $ae1edc3560a01a63$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}



function $c6d4ed3d82470318$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $4c8d81aafd70cb25$export$dcfe1c11d168b5a1)(el) || (0, $4c8d81aafd70cb25$export$6c796d116f0a4fbc)(el)) for(var k in el.options){
            delete el.options[k].location;
            $c6d4ed3d82470318$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $4c8d81aafd70cb25$export$e11187b219e191e1)(el) && (0, $4c8d81aafd70cb25$export$3f9a19cd4152eda3)(el.style)) delete el.style.location;
        else if (((0, $4c8d81aafd70cb25$export$32d811605da75f40)(el) || (0, $4c8d81aafd70cb25$export$34ec46f596b1702f)(el)) && (0, $4c8d81aafd70cb25$export$7680c41f1a55f4cf)(el.style)) delete el.style.location;
        else if ((0, $4c8d81aafd70cb25$export$5c83de34745812b)(el)) $c6d4ed3d82470318$var$pruneLocation(el.children);
    });
}
function $c6d4ed3d82470318$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $21175c20cefb0343$export$18ce0697a983be9b)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $ae1edc3560a01a63$export$7acfa6ed01010e37)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $fa46c6fbc425a38f$export$896afd8541959ee5)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $c6d4ed3d82470318$var$pruneLocation(result.val);
    return result.val;
}
var $c6d4ed3d82470318$export$d3c1bfa0f7d806e9 = (0, $ae1edc3560a01a63$export$7acfa6ed01010e37);




var $cdd1aad0435a7fe4$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($cdd1aad0435a7fe4$export$d4e71bc0b80dc0fb || ($cdd1aad0435a7fe4$export$d4e71bc0b80dc0fb = {}));
var $cdd1aad0435a7fe4$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $21175c20cefb0343$export$a8ba968b8961cb8a)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $cdd1aad0435a7fe4$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $21175c20cefb0343$export$a8ba968b8961cb8a)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $cdd1aad0435a7fe4$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($cdd1aad0435a7fe4$export$7369836851cc1329);
var $cdd1aad0435a7fe4$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $21175c20cefb0343$export$a8ba968b8961cb8a)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $cdd1aad0435a7fe4$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($cdd1aad0435a7fe4$export$7369836851cc1329);
var $cdd1aad0435a7fe4$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $21175c20cefb0343$export$a8ba968b8961cb8a)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $cdd1aad0435a7fe4$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($cdd1aad0435a7fe4$export$7369836851cc1329);


var $9f488594d2e0e5a5$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($9f488594d2e0e5a5$export$49694c2877b44c57 || ($9f488594d2e0e5a5$export$49694c2877b44c57 = {}));
function $9f488594d2e0e5a5$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $9f488594d2e0e5a5$export$49694c2877b44c57.literal || part.type !== $9f488594d2e0e5a5$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $9f488594d2e0e5a5$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $9f488594d2e0e5a5$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $4c8d81aafd70cb25$export$cfa10c5697238752)(els[0])) return [
        {
            type: $9f488594d2e0e5a5$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $4c8d81aafd70cb25$export$cfa10c5697238752)(el)) {
            result.push({
                type: $9f488594d2e0e5a5$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $4c8d81aafd70cb25$export$c0ece297bdd0c082)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $9f488594d2e0e5a5$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $cdd1aad0435a7fe4$export$8bfc137e4d23fdf0)(varName, originalMessage);
        var value = values[varName];
        if ((0, $4c8d81aafd70cb25$export$4f55724281bdfaf9)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $9f488594d2e0e5a5$export$49694c2877b44c57.literal : $9f488594d2e0e5a5$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $4c8d81aafd70cb25$export$32d811605da75f40)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $4c8d81aafd70cb25$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $9f488594d2e0e5a5$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4c8d81aafd70cb25$export$34ec46f596b1702f)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $4c8d81aafd70cb25$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $9f488594d2e0e5a5$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4c8d81aafd70cb25$export$e11187b219e191e1)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $4c8d81aafd70cb25$export$3f9a19cd4152eda3)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $9f488594d2e0e5a5$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $4c8d81aafd70cb25$export$5c83de34745812b)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$9f488594d2e0e5a5$export$df0c12a2d414a163(formatFn)) throw new (0, $cdd1aad0435a7fe4$export$cbc0db47c750f7c9)(value_1, 'function', originalMessage);
            var parts = $9f488594d2e0e5a5$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $9f488594d2e0e5a5$export$49694c2877b44c57.literal : $9f488594d2e0e5a5$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $4c8d81aafd70cb25$export$dcfe1c11d168b5a1)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $cdd1aad0435a7fe4$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $9f488594d2e0e5a5$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $4c8d81aafd70cb25$export$6c796d116f0a4fbc)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $cdd1aad0435a7fe4$export$7369836851cc1329)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $cdd1aad0435a7fe4$export$d4e71bc0b80dc0fb).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $cdd1aad0435a7fe4$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $9f488594d2e0e5a5$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $9f488594d2e0e5a5$var$mergeLiteral(result);
}


// -- MessageFormat --------------------------------------------------------
function $9c3192b3aeeea51e$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $9c3192b3aeeea51e$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $9c3192b3aeeea51e$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $21175c20cefb0343$export$18ce0697a983be9b)({}, defaultConfig));
}
function $9c3192b3aeeea51e$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $9c3192b3aeeea51e$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $63a4f6f651251ed6$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $21175c20cefb0343$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $9c3192b3aeeea51e$var$createFastMemoizeCache(cache.number),
            strategy: (0, $63a4f6f651251ed6$export$c5491a8691a23b9e).variadic
        }),
        getDateTimeFormat: (0, $63a4f6f651251ed6$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $21175c20cefb0343$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $9c3192b3aeeea51e$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $63a4f6f651251ed6$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: (0, $63a4f6f651251ed6$export$fc10aeed3a532e2a)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $21175c20cefb0343$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $9c3192b3aeeea51e$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $63a4f6f651251ed6$export$c5491a8691a23b9e).variadic
        })
    };
}
var $9c3192b3aeeea51e$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $9f488594d2e0e5a5$export$49694c2877b44c57).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $9f488594d2e0e5a5$export$275d4a3bb5f66fda)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $21175c20cefb0343$export$3c9a16f847548506)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $9c3192b3aeeea51e$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $9c3192b3aeeea51e$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $c6d4ed3d82470318$export$98e6a39c04603d36);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();




var $14bbb6d14d7e0b5b$export$2e2bcd8739ae039 = (0, $9c3192b3aeeea51e$export$d342343268debc40);




var $c20acf2711ccd7bd$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($c20acf2711ccd7bd$export$557d6acb76e8a244 || ($c20acf2711ccd7bd$export$557d6acb76e8a244 = {}));
var $c20acf2711ccd7bd$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $21175c20cefb0343$export$a8ba968b8961cb8a)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $c20acf2711ccd7bd$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $21175c20cefb0343$export$a8ba968b8961cb8a)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $c20acf2711ccd7bd$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($c20acf2711ccd7bd$export$c016d36112f6ddf8);
var $c20acf2711ccd7bd$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $21175c20cefb0343$export$a8ba968b8961cb8a)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $c20acf2711ccd7bd$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($c20acf2711ccd7bd$export$c016d36112f6ddf8);
var $c20acf2711ccd7bd$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $21175c20cefb0343$export$a8ba968b8961cb8a)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $c20acf2711ccd7bd$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($c20acf2711ccd7bd$export$c016d36112f6ddf8);
var $c20acf2711ccd7bd$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $21175c20cefb0343$export$a8ba968b8961cb8a)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $c20acf2711ccd7bd$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($c20acf2711ccd7bd$export$c016d36112f6ddf8);
var $c20acf2711ccd7bd$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $21175c20cefb0343$export$a8ba968b8961cb8a)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($c20acf2711ccd7bd$export$e3b7eee1dbc44895);
var $c20acf2711ccd7bd$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $21175c20cefb0343$export$a8ba968b8961cb8a)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $c20acf2711ccd7bd$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($c20acf2711ccd7bd$export$c016d36112f6ddf8);


function $aec25548772adc94$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $aec25548772adc94$var$defaultErrorHandler = function(error) {};
var $aec25548772adc94$var$defaultWarnHandler = function(warning) {};
var $aec25548772adc94$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $aec25548772adc94$var$defaultErrorHandler,
    onWarn: $aec25548772adc94$var$defaultWarnHandler
};
function $aec25548772adc94$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $aec25548772adc94$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $aec25548772adc94$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $aec25548772adc94$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $63a4f6f651251ed6$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $21175c20cefb0343$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $aec25548772adc94$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $63a4f6f651251ed6$export$c5491a8691a23b9e).variadic
    });
    var getNumberFormat = (0, $63a4f6f651251ed6$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $21175c20cefb0343$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $aec25548772adc94$var$createFastMemoizeCache(cache.number),
        strategy: (0, $63a4f6f651251ed6$export$c5491a8691a23b9e).variadic
    });
    var getPluralRules = (0, $63a4f6f651251ed6$export$fc10aeed3a532e2a)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $21175c20cefb0343$export$1216008129fb82ed)([
            void 0
        ], args, false)))();
    }, {
        cache: $aec25548772adc94$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $63a4f6f651251ed6$export$c5491a8691a23b9e).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $63a4f6f651251ed6$export$fc10aeed3a532e2a)(function(message, locales, overrideFormats, opts) {
            return new (0, $9c3192b3aeeea51e$export$d342343268debc40)(message, locales, overrideFormats, (0, $21175c20cefb0343$export$18ce0697a983be9b)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $aec25548772adc94$var$createFastMemoizeCache(cache.message),
            strategy: (0, $63a4f6f651251ed6$export$c5491a8691a23b9e).variadic
        }),
        getRelativeTimeFormat: (0, $63a4f6f651251ed6$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $21175c20cefb0343$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $aec25548772adc94$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $63a4f6f651251ed6$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $63a4f6f651251ed6$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $21175c20cefb0343$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $aec25548772adc94$var$createFastMemoizeCache(cache.list),
            strategy: (0, $63a4f6f651251ed6$export$c5491a8691a23b9e).variadic
        }),
        getDisplayNames: (0, $63a4f6f651251ed6$export$fc10aeed3a532e2a)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $21175c20cefb0343$export$1216008129fb82ed)([
                void 0
            ], args, false)))();
        }, {
            cache: $aec25548772adc94$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $63a4f6f651251ed6$export$c5491a8691a23b9e).variadic
        })
    };
}
function $aec25548772adc94$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $c20acf2711ccd7bd$export$549f97e137a05c90)("No ".concat(type, " format named: ").concat(name)));
}


function $81047c1ca6bde4f6$export$45c4bbf6e55bba1f(intl) {
    (0, $a1cc92d68b9862b4$export$f5708dca728d7177)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $81047c1ca6bde4f6$export$b52f8d6fc0d47415 = (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, (0, $aec25548772adc94$export$b52f8d6fc0d47415)), {
    textComponent: $Fo7oF.Fragment
});
function $81047c1ca6bde4f6$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($Fo7oF.Children.toArray(parts));
    };
}
function $81047c1ca6bde4f6$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}



var $Fo7oF = parcelRequire("Fo7oF");



var $1xoRX = parcelRequire("1xoRX");

var $Fo7oF = parcelRequire("Fo7oF");

function $560608e2ff51836b$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $560608e2ff51836b$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $Fo7oF.createContext(null)) : $Fo7oF.createContext(null);
var $560608e2ff51836b$var$IntlConsumer = $560608e2ff51836b$var$IntlContext.Consumer, $560608e2ff51836b$var$IntlProvider = $560608e2ff51836b$var$IntlContext.Provider;
var $560608e2ff51836b$export$2881499e37b75b9a = $560608e2ff51836b$var$IntlProvider;
var $560608e2ff51836b$export$841858b892ce1f4c = $560608e2ff51836b$var$IntlContext;
function $560608e2ff51836b$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $Fo7oF.createElement($560608e2ff51836b$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $81047c1ca6bde4f6$export$45c4bbf6e55bba1f)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $Fo7oF.createElement(WrappedComponent, (0, $21175c20cefb0343$export$18ce0697a983be9b)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($560608e2ff51836b$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($1xoRX)))(// @ts-expect-error
    $Fo7oF.forwardRef(function(props, ref) {
        return $Fo7oF.createElement(WithIntl, (0, $21175c20cefb0343$export$18ce0697a983be9b)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1xoRX)))(WithIntl, WrappedComponent);
}


function $b637120a7f65e10c$export$2e2bcd8739ae039() {
    var intl = $Fo7oF.useContext((0, $560608e2ff51836b$export$841858b892ce1f4c));
    (0, $81047c1ca6bde4f6$export$45c4bbf6e55bba1f)(intl);
    return intl;
}


function $1117f10944a397d9$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $21175c20cefb0343$export$3c9a16f847548506)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $21175c20cefb0343$export$3c9a16f847548506)(nextProps, [
        "values"
    ]);
    return (0, $81047c1ca6bde4f6$export$d36bdfa510afb180)(nextValues, values) && (0, $81047c1ca6bde4f6$export$d36bdfa510afb180)(otherProps, nextOtherProps);
}
function $1117f10944a397d9$var$FormattedMessage(props) {
    var intl = (0, $b637120a7f65e10c$export$2e2bcd8739ae039)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $Fo7oF.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $Fo7oF.createElement(Component, null, $Fo7oF.Children.toArray(nodes));
    return $Fo7oF.createElement($Fo7oF.Fragment, null, nodes);
}
$1117f10944a397d9$var$FormattedMessage.displayName = 'FormattedMessage';
var $1117f10944a397d9$var$MemoizedFormattedMessage = $Fo7oF.memo($1117f10944a397d9$var$FormattedMessage, $1117f10944a397d9$var$areEqual);
$1117f10944a397d9$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $1117f10944a397d9$export$2e2bcd8739ae039 = $1117f10944a397d9$var$MemoizedFormattedMessage;



var $eFTP6 = parcelRequire("eFTP6");

parcelRequire("Fo7oF");
const $da769170dfa840d0$export$486333360725fcc9 = {
    'PRIMARY': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.PRIMARY'
    }),
    'ASSOCIATE': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.ASSOCIATE'
    }),
    'CO_BORROWER': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.CO-BORROWER'
    }),
    'GUARANTOR': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.GUARANTOR'
    }),
    'ON DEMAND': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.ON_DEMAND'
    }),
    'PROXY': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.PROXY'
    }),
    'DEALER': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.DEALER'
    }),
    'JDF SIGNER': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.JDF_SIGNER'
    })
};
const $da769170dfa840d0$export$ff432e19f42d75f = {
    'you can only assign': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.you can only assign'
    }),
    'representatives to the': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.representatives to the'
    })
};
const $da769170dfa840d0$export$7b5a6e1e04903656 = {
    'SIGN BY EMAIL': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.SIGN_BY_EMAIL'
    }),
    'SIGN NOW': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.SIGN_NOW'
    })
};
const $da769170dfa840d0$export$2c62012ca01f1bea = {
    'COMPLETED': 'labels.COMPLETED',
    'CREATED': 'labels.CREATED',
    'DECLINED': 'labels.DECLINED',
    'DELETED': 'labels.DELETED',
    'DELIVERED': 'labels.DELIVERED',
    'PROCESSING': 'labels.PROCESSING',
    'SENT': 'labels.SENT',
    'SIGNED': 'labels.SIGNED',
    'TEMPLATE': 'labels.TEMPLATE',
    'VOIDED': 'labels.VOIDED'
};
const $da769170dfa840d0$export$ddd81c2d171fb653 = {
    'AUTO-APPROVED': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.AUTO_APPROVED'
    }),
    'AWAITING FURTHER INFORMATION/DOCUMENTS': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.AWAITING_FURTHER_INFORMATION_DOCUMENTS'
    }),
    'APPROVED': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.APPROVED'
    }),
    'APPROVED WITH CONDITIONS': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.APPROVED_WITH_CONDITIONS'
    }),
    'CREDIT DECISION ROUTED FOR MANUAL REVIEW': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.CREDIT_DECISION_ROUTED_FOR_MANUAL_REVIEW'
    }),
    'CONTRACT PAID OFF': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.CONTRACT_PAID_OFF'
    }),
    'DECLINED': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.DECLINED'
    }),
    'DELETED': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.DELETED'
    }),
    'EXPIRED': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.EXPIRED'
    }),
    'PROPOSED': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.PROPOSED'
    }),
    'QUOTE': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.QUOTE'
    }),
    'SUBMITTED': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.SUBMITTED'
    }),
    'WITHDRAWN': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.WITHDRAWN'
    })
};


function $f974bcd17bc8d396$export$2e2bcd8739ae039({ showSignNowIcon: showSignNowIcon, isHidden: isHidden, signerInfo: signerInfo, envelopeId: envelopeId, statusColor: statusColor, setHideSignerInfoPopup: setHideSignerInfoPopup }) {
    const handleClose = ()=>{
        setHideSignerInfoPopup(false);
    };
    const getDateTime = (time)=>{
        return new Date(time).toLocaleDateString() + ' ' + new Date(time).toLocaleTimeString();
    };
    const signerStatus = {
        created: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
            id: 'labels.CREATED'
        }),
        sent: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
            id: 'labels.SENT'
        }),
        delivered: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
            id: 'labels.VIEWED'
        }),
        declined: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
            id: 'labels.DECLINED'
        }),
        completed: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
            id: 'labels.COMPLETED'
        }),
        autoresponded: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
            id: 'labels.UNDELIVERABLE'
        })
    };
    return /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $06c828c7d8d76aa9$export$2e2bcd8739ae039), {
        "aria-labelledby": "customized-dialog-title",
        fullWidth: true,
        onClose: handleClose,
        open: isHidden,
        children: [
            /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Row), {
                className: "d-flex ml-3 mr-2 mt-2 justify-content-between",
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                        className: "d-inline",
                        children: /*#__PURE__*/ (0, $eFTP6.jsxs)("h5", {
                            className: "font-weight-bold mt-1",
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($21bf5b2cd2866b79$exports))), {
                                        className: "mr-2",
                                        color: "action",
                                        fontSize: "large"
                                    })
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                    "data-sl": "mask",
                                    children: signerInfo.signerName
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)("span", {
                                    className: "font-weight-light ml-2",
                                    style: {
                                        fontSize: '13px'
                                    },
                                    children: [
                                        "(",
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                            id: 'labels.ROLE'
                                        }),
                                        ": ",
                                        (0, $da769170dfa840d0$export$486333360725fcc9)[signerInfo.signerRole.toUpperCase()],
                                        ")"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                        className: "d-inline",
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c6e28b9de0df1599$export$2e2bcd8739ae039), {
                            "aria-label": "close",
                            onClick: handleClose,
                            size: "small",
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($57b96121aa7aac71$exports))), {
                                fontSize: "small"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b04338db8f46de7f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $1c55bad717a43115$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Row), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0045f42ade89216a$exports))).dialogContentRow,
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Col), {
                                children: /*#__PURE__*/ (0, $eFTP6.jsxs)("dl", {
                                    className: "uxf-dl",
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("dt", {
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.EMAIL'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("dd", {
                                            "data-sl": "mask",
                                            children: signerInfo.signerEmail
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("dt", {
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.MOBILE'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("dd", {
                                            "data-sl": "mask",
                                            children: signerInfo.signerContactNumber
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("dt", {
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.SIGNING_OPTION'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("dd", {
                                            children: (0, $da769170dfa840d0$export$7b5a6e1e04903656)[signerInfo.signingOption.toUpperCase()]
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("dt", {
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.SIGNING_ORDER'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("dd", {
                                            children: signerInfo.signingOrder
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Col), {
                                children: /*#__PURE__*/ (0, $eFTP6.jsxs)("dl", {
                                    className: "uxf-dl",
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("dt", {
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.SIGNING_STATUS'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("dd", {
                                            style: {
                                                color: statusColor
                                            },
                                            children: signerStatus[signerInfo.status]
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("dt", {
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.SENT_DATE'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("dd", {
                                            children: signerInfo.envelopeSentDate ? getDateTime(signerInfo.envelopeSentDate) : /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.NOT_AVAILABLE'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("dt", {
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.VIEWED_DATE'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("dd", {
                                            children: signerInfo.envelopeViewedDate ? getDateTime(signerInfo.envelopeViewedDate) : signerInfo.deliveredDateTime ? getDateTime(signerInfo.deliveredDateTime) : /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.NOT_VIEWED'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("br", {}),
                                        signerInfo.envelopeDeclinedDate ? /*#__PURE__*/ (0, $eFTP6.jsx)("dt", {
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.DECLINED_DATE'
                                            })
                                        }) : /*#__PURE__*/ (0, $eFTP6.jsx)("dt", {
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.SIGNED_DATE'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("dd", {
                                            children: signerInfo.envelopeDeclinedDate ? getDateTime(signerInfo.envelopeDeclinedDate) : signerInfo.envelopeSignedDate ? getDateTime(signerInfo.envelopeSignedDate) : /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.NOT_SIGNED'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("br", {})
                                    ]
                                })
                            })
                        ]
                    }),
                    signerInfo.status === 'declined' ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Row), {
                        children: /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($0045f42ade89216a$exports))).declinedDiv,
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                    className: "d-block font-weight-bold",
                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.DECLINED_REASON'
                                    })
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                    className: "d-block",
                                    children: signerInfo.envelopeDeclinedReason ? signerInfo.envelopeDeclinedReason : /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.NO_DECLINING_REASON_PROVIDED'
                                    })
                                })
                            ]
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b04338db8f46de7f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1b29532bd4542510$export$2e2bcd8739ae039), {
                children: showSignNowIcon ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                    component: "a",
                    onClick: ()=>(0, $978f9aa25fa80483$export$2e2bcd8739ae039)(envelopeId, signerInfo),
                    size: "small",
                    style: {
                        backgroundColor: '#ffde00'
                    },
                    variant: "outlined",
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                        id: 'labels.SIGN_NOW'
                    })
                }) : /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                    disabled: true,
                    size: "small",
                    style: {
                        backgroundColor: '#ffde00'
                    },
                    variant: "outlined",
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                        id: 'labels.SIGN_NOW'
                    })
                })
            })
        ]
    });
}


var $034bb2b9a7aeb259$exports = {};
$034bb2b9a7aeb259$exports = JSON.parse("{\"role\":\"JDF SIGNER\",\"emailID\":\"***********\",\"name\":\"JDF Signer\",\"recipientId\":\"111\",\"routingOrder\":7,\"signingOption\":\"Sign by email\",\"countryCodeforPhone\":\"**\",\"contactNumber\":\"***********\"}");



function $3b23e285955cd078$var$getSteps(signersList) {
    const OrderOne = [];
    const OrderTwo = [];
    const OrderThree = [];
    const OrderFour = [];
    const OrderFive = [];
    const OrderSix = [];
    signersList.map((signer)=>{
        if (signer.signingOrder === '1') OrderOne.push(signer);
        else if (signer.signingOrder === '2') OrderTwo.push(signer);
        else if (signer.signingOrder === '3') OrderThree.push(signer);
        else if (signer.signingOrder === '4') OrderFour.push(signer);
        else if (signer.signingOrder === '5') OrderFive.push(signer);
        else if (signer.signerRole === (0, (/*@__PURE__*/$parcel$interopDefault($034bb2b9a7aeb259$exports))).role) OrderSix.push(signer);
    });
    return [
        OrderOne,
        OrderTwo,
        OrderThree,
        OrderFour,
        OrderFive,
        OrderSix
    ];
}
const $3b23e285955cd078$var$statusColours = {
    created: '#666666',
    //grey
    sent: '#FFB000',
    //yellow-sea
    delivered: '#FF8C00',
    //yellow
    declined: '#c21020',
    //red
    completed: '#367c2b',
    //green
    autoresponded: '#337dc1' //dark-blue // Signer Status autoresponded means email is Undeliverable/Bounced beacuse of some reason.
};
function $3b23e285955cd078$var$getSignerChip(envelopeStatus, signer, envelopeId) {
    const [hideSignerInfoPopup, setHideSignerInfoPopup] = (0, $Fo7oF.useState)(false);
    const showSignNowIcon = (signer.status === 'sent' || signer.status === 'delivered') && envelopeStatus !== 'completed' && envelopeStatus !== 'declined' && signer.signingOption === 'Sign now';
    return /*#__PURE__*/ (0, $eFTP6.jsxs)("span", {
        children: [
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $88209bc93a38e520$export$2e2bcd8739ae039), {
                className: "mb-1",
                icon: showSignNowIcon ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f4267c9105e002e8$export$fd4688af832bd039), {
                    envelopeId: envelopeId,
                    signer: signer
                }) : null,
                label: /*#__PURE__*/ (0, $eFTP6.jsx)("strong", {
                    "data-sl": "mask",
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($034bb2b9a7aeb259$exports))).role === signer.signerRole ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                        id: 'labels.JDF_SIGNER'
                    }) : signer.signerName
                }),
                onClick: ()=>setHideSignerInfoPopup(!hideSignerInfoPopup),
                size: "medium",
                style: {
                    color: '#ffffff',
                    'backgroundColor': $3b23e285955cd078$var$statusColours[signer.status]
                }
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)("br", {}),
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f974bcd17bc8d396$export$2e2bcd8739ae039), {
                envelopeId: envelopeId,
                isHidden: hideSignerInfoPopup,
                setHideSignerInfoPopup: setHideSignerInfoPopup,
                showSignNowIcon: showSignNowIcon,
                signerInfo: signer,
                statusColor: $3b23e285955cd078$var$statusColours[signer.status]
            })
        ]
    }, 'signerstatus-' + (0, $ce7657dc4dcb9e28$export$a47fb462a08de82f)() + (0, $ce7657dc4dcb9e28$export$a47fb462a08de82f)());
}
function $3b23e285955cd078$export$2e2bcd8739ae039({ envelopeStatus: envelopeStatus, signersList: signersList, bgColor: bgColor, envelopeId: envelopeId }) {
    const steps = $3b23e285955cd078$var$getSteps(signersList);
    return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2a2dbee2872ed1ff$export$2e2bcd8739ae039), {
        alternativeLabel: true,
        className: "mw-100",
        style: {
            'backgroundColor': bgColor
        },
        children: steps.filter((step)=>step.length > 0).map((signers)=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $b7cae7699bf248ce$export$2e2bcd8739ae039), {
                active: true,
                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $7a09dab997ab6c9a$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f4267c9105e002e8$export$7dcc8f518762622d), {}),
                    children: signers.map((signer)=>$3b23e285955cd078$var$getSignerChip(envelopeStatus, signer, envelopeId))
                })
            }, 'sign-' + (0, $ce7657dc4dcb9e28$export$a47fb462a08de82f)() + (0, $ce7657dc4dcb9e28$export$a47fb462a08de82f)()))
    });
}



var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");

const $9ab8fe562bccfb23$export$c0d6fd47a193aea1 = ({ context: context, message: message })=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Container), {
        fluid: true,
        children: /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
            className: "justify-content-center text-center d-block",
            style: {
                'height': '200px'
            },
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)("h4", {
                    style: {
                        maxWidth: '28.125rem',
                        marginTop: 100,
                        marginLeft: 'auto',
                        marginRight: 'auto'
                    },
                    children: context
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)("p", {
                    className: "d-block",
                    style: {
                        maxWidth: '28.125rem',
                        marginTop: 15,
                        marginLeft: 'auto',
                        marginRight: 'auto'
                    },
                    children: message
                })
            ]
        })
    });



var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");


function $39bdaf6b319ea388$export$2e2bcd8739ae039() {
    const styles = {
        statusName: {
            'fontSize': '12px',
            'fontWeight': 'normal'
        }
    };
    const statusIndicators = [
        [
            '#367c2b',
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                id: 'labels.COMPLETED'
            })
        ],
        [
            '#ffb000',
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                id: 'labels.SENT_/_VIEWED'
            })
        ],
        [
            '#666666',
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                id: 'labels.CREATED'
            })
        ],
        [
            '#c21020',
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                id: 'labels.DECLINED'
            })
        ],
        [
            '#337dc1',
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                id: 'labels.UNDELIVERABLE'
            })
        ]
    ];
    return /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
        style: {
            'marginRight': '2%'
        },
        children: statusIndicators.map((indicator)=>/*#__PURE__*/ (0, $eFTP6.jsxs)("p", {
                className: "d-inline mr-2",
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                        className: "font-weight-bold",
                        style: {
                            'fontSize': '60px',
                            'color': indicator[0]
                        },
                        children: "."
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                        style: styles.statusName,
                        children: indicator[1]
                    })
                ]
            }, 'indicator-' + (0, $ce7657dc4dcb9e28$export$a47fb462a08de82f)()))
    });
}



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");

var $a88484a22110b9b6$exports = {};
"use strict";


Object.defineProperty($a88484a22110b9b6$exports, "__esModule", {
    value: true
});
$a88484a22110b9b6$exports.default = void 0;

var $a88484a22110b9b6$var$React = $e542637ee86bba6a$exports((parcelRequire("Fo7oF")));

var $a88484a22110b9b6$var$_createSvgIcon = $368639c97fe780bf$exports((parcelRequire("bI8Gq")));
var $a88484a22110b9b6$var$_default = (0, $a88484a22110b9b6$var$_createSvgIcon.default)(/*#__PURE__*/ $a88484a22110b9b6$var$React.createElement("path", {
    d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
}), 'GetApp');
$a88484a22110b9b6$exports.default = $a88484a22110b9b6$var$_default;



var $fjJNR = parcelRequire("fjJNR");

var $elnlQ = parcelRequire("elnlQ");

var $Fo7oF = parcelRequire("Fo7oF");

function $57f9e9fab6f781fc$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $57f9e9fab6f781fc$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $57f9e9fab6f781fc$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $57f9e9fab6f781fc$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $57f9e9fab6f781fc$export$2e2bcd8739ae039 = $57f9e9fab6f781fc$export$4f5d2d50c9deca37;



function $6912f2a122303628$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}


var $d4db04b0acbeed96$exports = {};
"use strict";

Object.defineProperty($d4db04b0acbeed96$exports, "__esModule", {
    value: true
});
$d4db04b0acbeed96$exports.alpha = $d4db04b0acbeed96$var$alpha;
$d4db04b0acbeed96$exports.blend = $d4db04b0acbeed96$var$blend;
$d4db04b0acbeed96$exports.colorChannel = void 0;
$d4db04b0acbeed96$exports.darken = $d4db04b0acbeed96$var$darken;
$d4db04b0acbeed96$exports.decomposeColor = $d4db04b0acbeed96$var$decomposeColor;
$d4db04b0acbeed96$exports.emphasize = $d4db04b0acbeed96$var$emphasize;
$d4db04b0acbeed96$exports.getContrastRatio = $d4db04b0acbeed96$var$getContrastRatio;
$d4db04b0acbeed96$exports.getLuminance = $d4db04b0acbeed96$var$getLuminance;
$d4db04b0acbeed96$exports.hexToRgb = $d4db04b0acbeed96$var$hexToRgb;
$d4db04b0acbeed96$exports.hslToRgb = $d4db04b0acbeed96$var$hslToRgb;
$d4db04b0acbeed96$exports.lighten = $d4db04b0acbeed96$var$lighten;
$d4db04b0acbeed96$exports.private_safeAlpha = $d4db04b0acbeed96$var$private_safeAlpha;
$d4db04b0acbeed96$exports.private_safeColorChannel = void 0;
$d4db04b0acbeed96$exports.private_safeDarken = $d4db04b0acbeed96$var$private_safeDarken;
$d4db04b0acbeed96$exports.private_safeEmphasize = $d4db04b0acbeed96$var$private_safeEmphasize;
$d4db04b0acbeed96$exports.private_safeLighten = $d4db04b0acbeed96$var$private_safeLighten;
$d4db04b0acbeed96$exports.recomposeColor = $d4db04b0acbeed96$var$recomposeColor;
$d4db04b0acbeed96$exports.rgbToHex = $d4db04b0acbeed96$var$rgbToHex;

var $d4db04b0acbeed96$var$_formatMuiErrorMessage2 = $368639c97fe780bf$exports((parcelRequire("djSQb")));

var $d4db04b0acbeed96$var$_clamp = $368639c97fe780bf$exports((parcelRequire("j7L58")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $d4db04b0acbeed96$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $d4db04b0acbeed96$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $d4db04b0acbeed96$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $d4db04b0acbeed96$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $d4db04b0acbeed96$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $d4db04b0acbeed96$var$decomposeColor($d4db04b0acbeed96$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $d4db04b0acbeed96$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $d4db04b0acbeed96$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $d4db04b0acbeed96$var$colorChannel = (color)=>{
    const decomposedColor = $d4db04b0acbeed96$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
$d4db04b0acbeed96$exports.colorChannel = $d4db04b0acbeed96$var$colorChannel;
const $d4db04b0acbeed96$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $d4db04b0acbeed96$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ $d4db04b0acbeed96$exports.private_safeColorChannel = $d4db04b0acbeed96$var$private_safeColorChannel;
function $d4db04b0acbeed96$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $d4db04b0acbeed96$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $d4db04b0acbeed96$var$decomposeColor(color);
    return `#${values.map((n, i)=>$d4db04b0acbeed96$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $d4db04b0acbeed96$var$hslToRgb(color) {
    color = $d4db04b0acbeed96$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $d4db04b0acbeed96$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $d4db04b0acbeed96$var$getLuminance(color) {
    color = $d4db04b0acbeed96$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $d4db04b0acbeed96$var$decomposeColor($d4db04b0acbeed96$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $d4db04b0acbeed96$var$getContrastRatio(foreground, background) {
    const lumA = $d4db04b0acbeed96$var$getLuminance(foreground);
    const lumB = $d4db04b0acbeed96$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d4db04b0acbeed96$var$alpha(color, value) {
    color = $d4db04b0acbeed96$var$decomposeColor(color);
    value = $d4db04b0acbeed96$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $d4db04b0acbeed96$var$recomposeColor(color);
}
function $d4db04b0acbeed96$var$private_safeAlpha(color, value, warning) {
    try {
        return $d4db04b0acbeed96$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d4db04b0acbeed96$var$darken(color, coefficient) {
    color = $d4db04b0acbeed96$var$decomposeColor(color);
    coefficient = $d4db04b0acbeed96$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $d4db04b0acbeed96$var$recomposeColor(color);
}
function $d4db04b0acbeed96$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $d4db04b0acbeed96$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d4db04b0acbeed96$var$lighten(color, coefficient) {
    color = $d4db04b0acbeed96$var$decomposeColor(color);
    coefficient = $d4db04b0acbeed96$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $d4db04b0acbeed96$var$recomposeColor(color);
}
function $d4db04b0acbeed96$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $d4db04b0acbeed96$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d4db04b0acbeed96$var$emphasize(color, coefficient = 0.15) {
    return $d4db04b0acbeed96$var$getLuminance(color) > 0.5 ? $d4db04b0acbeed96$var$darken(color, coefficient) : $d4db04b0acbeed96$var$lighten(color, coefficient);
}
function $d4db04b0acbeed96$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $d4db04b0acbeed96$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $d4db04b0acbeed96$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $d4db04b0acbeed96$var$decomposeColor(background);
    const overlayColor = $d4db04b0acbeed96$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $d4db04b0acbeed96$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}


var $40a3b2c02656d57f$exports = {};
"use strict";

Object.defineProperty($40a3b2c02656d57f$exports, "__esModule", {
    value: true
});
$40a3b2c02656d57f$exports.default = $40a3b2c02656d57f$var$createStyled;
$40a3b2c02656d57f$exports.shouldForwardProp = $40a3b2c02656d57f$var$shouldForwardProp;
$40a3b2c02656d57f$exports.systemDefaultTheme = void 0;

var $40a3b2c02656d57f$var$_extends2 = $368639c97fe780bf$exports((parcelRequire("edCRM")));

var $40a3b2c02656d57f$var$_objectWithoutPropertiesLoose2 = $368639c97fe780bf$exports((parcelRequire("1Z1cO")));

var $40a3b2c02656d57f$var$_styledEngine = $40a3b2c02656d57f$var$_interopRequireWildcard((parcelRequire("8wjNP")));

var $biRRW = parcelRequire("biRRW");

var $40a3b2c02656d57f$var$_capitalize = $368639c97fe780bf$exports((parcelRequire("b7grI")));

var $40a3b2c02656d57f$var$_getDisplayName = $368639c97fe780bf$exports((parcelRequire("5tOGm")));

var $40a3b2c02656d57f$var$_createTheme = $368639c97fe780bf$exports((parcelRequire("3X7TK")));

var $40a3b2c02656d57f$var$_styleFunctionSx = $368639c97fe780bf$exports((parcelRequire("5pVfa")));
const $40a3b2c02656d57f$var$_excluded = [
    "ownerState"
], $40a3b2c02656d57f$var$_excluded2 = [
    "variants"
], $40a3b2c02656d57f$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $40a3b2c02656d57f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($40a3b2c02656d57f$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $40a3b2c02656d57f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $40a3b2c02656d57f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $40a3b2c02656d57f$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $40a3b2c02656d57f$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $40a3b2c02656d57f$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $40a3b2c02656d57f$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $40a3b2c02656d57f$var$systemDefaultTheme = $40a3b2c02656d57f$exports.systemDefaultTheme = (0, $40a3b2c02656d57f$var$_createTheme.default)();
const $40a3b2c02656d57f$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $40a3b2c02656d57f$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $40a3b2c02656d57f$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $40a3b2c02656d57f$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $40a3b2c02656d57f$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $40a3b2c02656d57f$var$_objectWithoutPropertiesLoose2.default)(_ref, $40a3b2c02656d57f$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $40a3b2c02656d57f$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$40a3b2c02656d57f$var$processStyleArg(resolvedStyle, (0, $40a3b2c02656d57f$var$_extends2.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $40a3b2c02656d57f$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $40a3b2c02656d57f$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $40a3b2c02656d57f$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $40a3b2c02656d57f$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $40a3b2c02656d57f$var$shallowLayer((0, $40a3b2c02656d57f$var$_styledEngine.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $40a3b2c02656d57f$var$shallowLayer((0, $40a3b2c02656d57f$var$_styledEngine.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $40a3b2c02656d57f$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $40a3b2c02656d57f$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $40a3b2c02656d57f$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $40a3b2c02656d57f$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $40a3b2c02656d57f$var$_styleFunctionSx.default)((0, $40a3b2c02656d57f$var$_extends2.default)({}, props, {
            theme: $40a3b2c02656d57f$var$resolveTheme((0, $40a3b2c02656d57f$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $40a3b2c02656d57f$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $40a3b2c02656d57f$var$defaultOverridesResolver($40a3b2c02656d57f$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $40a3b2c02656d57f$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $40a3b2c02656d57f$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $40a3b2c02656d57f$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($40a3b2c02656d57f$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $40a3b2c02656d57f$var$_styledEngine.default)(tag, (0, $40a3b2c02656d57f$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $biRRW.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $40a3b2c02656d57f$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $40a3b2c02656d57f$var$processStyleArg(stylesArg, (0, $40a3b2c02656d57f$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $40a3b2c02656d57f$var$resolveTheme((0, $40a3b2c02656d57f$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $40a3b2c02656d57f$var$processStyleArg(slotStyle, (0, $40a3b2c02656d57f$var$_extends2.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $40a3b2c02656d57f$var$resolveTheme((0, $40a3b2c02656d57f$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $40a3b2c02656d57f$var$processStyleArg({
                    variants: themeVariants
                }, (0, $40a3b2c02656d57f$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}



var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $e3Eh1 = parcelRequire("e3Eh1");

var $biRRW = parcelRequire("biRRW");

var $ak9Gk = parcelRequire("ak9Gk");
var $agTT6 = parcelRequire("agTT6");

var $aJsfD = parcelRequire("aJsfD");


var $elnlQ = parcelRequire("elnlQ");
function $40a02631d7794fdb$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $elnlQ.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}



var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $e3Eh1 = parcelRequire("e3Eh1");

var $biRRW = parcelRequire("biRRW");

const $96a30d4506e84e07$var$common = {
    black: '#000',
    white: '#fff'
};
var $96a30d4506e84e07$export$2e2bcd8739ae039 = $96a30d4506e84e07$var$common;


const $2bf09e8aafc71898$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $2bf09e8aafc71898$export$2e2bcd8739ae039 = $2bf09e8aafc71898$var$grey;


const $ca96511fc2d62b66$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $ca96511fc2d62b66$export$2e2bcd8739ae039 = $ca96511fc2d62b66$var$purple;


const $b952879c01f9718e$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $b952879c01f9718e$export$2e2bcd8739ae039 = $b952879c01f9718e$var$red;


const $dfdf450dc15de4e0$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $dfdf450dc15de4e0$export$2e2bcd8739ae039 = $dfdf450dc15de4e0$var$orange;


const $e1c2b232d33f641d$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $e1c2b232d33f641d$export$2e2bcd8739ae039 = $e1c2b232d33f641d$var$blue;


const $8ae290d1c1251e12$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $8ae290d1c1251e12$export$2e2bcd8739ae039 = $8ae290d1c1251e12$var$lightBlue;


const $cdae926070f04ccc$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $cdae926070f04ccc$export$2e2bcd8739ae039 = $cdae926070f04ccc$var$green;


const $422bc56442919213$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $422bc56442919213$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $96a30d4506e84e07$export$2e2bcd8739ae039).white,
        default: (0, $96a30d4506e84e07$export$2e2bcd8739ae039).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $422bc56442919213$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $96a30d4506e84e07$export$2e2bcd8739ae039).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $96a30d4506e84e07$export$2e2bcd8739ae039).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $422bc56442919213$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $d4db04b0acbeed96$exports.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $d4db04b0acbeed96$exports.darken)(intent.main, tonalOffsetDark);
    }
}
function $422bc56442919213$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $e1c2b232d33f641d$export$2e2bcd8739ae039)[200],
        light: (0, $e1c2b232d33f641d$export$2e2bcd8739ae039)[50],
        dark: (0, $e1c2b232d33f641d$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $e1c2b232d33f641d$export$2e2bcd8739ae039)[700],
        light: (0, $e1c2b232d33f641d$export$2e2bcd8739ae039)[400],
        dark: (0, $e1c2b232d33f641d$export$2e2bcd8739ae039)[800]
    };
}
function $422bc56442919213$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $ca96511fc2d62b66$export$2e2bcd8739ae039)[200],
        light: (0, $ca96511fc2d62b66$export$2e2bcd8739ae039)[50],
        dark: (0, $ca96511fc2d62b66$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $ca96511fc2d62b66$export$2e2bcd8739ae039)[500],
        light: (0, $ca96511fc2d62b66$export$2e2bcd8739ae039)[300],
        dark: (0, $ca96511fc2d62b66$export$2e2bcd8739ae039)[700]
    };
}
function $422bc56442919213$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $b952879c01f9718e$export$2e2bcd8739ae039)[500],
        light: (0, $b952879c01f9718e$export$2e2bcd8739ae039)[300],
        dark: (0, $b952879c01f9718e$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $b952879c01f9718e$export$2e2bcd8739ae039)[700],
        light: (0, $b952879c01f9718e$export$2e2bcd8739ae039)[400],
        dark: (0, $b952879c01f9718e$export$2e2bcd8739ae039)[800]
    };
}
function $422bc56442919213$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $8ae290d1c1251e12$export$2e2bcd8739ae039)[400],
        light: (0, $8ae290d1c1251e12$export$2e2bcd8739ae039)[300],
        dark: (0, $8ae290d1c1251e12$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $8ae290d1c1251e12$export$2e2bcd8739ae039)[700],
        light: (0, $8ae290d1c1251e12$export$2e2bcd8739ae039)[500],
        dark: (0, $8ae290d1c1251e12$export$2e2bcd8739ae039)[900]
    };
}
function $422bc56442919213$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $cdae926070f04ccc$export$2e2bcd8739ae039)[400],
        light: (0, $cdae926070f04ccc$export$2e2bcd8739ae039)[300],
        dark: (0, $cdae926070f04ccc$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $cdae926070f04ccc$export$2e2bcd8739ae039)[800],
        light: (0, $cdae926070f04ccc$export$2e2bcd8739ae039)[500],
        dark: (0, $cdae926070f04ccc$export$2e2bcd8739ae039)[900]
    };
}
function $422bc56442919213$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $dfdf450dc15de4e0$export$2e2bcd8739ae039)[400],
        light: (0, $dfdf450dc15de4e0$export$2e2bcd8739ae039)[300],
        dark: (0, $dfdf450dc15de4e0$export$2e2bcd8739ae039)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $dfdf450dc15de4e0$export$2e2bcd8739ae039)[500],
        dark: (0, $dfdf450dc15de4e0$export$2e2bcd8739ae039)[900]
    };
}
function $422bc56442919213$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $fjJNR.default)(palette, $422bc56442919213$var$_excluded);
    const primary = palette.primary || $422bc56442919213$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $422bc56442919213$var$getDefaultSecondary(mode);
    const error = palette.error || $422bc56442919213$var$getDefaultError(mode);
    const info = palette.info || $422bc56442919213$var$getDefaultInfo(mode);
    const success = palette.success || $422bc56442919213$var$getDefaultSuccess(mode);
    const warning = palette.warning || $422bc56442919213$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $d4db04b0acbeed96$exports.getContrastRatio)(background, $422bc56442919213$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $422bc56442919213$export$55ce6f3a06c59543.text.primary : $422bc56442919213$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $elnlQ.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $e3Eh1.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $e3Eh1.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $422bc56442919213$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $422bc56442919213$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $422bc56442919213$export$55ce6f3a06c59543,
        light: $422bc56442919213$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $biRRW.default)((0, $elnlQ.default)({
        // A collection of common colors.
        common: (0, $elnlQ.default)({}, (0, $96a30d4506e84e07$export$2e2bcd8739ae039)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $2bf09e8aafc71898$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}



var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $biRRW = parcelRequire("biRRW");
const $39d5726129f37a62$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $39d5726129f37a62$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $39d5726129f37a62$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $39d5726129f37a62$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $39d5726129f37a62$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $39d5726129f37a62$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $fjJNR.default)(_ref, $39d5726129f37a62$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $elnlQ.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $39d5726129f37a62$var$defaultFontFamily ? {
            letterSpacing: `${$39d5726129f37a62$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $39d5726129f37a62$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $39d5726129f37a62$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $biRRW.default)((0, $elnlQ.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}


const $8f87aac9a65db6fc$var$shadowKeyUmbraOpacity = 0.2;
const $8f87aac9a65db6fc$var$shadowKeyPenumbraOpacity = 0.14;
const $8f87aac9a65db6fc$var$shadowAmbientShadowOpacity = 0.12;
function $8f87aac9a65db6fc$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$8f87aac9a65db6fc$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$8f87aac9a65db6fc$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$8f87aac9a65db6fc$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $8f87aac9a65db6fc$var$shadows = [
    'none',
    $8f87aac9a65db6fc$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $8f87aac9a65db6fc$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $8f87aac9a65db6fc$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $8f87aac9a65db6fc$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $8f87aac9a65db6fc$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $8f87aac9a65db6fc$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $8f87aac9a65db6fc$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $8f87aac9a65db6fc$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $8f87aac9a65db6fc$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $8f87aac9a65db6fc$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $8f87aac9a65db6fc$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $8f87aac9a65db6fc$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $8f87aac9a65db6fc$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $8f87aac9a65db6fc$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $8f87aac9a65db6fc$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $8f87aac9a65db6fc$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $8f87aac9a65db6fc$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $8f87aac9a65db6fc$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $8f87aac9a65db6fc$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $8f87aac9a65db6fc$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $8f87aac9a65db6fc$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $8f87aac9a65db6fc$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $8f87aac9a65db6fc$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $8f87aac9a65db6fc$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $8f87aac9a65db6fc$export$2e2bcd8739ae039 = $8f87aac9a65db6fc$var$shadows;



var $fjJNR = parcelRequire("fjJNR");

var $elnlQ = parcelRequire("elnlQ");
const $cea78484914d59f7$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $cea78484914d59f7$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $cea78484914d59f7$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $cea78484914d59f7$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $cea78484914d59f7$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $cea78484914d59f7$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $elnlQ.default)({}, $cea78484914d59f7$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $elnlQ.default)({}, $cea78484914d59f7$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $fjJNR.default)(options, $cea78484914d59f7$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $cea78484914d59f7$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $cea78484914d59f7$var$formatMs(delay)}`).join(',');
    };
    return (0, $elnlQ.default)({
        getAutoHeightDuration: $cea78484914d59f7$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $d056af58ec0311e6$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $d056af58ec0311e6$export$2e2bcd8739ae039 = $d056af58ec0311e6$var$zIndex;


const $77115e398517d9f3$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $77115e398517d9f3$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $fjJNR.default)(options, $77115e398517d9f3$var$_excluded);
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateCssVars === undefined) throw new Error((0, $e3Eh1.default)(18));
    const palette = (0, $422bc56442919213$export$2e2bcd8739ae039)(paletteInput);
    const systemTheme = (0, $aJsfD.default)(options);
    let muiTheme = (0, $biRRW.default)(systemTheme, {
        mixins: (0, $40a02631d7794fdb$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $8f87aac9a65db6fc$export$2e2bcd8739ae039).slice(),
        typography: (0, $39d5726129f37a62$export$2e2bcd8739ae039)(palette, typographyInput),
        transitions: (0, $cea78484914d59f7$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: (0, $elnlQ.default)({}, (0, $d056af58ec0311e6$export$2e2bcd8739ae039))
    });
    muiTheme = (0, $biRRW.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $biRRW.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $elnlQ.default)({}, (0, $agTT6.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $ak9Gk.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $77115e398517d9f3$var$warnedOnce = false;
function $77115e398517d9f3$export$c469355549431d9b(...args) {
    return $77115e398517d9f3$var$createTheme(...args);
}
var $77115e398517d9f3$export$2e2bcd8739ae039 = $77115e398517d9f3$var$createTheme;


'use client';
const $771194d5b2f9476e$var$defaultTheme = (0, $77115e398517d9f3$export$2e2bcd8739ae039)();
var $771194d5b2f9476e$export$2e2bcd8739ae039 = $771194d5b2f9476e$var$defaultTheme;


var $f0e1518dbc4d8a1e$export$2e2bcd8739ae039 = '$$material';


// copied from @mui/system/createStyled
function $11d6444568151f27$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $11d6444568151f27$export$2e2bcd8739ae039 = $11d6444568151f27$var$slotShouldForwardProp;


const $0add45061e39dd57$var$rootShouldForwardProp = (prop)=>(0, $11d6444568151f27$export$2e2bcd8739ae039)(prop) && prop !== 'classes';
var $0add45061e39dd57$export$2e2bcd8739ae039 = $0add45061e39dd57$var$rootShouldForwardProp;



'use client';
const $ad5f42e87dfcc43f$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($40a3b2c02656d57f$exports)))({
    themeId: (0, $f0e1518dbc4d8a1e$export$2e2bcd8739ae039),
    defaultTheme: $771194d5b2f9476e$export$2e2bcd8739ae039,
    rootShouldForwardProp: $0add45061e39dd57$export$2e2bcd8739ae039
});
var $ad5f42e87dfcc43f$export$2e2bcd8739ae039 = $ad5f42e87dfcc43f$var$styled;



var $elnlQ = parcelRequire("elnlQ");
parcelRequire("Fo7oF");


var $Fo7oF = parcelRequire("Fo7oF");


var $elnlQ = parcelRequire("elnlQ");
function $6cea0fbd557a0abf$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $elnlQ.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $elnlQ.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $elnlQ.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $6cea0fbd557a0abf$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}



var $eFTP6 = parcelRequire("eFTP6");
'use client';
const $1b7844783315195d$var$PropsContext = /*#__PURE__*/ $Fo7oF.createContext(undefined);
function $1b7844783315195d$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $eFTP6.jsx)($1b7844783315195d$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $1b7844783315195d$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $6cea0fbd557a0abf$export$2e2bcd8739ae039)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $6cea0fbd557a0abf$export$2e2bcd8739ae039)(config, props);
    return props;
}
function $1b7844783315195d$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $Fo7oF.useContext($1b7844783315195d$var$PropsContext);
    return $1b7844783315195d$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $1b7844783315195d$export$2e2bcd8739ae039 = $1b7844783315195d$var$DefaultPropsProvider;



var $eFTP6 = parcelRequire("eFTP6");
'use client';
function $fcafec987ec8106f$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1b7844783315195d$export$2e2bcd8739ae039), (0, $elnlQ.default)({}, props));
}
var $fcafec987ec8106f$export$2e2bcd8739ae039 = $fcafec987ec8106f$var$DefaultPropsProvider;
function $fcafec987ec8106f$export$2440da353cedad43(params) {
    return (0, $1b7844783315195d$export$2440da353cedad43)(params);
}



var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $Fo7oF = parcelRequire("Fo7oF");








var $Fo7oF = parcelRequire("Fo7oF");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $2422d2143a25966a$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $17f8d81559bd7ed2$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $Fo7oF.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $2422d2143a25966a$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


'use client';
var $2638595c835ba541$export$2e2bcd8739ae039 = (0, $17f8d81559bd7ed2$export$2e2bcd8739ae039);



var $Fo7oF = parcelRequire("Fo7oF");

var $Fo7oF = parcelRequire("Fo7oF");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $2be3c58238ebe706$var$useEnhancedEffect = typeof window !== 'undefined' ? $Fo7oF.useLayoutEffect : $Fo7oF.useEffect;
var $2be3c58238ebe706$export$2e2bcd8739ae039 = $2be3c58238ebe706$var$useEnhancedEffect;


'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $ac20b2bce05b773e$var$useEventCallback(fn) {
    const ref = $Fo7oF.useRef(fn);
    (0, $2be3c58238ebe706$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $Fo7oF.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $ac20b2bce05b773e$export$2e2bcd8739ae039 = $ac20b2bce05b773e$var$useEventCallback;


'use client';
var $2cf43d675fd6e331$export$2e2bcd8739ae039 = (0, $ac20b2bce05b773e$export$2e2bcd8739ae039);



var $Fo7oF = parcelRequire("Fo7oF");

var $Fo7oF = parcelRequire("Fo7oF");
'use client';
const $0fb0e5cd051d5c10$var$UNINITIALIZED = {};
function $0fb0e5cd051d5c10$export$2e2bcd8739ae039(init, initArg) {
    const ref = $Fo7oF.useRef($0fb0e5cd051d5c10$var$UNINITIALIZED);
    if (ref.current === $0fb0e5cd051d5c10$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $Fo7oF = parcelRequire("Fo7oF");
'use client';
const $00ca5c31e6a2d50b$var$EMPTY = [];
function $00ca5c31e6a2d50b$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $Fo7oF.useEffect(fn, $00ca5c31e6a2d50b$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $d19b125a5a849404$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $d19b125a5a849404$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $d19b125a5a849404$export$2e2bcd8739ae039() {
    const timeout = (0, $0fb0e5cd051d5c10$export$2e2bcd8739ae039)($d19b125a5a849404$export$786b4da70f00938b.create).current;
    (0, $00ca5c31e6a2d50b$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


'use client';
let $74b1045be6d91f06$var$hadKeyboardEvent = true;
let $74b1045be6d91f06$var$hadFocusVisibleRecently = false;
const $74b1045be6d91f06$var$hadFocusVisibleRecentlyTimeout = new (0, $d19b125a5a849404$export$786b4da70f00938b)();
const $74b1045be6d91f06$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $74b1045be6d91f06$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $74b1045be6d91f06$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $74b1045be6d91f06$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $74b1045be6d91f06$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $74b1045be6d91f06$var$handlePointerDown() {
    $74b1045be6d91f06$var$hadKeyboardEvent = false;
}
function $74b1045be6d91f06$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($74b1045be6d91f06$var$hadFocusVisibleRecently) $74b1045be6d91f06$var$hadKeyboardEvent = true;
    }
}
function $74b1045be6d91f06$var$prepare(doc) {
    doc.addEventListener('keydown', $74b1045be6d91f06$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $74b1045be6d91f06$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $74b1045be6d91f06$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $74b1045be6d91f06$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $74b1045be6d91f06$var$handleVisibilityChange, true);
}
function $74b1045be6d91f06$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $74b1045be6d91f06$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $74b1045be6d91f06$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $74b1045be6d91f06$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $74b1045be6d91f06$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $74b1045be6d91f06$var$handleVisibilityChange, true);
}
function $74b1045be6d91f06$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $74b1045be6d91f06$var$hadKeyboardEvent || $74b1045be6d91f06$var$focusTriggersKeyboardModality(target);
}
function $74b1045be6d91f06$export$2e2bcd8739ae039() {
    const ref = $Fo7oF.useCallback((node)=>{
        if (node != null) $74b1045be6d91f06$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $Fo7oF.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $74b1045be6d91f06$var$hadFocusVisibleRecently = true;
            $74b1045be6d91f06$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $74b1045be6d91f06$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($74b1045be6d91f06$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


'use client';
var $ab3a7dc8d0a5d99f$export$2e2bcd8739ae039 = (0, $74b1045be6d91f06$export$2e2bcd8739ae039);



var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $Fo7oF = parcelRequire("Fo7oF");




var $euOyk = parcelRequire("euOyk");




var $Fo7oF = parcelRequire("Fo7oF");



var $eFTP6 = parcelRequire("eFTP6");
'use client';
function $d8eaef2c7a9500b1$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $Fo7oF.useState(false);
    const rippleClassName = (0, $57f9e9fab6f781fc$export$2e2bcd8739ae039)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $57f9e9fab6f781fc$export$2e2bcd8739ae039)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $Fo7oF.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
            className: childClassName
        })
    });
}
var $d8eaef2c7a9500b1$export$2e2bcd8739ae039 = $d8eaef2c7a9500b1$var$Ripple;


const $a3034a92e1e63f4f$var$defaultGenerator = (componentName)=>componentName;
const $a3034a92e1e63f4f$var$createClassNameGenerator = ()=>{
    let generate = $a3034a92e1e63f4f$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $a3034a92e1e63f4f$var$defaultGenerator;
        }
    };
};
const $a3034a92e1e63f4f$var$ClassNameGenerator = $a3034a92e1e63f4f$var$createClassNameGenerator();
var $a3034a92e1e63f4f$export$2e2bcd8739ae039 = $a3034a92e1e63f4f$var$ClassNameGenerator;


const $92c782f114dd9234$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $92c782f114dd9234$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $92c782f114dd9234$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $a3034a92e1e63f4f$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}
function $92c782f114dd9234$export$34c0130b1f3e8ae3(slot) {
    return $92c782f114dd9234$export$9d6b9120de57c54[slot] !== undefined;
}


function $3ff8307cf2c8fc75$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $92c782f114dd9234$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}



function $a40bd19e5a798a67$export$b464606f735ab902(slot) {
    return (0, $92c782f114dd9234$export$2e2bcd8739ae039)('MuiTouchRipple', slot);
}
const $a40bd19e5a798a67$var$touchRippleClasses = (0, $3ff8307cf2c8fc75$export$2e2bcd8739ae039)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $a40bd19e5a798a67$export$2e2bcd8739ae039 = $a40bd19e5a798a67$var$touchRippleClasses;



var $eFTP6 = parcelRequire("eFTP6");
'use client';
const $7ffce79384a275cc$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $7ffce79384a275cc$var$_ = (t)=>t, $7ffce79384a275cc$var$_t, $7ffce79384a275cc$var$_t2, $7ffce79384a275cc$var$_t3, $7ffce79384a275cc$var$_t4;
const $7ffce79384a275cc$var$DURATION = 550;
const $7ffce79384a275cc$export$95d0c9356b2231a3 = 80;
const $7ffce79384a275cc$var$enterKeyframe = (0, $euOyk.keyframes)($7ffce79384a275cc$var$_t || ($7ffce79384a275cc$var$_t = $7ffce79384a275cc$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $7ffce79384a275cc$var$exitKeyframe = (0, $euOyk.keyframes)($7ffce79384a275cc$var$_t2 || ($7ffce79384a275cc$var$_t2 = $7ffce79384a275cc$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $7ffce79384a275cc$var$pulsateKeyframe = (0, $euOyk.keyframes)($7ffce79384a275cc$var$_t3 || ($7ffce79384a275cc$var$_t3 = $7ffce79384a275cc$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $7ffce79384a275cc$export$f6b7418508c72c25 = (0, $ad5f42e87dfcc43f$export$2e2bcd8739ae039)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $7ffce79384a275cc$export$676cfe7b12693c4b = (0, $ad5f42e87dfcc43f$export$2e2bcd8739ae039)((0, $d8eaef2c7a9500b1$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($7ffce79384a275cc$var$_t4 || ($7ffce79384a275cc$var$_t4 = $7ffce79384a275cc$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $a40bd19e5a798a67$export$2e2bcd8739ae039).rippleVisible, $7ffce79384a275cc$var$enterKeyframe, $7ffce79384a275cc$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $a40bd19e5a798a67$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $a40bd19e5a798a67$export$2e2bcd8739ae039).child, (0, $a40bd19e5a798a67$export$2e2bcd8739ae039).childLeaving, $7ffce79384a275cc$var$exitKeyframe, $7ffce79384a275cc$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $a40bd19e5a798a67$export$2e2bcd8739ae039).childPulsate, $7ffce79384a275cc$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $7ffce79384a275cc$var$TouchRipple = /*#__PURE__*/ $Fo7oF.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $fcafec987ec8106f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $fjJNR.default)(props, $7ffce79384a275cc$var$_excluded);
    const [ripples, setRipples] = $Fo7oF.useState([]);
    const nextKey = $Fo7oF.useRef(0);
    const rippleCallback = $Fo7oF.useRef(null);
    $Fo7oF.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $Fo7oF.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $d19b125a5a849404$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $Fo7oF.useRef(null);
    const container = $Fo7oF.useRef(null);
    const startCommit = $Fo7oF.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $eFTP6.jsx)($7ffce79384a275cc$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $57f9e9fab6f781fc$export$2e2bcd8739ae039)(classes.ripple, (0, $a40bd19e5a798a67$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $57f9e9fab6f781fc$export$2e2bcd8739ae039)(classes.rippleVisible, (0, $a40bd19e5a798a67$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $57f9e9fab6f781fc$export$2e2bcd8739ae039)(classes.ripplePulsate, (0, $a40bd19e5a798a67$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $57f9e9fab6f781fc$export$2e2bcd8739ae039)(classes.child, (0, $a40bd19e5a798a67$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $57f9e9fab6f781fc$export$2e2bcd8739ae039)(classes.childLeaving, (0, $a40bd19e5a798a67$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $57f9e9fab6f781fc$export$2e2bcd8739ae039)(classes.childPulsate, (0, $a40bd19e5a798a67$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $7ffce79384a275cc$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $Fo7oF.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($7ffce79384a275cc$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $Fo7oF.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $Fo7oF.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $Fo7oF.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $eFTP6.jsx)($7ffce79384a275cc$export$f6b7418508c72c25, (0, $elnlQ.default)({
        className: (0, $57f9e9fab6f781fc$export$2e2bcd8739ae039)((0, $a40bd19e5a798a67$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $7568199b92ec00e5$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $7ffce79384a275cc$export$2e2bcd8739ae039 = $7ffce79384a275cc$var$TouchRipple;




function $617d497f237ece48$export$fccb0498dcd99783(slot) {
    return (0, $92c782f114dd9234$export$2e2bcd8739ae039)('MuiButtonBase', slot);
}
const $617d497f237ece48$var$buttonBaseClasses = (0, $3ff8307cf2c8fc75$export$2e2bcd8739ae039)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $617d497f237ece48$export$2e2bcd8739ae039 = $617d497f237ece48$var$buttonBaseClasses;



var $eFTP6 = parcelRequire("eFTP6");
'use client';
const $d6faaf737bf438d1$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $d6faaf737bf438d1$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $6912f2a122303628$export$2e2bcd8739ae039)(slots, (0, $617d497f237ece48$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $d6faaf737bf438d1$export$7ec0dcc5e3cdcd36 = (0, $ad5f42e87dfcc43f$export$2e2bcd8739ae039)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $617d497f237ece48$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $d6faaf737bf438d1$var$ButtonBase = /*#__PURE__*/ $Fo7oF.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $fcafec987ec8106f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $fjJNR.default)(props, $d6faaf737bf438d1$var$_excluded);
    const buttonRef = $Fo7oF.useRef(null);
    const rippleRef = $Fo7oF.useRef(null);
    const handleRippleRef = (0, $2638595c835ba541$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $ab3a7dc8d0a5d99f$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $Fo7oF.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $Fo7oF.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $Fo7oF.useState(false);
    $Fo7oF.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $Fo7oF.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $2cf43d675fd6e331$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $2cf43d675fd6e331$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $Fo7oF.useRef(false);
    const handleKeyDown = (0, $2cf43d675fd6e331$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $2cf43d675fd6e331$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $2638595c835ba541$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $elnlQ.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $d6faaf737bf438d1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $eFTP6.jsxs)($d6faaf737bf438d1$export$7ec0dcc5e3cdcd36, (0, $elnlQ.default)({
        as: ComponentProp,
        className: (0, $57f9e9fab6f781fc$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $eFTP6.jsx)((0, $7ffce79384a275cc$export$2e2bcd8739ae039), (0, $elnlQ.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $d6faaf737bf438d1$export$2e2bcd8739ae039 = $d6faaf737bf438d1$var$ButtonBase;



var $g00EB = parcelRequire("g00EB");
var $a40686bcce9ccc8a$export$2e2bcd8739ae039 = (0, $g00EB.default);




function $3c9918ff20244bb9$export$5e8702d71474f093(slot) {
    return (0, $92c782f114dd9234$export$2e2bcd8739ae039)('MuiIconButton', slot);
}
const $3c9918ff20244bb9$var$iconButtonClasses = (0, $3ff8307cf2c8fc75$export$2e2bcd8739ae039)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $3c9918ff20244bb9$export$2e2bcd8739ae039 = $3c9918ff20244bb9$var$iconButtonClasses;



var $eFTP6 = parcelRequire("eFTP6");
'use client';
const $f34b7afd4ebe08fc$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $f34b7afd4ebe08fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $a40686bcce9ccc8a$export$2e2bcd8739ae039)(color)}`,
            edge && `edge${(0, $a40686bcce9ccc8a$export$2e2bcd8739ae039)(edge)}`,
            `size${(0, $a40686bcce9ccc8a$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $6912f2a122303628$export$2e2bcd8739ae039)(slots, (0, $3c9918ff20244bb9$export$5e8702d71474f093), classes);
};
const $f34b7afd4ebe08fc$var$IconButtonRoot = (0, $ad5f42e87dfcc43f$export$2e2bcd8739ae039)((0, $d6faaf737bf438d1$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $a40686bcce9ccc8a$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $a40686bcce9ccc8a$export$2e2bcd8739ae039)(ownerState.edge)}`],
            styles[`size${(0, $a40686bcce9ccc8a$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $elnlQ.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $d4db04b0acbeed96$exports.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $elnlQ.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $elnlQ.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $elnlQ.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $d4db04b0acbeed96$exports.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $3c9918ff20244bb9$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $f34b7afd4ebe08fc$var$IconButton = /*#__PURE__*/ $Fo7oF.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $fcafec987ec8106f$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $fjJNR.default)(props, $f34b7afd4ebe08fc$var$_excluded);
    const ownerState = (0, $elnlQ.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $f34b7afd4ebe08fc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $eFTP6.jsx)($f34b7afd4ebe08fc$var$IconButtonRoot, (0, $elnlQ.default)({
        className: (0, $57f9e9fab6f781fc$export$2e2bcd8739ae039)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $f34b7afd4ebe08fc$export$2e2bcd8739ae039 = $f34b7afd4ebe08fc$var$IconButton;






var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");

const $fff13ca3fea305fa$export$540e7666225e84be = 'alerts.AN_ERROR_OCCURRED';
const $fff13ca3fea305fa$export$d77641b7e1f952a6 = {
    'ANCHOR_TAB_STRING_NOT_FOUND': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'alerts.ANCHOR_TAB_STRING_NOT_FOUND'
    }),
    'GENERIC_ERROR': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'alerts.GENERIC_ERROR'
    }),
    'INVALID_EMAIL_ADDRESS_FOR_RECIPIENT': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'alerts.INVALID_EMAIL_ADDRESS_FOR_RECIPIENT'
    })
};
const $fff13ca3fea305fa$export$b74071247c4c0bb4 = /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
    id: 'alerts.DUPLICATE_SIGNER_ERROR'
});
const $fff13ca3fea305fa$export$2d34b090e360d9ca = /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
    id: 'alerts.MANDATORY_FIELD_FOR_SIGNER_ERROR'
});
const $fff13ca3fea305fa$export$cd1128a48dbe8d2c = /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
    id: 'alerts.DUPLICATE_EMAIL_MOBILE_SIGNER_ERROR'
});
const $fff13ca3fea305fa$export$8fa2abd762c7dcc8 = /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
    id: 'alerts.DUPLICATE_EMAIL_MOBILE_SIGNER_LEGAL_COMPLIANCE'
});
const $fff13ca3fea305fa$export$637c4a33103d8bbe = {
    'NO_SIGNER_DOCUMENT_SELECTED_MESSAGE': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'alerts.NO_SIGNER_OR_DOCUMENT_SELECTED'
    }),
    'NO_SIGNER_DOCUMENT_SELECTED_ACTION': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'alerts.NO_SIGNER_DOCUMENT_SELECTED_ACTION'
    }),
    'NO_SIGNER_SELECTED': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'alerts.NO_SIGNER_SELECTED'
    }),
    'NO_DOCUMENT_SELECTED': /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'alerts.NO_DOCUMENT_SELECTED'
    })
};
const $fff13ca3fea305fa$export$38c17fd507d6a604 = 'alerts.NO_SIGNED_DOCUMENTS_AVAILABLE';
const $fff13ca3fea305fa$export$33186d4108d76629 = {
    ES: {
        'locale': 'es_ES',
        getIsdCode: ()=>'+34',
        getCountryName: ()=>'labels.SPAIN'
    },
    DE: {
        'locale': 'de_DE',
        getIsdCode: ()=>'+49',
        getCountryName: ()=>'labels.GERMANY'
    },
    UK: {
        'locale': 'en_GB',
        getIsdCode: ()=>'+44',
        getCountryName: ()=>'labels.UNITED_KINGDOM'
    },
    GB: {
        'locale': 'en_GB',
        getIsdCode: ()=>'+44',
        getCountryName: ()=>'labels.UNITED_KINGDOM'
    },
    PT: {
        'locale': 'pt_PT',
        getIsdCode: ()=>'+351',
        getCountryName: ()=>'labels.PORTUGAL'
    }
};
const $fff13ca3fea305fa$export$8ad15c0595d77203 = [
    'Proposed',
    'Quote',
    'Submitted'
];
const $fff13ca3fea305fa$export$3eb496376f50c0bb = 'alerts.EXCLUDE_ALFA_CASE_STATUS_ERROR_MESSAGE';
const $fff13ca3fea305fa$export$deeeeccc481ce51a = [
    'ANCHOR_TAB_STRING_NOT_FOUND',
    'INVALID_EMAIL_ADDRESS_FOR_RECIPIENT',
    'PHONE_NUMBER_INVALID',
    'INVALID_EMAIL_ADDRESS'
];
const $fff13ca3fea305fa$export$445324ddcea400ab = {
    'DPFR - 24 month Loan Stock DE': 'products.DPFR_24_MONTH_LOAN_STOCK_DE',
    'DPFR - Loan DE': 'products.DPFR_LOAN_DE',
    'DPFR - Loan Stock DE': 'products.DPFR_LOAN_STOCK_DE',
    'DPFR - Non Full Payout Lease DE': 'products.DPFR_NON_FULL_PAYOUT_LEASE_DE',
    'DPFR - Operating Lease DE': 'products.DPFR_OPERATING_LEASE_DE',
    'Loan DE': 'products.LOAN_DE',
    'Non Full Payout Lease DE': 'products.NON_FULL_PAYOUT_LEASE_DE',
    'Operating Lease DE': 'products.OPERATING_LEASE_DE'
};
const $fff13ca3fea305fa$export$2f366a6780c600bc = 'CONTRATO';
const $fff13ca3fea305fa$export$5077d0853d786d24 = 'ES';
const $fff13ca3fea305fa$export$f38ea8db6d27a647 = 'DE';
const $fff13ca3fea305fa$export$36fc17e38f57b5c7 = 'UK';
const $fff13ca3fea305fa$export$e996d55be246b546 = 'PT';




var $d2bgE = parcelRequire("d2bgE");

var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");




var $d2bgE = parcelRequire("d2bgE");

const $d9a0f318b57c2b12$export$f4787d1f58fa1eb7 = ({ disabled: disabled, documentsInEnvelope: documentsInEnvelope, documentType: documentType, dropdownHandler: dropdownHandler, envelopeId: envelopeId })=>{
    const envelopeContainsContratoDocument = documentsInEnvelope.some((document)=>document && document.documentDesc && document.documentDesc.toUpperCase() === (0, $fff13ca3fea305fa$export$2f366a6780c600bc));
    return /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Dropdown), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2260333d3ecc242c$exports))).dropdownMenuDiv,
        children: [
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Dropdown).Toggle, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2260333d3ecc242c$exports))).dropdownFeature,
                disabled: disabled,
                id: "dropdown-basic",
                variant: "secondary",
                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                    id: `labels.${documentType}`
                })
            }),
            /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Dropdown).Menu, {
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Dropdown).Item, {
                        inline: true,
                        onSelect: ()=>dropdownHandler('COMBINED'),
                        value: 'COMBINED',
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                            id: 'labels.COMBINED'
                        })
                    }, `pdf-${envelopeId}`),
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Dropdown).Item, {
                        onSelect: ()=>dropdownHandler('SEPARATE'),
                        value: 'SEPARATE',
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                            id: 'labels.SEPARATE'
                        })
                    }, `zip-${envelopeId}`),
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Dropdown).Item, {
                        disabled: !envelopeContainsContratoDocument,
                        onSelect: ()=>dropdownHandler('E-REGISTRY_DOWNLOAD'),
                        value: 'E-REGISTRY_DOWNLOAD',
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                            id: 'labels.E-REGISTRY_DOWNLOAD'
                        })
                    }, `eregistry-${envelopeId}`)
                ]
            })
        ]
    });
};
$d9a0f318b57c2b12$export$f4787d1f58fa1eb7.propTypes = {
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool.isRequired,
    documentsInEnvelope: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).array.isRequired,
    documentType: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    dropdownHandler: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func.isRequired,
    envelopeId: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired
};


function $c8342d32993f137e$export$2e2bcd8739ae039(props) {
    const intl = (0, $b637120a7f65e10c$export$2e2bcd8739ae039)();
    const [documentType, setDocumentType] = (0, $Fo7oF.useState)('COMBINED');
    const [downloading, setDownloading] = (0, $Fo7oF.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $Fo7oF.useState)('');
    const { bundleNumber: bundleNumber, documentsInEnvelope: documentsInEnvelope, envelopeId: envelopeId, envelopeStatus: envelopeStatus, icsID: icsID, quoteNumber: quoteNumber, userBranchCode: userBranchCode, userHasAccessToERegistry: userHasAccessToERegistry } = props;
    const disableDocumentDownload = !(envelopeStatus === 'completed' && userBranchCode.includes('DRO', 'ASM'));
    const documentTypeMap = {
        'COMBINED': {
            documentName: 'combined.pdf',
            downloadFileName: `${bundleNumber}-${quoteNumber}.pdf`
        },
        'SEPARATE': {
            documentName: 'archive.zip',
            downloadFileName: `${bundleNumber}-${quoteNumber}.zip`
        },
        'E-REGISTRY_DOWNLOAD': {
            documentName: 'ERegistry.zip',
            downloadFileName: `${bundleNumber}-${quoteNumber}-${icsID}.zip`
        }
    };
    const downloadSignedDocuments = async ()=>{
        setDownloading(true);
        setErrorMessage('');
        try {
            const documentName = documentTypeMap[documentType].documentName;
            const signedDocumentResponse = await (0, $c04283212adf4fb0$export$c4b7edec3f76b207)(`/api/esign/envelope/${envelopeId}/${documentName}`);
            const documentContent = 'data:application/pdf;base64,' + signedDocumentResponse.documentData;
            if (signedDocumentResponse.documentData) {
                const documentLink = document.createElement('a');
                document.body.appendChild(documentLink);
                documentLink.href = documentContent;
                documentLink.download = documentTypeMap[documentType].downloadFileName;
                documentLink.click();
                documentLink.remove();
            } else setErrorMessage(intl.formatMessage({
                id: (0, $fff13ca3fea305fa$export$38c17fd507d6a604)
            }));
        } catch (err) {
            setErrorMessage(intl.formatMessage({
                id: (0, $fff13ca3fea305fa$export$540e7666225e84be)
            }));
        } finally{
            setDownloading(false);
        }
    };
    function radioButtonHandler(value) {
        setDocumentType(value);
    }
    function dropdownHandler(value) {
        setDocumentType(value);
    }
    const componentMap = {
        [userHasAccessToERegistry]: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $d9a0f318b57c2b12$export$f4787d1f58fa1eb7), {
            disabled: disableDocumentDownload,
            documentType: documentType,
            documentsInEnvelope: documentsInEnvelope,
            dropdownHandler: dropdownHandler,
            envelopeId: envelopeId
        }),
        [!userHasAccessToERegistry]: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $eFTP6.Fragment), {
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.RadioButton), {
                    checked: documentType === 'COMBINED',
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($2260333d3ecc242c$exports))).downloadDocRadio,
                    disabled: disableDocumentDownload,
                    id: `pdf-${envelopeId}`,
                    inline: true,
                    label: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                        id: 'labels.COMBINED'
                    }),
                    name: envelopeId,
                    onChange: ()=>radioButtonHandler('COMBINED'),
                    value: 'COMBINED'
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.RadioButton), {
                    checked: documentType === 'SEPARATE',
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($2260333d3ecc242c$exports))).downloadDocRadio,
                    disabled: disableDocumentDownload,
                    id: `zip-${envelopeId}`,
                    inline: true,
                    label: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                        id: 'labels.SEPARATE'
                    }),
                    name: envelopeId,
                    onChange: ()=>radioButtonHandler('SEPARATE'),
                    value: 'SEPARATE'
                })
            ]
        })
    };
    return /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form).Group, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2260333d3ecc242c$exports))).downloadSignedDocDiv,
        children: [
            /*#__PURE__*/ (0, $eFTP6.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsx)("p", {
                        className: "download-docs",
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                            id: 'labels.DOWNLOAD'
                        })
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsxs)("span", {
                        children: [
                            componentMap.true,
                            /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($2260333d3ecc242c$exports))).downloadFiles,
                                children: [
                                    downloading && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f4267c9105e002e8$export$fe708d541030d854), {
                                        size: "sm"
                                    }),
                                    !downloading && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f34b7afd4ebe08fc$export$2e2bcd8739ae039), {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($2260333d3ecc242c$exports))).downloadIcon,
                                        disabled: disableDocumentDownload,
                                        onClick: downloadSignedDocuments,
                                        size: "large",
                                        title: intl.formatMessage({
                                            id: 'labels.DOWNLOAD'
                                        }),
                                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a88484a22110b9b6$exports))), {})
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2260333d3ecc242c$exports))).downloadError,
                children: errorMessage
            })
        ]
    });
}
$c8342d32993f137e$export$2e2bcd8739ae039.propTypes = {
    bundleNumber: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    documentsInEnvelope: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).array.isRequired,
    envelopeId: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    envelopeStatus: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    icsID: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    quoteNumber: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    userBranchCode: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    userHasAccessToERegistry: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool.isRequired
};




var $eFTP6 = parcelRequire("eFTP6");

var $d2bgE = parcelRequire("d2bgE");

var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");

const $91b041060f19e3dd$export$ea368e53cc6e07e9 = [
    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.REVIEW_MESSAGE_OTP'
    }),
    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.REVIEW_MESSAGE_ISD_CODE'
    }),
    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: 'labels.REVIEW_MESSAGE_DETAILS_CANNOT_UPDATE'
    })
];
const $91b041060f19e3dd$export$53e31fc9a3189fd8 = 'alerts.START_DATE_WARNING_MESSAGE';
const $91b041060f19e3dd$export$ca1267a54e2ff5a6 = 'alerts.INVALID_PRODUCT_WARNING';
const $91b041060f19e3dd$export$7567ba3a14d8b191 = 'alerts.GUARANTOR_WARNING_MESSAGE';



parcelRequire("Fo7oF");


var $eFTP6 = parcelRequire("eFTP6");

var $d2bgE = parcelRequire("d2bgE");

var $elnlQ = parcelRequire("elnlQ");

var $8YHhK = parcelRequire("8YHhK");

var $67mp8 = parcelRequire("67mp8");

var $d2vKa = parcelRequire("d2vKa");

var $Fo7oF = parcelRequire("Fo7oF");

var $bvYwR = parcelRequire("bvYwR");


var $78z8j = parcelRequire("78z8j");

var $dbHGl = parcelRequire("dbHGl");

var $8Hh6N = parcelRequire("8Hh6N");

var $5rVgt = parcelRequire("5rVgt");

var $bT5dp = parcelRequire("bT5dp");


var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");

/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1-lts
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $41a5bf479ceb67fa$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
var $41a5bf479ceb67fa$var$timeoutDuration = function() {
    var longerTimeoutBrowsers = [
        'Edge',
        'Trident',
        'Firefox'
    ];
    for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
        if ($41a5bf479ceb67fa$var$isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
    }
    return 0;
}();
function $41a5bf479ceb67fa$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $41a5bf479ceb67fa$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $41a5bf479ceb67fa$var$timeoutDuration);
        }
    };
}
var $41a5bf479ceb67fa$var$supportsMicroTasks = $41a5bf479ceb67fa$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $41a5bf479ceb67fa$var$debounce = $41a5bf479ceb67fa$var$supportsMicroTasks ? $41a5bf479ceb67fa$var$microtaskDebounce : $41a5bf479ceb67fa$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $41a5bf479ceb67fa$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $41a5bf479ceb67fa$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $41a5bf479ceb67fa$var$getParentNode(element) {
    if (element.nodeName === 'HTML') return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $41a5bf479ceb67fa$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $41a5bf479ceb67fa$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $41a5bf479ceb67fa$var$getScrollParent($41a5bf479ceb67fa$var$getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */ function $41a5bf479ceb67fa$var$getReferenceNode(reference) {
    return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var $41a5bf479ceb67fa$var$isIE11 = $41a5bf479ceb67fa$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $41a5bf479ceb67fa$var$isIE10 = $41a5bf479ceb67fa$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $41a5bf479ceb67fa$var$isIE(version) {
    if (version === 11) return $41a5bf479ceb67fa$var$isIE11;
    if (version === 10) return $41a5bf479ceb67fa$var$isIE10;
    return $41a5bf479ceb67fa$var$isIE11 || $41a5bf479ceb67fa$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $41a5bf479ceb67fa$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $41a5bf479ceb67fa$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        'TH',
        'TD',
        'TABLE'
    ].indexOf(offsetParent.nodeName) !== -1 && $41a5bf479ceb67fa$var$getStyleComputedProperty(offsetParent, 'position') === 'static') return $41a5bf479ceb67fa$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $41a5bf479ceb67fa$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY') return false;
    return nodeName === 'HTML' || $41a5bf479ceb67fa$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $41a5bf479ceb67fa$var$getRoot(node) {
    if (node.parentNode !== null) return $41a5bf479ceb67fa$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $41a5bf479ceb67fa$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($41a5bf479ceb67fa$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $41a5bf479ceb67fa$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $41a5bf479ceb67fa$var$getRoot(element1);
    if (element1root.host) return $41a5bf479ceb67fa$var$findCommonOffsetParent(element1root.host, element2);
    else return $41a5bf479ceb67fa$var$findCommonOffsetParent(element1, $41a5bf479ceb67fa$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $41a5bf479ceb67fa$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $41a5bf479ceb67fa$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $41a5bf479ceb67fa$var$getScroll(element, 'top');
    var scrollLeft = $41a5bf479ceb67fa$var$getScroll(element, 'left');
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $41a5bf479ceb67fa$var$getBordersSize(styles, axis) {
    var sideA = axis === 'x' ? 'Left' : 'Top';
    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
    return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}
function $41a5bf479ceb67fa$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], $41a5bf479ceb67fa$var$isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function $41a5bf479ceb67fa$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $41a5bf479ceb67fa$var$isIE(10) && getComputedStyle(html);
    return {
        height: $41a5bf479ceb67fa$var$getSize('Height', body, html, computedStyle),
        width: $41a5bf479ceb67fa$var$getSize('Width', body, html, computedStyle)
    };
}
var $41a5bf479ceb67fa$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $41a5bf479ceb67fa$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $41a5bf479ceb67fa$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $41a5bf479ceb67fa$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $41a5bf479ceb67fa$var$getClientRect(offsets) {
    return $41a5bf479ceb67fa$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $41a5bf479ceb67fa$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($41a5bf479ceb67fa$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $41a5bf479ceb67fa$var$getScroll(element, 'top');
            var scrollLeft = $41a5bf479ceb67fa$var$getScroll(element, 'left');
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === 'HTML' ? $41a5bf479ceb67fa$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.width;
    var height = sizes.height || element.clientHeight || result.height;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $41a5bf479ceb67fa$var$getStyleComputedProperty(element);
        horizScrollbar -= $41a5bf479ceb67fa$var$getBordersSize(styles, 'x');
        vertScrollbar -= $41a5bf479ceb67fa$var$getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $41a5bf479ceb67fa$var$getClientRect(result);
}
function $41a5bf479ceb67fa$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $41a5bf479ceb67fa$var$isIE(10);
    var isHTML = parent.nodeName === 'HTML';
    var childrenRect = $41a5bf479ceb67fa$var$getBoundingClientRect(children);
    var parentRect = $41a5bf479ceb67fa$var$getBoundingClientRect(parent);
    var scrollParent = $41a5bf479ceb67fa$var$getScrollParent(children);
    var styles = $41a5bf479ceb67fa$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $41a5bf479ceb67fa$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop);
        var marginLeft = parseFloat(styles.marginLeft);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') offsets = $41a5bf479ceb67fa$var$includeScroll(offsets, parent);
    return offsets;
}
function $41a5bf479ceb67fa$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $41a5bf479ceb67fa$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $41a5bf479ceb67fa$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $41a5bf479ceb67fa$var$getScroll(html, 'left') : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $41a5bf479ceb67fa$var$getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $41a5bf479ceb67fa$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') return false;
    if ($41a5bf479ceb67fa$var$getStyleComputedProperty(element, 'position') === 'fixed') return true;
    var parentNode = $41a5bf479ceb67fa$var$getParentNode(element);
    if (!parentNode) return false;
    return $41a5bf479ceb67fa$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $41a5bf479ceb67fa$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $41a5bf479ceb67fa$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $41a5bf479ceb67fa$var$getStyleComputedProperty(el, 'transform') === 'none')el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $41a5bf479ceb67fa$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $41a5bf479ceb67fa$var$getFixedPositionOffsetParent(popper) : $41a5bf479ceb67fa$var$findCommonOffsetParent(popper, $41a5bf479ceb67fa$var$getReferenceNode(reference));
    // Handle viewport case
    if (boundariesElement === 'viewport') boundaries = $41a5bf479ceb67fa$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === 'scrollParent') {
            boundariesNode = $41a5bf479ceb67fa$var$getScrollParent($41a5bf479ceb67fa$var$getParentNode(reference));
            if (boundariesNode.nodeName === 'BODY') boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === 'window') boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $41a5bf479ceb67fa$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === 'HTML' && !$41a5bf479ceb67fa$var$isFixed(offsetParent)) {
            var _getWindowSizes = $41a5bf479ceb67fa$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === 'number';
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $41a5bf479ceb67fa$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $41a5bf479ceb67fa$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf('auto') === -1) return placement;
    var boundaries = $41a5bf479ceb67fa$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $41a5bf479ceb67fa$var$_extends({
            key: key
        }, rects[key], {
            area: $41a5bf479ceb67fa$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split('-')[1];
    return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $41a5bf479ceb67fa$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $41a5bf479ceb67fa$var$getFixedPositionOffsetParent(popper) : $41a5bf479ceb67fa$var$findCommonOffsetParent(popper, $41a5bf479ceb67fa$var$getReferenceNode(reference));
    return $41a5bf479ceb67fa$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $41a5bf479ceb67fa$var$getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $41a5bf479ceb67fa$var$getOppositePlacement(placement) {
    var hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $41a5bf479ceb67fa$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split('-')[0];
    // Get popper node sizes
    var popperRect = $41a5bf479ceb67fa$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        'right',
        'left'
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? 'top' : 'left';
    var secondarySide = isHoriz ? 'left' : 'top';
    var measurement = isHoriz ? 'height' : 'width';
    var secondaryMeasurement = !isHoriz ? 'height' : 'width';
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$41a5bf479ceb67fa$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $41a5bf479ceb67fa$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $41a5bf479ceb67fa$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $41a5bf479ceb67fa$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $41a5bf479ceb67fa$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $41a5bf479ceb67fa$var$findIndex(modifiers, 'name', ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier['function']) // eslint-disable-line dot-notation
        console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $41a5bf479ceb67fa$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $41a5bf479ceb67fa$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $41a5bf479ceb67fa$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $41a5bf479ceb67fa$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $41a5bf479ceb67fa$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $41a5bf479ceb67fa$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $41a5bf479ceb67fa$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
    // run the modifiers
    data = $41a5bf479ceb67fa$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $41a5bf479ceb67fa$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $41a5bf479ceb67fa$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        'ms',
        'Webkit',
        'Moz',
        'O'
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== 'undefined') return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $41a5bf479ceb67fa$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($41a5bf479ceb67fa$var$isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[$41a5bf479ceb67fa$var$getSupportedPropertyName('transform')] = '';
    }
    this.disableEventListeners();
    // remove the popper if user explicitly asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $41a5bf479ceb67fa$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $41a5bf479ceb67fa$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === 'BODY';
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $41a5bf479ceb67fa$var$attachToScrollParents($41a5bf479ceb67fa$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $41a5bf479ceb67fa$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $41a5bf479ceb67fa$var$getWindow(reference).addEventListener('resize', state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $41a5bf479ceb67fa$var$getScrollParent(reference);
    $41a5bf479ceb67fa$var$attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $41a5bf479ceb67fa$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $41a5bf479ceb67fa$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $41a5bf479ceb67fa$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $41a5bf479ceb67fa$var$getWindow(reference).removeEventListener('resize', state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener('scroll', state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $41a5bf479ceb67fa$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $41a5bf479ceb67fa$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $41a5bf479ceb67fa$var$isNumeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $41a5bf479ceb67fa$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if ([
            'width',
            'height',
            'top',
            'right',
            'bottom',
            'left'
        ].indexOf(prop) !== -1 && $41a5bf479ceb67fa$var$isNumeric(styles[prop])) unit = 'px';
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $41a5bf479ceb67fa$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $41a5bf479ceb67fa$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $41a5bf479ceb67fa$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $41a5bf479ceb67fa$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $41a5bf479ceb67fa$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $41a5bf479ceb67fa$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $41a5bf479ceb67fa$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $41a5bf479ceb67fa$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute('x-placement', placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $41a5bf479ceb67fa$var$setStyles(popper, {
        position: options.positionFixed ? 'fixed' : 'absolute'
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $41a5bf479ceb67fa$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        'left',
        'right'
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf('-') !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $41a5bf479ceb67fa$var$isFirefox = $41a5bf479ceb67fa$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $41a5bf479ceb67fa$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $41a5bf479ceb67fa$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'applyStyle';
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $41a5bf479ceb67fa$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $41a5bf479ceb67fa$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $41a5bf479ceb67fa$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$41a5bf479ceb67fa$var$isFirefox);
    var sideA = x === 'bottom' ? 'top' : 'bottom';
    var sideB = y === 'right' ? 'left' : 'right';
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $41a5bf479ceb67fa$var$getSupportedPropertyName('transform');
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === 'bottom') {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === 'HTML') top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === 'right') {
        if (offsetParent.nodeName === 'HTML') left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
    }
    // Attributes
    var attributes = {
        'x-placement': data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $41a5bf479ceb67fa$var$_extends({}, attributes, data.attributes);
    data.styles = $41a5bf479ceb67fa$var$_extends({}, styles, data.styles);
    data.arrowStyles = $41a5bf479ceb67fa$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $41a5bf479ceb67fa$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $41a5bf479ceb67fa$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = '`' + requestingName + '`';
        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $41a5bf479ceb67fa$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$41a5bf479ceb67fa$var$isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn('WARNING: `arrow.element` must be child of its popper element!');
        return data;
    }
    var placement = data.placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        'left',
        'right'
    ].indexOf(placement) !== -1;
    var len = isVertical ? 'height' : 'width';
    var sideCapitalized = isVertical ? 'Top' : 'Left';
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? 'left' : 'top';
    var opSide = isVertical ? 'bottom' : 'right';
    var arrowElementSize = $41a5bf479ceb67fa$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $41a5bf479ceb67fa$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $41a5bf479ceb67fa$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $41a5bf479ceb67fa$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $41a5bf479ceb67fa$var$defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $41a5bf479ceb67fa$var$getOppositeVariation(variation) {
    if (variation === 'end') return 'start';
    else if (variation === 'start') return 'end';
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $41a5bf479ceb67fa$var$placements = [
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
];
// Get rid of `auto` `auto-start` and `auto-end`
var $41a5bf479ceb67fa$var$validPlacements = $41a5bf479ceb67fa$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $41a5bf479ceb67fa$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $41a5bf479ceb67fa$var$validPlacements.indexOf(placement);
    var arr = $41a5bf479ceb67fa$var$validPlacements.slice(index + 1).concat($41a5bf479ceb67fa$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $41a5bf479ceb67fa$var$BEHAVIORS = {
    FLIP: 'flip',
    CLOCKWISE: 'clockwise',
    COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $41a5bf479ceb67fa$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($41a5bf479ceb67fa$var$isModifierEnabled(data.instance.modifiers, 'inner')) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $41a5bf479ceb67fa$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split('-')[0];
    var placementOpposite = $41a5bf479ceb67fa$var$getOppositePlacement(placement);
    var variation = data.placement.split('-')[1] || '';
    var flipOrder = [];
    switch(options.behavior){
        case $41a5bf479ceb67fa$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $41a5bf479ceb67fa$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $41a5bf479ceb67fa$var$clockwise(placement);
            break;
        case $41a5bf479ceb67fa$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $41a5bf479ceb67fa$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split('-')[0];
        placementOpposite = $41a5bf479ceb67fa$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            'top',
            'bottom'
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $41a5bf479ceb67fa$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? '-' + variation : '');
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $41a5bf479ceb67fa$var$_extends({}, data.offsets.popper, $41a5bf479ceb67fa$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $41a5bf479ceb67fa$var$runModifiers(data.instance.modifiers, data, 'flip');
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $41a5bf479ceb67fa$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split('-')[0];
    var floor = Math.floor;
    var isVertical = [
        'top',
        'bottom'
    ].indexOf(placement) !== -1;
    var side = isVertical ? 'right' : 'bottom';
    var opSide = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $41a5bf479ceb67fa$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf('%') === 0) {
        var element = void 0;
        switch(unit){
            case '%p':
                element = popperOffsets;
                break;
            case '%':
            case '%r':
            default:
                element = referenceOffsets;
        }
        var rect = $41a5bf479ceb67fa$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === 'vh') size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $41a5bf479ceb67fa$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        'right',
        'left'
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($41a5bf479ceb67fa$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(',') === -1) console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === '' && [
                '+',
                '-'
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $41a5bf479ceb67fa$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($41a5bf479ceb67fa$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $41a5bf479ceb67fa$var$offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split('-')[0];
    var offsets = void 0;
    if ($41a5bf479ceb67fa$var$isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = $41a5bf479ceb67fa$var$parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $41a5bf479ceb67fa$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $41a5bf479ceb67fa$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $41a5bf479ceb67fa$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $41a5bf479ceb67fa$var$getSupportedPropertyName('transform');
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = '';
    popperStyles.left = '';
    popperStyles[transformProp] = '';
    var boundaries = $41a5bf479ceb67fa$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $41a5bf479ceb67fa$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === 'right' ? 'left' : 'top';
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
            return $41a5bf479ceb67fa$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            'left',
            'top'
        ].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = $41a5bf479ceb67fa$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $41a5bf479ceb67fa$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var shiftvariation = placement.split('-')[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            'bottom',
            'top'
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
            start: $41a5bf479ceb67fa$var$defineProperty({}, side, reference[side]),
            end: $41a5bf479ceb67fa$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $41a5bf479ceb67fa$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $41a5bf479ceb67fa$var$hide(data) {
    if (!$41a5bf479ceb67fa$var$isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) return data;
    var refRect = data.offsets.reference;
    var bound = $41a5bf479ceb67fa$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'preventOverflow';
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $41a5bf479ceb67fa$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        'left',
        'right'
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        'top',
        'left'
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
    data.placement = $41a5bf479ceb67fa$var$getOppositePlacement(placement);
    data.offsets.popper = $41a5bf479ceb67fa$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $41a5bf479ceb67fa$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $41a5bf479ceb67fa$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $41a5bf479ceb67fa$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $41a5bf479ceb67fa$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            'left',
            'right',
            'top',
            'bottom'
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: 'scrollParent'
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $41a5bf479ceb67fa$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $41a5bf479ceb67fa$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: '[x-arrow]'
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $41a5bf479ceb67fa$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: 'flip',
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: 'viewport',
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $41a5bf479ceb67fa$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $41a5bf479ceb67fa$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $41a5bf479ceb67fa$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: 'bottom',
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: 'right'
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $41a5bf479ceb67fa$var$applyStyle,
        /** @prop {Function} */ onLoad: $41a5bf479ceb67fa$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $41a5bf479ceb67fa$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: 'bottom',
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $41a5bf479ceb67fa$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $41a5bf479ceb67fa$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $41a5bf479ceb67fa$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $41a5bf479ceb67fa$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $41a5bf479ceb67fa$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($41a5bf479ceb67fa$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $41a5bf479ceb67fa$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $41a5bf479ceb67fa$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $41a5bf479ceb67fa$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $41a5bf479ceb67fa$var$createClass(Popper, [
        {
            key: 'update',
            value: function update$$1() {
                return $41a5bf479ceb67fa$var$update.call(this);
            }
        },
        {
            key: 'destroy',
            value: function destroy$$1() {
                return $41a5bf479ceb67fa$var$destroy.call(this);
            }
        },
        {
            key: 'enableEventListeners',
            value: function enableEventListeners$$1() {
                return $41a5bf479ceb67fa$var$enableEventListeners.call(this);
            }
        },
        {
            key: 'disableEventListeners',
            value: function disableEventListeners$$1() {
                return $41a5bf479ceb67fa$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $41a5bf479ceb67fa$var$Popper.Utils = (typeof window !== 'undefined' ? window : $parcel$global).PopperUtils;
$41a5bf479ceb67fa$var$Popper.placements = $41a5bf479ceb67fa$var$placements;
$41a5bf479ceb67fa$var$Popper.Defaults = $41a5bf479ceb67fa$var$Defaults;
var $41a5bf479ceb67fa$export$2e2bcd8739ae039 = $41a5bf479ceb67fa$var$Popper;




var $bauHK = parcelRequire("bauHK");




function $ce0a0b1df9daa374$var$flipPlacement(placement, theme) {
    var direction = theme && theme.direction || 'ltr';
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $ce0a0b1df9daa374$var$getAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
var $ce0a0b1df9daa374$var$useEnhancedEffect = typeof window !== 'undefined' ? $Fo7oF.useLayoutEffect : $Fo7oF.useEffect;
var $ce0a0b1df9daa374$var$defaultPopperOptions = {};
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v1/) for positioning.
 */ var $ce0a0b1df9daa374$var$Popper = /*#__PURE__*/ $Fo7oF.forwardRef(function Popper(props, ref) {
    var anchorEl = props.anchorEl, children = props.children, container = props.container, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, _props$keepMounted = props.keepMounted, keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted, modifiers = props.modifiers, open = props.open, _props$placement = props.placement, initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement, _props$popperOptions = props.popperOptions, popperOptions = _props$popperOptions === void 0 ? $ce0a0b1df9daa374$var$defaultPopperOptions : _props$popperOptions, popperRefProp = props.popperRef, style = props.style, _props$transition = props.transition, transition = _props$transition === void 0 ? false : _props$transition, other = (0, $67mp8.default)(props, [
        "anchorEl",
        "children",
        "container",
        "disablePortal",
        "keepMounted",
        "modifiers",
        "open",
        "placement",
        "popperOptions",
        "popperRef",
        "style",
        "transition"
    ]);
    var tooltipRef = $Fo7oF.useRef(null);
    var ownRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(tooltipRef, ref);
    var popperRef = $Fo7oF.useRef(null);
    var handlePopperRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    var handlePopperRefRef = $Fo7oF.useRef(handlePopperRef);
    $ce0a0b1df9daa374$var$useEnhancedEffect(function() {
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $Fo7oF.useImperativeHandle(popperRefProp, function() {
        return popperRef.current;
    }, []);
    var _React$useState = $Fo7oF.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
    var theme = (0, $bauHK.default)();
    var rtlPlacement = $ce0a0b1df9daa374$var$flipPlacement(initialPlacement, theme);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ var _React$useState2 = $Fo7oF.useState(rtlPlacement), placement = _React$useState2[0], setPlacement = _React$useState2[1];
    $Fo7oF.useEffect(function() {
        if (popperRef.current) popperRef.current.update();
    });
    var handleOpen = $Fo7oF.useCallback(function() {
        if (!tooltipRef.current || !anchorEl || !open) return;
        if (popperRef.current) {
            popperRef.current.destroy();
            handlePopperRefRef.current(null);
        }
        var handlePopperUpdate = function handlePopperUpdate(data) {
            setPlacement(data.placement);
        };
        var resolvedAnchorEl = $ce0a0b1df9daa374$var$getAnchorEl(anchorEl);
        var box;
        var popper = new (0, $41a5bf479ceb67fa$export$2e2bcd8739ae039)($ce0a0b1df9daa374$var$getAnchorEl(anchorEl), tooltipRef.current, (0, $elnlQ.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: (0, $elnlQ.default)({}, disablePortal ? {} : {
                // It's using scrollParent by default, we can use the viewport when using a portal.
                preventOverflow: {
                    boundariesElement: 'window'
                }
            }, modifiers, popperOptions.modifiers),
            // We could have been using a custom modifier like react-popper is doing.
            // But it seems this is the best public API for this use case.
            onCreate: (0, $f5393b90dfc3d6af$export$2e2bcd8739ae039)(handlePopperUpdate, popperOptions.onCreate),
            onUpdate: (0, $f5393b90dfc3d6af$export$2e2bcd8739ae039)(handlePopperUpdate, popperOptions.onUpdate)
        }));
        handlePopperRefRef.current(popper);
    }, [
        anchorEl,
        disablePortal,
        modifiers,
        open,
        rtlPlacement,
        popperOptions
    ]);
    var handleRef = $Fo7oF.useCallback(function(node) {
        (0, $797ab9d955819a25$export$2e2bcd8739ae039)(ownRef, node);
        handleOpen();
    }, [
        ownRef,
        handleOpen
    ]);
    var handleEnter = function handleEnter() {
        setExited(false);
    };
    var handleClose = function handleClose() {
        if (!popperRef.current) return;
        popperRef.current.destroy();
        handlePopperRefRef.current(null);
    };
    var handleExited = function handleExited() {
        setExited(true);
        handleClose();
    };
    $Fo7oF.useEffect(function() {
        return function() {
            handleClose();
        };
    }, []);
    $Fo7oF.useEffect(function() {
        if (!open && !transition) // Otherwise handleExited will call this.
        handleClose();
    }, [
        open,
        transition
    ]);
    if (!keepMounted && !open && (!transition || exited)) return null;
    var childProps = {
        placement: placement
    };
    if (transition) childProps.TransitionProps = {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    };
    return /*#__PURE__*/ $Fo7oF.createElement((0, $7105c4b49b050e4f$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container
    }, /*#__PURE__*/ $Fo7oF.createElement("div", (0, $elnlQ.default)({
        ref: handleRef,
        role: "tooltip"
    }, other, {
        style: (0, $elnlQ.default)({
            // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
            position: 'fixed',
            // Fix Popper.js display issue
            top: 0,
            left: 0,
            display: !open && keepMounted && !transition ? 'none' : null
        }, style)
    }), typeof children === 'function' ? children(childProps) : children));
});
var $ce0a0b1df9daa374$export$2e2bcd8739ae039 = $ce0a0b1df9daa374$var$Popper;




var $Fo7oF = parcelRequire("Fo7oF");
function $dd9cbbe9e66981f6$export$2e2bcd8739ae039(idOverride) {
    var _React$useState = $Fo7oF.useState(idOverride), defaultId = _React$useState[0], setDefaultId = _React$useState[1];
    var id = idOverride || defaultId;
    $Fo7oF.useEffect(function() {
        if (defaultId == null) // Fallback to this default id when possible.
        // Use the random value for client-side rendering only.
        // We can't use it server-side.
        setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }, [
        defaultId
    ]);
    return id;
}






function $840d38c8785ff9ec$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
function $840d38c8785ff9ec$var$arrowGenerator() {
    return {
        '&[x-placement*="bottom"] $arrow': {
            top: 0,
            left: 0,
            marginTop: '-0.71em',
            marginLeft: 4,
            marginRight: 4,
            '&::before': {
                transformOrigin: '0 100%'
            }
        },
        '&[x-placement*="top"] $arrow': {
            bottom: 0,
            left: 0,
            marginBottom: '-0.71em',
            marginLeft: 4,
            marginRight: 4,
            '&::before': {
                transformOrigin: '100% 0'
            }
        },
        '&[x-placement*="right"] $arrow': {
            left: 0,
            marginLeft: '-0.71em',
            height: '1em',
            width: '0.71em',
            marginTop: 4,
            marginBottom: 4,
            '&::before': {
                transformOrigin: '100% 100%'
            }
        },
        '&[x-placement*="left"] $arrow': {
            right: 0,
            marginRight: '-0.71em',
            height: '1em',
            width: '0.71em',
            marginTop: 4,
            marginBottom: 4,
            '&::before': {
                transformOrigin: '0 0'
            }
        }
    };
}
var $840d38c8785ff9ec$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the Popper component. */ popper: {
            zIndex: theme.zIndex.tooltip,
            pointerEvents: 'none' // disable jss-rtl plugin
        },
        /* Styles applied to the Popper component if `interactive={true}`. */ popperInteractive: {
            pointerEvents: 'auto'
        },
        /* Styles applied to the Popper component if `arrow={true}`. */ popperArrow: $840d38c8785ff9ec$var$arrowGenerator(),
        /* Styles applied to the tooltip (label wrapper) element. */ tooltip: {
            backgroundColor: (0, $8Hh6N.alpha)(theme.palette.grey[700], 0.9),
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.common.white,
            fontFamily: theme.typography.fontFamily,
            padding: '4px 8px',
            fontSize: theme.typography.pxToRem(10),
            lineHeight: "".concat($840d38c8785ff9ec$var$round(1.4), "em"),
            maxWidth: 300,
            wordWrap: 'break-word',
            fontWeight: theme.typography.fontWeightMedium
        },
        /* Styles applied to the tooltip (label wrapper) element if `arrow={true}`. */ tooltipArrow: {
            position: 'relative',
            margin: '0'
        },
        /* Styles applied to the arrow element. */ arrow: {
            overflow: 'hidden',
            position: 'absolute',
            width: '1em',
            height: '0.71em',
            boxSizing: 'border-box',
            color: (0, $8Hh6N.alpha)(theme.palette.grey[700], 0.9),
            '&::before': {
                content: '""',
                margin: 'auto',
                display: 'block',
                width: '100%',
                height: '100%',
                backgroundColor: 'currentColor',
                transform: 'rotate(45deg)'
            }
        },
        /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */ touch: {
            padding: '8px 16px',
            fontSize: theme.typography.pxToRem(14),
            lineHeight: "".concat($840d38c8785ff9ec$var$round(16 / 14), "em"),
            fontWeight: theme.typography.fontWeightRegular
        },
        /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */ tooltipPlacementLeft: (0, $d2vKa.default)({
            transformOrigin: 'right center',
            margin: '0 24px '
        }, theme.breakpoints.up('sm'), {
            margin: '0 14px'
        }),
        /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */ tooltipPlacementRight: (0, $d2vKa.default)({
            transformOrigin: 'left center',
            margin: '0 24px'
        }, theme.breakpoints.up('sm'), {
            margin: '0 14px'
        }),
        /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */ tooltipPlacementTop: (0, $d2vKa.default)({
            transformOrigin: 'center bottom',
            margin: '24px 0'
        }, theme.breakpoints.up('sm'), {
            margin: '14px 0'
        }),
        /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */ tooltipPlacementBottom: (0, $d2vKa.default)({
            transformOrigin: 'center top',
            margin: '24px 0'
        }, theme.breakpoints.up('sm'), {
            margin: '14px 0'
        })
    };
};
var $840d38c8785ff9ec$var$hystersisOpen = false;
var $840d38c8785ff9ec$var$hystersisTimer = null;
function $840d38c8785ff9ec$export$b9ee5a7ace0541f8() {
    $840d38c8785ff9ec$var$hystersisOpen = false;
    clearTimeout($840d38c8785ff9ec$var$hystersisTimer);
}
var $840d38c8785ff9ec$var$Tooltip = /*#__PURE__*/ $Fo7oF.forwardRef(function Tooltip(props, ref) {
    var _props$arrow = props.arrow, arrow = _props$arrow === void 0 ? false : _props$arrow, children = props.children, classes = props.classes, _props$disableFocusLi = props.disableFocusListener, disableFocusListener = _props$disableFocusLi === void 0 ? false : _props$disableFocusLi, _props$disableHoverLi = props.disableHoverListener, disableHoverListener = _props$disableHoverLi === void 0 ? false : _props$disableHoverLi, _props$disableTouchLi = props.disableTouchListener, disableTouchListener = _props$disableTouchLi === void 0 ? false : _props$disableTouchLi, _props$enterDelay = props.enterDelay, enterDelay = _props$enterDelay === void 0 ? 100 : _props$enterDelay, _props$enterNextDelay = props.enterNextDelay, enterNextDelay = _props$enterNextDelay === void 0 ? 0 : _props$enterNextDelay, _props$enterTouchDela = props.enterTouchDelay, enterTouchDelay = _props$enterTouchDela === void 0 ? 700 : _props$enterTouchDela, idProp = props.id, _props$interactive = props.interactive, interactive = _props$interactive === void 0 ? false : _props$interactive, _props$leaveDelay = props.leaveDelay, leaveDelay = _props$leaveDelay === void 0 ? 0 : _props$leaveDelay, _props$leaveTouchDela = props.leaveTouchDelay, leaveTouchDelay = _props$leaveTouchDela === void 0 ? 1500 : _props$leaveTouchDela, onClose = props.onClose, onOpen = props.onOpen, openProp = props.open, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom' : _props$placement, _props$PopperComponen = props.PopperComponent, PopperComponent = _props$PopperComponen === void 0 ? (0, $ce0a0b1df9daa374$export$2e2bcd8739ae039) : _props$PopperComponen, PopperProps = props.PopperProps, title = props.title, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $60073b28508896e0$export$2e2bcd8739ae039) : _props$TransitionComp, TransitionProps = props.TransitionProps, other = (0, $67mp8.default)(props, [
        "arrow",
        "children",
        "classes",
        "disableFocusListener",
        "disableHoverListener",
        "disableTouchListener",
        "enterDelay",
        "enterNextDelay",
        "enterTouchDelay",
        "id",
        "interactive",
        "leaveDelay",
        "leaveTouchDelay",
        "onClose",
        "onOpen",
        "open",
        "placement",
        "PopperComponent",
        "PopperProps",
        "title",
        "TransitionComponent",
        "TransitionProps"
    ]);
    var theme = (0, $c6db41e315144c8b$export$2e2bcd8739ae039)();
    var _React$useState = $Fo7oF.useState(), childNode = _React$useState[0], setChildNode = _React$useState[1];
    var _React$useState2 = $Fo7oF.useState(null), arrowRef = _React$useState2[0], setArrowRef = _React$useState2[1];
    var ignoreNonTouchEvents = $Fo7oF.useRef(false);
    var closeTimer = $Fo7oF.useRef();
    var enterTimer = $Fo7oF.useRef();
    var leaveTimer = $Fo7oF.useRef();
    var touchTimer = $Fo7oF.useRef();
    var _useControlled = (0, $c6d3b036d5d216ae$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    }), _useControlled2 = (0, $8YHhK.default)(_useControlled, 2), openState = _useControlled2[0], setOpenState = _useControlled2[1];
    var open = openState;
    var _React$useRef, isControlled;
    var id = (0, $dd9cbbe9e66981f6$export$2e2bcd8739ae039)(idProp);
    $Fo7oF.useEffect(function() {
        return function() {
            clearTimeout(closeTimer.current);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            clearTimeout(touchTimer.current);
        };
    }, []);
    var handleOpen = function handleOpen(event) {
        clearTimeout($840d38c8785ff9ec$var$hystersisTimer);
        $840d38c8785ff9ec$var$hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen) onOpen(event);
    };
    var handleEnter = function handleEnter() {
        var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return function(event) {
            var childrenProps = children.props;
            if (event.type === 'mouseover' && childrenProps.onMouseOver && forward) childrenProps.onMouseOver(event);
            if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
             // Remove the title ahead of time.
            // We don't want to wait for the next render commit.
            // We would risk displaying two tooltips at the same time (native + this one).
            if (childNode) childNode.removeAttribute('title');
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            if (enterDelay || $840d38c8785ff9ec$var$hystersisOpen && enterNextDelay) {
                event.persist();
                enterTimer.current = setTimeout(function() {
                    handleOpen(event);
                }, $840d38c8785ff9ec$var$hystersisOpen ? enterNextDelay : enterDelay);
            } else handleOpen(event);
        };
    };
    var _useIsFocusVisible = (0, $ef37cdf34d04c3a7$export$2e2bcd8739ae039)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    var _React$useState3 = $Fo7oF.useState(false), childIsFocusVisible = _React$useState3[0], setChildIsFocusVisible = _React$useState3[1];
    var handleBlur = function handleBlur() {
        if (childIsFocusVisible) {
            setChildIsFocusVisible(false);
            onBlurVisible();
        }
    };
    var handleFocus = function handleFocus() {
        var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return function(event) {
            // Workaround for https://github.com/facebook/react/issues/7769
            // The autoFocus of React might trigger the event before the componentDidMount.
            // We need to account for this eventuality.
            if (!childNode) setChildNode(event.currentTarget);
            if (isFocusVisible(event)) {
                setChildIsFocusVisible(true);
                handleEnter()(event);
            }
            var childrenProps = children.props;
            if (childrenProps.onFocus && forward) childrenProps.onFocus(event);
        };
    };
    var handleClose = function handleClose(event) {
        clearTimeout($840d38c8785ff9ec$var$hystersisTimer);
        $840d38c8785ff9ec$var$hystersisTimer = setTimeout(function() {
            $840d38c8785ff9ec$var$hystersisOpen = false;
        }, 800 + leaveDelay);
        setOpenState(false);
        if (onClose) onClose(event);
        clearTimeout(closeTimer.current);
        closeTimer.current = setTimeout(function() {
            ignoreNonTouchEvents.current = false;
        }, theme.transitions.duration.shortest);
    };
    var handleLeave = function handleLeave() {
        var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return function(event) {
            var childrenProps = children.props;
            if (event.type === 'blur') {
                if (childrenProps.onBlur && forward) childrenProps.onBlur(event);
                handleBlur();
            }
            if (event.type === 'mouseleave' && childrenProps.onMouseLeave && event.currentTarget === childNode) childrenProps.onMouseLeave(event);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            event.persist();
            leaveTimer.current = setTimeout(function() {
                handleClose(event);
            }, leaveDelay);
        };
    };
    var detectTouchStart = function detectTouchStart(event) {
        ignoreNonTouchEvents.current = true;
        var childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    var handleTouchStart = function handleTouchStart(event) {
        detectTouchStart(event);
        clearTimeout(leaveTimer.current);
        clearTimeout(closeTimer.current);
        clearTimeout(touchTimer.current);
        event.persist();
        touchTimer.current = setTimeout(function() {
            handleEnter()(event);
        }, enterTouchDelay);
    };
    var handleTouchEnd = function handleTouchEnd(event) {
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        clearTimeout(touchTimer.current);
        clearTimeout(leaveTimer.current);
        event.persist();
        leaveTimer.current = setTimeout(function() {
            handleClose(event);
        }, leaveTouchDelay);
    };
    var handleUseRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(setChildNode, ref);
    var handleFocusRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(focusVisibleRef, handleUseRef); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $Fo7oF.useCallback(function(instance) {
        // #StrictMode ready
        (0, $797ab9d955819a25$export$2e2bcd8739ae039)(handleFocusRef, $bvYwR.findDOMNode(instance));
    }, [
        handleFocusRef
    ]);
    var handleRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(children.ref, handleOwnRef); // There is no point in displaying an empty tooltip.
    if (title === '') open = false;
     // For accessibility and SEO concerns, we render the title to the DOM node when
    // the tooltip is hidden. However, we have made a tradeoff when
    // `disableHoverListener` is set. This title logic is disabled.
    // It's allowing us to keep the implementation size minimal.
    // We are open to change the tradeoff.
    var shouldShowNativeTitle = !open && !disableHoverListener;
    var childrenProps = (0, $elnlQ.default)({
        'aria-describedby': open ? id : null,
        title: shouldShowNativeTitle && typeof title === 'string' ? title : null
    }, other, children.props, {
        className: (0, $78z8j.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    });
    var interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = handleEnter();
        childrenProps.onMouseLeave = handleLeave();
        if (interactive) {
            interactiveWrapperListeners.onMouseOver = handleEnter(false);
            interactiveWrapperListeners.onMouseLeave = handleLeave(false);
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = handleFocus();
        childrenProps.onBlur = handleLeave();
        if (interactive) {
            interactiveWrapperListeners.onFocus = handleFocus(false);
            interactiveWrapperListeners.onBlur = handleLeave(false);
        }
    }
    var mergedPopperProps = $Fo7oF.useMemo(function() {
        return (0, $dbHGl.default)({
            popperOptions: {
                modifiers: {
                    arrow: {
                        enabled: Boolean(arrowRef),
                        element: arrowRef
                    }
                }
            }
        }, PopperProps);
    }, [
        arrowRef,
        PopperProps
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement($Fo7oF.Fragment, null, /*#__PURE__*/ $Fo7oF.cloneElement(children, childrenProps), /*#__PURE__*/ $Fo7oF.createElement(PopperComponent, (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.popper, interactive && classes.popperInteractive, arrow && classes.popperArrow),
        placement: placement,
        anchorEl: childNode,
        open: childNode ? open : false,
        id: childrenProps['aria-describedby'],
        transition: true
    }, interactiveWrapperListeners, mergedPopperProps), function(_ref) {
        var placementInner = _ref.placement, TransitionPropsInner = _ref.TransitionProps;
        return /*#__PURE__*/ $Fo7oF.createElement(TransitionComponent, (0, $elnlQ.default)({
            timeout: theme.transitions.duration.shorter
        }, TransitionPropsInner, TransitionProps), /*#__PURE__*/ $Fo7oF.createElement("div", {
            className: (0, $78z8j.default)(classes.tooltip, classes["tooltipPlacement".concat((0, $bT5dp.default)(placementInner.split('-')[0]))], ignoreNonTouchEvents.current && classes.touch, arrow && classes.tooltipArrow)
        }, title, arrow ? /*#__PURE__*/ $Fo7oF.createElement("span", {
            className: classes.arrow,
            ref: setArrowRef
        }) : null));
    }));
});
var $840d38c8785ff9ec$export$2e2bcd8739ae039 = (0, $5rVgt.default)($840d38c8785ff9ec$export$9dd6ff9ea0189349, {
    name: 'MuiTooltip',
    flip: false
})($840d38c8785ff9ec$var$Tooltip);





parcelRequire("Fo7oF");

const $f801e09e2bd4726d$export$ad8546dde9ea625c = ({ warningMessage: warningMessage })=>{
    return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $840d38c8785ff9ec$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2260333d3ecc242c$exports))).warningTooltip,
        enterTouchDelay: 0,
        title: /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
            style: {
                fontSize: 16
            },
            children: warningMessage
        }),
        children: /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2260333d3ecc242c$exports))).warningDiv,
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                    color: "primary",
                    disabled: true,
                    size: "small",
                    style: {
                        fontSize: 12
                    },
                    variant: "contained",
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                        id: 'labels.CREATE_ENVELOPE'
                    })
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f4267c9105e002e8$export$f7dc499a72baa103), {})
            ]
        })
    });
};
$f801e09e2bd4726d$export$ad8546dde9ea625c.propTypes = {
    warningMessage: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired
};




const $9b23cd2cecd32db8$export$ff3bda8690417cdb = ({ row: row, userBranchCode: userBranchCode })=>{
    const countryCode = userBranchCode.slice(0, 2);
    const intl = (0, $b637120a7f65e10c$export$2e2bcd8739ae039)();
    const isInvalidDate = (startDate)=>{
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        const formattedStartDate = new Date(startDate);
        formattedStartDate.setHours(0, 0, 0, 0);
        return formattedStartDate < currentDate;
    };
    const navigate = (0, $5a9c912afef4aac7$export$9770f232ac06a008)();
    const isInvalidStartDate = (countryCode === 'ES' || countryCode === 'PT') && isInvalidDate(row.startDate);
    const hasGuarantorRole = countryCode === 'DE' && row.hasGuarantor;
    const handleClick = ()=>{
        navigate(`/e-sign/${row.quoteNumber}`, {
            state: row
        });
    };
    const buttonMap = {
        [true]: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
            color: "primary",
            onClick: handleClick,
            size: "small",
            style: {
                fontSize: 12
            },
            variant: "contained",
            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                id: 'labels.CREATE_ENVELOPE'
            })
        }),
        [(0, $fff13ca3fea305fa$export$8ad15c0595d77203).includes(row.alfaCaseStatus)]: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f801e09e2bd4726d$export$ad8546dde9ea625c), {
            warningMessage: intl.formatMessage({
                id: (0, $fff13ca3fea305fa$export$3eb496376f50c0bb)
            })
        }),
        [isInvalidStartDate]: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f801e09e2bd4726d$export$ad8546dde9ea625c), {
            warningMessage: intl.formatMessage({
                id: (0, $91b041060f19e3dd$export$53e31fc9a3189fd8)
            })
        }),
        [hasGuarantorRole]: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f801e09e2bd4726d$export$ad8546dde9ea625c), {
            warningMessage: intl.formatMessage({
                id: (0, $91b041060f19e3dd$export$7567ba3a14d8b191)
            })
        })
    };
    return buttonMap.true;
};
$9b23cd2cecd32db8$export$ff3bda8690417cdb.propTypes = {
    userBranchCode: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    row: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).object
};





var $eFTP6 = parcelRequire("eFTP6");






parcelRequire("Fo7oF");

var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");

var $d2bgE = parcelRequire("d2bgE");
var $9bc66340e7900d18$exports = {};

$parcel$export($9bc66340e7900d18$exports, "reviewDocument", () => $9bc66340e7900d18$export$c020aafd49b4a2fe, (v) => $9bc66340e7900d18$export$c020aafd49b4a2fe = v);
$parcel$export($9bc66340e7900d18$exports, "signerReview", () => $9bc66340e7900d18$export$8fbb0cc29fc04457, (v) => $9bc66340e7900d18$export$8fbb0cc29fc04457 = v);
$parcel$export($9bc66340e7900d18$exports, "signerReviewError", () => $9bc66340e7900d18$export$4dabb2d5ca57e2c1, (v) => $9bc66340e7900d18$export$4dabb2d5ca57e2c1 = v);
$parcel$export($9bc66340e7900d18$exports, "reviewAvatar", () => $9bc66340e7900d18$export$92ad7b46eadfc87f, (v) => $9bc66340e7900d18$export$92ad7b46eadfc87f = v);
$parcel$export($9bc66340e7900d18$exports, "signerReviewDiv", () => $9bc66340e7900d18$export$e088abac37a5ab5d, (v) => $9bc66340e7900d18$export$e088abac37a5ab5d = v);
$parcel$export($9bc66340e7900d18$exports, "signerReviewInfo", () => $9bc66340e7900d18$export$bbb1be25b2283c4d, (v) => $9bc66340e7900d18$export$bbb1be25b2283c4d = v);
$parcel$export($9bc66340e7900d18$exports, "signerOptionsReview", () => $9bc66340e7900d18$export$e328414cb1dab272, (v) => $9bc66340e7900d18$export$e328414cb1dab272 = v);
$parcel$export($9bc66340e7900d18$exports, "reviewOrder", () => $9bc66340e7900d18$export$1483976fa1555bc2, (v) => $9bc66340e7900d18$export$1483976fa1555bc2 = v);
var $9bc66340e7900d18$export$c020aafd49b4a2fe;
var $9bc66340e7900d18$export$8fbb0cc29fc04457;
var $9bc66340e7900d18$export$4dabb2d5ca57e2c1;
var $9bc66340e7900d18$export$92ad7b46eadfc87f;
var $9bc66340e7900d18$export$e088abac37a5ab5d;
var $9bc66340e7900d18$export$bbb1be25b2283c4d;
var $9bc66340e7900d18$export$e328414cb1dab272;
var $9bc66340e7900d18$export$1483976fa1555bc2;
$9bc66340e7900d18$export$c020aafd49b4a2fe = "reviewDocument_d90f12";
$9bc66340e7900d18$export$8fbb0cc29fc04457 = "signerReview_d90f12";
$9bc66340e7900d18$export$4dabb2d5ca57e2c1 = "signerReviewError_d90f12";
$9bc66340e7900d18$export$92ad7b46eadfc87f = "reviewAvatar_d90f12";
$9bc66340e7900d18$export$e088abac37a5ab5d = "signerReviewDiv_d90f12";
$9bc66340e7900d18$export$bbb1be25b2283c4d = "signerReviewInfo_d90f12";
$9bc66340e7900d18$export$e328414cb1dab272 = "signerOptionsReview_d90f12";
$9bc66340e7900d18$export$1483976fa1555bc2 = "reviewOrder_d90f12";



const $ab193334c82ec2ed$export$ebf44949dcb5de42 = ({ documentName: documentName })=>/*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9bc66340e7900d18$exports))).reviewDocument,
        children: [
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f4267c9105e002e8$export$5068802198d106bd), {
                className: "uxf-icon-fill-green"
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                children: documentName
            })
        ]
    });
$ab193334c82ec2ed$export$ebf44949dcb5de42.propTypes = {
    documentName: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string
};



var $d2bgE = parcelRequire("d2bgE");

const $0a7b72d03fc86354$export$e17bb34100dcb160 = ({ setDocumentInfoPopupStatus: setDocumentInfoPopupStatus, isHidden: isHidden, documents: documents })=>{
    const handleClose = ()=>{
        setDocumentInfoPopupStatus(false);
    };
    return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $eFTP6.Fragment), {
        children: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $06c828c7d8d76aa9$export$2e2bcd8739ae039), {
            "aria-labelledby": "customized-dialog-title",
            fullWidth: true,
            onClose: handleClose,
            open: isHidden,
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Row), {
                    className: "d-flex ml-3 mr-2 mt-2 justify-content-between",
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                            className: "d-inline",
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)("h5", {
                                className: "font-weight-bold mt-1",
                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                    id: 'labels.SELECTED_DOCUMENTS'
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                            className: "d-inline",
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c6e28b9de0df1599$export$2e2bcd8739ae039), {
                                "aria-label": "close",
                                onClick: handleClose,
                                size: "small",
                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($57b96121aa7aac71$exports))), {
                                    fontSize: "small"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b04338db8f46de7f$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1c55bad717a43115$export$2e2bcd8739ae039), {
                    children: documents.map((document)=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $ab193334c82ec2ed$export$ebf44949dcb5de42), {
                            documentName: document.documentDesc
                        }, document.id))
                })
            ]
        })
    });
};
$0a7b72d03fc86354$export$e17bb34100dcb160.propTypes = {
    setDocumentInfoPopupStatus: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    documents: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).array,
    isHidden: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool
};




var $eFTP6 = parcelRequire("eFTP6");
var $a5cc098b12e205d6$exports = {};
"use strict";


Object.defineProperty($a5cc098b12e205d6$exports, "__esModule", {
    value: true
});
$a5cc098b12e205d6$exports.default = void 0;

var $a5cc098b12e205d6$var$React = $e542637ee86bba6a$exports((parcelRequire("Fo7oF")));

var $a5cc098b12e205d6$var$_createSvgIcon = $368639c97fe780bf$exports((parcelRequire("bI8Gq")));
var $a5cc098b12e205d6$var$_default = (0, $a5cc098b12e205d6$var$_createSvgIcon.default)(/*#__PURE__*/ $a5cc098b12e205d6$var$React.createElement("path", {
    d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');
$a5cc098b12e205d6$exports.default = $a5cc098b12e205d6$var$_default;



var $d2bgE = parcelRequire("d2bgE");


parcelRequire("Fo7oF");

const $222d1e581120196e$export$a5fae3b3a761e46c = ({ row: row })=>{
    const primaryQuote = row.primaryQuote;
    return primaryQuote && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $840d38c8785ff9ec$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2260333d3ecc242c$exports))).tooltip,
        enterTouchDelay: 0,
        title: /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
            style: {
                fontSize: 16
            },
            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                id: 'labels.PRIMARY_QUOTE'
            })
        }),
        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a5cc098b12e205d6$exports))), {
            fontSize: "small"
        })
    });
};
$222d1e581120196e$export$a5fae3b3a761e46c.propTypes = {
    row: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).object.isRequired
};



var $d2bgE = parcelRequire("d2bgE");
const $0f94eacaaa2f884c$var$formatStringCase = (str)=>{
    if (typeof str !== 'string') return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $0f94eacaaa2f884c$var$getDateTime = (date)=>{
    return new Date(date).toLocaleDateString();
};
const $0f94eacaaa2f884c$var$envelopeStatusColors = {
    sent: '#ffb000',
    //yellow-sea
    declined: '#c21020',
    //red
    completed: '#367c2b',
    //green
    noEnvelope: '#C0C0C0' //silver-grey
};
function $0f94eacaaa2f884c$export$2e2bcd8739ae039(props) {
    const { handleGetStatus: handleGetStatus, row: row, userBranchCode: userBranchCode, userHasAccessToERegistry: userHasAccessToERegistry } = props;
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useState(Boolean(row.newEnvelope));
    const intl = (0, $b637120a7f65e10c$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $eFTP6.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $e6915f08e195d274$export$2e2bcd8739ae039), {
                style: {
                    'borderLeft': `15px solid ${row.envelopes !== null && row.envelopes.length > 0 ? $0f94eacaaa2f884c$var$envelopeStatusColors[row.envelopes[0].Status] : $0f94eacaaa2f884c$var$envelopeStatusColors['noEnvelope']}`
                },
                variant: "outlined",
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $924d8ef775c5c9f0$export$2e2bcd8739ae039), {
                        width: "5%",
                        children: row.envelopes !== null && row.envelopes.length > 0 ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c6e28b9de0df1599$export$2e2bcd8739ae039), {
                            "aria-label": "expand row",
                            onClick: ()=>setOpen(!open),
                            size: "small",
                            children: open ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b2b44968505dfb82$exports))), {}) : /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($050d10d83b7c7041$exports))), {})
                        }) : null
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $924d8ef775c5c9f0$export$2e2bcd8739ae039), {
                        component: "th",
                        scope: "row",
                        width: "8%",
                        children: row.bundleNumber
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $924d8ef775c5c9f0$export$2e2bcd8739ae039), {
                        align: "left",
                        width: "8%",
                        children: /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($2260333d3ecc242c$exports))).primaryQuoteIcon,
                            children: [
                                row.quoteNumber,
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $222d1e581120196e$export$a5fae3b3a761e46c), {
                                    row: row
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $924d8ef775c5c9f0$export$2e2bcd8739ae039), {
                        align: "left",
                        width: "11%",
                        children: $0f94eacaaa2f884c$var$getDateTime(row.startDate)
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $924d8ef775c5c9f0$export$2e2bcd8739ae039), {
                        align: "left",
                        width: "19%",
                        children: row.alfaDealerName
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $924d8ef775c5c9f0$export$2e2bcd8739ae039), {
                        align: "left",
                        "data-sl": "mask",
                        children: row.primaryCustomer
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $924d8ef775c5c9f0$export$2e2bcd8739ae039), {
                        align: "left",
                        width: "16%",
                        children: row.salesPersonName.split(' ').map((s)=>s[0] + s.slice(1).toLowerCase()).join(' ')
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $924d8ef775c5c9f0$export$2e2bcd8739ae039), {
                        align: "left",
                        width: "19%",
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $9b23cd2cecd32db8$export$ff3bda8690417cdb), {
                            row: row,
                            userBranchCode: userBranchCode
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $e6915f08e195d274$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $924d8ef775c5c9f0$export$2e2bcd8739ae039), {
                    colSpan: 12,
                    style: {
                        padding: 0
                    },
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $3d1b9735f1beaaf9$export$2e2bcd8739ae039), {
                        in: open,
                        timeout: "auto",
                        unmountOnExit: true,
                        children: row.envelopes !== null && row.envelopes.length > 0 ? row.envelopes.map((envelopeData)=>{
                            const [documentInfoPopupStatus, setDocumentInfoPopupStatus] = (0, $Fo7oF.useState)(false);
                            const handleDocumentPopup = (event)=>{
                                event.preventDefault();
                                setDocumentInfoPopupStatus(true);
                            };
                            const [spinnerOn, setSpinnerOn] = (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useState(false);
                            return /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $fe0aa9e32766c0f5$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($2260333d3ecc242c$exports))).paper,
                                elevation: 1,
                                style: {},
                                children: [
                                    /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Row), {
                                        className: "d-flex flex-wrap justify-content-around",
                                        style: {
                                            paddingTop: 20
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $eFTP6.jsxs)("p", {
                                                className: "d-inline font-weight-bold pt-1",
                                                children: [
                                                    intl.formatMessage({
                                                        id: 'labels.ENVELOPE_ID'
                                                    }) + ': ',
                                                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                                        className: "font-weight-normal",
                                                        children: envelopeData.envelopeDetail.envelopeId
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eFTP6.jsxs)("p", {
                                                className: "d-inline font-weight-bold pt-1",
                                                children: [
                                                    intl.formatMessage({
                                                        id: 'labels.STATUS_DATE'
                                                    }) + ': ',
                                                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                                        className: "font-weight-normal",
                                                        children: $0f94eacaaa2f884c$var$getDateTime(envelopeData.envelopeDetail.lastModifiedAt)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eFTP6.jsxs)("p", {
                                                className: "d-inline font-weight-bold pt-1",
                                                children: [
                                                    intl.formatMessage({
                                                        id: 'labels.STATUS'
                                                    }) + ': ',
                                                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                                        className: "font-weight-normal",
                                                        children: $0f94eacaaa2f884c$var$formatStringCase(envelopeData.envelopeDetail.status && intl.formatMessage({
                                                            id: (0, $da769170dfa840d0$export$2c62012ca01f1bea)[envelopeData.envelopeDetail.status.toUpperCase()]
                                                        }))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $5b05347dc97ebaf8$export$2e2bcd8739ae039), {
                                                className: "d-inline",
                                                justifyContent: "flex-end",
                                                children: spinnerOn ? /*#__PURE__*/ (0, $eFTP6.jsxs)("span", {
                                                    className: "font-italic text-success",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                            id: 'labels.UPDATING_STATUS'
                                                        }),
                                                        "... ",
                                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f4267c9105e002e8$export$fe708d541030d854), {
                                                            size: "sm"
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                                                    onClick: ()=>handleGetStatus(envelopeData.envelopeDetail.envelopeId, row.quoteNumber, setSpinnerOn),
                                                    size: "small",
                                                    style: {
                                                        backgroundColor: '#ffde00'
                                                    },
                                                    variant: "contained",
                                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                        id: 'labels.GET_STATUS'
                                                    })
                                                })
                                            }, envelopeData.envelopeDetail.envelopeId + '-box')
                                        ]
                                    }),
                                    envelopeData.envelopeDetail.signers && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $3b23e285955cd078$export$2e2bcd8739ae039), {
                                        bgColor: '#fafafa',
                                        envelopeId: envelopeData.envelopeDetail.envelopeId,
                                        envelopeStatus: envelopeData.envelopeDetail.status,
                                        signersList: envelopeData.envelopeDetail.signers
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Row), {
                                        className: "d-flex justify-content-between ml-20",
                                        children: [
                                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c8342d32993f137e$export$2e2bcd8739ae039), {
                                                bundleNumber: row.bundleNumber,
                                                documentsInEnvelope: envelopeData.documents,
                                                envelopeId: envelopeData.envelopeDetail.envelopeId,
                                                envelopeStatus: envelopeData.envelopeDetail.status,
                                                icsID: row.icsID,
                                                quoteNumber: row.quoteNumber,
                                                userBranchCode: userBranchCode,
                                                userHasAccessToERegistry: userHasAccessToERegistry
                                            }),
                                            /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($2260333d3ecc242c$exports))).documentInfoPopup,
                                                onClick: handleDocumentPopup,
                                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $ab193334c82ec2ed$export$ebf44949dcb5de42), {
                                                    documentName: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                        id: 'labels.SELECTED_DOCUMENTS'
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $39bdaf6b319ea388$export$2e2bcd8739ae039), {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $0a7b72d03fc86354$export$e17bb34100dcb160), {
                                        documents: envelopeData.documents,
                                        isHidden: documentInfoPopupStatus,
                                        setDocumentInfoPopupStatus: setDocumentInfoPopupStatus
                                    })
                                ]
                            }, envelopeData.envelopeDetail.envelopeId);
                        }) : /*#__PURE__*/ (0, $eFTP6.jsx)((0, $9ab8fe562bccfb23$export$c0d6fd47a193aea1), {
                            context: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                id: 'alerts.NO_ENVELOPE_FOUND'
                            })
                        })
                    })
                })
            })
        ]
    });
}
$0f94eacaaa2f884c$export$2e2bcd8739ae039.propTypes = {
    handleGetStatus: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func.isRequired,
    row: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).object.isRequired,
    userBranchCode: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    userHasAccessToERegistry: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool.isRequired
};



var $02cc5564964dc241$exports = {};

$parcel$export($02cc5564964dc241$exports, "tableProgress", () => $02cc5564964dc241$export$e3a623a484ea6747, (v) => $02cc5564964dc241$export$e3a623a484ea6747 = v);
var $02cc5564964dc241$export$e3a623a484ea6747;
$02cc5564964dc241$export$e3a623a484ea6747 = "tableProgress_4a3ec8";



function $a60f42d8cb9b974a$var$descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
}
function $a60f42d8cb9b974a$var$getComparator(order, orderBy) {
    return order === 'desc' ? (a, b)=>$a60f42d8cb9b974a$var$descendingComparator(a, b, orderBy) : (a, b)=>-$a60f42d8cb9b974a$var$descendingComparator(a, b, orderBy);
}
function $a60f42d8cb9b974a$var$stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index)=>[
            el,
            index
        ]);
    stabilizedThis.sort((a, b)=>{
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el)=>el[0]);
}
const $a60f42d8cb9b974a$var$headCells = [
    {
        id: 'bundleNumber',
        numeric: false,
        disablePadding: false,
        label: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
            id: 'labels.BUNDLE'
        })
    },
    {
        id: 'quoteNumber',
        numeric: false,
        disablePadding: false,
        label: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
            id: 'labels.QUOTE'
        })
    },
    {
        id: 'startDate',
        numeric: false,
        disablePadding: false,
        label: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
            id: 'labels.START_DATE'
        })
    },
    {
        id: 'alfaDealerName',
        numeric: false,
        disablePadding: false,
        label: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
            id: 'labels.DEALERSHIP_NAME'
        })
    },
    {
        id: 'primaryCustomer',
        numeric: false,
        disablePadding: false,
        label: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
            id: 'labels.PRIMARY_CUSTOMER'
        })
    },
    {
        id: 'salesPersonName',
        numeric: false,
        disablePadding: false,
        label: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
            id: 'labels.SALESPERSON'
        })
    }
];
function $a60f42d8cb9b974a$var$EnhancedTableHead(props) {
    const { classes: classes, order: order, orderBy: orderBy, onRequestSort: onRequestSort } = props;
    const createSortHandler = (property)=>(event)=>{
            onRequestSort(event, property);
        };
    return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $814252108fd031b4$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $e6915f08e195d274$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $924d8ef775c5c9f0$export$2e2bcd8739ae039), {}),
                $a60f42d8cb9b974a$var$headCells.map((headCell)=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $924d8ef775c5c9f0$export$2e2bcd8739ae039), {
                        align: headCell.numeric ? 'right' : 'left',
                        padding: headCell.disablePadding ? 'none' : 'normal',
                        sortDirection: orderBy === headCell.id ? order : false,
                        style: {
                            'fontWeight': 'bold'
                        },
                        children: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $b606d0832a5935be$export$2e2bcd8739ae039), {
                            active: orderBy === headCell.id,
                            direction: orderBy === headCell.id ? order : 'asc',
                            onClick: createSortHandler(headCell.id),
                            children: [
                                headCell.label,
                                orderBy === headCell.id ? /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                    className: classes.visuallyHidden,
                                    children: order === 'desc' ? 'sorted descending' : 'sorted ascending'
                                }) : null
                            ]
                        })
                    }, headCell.id)),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $924d8ef775c5c9f0$export$2e2bcd8739ae039), {
                    style: {
                        'fontWeight': 'bold'
                    },
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                        id: 'labels.ACTION'
                    })
                })
            ]
        })
    });
}
$a60f42d8cb9b974a$var$EnhancedTableHead.propTypes = {
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).object.isRequired,
    onRequestSort: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func.isRequired,
    order: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).oneOf([
        'asc',
        'desc'
    ]).isRequired,
    orderBy: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    rowCount: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).number.isRequired
};
const $a60f42d8cb9b974a$var$useStyles = (0, $43f27ed29b5bb141$export$2e2bcd8739ae039)((theme)=>({
        root: {
            width: '100%'
        },
        paper: {
            width: '100%',
            marginBottom: theme.spacing(2)
        },
        table: {
            minWidth: 750
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1
        }
    }));
function $a60f42d8cb9b974a$export$2e2bcd8739ae039({ handleGetStatus: handleGetStatus, rows: rows, userBranchCode: userBranchCode, userHasAccessToERegistry: userHasAccessToERegistry }) {
    const classes = $a60f42d8cb9b974a$var$useStyles();
    const [order, setOrder] = (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useState('desc');
    const [orderBy, setOrderBy] = (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useState('createdDate');
    const handleRequestSort = (event, property)=>{
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };
    return /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $fe0aa9e32766c0f5$export$2e2bcd8739ae039), {
            className: classes.paper,
            children: rows.length > 0 ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $38bdee8745793da0$export$2e2bcd8739ae039), {
                component: (0, $fe0aa9e32766c0f5$export$2e2bcd8739ae039),
                children: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $0c4ceb83c44a630e$export$2e2bcd8739ae039), {
                    "aria-label": "collapsible table",
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsx)($a60f42d8cb9b974a$var$EnhancedTableHead, {
                            classes: classes,
                            onRequestSort: handleRequestSort,
                            order: order,
                            orderBy: orderBy,
                            rowCount: rows.length
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b5b6ab7f22f12380$export$2e2bcd8739ae039), {
                            children: $a60f42d8cb9b974a$var$stableSort(rows, $a60f42d8cb9b974a$var$getComparator(order, orderBy)).map((row)=>{
                                return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $0f94eacaaa2f884c$export$2e2bcd8739ae039), {
                                    handleGetStatus: handleGetStatus,
                                    row: row,
                                    userBranchCode: userBranchCode,
                                    userHasAccessToERegistry: userHasAccessToERegistry
                                }, row.quoteNumber);
                            })
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $eFTP6.jsx)((0, $75157c5b2ba08cec$export$2e2bcd8739ae039), {
                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($02cc5564964dc241$exports))).tableProgress}`,
                disableShrink: true,
                size: 50,
                thickness: 5
            })
        })
    });
}
$a60f42d8cb9b974a$export$2e2bcd8739ae039.propTypes = {
    handleGetStatus: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func.isRequired,
    rows: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).array,
    userBranchCode: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    userHasAccessToERegistry: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool.isRequired
};



var $elnlQ = parcelRequire("elnlQ");
/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $ab96d541745ba17c$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($ab96d541745ba17c$export$e19cd5f9376f8cee || ($ab96d541745ba17c$export$e19cd5f9376f8cee = {}));
var $ab96d541745ba17c$var$readOnly = function(obj) {
    return obj;
};
function $ab96d541745ba17c$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== 'undefined') console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $ab96d541745ba17c$var$BeforeUnloadEventType = 'beforeunload';
var $ab96d541745ba17c$var$HashChangeEventType = 'hashchange';
var $ab96d541745ba17c$var$PopStateEventType = 'popstate';
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $ab96d541745ba17c$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $ab96d541745ba17c$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $ab96d541745ba17c$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($ab96d541745ba17c$var$PopStateEventType, handlePop);
    var action = $ab96d541745ba17c$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $ab96d541745ba17c$var$createEvents();
    var blockers = $ab96d541745ba17c$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $elnlQ.default)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function createHref(to) {
        return typeof to === 'string' ? to : $ab96d541745ba17c$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $ab96d541745ba17c$var$readOnly((0, $elnlQ.default)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $ab96d541745ba17c$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $ab96d541745ba17c$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $ab96d541745ba17c$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $ab96d541745ba17c$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($ab96d541745ba17c$var$BeforeUnloadEventType, $ab96d541745ba17c$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($ab96d541745ba17c$var$BeforeUnloadEventType, $ab96d541745ba17c$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $ab96d541745ba17c$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $ab96d541745ba17c$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? '/' : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? '' : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? '' : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $ab96d541745ba17c$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $ab96d541745ba17c$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($ab96d541745ba17c$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($ab96d541745ba17c$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($ab96d541745ba17c$export$fe53371bee54353d(nextLocation) !== $ab96d541745ba17c$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $ab96d541745ba17c$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $ab96d541745ba17c$var$createEvents();
    var blockers = $ab96d541745ba17c$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $elnlQ.default)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function getBaseHref() {
        var base = document.querySelector('base');
        var href = '';
        if (base && base.getAttribute('href')) {
            var url = window.location.href;
            var hashIndex = url.indexOf('#');
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + '#' + (typeof to === 'string' ? to : $ab96d541745ba17c$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $ab96d541745ba17c$var$readOnly((0, $elnlQ.default)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $ab96d541745ba17c$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $ab96d541745ba17c$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $ab96d541745ba17c$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $ab96d541745ba17c$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($ab96d541745ba17c$var$BeforeUnloadEventType, $ab96d541745ba17c$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($ab96d541745ba17c$var$BeforeUnloadEventType, $ab96d541745ba17c$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $ab96d541745ba17c$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        '/'
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $ab96d541745ba17c$var$readOnly((0, $elnlQ.default)({
            pathname: '/',
            search: '',
            hash: '',
            state: null,
            key: $ab96d541745ba17c$var$createKey()
        }, typeof entry === 'string' ? $ab96d541745ba17c$export$8ccf933b0513f8d0(entry) : entry));
        return location;
    });
    var index = $ab96d541745ba17c$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $ab96d541745ba17c$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $ab96d541745ba17c$var$createEvents();
    var blockers = $ab96d541745ba17c$var$createEvents();
    function createHref(to) {
        return typeof to === 'string' ? to : $ab96d541745ba17c$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $ab96d541745ba17c$var$readOnly((0, $elnlQ.default)({
            pathname: location.pathname,
            search: '',
            hash: ''
        }, typeof to === 'string' ? $ab96d541745ba17c$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $ab96d541745ba17c$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $ab96d541745ba17c$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $ab96d541745ba17c$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $ab96d541745ba17c$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $ab96d541745ba17c$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $ab96d541745ba17c$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $ab96d541745ba17c$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = '';
}
function $ab96d541745ba17c$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $ab96d541745ba17c$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $ab96d541745ba17c$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? '/' : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? '' : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? '' : _ref$hash;
    if (search && search !== '?') pathname += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') pathname += hash.charAt(0) === '#' ? hash : '#' + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $ab96d541745ba17c$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf('#');
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf('?');
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}


var $b095844d27f3f99a$export$2e2bcd8739ae039 = (0, $ab96d541745ba17c$export$719fc203c4e16dee)();





var $d2bgE = parcelRequire("d2bgE");

class $f8a95d6ca5350b42$export$5e2670b88b4a3574 extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    constructor(props){
        super(props);
        this.state = {
            dealerNames: [],
            countries: [],
            dealers: [],
            bundleDataForSalesPerson: [],
            dataRows: [],
            primaryCustomers: [],
            quoteNumber: '',
            quoteNumberSearch: '',
            bundleNumberSearch: '',
            icsIdSearch: '',
            primaryCustomer: '',
            search: '',
            showGetStatusSpinner: false,
            noSearchResults: false,
            isAsmOrDro: false,
            hasError: false,
            errorMessage: '',
            initialLoad: true,
            bundlesToShow: new Set()
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleGetStatus = this.handleGetStatus.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.searchHelper = this.searchHelper.bind(this);
        this.getBundleData = this.getBundleData.bind(this);
    }
    async getEnvelopeDetailsForBundles(bundleNumbers, rebuildCache) {
        const urls = Array.from(bundleNumbers).map((bundleNumber)=>'/api/esign/bundle/envelopes/' + bundleNumber);
        const envelopeDetails = await Promise.all(urls.map((url)=>(0, $c04283212adf4fb0$export$60ad299e2e6f36fe)(url, {
                cacheDuration: 'forever'
            }, rebuildCache)));
        return envelopeDetails.reduce((accumulator, value)=>accumulator.concat(value), []);
    }
    async componentDidMount() {
        const bundleData = await this.getBundleData(1);
        (0, (/*@__PURE__*/$parcel$interopDefault($ebc81e85cd9d0f88$exports))).record({
            forms: true,
            numbers: true,
            emails: false
        });
        let bundleDataForSalesPerson;
        if (bundleData !== null) {
            //when user is a salesperson
            const allBundleData = [
                ...bundleData.esignProposalDetails
            ];
            const bundlesToShow = new Set(allBundleData.map((data)=>data.bundleNumber));
            bundleDataForSalesPerson = allBundleData.map((data)=>{
                return {
                    id: data.agreementNumber,
                    countryCode: data.country,
                    icsID: data.icsId,
                    bundleNumber: data.bundleNumber,
                    quoteNumber: data.agreementNumber,
                    startDate: data.startDate,
                    maturityDate: data.maturityDate,
                    asmName: null,
                    alfaDealerIdentifier: data.thirdPartyDetails[0].thirdPartyNumber,
                    alfaDealerName: data.thirdPartyDetails[0].displayName,
                    alfaCaseStatus: data.alfaCaseStatus,
                    financeProduct: data.financeProduct,
                    salesPersonName: data.salesperson,
                    primaryCustomer: [
                        data.thirdPartyDetails[1] ? data.thirdPartyDetails[1].displayName : ' '
                    ],
                    hasGuarantor: data.hasGuarantor,
                    assetInformation: data.scheduleDescription,
                    dealerReference: data.dealerReference,
                    primaryQuote: data.primaryQuote
                };
            });
            this.setState({
                bundlesToShow: bundlesToShow
            });
            let bundleEnvelopes = [];
            bundleEnvelopes = await this.getEnvelopeDetailsForBundles(bundlesToShow, this.props.location && this.props.location.search);
            /*setting the envelope details of a quote into bundle data*/ for (const element of bundleDataForSalesPerson)element.envelopes = bundleEnvelopes.filter((bundleEnvelope)=>bundleEnvelope.envelopeDetail.quoteNumber === element.quoteNumber);
        }
        const query = this.props.location && this.props.location.search;
        const params = new URLSearchParams(query || '');
        const search = params.get('search') || '';
        const bundleNumberSearch = this.props.bundleNumber || '';
        const quoteNumberSearch = this.props.agreementNumber || '';
        const hasInitialSearch = Boolean(query || bundleNumberSearch || quoteNumberSearch);
        if (hasInitialSearch) this.setState({
            search: search,
            quoteNumber: search,
            bundleNumberSearch: bundleNumberSearch,
            quoteNumberSearch: quoteNumberSearch
        });
        const primCustomers = bundleDataForSalesPerson && bundleDataForSalesPerson.map((detail)=>detail.primaryCustomer);
        const primaryCustomerSet = new Set();
        primCustomers && primCustomers.map((primCustomer)=>primaryCustomerSet.add(primCustomer[0]));
        if (hasInitialSearch) await this.handleSearch({
            bundleNumberSearch: bundleNumberSearch,
            quoteNumberSearch: quoteNumberSearch,
            icsIdSearch: '',
            primaryCustomer: ''
        });
        else this.setState({
            dataRows: bundleDataForSalesPerson,
            bundleDataForSalesPerson: bundleDataForSalesPerson,
            primaryCustomers: Array.from(primaryCustomerSet)
        });
        if (hasInitialSearch) this.setState({
            bundleDataForSalesPerson: bundleDataForSalesPerson,
            primaryCustomers: Array.from(primaryCustomerSet)
        });
    }
    async handleGetStatus(envelopeId, quoteNumber, setSpinnerOn) {
        setSpinnerOn(true);
        const recipientsStatus = await (0, $c04283212adf4fb0$export$c4b7edec3f76b207)('/api/esign/recipients-status/' + envelopeId);
        const envelopeStatus = await (0, $c04283212adf4fb0$export$c4b7edec3f76b207)('/api/esign/envelope-status/' + envelopeId);
        const dataRows = JSON.parse(JSON.stringify(this.state.dataRows));
        const quotes = dataRows.find((o)=>o.quoteNumber === quoteNumber);
        const envelopes = quotes.envelopes;
        const envelope = envelopes.find((o)=>o.envelopeDetail.envelopeId === envelopeId);
        envelope.envelopeDetail.lastModifiedAt = envelopeStatus.LastModifiedDate;
        envelope.envelopeDetail.status = envelopeStatus.Status;
        envelope.envelopeDetail.signers.forEach((signer)=>{
            const recipientStatus = recipientsStatus.filter((recipient)=>recipient.recipientId === signer.recipientId);
            if (recipientStatus !== null && recipientStatus.length > 0) {
                signer.status = recipientStatus[0].status;
                signer.envelopeDeclinedDate = recipientStatus[0].envelopeDeclinedDate;
                signer.envelopeDeclinedReason = recipientStatus[0].envelopeDeclinedReason;
                signer.envelopeViewedDate = recipientStatus[0].envelopeViewedDate;
                signer.envelopeSentDate = recipientStatus[0].envelopeSentDate;
                signer.envelopeSignedDate = recipientStatus[0].envelopeSignedDate;
            }
        });
        const bundleData = JSON.parse(JSON.stringify(this.state.dataRows));
        const salespersonQuotes = bundleData.filter((eSignProposal)=>eSignProposal.quoteNumber === quoteNumber);
        salespersonQuotes[0].envelopes = quotes.envelopes;
        this.setState({
            dataRows: dataRows,
            bundleData: bundleData
        });
        setSpinnerOn(false);
    }
    async getBundleData(pageNum) {
        const user = this.props.user;
        if (user.branchCode.includes('SP')) return (0, $c04283212adf4fb0$export$60ad299e2e6f36fe)('/api/esign/bundles-list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({
                userId: user.id,
                pageNumber: pageNum,
                branchCode: user.branchCode
            })
        });
        this.setState({
            isAsmOrDro: true
        });
        return null;
    }
    handleChange(name) {
        return (e)=>{
            this.setState({
                [name]: e.target.value
            });
        };
    }
    handleClear() {
        (0, $b095844d27f3f99a$export$2e2bcd8739ae039).push('/e-sign');
        this.setState((prevState)=>({
                bundleNumberSearch: '',
                icsIdSearch: '',
                primaryCustomer: '',
                noSearchResults: false,
                hasError: false,
                initialLoad: true,
                dataRows: prevState.bundleDataForSalesPerson,
                quoteNumber: '',
                quoteNumberSearch: ''
            }));
    }
    searchHelper(searchCriteria) {
        const [data, fieldName, searchField] = searchCriteria;
        return data.filter((dataRow)=>dataRow[fieldName] === searchField);
    }
    async handleSearch(searchCriteria) {
        const criteria = searchCriteria && Object.prototype.hasOwnProperty.call(searchCriteria, 'quoteNumberSearch') ? searchCriteria : this.state;
        const user = this.props.user;
        this.setState({
            initialLoad: false,
            hasError: false,
            dataRows: []
        });
        try {
            const searchedData = await (0, $c04283212adf4fb0$export$60ad299e2e6f36fe)('/api/esign/bundle-search', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify({
                    userId: user.id,
                    bundleNumber: criteria.bundleNumberSearch || null,
                    agreementNumber: criteria.quoteNumberSearch || null,
                    icsReference: criteria.icsIdSearch || null,
                    customer: criteria.primaryCustomer || null
                })
            });
            if (searchedData.esignProposalDetails === null || searchedData.esignProposalDetails.length === 0) this.setState({
                noSearchResults: true
            });
            else {
                const allBundleData = [
                    ...searchedData.esignProposalDetails
                ];
                const bundlesToShow = new Set(allBundleData.map((data)=>data.bundleNumber));
                const bundleDataForSalesPerson = allBundleData.map((data)=>{
                    return {
                        id: data.agreementNumber,
                        countryCode: data.country,
                        icsID: data.icsId,
                        bundleNumber: data.bundleNumber,
                        quoteNumber: data.agreementNumber,
                        startDate: data.startDate,
                        maturityDate: data.maturityDate,
                        asmName: null,
                        alfaDealerIdentifier: data.thirdPartyDetails[0].thirdPartyNumber,
                        alfaDealerName: data.thirdPartyDetails[0].displayName,
                        alfaCaseStatus: data.alfaCaseStatus,
                        financeProduct: data.financeProduct,
                        salesPersonName: data.salesperson,
                        primaryCustomer: [
                            data.thirdPartyDetails[1] ? data.thirdPartyDetails[1].displayName : ' '
                        ],
                        hasGuarantor: data.hasGuarantor,
                        assetInformation: data.scheduleDescription,
                        dealerReference: data.dealerReference,
                        primaryQuote: data.primaryQuote
                    };
                });
                this.setState({
                    bundlesToShow: bundlesToShow
                });
                let bundleEnvelopes = [];
                bundleEnvelopes = await this.getEnvelopeDetailsForBundles(bundlesToShow, this.props.location && this.props.location.search);
                for (const element of bundleDataForSalesPerson)element.envelopes = bundleEnvelopes.filter((bundleEnvelope)=>bundleEnvelope.envelopeDetail.quoteNumber === element.quoteNumber);
                this.setState({
                    dataRows: bundleDataForSalesPerson,
                    noSearchResults: bundleDataForSalesPerson === null || bundleDataForSalesPerson === undefined
                });
            }
        } catch (e) {
            this.setState({
                hasError: true,
                errorMessage: e.errorMessage
            });
        }
    }
    render() {
        const isEmptyResultShown = this.state.isAsmOrDro && this.state.initialLoad;
        const componentMap = {
            [!this.state.noSearchResults]: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $a60f42d8cb9b974a$export$2e2bcd8739ae039), {
                handleGetStatus: this.handleGetStatus,
                order: 'desc',
                orderBy: 'startDate',
                rows: this.state.dataRows,
                userBranchCode: this.props.user.branchCode,
                userHasAccessToERegistry: this.props.user.hasAccessToERegistry
            }),
            [this.state.noSearchResults && this.state.isAsmOrDro]: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $9ab8fe562bccfb23$export$c0d6fd47a193aea1), {
                context: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                    id: 'alerts.NO_RESULTS_FOUND'
                }),
                message: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                    id: 'alerts.NO_PROPOSALS_AVAILABLE_FOR_GIVEN_SEARCH_CRITERIA'
                })
            }),
            [this.state.noSearchResults && !this.state.isAsmOrDro]: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $9ab8fe562bccfb23$export$c0d6fd47a193aea1), {
                context: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                    id: 'alerts.NO_RESULTS_FOUND'
                }),
                message: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                    id: 'alerts.NO_PROPOSALS_AVAILABLE_FOR_GIVEN_SEARCH_CRITERIA_CLICK_CLEAR'
                })
            }),
            [isEmptyResultShown]: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $9ab8fe562bccfb23$export$c0d6fd47a193aea1), {
                context: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                    id: 'alerts.SEARCH_FOR_A_PROPOSAL_TO_CONTINUE'
                })
            }),
            [this.state.hasError]: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $9ab8fe562bccfb23$export$c0d6fd47a193aea1), {
                context: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                    id: this.state.errorMessage
                })
            })
        };
        return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)("h3", {
                    className: "mb-2",
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                        id: 'labels.E_SIGNATURE_DASHBOARD'
                    })
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c140a9ec31059532$export$2e2bcd8739ae039), {
                    style: {
                        marginBottom: 20
                    },
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $5925addb94d391de$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                            container: true,
                            direction: "row",
                            item: true,
                            spacing: 2,
                            style: {
                                marginLeft: '2%'
                            },
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    alignItems: "flex-start",
                                    container: true,
                                    direction: "column",
                                    item: true,
                                    justifyContent: "space-between",
                                    sm: 3,
                                    xs: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                            style: {
                                                fontWeight: 'bold'
                                            },
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.BUNDLE'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $3a4ed32c219a2dd3$export$2e2bcd8739ae039), {
                                            disabled: false,
                                            id: "bundle-number",
                                            margin: "none",
                                            onChange: this.handleChange('bundleNumberSearch'),
                                            placeholder: "B001234",
                                            value: this.state.bundleNumberSearch
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    alignItems: "flex-start",
                                    container: true,
                                    direction: "column",
                                    item: true,
                                    justifyContent: "space-between",
                                    sm: 3,
                                    xs: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                            style: {
                                                fontWeight: 'bold'
                                            },
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.QUOTE'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $3a4ed32c219a2dd3$export$2e2bcd8739ae039), {
                                            disabled: false,
                                            id: "quote-number",
                                            margin: "none",
                                            onChange: this.handleChange('quoteNumberSearch'),
                                            placeholder: "AALF001234",
                                            value: this.state.quoteNumberSearch
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    alignItems: "flex-start",
                                    container: true,
                                    direction: "column",
                                    item: true,
                                    justifyContent: "space-between",
                                    sm: 3,
                                    xs: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                            style: {
                                                fontWeight: 'bold'
                                            },
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.ICS_REFERENCE'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $3a4ed32c219a2dd3$export$2e2bcd8739ae039), {
                                            disabled: false,
                                            id: "ics-reference",
                                            margin: "none",
                                            onChange: this.handleChange('icsIdSearch'),
                                            placeholder: "123456",
                                            value: this.state.icsIdSearch
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    alignItems: "flex-start",
                                    container: true,
                                    direction: "column",
                                    item: true,
                                    justifyContent: "space-between",
                                    sm: 3,
                                    xs: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                            style: {
                                                fontWeight: 'bold'
                                            },
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.PRIMARY_CUSTOMER'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $3a4ed32c219a2dd3$export$2e2bcd8739ae039), {
                                            disabled: false,
                                            id: "primaryCustomer",
                                            margin: "none",
                                            onChange: this.handleChange('primaryCustomer'),
                                            placeholder: "David Smith",
                                            value: this.state.primaryCustomer
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                    alignItems: "center",
                    container: true,
                    direction: "row",
                    justifyContent: "flex-end",
                    style: {
                        marginBottom: 20
                    },
                    children: /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                        style: {
                            position: 'relative',
                            marginLeft: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                                color: "default",
                                disabled: this.state.loading,
                                onClick: this.handleClear,
                                style: {
                                    marginLeft: 10
                                },
                                variant: "contained",
                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                    id: 'labels.CLEAR'
                                })
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                                disabled: this.state.loading,
                                onClick: this.handleSearch,
                                style: {
                                    marginLeft: 10,
                                    backgroundColor: '#ffde00'
                                },
                                variant: "contained",
                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                    id: 'labels.SEARCH'
                                })
                            }),
                            this.state.loading && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $75157c5b2ba08cec$export$2e2bcd8739ae039), {
                                disableShrink: true,
                                size: 24,
                                style: {
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    marginTop: -12,
                                    marginLeft: -12
                                }
                            })
                        ]
                    })
                }),
                componentMap.true
            ]
        });
    }
}
$f8a95d6ca5350b42$export$5e2670b88b4a3574.propTypes = {
    location: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).object.isRequired,
    user: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).object.isRequired,
    bundleNumber: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    agreementNumber: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string
};





var $bdmad = parcelRequire("bdmad");
var $elnlQ = parcelRequire("elnlQ");

var $Fo7oF = parcelRequire("Fo7oF");



var $jpxeP = parcelRequire("jpxeP");

var $bauHK = parcelRequire("bauHK");

var $18Npe = parcelRequire("18Npe");
function $c69902c63474d2eb$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        var mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $elnlQ.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $c69902c63474d2eb$var$ThemeProvider(props) {
    var children = props.children, localTheme = props.theme;
    var outerTheme = (0, $bauHK.default)();
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useMemo(function() {
        var output = outerTheme === null ? localTheme : $c69902c63474d2eb$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $18Npe.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $jpxeP.default).Provider, {
        value: theme
    }, children);
}
var $c69902c63474d2eb$export$2e2bcd8739ae039 = $c69902c63474d2eb$var$ThemeProvider;




var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");

function $b567281d998fb069$var$DeereFooter() {
    return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Footer), {
        children: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.List), {
            className: "nav",
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.ListItem), {
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.FooterLink), {
                        href: "http://ux.deere.com/",
                        children: "Home"
                    })
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.ListItem), {
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.FooterLink), {
                        href: "http://ux.deere.com/other-pages/contact-us/",
                        children: "Contact Us"
                    })
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.ListItem), {
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.FooterLink), {
                        href: "https://github.deere.com/ux/uxframe",
                        rel: "noopener noreferrer",
                        target: "_blank",
                        children: "GitHub"
                    })
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.ListItem), {
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.FooterLink), {
                        href: "https://www.yammer.com/johndeere.com/#/threads/inGroup?type=in_group&feedId=15611067&view=all",
                        rel: "noopener noreferrer",
                        target: "_blank",
                        children: "Yammer"
                    })
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.ListItem), {
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.FooterLink), {
                        href: "https://www.flowdock.com/app/john-deere/ux",
                        rel: "noopener noreferrer",
                        target: "_blank",
                        children: "Flowdock"
                    })
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.ListItem), {
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.FooterLink), {
                        href: "https://johndeere.cvent.com/pub/eMarketing/Pages/SignUp.aspx?p=2a69c63b-ace1-454f-bbe3-e371c5a09d58&m=",
                        rel: "noopener noreferrer",
                        target: "_blank",
                        children: "Subscribe to our Newsletter"
                    })
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.ListItem), {
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.FooterLink), {
                        href: "https://www.deere.com/en/privacy-and-data/",
                        rel: "noopener noreferrer",
                        target: "_blank",
                        children: "Privacy & Data"
                    })
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.ListItem), {
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.FooterLink), {
                        href: "https://www.deere.com/en/privacy-and-data/terms/",
                        rel: "noopener noreferrer",
                        target: "_blank",
                        children: "Terms of Use"
                    })
                })
            ]
        })
    });
}
var $b567281d998fb069$export$2e2bcd8739ae039 = $b567281d998fb069$var$DeereFooter;




var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");









var $1594f541af463959$exports = {};

$parcel$export($1594f541af463959$exports, "warningText", () => $1594f541af463959$export$d1e6de57dc4d952e, (v) => $1594f541af463959$export$d1e6de57dc4d952e = v);
$parcel$export($1594f541af463959$exports, "validationError", () => $1594f541af463959$export$6d5883677622dc6d, (v) => $1594f541af463959$export$6d5883677622dc6d = v);
$parcel$export($1594f541af463959$exports, "isDisabled", () => $1594f541af463959$export$30e0dc115df457ed, (v) => $1594f541af463959$export$30e0dc115df457ed = v);
$parcel$export($1594f541af463959$exports, "mergeFailed", () => $1594f541af463959$export$c4ff22de194af1f7, (v) => $1594f541af463959$export$c4ff22de194af1f7 = v);
$parcel$export($1594f541af463959$exports, "mergeSuccess", () => $1594f541af463959$export$f21f5376fff9c523, (v) => $1594f541af463959$export$f21f5376fff9c523 = v);
$parcel$export($1594f541af463959$exports, "prerequisitesInfo", () => $1594f541af463959$export$402e5a935d55d441, (v) => $1594f541af463959$export$402e5a935d55d441 = v);
var $1594f541af463959$export$d1e6de57dc4d952e;
var $1594f541af463959$export$6d5883677622dc6d;
var $1594f541af463959$export$30e0dc115df457ed;
var $1594f541af463959$export$c4ff22de194af1f7;
var $1594f541af463959$export$f21f5376fff9c523;
var $1594f541af463959$export$402e5a935d55d441;
$1594f541af463959$export$d1e6de57dc4d952e = "warningText_afe949";
$1594f541af463959$export$6d5883677622dc6d = "validationError_afe949";
$1594f541af463959$export$30e0dc115df457ed = "isDisabled_afe949";
$1594f541af463959$export$c4ff22de194af1f7 = "mergeFailed_afe949";
$1594f541af463959$export$f21f5376fff9c523 = "mergeSuccess_afe949";
$1594f541af463959$export$402e5a935d55d441 = "prerequisitesInfo_afe949";



const $7b1df986b539a107$export$defe85febe8b728c = {
    error1: 'Number of source dealers should be > 0',
    error2: 'Invalid new dealer id. Please enter 10 character alphanumeric dealer id. Ex. TALF000000.',
    error3: 'New and Source dealer Ids cannot be same.',
    warningText: 'Please review source and new dealer ids carefully.',
    infoText: 'Proposal and customer data from source dealers will be migrated to new dealer.',
    processingInfoText: 'Migrating data from Source to New dealer.',
    mergeSuccessText: 'Completed successfully.',
    genericError: 'ERROR: There was an error duirng merge process.',
    importantInfo: [
        'a. Full data back-up has been done.',
        'b. ICS system changes have been completed for new and source dealers.',
        'c. New dealer should have at least two billing address versions created in Alfa core. Ex. TALF000000/1 and TALF000000/2'
    ]
};



function $ba0a375eac74307a$var$_defineProperty(e, r, t) {
    return (r = $ba0a375eac74307a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ba0a375eac74307a$var$_toPropertyKey(t) {
    var i = $ba0a375eac74307a$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ba0a375eac74307a$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $ba0a375eac74307a$export$e32b480bab30b999 extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    constructor(props){
        super(props);
        $ba0a375eac74307a$var$_defineProperty(this, "handleClose", (e)=>{
            e.preventDefault();
            this.setState({
                confirmationDialog: false
            });
        });
        $ba0a375eac74307a$var$_defineProperty(this, "clearAll", (e)=>{
            e.preventDefault();
            window.location.reload();
        });
        $ba0a375eac74307a$var$_defineProperty(this, "getNewDealer", (newDealer)=>{
            this.setState({
                newDealer: newDealer.toUpperCase()
            });
        });
        $ba0a375eac74307a$var$_defineProperty(this, "validateMerge", (e)=>{
            e.preventDefault();
            this.setState({
                mergeResult: ''
            });
            const errors = [];
            this.state.sourceDealers.length < 1 && errors.push((0, $7b1df986b539a107$export$defe85febe8b728c).error1);
            this.state.newDealer.length !== 10 && errors.push((0, $7b1df986b539a107$export$defe85febe8b728c).error2);
            this.state.sourceDealers.includes(this.state.newDealer) && errors.push((0, $7b1df986b539a107$export$defe85febe8b728c).error3);
            this.setState({
                validationError: errors
            });
            errors.length === 0 && this.setState({
                confirmationDialog: true
            });
        });
        this.state = {
            sourceDealers: [],
            newDealer: '',
            validationError: [],
            confirmationDialog: false,
            processing: false,
            mergeResult: '',
            mergeApiError: null
        };
        this.getSourceDealers = this.getSourceDealers.bind(this);
        this.getNewDealer = this.getNewDealer.bind(this);
        this.validateMerge = this.validateMerge.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.mergeDealers = this.mergeDealers.bind(this);
        this.clearAll = this.clearAll.bind(this);
    }
    async mergeDealers(e) {
        e.preventDefault();
        this.setState({
            processing: true
        });
        const sourceDealers = this.state.sourceDealers;
        const newDealer = this.state.newDealer;
        this.setState({
            confirmationDialog: false
        }); // Close merge popup
        const body = {
            'oldThirdPartyNumbers': sourceDealers,
            'newThirdPartyNumber': newDealer
        };
        try {
            const mergeResponse = await (0, $c04283212adf4fb0$export$c4b7edec3f76b207)('/api/merger/merger-and-acquisition', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify(body)
            });
            this.setState({
                mergeResult: mergeResponse,
                mergeApiError: mergeResponse === false ? (0, $7b1df986b539a107$export$defe85febe8b728c).genericError : null,
                processing: false
            });
        } catch (err) {
            this.setState({
                processing: false
            });
            this.setState({
                mergeApiError: `An error occured: ${err.status} ${err.error} ${err.message}`
            });
        }
    }
    getSourceDealers(source) {
        const removeSpaces = source.replace(/\s+/g, '');
        const filteredList = removeSpaces.toUpperCase().split(';').filter((value)=>value !== '' && value !== null);
        this.setState({
            sourceDealers: filteredList
        });
    }
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
            className: this.state.processing ? `${(0, (/*@__PURE__*/$parcel$interopDefault($1594f541af463959$exports))).isDisabled}` : 'mNaDiv',
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)("h3", {
                    className: "mb10",
                    children: "Merger & Acquisition "
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Card), {
                    children: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Card).Body, {
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Row), {
                                children: /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                                    className: `${(0, (/*@__PURE__*/$parcel$interopDefault($1594f541af463959$exports))).prerequisitesInfo}`,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                            className: "d-block font-weight-bold mb-2",
                                            children: "Important prerequisites: "
                                        }),
                                        (0, $7b1df986b539a107$export$defe85febe8b728c).importantInfo.map((info)=>/*#__PURE__*/ (0, $eFTP6.jsxs)("span", {
                                                className: "d-block mb-1 pl-3",
                                                children: [
                                                    info,
                                                    " "
                                                ]
                                            }, 'info-' + (0, $ce7657dc4dcb9e28$export$a47fb462a08de82f)()))
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Row), {
                                children: [
                                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Col), {
                                        children: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form), {
                                            id: "mNaForm",
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form).Group, {
                                                    controlId: "formGridName",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form).Label, {
                                                            className: "uxf-label",
                                                            children: [
                                                                "Source Dealer Ids",
                                                                ' ',
                                                                /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                                                    "aria-label": "required field",
                                                                    className: "uxf-is-required",
                                                                    children: "*"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Form).Control, {
                                                            className: "text-uppercase",
                                                            onChange: (e)=>this.getSourceDealers(e.target.value),
                                                            placeholder: "TALF000001;TALF000002",
                                                            required: true,
                                                            type: "text"
                                                        }),
                                                        /*#__PURE__*/ (0, $eFTP6.jsx)("small", {
                                                            className: "form-text text-muted",
                                                            id: "sourceDealerHelp",
                                                            children: "Enter semicolon seperated values"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $eFTP6.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form).Group, {
                                                    controlId: "formGridEmail",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form).Label, {
                                                            className: "uxf-label",
                                                            children: [
                                                                "New Dealer Id",
                                                                ' ',
                                                                /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                                                    "aria-label": "required field",
                                                                    className: "uxf-is-required",
                                                                    children: "*"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Form).Control, {
                                                            className: "text-uppercase",
                                                            onChange: (e)=>this.getNewDealer(e.target.value),
                                                            placeholder: "TALF000333",
                                                            required: true,
                                                            type: "text"
                                                        }),
                                                        /*#__PURE__*/ (0, $eFTP6.jsx)("small", {
                                                            className: "form-text text-muted",
                                                            id: "sourceDealerHelp",
                                                            children: "Only one value expected"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $eFTP6.jsx)("br", {}),
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                                                    color: "primary",
                                                    onClick: (e)=>this.validateMerge(e),
                                                    size: "medium",
                                                    variant: "contained",
                                                    children: "Review"
                                                }),
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                                                    className: "ml-2",
                                                    color: "inherit",
                                                    onClick: (e)=>this.clearAll(e),
                                                    size: "medium",
                                                    variant: "contained",
                                                    children: "Clear"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Col), {
                                        children: [
                                            /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                                                className: "d-flex flex-column align-items-left",
                                                children: this.state.validationError.map((err)=>/*#__PURE__*/ (0, $eFTP6.jsxs)("p", {
                                                        className: `text-danger p-2 ${(0, (/*@__PURE__*/$parcel$interopDefault($1594f541af463959$exports))).validationError}`,
                                                        style: {
                                                            fontSize: 13
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $eFTP6.jsx)("strong", {
                                                                children: "Error:"
                                                            }),
                                                            " ",
                                                            err
                                                        ]
                                                    }, 'err-' + (0, $ce7657dc4dcb9e28$export$a47fb462a08de82f)()))
                                            }),
                                            this.state.processing && /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                                                className: 'd-flex flex-column align-items-center',
                                                children: [
                                                    /*#__PURE__*/ (0, $eFTP6.jsx)("p", {
                                                        className: "font-weight-bold text-success",
                                                        children: "Please wait..."
                                                    }),
                                                    /*#__PURE__*/ (0, $eFTP6.jsx)("p", {
                                                        className: "text-success",
                                                        children: (0, $7b1df986b539a107$export$defe85febe8b728c).processingInfoText
                                                    }),
                                                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f4267c9105e002e8$export$fe708d541030d854), {
                                                        size: "md"
                                                    })
                                                ]
                                            }),
                                            this.state.mergeApiError !== null && /*#__PURE__*/ (0, $eFTP6.jsx)("p", {
                                                className: `${(0, (/*@__PURE__*/$parcel$interopDefault($1594f541af463959$exports))).mergeFailed}`,
                                                children: this.state.mergeApiError
                                            }),
                                            this.state.mergeResult && /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $eFTP6.jsxs)("p", {
                                                    className: `${(0, (/*@__PURE__*/$parcel$interopDefault($1594f541af463959$exports))).mergeSuccess}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f4267c9105e002e8$export$63b4fc557d1c57af), {
                                                            className: "mergesuccess",
                                                            size: "18%"
                                                        }),
                                                        /*#__PURE__*/ (0, $eFTP6.jsxs)("span", {
                                                            className: "d-block mt-20",
                                                            children: [
                                                                " ",
                                                                (0, $7b1df986b539a107$export$defe85febe8b728c).mergeSuccessText
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $06c828c7d8d76aa9$export$2e2bcd8739ae039), {
                    "aria-labelledby": "customized-dialog-title",
                    fullWidth: true,
                    onClose: (e)=>this.handleClose(e),
                    open: this.state.confirmationDialog,
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Row), {
                            className: "d-flex ml-3 mr-2 mt-2 justify-content-between",
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                    className: "d-inline",
                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)("h5", {
                                        className: "font-weight-bold mt-1",
                                        children: "Review Details"
                                    })
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                    className: "d-inline",
                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c6e28b9de0df1599$export$2e2bcd8739ae039), {
                                        "aria-label": "close",
                                        onClick: (e)=>this.handleClose(e),
                                        size: "small",
                                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($57b96121aa7aac71$exports))), {
                                            fontSize: "small"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b04338db8f46de7f$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $1c55bad717a43115$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1594f541af463959$exports))).warningText,
                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)("p", {
                                        className: "ml-3 pt-2 pb-2 font-weight-bold",
                                        children: (0, $7b1df986b539a107$export$defe85febe8b728c).warningText
                                    })
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsx)("p", {
                                    className: "mt-2",
                                    children: (0, $7b1df986b539a107$export$defe85febe8b728c).infoText
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Row), {
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Col), {
                                            children: /*#__PURE__*/ (0, $eFTP6.jsxs)("dl", {
                                                className: "uxf-dl",
                                                children: [
                                                    /*#__PURE__*/ (0, $eFTP6.jsx)("dt", {
                                                        children: "Source Dealer Ids:"
                                                    }),
                                                    this.state.sourceDealers.map((srcDealer)=>/*#__PURE__*/ (0, $eFTP6.jsx)("dd", {
                                                            children: srcDealer
                                                        }, 'sd-' + (0, $ce7657dc4dcb9e28$export$a47fb462a08de82f)()))
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Col), {
                                            children: /*#__PURE__*/ (0, $eFTP6.jsxs)("dl", {
                                                children: [
                                                    /*#__PURE__*/ (0, $eFTP6.jsx)("dt", {
                                                        children: "New Dealer Id:"
                                                    }),
                                                    /*#__PURE__*/ (0, $eFTP6.jsx)("dd", {
                                                        children: this.state.newDealer
                                                    }),
                                                    /*#__PURE__*/ (0, $eFTP6.jsx)("br", {})
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("br", {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b04338db8f46de7f$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1b29532bd4542510$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                                className: "mt-1 mb-1",
                                color: "primary",
                                onClick: (e)=>this.mergeDealers(e),
                                size: "medium",
                                variant: "contained",
                                children: "Merge"
                            })
                        })
                    ]
                })
            ]
        });
    }
}


const $7030535042884b0b$export$af506a8c57c66b45 = [
    'ESSP',
    'ESDRO',
    'ESASM',
    'DEDRO',
    'DEASM',
    'GBDRO',
    'GBASM',
    'GBCNT',
    'DECNT',
    'ESCNT',
    'DESP',
    'GBSP',
    'PTSP',
    'PTDRO',
    'PTASM',
    'PTCNT'
];
const $7030535042884b0b$export$5ac229ab51eeefcb = [
    'ESDRO',
    'DEDRO',
    'GBDRO',
    'GBCNT',
    'DECNT',
    'ESCNT',
    'PTCNT',
    'PTDRO'
];




var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 


var $Fo7oF = parcelRequire("Fo7oF");


/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 





var $58af422d84878f27$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $58af422d84878f27$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $aec25548772adc94$export$4ee1db8ce44a209b)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $aec25548772adc94$export$d697c39a2985a4c)(options, $58af422d84878f27$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $58af422d84878f27$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $58af422d84878f27$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $c20acf2711ccd7bd$export$e3b7eee1dbc44895)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $58af422d84878f27$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $58af422d84878f27$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $c20acf2711ccd7bd$export$e3b7eee1dbc44895)('Error formatting number.', config.locale, e));
    }
    return [];
}





var $4a6487223ef7e2fc$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $4a6487223ef7e2fc$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $aec25548772adc94$export$4ee1db8ce44a209b)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $aec25548772adc94$export$d697c39a2985a4c)(options, $4a6487223ef7e2fc$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $4a6487223ef7e2fc$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $cdd1aad0435a7fe4$export$7369836851cc1329)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $cdd1aad0435a7fe4$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    try {
        return $4a6487223ef7e2fc$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $c20acf2711ccd7bd$export$e3b7eee1dbc44895)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}





var $9e43211bdac3e9df$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $9e43211bdac3e9df$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $aec25548772adc94$export$4ee1db8ce44a209b)(formats, type, format, onError));
    var filteredOptions = (0, $aec25548772adc94$export$d697c39a2985a4c)(options, $9e43211bdac3e9df$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $9e43211bdac3e9df$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $9e43211bdac3e9df$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $c20acf2711ccd7bd$export$e3b7eee1dbc44895)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $9e43211bdac3e9df$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $9e43211bdac3e9df$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $c20acf2711ccd7bd$export$e3b7eee1dbc44895)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $9e43211bdac3e9df$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $aec25548772adc94$export$d697c39a2985a4c)(options, $9e43211bdac3e9df$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $c20acf2711ccd7bd$export$e3b7eee1dbc44895)('Error formatting date time range.', config.locale, e));
    }
    return String(from);
}
function $9e43211bdac3e9df$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $9e43211bdac3e9df$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $c20acf2711ccd7bd$export$e3b7eee1dbc44895)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $9e43211bdac3e9df$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $9e43211bdac3e9df$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $c20acf2711ccd7bd$export$e3b7eee1dbc44895)('Error formatting time.', config.locale, e));
    }
    return [];
}





var $635463e839fec1a6$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $635463e839fec1a6$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $cdd1aad0435a7fe4$export$7369836851cc1329)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $cdd1aad0435a7fe4$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $aec25548772adc94$export$d697c39a2985a4c)(options, $635463e839fec1a6$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $c20acf2711ccd7bd$export$e3b7eee1dbc44895)('Error formatting plural.', locale, e));
    }
    return 'other';
}







function $bfc6d908b9670737$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $21175c20cefb0343$export$18ce0697a983be9b)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $bfc6d908b9670737$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $bfc6d908b9670737$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $9c3192b3aeeea51e$export$d342343268debc40).formats;
    return (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, mfFormats), f1), {
        date: $bfc6d908b9670737$var$deepMergeOptions($bfc6d908b9670737$var$setTimeZoneInOptions(mfFormats.date, timeZone), $bfc6d908b9670737$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $bfc6d908b9670737$var$deepMergeOptions($bfc6d908b9670737$var$setTimeZoneInOptions(mfFormats.time, timeZone), $bfc6d908b9670737$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $bfc6d908b9670737$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $a1cc92d68b9862b4$export$f5708dca728d7177)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $4c8d81aafd70cb25$export$b87f371cbc396fcf).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, defaultRichTextElements), values || {});
    formats = $bfc6d908b9670737$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $bfc6d908b9670737$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $c20acf2711ccd7bd$export$2ddcb436d0aa3688)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $c20acf2711ccd7bd$export$74a601a3d3f31621)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $21175c20cefb0343$export$18ce0697a983be9b)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $c20acf2711ccd7bd$export$74a601a3d3f31621)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $c20acf2711ccd7bd$export$74a601a3d3f31621)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};






var $68b35c248981015f$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $68b35c248981015f$var$now = Date.now();
function $68b35c248981015f$var$generateToken(i) {
    return "".concat($68b35c248981015f$var$now, "_").concat(i, "_").concat($68b35c248981015f$var$now);
}
function $68b35c248981015f$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $68b35c248981015f$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $68b35c248981015f$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $cdd1aad0435a7fe4$export$7369836851cc1329)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $cdd1aad0435a7fe4$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $aec25548772adc94$export$d697c39a2985a4c)(options, $68b35c248981015f$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $68b35c248981015f$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $c20acf2711ccd7bd$export$e3b7eee1dbc44895)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}





var $50e230a6dfb2b464$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $50e230a6dfb2b464$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $cdd1aad0435a7fe4$export$7369836851cc1329)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $cdd1aad0435a7fe4$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $aec25548772adc94$export$d697c39a2985a4c)(options, $50e230a6dfb2b464$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $c20acf2711ccd7bd$export$e3b7eee1dbc44895)('Error formatting display name.', locale, e));
    }
}


function $864c3533cee8b1d1$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $864c3533cee8b1d1$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $864c3533cee8b1d1$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $864c3533cee8b1d1$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $aec25548772adc94$export$c3f4cd5551df13fd)(cache);
    var resolvedConfig = (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, (0, $aec25548772adc94$export$b52f8d6fc0d47415)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $c20acf2711ccd7bd$export$3ca04dd7fb305893)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $c20acf2711ccd7bd$export$c1eaf877d81384b6)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $c20acf2711ccd7bd$export$c1eaf877d81384b6)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $864c3533cee8b1d1$var$verifyConfigMessages(resolvedConfig);
    return (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $58af422d84878f27$export$f5dd818bff069720).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $58af422d84878f27$export$6871080848f10b2f).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $4a6487223ef7e2fc$export$b4ea3b48dcf921f6).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $9e43211bdac3e9df$export$3ae94a2503e890a1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $9e43211bdac3e9df$export$dc1f059bce486b1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $9e43211bdac3e9df$export$3203edd9e5edd663).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $9e43211bdac3e9df$export$a7fc3a91cb2ec376).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $9e43211bdac3e9df$export$af6e5d7a5c73edeb).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $635463e839fec1a6$export$bbbd05c900f3568d).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $bfc6d908b9670737$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $bfc6d908b9670737$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        formatList: (0, $68b35c248981015f$export$e8b8be48b45905bb).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $68b35c248981015f$export$6f284aad1934db69).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $50e230a6dfb2b464$export$62fe1a4d9e891fa2).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}



var $Fo7oF = parcelRequire("Fo7oF");


function $f2ec4c58788dfff4$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $9f488594d2e0e5a5$export$df0c12a2d414a163)(v) ? (0, $81047c1ca6bde4f6$export$cfec03d26465fa63)(v) : v;
        return acc;
    }, {});
}
var $f2ec4c58788dfff4$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $f2ec4c58788dfff4$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $bfc6d908b9670737$export$25868d1e8e76735f).apply(void 0, (0, $21175c20cefb0343$export$1216008129fb82ed)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $Fo7oF.Children.toArray(chunks);
    return chunks;
};
var $f2ec4c58788dfff4$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $21175c20cefb0343$export$3c9a16f847548506)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $f2ec4c58788dfff4$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $864c3533cee8b1d1$export$7e4cbedfdd7b4c0d)((0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, (0, $81047c1ca6bde4f6$export$b52f8d6fc0d47415)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $21175c20cefb0343$export$18ce0697a983be9b)((0, $21175c20cefb0343$export$18ce0697a983be9b)({}, coreIntl), {
        formatMessage: $f2ec4c58788dfff4$var$formatMessage.bind(null, resolvedConfig, // @ts-expect-error fix this
        coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $f2ec4c58788dfff4$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};


function $ed965e05d58e6e5e$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $ed965e05d58e6e5e$var$IntlProvider = /** @class */ function(_super) {
    (0, $21175c20cefb0343$export$a8ba968b8961cb8a)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $aec25548772adc94$export$51c4f4e973f2dc00)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $f2ec4c58788dfff4$export$7e4cbedfdd7b4c0d)($ed965e05d58e6e5e$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $ed965e05d58e6e5e$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $ed965e05d58e6e5e$var$processIntlConfig(props);
        if (!(0, $81047c1ca6bde4f6$export$d36bdfa510afb180)(prevConfig, config)) return {
            intl: (0, $f2ec4c58788dfff4$export$7e4cbedfdd7b4c0d)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $81047c1ca6bde4f6$export$45c4bbf6e55bba1f)(this.state.intl);
        return $Fo7oF.createElement((0, $560608e2ff51836b$export$2881499e37b75b9a), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $81047c1ca6bde4f6$export$b52f8d6fc0d47415);
    return IntlProvider;
}($Fo7oF.PureComponent);
var $ed965e05d58e6e5e$export$2e2bcd8739ae039 = $ed965e05d58e6e5e$var$IntlProvider;


var $5729c03844a6dc6a$exports = {};
$5729c03844a6dc6a$exports = JSON.parse('{"alerts":{"AN_ERROR_OCCURRED":"Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.","ANCHOR_TAB_STRING_NOT_FOUND":"Jeder Unterzeichner muss mindestens ein Dokument unterschreiben.","DUPLICATE_SIGNER_ERROR":"Doppelte Unterzeichner m\xfcssen dieselbe Unterzeichneroption haben.","DUPLICATE_EMAIL_MOBILE_SIGNER_ERROR":"Die E-Mail-Adressen und Telefonnummern der Teilnehmer m\xfcssen individuell sein und d\xfcrfen nicht miteinander \xfcbereinstimmen","EMAIL_AND_PHONE_MANDATORY":"Email und Mobilnummer sind f\xfcr alle Unterzeichner erforderlich","EXCLUDE_ALFA_CASE_STATUS_ERROR_MESSAGE":"F\xfcr dieses Angebot kann kein Umschlag erstellt werden, da das Angebot noch nicht in Finance Connect eingereicht wurde","GENERIC_ERROR":"Die Umschlagerstellung ist aufgrund eines unbekannten Fehlers fehlgeschlagen.","GUARANTOR_WARNING_MESSAGE":"Projekte mit B\xfcrgschaften sind nicht autorisiert f\xfcr E-sign","INVALID_EMAIL_ADDRESS_FOR_RECIPIENT":"Ung\xfcltige E-Mail-Adresse f\xfcr Unterzeichner angegeben.","MANDATORY_FIELD_FOR_SIGNER_ERROR":"Email und Mobilnummer sind f\xfcr alle Unterzeichner erforderlich","NO_ACCESS_TO_PROPOSAL_TRACKING_OR_ESIGN":"Sie haben keinen Zugriff auf die Module Proposal Tracking oder eSignature.","NO_DOCUMENT_SELECTED":"Bitte w\xe4hlen Sie mindestens ein Dokument aus.","NO_ENVELOPE_FOUND":"F\xfcr das Angebot wurde kein Umschlag gefunden.","NO_MODULE_ASSIGNED":"Kein Modul zugeordnet","NO_PROPOSALS_AVAILABLE_FOR_GIVEN_SEARCH_CRITERIA":"Keine Vorschl\xe4ge f\xfcr die angegebenen Suchkriterien verf\xfcgbar.","NO_PROPOSALS_AVAILABLE_FOR_GIVEN_SEARCH_CRITERIA_CLICK_CLEAR":"Keine Vorschl\xe4ge f\xfcr die angegebenen Suchkriterien verf\xfcgbar. Klicken Sie auf die Schaltfl\xe4che zur\xfccksetzen, um alle Datens\xe4tze anzuzeigen.","NO_RESULTS_FOUND":"Keine Ergebnisse gefunden","NO_SIGNED_DOCUMENTS_AVAILABLE":"F\xfcr diesen Umschlag sind keine Dokumente verf\xfcgbar.","NO_SIGNER_DOCUMENT_SELECTED_ACTION":"Bitte w\xe4hlen Sie mindestens ein Dokument und einen Unterzeichner aus, um einen Umschlag zu erstellen.","NO_SIGNER_OR_DOCUMENT_SELECTED":"Kein Unterzeichner/Dokument ausgew\xe4hlt","NO_SIGNER_SELECTED":"Bitte w\xe4hlen Sie mindestens einen Unterzeichner aus.","SEARCH_FOR_A_PROPOSAL_TO_CONTINUE":"Suchen Sie nach einem Angebot, um fortzufahren.","START_DATE_WARNING_MESSAGE":"Das Startdatum des Angebots liegt vor dem Datum der Unterzeichnung. Bitte \xfcberpr\xfcfen Sie die Daten und stellen Sie sicher, dass die Unterzeichnung vor oder am selben Datum wie das Startdatum des Angebots liegt.","INVALID_PRODUCT_WARNING":"Esign is not available for Leasing and Renting Product"},"docusignErrorMessages":{"ANCHOR_TAB_STRING_NOT_FOUND":"Der ausgew\xe4hlte Unterzeichner ist nicht berechtigt das ausgew\xe4hlte Dokument zu unterschreiben","INVALID_EMAIL_ADDRESS":"Ung\xfcltige E-Mail-Adresse","INVALID_EMAIL_ADDRESS_FOR_RECIPIENT":"Die E-Mail-Adresse des Empf\xe4ngers ist ung\xfcltig.","PHONE_NUMBER_INVALID":"Telefonnummer ist ung\xfcltig."},"labels":{"ACTION":"Aktion","ADD":"Hinzuf\xfcgen","ADD_NEW_SIGNER":"Unterzeichner hinzuf\xfcgen","ADD_NEXT":"Weitere hinzuf\xfcgen","ADD_SIGNER":"Zus\xe4tzlicher Unterzeichner","ADMIN_UTILITY":"Admin Utility","APPROVED":"Genehmigt","APPROVED_WITH_CONDITIONS":"Genehmigt mit Auflage","ASSOCIATE":"Unterzeichner","ASSOCIATED_PARTIES":"Unterzeichner","AUTO_APPROVED":"Automatische Genehmigung","AWAITING_FURTHER_INFORMATION_DOCUMENTS":"Zus\xe4tzlich Dokumente angefordert","BACK_TO_DASHBOARD":"Zur\xfcck zur \xdcbersicht","BULK_EREGISTRY_UTILITY":"Massendienstprogramm E-Registry","BUNDLE":"Projektnummer","CLEAR":"zur\xfccksetzen","CO-BORROWER":"Weiterer Darlehensnehmer","COMBINED":"Kombiniert","COMPLETED":"Beendet","CONTRACT_PAID_OFF":"Ausgezahlt","COUNTRY":"Land","CREATE_ENVELOPE":"Umschlag erstellen","CREATED":"Erstellt","CREATED_DATE":"Datum der Erstellung","CREDIT_DECISION_ROUTED_FOR_MANUAL_REVIEW":"In Bearbeitung","DEALER":"Vertriebspartner","DEALER_REFERENCE":"Vertriebspartnerreferenz","DEALERSHIP_NAME":"Vertriebspartner","DECLINED":"Abgelehnt","DECLINED_DATE":"Datum der Ablehnung","DECLINED_REASON":"Grund der Ablehnung","DELETED":"Gel\xf6scht","DELIVERED":"Geliefert","DOCUMENT_NAME":"Dokumentenname","DOCUMENTS":"Dokumente","DOCUMENTS_SELECTED":"ausgew\xe4hlte Dokumente","DOWNLOAD":"Herunterladen","E_SIGNATURE":"E-Signature","E_SIGNATURE_DASHBOARD":"E-Signature \xdcbersicht","EMAIL":"Email","ENVELOPE_ID":"Umschlag ID","ENVELOPE_REVIEW":"Umschlag pr\xfcfen","E-REGISTRY_DOWNLOAD":"E-Registrierung","EXAMPLE_PHONE_NUMBER":"Bsp. +49 123456789","EXPIRED":"Abgelaufene Genehmigung","FETCHING_DOCUMENTS_FOR":"Abrufen von Dokumenten f\xfcr","GERMANY":"Deutschland","GET_STATUS":"Status aktualisieren","GUARANTOR":"B\xfcrge","HI":"Hi","ICS_REFERENCE":"ICS ID","ISD_CODE_IS_REQUIRED":"ISD-Code ist erforderlich","JDF_SIGNER":"JDF-Unterzeichner","MATURITY_DATE":"F\xe4lligkeitstag","MERGER_AND_ACQUISITION":"Fusionen und \xdcbernahmen","MOBILE":"Mobilfunk-Nr.","NAME":"Name","NO_DECLINING_REASON_PROVIDED":"Kein Ablehnungsgrund angegeben","NOT_AVAILABLE":"Nicht verf\xfcgbar","NOT_SIGNED":"Nicht unterschrieben","NOT_VIEWED":"Nicht angesehen","OF":"von","ON_DEMAND":"Weiterer Unterzeichner","OPTION":"Option","OPTIONS":"Optionen","ORDER":"Reihenfolge","PRIMARY":"Kunde","PRIMARY_CUSTOMER":"Kunde","PROCESSING":"In Bearbeitung","PRODUCT":"Produkt","PROPOSAL":"Angebotsnummer","PROPOSAL_DETAILS":"Angebotsdetails","PROPOSAL_TRACKING":"Angebotsverfolgung","PROPOSED":"Vorgeschlagen","QUOTE":"Angebotsnummer","QUOTE_STATUS":"Angebotsstatus","REVIEW_MESSAGE_DETAILS_CANNOT_UPDATE":"c. Diese Details k\xf6nnen nicht aktualisiert werden, nachdem der Umschlag gesendet wurde.","REVIEW_MESSAGE_ISD_CODE":"b. Der Mobilfunk-Nr. muss f\xfcr alle Unterzeichner der L\xe4ndercode (ISD-Code) vorangestellt werden. Beispiel: +49 123456789","REVIEW_MESSAGE_OTP":"a. Jeder Unterzeichner wird \xfcber ein einmaliges Passwort authentifiziert, das an die unten angegebene Mobilfunk-Nr. gesendet wird.","ROLE":"Rolle","SALESPERSON":"Verkaufsberater","SAVE_&_ADD_NEXT_SIGNER":"Speichern und n\xe4chsten Unterzeichner hinzuf\xfcgen","SAVE_SIGNER":"Unterzeichner speichern","SEARCH":"Suche","SELECT_DOCUMENTS":"Auswahl Dokumente","SELECTED_DOCUMENTS":"versendete Dokumente","SEND_ENVELOPE":"Umschlag versenden","SENDING_ENVELOPE":"Umschlag wird versendet","SENT":"Versendet","SENT_/_VIEWED":"Versendet","SENT_DATE":"Versanddatum","SEPARATE":"Getrennt","SIGN_BY_EMAIL":"Sign by Email","SIGN_NOW":"Sign Now","SIGNED":"Unterzeichnet","SIGNED_DATE":"Unterschriftsdatum","SIGNER":"Unterzeichner","SIGNERS":"Unterzeichner","SIGNING_OPTION":"Optionen","SIGNING_ORDER":"Reihenfolge der Unterzeichner","SIGNING_ORDER_PREVIEW":"Reihenfolge der Unterzeichner","SIGNING_STATUS":"Umschlag Status","PORTUGAL":"Portugal","SPAIN":"Spanien","START_DATE":"Startdatum","STATUS":"Status","STATUS_DATE":"Status Datum","SUBMITTED":"Eingereicht","TEMPLATE":"Vorlage","UNDELIVERABLE":"Nicht zustellbar","UNITED_KINGDOM":"Vereinigtes K\xf6nigreich","UPDATING_STATUS":"Status aktualisieren","VIEWED":"Angesehen","VIEWED_DATE":"Bearbeitungsdatum","VOIDED":"Annulliert","WITHDRAWN":"Zur\xfcckgezogen","PRIMARY_QUOTE":"eingereichte Kalkulation","ENVELOPE_SENT_UNDER_PROCESS":"Umschlag wird versendet. Bitte warten Sie","ENVELOPE_SUCCESSFULLY_SENT":"Ihr Umschlag wurde erfolgreich versendet"},"messages":{"BUNDLE_NUMBER_NOT_FOUND":"Kein Ergebnis gefunden. Keine Angebote f\xfcr die Projekt-Nr. gefunden.","CREATE_ON_DEMAND_SIGNER_FOR_ASSOCIATE":"Bitte f\xfcgen Sie einen weiteren Unterzeichner hinzu","DOCUMENT_DOWNLOAD_FAILED":"Herunterladen der Dokumente fehlgeschlagen","ICS_NUMBER_NOT_FOUND":"Kein Ergebnis gefunden. Kein Angebot f\xfcr die ICS-Nr. gefunden.","INVALID_BUNDLE_NUMBER":"Die Projekt-Nr. ist ung\xfcltig. Bitte verwenden Sie eine g\xfcltige Nummer. ","INVALID_ICS_NUMBER":"Die ICS Nummer ist ung\xfcltig. Bitte verwenden Sie ein g\xfcltige Nummer.","INVALID_PRIMARY_CUSTOMER":"Der Kundenname ist ung\xfcltig. Bitte verwenden Sie einen g\xfcltigen Namen.","INVALID_QUOTE_NUMBER":"Die Angebots-Nr. ist ung\xfcltig. Bitte verwenden Sie eine g\xfcltige Nummer.","PRIMARY_CUSTOMER_NOT_FOUND":"Kein Ergebnis gefunden. Bitte \xfcberpr\xfcfen Sie Ihre Eingabe.","QUOTE_NUMBER_NOT_FOUND":"Kein Ergebnis gefunden. Die Angebots-Nr. stimmt nicht mit der Projekt-Nr. \xfcberein. "},"products":{"DPFR_24_MONTH_LOAN_STOCK_DE":"VP - Lager (24 Monate)","DPFR_LOAN_DE":"VP - Try&Buy/Mietpark","DPFR_LOAN_STOCK_DE":"VP - Lager","DPFR_NON_FULL_PAYOUT_LEASE_DE":"VP - Leasing Teilamortisation","DPFR_OPERATING_LEASE_DE":"VP - Operate Leasing","LOAN_DE":"Darlehen","NON_FULL_PAYOUT_LEASE_DE":"Leasing Teilamortisation","OPERATING_LEASE_DE":"Operate Leasing"}}');


var $547aae9e6801c25c$exports = {};
$547aae9e6801c25c$exports = JSON.parse("{\"alerts\":{\"AN_ERROR_OCCURRED\":\"An error occured. Please try again.\",\"ANCHOR_TAB_STRING_NOT_FOUND\":\"Each signer must be required to sign at least one document.\",\"DUPLICATE_SIGNER_ERROR\":\"Duplicate signers must have same signing option. \",\"DUPLICATE_EMAIL_MOBILE_SIGNER_ERROR\":\"The email addresses and telephone numbers of the participants must be individual and cannot coincide with each other\",\"EMAIL_AND_PHONE_MANDATORY\":\"Email and Mobile number are mandatory for all signers\",\"EXCLUDE_ALFA_CASE_STATUS_ERROR_MESSAGE\":\"Envelope can not be created for this quote as it is not submitted for credit\",\"GENERIC_ERROR\":\"Envelope creation failed due to unknown error.\",\"GUARANTOR_WARNING_MESSAGE\":\"Bundles including guarantors are not authorised for Esign\",\"INVALID_EMAIL_ADDRESS_FOR_RECIPIENT\":\"Invalid email address provided for signer(s).\",\"MANDATORY_FIELD_FOR_SIGNER_ERROR\":\"Email and Mobile number are mandatory for all signers.\",\"NO_ACCESS_TO_PROPOSAL_TRACKING_OR_ESIGN\":\"You do not have access to Proposal Tracking or eSignature modules.\",\"NO_DOCUMENT_SELECTED\":\"Please select at least one document.\",\"NO_ENVELOPE_FOUND\":\"No envelope found for the proposal.\",\"NO_MODULE_ASSIGNED\":\"No modules assigned\",\"NO_PROPOSALS_AVAILABLE_FOR_GIVEN_SEARCH_CRITERIA\":\"No proposals available for given search criteria\",\"NO_PROPOSALS_AVAILABLE_FOR_GIVEN_SEARCH_CRITERIA_CLICK_CLEAR\":\"No proposals available for given search criteria. Click on CLEAR button to view all records.\",\"NO_RESULTS_FOUND\":\"No Results Found\",\"NO_SIGNED_DOCUMENTS_AVAILABLE\":\"No documents available for this envelope.\",\"NO_SIGNER_DOCUMENT_SELECTED_ACTION\":\"Please select at least one document and one signer to create an envelope.\",\"NO_SIGNER_OR_DOCUMENT_SELECTED\":\"No Signer/Document Selected\",\"NO_SIGNER_SELECTED\":\"Please select at least one signer.\",\"SEARCH_FOR_A_PROPOSAL_TO_CONTINUE\":\"Search for a proposal to continue.\",\"START_DATE_WARNING_MESSAGE\":\"The start date of this contract happens before its signature, which voids it. Please verify the dates and ensure that of the signature comes prior to or the same date as the contract start date\"},\"docusignErrorMessages\":{\"ANCHOR_TAB_STRING_NOT_FOUND\":\"The specified Anchor Tab string was not found in the document.\",\"INVALID_EMAIL_ADDRESS\":\"Invalid Email Address\",\"INVALID_EMAIL_ADDRESS_FOR_RECIPIENT\":\"The email address for the recipient is invalid.\",\"PHONE_NUMBER_INVALID\":\"Phone number is not valid.\"},\"labels\":{\"ACTION\":\"Action\",\"ADD\":\"Add\",\"ADD_NEW_SIGNER\":\"Add New Signer\",\"ADD_NEXT\":\"Add Next\",\"ADD_SIGNER\":\"Add Signer\",\"ADMIN_UTILITY\":\"Admin Utility\",\"APPROVED\":\"Approved\",\"APPROVED_WITH_CONDITIONS\":\"Approved with conditions\",\"ASSOCIATE\":\"Associate\",\"ASSOCIATED_PARTIES\":\"Associated Parties\",\"AUTO_APPROVED\":\"Auto-Approved\",\"AWAITING_FURTHER_INFORMATION_DOCUMENTS\":\"Awaiting further Information/Documents\",\"BACK_TO_DASHBOARD\":\"Back to Dashboard\",\"BULK_EREGISTRY_UTILITY\":\"Bulk E-Registry Utility\",\"BUNDLE\":\"Bundle\",\"CLEAR\":\"Clear\",\"CO-BORROWER\":\"Co-Borrower\",\"COMBINED\":\"Combined\",\"COMPLETED\":\"Completed\",\"CONTRACT_PAID_OFF\":\"Contract paid off\",\"COUNTRY\":\"Country\",\"CREATE_ENVELOPE\":\"Create Envelope\",\"CREATED\":\"Created\",\"CREATED_DATE\":\"Created Date\",\"CREDIT_DECISION_ROUTED_FOR_MANUAL_REVIEW\":\"Credit Decision Routed For Manual Review\",\"DEALER\":\"Dealer\",\"DEALER_REFERENCE\":\"Dealer Reference\",\"DEALERSHIP_NAME\":\"Dealership Name\",\"DECLINED\":\"Declined\",\"DECLINED_DATE\":\"Declined Date\",\"DECLINED_REASON\":\"Declined Reason\",\"DELETED\":\"Deleted\",\"DELIVERED\":\"Delivered\",\"DOCUMENT_NAME\":\"Document Name\",\"DOCUMENTS\":\"Documents\",\"DOCUMENTS_SELECTED\":\"documents selected\",\"DOWNLOAD\":\"Download\",\"E_SIGNATURE\":\"E-Signature\",\"E_SIGNATURE_DASHBOARD\":\"E-Signature Dashboard\",\"EMAIL\":\"Email\",\"ENVELOPE_ID\":\"Envelope ID\",\"ENVELOPE_REVIEW\":\"Envelope Review\",\"E-REGISTRY_DOWNLOAD\":\"E-Registry\",\"EXAMPLE_PHONE_NUMBER\":\"Ex. +44 123456789\",\"EXPIRED\":\"Expired\",\"FETCHING_DOCUMENTS_FOR\":\"Fetching documents for\",\"GERMANY\":\"Germany\",\"GET_STATUS\":\"Get Status\",\"GUARANTOR\":\"Guarantor\",\"HI\":\"Hi\",\"ICS_REFERENCE\":\"ICS ID\",\"ISD_CODE_IS_REQUIRED\":\"ISD Code is required\",\"JDF_SIGNER\":\"JDF Signer\",\"MATURITY_DATE\":\"Maturity Date\",\"MERGER_AND_ACQUISITION\":\"Merger & Acquisition\",\"MOBILE\":\"Mobile\",\"NAME\":\"Name\",\"NO_DECLINING_REASON_PROVIDED\":\"No Declining Reason Provided\",\"NOT_AVAILABLE\":\"Not Available\",\"NOT_SIGNED\":\"Not Signed\",\"NOT_VIEWED\":\"Not Viewed\",\"OF\":\"of\",\"ON_DEMAND\":\"On Demand\",\"OPTION\":\"Option\",\"OPTIONS\":\"Options\",\"ORDER\":\"Order\",\"PRIMARY\":\"Primary\",\"PRIMARY_CUSTOMER\":\"Primary Customer\",\"PROCESSING\":\"Processing\",\"PRODUCT\":\"Product\",\"PROPOSAL\":\"Proposal\",\"PROPOSAL_DETAILS\":\"Proposal Details\",\"PROPOSAL_TRACKING\":\"Proposal Tracking\",\"PROPOSED\":\"Proposed\",\"QUOTE\":\"Quote\",\"QUOTE_STATUS\":\"Quote Status\",\"REVIEW_MESSAGE_DETAILS_CANNOT_UPDATE\":\"c. These details cannot be updated once Envelope is sent.\",\"REVIEW_MESSAGE_ISD_CODE\":\"b. Mobile number must be pre-fixed with country code (ISD Code) for all signers. Example: +34 123456789\",\"REVIEW_MESSAGE_OTP\":\"a. Each signer will be authenticated via One Time Password (OTP) sent on Mobile number provided below.\",\"ROLE\":\"Role\",\"SALESPERSON\":\"Salesperson\",\"SAVE_&_ADD_NEXT_SIGNER\":\"Save & Add Next Signer\",\"SAVE_SIGNER\":\"Save Signer\",\"SEARCH\":\"Search\",\"SELECT_DOCUMENTS\":\"Select Documents\",\"SELECTED_DOCUMENTS\":\"Sent Documents\",\"SELECT_THIRD_PARTY\":\"Select Third Party\",\"SEND_ENVELOPE\":\"Send Envelope\",\"SENDING_ENVELOPE\":\"Sending Envelope\",\"SENT\":\"Sent\",\"SENT_/_VIEWED\":\"Sent / Viewed\",\"SENT_DATE\":\"Sent Date\",\"SEPARATE\":\"Separate\",\"SIGN_BY_EMAIL\":\"Sign by Email\",\"SIGN_NOW\":\"Sign Now\",\"SIGNED\":\"Signed\",\"SIGNED_DATE\":\"Signed Date\",\"SIGNER\":\"Signer\",\"SIGNERS\":\"Signers\",\"SIGNING_OPTION\":\"Signing Option\",\"SIGNING_ORDER\":\"Signing Order\",\"SIGNING_ORDER_PREVIEW\":\"Signing Order Preview\",\"SIGNING_STATUS\":\"Signing Status\",\"PORTUGAL\":\"Portugal\",\"SPAIN\":\"Spain\",\"START_DATE\":\"Start Date\",\"STATUS\":\"Status\",\"STATUS_DATE\":\"Status Date\",\"SUBMITTED\":\"Submitted\",\"TEMPLATE\":\"Template\",\"THIRD_PARTY\":\"Third Party\",\"UNDELIVERABLE\":\"Undeliverable\",\"UNITED_KINGDOM\":\"United Kingdom\",\"UPDATING_STATUS\":\"Updating Status\",\"VIEWED\":\"Viewed\",\"VIEWED_DATE\":\"Viewed Date\",\"VOIDED\":\"Voided\",\"WITHDRAWN\":\"Withdrawn\",\"PRIMARY_QUOTE\":\"Primary Quote\",\"ENVELOPE_SENT_UNDER_PROCESS\":\"Envelope is being sent. Please wait till the process completes\",\"ENVELOPE_SUCCESSFULLY_SENT\":\"Your envelope has been successfully sent\",\"ADD_PROXY\":\"Add Proxy\",\"PROXY\":\"Proxy\",\"you can only assign\":\"you can only assign\",\"representatives to the\":\"representatives to the\",\"ADD_NEW_PROXY\":\"Add New Proxy\"},\"messages\":{\"BUNDLE_NUMBER_NOT_FOUND\":\"No results found since no quotes found for the given bundle number.\",\"CREATE_ON_DEMAND_SIGNER_FOR_ASSOCIATE\":\"Please create this signer as an on-demand signer\",\"DOCUMENT_DOWNLOAD_FAILED\":\"Document Download from S3 failed\",\"ICS_NUMBER_NOT_FOUND\":\"No results found since no quotes found for the given ICS reference number.\",\"INVALID_BUNDLE_NUMBER\":\"Bundle Number provided is invalid. Please provide a valid bundle number and retry.\",\"INVALID_ICS_NUMBER\":\"ICS reference provided is invalid. Please provide a valid ICS reference number and retry.\",\"INVALID_PRIMARY_CUSTOMER\":\"Primary Customer's name provided is invalid. Please provide a valid name and retry.\",\"INVALID_QUOTE_NUMBER\":\"Quote Number provided is invalid. Please provide a valid quote number and retry.\",\"PRIMARY_CUSTOMER_NOT_FOUND\":\"No results found since given primary customer does not exist in the system.\",\"QUOTE_NUMBER_NOT_FOUND\":\"No results found since given Bundle Number and given Quote Number do not correspond to a common bundle.\"},\"products\":{\"DPFR_24_MONTH_LOAN_STOCK_DE\":\"DPFR - 24 month Loan Stock DE\",\"DPFR_LOAN_DE\":\"DPFR - Loan DE\",\"DPFR_LOAN_STOCK_DE\":\"DPFR - Loan Stock DE\",\"DPFR_NON_FULL_PAYOUT_LEASE_DE\":\"DPFR - Non Full Payout Lease DE\",\"DPFR_OPERATING_LEASE_DE\":\"Operating Lease DE\",\"LOAN_DE\":\"Loan DE\",\"NON_FULL_PAYOUT_LEASE_DE\":\"Non Full Payout Lease DE\",\"OPERATING_LEASE_DE\":\"Operating Lease DE\"}}");


var $44ea08415c9010a0$exports = {};
$44ea08415c9010a0$exports = JSON.parse('{"alerts":{"AN_ERROR_OCCURRED":"Se ha poducido un error. Por favor, int\xe9ntelo de nuevo.","ANCHOR_TAB_STRING_NOT_FOUND":"Cada firmante debe firmar al menos un documento.","DUPLICATE_SIGNER_ERROR":"Los firmantes duplicados deben tener la misma opci\xf3n de firma.","DUPLICATE_EMAIL_MOBILE_SIGNER_ERROR":"Email y tel\xe9fono de cada interviniente debe ser \xfanico y no puede repetirse, excepto para CB/SC o firma por poder. En ese caso por favor marque esta casilla","DUPLICATE_EMAIL_MOBILE_SIGNER_LEGAL_COMPLIANCE":"Al marcar la casilla para casos de CB/Sc o firma por poder usted confirma que no se trata de una suplantaci\xf3n de identidad por parte de ning\xfan interviniente, con las implicaciones legales correspondientes","EMAIL_AND_PHONE_MANDATORY":"Todos los firmantes deben tener una direcci\xf3n de correo electr\xf3nico y un n\xfamero de tel\xe9fono m\xf3vil","EXCLUDE_ALFA_CASE_STATUS_ERROR_MESSAGE":"No se puede crear un sobre para esta propuesta porque no se ha enviado a cr\xe9dito","GENERIC_ERROR":"La creaci\xf3n del sobre fall\xf3 debido a un error desconocido.","GUARANTOR_WARNING_MESSAGE":"Los paquetes que incluyen garantes no est\xe1n autorizados para Dise\xf1o","INVALID_EMAIL_ADDRESS_FOR_RECIPIENT":"Direcci\xf3n de correo electr\xf3nico proporcionada para el/los firmante/s no es v\xe1lida","MANDATORY_FIELD_FOR_SIGNER_ERROR":"Todos los firmantes deben tener una direcci\xf3n de correo electr\xf3nico y un n\xfamero de tel\xe9fono m\xf3vil","NO_ACCESS_TO_PROPOSAL_TRACKING_OR_ESIGN":"Su usuario no tiene acceso a los m\xf3dulos Seguimiento de propuestas o Firma electr\xf3nica.","NO_DOCUMENT_SELECTED":"Seleccione al menos un documento.","NO_ENVELOPE_FOUND":"No se ha encontrado ning\xfan sobre para la propuesta.","NO_MODULE_ASSIGNED":"Ning\xfan m\xf3dulo asignado","NO_PROPOSALS_AVAILABLE_FOR_GIVEN_SEARCH_CRITERIA":"No hay propuestas disponibles para los criterios de b\xfasqueda dados.","NO_PROPOSALS_AVAILABLE_FOR_GIVEN_SEARCH_CRITERIA_CLICK_CLEAR":"No hay propuestas disponibles para los criterios de b\xfasqueda dados. Haga clic en el bot\xf3n BORRAR para ver todos los registros.","NO_RESULTS_FOUND":"No se han encontrado resultados","NO_SIGNED_DOCUMENTS_AVAILABLE":"No hay documentos disponibles para este sobre.","NO_SIGNER_DOCUMENT_SELECTED_ACTION":"Por favor, seleccione al menos un documento y un firmante para crear un sobre.","NO_SIGNER_OR_DOCUMENT_SELECTED":"Ning\xfan firmante/documento seleccionado","NO_SIGNER_SELECTED":"Por favor seleccione al menos un firmante.","SEARCH_FOR_A_PROPOSAL_TO_CONTINUE":"Busque una propuesta para continuar.","START_DATE_WARNING_MESSAGE":"La fecha de inicio de este contrato es anterior a su firma, lo que lo dejar\xeda sin efecto. Verifique la fecha y aseg\xfarese de que la firma sea anterior o la misma que la fecha de inicio del contrato.","INVALID_PRODUCT_WARNING":"Esign no est\xe1 disponible para arrendamiento y alquiler de productos"},"docusignErrorMessages":{"ANCHOR_TAB_STRING_NOT_FOUND":"El punto de firma no se encontr\xf3 en el documento","INVALID_EMAIL_ADDRESS":"Direcci\xf3n de correo electr\xf3nico no v\xe1lida","INVALID_EMAIL_ADDRESS_FOR_RECIPIENT":"La direcci\xf3n de correo electr\xf3nico del destinatario no es v\xe1lida.","PHONE_NUMBER_INVALID":"El n\xfamero de tel\xe9fono no es v\xe1lido."},"labels":{"ACTION":"Accion","ADD":"A\xf1adir","ADD_NEW_SIGNER":"A\xf1adir nuevo firmante","ADD_NEXT":"A\xf1adir siguiente","ADD_SIGNER":"A\xf1adir firmante","ADMIN_UTILITY":"Admin Utility","APPROVED":"Aprobado","APPROVED_WITH_CONDITIONS":"Aprobado con condiciones","ASSOCIATE":"Comprador","ASSOCIATED_PARTIES":"Compradores","AUTO_APPROVED":"Aprobado autom\xe1ticamente","AWAITING_FURTHER_INFORMATION_DOCUMENTS":"En espera de documentaci\xf3n","BACK_TO_DASHBOARD":"Volver al inicio","BULK_EREGISTRY_UTILITY":"Utilidad E-Registry masiva","BUNDLE":"Presupuesto","CLEAR":"Borrar","CO-BORROWER":"Segundo Comprador","COMBINED":"Conjunto","COMPLETED":"Completado","CONTRACT_PAID_OFF":"Contrato pagado","COUNTRY":"Pa\xeds","CREATE_ENVELOPE":"Crear Sobre","CREATED":"Creado","CREATED_DATE":"Fecha de creacion","CREDIT_DECISION_ROUTED_FOR_MANUAL_REVIEW":"Propuesta enviada a revisi\xf3n manual","DEALER":"Concesi\xf3n","DEALER_REFERENCE":"Referencia del concesionario","DEALERSHIP_NAME":"Concesionario","DECLINED":"Denegado","DECLINED_DATE":"Fecha de denegaci\xf3ns","DECLINED_REASON":"Motivo de la denegaci\xf3n","DELETED":"Eliminado","DELIVERED":"Entregado","DOCUMENT_NAME":"Nombre del documento","DOCUMENTS":"Documentos","DOCUMENTS_SELECTED":"documentos seleccionados","DOWNLOAD":"Descargar","E_SIGNATURE":"Firma Digital","E_SIGNATURE_DASHBOARD":"Firma Digital - Pantalla de Inicio","EMAIL":"Email","ENVELOPE_ID":"N\xfamero de identificaci\xf3n del sobre","ENVELOPE_REVIEW":"Revision del Sobre","E-REGISTRY_DOWNLOAD":"Registro","EXAMPLE_PHONE_NUMBER":"Ex. +34 123456789","EXPIRED":"Caducado","FETCHING_DOCUMENTS_FOR":"Obtenci\xf3n de documentos para","GERMANY":"Alemania","GET_STATUS":"Actualizar estado","GUARANTOR":"Avalista","HI":"Hola","ICS_REFERENCE":"Numero de contrato","ISD_CODE_IS_REQUIRED":"Se requiere prefijo de pa\xeds","JDF_SIGNER":"Firmante JDF","MATURITY_DATE":"Fecha de vencimiento","MERGER_AND_ACQUISITION":"Fusiones y Adquisiciones","MOBILE":"M\xf3vil","NAME":"Nombre","NO_DECLINING_REASON_PROVIDED":"No se proporcion\xf3 el motivo de la denegaci\xf3n","NOT_AVAILABLE":"No disponible","NOT_SIGNED":"No firmado","NOT_VIEWED":"No visto","OF":"de","ON_DEMAND":"Bajo demanda","OPTION":"Opci\xf3n","OPTIONS":"Opciones","ORDER":"Posicion","PRIMARY":"Comprador","PRIMARY_CUSTOMER":"Nombre del Cliente","PROCESSING":"Procesando","PRODUCT":"Producto","PROPOSAL":"Propuesta","PROPOSAL_DETAILS":"Detalles de la propuesta","PROPOSAL_TRACKING":"Seguimiento de propuestas","PROPOSED":"Propuesto","QUOTE":"Estructura Financiera","QUOTE_STATUS":"Estado","REVIEW_MESSAGE_DETAILS_CANNOT_UPDATE":"c. Estos detalles no se pueden actualizar una vez que se env\xeda el sobre.","REVIEW_MESSAGE_ISD_CODE":"b. El n\xfamero de m\xf3vil debe inlcuir el prefijo de pa\xeds para todos los firmantes. Ejemplo: +34 123456789","REVIEW_MESSAGE_OTP":"a. Cada firmante se autenticar\xe1 a trav\xe9s de una contrase\xf1a de un solo uso (OTP) enviada al n\xfamero de m\xf3vil que se proporciona a continuaci\xf3n.","ROLE":"Posici\xf3n","SALESPERSON":"Vendedor","SAVE_&_ADD_NEXT_SIGNER":"Guardar y agregar el siguiente firmante","SAVE_SIGNER":"Guardar firmante","SEARCH":"Buscar","SELECT_DOCUMENTS":"Selecci\xf3n de documentos","SELECTED_DOCUMENTS":"Documentos en el sobre","SELECT_THIRD_PARTY":"Seleccionar tercero","SEND_ENVELOPE":"Enviar sobre","SENDING_ENVELOPE":"Enviando sobre","SENT":"Enviado","SENT_/_VIEWED":"Enviado / Visto","SENT_DATE":"Fecha de Env\xedo","SEPARATE":"Separado","SIGN_BY_EMAIL":"Firmar por correo electr\xf3nico","SIGN_NOW":"Firmar ahora","SIGNED":"Firmado","SIGNED_DATE":"Fecha de Firma","SIGNER":"Firmante","SIGNERS":"Firmantes","SIGNING_OPTION":"Opci\xf3n de firma","SIGNING_ORDER":"Orden de firma","SIGNING_ORDER_PREVIEW":"Vista previa del orden de firma","SIGNING_STATUS":"Estado de firma","PORTUGAL":"Portugal","SPAIN":"Espa\xf1a","START_DATE":"Fecha de Inicio","STATUS":"Estado","STATUS_DATE":"Fecha de estado","SUBMITTED":"Presentada","TEMPLATE":"Modelo","THIRD_PARTY":"Tercero","UNDELIVERABLE":"Sin enviar","UNITED_KINGDOM":"Reino Unido","UPDATING_STATUS":"Actualizando Estado","VIEWED":"Visto","VIEWED_DATE":"Fecha de vista","VOIDED":"Anulado","WITHDRAWN":"Retirado","PRIMARY_QUOTE":"Propuesta procesada","ENVELOPE_SENT_UNDER_PROCESS":"El sobre ha sido enviado. Por favor espere a que el proceso se complete","ENVELOPE_SUCCESSFULLY_SENT":"El sobre ha sido enviado correctamente","ADD_PROXY":"A\xf1adir representante","PROXY":"representantes","ADD_NEW_PROXY":"A\xf1adir nuevo representante","you can only assign":"S\xf3lo puede asignar","representatives to the":"representantes como m\xe1ximo a la"},"messages":{"BUNDLE_NUMBER_NOT_FOUND":"No se encontr\xf3 ning\xfan resultado porque no hay estructuras financieras asociadas a este n\xfamero de presupuesto.","CREATE_ON_DEMAND_SIGNER_FOR_ASSOCIATE":"por favor, cree este firmante como un firmante bajo demanda","DOCUMENT_DOWNLOAD_FAILED":"La descarga del documento desde S3 fall\xf3.","ICS_NUMBER_NOT_FOUND":"No se encontr\xf3 ning\xfan resultado porque no hay estructuras financieras asociadas a este n\xfamero de contrato.","INVALID_BUNDLE_NUMBER":"El n\xfamero de presupuesto introducido no es v\xe1lido. Por favor, introduzca uno v\xe1lido y vuelva a internarlo.","INVALID_ICS_NUMBER":"El n\xfamero de contrato proporcionado no es v\xe1lido. Por favor, introduzca uno v\xe1lido y vuelva a internarlo.","INVALID_PRIMARY_CUSTOMER":"El nombre del cliente proporcionado no es v\xe1lido. Por favor, introduzca uno v\xe1lido y vuelva a internarlo.","INVALID_QUOTE_NUMBER":"El n\xfamero de estructura financiera introducido no es v\xe1lido. Por favor, introduzca uno v\xe1lido y vuelva a internarlo.","PRIMARY_CUSTOMER_NOT_FOUND":"No se encontr\xf3 ning\xfan resultado porque el cliente no existe en el sistema.","QUOTE_NUMBER_NOT_FOUND":"No se encontr\xf3 ning\xfan resultado porque el n\xfamero de presupuesto y el de la estructura financiera no est\xe1n relacionados."},"products":{"DPFR_24_MONTH_LOAN_STOCK_DE":"DPFR - 24 month Loan Stock DE","DPFR_LOAN_DE":"DPFR - Loan DE","DPFR_LOAN_STOCK_DE":"DPFR - Loan Stock DE","DPFR_NON_FULL_PAYOUT_LEASE_DE":"DPFR - Non Full Payout Lease DE","DPFR_OPERATING_LEASE_DE":"Operating Lease DE","LOAN_DE":"Loan DE","NON_FULL_PAYOUT_LEASE_DE":"Non Full Payout Lease DE","OPERATING_LEASE_DE":"Operating Lease DE"}}');


var $4f9aeb458f23dd24$exports = {};
$4f9aeb458f23dd24$exports = JSON.parse('{"alerts":{"AN_ERROR_OCCURRED":"Ocorreu um erro. Por favor, tente novamente.","ANCHOR_TAB_STRING_NOT_FOUND":"Cada signat\xe1rio deve assinar pelo menos um documento.","DUPLICATE_SIGNER_ERROR":"Os signat\xe1rios duplicados devem ter a mesma op\xe7\xe3o de assinatura.","DUPLICATE_EMAIL_MOBILE_SIGNER_ERROR":"O e-mail e o telem\xf3vel de cada interveniente devem ser \xfanicos e n\xe3o podem repetir-se, exceto para CB/SC ou assinatura por procura\xe7\xe3o. Nesse caso, por favor, marque esta caixa.","DUPLICATE_EMAIL_MOBILE_SIGNER_LEGAL_COMPLIANCE":"Ao marcar a caixa para casos de CB/SC ou assinatura por procura\xe7\xe3o, confirma que n\xe3o se trata de uma usurpa\xe7\xe3o de identidade por parte de qualquer interveniente, com as implica\xe7\xf5es legais correspondentes.","EMAIL_AND_PHONE_MANDATORY":"Todos os signat\xe1rios devem ter um endere\xe7o de e-mail e um n\xfamero de telem\xf3vel.","EXCLUDE_ALFA_CASE_STATUS_ERROR_MESSAGE":"N\xe3o \xe9 poss\xedvel criar um envelope para esta proposta porque n\xe3o foi enviada para cr\xe9dito.","GENERIC_ERROR":"A cria\xe7\xe3o do envelope falhou devido a um erro desconhecido.","GUARANTOR_WARNING_MESSAGE":"Os pacotes que incluem garantes n\xe3o est\xe3o autorizados para Dise\xf1o.","INVALID_EMAIL_ADDRESS_FOR_RECIPIENT":"O endere\xe7o de e-mail fornecido para o(s) signat\xe1rio(s) n\xe3o \xe9 v\xe1lido.","MANDATORY_FIELD_FOR_SIGNER_ERROR":"Todos os signat\xe1rios devem ter um endere\xe7o de e-mail e um n\xfamero de telem\xf3vel.","NO_ACCESS_TO_PROPOSAL_TRACKING_OR_ESIGN":"O seu utilizador n\xe3o tem acesso aos m\xf3dulos Gest\xe3o de Propostas ou Assinatura Eletr\xf3nica.","NO_DOCUMENT_SELECTED":"Selecione pelo menos um documento.","NO_ENVELOPE_FOUND":"N\xe3o foi encontrado nenhum envelope para a proposta.","NO_MODULE_ASSIGNED":"Nenhum m\xf3dulo atribu\xeddo","NO_PROPOSALS_AVAILABLE_FOR_GIVEN_SEARCH_CRITERIA":"N\xe3o h\xe1 propostas dispon\xedveis para os crit\xe9rios de pesquisa indicados.","NO_PROPOSALS_AVAILABLE_FOR_GIVEN_SEARCH_CRITERIA_CLICK_CLEAR":"N\xe3o h\xe1 propostas dispon\xedveis para os crit\xe9rios de pesquisa indicados. Clique no bot\xe3o LIMPAR para ver todos os registos.","NO_RESULTS_FOUND":"N\xe3o foram encontrados resultados.","NO_SIGNED_DOCUMENTS_AVAILABLE":"N\xe3o h\xe1 documentos dispon\xedveis para este envelope.","NO_SIGNER_DOCUMENT_SELECTED_ACTION":"Por favor, selecione pelo menos um documento e um signat\xe1rio para criar um envelope.","NO_SIGNER_OR_DOCUMENT_SELECTED":"Nenhum signat\xe1rio/documento selecionado","NO_SIGNER_SELECTED":"Por favor, selecione pelo menos um signat\xe1rio.","SEARCH_FOR_A_PROPOSAL_TO_CONTINUE":"Pesquise uma proposta para continuar.","START_DATE_WARNING_MESSAGE":"A data de in\xedcio deste contrato \xe9 anterior \xe0 sua assinatura, o que o tornaria sem efeito. Verifique a data e certifique-se de que a assinatura \xe9 anterior ou igual \xe0 data de in\xedcio do contrato.","INVALID_PRODUCT_WARNING":"A assinatura eletr\xf3nica n\xe3o est\xe1 dispon\xedvel para arrendamento e aluguer de produtos."},"docusignErrorMessages":{"ANCHOR_TAB_STRING_NOT_FOUND":"O ponto de assinatura n\xe3o foi encontrado no documento.","INVALID_EMAIL_ADDRESS":"Endere\xe7o de e-mail inv\xe1lido.","INVALID_EMAIL_ADDRESS_FOR_RECIPIENT":"O endere\xe7o de e-mail do destinat\xe1rio n\xe3o \xe9 v\xe1lido.","PHONE_NUMBER_INVALID":"O n\xfamero de telefone n\xe3o \xe9 v\xe1lido."},"labels":{"ACTION":"A\xe7\xe3o","ADD":"Adicionar","ADD_NEW_SIGNER":"Adicionar novo signat\xe1rio","ADD_NEXT":"Adicionar seguinte","ADD_SIGNER":"Adicionar signat\xe1rio","ADMIN_UTILITY":"Admin Utility","APPROVED":"Aprovado","APPROVED_WITH_CONDITIONS":"Aprovada com condi\xe7\xf5es","ASSOCIATE":"Cliente","ASSOCIATED_PARTIES":"Cliente","AUTO_APPROVED":"Aprovada automaticamente","AWAITING_FURTHER_INFORMATION_DOCUMENTS":"Documenta\xe7\xe3o pendente","BACK_TO_DASHBOARD":"Voltar ao in\xedcio","BULK_EREGISTRY_UTILITY":"Processamento massivo de E-Registo","BUNDLE":"Proposta","CLEAR":"Limpar","CO-BORROWER":"Segundo Cliente","COMBINED":"Conjunto","COMPLETED":"Conclu\xeddo","CONTRACT_PAID_OFF":"Contrato pago","COUNTRY":"Pa\xeds","CREATE_ENVELOPE":"Criar Envelope","CREATED":"Criado","CREATED_DATE":"Data de cria\xe7\xe3o","CREDIT_DECISION_ROUTED_FOR_MANUAL_REVIEW":"Proposta enviada para revis\xe3o manual","DEALER":"Fornecedor","DEALER_REFERENCE":"Refer\xeancia do fornecedor","DEALERSHIP_NAME":"Fornecedor","DECLINED":"Recusado","DECLINED_DATE":"Data de recusa","DECLINED_REASON":"Motivo da recusa","DELETED":"Eliminado","DELIVERED":"Entregue","DOCUMENT_NAME":"Nome do documento","DOCUMENTS":"Documentos","DOCUMENTS_SELECTED":"Documentos selecionados","DOWNLOAD":"Descarregar","E_SIGNATURE":"Assinatura Digital","E_SIGNATURE_DASHBOARD":"Assinatura Digital - P\xe1gina Inicial","EMAIL":"E-mail","ENVELOPE_ID":"N\xfamero de Identifica\xe7\xe3o do envelope","ENVELOPE_REVIEW":"Revis\xe3o do Envelope","E-REGISTRY_DOWNLOAD":"Registo","EXAMPLE_PHONE_NUMBER":"Ex. +351 123456789","EXPIRED":"Expirado","FETCHING_DOCUMENTS_FOR":"A obter documentos para","GERMANY":"Alemanha","GET_STATUS":"Atualizar estado","GUARANTOR":"Garante","HI":"Ol\xe1","ICS_REFERENCE":"N\xfamero de contrato","ISD_CODE_IS_REQUIRED":"O prefixo do pa\xeds \xe9 obrigat\xf3rio","JDF_SIGNER":"Signat\xe1rio JDF","MATURITY_DATE":"Data de vencimento","MERGER_AND_ACQUISITION":"Fus\xf5es e Aquisi\xe7\xf5es","MOBILE":"Telem\xf3vel","NAME":"Nome","NO_DECLINING_REASON_PROVIDED":"N\xe3o foi fornecido o motivo da recusa","NOT_AVAILABLE":"N\xe3o dispon\xedvel","NOT_SIGNED":"N\xe3o assinado","NOT_VIEWED":"N\xe3o visualizado","OF":"de","ON_DEMAND":"A pedido","OPTION":"Op\xe7\xe3o","OPTIONS":"Op\xe7\xf5es","ORDER":"Ordem","PRIMARY":"Cliente","PRIMARY_CUSTOMER":"Nome do Cliente","PROCESSING":"Em processamento","PRODUCT":"Produto","PROPOSAL":"Proposta","PROPOSAL_DETAILS":"Detalhes da proposta","PROPOSAL_TRACKING":"Gest\xe3o de Propostas","PROPOSED":"Proposto","QUOTE":"Estrutura Financeira","QUOTE_STATUS":"Estado","REVIEW_MESSAGE_DETAILS_CANNOT_UPDATE":"c. Estes dados n\xe3o podem ser atualizados depois de o envelope ser enviado.","REVIEW_MESSAGE_ISD_CODE":"b. O n\xfamero de telem\xf3vel deve incluir o prefixo do pa\xeds para todos os signat\xe1rios. Exemplo: +351 123456789","REVIEW_MESSAGE_OTP":"a. Cada signat\xe1rio ser\xe1 autenticado atrav\xe9s de uma palavra-passe de utiliza\xe7\xe3o \xfanica (OTP) enviada para o n\xfamero de telem\xf3vel indicado abaixo.","ROLE":"Ordem","SALESPERSON":"Vendedor","SAVE_&_ADD_NEXT_SIGNER":"Guardar e adicionar o signat\xe1rio seguinte","SAVE_SIGNER":"Guardar signat\xe1rio","SEARCH":"Pesquisar","SELECT_DOCUMENTS":"Sele\xe7\xe3o de documentos","SELECTED_DOCUMENTS":"Documentos no envelope","SELECT_THIRD_PARTY":"Selecionar Interveniente associado","SEND_ENVELOPE":"Enviar envelope","SENDING_ENVELOPE":"A enviar envelope","SENT":"Enviado","SENT_/_VIEWED":"Enviado / Visualizado","SENT_DATE":"Data de envio","SEPARATE":"Separado","SIGN_BY_EMAIL":"Assinar por e-mail","SIGN_NOW":"Assinar agora","SIGNED":"Assinado","SIGNED_DATE":"Data de assinatura","SIGNER":"Signat\xe1rio","SIGNERS":"Signat\xe1rios","SIGNING_OPTION":"Op\xe7\xe3o de assinatura","SIGNING_ORDER":"Ordem de assinatura","SIGNING_ORDER_PREVIEW":"Pr\xe9-visualiza\xe7\xe3o da ordem de assinatura","SIGNING_STATUS":"Estado da assinatura","PORTUGAL":"Portugal","SPAIN":"Espanha","START_DATE":"Data de In\xedcio","STATUS":"Estado","STATUS_DATE":"Data de estado","SUBMITTED":"Submetido","TEMPLATE":"Modelo","THIRD_PARTY":"Interveniente associado","UNDELIVERABLE":"N\xe3o entregue","UNITED_KINGDOM":"Reino Unido","UPDATING_STATUS":"A atualizar estado","VIEWED":"Visualizado","VIEWED_DATE":"Data de visualiza\xe7\xe3o","VOIDED":"Anulado","WITHDRAWN":"Retirado","PRIMARY_QUOTE":"Proposta processada","ENVELOPE_SENT_UNDER_PROCESS":"O envelope foi enviado. Por favor, aguarde at\xe9 que o processo seja conclu\xeddo.","ENVELOPE_SUCCESSFULLY_SENT":"O envelope foi enviado com sucesso","ADD_PROXY":"Adicionar representante legal","PROXY":"Representantes legais","ADD_NEW_PROXY":"Adicionar novo representante LEGAL","you can only assign":"S\xf3 pode atribuir","representatives to the":"representantes no m\xe1ximo \xe0"},"messages":{"BUNDLE_NUMBER_NOT_FOUND":"N\xe3o foi encontrado nenhum resultado porque n\xe3o existem estruturas financeiras associadas a este n\xfamero de proposta.","CREATE_ON_DEMAND_SIGNER_FOR_ASSOCIATE":"Por favor, crie este signat\xe1rio como um signat\xe1rio a pedido.","DOCUMENT_DOWNLOAD_FAILED":"A transfer\xeancia do documento a partir do S3 falhou.","ICS_NUMBER_NOT_FOUND":"N\xe3o foi encontrado nenhum resultado porque n\xe3o existem estruturas financeiras associadas a este n\xfamero de contrato.","INVALID_BUNDLE_NUMBER":"O n\xfamero de proposta introduzido n\xe3o \xe9 v\xe1lido. Por favor, introduza um v\xe1lido e tente novamente.","INVALID_ICS_NUMBER":"O n\xfamero de contrato fornecido n\xe3o \xe9 v\xe1lido. Por favor, introduza um v\xe1lido e tente novamente.","INVALID_PRIMARY_CUSTOMER":"O nome do cliente fornecido n\xe3o \xe9 v\xe1lido. Por favor, introduza um v\xe1lido e tente novamente.","INVALID_QUOTE_NUMBER":"O n\xfamero de estrutura financeira introduzido n\xe3o \xe9 v\xe1lido. Por favor, introduza um v\xe1lido e tente novamente.","PRIMARY_CUSTOMER_NOT_FOUND":"N\xe3o foi encontrado nenhum resultado porque o cliente n\xe3o existe no sistema.","QUOTE_NUMBER_NOT_FOUND":"N\xe3o foi encontrado nenhum resultado porque o n\xfamero da proposta e o da estrutura financeira n\xe3o est\xe3o relacionados."},"products":{"DPFR_24_MONTH_LOAN_STOCK_DE":"DPFR - 24 month Loan Stock DE","DPFR_LOAN_DE":"DPFR - Loan DE","DPFR_LOAN_STOCK_DE":"DPFR - Loan Stock DE","DPFR_NON_FULL_PAYOUT_LEASE_DE":"DPFR - Non Full Payout Lease DE","DPFR_OPERATING_LEASE_DE":"Operating Lease DE","LOAN_DE":"Loan DE","NON_FULL_PAYOUT_LEASE_DE":"Non Full Payout Lease DE","OPERATING_LEASE_DE":"Operating Lease DE"}}');


const $10870254ed2b7706$var$flattenObj = (translations)=>{
    const result = {};
    for(const translationsKey in translations)if (typeof translations[translationsKey] === 'object' && !Array.isArray(translations[translationsKey])) {
        const nextedTranslations = $10870254ed2b7706$var$flattenObj(translations[translationsKey]);
        for(const key in nextedTranslations)result[translationsKey + '.' + key] = nextedTranslations[key];
    } else result[translationsKey] = translations[translationsKey];
    return result;
};
const $10870254ed2b7706$export$defe85febe8b728c = {
    'de_DE': $10870254ed2b7706$var$flattenObj((0, (/*@__PURE__*/$parcel$interopDefault($5729c03844a6dc6a$exports)))),
    'en_GB': $10870254ed2b7706$var$flattenObj((0, (/*@__PURE__*/$parcel$interopDefault($547aae9e6801c25c$exports)))),
    'es_ES': $10870254ed2b7706$var$flattenObj((0, (/*@__PURE__*/$parcel$interopDefault($44ea08415c9010a0$exports)))),
    'pt_PT': $10870254ed2b7706$var$flattenObj((0, (/*@__PURE__*/$parcel$interopDefault($4f9aeb458f23dd24$exports))))
};



var $d2bgE = parcelRequire("d2bgE");

const $85ff2091aa0ceb09$export$ef65e7c7fb2941e0 = ({ branchCode: branchCode, children: children })=>{
    const locale = branchCode && branchCode.slice(0, 2);
    const countryCode = locale && (0, $fff13ca3fea305fa$export$33186d4108d76629)[locale].locale;
    return branchCode ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $ed965e05d58e6e5e$export$2e2bcd8739ae039), {
        locale: locale,
        messages: (0, $10870254ed2b7706$export$defe85febe8b728c)[countryCode],
        children: children
    }) : null;
};
$85ff2091aa0ceb09$export$ef65e7c7fb2941e0.propTypes = {
    branchCode: $d2bgE.string,
    children: $d2bgE.node.isRequired
};



var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");




var $d2bgE = parcelRequire("d2bgE");

const $8ffbcbb17dd5e3f0$var$TranslateTab = ({ translateToEnglishSwitchHandler: translateToEnglishSwitchHandler, user: user })=>{
    const onChangeHandler = (event)=>{
        const branchCode = event.target.checked ? (0, $fff13ca3fea305fa$export$36fc17e38f57b5c7) : user.branchCode;
        translateToEnglishSwitchHandler(branchCode);
    };
    const isSpanishOrGermanUser = ()=>{
        return user && (user.branchCode.slice(0, 2).toUpperCase() === (0, $fff13ca3fea305fa$export$5077d0853d786d24) || user.branchCode.slice(0, 2).toUpperCase() === (0, $fff13ca3fea305fa$export$f38ea8db6d27a647) || user.branchCode.slice(0, 2).toUpperCase() === (0, $fff13ca3fea305fa$export$e996d55be246b546));
    };
    return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $eFTP6.Fragment), {
        children: isSpanishOrGermanUser() && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Item, {
            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1d79a71788b0c844$export$2e2bcd8739ae039), {
                control: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $e7fce3dd40da0110$export$2e2bcd8739ae039), {
                    color: "primary",
                    onChange: onChangeHandler
                }),
                label: "Translate to English"
            })
        })
    });
};
$8ffbcbb17dd5e3f0$var$TranslateTab.propTypes = {
    translateToEnglishSwitchHandler: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func.isRequired,
    user: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).object
};
var $8ffbcbb17dd5e3f0$export$2e2bcd8739ae039 = $8ffbcbb17dd5e3f0$var$TranslateTab;




const $7b3ef6c8ebcd5b66$var$Smartlook = ()=>{
    const getCookie = (name)=>{
        const cookieArr = document.cookie.split(';');
        let cookiePair;
        cookieArr.map((cookie)=>{
            cookiePair = cookie.split('=');
            if (name === cookiePair[0].trim()) return decodeURIComponent(cookiePair[1]);
            return null;
        });
        return null;
    };
    const InitSmartlook = ()=>{
        const cookie = getCookie('OptanonConsent');
        let performanceCookieValue = 1;
        let recordScriptFlag;
        if (cookie !== null) {
            cookie.split('&').forEach((element)=>{
                if (element.includes('groups=')) element.split(',').forEach((element)=>{
                    if (element.includes('C0002')) performanceCookieValue = element.split(':');
                });
            });
            if (performanceCookieValue[1] === 1) recordScriptFlag = true;
            else recordScriptFlag = false;
        } else recordScriptFlag = true;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ebc81e85cd9d0f88$exports))).initialized() && recordScriptFlag) {
            if ((0, $c8fcd73ceb71c905$export$e506a1d27d1eaa20).isDevelopmentEnvironment) {
                (0, (/*@__PURE__*/$parcel$interopDefault($ebc81e85cd9d0f88$exports))).init('7f3c19eac9e239b6ba0981db252da7faa7b5f362', {
                    region: 'eu'
                });
                (0, (/*@__PURE__*/$parcel$interopDefault($ebc81e85cd9d0f88$exports))).anonymize();
            } else if ((0, $c8fcd73ceb71c905$export$e506a1d27d1eaa20).isProductionEnvironment) {
                (0, (/*@__PURE__*/$parcel$interopDefault($ebc81e85cd9d0f88$exports))).init('af904ec8305541c1d7c3aceed3f5ab9b2c175ff8', {
                    region: 'eu'
                });
                (0, (/*@__PURE__*/$parcel$interopDefault($ebc81e85cd9d0f88$exports))).anonymize();
            } else if ((0, $c8fcd73ceb71c905$export$e506a1d27d1eaa20).isQualityEnvironment) {
                (0, (/*@__PURE__*/$parcel$interopDefault($ebc81e85cd9d0f88$exports))).init('3e794448447babc6f9b922a28ccacc9771b9efe4', {
                    region: 'eu'
                });
                (0, (/*@__PURE__*/$parcel$interopDefault($ebc81e85cd9d0f88$exports))).anonymize();
            }
        } else (0, (/*@__PURE__*/$parcel$interopDefault($ebc81e85cd9d0f88$exports))).disable(true);
        return null;
    };
    return InitSmartlook();
};
var $7b3ef6c8ebcd5b66$export$2e2bcd8739ae039 = $7b3ef6c8ebcd5b66$var$Smartlook;




var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");

var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");


var $d3cecd9b716e8731$exports = {};

$parcel$export($d3cecd9b716e8731$exports, "header", () => $d3cecd9b716e8731$export$38e42c68cf43b5d4, (v) => $d3cecd9b716e8731$export$38e42c68cf43b5d4 = v);
$parcel$export($d3cecd9b716e8731$exports, "failed", () => $d3cecd9b716e8731$export$7ab64d539530aa6c, (v) => $d3cecd9b716e8731$export$7ab64d539530aa6c = v);
$parcel$export($d3cecd9b716e8731$exports, "success", () => $d3cecd9b716e8731$export$fe7c49d056ea1d88, (v) => $d3cecd9b716e8731$export$fe7c49d056ea1d88 = v);
var $d3cecd9b716e8731$export$38e42c68cf43b5d4;
var $d3cecd9b716e8731$export$7ab64d539530aa6c;
var $d3cecd9b716e8731$export$fe7c49d056ea1d88;
$d3cecd9b716e8731$export$38e42c68cf43b5d4 = "header_a4f899";
$d3cecd9b716e8731$export$7ab64d539530aa6c = "failed_a4f899";
$d3cecd9b716e8731$export$fe7c49d056ea1d88 = "success_a4f899";





const $c80433e6bd78fa25$export$aaef702f6c66099b = ()=>{
    const [processing, setProcessing] = (0, $Fo7oF.useState)(false);
    const [bundleNumbers, setBundleNumbers] = (0, $Fo7oF.useState)('');
    const [errorMsg, setErrorMsg] = (0, $Fo7oF.useState)(null);
    const [completed, setCompleted] = (0, $Fo7oF.useState)(false);
    const [bundlesForProcessing, setBundlesForProcessing] = (0, $Fo7oF.useState)(null);
    const [isIncorrectDocumentDownloadFlag, setIsIncorrectDocumentDownloadFlag] = (0, $Fo7oF.useState)(false);
    const processBundles = async ()=>{
        return await (0, $c04283212adf4fb0$export$c4b7edec3f76b207)('/api/esign/eregistry/xml/bulk', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({
                'bundleNumbers': bundleNumbers,
                'incorrectDocumentDownloadFlag': isIncorrectDocumentDownloadFlag
            })
        });
    };
    const onProcessButtonClick = ()=>{
        setProcessing(true);
        setCompleted(false);
        processBundles().then((response)=>{
            response && setBundlesForProcessing(response);
        }).catch((err)=>{
            setErrorMsg(`An error occured: ${err.status} ${err.error} ${err.message}`);
        }).finally(()=>{
            setCompleted(true);
            setProcessing(false);
        });
    };
    const handleChange = (e)=>{
        setBundleNumbers(e.target.value);
    };
    const handleCheckboxChange = (e)=>{
        setIsIncorrectDocumentDownloadFlag(e.target.checked);
    };
    const componentMap = {
        [completed && errorMsg === null]: /*#__PURE__*/ (0, $eFTP6.jsxs)("p", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d3cecd9b716e8731$exports))).success,
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f4267c9105e002e8$export$63b4fc557d1c57af), {
                    className: "success",
                    size: "18%"
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                    className: "d-block mt-20",
                    children: "COMPLETED"
                })
            ]
        }),
        [completed && errorMsg !== null]: /*#__PURE__*/ (0, $eFTP6.jsx)("p", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($d3cecd9b716e8731$exports))).failed,
            children: errorMsg
        })
    };
    return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Card), {
        children: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Card).Body, {
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Row), {
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Col), {
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($d3cecd9b716e8731$exports))).header,
                                children: "Bulk E-Registry XML Generation Utility"
                            })
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Col), {
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $3a4ed32c219a2dd3$export$2e2bcd8739ae039), {
                                id: "quote-number",
                                margin: "none",
                                multiline: true,
                                onChange: handleChange,
                                placeholder: "B123456,B234567",
                                value: bundleNumbers
                            })
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Col), {
                            children: [
                                "Is this process for Incorrect Document Download Issue?",
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Checkbox), {
                                    id: 'isIncorrectDocumentDownloadIssueCheckbox',
                                    onChange: (e)=>handleCheckboxChange(e)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Col), {
                            children: processing ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f4267c9105e002e8$export$fe708d541030d854), {
                                size: "md"
                            }) : /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                                color: "primary",
                                onClick: ()=>onProcessButtonClick(),
                                size: "large",
                                variant: "contained",
                                children: "PROCESS"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Row), {
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Col), {
                        children: componentMap.true
                    })
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Row), {
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Col), {
                        children: bundlesForProcessing && bundlesForProcessing.length !== 0 && /*#__PURE__*/ (0, $eFTP6.jsxs)("span", {
                            className: "d-block mt-20",
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsx)("strong", {
                                    children: "Bundles For Processing:"
                                }),
                                " ",
                                bundlesForProcessing.join(' ')
                            ]
                        })
                    })
                })
            ]
        })
    });
};



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");


var $1938b27f02015614$exports = {};

$parcel$export($1938b27f02015614$exports, "body", () => $1938b27f02015614$export$32180ef41b15b513, (v) => $1938b27f02015614$export$32180ef41b15b513 = v);
$parcel$export($1938b27f02015614$exports, "header", () => $1938b27f02015614$export$38e42c68cf43b5d4, (v) => $1938b27f02015614$export$38e42c68cf43b5d4 = v);
var $1938b27f02015614$export$32180ef41b15b513;
var $1938b27f02015614$export$38e42c68cf43b5d4;
$1938b27f02015614$export$32180ef41b15b513 = "body_ff57cb";
$1938b27f02015614$export$38e42c68cf43b5d4 = "header_ff57cb";



const $811da0c10cf6486a$export$ccc7093d03f04e80 = ()=>{
    const [disable, setDisable] = (0, $Fo7oF.useState)(false);
    const processMissingBundle = ()=>{
        setDisable(true);
        (0, $c04283212adf4fb0$export$c4b7edec3f76b207)('/api/missing-proposal-status', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: {}
        });
    };
    return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Card), {
        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Card).Body, {
            children: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Row), {
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Col), {
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1938b27f02015614$exports))).header,
                            children: "Missing Proposal Status Update"
                        })
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Col), {
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                            color: "primary",
                            disabled: disable,
                            onClick: ()=>processMissingBundle(),
                            size: "large",
                            variant: "contained",
                            children: "Process"
                        })
                    })
                ]
            })
        })
    });
};



var $c45cb6602608aeee$exports = {};

$parcel$export($c45cb6602608aeee$exports, "base", () => $c45cb6602608aeee$export$e2253033e6e1df16, (v) => $c45cb6602608aeee$export$e2253033e6e1df16 = v);
var $c45cb6602608aeee$export$e2253033e6e1df16;
$c45cb6602608aeee$export$e2253033e6e1df16 = "base_1704e9";


const $dfc257ad8b4a3bfc$var$AdminUtility = ()=>{
    return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c45cb6602608aeee$exports))).base,
        children: [
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                style: {
                    marginBottom: 30,
                    fontWeight: 'bold'
                },
                variant: "h5",
                children: "Admin Utility"
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $811da0c10cf6486a$export$ccc7093d03f04e80), {}),
            /*#__PURE__*/ (0, $eFTP6.jsx)("br", {}),
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c80433e6bd78fa25$export$aaef702f6c66099b), {}),
            /*#__PURE__*/ (0, $eFTP6.jsx)("br", {})
        ]
    });
};
var $dfc257ad8b4a3bfc$export$2e2bcd8739ae039 = $dfc257ad8b4a3bfc$var$AdminUtility;



var $eFTP6 = parcelRequire("eFTP6");

var $69Iz3 = parcelRequire("69Iz3");
function $07b58fb47cf4295b$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}


function $5bfc471531f34f17$export$2e2bcd8739ae039(value) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $69Iz3.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}



var $69Iz3 = parcelRequire("69Iz3");

function $30dc93c0e65a3522$export$2e2bcd8739ae039(argument) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $69Iz3.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $8612fe49a22cd580$export$2e2bcd8739ae039(dirtyDate) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $5bfc471531f34f17$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $61108a93da14431c$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $f20e476a62ec88f3$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $61108a93da14431c$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $1cd21754379d30b9$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $61108a93da14431c$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $f20e476a62ec88f3$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $37a9dc5a3535629a$var$MILLISECONDS_IN_DAY = 86400000;
function $37a9dc5a3535629a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $37a9dc5a3535629a$var$MILLISECONDS_IN_DAY) + 1;
}





function $3f9b5eaaadf54def$export$2e2bcd8739ae039(dirtyDate) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $dcfcb80f9d0103ce$export$2e2bcd8739ae039(dirtyDate) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $3f9b5eaaadf54def$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $3f9b5eaaadf54def$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $19720e0d332bfefb$export$2e2bcd8739ae039(dirtyDate) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $dcfcb80f9d0103ce$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $3f9b5eaaadf54def$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $96aebc492180ec1b$var$MILLISECONDS_IN_WEEK = 604800000;
function $96aebc492180ec1b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $3f9b5eaaadf54def$export$2e2bcd8739ae039)(date).getTime() - (0, $19720e0d332bfefb$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $96aebc492180ec1b$var$MILLISECONDS_IN_WEEK) + 1;
}







var $9c5583b80741d6b5$var$defaultOptions = {};
function $9c5583b80741d6b5$export$430a3269e24b912e() {
    return $9c5583b80741d6b5$var$defaultOptions;
}
function $9c5583b80741d6b5$export$95365be1b0704abc(newOptions) {
    $9c5583b80741d6b5$var$defaultOptions = newOptions;
}


function $0e22a7c84bf87872$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $9c5583b80741d6b5$export$430a3269e24b912e)();
    var weekStartsOn = (0, $61108a93da14431c$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $27df90d0b1668d5a$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $9c5583b80741d6b5$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $61108a93da14431c$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $0e22a7c84bf87872$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $0e22a7c84bf87872$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $d3a34cc1ed771121$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $9c5583b80741d6b5$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $61108a93da14431c$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $27df90d0b1668d5a$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $0e22a7c84bf87872$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $bfdcc27d2aeebcfe$var$MILLISECONDS_IN_WEEK = 604800000;
function $bfdcc27d2aeebcfe$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $0e22a7c84bf87872$export$2e2bcd8739ae039)(date, options).getTime() - (0, $d3a34cc1ed771121$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $bfdcc27d2aeebcfe$var$MILLISECONDS_IN_WEEK) + 1;
}



function $dd9ae607c163269a$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $a5e2f021bfaf6da9$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $a5e2f021bfaf6da9$export$2e2bcd8739ae039 = $a5e2f021bfaf6da9$var$formatters;


var $4b65b4b18f44acd7$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $4b65b4b18f44acd7$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $a5e2f021bfaf6da9$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $27df90d0b1668d5a$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $dcfcb80f9d0103ce$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $a5e2f021bfaf6da9$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $bfdcc27d2aeebcfe$export$2e2bcd8739ae039)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $96aebc492180ec1b$export$2e2bcd8739ae039)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $a5e2f021bfaf6da9$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $37a9dc5a3535629a$export$2e2bcd8739ae039)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $4b65b4b18f44acd7$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $4b65b4b18f44acd7$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $4b65b4b18f44acd7$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $4b65b4b18f44acd7$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $4b65b4b18f44acd7$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $4b65b4b18f44acd7$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $a5e2f021bfaf6da9$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $a5e2f021bfaf6da9$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $a5e2f021bfaf6da9$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $a5e2f021bfaf6da9$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $a5e2f021bfaf6da9$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $4b65b4b18f44acd7$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $4b65b4b18f44acd7$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $4b65b4b18f44acd7$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $4b65b4b18f44acd7$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $4b65b4b18f44acd7$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $4b65b4b18f44acd7$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $4b65b4b18f44acd7$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $4b65b4b18f44acd7$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $4b65b4b18f44acd7$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $4b65b4b18f44acd7$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $4b65b4b18f44acd7$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(minutes, 2);
}
function $4b65b4b18f44acd7$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $4b65b4b18f44acd7$var$formatTimezone(offset, dirtyDelimiter);
}
function $4b65b4b18f44acd7$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $dd9ae607c163269a$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $4b65b4b18f44acd7$export$2e2bcd8739ae039 = $4b65b4b18f44acd7$var$formatters;


var $90ef58b2137d1f7c$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $90ef58b2137d1f7c$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $90ef58b2137d1f7c$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $90ef58b2137d1f7c$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $90ef58b2137d1f7c$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $90ef58b2137d1f7c$var$timeLongFormatter(timePattern, formatLong));
};
var $90ef58b2137d1f7c$var$longFormatters = {
    p: $90ef58b2137d1f7c$var$timeLongFormatter,
    P: $90ef58b2137d1f7c$var$dateTimeLongFormatter
};
var $90ef58b2137d1f7c$export$2e2bcd8739ae039 = $90ef58b2137d1f7c$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $889389e707901a56$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $a2d35b5c87ad8163$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $a2d35b5c87ad8163$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $a2d35b5c87ad8163$export$c6cc36aa33304772(token) {
    return $a2d35b5c87ad8163$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $a2d35b5c87ad8163$export$c6b49d6dceb604a1(token) {
    return $a2d35b5c87ad8163$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $a2d35b5c87ad8163$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $27a04659bf77899a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $27a04659bf77899a$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $27a04659bf77899a$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $27a04659bf77899a$export$2e2bcd8739ae039 = $27a04659bf77899a$var$formatDistance;


function $410b04e06634210e$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $fe0f200839b96c0f$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $fe0f200839b96c0f$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $fe0f200839b96c0f$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $fe0f200839b96c0f$var$formatLong = {
    date: (0, $410b04e06634210e$export$2e2bcd8739ae039)({
        formats: $fe0f200839b96c0f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $410b04e06634210e$export$2e2bcd8739ae039)({
        formats: $fe0f200839b96c0f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $410b04e06634210e$export$2e2bcd8739ae039)({
        formats: $fe0f200839b96c0f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $fe0f200839b96c0f$export$2e2bcd8739ae039 = $fe0f200839b96c0f$var$formatLong;


var $97497f83791ed255$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $97497f83791ed255$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $97497f83791ed255$var$formatRelativeLocale[token];
};
var $97497f83791ed255$export$2e2bcd8739ae039 = $97497f83791ed255$var$formatRelative;


function $1f68434e4fc48170$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $500983bfb5e84ec3$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $500983bfb5e84ec3$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $500983bfb5e84ec3$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $500983bfb5e84ec3$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $500983bfb5e84ec3$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $500983bfb5e84ec3$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $500983bfb5e84ec3$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $500983bfb5e84ec3$var$localize = {
    ordinalNumber: $500983bfb5e84ec3$var$ordinalNumber,
    era: (0, $1f68434e4fc48170$export$2e2bcd8739ae039)({
        values: $500983bfb5e84ec3$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $1f68434e4fc48170$export$2e2bcd8739ae039)({
        values: $500983bfb5e84ec3$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $1f68434e4fc48170$export$2e2bcd8739ae039)({
        values: $500983bfb5e84ec3$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $1f68434e4fc48170$export$2e2bcd8739ae039)({
        values: $500983bfb5e84ec3$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $1f68434e4fc48170$export$2e2bcd8739ae039)({
        values: $500983bfb5e84ec3$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $500983bfb5e84ec3$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $500983bfb5e84ec3$export$2e2bcd8739ae039 = $500983bfb5e84ec3$var$localize;


function $18a881eb94e00a8e$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $18a881eb94e00a8e$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $18a881eb94e00a8e$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $18a881eb94e00a8e$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $18a881eb94e00a8e$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $7997162b12d59f2a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $6a33625cabd23234$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $6a33625cabd23234$var$parseOrdinalNumberPattern = /\d+/i;
var $6a33625cabd23234$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $6a33625cabd23234$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $6a33625cabd23234$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $6a33625cabd23234$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $6a33625cabd23234$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $6a33625cabd23234$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $6a33625cabd23234$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $6a33625cabd23234$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $6a33625cabd23234$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $6a33625cabd23234$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $6a33625cabd23234$var$match = {
    ordinalNumber: (0, $7997162b12d59f2a$export$2e2bcd8739ae039)({
        matchPattern: $6a33625cabd23234$var$matchOrdinalNumberPattern,
        parsePattern: $6a33625cabd23234$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $18a881eb94e00a8e$export$2e2bcd8739ae039)({
        matchPatterns: $6a33625cabd23234$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6a33625cabd23234$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $18a881eb94e00a8e$export$2e2bcd8739ae039)({
        matchPatterns: $6a33625cabd23234$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6a33625cabd23234$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $18a881eb94e00a8e$export$2e2bcd8739ae039)({
        matchPatterns: $6a33625cabd23234$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6a33625cabd23234$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $18a881eb94e00a8e$export$2e2bcd8739ae039)({
        matchPatterns: $6a33625cabd23234$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6a33625cabd23234$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $18a881eb94e00a8e$export$2e2bcd8739ae039)({
        matchPatterns: $6a33625cabd23234$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $6a33625cabd23234$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $6a33625cabd23234$export$2e2bcd8739ae039 = $6a33625cabd23234$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $a1064debe688b59b$var$locale = {
    code: 'en-US',
    formatDistance: (0, $27a04659bf77899a$export$2e2bcd8739ae039),
    formatLong: (0, $fe0f200839b96c0f$export$2e2bcd8739ae039),
    formatRelative: (0, $97497f83791ed255$export$2e2bcd8739ae039),
    localize: (0, $500983bfb5e84ec3$export$2e2bcd8739ae039),
    match: (0, $6a33625cabd23234$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $a1064debe688b59b$export$2e2bcd8739ae039 = $a1064debe688b59b$var$locale;


var $3418bfcc10e6c14b$export$2e2bcd8739ae039 = (0, $a1064debe688b59b$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $2644bf2d885f615e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $2644bf2d885f615e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $2644bf2d885f615e$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $2644bf2d885f615e$var$doubleQuoteRegExp = /''/g;
var $2644bf2d885f615e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $2644bf2d885f615e$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $9c5583b80741d6b5$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $3418bfcc10e6c14b$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $61108a93da14431c$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $61108a93da14431c$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $8612fe49a22cd580$export$2e2bcd8739ae039)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $889389e707901a56$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $1cd21754379d30b9$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($2644bf2d885f615e$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $90ef58b2137d1f7c$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($2644bf2d885f615e$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $2644bf2d885f615e$var$cleanEscapedString(substring);
        var formatter = (0, $4b65b4b18f44acd7$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $a2d35b5c87ad8163$export$c6b49d6dceb604a1)(substring)) (0, $a2d35b5c87ad8163$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $a2d35b5c87ad8163$export$c6cc36aa33304772)(substring)) (0, $a2d35b5c87ad8163$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($2644bf2d885f615e$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $2644bf2d885f615e$var$cleanEscapedString(input) {
    var matched = input.match($2644bf2d885f615e$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($2644bf2d885f615e$var$doubleQuoteRegExp, "'");
}


var $69Iz3 = parcelRequire("69Iz3");

var $graxV = parcelRequire("graxV");
function $cba86bd82dd4b05b$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $graxV.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}





function $1f0abcacc5e5a53c$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}








var $bnz4d = parcelRequire("bnz4d");

var $bkGme = parcelRequire("bkGme");
function $f79f302d728c8fa0$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $bkGme.default)(t, e);
}


function $17c9b9cedb1b1791$export$2e2bcd8739ae039(t) {
    return $17c9b9cedb1b1791$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $17c9b9cedb1b1791$export$2e2bcd8739ae039(t);
}


function $a12d9ce17d12e909$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a12d9ce17d12e909$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



var $69Iz3 = parcelRequire("69Iz3");

var $bnz4d = parcelRequire("bnz4d");
function $03e7eaefdaf85d7c$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $69Iz3.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $bnz4d.default)(t);
}


function $e25fd962c7d10999$export$2e2bcd8739ae039(t) {
    var r = (0, $a12d9ce17d12e909$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $17c9b9cedb1b1791$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $17c9b9cedb1b1791$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $03e7eaefdaf85d7c$export$2e2bcd8739ae039)(this, e);
    };
}




var $fxzEt = parcelRequire("fxzEt");

var $d2vKa = parcelRequire("d2vKa");
var $32bebba5d5055137$var$TIMEZONE_UNIT_PRIORITY = 10;
var $32bebba5d5055137$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, Setter);
        (0, $d2vKa.default)(this, "priority", void 0);
        (0, $d2vKa.default)(this, "subPriority", 0);
    }
    (0, $fxzEt.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $32bebba5d5055137$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(ValueSetter, _Setter);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $fxzEt.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($32bebba5d5055137$export$81d53e3678089a6);
var $32bebba5d5055137$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this2), "priority", $32bebba5d5055137$var$TIMEZONE_UNIT_PRIORITY);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $fxzEt.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($32bebba5d5055137$export$81d53e3678089a6);




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");


var $fxzEt = parcelRequire("fxzEt");

var $d2vKa = parcelRequire("d2vKa");

var $cbcbf6edce9db563$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, Parser);
        (0, $d2vKa.default)(this, "incompatibleTokens", void 0);
        (0, $d2vKa.default)(this, "priority", void 0);
        (0, $d2vKa.default)(this, "subPriority", void 0);
    }
    (0, $fxzEt.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $32bebba5d5055137$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();


var $5a71adf30b7305a1$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(EraParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(EraParser);
    function EraParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 140);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $95c270131c6ef534$export$dfd9b671c89acc8e = 7;
var $95c270131c6ef534$export$3913210603d8e9ae = 365.2425;
var $95c270131c6ef534$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $95c270131c6ef534$export$91246f0b9bd9beff = 60000;
var $95c270131c6ef534$export$7f72910d6dfd237a = 3600000;
var $95c270131c6ef534$export$397c2d5776aa9055 = 1000;
var $95c270131c6ef534$export$4dec998e48f9c246 = -$95c270131c6ef534$export$81caae6e1cc7a622;
var $95c270131c6ef534$export$f2f5ae5a8e2d8f9f = 60;
var $95c270131c6ef534$export$3c58128db900d44e = 3;
var $95c270131c6ef534$export$80d7e435f744f319 = 12;
var $95c270131c6ef534$export$4db7641526e3241f = 4;
var $95c270131c6ef534$export$698aec755e92c695 = 3600;
var $95c270131c6ef534$export$a77c1a7ebebe2a5a = 60;
var $95c270131c6ef534$export$815a9362476d2fe3 = $95c270131c6ef534$export$698aec755e92c695 * 24;
var $95c270131c6ef534$export$34804a017b31e2fe = $95c270131c6ef534$export$815a9362476d2fe3 * 7;
var $95c270131c6ef534$export$7271e9e3478110d1 = $95c270131c6ef534$export$815a9362476d2fe3 * $95c270131c6ef534$export$3913210603d8e9ae;
var $95c270131c6ef534$export$8e6600bbdee7dabb = $95c270131c6ef534$export$7271e9e3478110d1 / 12;
var $95c270131c6ef534$export$be1dccf2de902d31 = $95c270131c6ef534$export$8e6600bbdee7dabb * 3;


var $9a1f3a34c4274ed0$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $9a1f3a34c4274ed0$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $502e090746357b90$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $502e090746357b90$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $502e090746357b90$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $95c270131c6ef534$export$7f72910d6dfd237a) + minutes * (0, $95c270131c6ef534$export$91246f0b9bd9beff) + seconds * (0, $95c270131c6ef534$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $502e090746357b90$export$d931c43c4608a164(dateString) {
    return $502e090746357b90$export$cc7cc9e2a3ff9388((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $502e090746357b90$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $502e090746357b90$export$cc7cc9e2a3ff9388((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $502e090746357b90$export$cc7cc9e2a3ff9388((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $502e090746357b90$export$cc7cc9e2a3ff9388((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $502e090746357b90$export$cc7cc9e2a3ff9388((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $502e090746357b90$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $502e090746357b90$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $502e090746357b90$export$cc7cc9e2a3ff9388((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $502e090746357b90$export$cc7cc9e2a3ff9388((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $502e090746357b90$export$cc7cc9e2a3ff9388((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $502e090746357b90$export$cc7cc9e2a3ff9388((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $502e090746357b90$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $502e090746357b90$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $502e090746357b90$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $502e090746357b90$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


var $027f0f027535355d$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(YearParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(YearParser);
    function YearParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 130);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $502e090746357b90$export$4f84e3a82c7b538)((0, $502e090746357b90$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $502e090746357b90$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $502e090746357b90$export$4f84e3a82c7b538)((0, $502e090746357b90$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $502e090746357b90$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");




var $035a536044a52889$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(LocalWeekYearParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 130);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $502e090746357b90$export$4f84e3a82c7b538)((0, $502e090746357b90$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $502e090746357b90$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $502e090746357b90$export$4f84e3a82c7b538)((0, $502e090746357b90$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $27df90d0b1668d5a$export$2e2bcd8739ae039)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $502e090746357b90$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $0e22a7c84bf87872$export$2e2bcd8739ae039)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $0e22a7c84bf87872$export$2e2bcd8739ae039)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");



var $ebd06980ea8f2cbb$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(ISOWeekYearParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 130);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $502e090746357b90$export$2c9307b2e29c533c)(4, dateString);
                return (0, $502e090746357b90$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $3f9b5eaaadf54def$export$2e2bcd8739ae039)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");


var $8eba777ad8072af5$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(ExtendedYearParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 130);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $502e090746357b90$export$2c9307b2e29c533c)(4, dateString);
                return (0, $502e090746357b90$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");


var $375928f62082e954$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(QuarterParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 120);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $502e090746357b90$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");


var $4e233872cbc38ef7$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(StandAloneQuarterParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 120);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $502e090746357b90$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");



var $fa2562e541615898$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(MonthParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 110);
        return _this;
    }
    (0, $fxzEt.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $502e090746357b90$export$4f84e3a82c7b538)((0, $502e090746357b90$export$cc7cc9e2a3ff9388)((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $502e090746357b90$export$4f84e3a82c7b538)((0, $502e090746357b90$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $502e090746357b90$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");



var $ffbdedf9d128b35f$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(StandAloneMonthParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 110);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $502e090746357b90$export$4f84e3a82c7b538)((0, $502e090746357b90$export$cc7cc9e2a3ff9388)((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $502e090746357b90$export$4f84e3a82c7b538)((0, $502e090746357b90$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $502e090746357b90$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");







function $f632f2d04c303361$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var week = (0, $61108a93da14431c$export$2e2bcd8739ae039)(dirtyWeek);
    var diff = (0, $bfdcc27d2aeebcfe$export$2e2bcd8739ae039)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $a7ed9fe92463cc7c$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(LocalWeekParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 100);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $502e090746357b90$export$cc7cc9e2a3ff9388)((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $502e090746357b90$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $0e22a7c84bf87872$export$2e2bcd8739ae039)((0, $f632f2d04c303361$export$2e2bcd8739ae039)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");







function $5601063e1139f13f$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var isoWeek = (0, $61108a93da14431c$export$2e2bcd8739ae039)(dirtyISOWeek);
    var diff = (0, $96aebc492180ec1b$export$2e2bcd8739ae039)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $7390d1ea79ac88ef$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(ISOWeekParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 100);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $502e090746357b90$export$cc7cc9e2a3ff9388)((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $502e090746357b90$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $3f9b5eaaadf54def$export$2e2bcd8739ae039)((0, $5601063e1139f13f$export$2e2bcd8739ae039)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");



var $6cd1e359f1e2f18b$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $6cd1e359f1e2f18b$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $6cd1e359f1e2f18b$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(DateParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(DateParser);
    function DateParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 90);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "subPriority", 1);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $502e090746357b90$export$cc7cc9e2a3ff9388)((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $502e090746357b90$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $502e090746357b90$export$3d50627710b84d75)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $6cd1e359f1e2f18b$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $6cd1e359f1e2f18b$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");



var $689040ff3c98812e$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(DayOfYearParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 90);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "subpriority", 1);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $502e090746357b90$export$cc7cc9e2a3ff9388)((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $502e090746357b90$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $502e090746357b90$export$3d50627710b84d75)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");





function $f54d6164d1f86e3e$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $9c5583b80741d6b5$export$430a3269e24b912e)();
    var weekStartsOn = (0, $61108a93da14431c$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var day = (0, $61108a93da14431c$export$2e2bcd8739ae039)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $7f4d4d59045bebc7$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(DayParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(DayParser);
    function DayParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 90);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $f54d6164d1f86e3e$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");



var $c41beea86e93913f$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(LocalDayParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 90);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $502e090746357b90$export$4f84e3a82c7b538)((0, $502e090746357b90$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $502e090746357b90$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $f54d6164d1f86e3e$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");



var $3e08aff510096666$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 90);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $502e090746357b90$export$4f84e3a82c7b538)((0, $502e090746357b90$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $502e090746357b90$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $f54d6164d1f86e3e$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");





function $4b2698ca086be74f$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var day = (0, $61108a93da14431c$export$2e2bcd8739ae039)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $0060f9f2bbdaa6e5$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(ISODayParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 90);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $502e090746357b90$export$513bb01536146ab6)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $502e090746357b90$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $502e090746357b90$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $502e090746357b90$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $502e090746357b90$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $4b2698ca086be74f$export$2e2bcd8739ae039)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");


var $edd332cb70c78118$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(AMPMParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 80);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $502e090746357b90$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");


var $d7d1cba822ac88c4$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(AMPMMidnightParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 80);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $502e090746357b90$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");


var $5be7efa90a947b24$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(DayPeriodParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 80);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $502e090746357b90$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");



var $f31b3e08e502f808$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(Hour1to12Parser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 70);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $502e090746357b90$export$cc7cc9e2a3ff9388)((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $502e090746357b90$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");



var $be378b57f2fccd4c$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(Hour0to23Parser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 70);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $502e090746357b90$export$cc7cc9e2a3ff9388)((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $502e090746357b90$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");



var $3e10c56fb3fea511$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(Hour0To11Parser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 70);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $502e090746357b90$export$cc7cc9e2a3ff9388)((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $502e090746357b90$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");



var $af48855859bee9c1$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(Hour1To24Parser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 70);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $502e090746357b90$export$cc7cc9e2a3ff9388)((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $502e090746357b90$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");



var $c30ba8fd6ddc0927$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(MinuteParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 60);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $502e090746357b90$export$cc7cc9e2a3ff9388)((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $502e090746357b90$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");



var $fa04f551cbafe75f$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(SecondParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 50);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $502e090746357b90$export$cc7cc9e2a3ff9388)((0, $9a1f3a34c4274ed0$export$c123ee06d9da8480).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $502e090746357b90$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");


var $411dd5e759dcf19b$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(FractionOfSecondParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 30);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $502e090746357b90$export$4f84e3a82c7b538)((0, $502e090746357b90$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");



var $e73db4c5a5669410$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 10);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $502e090746357b90$export$6497f4c0ecdfba8e)((0, $9a1f3a34c4274ed0$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $502e090746357b90$export$6497f4c0ecdfba8e)((0, $9a1f3a34c4274ed0$export$a7ee192b982af9c1).basic, dateString);
                    case 'XXXX':
                        return (0, $502e090746357b90$export$6497f4c0ecdfba8e)((0, $9a1f3a34c4274ed0$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $502e090746357b90$export$6497f4c0ecdfba8e)((0, $9a1f3a34c4274ed0$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $502e090746357b90$export$6497f4c0ecdfba8e)((0, $9a1f3a34c4274ed0$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");



var $934c0f53b6e7cd3e$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(ISOTimezoneParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 10);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $fxzEt.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $502e090746357b90$export$6497f4c0ecdfba8e)((0, $9a1f3a34c4274ed0$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $502e090746357b90$export$6497f4c0ecdfba8e)((0, $9a1f3a34c4274ed0$export$a7ee192b982af9c1).basic, dateString);
                    case 'xxxx':
                        return (0, $502e090746357b90$export$6497f4c0ecdfba8e)((0, $9a1f3a34c4274ed0$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $502e090746357b90$export$6497f4c0ecdfba8e)((0, $9a1f3a34c4274ed0$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $502e090746357b90$export$6497f4c0ecdfba8e)((0, $9a1f3a34c4274ed0$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");


var $a343feb18b5d2e05$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(TimestampSecondsParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 40);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $fxzEt.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $502e090746357b90$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));




var $fxzEt = parcelRequire("fxzEt");

var $bnz4d = parcelRequire("bnz4d");



var $d2vKa = parcelRequire("d2vKa");


var $e42889aeb2e64596$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $e25fd962c7d10999$export$2e2bcd8739ae039)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "priority", 20);
        (0, $d2vKa.default)((0, $bnz4d.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $fxzEt.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $502e090746357b90$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $cbcbf6edce9db563$export$7acfa6ed01010e37));


var $1bfcf3f2467ed7f2$export$19131010e7fd8373 = {
    G: new (0, $5a71adf30b7305a1$export$8e5a1d3f85a9688)(),
    y: new (0, $027f0f027535355d$export$48d352de7cd4a988)(),
    Y: new (0, $035a536044a52889$export$b8ef38dfcf05d5db)(),
    R: new (0, $ebd06980ea8f2cbb$export$951d1df011fde06f)(),
    u: new (0, $8eba777ad8072af5$export$bad9d2ea38e8f1a)(),
    Q: new (0, $375928f62082e954$export$5cb0f701186dde1d)(),
    q: new (0, $4e233872cbc38ef7$export$300c0c2990e20e6d)(),
    M: new (0, $fa2562e541615898$export$400dd8b40ef138a3)(),
    L: new (0, $ffbdedf9d128b35f$export$1d7eaa53eaa5deba)(),
    w: new (0, $a7ed9fe92463cc7c$export$c4005ffc174e07c0)(),
    I: new (0, $7390d1ea79ac88ef$export$6fc8dbedd560a6af)(),
    d: new (0, $6cd1e359f1e2f18b$export$e8d4b28a20981dd2)(),
    D: new (0, $689040ff3c98812e$export$6cfe0d613455f615)(),
    E: new (0, $7f4d4d59045bebc7$export$1b03c8b76262f7bd)(),
    e: new (0, $c41beea86e93913f$export$44d1c127ab42c480)(),
    c: new (0, $3e08aff510096666$export$e447a647caaaec1d)(),
    i: new (0, $0060f9f2bbdaa6e5$export$693fb1e525095b2a)(),
    a: new (0, $edd332cb70c78118$export$8d1e08492351df91)(),
    b: new (0, $d7d1cba822ac88c4$export$73ca2bd0a17d273)(),
    B: new (0, $5be7efa90a947b24$export$bb9212adf05373db)(),
    h: new (0, $f31b3e08e502f808$export$8a04050a727a1756)(),
    H: new (0, $be378b57f2fccd4c$export$e56f4dea2c3e56dd)(),
    K: new (0, $3e10c56fb3fea511$export$cbbe855312f87d77)(),
    k: new (0, $af48855859bee9c1$export$6008046d2b34b6a5)(),
    m: new (0, $c30ba8fd6ddc0927$export$2b52670d9e2be53)(),
    s: new (0, $fa04f551cbafe75f$export$94d46d540cf1366a)(),
    S: new (0, $411dd5e759dcf19b$export$b8e6f8b2d70893b1)(),
    X: new (0, $e73db4c5a5669410$export$104d901d49fea29b)(),
    x: new (0, $934c0f53b6e7cd3e$export$12910e5204b52b9)(),
    t: new (0, $a343feb18b5d2e05$export$2cd8bf877a05e96)(),
    T: new (0, $e42889aeb2e64596$export$6d8f69c6906d6368)()
};



// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $f71cfd9f27b06d6b$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $f71cfd9f27b06d6b$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $f71cfd9f27b06d6b$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $f71cfd9f27b06d6b$var$doubleQuoteRegExp = /''/g;
var $f71cfd9f27b06d6b$var$notWhitespaceRegExp = /\S/;
var $f71cfd9f27b06d6b$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $f71cfd9f27b06d6b$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $9c5583b80741d6b5$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $3418bfcc10e6c14b$export$2e2bcd8739ae039);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $61108a93da14431c$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $61108a93da14431c$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $32bebba5d5055137$export$5aaf7ff7f09ea4ee)()
    ];
    var tokens = formatString.match($f71cfd9f27b06d6b$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $90ef58b2137d1f7c$export$2e2bcd8739ae039)) {
            var longFormatter = (0, $90ef58b2137d1f7c$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($f71cfd9f27b06d6b$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $cba86bd82dd4b05b$export$2e2bcd8739ae039)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $a2d35b5c87ad8163$export$c6b49d6dceb604a1)(token)) (0, $a2d35b5c87ad8163$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $a2d35b5c87ad8163$export$c6cc36aa33304772)(token)) (0, $a2d35b5c87ad8163$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $1bfcf3f2467ed7f2$export$19131010e7fd8373)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($f71cfd9f27b06d6b$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $f71cfd9f27b06d6b$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $69Iz3.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $f71cfd9f27b06d6b$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $1cd21754379d30b9$export$2e2bcd8739ae039)(date, (0, $889389e707901a56$export$2e2bcd8739ae039)(date));
    var flags = {};
    var _iterator2 = (0, $cba86bd82dd4b05b$export$2e2bcd8739ae039)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $1f0abcacc5e5a53c$export$2e2bcd8739ae039)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $f71cfd9f27b06d6b$var$cleanEscapedString(input) {
    return input.match($f71cfd9f27b06d6b$var$escapedStringRegExp)[1].replace($f71cfd9f27b06d6b$var$doubleQuoteRegExp, "'");
}



var $Fo7oF = parcelRequire("Fo7oF");




function $8a04c0440b7e21a7$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $61108a93da14431c$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}





function $251ada10bcd026d4$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $61108a93da14431c$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}





function $54fc8ed9cfae127f$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $61108a93da14431c$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $251ada10bcd026d4$export$2e2bcd8739ae039)(dirtyDate, amount * 12);
}




function $6f354e368d15f250$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    return (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dateLeft).getTime() - (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dateRight).getTime();
}




function $1472a79476010e3e$export$2e2bcd8739ae039(dirtyInterval, options) {
    var _options$step;
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(interval.start);
    var endDate = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError('Invalid interval');
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
    while(currentDate.getTime() <= endTime){
        dates.push((0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return dates;
}




function $b41cd926fb210479$export$2e2bcd8739ae039(dirtyDate) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}






function $9abb06d30e4596ee$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $9c5583b80741d6b5$export$430a3269e24b912e)();
    var weekStartsOn = (0, $61108a93da14431c$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $92ec91e13400f9c7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}





function $ce3242673d93803a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var hours = date.getHours();
    return hours;
}




function $3947a2fbaeffb734$export$2e2bcd8739ae039(dirtyDate) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}




function $f5a243237a040242$export$2e2bcd8739ae039(dirtyDate) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    return (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate).getFullYear();
}




function $631e89b11c52a04d$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}




function $b2187ab4762b4275$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}




function $97070a28069e3122$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyLeftDate);
    var dateRight = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}




function $e6a4269ef9109615$export$2e2bcd8739ae039(dirtyDate) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



function $715460132d37912f$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfDay = (0, $e6a4269ef9109615$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $e6a4269ef9109615$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}




function $44a6aa89656e66fc$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}




function $8c53baaf3069d6a0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}




function $0a9754dd5986979a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    date.setMinutes(0, 0, 0);
    return date;
}



function $cd6897d837c4ab61$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfHour = (0, $0a9754dd5986979a$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfHour = (0, $0a9754dd5986979a$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}







function $87365b29a653404a$export$2e2bcd8739ae039(dirtyDate, dirtyHours) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var hours = (0, $61108a93da14431c$export$2e2bcd8739ae039)(dirtyHours);
    date.setHours(hours);
    return date;
}





function $c5393fdf206e0306$export$2e2bcd8739ae039(dirtyDate, dirtyMinutes) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var minutes = (0, $61108a93da14431c$export$2e2bcd8739ae039)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}






function $908089c91d79bed7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}



function $8f8d9da5a252812a$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var month = (0, $61108a93da14431c$export$2e2bcd8739ae039)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $908089c91d79bed7$export$2e2bcd8739ae039)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}





function $aab863c2b9f92169$export$2e2bcd8739ae039(dirtyDate, dirtySeconds) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var seconds = (0, $61108a93da14431c$export$2e2bcd8739ae039)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}





function $6b7c666653b8de6e$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var year = (0, $61108a93da14431c$export$2e2bcd8739ae039)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}





function $0bc3585debf50d81$export$2e2bcd8739ae039(dirtyDate) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}




function $a67730ad06e0214f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}






function $5488454aaf7f20df$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $9c5583b80741d6b5$export$430a3269e24b912e)();
    var weekStartsOn = (0, $61108a93da14431c$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}




function $2464cccf40987654$export$2e2bcd8739ae039(dirtyDate) {
    (0, $07b58fb47cf4295b$export$2e2bcd8739ae039)(1, arguments);
    var cleanDate = (0, $30dc93c0e65a3522$export$2e2bcd8739ae039)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}


var $dd12c932fd8737b5$var$DateFnsUtils = /** @class */ function() {
    function DateFnsUtils(_a) {
        var locale = (_a === void 0 ? {} : _a).locale;
        this.yearFormat = "yyyy";
        this.yearMonthFormat = "MMMM yyyy";
        this.dateTime12hFormat = "MMMM do hh:mm aaaa";
        this.dateTime24hFormat = "MMMM do HH:mm";
        this.time12hFormat = "hh:mm a";
        this.time24hFormat = "HH:mm";
        this.dateFormat = "MMMM do";
        this.locale = locale;
    }
    // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
    // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
    DateFnsUtils.prototype.addDays = function(value, count) {
        return (0, $8a04c0440b7e21a7$export$2e2bcd8739ae039)(value, count);
    };
    DateFnsUtils.prototype.isValid = function(value) {
        return (0, $8612fe49a22cd580$export$2e2bcd8739ae039)(this.date(value));
    };
    DateFnsUtils.prototype.getDiff = function(value, comparing) {
        return (0, $6f354e368d15f250$export$2e2bcd8739ae039)(value, this.date(comparing));
    };
    DateFnsUtils.prototype.isAfter = function(value, comparing) {
        return (0, $631e89b11c52a04d$export$2e2bcd8739ae039)(value, comparing);
    };
    DateFnsUtils.prototype.isBefore = function(value, comparing) {
        return (0, $b2187ab4762b4275$export$2e2bcd8739ae039)(value, comparing);
    };
    DateFnsUtils.prototype.startOfDay = function(value) {
        return (0, $e6a4269ef9109615$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.endOfDay = function(value) {
        return (0, $b41cd926fb210479$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.getHours = function(value) {
        return (0, $ce3242673d93803a$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.setHours = function(value, count) {
        return (0, $87365b29a653404a$export$2e2bcd8739ae039)(value, count);
    };
    DateFnsUtils.prototype.setMinutes = function(value, count) {
        return (0, $c5393fdf206e0306$export$2e2bcd8739ae039)(value, count);
    };
    DateFnsUtils.prototype.getSeconds = function(value) {
        return (0, $3947a2fbaeffb734$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.setSeconds = function(value, count) {
        return (0, $aab863c2b9f92169$export$2e2bcd8739ae039)(value, count);
    };
    DateFnsUtils.prototype.isSameDay = function(value, comparing) {
        return (0, $715460132d37912f$export$2e2bcd8739ae039)(value, comparing);
    };
    DateFnsUtils.prototype.isSameMonth = function(value, comparing) {
        return (0, $8c53baaf3069d6a0$export$2e2bcd8739ae039)(value, comparing);
    };
    DateFnsUtils.prototype.isSameYear = function(value, comparing) {
        return (0, $44a6aa89656e66fc$export$2e2bcd8739ae039)(value, comparing);
    };
    DateFnsUtils.prototype.isSameHour = function(value, comparing) {
        return (0, $cd6897d837c4ab61$export$2e2bcd8739ae039)(value, comparing);
    };
    DateFnsUtils.prototype.startOfMonth = function(value) {
        return (0, $0bc3585debf50d81$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.endOfMonth = function(value) {
        return (0, $a67730ad06e0214f$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.getYear = function(value) {
        return (0, $f5a243237a040242$export$2e2bcd8739ae039)(value);
    };
    DateFnsUtils.prototype.setYear = function(value, count) {
        return (0, $6b7c666653b8de6e$export$2e2bcd8739ae039)(value, count);
    };
    DateFnsUtils.prototype.date = function(value) {
        if (typeof value === "undefined") return new Date();
        if (value === null) return null;
        return new Date(value);
    };
    DateFnsUtils.prototype.parse = function(value, formatString) {
        if (value === "") return null;
        return (0, $f71cfd9f27b06d6b$export$2e2bcd8739ae039)(value, formatString, new Date(), {
            locale: this.locale
        });
    };
    DateFnsUtils.prototype.format = function(date, formatString) {
        return (0, $2644bf2d885f615e$export$2e2bcd8739ae039)(date, formatString, {
            locale: this.locale
        });
    };
    DateFnsUtils.prototype.isEqual = function(date, comparing) {
        if (date === null && comparing === null) return true;
        return (0, $97070a28069e3122$export$2e2bcd8739ae039)(date, comparing);
    };
    DateFnsUtils.prototype.isNull = function(date) {
        return date === null;
    };
    DateFnsUtils.prototype.isAfterDay = function(date, value) {
        return (0, $631e89b11c52a04d$export$2e2bcd8739ae039)(date, (0, $b41cd926fb210479$export$2e2bcd8739ae039)(value));
    };
    DateFnsUtils.prototype.isBeforeDay = function(date, value) {
        return (0, $b2187ab4762b4275$export$2e2bcd8739ae039)(date, (0, $e6a4269ef9109615$export$2e2bcd8739ae039)(value));
    };
    DateFnsUtils.prototype.isBeforeYear = function(date, value) {
        return (0, $b2187ab4762b4275$export$2e2bcd8739ae039)(date, (0, $2464cccf40987654$export$2e2bcd8739ae039)(value));
    };
    DateFnsUtils.prototype.isAfterYear = function(date, value) {
        return (0, $631e89b11c52a04d$export$2e2bcd8739ae039)(date, (0, $92ec91e13400f9c7$export$2e2bcd8739ae039)(value));
    };
    DateFnsUtils.prototype.formatNumber = function(numberToFormat) {
        return numberToFormat;
    };
    DateFnsUtils.prototype.getMinutes = function(date) {
        return date.getMinutes();
    };
    DateFnsUtils.prototype.getMonth = function(date) {
        return date.getMonth();
    };
    DateFnsUtils.prototype.setMonth = function(date, count) {
        return (0, $8f8d9da5a252812a$export$2e2bcd8739ae039)(date, count);
    };
    DateFnsUtils.prototype.getMeridiemText = function(ampm) {
        return ampm === "am" ? "AM" : "PM";
    };
    DateFnsUtils.prototype.getNextMonth = function(date) {
        return (0, $251ada10bcd026d4$export$2e2bcd8739ae039)(date, 1);
    };
    DateFnsUtils.prototype.getPreviousMonth = function(date) {
        return (0, $251ada10bcd026d4$export$2e2bcd8739ae039)(date, -1);
    };
    DateFnsUtils.prototype.getMonthArray = function(date) {
        var firstMonth = (0, $2464cccf40987654$export$2e2bcd8739ae039)(date);
        var monthArray = [
            firstMonth
        ];
        while(monthArray.length < 12){
            var prevMonth = monthArray[monthArray.length - 1];
            monthArray.push(this.getNextMonth(prevMonth));
        }
        return monthArray;
    };
    DateFnsUtils.prototype.mergeDateAndTime = function(date, time) {
        return this.setMinutes(this.setHours(date, this.getHours(time)), this.getMinutes(time));
    };
    DateFnsUtils.prototype.getWeekdays = function() {
        var _this = this;
        var now = new Date();
        return (0, $1472a79476010e3e$export$2e2bcd8739ae039)({
            start: (0, $5488454aaf7f20df$export$2e2bcd8739ae039)(now, {
                locale: this.locale
            }),
            end: (0, $9abb06d30e4596ee$export$2e2bcd8739ae039)(now, {
                locale: this.locale
            })
        }).map(function(day) {
            return _this.format(day, "EEEEEE");
        });
    };
    DateFnsUtils.prototype.getWeekArray = function(date) {
        var start = (0, $5488454aaf7f20df$export$2e2bcd8739ae039)((0, $0bc3585debf50d81$export$2e2bcd8739ae039)(date), {
            locale: this.locale
        });
        var end = (0, $9abb06d30e4596ee$export$2e2bcd8739ae039)((0, $a67730ad06e0214f$export$2e2bcd8739ae039)(date), {
            locale: this.locale
        });
        var count = 0;
        var current = start;
        var nestedWeeks = [];
        while((0, $b2187ab4762b4275$export$2e2bcd8739ae039)(current, end)){
            var weekNumber = Math.floor(count / 7);
            nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
            nestedWeeks[weekNumber].push(current);
            current = (0, $8a04c0440b7e21a7$export$2e2bcd8739ae039)(current, 1);
            count += 1;
        }
        return nestedWeeks;
    };
    DateFnsUtils.prototype.getYearRange = function(start, end) {
        var startDate = (0, $2464cccf40987654$export$2e2bcd8739ae039)(start);
        var endDate = (0, $92ec91e13400f9c7$export$2e2bcd8739ae039)(end);
        var years = [];
        var current = startDate;
        while((0, $b2187ab4762b4275$export$2e2bcd8739ae039)(current, endDate)){
            years.push(current);
            current = (0, $54fc8ed9cfae127f$export$2e2bcd8739ae039)(current, 1);
        }
        return years;
    };
    // displaying methpds
    DateFnsUtils.prototype.getCalendarHeaderText = function(date) {
        return this.format(date, this.yearMonthFormat);
    };
    DateFnsUtils.prototype.getYearText = function(date) {
        return this.format(date, "yyyy");
    };
    DateFnsUtils.prototype.getDatePickerHeaderText = function(date) {
        return this.format(date, "EEE, MMM d");
    };
    DateFnsUtils.prototype.getDateTimePickerHeaderText = function(date) {
        return this.format(date, "MMM d");
    };
    DateFnsUtils.prototype.getMonthText = function(date) {
        return this.format(date, "MMMM");
    };
    DateFnsUtils.prototype.getDayText = function(date) {
        return this.format(date, "d");
    };
    DateFnsUtils.prototype.getHourText = function(date, ampm) {
        return this.format(date, ampm ? "hh" : "HH");
    };
    DateFnsUtils.prototype.getMinuteText = function(date) {
        return this.format(date, "mm");
    };
    DateFnsUtils.prototype.getSecondText = function(date) {
        return this.format(date, "ss");
    };
    return DateFnsUtils;
}();
var $dd12c932fd8737b5$export$2e2bcd8739ae039 = $dd12c932fd8737b5$var$DateFnsUtils;









var $d2vKa = parcelRequire("d2vKa");

var $Fo7oF = parcelRequire("Fo7oF");


var $Fo7oF = parcelRequire("Fo7oF");

var $3e8620cba75a223b$export$407448d2b89b1813 = (0, $Fo7oF.createContext)(null);
var $3e8620cba75a223b$export$3a1a48c8f6ef640e = function MuiPickersUtilsProvider(_ref) {
    var Utils = _ref.utils, children = _ref.children, locale = _ref.locale, libInstance = _ref.libInstance;
    var utils = (0, $Fo7oF.useMemo)(function() {
        return new Utils({
            locale: locale,
            instance: libInstance
        });
    }, [
        Utils,
        libInstance,
        locale
    ]);
    return (0, $Fo7oF.createElement)($3e8620cba75a223b$export$407448d2b89b1813.Provider, {
        value: utils,
        children: children
    });
};
var $3e8620cba75a223b$var$checkUtils = function checkUtils(utils) {
    if (!utils) // tslint:disable-next-line
    throw new Error('Can not find utils in context. You either a) forgot to wrap your component tree in MuiPickersUtilsProvider; or b) mixed named and direct file imports.  Recommendation: use named imports from the module index.');
};
function $3e8620cba75a223b$export$3b14a55fb2447963() {
    var utils = (0, $Fo7oF.useContext)($3e8620cba75a223b$export$407448d2b89b1813);
    $3e8620cba75a223b$var$checkUtils(utils);
    return utils;
}



var $78z8j = parcelRequire("78z8j");
parcelRequire("elnlQ");
parcelRequire("67mp8");



var $d2vKa = parcelRequire("d2vKa");

var $Fo7oF = parcelRequire("Fo7oF");



var $78z8j = parcelRequire("78z8j");

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

function $e03a8ffda104b7a5$export$2e2bcd8739ae039(styles) {
    return styles;
}


function $96c662afe0eabd27$export$2e2bcd8739ae039(styles) {
    // warning(
    //   warnOnce,
    //   [
    //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
    //     'Please use @material-ui/styles/createStyles',
    //   ].join('\n'),
    // );
    // warnOnce = true;
    return (0, $e03a8ffda104b7a5$export$2e2bcd8739ae039)(styles);
}


var $8Hh6N = parcelRequire("8Hh6N");
var $5rVgt = parcelRequire("5rVgt");



var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $5rVgt = parcelRequire("5rVgt");





/** Use it instead of .includes method for IE support */ function $0ac5014ff7821bc1$export$407448d2b89b1813(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every(function(item) {
        return array.indexOf(item) !== -1;
    });
    return array.indexOf(itemOrItems) !== -1;
}
var $0ac5014ff7821bc1$export$96f57966bedc81b4 = 310;
var $0ac5014ff7821bc1$export$db3b6bfb95261072 = 325;
var $0ac5014ff7821bc1$export$8b22cf2602fb60ce = 305;
var $0ac5014ff7821bc1$var$useStyles = (0, $43f27ed29b5bb141$export$2e2bcd8739ae039)(function(theme) {
    return {
        staticWrapperRoot: {
            overflow: 'hidden',
            minWidth: $0ac5014ff7821bc1$export$96f57966bedc81b4,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: theme.palette.background.paper
        }
    };
}, {
    name: 'MuiPickersStaticWrapper'
});
var $0ac5014ff7821bc1$var$StaticWrapper = function StaticWrapper(_ref) {
    var children = _ref.children;
    var classes = $0ac5014ff7821bc1$var$useStyles();
    return (0, $Fo7oF.createElement)("div", {
        className: classes.staticWrapperRoot,
        children: children
    });
};
var $0ac5014ff7821bc1$var$ModalDialog = function ModalDialog(_ref) {
    var children = _ref.children, classes = _ref.classes, onAccept = _ref.onAccept, onDismiss = _ref.onDismiss, onClear = _ref.onClear, onSetToday = _ref.onSetToday, okLabel = _ref.okLabel, cancelLabel = _ref.cancelLabel, clearLabel = _ref.clearLabel, todayLabel = _ref.todayLabel, clearable = _ref.clearable, showTodayButton = _ref.showTodayButton, showTabs = _ref.showTabs, wider = _ref.wider, other = (0, $67mp8.default)(_ref, [
        "children",
        "classes",
        "onAccept",
        "onDismiss",
        "onClear",
        "onSetToday",
        "okLabel",
        "cancelLabel",
        "clearLabel",
        "todayLabel",
        "clearable",
        "showTodayButton",
        "showTabs",
        "wider"
    ]);
    return (0, $Fo7oF.createElement)((0, $06c828c7d8d76aa9$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        role: "dialog",
        onClose: onDismiss,
        classes: {
            paper: (0, $78z8j.default)(classes.dialogRoot, wider && classes.dialogRootWider)
        }
    }, other), (0, $Fo7oF.createElement)((0, $1c55bad717a43115$export$2e2bcd8739ae039), {
        children: children,
        className: classes.dialog
    }), (0, $Fo7oF.createElement)((0, $1b29532bd4542510$export$2e2bcd8739ae039), {
        classes: {
            root: (0, $78z8j.default)((clearable || showTodayButton) && classes.withAdditionalAction)
        }
    }, clearable && (0, $Fo7oF.createElement)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
        color: "primary",
        onClick: onClear
    }, clearLabel), showTodayButton && (0, $Fo7oF.createElement)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
        color: "primary",
        onClick: onSetToday
    }, todayLabel), cancelLabel && (0, $Fo7oF.createElement)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
        color: "primary",
        onClick: onDismiss
    }, cancelLabel), okLabel && (0, $Fo7oF.createElement)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
        color: "primary",
        onClick: onAccept
    }, okLabel)));
};
$0ac5014ff7821bc1$var$ModalDialog.displayName = 'ModalDialog';
var $0ac5014ff7821bc1$var$styles = (0, $96c662afe0eabd27$export$2e2bcd8739ae039)({
    dialogRoot: {
        minWidth: $0ac5014ff7821bc1$export$96f57966bedc81b4
    },
    dialogRootWider: {
        minWidth: $0ac5014ff7821bc1$export$db3b6bfb95261072
    },
    dialog: {
        '&:first-child': {
            padding: 0
        }
    },
    withAdditionalAction: {
        // set justifyContent to default value to fix IE11 layout bug
        // see https://github.com/dmtrKovalenko/material-ui-pickers/pull/267
        justifyContent: 'flex-start',
        '& > *:first-child': {
            marginRight: 'auto'
        }
    }
});
var $0ac5014ff7821bc1$var$ModalDialog$1 = (0, $5rVgt.default)($0ac5014ff7821bc1$var$styles, {
    name: 'MuiPickersModal'
})($0ac5014ff7821bc1$var$ModalDialog);
var $0ac5014ff7821bc1$export$3b14a55fb2447963 = typeof window === 'undefined' ? (0, $Fo7oF.useEffect) : (0, $Fo7oF.useLayoutEffect);
function $0ac5014ff7821bc1$export$43caf9889c228507(e, keyHandlers) {
    var handler = keyHandlers[e.key];
    if (handler) {
        handler(); // if event was handled prevent other side effects (e.g. page scroll)
        e.preventDefault();
    }
}
function $0ac5014ff7821bc1$var$useKeyDown(active, keyHandlers) {
    var keyHandlersRef = (0, $Fo7oF.useRef)(keyHandlers);
    keyHandlersRef.current = keyHandlers;
    $0ac5014ff7821bc1$export$3b14a55fb2447963(function() {
        if (active) {
            var handleKeyDown = function handleKeyDown(event) {
                $0ac5014ff7821bc1$export$43caf9889c228507(event, keyHandlersRef.current);
            };
            window.addEventListener('keydown', handleKeyDown);
            return function() {
                window.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [
        active
    ]);
}
var $0ac5014ff7821bc1$var$ModalWrapper = function ModalWrapper(_ref) {
    var open = _ref.open, children = _ref.children, okLabel = _ref.okLabel, cancelLabel = _ref.cancelLabel, clearLabel = _ref.clearLabel, todayLabel = _ref.todayLabel, showTodayButton = _ref.showTodayButton, clearable = _ref.clearable, DialogProps = _ref.DialogProps, showTabs = _ref.showTabs, wider = _ref.wider, InputComponent = _ref.InputComponent, DateInputProps = _ref.DateInputProps, onClear = _ref.onClear, onAccept = _ref.onAccept, onDismiss = _ref.onDismiss, onSetToday = _ref.onSetToday, other = (0, $67mp8.default)(_ref, [
        "open",
        "children",
        "okLabel",
        "cancelLabel",
        "clearLabel",
        "todayLabel",
        "showTodayButton",
        "clearable",
        "DialogProps",
        "showTabs",
        "wider",
        "InputComponent",
        "DateInputProps",
        "onClear",
        "onAccept",
        "onDismiss",
        "onSetToday"
    ]);
    $0ac5014ff7821bc1$var$useKeyDown(open, {
        Enter: onAccept
    });
    return (0, $Fo7oF.createElement)((0, $Fo7oF.Fragment), null, (0, $Fo7oF.createElement)(InputComponent, (0, $elnlQ.default)({}, other, DateInputProps)), (0, $Fo7oF.createElement)($0ac5014ff7821bc1$var$ModalDialog$1, (0, $elnlQ.default)({
        wider: wider,
        showTabs: showTabs,
        open: open,
        onClear: onClear,
        onAccept: onAccept,
        onDismiss: onDismiss,
        onSetToday: onSetToday,
        clearLabel: clearLabel,
        todayLabel: todayLabel,
        okLabel: okLabel,
        cancelLabel: cancelLabel,
        clearable: clearable,
        showTodayButton: showTodayButton,
        children: children
    }, DialogProps)));
};
$0ac5014ff7821bc1$var$ModalWrapper.defaultProps = {
    okLabel: 'OK',
    cancelLabel: 'Cancel',
    clearLabel: 'Clear',
    todayLabel: 'Today',
    clearable: false,
    showTodayButton: false
};
var $0ac5014ff7821bc1$var$InlineWrapper = function InlineWrapper(_ref) {
    var open = _ref.open, wider = _ref.wider, children = _ref.children, PopoverProps = _ref.PopoverProps, onClear = _ref.onClear, onDismiss = _ref.onDismiss, onSetToday = _ref.onSetToday, onAccept = _ref.onAccept, showTabs = _ref.showTabs, DateInputProps = _ref.DateInputProps, InputComponent = _ref.InputComponent, other = (0, $67mp8.default)(_ref, [
        "open",
        "wider",
        "children",
        "PopoverProps",
        "onClear",
        "onDismiss",
        "onSetToday",
        "onAccept",
        "showTabs",
        "DateInputProps",
        "InputComponent"
    ]);
    var ref = (0, $Fo7oF.useRef)();
    $0ac5014ff7821bc1$var$useKeyDown(open, {
        Enter: onAccept
    });
    return (0, $Fo7oF.createElement)((0, $Fo7oF.Fragment), null, (0, $Fo7oF.createElement)(InputComponent, (0, $elnlQ.default)({}, other, DateInputProps, {
        inputRef: ref
    })), (0, $Fo7oF.createElement)((0, $41ed658adbcb63fb$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        open: open,
        onClose: onDismiss,
        anchorEl: ref.current,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
        },
        children: children
    }, PopoverProps)));
};
function $0ac5014ff7821bc1$var$getWrapperFromVariant(variant) {
    switch(variant){
        case 'inline':
            return $0ac5014ff7821bc1$var$InlineWrapper;
        case 'static':
            return $0ac5014ff7821bc1$var$StaticWrapper;
        default:
            return $0ac5014ff7821bc1$var$ModalWrapper;
    }
}
var $0ac5014ff7821bc1$export$e7c866399fa523f5 = (0, $Fo7oF.createContext)(null);
var $0ac5014ff7821bc1$export$71cec2538cb2c617 = function Wrapper(_ref) {
    var variant = _ref.variant, props = (0, $67mp8.default)(_ref, [
        "variant"
    ]);
    var Component = $0ac5014ff7821bc1$var$getWrapperFromVariant(variant);
    return (0, $Fo7oF.createElement)($0ac5014ff7821bc1$export$e7c866399fa523f5.Provider, {
        value: variant || 'dialog'
    }, (0, $Fo7oF.createElement)(Component, props));
};





var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");


var $5rVgt = parcelRequire("5rVgt");

var $e8c9d2e5a94efd65$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'flex',
        height: '0.01em',
        // Fix IE 11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap'
    },
    /* Styles applied to the root element if `variant="filled"`. */ filled: {
        '&$positionStart:not($hiddenLabel)': {
            marginTop: 16
        }
    },
    /* Styles applied to the root element if `position="start"`. */ positionStart: {
        marginRight: 8
    },
    /* Styles applied to the root element if `position="end"`. */ positionEnd: {
        marginLeft: 8
    },
    /* Styles applied to the root element if `disablePointerEvents=true`. */ disablePointerEvents: {
        pointerEvents: 'none'
    },
    /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */ hiddenLabel: {},
    /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */ marginDense: {}
};
var $e8c9d2e5a94efd65$var$InputAdornment = /*#__PURE__*/ $Fo7oF.forwardRef(function InputAdornment(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disablePointer = props.disablePointerEvents, disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, position = props.position, variantProp = props.variant, other = (0, $67mp8.default)(props, [
        "children",
        "classes",
        "className",
        "component",
        "disablePointerEvents",
        "disableTypography",
        "position",
        "variant"
    ]);
    var muiFormControl = (0, $8d9862aa244cad11$export$62ecd8ad1bbe1a18)() || {};
    var variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    return /*#__PURE__*/ $Fo7oF.createElement((0, $8d9862aa244cad11$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className, position === 'end' ? classes.positionEnd : classes.positionStart, disablePointerEvents && classes.disablePointerEvents, muiFormControl.hiddenLabel && classes.hiddenLabel, variant === 'filled' && classes.filled, muiFormControl.margin === 'dense' && classes.marginDense),
        ref: ref
    }, other), typeof children === 'string' && !disableTypography ? /*#__PURE__*/ $Fo7oF.createElement((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
        color: "textSecondary"
    }, children) : children));
});
var $e8c9d2e5a94efd65$export$2e2bcd8739ae039 = (0, $5rVgt.default)($e8c9d2e5a94efd65$export$9dd6ff9ea0189349, {
    name: 'MuiInputAdornment'
})($e8c9d2e5a94efd65$var$InputAdornment);



var $bLCcc = parcelRequire("bLCcc");

var $Fo7oF = parcelRequire("Fo7oF");
var $5293dfd67851a7a7$export$5519909ee832c7c = /*#__PURE__*/ function(_React$Component) {
    (0, $bLCcc.default)(Rifm, _React$Component);
    function Rifm(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this._state = null;
        _this._del = false;
        _this._handleChange = function(evt) {
            var stateValue = _this.state.value;
            var value = evt.target.value;
            var input = evt.target;
            var op = value.length > stateValue.length;
            var del = _this._del;
            var noOp = stateValue === _this.props.format(value);
            _this.setState({
                value: value,
                local: true
            }, function() {
                var selectionStart = input.selectionStart;
                var refuse = _this.props.refuse || /[^\d]+/g;
                var before = value.substr(0, selectionStart).replace(refuse, '');
                _this._state = {
                    input: input,
                    before: before,
                    op: op,
                    di: del && noOp,
                    del: del
                };
                if (_this.props.replace && _this.props.replace(stateValue) && op && !noOp) {
                    var start = -1;
                    for(var i = 0; i !== before.length; ++i)start = Math.max(start, value.toLowerCase().indexOf(before[i].toLowerCase(), start + 1));
                    var c = value.substr(start + 1).replace(refuse, '')[0];
                    start = value.indexOf(c, start + 1);
                    value = "" + value.substr(0, start) + value.substr(start + 1);
                }
                var fv = _this.props.format(value);
                if (stateValue === fv) _this.setState({
                    value: value
                });
                else _this.props.onChange(fv);
            });
        };
        _this._hKD = function(evt) {
            if (evt.code === 'Delete') _this._del = true;
        };
        _this._hKU = function(evt) {
            if (evt.code === 'Delete') _this._del = false;
        };
        _this.state = {
            value: props.value,
            local: true
        };
        return _this;
    }
    Rifm.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        return {
            value: state.local ? state.value : props.value,
            local: false
        };
    };
    var _proto = Rifm.prototype;
    _proto.render = function render() {
        var _handleChange = this._handleChange, value = this.state.value, children = this.props.children;
        return children({
            value: value,
            onChange: _handleChange
        });
    } // delete when  https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported by all major browsers
    ;
    _proto.componentWillUnmount = function componentWillUnmount() {
        document.removeEventListener('keydown', this._hKD);
        document.removeEventListener('keyup', this._hKU);
    } // delete when  https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported by all major browsers
    ;
    _proto.componentDidMount = function componentDidMount() {
        document.addEventListener('keydown', this._hKD);
        document.addEventListener('keyup', this._hKU);
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
        var _state = this._state;
        if (_state) {
            var value = this.state.value;
            var start = -1;
            for(var i = 0; i !== _state.before.length; ++i)start = Math.max(start, value.toLowerCase().indexOf(_state.before[i].toLowerCase(), start + 1));
             // format usually looks better without this
            if (this.props.replace && (_state.op || _state.del && !_state.di)) while(value[start + 1] && (this.props.refuse || /[^\d]+/).test(value[start + 1]))start += 1;
            _state.input.selectionStart = _state.input.selectionEnd = start + 1 + (_state.di ? 1 : 0);
        }
        this._state = null;
    };
    return Rifm;
}((0, $Fo7oF.Component));



var $72Yet = parcelRequire("72Yet");

var $8YHhK = parcelRequire("8YHhK");

var $d2vKa = parcelRequire("d2vKa");

var $Fo7oF = parcelRequire("Fo7oF");

var $d2bgE = parcelRequire("d2bgE");


var $78z8j = parcelRequire("78z8j");

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");




var $Fo7oF = parcelRequire("Fo7oF");



var $78z8j = parcelRequire("78z8j");

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");


var $5rVgt = parcelRequire("5rVgt");



var $72Yet = parcelRequire("72Yet");


var $fxzEt = parcelRequire("fxzEt");




var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");



var $7640f7b3a0a7eca0$export$28e6b9b82ee883c = (0, $43f27ed29b5bb141$export$2e2bcd8739ae039)(function(theme) {
    return {
        day: {
            width: 36,
            height: 36,
            fontSize: theme.typography.caption.fontSize,
            margin: '0 2px',
            color: theme.palette.text.primary,
            fontWeight: theme.typography.fontWeightMedium,
            padding: 0
        },
        hidden: {
            opacity: 0,
            pointerEvents: 'none'
        },
        current: {
            color: theme.palette.primary.main,
            fontWeight: 600
        },
        daySelected: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            '&:hover': {
                backgroundColor: theme.palette.primary.main
            }
        },
        dayDisabled: {
            pointerEvents: 'none',
            color: theme.palette.text.hint
        }
    };
}, {
    name: 'MuiPickersDay'
});
var $7640f7b3a0a7eca0$export$7a9a31a911eb9a20 = function Day(_ref) {
    var children = _ref.children, disabled = _ref.disabled, hidden = _ref.hidden, current = _ref.current, selected = _ref.selected, other = (0, $67mp8.default)(_ref, [
        "children",
        "disabled",
        "hidden",
        "current",
        "selected"
    ]);
    var classes = $7640f7b3a0a7eca0$export$28e6b9b82ee883c();
    var className = (0, $78z8j.default)(classes.day, hidden && classes.hidden, current && classes.current, selected && classes.daySelected, disabled && classes.dayDisabled);
    return (0, $Fo7oF.createElement)((0, $c6e28b9de0df1599$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        className: className,
        tabIndex: hidden || disabled ? -1 : 0
    }, other), (0, $Fo7oF.createElement)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
        variant: "body2",
        color: "inherit"
    }, children));
};
$7640f7b3a0a7eca0$export$7a9a31a911eb9a20.displayName = 'Day';
$7640f7b3a0a7eca0$export$7a9a31a911eb9a20.defaultProps = {
    disabled: false,
    hidden: false,
    current: false,
    selected: false
};
var $7640f7b3a0a7eca0$export$2e2bcd8739ae039 = $7640f7b3a0a7eca0$export$7a9a31a911eb9a20;



var $elnlQ = parcelRequire("elnlQ");

var $fjJNR = parcelRequire("fjJNR");

var $bLCcc = parcelRequire("bLCcc");


var $78ARM = parcelRequire("78ARM");

var $PLT6M = parcelRequire("PLT6M");

var $Fo7oF = parcelRequire("Fo7oF");

var $dOG8L = parcelRequire("dOG8L");


var $9Og96 = parcelRequire("9Og96");
var $1aed266d1c99b659$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $78ARM.default)(node, c);
    });
};
var $1aed266d1c99b659$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $PLT6M.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $1aed266d1c99b659$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $bLCcc.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $9Og96.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $1aed266d1c99b659$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $1aed266d1c99b659$var$removeClass(node, baseClassName);
        if (activeClassName) $1aed266d1c99b659$var$removeClass(node, activeClassName);
        if (doneClassName) $1aed266d1c99b659$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $fjJNR.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $dOG8L.default), (0, $elnlQ.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component);
$1aed266d1c99b659$var$CSSTransition.defaultProps = {
    classNames: ''
};
$1aed266d1c99b659$var$CSSTransition.propTypes = {};
var $1aed266d1c99b659$export$2e2bcd8739ae039 = $1aed266d1c99b659$var$CSSTransition;



var $0fa1d30fe6dc6a08$var$findClosestEnabledDate = function findClosestEnabledDate(_ref) {
    var date = _ref.date, utils = _ref.utils, minDate = _ref.minDate, maxDate = _ref.maxDate, disableFuture = _ref.disableFuture, disablePast = _ref.disablePast, shouldDisableDate = _ref.shouldDisableDate;
    var today = utils.startOfDay(utils.date());
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    var forward = date;
    var backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = utils.date(minDate);
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = utils.date(maxDate);
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!shouldDisableDate(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!shouldDisableDate(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    } // fallback to today if no enabled days
    return utils.date();
};
var $0fa1d30fe6dc6a08$export$23f2a1d2818174ef = function isYearOnlyView(views) {
    return views.length === 1 && views[0] === 'year';
};
var $0fa1d30fe6dc6a08$export$8b22cf2602fb60ce = function isYearAndMonthViews(views) {
    return views.length === 2 && (0, $0ac5014ff7821bc1$export$407448d2b89b1813)(views, 'month') && (0, $0ac5014ff7821bc1$export$407448d2b89b1813)(views, 'year');
};
var $0fa1d30fe6dc6a08$export$39b482c5e57630a8 = function getFormatByViews(views, utils) {
    if ($0fa1d30fe6dc6a08$export$23f2a1d2818174ef(views)) return utils.yearFormat;
    if ($0fa1d30fe6dc6a08$export$8b22cf2602fb60ce(views)) return utils.yearMonthFormat;
    return utils.dateFormat;
};
var $0fa1d30fe6dc6a08$var$DayWrapper = function DayWrapper(_ref) {
    var children = _ref.children, value = _ref.value, disabled = _ref.disabled, onSelect = _ref.onSelect, dayInCurrentMonth = _ref.dayInCurrentMonth, other = (0, $67mp8.default)(_ref, [
        "children",
        "value",
        "disabled",
        "onSelect",
        "dayInCurrentMonth"
    ]);
    var handleClick = (0, $Fo7oF.useCallback)(function() {
        return onSelect(value);
    }, [
        onSelect,
        value
    ]);
    return (0, $Fo7oF.createElement)("div", (0, $elnlQ.default)({
        role: "presentation",
        onClick: dayInCurrentMonth && !disabled ? handleClick : undefined,
        onKeyPress: dayInCurrentMonth && !disabled ? handleClick : undefined
    }, other), children);
};
var $0fa1d30fe6dc6a08$var$animationDuration = 350;
var $0fa1d30fe6dc6a08$var$useStyles = (0, $43f27ed29b5bb141$export$2e2bcd8739ae039)(function(theme) {
    var slideTransition = theme.transitions.create('transform', {
        duration: $0fa1d30fe6dc6a08$var$animationDuration,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        transitionContainer: {
            display: 'block',
            position: 'relative',
            '& > *': {
                position: 'absolute',
                top: 0,
                right: 0,
                left: 0
            }
        },
        'slideEnter-left': {
            willChange: 'transform',
            transform: 'translate(100%)'
        },
        'slideEnter-right': {
            willChange: 'transform',
            transform: 'translate(-100%)'
        },
        slideEnterActive: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        slideExit: {
            transform: 'translate(0%)'
        },
        'slideExitActiveLeft-left': {
            willChange: 'transform',
            transform: 'translate(-200%)',
            transition: slideTransition
        },
        'slideExitActiveLeft-right': {
            willChange: 'transform',
            transform: 'translate(200%)',
            transition: slideTransition
        }
    };
}, {
    name: 'MuiPickersSlideTransition'
});
var $0fa1d30fe6dc6a08$var$SlideTransition = function SlideTransition(_ref) {
    var children = _ref.children, transKey = _ref.transKey, slideDirection = _ref.slideDirection, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className;
    var classes = $0fa1d30fe6dc6a08$var$useStyles();
    var transitionClasses = {
        exit: classes.slideExit,
        enterActive: classes.slideEnterActive,
        // @ts-ignore
        enter: classes['slideEnter-' + slideDirection],
        // @ts-ignore
        exitActive: classes['slideExitActiveLeft-' + slideDirection]
    };
    return (0, $Fo7oF.createElement)((0, $7568199b92ec00e5$export$2e2bcd8739ae039), {
        className: (0, $78z8j.default)(classes.transitionContainer, className),
        childFactory: function childFactory(element) {
            return (0, $Fo7oF.cloneElement)(element, {
                classNames: transitionClasses
            });
        }
    }, (0, $Fo7oF.createElement)((0, $1aed266d1c99b659$export$2e2bcd8739ae039), {
        mountOnEnter: true,
        unmountOnExit: true,
        key: transKey + slideDirection,
        timeout: $0fa1d30fe6dc6a08$var$animationDuration,
        classNames: transitionClasses,
        children: children
    }));
};
var $0fa1d30fe6dc6a08$var$ArrowLeftIcon = function ArrowLeftIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $72Yet.default), props, (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("path", {
        d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0V0z"
    }));
};
var $0fa1d30fe6dc6a08$var$ArrowRightIcon = function ArrowRightIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $72Yet.default), props, (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("path", {
        d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0V0z"
    }));
};
var $0fa1d30fe6dc6a08$var$useStyles$1 = (0, $43f27ed29b5bb141$export$2e2bcd8739ae039)(function(theme) {
    return {
        switchHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: theme.spacing(0.5),
            marginBottom: theme.spacing(1)
        },
        transitionContainer: {
            width: '100%',
            overflow: 'hidden',
            height: 23
        },
        iconButton: {
            zIndex: 1,
            backgroundColor: theme.palette.background.paper
        },
        daysHeader: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: 16
        },
        dayLabel: {
            width: 36,
            margin: '0 2px',
            textAlign: 'center',
            color: theme.palette.text.hint
        }
    };
}, {
    name: 'MuiPickersCalendarHeader'
});
var $0fa1d30fe6dc6a08$var$CalendarHeader = function CalendarHeader(_ref) {
    var currentMonth = _ref.currentMonth, onMonthChange = _ref.onMonthChange, leftArrowIcon = _ref.leftArrowIcon, rightArrowIcon = _ref.rightArrowIcon, leftArrowButtonProps = _ref.leftArrowButtonProps, rightArrowButtonProps = _ref.rightArrowButtonProps, disablePrevMonth = _ref.disablePrevMonth, disableNextMonth = _ref.disableNextMonth, slideDirection = _ref.slideDirection;
    var utils = (0, $3e8620cba75a223b$export$3b14a55fb2447963)();
    var classes = $0fa1d30fe6dc6a08$var$useStyles$1();
    var theme = (0, $c6db41e315144c8b$export$2e2bcd8739ae039)();
    var rtl = theme.direction === 'rtl';
    var selectNextMonth = function selectNextMonth() {
        return onMonthChange(utils.getNextMonth(currentMonth), 'left');
    };
    var selectPreviousMonth = function selectPreviousMonth() {
        return onMonthChange(utils.getPreviousMonth(currentMonth), 'right');
    };
    return (0, $Fo7oF.createElement)("div", null, (0, $Fo7oF.createElement)("div", {
        className: classes.switchHeader
    }, (0, $Fo7oF.createElement)((0, $c6e28b9de0df1599$export$2e2bcd8739ae039), (0, $elnlQ.default)({}, leftArrowButtonProps, {
        disabled: disablePrevMonth,
        onClick: selectPreviousMonth,
        className: classes.iconButton
    }), rtl ? rightArrowIcon : leftArrowIcon), (0, $Fo7oF.createElement)($0fa1d30fe6dc6a08$var$SlideTransition, {
        slideDirection: slideDirection,
        transKey: currentMonth.toString(),
        className: classes.transitionContainer
    }, (0, $Fo7oF.createElement)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
        align: "center",
        variant: "body1"
    }, utils.getCalendarHeaderText(currentMonth))), (0, $Fo7oF.createElement)((0, $c6e28b9de0df1599$export$2e2bcd8739ae039), (0, $elnlQ.default)({}, rightArrowButtonProps, {
        disabled: disableNextMonth,
        onClick: selectNextMonth,
        className: classes.iconButton
    }), rtl ? leftArrowIcon : rightArrowIcon)), (0, $Fo7oF.createElement)("div", {
        className: classes.daysHeader
    }, utils.getWeekdays().map(function(day, index) {
        return (0, $Fo7oF.createElement)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
            key: index // eslint-disable-line react/no-array-index-key
            ,
            variant: "caption",
            className: classes.dayLabel
        }, day);
    })));
};
$0fa1d30fe6dc6a08$var$CalendarHeader.displayName = 'CalendarHeader';
$0fa1d30fe6dc6a08$var$CalendarHeader.defaultProps = {
    leftArrowIcon: (0, $Fo7oF.createElement)($0fa1d30fe6dc6a08$var$ArrowLeftIcon, null),
    rightArrowIcon: (0, $Fo7oF.createElement)($0fa1d30fe6dc6a08$var$ArrowRightIcon, null),
    disablePrevMonth: false,
    disableNextMonth: false
};
var $0fa1d30fe6dc6a08$var$withUtils = function withUtils() {
    return function(Component) {
        var WithUtils = function WithUtils(props) {
            var utils = (0, $3e8620cba75a223b$export$3b14a55fb2447963)();
            return (0, $Fo7oF.createElement)(Component, (0, $elnlQ.default)({
                utils: utils
            }, props));
        };
        WithUtils.displayName = "WithUtils(".concat(Component.displayName || Component.name, ")");
        return WithUtils;
    };
};
var $0fa1d30fe6dc6a08$var$KeyDownListener = function KeyDownListener(_ref) {
    var onKeyDown = _ref.onKeyDown;
    (0, $Fo7oF.useEffect)(function() {
        window.addEventListener('keydown', onKeyDown);
        return function() {
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [
        onKeyDown
    ]);
    return null;
};
var $0fa1d30fe6dc6a08$export$e7094788287c5e9b = /*#__PURE__*/ function(_React$Component) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(Calendar, _React$Component);
    function Calendar() {
        var _getPrototypeOf2;
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, Calendar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $03e7eaefdaf85d7c$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $17c9b9cedb1b1791$export$2e2bcd8739ae039)(Calendar)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _this.state = {
            slideDirection: 'left',
            currentMonth: _this.props.utils.startOfMonth(_this.props.date),
            loadingQueue: 0
        };
        _this.pushToLoadingQueue = function() {
            var loadingQueue = _this.state.loadingQueue + 1;
            _this.setState({
                loadingQueue: loadingQueue
            });
        };
        _this.popFromLoadingQueue = function() {
            var loadingQueue = _this.state.loadingQueue;
            loadingQueue = loadingQueue <= 0 ? 0 : loadingQueue - 1;
            _this.setState({
                loadingQueue: loadingQueue
            });
        };
        _this.handleChangeMonth = function(newMonth, slideDirection) {
            _this.setState({
                currentMonth: newMonth,
                slideDirection: slideDirection
            });
            if (_this.props.onMonthChange) {
                var returnVal = _this.props.onMonthChange(newMonth);
                if (returnVal) {
                    _this.pushToLoadingQueue();
                    returnVal.then(function() {
                        _this.popFromLoadingQueue();
                    });
                }
            }
        };
        _this.validateMinMaxDate = function(day) {
            var _this$props = _this.props, minDate = _this$props.minDate, maxDate = _this$props.maxDate, utils = _this$props.utils, disableFuture = _this$props.disableFuture, disablePast = _this$props.disablePast;
            var now = utils.date();
            return Boolean(disableFuture && utils.isAfterDay(day, now) || disablePast && utils.isBeforeDay(day, now) || minDate && utils.isBeforeDay(day, utils.date(minDate)) || maxDate && utils.isAfterDay(day, utils.date(maxDate)));
        };
        _this.shouldDisablePrevMonth = function() {
            var _this$props2 = _this.props, utils = _this$props2.utils, disablePast = _this$props2.disablePast, minDate = _this$props2.minDate;
            var now = utils.date();
            var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utils.date(minDate)) ? now : utils.date(minDate));
            return !utils.isBefore(firstEnabledMonth, _this.state.currentMonth);
        };
        _this.shouldDisableNextMonth = function() {
            var _this$props3 = _this.props, utils = _this$props3.utils, disableFuture = _this$props3.disableFuture, maxDate = _this$props3.maxDate;
            var now = utils.date();
            var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utils.date(maxDate)) ? now : utils.date(maxDate));
            return !utils.isAfter(lastEnabledMonth, _this.state.currentMonth);
        };
        _this.shouldDisableDate = function(day) {
            var shouldDisableDate = _this.props.shouldDisableDate;
            return _this.validateMinMaxDate(day) || Boolean(shouldDisableDate && shouldDisableDate(day));
        };
        _this.handleDaySelect = function(day) {
            var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            var _this$props4 = _this.props, date = _this$props4.date, utils = _this$props4.utils;
            _this.props.onChange(utils.mergeDateAndTime(day, date), isFinish);
        };
        _this.moveToDay = function(day) {
            var utils = _this.props.utils;
            if (day && !_this.shouldDisableDate(day)) {
                if (utils.getMonth(day) !== utils.getMonth(_this.state.currentMonth)) _this.handleChangeMonth(utils.startOfMonth(day), 'left');
                _this.handleDaySelect(day, false);
            }
        };
        _this.handleKeyDown = function(event) {
            var _this$props5 = _this.props, theme = _this$props5.theme, date = _this$props5.date, utils = _this$props5.utils;
            (0, $0ac5014ff7821bc1$export$43caf9889c228507)(event, {
                ArrowUp: function ArrowUp() {
                    return _this.moveToDay(utils.addDays(date, -7));
                },
                ArrowDown: function ArrowDown() {
                    return _this.moveToDay(utils.addDays(date, 7));
                },
                ArrowLeft: function ArrowLeft() {
                    return _this.moveToDay(utils.addDays(date, theme.direction === 'ltr' ? -1 : 1));
                },
                ArrowRight: function ArrowRight() {
                    return _this.moveToDay(utils.addDays(date, theme.direction === 'ltr' ? 1 : -1));
                }
            });
        };
        _this.renderWeeks = function() {
            var _this$props6 = _this.props, utils = _this$props6.utils, classes = _this$props6.classes;
            var weeks = utils.getWeekArray(_this.state.currentMonth);
            return weeks.map(function(week) {
                return (0, $Fo7oF.createElement)("div", {
                    key: "week-".concat(week[0].toString()),
                    className: classes.week
                }, _this.renderDays(week));
            });
        };
        _this.renderDays = function(week) {
            var _this$props7 = _this.props, date = _this$props7.date, renderDay = _this$props7.renderDay, utils = _this$props7.utils;
            var now = utils.date();
            var selectedDate = utils.startOfDay(date);
            var currentMonthNumber = utils.getMonth(_this.state.currentMonth);
            return week.map(function(day) {
                var disabled = _this.shouldDisableDate(day);
                var isDayInCurrentMonth = utils.getMonth(day) === currentMonthNumber;
                var dayComponent = (0, $Fo7oF.createElement)((0, $7640f7b3a0a7eca0$export$2e2bcd8739ae039), {
                    disabled: disabled,
                    current: utils.isSameDay(day, now),
                    hidden: !isDayInCurrentMonth,
                    selected: utils.isSameDay(selectedDate, day)
                }, utils.getDayText(day));
                if (renderDay) dayComponent = renderDay(day, selectedDate, isDayInCurrentMonth, dayComponent);
                return (0, $Fo7oF.createElement)($0fa1d30fe6dc6a08$var$DayWrapper, {
                    value: day,
                    key: day.toString(),
                    disabled: disabled,
                    dayInCurrentMonth: isDayInCurrentMonth,
                    onSelect: _this.handleDaySelect
                }, dayComponent);
            });
        };
        return _this;
    }
    (0, $fxzEt.default)(Calendar, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props8 = this.props, date = _this$props8.date, minDate = _this$props8.minDate, maxDate = _this$props8.maxDate, utils = _this$props8.utils, disablePast = _this$props8.disablePast, disableFuture = _this$props8.disableFuture;
                if (this.shouldDisableDate(date)) {
                    var closestEnabledDate = $0fa1d30fe6dc6a08$var$findClosestEnabledDate({
                        date: date,
                        utils: utils,
                        minDate: utils.date(minDate),
                        maxDate: utils.date(maxDate),
                        disablePast: Boolean(disablePast),
                        disableFuture: Boolean(disableFuture),
                        shouldDisableDate: this.shouldDisableDate
                    });
                    this.handleDaySelect(closestEnabledDate, false);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$state = this.state, currentMonth = _this$state.currentMonth, slideDirection = _this$state.slideDirection;
                var _this$props9 = this.props, classes = _this$props9.classes, allowKeyboardControl = _this$props9.allowKeyboardControl, leftArrowButtonProps = _this$props9.leftArrowButtonProps, leftArrowIcon = _this$props9.leftArrowIcon, rightArrowButtonProps = _this$props9.rightArrowButtonProps, rightArrowIcon = _this$props9.rightArrowIcon, loadingIndicator = _this$props9.loadingIndicator;
                var loadingElement = loadingIndicator ? loadingIndicator : (0, $Fo7oF.createElement)((0, $75157c5b2ba08cec$export$2e2bcd8739ae039), null);
                return (0, $Fo7oF.createElement)((0, $Fo7oF.Fragment), null, allowKeyboardControl && this.context !== 'static' && (0, $Fo7oF.createElement)($0fa1d30fe6dc6a08$var$KeyDownListener, {
                    onKeyDown: this.handleKeyDown
                }), (0, $Fo7oF.createElement)($0fa1d30fe6dc6a08$var$CalendarHeader, {
                    currentMonth: currentMonth,
                    slideDirection: slideDirection,
                    onMonthChange: this.handleChangeMonth,
                    leftArrowIcon: leftArrowIcon,
                    leftArrowButtonProps: leftArrowButtonProps,
                    rightArrowIcon: rightArrowIcon,
                    rightArrowButtonProps: rightArrowButtonProps,
                    disablePrevMonth: this.shouldDisablePrevMonth(),
                    disableNextMonth: this.shouldDisableNextMonth()
                }), (0, $Fo7oF.createElement)($0fa1d30fe6dc6a08$var$SlideTransition, {
                    slideDirection: slideDirection,
                    transKey: currentMonth.toString(),
                    className: classes.transitionContainer
                }, (0, $Fo7oF.createElement)((0, $Fo7oF.Fragment), null, this.state.loadingQueue > 0 && (0, $Fo7oF.createElement)("div", {
                    className: classes.progressContainer
                }, loadingElement) || (0, $Fo7oF.createElement)("div", null, this.renderWeeks()))));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, state) {
                var utils = nextProps.utils, nextDate = nextProps.date;
                if (!utils.isEqual(nextDate, state.lastDate)) {
                    var nextMonth = utils.getMonth(nextDate);
                    var lastDate = state.lastDate || nextDate;
                    var lastMonth = utils.getMonth(lastDate);
                    return {
                        lastDate: nextDate,
                        currentMonth: nextProps.utils.startOfMonth(nextDate),
                        // prettier-ignore
                        slideDirection: nextMonth === lastMonth ? state.slideDirection : utils.isAfterDay(nextDate, lastDate) ? 'left' : 'right'
                    };
                }
                return null;
            }
        }
    ]);
    return Calendar;
}((0, $Fo7oF.Component));
$0fa1d30fe6dc6a08$export$e7094788287c5e9b.contextType = (0, $0ac5014ff7821bc1$export$e7c866399fa523f5);
$0fa1d30fe6dc6a08$export$e7094788287c5e9b.defaultProps = {
    minDate: new Date('1900-01-01'),
    maxDate: new Date('2100-01-01'),
    disablePast: false,
    disableFuture: false,
    allowKeyboardControl: true
};
var $0fa1d30fe6dc6a08$export$2408f22a0fab9ae5 = function styles(theme) {
    return {
        transitionContainer: {
            minHeight: 216,
            marginTop: theme.spacing(1.5)
        },
        progressContainer: {
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        week: {
            display: 'flex',
            justifyContent: 'center'
        }
    };
};
var $0fa1d30fe6dc6a08$export$407448d2b89b1813 = (0, $5rVgt.default)($0fa1d30fe6dc6a08$export$2408f22a0fab9ae5, {
    name: 'MuiPickersCalendar',
    withTheme: true
})($0fa1d30fe6dc6a08$var$withUtils()($0fa1d30fe6dc6a08$export$e7094788287c5e9b));



var $8YHhK = parcelRequire("8YHhK");

var $Fo7oF = parcelRequire("Fo7oF");



var $78z8j = parcelRequire("78z8j");

var $elnlQ = parcelRequire("elnlQ");



parcelRequire("fxzEt");




var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");


var $fxzEt = parcelRequire("fxzEt");



var $447b26871c9763ac$var$ClockType;
(function(ClockType) {
    ClockType["HOURS"] = "hours";
    ClockType["MINUTES"] = "minutes";
    ClockType["SECONDS"] = "seconds";
})($447b26871c9763ac$var$ClockType || ($447b26871c9763ac$var$ClockType = {}));
var $447b26871c9763ac$export$8b22cf2602fb60ce = $447b26871c9763ac$var$ClockType;
var $447b26871c9763ac$var$ClockPointer = /*#__PURE__*/ function(_React$Component) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(ClockPointer, _React$Component);
    function ClockPointer() {
        var _getPrototypeOf2;
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, ClockPointer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $03e7eaefdaf85d7c$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $17c9b9cedb1b1791$export$2e2bcd8739ae039)(ClockPointer)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _this.state = {
            toAnimateTransform: false,
            previousType: undefined
        };
        _this.getAngleStyle = function() {
            var _this$props = _this.props, value = _this$props.value, isInner = _this$props.isInner, type = _this$props.type;
            var max = type === $447b26871c9763ac$export$8b22cf2602fb60ce.HOURS ? 12 : 60;
            var angle = 360 / max * value;
            if (type === $447b26871c9763ac$export$8b22cf2602fb60ce.HOURS && value > 12) angle -= 360; // round up angle to max 360 degrees
            return {
                height: isInner ? '26%' : '40%',
                transform: "rotateZ(".concat(angle, "deg)")
            };
        };
        return _this;
    }
    (0, $fxzEt.default)(ClockPointer, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, classes = _this$props2.classes, hasSelected = _this$props2.hasSelected;
                return (0, $Fo7oF.createElement)("div", {
                    style: this.getAngleStyle(),
                    className: (0, $78z8j.default)(classes.pointer, this.state.toAnimateTransform && classes.animateTransform)
                }, (0, $Fo7oF.createElement)("div", {
                    className: (0, $78z8j.default)(classes.thumb, hasSelected && classes.noPoint)
                }));
            }
        }
    ]);
    return ClockPointer;
}((0, $Fo7oF.Component));
$447b26871c9763ac$var$ClockPointer.getDerivedStateFromProps = function(nextProps, state) {
    if (nextProps.type !== state.previousType) return {
        toAnimateTransform: true,
        previousType: nextProps.type
    };
    return {
        toAnimateTransform: false,
        previousType: nextProps.type
    };
};
var $447b26871c9763ac$var$styles = function styles(theme) {
    return (0, $96c662afe0eabd27$export$2e2bcd8739ae039)({
        pointer: {
            width: 2,
            backgroundColor: theme.palette.primary.main,
            position: 'absolute',
            left: 'calc(50% - 1px)',
            bottom: '50%',
            transformOrigin: 'center bottom 0px'
        },
        animateTransform: {
            transition: theme.transitions.create([
                'transform',
                'height'
            ])
        },
        thumb: {
            width: 4,
            height: 4,
            backgroundColor: theme.palette.primary.contrastText,
            borderRadius: '100%',
            position: 'absolute',
            top: -21,
            left: -15,
            border: "14px solid ".concat(theme.palette.primary.main),
            boxSizing: 'content-box'
        },
        noPoint: {
            backgroundColor: theme.palette.primary.main
        }
    });
};
var $447b26871c9763ac$var$ClockPointer$1 = (0, $5rVgt.default)($447b26871c9763ac$var$styles, {
    name: 'MuiPickersClockPointer'
})($447b26871c9763ac$var$ClockPointer);
var $447b26871c9763ac$var$center = {
    x: 130,
    y: 130
};
var $447b26871c9763ac$var$basePoint = {
    x: $447b26871c9763ac$var$center.x,
    y: 0
};
var $447b26871c9763ac$var$cx = $447b26871c9763ac$var$basePoint.x - $447b26871c9763ac$var$center.x;
var $447b26871c9763ac$var$cy = $447b26871c9763ac$var$basePoint.y - $447b26871c9763ac$var$center.y;
var $447b26871c9763ac$var$rad2deg = function rad2deg(rad) {
    return rad * 57.29577951308232;
};
var $447b26871c9763ac$var$getAngleValue = function getAngleValue(step, offsetX, offsetY) {
    var x = offsetX - $447b26871c9763ac$var$center.x;
    var y = offsetY - $447b26871c9763ac$var$center.y;
    var atan = Math.atan2($447b26871c9763ac$var$cx, $447b26871c9763ac$var$cy) - Math.atan2(x, y);
    var deg = $447b26871c9763ac$var$rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    var value = Math.floor(deg / step) || 0;
    var delta = Math.pow(x, 2) + Math.pow(y, 2);
    var distance = Math.sqrt(delta);
    return {
        value: value,
        distance: distance
    };
};
var $447b26871c9763ac$var$getHours = function getHours(offsetX, offsetY, ampm) {
    var _getAngleValue = $447b26871c9763ac$var$getAngleValue(30, offsetX, offsetY), value = _getAngleValue.value, distance = _getAngleValue.distance;
    value = value || 12;
    if (!ampm) {
        if (distance < 90) {
            value += 12;
            value %= 24;
        }
    } else value %= 12;
    return value;
};
var $447b26871c9763ac$var$getMinutes = function getMinutes(offsetX, offsetY) {
    var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var angleStep = step * 6;
    var _getAngleValue2 = $447b26871c9763ac$var$getAngleValue(angleStep, offsetX, offsetY), value = _getAngleValue2.value;
    value = value * step % 60;
    return value;
};
var $447b26871c9763ac$export$39b482c5e57630a8 = function getMeridiem(date, utils) {
    return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
var $447b26871c9763ac$export$db3b6bfb95261072 = function convertToMeridiem(time, meridiem, ampm, utils) {
    if (ampm) {
        var currentMeridiem = utils.getHours(time) >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) {
            var hours = meridiem === 'am' ? utils.getHours(time) - 12 : utils.getHours(time) + 12;
            return utils.setHours(time, hours);
        }
    }
    return time;
};
var $447b26871c9763ac$export$e7094788287c5e9b = /*#__PURE__*/ function(_React$Component) {
    (0, $f79f302d728c8fa0$export$2e2bcd8739ae039)(Clock, _React$Component);
    function Clock() {
        var _getPrototypeOf2;
        var _this;
        (0, $79e75fc78697f660$export$2e2bcd8739ae039)(this, Clock);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $03e7eaefdaf85d7c$export$2e2bcd8739ae039)(this, (_getPrototypeOf2 = (0, $17c9b9cedb1b1791$export$2e2bcd8739ae039)(Clock)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _this.isMoving = false;
        _this.handleTouchMove = function(e) {
            _this.isMoving = true;
            _this.setTime(e);
        };
        _this.handleTouchEnd = function(e) {
            if (_this.isMoving) {
                _this.setTime(e, true);
                _this.isMoving = false;
            }
        };
        _this.handleMove = function(e) {
            e.preventDefault();
            e.stopPropagation(); // MouseEvent.which is deprecated, but MouseEvent.buttons is not supported in Safari
            var isButtonPressed = typeof e.buttons === 'undefined' ? e.nativeEvent.which === 1 : e.buttons === 1;
            if (isButtonPressed) _this.setTime(e.nativeEvent, false);
        };
        _this.handleMouseUp = function(e) {
            if (_this.isMoving) _this.isMoving = false;
            _this.setTime(e.nativeEvent, true);
        };
        _this.hasSelected = function() {
            var _this$props = _this.props, type = _this$props.type, value = _this$props.value;
            if (type === $447b26871c9763ac$export$8b22cf2602fb60ce.HOURS) return true;
            return value % 5 === 0;
        };
        return _this;
    }
    (0, $fxzEt.default)(Clock, [
        {
            key: "setTime",
            value: function setTime(e) {
                var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var offsetX = e.offsetX, offsetY = e.offsetY;
                if (typeof offsetX === 'undefined') {
                    var rect = e.target.getBoundingClientRect();
                    offsetX = e.changedTouches[0].clientX - rect.left;
                    offsetY = e.changedTouches[0].clientY - rect.top;
                }
                var value = this.props.type === $447b26871c9763ac$export$8b22cf2602fb60ce.SECONDS || this.props.type === $447b26871c9763ac$export$8b22cf2602fb60ce.MINUTES ? $447b26871c9763ac$var$getMinutes(offsetX, offsetY, this.props.minutesStep) : $447b26871c9763ac$var$getHours(offsetX, offsetY, Boolean(this.props.ampm));
                this.props.onChange(value, isFinish);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, classes = _this$props2.classes, value = _this$props2.value, children = _this$props2.children, type = _this$props2.type, ampm = _this$props2.ampm;
                var isPointerInner = !ampm && type === $447b26871c9763ac$export$8b22cf2602fb60ce.HOURS && (value < 1 || value > 12);
                return (0, $Fo7oF.createElement)("div", {
                    className: classes.container
                }, (0, $Fo7oF.createElement)("div", {
                    className: classes.clock
                }, (0, $Fo7oF.createElement)("div", {
                    role: "menu",
                    tabIndex: -1,
                    className: classes.squareMask,
                    onTouchMove: this.handleTouchMove,
                    onTouchEnd: this.handleTouchEnd,
                    onMouseUp: this.handleMouseUp,
                    onMouseMove: this.handleMove
                }), (0, $Fo7oF.createElement)("div", {
                    className: classes.pin
                }), (0, $Fo7oF.createElement)($447b26871c9763ac$var$ClockPointer$1, {
                    type: type,
                    value: value,
                    isInner: isPointerInner,
                    hasSelected: this.hasSelected()
                }), children));
            }
        }
    ]);
    return Clock;
}((0, $Fo7oF.Component));
$447b26871c9763ac$export$e7094788287c5e9b.defaultProps = {
    ampm: false,
    minutesStep: 1
};
var $447b26871c9763ac$export$2408f22a0fab9ae5 = function styles(theme) {
    return (0, $96c662afe0eabd27$export$2e2bcd8739ae039)({
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-end',
            margin: "".concat(theme.spacing(2), "px 0 ").concat(theme.spacing(1), "px")
        },
        clock: {
            backgroundColor: 'rgba(0,0,0,.07)',
            borderRadius: '50%',
            height: 260,
            width: 260,
            position: 'relative',
            pointerEvents: 'none'
        },
        squareMask: {
            width: '100%',
            height: '100%',
            position: 'absolute',
            pointerEvents: 'auto',
            outline: 'none',
            touchActions: 'none',
            userSelect: 'none',
            '&:active': {
                cursor: 'move'
            }
        },
        pin: {
            width: 6,
            height: 6,
            borderRadius: '50%',
            backgroundColor: theme.palette.primary.main,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        }
    });
};
var $447b26871c9763ac$export$407448d2b89b1813 = (0, $5rVgt.default)($447b26871c9763ac$export$2408f22a0fab9ae5, {
    name: 'MuiPickersClock'
})($447b26871c9763ac$export$e7094788287c5e9b);


var $3e299e0554fe2b3b$var$positions = {
    0: [
        0,
        40
    ],
    1: [
        55,
        19.6
    ],
    2: [
        94.4,
        59.5
    ],
    3: [
        109,
        114
    ],
    4: [
        94.4,
        168.5
    ],
    5: [
        54.5,
        208.4
    ],
    6: [
        0,
        223
    ],
    7: [
        -54.5,
        208.4
    ],
    8: [
        -94.4,
        168.5
    ],
    9: [
        -109,
        114
    ],
    10: [
        -94.4,
        59.5
    ],
    11: [
        -54.5,
        19.6
    ],
    12: [
        0,
        5
    ],
    13: [
        36.9,
        49.9
    ],
    14: [
        64,
        77
    ],
    15: [
        74,
        114
    ],
    16: [
        64,
        151
    ],
    17: [
        37,
        178
    ],
    18: [
        0,
        188
    ],
    19: [
        -37,
        178
    ],
    20: [
        -64,
        151
    ],
    21: [
        -74,
        114
    ],
    22: [
        -64,
        77
    ],
    23: [
        -37,
        50
    ]
};
var $3e299e0554fe2b3b$var$useStyles = (0, $43f27ed29b5bb141$export$2e2bcd8739ae039)(function(theme) {
    var size = theme.spacing(4);
    return {
        clockNumber: {
            width: size,
            height: 32,
            userSelect: 'none',
            position: 'absolute',
            left: "calc((100% - ".concat(typeof size === 'number' ? "".concat(size, "px") : size, ") / 2)"),
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '50%',
            color: theme.palette.type === 'light' ? theme.palette.text.primary : theme.palette.text.hint
        },
        clockNumberSelected: {
            color: theme.palette.primary.contrastText
        }
    };
}, {
    name: 'MuiPickersClockNumber'
});
var $3e299e0554fe2b3b$var$ClockNumber = function ClockNumber(_ref) {
    var selected = _ref.selected, label = _ref.label, index = _ref.index, isInner = _ref.isInner;
    var classes = $3e299e0554fe2b3b$var$useStyles();
    var className = (0, $78z8j.default)(classes.clockNumber, selected && classes.clockNumberSelected);
    var transformStyle = (0, $Fo7oF.useMemo)(function() {
        var position = $3e299e0554fe2b3b$var$positions[index];
        return {
            transform: "translate(".concat(position[0], "px, ").concat(position[1], "px")
        };
    }, [
        index
    ]);
    return (0, $Fo7oF.createElement)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
        component: "span",
        className: className,
        variant: isInner ? 'body2' : 'body1',
        style: transformStyle,
        children: label
    });
};
var $3e299e0554fe2b3b$var$getHourNumbers = function getHourNumbers(_ref) {
    var ampm = _ref.ampm, utils = _ref.utils, date = _ref.date;
    var currentHours = utils.getHours(date);
    var hourNumbers = [];
    var startHour = ampm ? 1 : 0;
    var endHour = ampm ? 12 : 23;
    var isSelected = function isSelected(hour) {
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(var hour = startHour; hour <= endHour; hour += 1){
        var label = hour.toString();
        if (hour === 0) label = '00';
        var props = {
            index: hour,
            label: utils.formatNumber(label),
            selected: isSelected(hour),
            isInner: !ampm && (hour === 0 || hour > 12)
        };
        hourNumbers.push((0, $Fo7oF.createElement)($3e299e0554fe2b3b$var$ClockNumber, (0, $elnlQ.default)({
            key: hour
        }, props)));
    }
    return hourNumbers;
};
var $3e299e0554fe2b3b$var$getMinutesNumbers = function getMinutesNumbers(_ref2) {
    var value = _ref2.value, utils = _ref2.utils;
    var f = utils.formatNumber;
    return [
        (0, $Fo7oF.createElement)($3e299e0554fe2b3b$var$ClockNumber, {
            label: f('00'),
            selected: value === 0,
            index: 12,
            key: 12
        }),
        (0, $Fo7oF.createElement)($3e299e0554fe2b3b$var$ClockNumber, {
            label: f('05'),
            selected: value === 5,
            index: 1,
            key: 1
        }),
        (0, $Fo7oF.createElement)($3e299e0554fe2b3b$var$ClockNumber, {
            label: f('10'),
            selected: value === 10,
            index: 2,
            key: 2
        }),
        (0, $Fo7oF.createElement)($3e299e0554fe2b3b$var$ClockNumber, {
            label: f('15'),
            selected: value === 15,
            index: 3,
            key: 3
        }),
        (0, $Fo7oF.createElement)($3e299e0554fe2b3b$var$ClockNumber, {
            label: f('20'),
            selected: value === 20,
            index: 4,
            key: 4
        }),
        (0, $Fo7oF.createElement)($3e299e0554fe2b3b$var$ClockNumber, {
            label: f('25'),
            selected: value === 25,
            index: 5,
            key: 5
        }),
        (0, $Fo7oF.createElement)($3e299e0554fe2b3b$var$ClockNumber, {
            label: f('30'),
            selected: value === 30,
            index: 6,
            key: 6
        }),
        (0, $Fo7oF.createElement)($3e299e0554fe2b3b$var$ClockNumber, {
            label: f('35'),
            selected: value === 35,
            index: 7,
            key: 7
        }),
        (0, $Fo7oF.createElement)($3e299e0554fe2b3b$var$ClockNumber, {
            label: f('40'),
            selected: value === 40,
            index: 8,
            key: 8
        }),
        (0, $Fo7oF.createElement)($3e299e0554fe2b3b$var$ClockNumber, {
            label: f('45'),
            selected: value === 45,
            index: 9,
            key: 9
        }),
        (0, $Fo7oF.createElement)($3e299e0554fe2b3b$var$ClockNumber, {
            label: f('50'),
            selected: value === 50,
            index: 10,
            key: 10
        }),
        (0, $Fo7oF.createElement)($3e299e0554fe2b3b$var$ClockNumber, {
            label: f('55'),
            selected: value === 55,
            index: 11,
            key: 11
        })
    ];
};
var $3e299e0554fe2b3b$export$e6ca67116c8adcad = function ClockView(_ref) {
    var type = _ref.type, onHourChange = _ref.onHourChange, onMinutesChange = _ref.onMinutesChange, onSecondsChange = _ref.onSecondsChange, ampm = _ref.ampm, date = _ref.date, minutesStep = _ref.minutesStep;
    var utils = (0, $3e8620cba75a223b$export$3b14a55fb2447963)();
    var viewProps = (0, $Fo7oF.useMemo)(function() {
        switch(type){
            case (0, $447b26871c9763ac$export$8b22cf2602fb60ce).HOURS:
                return {
                    value: utils.getHours(date),
                    children: $3e299e0554fe2b3b$var$getHourNumbers({
                        date: date,
                        utils: utils,
                        ampm: Boolean(ampm)
                    }),
                    onChange: function onChange(value, isFinish) {
                        var currentMeridiem = (0, $447b26871c9763ac$export$39b482c5e57630a8)(date, utils);
                        var updatedTimeWithMeridiem = (0, $447b26871c9763ac$export$db3b6bfb95261072)(utils.setHours(date, value), currentMeridiem, Boolean(ampm), utils);
                        onHourChange(updatedTimeWithMeridiem, isFinish);
                    }
                };
            case (0, $447b26871c9763ac$export$8b22cf2602fb60ce).MINUTES:
                var minutesValue = utils.getMinutes(date);
                return {
                    value: minutesValue,
                    children: $3e299e0554fe2b3b$var$getMinutesNumbers({
                        value: minutesValue,
                        utils: utils
                    }),
                    onChange: function onChange(value, isFinish) {
                        var updatedTime = utils.setMinutes(date, value);
                        onMinutesChange(updatedTime, isFinish);
                    }
                };
            case (0, $447b26871c9763ac$export$8b22cf2602fb60ce).SECONDS:
                var secondsValue = utils.getSeconds(date);
                return {
                    value: secondsValue,
                    children: $3e299e0554fe2b3b$var$getMinutesNumbers({
                        value: secondsValue,
                        utils: utils
                    }),
                    onChange: function onChange(value, isFinish) {
                        var updatedTime = utils.setSeconds(date, value);
                        onSecondsChange(updatedTime, isFinish);
                    }
                };
            default:
                throw new Error('You must provide the type for TimePickerView');
        }
    }, [
        ampm,
        date,
        onHourChange,
        onMinutesChange,
        onSecondsChange,
        type,
        utils
    ]);
    return (0, $Fo7oF.createElement)((0, $447b26871c9763ac$export$407448d2b89b1813), (0, $elnlQ.default)({
        type: type,
        ampm: ampm,
        minutesStep: minutesStep
    }, viewProps));
};
$3e299e0554fe2b3b$export$e6ca67116c8adcad.displayName = 'TimePickerView';
$3e299e0554fe2b3b$export$e6ca67116c8adcad.defaultProps = {
    ampm: true,
    minutesStep: 1
};
var $3e299e0554fe2b3b$var$ClockView$1 = (0, $Fo7oF.memo)($3e299e0554fe2b3b$export$e6ca67116c8adcad);
var $3e299e0554fe2b3b$export$2e2bcd8739ae039 = $3e299e0554fe2b3b$var$ClockView$1;


function $872b39ed4acf9f0d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $872b39ed4acf9f0d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $872b39ed4acf9f0d$var$ownKeys(source, true).forEach(function(key) {
            (0, $d2vKa.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $872b39ed4acf9f0d$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $872b39ed4acf9f0d$var$date = (0, $d2bgE.oneOfType)([
    (0, $d2bgE.object),
    (0, $d2bgE.string),
    (0, $d2bgE.number),
    (0, $d2bgE.instanceOf)(Date)
]);
var $872b39ed4acf9f0d$var$datePickerView = (0, $d2bgE.oneOf)([
    'year',
    'month',
    'day'
]);
/* eslint-disable @typescript-eslint/no-object-literal-type-assertion */ var $872b39ed4acf9f0d$export$625550452a3fa3ec = {
    ampm: true,
    invalidDateMessage: 'Invalid Time Format'
};
var $872b39ed4acf9f0d$export$4368d992c4eafac0 = {
    minDate: new Date('1900-01-01'),
    maxDate: new Date('2100-01-01'),
    invalidDateMessage: 'Invalid Date Format',
    minDateMessage: 'Date should not be before minimal date',
    maxDateMessage: 'Date should not be after maximal date',
    allowKeyboardControl: true
};
var $872b39ed4acf9f0d$export$407448d2b89b1813 = $872b39ed4acf9f0d$var$_objectSpread({}, $872b39ed4acf9f0d$export$625550452a3fa3ec, {}, $872b39ed4acf9f0d$export$4368d992c4eafac0, {
    showTabs: true
});
function $872b39ed4acf9f0d$var$useViews(views, openTo, onChange) {
    var _React$useState = (0, $Fo7oF.useState)(openTo && (0, $0ac5014ff7821bc1$export$407448d2b89b1813)(views, openTo) ? openTo : views[0]), _React$useState2 = (0, $8YHhK.default)(_React$useState, 2), openView = _React$useState2[0], setOpenView = _React$useState2[1];
    var handleChangeAndOpenNext = (0, $Fo7oF.useCallback)(function(date, isFinish) {
        var nextViewToOpen = views[views.indexOf(openView) + 1];
        if (isFinish && nextViewToOpen) {
            // do not close picker if needs to show next view
            onChange(date, false);
            setOpenView(nextViewToOpen);
            return;
        }
        onChange(date, Boolean(isFinish));
    }, [
        onChange,
        openView,
        views
    ]);
    return {
        handleChangeAndOpenNext: handleChangeAndOpenNext,
        openView: openView,
        setOpenView: setOpenView
    };
}
var $872b39ed4acf9f0d$var$useStyles = (0, $43f27ed29b5bb141$export$2e2bcd8739ae039)(function(theme) {
    return {
        root: {
            height: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            outline: 'none',
            '&:focus': {
                color: theme.palette.primary.main,
                fontWeight: theme.typography.fontWeightMedium
            }
        },
        yearSelected: {
            margin: '10px 0',
            fontWeight: theme.typography.fontWeightMedium
        },
        yearDisabled: {
            pointerEvents: 'none',
            color: theme.palette.text.hint
        }
    };
}, {
    name: 'MuiPickersYear'
});
var $872b39ed4acf9f0d$var$Year = function Year(_ref) {
    var onSelect = _ref.onSelect, forwardedRef = _ref.forwardedRef, value = _ref.value, selected = _ref.selected, disabled = _ref.disabled, children = _ref.children, other = (0, $67mp8.default)(_ref, [
        "onSelect",
        "forwardedRef",
        "value",
        "selected",
        "disabled",
        "children"
    ]);
    var classes = $872b39ed4acf9f0d$var$useStyles();
    var handleClick = (0, $Fo7oF.useCallback)(function() {
        return onSelect(value);
    }, [
        onSelect,
        value
    ]);
    return (0, $Fo7oF.createElement)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        role: "button",
        component: "div",
        tabIndex: disabled ? -1 : 0,
        onClick: handleClick,
        onKeyPress: handleClick,
        color: selected ? 'primary' : undefined,
        variant: selected ? 'h5' : 'subtitle1',
        children: children,
        ref: forwardedRef,
        className: (0, $78z8j.default)(classes.root, selected && classes.yearSelected, disabled && classes.yearDisabled)
    }, other));
};
$872b39ed4acf9f0d$var$Year.displayName = 'Year';
var $872b39ed4acf9f0d$var$Year$1 = (0, $Fo7oF.forwardRef)(function(props, ref) {
    return (0, $Fo7oF.createElement)($872b39ed4acf9f0d$var$Year, (0, $elnlQ.default)({}, props, {
        forwardedRef: ref
    }));
});
var $872b39ed4acf9f0d$var$useStyles$1 = (0, $43f27ed29b5bb141$export$2e2bcd8739ae039)({
    container: {
        height: 300,
        overflowY: 'auto'
    }
}, {
    name: 'MuiPickersYearSelection'
});
var $872b39ed4acf9f0d$var$YearSelection = function YearSelection(_ref) {
    var date = _ref.date, onChange = _ref.onChange, onYearChange = _ref.onYearChange, minDate = _ref.minDate, maxDate = _ref.maxDate, disablePast = _ref.disablePast, disableFuture = _ref.disableFuture, animateYearScrolling = _ref.animateYearScrolling;
    var utils = (0, $3e8620cba75a223b$export$3b14a55fb2447963)();
    var classes = $872b39ed4acf9f0d$var$useStyles$1();
    var currentVariant = (0, $Fo7oF.useContext)((0, $0ac5014ff7821bc1$export$e7c866399fa523f5));
    var selectedYearRef = (0, $Fo7oF.useRef)(null);
    (0, $Fo7oF.useEffect)(function() {
        if (selectedYearRef.current && selectedYearRef.current.scrollIntoView) try {
            selectedYearRef.current.scrollIntoView({
                block: currentVariant === 'static' ? 'nearest' : 'center',
                behavior: animateYearScrolling ? 'smooth' : 'auto'
            });
        } catch (e) {
            // call without arguments in case when scrollIntoView works improperly (e.g. Firefox 52-57)
            selectedYearRef.current.scrollIntoView();
        }
    }, []); // eslint-disable-line
    var currentYear = utils.getYear(date);
    var onYearSelect = (0, $Fo7oF.useCallback)(function(year) {
        var newDate = utils.setYear(date, year);
        if (onYearChange) onYearChange(newDate);
        onChange(newDate, true);
    }, [
        date,
        onChange,
        onYearChange,
        utils
    ]);
    return (0, $Fo7oF.createElement)("div", {
        className: classes.container
    }, utils.getYearRange(minDate, maxDate).map(function(year) {
        var yearNumber = utils.getYear(year);
        var selected = yearNumber === currentYear;
        return (0, $Fo7oF.createElement)($872b39ed4acf9f0d$var$Year$1, {
            key: utils.getYearText(year),
            selected: selected,
            value: yearNumber,
            onSelect: onYearSelect,
            ref: selected ? selectedYearRef : undefined,
            disabled: Boolean(disablePast && utils.isBeforeYear(year, utils.date()) || disableFuture && utils.isAfterYear(year, utils.date()))
        }, utils.getYearText(year));
    }));
};
var $872b39ed4acf9f0d$var$useStyles$2 = (0, $43f27ed29b5bb141$export$2e2bcd8739ae039)(function(theme) {
    return {
        root: {
            flex: '1 0 33.33%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            outline: 'none',
            height: 75,
            transition: theme.transitions.create('font-size', {
                duration: '100ms'
            }),
            '&:focus': {
                color: theme.palette.primary.main,
                fontWeight: theme.typography.fontWeightMedium
            }
        },
        monthSelected: {
            color: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium
        },
        monthDisabled: {
            pointerEvents: 'none',
            color: theme.palette.text.hint
        }
    };
}, {
    name: 'MuiPickersMonth'
});
var $872b39ed4acf9f0d$var$Month = function Month(_ref) {
    var selected = _ref.selected, onSelect = _ref.onSelect, disabled = _ref.disabled, value = _ref.value, children = _ref.children, other = (0, $67mp8.default)(_ref, [
        "selected",
        "onSelect",
        "disabled",
        "value",
        "children"
    ]);
    var classes = $872b39ed4acf9f0d$var$useStyles$2();
    var handleSelection = (0, $Fo7oF.useCallback)(function() {
        onSelect(value);
    }, [
        onSelect,
        value
    ]);
    return (0, $Fo7oF.createElement)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        role: "button",
        component: "div",
        className: (0, $78z8j.default)(classes.root, selected && classes.monthSelected, disabled && classes.monthDisabled),
        tabIndex: disabled ? -1 : 0,
        onClick: handleSelection,
        onKeyPress: handleSelection,
        color: selected ? 'primary' : undefined,
        variant: selected ? 'h5' : 'subtitle1',
        children: children
    }, other));
};
$872b39ed4acf9f0d$var$Month.displayName = 'Month';
var $872b39ed4acf9f0d$var$useStyles$3 = (0, $43f27ed29b5bb141$export$2e2bcd8739ae039)({
    container: {
        width: 310,
        display: 'flex',
        flexWrap: 'wrap',
        alignContent: 'stretch'
    }
}, {
    name: 'MuiPickersMonthSelection'
});
var $872b39ed4acf9f0d$var$MonthSelection = function MonthSelection(_ref) {
    var disablePast = _ref.disablePast, disableFuture = _ref.disableFuture, minDate = _ref.minDate, maxDate = _ref.maxDate, date = _ref.date, onMonthChange = _ref.onMonthChange, onChange = _ref.onChange;
    var utils = (0, $3e8620cba75a223b$export$3b14a55fb2447963)();
    var classes = $872b39ed4acf9f0d$var$useStyles$3();
    var currentMonth = utils.getMonth(date);
    var shouldDisableMonth = function shouldDisableMonth(month) {
        var now = utils.date();
        var utilMinDate = utils.date(minDate);
        var utilMaxDate = utils.date(maxDate);
        var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utilMinDate) ? now : utilMinDate);
        var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utilMaxDate) ? now : utilMaxDate);
        var isBeforeFirstEnabled = utils.isBefore(month, firstEnabledMonth);
        var isAfterLastEnabled = utils.isAfter(month, lastEnabledMonth);
        return isBeforeFirstEnabled || isAfterLastEnabled;
    };
    var onMonthSelect = (0, $Fo7oF.useCallback)(function(month) {
        var newDate = utils.setMonth(date, month);
        onChange(newDate, true);
        if (onMonthChange) onMonthChange(newDate);
    }, [
        date,
        onChange,
        onMonthChange,
        utils
    ]);
    return (0, $Fo7oF.createElement)("div", {
        className: classes.container
    }, utils.getMonthArray(date).map(function(month) {
        var monthNumber = utils.getMonth(month);
        var monthText = utils.format(month, 'MMM');
        return (0, $Fo7oF.createElement)($872b39ed4acf9f0d$var$Month, {
            key: monthText,
            value: monthNumber,
            selected: monthNumber === currentMonth,
            onSelect: onMonthSelect,
            disabled: shouldDisableMonth(month)
        }, monthText);
    }));
};
var $872b39ed4acf9f0d$var$getOrientation = function getOrientation() {
    if (typeof window === 'undefined') return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
     // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    return 'portrait';
};
function $872b39ed4acf9f0d$var$useIsLandscape(customOrientation) {
    var _React$useState = (0, $Fo7oF.useState)($872b39ed4acf9f0d$var$getOrientation()), _React$useState2 = (0, $8YHhK.default)(_React$useState, 2), orientation = _React$useState2[0], setOrientation = _React$useState2[1];
    var eventHandler = (0, $Fo7oF.useCallback)(function() {
        return setOrientation($872b39ed4acf9f0d$var$getOrientation());
    }, []);
    (0, $0ac5014ff7821bc1$export$3b14a55fb2447963)(function() {
        window.addEventListener('orientationchange', eventHandler);
        return function() {
            return window.removeEventListener('orientationchange', eventHandler);
        };
    }, [
        eventHandler
    ]);
    var orientationToUse = customOrientation || orientation;
    return orientationToUse === 'landscape';
}
function $872b39ed4acf9f0d$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $872b39ed4acf9f0d$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $872b39ed4acf9f0d$var$ownKeys$1(source, true).forEach(function(key) {
            (0, $d2vKa.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $872b39ed4acf9f0d$var$ownKeys$1(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $872b39ed4acf9f0d$var$viewsMap = {
    year: $872b39ed4acf9f0d$var$YearSelection,
    month: $872b39ed4acf9f0d$var$MonthSelection,
    date: (0, $0fa1d30fe6dc6a08$export$407448d2b89b1813),
    hours: (0, $3e299e0554fe2b3b$export$e6ca67116c8adcad),
    minutes: (0, $3e299e0554fe2b3b$export$e6ca67116c8adcad),
    seconds: (0, $3e299e0554fe2b3b$export$e6ca67116c8adcad)
};
var $872b39ed4acf9f0d$var$useStyles$4 = (0, $43f27ed29b5bb141$export$2e2bcd8739ae039)({
    container: {
        display: 'flex',
        flexDirection: 'column'
    },
    containerLandscape: {
        flexDirection: 'row'
    },
    pickerView: {
        overflowX: 'hidden',
        minHeight: (0, $0ac5014ff7821bc1$export$8b22cf2602fb60ce),
        minWidth: (0, $0ac5014ff7821bc1$export$96f57966bedc81b4),
        maxWidth: (0, $0ac5014ff7821bc1$export$db3b6bfb95261072),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    pickerViewLandscape: {
        padding: '0 8px'
    }
}, {
    name: 'MuiPickersBasePicker'
});
var $872b39ed4acf9f0d$export$56c0d5a1e737357d = function Picker(_ref) {
    var date = _ref.date, views = _ref.views, disableToolbar = _ref.disableToolbar, onChange = _ref.onChange, openTo = _ref.openTo, unparsedMinDate = _ref.minDate, unparsedMaxDate = _ref.maxDate, ToolbarComponent = _ref.ToolbarComponent, orientation = _ref.orientation, rest = (0, $67mp8.default)(_ref, [
        "date",
        "views",
        "disableToolbar",
        "onChange",
        "openTo",
        "minDate",
        "maxDate",
        "ToolbarComponent",
        "orientation"
    ]);
    var utils = (0, $3e8620cba75a223b$export$3b14a55fb2447963)();
    var classes = $872b39ed4acf9f0d$var$useStyles$4();
    var isLandscape = $872b39ed4acf9f0d$var$useIsLandscape(orientation);
    var _useViews = $872b39ed4acf9f0d$var$useViews(views, openTo, onChange), openView = _useViews.openView, setOpenView = _useViews.setOpenView, handleChangeAndOpenNext = _useViews.handleChangeAndOpenNext;
    var minDate = (0, $Fo7oF.useMemo)(function() {
        return utils.date(unparsedMinDate);
    }, [
        unparsedMinDate,
        utils
    ]);
    var maxDate = (0, $Fo7oF.useMemo)(function() {
        return utils.date(unparsedMaxDate);
    }, [
        unparsedMaxDate,
        utils
    ]);
    return (0, $Fo7oF.createElement)("div", {
        className: (0, $78z8j.default)(classes.container, isLandscape && classes.containerLandscape)
    }, !disableToolbar && (0, $Fo7oF.createElement)(ToolbarComponent, (0, $elnlQ.default)({}, rest, {
        views: views,
        isLandscape: isLandscape,
        date: date,
        onChange: onChange,
        setOpenView: setOpenView,
        openView: openView
    })), (0, $Fo7oF.createElement)("div", {
        className: (0, $78z8j.default)(classes.pickerView, isLandscape && classes.pickerViewLandscape)
    }, openView === 'year' && (0, $Fo7oF.createElement)($872b39ed4acf9f0d$var$YearSelection, (0, $elnlQ.default)({}, rest, {
        date: date,
        onChange: handleChangeAndOpenNext,
        minDate: minDate,
        maxDate: maxDate
    })), openView === 'month' && (0, $Fo7oF.createElement)($872b39ed4acf9f0d$var$MonthSelection, (0, $elnlQ.default)({}, rest, {
        date: date,
        onChange: handleChangeAndOpenNext,
        minDate: minDate,
        maxDate: maxDate
    })), openView === 'date' && (0, $Fo7oF.createElement)((0, $0fa1d30fe6dc6a08$export$407448d2b89b1813), (0, $elnlQ.default)({}, rest, {
        date: date,
        onChange: handleChangeAndOpenNext,
        minDate: minDate,
        maxDate: maxDate
    })), (openView === 'hours' || openView === 'minutes' || openView === 'seconds') && (0, $Fo7oF.createElement)((0, $3e299e0554fe2b3b$export$e6ca67116c8adcad), (0, $elnlQ.default)({}, rest, {
        date: date,
        type: openView,
        onHourChange: handleChangeAndOpenNext,
        onMinutesChange: handleChangeAndOpenNext,
        onSecondsChange: handleChangeAndOpenNext
    }))));
};
$872b39ed4acf9f0d$export$56c0d5a1e737357d.defaultProps = $872b39ed4acf9f0d$var$_objectSpread$1({}, $872b39ed4acf9f0d$export$4368d992c4eafac0, {
    views: Object.keys($872b39ed4acf9f0d$var$viewsMap)
});


var $c499664a2072b83c$var$useStyles = (0, $43f27ed29b5bb141$export$2e2bcd8739ae039)(function(theme) {
    var textColor = theme.palette.type === 'light' ? theme.palette.primary.contrastText : theme.palette.getContrastText(theme.palette.background["default"]);
    return {
        toolbarTxt: {
            color: (0, $8Hh6N.fade)(textColor, 0.54)
        },
        toolbarBtnSelected: {
            color: textColor
        }
    };
}, {
    name: 'MuiPickersToolbarText'
});
var $c499664a2072b83c$export$db3b6bfb95261072 = function ToolbarText(_ref) {
    var selected = _ref.selected, label = _ref.label, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, other = (0, $67mp8.default)(_ref, [
        "selected",
        "label",
        "className"
    ]);
    var classes = $c499664a2072b83c$var$useStyles();
    return (0, $Fo7oF.createElement)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        children: label,
        className: (0, $78z8j.default)(classes.toolbarTxt, className, selected && classes.toolbarBtnSelected)
    }, other));
};
var $c499664a2072b83c$var$ToolbarButton = function ToolbarButton(_ref) {
    var classes = _ref.classes, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, label = _ref.label, selected = _ref.selected, variant = _ref.variant, align = _ref.align, typographyClassName = _ref.typographyClassName, other = (0, $67mp8.default)(_ref, [
        "classes",
        "className",
        "label",
        "selected",
        "variant",
        "align",
        "typographyClassName"
    ]);
    return (0, $Fo7oF.createElement)((0, $896fad33a17d8629$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        variant: "text",
        className: (0, $78z8j.default)(classes.toolbarBtn, className)
    }, other), (0, $Fo7oF.createElement)($c499664a2072b83c$export$db3b6bfb95261072, {
        align: align,
        className: typographyClassName,
        variant: variant,
        label: label,
        selected: selected
    }));
};
$c499664a2072b83c$var$ToolbarButton.defaultProps = {
    className: ''
};
var $c499664a2072b83c$var$styles = (0, $96c662afe0eabd27$export$2e2bcd8739ae039)({
    toolbarBtn: {
        padding: 0,
        minWidth: '16px',
        textTransform: 'none'
    }
});
var $c499664a2072b83c$export$971d5caa766a69d7 = (0, $5rVgt.default)($c499664a2072b83c$var$styles, {
    name: 'MuiPickersToolbarButton'
})($c499664a2072b83c$var$ToolbarButton);
var $c499664a2072b83c$var$useStyles$1 = (0, $43f27ed29b5bb141$export$2e2bcd8739ae039)(function(theme) {
    return {
        toolbar: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            height: 100,
            backgroundColor: theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.background["default"]
        },
        toolbarLandscape: {
            height: 'auto',
            maxWidth: 150,
            padding: 8,
            justifyContent: 'flex-start'
        }
    };
}, {
    name: 'MuiPickersToolbar'
});
var $c499664a2072b83c$export$56c0d5a1e737357d = function PickerToolbar(_ref) {
    var children = _ref.children, isLandscape = _ref.isLandscape, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, other = (0, $67mp8.default)(_ref, [
        "children",
        "isLandscape",
        "className"
    ]);
    var classes = $c499664a2072b83c$var$useStyles$1();
    return (0, $Fo7oF.createElement)((0, $04d9144fb2276d87$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.toolbar, className, isLandscape && classes.toolbarLandscape)
    }, other), children);
};
function $c499664a2072b83c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c499664a2072b83c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $c499664a2072b83c$var$ownKeys(source, true).forEach(function(key) {
            (0, $d2vKa.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $c499664a2072b83c$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $c499664a2072b83c$export$407448d2b89b1813 = function PureDateInput(_ref) {
    var inputValue = _ref.inputValue, inputVariant = _ref.inputVariant, validationError = _ref.validationError, InputProps = _ref.InputProps, onOpen = _ref.openPicker, _ref$TextFieldCompone = _ref.TextFieldComponent, TextFieldComponent = _ref$TextFieldCompone === void 0 ? (0, $3a4ed32c219a2dd3$export$2e2bcd8739ae039) : _ref$TextFieldCompone, other = (0, $67mp8.default)(_ref, [
        "inputValue",
        "inputVariant",
        "validationError",
        "InputProps",
        "openPicker",
        "TextFieldComponent"
    ]);
    var PureDateInputProps = (0, $Fo7oF.useMemo)(function() {
        return $c499664a2072b83c$var$_objectSpread({}, InputProps, {
            readOnly: true
        });
    }, [
        InputProps
    ]);
    return (0, $Fo7oF.createElement)(TextFieldComponent, (0, $elnlQ.default)({
        error: Boolean(validationError),
        helperText: validationError
    }, other, {
        // do not overridable
        onClick: onOpen,
        value: inputValue,
        variant: inputVariant,
        InputProps: PureDateInputProps,
        onKeyDown: function onKeyDown(e) {
            // space
            if (e.keyCode === 32) {
                e.stopPropagation();
                onOpen();
            }
        }
    }));
};
$c499664a2072b83c$export$407448d2b89b1813.displayName = 'PureDateInput';
var $c499664a2072b83c$var$KeyboardIcon = function KeyboardIcon(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement((0, $72Yet.default), props, (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("path", {
        d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createElement("path", {
        fill: "none",
        d: "M0 0h24v24H0z"
    }));
};
var $c499664a2072b83c$var$getDisplayDate = function getDisplayDate(value, format, utils, isEmpty, _ref) {
    var invalidLabel = _ref.invalidLabel, emptyLabel = _ref.emptyLabel, labelFunc = _ref.labelFunc;
    var date = utils.date(value);
    if (labelFunc) return labelFunc(isEmpty ? null : date, invalidLabel);
    if (isEmpty) return emptyLabel || '';
    return utils.isValid(date) ? utils.format(date, format) : invalidLabel;
};
var $c499664a2072b83c$var$getComparisonMaxDate = function getComparisonMaxDate(utils, strictCompareDates, date) {
    if (strictCompareDates) return date;
    return utils.endOfDay(date);
};
var $c499664a2072b83c$var$getComparisonMinDate = function getComparisonMinDate(utils, strictCompareDates, date) {
    if (strictCompareDates) return date;
    return utils.startOfDay(date);
};
var $c499664a2072b83c$export$90a7f3efeed30595 = function validate(value, utils, _ref2) {
    var maxDate = _ref2.maxDate, minDate = _ref2.minDate, disablePast = _ref2.disablePast, disableFuture = _ref2.disableFuture, maxDateMessage = _ref2.maxDateMessage, minDateMessage = _ref2.minDateMessage, invalidDateMessage = _ref2.invalidDateMessage, strictCompareDates = _ref2.strictCompareDates;
    var parsedValue = utils.date(value); // if null - do not show error
    if (value === null) return '';
    if (!utils.isValid(value)) return invalidDateMessage;
    if (maxDate && utils.isAfter(parsedValue, $c499664a2072b83c$var$getComparisonMaxDate(utils, !!strictCompareDates, utils.date(maxDate)))) return maxDateMessage;
    if (disableFuture && utils.isAfter(parsedValue, $c499664a2072b83c$var$getComparisonMaxDate(utils, !!strictCompareDates, utils.date()))) return maxDateMessage;
    if (minDate && utils.isBefore(parsedValue, $c499664a2072b83c$var$getComparisonMinDate(utils, !!strictCompareDates, utils.date(minDate)))) return minDateMessage;
    if (disablePast && utils.isBefore(parsedValue, $c499664a2072b83c$var$getComparisonMinDate(utils, !!strictCompareDates, utils.date()))) return minDateMessage;
    return '';
};
function $c499664a2072b83c$export$ffb5f4729a158638(userFormat) {
    var ampm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var formats = arguments.length > 2 ? arguments[2] : undefined;
    if (userFormat) return userFormat;
    return ampm ? formats['12h'] : formats['24h'];
}
function $c499664a2072b83c$var$makeMaskFromFormat(format, numberMaskChar) {
    return format.replace(/[a-z]/gi, numberMaskChar);
}
var $c499664a2072b83c$var$maskedDateFormatter = function maskedDateFormatter(mask, numberMaskChar, refuse) {
    return function(value) {
        var result = '';
        var parsed = value.replace(refuse, '');
        if (parsed === '') return parsed;
        var i = 0;
        var n = 0;
        while(i < mask.length){
            var maskChar = mask[i];
            if (maskChar === numberMaskChar && n < parsed.length) {
                var parsedChar = parsed[n];
                result += parsedChar;
                n += 1;
            } else result += maskChar;
            i += 1;
        }
        return result;
    };
};
function $c499664a2072b83c$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c499664a2072b83c$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $c499664a2072b83c$var$ownKeys$1(source, true).forEach(function(key) {
            (0, $d2vKa.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $c499664a2072b83c$var$ownKeys$1(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $c499664a2072b83c$export$3466f893ebf79586 = function KeyboardDateInput(_ref) {
    var inputValue = _ref.inputValue, inputVariant = _ref.inputVariant, validationError = _ref.validationError, KeyboardButtonProps = _ref.KeyboardButtonProps, InputAdornmentProps = _ref.InputAdornmentProps, onOpen = _ref.openPicker, onChange = _ref.onChange, InputProps = _ref.InputProps, mask = _ref.mask, _ref$maskChar = _ref.maskChar, maskChar = _ref$maskChar === void 0 ? '_' : _ref$maskChar, _ref$refuse = _ref.refuse, refuse = _ref$refuse === void 0 ? /[^\d]+/gi : _ref$refuse, format = _ref.format, keyboardIcon = _ref.keyboardIcon, disabled = _ref.disabled, rifmFormatter = _ref.rifmFormatter, _ref$TextFieldCompone = _ref.TextFieldComponent, TextFieldComponent = _ref$TextFieldCompone === void 0 ? (0, $3a4ed32c219a2dd3$export$2e2bcd8739ae039) : _ref$TextFieldCompone, other = (0, $67mp8.default)(_ref, [
        "inputValue",
        "inputVariant",
        "validationError",
        "KeyboardButtonProps",
        "InputAdornmentProps",
        "openPicker",
        "onChange",
        "InputProps",
        "mask",
        "maskChar",
        "refuse",
        "format",
        "keyboardIcon",
        "disabled",
        "rifmFormatter",
        "TextFieldComponent"
    ]);
    var inputMask = mask || $c499664a2072b83c$var$makeMaskFromFormat(format, maskChar); // prettier-ignore
    var formatter = (0, $Fo7oF.useMemo)(function() {
        return $c499664a2072b83c$var$maskedDateFormatter(inputMask, maskChar, refuse);
    }, [
        inputMask,
        maskChar,
        refuse
    ]);
    var position = InputAdornmentProps && InputAdornmentProps.position ? InputAdornmentProps.position : 'end';
    var handleChange = function handleChange(text) {
        var finalString = text === '' || text === inputMask ? null : text;
        onChange(finalString);
    };
    return (0, $Fo7oF.createElement)((0, $5293dfd67851a7a7$export$5519909ee832c7c), {
        key: inputMask,
        value: inputValue,
        onChange: handleChange,
        refuse: refuse,
        format: rifmFormatter || formatter
    }, function(_ref2) {
        var onChange = _ref2.onChange, value = _ref2.value;
        return (0, $Fo7oF.createElement)(TextFieldComponent, (0, $elnlQ.default)({
            disabled: disabled,
            error: Boolean(validationError),
            helperText: validationError
        }, other, {
            value: value,
            onChange: onChange,
            variant: inputVariant,
            InputProps: $c499664a2072b83c$var$_objectSpread$1({}, InputProps, (0, $d2vKa.default)({}, "".concat(position, "Adornment"), (0, $Fo7oF.createElement)((0, $e8c9d2e5a94efd65$export$2e2bcd8739ae039), (0, $elnlQ.default)({
                position: position
            }, InputAdornmentProps), (0, $Fo7oF.createElement)((0, $c6e28b9de0df1599$export$2e2bcd8739ae039), (0, $elnlQ.default)({
                disabled: disabled
            }, KeyboardButtonProps, {
                onClick: onOpen
            }), keyboardIcon))))
        }));
    });
};
$c499664a2072b83c$export$3466f893ebf79586.defaultProps = {
    keyboardIcon: (0, $Fo7oF.createElement)($c499664a2072b83c$var$KeyboardIcon, null)
};
function $c499664a2072b83c$var$useOpenState(_ref) {
    var open = _ref.open, onOpen = _ref.onOpen, onClose = _ref.onClose;
    var setIsOpenState = null;
    if (open === undefined || open === null) {
        // The component is uncontrolled, so we need to give it its own state.
        var _useState = (0, $Fo7oF.useState)(false);
        var _useState2 = (0, $8YHhK.default)(_useState, 2);
        open = _useState2[0];
        setIsOpenState = _useState2[1];
    } // prettier-ignore
    var setIsOpen = (0, $Fo7oF.useCallback)(function(newIsOpen) {
        setIsOpenState && setIsOpenState(newIsOpen);
        return newIsOpen ? onOpen && onOpen() : onClose && onClose();
    }, [
        onOpen,
        onClose,
        setIsOpenState
    ]);
    return {
        isOpen: open,
        setIsOpen: setIsOpen
    };
}
var $c499664a2072b83c$var$useValueToDate = function useValueToDate(utils, _ref) {
    var value = _ref.value, initialFocusedDate = _ref.initialFocusedDate;
    var nowRef = (0, $Fo7oF.useRef)(utils.date());
    var date = utils.date(value || initialFocusedDate || nowRef.current);
    return date && utils.isValid(date) ? date : nowRef.current;
};
function $c499664a2072b83c$var$useDateValues(props, options) {
    var utils = (0, $3e8620cba75a223b$export$3b14a55fb2447963)();
    var date = $c499664a2072b83c$var$useValueToDate(utils, props);
    var format = props.format || options.getDefaultFormat();
    return {
        date: date,
        format: format
    };
}
function $c499664a2072b83c$export$3b14a55fb2447963(props, options) {
    var autoOk = props.autoOk, disabled = props.disabled, readOnly = props.readOnly, onAccept = props.onAccept, _onChange = props.onChange, onError = props.onError, value = props.value, variant = props.variant;
    var utils = (0, $3e8620cba75a223b$export$3b14a55fb2447963)();
    var _useOpenState = $c499664a2072b83c$var$useOpenState(props), isOpen = _useOpenState.isOpen, setIsOpen = _useOpenState.setIsOpen;
    var _useDateValues = $c499664a2072b83c$var$useDateValues(props, options), date = _useDateValues.date, format = _useDateValues.format;
    var _useState = (0, $Fo7oF.useState)(date), _useState2 = (0, $8YHhK.default)(_useState, 2), pickerDate = _useState2[0], setPickerDate = _useState2[1];
    (0, $Fo7oF.useEffect)(function() {
        // if value was changed in closed state - treat it as accepted
        if (!isOpen && !utils.isEqual(pickerDate, date)) setPickerDate(date);
    }, [
        date,
        isOpen,
        pickerDate,
        utils
    ]);
    var acceptDate = (0, $Fo7oF.useCallback)(function(acceptedDate) {
        _onChange(acceptedDate);
        if (onAccept) onAccept(acceptedDate);
        setIsOpen(false);
    }, [
        onAccept,
        _onChange,
        setIsOpen
    ]);
    var wrapperProps = (0, $Fo7oF.useMemo)(function() {
        return {
            format: format,
            open: isOpen,
            onClear: function onClear() {
                return acceptDate(null);
            },
            onAccept: function onAccept() {
                return acceptDate(pickerDate);
            },
            onSetToday: function onSetToday() {
                return setPickerDate(utils.date());
            },
            onDismiss: function onDismiss() {
                setIsOpen(false);
            }
        };
    }, [
        acceptDate,
        format,
        isOpen,
        pickerDate,
        setIsOpen,
        utils
    ]);
    var pickerProps = (0, $Fo7oF.useMemo)(function() {
        return {
            date: pickerDate,
            onChange: function onChange(newDate) {
                var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                setPickerDate(newDate);
                if (isFinish && autoOk) {
                    acceptDate(newDate);
                    return;
                } // simulate autoOk, but do not close the modal
                if (variant === 'inline' || variant === 'static') {
                    _onChange(newDate);
                    onAccept && onAccept(newDate);
                }
            }
        };
    }, [
        acceptDate,
        autoOk,
        onAccept,
        _onChange,
        pickerDate,
        variant
    ]);
    var validationError = $c499664a2072b83c$export$90a7f3efeed30595(value, utils, props);
    (0, $Fo7oF.useEffect)(function() {
        if (onError) onError(validationError, value);
    }, [
        onError,
        validationError,
        value
    ]);
    var inputValue = $c499664a2072b83c$var$getDisplayDate(date, format, utils, value === null, props);
    var inputProps = (0, $Fo7oF.useMemo)(function() {
        return {
            inputValue: inputValue,
            validationError: validationError,
            openPicker: function openPicker() {
                return !readOnly && !disabled && setIsOpen(true);
            }
        };
    }, [
        disabled,
        inputValue,
        readOnly,
        setIsOpen,
        validationError
    ]);
    var pickerState = {
        pickerProps: pickerProps,
        inputProps: inputProps,
        wrapperProps: wrapperProps
    };
    (0, $Fo7oF.useDebugValue)(pickerState);
    return pickerState;
}
function $c499664a2072b83c$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c499664a2072b83c$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $c499664a2072b83c$var$ownKeys$2(source, true).forEach(function(key) {
            (0, $d2vKa.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $c499664a2072b83c$var$ownKeys$2(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c499664a2072b83c$var$parseInputString(value, utils, format) {
    try {
        return utils.parse(value, format);
    } catch (_unused) {
        return null;
    }
}
function $c499664a2072b83c$export$8b22cf2602fb60ce(props, options) {
    var _props$format = props.format, format = _props$format === void 0 ? options.getDefaultFormat() : _props$format, inputValue = props.inputValue, _onChange = props.onChange, value = props.value;
    var utils = (0, $3e8620cba75a223b$export$3b14a55fb2447963)();
    var displayDate = $c499664a2072b83c$var$getDisplayDate(value, format, utils, value === null, props);
    var _useState = (0, $Fo7oF.useState)(displayDate), _useState2 = (0, $8YHhK.default)(_useState, 2), innerInputValue = _useState2[0], setInnerInputValue = _useState2[1];
    var dateValue = inputValue ? $c499664a2072b83c$var$parseInputString(inputValue, utils, format) : value;
    (0, $Fo7oF.useEffect)(function() {
        if (value === null || utils.isValid(value)) setInnerInputValue(displayDate);
    }, [
        displayDate,
        setInnerInputValue,
        utils,
        value
    ]);
    var handleKeyboardChange = (0, $Fo7oF.useCallback)(function(date) {
        _onChange(date, date === null ? null : utils.format(date, format));
    }, [
        format,
        _onChange,
        utils
    ]);
    var _usePickerState = $c499664a2072b83c$export$3b14a55fb2447963($c499664a2072b83c$var$_objectSpread$2({}, props, {
        value: dateValue,
        onChange: handleKeyboardChange
    }), options), innerInputProps = _usePickerState.inputProps, wrapperProps = _usePickerState.wrapperProps, pickerProps = _usePickerState.pickerProps;
    var inputProps = (0, $Fo7oF.useMemo)(function() {
        return $c499664a2072b83c$var$_objectSpread$2({}, innerInputProps, {
            // reuse validation and open/close logic
            format: wrapperProps.format,
            inputValue: inputValue || innerInputValue,
            onChange: function onChange(value) {
                setInnerInputValue(value || '');
                var date = value === null ? null : utils.parse(value, wrapperProps.format);
                _onChange(date, value);
            }
        });
    }, [
        innerInputProps,
        innerInputValue,
        inputValue,
        _onChange,
        utils,
        wrapperProps.format
    ]);
    return {
        inputProps: inputProps,
        wrapperProps: wrapperProps,
        pickerProps: pickerProps
    };
}
function $c499664a2072b83c$export$953cecd6e717a553(_ref) {
    var Input = _ref.Input, useState = _ref.useState, useOptions = _ref.useOptions, getCustomProps = _ref.getCustomProps, DefaultToolbarComponent = _ref.DefaultToolbarComponent;
    function PickerWithState(props) {
        var allowKeyboardControl = props.allowKeyboardControl, ampm = props.ampm, animateYearScrolling = props.animateYearScrolling, autoOk = props.autoOk, dateRangeIcon = props.dateRangeIcon, disableFuture = props.disableFuture, disablePast = props.disablePast, disableToolbar = props.disableToolbar, emptyLabel = props.emptyLabel, format = props.format, forwardedRef = props.forwardedRef, hideTabs = props.hideTabs, initialFocusedDate = props.initialFocusedDate, invalidDateMessage = props.invalidDateMessage, invalidLabel = props.invalidLabel, labelFunc = props.labelFunc, leftArrowButtonProps = props.leftArrowButtonProps, leftArrowIcon = props.leftArrowIcon, loadingIndicator = props.loadingIndicator, maxDate = props.maxDate, maxDateMessage = props.maxDateMessage, minDate = props.minDate, minDateMessage = props.minDateMessage, minutesStep = props.minutesStep, onAccept = props.onAccept, onChange = props.onChange, onClose = props.onClose, onMonthChange = props.onMonthChange, onOpen = props.onOpen, onYearChange = props.onYearChange, openTo = props.openTo, orientation = props.orientation, renderDay = props.renderDay, rightArrowButtonProps = props.rightArrowButtonProps, rightArrowIcon = props.rightArrowIcon, shouldDisableDate = props.shouldDisableDate, strictCompareDates = props.strictCompareDates, timeIcon = props.timeIcon, _props$ToolbarCompone = props.ToolbarComponent, ToolbarComponent = _props$ToolbarCompone === void 0 ? DefaultToolbarComponent : _props$ToolbarCompone, value = props.value, variant = props.variant, views = props.views, other = (0, $67mp8.default)(props, [
            "allowKeyboardControl",
            "ampm",
            "animateYearScrolling",
            "autoOk",
            "dateRangeIcon",
            "disableFuture",
            "disablePast",
            "disableToolbar",
            "emptyLabel",
            "format",
            "forwardedRef",
            "hideTabs",
            "initialFocusedDate",
            "invalidDateMessage",
            "invalidLabel",
            "labelFunc",
            "leftArrowButtonProps",
            "leftArrowIcon",
            "loadingIndicator",
            "maxDate",
            "maxDateMessage",
            "minDate",
            "minDateMessage",
            "minutesStep",
            "onAccept",
            "onChange",
            "onClose",
            "onMonthChange",
            "onOpen",
            "onYearChange",
            "openTo",
            "orientation",
            "renderDay",
            "rightArrowButtonProps",
            "rightArrowIcon",
            "shouldDisableDate",
            "strictCompareDates",
            "timeIcon",
            "ToolbarComponent",
            "value",
            "variant",
            "views"
        ]);
        var injectedProps = getCustomProps ? getCustomProps(props) : {};
        var options = useOptions(props);
        var _useState = useState(props, options), pickerProps = _useState.pickerProps, inputProps = _useState.inputProps, wrapperProps = _useState.wrapperProps;
        return (0, $Fo7oF.createElement)((0, $0ac5014ff7821bc1$export$71cec2538cb2c617), (0, $elnlQ.default)({
            variant: variant,
            InputComponent: Input,
            DateInputProps: inputProps
        }, injectedProps, wrapperProps, other), (0, $Fo7oF.createElement)((0, $872b39ed4acf9f0d$export$56c0d5a1e737357d), (0, $elnlQ.default)({}, pickerProps, {
            allowKeyboardControl: allowKeyboardControl,
            ampm: ampm,
            animateYearScrolling: animateYearScrolling,
            dateRangeIcon: dateRangeIcon,
            disableFuture: disableFuture,
            disablePast: disablePast,
            disableToolbar: disableToolbar,
            hideTabs: hideTabs,
            leftArrowButtonProps: leftArrowButtonProps,
            leftArrowIcon: leftArrowIcon,
            loadingIndicator: loadingIndicator,
            maxDate: maxDate,
            minDate: minDate,
            minutesStep: minutesStep,
            onMonthChange: onMonthChange,
            onYearChange: onYearChange,
            openTo: openTo,
            orientation: orientation,
            renderDay: renderDay,
            rightArrowButtonProps: rightArrowButtonProps,
            rightArrowIcon: rightArrowIcon,
            shouldDisableDate: shouldDisableDate,
            strictCompareDates: strictCompareDates,
            timeIcon: timeIcon,
            ToolbarComponent: ToolbarComponent,
            views: views
        })));
    }
    return PickerWithState;
}











parcelRequire("8YHhK");


parcelRequire("fxzEt");












var $dc5e91e41ff588fc$var$useStyles = (0, $43f27ed29b5bb141$export$2e2bcd8739ae039)({
    toolbar: {
        flexDirection: 'column',
        alignItems: 'flex-start'
    },
    toolbarLandscape: {
        padding: 16
    },
    dateLandscape: {
        marginRight: 16
    }
}, {
    name: 'MuiPickersDatePickerRoot'
});
var $dc5e91e41ff588fc$var$DatePickerToolbar = function DatePickerToolbar(_ref) {
    var date = _ref.date, views = _ref.views, setOpenView = _ref.setOpenView, isLandscape = _ref.isLandscape, openView = _ref.openView;
    var utils = (0, $3e8620cba75a223b$export$3b14a55fb2447963)();
    var classes = $dc5e91e41ff588fc$var$useStyles();
    var isYearOnly = (0, $Fo7oF.useMemo)(function() {
        return (0, $0fa1d30fe6dc6a08$export$23f2a1d2818174ef)(views);
    }, [
        views
    ]);
    var isYearAndMonth = (0, $Fo7oF.useMemo)(function() {
        return (0, $0fa1d30fe6dc6a08$export$8b22cf2602fb60ce)(views);
    }, [
        views
    ]);
    return (0, $Fo7oF.createElement)((0, $c499664a2072b83c$export$56c0d5a1e737357d), {
        isLandscape: isLandscape,
        className: (0, $78z8j.default)(!isYearOnly && classes.toolbar, isLandscape && classes.toolbarLandscape)
    }, (0, $Fo7oF.createElement)((0, $c499664a2072b83c$export$971d5caa766a69d7), {
        variant: isYearOnly ? 'h3' : 'subtitle1',
        onClick: function onClick() {
            return setOpenView('year');
        },
        selected: openView === 'year',
        label: utils.getYearText(date)
    }), !isYearOnly && !isYearAndMonth && (0, $Fo7oF.createElement)((0, $c499664a2072b83c$export$971d5caa766a69d7), {
        variant: "h4",
        selected: openView === 'date',
        onClick: function onClick() {
            return setOpenView('date');
        },
        align: isLandscape ? 'left' : 'center',
        label: utils.getDatePickerHeaderText(date),
        className: (0, $78z8j.default)(isLandscape && classes.dateLandscape)
    }), isYearAndMonth && (0, $Fo7oF.createElement)((0, $c499664a2072b83c$export$971d5caa766a69d7), {
        variant: "h4",
        onClick: function onClick() {
            return setOpenView('month');
        },
        selected: openView === 'month',
        label: utils.getMonthText(date)
    }));
};
function $dc5e91e41ff588fc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dc5e91e41ff588fc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dc5e91e41ff588fc$var$ownKeys(source, true).forEach(function(key) {
            (0, $d2vKa.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dc5e91e41ff588fc$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $dc5e91e41ff588fc$var$defaultProps = $dc5e91e41ff588fc$var$_objectSpread({}, (0, $872b39ed4acf9f0d$export$4368d992c4eafac0), {
    openTo: 'date',
    views: [
        'year',
        'date'
    ]
});
function $dc5e91e41ff588fc$var$useOptions(props) {
    var utils = (0, $3e8620cba75a223b$export$3b14a55fb2447963)();
    return {
        getDefaultFormat: function getDefaultFormat() {
            return (0, $0fa1d30fe6dc6a08$export$39b482c5e57630a8)(props.views, utils);
        }
    };
}
var $dc5e91e41ff588fc$export$5109c6dd95d8fb00 = (0, $c499664a2072b83c$export$953cecd6e717a553)({
    useOptions: $dc5e91e41ff588fc$var$useOptions,
    Input: (0, $c499664a2072b83c$export$407448d2b89b1813),
    useState: (0, $c499664a2072b83c$export$3b14a55fb2447963),
    DefaultToolbarComponent: $dc5e91e41ff588fc$var$DatePickerToolbar
});
var $dc5e91e41ff588fc$export$d8c44f501031ee7c = (0, $c499664a2072b83c$export$953cecd6e717a553)({
    useOptions: $dc5e91e41ff588fc$var$useOptions,
    Input: (0, $c499664a2072b83c$export$3466f893ebf79586),
    useState: (0, $c499664a2072b83c$export$8b22cf2602fb60ce),
    DefaultToolbarComponent: $dc5e91e41ff588fc$var$DatePickerToolbar
});
$dc5e91e41ff588fc$export$5109c6dd95d8fb00.defaultProps = $dc5e91e41ff588fc$var$defaultProps;
$dc5e91e41ff588fc$export$d8c44f501031ee7c.defaultProps = $dc5e91e41ff588fc$var$defaultProps;








var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");
var $27bb6d1dc23c636d$exports = {};


!function(e, t) {
    $27bb6d1dc23c636d$exports = t((parcelRequire("lwFFd")), (parcelRequire("Fo7oF")));
}($27bb6d1dc23c636d$exports, function(e, t) {
    return function(e) {
        var t = {};
        function n(r) {
            if (t[r]) return t[r].exports;
            var o = t[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
        }
        return n.m = e, n.c = t, n.d = function(e, t, r) {
            n.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: r
            });
        }, n.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, n.t = function(e, t) {
            if (1 & t && (e = n(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var r = Object.create(null);
            if (n.r(r), Object.defineProperty(r, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var o in e)n.d(r, o, (function(t) {
                return e[t];
            }).bind(null, o));
            return r;
        }, n.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return n.d(t, "a", t), t;
        }, n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = 6);
    }([
        function(e, t, n) {
            e.exports = n(3)();
        },
        function(t, n) {
            t.exports = e;
        },
        function(e, n) {
            e.exports = t;
        },
        function(e, t, n) {
            "use strict";
            var r = n(4);
            function o() {}
            function i() {}
            i.resetWarningCache = o, e.exports = function() {
                function e(e, t, n, o, i, a) {
                    if (a !== r) {
                        var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                        throw l.name = "Invariant Violation", l;
                    }
                }
                function t() {
                    return e;
                }
                e.isRequired = e;
                var n = {
                    array: e,
                    bool: e,
                    func: e,
                    number: e,
                    object: e,
                    string: e,
                    symbol: e,
                    any: e,
                    arrayOf: t,
                    element: e,
                    elementType: e,
                    instanceOf: t,
                    node: e,
                    objectOf: t,
                    oneOf: t,
                    oneOfType: t,
                    shape: t,
                    exact: t,
                    checkPropTypes: i,
                    resetWarningCache: o
                };
                return n.PropTypes = n, n;
            };
        },
        function(e, t, n) {
            "use strict";
            e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        },
        function(e, t, n) {
            var r, o, i, a, l;
            /*! Moment Duration Format v2.2.2
 *  https://github.com/jsmreese/moment-duration-format
 *  Date: 2018-02-16
 *
 *  Duration format plugin function for the Moment.js library
 *  http://momentjs.com/
 *
 *  Copyright 2018 John Madhavan-Reese
 *  Released under the MIT license
 */ /*! Moment Duration Format v2.2.2
 *  https://github.com/jsmreese/moment-duration-format
 *  Date: 2018-02-16
 *
 *  Duration format plugin function for the Moment.js library
 *  http://momentjs.com/
 *
 *  Copyright 2018 John Madhavan-Reese
 *  Released under the MIT license
 */ a = this, l = function(e) {
                var t = !1, n = !1, r = "escape years months weeks days hours minutes seconds milliseconds general".split(" "), o = [
                    {
                        type: "seconds",
                        targets: [
                            {
                                type: "minutes",
                                value: 60
                            },
                            {
                                type: "hours",
                                value: 3600
                            },
                            {
                                type: "days",
                                value: 86400
                            },
                            {
                                type: "weeks",
                                value: 604800
                            },
                            {
                                type: "months",
                                value: 2678400
                            },
                            {
                                type: "years",
                                value: 31536e3
                            }
                        ]
                    },
                    {
                        type: "minutes",
                        targets: [
                            {
                                type: "hours",
                                value: 60
                            },
                            {
                                type: "days",
                                value: 1440
                            },
                            {
                                type: "weeks",
                                value: 10080
                            },
                            {
                                type: "months",
                                value: 44640
                            },
                            {
                                type: "years",
                                value: 525600
                            }
                        ]
                    },
                    {
                        type: "hours",
                        targets: [
                            {
                                type: "days",
                                value: 24
                            },
                            {
                                type: "weeks",
                                value: 168
                            },
                            {
                                type: "months",
                                value: 744
                            },
                            {
                                type: "years",
                                value: 8760
                            }
                        ]
                    },
                    {
                        type: "days",
                        targets: [
                            {
                                type: "weeks",
                                value: 7
                            },
                            {
                                type: "months",
                                value: 31
                            },
                            {
                                type: "years",
                                value: 365
                            }
                        ]
                    },
                    {
                        type: "months",
                        targets: [
                            {
                                type: "years",
                                value: 12
                            }
                        ]
                    }
                ];
                function i(e, t) {
                    return !(t.length > e.length) && -1 !== e.indexOf(t);
                }
                function a(e) {
                    for(var t = ""; e;)t += "0", e -= 1;
                    return t;
                }
                function l(e, t, r) {
                    var o, i, u, s = t.useToLocaleString, c = t.useGrouping, m = c && t.grouping.slice(), f = t.maximumSignificantDigits, p = t.minimumIntegerDigits || 1, g = t.fractionDigits || 0, y = t.groupingSeparator, h = t.decimalSeparator;
                    if (s && r) {
                        var d = {
                            minimumIntegerDigits: p,
                            useGrouping: c
                        };
                        if (g && (d.maximumFractionDigits = g, d.minimumFractionDigits = g), f && e > 0 && (d.maximumSignificantDigits = f), !n) {
                            var v = w({}, t);
                            v.useGrouping = !1, v.decimalSeparator = ".", e = parseFloat(l(e, v), 10);
                        }
                        return e.toLocaleString(r, d);
                    }
                    var b = (f ? e.toPrecision(f + 1) : e.toFixed(g + 1)).split("e");
                    u = b[1] || "", i = (b = b[0].split("."))[1] || "";
                    var S = (o = b[0] || "").length, T = i.length, _ = S + T, x = o + i;
                    (f && _ === f + 1 || !f && T === g + 1) && ((x = function(e) {
                        for(var t = e.split("").reverse(), n = 0, r = !0; r && n < t.length;)n ? "9" === t[n] ? t[n] = "0" : (t[n] = (parseInt(t[n], 10) + 1).toString(), r = !1) : (parseInt(t[n], 10) < 5 && (r = !1), t[n] = "0"), n += 1;
                        return r && t.push("1"), t.reverse().join("");
                    }(x)).length === _ + 1 && (S += 1), T && (x = x.slice(0, -1)), o = x.slice(0, S), i = x.slice(S)), f && (i = i.replace(/0*$/, ""));
                    var O = parseInt(u, 10);
                    O > 0 ? i.length <= O ? (o += i += a(O - i.length), i = "") : (o += i.slice(0, O), i = i.slice(O)) : O < 0 && (i = a(Math.abs(O) - o.length) + o + i, o = "0"), f || ((i = i.slice(0, g)).length < g && (i += a(g - i.length)), o.length < p && (o = a(p - o.length) + o));
                    var V, D = "";
                    if (c) for(b = o; b.length;)m.length && (V = m.shift()), D && (D = y + D), D = b.slice(-V) + D, b = b.slice(0, -V);
                    else D = o;
                    return i && (D = D + h + i), D;
                }
                function u(e, t) {
                    return e.label.length > t.label.length ? -1 : e.label.length < t.label.length ? 1 : 0;
                }
                var s, c = {
                    durationLabelsStandard: {
                        S: "millisecond",
                        SS: "milliseconds",
                        s: "second",
                        ss: "seconds",
                        m: "minute",
                        mm: "minutes",
                        h: "hour",
                        hh: "hours",
                        d: "day",
                        dd: "days",
                        w: "week",
                        ww: "weeks",
                        M: "month",
                        MM: "months",
                        y: "year",
                        yy: "years"
                    },
                    durationLabelsShort: {
                        S: "msec",
                        SS: "msecs",
                        s: "sec",
                        ss: "secs",
                        m: "min",
                        mm: "mins",
                        h: "hr",
                        hh: "hrs",
                        d: "dy",
                        dd: "dys",
                        w: "wk",
                        ww: "wks",
                        M: "mo",
                        MM: "mos",
                        y: "yr",
                        yy: "yrs"
                    },
                    durationTimeTemplates: {
                        HMS: "h:mm:ss",
                        HM: "h:mm",
                        MS: "m:ss"
                    },
                    durationLabelTypes: [
                        {
                            type: "standard",
                            string: "__"
                        },
                        {
                            type: "short",
                            string: "_"
                        }
                    ],
                    durationPluralKey: function(e, t, n) {
                        return 1 === t && null === n ? e : e + e;
                    }
                };
                function m(e) {
                    return "[object Array]" === Object.prototype.toString.call(e);
                }
                function f(e) {
                    return "[object Object]" === Object.prototype.toString.call(e);
                }
                function p(e, t) {
                    var n, r = 0, o = e && e.length || 0;
                    for("function" != typeof t && (n = t, t = function(e) {
                        return e === n;
                    }); r < o;){
                        if (t(e[r])) return e[r];
                        r += 1;
                    }
                }
                function g(e, t) {
                    var n = 0, r = e.length;
                    if (e && r) for(; n < r;){
                        if (!1 === t(e[n], n)) return;
                        n += 1;
                    }
                }
                function y(e, t) {
                    var n = 0, r = e.length, o = [];
                    if (!e || !r) return o;
                    for(; n < r;)o[n] = t(e[n], n), n += 1;
                    return o;
                }
                function h(e, t) {
                    return y(e, function(e) {
                        return e[t];
                    });
                }
                function d(e) {
                    var t = [];
                    return g(e, function(e) {
                        e && t.push(e);
                    }), t;
                }
                function v(e) {
                    var t = [];
                    return g(e, function(e) {
                        p(t, e) || t.push(e);
                    }), t;
                }
                function b(e, t) {
                    var n = [];
                    return g(e, function(e) {
                        g(t, function(t) {
                            e === t && n.push(e);
                        });
                    }), v(n);
                }
                function S(e, t) {
                    var n = [];
                    return g(e, function(r, o) {
                        if (!t(r)) return n = e.slice(o), !1;
                    }), n;
                }
                function w(e, t) {
                    for(var n in t)t.hasOwnProperty(n) && (e[n] = t[n]);
                    return e;
                }
                function T(e) {
                    var t = [];
                    for(var n in e)e.hasOwnProperty(n) && t.push(n);
                    return t;
                }
                function _(e, t) {
                    var n = 0, r = e.length;
                    if (!e || !r) return !1;
                    for(; n < r;){
                        if (!0 === t(e[n], n)) return !0;
                        n += 1;
                    }
                    return !1;
                }
                function x() {
                    var e, t = [].slice.call(arguments), n = {};
                    if (g(t, function(t, r) {
                        if (!r) {
                            if (!m(t)) throw "Expected array as the first argument to durationsFormat.";
                            e = t;
                        }
                        "string" != typeof t && "function" != typeof t ? "number" != typeof t ? f(t) && w(n, t) : n.precision = t : n.template = t;
                    }), !e || !e.length) return [];
                    n.returnMomentTypes = !0;
                    var o, i = y(e, function(e) {
                        return e.format(n);
                    }), a = b(r, v(h((o = [], g(i, function(e) {
                        o = o.concat(e);
                    }), o), "type"))), l = n.largest;
                    return l && (a = a.slice(0, l)), n.returnMomentTypes = !1, n.outputTypes = a, y(e, function(e) {
                        return e.format(n);
                    });
                }
                function O() {
                    var n = [].slice.call(arguments), a = w({}, this.format.defaults), s = this.asMilliseconds(), x = this.asMonths();
                    "function" == typeof this.isValid && !1 === this.isValid() && (s = 0, x = 0);
                    var O = s < 0, V = e.duration(Math.abs(s), "milliseconds"), D = e.duration(Math.abs(x), "months");
                    g(n, function(e) {
                        "string" != typeof e && "function" != typeof e ? "number" != typeof e ? f(e) && w(a, e) : a.precision = e : a.template = e;
                    });
                    var L = {
                        years: "y",
                        months: "M",
                        weeks: "w",
                        days: "d",
                        hours: "h",
                        minutes: "m",
                        seconds: "s",
                        milliseconds: "S"
                    }, j = {
                        escape: /\[(.+?)\]/,
                        years: /\*?[Yy]+/,
                        months: /\*?M+/,
                        weeks: /\*?[Ww]+/,
                        days: /\*?[Dd]+/,
                        hours: /\*?[Hh]+/,
                        minutes: /\*?m+/,
                        seconds: /\*?s+/,
                        milliseconds: /\*?S+/,
                        general: /.+?/
                    };
                    a.types = r;
                    var M = function(e) {
                        return p(r, function(t) {
                            return j[t].test(e);
                        });
                    }, k = new RegExp(y(r, function(e) {
                        return j[e].source;
                    }).join("|"), "g");
                    a.duration = this;
                    var P = "function" == typeof a.template ? a.template.apply(a) : a.template, E = a.outputTypes, F = a.returnMomentTypes, I = a.largest, C = [];
                    E || (m(a.stopTrim) && (a.stopTrim = a.stopTrim.join("")), a.stopTrim && g(a.stopTrim.match(k), function(e) {
                        var t = M(e);
                        "escape" !== t && "general" !== t && C.push(t);
                    }));
                    var N = e.localeData();
                    N || (N = {}), g(T(c), function(e) {
                        "function" != typeof c[e] ? N["_" + e] || (N["_" + e] = c[e]) : N[e] || (N[e] = c[e]);
                    }), g(T(N._durationTimeTemplates), function(e) {
                        P = P.replace("_" + e + "_", N._durationTimeTemplates[e]);
                    });
                    var G = a.userLocale || e.locale(), R = a.useLeftUnits, U = a.usePlural, q = a.precision, z = a.forceLength, H = a.useGrouping, W = a.trunc, $ = a.useSignificantDigits && q > 0, A = $ ? a.precision : 0, B = A, K = a.minValue, Y = !1, J = a.maxValue, Q = !1, X = a.useToLocaleString, Z = a.groupingSeparator, ee = a.decimalSeparator, te = a.grouping;
                    X = X && t;
                    var ne = a.trim;
                    m(ne) && (ne = ne.join(" ")), null === ne && (I || J || $) && (ne = "all"), null !== ne && !0 !== ne && "left" !== ne && "right" !== ne || (ne = "large"), !1 === ne && (ne = "");
                    var re = function(e) {
                        return e.test(ne);
                    }, oe = /both/, ie = /^all|[^sm]all/, ae = I > 0 || _([
                        /large/,
                        oe,
                        ie
                    ], re), le = _([
                        /small/,
                        oe,
                        ie
                    ], re), ue = _([
                        /mid/,
                        ie
                    ], re), se = _([
                        /final/,
                        ie
                    ], re), ce = y(P.match(k), function(e, t) {
                        var n = M(e);
                        return "*" === e.slice(0, 1) && (e = e.slice(1), "escape" !== n && "general" !== n && C.push(n)), {
                            index: t,
                            length: e.length,
                            text: "",
                            token: "escape" === n ? e.replace(j.escape, "$1") : e,
                            type: "escape" === n || "general" === n ? null : n
                        };
                    }), me = {
                        index: 0,
                        length: 0,
                        token: "",
                        text: "",
                        type: null
                    }, fe = [];
                    R && ce.reverse(), g(ce, function(e) {
                        if (e.type) return (me.type || me.text) && fe.push(me), void (me = e);
                        R ? me.text = e.token + me.text : me.text += e.token;
                    }), (me.type || me.text) && fe.push(me), R && fe.reverse();
                    var pe = b(r, v(d(h(fe, "type"))));
                    if (!pe.length) return h(fe, "text").join("");
                    pe = y(pe, function(e, t) {
                        var n, r = t + 1 === pe.length, o = !t;
                        n = "years" === e || "months" === e ? D.as(e) : V.as(e);
                        var i = Math.floor(n), l = n - i, u = p(fe, function(t) {
                            return e === t.type;
                        });
                        return o && J && n > J && (Q = !0), r && K && Math.abs(a.duration.as(e)) < K && (Y = !0), o && null === z && u.length > 1 && (z = !0), V.subtract(i, e), D.subtract(i, e), {
                            rawValue: n,
                            wholeValue: i,
                            decimalValue: r ? l : 0,
                            isSmallest: r,
                            isLargest: o,
                            type: e,
                            tokenLength: u.length
                        };
                    });
                    var ge, ye = W ? Math.floor : Math.round, he = function(e, t) {
                        var n = Math.pow(10, t);
                        return ye(e * n) / n;
                    }, de = !1, ve = !1, be = function(e, t) {
                        var n = {
                            useGrouping: H,
                            groupingSeparator: Z,
                            decimalSeparator: ee,
                            grouping: te,
                            useToLocaleString: X
                        };
                        return $ && (A <= 0 ? (e.rawValue = 0, e.wholeValue = 0, e.decimalValue = 0) : (n.maximumSignificantDigits = A, e.significantDigits = A)), Q && !ve && (e.isLargest ? (e.wholeValue = J, e.decimalValue = 0) : (e.wholeValue = 0, e.decimalValue = 0)), Y && !ve && (e.isSmallest ? (e.wholeValue = K, e.decimalValue = 0) : (e.wholeValue = 0, e.decimalValue = 0)), e.isSmallest || e.significantDigits && e.significantDigits - e.wholeValue.toString().length <= 0 ? q < 0 ? e.value = he(e.wholeValue, q) : 0 === q ? e.value = ye(e.wholeValue + e.decimalValue) : $ ? (e.value = W ? he(e.rawValue, A - e.wholeValue.toString().length) : e.rawValue, e.wholeValue && (A -= e.wholeValue.toString().length)) : (n.fractionDigits = q, e.value = W ? e.wholeValue + he(e.decimalValue, q) : e.wholeValue + e.decimalValue) : $ && e.wholeValue ? (e.value = Math.round(he(e.wholeValue, e.significantDigits - e.wholeValue.toString().length)), A -= e.wholeValue.toString().length) : e.value = e.wholeValue, e.tokenLength > 1 && (z || de) && (n.minimumIntegerDigits = e.tokenLength, ve && n.maximumSignificantDigits < e.tokenLength && delete n.maximumSignificantDigits), !de && (e.value > 0 || "" === ne || p(C, e.type) || p(E, e.type)) && (de = !0), e.formattedValue = l(e.value, n, G), n.useGrouping = !1, n.decimalSeparator = ".", e.formattedValueEn = l(e.value, n, "en"), 2 === e.tokenLength && "milliseconds" === e.type && (e.formattedValueMS = l(e.value, {
                            minimumIntegerDigits: 3,
                            useGrouping: !1
                        }, "en").slice(0, 2)), e;
                    };
                    if ((pe = d(pe = y(pe, be))).length > 1) {
                        var Se = function(e) {
                            return p(pe, function(t) {
                                return t.type === e;
                            });
                        };
                        g(o, function(e) {
                            var t = Se(e.type);
                            t && g(e.targets, function(e) {
                                var n = Se(e.type);
                                n && parseInt(t.formattedValueEn, 10) === e.value && (t.rawValue = 0, t.wholeValue = 0, t.decimalValue = 0, n.rawValue += 1, n.wholeValue += 1, n.decimalValue = 0, n.formattedValueEn = n.wholeValue.toString(), ve = !0);
                            });
                        });
                    }
                    return ve && (de = !1, A = B, pe = d(pe = y(pe, be))), !E || Q && !a.trim ? (ae && (pe = S(pe, function(e) {
                        return !e.isSmallest && !e.wholeValue && !p(C, e.type);
                    })), I && pe.length && (pe = pe.slice(0, I)), le && pe.length > 1 && (ge = function(e) {
                        return !e.wholeValue && !p(C, e.type) && !e.isLargest;
                    }, pe = S(pe.slice().reverse(), ge).reverse()), ue && (pe = d(pe = y(pe, function(e, t) {
                        return t > 0 && t < pe.length - 1 && !e.wholeValue ? null : e;
                    }))), !se || 1 !== pe.length || pe[0].wholeValue || !W && pe[0].isSmallest && pe[0].rawValue < K || (pe = [])) : pe = d(pe = y(pe, function(e) {
                        return p(E, function(t) {
                            return e.type === t;
                        }) ? e : null;
                    })), F ? pe : (g(fe, function(e) {
                        var t = L[e.type], n = p(pe, function(t) {
                            return t.type === e.type;
                        });
                        if (t && n) {
                            var r = n.formattedValueEn.split(".");
                            r[0] = parseInt(r[0], 10), r[1] ? r[1] = parseFloat("0." + r[1], 10) : r[1] = null;
                            var o = N.durationPluralKey(t, r[0], r[1]), a = function(e, t) {
                                var n = [];
                                return g(T(t), function(r) {
                                    if ("_durationLabels" === r.slice(0, 15)) {
                                        var o = r.slice(15).toLowerCase();
                                        g(T(t[r]), function(i) {
                                            i.slice(0, 1) === e && n.push({
                                                type: o,
                                                key: i,
                                                label: t[r][i]
                                            });
                                        });
                                    }
                                }), n;
                            }(t, N), l = !1, s = {};
                            g(N._durationLabelTypes, function(t) {
                                var n = p(a, function(e) {
                                    return e.type === t.type && e.key === o;
                                });
                                n && (s[n.type] = n.label, i(e.text, t.string) && (e.text = e.text.replace(t.string, n.label), l = !0));
                            }), U && !l && (a.sort(u), g(a, function(t) {
                                return s[t.type] === t.label ? !i(e.text, t.label) && void 0 : i(e.text, t.label) ? (e.text = e.text.replace(t.label, s[t.type]), !1) : void 0;
                            }));
                        }
                    }), (fe = y(fe, function(e) {
                        if (!e.type) return e.text;
                        var t = p(pe, function(t) {
                            return t.type === e.type;
                        });
                        if (!t) return "";
                        var n = "";
                        return R && (n += e.text), (O && Q || !O && Y) && (n += "< ", Q = !1, Y = !1), (O && Y || !O && Q) && (n += "> ", Q = !1, Y = !1), O && (t.value > 0 || "" === ne || p(C, t.type) || p(E, t.type)) && (n += "-", O = !1), "milliseconds" === e.type && t.formattedValueMS ? n += t.formattedValueMS : n += t.formattedValue, R || (n += e.text), n;
                    })).join("").replace(/(,| |:|\.)*$/, "").replace(/^(,| |:|\.)*/, ""));
                }
                function V() {
                    var e = this.duration, t = function(t) {
                        return e._data[t];
                    }, n = p(this.types, t), r = function(e, t) {
                        for(var n = e.length; n -= 1;)if (t(e[n])) return e[n];
                    }(this.types, t);
                    switch(n){
                        case "milliseconds":
                            return "S __";
                        case "seconds":
                        case "minutes":
                            return "*_MS_";
                        case "hours":
                            return "_HMS_";
                        case "days":
                            if (n === r) return "d __";
                        case "weeks":
                            return n === r ? "w __" : (null === this.trim && (this.trim = "both"), "w __, d __, h __");
                        case "months":
                            if (n === r) return "M __";
                        case "years":
                            return n === r ? "y __" : (null === this.trim && (this.trim = "both"), "y __, M __, d __");
                        default:
                            return null === this.trim && (this.trim = "both"), "y __, d __, h __, m __, s __";
                    }
                }
                function D(e) {
                    if (!e) throw "Moment Duration Format init cannot find moment instance.";
                    e.duration.format = x, e.duration.fn.format = O, e.duration.fn.format.defaults = {
                        trim: null,
                        stopTrim: null,
                        largest: null,
                        maxValue: null,
                        minValue: null,
                        precision: 0,
                        trunc: !1,
                        forceLength: null,
                        userLocale: null,
                        usePlural: !0,
                        useLeftUnits: !1,
                        useGrouping: !0,
                        useSignificantDigits: !1,
                        template: V,
                        useToLocaleString: !0,
                        groupingSeparator: ",",
                        decimalSeparator: ".",
                        grouping: [
                            3
                        ]
                    }, e.updateLocale("en", c);
                }
                return t = !!((s = (s = !0, function() {
                    try {
                        0..toLocaleString("i");
                    } catch (e) {
                        return "RangeError" === e.name;
                    }
                    return !1;
                }())) && (s = (s = (s = s && "1" === 1..toLocaleString("en", {
                    minimumIntegerDigits: 1
                })) && "01" === 1..toLocaleString("en", {
                    minimumIntegerDigits: 2
                })) && "001" === 1..toLocaleString("en", {
                    minimumIntegerDigits: 3
                })) && (s = (s = (s = (s = s && "100" === 99.99.toLocaleString("en", {
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0
                })) && "100.0" === 99.99.toLocaleString("en", {
                    maximumFractionDigits: 1,
                    minimumFractionDigits: 1
                })) && "99.99" === 99.99.toLocaleString("en", {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2
                })) && "99.990" === 99.99.toLocaleString("en", {
                    maximumFractionDigits: 3,
                    minimumFractionDigits: 3
                })) && (s = (s = (s = (s = (s = s && "100" === 99.99.toLocaleString("en", {
                    maximumSignificantDigits: 1
                })) && "100" === 99.99.toLocaleString("en", {
                    maximumSignificantDigits: 2
                })) && "100" === 99.99.toLocaleString("en", {
                    maximumSignificantDigits: 3
                })) && "99.99" === 99.99.toLocaleString("en", {
                    maximumSignificantDigits: 4
                })) && "99.99" === 99.99.toLocaleString("en", {
                    maximumSignificantDigits: 5
                })) && (s = (s = s && "1,000" === 1e3.toLocaleString("en", {
                    useGrouping: !0
                })) && "1000" === 1e3.toLocaleString("en", {
                    useGrouping: !1
                }))), n = t && "3.6" === 3.55.toLocaleString("en", {
                    useGrouping: !1,
                    minimumIntegerDigits: 1,
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1
                }), D(e), D;
            }, o = [
                n(1)
            ], void 0 === (i = "function" == typeof (r = l) ? r.apply(t, o) : r) || (e.exports = i), a && (a.momentDurationFormatSetup = a.moment ? l(a.moment) : l);
        },
        function(e, t, n) {
            "use strict";
            n.r(t);
            var r = n(2), o = n.n(r), i = n(0), a = n.n(i), l = n(1), u = n.n(l);
            n(5);
            function s(e) {
                return (s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function c(e, t) {
                if (null == e) return {};
                var n, r, o = function(e, t) {
                    if (null == e) return {};
                    var n, r, o = {}, i = Object.keys(e);
                    for(r = 0; r < i.length; r++)n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                    return o;
                }(e, t);
                if (Object.getOwnPropertySymbols) {
                    var i = Object.getOwnPropertySymbols(e);
                    for(r = 0; r < i.length; r++)n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
                }
                return o;
            }
            function m(e) {
                return (m = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e);
                })(e);
            }
            function f(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }
            function p(e, t) {
                for(var n = 0; n < t.length; n++){
                    var r = t[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                }
            }
            function g(e, t, n) {
                return t && p(e.prototype, t), n && p(e, n), e;
            }
            function y(e, t) {
                return (y = Object.setPrototypeOf || function(e, t) {
                    return e.__proto__ = t, e;
                })(e, t);
            }
            function h(e, t, n) {
                return t in e ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = n, e;
            }
            n.d(t, "default", function() {
                return S;
            });
            var d = [
                a.a.string,
                a.a.number,
                a.a.array,
                a.a.object
            ], v = [
                a.a.string,
                a.a.array
            ], b = [
                a.a.object,
                a.a.bool
            ], S = function(e) {
                function t(e) {
                    var n, r, o;
                    return function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), r = this, o = m(t).call(this, e), n = !o || "object" !== s(o) && "function" != typeof o ? f(r) : o, h(f(n), "setTimer", function() {
                        var e = n.props.interval;
                        n.clearTimer(), t.pooledTimer || 0 === e || (n.timer = setInterval(function() {
                            n.update(n.props);
                        }, e));
                    }), h(f(n), "getTitle", function() {
                        var e = n.props.titleFormat, r = t.getDatetime(n.props), o = e || t.globalFormat;
                        return r.format(o);
                    }), h(f(n), "clearTimer", function() {
                        !t.pooledTimer && n.timer && (clearInterval(n.timer), n.timer = null), t.pooledTimer && !n.timer && t.removePooledElement(f(n));
                    }), t.globalMoment || (t.globalMoment = u.a), n.state = {
                        content: ""
                    }, n.timer = null, n;
                }
                return function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), t && y(e, t);
                }(t, o.a.Component), g(t, null, [
                    {
                        key: "startPooledTimer",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 6e4;
                            t.clearPooledTimer(), t.pooledTimer = setInterval(function() {
                                t.pooledElements.forEach(function(e) {
                                    0 !== e.props.interval && e.update();
                                });
                            }, e);
                        }
                    },
                    {
                        key: "clearPooledTimer",
                        value: function() {
                            t.pooledTimer && (clearInterval(t.pooledTimer), t.pooledTimer = null, t.pooledElements = []);
                        }
                    },
                    {
                        key: "pushPooledElement",
                        value: function(e) {
                            e instanceof t ? -1 === t.pooledElements.indexOf(e) && t.pooledElements.push(e) : console.error("Element not an instance of Moment.");
                        }
                    },
                    {
                        key: "removePooledElement",
                        value: function(e) {
                            var n = t.pooledElements.indexOf(e);
                            -1 !== n && t.pooledElements.splice(n, 1);
                        }
                    },
                    {
                        key: "getDatetime",
                        value: function(e) {
                            var n = e.utc, r = e.unix, o = e.date, i = e.locale, a = e.parse, l = e.tz, u = e.local;
                            o = o || e.children, a = a || t.globalParse, u = u || t.globalLocal, l = l || t.globalTimezone, i = t.globalLocale ? t.globalLocale : i || t.globalMoment.locale();
                            var s = null;
                            return s = n ? t.globalMoment.utc(o, a, i) : r ? t.globalMoment(1e3 * o, a, i) : t.globalMoment(o, a, i), l ? s = s.tz(l) : u && (s = s.local()), s;
                        }
                    },
                    {
                        key: "getContent",
                        value: function(e) {
                            var n = e.fromNow, r = e.fromNowDuring, o = e.from, i = e.add, a = e.subtract, l = e.toNow, s = e.to, c = e.ago, m = e.calendar, f = e.diff, p = e.duration, g = e.durationFromNow, y = e.unit, h = e.decimal, d = e.format;
                            d = d || t.globalFormat;
                            var v = t.getDatetime(e);
                            i && v.add(i), a && v.subtract(a);
                            var b = Boolean(r) && -v.diff(u()()) < r, S = "";
                            return S = d && !b ? v.format(d) : o ? v.from(o, c) : n || b ? v.fromNow(c) : s ? v.to(s, c) : l ? v.toNow(c) : m ? v.calendar(null, m) : f ? v.diff(f, y, h) : p ? v.diff(p) : g ? u()().diff(v) : v.toString(), (p || g) && (S = (S = u.a.duration(S)).format(d)), S = (t.globalFilter || e.filter)(S);
                        }
                    }
                ]), g(t, [
                    {
                        key: "componentDidMount",
                        value: function() {
                            this.setTimer(), t.pooledTimer && t.pushPooledElement(this);
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function(e) {
                            var t = this.props.interval;
                            e.interval !== t && this.setTimer();
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.clearTimer();
                        }
                    },
                    {
                        key: "update",
                        value: function(e) {
                            var n = e || this.props, r = n.onChange, o = t.getContent(n);
                            this.setState({
                                content: o
                            }, function() {
                                r(o);
                            });
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e, n, r, i, a = this.props, l = a.withTitle, u = a.element, s = c(a, [
                                "withTitle",
                                "element"
                            ]), m = this.state.content, f = (e = s, n = t.propTypes, r = Object.keys(n), i = Object.assign({}, e), Object.keys(i).filter(function(e) {
                                return -1 !== r.indexOf(e);
                            }).forEach(function(e) {
                                return delete i[e];
                            }), i);
                            return l && (f.title = this.getTitle()), o.a.createElement(u || t.globalElement, function(e) {
                                for(var t = 1; t < arguments.length; t++){
                                    var n = null != arguments[t] ? arguments[t] : {}, r = Object.keys(n);
                                    "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(e) {
                                        return Object.getOwnPropertyDescriptor(n, e).enumerable;
                                    }))), r.forEach(function(t) {
                                        h(e, t, n[t]);
                                    });
                                }
                                return e;
                            }({
                                dateTime: t.getDatetime(this.props)
                            }, f), m);
                        }
                    }
                ], [
                    {
                        key: "getDerivedStateFromProps",
                        value: function(e) {
                            return {
                                content: t.getContent(e)
                            };
                        }
                    }
                ]), t;
            }();
            h(S, "propTypes", {
                element: a.a.any,
                date: a.a.oneOfType(d),
                parse: a.a.oneOfType(v),
                format: a.a.string,
                add: a.a.object,
                subtract: a.a.object,
                ago: a.a.bool,
                fromNow: a.a.bool,
                fromNowDuring: a.a.number,
                from: a.a.oneOfType(d),
                toNow: a.a.bool,
                to: a.a.oneOfType(d),
                calendar: a.a.oneOfType(b),
                unix: a.a.bool,
                utc: a.a.bool,
                local: a.a.bool,
                tz: a.a.string,
                withTitle: a.a.bool,
                titleFormat: a.a.string,
                locale: a.a.string,
                interval: a.a.number,
                diff: a.a.oneOfType(d),
                duration: a.a.oneOfType(d),
                durationFromNow: a.a.bool,
                unit: a.a.string,
                decimal: a.a.bool,
                filter: a.a.func,
                onChange: a.a.func
            }), h(S, "defaultProps", {
                element: null,
                fromNow: !1,
                toNow: !1,
                calendar: !1,
                ago: !1,
                unix: !1,
                utc: !1,
                local: !1,
                unit: null,
                withTitle: !1,
                decimal: !1,
                titleFormat: "",
                interval: 6e4,
                filter: function(e) {
                    return e;
                },
                onChange: function() {}
            }), h(S, "globalMoment", null), h(S, "globalLocale", null), h(S, "globalLocal", null), h(S, "globalFormat", null), h(S, "globalParse", null), h(S, "globalFilter", null), h(S, "globalElement", "time"), h(S, "globalTimezone", null), h(S, "pooledElements", []), h(S, "pooledTimer", null);
        }
    ]);
});




var $elnlQ = parcelRequire("elnlQ");

var $9tJ2C = parcelRequire("9tJ2C");

var $aWElp = parcelRequire("aWElp");

var $graxV = parcelRequire("graxV");

var $86nLB = parcelRequire("86nLB");
function $0c0ecca6f8d47f70$export$2e2bcd8739ae039(r) {
    return (0, $9tJ2C.default)(r) || (0, $aWElp.default)(r) || (0, $graxV.default)(r) || (0, $86nLB.default)();
}



var $8YHhK = parcelRequire("8YHhK");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");
parcelRequire("7XcX3");


var $78z8j = parcelRequire("78z8j");




var $5rVgt = parcelRequire("5rVgt");

var $Fo7oF = parcelRequire("Fo7oF");
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ var $869a2c92128e4808$var$AccordionContext = $Fo7oF.createContext({});
var $869a2c92128e4808$export$2e2bcd8739ae039 = $869a2c92128e4808$var$AccordionContext;



var $44bfc8db52a695cd$export$9dd6ff9ea0189349 = function styles(theme) {
    var transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            transition: theme.transitions.create([
                'margin'
            ], transition),
            '&:before': {
                position: 'absolute',
                left: 0,
                top: -1,
                right: 0,
                height: 1,
                content: '""',
                opacity: 1,
                backgroundColor: theme.palette.divider,
                transition: theme.transitions.create([
                    'opacity',
                    'background-color'
                ], transition)
            },
            '&:first-child': {
                '&:before': {
                    display: 'none'
                }
            },
            '&$expanded': {
                margin: '16px 0',
                '&:first-child': {
                    marginTop: 0
                },
                '&:last-child': {
                    marginBottom: 0
                },
                '&:before': {
                    opacity: 0
                }
            },
            '&$expanded + &': {
                '&:before': {
                    display: 'none'
                }
            },
            '&$disabled': {
                backgroundColor: theme.palette.action.disabledBackground
            }
        },
        /* Styles applied to the root element if `square={false}`. */ rounded: {
            borderRadius: 0,
            '&:first-child': {
                borderTopLeftRadius: theme.shape.borderRadius,
                borderTopRightRadius: theme.shape.borderRadius
            },
            '&:last-child': {
                borderBottomLeftRadius: theme.shape.borderRadius,
                borderBottomRightRadius: theme.shape.borderRadius,
                // Fix a rendering issue on Edge
                '@supports (-ms-ime-align: auto)': {
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0
                }
            }
        },
        /* Styles applied to the root element if `expanded={true}`. */ expanded: {},
        /* Styles applied to the root element if `disabled={true}`. */ disabled: {}
    };
};
var $44bfc8db52a695cd$var$Accordion = /*#__PURE__*/ $Fo7oF.forwardRef(function Accordion(props, ref) {
    var childrenProp = props.children, classes = props.classes, className = props.className, _props$defaultExpande = props.defaultExpanded, defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, expandedProp = props.expanded, onChange = props.onChange, _props$square = props.square, square = _props$square === void 0 ? false : _props$square, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $3d1b9735f1beaaf9$export$2e2bcd8739ae039) : _props$TransitionComp, TransitionProps = props.TransitionProps, other = (0, $67mp8.default)(props, [
        "children",
        "classes",
        "className",
        "defaultExpanded",
        "disabled",
        "expanded",
        "onChange",
        "square",
        "TransitionComponent",
        "TransitionProps"
    ]);
    var _useControlled = (0, $c6d3b036d5d216ae$export$2e2bcd8739ae039)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    }), _useControlled2 = (0, $8YHhK.default)(_useControlled, 2), expanded = _useControlled2[0], setExpandedState = _useControlled2[1];
    var handleChange = $Fo7oF.useCallback(function(event) {
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    var _React$Children$toArr = $Fo7oF.Children.toArray(childrenProp), _React$Children$toArr2 = (0, $0c0ecca6f8d47f70$export$2e2bcd8739ae039)(_React$Children$toArr), summary = _React$Children$toArr2[0], children = _React$Children$toArr2.slice(1);
    var contextValue = $Fo7oF.useMemo(function() {
        return {
            expanded: expanded,
            disabled: disabled,
            toggle: handleChange
        };
    }, [
        expanded,
        disabled,
        handleChange
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement((0, $fe0aa9e32766c0f5$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
        ref: ref,
        square: square
    }, other), /*#__PURE__*/ $Fo7oF.createElement((0, $869a2c92128e4808$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, summary), /*#__PURE__*/ $Fo7oF.createElement(TransitionComponent, (0, $elnlQ.default)({
        in: expanded,
        timeout: "auto"
    }, TransitionProps), /*#__PURE__*/ $Fo7oF.createElement("div", {
        "aria-labelledby": summary.props.id,
        id: summary.props['aria-controls'],
        role: "region"
    }, children)));
});
var $44bfc8db52a695cd$export$2e2bcd8739ae039 = (0, $5rVgt.default)($44bfc8db52a695cd$export$9dd6ff9ea0189349, {
    name: 'MuiAccordion'
})($44bfc8db52a695cd$var$Accordion);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");
var $ad263a9515ab84b9$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'flex',
            padding: theme.spacing(1, 2, 2)
        }
    };
};
var $ad263a9515ab84b9$var$AccordionDetails = /*#__PURE__*/ $Fo7oF.forwardRef(function AccordionDetails(props, ref) {
    var classes = props.classes, className = props.className, other = (0, $67mp8.default)(props, [
        "classes",
        "className"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement("div", (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className),
        ref: ref
    }, other));
});
var $ad263a9515ab84b9$export$2e2bcd8739ae039 = (0, $5rVgt.default)($ad263a9515ab84b9$export$9dd6ff9ea0189349, {
    name: 'MuiAccordionDetails'
})($ad263a9515ab84b9$var$AccordionDetails);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");




var $5rVgt = parcelRequire("5rVgt");

var $99b66347e4b05854$export$9dd6ff9ea0189349 = function styles(theme) {
    var transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        /* Styles applied to the root element. */ root: {
            display: 'flex',
            minHeight: 48,
            transition: theme.transitions.create([
                'min-height',
                'background-color'
            ], transition),
            padding: theme.spacing(0, 2),
            '&:hover:not($disabled)': {
                cursor: 'pointer'
            },
            '&$expanded': {
                minHeight: 64
            },
            '&$focused, &$focusVisible': {
                backgroundColor: theme.palette.action.focus
            },
            '&$disabled': {
                opacity: theme.palette.action.disabledOpacity
            }
        },
        /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */ expanded: {},
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focused: {},
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focusVisible: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the children wrapper element. */ content: {
            display: 'flex',
            flexGrow: 1,
            transition: theme.transitions.create([
                'margin'
            ], transition),
            margin: '12px 0',
            '&$expanded': {
                margin: '20px 0'
            }
        },
        /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */ expandIcon: {
            transform: 'rotate(0deg)',
            transition: theme.transitions.create('transform', transition),
            '&:hover': {
                // Disable the hover effect for the IconButton,
                // because a hover effect should apply to the entire Expand button and
                // not only to the IconButton.
                backgroundColor: 'transparent'
            },
            '&$expanded': {
                transform: 'rotate(180deg)'
            }
        }
    };
};
var $99b66347e4b05854$var$AccordionSummary = /*#__PURE__*/ $Fo7oF.forwardRef(function AccordionSummary(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, expandIcon = props.expandIcon, focusVisibleClassName = props.focusVisibleClassName, _props$IconButtonProp = props.IconButtonProps, IconButtonProps = _props$IconButtonProp === void 0 ? {} : _props$IconButtonProp, onClick = props.onClick, other = (0, $67mp8.default)(props, [
        "children",
        "classes",
        "className",
        "expandIcon",
        "focusVisibleClassName",
        "IconButtonProps",
        "onClick"
    ]);
    var _React$useContext = $Fo7oF.useContext((0, $869a2c92128e4808$export$2e2bcd8739ae039)), _React$useContext$dis = _React$useContext.disabled, disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis, expanded = _React$useContext.expanded, toggle = _React$useContext.toggle;
    var handleChange = function handleChange(event) {
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    return /*#__PURE__*/ $Fo7oF.createElement((0, $67b46b5fd967aa2b$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, $78z8j.default)(classes.root, className, disabled && classes.disabled, expanded && classes.expanded),
        focusVisibleClassName: (0, $78z8j.default)(classes.focusVisible, classes.focused, focusVisibleClassName),
        onClick: handleChange,
        ref: ref
    }, other), /*#__PURE__*/ $Fo7oF.createElement("div", {
        className: (0, $78z8j.default)(classes.content, expanded && classes.expanded)
    }, children), expandIcon && /*#__PURE__*/ $Fo7oF.createElement((0, $c6e28b9de0df1599$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.expandIcon, expanded && classes.expanded),
        edge: "end",
        component: "div",
        tabIndex: null,
        role: null,
        "aria-hidden": true
    }, IconButtonProps), expandIcon));
});
var $99b66347e4b05854$export$2e2bcd8739ae039 = (0, $5rVgt.default)($99b66347e4b05854$export$9dd6ff9ea0189349, {
    name: 'MuiAccordionSummary'
})($99b66347e4b05854$var$AccordionSummary);




var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");

var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $bT5dp = parcelRequire("bT5dp");

var $5rVgt = parcelRequire("5rVgt");




var $76fa97096423dde0$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {},
    /* Styles applied to the root element if `underline="none"`. */ underlineNone: {
        textDecoration: 'none'
    },
    /* Styles applied to the root element if `underline="hover"`. */ underlineHover: {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    },
    /* Styles applied to the root element if `underline="always"`. */ underlineAlways: {
        textDecoration: 'underline'
    },
    // Same reset as ButtonBase.root
    /* Styles applied to the root element if `component="button"`. */ button: {
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        '-moz-appearance': 'none',
        // Reset
        '-webkit-appearance': 'none',
        // Reset
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        '&$focusVisible': {
            outline: 'auto'
        }
    },
    /* Pseudo-class applied to the root element if the link is keyboard focused. */ focusVisible: {}
};
var $76fa97096423dde0$var$Link = /*#__PURE__*/ $Fo7oF.forwardRef(function Link(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, _props$component = props.component, component = _props$component === void 0 ? 'a' : _props$component, onBlur = props.onBlur, onFocus = props.onFocus, TypographyClasses = props.TypographyClasses, _props$underline = props.underline, underline = _props$underline === void 0 ? 'hover' : _props$underline, _props$variant = props.variant, variant = _props$variant === void 0 ? 'inherit' : _props$variant, other = (0, $67mp8.default)(props, [
        "classes",
        "className",
        "color",
        "component",
        "onBlur",
        "onFocus",
        "TypographyClasses",
        "underline",
        "variant"
    ]);
    var _useIsFocusVisible = (0, $ef37cdf34d04c3a7$export$2e2bcd8739ae039)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    var _React$useState = $Fo7oF.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    var handlerRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(ref, focusVisibleRef);
    var handleBlur = function handleBlur(event) {
        if (focusVisible) {
            onBlurVisible();
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    };
    var handleFocus = function handleFocus(event) {
        if (isFocusVisible(event)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ $Fo7oF.createElement((0, $b6511d47df71b02c$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, classes["underline".concat((0, $bT5dp.default)(underline))], className, focusVisible && classes.focusVisible, component === 'button' && classes.button),
        classes: TypographyClasses,
        color: color,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        variant: variant
    }, other));
});
var $76fa97096423dde0$export$2e2bcd8739ae039 = (0, $5rVgt.default)($76fa97096423dde0$export$9dd6ff9ea0189349, {
    name: 'MuiLink'
})($76fa97096423dde0$var$Link);


var $876ffa0f7de9a307$exports = {};
"use strict";


Object.defineProperty($876ffa0f7de9a307$exports, "__esModule", {
    value: true
});
$876ffa0f7de9a307$exports.default = void 0;

var $876ffa0f7de9a307$var$React = $e542637ee86bba6a$exports((parcelRequire("Fo7oF")));

var $876ffa0f7de9a307$var$_createSvgIcon = $368639c97fe780bf$exports((parcelRequire("bI8Gq")));
var $876ffa0f7de9a307$var$_default = (0, $876ffa0f7de9a307$var$_createSvgIcon.default)(/*#__PURE__*/ $876ffa0f7de9a307$var$React.createElement("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
}), 'OpenInNew');
$876ffa0f7de9a307$exports.default = $876ffa0f7de9a307$var$_default;



const $d4ac1c58486e2133$var$styles = {
    icons: {
        fontSize: 22,
        marginLeft: 4
    },
    links: {
        display: 'inline-flex',
        alignItems: 'center'
    }
};
class $d4ac1c58486e2133$export$6694b0c0bee011e4 extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    stopPropagation(e) {
        e.stopPropagation();
    }
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $76fa97096423dde0$export$2e2bcd8739ae039), {
            href: `${(0, $c8fcd73ceb71c905$export$e506a1d27d1eaa20).pos}/pos/bundle/${this.props.bundleNumber}`,
            onClick: this.stopPropagation,
            rel: "noopener",
            style: $d4ac1c58486e2133$var$styles.links,
            target: "_blank",
            children: [
                this.props.bundleNumber,
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($876ffa0f7de9a307$exports))), {
                    style: $d4ac1c58486e2133$var$styles.icons
                })
            ]
        });
    }
}



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");



var $d2bgE = parcelRequire("d2bgE");

var $a501f31abf81bf7e$exports = {};

$parcel$export($a501f31abf81bf7e$exports, "root", () => $a501f31abf81bf7e$export$e8e78c978b129247, (v) => $a501f31abf81bf7e$export$e8e78c978b129247 = v);
$parcel$export($a501f31abf81bf7e$exports, "icon", () => $a501f31abf81bf7e$export$1ca1ec8b29a4ce27, (v) => $a501f31abf81bf7e$export$1ca1ec8b29a4ce27 = v);
var $a501f31abf81bf7e$export$e8e78c978b129247;
var $a501f31abf81bf7e$export$1ca1ec8b29a4ce27;
$a501f31abf81bf7e$export$e8e78c978b129247 = "root_9d2972";
$a501f31abf81bf7e$export$1ca1ec8b29a4ce27 = "icon_9d2972";


class $a2f92cf4a018f00e$export$3e77db7758871207 extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $76fa97096423dde0$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($a501f31abf81bf7e$exports))).root,
            href: `${(0, $c8fcd73ceb71c905$export$e506a1d27d1eaa20).core}/alfa/c/enquiry-schedule(${this.props.quoteNumber},1)`,
            rel: "noopener",
            target: "_blank",
            children: [
                this.props.quoteNumber,
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($876ffa0f7de9a307$exports))), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($a501f31abf81bf7e$exports))).icon
                })
            ]
        });
    }
}
$a2f92cf4a018f00e$export$3e77db7758871207.propTypes = {
    quoteNumber: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired
};




var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");





var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");

var $2dfad9ad2947fbe9$exports = {};

$parcel$export($2dfad9ad2947fbe9$exports, "root", () => $2dfad9ad2947fbe9$export$e8e78c978b129247, (v) => $2dfad9ad2947fbe9$export$e8e78c978b129247 = v);
var $2dfad9ad2947fbe9$export$e8e78c978b129247;
$2dfad9ad2947fbe9$export$e8e78c978b129247 = "root_4113ee";


class $699fad24ff92f60c$export$75d8f5b437e63034 extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $fe0aa9e32766c0f5$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2dfad9ad2947fbe9$exports))).root,
            children: this.props.children
        });
    }
}



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");


var $8f89cd94069c3bc4$exports = {};

$parcel$export($8f89cd94069c3bc4$exports, "header", () => $8f89cd94069c3bc4$export$38e42c68cf43b5d4, (v) => $8f89cd94069c3bc4$export$38e42c68cf43b5d4 = v);
$parcel$export($8f89cd94069c3bc4$exports, "content", () => $8f89cd94069c3bc4$export$a7db06668cad9adb, (v) => $8f89cd94069c3bc4$export$a7db06668cad9adb = v);
var $8f89cd94069c3bc4$export$38e42c68cf43b5d4;
var $8f89cd94069c3bc4$export$a7db06668cad9adb;
$8f89cd94069c3bc4$export$38e42c68cf43b5d4 = "header_8e14db";
$8f89cd94069c3bc4$export$a7db06668cad9adb = "content_8e14db";


class $79941fd48a3dfca6$export$c4868e4a24d48fad extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
            container: true,
            justify: "space-between",
            spacing: 2,
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                    item: true,
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8f89cd94069c3bc4$exports))).header,
                        children: this.props.label
                    })
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                    item: true,
                    xs: true,
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($8f89cd94069c3bc4$exports))).content,
                        component: "div",
                        title: this.props.contentTitle,
                        children: this.props.children
                    })
                })
            ]
        });
    }
}



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");

var $99d3be61565f7c98$exports = {};
$99d3be61565f7c98$exports = JSON.parse("{\"2\":\"Successfully saved Third Parties.\",\"3\":\"Waiting to be loaded.\",\"4\":\"Error while saving Third Parties.\",\"5\":\"Successfully saved into staging database.\",\"6\":\"Error while saving into staging database.\",\"7\":\"Successfully saved into ICS.\",\"8\":\"Error while processing into ICS.\",\"9\":\"Successfully processed into ICS and Alfa.\",\"10\":\"Error while saving to Alfa.\",\"11\":\"Resubmitting Proposal\",\"100\":\"Error while saving to ICS.\",\"101\":\"Error while processing in Loaders.\",\"102\":\"Unsupported Country\"}");


var $16c8d9945c564f9b$exports = {};
$16c8d9945c564f9b$exports = JSON.parse("{\"1\":\"Successfully saved Third Party.\",\"3\":\"Waiting to be loaded.\",\"4\":\"Error while saving Third Party.\",\"5\":\"Successfully saved into staging database.\",\"6\":\"Error while saving into staging database.\",\"7\":\"Successfully saved into ICS.\",\"8\":\"Error while processing into ICS.\",\"9\":\"Successfully processed into ICS and Alfa.\",\"10\":\"Error while saving to Alfa.\",\"11\":\"Resubmitting Third Party\",\"100\":\"Error while saving to ICS.\",\"101\":\"Error while processing in Loaders.\",\"102\":\"Unsupported Country\"}");


let $b0afd96bc54a6957$var$friendlyProposalStatusesMap = null;
let $b0afd96bc54a6957$var$friendlyThirdPartyStatusesMap = null;
let $b0afd96bc54a6957$var$friendlyProposalStatusesList = null;
let $b0afd96bc54a6957$var$friendlyThirdPartyStatusesList = null;
class $b0afd96bc54a6957$export$3e14b51c9a9c5a1a {
    static get statuses() {
        return (0, $c04283212adf4fb0$export$60ad299e2e6f36fe)('/api/statuses', {
            cacheDuration: 'forever'
        });
    }
    static get proposalStatuses() {
        return (0, $c04283212adf4fb0$export$60ad299e2e6f36fe)('/api/quotes/statuses', {
            cacheDuration: 'forever'
        });
    }
    static get thirdPartyStatuses() {
        return (0, $c04283212adf4fb0$export$60ad299e2e6f36fe)('/api/third-parties/statuses', {
            cacheDuration: 'forever'
        });
    }
    static getFriendlyProposalMessage(statusID) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($99d3be61565f7c98$exports)))[statusID];
    }
    static getFriendlyThirdPartyMessage(statusID) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($16c8d9945c564f9b$exports)))[statusID];
    }
    static get friendlyProposalStatusesMap() {
        if (!$b0afd96bc54a6957$var$friendlyProposalStatusesMap) $b0afd96bc54a6957$var$friendlyProposalStatusesMap = (async ()=>{
            const statuses = await this.proposalStatuses;
            return Object.values(statuses).reduce((output, code)=>{
                output[code] = this.getFriendlyProposalMessage(code);
                return output;
            }, {});
        })();
        return $b0afd96bc54a6957$var$friendlyProposalStatusesMap;
    }
    static get friendlyProposalStatusesList() {
        if (!$b0afd96bc54a6957$var$friendlyProposalStatusesList) $b0afd96bc54a6957$var$friendlyProposalStatusesList = (async ()=>{
            const statuses = await this.proposalStatuses;
            return Object.values(statuses).map((code)=>({
                    label: this.getFriendlyProposalMessage(code),
                    value: code
                })).filter(({ label: label })=>!!label);
        })();
        return $b0afd96bc54a6957$var$friendlyProposalStatusesList;
    }
    static get friendlyThirdPartyStatusesMap() {
        if (!$b0afd96bc54a6957$var$friendlyThirdPartyStatusesMap) $b0afd96bc54a6957$var$friendlyThirdPartyStatusesMap = (async ()=>{
            const statuses = await this.thirdPartyStatuses;
            return Object.values(statuses).reduce((output, code)=>{
                output[code] = this.getFriendlyThirdPartyMessage(code);
                return output;
            }, {});
        })();
        return $b0afd96bc54a6957$var$friendlyThirdPartyStatusesMap;
    }
    static get friendlyThirdPartyStatusesList() {
        if (!$b0afd96bc54a6957$var$friendlyThirdPartyStatusesList) $b0afd96bc54a6957$var$friendlyThirdPartyStatusesList = (async ()=>{
            const statuses = await this.thirdPartyStatuses;
            return Object.values(statuses).map((code)=>({
                    label: this.getFriendlyThirdPartyMessage(code),
                    value: code
                })).filter(({ label: label })=>!!label);
        })();
        return $b0afd96bc54a6957$var$friendlyThirdPartyStatusesList;
    }
    static color(code) {
        if (this.isSuccess(code)) return '#367C2B';
        else if (this.isInProgress(code)) return '#FFC107';
        return '#f44336';
    }
    static status(code) {
        if (this.isSuccess(code)) return 'success';
        else if (this.isInProgress(code)) return 'in-progress';
        return 'error';
    }
    static isSuccess(code) {
        return [
            1,
            2,
            5,
            7,
            9
        ].includes(code);
    }
    static isInProgress(code) {
        return [
            3,
            11
        ].includes(code);
    }
    static isError(code) {
        return !this.isSuccess(code) && !this.isInProgress(code);
    }
}


class $6523f76669541a7d$export$96e9906d6d93a972 extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    constructor(props){
        super(props);
        this.state = {
            statuses: {},
            color: (0, $b0afd96bc54a6957$export$3e14b51c9a9c5a1a).color(this.props.statusID)
        };
        if (this.props.errorMessage) this.state.message = this.props.errorMessage.message;
        if (!this.state.message) this.state.message = this.props.thirdParty ? (0, $b0afd96bc54a6957$export$3e14b51c9a9c5a1a).getFriendlyThirdPartyMessage(this.props.statusID) : (0, $b0afd96bc54a6957$export$3e14b51c9a9c5a1a).getFriendlyProposalMessage(this.props.statusID);
    }
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
            style: Object.assign({
                color: this.state.color
            }, this.props.style),
            title: `${this.state.message} (${this.props.statusID})`,
            children: [
                this.state.message,
                this.props.includeID && /*#__PURE__*/ (0, $eFTP6.jsxs)("span", {
                    children: [
                        "\xa0(",
                        this.props.statusID,
                        ")"
                    ]
                })
            ]
        });
    }
}



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");




var $d2bgE = parcelRequire("d2bgE");
const $a4b83e83cad71f12$var$styles = {
    icons: {
        fontSize: 22,
        marginLeft: 4
    },
    links: {
        display: 'inline-flex',
        alignItems: 'center'
    }
};
class $a4b83e83cad71f12$export$b0189f0e8ca67e77 extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $76fa97096423dde0$export$2e2bcd8739ae039), {
            href: `${(0, $c8fcd73ceb71c905$export$e506a1d27d1eaa20).core}/alfa/c/maintain-thirdparty(${this.props.thirdPartyNumber},1)`,
            rel: "noopener",
            style: $a4b83e83cad71f12$var$styles.links,
            target: "_blank",
            children: [
                this.props.thirdPartyNumber,
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($876ffa0f7de9a307$exports))), {
                    style: $a4b83e83cad71f12$var$styles.icons
                })
            ]
        });
    }
}
$a4b83e83cad71f12$export$b0189f0e8ca67e77.propTypes = {
    thirdPartyNumber: $d2bgE.number
};



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");





var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");

var $ef0fdebb5745dee4$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        margin: 0,
        padding: '16px 24px',
        flex: '0 0 auto'
    }
};
var $ef0fdebb5745dee4$var$DialogTitle = /*#__PURE__*/ $Fo7oF.forwardRef(function DialogTitle(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, other = (0, $67mp8.default)(props, [
        "children",
        "classes",
        "className",
        "disableTypography"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement("div", (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className),
        ref: ref
    }, other), disableTypography ? children : /*#__PURE__*/ $Fo7oF.createElement((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
        component: "h2",
        variant: "h6"
    }, children));
});
var $ef0fdebb5745dee4$export$2e2bcd8739ae039 = (0, $5rVgt.default)($ef0fdebb5745dee4$export$9dd6ff9ea0189349, {
    name: 'MuiDialogTitle'
})($ef0fdebb5745dee4$var$DialogTitle);




var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");

var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");




var $15c71dab1c0b9eb5$exports = {};

$parcel$export($15c71dab1c0b9eb5$exports, "root", () => $15c71dab1c0b9eb5$export$e8e78c978b129247, (v) => $15c71dab1c0b9eb5$export$e8e78c978b129247 = v);
$parcel$export($15c71dab1c0b9eb5$exports, "date", () => $15c71dab1c0b9eb5$export$324d90190a8b822a, (v) => $15c71dab1c0b9eb5$export$324d90190a8b822a = v);
$parcel$export($15c71dab1c0b9eb5$exports, "dot", () => $15c71dab1c0b9eb5$export$94132a0e348806d4, (v) => $15c71dab1c0b9eb5$export$94132a0e348806d4 = v);
var $15c71dab1c0b9eb5$export$e8e78c978b129247;
var $15c71dab1c0b9eb5$export$324d90190a8b822a;
var $15c71dab1c0b9eb5$export$94132a0e348806d4;
$15c71dab1c0b9eb5$export$e8e78c978b129247 = "root_13bb12";
$15c71dab1c0b9eb5$export$324d90190a8b822a = "date_13bb12";
$15c71dab1c0b9eb5$export$94132a0e348806d4 = "dot_13bb12";


class $d2c96790df864efa$export$d3701c9b7ee3817b extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($15c71dab1c0b9eb5$exports))).root,
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $9cdb8eaf07a9f9ce$export$d046b3c4a416f60d), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($15c71dab1c0b9eb5$exports))).dot,
                    color: (0, $b0afd96bc54a6957$export$3e14b51c9a9c5a1a).color(this.props.statusID)
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $6523f76669541a7d$export$96e9906d6d93a972), {
                    includeID: true,
                    statusID: this.props.statusID,
                    thirdParty: this.props.thirdParty
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($27bb6d1dc23c636d$exports))), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($15c71dab1c0b9eb5$exports))).date,
                    format: "YYYY/MM/DD HH:mm:ss",
                    children: this.props.date
                })
            ]
        });
    }
}


class $f884199f52172076$export$4a6e5c851326e8b4 extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
            children: this.props.history && this.props.history.map((item)=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $d2c96790df864efa$export$d3701c9b7ee3817b), {
                    date: item.createdDate,
                    statusID: item.statusID,
                    thirdParty: this.props.thirdParty
                }, item.id))
        });
    }
}


class $5467c35872494bca$export$50fdf32d919bb0f3 extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    constructor(props){
        super(props);
        this.state = {
            opened: false,
            history: []
        };
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
    }
    async componentDidUpdate(prevProps, prevState) {
        if (this.state.opened !== prevState.opened && this.state.opened) {
            this.setState({
                loading: true
            });
            try {
                if (this.props.quote) this.setState({
                    history: await (0, $c04283212adf4fb0$export$c4b7edec3f76b207)(`/api/quotes/${this.props.quote.id}/history`),
                    historyElementNumber: this.props.quote.quoteNumber
                });
                else if (this.props.thirdParty) this.setState({
                    history: await (0, $c04283212adf4fb0$export$c4b7edec3f76b207)(`/api/third-parties/${this.props.thirdParty.id}/history`),
                    historyElementNumber: this.props.thirdParty.number
                });
                else this.setState({
                    history: []
                });
            } finally{
                this.setState({
                    loading: false
                });
            }
        }
    }
    open() {
        this.setState({
            opened: true
        });
    }
    close() {
        this.setState({
            opened: false
        });
    }
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                    color: "primary",
                    onClick: this.open,
                    variant: "outlined",
                    children: "History"
                }),
                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $06c828c7d8d76aa9$export$2e2bcd8739ae039), {
                    "aria-labelledby": "history-dialog-title",
                    onClose: this.close,
                    open: this.state.opened,
                    scroll: "paper",
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $ef0fdebb5745dee4$export$2e2bcd8739ae039), {
                            id: "history-dialog-title",
                            children: [
                                "Status History ",
                                this.state.historyElementNumber
                            ]
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1c55bad717a43115$export$2e2bcd8739ae039), {
                            dividers: true,
                            children: !this.state.loading && /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                                children: this.state.history && this.state.history.length > 0 ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f884199f52172076$export$4a6e5c851326e8b4), {
                                    history: this.state.history,
                                    thirdParty: !!this.props.thirdParty
                                }) : /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                                    children: "No History Available"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1b29532bd4542510$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                                color: "primary",
                                onClick: this.close,
                                children: "Close"
                            })
                        })
                    ]
                })
            ]
        });
    }
}



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");






var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $bvYwR = parcelRequire("bvYwR");


var $dOG8L = parcelRequire("dOG8L");




var $6N3by = parcelRequire("6N3by");

// Later, we gonna translate back the node to his original location
// with `none`.`
function $466d6eb6a69ea8ba$var$getTranslateValue(direction, node) {
    var rect = node.getBoundingClientRect();
    var transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        var computedStyle = window.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    var offsetX = 0;
    var offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        var transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') return "translateX(".concat(window.innerWidth, "px) translateX(").concat(offsetX - rect.left, "px)");
    if (direction === 'right') return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
    if (direction === 'up') return "translateY(".concat(window.innerHeight, "px) translateY(").concat(offsetY - rect.top, "px)");
     // direction === 'down'
    return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
}
function $466d6eb6a69ea8ba$export$f820ccdc5b48abdf(direction, node) {
    var transform = $466d6eb6a69ea8ba$var$getTranslateValue(direction, node);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
var $466d6eb6a69ea8ba$var$defaultTimeout = {
    enter: (0, $6N3by.duration).enteringScreen,
    exit: (0, $6N3by.duration).leavingScreen
};
/**
 * The Slide transition is used by the [Drawer](/components/drawers/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ var $466d6eb6a69ea8ba$var$Slide = /*#__PURE__*/ $Fo7oF.forwardRef(function Slide(props, ref) {
    var children = props.children, _props$direction = props.direction, direction = _props$direction === void 0 ? 'down' : _props$direction, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? $466d6eb6a69ea8ba$var$defaultTimeout : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? (0, $dOG8L.default) : _props$TransitionComp, other = (0, $67mp8.default)(props, [
        "children",
        "direction",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent"
    ]);
    var theme = (0, $c6db41e315144c8b$export$2e2bcd8739ae039)();
    var childrenRef = $Fo7oF.useRef(null);
    /**
   * used in cloneElement(children, { ref: handleRef })
   */ var handleOwnRef = $Fo7oF.useCallback(function(instance) {
        // #StrictMode ready
        childrenRef.current = $bvYwR.findDOMNode(instance);
    }, []);
    var handleRefIntermediary = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(children.ref, handleOwnRef);
    var handleRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(handleRefIntermediary, ref);
    var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
        return function(isAppearing) {
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    };
    var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
        $466d6eb6a69ea8ba$export$f820ccdc5b48abdf(direction, node);
        (0, $f7011715ddf0f929$export$b7a864e1eaef9de5)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    var handleEntering = normalizedTransitionCallback(function(node, isAppearing) {
        var transitionProps = (0, $f7011715ddf0f929$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, $elnlQ.default)({}, transitionProps, {
            easing: theme.transitions.easing.easeOut
        }));
        node.style.transition = theme.transitions.create('transform', (0, $elnlQ.default)({}, transitionProps, {
            easing: theme.transitions.easing.easeOut
        }));
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function(node) {
        var transitionProps = (0, $f7011715ddf0f929$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, $elnlQ.default)({}, transitionProps, {
            easing: theme.transitions.easing.sharp
        }));
        node.style.transition = theme.transitions.create('transform', (0, $elnlQ.default)({}, transitionProps, {
            easing: theme.transitions.easing.sharp
        }));
        $466d6eb6a69ea8ba$export$f820ccdc5b48abdf(direction, node);
        if (onExit) onExit(node);
    });
    var handleExited = normalizedTransitionCallback(function(node) {
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    var updatePosition = $Fo7oF.useCallback(function() {
        if (childrenRef.current) $466d6eb6a69ea8ba$export$f820ccdc5b48abdf(direction, childrenRef.current);
    }, [
        direction
    ]);
    $Fo7oF.useEffect(function() {
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        var handleResize = (0, $6f88adb62ae78218$export$2e2bcd8739ae039)(function() {
            if (childrenRef.current) $466d6eb6a69ea8ba$export$f820ccdc5b48abdf(direction, childrenRef.current);
        });
        window.addEventListener('resize', handleResize);
        return function() {
            handleResize.clear();
            window.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp
    ]);
    $Fo7oF.useEffect(function() {
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement(TransitionComponent, (0, $elnlQ.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        appear: true,
        in: inProp,
        timeout: timeout
    }, other), function(state, childProps) {
        return /*#__PURE__*/ $Fo7oF.cloneElement(children, (0, $elnlQ.default)({
            ref: handleRef,
            style: (0, $elnlQ.default)({
                visibility: state === 'exited' && !inProp ? 'hidden' : undefined
            }, style, children.props.style)
        }, childProps));
    });
});
var $466d6eb6a69ea8ba$export$2e2bcd8739ae039 = $466d6eb6a69ea8ba$var$Slide;










var $af5800e0c7c5d3ba$exports = {};

$parcel$export($af5800e0c7c5d3ba$exports, "dtable", () => $af5800e0c7c5d3ba$export$141650fc308d40e6, (v) => $af5800e0c7c5d3ba$export$141650fc308d40e6 = v);
var $af5800e0c7c5d3ba$export$141650fc308d40e6;
$af5800e0c7c5d3ba$export$141650fc308d40e6 = "dtable_6fbc62";



var $5rVgt = parcelRequire("5rVgt");
function $ab7a3db972dce148$var$_defineProperty(e, r, t) {
    return (r = $ab7a3db972dce148$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ab7a3db972dce148$var$_toPropertyKey(t) {
    var i = $ab7a3db972dce148$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ab7a3db972dce148$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $ab7a3db972dce148$var$StyledTableCell = (0, $5rVgt.default)((theme)=>({
        head: {
            backgroundColor: '#367C2B',
            color: theme.palette.common.white
        },
        body: {
            fontSize: 14
        }
    }))((0, $924d8ef775c5c9f0$export$2e2bcd8739ae039));
const $ab7a3db972dce148$var$StyledTableRow = (0, $5rVgt.default)((theme)=>({
        root: {
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.action.hover
            }
        }
    }))((0, $e6915f08e195d274$export$2e2bcd8739ae039));
const $ab7a3db972dce148$var$styles = {
    body: {
        display: 'flex',
        flexDirection: 'row',
        margin: 2
    },
    button: {
        zIndex: 1000,
        height: 100,
        width: 100,
        margin: 6.5,
        borderRadius: 0
    },
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        flexWrap: 'wrap',
        margin: '5px 50px',
        backgroundColor: 'white',
        padding: 6.5
    },
    modal: {
        position: 'absolute',
        width: 400,
        backgroundColor: 'white',
        boxShadow: 'none',
        padding: 10,
        outline: 'none',
        top: '15%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }
};
const $ab7a3db972dce148$var$Transition = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $466d6eb6a69ea8ba$export$2e2bcd8739ae039), {
        direction: "up",
        ref: ref,
        ...props
    });
});
$ab7a3db972dce148$var$Transition.displayName = 'Transition';
class $ab7a3db972dce148$export$98fb66d3f4063010 extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    constructor(props){
        super(props);
        $ab7a3db972dce148$var$_defineProperty(this, "handleOpen", ()=>async ()=>{
                this.setState({
                    open: true,
                    message: [
                        {
                            updatedDate: '-',
                            message: 'Loading....',
                            messageType: '-'
                        }
                    ]
                });
                const alfaMessages = await this.getAlfaMessages();
                this.setState({
                    open: true,
                    message: alfaMessages
                });
            });
        $ab7a3db972dce148$var$_defineProperty(this, "handleClose", ()=>{
            this.setState({
                open: false
            });
        });
        this.state = {
            open: false,
            message: [],
            bundleID: ''
        };
    }
    async getAlfaMessages() {
        const alfaMessages = await (0, $c04283212adf4fb0$export$60ad299e2e6f36fe)('/api/alfamessages', {
            query: {
                bundleNumber: this.props.bundleNumber
            }
        });
        return alfaMessages;
    }
    render() {
        const { message: message } = this.state;
        return /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
            style: $ab7a3db972dce148$var$styles.wrapper,
            children: /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                style: $ab7a3db972dce148$var$styles.body,
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                        color: "primary",
                        onClick: this.handleOpen(),
                        variant: "outlined",
                        children: "View"
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $06c828c7d8d76aa9$export$2e2bcd8739ae039), {
                        TransitionComponent: $ab7a3db972dce148$var$Transition,
                        "aria-describedby": "alert-dialog-slide-description",
                        "aria-labelledby": "alert-dialog-slide-title",
                        keepMounted: true,
                        maxWidth: "md",
                        onClose: this.handleClose,
                        // fullWidth="300"
                        open: this.state.open,
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $ef0fdebb5745dee4$export$2e2bcd8739ae039), {
                                id: "alert-dialog-slide-title",
                                children: [
                                    'Message Details',
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("hr", {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1c55bad717a43115$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $38bdee8745793da0$export$2e2bcd8739ae039), {
                                    component: (0, $fe0aa9e32766c0f5$export$2e2bcd8739ae039),
                                    children: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $0c4ceb83c44a630e$export$2e2bcd8739ae039), {
                                        "aria-label": "simple table",
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($af5800e0c7c5d3ba$exports))).dtable,
                                        children: [
                                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $814252108fd031b4$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $e6915f08e195d274$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $eFTP6.jsx)($ab7a3db972dce148$var$StyledTableCell, {
                                                            children: "Date"
                                                        }),
                                                        /*#__PURE__*/ (0, $eFTP6.jsx)($ab7a3db972dce148$var$StyledTableCell, {
                                                            children: "Message"
                                                        }),
                                                        /*#__PURE__*/ (0, $eFTP6.jsx)($ab7a3db972dce148$var$StyledTableCell, {
                                                            children: "Message Type"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b5b6ab7f22f12380$export$2e2bcd8739ae039), {
                                                children: message.map((row)=>/*#__PURE__*/ (0, $eFTP6.jsxs)($ab7a3db972dce148$var$StyledTableRow, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $eFTP6.jsx)($ab7a3db972dce148$var$StyledTableCell, {
                                                                children: row.updatedDate && row.updatedDate.length > 9 ? row.updatedDate.substring(0, row.updatedDate.length - 9) : ''
                                                            }),
                                                            /*#__PURE__*/ (0, $eFTP6.jsx)($ab7a3db972dce148$var$StyledTableCell, {
                                                                children: row.message
                                                            }),
                                                            /*#__PURE__*/ (0, $eFTP6.jsx)($ab7a3db972dce148$var$StyledTableCell, {
                                                                children: row.messageType
                                                            })
                                                        ]
                                                    }, row.updatedDate))
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1b29532bd4542510$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                                    color: "primary",
                                    onClick: this.handleClose,
                                    children: "close"
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
}


class $85f60afe5971bccf$export$1c582b19b22f1207 extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    constructor(props){
        super(props);
        this.state = {
            role: null
        };
    }
    componentDidMount() {
        this.updateRole(this.props.quote, this.props.thirdParty);
    }
    componentDidUpdate(prevProps) {
        if (this.props.quote !== prevProps.quote || this.props.thirdParty !== prevProps.thirdParty) this.updateRole(this.props.quote, this.props.thirdParty);
    }
    updateRole(quote, thirdParty) {
        if (quote && thirdParty) {
            const proposalThirdParty = thirdParty.proposalThirdParties.find(({ proposalTrackingID: proposalTrackingID })=>proposalTrackingID === quote.id);
            this.setState({
                role: proposalThirdParty && proposalThirdParty.thirdPartyRole || proposalThirdParty
            });
        } else this.setState({
            role: null
        });
    }
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $699fad24ff92f60c$export$75d8f5b437e63034), {
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                    label: "Third Party",
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $a4b83e83cad71f12$export$b0189f0e8ca67e77), {
                        thirdPartyNumber: this.props.thirdParty.number
                    })
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                    label: "ICS ID",
                    children: this.props.thirdParty.icsID || 'N/A'
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                    contentTitle: `${this.props.thirdParty.country} (${this.props.thirdParty.countryCode})`,
                    label: "Country",
                    children: this.props.thirdParty.country
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                    label: "Message",
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $6523f76669541a7d$export$96e9906d6d93a972), {
                        errorMessage: this.props.thirdParty.errorMessage,
                        includeID: true,
                        statusID: this.props.thirdParty.statusID,
                        thirdParty: true
                    })
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                    label: "Message Details",
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $ab7a3db972dce148$export$98fb66d3f4063010), {
                        msg: this.props.thirdParty.alfaMessage ? this.props.thirdParty.messageDetails : '-'
                    })
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                    label: "Role",
                    children: this.state.role
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                    label: "Created Date",
                    children: this.props.quote.createdDate ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($27bb6d1dc23c636d$exports))), {
                        format: "MMMM Do, YYYY",
                        children: this.props.quote.createdDate
                    }) : 'N/A'
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                    label: "Updated Date",
                    children: this.props.quote.updatedDate ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($27bb6d1dc23c636d$exports))), {
                        format: "MMMM Do, YYYY",
                        children: this.props.quote.updatedDate
                    }) : 'N/A'
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                    container: true,
                    justify: "flex-end",
                    spacing: 3,
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $5467c35872494bca$export$50fdf32d919bb0f3), {
                            thirdParty: this.props.thirdParty
                        })
                    })
                })
            ]
        });
    }
}











var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");






var $9bb0b691044c8b01$exports = {};

$9bb0b691044c8b01$exports = (parcelRequire("74m7k"));




function $d18d09eb3d1dbd72$var$_defineProperty(e, r, t) {
    return (r = $d18d09eb3d1dbd72$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d18d09eb3d1dbd72$var$_toPropertyKey(t) {
    var i = $d18d09eb3d1dbd72$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d18d09eb3d1dbd72$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $d18d09eb3d1dbd72$export$90fe1f648de16e10 extends (0, $Fo7oF.Component) {
    constructor(props){
        super(props);
        $d18d09eb3d1dbd72$var$_defineProperty(this, "handleClose", ()=>{
            this.setState({
                open: false
            });
        });
        $d18d09eb3d1dbd72$var$_defineProperty(this, "handleCloseWithLoading", ()=>{
            this.setState({
                loading: true,
                open: false
            });
            setTimeout(()=>{
                this.setState({
                    loading: false,
                    open: false
                });
            }, 3000);
        });
        this.state = {
            open: false,
            loading: false
        };
        this.handleClickOpen = this.handleClickOpen.bind(this);
    }
    async handleClickOpen() {
        this.setState({
            open: true
        });
        try {
            const currentUser = await (0, $1982a4c5f4dd80b7$export$69d4516a6fd8e701).user;
            const quote = await (0, $c04283212adf4fb0$export$c4b7edec3f76b207)(`/api/quotes/${this.props.quote.id}/closecase`, {
                method: 'POST',
                query: {
                    userID: currentUser.id
                }
            });
            if (this.props.onclosecase) this.props.onclosecase(quote);
        } catch (err) {
            this.setState({
                open: false
            });
        } finally{
            this.setState({
                open: false
            });
        }
    }
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                    color: "primary",
                    onClick: this.handleClickOpen,
                    variant: "outlined",
                    children: "Close Case"
                }),
                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $06c828c7d8d76aa9$export$2e2bcd8739ae039), {
                    "aria-describedby": "alert-dialog-description",
                    "aria-labelledby": "alert-dialog-title",
                    onClose: this.handleClose,
                    open: this.state.open,
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $ef0fdebb5745dee4$export$2e2bcd8739ae039), {
                            id: "alert-dialog-title",
                            children: 'Saving data'
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1c55bad717a43115$export$2e2bcd8739ae039), {
                            align: "center",
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9bb0b691044c8b01$exports))), {
                                color: "#55a005",
                                height: 100,
                                timeout: 0,
                                type: "Puff",
                                width: 100
                            })
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1b29532bd4542510$export$2e2bcd8739ae039), {})
                    ]
                })
            ]
        });
    }
}



var $67mp8 = parcelRequire("67mp8");

var $elnlQ = parcelRequire("elnlQ");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $8Hh6N = parcelRequire("8Hh6N");
var $5rVgt = parcelRequire("5rVgt");


var $Fo7oF = parcelRequire("Fo7oF");

var $3yRq4 = parcelRequire("3yRq4");
var /**
 * @ignore - internal component.
 */ $ab51ed16e1ab142e$export$2e2bcd8739ae039 = (0, $3yRq4.default)(/*#__PURE__*/ $Fo7oF.createElement("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');



var $Fo7oF = parcelRequire("Fo7oF");

var $3yRq4 = parcelRequire("3yRq4");
var /**
 * @ignore - internal component.
 */ $a8df82b2862f6da4$export$2e2bcd8739ae039 = (0, $3yRq4.default)(/*#__PURE__*/ $Fo7oF.createElement("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');



var $Fo7oF = parcelRequire("Fo7oF");

var $3yRq4 = parcelRequire("3yRq4");
var /**
 * @ignore - internal component.
 */ $67317b271f7507e8$export$2e2bcd8739ae039 = (0, $3yRq4.default)(/*#__PURE__*/ $Fo7oF.createElement("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');



var $Fo7oF = parcelRequire("Fo7oF");

var $3yRq4 = parcelRequire("3yRq4");
var /**
 * @ignore - internal component.
 */ $3338f95bb31e8c93$export$2e2bcd8739ae039 = (0, $3yRq4.default)(/*#__PURE__*/ $Fo7oF.createElement("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');



var $Fo7oF = parcelRequire("Fo7oF");

var $3yRq4 = parcelRequire("3yRq4");
var /**
 * @ignore - internal component.
 */ $bdff2824de8910c9$export$2e2bcd8739ae039 = (0, $3yRq4.default)(/*#__PURE__*/ $Fo7oF.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');




var $bT5dp = parcelRequire("bT5dp");
var $c828443744cea9f4$export$9dd6ff9ea0189349 = function styles(theme) {
    var getColor = theme.palette.type === 'light' ? (0, $8Hh6N.darken) : (0, $8Hh6N.lighten);
    var getBackgroundColor = theme.palette.type === 'light' ? (0, $8Hh6N.lighten) : (0, $8Hh6N.darken);
    return {
        /* Styles applied to the root element. */ root: (0, $elnlQ.default)({}, theme.typography.body2, {
            borderRadius: theme.shape.borderRadius,
            backgroundColor: 'transparent',
            display: 'flex',
            padding: '6px 16px'
        }),
        /* Styles applied to the root element if `variant="standard"` and `color="success"`. */ standardSuccess: {
            color: getColor(theme.palette.success.main, 0.6),
            backgroundColor: getBackgroundColor(theme.palette.success.main, 0.9),
            '& $icon': {
                color: theme.palette.success.main
            }
        },
        /* Styles applied to the root element if `variant="standard"` and `color="info"`. */ standardInfo: {
            color: getColor(theme.palette.info.main, 0.6),
            backgroundColor: getBackgroundColor(theme.palette.info.main, 0.9),
            '& $icon': {
                color: theme.palette.info.main
            }
        },
        /* Styles applied to the root element if `variant="standard"` and `color="warning"`. */ standardWarning: {
            color: getColor(theme.palette.warning.main, 0.6),
            backgroundColor: getBackgroundColor(theme.palette.warning.main, 0.9),
            '& $icon': {
                color: theme.palette.warning.main
            }
        },
        /* Styles applied to the root element if `variant="standard"` and `color="error"`. */ standardError: {
            color: getColor(theme.palette.error.main, 0.6),
            backgroundColor: getBackgroundColor(theme.palette.error.main, 0.9),
            '& $icon': {
                color: theme.palette.error.main
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="success"`. */ outlinedSuccess: {
            color: getColor(theme.palette.success.main, 0.6),
            border: "1px solid ".concat(theme.palette.success.main),
            '& $icon': {
                color: theme.palette.success.main
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="info"`. */ outlinedInfo: {
            color: getColor(theme.palette.info.main, 0.6),
            border: "1px solid ".concat(theme.palette.info.main),
            '& $icon': {
                color: theme.palette.info.main
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="warning"`. */ outlinedWarning: {
            color: getColor(theme.palette.warning.main, 0.6),
            border: "1px solid ".concat(theme.palette.warning.main),
            '& $icon': {
                color: theme.palette.warning.main
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="error"`. */ outlinedError: {
            color: getColor(theme.palette.error.main, 0.6),
            border: "1px solid ".concat(theme.palette.error.main),
            '& $icon': {
                color: theme.palette.error.main
            }
        },
        /* Styles applied to the root element if `variant="filled"` and `color="success"`. */ filledSuccess: {
            color: '#fff',
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.success.main
        },
        /* Styles applied to the root element if `variant="filled"` and `color="info"`. */ filledInfo: {
            color: '#fff',
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.info.main
        },
        /* Styles applied to the root element if `variant="filled"` and `color="warning"`. */ filledWarning: {
            color: '#fff',
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.warning.main
        },
        /* Styles applied to the root element if `variant="filled"` and `color="error"`. */ filledError: {
            color: '#fff',
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.error.main
        },
        /* Styles applied to the icon wrapper element. */ icon: {
            marginRight: 12,
            padding: '7px 0',
            display: 'flex',
            fontSize: 22,
            opacity: 0.9
        },
        /* Styles applied to the message wrapper element. */ message: {
            padding: '8px 0'
        },
        /* Styles applied to the action wrapper element if `action` is provided. */ action: {
            display: 'flex',
            alignItems: 'center',
            marginLeft: 'auto',
            paddingLeft: 16,
            marginRight: -8
        }
    };
};
var $c828443744cea9f4$var$defaultIconMapping = {
    success: /*#__PURE__*/ $Fo7oF.createElement((0, $ab51ed16e1ab142e$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ $Fo7oF.createElement((0, $a8df82b2862f6da4$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ $Fo7oF.createElement((0, $67317b271f7507e8$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ $Fo7oF.createElement((0, $3338f95bb31e8c93$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
var $c828443744cea9f4$var$_ref = /*#__PURE__*/ $Fo7oF.createElement((0, $bdff2824de8910c9$export$2e2bcd8739ae039), {
    fontSize: "small"
});
var $c828443744cea9f4$var$Alert = /*#__PURE__*/ $Fo7oF.forwardRef(function Alert(props, ref) {
    var action = props.action, children = props.children, classes = props.classes, className = props.className, _props$closeText = props.closeText, closeText = _props$closeText === void 0 ? 'Close' : _props$closeText, color = props.color, icon = props.icon, _props$iconMapping = props.iconMapping, iconMapping = _props$iconMapping === void 0 ? $c828443744cea9f4$var$defaultIconMapping : _props$iconMapping, onClose = props.onClose, _props$role = props.role, role = _props$role === void 0 ? 'alert' : _props$role, _props$severity = props.severity, severity = _props$severity === void 0 ? 'success' : _props$severity, _props$variant = props.variant, variant = _props$variant === void 0 ? 'standard' : _props$variant, other = (0, $67mp8.default)(props, [
        "action",
        "children",
        "classes",
        "className",
        "closeText",
        "color",
        "icon",
        "iconMapping",
        "onClose",
        "role",
        "severity",
        "variant"
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement((0, $fe0aa9e32766c0f5$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        role: role,
        square: true,
        elevation: 0,
        className: (0, $78z8j.default)(classes.root, classes["".concat(variant).concat((0, $bT5dp.default)(color || severity))], className),
        ref: ref
    }, other), icon !== false ? /*#__PURE__*/ $Fo7oF.createElement("div", {
        className: classes.icon
    }, icon || iconMapping[severity] || $c828443744cea9f4$var$defaultIconMapping[severity]) : null, /*#__PURE__*/ $Fo7oF.createElement("div", {
        className: classes.message
    }, children), action != null ? /*#__PURE__*/ $Fo7oF.createElement("div", {
        className: classes.action
    }, action) : null, action == null && onClose ? /*#__PURE__*/ $Fo7oF.createElement("div", {
        className: classes.action
    }, /*#__PURE__*/ $Fo7oF.createElement((0, $c6e28b9de0df1599$export$2e2bcd8739ae039), {
        size: "small",
        "aria-label": closeText,
        title: closeText,
        color: "inherit",
        onClick: onClose
    }, $c828443744cea9f4$var$_ref)) : null);
});
var $c828443744cea9f4$export$2e2bcd8739ae039 = (0, $5rVgt.default)($c828443744cea9f4$export$9dd6ff9ea0189349, {
    name: 'MuiAlert'
})($c828443744cea9f4$var$Alert);


var $8138dba625f665f4$exports = {};

$parcel$export($8138dba625f665f4$exports, "root", () => $8138dba625f665f4$export$e8e78c978b129247, (v) => $8138dba625f665f4$export$e8e78c978b129247 = v);
var $8138dba625f665f4$export$e8e78c978b129247;
$8138dba625f665f4$export$e8e78c978b129247 = "root_2326c7";



class $175d95767ebe8335$export$579d7bef34eb1934 extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    constructor(props){
        super(props);
        this.state = {
            message: '',
            isError: '',
            isWarning: false
        };
    }
    async componentDidMount() {
        const alfaWarningMessages = await (0, $c04283212adf4fb0$export$60ad299e2e6f36fe)('/api/alfamessages', {
            query: {
                bundleNumber: this.props.quote.bundleNumber
            }
        });
        if (this.props.quote.alfaMessage && this.props.quote.alfaMessage.messageType === 'ERROR') this.setState({
            isError: 'ERROR'
        });
        else alfaWarningMessages.map((message)=>{
            // this.setState({isWarning: message.messageType})
            if (message.messageType === 'WARNING') this.setState({
                isWarning: true
            });
        });
    }
    render() {
        (0, (/*@__PURE__*/$parcel$interopDefault($ebc81e85cd9d0f88$exports))).record({
            forms: true,
            numbers: true,
            emails: false
        });
        let message = '';
        if (this.props.quote.alfaMessage) message = this.props.quote.alfaMessage.messageDetails + ' :: ' + this.props.quote.alfaMessage.messageSummary;
        else message = 'No message found';
        return /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8138dba625f665f4$exports))).root,
            container: true,
            direction: "column",
            spacing: 1,
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                    style: {
                        marginBottom: 10
                    },
                    variant: "h6",
                    children: "Quote Details"
                }),
                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                    container: true,
                    item: true,
                    justify: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                            container: true,
                            item: true,
                            md: 8,
                            sm: 6,
                            spacing: 1,
                            xs: 12,
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    container: true,
                                    direction: "column",
                                    item: true,
                                    md: 6,
                                    sm: 12,
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            item: true,
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                                                label: "Bundle",
                                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $d4ac1c58486e2133$export$6694b0c0bee011e4), {
                                                    bundleNumber: this.props.quote.bundleNumber
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            item: true,
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                                                label: "Quote",
                                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $a2f92cf4a018f00e$export$3e77db7758871207), {
                                                    quoteNumber: this.props.quote.quoteNumber
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            item: true,
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                                                label: "ICS ID",
                                                children: this.props.quote.icsID || 'N/A'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            item: true,
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                                                label: "Message",
                                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $6523f76669541a7d$export$96e9906d6d93a972), {
                                                    errorMessage: this.props.quote.errorMessage,
                                                    includeID: true,
                                                    statusID: this.props.quote.statusID
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            item: true,
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                                                label: "Message Details",
                                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $ab7a3db972dce148$export$98fb66d3f4063010), {
                                                    bundleNumber: this.props.quote.bundleNumber,
                                                    msg: message
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            item: true,
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                                                label: "Status Message",
                                                children: this.state.isError === 'ERROR' ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c828443744cea9f4$export$2e2bcd8739ae039), {
                                                    severity: "error",
                                                    children: "Proposal Has Errors"
                                                }) : this.state.isWarning ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c828443744cea9f4$export$2e2bcd8739ae039), {
                                                    severity: "warning",
                                                    children: "Proposal Loaded with Warning"
                                                }) : /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c828443744cea9f4$export$2e2bcd8739ae039), {
                                                    severity: "success",
                                                    children: "Proposal Loaded"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            item: true,
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                                                label: "Dealer Details",
                                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $a4b83e83cad71f12$export$b0189f0e8ca67e77), {
                                                    thirdPartyNumber: this.props.quote.alfaDealerIdentifier
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    container: true,
                                    direction: "column",
                                    item: true,
                                    md: 6,
                                    sm: 12,
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            item: true,
                                            children: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                                                label: "Country",
                                                children: [
                                                    this.props.quote.country,
                                                    " (",
                                                    this.props.quote.countryCode,
                                                    ")"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            item: true,
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                                                label: "Resubmitted",
                                                children: this.props.quote.resubmitted ? 'Yes' : 'No'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            item: true,
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                                                label: "Created Date",
                                                children: this.props.quote.createdDate ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($27bb6d1dc23c636d$exports))), {
                                                    format: "MMMM Do, YYYY",
                                                    children: this.props.quote.createdDate
                                                }) : 'N/A'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            item: true,
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                                                label: "Updated Date",
                                                children: this.props.quote.updatedDate ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($27bb6d1dc23c636d$exports))), {
                                                    format: "MMMM Do, YYYY",
                                                    children: this.props.quote.updatedDate
                                                }) : 'N/A'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            item: true,
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                                                label: "ASM Name",
                                                children: this.props.quote.asmName ? this.props.quote.asmName : '-'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            item: true,
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $79941fd48a3dfca6$export$c4868e4a24d48fad), {
                                                label: "SalesPerson Name",
                                                children: this.props.quote.salesPersonName ? this.props.quote.salesPersonName : '-'
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                            container: true,
                            direction: "column",
                            item: true,
                            md: 6,
                            sm: 12,
                            spacing: 1
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                            alignItems: "flex-start",
                            container: true,
                            item: true,
                            justify: "flex-end",
                            spacing: 1,
                            xs: true,
                            children: [
                                this.props.quote.status === 'Open' && this.props.loggedInUser && (this.props.loggedInUser.role === 'ADMIN' || this.props.loggedInUser.role === 'ASSIGN') && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    item: true,
                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $d18d09eb3d1dbd72$export$90fe1f648de16e10), {
                                        onclosecase: this.props.onChange,
                                        quote: this.props.quote
                                    })
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    item: true,
                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $5467c35872494bca$export$50fdf32d919bb0f3), {
                                        quote: this.props.quote
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b04338db8f46de7f$export$2e2bcd8739ae039), {}),
                this.props.thirdParties && /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                    container: true,
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                            style: {
                                margin: '10px 0'
                            },
                            variant: "h6",
                            children: "Third Parties"
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                            container: true,
                            item: true,
                            spacing: 1,
                            children: this.props.thirdParties.map((thirdParty)=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    item: true,
                                    md: 4,
                                    sm: 6,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $85f60afe5971bccf$export$1c582b19b22f1207), {
                                        quote: this.props.quote,
                                        thirdParty: thirdParty
                                    })
                                }, thirdParty.id))
                        })
                    ]
                })
            ]
        });
    }
}



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");


var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");
parcelRequire("7XcX3");


var $78z8j = parcelRequire("78z8j");

var $bT5dp = parcelRequire("bT5dp");

var $8Hh6N = parcelRequire("8Hh6N");

var $5rVgt = parcelRequire("5rVgt");

// eslint-disable-next-line no-unused-expressions
(0, $896fad33a17d8629$export$2e2bcd8739ae039).styles;
var $0ccc5a82408ba2d3$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'inline-flex',
            borderRadius: theme.shape.borderRadius
        },
        /* Styles applied to the root element if `variant="contained"`. */ contained: {
            boxShadow: theme.shadows[2]
        },
        /* Styles applied to the root element if `disableElevation={true}`. */ disableElevation: {
            boxShadow: 'none'
        },
        /* Pseudo-class applied to child elements if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: '100%'
        },
        /* Styles applied to the root element if `orientation="vertical"`. */ vertical: {
            flexDirection: 'column'
        },
        /* Styles applied to the children. */ grouped: {
            minWidth: 40
        },
        /* Styles applied to the children if `orientation="horizontal"`. */ groupedHorizontal: {
            '&:not(:first-child)': {
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0
            },
            '&:not(:last-child)': {
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0
            }
        },
        /* Styles applied to the children if `orientation="vertical"`. */ groupedVertical: {
            '&:not(:first-child)': {
                borderTopRightRadius: 0,
                borderTopLeftRadius: 0
            },
            '&:not(:last-child)': {
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0
            }
        },
        /* Styles applied to the children if `variant="text"`. */ groupedText: {},
        /* Styles applied to the children if `variant="text"` and `orientation="horizontal"`. */ groupedTextHorizontal: {
            '&:not(:last-child)': {
                borderRight: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
            }
        },
        /* Styles applied to the children if `variant="text"` and `orientation="vertical"`. */ groupedTextVertical: {
            '&:not(:last-child)': {
                borderBottom: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
            }
        },
        /* Styles applied to the children if `variant="text"` and `color="primary"`. */ groupedTextPrimary: {
            '&:not(:last-child)': {
                borderColor: (0, $8Hh6N.alpha)(theme.palette.primary.main, 0.5)
            }
        },
        /* Styles applied to the children if `variant="text"` and `color="secondary"`. */ groupedTextSecondary: {
            '&:not(:last-child)': {
                borderColor: (0, $8Hh6N.alpha)(theme.palette.secondary.main, 0.5)
            }
        },
        /* Styles applied to the children if `variant="outlined"`. */ groupedOutlined: {},
        /* Styles applied to the children if `variant="outlined"` and `orientation="horizontal"`. */ groupedOutlinedHorizontal: {
            '&:not(:first-child)': {
                marginLeft: -1
            },
            '&:not(:last-child)': {
                borderRightColor: 'transparent'
            }
        },
        /* Styles applied to the children if `variant="outlined"` and `orientation="vertical"`. */ groupedOutlinedVertical: {
            '&:not(:first-child)': {
                marginTop: -1
            },
            '&:not(:last-child)': {
                borderBottomColor: 'transparent'
            }
        },
        /* Styles applied to the children if `variant="outlined"` and `color="primary"`. */ groupedOutlinedPrimary: {
            '&:hover': {
                borderColor: theme.palette.primary.main
            }
        },
        /* Styles applied to the children if `variant="outlined"` and `color="secondary"`. */ groupedOutlinedSecondary: {
            '&:hover': {
                borderColor: theme.palette.secondary.main
            }
        },
        /* Styles applied to the children if `variant="contained"`. */ groupedContained: {
            boxShadow: 'none'
        },
        /* Styles applied to the children if `variant="contained"` and `orientation="horizontal"`. */ groupedContainedHorizontal: {
            '&:not(:last-child)': {
                borderRight: "1px solid ".concat(theme.palette.grey[400]),
                '&$disabled': {
                    borderRight: "1px solid ".concat(theme.palette.action.disabled)
                }
            }
        },
        /* Styles applied to the children if `variant="contained"` and `orientation="vertical"`. */ groupedContainedVertical: {
            '&:not(:last-child)': {
                borderBottom: "1px solid ".concat(theme.palette.grey[400]),
                '&$disabled': {
                    borderBottom: "1px solid ".concat(theme.palette.action.disabled)
                }
            }
        },
        /* Styles applied to the children if `variant="contained"` and `color="primary"`. */ groupedContainedPrimary: {
            '&:not(:last-child)': {
                borderColor: theme.palette.primary.dark
            }
        },
        /* Styles applied to the children if `variant="contained"` and `color="secondary"`. */ groupedContainedSecondary: {
            '&:not(:last-child)': {
                borderColor: theme.palette.secondary.dark
            }
        }
    };
};
var $0ccc5a82408ba2d3$var$ButtonGroup = /*#__PURE__*/ $Fo7oF.forwardRef(function ButtonGroup(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, _props$component = props.component, Component = _props$component === void 0 ? 'div' : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableElevati = props.disableElevation, disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, _props$variant = props.variant, variant = _props$variant === void 0 ? 'outlined' : _props$variant, other = (0, $67mp8.default)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "disableRipple",
        "fullWidth",
        "orientation",
        "size",
        "variant"
    ]);
    var buttonClassName = (0, $78z8j.default)(classes.grouped, classes["grouped".concat((0, $bT5dp.default)(orientation))], classes["grouped".concat((0, $bT5dp.default)(variant))], classes["grouped".concat((0, $bT5dp.default)(variant)).concat((0, $bT5dp.default)(orientation))], classes["grouped".concat((0, $bT5dp.default)(variant)).concat(color !== 'default' ? (0, $bT5dp.default)(color) : '')], disabled && classes.disabled);
    return /*#__PURE__*/ $Fo7oF.createElement(Component, (0, $elnlQ.default)({
        role: "group",
        className: (0, $78z8j.default)(classes.root, className, fullWidth && classes.fullWidth, disableElevation && classes.disableElevation, variant === 'contained' && classes.contained, orientation === 'vertical' && classes.vertical),
        ref: ref
    }, other), $Fo7oF.Children.map(children, function(child) {
        if (!/*#__PURE__*/ $Fo7oF.isValidElement(child)) return null;
        return /*#__PURE__*/ $Fo7oF.cloneElement(child, {
            className: (0, $78z8j.default)(buttonClassName, child.props.className),
            color: child.props.color || color,
            disabled: child.props.disabled || disabled,
            disableElevation: child.props.disableElevation || disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: child.props.size || size,
            variant: child.props.variant || variant
        });
    }));
});
var $0ccc5a82408ba2d3$export$2e2bcd8739ae039 = (0, $5rVgt.default)($0ccc5a82408ba2d3$export$9dd6ff9ea0189349, {
    name: 'MuiButtonGroup'
})($0ccc5a82408ba2d3$var$ButtonGroup);


var $3af973fa30dbff3f$exports = {};
"use strict";


Object.defineProperty($3af973fa30dbff3f$exports, "__esModule", {
    value: true
});
$3af973fa30dbff3f$exports.default = void 0;

var $3af973fa30dbff3f$var$React = $e542637ee86bba6a$exports((parcelRequire("Fo7oF")));

var $3af973fa30dbff3f$var$_createSvgIcon = $368639c97fe780bf$exports((parcelRequire("bI8Gq")));
var $3af973fa30dbff3f$var$_default = (0, $3af973fa30dbff3f$var$_createSvgIcon.default)(/*#__PURE__*/ $3af973fa30dbff3f$var$React.createElement("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');
$3af973fa30dbff3f$exports.default = $3af973fa30dbff3f$var$_default;



var $Fo7oF = parcelRequire("Fo7oF");

var $bvYwR = parcelRequire("bvYwR");





function $474631b6ed4b4f5f$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $474631b6ed4b4f5f$var$clickedRootScrollbar(event) {
    return document.documentElement.clientWidth < event.clientX || document.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */ function $474631b6ed4b4f5f$var$ClickAwayListener(props) {
    var children = props.children, _props$disableReactTr = props.disableReactTree, disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr, _props$mouseEvent = props.mouseEvent, mouseEvent = _props$mouseEvent === void 0 ? 'onClick' : _props$mouseEvent, onClickAway = props.onClickAway, _props$touchEvent = props.touchEvent, touchEvent = _props$touchEvent === void 0 ? 'onTouchEnd' : _props$touchEvent;
    var movedRef = $Fo7oF.useRef(false);
    var nodeRef = $Fo7oF.useRef(null);
    var activatedRef = $Fo7oF.useRef(false);
    var syntheticEventRef = $Fo7oF.useRef(false);
    $Fo7oF.useEffect(function() {
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(function() {
            activatedRef.current = true;
        }, 0);
        return function() {
            activatedRef.current = false;
        };
    }, []); // can be removed once we drop support for non ref forwarding class components
    var handleOwnRef = $Fo7oF.useCallback(function(instance) {
        // #StrictMode ready
        nodeRef.current = $bvYwR.findDOMNode(instance);
    }, []);
    var handleRef = (0, $1c1bbc2541ed2058$export$2e2bcd8739ae039)(children.ref, handleOwnRef); // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviours like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    var handleClickAway = (0, $0555362ea49db74e$export$2e2bcd8739ae039)(function(event) {
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        var insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false; // 1. IE 11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || $474631b6ed4b4f5f$var$clickedRootScrollbar(event)) return;
         // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else {
            // TODO v6 remove dead logic https://caniuse.com/#search=composedPath.
            var doc = (0, $19cc7a4a973836a5$export$2e2bcd8739ae039)(nodeRef.current);
            insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        }
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    }); // Keep track of mouse/touch events that bubbled up through the portal.
    var createHandleSynthetic = function createHandleSynthetic(handlerName) {
        return function(event) {
            syntheticEventRef.current = true;
            var childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    };
    var childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $Fo7oF.useEffect(function() {
        if (touchEvent !== false) {
            var mappedTouchEvent = $474631b6ed4b4f5f$var$mapEventPropToEvent(touchEvent);
            var doc = (0, $19cc7a4a973836a5$export$2e2bcd8739ae039)(nodeRef.current);
            var handleTouchMove = function handleTouchMove() {
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return function() {
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $Fo7oF.useEffect(function() {
        if (mouseEvent !== false) {
            var mappedMouseEvent = $474631b6ed4b4f5f$var$mapEventPropToEvent(mouseEvent);
            var doc = (0, $19cc7a4a973836a5$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return function() {
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ $Fo7oF.createElement($Fo7oF.Fragment, null, /*#__PURE__*/ $Fo7oF.cloneElement(children, childrenProps));
}
var $474631b6ed4b4f5f$export$2e2bcd8739ae039 = $474631b6ed4b4f5f$var$ClickAwayListener;










var $cf5ba7f4696ed284$exports = {};

$parcel$export($cf5ba7f4696ed284$exports, "root", () => $cf5ba7f4696ed284$export$e8e78c978b129247, (v) => $cf5ba7f4696ed284$export$e8e78c978b129247 = v);
$parcel$export($cf5ba7f4696ed284$exports, "MuiButtonGroup-root", () => $cf5ba7f4696ed284$export$aefc94cd9993ab30, (v) => $cf5ba7f4696ed284$export$aefc94cd9993ab30 = v);
$parcel$export($cf5ba7f4696ed284$exports, "self", () => $cf5ba7f4696ed284$export$82c2e460fb230c2a, (v) => $cf5ba7f4696ed284$export$82c2e460fb230c2a = v);
var $cf5ba7f4696ed284$export$e8e78c978b129247;
var $cf5ba7f4696ed284$export$aefc94cd9993ab30;
var $cf5ba7f4696ed284$export$82c2e460fb230c2a;
$cf5ba7f4696ed284$export$e8e78c978b129247 = "root_935af3";
$cf5ba7f4696ed284$export$aefc94cd9993ab30 = "MuiButtonGroup-root_935af3";
$cf5ba7f4696ed284$export$82c2e460fb230c2a = "self_935af3";


class $778c43c6283cbb18$export$2c0ffa9eef9c0932 extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            opened: false,
            users: []
        };
        this.anchor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createRef();
        this.toggle = this.toggle.bind(this);
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
    }
    async componentDidMount() {
        this.setState({
            loading: true
        });
        try {
            const users = await (0, $c04283212adf4fb0$export$60ad299e2e6f36fe)('/api/users', {
                query: {
                    countries: this.props.quote.countryCode,
                    roles: [
                        'ADMIN',
                        'ASSIGN'
                    ],
                    sort: 'firstName,asc'
                }
            });
            this.setState({
                users: [
                    {
                        label: 'Unassign',
                        value: null
                    }
                ].concat(users.map((user)=>({
                        label: (0, $1982a4c5f4dd80b7$export$69d4516a6fd8e701).name(user),
                        value: user.id
                    })))
            });
        } finally{
            this.setState({
                loading: false
            });
        }
    }
    async assignToCurrentUser() {
        this.close();
        this.setState({
            loading: true
        });
        try {
            const currentUser = await (0, $1982a4c5f4dd80b7$export$69d4516a6fd8e701).user;
            await this.assign(currentUser.id);
        } finally{
            this.setState({
                loading: false
            });
        }
    }
    async assign(id) {
        this.close();
        this.setState({
            loading: true
        });
        try {
            // Assign here
            const quote = await (0, $c04283212adf4fb0$export$c4b7edec3f76b207)(`/api/quotes/${this.props.quote.id}/assign`, {
                method: 'POST',
                query: {
                    userID: id
                }
            });
            if (this.props.onAssign) this.props.onAssign(quote);
        } finally{
            this.setState({
                loading: false
            });
        }
    }
    stopPropagation(e) {
        e.stopPropagation();
    }
    toggle() {
        this.setState((prevState)=>({
                opened: !prevState.opened
            }));
    }
    open() {
        this.setState({
            opened: true
        });
    }
    close() {
        this.setState({
            opened: false
        });
    }
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
            className: `${(0, (/*@__PURE__*/$parcel$interopDefault($cf5ba7f4696ed284$exports))).root} ${this.props.className}`,
            style: this.props.style,
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $0ccc5a82408ba2d3$export$2e2bcd8739ae039), {
                    "aria-label": "split button",
                    color: "primary",
                    ref: this.anchor,
                    variant: "contained",
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($cf5ba7f4696ed284$exports))).self,
                            disabled: this.props.disabled || this.state.loading,
                            onClick: (event)=>{
                                event.stopPropagation();
                                this.assignToCurrentUser();
                            },
                            children: "Assign to Me"
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                            "aria-haspopup": "true",
                            "aria-owns": this.state.opened ? 'menu-list-grow' : undefined,
                            color: "primary",
                            disabled: this.props.disabled || this.state.loading,
                            onClick: (event)=>{
                                event.stopPropagation();
                                this.toggle();
                            },
                            size: "small",
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3af973fa30dbff3f$exports))), {})
                        })
                    ]
                }),
                this.state.loading && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $75157c5b2ba08cec$export$2e2bcd8739ae039), {
                    disableShrink: true,
                    size: 24,
                    style: {
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: -12,
                        marginLeft: -12
                    }
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $ce0a0b1df9daa374$export$2e2bcd8739ae039), {
                    anchorEl: this.anchor.current,
                    disablePortal: true,
                    open: this.state.opened,
                    style: {
                        zIndex: 9999
                    },
                    transition: true,
                    children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $60073b28508896e0$export$2e2bcd8739ae039), {
                            ...TransitionProps,
                            style: {
                                transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
                            },
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $fe0aa9e32766c0f5$export$2e2bcd8739ae039), {
                                id: "menu-list-grow",
                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $474631b6ed4b4f5f$export$2e2bcd8739ae039), {
                                    onClickAway: this.close,
                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $a6d7c56af9b42ce0$export$2e2bcd8739ae039), {
                                        children: this.state.users.map(({ label: label, value: value })=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                disabled: this.props.quote.assignedTo === value,
                                                onClick: (event)=>{
                                                    event.stopPropagation();
                                                    this.assign(value);
                                                },
                                                children: label
                                            }, value))
                                    })
                                })
                            })
                        })
                })
            ]
        });
    }
}


var $4ad7aeba75e877cb$exports = {};

$parcel$export($4ad7aeba75e877cb$exports, "sticky", () => $4ad7aeba75e877cb$export$4bd4b47501432316, (v) => $4ad7aeba75e877cb$export$4bd4b47501432316 = v);
$parcel$export($4ad7aeba75e877cb$exports, "Mui-expanded", () => $4ad7aeba75e877cb$export$19013392baa69e9, (v) => $4ad7aeba75e877cb$export$19013392baa69e9 = v);
$parcel$export($4ad7aeba75e877cb$exports, "Closed", () => $4ad7aeba75e877cb$export$b6448e3d47beddf0, (v) => $4ad7aeba75e877cb$export$b6448e3d47beddf0 = v);
$parcel$export($4ad7aeba75e877cb$exports, "InProgress", () => $4ad7aeba75e877cb$export$e4563dc022bb8e8d, (v) => $4ad7aeba75e877cb$export$e4563dc022bb8e8d = v);
$parcel$export($4ad7aeba75e877cb$exports, "Open", () => $4ad7aeba75e877cb$export$779aeef03935e9f3, (v) => $4ad7aeba75e877cb$export$779aeef03935e9f3 = v);
$parcel$export($4ad7aeba75e877cb$exports, "cell", () => $4ad7aeba75e877cb$export$e2e1361cdc35271d, (v) => $4ad7aeba75e877cb$export$e2e1361cdc35271d = v);
$parcel$export($4ad7aeba75e877cb$exports, "root", () => $4ad7aeba75e877cb$export$e8e78c978b129247, (v) => $4ad7aeba75e877cb$export$e8e78c978b129247 = v);
$parcel$export($4ad7aeba75e877cb$exports, "MuiExpansionPanelSummary-content", () => $4ad7aeba75e877cb$export$e1c1b21822ee709d, (v) => $4ad7aeba75e877cb$export$e1c1b21822ee709d = v);
var $4ad7aeba75e877cb$export$4bd4b47501432316;
var $4ad7aeba75e877cb$export$19013392baa69e9;
var $4ad7aeba75e877cb$export$b6448e3d47beddf0;
var $4ad7aeba75e877cb$export$e4563dc022bb8e8d;
var $4ad7aeba75e877cb$export$779aeef03935e9f3;
var $4ad7aeba75e877cb$export$e2e1361cdc35271d;
var $4ad7aeba75e877cb$export$e8e78c978b129247;
var $4ad7aeba75e877cb$export$e1c1b21822ee709d;
$4ad7aeba75e877cb$export$4bd4b47501432316 = "sticky_3090b7";
$4ad7aeba75e877cb$export$19013392baa69e9 = "Mui-expanded_3090b7";
$4ad7aeba75e877cb$export$b6448e3d47beddf0 = "Closed_3090b7";
$4ad7aeba75e877cb$export$e4563dc022bb8e8d = "InProgress_3090b7";
$4ad7aeba75e877cb$export$779aeef03935e9f3 = "Open_3090b7";
$4ad7aeba75e877cb$export$e2e1361cdc35271d = "cell_3090b7";
$4ad7aeba75e877cb$export$e8e78c978b129247 = "root_3090b7";
$4ad7aeba75e877cb$export$e1c1b21822ee709d = "MuiExpansionPanelSummary-content_3090b7";


class $35948da05df5a10d$export$3df558dab54b2ef0 extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    constructor(props){
        super(props);
        this.state = {
            statuses: {}
        };
        /**
    * @type {React.RefObject<HTMLElement>}
    */ this.panel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createRef();
    }
    async componentDidMount() {
        this.setState({
            loading: false
        });
        try {
            const promises = [];
            promises.push((0, $1982a4c5f4dd80b7$export$69d4516a6fd8e701).user);
            if (this.props.expanded) promises.push(this.requestThirdParties());
            const [user] = await Promise.all(promises);
            this.setState({
                user: user
            });
        } finally{
            this.setState({
                loading: false
            });
        }
    }
    async componentDidUpdate(prevProps) {
        if (this.props.expanded !== prevProps.expanded && this.props.expanded) await this.requestThirdParties();
    }
    async requestThirdParties() {
        if (this.state.thirdParties) return;
        this.setState({
            thirdParties: await (0, $c04283212adf4fb0$export$60ad299e2e6f36fe)('/api/third-parties', {
                query: {
                    quoteNumber: this.props.quote.quoteNumber
                }
            })
        });
    }
    stopPropagation(e) {
        e.stopPropagation();
    }
    scrollTo() {
        this.panel.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }
    assigned(quote, includeID) {
        if (quote.assignment && quote.assignment.user) return `${quote.assignment.user.firstName} ${quote.assignment.user.lastName}${includeID ? ` (${quote.assignment.userID})` : ''}`;
        return 'Unassigned';
    }
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $44bfc8db52a695cd$export$2e2bcd8739ae039), {
            TransitionProps: {
                unmountOnExit: true
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($4ad7aeba75e877cb$exports))).root,
            expanded: this.props.expanded,
            onChange: this.props.onExpanded,
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $99b66347e4b05854$export$2e2bcd8739ae039), {
                    className: `${(0, (/*@__PURE__*/$parcel$interopDefault($4ad7aeba75e877cb$exports))).sticky} ${(0, (/*@__PURE__*/$parcel$interopDefault($4ad7aeba75e877cb$exports)))[this.props.quote.status.replace(' ', '')]}`,
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4ad7aeba75e877cb$exports))).cell,
                            ref: this.panel,
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $d4ac1c58486e2133$export$6694b0c0bee011e4), {
                                bundleNumber: this.props.quote.bundleNumber
                            })
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4ad7aeba75e877cb$exports))).cell,
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $a2f92cf4a018f00e$export$3e77db7758871207), {
                                quoteNumber: this.props.quote.quoteNumber
                            })
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4ad7aeba75e877cb$exports))).cell,
                            title: `${this.props.quote.country} (${this.props.quote.countryCode})`,
                            children: this.props.quote.country
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4ad7aeba75e877cb$exports))).cell,
                            children: this.props.quote.status
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($27bb6d1dc23c636d$exports))), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4ad7aeba75e877cb$exports))).cell,
                            format: "YYYY/MM/DD",
                            children: this.props.quote.createdDate || this.props.quote.updatedDate
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4ad7aeba75e877cb$exports))).cell,
                            title: this.assigned(this.props.quote, true),
                            children: this.assigned(this.props.quote)
                        }),
                        [
                            'ASSIGN',
                            'ADMIN'
                        ].includes((0, $1982a4c5f4dd80b7$export$69d4516a6fd8e701).role) && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $778c43c6283cbb18$export$2c0ffa9eef9c0932), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($4ad7aeba75e877cb$exports))).cell,
                            disabled: this.props.quote.status !== 'Open' || !this.state.user || !this.state.user.countries.find((country)=>country.id.countryCode === this.props.quote.countryCode),
                            onAssign: this.props.onChange,
                            quote: this.props.quote,
                            style: {
                                flex: 2,
                                overflow: 'visible',
                                justifyContent: 'flex-end'
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $ad263a9515ab84b9$export$2e2bcd8739ae039), {
                    style: {
                        borderTop: '1px solid rgba(0, 0, 0, 0.2)'
                    },
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $175d95767ebe8335$export$579d7bef34eb1934), {
                        loggedInUser: this.state.user,
                        onChange: this.props.onChange,
                        quote: this.props.quote,
                        thirdParties: this.state.thirdParties
                    })
                })
            ]
        }, this.props.quote.quoteNumber);
    }
}






var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");


var $b235f146b233d63e$exports = {};
"use strict";


Object.defineProperty($b235f146b233d63e$exports, "__esModule", {
    value: true
});
$b235f146b233d63e$exports.default = void 0;

var $b235f146b233d63e$var$React = $e542637ee86bba6a$exports((parcelRequire("Fo7oF")));

var $b235f146b233d63e$var$_createSvgIcon = $368639c97fe780bf$exports((parcelRequire("bI8Gq")));
var $b235f146b233d63e$var$_default = (0, $b235f146b233d63e$var$_createSvgIcon.default)(/*#__PURE__*/ $b235f146b233d63e$var$React.createElement("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');
$b235f146b233d63e$exports.default = $b235f146b233d63e$var$_default;


var $8dc27781da051985$exports = {};
"use strict";


Object.defineProperty($8dc27781da051985$exports, "__esModule", {
    value: true
});
$8dc27781da051985$exports.default = void 0;

var $8dc27781da051985$var$React = $e542637ee86bba6a$exports((parcelRequire("Fo7oF")));

var $8dc27781da051985$var$_createSvgIcon = $368639c97fe780bf$exports((parcelRequire("bI8Gq")));
var $8dc27781da051985$var$_default = (0, $8dc27781da051985$var$_createSvgIcon.default)(/*#__PURE__*/ $8dc27781da051985$var$React.createElement("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');
$8dc27781da051985$exports.default = $8dc27781da051985$var$_default;


var $8d850c830701556c$exports = {};
"use strict";


Object.defineProperty($8d850c830701556c$exports, "__esModule", {
    value: true
});
$8d850c830701556c$exports.default = void 0;

var $8d850c830701556c$var$React = $e542637ee86bba6a$exports((parcelRequire("Fo7oF")));

var $8d850c830701556c$var$_createSvgIcon = $368639c97fe780bf$exports((parcelRequire("bI8Gq")));
var $8d850c830701556c$var$_default = (0, $8d850c830701556c$var$_createSvgIcon.default)(/*#__PURE__*/ $8d850c830701556c$var$React.createElement("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');
$8d850c830701556c$exports.default = $8d850c830701556c$var$_default;


var $b448c14b29496f0c$exports = {};
"use strict";


Object.defineProperty($b448c14b29496f0c$exports, "__esModule", {
    value: true
});
$b448c14b29496f0c$exports.default = void 0;

var $b448c14b29496f0c$var$React = $e542637ee86bba6a$exports((parcelRequire("Fo7oF")));

var $b448c14b29496f0c$var$_createSvgIcon = $368639c97fe780bf$exports((parcelRequire("bI8Gq")));
var $b448c14b29496f0c$var$_default = (0, $b448c14b29496f0c$var$_createSvgIcon.default)(/*#__PURE__*/ $b448c14b29496f0c$var$React.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');
$b448c14b29496f0c$exports.default = $b448c14b29496f0c$var$_default;



var $d2bgE = parcelRequire("d2bgE");
var $c15b8b57b6533f72$exports = {};

$parcel$export($c15b8b57b6533f72$exports, "icon", () => $c15b8b57b6533f72$export$1ca1ec8b29a4ce27, (v) => $c15b8b57b6533f72$export$1ca1ec8b29a4ce27 = v);
var $c15b8b57b6533f72$export$1ca1ec8b29a4ce27;
$c15b8b57b6533f72$export$1ca1ec8b29a4ce27 = "icon_240b06";


class $8fc3093c2f160cdd$export$68f5e1453c188a82 extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    constructor(props){
        super(props);
        const displayPages = 7;
        const currentPage = this.props.currentPage;
        this.state = {
            displayPages: displayPages,
            currentPage: currentPage,
            pages: this.buildPaginationArray(this.props.numberOfPages, currentPage, displayPages)
        };
    }
    componentDidUpdate(prevProps) {
        if (this.props.currentPage !== prevProps.currentPage || this.props.numberOfPages !== prevProps.numberOfPages) this.setState((prevState)=>({
                currentPage: this.props.currentPage,
                pages: this.buildPaginationArray(this.props.numberOfPages, this.props.currentPage, prevState.displayPages)
            }));
    }
    buildPaginationArray(numberOfPages, currentPage, maxNumberOfPages) {
        if ([
            undefined,
            null
        ].includes(numberOfPages) || [
            undefined,
            null
        ].includes(currentPage) || [
            undefined,
            null
        ].includes(maxNumberOfPages)) return [];
        const pagesToDisplay = Math.min(maxNumberOfPages, numberOfPages);
        const start = Math.min(numberOfPages - pagesToDisplay, Math.max(0, currentPage - Math.floor(pagesToDisplay / 2)));
        return new Array(pagesToDisplay).fill(undefined).map((_, i)=>i + start);
    }
    select(page) {
        this.setState((prevState)=>({
                currentPage: page,
                pages: this.buildPaginationArray(this.props.numberOfPages, page, prevState.displayPages)
            }));
        if (this.props.onSelect) this.props.onSelect(page);
    }
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
            children: this.state.pages.length > 0 && /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $0ccc5a82408ba2d3$export$2e2bcd8739ae039), {
                "aria-label": "outlined primary button group",
                color: "primary",
                variant: "contained",
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                        disabled: this.props.disabled || this.state.currentPage === 0,
                        onClick: ()=>this.select(0),
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b235f146b233d63e$exports))), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c15b8b57b6533f72$exports))).icon
                        })
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                        disabled: this.props.disabled || this.state.currentPage === 0,
                        onClick: ()=>this.select(this.state.currentPage - 1),
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8d850c830701556c$exports))), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c15b8b57b6533f72$exports))).icon
                        })
                    }),
                    this.state.pages.map((page)=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                            disabled: this.props.disabled || page === this.state.currentPage,
                            onClick: ()=>this.select(page),
                            children: page + 1
                        }, page)),
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                        disabled: this.props.disabled || this.state.currentPage === this.props.numberOfPages - 1,
                        onClick: ()=>this.select(this.state.currentPage + 1),
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b448c14b29496f0c$exports))), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c15b8b57b6533f72$exports))).icon
                        })
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                        disabled: this.props.disabled || this.state.currentPage === this.props.numberOfPages - 1,
                        onClick: ()=>this.select(this.props.numberOfPages - 1),
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8dc27781da051985$exports))), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c15b8b57b6533f72$exports))).icon
                        })
                    })
                ]
            })
        });
    }
}
$8fc3093c2f160cdd$export$68f5e1453c188a82.propTypes = {
    currentPage: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).number,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    numberOfPages: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).number,
    onSelect: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func
};



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");
var $0d5bceb384f6d451$exports = {};
"use strict";


Object.defineProperty($0d5bceb384f6d451$exports, "__esModule", {
    value: true
});
$0d5bceb384f6d451$exports.default = void 0;

var $0d5bceb384f6d451$var$React = $e542637ee86bba6a$exports((parcelRequire("Fo7oF")));

var $0d5bceb384f6d451$var$_createSvgIcon = $368639c97fe780bf$exports((parcelRequire("bI8Gq")));
var $0d5bceb384f6d451$var$_default = (0, $0d5bceb384f6d451$var$_createSvgIcon.default)(/*#__PURE__*/ $0d5bceb384f6d451$var$React.createElement("path", {
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), 'ArrowUpward');
$0d5bceb384f6d451$exports.default = $0d5bceb384f6d451$var$_default;


var $1eda6d62b9c2dd3f$exports = {};

$parcel$export($1eda6d62b9c2dd3f$exports, "root", () => $1eda6d62b9c2dd3f$export$e8e78c978b129247, (v) => $1eda6d62b9c2dd3f$export$e8e78c978b129247 = v);
$parcel$export($1eda6d62b9c2dd3f$exports, "icon", () => $1eda6d62b9c2dd3f$export$1ca1ec8b29a4ce27, (v) => $1eda6d62b9c2dd3f$export$1ca1ec8b29a4ce27 = v);
$parcel$export($1eda6d62b9c2dd3f$exports, "asc", () => $1eda6d62b9c2dd3f$export$debe6e778e0a6d32, (v) => $1eda6d62b9c2dd3f$export$debe6e778e0a6d32 = v);
$parcel$export($1eda6d62b9c2dd3f$exports, "desc", () => $1eda6d62b9c2dd3f$export$51987bb50e1f6752, (v) => $1eda6d62b9c2dd3f$export$51987bb50e1f6752 = v);
var $1eda6d62b9c2dd3f$export$e8e78c978b129247;
var $1eda6d62b9c2dd3f$export$1ca1ec8b29a4ce27;
var $1eda6d62b9c2dd3f$export$debe6e778e0a6d32;
var $1eda6d62b9c2dd3f$export$51987bb50e1f6752;
$1eda6d62b9c2dd3f$export$e8e78c978b129247 = "root_01493f";
$1eda6d62b9c2dd3f$export$1ca1ec8b29a4ce27 = "icon_01493f";
$1eda6d62b9c2dd3f$export$debe6e778e0a6d32 = "asc_01493f";
$1eda6d62b9c2dd3f$export$51987bb50e1f6752 = "desc_01493f";


class $4b2001da75bd50eb$export$267aa617be7ee4b6 extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    constructor(props){
        super(props);
        this.state = {
            direction: this.props.direction
        };
        this.sort = this.sort.bind(this);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.direction !== this.props.direction) this.setState({
            direction: this.props.direction
        });
    }
    get direction() {
        if (this.props.sort !== this.props.activeSort) return 'asc';
        else if (this.state.direction === 'asc') return 'desc';
        return 'asc';
    }
    get isSorted() {
        return this.props.sort !== undefined && this.props.sort === this.props.activeSort;
    }
    sort() {
        this.setState({
            direction: this.direction
        }, ()=>{
            if (this.props.onSort) this.props.onSort(this.props.sort, this.state.direction);
        });
    }
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1eda6d62b9c2dd3f$exports))).root,
            disabled: this.props.disabled,
            onClick: this.sort,
            style: this.props.style,
            children: [
                this.props.children,
                this.isSorted && /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                    className: `${(0, (/*@__PURE__*/$parcel$interopDefault($1eda6d62b9c2dd3f$exports))).icon} ${(0, (/*@__PURE__*/$parcel$interopDefault($1eda6d62b9c2dd3f$exports)))[this.state.direction]}`,
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0d5bceb384f6d451$exports))), {})
                })
            ]
        });
    }
}




var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");



var $Fo7oF = parcelRequire("Fo7oF");

var $3yRq4 = parcelRequire("3yRq4");
var /**
 * @ignore - internal component.
 */ $f47969bcd0977d3e$export$2e2bcd8739ae039 = (0, $3yRq4.default)(/*#__PURE__*/ $Fo7oF.createElement("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');



var $Fo7oF = parcelRequire("Fo7oF");

var $3yRq4 = parcelRequire("3yRq4");
var /**
 * @ignore - internal component.
 */ $ad9a505a7f2e7583$export$2e2bcd8739ae039 = (0, $3yRq4.default)(/*#__PURE__*/ $Fo7oF.createElement("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');



var $8Hh6N = parcelRequire("8Hh6N");

var $Fo7oF = parcelRequire("Fo7oF");

var $3yRq4 = parcelRequire("3yRq4");
var /**
 * @ignore - internal component.
 */ $af17036c62fbf1c0$export$2e2bcd8739ae039 = (0, $3yRq4.default)(/*#__PURE__*/ $Fo7oF.createElement("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');



var $bT5dp = parcelRequire("bT5dp");

var $5rVgt = parcelRequire("5rVgt");
var $20f0c6d4e6c1d2d6$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            color: theme.palette.text.secondary
        },
        /* Pseudo-class applied to the root element if `checked={true}`. */ checked: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `indeterminate={true}`. */ indeterminate: {},
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            '&$checked': {
                color: theme.palette.primary.main,
                '&:hover': {
                    backgroundColor: (0, $8Hh6N.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            '&$checked': {
                color: theme.palette.secondary.main,
                '&:hover': {
                    backgroundColor: (0, $8Hh6N.alpha)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        }
    };
};
var $20f0c6d4e6c1d2d6$var$defaultCheckedIcon = /*#__PURE__*/ $Fo7oF.createElement((0, $ad9a505a7f2e7583$export$2e2bcd8739ae039), null);
var $20f0c6d4e6c1d2d6$var$defaultIcon = /*#__PURE__*/ $Fo7oF.createElement((0, $f47969bcd0977d3e$export$2e2bcd8739ae039), null);
var $20f0c6d4e6c1d2d6$var$defaultIndeterminateIcon = /*#__PURE__*/ $Fo7oF.createElement((0, $af17036c62fbf1c0$export$2e2bcd8739ae039), null);
var $20f0c6d4e6c1d2d6$var$Checkbox = /*#__PURE__*/ $Fo7oF.forwardRef(function Checkbox(props, ref) {
    var _props$checkedIcon = props.checkedIcon, checkedIcon = _props$checkedIcon === void 0 ? $20f0c6d4e6c1d2d6$var$defaultCheckedIcon : _props$checkedIcon, classes = props.classes, _props$color = props.color, color = _props$color === void 0 ? 'secondary' : _props$color, _props$icon = props.icon, iconProp = _props$icon === void 0 ? $20f0c6d4e6c1d2d6$var$defaultIcon : _props$icon, _props$indeterminate = props.indeterminate, indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate, _props$indeterminateI = props.indeterminateIcon, indeterminateIconProp = _props$indeterminateI === void 0 ? $20f0c6d4e6c1d2d6$var$defaultIndeterminateIcon : _props$indeterminateI, inputProps = props.inputProps, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, other = (0, $67mp8.default)(props, [
        "checkedIcon",
        "classes",
        "color",
        "icon",
        "indeterminate",
        "indeterminateIcon",
        "inputProps",
        "size"
    ]);
    var icon = indeterminate ? indeterminateIconProp : iconProp;
    var indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    return /*#__PURE__*/ $Fo7oF.createElement((0, $b46bfdb01167da1e$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        type: "checkbox",
        classes: {
            root: (0, $78z8j.default)(classes.root, classes["color".concat((0, $bT5dp.default)(color))], indeterminate && classes.indeterminate),
            checked: classes.checked,
            disabled: classes.disabled
        },
        color: color,
        inputProps: (0, $elnlQ.default)({
            'data-indeterminate': indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $Fo7oF.cloneElement(icon, {
            fontSize: icon.props.fontSize === undefined && size === "small" ? size : icon.props.fontSize
        }),
        checkedIcon: /*#__PURE__*/ $Fo7oF.cloneElement(indeterminateIcon, {
            fontSize: indeterminateIcon.props.fontSize === undefined && size === "small" ? size : indeterminateIcon.props.fontSize
        }),
        ref: ref
    }, other));
});
var $20f0c6d4e6c1d2d6$export$2e2bcd8739ae039 = (0, $5rVgt.default)($20f0c6d4e6c1d2d6$export$9dd6ff9ea0189349, {
    name: 'MuiCheckbox'
})($20f0c6d4e6c1d2d6$var$Checkbox);



var $elnlQ = parcelRequire("elnlQ");

var $67mp8 = parcelRequire("67mp8");

var $Fo7oF = parcelRequire("Fo7oF");


var $78z8j = parcelRequire("78z8j");

var $5rVgt = parcelRequire("5rVgt");


var $ee0f7cfd00f75caf$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        flex: '1 1 auto',
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    },
    /* Styles applied to the `Typography` components if primary and secondary are set. */ multiline: {
        marginTop: 6,
        marginBottom: 6
    },
    /* Styles applied to the `Typography` components if dense. */ dense: {},
    /* Styles applied to the root element if `inset={true}`. */ inset: {
        paddingLeft: 56
    },
    /* Styles applied to the primary `Typography` component. */ primary: {},
    /* Styles applied to the secondary `Typography` component. */ secondary: {}
};
var $ee0f7cfd00f75caf$var$ListItemText = /*#__PURE__*/ $Fo7oF.forwardRef(function ListItemText(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, _props$inset = props.inset, inset = _props$inset === void 0 ? false : _props$inset, primaryProp = props.primary, primaryTypographyProps = props.primaryTypographyProps, secondaryProp = props.secondary, secondaryTypographyProps = props.secondaryTypographyProps, other = (0, $67mp8.default)(props, [
        "children",
        "classes",
        "className",
        "disableTypography",
        "inset",
        "primary",
        "primaryTypographyProps",
        "secondary",
        "secondaryTypographyProps"
    ]);
    var _React$useContext = $Fo7oF.useContext((0, $e072d90b3b716aaf$export$2e2bcd8739ae039)), dense = _React$useContext.dense;
    var primary = primaryProp != null ? primaryProp : children;
    if (primary != null && primary.type !== (0, $b6511d47df71b02c$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ $Fo7oF.createElement((0, $b6511d47df71b02c$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        variant: dense ? 'body2' : 'body1',
        className: classes.primary,
        component: "span",
        display: "block"
    }, primaryTypographyProps), primary);
    var secondary = secondaryProp;
    if (secondary != null && secondary.type !== (0, $b6511d47df71b02c$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ $Fo7oF.createElement((0, $b6511d47df71b02c$export$2e2bcd8739ae039), (0, $elnlQ.default)({
        variant: "body2",
        className: classes.secondary,
        color: "textSecondary",
        display: "block"
    }, secondaryTypographyProps), secondary);
    return /*#__PURE__*/ $Fo7oF.createElement("div", (0, $elnlQ.default)({
        className: (0, $78z8j.default)(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
        ref: ref
    }, other), primary, secondary);
});
var $ee0f7cfd00f75caf$export$2e2bcd8739ae039 = (0, $5rVgt.default)($ee0f7cfd00f75caf$export$9dd6ff9ea0189349, {
    name: 'MuiListItemText'
})($ee0f7cfd00f75caf$var$ListItemText);



const $cbb5e14997b0da75$var$styles = {
    expansionHeader: {
        display: 'flex',
        padding: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        position: 'sticky',
        top: 0,
        zIndex: 2
    },
    heading: {
        display: 'block',
        fontSize: '15px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        margin: 'auto 5px',
        flex: 1,
        fontWeight: 'bold'
    },
    icons: {
        fontSize: 22,
        marginLeft: 4
    },
    links: {
        display: 'flex',
        alignItems: 'center'
    }
};
$cbb5e14997b0da75$var$styles.assign = Object.assign({}, $cbb5e14997b0da75$var$styles.heading, {
    textAlign: 'right',
    flex: 2
});
$cbb5e14997b0da75$var$styles.message = Object.assign({}, $cbb5e14997b0da75$var$styles.heading, {
    flex: 2
});
const $cbb5e14997b0da75$var$ITEM_HEIGHT = 48;
const $cbb5e14997b0da75$var$ITEM_PADDING_TOP = 8;
const $cbb5e14997b0da75$var$MenuProps = {
    PaperProps: {
        style: {
            maxHeight: $cbb5e14997b0da75$var$ITEM_HEIGHT * 4.5 + $cbb5e14997b0da75$var$ITEM_PADDING_TOP,
            width: 250
        }
    }
};
class $cbb5e14997b0da75$export$a54ec244c8863715 extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    constructor(props){
        super(props);
        const url = new URL(location.href);
        this.state = {
            users: [],
            countries: [],
            asmNames: [],
            daemonData: [],
            dealerNames: [],
            startDate: url.searchParams.get('startDate') || null,
            endDate: url.searchParams.get('endDate') || null,
            status: url.searchParams.get('status') ? [
                url.searchParams.get('status')
            ] : [],
            statusID: url.searchParams.get('statusID') || '',
            icsID: url.searchParams.get('icsID') || '',
            assignedTo: url.searchParams.get('assignedTo') || '',
            quoteNumber: url.searchParams.get('quoteNumber') || '',
            bundleNumber: url.searchParams.get('bundleNumber') || '',
            countryCodes: url.searchParams.get('countryCodes') || '',
            resubmitted: url.searchParams.get('resubmitted') || '',
            dealerRef: url.searchParams.get('alfaDealerIdentifier') || '',
            asm: url.searchParams.get('asm') || '',
            dealer: url.searchParams.get('dealer') || '',
            sort: url.searchParams.get('sort') || '',
            direction: url.searchParams.get('direction') || '',
            numberOfPages: 0,
            currentPage: (Number(url.searchParams.get('page')) || 1) - 1,
            expanded: url.searchParams.get('expanded'),
            salespeople: [],
            salesPerson: url.searchParams.get('salesPerson') || ''
        };
        if (this.state.startDate) this.state.startDate = (0, $f71cfd9f27b06d6b$export$2e2bcd8739ae039)(this.state.startDate, 'yyyy/MM/dd', new Date());
        if (this.state.endDate) this.state.endDate = (0, $f71cfd9f27b06d6b$export$2e2bcd8739ae039)(this.state.endDate, 'yyyy/MM/dd', new Date());
        this.handleChange = this.handleChange.bind(this);
        this.search = this.search.bind(this);
        this.clear = this.clear.bind(this);
        this.onExpanded = this.onExpanded.bind(this);
        this.expanded = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).createRef();
    }
    async componentDidMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($ebc81e85cd9d0f88$exports))).record({
            forms: true,
            numbers: true,
            emails: false
        });
        await this.search(this.state.currentPage);
        this.setState({
            loading: true
        });
        try {
            const promises = [];
            promises.push((0, $1982a4c5f4dd80b7$export$69d4516a6fd8e701).user.then(async (user)=>{
                const users = await (0, $c04283212adf4fb0$export$60ad299e2e6f36fe)('/api/users', {
                    query: {
                        countries: user.countries.map(({ id: id })=>id.countryCode),
                        roles: [
                            'ASSIGN',
                            'ADMIN'
                        ],
                        sort: 'firstName,asc'
                    }
                });
                return [
                    user,
                    users
                ];
            }));
            promises.push((0, $c04283212adf4fb0$export$60ad299e2e6f36fe)('/api/countries', {
                cacheDuration: 'forever'
            }));
            promises.push((0, $b0afd96bc54a6957$export$3e14b51c9a9c5a1a).friendlyProposalStatusesList);
            const [[user, users], countries, statuses] = await Promise.all(promises);
            const npromises = [];
            let countriesOfUser = '';
            user.countries.forEach(({ id: id })=>countriesOfUser = countriesOfUser + id.countryCode + ',');
            npromises.push((0, $c04283212adf4fb0$export$60ad299e2e6f36fe)('/api/dealers?country=' + countriesOfUser, {
                cacheDuration: 'forever'
            }));
            npromises.push((0, $c04283212adf4fb0$export$60ad299e2e6f36fe)('/api/asms?country=' + countriesOfUser, {
                cacheDuration: 'forever'
            }));
            let cntries = '';
            user.countries.map((u)=>{
                cntries = cntries + u.id.countryCode + ':';
            });
            npromises.push((0, $c04283212adf4fb0$export$60ad299e2e6f36fe)('/api/salespeople/' + cntries, {
                cacheDuration: 'forever'
            }));
            const [dealerNames, asmNames, salesPeople] = await Promise.all(npromises);
            const proposalLoader = await (0, $c04283212adf4fb0$export$60ad299e2e6f36fe)('/api/daemon', {
                cacheDuration: 'forever'
            });
            this.setState({
                user: user,
                users: users,
                countries: countries && Object.entries(countries).filter(([code])=>{
                    return !!user.countries.find(({ id: id })=>id.countryCode === code);
                }).map(([code, name])=>({
                        value: code,
                        label: name
                    })),
                statuses: statuses,
                asmNames: asmNames,
                salespeople: salesPeople,
                daemonData: proposalLoader,
                dealerNames: dealerNames
            });
        } finally{
            this.setState({
                loading: false
            });
        }
        if (this.expanded.current) this.expanded.current.scrollTo();
    }
    handleChange(name) {
        return (e)=>{
            this.setState({
                [name]: e.target.value
            });
        };
    }
    onExpanded(quoteNumber) {
        return (event, isExpanded)=>{
            const url = new URL(location.href);
            if (isExpanded) {
                url.searchParams.set('expanded', quoteNumber);
                this.setState({
                    expanded: quoteNumber
                });
            } else {
                url.searchParams.delete('expanded');
                this.setState({
                    expanded: false
                });
            }
            history.pushState(null, `Page (${this.state.currentPage}/${this.state.numberOfPages}) \u{2022} FC Utilities`, url.toString());
        };
    }
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
            children: [
                this.state.daemonData.map((data)=>/*#__PURE__*/ (0, $eFTP6.jsxs)("span", {
                        display: "inline",
                        style: {
                            marginBottom: 3
                        },
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $88209bc93a38e520$export$2e2bcd8739ae039), {
                                color: "primary",
                                display: "inline",
                                label: 'Proposal Daemon ' + data.country + ': ' + data.proposalDaemonDate,
                                size: "small",
                                style: {
                                    marginLeft: 3
                                },
                                variant: "outlined"
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $88209bc93a38e520$export$2e2bcd8739ae039), {
                                color: "primary",
                                display: "inline",
                                label: 'TP Daemon ' + data.country + ': ' + data.thirdPartyDaemonDate,
                                size: "small",
                                style: {
                                    marginLeft: 3
                                },
                                variant: "outlined"
                            })
                        ]
                    }, 'daemon-' + (0, $ce7657dc4dcb9e28$export$a47fb462a08de82f)())),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                    style: {
                        marginBottom: 10,
                        marginTop: 5
                    },
                    variant: "h5",
                    children: "Proposal Search"
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c140a9ec31059532$export$2e2bcd8739ae039), {
                    style: {
                        marginBottom: 20
                    },
                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $5925addb94d391de$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                            container: true,
                            direction: "row",
                            item: true,
                            spacing: 2,
                            style: {
                                marginLeft: '2%'
                            },
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    alignItems: "flex-start",
                                    container: true,
                                    direction: "column",
                                    item: true,
                                    justifyContent: "space-between",
                                    sm: 3,
                                    xs: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                            style: {
                                                fontWeight: 'bold'
                                            },
                                            children: "Bundle"
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $3a4ed32c219a2dd3$export$2e2bcd8739ae039), {
                                            id: "bundle-number",
                                            margin: "none",
                                            onChange: this.handleChange('bundleNumber'),
                                            placeholder: "B000123",
                                            value: this.state.bundleNumber
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    alignItems: "flex-start",
                                    container: true,
                                    direction: "column",
                                    item: true,
                                    justifyContent: "space-between",
                                    sm: 3,
                                    xs: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                            style: {
                                                fontWeight: 'bold'
                                            },
                                            children: "Quote"
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $3a4ed32c219a2dd3$export$2e2bcd8739ae039), {
                                            id: "quote-number",
                                            margin: "none",
                                            onChange: this.handleChange('quoteNumber'),
                                            placeholder: "AALF001234",
                                            value: this.state.quoteNumber
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    alignItems: "flex-start",
                                    container: true,
                                    direction: "column",
                                    item: true,
                                    justifyContent: "space-between",
                                    sm: 3,
                                    xs: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                            style: {
                                                fontWeight: 'bold'
                                            },
                                            children: "ICS ID"
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $3a4ed32c219a2dd3$export$2e2bcd8739ae039), {
                                            id: "ics-id",
                                            margin: "none",
                                            onChange: this.handleChange('icsID'),
                                            placeholder: "146282",
                                            value: this.state.icsID
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    alignItems: "flex-start",
                                    container: true,
                                    direction: "column",
                                    item: true,
                                    justifyContent: "space-between",
                                    sm: 3,
                                    xs: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                            style: {
                                                fontWeight: 'bold'
                                            },
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $96006197b33869f9$export$2e2bcd8739ae039), {
                                            MenuProps: $cbb5e14997b0da75$var$MenuProps,
                                            input: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $38f814057e5cea08$export$2e2bcd8739ae039), {}),
                                            inputProps: {
                                                name: 'status',
                                                id: 'status'
                                            },
                                            multiple: true,
                                            onChange: this.handleChange('status'),
                                            renderValue: (selected)=>selected.join(', '),
                                            style: {
                                                minWidth: 195
                                            },
                                            value: this.state.status,
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                    value: "Open",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $20f0c6d4e6c1d2d6$export$2e2bcd8739ae039), {
                                                            checked: this.state.status.indexOf('Open') > -1,
                                                            style: {
                                                                color: '#25561e'
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $ee0f7cfd00f75caf$export$2e2bcd8739ae039), {
                                                            primary: "Open"
                                                        })
                                                    ]
                                                }, "Open"),
                                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                    value: "In Progress",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $20f0c6d4e6c1d2d6$export$2e2bcd8739ae039), {
                                                            checked: this.state.status.indexOf('In Progress') > -1,
                                                            style: {
                                                                color: '#25561e'
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $ee0f7cfd00f75caf$export$2e2bcd8739ae039), {
                                                            primary: "In Progress"
                                                        })
                                                    ]
                                                }, "In Progress"),
                                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                    value: "Closed",
                                                    children: [
                                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $20f0c6d4e6c1d2d6$export$2e2bcd8739ae039), {
                                                            checked: this.state.status.indexOf('Closed') > -1,
                                                            style: {
                                                                color: '#25561e'
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $ee0f7cfd00f75caf$export$2e2bcd8739ae039), {
                                                            primary: "Closed"
                                                        })
                                                    ]
                                                }, "Closed")
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $3e8620cba75a223b$export$3a1a48c8f6ef640e), {
                                    utils: (0, $dd12c932fd8737b5$export$2e2bcd8739ae039),
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            alignItems: "flex-start",
                                            container: true,
                                            direction: "column",
                                            item: true,
                                            justifyContent: "space-between",
                                            sm: 3,
                                            xs: 6,
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                                    style: {
                                                        fontWeight: 'bold'
                                                    },
                                                    children: "Start Date"
                                                }),
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $dc5e91e41ff588fc$export$d8c44f501031ee7c), {
                                                    KeyboardButtonProps: {
                                                        'aria-label': 'change date'
                                                    },
                                                    autoOk: true,
                                                    disableFuture: true,
                                                    disableToolbar: true,
                                                    format: "yyyy/MM/dd",
                                                    id: "start-date",
                                                    maxDate: this.state.endDate,
                                                    onChange: (value)=>this.setState({
                                                            startDate: value
                                                        }),
                                                    required: false,
                                                    style: {
                                                        maxWidth: 195
                                                    },
                                                    value: this.state.startDate,
                                                    variant: "inline"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                            alignItems: "flex-start",
                                            container: true,
                                            direction: "column",
                                            item: true,
                                            justifyContent: "space-between",
                                            sm: 3,
                                            xs: 6,
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                                    style: {
                                                        fontWeight: 'bold'
                                                    },
                                                    children: "End Date"
                                                }),
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $dc5e91e41ff588fc$export$d8c44f501031ee7c), {
                                                    KeyboardButtonProps: {
                                                        'aria-label': 'change date'
                                                    },
                                                    autoOk: true,
                                                    disableFuture: true,
                                                    disableToolbar: true,
                                                    format: "yyyy/MM/dd",
                                                    id: "end-date",
                                                    minDate: this.state.startDate,
                                                    onChange: (value)=>this.setState({
                                                            endDate: value
                                                        }),
                                                    required: false,
                                                    style: {
                                                        maxWidth: 195
                                                    },
                                                    value: this.state.endDate,
                                                    variant: "inline"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    alignItems: "flex-start",
                                    container: true,
                                    direction: "column",
                                    item: true,
                                    justifyContent: "space-between",
                                    sm: 3,
                                    xs: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                            style: {
                                                fontWeight: 'bold'
                                            },
                                            children: "Resubmitted"
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $96006197b33869f9$export$2e2bcd8739ae039), {
                                            inputProps: {
                                                name: 'resubmitted',
                                                id: 'resubmitted'
                                            },
                                            onChange: this.handleChange('resubmitted'),
                                            style: {
                                                minWidth: 195
                                            },
                                            value: this.state.resubmitted,
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                    value: "",
                                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)("em", {
                                                        children: "None"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                    value: true,
                                                    children: "Yes"
                                                }),
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                    value: false,
                                                    children: "No"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    alignItems: "flex-start",
                                    container: true,
                                    direction: "column",
                                    item: true,
                                    justifyContent: "space-between",
                                    sm: 3,
                                    xs: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                            style: {
                                                fontWeight: 'bold'
                                            },
                                            children: "Assigned"
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $96006197b33869f9$export$2e2bcd8739ae039), {
                                            disabled: this.state.loading,
                                            inputProps: {
                                                name: 'assigned-user',
                                                id: 'assigned-user'
                                            },
                                            onChange: this.handleChange('assignedTo'),
                                            style: {
                                                minWidth: 195
                                            },
                                            value: this.state.assignedTo,
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                    value: "",
                                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)("em", {
                                                        children: "None"
                                                    })
                                                }),
                                                this.state.users && this.state.users.map((user)=>/*#__PURE__*/ (0, $eFTP6.jsxs)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                        value: user.id,
                                                        children: [
                                                            user.firstName,
                                                            " ",
                                                            user.lastName
                                                        ]
                                                    }, user.id))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    alignItems: "flex-start",
                                    container: true,
                                    direction: "column",
                                    item: true,
                                    justifyContent: "space-between",
                                    sm: 3,
                                    xs: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                            style: {
                                                fontWeight: 'bold'
                                            },
                                            children: "Message"
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $96006197b33869f9$export$2e2bcd8739ae039), {
                                            disabled: this.state.loading,
                                            inputProps: {
                                                name: 'status-id',
                                                id: 'status-id'
                                            },
                                            onChange: this.handleChange('statusID'),
                                            style: {
                                                minWidth: 195
                                            },
                                            value: this.state.statusID,
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                    value: "",
                                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)("em", {
                                                        children: "None"
                                                    })
                                                }),
                                                this.state.statuses && this.state.statuses.map(({ label: label, value: value })=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                        value: value,
                                                        children: label
                                                    }, value))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    alignItems: "flex-start",
                                    container: true,
                                    direction: "column",
                                    item: true,
                                    justifyContent: "space-between",
                                    sm: 3,
                                    xs: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                            style: {
                                                fontWeight: 'bold'
                                            },
                                            children: "Dealer"
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $96006197b33869f9$export$2e2bcd8739ae039), {
                                            disabled: this.state.loading,
                                            inputProps: {
                                                name: 'dealer',
                                                id: 'dealer'
                                            },
                                            onChange: this.handleChange('dealer'),
                                            style: {
                                                minWidth: 195
                                            },
                                            value: this.state.dealer,
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                    value: "",
                                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)("em", {
                                                        children: "None"
                                                    })
                                                }),
                                                this.state.dealerNames && this.state.dealerNames.map((value)=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                        value: value,
                                                        children: value
                                                    }, value))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    alignItems: "flex-start",
                                    container: true,
                                    direction: "column",
                                    item: true,
                                    justifyContent: "space-between",
                                    sm: 3,
                                    xs: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                            style: {
                                                fontWeight: 'bold'
                                            },
                                            children: "ASM"
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $96006197b33869f9$export$2e2bcd8739ae039), {
                                            disabled: this.state.loading,
                                            inputProps: {
                                                name: 'asm',
                                                id: 'asm'
                                            },
                                            onChange: this.handleChange('asm'),
                                            style: {
                                                minWidth: 195
                                            },
                                            value: this.state.asm,
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                    value: "",
                                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)("em", {
                                                        children: "None"
                                                    })
                                                }),
                                                this.state.asmNames && this.state.asmNames.map((value)=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                        value: value,
                                                        children: value
                                                    }, value))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    alignItems: "flex-start",
                                    container: true,
                                    direction: "column",
                                    item: true,
                                    justifyContent: "space-between",
                                    sm: 3,
                                    xs: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                            style: {
                                                fontWeight: 'bold'
                                            },
                                            children: "Sales Person"
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $96006197b33869f9$export$2e2bcd8739ae039), {
                                            disabled: this.state.loading,
                                            inputProps: {
                                                name: 'salesPerson',
                                                id: 'salesPerson'
                                            },
                                            onChange: this.handleChange('salesPerson'),
                                            style: {
                                                minWidth: 195
                                            },
                                            value: this.state.salesPerson,
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                    value: "",
                                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)("em", {
                                                        children: "None"
                                                    })
                                                }),
                                                this.state.salespeople && this.state.salespeople.map((value)=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                        value: value,
                                                        children: value
                                                    }, value))
                                            ]
                                        })
                                    ]
                                }),
                                this.state.countries && this.state.countries.length > 1 && /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    alignItems: "flex-start",
                                    container: true,
                                    direction: "column",
                                    item: true,
                                    justifyContent: "space-between",
                                    sm: 3,
                                    xs: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                            style: {
                                                fontWeight: 'bold'
                                            },
                                            children: "Country"
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $96006197b33869f9$export$2e2bcd8739ae039), {
                                            disabled: this.state.loading,
                                            inputProps: {
                                                name: 'country-code',
                                                id: 'country-code'
                                            },
                                            onChange: this.handleChange('countryCodes'),
                                            style: {
                                                minWidth: 195
                                            },
                                            value: this.state.countryCodes,
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                    value: "",
                                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)("em", {
                                                        children: "None"
                                                    })
                                                }),
                                                this.state.countries && this.state.countries.map(({ value: value, label: label })=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                        value: value,
                                                        children: label || value
                                                    }, value))
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                    alignItems: "center",
                    container: true,
                    direction: "row",
                    justifyContent: "flex-end",
                    style: {
                        marginBottom: 20
                    },
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                            style: {
                                flex: 1
                            }
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                            disabled: this.state.loading || !this.hasSearchParameters(),
                            onClick: this.clear,
                            style: {
                                marginLeft: 10
                            },
                            variant: "contained",
                            children: "Clear"
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                            style: {
                                position: 'relative',
                                marginLeft: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                                    color: "primary",
                                    disabled: this.state.loading,
                                    onClick: ()=>this.search(0, true),
                                    variant: "contained",
                                    children: "Search"
                                }),
                                this.state.loading && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $75157c5b2ba08cec$export$2e2bcd8739ae039), {
                                    disableShrink: true,
                                    size: 24,
                                    style: {
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: -12,
                                        marginLeft: -12
                                    }
                                })
                            ]
                        })
                    ]
                }),
                this.state.quotes && this.state.quotes.length > 0 && /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                            alignItems: "center",
                            container: true,
                            direction: "row",
                            justifyContent: "space-between",
                            spacing: 3,
                            style: {
                                marginBottom: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    item: true,
                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $8fc3093c2f160cdd$export$68f5e1453c188a82), {
                                        currentPage: this.state.currentPage,
                                        disabled: this.state.loading,
                                        numberOfPages: this.state.numberOfPages,
                                        onSelect: (page)=>this.search(page, true)
                                    })
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    item: true,
                                    children: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                        children: [
                                            "Displaying ",
                                            this.state.currentPage * this.state.pageSize + 1,
                                            " - ",
                                            this.state.currentPage * this.state.pageSize + this.state.quotesPerPage,
                                            " of ",
                                            this.state.totalNumberOfQuotes
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $fe0aa9e32766c0f5$export$2e2bcd8739ae039), {
                                    style: $cbb5e14997b0da75$var$styles.expansionHeader,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $4b2001da75bd50eb$export$267aa617be7ee4b6), {
                                            activeSort: this.state.sort,
                                            direction: this.state.direction,
                                            onSort: (sort, direction)=>{
                                                this.setState({
                                                    sort: sort,
                                                    direction: direction
                                                }, ()=>this.search(null, true));
                                            },
                                            sort: "bundleNumber",
                                            children: "Bundle"
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $4b2001da75bd50eb$export$267aa617be7ee4b6), {
                                            activeSort: this.state.sort,
                                            direction: this.state.direction,
                                            onSort: (sort, direction)=>{
                                                this.setState({
                                                    sort: sort,
                                                    direction: direction
                                                }, ()=>this.search(null, true));
                                            },
                                            sort: "quoteNumber",
                                            children: "Quote"
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $4b2001da75bd50eb$export$267aa617be7ee4b6), {
                                            activeSort: this.state.sort,
                                            direction: this.state.direction,
                                            onSort: (sort, direction)=>{
                                                this.setState({
                                                    sort: sort,
                                                    direction: direction
                                                }, ()=>this.search(null, true));
                                            },
                                            sort: "countryCodes",
                                            children: "Country"
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $4b2001da75bd50eb$export$267aa617be7ee4b6), {
                                            activeSort: this.state.sort,
                                            direction: this.state.direction,
                                            onSort: (sort, direction)=>{
                                                this.setState({
                                                    sort: sort,
                                                    direction: direction
                                                }, ()=>this.search(null, true));
                                            },
                                            sort: "status",
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $4b2001da75bd50eb$export$267aa617be7ee4b6), {
                                            activeSort: this.state.sort,
                                            direction: this.state.direction,
                                            onSort: (sort, direction)=>{
                                                this.setState({
                                                    sort: sort,
                                                    direction: direction
                                                }, ()=>this.search(null, true));
                                            },
                                            sort: "createdDate",
                                            children: "Submit Date"
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $4b2001da75bd50eb$export$267aa617be7ee4b6), {
                                            activeSort: this.state.sort,
                                            direction: this.state.direction,
                                            onSort: (sort, direction)=>{
                                                this.setState({
                                                    sort: sort,
                                                    direction: direction
                                                }, ()=>this.search(null, true));
                                            },
                                            sort: "assignment.userID",
                                            children: "Assigned User"
                                        }),
                                        [
                                            'ASSIGN',
                                            'ADMIN'
                                        ].includes((0, $1982a4c5f4dd80b7$export$69d4516a6fd8e701).role) && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $4b2001da75bd50eb$export$267aa617be7ee4b6), {
                                            disabled: true,
                                            style: {
                                                flex: 2,
                                                textAlign: 'right'
                                            },
                                            children: "Assign To"
                                        })
                                    ]
                                }),
                                this.state.quotes.map((quote, index)=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $35948da05df5a10d$export$3df558dab54b2ef0), {
                                        expanded: this.state.expanded === quote.quoteNumber,
                                        id: quote.quoteNumber,
                                        onChange: (quote)=>{
                                            this.setState((prevState)=>({
                                                    quotes: prevState.quotes.map((existingQuote, quoteIndex)=>quoteIndex === index ? quote : existingQuote)
                                                }));
                                        },
                                        onExpanded: this.onExpanded(quote.quoteNumber),
                                        quote: quote,
                                        ref: this.state.expanded === quote.quoteNumber ? this.expanded : null
                                    }, quote.quoteNumber))
                            ]
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                            alignItems: "center",
                            container: true,
                            direction: "row",
                            justifyContent: "space-between",
                            spacing: 3,
                            style: {
                                marginBottom: 10
                            },
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    item: true,
                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $8fc3093c2f160cdd$export$68f5e1453c188a82), {
                                        currentPage: this.state.currentPage,
                                        disabled: this.state.loading,
                                        numberOfPages: this.state.numberOfPages,
                                        onSelect: (page)=>this.search(page, true)
                                    })
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                    item: true,
                                    children: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                                        children: [
                                            "Displaying ",
                                            this.state.currentPage * this.state.pageSize + 1,
                                            " - ",
                                            this.state.currentPage * this.state.pageSize + this.state.quotesPerPage,
                                            " of ",
                                            this.state.totalNumberOfQuotes
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    hasSearchParameters() {
        return !!this.state.quoteNumber || !!this.state.bundleNumber || !!this.state.countryCodes || !!this.state.resubmitted || !!this.state.assignedTo || !!this.state.icsID || !!this.state.statusID || !!this.state.status || !!this.state.startDate || !!this.state.endDate || !!this.state.dealerRef || !!this.state.sort || !!this.state.salesPerson || !!this.state.direction;
    }
    clear() {
        this.setState({
            startDate: null,
            endDate: null,
            status: [],
            statusID: '',
            icsID: '',
            assignedTo: '',
            quoteNumber: '',
            bundleNumber: '',
            dealerRef: '',
            countryCodes: '',
            resubmitted: '',
            sort: '',
            direction: '',
            salesPerson: ''
        });
    }
    async search(page, reflect) {
        if ([
            undefined,
            null
        ].includes(page)) page = this.state.currentPage;
        page = Math.max(0, page);
        this.setState({
            error: null,
            loading: true
        });
        try {
            const quotesPage = await (0, $c04283212adf4fb0$export$c4b7edec3f76b207)('/api/quotes', {
                query: {
                    startDate: this.state.startDate,
                    endDate: this.state.endDate,
                    assignedTo: this.state.assignedTo,
                    statusID: this.state.statusID,
                    status: this.state.status,
                    icsID: this.state.icsID,
                    bundleNumber: this.state.bundleNumber,
                    quoteNumber: this.state.quoteNumber,
                    dealerRef: this.state.dealerRef,
                    countryCodes: this.state.countryCodes,
                    salesPerson: this.state.salesPerson,
                    resubmitted: this.state.resubmitted,
                    asm: this.state.asm,
                    dealer: this.state.dealer,
                    size: 100,
                    page: page,
                    sort: this.state.sort ? `${this.state.sort},${this.state.direction}` : null
                }
            });
            if (quotesPage.totalPages !== 0 && page >= quotesPage.totalPages) await this.search(0, true);
            else {
                this.setState({
                    totalNumberOfQuotes: quotesPage.totalItemCount,
                    pageSize: quotesPage.pageSize,
                    quotesPerPage: quotesPage.itemCount,
                    quotes: quotesPage.content,
                    numberOfPages: quotesPage.pageCount,
                    currentPage: quotesPage.page
                });
                const url = new URL(location.href);
                url.searchParams.forEach((_, key)=>url.searchParams.delete(key));
                if (this.state.startDate) url.searchParams.set('startDate', (0, $2644bf2d885f615e$export$2e2bcd8739ae039)(this.state.startDate, 'yyyy/MM/dd'));
                if (this.state.endDate) url.searchParams.set('endDate', (0, $2644bf2d885f615e$export$2e2bcd8739ae039)(this.state.endDate, 'yyyy/MM/dd'));
                if (this.state.assignedTo) url.searchParams.set('assignedTo', this.state.assignedTo);
                if (this.state.status) url.searchParams.set('status', this.state.status);
                if (this.state.statusID) url.searchParams.set('statusID', this.state.statusID);
                if (this.state.icsID) url.searchParams.set('icsID', this.state.icsID);
                if (this.state.bundleNumber) url.searchParams.set('bundleNumber', this.state.bundleNumber);
                if (this.state.quoteNumber) url.searchParams.set('quoteNumber', this.state.quoteNumber);
                if (this.state.countryCodes) url.searchParams.set('countryCodes', this.state.countryCodes);
                if (this.state.salesPerson) url.searchParams.set('salesPerson', this.state.salesPerson);
                if (this.state.resubmitted) url.searchParams.set('resubmitted', this.state.resubmitted);
                if (this.state.sort) url.searchParams.set('sort', this.state.sort);
                if (this.state.direction) url.searchParams.set('direction', this.state.direction);
                if (quotesPage.page) url.searchParams.set('page', quotesPage.page + 1);
                if (reflect) history.pushState(null, `Page (${quotesPage.page}/${quotesPage.pageCount}) \u{2022} FC Utilities`, url.toString());
            }
        } catch (error) {
            this.setState({
                error: error
            });
        } finally{
            this.setState({
                loading: false
            });
        }
    }
}



var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");


var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");


var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");



var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");

const $4996ea9768088579$export$8a87ed39d92bbc1b = ({ label: label, value: value })=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Col), {
        children: /*#__PURE__*/ (0, $eFTP6.jsxs)("dl", {
            className: "uxf-dl uxf-dl-vertical mb-0",
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)("dt", {
                    children: label
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)("dd", {
                    "data-sl": "mask",
                    children: value
                })
            ]
        })
    });
var $4996ea9768088579$export$2e2bcd8739ae039 = $4996ea9768088579$export$8a87ed39d92bbc1b;




var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");






var $d2bgE = parcelRequire("d2bgE");
const $14908054240799af$var$DocumentRow = ({ countryCode: countryCode, documentName: documentName, documentCode: documentCode, documentSigners: documentSigners, financeProduct: financeProduct, quoteNumber: quoteNumber, getSelected: getSelected })=>{
    const [downloading, setDownloading] = (0, $Fo7oF.useState)(false);
    const [downloadError, setDownloadError] = (0, $Fo7oF.useState)(false);
    async function downloadPdfFile() {
        setDownloading(true);
        setDownloadError(false);
        try {
            const pdfDocData = await (0, $c04283212adf4fb0$export$c4b7edec3f76b207)(`/api/quotes/documents/${quoteNumber}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify({
                    'code': documentCode,
                    'country': countryCode,
                    'description': documentName,
                    'financeProduct': financeProduct
                })
            });
            const pdfText = 'data:application/pdf;base64,' + pdfDocData.dataHandler;
            const link = document.createElement('a');
            document.body.appendChild(link);
            link.href = pdfText;
            link.download = pdfDocData.filename;
            link.click();
            link.remove();
        } catch (err) {
            setDownloadError(true);
        } finally{
            setDownloading(false);
        }
    }
    function handleChange(e) {
        getSelected(e.target.checked, documentCode, documentName, documentSigners);
    }
    return /*#__PURE__*/ (0, $eFTP6.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0, $eFTP6.jsx)("td", {
                className: "text-center",
                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Checkbox), {
                    id: 'checkbox-' + documentCode,
                    onChange: (e)=>handleChange(e)
                })
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)("td", {
                children: documentName
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)("td", {
                className: "text-center",
                children: downloading ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f4267c9105e002e8$export$fe708d541030d854), {
                    size: "sm"
                }) : /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                            onClick: ()=>downloadPdfFile(),
                            size: "small",
                            style: {
                                margin: 'auto'
                            },
                            title: "Download",
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a88484a22110b9b6$exports))), {})
                        }),
                        downloadError && /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                            className: "text-danger font-weight-normal",
                            style: {
                                fontSize: '12px'
                            },
                            children: "Unable to download."
                        })
                    ]
                })
            })
        ]
    });
};
$14908054240799af$var$DocumentRow.propTypes = {
    countryCode: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    documentName: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    documentCode: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    documentSigners: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string),
    financeProduct: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    quoteNumber: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    getSelected: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func
};
var $14908054240799af$export$2e2bcd8739ae039 = $14908054240799af$var$DocumentRow;







var $d2bgE = parcelRequire("d2bgE");

var $eFTP6 = parcelRequire("eFTP6");


parcelRequire("Fo7oF");
const $051c4777ecf8ecff$export$2247bbc5887beda7 = (countryCode, financeProduct)=>{
    if (countryCode === 'DE') return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
        id: (0, $fff13ca3fea305fa$export$445324ddcea400ab)[financeProduct]
    });
    return financeProduct;
};
const $051c4777ecf8ecff$export$4b14101412abd9cf = (signersInfo, suppressEmailMobileValidation, setDuplicateEmailMobileErrorState, setDuplicateEmailMobileErrorState2)=>{
    if (signersInfo.length > 0) {
        const duplicateEmailMobileNoSigners = new Set();
        const tempDuplicateEmailMobileArray = [];
        signersInfo.forEach((signer)=>{
            for(let i = signersInfo.indexOf(signer); i < signersInfo.length; i++)if (i !== signersInfo.indexOf(signer)) {
                const isDuplicateEmailMobileNo = !suppressEmailMobileValidation && signer.name.toLowerCase() !== signersInfo[i].name.toLowerCase() && (signer.emailID && signersInfo[i].emailID && signer.emailID.toLowerCase() === signersInfo[i].emailID.toLowerCase() || signer.phoneNumber === signersInfo[i].phoneNumber);
                if (isDuplicateEmailMobileNo) duplicateEmailMobileNoSigners.add(signer.tpNumber + '_' + signersInfo[i].tpNumber);
                else duplicateEmailMobileNoSigners.delete(signer.tpNumber + '_' + signersInfo[i].tpNumber);
            }
        });
        duplicateEmailMobileNoSigners.forEach((sign)=>tempDuplicateEmailMobileArray.push(...sign.split('_')));
        setDuplicateEmailMobileErrorState(duplicateEmailMobileNoSigners, tempDuplicateEmailMobileArray);
    } else if (signersInfo.length === 0) setDuplicateEmailMobileErrorState2();
};
const $051c4777ecf8ecff$export$1f4c20e4792e1672 = (signersInfo, setDuplicateSignersErrorState, setDuplicateSignersErrorState2)=>{
    if (signersInfo.length > 0) {
        const duplicateSigners = new Set();
        const tempDuplicateSignersArray = [];
        signersInfo.forEach((signer)=>{
            for(let i = signersInfo.indexOf(signer); i < signersInfo.length; i++)if (i !== signersInfo.indexOf(signer)) {
                const isDuplicate = signer.name.toLowerCase() === signersInfo[i].name.toLowerCase() && signer.emailID && signersInfo[i].emailID && signer.emailID.toLowerCase() === signersInfo[i].emailID.toLowerCase() && signer.phoneNumber === signersInfo[i].phoneNumber && signer.signingOrder === signersInfo[i].signingOrder;
                if (isDuplicate) {
                    if (signer.signingMethod !== signersInfo[i].signingMethod) duplicateSigners.add(signer.tpNumber + '_' + signersInfo[i].tpNumber);
                    else if (signer.signingMethod === signersInfo[i].signingMethod) duplicateSigners.delete(signer.tpNumber + '_' + signersInfo[i].tpNumber);
                } else duplicateSigners.delete(signer.tpNumber + '_' + signersInfo[i].tpNumber);
            }
        });
        duplicateSigners.forEach((sign)=>tempDuplicateSignersArray.push(...sign.split('_')));
        setDuplicateSignersErrorState(duplicateSigners, tempDuplicateSignersArray);
    } else if (signersInfo.length === 0) setDuplicateSignersErrorState2();
};


function $d300b6c6d840a36e$var$_defineProperty(e, r, t) {
    return (r = $d300b6c6d840a36e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d300b6c6d840a36e$var$_toPropertyKey(t) {
    var i = $d300b6c6d840a36e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d300b6c6d840a36e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $d300b6c6d840a36e$var$styles = {
    dataTable: {
        display: 'flex',
        flexWrap: 'wrap',
        margin: '20px auto',
        width: '90%'
    },
    proposalInfo: {
        marginLeft: '5%'
    },
    spinner: {
        display: 'flex',
        flexDirection: 'column',
        width: '10rem',
        height: '10rem',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: '40%',
        marginTop: '10%'
    }
};
class $d300b6c6d840a36e$export$935614c0ecdada2e extends (0, $Fo7oF.Component) {
    constructor(...args){
        super(...args);
        $d300b6c6d840a36e$var$_defineProperty(this, "state", {
            expanded: false,
            bundleData: this.props.bundleData,
            // Bundle Data passed from Select Proposal page at click Create Envelope
            documentList: [],
            pdfData: '',
            pdfFileName: '',
            selectedDocuments: []
        });
        $d300b6c6d840a36e$var$_defineProperty(this, "getSelectedDocuments", (checked, docCode, docName, documentSigners)=>{
            this.setState((prevState)=>({
                    selectedDocuments: checked ? [
                        ...prevState.selectedDocuments,
                        {
                            code: docCode,
                            description: docName,
                            documentSigners: documentSigners
                        }
                    ] : prevState.selectedDocuments.filter((document)=>document.code !== docCode)
                }), ()=>this.props.getDocumentList(this.state.selectedDocuments));
        });
    }
    async componentDidMount() {
        const promises = [];
        promises.push((0, $c04283212adf4fb0$export$60ad299e2e6f36fe)(`/api/quotes/documents/${this.state.bundleData.quoteNumber}`, {
            cacheDuration: 'forever'
        }));
        const [documentsForQuote] = await Promise.all(promises);
        const portugalAllowedDocuments = [
            'PTCONTRA',
            'PTAF',
            'PTSBM',
            'PTWHT'
        ];
        const isPortugal = this.state.bundleData.countryCode === 'PT';
        const filteredDocuments = isPortugal ? documentsForQuote.filter((value)=>portugalAllowedDocuments.includes(value.letterClass.code)) : documentsForQuote;
        const documentsJson = [];
        filteredDocuments.map((value)=>documentsJson.push({
                isChecked: false,
                code: value.letterClass.code,
                docname: value.letterClass.description,
                signers: value.signers
            }));
        this.setState({
            documentList: documentsJson
        });
    }
    render() {
        const countryNameLabel = (0, $fff13ca3fea305fa$export$33186d4108d76629)[this.state.bundleData.countryCode].getCountryName();
        return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                    style: $d300b6c6d840a36e$var$styles.proposalInfo,
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Row), {
                            className: "d-flex mx-auto justify-content-around",
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $4996ea9768088579$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.BUNDLE'
                                    }),
                                    value: this.state.bundleData.bundleNumber
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $4996ea9768088579$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.QUOTE'
                                    }),
                                    value: this.state.bundleData.quoteNumber
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $4996ea9768088579$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.ICS_REFERENCE'
                                    }),
                                    value: this.state.bundleData.icsID ? this.state.bundleData.icsID : /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.NOT_AVAILABLE'
                                    })
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $4996ea9768088579$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.START_DATE'
                                    }),
                                    value: this.state.bundleData.startDate
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $4996ea9768088579$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.MATURITY_DATE'
                                    }),
                                    value: this.state.bundleData.maturityDate
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)("br", {}),
                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Row), {
                            className: "d-flex mx-auto justify-content-around",
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $4996ea9768088579$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.COUNTRY'
                                    }),
                                    value: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: countryNameLabel
                                    })
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $4996ea9768088579$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.QUOTE_STATUS'
                                    }),
                                    value: this.state.bundleData.alfaCaseStatus && (0, $da769170dfa840d0$export$ddd81c2d171fb653)[this.state.bundleData.alfaCaseStatus.toUpperCase()]
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $4996ea9768088579$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.PRODUCT'
                                    }),
                                    value: (0, $051c4777ecf8ecff$export$2247bbc5887beda7)(this.state.bundleData.countryCode, this.state.bundleData.financeProduct)
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $4996ea9768088579$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.PRIMARY_CUSTOMER'
                                    }),
                                    value: this.state.bundleData.primaryCustomer
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $4996ea9768088579$export$2e2bcd8739ae039), {
                                    label: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.DEALER_REFERENCE'
                                    }),
                                    value: this.state.bundleData.dealerReference
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $fe0aa9e32766c0f5$export$2e2bcd8739ae039), {
                    elevation: 0,
                    style: $d300b6c6d840a36e$var$styles.dataTable,
                    children: [
                        this.state.documentList.length === 0 ? /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                            style: $d300b6c6d840a36e$var$styles.spinner,
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f4267c9105e002e8$export$fe708d541030d854), {}),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)("p", {
                                    className: "text-sm font-italic",
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                            id: 'labels.FETCHING_DOCUMENTS_FOR'
                                        }),
                                        " ",
                                        this.state.bundleData.quoteNumber,
                                        "..."
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Table), {
                            hover: true,
                            responsive: true,
                            striped: true,
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsx)("caption", {
                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.SELECT_DOCUMENTS'
                                    })
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $eFTP6.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $eFTP6.jsx)("th", {
                                                className: "text-center",
                                                scope: "col",
                                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Checkbox), {
                                                    disabled: true,
                                                    id: "checkbox-all"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eFTP6.jsx)("th", {
                                                scope: "col",
                                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                    id: 'labels.DOCUMENT_NAME'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eFTP6.jsx)("th", {
                                                className: "text-center",
                                                scope: "col",
                                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                    id: 'labels.DOWNLOAD'
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsx)("tbody", {
                                    children: this.state.documentList.map((document)=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $14908054240799af$export$2e2bcd8739ae039), {
                                            countryCode: this.state.bundleData.countryCode,
                                            documentCode: document.code,
                                            documentName: document.docname,
                                            documentSigners: document.signers,
                                            financeProduct: this.state.bundleData.financeProduct,
                                            getSelected: this.getSelectedDocuments.bind(this),
                                            quoteNumber: this.state.bundleData.quoteNumber
                                        }, document.code))
                                })
                            ]
                        }),
                        this.state.documentList.length === 0 ? '' : /*#__PURE__*/ (0, $eFTP6.jsxs)("p", {
                            className: "text-muted",
                            children: [
                                this.state.selectedDocuments.length,
                                " ",
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                    id: 'labels.OF'
                                }),
                                ' ',
                                this.state.documentList.length,
                                " ",
                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                    id: 'labels.DOCUMENTS_SELECTED'
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
$d300b6c6d840a36e$export$935614c0ecdada2e.propTypes = {
    bundleData: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).array.isRequired,
    getDocumentList: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func.isRequired
};



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");
var $0aa55432174d8817$exports = {};

$parcel$export($0aa55432174d8817$exports, "cardContainer", () => $0aa55432174d8817$export$6b2d426110a11d7a, (v) => $0aa55432174d8817$export$6b2d426110a11d7a = v);
$parcel$export($0aa55432174d8817$exports, "cardContainerDisabled", () => $0aa55432174d8817$export$5acb294d019103df, (v) => $0aa55432174d8817$export$5acb294d019103df = v);
$parcel$export($0aa55432174d8817$exports, "cardContainerSigner", () => $0aa55432174d8817$export$42757ff4670d5f16, (v) => $0aa55432174d8817$export$42757ff4670d5f16 = v);
$parcel$export($0aa55432174d8817$exports, "cardContainerDuplicateSigner", () => $0aa55432174d8817$export$9473fb56f88e0665, (v) => $0aa55432174d8817$export$9473fb56f88e0665 = v);
$parcel$export($0aa55432174d8817$exports, "talf_id", () => $0aa55432174d8817$export$2c1cab0e8bff26, (v) => $0aa55432174d8817$export$2c1cab0e8bff26 = v);
$parcel$export($0aa55432174d8817$exports, "clr", () => $0aa55432174d8817$export$37dda02e479dd8d5, (v) => $0aa55432174d8817$export$37dda02e479dd8d5 = v);
$parcel$export($0aa55432174d8817$exports, "cardHeader", () => $0aa55432174d8817$export$b8bf98e4d70f4134, (v) => $0aa55432174d8817$export$b8bf98e4d70f4134 = v);
$parcel$export($0aa55432174d8817$exports, "signerName", () => $0aa55432174d8817$export$661231f28b6c53d4, (v) => $0aa55432174d8817$export$661231f28b6c53d4 = v);
$parcel$export($0aa55432174d8817$exports, "avatar", () => $0aa55432174d8817$export$345c5736c8054f22, (v) => $0aa55432174d8817$export$345c5736c8054f22 = v);
$parcel$export($0aa55432174d8817$exports, "signerEnabled", () => $0aa55432174d8817$export$3f067990e93d96cf, (v) => $0aa55432174d8817$export$3f067990e93d96cf = v);
$parcel$export($0aa55432174d8817$exports, "signerLabel", () => $0aa55432174d8817$export$100265c84f94d4c3, (v) => $0aa55432174d8817$export$100265c84f94d4c3 = v);
$parcel$export($0aa55432174d8817$exports, "role", () => $0aa55432174d8817$export$3100efae45e879, (v) => $0aa55432174d8817$export$3100efae45e879 = v);
$parcel$export($0aa55432174d8817$exports, "signingActions", () => $0aa55432174d8817$export$a7ab1c2edf5dc067, (v) => $0aa55432174d8817$export$a7ab1c2edf5dc067 = v);
$parcel$export($0aa55432174d8817$exports, "signOrder", () => $0aa55432174d8817$export$531fca0b4ed10da8, (v) => $0aa55432174d8817$export$531fca0b4ed10da8 = v);
$parcel$export($0aa55432174d8817$exports, "signMethod", () => $0aa55432174d8817$export$e84f2765c5ba7b66, (v) => $0aa55432174d8817$export$e84f2765c5ba7b66 = v);
$parcel$export($0aa55432174d8817$exports, "contactInfo", () => $0aa55432174d8817$export$ff6e116295a0f641, (v) => $0aa55432174d8817$export$ff6e116295a0f641 = v);
$parcel$export($0aa55432174d8817$exports, "contactInfoDisabled", () => $0aa55432174d8817$export$7f56c39c10d430f6, (v) => $0aa55432174d8817$export$7f56c39c10d430f6 = v);
$parcel$export($0aa55432174d8817$exports, "addNewSignerMain", () => $0aa55432174d8817$export$66c4907706023c3f, (v) => $0aa55432174d8817$export$66c4907706023c3f = v);
$parcel$export($0aa55432174d8817$exports, "addNewSigner", () => $0aa55432174d8817$export$2855cbebc4efb6e8, (v) => $0aa55432174d8817$export$2855cbebc4efb6e8 = v);
$parcel$export($0aa55432174d8817$exports, "thirdPartiesTab", () => $0aa55432174d8817$export$dc401ebefbe6f3c3, (v) => $0aa55432174d8817$export$dc401ebefbe6f3c3 = v);
$parcel$export($0aa55432174d8817$exports, "thirdPartyStepper", () => $0aa55432174d8817$export$2a2d95df959a6c8a, (v) => $0aa55432174d8817$export$2a2d95df959a6c8a = v);
$parcel$export($0aa55432174d8817$exports, "stepperHeader", () => $0aa55432174d8817$export$116e2b778534bfe3, (v) => $0aa55432174d8817$export$116e2b778534bfe3 = v);
$parcel$export($0aa55432174d8817$exports, "contactNumberHelperText", () => $0aa55432174d8817$export$9c821d3fe45f6dab, (v) => $0aa55432174d8817$export$9c821d3fe45f6dab = v);
$parcel$export($0aa55432174d8817$exports, "addSignerDialog", () => $0aa55432174d8817$export$9b11edf375b569f6, (v) => $0aa55432174d8817$export$9b11edf375b569f6 = v);
$parcel$export($0aa55432174d8817$exports, "signerDialogTitle", () => $0aa55432174d8817$export$be73eb4d9d86c098, (v) => $0aa55432174d8817$export$be73eb4d9d86c098 = v);
$parcel$export($0aa55432174d8817$exports, "odSignerDialogContent", () => $0aa55432174d8817$export$1e04b0c89e0f679d, (v) => $0aa55432174d8817$export$1e04b0c89e0f679d = v);
$parcel$export($0aa55432174d8817$exports, "odSignerInputLabel", () => $0aa55432174d8817$export$2b2afea73a670f83, (v) => $0aa55432174d8817$export$2b2afea73a670f83 = v);
$parcel$export($0aa55432174d8817$exports, "odSignerTop", () => $0aa55432174d8817$export$eae654cc1d6482e5, (v) => $0aa55432174d8817$export$eae654cc1d6482e5 = v);
$parcel$export($0aa55432174d8817$exports, "odSignerAvatar", () => $0aa55432174d8817$export$5956409a1e9e40da, (v) => $0aa55432174d8817$export$5956409a1e9e40da = v);
$parcel$export($0aa55432174d8817$exports, "signerRole", () => $0aa55432174d8817$export$f814a5a4f9cd0c96, (v) => $0aa55432174d8817$export$f814a5a4f9cd0c96 = v);
$parcel$export($0aa55432174d8817$exports, "signerId", () => $0aa55432174d8817$export$f3e1986bc2ecc12, (v) => $0aa55432174d8817$export$f3e1986bc2ecc12 = v);
var $0aa55432174d8817$export$6b2d426110a11d7a;
var $0aa55432174d8817$export$5acb294d019103df;
var $0aa55432174d8817$export$42757ff4670d5f16;
var $0aa55432174d8817$export$9473fb56f88e0665;
var $0aa55432174d8817$export$2c1cab0e8bff26;
var $0aa55432174d8817$export$37dda02e479dd8d5;
var $0aa55432174d8817$export$b8bf98e4d70f4134;
var $0aa55432174d8817$export$661231f28b6c53d4;
var $0aa55432174d8817$export$345c5736c8054f22;
var $0aa55432174d8817$export$3f067990e93d96cf;
var $0aa55432174d8817$export$100265c84f94d4c3;
var $0aa55432174d8817$export$3100efae45e879;
var $0aa55432174d8817$export$a7ab1c2edf5dc067;
var $0aa55432174d8817$export$531fca0b4ed10da8;
var $0aa55432174d8817$export$e84f2765c5ba7b66;
var $0aa55432174d8817$export$ff6e116295a0f641;
var $0aa55432174d8817$export$7f56c39c10d430f6;
var $0aa55432174d8817$export$66c4907706023c3f;
var $0aa55432174d8817$export$2855cbebc4efb6e8;
var $0aa55432174d8817$export$dc401ebefbe6f3c3;
var $0aa55432174d8817$export$2a2d95df959a6c8a;
var $0aa55432174d8817$export$116e2b778534bfe3;
var $0aa55432174d8817$export$9c821d3fe45f6dab;
var $0aa55432174d8817$export$9b11edf375b569f6;
var $0aa55432174d8817$export$be73eb4d9d86c098;
var $0aa55432174d8817$export$1e04b0c89e0f679d;
var $0aa55432174d8817$export$2b2afea73a670f83;
var $0aa55432174d8817$export$eae654cc1d6482e5;
var $0aa55432174d8817$export$5956409a1e9e40da;
var $0aa55432174d8817$export$f814a5a4f9cd0c96;
var $0aa55432174d8817$export$f3e1986bc2ecc12;
$0aa55432174d8817$export$6b2d426110a11d7a = "cardContainer_1a49e4";
$0aa55432174d8817$export$5acb294d019103df = "cardContainerDisabled_1a49e4";
$0aa55432174d8817$export$42757ff4670d5f16 = "cardContainerSigner_1a49e4";
$0aa55432174d8817$export$9473fb56f88e0665 = "cardContainerDuplicateSigner_1a49e4";
$0aa55432174d8817$export$2c1cab0e8bff26 = "talf_id_1a49e4";
$0aa55432174d8817$export$37dda02e479dd8d5 = "clr_1a49e4";
$0aa55432174d8817$export$b8bf98e4d70f4134 = "cardHeader_1a49e4";
$0aa55432174d8817$export$661231f28b6c53d4 = "signerName_1a49e4";
$0aa55432174d8817$export$345c5736c8054f22 = "avatar_1a49e4";
$0aa55432174d8817$export$3f067990e93d96cf = "signerEnabled_1a49e4";
$0aa55432174d8817$export$100265c84f94d4c3 = "signerLabel_1a49e4";
$0aa55432174d8817$export$3100efae45e879 = "role_1a49e4";
$0aa55432174d8817$export$a7ab1c2edf5dc067 = "signingActions_1a49e4";
$0aa55432174d8817$export$531fca0b4ed10da8 = "signOrder_1a49e4";
$0aa55432174d8817$export$e84f2765c5ba7b66 = "signMethod_1a49e4";
$0aa55432174d8817$export$ff6e116295a0f641 = "contactInfo_1a49e4";
$0aa55432174d8817$export$7f56c39c10d430f6 = "contactInfoDisabled_1a49e4";
$0aa55432174d8817$export$66c4907706023c3f = "addNewSignerMain_1a49e4";
$0aa55432174d8817$export$2855cbebc4efb6e8 = "addNewSigner_1a49e4";
$0aa55432174d8817$export$dc401ebefbe6f3c3 = "thirdPartiesTab_1a49e4";
$0aa55432174d8817$export$2a2d95df959a6c8a = "thirdPartyStepper_1a49e4";
$0aa55432174d8817$export$116e2b778534bfe3 = "stepperHeader_1a49e4";
$0aa55432174d8817$export$9c821d3fe45f6dab = "contactNumberHelperText_1a49e4";
$0aa55432174d8817$export$9b11edf375b569f6 = "addSignerDialog_1a49e4";
$0aa55432174d8817$export$be73eb4d9d86c098 = "signerDialogTitle_1a49e4";
$0aa55432174d8817$export$1e04b0c89e0f679d = "odSignerDialogContent_1a49e4";
$0aa55432174d8817$export$2b2afea73a670f83 = "odSignerInputLabel_1a49e4";
$0aa55432174d8817$export$eae654cc1d6482e5 = "odSignerTop_1a49e4";
$0aa55432174d8817$export$5956409a1e9e40da = "odSignerAvatar_1a49e4";
$0aa55432174d8817$export$f814a5a4f9cd0c96 = "signerRole_1a49e4";
$0aa55432174d8817$export$f3e1986bc2ecc12 = "signerId_1a49e4";





var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");






function $fccde1fde82fe96f$var$getSteps(signersList) {
    const OrderOne = [];
    const OrderTwo = [];
    const OrderThree = [];
    const OrderFour = [];
    const OrderFive = [];
    signersList.map((signer)=>{
        if (signer.signingOrder === 1) OrderOne.push(signer);
        else if (signer.signingOrder === 2) OrderTwo.push(signer);
        else if (signer.signingOrder === 3) OrderThree.push(signer);
        else if (signer.signingOrder === 4) OrderFour.push(signer);
        else if (signer.signingOrder === 5) OrderFive.push(signer);
    });
    return [
        OrderOne,
        OrderTwo,
        OrderThree,
        OrderFour,
        OrderFive
    ];
}
const $fccde1fde82fe96f$var$statusColours = {
    created: '#666666',
    sent: '#ffc107',
    declined: '#c21020',
    completed: '#367c2b',
    review: '#666666'
};
function $fccde1fde82fe96f$var$getSignerChip(signer) {
    return /*#__PURE__*/ (0, $eFTP6.jsxs)("span", {
        children: [
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $88209bc93a38e520$export$2e2bcd8739ae039), {
                className: "mb-1",
                label: signer.name,
                size: "medium",
                style: {
                    color: '#ffffff',
                    'backgroundColor': signer.status ? $fccde1fde82fe96f$var$statusColours[signer.status] : $fccde1fde82fe96f$var$statusColours['review']
                }
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)("br", {})
        ]
    }, 'ord-' + (0, $ce7657dc4dcb9e28$export$a47fb462a08de82f)() + (0, $ce7657dc4dcb9e28$export$a47fb462a08de82f)());
}
function $fccde1fde82fe96f$export$2e2bcd8739ae039({ signersList: signersList, bgColor: bgColor }) {
    const steps = $fccde1fde82fe96f$var$getSteps(signersList);
    return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2a2dbee2872ed1ff$export$2e2bcd8739ae039), {
        alternativeLabel: true,
        className: "mw-100 border rounded",
        style: {
            'backgroundColor': bgColor
        },
        children: steps.filter((step)=>step.length > 0).map((signers)=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $b7cae7699bf248ce$export$2e2bcd8739ae039), {
                active: true,
                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $7a09dab997ab6c9a$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f4267c9105e002e8$export$7dcc8f518762622d), {}),
                    children: signers.map((signer)=>$fccde1fde82fe96f$var$getSignerChip(signer))
                })
            }, 'sign-' + (0, $ce7657dc4dcb9e28$export$a47fb462a08de82f)() + (0, $ce7657dc4dcb9e28$export$a47fb462a08de82f)()))
    });
}



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");








var $d2bgE = parcelRequire("d2bgE");
const $6bc7f2ab5fc849a9$var$inputStyles = {
    inputEmailError: {
        borderStyle: 'solid',
        borderColor: '#c21020',
        borderRadius: '15px',
        marginBottom: '4px',
        backgroundColor: '#f8dedd'
    },
    inputEmailField: {
        border: '0px',
        borderRadius: '15px',
        marginBottom: '4px'
    },
    inputPhoneError: {
        borderStyle: 'solid',
        borderColor: '#c21020',
        borderRadius: '15px',
        backgroundColor: '#f8dedd',
        marginBottom: '0.1rem'
    },
    inputPhoneField: {
        border: '0px',
        borderRadius: '15px',
        marginBottom: '0.1rem'
    },
    inputRepresentativeError: {
        borderStyle: 'solid',
        borderColor: '#c21020',
        borderRadius: '15px',
        backgroundColor: '#f8dedd',
        marginBottom: '0.1rem'
    },
    inputRepresentativeField: {
        border: '0px',
        borderRadius: '15px',
        marginBottom: '0.1rem'
    }
};
const $6bc7f2ab5fc849a9$var$ThirdPartyInfo = ({ talf_id: talf_id, name: name, emailId: emailId, enabled: enabled, phoneNumber: phoneNumber, role: role, isDuplicate: isDuplicate, parentCallback: parentCallback, countryCode: countryCode, isDuplicateEmailMobile: isDuplicateEmailMobile })=>{
    const [enable, setEnable] = (0, $Fo7oF.useState)(true);
    const [errorPhoneNumber, setErrorPhoneNumber] = (0, $Fo7oF.useState)(false);
    const [errorEmail, setErrorEmail] = (0, $Fo7oF.useState)(false);
    const [checked, setChecked] = (0, $Fo7oF.useState)(false);
    const [signerCardCss, setSignerCardCss] = (0, $Fo7oF.useState)((0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).cardContainer);
    const intl = (0, $b637120a7f65e10c$export$2e2bcd8739ae039)();
    const isESPTAssociateRole = role === 'ASSOCIATE' && (countryCode === 'ES' || countryCode === 'PT');
    function enableOrder(talf_id, e) {
        setEnable(!e.target.checked);
        setChecked(e.target.checked);
        parentCallback({
            tpNumber: talf_id,
            signer: e.target.checked,
            role: role
        });
    }
    function handleChange(talf_id, field, value) {
        if (field === 'signingMethod') parentCallback({
            tpNumber: talf_id,
            signingMethod: value
        });
        else if (field === 'signingOrder') parentCallback({
            tpNumber: talf_id,
            signingOrder: value
        });
        else if (field === 'phoneNumber') {
            value ? setErrorPhoneNumber(false) : setErrorPhoneNumber(true);
            parentCallback({
                tpNumber: talf_id,
                phoneNumber: value
            });
        } else if (field === 'emailID') {
            value ? setErrorEmail(false) : setErrorEmail(true);
            parentCallback({
                tpNumber: talf_id,
                emailID: value
            });
        }
    }
    (0, $Fo7oF.useEffect)(()=>{
        if (checked && (isDuplicate || isDuplicateEmailMobile)) setSignerCardCss((0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).cardContainerDuplicateSigner);
        else if (checked && !isDuplicate && !isDuplicateEmailMobile) setSignerCardCss((0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).cardContainerSigner);
        else setSignerCardCss((0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).cardContainer);
    }, [
        checked,
        isDuplicate,
        isDuplicateEmailMobile
    ]);
    (0, $Fo7oF.useEffect)(()=>{
        if (isESPTAssociateRole) setSignerCardCss((0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).cardContainerDisabled);
    }, [
        role,
        countryCode
    ]);
    (0, $Fo7oF.useEffect)(()=>{
        setChecked(enabled);
        enableOrder(talf_id, {
            target: {
                checked: enabled
            }
        });
    }, [
        enabled
    ]);
    return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
        className: signerCardCss,
        title: isESPTAssociateRole ? `${intl.formatMessage({
            id: 'messages.CREATE_ON_DEMAND_SIGNER_FOR_ASSOCIATE'
        })}` : '',
        children: [
            /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).cardHeader,
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).signerEnabled,
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1d79a71788b0c844$export$2e2bcd8739ae039), {
                            control: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $e7fce3dd40da0110$export$2e2bcd8739ae039), {
                                checked: checked,
                                color: "primary",
                                disabled: isESPTAssociateRole,
                                id: talf_id,
                                name: talf_id,
                                onChange: (e)=>enableOrder(talf_id, e)
                            }),
                            id: 'signer-' + talf_id,
                            label: /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).signerLabel,
                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                    id: 'labels.SIGNER'
                                })
                            }),
                            labelPlacement: "end"
                        })
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).role,
                        children: role && (0, $da769170dfa840d0$export$486333360725fcc9)[role.toUpperCase()]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).clr
            }),
            /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).signerName,
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($21bf5b2cd2866b79$exports))), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).avatar,
                        color: "disabled"
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                        "data-sl": "mask",
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)("h6", {
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)("strong", {
                                children: name
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eFTP6.jsxs)("section", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).signingActions,
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).signOrder,
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsx)("p", {
                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                    id: 'labels.ORDER'
                                })
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form).Control, {
                                as: "select",
                                className: "custom-select-sm border rounded",
                                disabled: enable,
                                id: 'order-' + talf_id,
                                onChange: (e)=>handleChange(talf_id, 'signingOrder', e.target.value),
                                children: [
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("option", {
                                        children: "1"
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("option", {
                                        children: "2"
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("option", {
                                        children: "3"
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("option", {
                                        children: "4"
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("option", {
                                        children: "5"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).signMethod,
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsx)("p", {
                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                    id: 'labels.OPTIONS'
                                })
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form).Control, {
                                as: "select",
                                className: "custom-select-sm border rounded",
                                disabled: enable,
                                id: 'method-' + talf_id,
                                onChange: (e)=>handleChange(talf_id, 'signingMethod', e.target.value),
                                children: [
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("option", {
                                        id: "signByEmail",
                                        value: "Sign by email",
                                        children: intl.formatMessage({
                                            id: 'labels.SIGN_BY_EMAIL'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("option", {
                                        id: "signNow",
                                        value: "Sign now",
                                        children: intl.formatMessage({
                                            id: 'labels.SIGN_NOW'
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                className: isESPTAssociateRole ? (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).contactInfoDisabled : (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).contactInfo,
                title: isESPTAssociateRole ? `${intl.formatMessage({
                    id: 'messages.CREATE_ON_DEMAND_SIGNER_FOR_ASSOCIATE'
                })}` : '',
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form).Group, {
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.EMAIL'
                                    }),
                                    ' ',
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                        "aria-label": "required field",
                                        className: "uxf-is-required",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Form).Control, {
                                className: errorEmail ? 'border border-danger' : '',
                                "data-sl": "mask",
                                defaultValue: emailId,
                                disabled: isESPTAssociateRole,
                                id: 'email-' + talf_id,
                                onChange: (e)=>handleChange(talf_id, 'emailID', e.target.value),
                                required: true,
                                size: "sm",
                                style: emailId ? $6bc7f2ab5fc849a9$var$inputStyles.inputEmailField : $6bc7f2ab5fc849a9$var$inputStyles.inputEmailError,
                                type: "email"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form).Group, {
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.MOBILE'
                                    }),
                                    ' ',
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                        "aria-label": "required field",
                                        className: "uxf-is-required",
                                        children: "*"
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsxs)("span", {
                                        "aria-label": "isd code required",
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).contactNumberHelperText,
                                        children: [
                                            "(",
                                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.ISD_CODE_IS_REQUIRED'
                                            }),
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Form).Control, {
                                className: errorPhoneNumber ? 'border border-danger' : '',
                                "data-sl": "mask",
                                defaultValue: phoneNumber,
                                disabled: isESPTAssociateRole,
                                id: 'contact-' + talf_id,
                                onChange: (e)=>handleChange(talf_id, 'phoneNumber', e.target.value),
                                required: true,
                                size: "sm",
                                style: phoneNumber ? $6bc7f2ab5fc849a9$var$inputStyles.inputPhoneField : $6bc7f2ab5fc849a9$var$inputStyles.inputPhoneError,
                                type: "text"
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).contactNumberHelperText,
                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                    id: 'labels.EXAMPLE_PHONE_NUMBER'
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$6bc7f2ab5fc849a9$var$ThirdPartyInfo.propTypes = {
    countryCode: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    emailId: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    enabled: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    isDuplicate: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    isDuplicateEmailMobile: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    parentCallback: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    phoneNumber: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    talf_id: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string
};
var $6bc7f2ab5fc849a9$export$2e2bcd8739ae039 = $6bc7f2ab5fc849a9$var$ThirdPartyInfo;
const $6bc7f2ab5fc849a9$export$624ee82ed91214d1 = ({ defaultTPs: defaultTPs, emailId: emailId, isDuplicate: isDuplicate, isDuplicateEmailMobile: isDuplicateEmailMobile, name: name, parentCallback: parentCallback, phoneNumber: phoneNumber, role: role, talf_id: talf_id, representativeFor: representativeFor })=>{
    const [enable, setEnable] = (0, $Fo7oF.useState)(true);
    const [errorPhoneNumber, setErrorPhoneNumber] = (0, $Fo7oF.useState)(false);
    const [errorEmail, setErrorEmail] = (0, $Fo7oF.useState)(false);
    const [checked, setChecked] = (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).useState(true);
    const [signerCardCss, setSignerCardCss] = (0, $Fo7oF.useState)((0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).cardContainer);
    const [errorThirdParty, setErrorThirdParty] = (0, $Fo7oF.useState)(false);
    const intl = (0, $b637120a7f65e10c$export$2e2bcd8739ae039)();
    function enableOrder(talf_id, e) {
        setEnable(!e.target.checked);
        setChecked(e.target.checked);
        parentCallback({
            tpNumber: talf_id,
            signer: e.target.checked,
            role: role
        });
    }
    function handleChange(talf_id, field, value) {
        if (field === 'signingMethod') parentCallback({
            tpNumber: talf_id,
            signingMethod: value
        });
        else if (field === 'signingOrder') parentCallback({
            tpNumber: talf_id,
            signingOrder: value
        });
        else if (field === 'phoneNumber') {
            value ? setErrorPhoneNumber(false) : setErrorPhoneNumber(true);
            parentCallback({
                tpNumber: talf_id,
                phoneNumber: value
            });
        } else if (field === 'emailID') {
            value ? setErrorEmail(false) : setErrorEmail(true);
            parentCallback({
                tpNumber: talf_id,
                emailID: value
            });
        } else if (field === 'representativeFor') {
            value ? setErrorThirdParty(false) : setErrorThirdParty(true);
            parentCallback({
                tpNumber: talf_id,
                representativeFor: value
            });
        }
    }
    (0, $Fo7oF.useEffect)(()=>{
        if (checked && (isDuplicate || isDuplicateEmailMobile)) setSignerCardCss((0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).cardContainerDuplicateSigner);
        else if (checked && !isDuplicate && !isDuplicateEmailMobile) setSignerCardCss((0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).cardContainerSigner);
        else setSignerCardCss((0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).cardContainer);
    }, [
        checked,
        isDuplicate,
        isDuplicateEmailMobile
    ]);
    const filteredThirdParties = (defaultTPs || []).filter((thirdParty)=>thirdParty.role !== 'GUARANTOR' && thirdParty.role !== 'ASSOCIATE' && thirdParty.thirdPartyClass !== 'Individual');
    return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
        className: signerCardCss,
        children: [
            /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).cardHeader,
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).signerEnabled,
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1d79a71788b0c844$export$2e2bcd8739ae039), {
                            control: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $e7fce3dd40da0110$export$2e2bcd8739ae039), {
                                checked: checked,
                                color: "primary",
                                id: talf_id,
                                name: talf_id,
                                onChange: (e)=>enableOrder(talf_id, e)
                            }),
                            id: 'signer-' + talf_id,
                            label: /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).signerLabel,
                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                    id: 'labels.SIGNER'
                                })
                            }),
                            labelPlacement: "end"
                        })
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).role,
                        children: role && (0, $da769170dfa840d0$export$486333360725fcc9)[role.toUpperCase()]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).clr
            }),
            /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).signerName,
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($21bf5b2cd2866b79$exports))), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).avatar,
                        color: "disabled"
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                        "data-sl": "mask",
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)("h6", {
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)("strong", {
                                children: name
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eFTP6.jsxs)("section", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).signingActions,
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).signOrder,
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).signOrderLabel,
                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                    id: 'labels.ORDER'
                                })
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form).Control, {
                                as: "select",
                                className: "custom-select-sm border rounded",
                                disabled: enable,
                                id: 'order-' + talf_id,
                                onChange: (e)=>handleChange(talf_id, 'signingOrder', e.target.value),
                                children: [
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("option", {
                                        children: "1"
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("option", {
                                        children: "2"
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("option", {
                                        children: "3"
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("option", {
                                        children: "4"
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("option", {
                                        children: "5"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).signMethod,
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).signMethodLabel,
                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                    id: 'labels.OPTIONS'
                                })
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form).Control, {
                                as: "select",
                                className: "custom-select-sm border rounded",
                                disabled: enable,
                                id: 'method-' + talf_id,
                                onChange: (e)=>handleChange(talf_id, 'signingMethod', e.target.value),
                                children: [
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("option", {
                                        value: "Sign by email",
                                        children: intl.formatMessage({
                                            id: 'labels.SIGN_BY_EMAIL'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("option", {
                                        value: "Sign now",
                                        children: intl.formatMessage({
                                            id: 'labels.SIGN_NOW'
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).contactInfo,
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form).Group, {
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsxs)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).emailLabel,
                                children: [
                                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.EMAIL'
                                    }),
                                    ' ',
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                        "aria-label": "required field",
                                        className: "uxf-is-required",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Form).Control, {
                                className: errorEmail ? 'border border-danger' : '',
                                "data-sl": "mask",
                                defaultValue: emailId,
                                id: 'email-' + talf_id,
                                onChange: (e)=>handleChange(talf_id, 'emailID', e.target.value),
                                required: true,
                                size: "sm",
                                style: emailId ? $6bc7f2ab5fc849a9$var$inputStyles.inputEmailField : $6bc7f2ab5fc849a9$var$inputStyles.inputEmailError,
                                type: "email"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form).Group, {
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.MOBILE'
                                    }),
                                    ' ',
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                        "aria-label": "required field",
                                        className: "uxf-is-required",
                                        children: "*"
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsxs)("span", {
                                        "aria-label": "isd code required",
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).contactNumberHelperText,
                                        children: [
                                            "(",
                                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.ISD_CODE_IS_REQUIRED'
                                            }),
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Form).Control, {
                                className: errorPhoneNumber ? 'border border-danger' : '',
                                "data-sl": "mask",
                                defaultValue: phoneNumber,
                                id: 'contact-' + talf_id,
                                onChange: (e)=>handleChange(talf_id, 'phoneNumber', e.target.value),
                                required: true,
                                size: "sm",
                                style: phoneNumber ? $6bc7f2ab5fc849a9$var$inputStyles.inputPhoneField : $6bc7f2ab5fc849a9$var$inputStyles.inputPhoneError,
                                type: "text"
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsx)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).contactNumberHelperText,
                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                    id: 'labels.EXAMPLE_PHONE_NUMBER'
                                })
                            })
                        ]
                    }),
                    representativeFor && /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form).Group, {
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsxs)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).odSignerInputLabel,
                                children: [
                                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.THIRD_PARTY'
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                        "aria-label": "required field",
                                        className: "uxf-is-required",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Form).Control, {
                                as: "select",
                                className: errorThirdParty ? 'border border-danger' : '',
                                "data-sl": "mask",
                                disabled: false,
                                id: `thirdPartySelect-${talf_id}`,
                                onChange: (e)=>handleChange(talf_id, 'representativeFor', e.target.value),
                                required: true,
                                size: "sm",
                                style: representativeFor ? $6bc7f2ab5fc849a9$var$inputStyles.inputRepresentativeField : $6bc7f2ab5fc849a9$var$inputStyles.inputRepresentativeError,
                                value: representativeFor,
                                children: filteredThirdParties.map((thirdParty, index)=>/*#__PURE__*/ (0, $eFTP6.jsxs)("option", {
                                        style: {
                                            whiteSpace: 'normal',
                                            wordWrap: 'break-word'
                                        },
                                        value: `${thirdParty.tpNumber}-${thirdParty.role}`,
                                        children: [
                                            thirdParty.name,
                                            " - ",
                                            thirdParty.tpNumber
                                        ]
                                    }, index))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$6bc7f2ab5fc849a9$export$624ee82ed91214d1.propTypes = {
    emailId: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    isDuplicate: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    isDuplicateEmailMobile: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    parentCallback: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func,
    phoneNumber: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    talf_id: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    representativeFor: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    defaultTPs: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).object)
};




var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");








function $ca0f897c1d1cbcb2$export$af16cf31077a6c4c(newDate) {
    const separator = '-';
    const date = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const year = newDate.getFullYear();
    const time = newDate.getHours() + ':' + newDate.getMinutes() + ':' + newDate.getSeconds();
    return `${date}${separator}${month < 10 ? `0${month}` : `${month}`}${separator}${year} ${time}`;
}
function $ca0f897c1d1cbcb2$export$adaf307e533580e2(newDate) {
    const separator = '';
    const date = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const year = newDate.getFullYear();
    return `${date}${separator}${month < 10 ? `0${month}` : `${month}`}${separator}${year}`;
}
function $ca0f897c1d1cbcb2$export$9609f2ad431a28cb(newDate) {
    const date = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const year = newDate.getFullYear();
    const timestamp = `${newDate.getHours()}` + `${newDate.getMinutes()}` + `${newDate.getSeconds()}`;
    return `${date}${month}${year}${timestamp}`;
}
function $ca0f897c1d1cbcb2$export$fd0602ed44e9cf1e(newDate) {
    const timestamp = `${newDate.getHours()}` + `${newDate.getMinutes()}` + `${newDate.getSeconds()}`;
    return `${timestamp}`;
}
function $ca0f897c1d1cbcb2$export$3473af77d3ffd3d5(newDate) {
    const date = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const minutes = newDate.getMinutes();
    const seconds = newDate.getSeconds();
    const timestamp = `${minutes < 10 ? `0${minutes}` : `${minutes}`}${seconds < 10 ? `0${seconds}` : `${seconds}`}`;
    return `${date}${month < 10 ? `0${month}` : `${month}`}${timestamp}`;
}






var $d2bgE = parcelRequire("d2bgE");
const $acb4b6a9d3e6a68a$var$inputStyles = {
    odSignerImputFieldError: {
        border: '1px solid',
        borderRadius: '6px',
        borderColor: '#c21020',
        maxWidth: '80%'
    },
    odSignerImputField: {
        border: '1px solid',
        borderRadius: '6px',
        marginBottom: '10px',
        borderColor: '#808080',
        maxWidth: '80%'
    }
};
$acb4b6a9d3e6a68a$export$2e2bcd8739ae039.propTypes = {
    odName: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    odEmail: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    odContactNumber: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    showPopup: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool.isRequired,
    setShowPopup: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func.isRequired,
    getOnDemandSigners: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func.isRequired,
    isProxy: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool.isRequired,
    allRepresentators: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).array.isRequired,
    selectedThirdParty: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).object
};
function $acb4b6a9d3e6a68a$export$2e2bcd8739ae039({ defaultTPs: defaultTPs, odName: odName, odEmail: odEmail, odContactNumber: odContactNumber, showPopup: showPopup, setShowPopup: setShowPopup, getOnDemandSigners: getOnDemandSigners, isProxy: isProxy, allRepresentators: allRepresentators }) {
    const [name, setName] = (0, $Fo7oF.useState)(odName);
    const [email, setEmail] = (0, $Fo7oF.useState)(odEmail);
    const [contactNumber, setContactNumber] = (0, $Fo7oF.useState)(odContactNumber);
    const [selectedThirdParty, setSelectedThirdParty] = (0, $Fo7oF.useState)('');
    const [errorMessage, setErrorMessage] = (0, $Fo7oF.useState)('');
    const signerId = 'OD' + (0, $ca0f897c1d1cbcb2$export$3473af77d3ffd3d5)(new Date());
    const signerRole = isProxy ? 'PROXY' : 'ON DEMAND';
    const intl = (0, $b637120a7f65e10c$export$2e2bcd8739ae039)();
    const handleClose = ()=>{
        setShowPopup(false);
        setErrorMessage('');
    };
    function resetAll() {
        setName(odName);
        setEmail(odEmail);
        setContactNumber(odContactNumber);
        setSelectedThirdParty('');
        setErrorMessage('');
    }
    function handleThirdPartySelection(event) {
        const value = event.target.value;
        if (value) {
            const [, role] = value.split('-');
            const currentCount = allRepresentators.filter((party)=>party.representativeFor === value).length;
            const limits = {
                PRIMARY: 6,
                // Allow up to 6 selections for PRIMARY
                CO_BORROWER: 2,
                // Allow up to 2 selections for CO-BORROWER
                DEALER: 2 // Allow up to 2 selections for DEALER
            };
            const roleName = intl.formatMessage({
                id: (0, $da769170dfa840d0$export$486333360725fcc9)[role].props.id
            });
            const errorst1 = intl.formatMessage({
                id: (0, $da769170dfa840d0$export$ff432e19f42d75f)['you can only assign'].props.id
            });
            const errorst2 = intl.formatMessage({
                id: (0, $da769170dfa840d0$export$ff432e19f42d75f)['representatives to the'].props.id
            });
            if (currentCount >= limits[role]) setErrorMessage(`${errorst1} ${limits[role]}  ${errorst2} ${roleName}`);
            else {
                setSelectedThirdParty(value);
                setErrorMessage('');
            }
        }
    }
    function saveOnDemandSigner() {
        const odSigner = {
            'role': signerRole,
            'tpNumber': signerId,
            'name': name.trim(),
            'emailID': email.trim(),
            'phoneNumber': contactNumber,
            'icsID': null,
            'signer': true,
            'signingOrder': 1,
            'signingMethod': 'Sign by email',
            'representativeFor': isProxy ? selectedThirdParty : null
        };
        getOnDemandSigners(odSigner);
        resetAll();
        setShowPopup(false);
    }
    function saveAndAddNextOnDemandSigner() {
        saveOnDemandSigner();
        setShowPopup(true);
    }
    const filteredThirdParties = (defaultTPs || []).filter((thirdParty)=>thirdParty.role !== 'GUARANTOR' && thirdParty.role !== 'ASSOCIATE' && thirdParty.thirdPartyClass !== 'Individual');
    return /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $06c828c7d8d76aa9$export$2e2bcd8739ae039), {
        "aria-labelledby": "add-signer-dialog",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).addSignerDialog,
        fullWidth: true,
        onClose: handleClose,
        open: showPopup,
        children: [
            /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).signerDialogTitle,
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                className: "form-dialog-title",
                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                    id: isProxy ? 'labels.ADD_NEW_PROXY' : 'labels.ADD_NEW_SIGNER'
                                })
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).signerId,
                                children: [
                                    "ID: ",
                                    signerId
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c6e28b9de0df1599$export$2e2bcd8739ae039), {
                        "aria-label": "close",
                        onClick: handleClose,
                        size: "small",
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($57b96121aa7aac71$exports))), {
                            fontSize: "small"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b04338db8f46de7f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).odSignerTop,
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($21bf5b2cd2866b79$exports))), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).odSignerAvatar,
                        color: "disabled"
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).signerRole,
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                id: 'labels.ROLE'
                            }),
                            ": ",
                            isProxy ? (0, $da769170dfa840d0$export$486333360725fcc9)['PROXY'] : (0, $da769170dfa840d0$export$486333360725fcc9)[signerRole]
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).odSignerDialogContent,
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form).Group, {
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsxs)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).odSignerInputLabel,
                                children: [
                                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.NAME'
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                        "aria-label": "required field",
                                        className: "uxf-is-required",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Form).Control, {
                                className: "odSignerImputField",
                                "data-sl": "mask",
                                id: "odSignerName",
                                onChange: (e)=>setName(e.target.value),
                                placeholder: "John Doe",
                                required: true,
                                size: "sm",
                                style: $acb4b6a9d3e6a68a$var$inputStyles.odSignerImputField,
                                type: "text",
                                value: name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form).Group, {
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsxs)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).odSignerInputLabel,
                                children: [
                                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.EMAIL'
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                        "aria-label": "required field",
                                        className: "uxf-is-required",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Form).Control, {
                                className: "odSignerImputField",
                                "data-sl": "mask",
                                id: "odSignerEmail",
                                onChange: (e)=>setEmail(e.target.value),
                                placeholder: "john.doe@example.com",
                                required: true,
                                size: "sm",
                                style: $acb4b6a9d3e6a68a$var$inputStyles.odSignerImputField,
                                type: "email",
                                value: email
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form).Group, {
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsxs)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).odSignerInputLabel,
                                children: [
                                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.MOBILE'
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                        "aria-label": "required field",
                                        className: "uxf-is-required",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Form).Control, {
                                className: "odSignerImputField",
                                "data-sl": "mask",
                                id: "odSignerContactNumber",
                                onChange: (e)=>setContactNumber(e.target.value),
                                placeholder: "1111 2222 33",
                                required: true,
                                size: "sm",
                                style: $acb4b6a9d3e6a68a$var$inputStyles.odSignerImputField,
                                type: "text",
                                value: contactNumber
                            })
                        ]
                    }),
                    isProxy && /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form).Group, {
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsxs)("p", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).odSignerInputLabel,
                                children: [
                                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                        id: 'labels.THIRD_PARTY'
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                        "aria-label": "required field",
                                        className: "uxf-is-required",
                                        children: "*"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form).Control, {
                                as: "select",
                                className: "odSignerImputField",
                                disabled: false,
                                id: "odSignerThirdPartySelect",
                                onChange: handleThirdPartySelection,
                                style: $acb4b6a9d3e6a68a$var$inputStyles.odSignerImputField,
                                value: selectedThirdParty,
                                children: [
                                    /*#__PURE__*/ (0, $eFTP6.jsx)("option", {
                                        disabled: true,
                                        value: "",
                                        children: intl.formatMessage({
                                            id: 'labels.SELECT_THIRD_PARTY'
                                        })
                                    }),
                                    filteredThirdParties.map((thirdParty, index)=>/*#__PURE__*/ (0, $eFTP6.jsxs)("option", {
                                            value: `${thirdParty.tpNumber}-${thirdParty.role}`,
                                            children: [
                                                thirdParty.name,
                                                " - ",
                                                thirdParty.tpNumber
                                            ]
                                        }, index))
                                ]
                            }),
                            errorMessage && /*#__PURE__*/ (0, $eFTP6.jsx)("p", {
                                style: {
                                    color: 'red',
                                    fontSize: '12px'
                                },
                                children: errorMessage
                            }),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b04338db8f46de7f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $1b29532bd4542510$export$2e2bcd8739ae039), {
                children: [
                    name && email && contactNumber && !errorMessage ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                        disabled: false,
                        onClick: ()=>saveAndAddNextOnDemandSigner(),
                        size: "small",
                        style: {
                            backgroundColor: '#ffde00'
                        },
                        title: intl.formatMessage({
                            id: 'labels.SAVE_&_ADD_NEXT_SIGNER'
                        }),
                        variant: "outlined",
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                            id: 'labels.ADD_NEXT'
                        })
                    }) : /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                        disabled: true,
                        onClick: ()=>saveAndAddNextOnDemandSigner(),
                        size: "small",
                        style: {
                            backgroundColor: '#ffde00'
                        },
                        title: intl.formatMessage({
                            id: 'labels.SAVE_SIGNER'
                        }),
                        variant: "outlined",
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                            id: 'labels.ADD_NEXT'
                        })
                    }),
                    name && email && contactNumber && !errorMessage ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                        disabled: false,
                        onClick: ()=>saveOnDemandSigner(),
                        size: "small",
                        style: {
                            backgroundColor: '#ffde00'
                        },
                        title: intl.formatMessage({
                            id: 'labels.ADD_SIGNER'
                        }),
                        variant: "outlined",
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                            id: 'labels.ADD'
                        })
                    }) : /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                        disabled: true,
                        onClick: ()=>saveOnDemandSigner(),
                        size: "small",
                        style: {
                            backgroundColor: '#ffde00'
                        },
                        title: intl.formatMessage({
                            id: 'labels.ADD_SIGNER'
                        }),
                        variant: "outlined",
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                            id: 'labels.ADD'
                        })
                    })
                ]
            })
        ]
    });
}




function $31ecb08fabe45ead$export$2e2bcd8739ae039({ getOnDemandSigners: getOnDemandSigners, countryCode: countryCode }) {
    const [showPopup, setShowPopup] = (0, $Fo7oF.useState)(false);
    function addSigner() {
        setShowPopup(!showPopup);
    }
    const getAddedOdSigener = (odSigner)=>{
        getOnDemandSigners(odSigner);
    };
    return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).addNewSignerMain,
        children: [
            /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).addNewSigner,
                onClick: ()=>addSigner(),
                children: /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($21bf5b2cd2866b79$exports))), {
                            fontSize: "large"
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)("p", {
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                id: 'labels.ADD_SIGNER'
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $acb4b6a9d3e6a68a$export$2e2bcd8739ae039), {
                getOnDemandSigners: getAddedOdSigener,
                odContactNumber: `${(0, $fff13ca3fea305fa$export$33186d4108d76629)[countryCode].getIsdCode()} `,
                odEmail: "",
                odName: "",
                setShowPopup: setShowPopup,
                showPopup: showPopup
            })
        ]
    });
}




var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");






var $d2bgE = parcelRequire("d2bgE");
$3a82179ab3bf6aee$export$2e2bcd8739ae039.propTypes = {
    getOnDemandSigners: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func.isRequired,
    countryCode: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    allThirdParties: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).array.isRequired,
    defaultTPs: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).array.isRequired,
    allRepresentators: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).array.isRequired
};
function $3a82179ab3bf6aee$export$2e2bcd8739ae039({ getOnDemandSigners: getOnDemandSigners, allRepresentators: allRepresentators, countryCode: countryCode, allThirdParties: allThirdParties, defaultTPs: defaultTPs }) {
    const [showPopup, setShowPopup] = (0, $Fo7oF.useState)(false);
    function addSigner() {
        setShowPopup(!showPopup);
    }
    const getAddedProxySigner = (odSigner)=>{
        getOnDemandSigners(odSigner);
    };
    return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).addNewSignerMain,
        children: [
            /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).addNewSigner,
                onClick: ()=>addSigner(),
                children: /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($21bf5b2cd2866b79$exports))), {
                            fontSize: "large"
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)("p", {
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                id: 'labels.ADD_PROXY'
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $acb4b6a9d3e6a68a$export$2e2bcd8739ae039), {
                allThirdParties: allThirdParties,
                allRepresentators: allRepresentators,
                defaultTPs: defaultTPs,
                getOnDemandSigners: getAddedProxySigner,
                isProxy: true,
                odContactNumber: `${(0, $fff13ca3fea305fa$export$33186d4108d76629)[countryCode].getIsdCode()} `,
                odEmail: "",
                odName: "",
                setShowPopup: setShowPopup,
                showPopup: showPopup
            })
        ]
    });
}


function $f4a350e8cd2b3224$var$_defineProperty(e, r, t) {
    return (r = $f4a350e8cd2b3224$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f4a350e8cd2b3224$var$_toPropertyKey(t) {
    var i = $f4a350e8cd2b3224$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f4a350e8cd2b3224$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $f4a350e8cd2b3224$export$a6ccfd79b0f9c762 extends (0, $Fo7oF.Component) {
    constructor(...args){
        super(...args);
        $f4a350e8cd2b3224$var$_defineProperty(this, "state", {
            quoteNumber: this.props.quoteNumber,
            alfaDealerIdentifier: this.props.alfaDealerIdentifier,
            primaryCustomer: {},
            coBorrowers: [],
            associates: [],
            guarantors: [],
            onDemand: [],
            dealer: {},
            allThirdParties: [],
            signersList: [],
            defaultTPs: []
        });
        $f4a350e8cd2b3224$var$_defineProperty(this, "getOnDemandSigners", (onDemandSigners)=>{
            this.setState((prevState)=>{
                const initializedSigner = {
                    ...onDemandSigners,
                    recipientId: prevState.allThirdParties.length + 1
                };
                const allThirdParties = [
                    ...prevState.allThirdParties,
                    initializedSigner
                ];
                return {
                    onDemand: [
                        ...prevState.onDemand,
                        initializedSigner
                    ],
                    allThirdParties: allThirdParties,
                    signersList: allThirdParties.filter((thirdParty)=>thirdParty.signer)
                };
            }, ()=>this.props.getSignerDetails(this.state.signersList));
        });
        $f4a350e8cd2b3224$var$_defineProperty(this, "getOrderInfo", (data)=>{
            let updatedField;
            let updatedValue;
            let matchRole = false;
            if ('signer' in data) {
                updatedField = 'signer';
                updatedValue = data.signer;
                matchRole = true;
            } else if ('signingMethod' in data) {
                updatedField = 'signingMethod';
                updatedValue = data.signingMethod;
            } else if ('emailID' in data) {
                updatedField = 'emailID';
                updatedValue = data.emailID;
            } else if ('signingOrder' in data) {
                updatedField = 'signingOrder';
                updatedValue = parseInt(data.signingOrder);
            } else if ('phoneNumber' in data) {
                updatedField = 'phoneNumber';
                updatedValue = data.phoneNumber;
            } else if ('representativeFor' in data) {
                updatedField = 'representativeFor';
                updatedValue = data.representativeFor;
            }
            this.setState((prevState)=>{
                const matchesParty = (thirdParty)=>thirdParty.tpNumber === data.tpNumber && (!matchRole || thirdParty.role === data.role);
                const updateParty = (thirdParty)=>matchesParty(thirdParty) ? {
                        ...thirdParty,
                        [updatedField]: updatedValue
                    } : thirdParty;
                const allThirdParties = prevState.allThirdParties.map(updateParty);
                return {
                    allThirdParties: allThirdParties,
                    onDemand: prevState.onDemand.map(updateParty),
                    signersList: allThirdParties.filter((thirdParty)=>thirdParty.signer)
                };
            }, ()=>this.props.getSignerDetails(this.state.signersList));
        });
    }
    async componentDidMount() {
        const promises = [];
        promises.push((0, $c04283212adf4fb0$export$60ad299e2e6f36fe)(`/api/third-parties/${this.state.quoteNumber}`, {
            cacheDuration: 'forever'
        }));
        promises.push((0, $c04283212adf4fb0$export$60ad299e2e6f36fe)(`/api/third-parties/dealer/${this.state.alfaDealerIdentifier}`, {
            cacheDuration: 'forever'
        }));
        const [thirdPartyDetails, dealer] = await Promise.all(promises);
        let recipientId = 1;
        const initializedThirdParties = thirdPartyDetails.map((thirdParty)=>({
                ...thirdParty,
                recipientId: recipientId++,
                signer: false,
                signingOrder: 1,
                signingMethod: 'Sign by email'
            }));
        const initializedDealer = {
            ...dealer,
            recipientId: recipientId++,
            signer: false,
            signingOrder: 1,
            signingMethod: 'Sign by email'
        };
        const allThirdParties = [
            ...initializedThirdParties,
            initializedDealer
        ];
        this.setState({
            primaryCustomer: initializedThirdParties.find((thirdParty)=>thirdParty.role === 'PRIMARY') || {},
            coBorrowers: initializedThirdParties.filter((thirdParty)=>thirdParty.role === 'CO_BORROWER'),
            guarantors: initializedThirdParties.filter((thirdParty)=>thirdParty.role === 'GUARANTOR'),
            associates: initializedThirdParties.filter((thirdParty)=>thirdParty.role === 'ASSOCIATE'),
            dealer: initializedDealer,
            allThirdParties: allThirdParties,
            defaultTPs: allThirdParties
        });
    }
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Form), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).thirdPartiesTab,
                    children: [
                        this.state.primaryCustomer.tpNumber ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $6bc7f2ab5fc849a9$export$2e2bcd8739ae039), {
                            countryCode: this.props.countryCode,
                            emailId: this.state.primaryCustomer.emailID,
                            enabled: this.props.signersInSelectedDocuments.has('PRIMARY'),
                            isDuplicate: Array.from(this.props.duplicateSignerSet).includes(this.state.primaryCustomer.tpNumber),
                            isDuplicateEmailMobile: Array.from(this.props.duplicateEmailMobileNoSet).includes(this.state.primaryCustomer.tpNumber),
                            name: this.state.primaryCustomer.name,
                            parentCallback: this.getOrderInfo.bind(this),
                            phoneNumber: this.state.primaryCustomer.phoneNumber,
                            role: this.state.primaryCustomer.role,
                            talf_id: this.state.primaryCustomer.tpNumber
                        }, 'primary-' + this.state.primaryCustomer.tpNumber) : '',
                        this.state.coBorrowers.map((coBorrower)=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $6bc7f2ab5fc849a9$export$2e2bcd8739ae039), {
                                countryCode: this.props.countryCode,
                                emailId: coBorrower.emailID,
                                enabled: this.props.signersInSelectedDocuments.has('CO_BORROWER'),
                                isDuplicate: Array.from(this.props.duplicateSignerSet).includes(coBorrower.tpNumber),
                                isDuplicateEmailMobile: Array.from(this.props.duplicateEmailMobileNoSet).includes(coBorrower.tpNumber),
                                name: coBorrower.name,
                                parentCallback: this.getOrderInfo.bind(this),
                                phoneNumber: coBorrower.phoneNumber,
                                role: coBorrower.role,
                                talf_id: coBorrower.tpNumber
                            }, coBorrower.tpNumber)),
                        this.state.associates.map((associate)=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $6bc7f2ab5fc849a9$export$2e2bcd8739ae039), {
                                countryCode: this.props.countryCode,
                                emailId: associate.emailID,
                                enabled: this.props.signersInSelectedDocuments.has('ASSOCIATE'),
                                isDuplicate: Array.from(this.props.duplicateSignerSet).includes(associate.tpNumber),
                                isDuplicateEmailMobile: Array.from(this.props.duplicateEmailMobileNoSet).includes(associate.tpNumber),
                                name: associate.name,
                                parentCallback: this.getOrderInfo.bind(this),
                                phoneNumber: associate.phoneNumber,
                                role: associate.role,
                                talf_id: associate.tpNumber
                            }, associate.tpNumber)),
                        this.state.guarantors.map((guarantor)=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $6bc7f2ab5fc849a9$export$2e2bcd8739ae039), {
                                countryCode: this.props.countryCode,
                                emailId: guarantor.emailID,
                                enabled: this.props.signersInSelectedDocuments.has('GUARANTOR'),
                                isDuplicate: Array.from(this.props.duplicateSignerSet).includes(guarantor.tpNumber),
                                isDuplicateEmailMobile: Array.from(this.props.duplicateEmailMobileNoSet).includes(guarantor.tpNumber),
                                name: guarantor.name,
                                parentCallback: this.getOrderInfo.bind(this),
                                phoneNumber: guarantor.phoneNumber,
                                role: guarantor.role,
                                talf_id: guarantor.tpNumber
                            }, guarantor.tpNumber)),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $6bc7f2ab5fc849a9$export$2e2bcd8739ae039), {
                            countryCode: this.props.countryCode,
                            emailId: this.state.dealer.emailID,
                            enabled: this.props.signersInSelectedDocuments.has('DEALER'),
                            isDuplicate: Array.from(this.props.duplicateSignerSet).includes(this.state.dealer.tpNumber),
                            isDuplicateEmailMobile: Array.from(this.props.duplicateEmailMobileNoSet).includes(this.state.dealer.tpNumber),
                            name: this.state.dealer.name,
                            parentCallback: this.getOrderInfo.bind(this),
                            phoneNumber: this.state.dealer.phoneNumber,
                            role: this.state.dealer.role,
                            talf_id: this.state.dealer.tpNumber
                        }, 'dealer' + this.state.dealer.tpNumber),
                        this.state.onDemand.map((ondemand)=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $6bc7f2ab5fc849a9$export$624ee82ed91214d1), {
                                allThirdParties: this.state.allThirdParties,
                                defaultTPs: this.state.defaultTPs,
                                emailId: ondemand.emailID,
                                isDuplicate: Array.from(this.props.duplicateSignerSet).includes(ondemand.tpNumber),
                                isDuplicateEmailMobile: Array.from(this.props.duplicateEmailMobileNoSet).includes(ondemand.tpNumber),
                                name: ondemand.name,
                                parentCallback: this.getOrderInfo.bind(this),
                                phoneNumber: ondemand.phoneNumber,
                                representativeFor: ondemand.representativeFor,
                                role: ondemand.role,
                                talf_id: ondemand.tpNumber
                            }, ondemand.tpNumber)),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $31ecb08fabe45ead$export$2e2bcd8739ae039), {
                            countryCode: this.props.countryCode,
                            getOnDemandSigners: this.getOnDemandSigners.bind(this)
                        }),
                        this.props.documentDetails.some((doc)=>doc.code === 'ESPLOC') && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $3a82179ab3bf6aee$export$2e2bcd8739ae039), {
                            allRepresentators: this.state.onDemand.filter((ondemand)=>ondemand.role === 'PROXY' && ondemand.signer !== false),
                            allThirdParties: this.state.allThirdParties,
                            countryCode: this.props.countryCode,
                            defaultTPs: this.state.defaultTPs,
                            getOnDemandSigners: this.getOnDemandSigners.bind(this)
                        })
                    ]
                }),
                this.state.signersList.length > 0 && /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).thirdPartyStepper,
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsx)("br", {}),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b04338db8f46de7f$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $eFTP6.jsx)("p", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($0aa55432174d8817$exports))).stepperHeader,
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                id: 'labels.SIGNING_ORDER_PREVIEW'
                            })
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $fccde1fde82fe96f$export$2e2bcd8739ae039), {
                            bgColor: '#E9F2F9',
                            signersList: this.state.signersList,
                            status: 'review'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eFTP6.jsx)("br", {})
            ]
        });
    }
}



var $eFTP6 = parcelRequire("eFTP6");

var $Fo7oF = parcelRequire("Fo7oF");



var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");

var $d2bgE = parcelRequire("d2bgE");






const $a6d65e7470b6d6a8$export$e173c7e03ce76501 = ({ name: name, role: role, email: email, contact: contact, signingOrder: signingOrder, signingMethod: signingMethod, isDuplicate: isDuplicate })=>{
    const intl = (0, $b637120a7f65e10c$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
        className: email && contact && !isDuplicate ? (0, (/*@__PURE__*/$parcel$interopDefault($9bc66340e7900d18$exports))).signerReview : (0, (/*@__PURE__*/$parcel$interopDefault($9bc66340e7900d18$exports))).signerReviewError,
        children: [
            /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($21bf5b2cd2866b79$exports))), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9bc66340e7900d18$exports))).reviewAvatar,
                    color: "disabled"
                })
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9bc66340e7900d18$exports))).signerReviewDiv,
                children: /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9bc66340e7900d18$exports))).signerReviewInfo,
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                            className: "d-flex flex-row justify-content-between",
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsx)("p", {
                                    className: "d-flex",
                                    "data-sl": "mask",
                                    children: name
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9bc66340e7900d18$exports))).reviewOrder,
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f4267c9105e002e8$export$19bc16ee58e19b3d), {
                                            className: email && contact && !isDuplicate ? 'uxf-icon d-inline-block mb-0 mr-1 invisible' : 'uxf-icon d-inline-block mb-0 mr-1 visible'
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $88209bc93a38e520$export$2e2bcd8739ae039), {
                                            color: "primary",
                                            label: intl.formatMessage({
                                                id: 'labels.ORDER'
                                            }) + ': ' + signingOrder,
                                            size: "small",
                                            variant: "outlined"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsxs)("span", {
                            className: "d-flex flex-row",
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsxs)("strong", {
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                            id: 'labels.EMAIL'
                                        }),
                                        ":\xa0"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                    "data-sl": "mask",
                                    children: email
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                            className: "d-flex flex-row justify-content-between",
                            children: [
                                /*#__PURE__*/ (0, $eFTP6.jsxs)("span", {
                                    "data-sl": "mask",
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsxs)("strong", {
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                    id: 'labels.MOBILE'
                                                }),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                            "data-sl": "mask",
                                            children: contact
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsxs)("strong", {
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                    id: 'labels.OPTION'
                                                }),
                                                ":"
                                            ]
                                        }),
                                        " ",
                                        signingMethod && (0, $da769170dfa840d0$export$7b5a6e1e04903656)[signingMethod.toUpperCase()]
                                    ]
                                }),
                                /*#__PURE__*/ (0, $eFTP6.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsxs)("strong", {
                                            children: [
                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                    id: 'labels.ROLE'
                                                }),
                                                ":"
                                            ]
                                        }),
                                        " ",
                                        role && (0, $da769170dfa840d0$export$486333360725fcc9)[role.toUpperCase()]
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
$a6d65e7470b6d6a8$export$e173c7e03ce76501.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    email: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    contact: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string,
    signingOrder: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).number,
    signingMethod: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string
};











var $98938e138e128222$exports = {};
$98938e138e128222$exports = JSON.parse("{\"role\":\"JDF REVIEWER\",\"emailID\":\"***********\",\"name\":\"JDF Reviewer\",\"recipientId\":\"110\",\"routingOrder\":6,\"signingOption\":\"Sign by email\"}");


var $d8abec1568d1980f$exports = {};

$parcel$export($d8abec1568d1980f$exports, "reviewInfo", () => $d8abec1568d1980f$export$43492fd8b591befa, (v) => $d8abec1568d1980f$export$43492fd8b591befa = v);
$parcel$export($d8abec1568d1980f$exports, "errorMessage", () => $d8abec1568d1980f$export$493b5823483d2c4e, (v) => $d8abec1568d1980f$export$493b5823483d2c4e = v);
var $d8abec1568d1980f$export$43492fd8b591befa;
var $d8abec1568d1980f$export$493b5823483d2c4e;
$d8abec1568d1980f$export$43492fd8b591befa = "reviewInfo_acec68";
$d8abec1568d1980f$export$493b5823483d2c4e = "errorMessage_acec68";




var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");
var $8d80d06b45099692$exports = {};

$parcel$export($8d80d06b45099692$exports, "errorMessageDiv", () => $8d80d06b45099692$export$cdaaad81c30c95be, (v) => $8d80d06b45099692$export$cdaaad81c30c95be = v);
$parcel$export($8d80d06b45099692$exports, "errorMessage", () => $8d80d06b45099692$export$493b5823483d2c4e, (v) => $8d80d06b45099692$export$493b5823483d2c4e = v);
$parcel$export($8d80d06b45099692$exports, "apiErrorMessageDiv", () => $8d80d06b45099692$export$fb3b1d3a638d31a9, (v) => $8d80d06b45099692$export$fb3b1d3a638d31a9 = v);
$parcel$export($8d80d06b45099692$exports, "apiErrorMessage", () => $8d80d06b45099692$export$d78e6d61b3e1e377, (v) => $8d80d06b45099692$export$d78e6d61b3e1e377 = v);
var $8d80d06b45099692$export$cdaaad81c30c95be;
var $8d80d06b45099692$export$493b5823483d2c4e;
var $8d80d06b45099692$export$fb3b1d3a638d31a9;
var $8d80d06b45099692$export$d78e6d61b3e1e377;
$8d80d06b45099692$export$cdaaad81c30c95be = "errorMessageDiv_6ef3b1";
$8d80d06b45099692$export$493b5823483d2c4e = "errorMessage_6ef3b1";
$8d80d06b45099692$export$fb3b1d3a638d31a9 = "apiErrorMessageDiv_6ef3b1";
$8d80d06b45099692$export$d78e6d61b3e1e377 = "apiErrorMessage_6ef3b1";


const $77e38fef844719b0$export$915e9e7bd4f0f96d = ({ message: message, showIcon: showIcon, cssFlag: cssFlag })=>/*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
        "aria-atomic": "true",
        className: cssFlag ? (0, (/*@__PURE__*/$parcel$interopDefault($8d80d06b45099692$exports))).errorMessageDiv : (0, (/*@__PURE__*/$parcel$interopDefault($8d80d06b45099692$exports))).apiErrorMessageDiv,
        children: [
            showIcon && /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                className: "uxf-icon align-middle p-1 m-auto",
                children: /*#__PURE__*/ (0, $eFTP6.jsxs)("svg", {
                    "aria-hidden": "true",
                    focusable: "false",
                    height: "24",
                    viewBox: "0 0 24 24",
                    width: "24",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsx)("path", {
                            d: "M0 0h24v24H0z",
                            fill: "none"
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)("path", {
                            d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z",
                            fill: "#D24625",
                            fillRule: "nonzero"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)("p", {
                className: cssFlag ? (0, (/*@__PURE__*/$parcel$interopDefault($8d80d06b45099692$exports))).errorMessage : (0, (/*@__PURE__*/$parcel$interopDefault($8d80d06b45099692$exports))).apiErrorMessage,
                children: message
            })
        ]
    });



const $ef7f3b0a54f56aeb$var$documentsToBeReviewedMap = {
    'ES': [
        'ESCONTRA',
        'ESPLOC',
        'ESCONTRALR',
        'ESCONTRALE',
        'ESCONTRARE'
    ],
    'PT': [
        'PTCONTRA',
        'PTAF',
        'PTSBM'
    ],
    'UK': [],
    'GB': []
};
const $ef7f3b0a54f56aeb$var$documentsToBeReviewedMapProduct = {
    'DPFR - 24 month Loan Stock DE': [
        'VER',
        'VERFU',
        'VERPG',
        'VERVP'
    ],
    'DPFR - Loan Stock DE': [
        'VER',
        'VERFU',
        'VERPG',
        'VERVP'
    ],
    'DPFR - Loan DE': [
        'VER',
        'VERFU',
        'VERPG',
        'VERVP'
    ],
    'Loan DE': [
        'VER',
        'VERFU',
        'VERPG',
        'VERVP'
    ]
};
const $ef7f3b0a54f56aeb$export$308eb99093272fad = (countryCode, financeProduct)=>{
    const financeProductElement = $ef7f3b0a54f56aeb$var$documentsToBeReviewedMap[countryCode];
    if (financeProductElement === undefined) return $ef7f3b0a54f56aeb$var$documentsToBeReviewedMapProduct[financeProduct] || [];
    return financeProductElement;
};



var $d2bgE = parcelRequire("d2bgE");

var $eFTP6 = parcelRequire("eFTP6");

parcelRequire("Fo7oF");





var $d2bgE = parcelRequire("d2bgE");
function $cc3c3e66f09a57c4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $06c828c7d8d76aa9$export$2e2bcd8739ae039), {
        open: true,
        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1c55bad717a43115$export$2e2bcd8739ae039), {
            style: {
                paddingBottom: 0
            },
            children: /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                style: {
                    marginRight: 10,
                    marginBottom: 10
                },
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsxs)("span", {
                        className: "font-italic text-success",
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f4267c9105e002e8$export$63b4fc557d1c57af), {
                                className: "success",
                                size: "6%"
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                id: 'labels.ENVELOPE_SUCCESSFULLY_SENT'
                            }),
                            "...",
                            ' '
                        ]
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                        color: "primary",
                        href: `/signAgreement?agreementNumber=${props.quoteNumber}`,
                        size: "small",
                        variant: "contained",
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                            id: 'labels.BACK_TO_DASHBOARD'
                        })
                    })
                ]
            })
        })
    });
}
$cc3c3e66f09a57c4$export$2e2bcd8739ae039.propTypes = {
    quoteNumber: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired
};



var $eFTP6 = parcelRequire("eFTP6");




parcelRequire("Fo7oF");
function $ea97811aba6c4c89$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $06c828c7d8d76aa9$export$2e2bcd8739ae039), {
        open: true,
        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1c55bad717a43115$export$2e2bcd8739ae039), {
            style: {
                paddingBottom: 0
            },
            children: /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                style: {
                    marginRight: 10,
                    marginBottom: 10
                },
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsxs)("span", {
                        className: "font-italic text-success",
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                id: 'labels.ENVELOPE_SENT_UNDER_PROCESS'
                            }),
                            "...",
                            ' '
                        ]
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f4267c9105e002e8$export$fe708d541030d854), {
                        size: "sm"
                    })
                ]
            })
        })
    });
}


class $b56bb2daccee3483$export$4e3e332352c3d092 extends (0, $Fo7oF.Component) {
    constructor(props){
        super(props);
        this.state = {
            downloading: false,
            envelopeCreated: false,
            envpError: false,
            apiErrorMessage: '',
            apiErrorCode: ''
        };
        this.handleSendEnvelope = this.handleSendEnvelope.bind(this);
    }
    async handleSendEnvelope() {
        const { bundleNumber: bundleNumber, createdBy: createdBy, countryCode: countryCode, documentDetails: documentDetails, financeProduct: financeProduct, primaryCustomerName: primaryCustomerName, quoteNumber: quoteNumber, signersDetails: signersDetails } = this.props;
        this.props.disableCreateEnvelopeTabs(true);
        this.setState({
            downloading: true
        });
        this.setState({
            envpError: false
        });
        const body = {
            country: countryCode,
            bundleNumber: bundleNumber,
            quoteNumber: quoteNumber,
            createdBy: createdBy,
            financeProduct: financeProduct,
            primaryCustomerName: primaryCustomerName,
            letters: documentDetails.map((document)=>{
                return {
                    code: document['code'],
                    description: document['description']
                };
            }),
            associatedParties: signersDetails.map((signer)=>{
                return {
                    role: signer.role,
                    emailID: signer.emailID.trim(),
                    name: signer.name,
                    recipientId: signer.recipientId,
                    routingOrder: signer.signingOrder,
                    signingOption: signer.signingMethod,
                    representativeFor: signer.representativeFor,
                    tpNumber: signer.tpNumber,
                    thirdPartyClass: signer.thirdPartyClass,
                    countryCodeforPhone: signer.phoneNumber.replace(/\D/g, '').slice(0, 2),
                    contactNumber: signer.phoneNumber.replace(/\D/g, '').slice(2)
                };
            })
        };
        const documentsForJDFAssociatedParties = documentDetails.filter((document)=>(0, $ef7f3b0a54f56aeb$export$308eb99093272fad)(countryCode, financeProduct).includes(document.code));
        if (documentsForJDFAssociatedParties.length > 0) {
            if (countryCode === 'ES' || countryCode === 'PT') {
                body.associatedParties.push((0, (/*@__PURE__*/$parcel$interopDefault($98938e138e128222$exports))));
                body.associatedParties.push((0, (/*@__PURE__*/$parcel$interopDefault($034bb2b9a7aeb259$exports))));
            }
        }
        try {
            await (0, $c04283212adf4fb0$export$c4b7edec3f76b207)('/api/esign/create-envelope', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify(body)
            });
            this.setState({
                downloading: false
            });
            this.setState({
                envelopeCreated: true
            });
            this.props.disableCreateEnvelopeTabs(false);
            this.setState({
                quoteNumber: quoteNumber
            });
        } catch (err) {
            this.setState({
                downloading: false
            });
            this.props.disableCreateEnvelopeTabs(false);
            this.setState({
                envpError: true
            }, ()=>{
                return true;
            });
            this.setState({
                apiErrorMessage: err.Message
            });
            if (Object.prototype.hasOwnProperty.call(err, 'ErrorCode')) this.setState({
                apiErrorCode: err.ErrorCode
            });
        }
    }
    render() {
        let errorMessage = this.state.apiErrorMessage;
        if ((0, $fff13ca3fea305fa$export$deeeeccc481ce51a).includes(this.state.apiErrorCode)) errorMessage = /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
            id: 'docusignErrorMessages.' + this.state.apiErrorCode
        });
        return /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
            style: {
                minHeight: '300px'
            },
            children: this.props.signersDetails.length === 0 && this.props.documentDetails.length === 0 ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $9ab8fe562bccfb23$export$c0d6fd47a193aea1), {
                context: (0, $fff13ca3fea305fa$export$637c4a33103d8bbe)['NO_SIGNER_DOCUMENT_SELECTED_MESSAGE'],
                message: (0, $fff13ca3fea305fa$export$637c4a33103d8bbe)['NO_SIGNER_DOCUMENT_SELECTED_ACTION']
            }) : /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                children: [
                    this.state.envpError && /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                        className: `d-flex ml-auto mb-2 ${(0, (/*@__PURE__*/$parcel$interopDefault($d8abec1568d1980f$exports))).errorMessage}`,
                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $77e38fef844719b0$export$915e9e7bd4f0f96d), {
                            cssFlag: false,
                            message: errorMessage,
                            showIcon: true
                        })
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Row), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($d8abec1568d1980f$exports))).reviewInfo,
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $eFTP6.jsxs)("span", {
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.PROPOSAL'
                                            }),
                                            ": ",
                                            this.props.quoteNumber,
                                            "| ",
                                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.SIGNERS'
                                            }),
                                            ":",
                                            ' ',
                                            this.props.signersDetails.length,
                                            "| ",
                                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.DOCUMENTS'
                                            }),
                                            ":",
                                            ' ',
                                            this.props.documentDetails.length
                                        ]
                                    }),
                                    (0, $91b041060f19e3dd$export$ea368e53cc6e07e9).map((info)=>/*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                            className: "d-block mb-1 pl-3",
                                            children: info
                                        }, 'info-' + (0, $ce7657dc4dcb9e28$export$a47fb462a08de82f)()))
                                ]
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $5b05347dc97ebaf8$export$2e2bcd8739ae039), {
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    children: this.state.downloading ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $ea97811aba6c4c89$export$2e2bcd8739ae039), {}) : this.state.envelopeCreated ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $cc3c3e66f09a57c4$export$2e2bcd8739ae039), {
                                        quoteNumber: this.state.quoteNumber
                                    }) : /*#__PURE__*/ (0, $eFTP6.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                                            color: "primary",
                                            disabled: !(this.props.signersDetails.length > 0 && this.props.documentDetails.length > 0 && this.props.showError),
                                            onClick: this.handleSendEnvelope,
                                            size: "medium",
                                            variant: "contained",
                                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                id: 'labels.SEND_ENVELOPE'
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Row), {
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Col), {
                                children: [
                                    this.props.signersDetails.length === 0 && /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                                        className: "d-flex flex-column align-items-center",
                                        style: {
                                            marginTop: 45
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f4267c9105e002e8$export$7dcc8f518762622d), {
                                                className: "text-black-50 uxf-icon-lg"
                                            }),
                                            /*#__PURE__*/ (0, $eFTP6.jsx)("h6", {
                                                className: "text-black-50",
                                                children: (0, $fff13ca3fea305fa$export$637c4a33103d8bbe)['NO_SIGNER_SELECTED']
                                            })
                                        ]
                                    }),
                                    this.props.signersDetails.sort((signer1, signer2)=>signer1.signingOrder > signer2.signingOrder ? 1 : -1).map((signer, i)=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $a6d65e7470b6d6a8$export$e173c7e03ce76501), {
                                            contact: signer.phoneNumber,
                                            email: signer.emailID,
                                            isDuplicate: Array.from(this.props.duplicateSignerSet).includes(signer.tpNumber),
                                            name: signer.name,
                                            role: signer.role,
                                            signingMethod: signer.signingMethod,
                                            signingOrder: signer.signingOrder
                                        }, 'Signer-' + i + (0, $ce7657dc4dcb9e28$export$a47fb462a08de82f)()))
                                ]
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b04338db8f46de7f$export$2e2bcd8739ae039), {
                                flexItem: true,
                                orientation: "vertical"
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Col), {
                                children: [
                                    this.props.documentDetails.length === 0 && /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                                        className: "d-flex flex-column align-items-center",
                                        style: {
                                            marginTop: 45
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f4267c9105e002e8$export$5068802198d106bd), {
                                                className: "text-black-50 uxf-icon-lg"
                                            }),
                                            /*#__PURE__*/ (0, $eFTP6.jsx)("h6", {
                                                className: "text-black-50",
                                                children: (0, $fff13ca3fea305fa$export$637c4a33103d8bbe)['NO_DOCUMENT_SELECTED']
                                            })
                                        ]
                                    }),
                                    this.props.documentDetails.map((documentName, i)=>/*#__PURE__*/ (0, $eFTP6.jsx)((0, $ab193334c82ec2ed$export$ebf44949dcb5de42), {
                                            documentName: documentName.description
                                        }, 'DocSummary-' + i + (0, $ce7657dc4dcb9e28$export$a47fb462a08de82f)()))
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
}
$b56bb2daccee3483$export$4e3e332352c3d092.propTypes = {
    createdBy: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    countryCode: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    disableCreateEnvelopeTabs: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).func.isRequired,
    documentDetails: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).array.isRequired,
    duplicateSignerSet: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).array.isRequired,
    duplicateEmailMobileNoSet: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).array.isRequired,
    financeProduct: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    primaryCustomerName: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    quoteNumber: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    showError: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool.isRequired,
    signersDetails: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).array.isRequired
};





var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");
var $b61bc040157f6d9f$exports = {};

$parcel$export($b61bc040157f6d9f$exports, "root", () => $b61bc040157f6d9f$export$e8e78c978b129247, (v) => $b61bc040157f6d9f$export$e8e78c978b129247 = v);
$parcel$export($b61bc040157f6d9f$exports, "pageHeader", () => $b61bc040157f6d9f$export$4cf1388ef83aed25, (v) => $b61bc040157f6d9f$export$4cf1388ef83aed25 = v);
$parcel$export($b61bc040157f6d9f$exports, "cbCheckbox", () => $b61bc040157f6d9f$export$aa54e48f10ef38df, (v) => $b61bc040157f6d9f$export$aa54e48f10ef38df = v);
var $b61bc040157f6d9f$export$e8e78c978b129247;
var $b61bc040157f6d9f$export$4cf1388ef83aed25;
var $b61bc040157f6d9f$export$aa54e48f10ef38df;
$b61bc040157f6d9f$export$e8e78c978b129247 = "root_f4b133";
$b61bc040157f6d9f$export$4cf1388ef83aed25 = "pageHeader_f4b133";
$b61bc040157f6d9f$export$aa54e48f10ef38df = "cbCheckbox_f4b133";






var $d2bgE = parcelRequire("d2bgE");

const $67a5bbf27fa8bb2e$export$71ad8d2b0f485a0a = ({ disabled: disabled })=>{
    const intl = (0, $b637120a7f65e10c$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($b61bc040157f6d9f$exports))).pageHeader,
        children: [
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c6e28b9de0df1599$export$2e2bcd8739ae039), {
                "aria-label": "Go to Dashboard",
                color: "primary",
                component: (0, $5a9c912afef4aac7$export$a6c7ac8248d6e38a),
                disabled: disabled,
                size: "small",
                style: {
                    backgroundColor: '#f7f7f7',
                    border: '1px solid'
                },
                title: intl.formatMessage({
                    id: 'labels.BACK_TO_DASHBOARD'
                }),
                to: "/e-sign",
                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f4267c9105e002e8$export$92c8767b874048d), {})
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)("h3", {
                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                    id: 'labels.CREATE_ENVELOPE'
                })
            })
        ]
    });
};
$67a5bbf27fa8bb2e$export$71ad8d2b0f485a0a.propTypes = {
    disabled: $d2bgE.bool
};



var $eFTP6 = parcelRequire("eFTP6");
parcelRequire("Fo7oF");




var $d2bgE = parcelRequire("d2bgE");
const $2e203d24118b2cb3$export$3f263f88a81d68fa = (props)=>{
    const isSignerValidationError = props.showMandatoryFieldsError === 'invisible' && props.showDuplicationError === 'invisible' && props.showDuplicateEmailMobileError === 'invisible';
    const checkboxHidden = props.showDuplicateEmailMobileError === 'invisible' || props.countryCode !== 'ES' && props.countryCode !== 'PT';
    const displayComplianceError = props.showDuplicateEmailMobileError === 'visible' && (props.countryCode === 'ES' || props.countryCode === 'PT');
    return !isSignerValidationError && /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $20f0c6d4e6c1d2d6$export$2e2bcd8739ae039), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($b61bc040157f6d9f$exports))).cbCheckbox,
                hidden: checkboxHidden,
                onChange: ()=>props.handleCBCheckBox()
            }),
            /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                className: "d-flex ml-auto mb-2",
                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $77e38fef844719b0$export$915e9e7bd4f0f96d), {
                    cssFlag: true,
                    message: props.errorMessage,
                    showIcon: true
                })
            }),
            displayComplianceError && /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                className: "d-flex ml-auto mb-2",
                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $77e38fef844719b0$export$915e9e7bd4f0f96d), {
                    cssFlag: true,
                    message: props.errorMessageCompliance,
                    showIcon: true
                })
            })
        ]
    });
};
$2e203d24118b2cb3$export$3f263f88a81d68fa.propTypes = {
    showMandatoryFieldsError: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool.isRequired,
    showDuplicationError: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool.isRequired,
    showDuplicateEmailMobileError: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).bool.isRequired,
    countryCode: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).string.isRequired,
    errorMessage: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).object.isRequired,
    errorMessageCompliance: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).object.isRequired
};




var $d2bgE = parcelRequire("d2bgE");
function $891f472c7a63f10e$var$_defineProperty(e, r, t) {
    return (r = $891f472c7a63f10e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $891f472c7a63f10e$var$_toPropertyKey(t) {
    var i = $891f472c7a63f10e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $891f472c7a63f10e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $891f472c7a63f10e$export$4e2d65a9843399df extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    constructor(props){
        super(props);
        $891f472c7a63f10e$var$_defineProperty(this, "getSignerDetails", (signersInfo, suppressEmailMobileValidation)=>{
            this.validateMandatoryFields(signersInfo);
            (0, $051c4777ecf8ecff$export$1f4c20e4792e1672)(signersInfo, this.setDuplicateSignersErrorState, this.setDuplicateSignersErrorState2);
            (0, $051c4777ecf8ecff$export$4b14101412abd9cf)(signersInfo, suppressEmailMobileValidation, this.setDuplicateEmailMobileErrorState, this.setDuplicateEmailMobileErrorState2);
            this.setState({
                signersDetails: signersInfo
            });
        });
        this.state = {
            activePane: 'proposal-details',
            bundleData: this.props.location.state,
            signersDetails: [],
            selectedDocumentDetails: [],
            showMandatoryFieldsError: 'invisible',
            showDuplicationError: 'invisible',
            showDuplicateEmailMobileError: 'invisible',
            errorMessage: 'Error',
            errorMessageCompliance: 'Error',
            duplicateSignerSet: [],
            duplicateEmailMobileNoSet: [],
            disableEnvelopeTabs: false,
            duplicateEmailMobileCheckSuppress: false,
            signersInSelectedDocuments: new Set()
        };
        this.handleExpandClick = this.handleExpandClick.bind(this);
        this.getSignerDetails = this.getSignerDetails.bind(this);
        this.getDocumentList = this.getDocumentList.bind(this);
        this.disableCreateEnvelopeTabs = this.disableCreateEnvelopeTabs.bind(this);
        this.validateMandatoryFields = this.validateMandatoryFields.bind(this);
        this.handleCBCheckBox = this.handleCBCheckBox.bind(this);
        this.setDuplicateEmailMobileErrorState = this.setDuplicateEmailMobileErrorState.bind(this);
        this.setDuplicateEmailMobileErrorState2 = this.setDuplicateEmailMobileErrorState2.bind(this);
        this.setDuplicateSignersErrorState = this.setDuplicateSignersErrorState.bind(this);
        this.setDuplicateSignersErrorState2 = this.setDuplicateSignersErrorState2.bind(this);
    }
    handleExpandClick() {
        this.setState((prevState)=>({
                expanded: !prevState.expanded
            }));
    }
    validateMandatoryFields(signersInfo) {
        if (signersInfo.length > 0) {
            for (const element of signersInfo)if (element['emailID'] === '' || element['phoneNumber'] === '' || element['emailID'] === null || element['phoneNumber'] === null) {
                this.setState({
                    showMandatoryFieldsError: 'visible'
                });
                this.setState({
                    errorMessage: (0, $fff13ca3fea305fa$export$2d34b090e360d9ca)
                });
                break;
            } else this.setState({
                showMandatoryFieldsError: 'invisible'
            });
        } else if (signersInfo.length === 0) this.setState({
            showMandatoryFieldsError: 'invisible'
        });
    }
    setDuplicateSignersErrorState(duplicateSigners, tempDuplicateSignersArray) {
        this.setState({
            duplicateSignerSet: new Set(tempDuplicateSignersArray)
        });
        if (duplicateSigners.size > 0) {
            this.setState({
                showDuplicationError: 'visible'
            });
            this.setState({
                errorMessage: (0, $fff13ca3fea305fa$export$b74071247c4c0bb4)
            });
        } else if (duplicateSigners.size === 0) this.setState({
            showDuplicationError: 'invisible'
        });
    }
    setDuplicateSignersErrorState2() {
        this.setState({
            showDuplicationError: 'invisible'
        });
    }
    setDuplicateEmailMobileErrorState(duplicateEmailMobileNoSigners, tempDuplicateEmailMobileArray) {
        this.setState({
            duplicateEmailMobileNoSet: new Set(tempDuplicateEmailMobileArray)
        });
        if (duplicateEmailMobileNoSigners.size > 0) {
            this.setState({
                showDuplicateEmailMobileError: 'visible'
            });
            this.setState({
                errorMessage: (0, $fff13ca3fea305fa$export$cd1128a48dbe8d2c)
            });
            this.setState({
                errorMessageCompliance: (0, $fff13ca3fea305fa$export$8fa2abd762c7dcc8)
            });
        } else if (duplicateEmailMobileNoSigners.size === 0) this.setState({
            showDuplicateEmailMobileError: 'invisible'
        });
    }
    setDuplicateEmailMobileErrorState2() {
        this.setState({
            showDuplicateEmailMobileError: 'invisible'
        });
    }
    getDocumentList(docList) {
        this.setState({
            selectedDocumentDetails: docList
        });
        const signers = new Set();
        docList.forEach((doc)=>{
            doc.documentSigners.forEach((signer)=>{
                signers.add(signer);
            });
        });
        this.setState({
            signersInSelectedDocuments: signers
        });
    }
    handleCBCheckBox() {
        this.getSignerDetails(this.state.signersDetails, true);
    }
    disableCreateEnvelopeTabs(tabStatus) {
        this.setState({
            disableEnvelopeTabs: tabStatus
        });
    }
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Tab).Container, {
            defaultActiveKey: "proposal-details",
            id: "left-tabs-example",
            onSelect: (key)=>this.setState({
                    activePane: key
                }),
            transition: false,
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $67a5bbf27fa8bb2e$export$71ad8d2b0f485a0a), {
                    disabled: this.state.disableEnvelopeTabs
                }),
                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Nav), {
                    className: "d-flex justify-content-left uxf-nav-tabs-medium",
                    variant: "tabs",
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Item, {
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Link, {
                                disabled: this.state.disableEnvelopeTabs,
                                eventKey: "proposal-details",
                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                    id: 'labels.PROPOSAL_DETAILS'
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Item, {
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Link, {
                                disabled: this.state.disableEnvelopeTabs,
                                eventKey: "third-parties",
                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                    id: 'labels.ASSOCIATED_PARTIES'
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Item, {
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Link, {
                                disabled: this.state.disableEnvelopeTabs,
                                eventKey: "envelope-review",
                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                    id: 'labels.ENVELOPE_REVIEW'
                                })
                            })
                        }),
                        (this.state.activePane === 'third-parties' || this.state.activePane === 'envelope-review') && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e203d24118b2cb3$export$3f263f88a81d68fa), {
                            countryCode: this.state.bundleData.countryCode,
                            errorMessage: this.state.errorMessage,
                            errorMessageCompliance: this.state.errorMessageCompliance,
                            handleCBCheckBox: this.handleCBCheckBox,
                            showDuplicateEmailMobileError: this.state.showDuplicateEmailMobileError,
                            showDuplicationError: this.state.showDuplicationError,
                            showMandatoryFieldsError: this.state.showMandatoryFieldsError
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $2e3699713c7ad81e$exports.Tab).Content, {
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Tab).Pane, {
                            className: "h-100",
                            eventKey: "proposal-details",
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $d300b6c6d840a36e$export$935614c0ecdada2e), {
                                bundleData: this.state.bundleData,
                                getDocumentList: this.getDocumentList
                            })
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Tab).Pane, {
                            className: "h-100",
                            eventKey: "third-parties",
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f4a350e8cd2b3224$export$a6ccfd79b0f9c762), {
                                alfaDealerIdentifier: this.state.bundleData.alfaDealerIdentifier,
                                countryCode: this.state.bundleData.countryCode,
                                documentDetails: this.state.selectedDocumentDetails,
                                duplicateEmailMobileNoSet: this.state.duplicateEmailMobileNoSet,
                                duplicateSignerSet: this.state.duplicateSignerSet,
                                getSignerDetails: this.getSignerDetails,
                                quoteNumber: this.state.bundleData.quoteNumber,
                                signersInSelectedDocuments: this.state.signersInSelectedDocuments
                            })
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Tab).Pane, {
                            className: "h-100",
                            eventKey: "envelope-review",
                            children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b56bb2daccee3483$export$4e3e332352c3d092), {
                                bundleNumber: this.state.bundleData.bundleNumber,
                                countryCode: this.state.bundleData.countryCode,
                                createdBy: this.state.bundleData.salesPersonName,
                                disableCreateEnvelopeTabs: this.disableCreateEnvelopeTabs,
                                documentDetails: this.state.selectedDocumentDetails,
                                duplicateEmailMobileNoSet: this.state.duplicateEmailMobileNoSet,
                                duplicateSignerSet: this.state.duplicateSignerSet,
                                financeProduct: this.state.bundleData.financeProduct,
                                primaryCustomerName: this.state.bundleData.primaryCustomer[0],
                                quoteNumber: this.state.bundleData.quoteNumber,
                                showError: this.state.showMandatoryFieldsError === 'invisible' && this.state.showDuplicationError === 'invisible' && this.state.showDuplicateEmailMobileError === 'invisible',
                                signersDetails: this.state.signersDetails
                            })
                        })
                    ]
                })
            ]
        });
    }
}
$891f472c7a63f10e$export$4e2d65a9843399df.propTypes = {
    location: (0, (/*@__PURE__*/$parcel$interopDefault($d2bgE))).object.isRequired
};


const $94cc46fb4b4d845c$var$EnvelopeWithLocation = ()=>{
    const location = (0, $5a9c912afef4aac7$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $891f472c7a63f10e$export$4e2d65a9843399df), {
        location: location
    });
};
var $94cc46fb4b4d845c$export$2e2bcd8739ae039 = $94cc46fb4b4d845c$var$EnvelopeWithLocation;


function $577d953595817292$var$_defineProperty(e, r, t) {
    return (r = $577d953595817292$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $577d953595817292$var$_toPropertyKey(t) {
    var i = $577d953595817292$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $577d953595817292$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $577d953595817292$var$theme = (0, $bdmad.default)({
    palette: {
        primary: {
            main: '#367C2B'
        },
        secondary: {
            main: '#FFF'
        }
    }
});
class $577d953595817292$export$a1ed0a31ef36e1f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($Fo7oF))).Component {
    constructor(props){
        super(props);
        $577d953595817292$var$_defineProperty(this, "translateToEnglishSwitchHandler", (branchCode)=>{
            this.setState({
                branchCode: branchCode
            });
        });
        this.state = {
            idTokenUser: (0, $1982a4c5f4dd80b7$export$73693bad9f5880b0).config.providers[0].idToken.user,
            user: null,
            role: null,
            activeMenu: window.location.pathname.split('/')[1],
            searchParam: (0, $b095844d27f3f99a$export$2e2bcd8739ae039).location.search.split('=')[1],
            branchCode: 'UK'
        };
        this.logoutApplication = this.logoutApplication.bind(this);
    }
    async componentDidMount() {
        this.setState({
            loading: true
        });
        const name = this.state.idTokenUser.given_name;
        const user_domainName = this.state.idTokenUser.preferred_username;
        (0, (/*@__PURE__*/$parcel$interopDefault($ebc81e85cd9d0f88$exports))).identify(name, {
            'userName': name,
            'user_domainName': user_domainName
        });
        try {
            const promises = [];
            promises.push((0, $1982a4c5f4dd80b7$export$69d4516a6fd8e701).user);
            const [user] = await Promise.all(promises);
            this.setState({
                user: user,
                role: (0, $1982a4c5f4dd80b7$export$69d4516a6fd8e701).role,
                branchCode: user.branchCode
            });
        } finally{
            this.setState({
                loading: false
            });
        }
    }
    logoutApplication() {
        (0, $1982a4c5f4dd80b7$export$69d4516a6fd8e701).logout((0, $1982a4c5f4dd80b7$export$73693bad9f5880b0).config.providers[0].name);
    }
    render() {
        return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $85ff2091aa0ceb09$export$ef65e7c7fb2941e0), {
            branchCode: this.state.branchCode,
            children: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c69902c63474d2eb$export$2e2bcd8739ae039), {
                theme: $577d953595817292$var$theme,
                children: [
                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $7b3ef6c8ebcd5b66$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $5a9c912afef4aac7$export$9ba4e89fdfa1fc54), {
                        history: (0, $b095844d27f3f99a$export$2e2bcd8739ae039),
                        children: [
                            /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $cbe03892a40445d8$export$2e2bcd8739ae039), {
                                color: "secondary",
                                position: "sticky",
                                children: [
                                    /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $04d9144fb2276d87$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $9d6b5b5c04a4d1e6$export$36f2c31d1240b26b), {
                                                bars: true,
                                                style: {
                                                    marginLeft: -24
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
                                                className: "uxf-header-title",
                                                style: {
                                                    marginRight: 10
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                                        className: "h1 uxf-header-title-heading",
                                                        children: /*#__PURE__*/ (0, $eFTP6.jsx)("a", {
                                                            className: "uxf-header-title-link",
                                                            href: "/",
                                                            children: "FC Utilities"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $eFTP6.jsxs)("p", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($460f76674a4a7bbb$exports))).logout,
                                                        onClick: this.logoutApplication,
                                                        children: [
                                                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                                id: 'labels.HI'
                                                            }),
                                                            ", ",
                                                            this.state.idTokenUser.given_name,
                                                            /*#__PURE__*/ (0, $eFTP6.jsx)("span", {
                                                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ae742c06fae423df$exports))), {
                                                                    fontSize: "small"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $c94ade5afe509790$export$2e2bcd8739ae039), {
                                        alignItems: "center",
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($460f76674a4a7bbb$exports))).navbar,
                                        container: true,
                                        justifyContent: "flex-start",
                                        children: [
                                            this.state.user !== null && (0, $7030535042884b0b$export$5ac229ab51eeefcb).includes(this.state.user.branchCode) && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Item, {
                                                onClick: ()=>this.setState({
                                                        activeMenu: 'proposal-tracking'
                                                    }),
                                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Link, {
                                                    as: (0, $5a9c912afef4aac7$export$a6c7ac8248d6e38a),
                                                    className: this.state.activeMenu === 'proposal-tracking' ? (0, (/*@__PURE__*/$parcel$interopDefault($460f76674a4a7bbb$exports))).menuItemActive : 'uxf-link-text',
                                                    to: "/proposal-tracking",
                                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                        id: 'labels.PROPOSAL_TRACKING'
                                                    })
                                                })
                                            }),
                                            this.state.user !== null && (0, $7030535042884b0b$export$af506a8c57c66b45).includes(this.state.user.branchCode) && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Item, {
                                                onClick: ()=>this.setState({
                                                        activeMenu: 'e-sign'
                                                    }),
                                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Link, {
                                                    as: (0, $5a9c912afef4aac7$export$a6c7ac8248d6e38a),
                                                    className: this.state.activeMenu === 'e-sign' ? (0, (/*@__PURE__*/$parcel$interopDefault($460f76674a4a7bbb$exports))).menuItemActive : 'uxf-link-text',
                                                    to: "/e-sign",
                                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                        id: 'labels.E_SIGNATURE'
                                                    })
                                                })
                                            }),
                                            this.state.user && this.state.user.hasAccessToMergerAndAcquisition && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Item, {
                                                onClick: ()=>this.setState({
                                                        activeMenu: 'merge-dealers'
                                                    }),
                                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Link, {
                                                    as: (0, $5a9c912afef4aac7$export$a6c7ac8248d6e38a),
                                                    className: this.state.activeMenu === 'merge-dealers' ? (0, (/*@__PURE__*/$parcel$interopDefault($460f76674a4a7bbb$exports))).menuItemActive : 'uxf-link-text',
                                                    to: "/merge-dealers",
                                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                        id: 'labels.MERGER_AND_ACQUISITION'
                                                    })
                                                })
                                            }),
                                            this.state.user && this.state.user.hasAccessToFCCMAdminUtility && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Item, {
                                                onClick: ()=>this.setState({
                                                        activeMenu: 'admin-utility'
                                                    }),
                                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Link, {
                                                    as: (0, $5a9c912afef4aac7$export$a6c7ac8248d6e38a),
                                                    className: this.state.activeMenu === 'admin-utility' ? (0, (/*@__PURE__*/$parcel$interopDefault($460f76674a4a7bbb$exports))).menuItemActive : 'uxf-link-text',
                                                    to: "/admin-utility",
                                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                        id: 'labels.ADMIN_UTILITY'
                                                    })
                                                })
                                            }),
                                            this.state.user && this.state.user.role === 'ADMIN' && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Item, {
                                                onClick: ()=>this.setState({
                                                        activeMenu: 'alfauser'
                                                    }),
                                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Link, {
                                                    as: (0, $5a9c912afef4aac7$export$a6c7ac8248d6e38a),
                                                    className: this.state.activeMenu === 'alfauser' ? (0, (/*@__PURE__*/$parcel$interopDefault($460f76674a4a7bbb$exports))).menuItemActive : 'uxf-link-text',
                                                    to: "/alfauser",
                                                    children: "FC User"
                                                })
                                            }),
                                            this.state.user && this.state.user.role === 'ADMIN' && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Item, {
                                                onClick: ()=>this.setState({
                                                        activeMenu: 'admin'
                                                    }),
                                                children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Link, {
                                                    as: (0, $5a9c912afef4aac7$export$a6c7ac8248d6e38a),
                                                    className: this.state.activeMenu === 'admin' ? (0, (/*@__PURE__*/$parcel$interopDefault($460f76674a4a7bbb$exports))).menuItemActive : 'uxf-link-text',
                                                    to: "/admin",
                                                    children: "Admin"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Item, {
                                                children: (0, $c8fcd73ceb71c905$export$e506a1d27d1eaa20).isDevelopmentEnvironment && this.state.user && this.state.user.role === 'ADMIN' && /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $9b463858a269c96b$export$2e2bcd8739ae039), {
                                                    style: {
                                                        minWidth: 150,
                                                        marginBottom: 15,
                                                        marginLeft: 15,
                                                        marginRight: 15
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $72e841643b7cb579$export$2e2bcd8739ae039), {
                                                            htmlFor: "role-override",
                                                            children: "Role Override"
                                                        }),
                                                        /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $96006197b33869f9$export$2e2bcd8739ae039), {
                                                            inputProps: {
                                                                name: 'role-override',
                                                                id: 'role-override'
                                                            },
                                                            labelWidth: 100,
                                                            onChange: ({ target: target })=>{
                                                                (0, $1982a4c5f4dd80b7$export$69d4516a6fd8e701).role = target.value;
                                                                location.reload();
                                                            },
                                                            style: {
                                                                maxHeight: '2.5em'
                                                            },
                                                            value: !this.state.role || this.state.role === 'ADMIN' ? '' : this.state.role,
                                                            children: [
                                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                                    value: "",
                                                                    children: /*#__PURE__*/ (0, $eFTP6.jsx)("em", {
                                                                        children: "None"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                                    value: 'ASSIGN',
                                                                    children: "Assignment"
                                                                }),
                                                                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $404ed5acf13336e9$export$2e2bcd8739ae039), {
                                                                    value: 'VIEW',
                                                                    children: "View Only"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            (0, $c8fcd73ceb71c905$export$e506a1d27d1eaa20).isDevelopmentEnvironment && /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $eFTP6.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $2e3699713c7ad81e$exports.Nav).Item, {
                                                        children: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1d79a71788b0c844$export$2e2bcd8739ae039), {
                                                            control: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $e7fce3dd40da0110$export$2e2bcd8739ae039), {
                                                                checked: localStorage.getItem('localhost') === 'true',
                                                                color: "primary",
                                                                onChange: (e)=>{
                                                                    localStorage.setItem('localhost', e.target.checked);
                                                                    location.reload();
                                                                }
                                                            }),
                                                            label: "Use Localhost"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $eFTP6.jsx)((0, $8ffbcbb17dd5e3f0$export$2e2bcd8739ae039), {
                                                        translateToEnglishSwitchHandler: this.translateToEnglishSwitchHandler,
                                                        user: this.state.user
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $85f6784786c38cd6$export$2e2bcd8739ae039), {
                                maxWidth: "lg",
                                style: {
                                    paddingTop: 20
                                },
                                children: /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $5a9c912afef4aac7$export$3565eb3d00ca5a74), {
                                    children: [
                                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $5a9c912afef4aac7$export$e7b0ac011bb776c6), {
                                            element: this.state.user !== null && (0, $7030535042884b0b$export$5ac229ab51eeefcb).includes(this.state.user.branchCode) ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $5a9c912afef4aac7$export$444b3ab0cb9aec40), {
                                                to: "/proposal-tracking"
                                            }) : this.state.user !== null && (0, $7030535042884b0b$export$af506a8c57c66b45).includes(this.state.user.branchCode) ? /*#__PURE__*/ (0, $eFTP6.jsx)((0, $5a9c912afef4aac7$export$444b3ab0cb9aec40), {
                                                to: "/e-sign"
                                            }) : /*#__PURE__*/ (0, $eFTP6.jsx)((0, $9ab8fe562bccfb23$export$c0d6fd47a193aea1), {
                                                context: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                    id: 'alerts.NO_MODULE_ASSIGNED'
                                                }),
                                                message: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $1117f10944a397d9$export$2e2bcd8739ae039), {
                                                    id: 'alerts.NO_ACCESS_TO_PROPOSAL_TRACKING_OR_ESIGN'
                                                })
                                            }),
                                            path: "/"
                                        }),
                                        this.state.user !== null && (0, $7030535042884b0b$export$5ac229ab51eeefcb).includes(this.state.user.branchCode) && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $5a9c912afef4aac7$export$e7b0ac011bb776c6), {
                                            element: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $cbb5e14997b0da75$export$a54ec244c8863715), {}),
                                            path: "/proposal-tracking"
                                        }),
                                        this.state.user !== null && this.state.user.role === 'ADMIN' && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $5a9c912afef4aac7$export$e7b0ac011bb776c6), {
                                            element: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $093873bf3b86cc30$export$b25f57c16f88d7e0), {}),
                                            path: "/admin"
                                        }),
                                        this.state.user !== null && this.state.user.role === 'ADMIN' && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $5a9c912afef4aac7$export$e7b0ac011bb776c6), {
                                            element: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $85fc3684d282153b$export$c57a80c7944cc612), {}),
                                            path: "/alfauser"
                                        }),
                                        this.state.user !== null && (0, $7030535042884b0b$export$af506a8c57c66b45).includes(this.state.user.branchCode) && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $5a9c912afef4aac7$export$e7b0ac011bb776c6), {
                                            element: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f8a95d6ca5350b42$export$5e2670b88b4a3574), {
                                                bundleNumber: this.state.searchParam,
                                                location: window.location,
                                                user: this.state.user
                                            }),
                                            path: "/signBundle"
                                        }),
                                        this.state.user !== null && (0, $7030535042884b0b$export$af506a8c57c66b45).includes(this.state.user.branchCode) && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $5a9c912afef4aac7$export$e7b0ac011bb776c6), {
                                            element: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f8a95d6ca5350b42$export$5e2670b88b4a3574), {
                                                agreementNumber: this.state.searchParam,
                                                location: window.location,
                                                user: this.state.user
                                            }),
                                            path: "/signAgreement"
                                        }),
                                        this.state.user !== null && (0, $7030535042884b0b$export$af506a8c57c66b45).includes(this.state.user.branchCode) && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $5a9c912afef4aac7$export$e7b0ac011bb776c6), {
                                            element: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $94cc46fb4b4d845c$export$2e2bcd8739ae039), {}),
                                            path: "/e-sign/*"
                                        }),
                                        this.state.user !== null && (0, $7030535042884b0b$export$af506a8c57c66b45).includes(this.state.user.branchCode) && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $5a9c912afef4aac7$export$e7b0ac011bb776c6), {
                                            element: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $f8a95d6ca5350b42$export$5e2670b88b4a3574), {
                                                location: window.location,
                                                user: this.state.user
                                            }),
                                            path: "/e-sign"
                                        }),
                                        this.state.user !== null && this.state.user.hasAccessToMergerAndAcquisition && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $5a9c912afef4aac7$export$e7b0ac011bb776c6), {
                                            element: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $ba0a375eac74307a$export$e32b480bab30b999), {}),
                                            path: "/merge-dealers"
                                        }),
                                        this.state.user !== null && this.state.user.hasAccessToFCCMAdminUtility && /*#__PURE__*/ (0, $eFTP6.jsx)((0, $5a9c912afef4aac7$export$e7b0ac011bb776c6), {
                                            element: /*#__PURE__*/ (0, $eFTP6.jsx)((0, $dfc257ad8b4a3bfc$export$2e2bcd8739ae039), {}),
                                            path: "/admin-utility"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b567281d998fb069$export$2e2bcd8739ae039), {})
                        ]
                    })
                ]
            })
        });
    }
}
$577d953595817292$var$_defineProperty($577d953595817292$export$a1ed0a31ef36e1f4, "contextType", (0, $2e3699713c7ad81e$exports.HeaderContext));




var $bdmad = parcelRequire("bdmad");
var $4f01355d586586b6$exports = {};

$parcel$export($4f01355d586586b6$exports, "root", () => $4f01355d586586b6$export$e8e78c978b129247, (v) => $4f01355d586586b6$export$e8e78c978b129247 = v);
$parcel$export($4f01355d586586b6$exports, "logo", () => $4f01355d586586b6$export$db3c28d99448dcff, (v) => $4f01355d586586b6$export$db3c28d99448dcff = v);
$parcel$export($4f01355d586586b6$exports, "error", () => $4f01355d586586b6$export$a3bc9b8ed74fc, (v) => $4f01355d586586b6$export$a3bc9b8ed74fc = v);
var $4f01355d586586b6$export$e8e78c978b129247;
var $4f01355d586586b6$export$db3c28d99448dcff;
var $4f01355d586586b6$export$a3bc9b8ed74fc;
$4f01355d586586b6$export$e8e78c978b129247 = "root_d72c7b";
$4f01355d586586b6$export$db3c28d99448dcff = "logo_d72c7b";
$4f01355d586586b6$export$a3bc9b8ed74fc = "error_d72c7b";


const $550cfb23fb5b0e42$var$theme = (0, $bdmad.default)({
    palette: {
        primary: {
            main: '#367C2B'
        },
        secondary: {
            main: '#FFF'
        }
    }
});
function $550cfb23fb5b0e42$export$6cd5d5c1dae69a36({ error: error }) {
    return /*#__PURE__*/ (0, $eFTP6.jsx)((0, $c69902c63474d2eb$export$2e2bcd8739ae039), {
        theme: $550cfb23fb5b0e42$var$theme,
        children: error ? /*#__PURE__*/ (0, $eFTP6.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($4f01355d586586b6$exports))).root,
            children: [
                /*#__PURE__*/ (0, $eFTP6.jsx)((0, $9d6b5b5c04a4d1e6$export$36f2c31d1240b26b), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4f01355d586586b6$exports))).logo,
                    component: "div"
                }),
                /*#__PURE__*/ (0, $eFTP6.jsxs)((0, $fe0aa9e32766c0f5$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4f01355d586586b6$exports))).error,
                    children: [
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                            variant: "h5",
                            children: "Access Denied"
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $b6511d47df71b02c$export$2e2bcd8739ae039), {
                            children: error.description.replace(/\+/g, ' ')
                        }),
                        /*#__PURE__*/ (0, $eFTP6.jsx)((0, $896fad33a17d8629$export$2e2bcd8739ae039), {
                            color: "primary",
                            fullWidth: true,
                            onClick: ()=>(0, $1982a4c5f4dd80b7$export$73693bad9f5880b0).loginWithRedirect(),
                            variant: "outlined",
                            children: "Retry"
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $eFTP6.jsx)((0, $577d953595817292$export$a1ed0a31ef36e1f4), {})
    });
}


let $e01aca5473a24233$var$rendered = false;
let $e01aca5473a24233$var$root;
async function $e01aca5473a24233$var$render(error) {
    if ($e01aca5473a24233$var$rendered) return;
    $e01aca5473a24233$var$rendered = true;
    await (0, $1982a4c5f4dd80b7$export$69d4516a6fd8e701).user.catch((error)=>error);
    const appContainer = document.getElementById('app');
    if (!appContainer) return;
    $e01aca5473a24233$var$root = $e01aca5473a24233$var$root || (0, $37f57d781b7d3ff8$export$882461b6382ed46c)(appContainer);
    $e01aca5473a24233$var$root.render(/*#__PURE__*/ (0, $eFTP6.jsx)((0, $550cfb23fb5b0e42$export$6cd5d5c1dae69a36), {
        error: error
    }));
}
if (!(0, $1982a4c5f4dd80b7$export$73693bad9f5880b0).config.providers[0].idToken.expired) $e01aca5473a24233$var$render();
else (0, $1982a4c5f4dd80b7$export$73693bad9f5880b0).on('login', (error)=>{
    $e01aca5473a24233$var$render(error);
});


//# sourceMappingURL=public.6ce8cf71.js.map
